[
  {
    "id": "68e755fdb5fe7bc0469597ff",
    "name": "68e755fdb5fe7bc0469597ff",
    "x": 0.81974,
    "y": 6.47,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.67881,
      "w": 0.73431
    },
    "statistics": {
      "hasStockCount": 3,
      "noStockCount": 0,
      "unknownStockCount": 12
    },
    "layers": [
      {
        "id": "696ead8b3b88e258afd73882",
        "height": 0.20472,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb37",
            "leftCorner": {
              "x": 0.87,
              "y": 6.455,
              "z": 0.195
            },
            "rightCorner": {
              "x": 0.883,
              "y": 6.635,
              "z": 0.195
            },
            "gtin": "4014838064222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb38",
            "leftCorner": {
              "x": 0.877,
              "y": 6.625,
              "z": 0.205
            },
            "rightCorner": {
              "x": 0.89,
              "y": 6.789,
              "z": 0.205
            },
            "gtin": "4014838064208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb39",
            "leftCorner": {
              "x": 0.89,
              "y": 6.789,
              "z": 0.205
            },
            "rightCorner": {
              "x": 0.9,
              "y": 6.912,
              "z": 0.205
            },
            "gtin": "4066447440546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb3a",
            "leftCorner": {
              "x": 0.9,
              "y": 6.912,
              "z": 0.205
            },
            "rightCorner": {
              "x": 0.908,
              "y": 7.011,
              "z": 0.205
            },
            "gtin": "4008600385394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb3b",
            "leftCorner": {
              "x": 0.908,
              "y": 7.011,
              "z": 0.205
            },
            "rightCorner": {
              "x": 0.915,
              "y": 7.107,
              "z": 0.205
            },
            "gtin": "4001499908347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb3c",
            "leftCorner": {
              "x": 0.915,
              "y": 7.107,
              "z": 0.205
            },
            "rightCorner": {
              "x": 0.924,
              "y": 7.213,
              "z": 0.205
            },
            "gtin": "4001499939013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb3d",
            "leftCorner": {
              "x": 0.924,
              "y": 7.213,
              "z": 0.205
            },
            "rightCorner": {
              "x": 0.936,
              "y": 7.365,
              "z": 0.205
            },
            "gtin": "8720689002158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb3e",
            "leftCorner": {
              "x": 0.936,
              "y": 7.365,
              "z": 0.205
            },
            "rightCorner": {
              "x": 0.943,
              "y": 7.463,
              "z": 0.205
            }
          },
          {
            "id": "696ebf6d43c343680a26fb3f",
            "leftCorner": {
              "x": 0.943,
              "y": 7.463,
              "z": 0.205
            },
            "rightCorner": {
              "x": 0.948,
              "y": 7.529,
              "z": 0.205
            }
          },
          {
            "id": "696ebf6d43c343680a26fb40",
            "leftCorner": {
              "x": 0.948,
              "y": 7.529,
              "z": 0.205
            },
            "rightCorner": {
              "x": 0.951,
              "y": 7.558,
              "z": 0.205
            }
          },
          {
            "id": "696ebf6d43c343680a26fb41",
            "leftCorner": {
              "x": 0.951,
              "y": 7.558,
              "z": 0.205
            },
            "rightCorner": {
              "x": 0.957,
              "y": 7.637,
              "z": 0.205
            },
            "gtin": "4067796069372",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb42",
            "leftCorner": {
              "x": 0.957,
              "y": 7.637,
              "z": 0.205
            },
            "rightCorner": {
              "x": 0.964,
              "y": 7.723,
              "z": 0.205
            },
            "gtin": "5414959046852",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd7387c",
        "height": 0.79188,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb62",
            "leftCorner": {
              "x": 0.633,
              "y": 6.485,
              "z": 0.792
            },
            "rightCorner": {
              "x": 0.703,
              "y": 7.381,
              "z": 0.792
            },
            "gtin": "4066447102642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb63",
            "leftCorner": {
              "x": 0.703,
              "y": 7.381,
              "z": 0.792
            },
            "rightCorner": {
              "x": 0.706,
              "y": 7.412,
              "z": 0.792
            },
            "gtin": "4066447102642",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd7387d",
        "height": 1.0426,
        "facings": []
      },
      {
        "id": "696ead8b3b88e258afd7387f",
        "height": 1.2531,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb64",
            "leftCorner": {
              "x": 0.634,
              "y": 6.485,
              "z": 1.253
            },
            "rightCorner": {
              "x": 0.657,
              "y": 6.772,
              "z": 1.253
            },
            "gtin": "4008600378723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb65",
            "leftCorner": {
              "x": 0.657,
              "y": 6.772,
              "z": 1.253
            },
            "rightCorner": {
              "x": 0.732,
              "y": 7.731,
              "z": 1.253
            },
            "gtin": "5713795263424",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73880",
        "height": 1.4709,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb66",
            "leftCorner": {
              "x": 0.639,
              "y": 6.484,
              "z": 1.471
            },
            "rightCorner": {
              "x": 0.729,
              "y": 7.634,
              "z": 1.471
            },
            "gtin": "8720689043809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb67",
            "leftCorner": {
              "x": 0.729,
              "y": 7.634,
              "z": 1.471
            },
            "rightCorner": {
              "x": 0.737,
              "y": 7.73,
              "z": 1.471
            },
            "gtin": "8720689041867",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73881",
        "height": 1.7141,
        "facings": []
      },
      {
        "id": "696ead8b3b88e258afd7387e",
        "height": 1.9635,
        "facings": []
      }
    ]
  },
  {
    "id": "68e755fdb5fe7bc046959800",
    "name": "68e755fdb5fe7bc046959800",
    "x": 0.91195,
    "y": 7.717,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68038,
      "w": 0.73286
    },
    "statistics": {
      "hasStockCount": 10,
      "noStockCount": 0,
      "unknownStockCount": 5
    },
    "layers": [
      {
        "id": "696ead8b3b88e258afd73884",
        "height": 0.20048,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb43",
            "leftCorner": {
              "x": 0.958,
              "y": 7.724,
              "z": 0.2
            },
            "rightCorner": {
              "x": 0.964,
              "y": 7.804,
              "z": 0.2
            },
            "gtin": "5414959063651",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb44",
            "leftCorner": {
              "x": 0.964,
              "y": 7.804,
              "z": 0.2
            },
            "rightCorner": {
              "x": 0.969,
              "y": 7.883,
              "z": 0.2
            },
            "gtin": "4008600432111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb45",
            "leftCorner": {
              "x": 0.969,
              "y": 7.883,
              "z": 0.2
            },
            "rightCorner": {
              "x": 0.975,
              "y": 7.959,
              "z": 0.2
            },
            "gtin": "7630135603901",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb46",
            "leftCorner": {
              "x": 0.975,
              "y": 7.959,
              "z": 0.2
            },
            "rightCorner": {
              "x": 0.981,
              "y": 8.034,
              "z": 0.2
            },
            "gtin": "7630135620632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb47",
            "leftCorner": {
              "x": 0.981,
              "y": 8.034,
              "z": 0.2
            },
            "rightCorner": {
              "x": 0.986,
              "y": 8.112,
              "z": 0.2
            },
            "gtin": "7610465900246",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb48",
            "leftCorner": {
              "x": 0.986,
              "y": 8.112,
              "z": 0.2
            },
            "rightCorner": {
              "x": 0.992,
              "y": 8.186,
              "z": 0.2
            }
          },
          {
            "id": "696ebf6d43c343680a26fb49",
            "leftCorner": {
              "x": 0.992,
              "y": 8.186,
              "z": 0.2
            },
            "rightCorner": {
              "x": 0.997,
              "y": 8.258,
              "z": 0.2
            },
            "gtin": "7630135605929",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb4a",
            "leftCorner": {
              "x": 0.997,
              "y": 8.258,
              "z": 0.2
            },
            "rightCorner": {
              "x": 0.999,
              "y": 8.287,
              "z": 0.2
            }
          },
          {
            "id": "696ebf6d43c343680a26fb4b",
            "leftCorner": {
              "x": 0.999,
              "y": 8.287,
              "z": 0.2
            },
            "rightCorner": {
              "x": 1.005,
              "y": 8.355,
              "z": 0.2
            },
            "gtin": "7610465862759",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb4c",
            "leftCorner": {
              "x": 1.005,
              "y": 8.355,
              "z": 0.2
            },
            "rightCorner": {
              "x": 1.011,
              "y": 8.442,
              "z": 0.2
            }
          },
          {
            "id": "696ebf6d43c343680a26fb4d",
            "leftCorner": {
              "x": 1.011,
              "y": 8.442,
              "z": 0.2
            },
            "rightCorner": {
              "x": 1.017,
              "y": 8.519,
              "z": 0.2
            },
            "gtin": "4009049451084",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb4e",
            "leftCorner": {
              "x": 1.017,
              "y": 8.519,
              "z": 0.2
            },
            "rightCorner": {
              "x": 1.021,
              "y": 8.58,
              "z": 0.2
            },
            "gtin": "4009049449524",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb4f",
            "leftCorner": {
              "x": 1.021,
              "y": 8.58,
              "z": 0.2
            },
            "rightCorner": {
              "x": 1.027,
              "y": 8.66,
              "z": 0.2
            },
            "gtin": "4009049449524",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb50",
            "leftCorner": {
              "x": 1.027,
              "y": 8.66,
              "z": 0.2
            },
            "rightCorner": {
              "x": 1.041,
              "y": 8.841,
              "z": 0.2
            },
            "gtin": "4058172972133",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6c43c343680a26fb35",
            "leftCorner": {
              "x": 1.041,
              "y": 8.841,
              "z": 0.2
            },
            "rightCorner": {
              "x": 1.05,
              "y": 8.96,
              "z": 0.2
            },
            "gtin": "4066447619591",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73883",
        "height": 0.78721,
        "facings": []
      },
      {
        "id": "696ead8b3b88e258afd73885",
        "height": 1.0894,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb68",
            "leftCorner": {
              "x": 0.721,
              "y": 7.731,
              "z": 1.089
            },
            "rightCorner": {
              "x": 0.738,
              "y": 7.963,
              "z": 1.089
            },
            "gtin": "9001616819384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb6a",
            "leftCorner": {
              "x": 0.738,
              "y": 7.963,
              "z": 1.089
            },
            "rightCorner": {
              "x": 0.74,
              "y": 7.996,
              "z": 1.089
            }
          },
          {
            "id": "696ebf6d43c343680a26fb69",
            "leftCorner": {
              "x": 0.74,
              "y": 7.996,
              "z": 1.089
            },
            "rightCorner": {
              "x": 0.813,
              "y": 8.978,
              "z": 1.089
            },
            "gtin": "5060420234169",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73886",
        "height": 1.4172,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb6b",
            "leftCorner": {
              "x": 0.728,
              "y": 7.731,
              "z": 1.417
            },
            "rightCorner": {
              "x": 0.757,
              "y": 8.12,
              "z": 1.417
            }
          },
          {
            "id": "696ebf6d43c343680a26fb6c",
            "leftCorner": {
              "x": 0.757,
              "y": 8.12,
              "z": 1.417
            },
            "rightCorner": {
              "x": 0.821,
              "y": 8.977,
              "z": 1.417
            },
            "gtin": "4008600159193",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73887",
        "height": 1.6752,
        "facings": []
      }
    ]
  },
  {
    "id": "68e75604b5fe7bc046959808",
    "name": "68e75604b5fe7bc046959808",
    "x": 0.75305,
    "y": 5.4819,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68056,
      "w": 0.73269
    },
    "statistics": {
      "hasStockCount": 16,
      "noStockCount": 0,
      "unknownStockCount": 25
    },
    "layers": [
      {
        "id": "696ead8b3b88e258afd73877",
        "height": 0.19531,
        "facings": [
          {
            "id": "696ebf6c43c343680a26fb34",
            "leftCorner": {
              "x": 0.798,
              "y": 5.479,
              "z": 0.195
            },
            "rightCorner": {
              "x": 0.816,
              "y": 5.726,
              "z": 0.195
            },
            "gtin": "4067796137538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb36",
            "leftCorner": {
              "x": 0.816,
              "y": 5.726,
              "z": 0.195
            },
            "rightCorner": {
              "x": 0.87,
              "y": 6.455,
              "z": 0.195
            },
            "gtin": "4067796137644",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73879",
        "height": 0.47055,
        "facings": []
      },
      {
        "id": "696ead8b3b88e258afd7387a",
        "height": 0.71791,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb56",
            "leftCorner": {
              "x": 0.695,
              "y": 5.486,
              "z": 0.718
            },
            "rightCorner": {
              "x": 0.716,
              "y": 5.763,
              "z": 0.718
            },
            "gtin": "4067796137309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb58",
            "leftCorner": {
              "x": 0.716,
              "y": 5.763,
              "z": 0.718
            },
            "rightCorner": {
              "x": 0.735,
              "y": 6.016,
              "z": 0.718
            },
            "gtin": "4067796137187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb59",
            "leftCorner": {
              "x": 0.735,
              "y": 6.016,
              "z": 0.718
            },
            "rightCorner": {
              "x": 0.744,
              "y": 6.144,
              "z": 0.718
            },
            "gtin": "4067796137248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb5a",
            "leftCorner": {
              "x": 0.744,
              "y": 6.144,
              "z": 0.718
            },
            "rightCorner": {
              "x": 0.755,
              "y": 6.294,
              "z": 0.718
            },
            "gtin": "4067796137125",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb57",
            "leftCorner": {
              "x": 0.755,
              "y": 6.294,
              "z": 0.718
            },
            "rightCorner": {
              "x": 0.769,
              "y": 6.483,
              "z": 0.718
            },
            "gtin": "4067796137279",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73878",
        "height": 0.931,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb52",
            "leftCorner": {
              "x": 0.596,
              "y": 5.517,
              "z": 0.931
            },
            "rightCorner": {
              "x": 0.608,
              "y": 5.688,
              "z": 0.931
            },
            "gtin": "4067796137156",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb53",
            "leftCorner": {
              "x": 0.608,
              "y": 5.688,
              "z": 0.931
            },
            "rightCorner": {
              "x": 0.624,
              "y": 5.897,
              "z": 0.931
            },
            "gtin": "4067796137330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb54",
            "leftCorner": {
              "x": 0.624,
              "y": 5.897,
              "z": 0.931
            },
            "rightCorner": {
              "x": 0.639,
              "y": 6.1,
              "z": 0.931
            },
            "gtin": "4067796137095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb55",
            "leftCorner": {
              "x": 0.639,
              "y": 6.1,
              "z": 0.931
            },
            "rightCorner": {
              "x": 0.653,
              "y": 6.288,
              "z": 0.931
            },
            "gtin": "4066447491623",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb51",
            "leftCorner": {
              "x": 0.653,
              "y": 6.288,
              "z": 0.931
            },
            "rightCorner": {
              "x": 0.668,
              "y": 6.491,
              "z": 0.931
            },
            "gtin": "4066447491654",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73875",
        "height": 1.1463,
        "facings": [
          {
            "id": "696ebf6c43c343680a26fb19",
            "leftCorner": {
              "x": 0.597,
              "y": 5.516,
              "z": 1.146
            },
            "rightCorner": {
              "x": 0.603,
              "y": 5.596,
              "z": 1.146
            },
            "gtin": "4010355479488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6c43c343680a26fb1a",
            "leftCorner": {
              "x": 0.603,
              "y": 5.596,
              "z": 1.146
            },
            "rightCorner": {
              "x": 0.608,
              "y": 5.675,
              "z": 1.146
            },
            "gtin": "4066447167108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6c43c343680a26fb1b",
            "leftCorner": {
              "x": 0.608,
              "y": 5.675,
              "z": 1.146
            },
            "rightCorner": {
              "x": 0.615,
              "y": 5.758,
              "z": 1.146
            },
            "gtin": "4066447430004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6c43c343680a26fb1c",
            "leftCorner": {
              "x": 0.615,
              "y": 5.758,
              "z": 1.146
            },
            "rightCorner": {
              "x": 0.62,
              "y": 5.83,
              "z": 1.146
            },
            "gtin": "4066447430097",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6c43c343680a26fb1d",
            "leftCorner": {
              "x": 0.62,
              "y": 5.83,
              "z": 1.146
            },
            "rightCorner": {
              "x": 0.626,
              "y": 5.917,
              "z": 1.146
            },
            "gtin": "4058172273858",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6c43c343680a26fb1e",
            "leftCorner": {
              "x": 0.626,
              "y": 5.917,
              "z": 1.146
            },
            "rightCorner": {
              "x": 0.631,
              "y": 5.981,
              "z": 1.146
            },
            "gtin": "4066447730616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6c43c343680a26fb1f",
            "leftCorner": {
              "x": 0.631,
              "y": 5.981,
              "z": 1.146
            },
            "rightCorner": {
              "x": 0.637,
              "y": 6.056,
              "z": 1.146
            },
            "gtin": "4066447730494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6c43c343680a26fb20",
            "leftCorner": {
              "x": 0.637,
              "y": 6.056,
              "z": 1.146
            },
            "rightCorner": {
              "x": 0.641,
              "y": 6.117,
              "z": 1.146
            },
            "gtin": "4066447730555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6c43c343680a26fb21",
            "leftCorner": {
              "x": 0.641,
              "y": 6.117,
              "z": 1.146
            },
            "rightCorner": {
              "x": 0.645,
              "y": 6.167,
              "z": 1.146
            },
            "gtin": "4066447416053",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6c43c343680a26fb22",
            "leftCorner": {
              "x": 0.645,
              "y": 6.167,
              "z": 1.146
            },
            "rightCorner": {
              "x": 0.648,
              "y": 6.213,
              "z": 1.146
            },
            "gtin": "4066447718829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6c43c343680a26fb23",
            "leftCorner": {
              "x": 0.648,
              "y": 6.213,
              "z": 1.146
            },
            "rightCorner": {
              "x": 0.651,
              "y": 6.247,
              "z": 1.146
            },
            "gtin": "4066447718812",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6c43c343680a26fb24",
            "leftCorner": {
              "x": 0.651,
              "y": 6.247,
              "z": 1.146
            },
            "rightCorner": {
              "x": 0.654,
              "y": 6.291,
              "z": 1.146
            },
            "gtin": "4066447174946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6c43c343680a26fb25",
            "leftCorner": {
              "x": 0.654,
              "y": 6.291,
              "z": 1.146
            },
            "rightCorner": {
              "x": 0.657,
              "y": 6.336,
              "z": 1.146
            },
            "gtin": "4066447174946",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6c43c343680a26fb26",
            "leftCorner": {
              "x": 0.657,
              "y": 6.336,
              "z": 1.146
            },
            "rightCorner": {
              "x": 0.665,
              "y": 6.434,
              "z": 1.146
            },
            "gtin": "4067796144444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6c43c343680a26fb18",
            "leftCorner": {
              "x": 0.665,
              "y": 6.434,
              "z": 1.146
            },
            "rightCorner": {
              "x": 0.669,
              "y": 6.491,
              "z": 1.146
            }
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73876",
        "height": 1.3101,
        "facings": [
          {
            "id": "696ebf6c43c343680a26fb27",
            "leftCorner": {
              "x": 0.594,
              "y": 5.494,
              "z": 1.31
            },
            "rightCorner": {
              "x": 0.601,
              "y": 5.585,
              "z": 1.31
            },
            "gtin": "4066447608007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6c43c343680a26fb29",
            "leftCorner": {
              "x": 0.601,
              "y": 5.585,
              "z": 1.31
            },
            "rightCorner": {
              "x": 0.606,
              "y": 5.653,
              "z": 1.31
            },
            "gtin": "4066447731163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6c43c343680a26fb2a",
            "leftCorner": {
              "x": 0.606,
              "y": 5.653,
              "z": 1.31
            },
            "rightCorner": {
              "x": 0.612,
              "y": 5.736,
              "z": 1.31
            },
            "gtin": "4058172327674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6c43c343680a26fb2b",
            "leftCorner": {
              "x": 0.612,
              "y": 5.736,
              "z": 1.31
            },
            "rightCorner": {
              "x": 0.617,
              "y": 5.805,
              "z": 1.31
            },
            "gtin": "4066447430066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6c43c343680a26fb2c",
            "leftCorner": {
              "x": 0.617,
              "y": 5.805,
              "z": 1.31
            },
            "rightCorner": {
              "x": 0.623,
              "y": 5.879,
              "z": 1.31
            },
            "gtin": "4066447730586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6c43c343680a26fb2d",
            "leftCorner": {
              "x": 0.623,
              "y": 5.879,
              "z": 1.31
            },
            "rightCorner": {
              "x": 0.627,
              "y": 5.945,
              "z": 1.31
            },
            "gtin": "4066447430189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6c43c343680a26fb2e",
            "leftCorner": {
              "x": 0.627,
              "y": 5.945,
              "z": 1.31
            },
            "rightCorner": {
              "x": 0.632,
              "y": 6.009,
              "z": 1.31
            },
            "gtin": "4066447731156",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6c43c343680a26fb2f",
            "leftCorner": {
              "x": 0.632,
              "y": 6.009,
              "z": 1.31
            },
            "rightCorner": {
              "x": 0.638,
              "y": 6.084,
              "z": 1.31
            },
            "gtin": "4066447731125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6c43c343680a26fb30",
            "leftCorner": {
              "x": 0.638,
              "y": 6.084,
              "z": 1.31
            },
            "rightCorner": {
              "x": 0.643,
              "y": 6.16,
              "z": 1.31
            },
            "gtin": "4066447430271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6c43c343680a26fb31",
            "leftCorner": {
              "x": 0.643,
              "y": 6.16,
              "z": 1.31
            },
            "rightCorner": {
              "x": 0.648,
              "y": 6.222,
              "z": 1.31
            },
            "gtin": "4010355290151",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6c43c343680a26fb32",
            "leftCorner": {
              "x": 0.648,
              "y": 6.222,
              "z": 1.31
            },
            "rightCorner": {
              "x": 0.652,
              "y": 6.282,
              "z": 1.31
            },
            "gtin": "4066447416145",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6c43c343680a26fb33",
            "leftCorner": {
              "x": 0.652,
              "y": 6.282,
              "z": 1.31
            },
            "rightCorner": {
              "x": 0.658,
              "y": 6.365,
              "z": 1.31
            },
            "gtin": "4066447903256",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6c43c343680a26fb28",
            "leftCorner": {
              "x": 0.658,
              "y": 6.365,
              "z": 1.31
            },
            "rightCorner": {
              "x": 0.668,
              "y": 6.491,
              "z": 1.31
            },
            "gtin": "4066447174915",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd7387b",
        "height": 1.5255,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb5c",
            "leftCorner": {
              "x": 0.505,
              "y": 5.527,
              "z": 1.525
            },
            "rightCorner": {
              "x": 0.508,
              "y": 5.575,
              "z": 1.525
            }
          },
          {
            "id": "696ebf6d43c343680a26fb5d",
            "leftCorner": {
              "x": 0.508,
              "y": 5.575,
              "z": 1.525
            },
            "rightCorner": {
              "x": 0.519,
              "y": 5.721,
              "z": 1.525
            }
          },
          {
            "id": "696ebf6d43c343680a26fb5e",
            "leftCorner": {
              "x": 0.519,
              "y": 5.721,
              "z": 1.525
            },
            "rightCorner": {
              "x": 0.528,
              "y": 5.835,
              "z": 1.525
            },
            "gtin": "4058172913716",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb5f",
            "leftCorner": {
              "x": 0.528,
              "y": 5.835,
              "z": 1.525
            },
            "rightCorner": {
              "x": 0.529,
              "y": 5.86,
              "z": 1.525
            }
          },
          {
            "id": "696ebf6d43c343680a26fb60",
            "leftCorner": {
              "x": 0.529,
              "y": 5.86,
              "z": 1.525
            },
            "rightCorner": {
              "x": 0.54,
              "y": 6.007,
              "z": 1.525
            }
          },
          {
            "id": "696ebf6d43c343680a26fb61",
            "leftCorner": {
              "x": 0.54,
              "y": 6.007,
              "z": 1.525
            },
            "rightCorner": {
              "x": 0.552,
              "y": 6.167,
              "z": 1.525
            }
          },
          {
            "id": "696ebf6d43c343680a26fb5b",
            "leftCorner": {
              "x": 0.552,
              "y": 6.167,
              "z": 1.525
            },
            "rightCorner": {
              "x": 0.576,
              "y": 6.498,
              "z": 1.525
            },
            "gtin": "4066447430615",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e75614b5fe7bc04695980b",
    "name": "68e75614b5fe7bc04695980b",
    "x": 0.59649,
    "y": 4.4905,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68816,
      "w": 0.72556
    },
    "layers": []
  },
  {
    "id": "68e7566db5fe7bc046959844",
    "name": "68e7566db5fe7bc046959844",
    "x": 15.217,
    "y": 13.758,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72359,
      "w": 0.69023
    },
    "statistics": {
      "hasStockCount": 6,
      "noStockCount": 0,
      "unknownStockCount": 10
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73bd9",
        "height": 0.19924,
        "facings": [
          {
            "id": "696ebf6e43c343680a27068d",
            "leftCorner": {
              "x": 15.098,
              "y": 13.763,
              "z": 0.199
            },
            "rightCorner": {
              "x": 15.07,
              "y": 13.168,
              "z": 0.199
            }
          },
          {
            "id": "696ebf6e43c343680a27068f",
            "leftCorner": {
              "x": 15.07,
              "y": 13.168,
              "z": 0.199
            },
            "rightCorner": {
              "x": 15.062,
              "y": 13.002,
              "z": 0.199
            },
            "gtin": "7322540788006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270690",
            "leftCorner": {
              "x": 15.062,
              "y": 13.002,
              "z": 0.199
            },
            "rightCorner": {
              "x": 15.054,
              "y": 12.837,
              "z": 0.199
            }
          },
          {
            "id": "696ebf6e43c343680a270691",
            "leftCorner": {
              "x": 15.054,
              "y": 12.837,
              "z": 0.199
            },
            "rightCorner": {
              "x": 15.04,
              "y": 12.543,
              "z": 0.199
            },
            "gtin": "4058172862144",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bd5",
        "height": 0.67565,
        "facings": [
          {
            "id": "696ebf7143c343680a271f65",
            "leftCorner": {
              "x": 15.108,
              "y": 13.763,
              "z": 0.676
            },
            "rightCorner": {
              "x": 15.084,
              "y": 13.255,
              "z": 0.676
            },
            "gtin": "7322541205670",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f67",
            "leftCorner": {
              "x": 15.084,
              "y": 13.255,
              "z": 0.676
            },
            "rightCorner": {
              "x": 15.073,
              "y": 13.018,
              "z": 0.676
            },
            "gtin": "7322542527962",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f68",
            "leftCorner": {
              "x": 15.073,
              "y": 13.018,
              "z": 0.676
            },
            "rightCorner": {
              "x": 15.06,
              "y": 12.748,
              "z": 0.676
            },
            "gtin": "7322541409276",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f66",
            "leftCorner": {
              "x": 15.06,
              "y": 12.748,
              "z": 0.676
            },
            "rightCorner": {
              "x": 15.049,
              "y": 12.514,
              "z": 0.676
            },
            "gtin": "7322542520284",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bd7",
        "height": 1.0957,
        "facings": [
          {
            "id": "696ebf7143c343680a271f69",
            "leftCorner": {
              "x": 15.113,
              "y": 13.763,
              "z": 1.096
            },
            "rightCorner": {
              "x": 15.101,
              "y": 13.502,
              "z": 1.096
            }
          },
          {
            "id": "696ebf7143c343680a271f6b",
            "leftCorner": {
              "x": 15.101,
              "y": 13.502,
              "z": 1.096
            },
            "rightCorner": {
              "x": 15.09,
              "y": 13.276,
              "z": 1.096
            },
            "gtin": "5029053038759",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f6c",
            "leftCorner": {
              "x": 15.09,
              "y": 13.276,
              "z": 1.096
            },
            "rightCorner": {
              "x": 15.08,
              "y": 13.06,
              "z": 1.096
            },
            "gtin": "7322541403113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f6d",
            "leftCorner": {
              "x": 15.08,
              "y": 13.06,
              "z": 1.096
            },
            "rightCorner": {
              "x": 15.067,
              "y": 12.795,
              "z": 1.096
            }
          },
          {
            "id": "696ebf7143c343680a271f6a",
            "leftCorner": {
              "x": 15.067,
              "y": 12.795,
              "z": 1.096
            },
            "rightCorner": {
              "x": 15.054,
              "y": 12.514,
              "z": 1.096
            },
            "gtin": "7322541402826",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bd8",
        "height": 1.4369,
        "facings": [
          {
            "id": "696ebf7143c343680a271f6e",
            "leftCorner": {
              "x": 15.113,
              "y": 13.763,
              "z": 1.437
            },
            "rightCorner": {
              "x": 15.101,
              "y": 13.51,
              "z": 1.437
            }
          },
          {
            "id": "696ebf7143c343680a271f70",
            "leftCorner": {
              "x": 15.101,
              "y": 13.51,
              "z": 1.437
            },
            "rightCorner": {
              "x": 15.093,
              "y": 13.333,
              "z": 1.437
            },
            "gtin": "4066447244687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f71",
            "leftCorner": {
              "x": 15.093,
              "y": 13.333,
              "z": 1.437
            },
            "rightCorner": {
              "x": 15.09,
              "y": 13.274,
              "z": 1.437
            },
            "gtin": "4066447244687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f72",
            "leftCorner": {
              "x": 15.09,
              "y": 13.274,
              "z": 1.437
            },
            "rightCorner": {
              "x": 15.082,
              "y": 13.118,
              "z": 1.437
            },
            "gtin": "4010355274618",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f73",
            "leftCorner": {
              "x": 15.082,
              "y": 13.118,
              "z": 1.437
            },
            "rightCorner": {
              "x": 15.076,
              "y": 12.983,
              "z": 1.437
            }
          },
          {
            "id": "696ebf7143c343680a271f6f",
            "leftCorner": {
              "x": 15.076,
              "y": 12.983,
              "z": 1.437
            },
            "rightCorner": {
              "x": 15.054,
              "y": 12.514,
              "z": 1.437
            },
            "gtin": "4066447244366",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bd6",
        "height": 1.7689,
        "facings": [
          {
            "id": "696ebf6e43c343680a270631",
            "leftCorner": {
              "x": 15.111,
              "y": 13.763,
              "z": 1.769
            },
            "rightCorner": {
              "x": 15.097,
              "y": 13.48,
              "z": 1.769
            }
          },
          {
            "id": "696ebf6e43c343680a270633",
            "leftCorner": {
              "x": 15.097,
              "y": 13.48,
              "z": 1.769
            },
            "rightCorner": {
              "x": 15.086,
              "y": 13.228,
              "z": 1.769
            },
            "gtin": "4066447484663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270634",
            "leftCorner": {
              "x": 15.086,
              "y": 13.228,
              "z": 1.769
            },
            "rightCorner": {
              "x": 15.074,
              "y": 12.994,
              "z": 1.769
            },
            "gtin": "4058172286414",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270635",
            "leftCorner": {
              "x": 15.074,
              "y": 12.994,
              "z": 1.769
            },
            "rightCorner": {
              "x": 15.063,
              "y": 12.752,
              "z": 1.769
            },
            "gtin": "4058172286391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270636",
            "leftCorner": {
              "x": 15.063,
              "y": 12.752,
              "z": 1.769
            },
            "rightCorner": {
              "x": 15.051,
              "y": 12.507,
              "z": 1.769
            }
          }
        ]
      }
    ]
  },
  {
    "id": "68e7566db5fe7bc046959845",
    "name": "68e7566db5fe7bc046959845",
    "x": 15.074,
    "y": 12.5,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72636,
      "w": 0.68731
    },
    "statistics": {
      "hasStockCount": 7,
      "noStockCount": 1,
      "unknownStockCount": 8
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73bdd",
        "height": 0.19261,
        "facings": [
          {
            "id": "696ebf6e43c343680a270692",
            "leftCorner": {
              "x": 15.03,
              "y": 12.531,
              "z": 0.193
            },
            "rightCorner": {
              "x": 15.016,
              "y": 12.23,
              "z": 0.193
            },
            "gtin": "4010355275981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270693",
            "leftCorner": {
              "x": 15.014,
              "y": 12.23,
              "z": 0.193
            },
            "rightCorner": {
              "x": 14.998,
              "y": 11.902,
              "z": 0.193
            },
            "gtin": "4058172622687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270694",
            "leftCorner": {
              "x": 14.995,
              "y": 11.902,
              "z": 0.193
            },
            "rightCorner": {
              "x": 14.979,
              "y": 11.551,
              "z": 0.193
            },
            "gtin": "8004260450546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270695",
            "leftCorner": {
              "x": 14.976,
              "y": 11.551,
              "z": 0.193
            },
            "rightCorner": {
              "x": 14.962,
              "y": 11.257,
              "z": 0.193
            },
            "gtin": "8004260450515",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bdc",
        "height": 0.75981,
        "facings": []
      },
      {
        "id": "696ead8e3b88e258afd73bda",
        "height": 1.261,
        "facings": [
          {
            "id": "696ebf7143c343680a271f74",
            "leftCorner": {
              "x": 15.03,
              "y": 12.503,
              "z": 1.261
            },
            "rightCorner": {
              "x": 15.001,
              "y": 11.982,
              "z": 1.261
            },
            "gtin": "4010355276476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f76",
            "leftCorner": {
              "x": 15.001,
              "y": 11.982,
              "z": 1.261
            },
            "rightCorner": {
              "x": 14.987,
              "y": 11.725,
              "z": 1.261
            },
            "gtin": "8004260450638",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f75",
            "leftCorner": {
              "x": 14.987,
              "y": 11.725,
              "z": 1.261
            },
            "rightCorner": {
              "x": 14.961,
              "y": 11.255,
              "z": 1.261
            },
            "gtin": "8004260007788",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bdb",
        "height": 1.7674,
        "facings": [
          {
            "id": "696ebf6e43c343680a270637",
            "leftCorner": {
              "x": 15.031,
              "y": 12.495,
              "z": 1.767
            },
            "rightCorner": {
              "x": 15.017,
              "y": 12.244,
              "z": 1.767
            },
            "gtin": "4066447484540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270638",
            "leftCorner": {
              "x": 15.017,
              "y": 12.244,
              "z": 1.767
            },
            "rightCorner": {
              "x": 15.014,
              "y": 12.189,
              "z": 1.767
            },
            "gtin": "4262362451173",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270639",
            "leftCorner": {
              "x": 15.014,
              "y": 12.189,
              "z": 1.767
            },
            "rightCorner": {
              "x": 15.009,
              "y": 12.111,
              "z": 1.767
            },
            "gtin": "4170000037668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27063a",
            "leftCorner": {
              "x": 15.009,
              "y": 12.111,
              "z": 1.767
            },
            "rightCorner": {
              "x": 15.005,
              "y": 12.024,
              "z": 1.767
            },
            "gtin": "4262368580303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27063b",
            "leftCorner": {
              "x": 15.005,
              "y": 12.024,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.996,
              "y": 11.86,
              "z": 1.767
            },
            "gtin": "4066447861341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27063c",
            "leftCorner": {
              "x": 14.996,
              "y": 11.86,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.987,
              "y": 11.708,
              "z": 1.767
            },
            "gtin": "4058172927928",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27063d",
            "leftCorner": {
              "x": 14.987,
              "y": 11.708,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.979,
              "y": 11.566,
              "z": 1.767
            },
            "gtin": "4058172927966",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27063e",
            "leftCorner": {
              "x": 14.979,
              "y": 11.566,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.972,
              "y": 11.437,
              "z": 1.767
            },
            "gtin": "4066447374773",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27063f",
            "leftCorner": {
              "x": 14.972,
              "y": 11.437,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.963,
              "y": 11.267,
              "z": 1.767
            },
            "gtin": "4058172928024",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7566db5fe7bc046959846",
    "name": "68e7566db5fe7bc046959846",
    "x": 14.99,
    "y": 11.251,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73811,
      "w": 0.67468
    },
    "statistics": {
      "hasStockCount": 3,
      "noStockCount": 0,
      "unknownStockCount": 7,
      "shelfCategory": "TOILET_PAPER"
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73be0",
        "height": 0.19109,
        "facings": [
          {
            "id": "696ebf6e43c343680a270696",
            "leftCorner": {
              "x": 14.96,
              "y": 11.257,
              "z": 0.193
            },
            "rightCorner": {
              "x": 14.945,
              "y": 10.993,
              "z": 0.193
            },
            "gtin": "7322541459691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270697",
            "leftCorner": {
              "x": 14.936,
              "y": 11.024,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.917,
              "y": 10.674,
              "z": 0.199
            },
            "gtin": "8004260007870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270698",
            "leftCorner": {
              "x": 14.908,
              "y": 10.675,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.889,
              "y": 10.328,
              "z": 0.199
            },
            "gtin": "4066447506310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270699",
            "leftCorner": {
              "x": 14.88,
              "y": 10.329,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.863,
              "y": 10.019,
              "z": 0.199
            },
            "gtin": "4066447506341",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bdf",
        "height": 0.92198,
        "facings": [
          {
            "id": "696ebf6e43c343680a27068b",
            "leftCorner": {
              "x": 14.949,
              "y": 11.255,
              "z": 0.922
            },
            "rightCorner": {
              "x": 14.895,
              "y": 10.661,
              "z": 0.922
            },
            "gtin": "7322540973235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27068c",
            "leftCorner": {
              "x": 14.895,
              "y": 10.661,
              "z": 0.922
            },
            "rightCorner": {
              "x": 14.892,
              "y": 10.629,
              "z": 0.922
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bde",
        "height": 1.7656,
        "facings": [
          {
            "id": "696ebf6e43c343680a270640",
            "leftCorner": {
              "x": 14.963,
              "y": 11.267,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.954,
              "y": 11.11,
              "z": 1.767
            },
            "gtin": "4066447374919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270641",
            "leftCorner": {
              "x": 14.927,
              "y": 11.112,
              "z": 1.766
            },
            "rightCorner": {
              "x": 14.909,
              "y": 10.905,
              "z": 1.766
            },
            "gtin": "4058172928086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270642",
            "leftCorner": {
              "x": 14.909,
              "y": 10.905,
              "z": 1.766
            },
            "rightCorner": {
              "x": 14.894,
              "y": 10.738,
              "z": 1.766
            }
          },
          {
            "id": "696ebf6e43c343680a270643",
            "leftCorner": {
              "x": 14.894,
              "y": 10.738,
              "z": 1.766
            },
            "rightCorner": {
              "x": 14.89,
              "y": 10.698,
              "z": 1.766
            }
          },
          {
            "id": "696ebf6e43c343680a270644",
            "leftCorner": {
              "x": 14.89,
              "y": 10.698,
              "z": 1.766
            },
            "rightCorner": {
              "x": 14.878,
              "y": 10.562,
              "z": 1.766
            },
            "gtin": "4067796192483",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270645",
            "leftCorner": {
              "x": 14.878,
              "y": 10.562,
              "z": 1.766
            },
            "rightCorner": {
              "x": 14.861,
              "y": 10.379,
              "z": 1.766
            },
            "gtin": "4067796195453",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270646",
            "leftCorner": {
              "x": 14.861,
              "y": 10.379,
              "z": 1.766
            },
            "rightCorner": {
              "x": 14.845,
              "y": 10.194,
              "z": 1.766
            }
          },
          {
            "id": "696ebf6e43c343680a270647",
            "leftCorner": {
              "x": 14.845,
              "y": 10.194,
              "z": 1.766
            },
            "rightCorner": {
              "x": 14.828,
              "y": 10.014,
              "z": 1.766
            },
            "gtin": "4066447374933",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7566db5fe7bc046959847",
    "name": "68e7566db5fe7bc046959847",
    "x": 14.976,
    "y": 10.005,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72975,
      "w": 0.68372
    },
    "statistics": {
      "hasStockCount": 3,
      "noStockCount": 0,
      "unknownStockCount": 7,
      "shelfCategory": "TOILET_PAPER"
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73be1",
        "height": 0.19539,
        "facings": [
          {
            "id": "696ebf6e43c343680a27069a",
            "leftCorner": {
              "x": 14.856,
              "y": 10.02,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.833,
              "y": 9.616,
              "z": 0.199
            },
            "gtin": "4067796195453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27069b",
            "leftCorner": {
              "x": 14.823,
              "y": 9.617,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.795,
              "y": 9.097,
              "z": 0.199
            },
            "gtin": "4066447787672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27069c",
            "leftCorner": {
              "x": 14.782,
              "y": 9.098,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.741,
              "y": 8.355,
              "z": 0.199
            },
            "gtin": "4066447946789",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73be3",
        "height": 0.92164,
        "facings": []
      },
      {
        "id": "696ead8e3b88e258afd73be2",
        "height": 1.7665,
        "facings": [
          {
            "id": "696ebf6e43c343680a270648",
            "leftCorner": {
              "x": 14.828,
              "y": 10.014,
              "z": 1.766
            },
            "rightCorner": {
              "x": 14.814,
              "y": 9.849,
              "z": 1.766
            },
            "gtin": "4066447375138",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270649",
            "leftCorner": {
              "x": 14.826,
              "y": 9.852,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.815,
              "y": 9.687,
              "z": 1.767
            },
            "gtin": "4066447375138",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27064a",
            "leftCorner": {
              "x": 14.815,
              "y": 9.687,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.802,
              "y": 9.497,
              "z": 1.767
            },
            "gtin": "4260344221523",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27064b",
            "leftCorner": {
              "x": 14.802,
              "y": 9.497,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.79,
              "y": 9.309,
              "z": 1.767
            },
            "gtin": "4260344220588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27064c",
            "leftCorner": {
              "x": 14.79,
              "y": 9.309,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.779,
              "y": 9.131,
              "z": 1.767
            },
            "gtin": "4260344220717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27064d",
            "leftCorner": {
              "x": 14.779,
              "y": 9.131,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.769,
              "y": 8.986,
              "z": 1.767
            },
            "gtin": "7322542461556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27064e",
            "leftCorner": {
              "x": 14.769,
              "y": 8.986,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.759,
              "y": 8.835,
              "z": 1.767
            },
            "gtin": "7322541420493",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7566db5fe7bc046959848",
    "name": "68e7566db5fe7bc046959848",
    "x": 14.89,
    "y": 8.7724,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73394,
      "w": 0.67922
    },
    "statistics": {
      "hasStockCount": 4,
      "noStockCount": 0,
      "unknownStockCount": 6,
      "shelfCategory": "TOILET_PAPER"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd7398d",
        "height": 0.20092,
        "facings": [
          {
            "id": "696ebf6e43c343680a27069d",
            "leftCorner": {
              "x": 14.722,
              "y": 8.356,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.676,
              "y": 7.522,
              "z": 0.199
            },
            "gtin": "4058172862212",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7398c",
        "height": 0.9275,
        "facings": []
      },
      {
        "id": "696ead8c3b88e258afd7398b",
        "height": 1.7706,
        "facings": [
          {
            "id": "696ebf6e43c343680a27064f",
            "leftCorner": {
              "x": 14.759,
              "y": 8.835,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.75,
              "y": 8.698,
              "z": 1.767
            },
            "gtin": "7322542162132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270650",
            "leftCorner": {
              "x": 14.736,
              "y": 8.715,
              "z": 1.771
            },
            "rightCorner": {
              "x": 14.725,
              "y": 8.571,
              "z": 1.771
            },
            "gtin": "7322541208251",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270651",
            "leftCorner": {
              "x": 14.725,
              "y": 8.571,
              "z": 1.771
            },
            "rightCorner": {
              "x": 14.712,
              "y": 8.411,
              "z": 1.771
            },
            "gtin": "7322542528334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270652",
            "leftCorner": {
              "x": 14.712,
              "y": 8.411,
              "z": 1.771
            },
            "rightCorner": {
              "x": 14.698,
              "y": 8.23,
              "z": 1.771
            },
            "gtin": "7322540907520",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270653",
            "leftCorner": {
              "x": 14.698,
              "y": 8.23,
              "z": 1.771
            },
            "rightCorner": {
              "x": 14.686,
              "y": 8.077,
              "z": 1.771
            },
            "gtin": "5029053584331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270654",
            "leftCorner": {
              "x": 14.686,
              "y": 8.077,
              "z": 1.771
            },
            "rightCorner": {
              "x": 14.674,
              "y": 7.917,
              "z": 1.771
            }
          },
          {
            "id": "696ebf6e43c343680a270655",
            "leftCorner": {
              "x": 14.674,
              "y": 7.917,
              "z": 1.771
            },
            "rightCorner": {
              "x": 14.662,
              "y": 7.768,
              "z": 1.771
            },
            "gtin": "5029053575162",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270656",
            "leftCorner": {
              "x": 14.662,
              "y": 7.768,
              "z": 1.771
            },
            "rightCorner": {
              "x": 14.651,
              "y": 7.618,
              "z": 1.771
            },
            "gtin": "5029053579672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270657",
            "leftCorner": {
              "x": 14.651,
              "y": 7.618,
              "z": 1.771
            },
            "rightCorner": {
              "x": 14.648,
              "y": 7.587,
              "z": 1.771
            },
            "gtin": "5029053575292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270658",
            "leftCorner": {
              "x": 14.648,
              "y": 7.587,
              "z": 1.771
            },
            "rightCorner": {
              "x": 14.641,
              "y": 7.498,
              "z": 1.771
            },
            "gtin": "4010355274595",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7566db5fe7bc046959849",
    "name": "68e7566db5fe7bc046959849",
    "x": 14.702,
    "y": 7.5441,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73484,
      "w": 0.67824
    },
    "statistics": {
      "hasStockCount": 13,
      "noStockCount": 0,
      "unknownStockCount": 21
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73be8",
        "height": 0.19937,
        "facings": [
          {
            "id": "696ebf6e43c343680a27069e",
            "leftCorner": {
              "x": 14.655,
              "y": 7.523,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.637,
              "y": 7.294,
              "z": 0.199
            },
            "gtin": "4009408038420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27069f",
            "leftCorner": {
              "x": 14.637,
              "y": 7.294,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.62,
              "y": 7.077,
              "z": 0.199
            },
            "gtin": "4009408038420",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706a0",
            "leftCorner": {
              "x": 14.62,
              "y": 7.077,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.6,
              "y": 6.832,
              "z": 0.199
            }
          },
          {
            "id": "696ebf6e43c343680a2706a1",
            "leftCorner": {
              "x": 14.6,
              "y": 6.832,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.579,
              "y": 6.567,
              "z": 0.199
            },
            "gtin": "7332152214114",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706a2",
            "leftCorner": {
              "x": 14.579,
              "y": 6.567,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.542,
              "y": 6.117,
              "z": 0.199
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73be6",
        "height": 0.50949,
        "facings": [
          {
            "id": "696ebf7143c343680a271f9d",
            "leftCorner": {
              "x": 14.658,
              "y": 7.548,
              "z": 0.509
            },
            "rightCorner": {
              "x": 14.641,
              "y": 7.338,
              "z": 0.509
            }
          },
          {
            "id": "696ebf7143c343680a271f9e",
            "leftCorner": {
              "x": 14.641,
              "y": 7.338,
              "z": 0.509
            },
            "rightCorner": {
              "x": 14.628,
              "y": 7.175,
              "z": 0.509
            },
            "gtin": "4066447366228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f9f",
            "leftCorner": {
              "x": 14.628,
              "y": 7.175,
              "z": 0.509
            },
            "rightCorner": {
              "x": 14.607,
              "y": 6.913,
              "z": 0.509
            }
          },
          {
            "id": "696ebf7143c343680a271fa0",
            "leftCorner": {
              "x": 14.607,
              "y": 6.913,
              "z": 0.509
            },
            "rightCorner": {
              "x": 14.587,
              "y": 6.667,
              "z": 0.509
            },
            "gtin": "4066447366242",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fa1",
            "leftCorner": {
              "x": 14.587,
              "y": 6.667,
              "z": 0.509
            },
            "rightCorner": {
              "x": 14.569,
              "y": 6.441,
              "z": 0.509
            }
          },
          {
            "id": "696ebf7143c343680a271fa2",
            "leftCorner": {
              "x": 14.569,
              "y": 6.441,
              "z": 0.509
            },
            "rightCorner": {
              "x": 14.557,
              "y": 6.289,
              "z": 0.509
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73be7",
        "height": 0.84338,
        "facings": [
          {
            "id": "696ebf7143c343680a271fba",
            "leftCorner": {
              "x": 14.655,
              "y": 7.548,
              "z": 0.843
            },
            "rightCorner": {
              "x": 14.638,
              "y": 7.335,
              "z": 0.843
            }
          },
          {
            "id": "696ebf7143c343680a271fbb",
            "leftCorner": {
              "x": 14.638,
              "y": 7.335,
              "z": 0.843
            },
            "rightCorner": {
              "x": 14.625,
              "y": 7.169,
              "z": 0.843
            },
            "gtin": "8700216224918",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fbc",
            "leftCorner": {
              "x": 14.625,
              "y": 7.169,
              "z": 0.843
            },
            "rightCorner": {
              "x": 14.61,
              "y": 6.986,
              "z": 0.843
            },
            "gtin": "8700216224970",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fbd",
            "leftCorner": {
              "x": 14.61,
              "y": 6.986,
              "z": 0.843
            },
            "rightCorner": {
              "x": 14.595,
              "y": 6.801,
              "z": 0.843
            },
            "gtin": "8700216224970",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fbe",
            "leftCorner": {
              "x": 14.595,
              "y": 6.801,
              "z": 0.843
            },
            "rightCorner": {
              "x": 14.593,
              "y": 6.776,
              "z": 0.843
            }
          },
          {
            "id": "696ebf7143c343680a271fbf",
            "leftCorner": {
              "x": 14.593,
              "y": 6.776,
              "z": 0.843
            },
            "rightCorner": {
              "x": 14.578,
              "y": 6.59,
              "z": 0.843
            },
            "gtin": "7322542146989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fc0",
            "leftCorner": {
              "x": 14.578,
              "y": 6.59,
              "z": 0.843
            },
            "rightCorner": {
              "x": 14.562,
              "y": 6.383,
              "z": 0.843
            },
            "gtin": "7322542088012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fc1",
            "leftCorner": {
              "x": 14.562,
              "y": 6.383,
              "z": 0.843
            },
            "rightCorner": {
              "x": 14.548,
              "y": 6.216,
              "z": 0.843
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73be4",
        "height": 1.1827,
        "facings": [
          {
            "id": "696ebf7143c343680a271f77",
            "leftCorner": {
              "x": 14.654,
              "y": 7.548,
              "z": 1.183
            },
            "rightCorner": {
              "x": 14.645,
              "y": 7.444,
              "z": 1.183
            },
            "gtin": "7322542327500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f79",
            "leftCorner": {
              "x": 14.645,
              "y": 7.444,
              "z": 1.183
            },
            "rightCorner": {
              "x": 14.638,
              "y": 7.352,
              "z": 1.183
            },
            "gtin": "7322542327500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f7a",
            "leftCorner": {
              "x": 14.638,
              "y": 7.352,
              "z": 1.183
            },
            "rightCorner": {
              "x": 14.629,
              "y": 7.238,
              "z": 1.183
            },
            "gtin": "4066447353082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f7b",
            "leftCorner": {
              "x": 14.629,
              "y": 7.238,
              "z": 1.183
            },
            "rightCorner": {
              "x": 14.622,
              "y": 7.156,
              "z": 1.183
            },
            "gtin": "4067796274028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f7c",
            "leftCorner": {
              "x": 14.622,
              "y": 7.156,
              "z": 1.183
            },
            "rightCorner": {
              "x": 14.615,
              "y": 7.069,
              "z": 1.183
            },
            "gtin": "4067796274004",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f7d",
            "leftCorner": {
              "x": 14.615,
              "y": 7.069,
              "z": 1.183
            },
            "rightCorner": {
              "x": 14.608,
              "y": 6.982,
              "z": 1.183
            },
            "gtin": "4067796274004",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f7e",
            "leftCorner": {
              "x": 14.608,
              "y": 6.982,
              "z": 1.183
            },
            "rightCorner": {
              "x": 14.601,
              "y": 6.888,
              "z": 1.183
            },
            "gtin": "4009408040447",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f7f",
            "leftCorner": {
              "x": 14.601,
              "y": 6.888,
              "z": 1.183
            },
            "rightCorner": {
              "x": 14.595,
              "y": 6.813,
              "z": 1.183
            }
          },
          {
            "id": "696ebf7143c343680a271f80",
            "leftCorner": {
              "x": 14.595,
              "y": 6.813,
              "z": 1.183
            },
            "rightCorner": {
              "x": 14.592,
              "y": 6.785,
              "z": 1.183
            }
          },
          {
            "id": "696ebf7143c343680a271f81",
            "leftCorner": {
              "x": 14.592,
              "y": 6.785,
              "z": 1.183
            },
            "rightCorner": {
              "x": 14.583,
              "y": 6.662,
              "z": 1.183
            },
            "gtin": "7332152213087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f82",
            "leftCorner": {
              "x": 14.583,
              "y": 6.662,
              "z": 1.183
            },
            "rightCorner": {
              "x": 14.573,
              "y": 6.537,
              "z": 1.183
            },
            "gtin": "7332152213087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f83",
            "leftCorner": {
              "x": 14.573,
              "y": 6.537,
              "z": 1.183
            },
            "rightCorner": {
              "x": 14.563,
              "y": 6.421,
              "z": 1.183
            },
            "gtin": "4009408040522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f84",
            "leftCorner": {
              "x": 14.563,
              "y": 6.421,
              "z": 1.183
            },
            "rightCorner": {
              "x": 14.553,
              "y": 6.294,
              "z": 1.183
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73be9",
        "height": 1.4791,
        "facings": [
          {
            "id": "696ebf7143c343680a271fd0",
            "leftCorner": {
              "x": 14.648,
              "y": 7.548,
              "z": 1.479
            },
            "rightCorner": {
              "x": 14.632,
              "y": 7.356,
              "z": 1.479
            },
            "gtin": "7322540887648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fd2",
            "leftCorner": {
              "x": 14.632,
              "y": 7.356,
              "z": 1.479
            },
            "rightCorner": {
              "x": 14.617,
              "y": 7.167,
              "z": 1.479
            }
          },
          {
            "id": "696ebf7143c343680a271fd3",
            "leftCorner": {
              "x": 14.617,
              "y": 7.167,
              "z": 1.479
            },
            "rightCorner": {
              "x": 14.602,
              "y": 6.976,
              "z": 1.479
            }
          },
          {
            "id": "696ebf7143c343680a271fd4",
            "leftCorner": {
              "x": 14.602,
              "y": 6.976,
              "z": 1.479
            },
            "rightCorner": {
              "x": 14.588,
              "y": 6.8,
              "z": 1.479
            },
            "gtin": "7322540887624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fd5",
            "leftCorner": {
              "x": 14.588,
              "y": 6.8,
              "z": 1.479
            },
            "rightCorner": {
              "x": 14.586,
              "y": 6.773,
              "z": 1.479
            }
          },
          {
            "id": "696ebf7143c343680a271fd6",
            "leftCorner": {
              "x": 14.586,
              "y": 6.773,
              "z": 1.479
            },
            "rightCorner": {
              "x": 14.574,
              "y": 6.623,
              "z": 1.479
            }
          },
          {
            "id": "696ebf7143c343680a271fd7",
            "leftCorner": {
              "x": 14.574,
              "y": 6.623,
              "z": 1.479
            },
            "rightCorner": {
              "x": 14.568,
              "y": 6.552,
              "z": 1.479
            },
            "gtin": "7322541079967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fd8",
            "leftCorner": {
              "x": 14.568,
              "y": 6.552,
              "z": 1.479
            },
            "rightCorner": {
              "x": 14.561,
              "y": 6.462,
              "z": 1.479
            },
            "gtin": "7322541079967",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fd9",
            "leftCorner": {
              "x": 14.561,
              "y": 6.462,
              "z": 1.479
            },
            "rightCorner": {
              "x": 14.556,
              "y": 6.401,
              "z": 1.479
            },
            "gtin": "7322541343686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fda",
            "leftCorner": {
              "x": 14.556,
              "y": 6.401,
              "z": 1.479
            },
            "rightCorner": {
              "x": 14.544,
              "y": 6.26,
              "z": 1.479
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73be5",
        "height": 1.7678,
        "facings": [
          {
            "id": "696ebf6e43c343680a270659",
            "leftCorner": {
              "x": 14.646,
              "y": 7.508,
              "z": 1.768
            },
            "rightCorner": {
              "x": 14.637,
              "y": 7.388,
              "z": 1.768
            },
            "gtin": "7322541497341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27065a",
            "leftCorner": {
              "x": 14.637,
              "y": 7.388,
              "z": 1.768
            },
            "rightCorner": {
              "x": 14.627,
              "y": 7.264,
              "z": 1.768
            },
            "gtin": "7322541497426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27065b",
            "leftCorner": {
              "x": 14.627,
              "y": 7.264,
              "z": 1.768
            },
            "rightCorner": {
              "x": 14.612,
              "y": 7.075,
              "z": 1.768
            },
            "gtin": "7322541497501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27065c",
            "leftCorner": {
              "x": 14.612,
              "y": 7.075,
              "z": 1.768
            },
            "rightCorner": {
              "x": 14.597,
              "y": 6.898,
              "z": 1.768
            },
            "gtin": "7322541497501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27065d",
            "leftCorner": {
              "x": 14.597,
              "y": 6.898,
              "z": 1.768
            },
            "rightCorner": {
              "x": 14.59,
              "y": 6.802,
              "z": 1.768
            },
            "gtin": "4058172997198",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27065e",
            "leftCorner": {
              "x": 14.59,
              "y": 6.802,
              "z": 1.768
            },
            "rightCorner": {
              "x": 14.587,
              "y": 6.774,
              "z": 1.768
            },
            "gtin": "4058172997198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27065f",
            "leftCorner": {
              "x": 14.587,
              "y": 6.774,
              "z": 1.768
            },
            "rightCorner": {
              "x": 14.582,
              "y": 6.703,
              "z": 1.768
            }
          },
          {
            "id": "696ebf6e43c343680a270660",
            "leftCorner": {
              "x": 14.582,
              "y": 6.703,
              "z": 1.768
            },
            "rightCorner": {
              "x": 14.573,
              "y": 6.598,
              "z": 1.768
            },
            "gtin": "4058172991660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270661",
            "leftCorner": {
              "x": 14.573,
              "y": 6.598,
              "z": 1.768
            },
            "rightCorner": {
              "x": 14.558,
              "y": 6.413,
              "z": 1.768
            },
            "gtin": "4058172991684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270662",
            "leftCorner": {
              "x": 14.558,
              "y": 6.413,
              "z": 1.768
            },
            "rightCorner": {
              "x": 14.55,
              "y": 6.301,
              "z": 1.768
            },
            "gtin": "4058172991684",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270663",
            "leftCorner": {
              "x": 14.55,
              "y": 6.301,
              "z": 1.768
            },
            "rightCorner": {
              "x": 14.521,
              "y": 5.949,
              "z": 1.768
            }
          }
        ]
      }
    ]
  },
  {
    "id": "68e7566db5fe7bc04695984a",
    "name": "68e7566db5fe7bc04695984a",
    "x": 14.695,
    "y": 6.288,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73375,
      "w": 0.67941
    },
    "statistics": {
      "hasStockCount": 12,
      "noStockCount": 0,
      "unknownStockCount": 11
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73bef",
        "height": 0.19846,
        "facings": [
          {
            "id": "696ebf6e43c343680a2706a3",
            "leftCorner": {
              "x": 14.533,
              "y": 6.115,
              "z": 0.198
            },
            "rightCorner": {
              "x": 14.512,
              "y": 5.835,
              "z": 0.198
            }
          },
          {
            "id": "696ebf6e43c343680a2706a4",
            "leftCorner": {
              "x": 14.512,
              "y": 5.835,
              "z": 0.198
            },
            "rightCorner": {
              "x": 14.495,
              "y": 5.622,
              "z": 0.198
            }
          },
          {
            "id": "696ebf6e43c343680a2706a5",
            "leftCorner": {
              "x": 14.495,
              "y": 5.622,
              "z": 0.198
            },
            "rightCorner": {
              "x": 14.481,
              "y": 5.429,
              "z": 0.198
            },
            "gtin": "4058172335136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706a6",
            "leftCorner": {
              "x": 14.481,
              "y": 5.429,
              "z": 0.198
            },
            "rightCorner": {
              "x": 14.465,
              "y": 5.225,
              "z": 0.198
            },
            "gtin": "4058172335136",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706a7",
            "leftCorner": {
              "x": 14.465,
              "y": 5.225,
              "z": 0.198
            },
            "rightCorner": {
              "x": 14.451,
              "y": 5.041,
              "z": 0.198
            },
            "gtin": "4058172335136",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bed",
        "height": 0.51172,
        "facings": [
          {
            "id": "696ebf7143c343680a271fa3",
            "leftCorner": {
              "x": 14.546,
              "y": 6.287,
              "z": 0.512
            },
            "rightCorner": {
              "x": 14.526,
              "y": 6.029,
              "z": 0.512
            }
          },
          {
            "id": "696ebf7143c343680a271fa4",
            "leftCorner": {
              "x": 14.526,
              "y": 6.029,
              "z": 0.512
            },
            "rightCorner": {
              "x": 14.509,
              "y": 5.803,
              "z": 0.512
            }
          },
          {
            "id": "696ebf7143c343680a271fa5",
            "leftCorner": {
              "x": 14.509,
              "y": 5.803,
              "z": 0.512
            },
            "rightCorner": {
              "x": 14.493,
              "y": 5.605,
              "z": 0.512
            },
            "gtin": "7332152215760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fa6",
            "leftCorner": {
              "x": 14.493,
              "y": 5.605,
              "z": 0.512
            },
            "rightCorner": {
              "x": 14.477,
              "y": 5.391,
              "z": 0.512
            },
            "gtin": "7332152215760",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fa7",
            "leftCorner": {
              "x": 14.477,
              "y": 5.391,
              "z": 0.512
            },
            "rightCorner": {
              "x": 14.461,
              "y": 5.188,
              "z": 0.512
            },
            "gtin": "7332152215760",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fa8",
            "leftCorner": {
              "x": 14.461,
              "y": 5.188,
              "z": 0.512
            },
            "rightCorner": {
              "x": 14.446,
              "y": 4.985,
              "z": 0.512
            },
            "gtin": "7322542133569",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bec",
        "height": 0.83923,
        "facings": [
          {
            "id": "696ebf7143c343680a271fc2",
            "leftCorner": {
              "x": 14.548,
              "y": 6.213,
              "z": 0.839
            },
            "rightCorner": {
              "x": 14.534,
              "y": 6.032,
              "z": 0.839
            }
          },
          {
            "id": "696ebf7143c343680a271fc3",
            "leftCorner": {
              "x": 14.534,
              "y": 6.032,
              "z": 0.839
            },
            "rightCorner": {
              "x": 14.528,
              "y": 5.957,
              "z": 0.839
            }
          },
          {
            "id": "696ebf7143c343680a271fc4",
            "leftCorner": {
              "x": 14.528,
              "y": 5.957,
              "z": 0.839
            },
            "rightCorner": {
              "x": 14.512,
              "y": 5.741,
              "z": 0.839
            },
            "gtin": "7322542506271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fc5",
            "leftCorner": {
              "x": 14.512,
              "y": 5.741,
              "z": 0.839
            },
            "rightCorner": {
              "x": 14.495,
              "y": 5.524,
              "z": 0.839
            },
            "gtin": "7322542506271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fc6",
            "leftCorner": {
              "x": 14.495,
              "y": 5.524,
              "z": 0.839
            },
            "rightCorner": {
              "x": 14.473,
              "y": 5.239,
              "z": 0.839
            },
            "gtin": "7322542308721",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fc7",
            "leftCorner": {
              "x": 14.473,
              "y": 5.239,
              "z": 0.839
            },
            "rightCorner": {
              "x": 14.442,
              "y": 4.841,
              "z": 0.839
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bee",
        "height": 1.1813,
        "facings": [
          {
            "id": "696ebf7143c343680a271f85",
            "leftCorner": {
              "x": 14.545,
              "y": 6.291,
              "z": 1.181
            },
            "rightCorner": {
              "x": 14.525,
              "y": 6.024,
              "z": 1.181
            }
          },
          {
            "id": "696ebf7143c343680a271f86",
            "leftCorner": {
              "x": 14.525,
              "y": 6.024,
              "z": 1.181
            },
            "rightCorner": {
              "x": 14.512,
              "y": 5.855,
              "z": 1.181
            }
          },
          {
            "id": "696ebf7143c343680a271f87",
            "leftCorner": {
              "x": 14.512,
              "y": 5.855,
              "z": 1.181
            },
            "rightCorner": {
              "x": 14.502,
              "y": 5.727,
              "z": 1.181
            }
          },
          {
            "id": "696ebf7143c343680a271f88",
            "leftCorner": {
              "x": 14.502,
              "y": 5.727,
              "z": 1.181
            },
            "rightCorner": {
              "x": 14.488,
              "y": 5.554,
              "z": 1.181
            }
          },
          {
            "id": "696ebf7143c343680a271f89",
            "leftCorner": {
              "x": 14.488,
              "y": 5.554,
              "z": 1.181
            },
            "rightCorner": {
              "x": 14.475,
              "y": 5.377,
              "z": 1.181
            }
          },
          {
            "id": "696ebf7143c343680a271f8a",
            "leftCorner": {
              "x": 14.475,
              "y": 5.377,
              "z": 1.181
            },
            "rightCorner": {
              "x": 14.463,
              "y": 5.23,
              "z": 1.181
            },
            "gtin": "7332152213100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f8b",
            "leftCorner": {
              "x": 14.463,
              "y": 5.23,
              "z": 1.181
            },
            "rightCorner": {
              "x": 14.451,
              "y": 5.069,
              "z": 1.181
            }
          },
          {
            "id": "696ebf7143c343680a271f8c",
            "leftCorner": {
              "x": 14.451,
              "y": 5.069,
              "z": 1.181
            },
            "rightCorner": {
              "x": 14.436,
              "y": 4.876,
              "z": 1.181
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73beb",
        "height": 1.4774,
        "facings": [
          {
            "id": "696ebf7143c343680a271fdb",
            "leftCorner": {
              "x": 14.539,
              "y": 6.257,
              "z": 1.477
            },
            "rightCorner": {
              "x": 14.504,
              "y": 5.803,
              "z": 1.477
            },
            "gtin": "7322541079677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fdc",
            "leftCorner": {
              "x": 14.504,
              "y": 5.803,
              "z": 1.477
            },
            "rightCorner": {
              "x": 14.492,
              "y": 5.64,
              "z": 1.477
            },
            "gtin": "7322541085739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fdd",
            "leftCorner": {
              "x": 14.492,
              "y": 5.64,
              "z": 1.477
            },
            "rightCorner": {
              "x": 14.476,
              "y": 5.432,
              "z": 1.477
            },
            "gtin": "7322541083087",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fde",
            "leftCorner": {
              "x": 14.476,
              "y": 5.432,
              "z": 1.477
            },
            "rightCorner": {
              "x": 14.467,
              "y": 5.325,
              "z": 1.477
            },
            "gtin": "7322541067780",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fdf",
            "leftCorner": {
              "x": 14.467,
              "y": 5.325,
              "z": 1.477
            },
            "rightCorner": {
              "x": 14.46,
              "y": 5.231,
              "z": 1.477
            },
            "gtin": "7322541067780",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fe0",
            "leftCorner": {
              "x": 14.46,
              "y": 5.231,
              "z": 1.477
            },
            "rightCorner": {
              "x": 14.447,
              "y": 5.057,
              "z": 1.477
            },
            "gtin": "7322541067032",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bea",
        "height": 1.7663,
        "facings": [
          {
            "id": "696ebf6e43c343680a270664",
            "leftCorner": {
              "x": 14.517,
              "y": 5.946,
              "z": 1.766
            },
            "rightCorner": {
              "x": 14.508,
              "y": 5.822,
              "z": 1.766
            }
          },
          {
            "id": "696ebf6e43c343680a270665",
            "leftCorner": {
              "x": 14.508,
              "y": 5.822,
              "z": 1.766
            },
            "rightCorner": {
              "x": 14.499,
              "y": 5.706,
              "z": 1.766
            }
          },
          {
            "id": "696ebf6e43c343680a270666",
            "leftCorner": {
              "x": 14.499,
              "y": 5.706,
              "z": 1.766
            },
            "rightCorner": {
              "x": 14.492,
              "y": 5.617,
              "z": 1.766
            },
            "gtin": "8006540738955",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270667",
            "leftCorner": {
              "x": 14.492,
              "y": 5.617,
              "z": 1.766
            },
            "rightCorner": {
              "x": 14.483,
              "y": 5.496,
              "z": 1.766
            },
            "gtin": "8700216178976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270668",
            "leftCorner": {
              "x": 14.483,
              "y": 5.496,
              "z": 1.766
            },
            "rightCorner": {
              "x": 14.474,
              "y": 5.386,
              "z": 1.766
            },
            "gtin": "8700216179386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270669",
            "leftCorner": {
              "x": 14.474,
              "y": 5.386,
              "z": 1.766
            },
            "rightCorner": {
              "x": 14.466,
              "y": 5.276,
              "z": 1.766
            },
            "gtin": "8700216179294",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27066a",
            "leftCorner": {
              "x": 14.466,
              "y": 5.276,
              "z": 1.766
            },
            "rightCorner": {
              "x": 14.456,
              "y": 5.148,
              "z": 1.766
            },
            "gtin": "8700216179348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27066b",
            "leftCorner": {
              "x": 14.456,
              "y": 5.148,
              "z": 1.766
            },
            "rightCorner": {
              "x": 14.443,
              "y": 4.983,
              "z": 1.766
            },
            "gtin": "8700216179348",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7566db5fe7bc04695984b",
    "name": "68e7566db5fe7bc04695984b",
    "x": 14.595,
    "y": 5.0262,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73254,
      "w": 0.68073
    },
    "statistics": {
      "hasStockCount": 10,
      "noStockCount": 2,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73bf4",
        "height": 0.51071,
        "facings": [
          {
            "id": "696ebf7143c343680a271fa9",
            "leftCorner": {
              "x": 14.446,
              "y": 4.969,
              "z": 0.511
            },
            "rightCorner": {
              "x": 14.426,
              "y": 4.7,
              "z": 0.511
            }
          },
          {
            "id": "696ebf7143c343680a271faa",
            "leftCorner": {
              "x": 14.426,
              "y": 4.7,
              "z": 0.511
            },
            "rightCorner": {
              "x": 14.423,
              "y": 4.665,
              "z": 0.511
            }
          },
          {
            "id": "696ebf7143c343680a271fab",
            "leftCorner": {
              "x": 14.423,
              "y": 4.665,
              "z": 0.511
            },
            "rightCorner": {
              "x": 14.401,
              "y": 4.357,
              "z": 0.511
            },
            "gtin": "4000576523664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fac",
            "leftCorner": {
              "x": 14.401,
              "y": 4.357,
              "z": 0.511
            },
            "rightCorner": {
              "x": 14.375,
              "y": 4.005,
              "z": 0.511
            }
          },
          {
            "id": "696ebf7143c343680a271fad",
            "leftCorner": {
              "x": 14.375,
              "y": 4.005,
              "z": 0.511
            },
            "rightCorner": {
              "x": 14.358,
              "y": 3.772,
              "z": 0.511
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bf5",
        "height": 0.19836,
        "facings": [
          {
            "id": "696ebf6e43c343680a2706a8",
            "leftCorner": {
              "x": 14.449,
              "y": 5.025,
              "z": 0.198
            },
            "rightCorner": {
              "x": 14.434,
              "y": 4.822,
              "z": 0.198
            },
            "gtin": "4066447366648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706a9",
            "leftCorner": {
              "x": 14.434,
              "y": 4.822,
              "z": 0.198
            },
            "rightCorner": {
              "x": 14.43,
              "y": 4.765,
              "z": 0.198
            }
          },
          {
            "id": "696ebf6e43c343680a2706aa",
            "leftCorner": {
              "x": 14.43,
              "y": 4.765,
              "z": 0.198
            },
            "rightCorner": {
              "x": 14.417,
              "y": 4.583,
              "z": 0.198
            }
          },
          {
            "id": "696ebf6e43c343680a2706ab",
            "leftCorner": {
              "x": 14.417,
              "y": 4.583,
              "z": 0.198
            },
            "rightCorner": {
              "x": 14.399,
              "y": 4.336,
              "z": 0.198
            }
          },
          {
            "id": "696ebf6e43c343680a2706ac",
            "leftCorner": {
              "x": 14.399,
              "y": 4.336,
              "z": 0.198
            },
            "rightCorner": {
              "x": 14.385,
              "y": 4.149,
              "z": 0.198
            },
            "gtin": "4066447166699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706ad",
            "leftCorner": {
              "x": 14.385,
              "y": 4.149,
              "z": 0.198
            },
            "rightCorner": {
              "x": 14.37,
              "y": 3.942,
              "z": 0.198
            }
          },
          {
            "id": "696ebf6e43c343680a2706ae",
            "leftCorner": {
              "x": 14.37,
              "y": 3.942,
              "z": 0.198
            },
            "rightCorner": {
              "x": 14.357,
              "y": 3.775,
              "z": 0.198
            },
            "gtin": "4067796000726",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bf1",
        "height": 0.84435,
        "facings": [
          {
            "id": "696ebf7143c343680a271fc8",
            "leftCorner": {
              "x": 14.433,
              "y": 4.825,
              "z": 0.844
            },
            "rightCorner": {
              "x": 14.429,
              "y": 4.77,
              "z": 0.844
            },
            "gtin": "7322540574890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fc9",
            "leftCorner": {
              "x": 14.429,
              "y": 4.77,
              "z": 0.844
            },
            "rightCorner": {
              "x": 14.417,
              "y": 4.6,
              "z": 0.844
            }
          },
          {
            "id": "696ebf7143c343680a271fca",
            "leftCorner": {
              "x": 14.417,
              "y": 4.6,
              "z": 0.844
            },
            "rightCorner": {
              "x": 14.407,
              "y": 4.471,
              "z": 0.844
            }
          },
          {
            "id": "696ebf7143c343680a271fcb",
            "leftCorner": {
              "x": 14.407,
              "y": 4.471,
              "z": 0.844
            },
            "rightCorner": {
              "x": 14.389,
              "y": 4.222,
              "z": 0.844
            },
            "gtin": "4066447015874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fcc",
            "leftCorner": {
              "x": 14.389,
              "y": 4.222,
              "z": 0.844
            },
            "rightCorner": {
              "x": 14.375,
              "y": 4.029,
              "z": 0.844
            },
            "gtin": "4066447015898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fcd",
            "leftCorner": {
              "x": 14.375,
              "y": 4.029,
              "z": 0.844
            },
            "rightCorner": {
              "x": 14.369,
              "y": 3.946,
              "z": 0.844
            }
          },
          {
            "id": "696ebf7143c343680a271fce",
            "leftCorner": {
              "x": 14.369,
              "y": 3.946,
              "z": 0.844
            },
            "rightCorner": {
              "x": 14.362,
              "y": 3.858,
              "z": 0.844
            },
            "gtin": "4066447122787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fcf",
            "leftCorner": {
              "x": 14.362,
              "y": 3.858,
              "z": 0.844
            },
            "rightCorner": {
              "x": 14.358,
              "y": 3.802,
              "z": 0.844
            },
            "gtin": "4067796261271",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bf3",
        "height": 1.1823,
        "facings": [
          {
            "id": "696ebf7143c343680a271f8d",
            "leftCorner": {
              "x": 14.436,
              "y": 4.859,
              "z": 1.182
            },
            "rightCorner": {
              "x": 14.421,
              "y": 4.659,
              "z": 1.182
            }
          },
          {
            "id": "696ebf7143c343680a271f8e",
            "leftCorner": {
              "x": 14.421,
              "y": 4.659,
              "z": 1.182
            },
            "rightCorner": {
              "x": 14.408,
              "y": 4.473,
              "z": 1.182
            },
            "gtin": "4066447353143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f8f",
            "leftCorner": {
              "x": 14.408,
              "y": 4.473,
              "z": 1.182
            },
            "rightCorner": {
              "x": 14.396,
              "y": 4.31,
              "z": 1.182
            }
          },
          {
            "id": "696ebf7143c343680a271f90",
            "leftCorner": {
              "x": 14.396,
              "y": 4.31,
              "z": 1.182
            },
            "rightCorner": {
              "x": 14.381,
              "y": 4.105,
              "z": 1.182
            }
          },
          {
            "id": "696ebf7143c343680a271f91",
            "leftCorner": {
              "x": 14.381,
              "y": 4.105,
              "z": 1.182
            },
            "rightCorner": {
              "x": 14.375,
              "y": 4.034,
              "z": 1.182
            },
            "gtin": "4066447122886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f92",
            "leftCorner": {
              "x": 14.375,
              "y": 4.034,
              "z": 1.182
            },
            "rightCorner": {
              "x": 14.37,
              "y": 3.954,
              "z": 1.182
            },
            "gtin": "4067796064056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f93",
            "leftCorner": {
              "x": 14.37,
              "y": 3.954,
              "z": 1.182
            },
            "rightCorner": {
              "x": 14.364,
              "y": 3.876,
              "z": 1.182
            },
            "gtin": "4067796064056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f94",
            "leftCorner": {
              "x": 14.364,
              "y": 3.876,
              "z": 1.182
            },
            "rightCorner": {
              "x": 14.358,
              "y": 3.797,
              "z": 1.182
            },
            "gtin": "4067796064056",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bf2",
        "height": 1.4776,
        "facings": [
          {
            "id": "696ebf7143c343680a271fe1",
            "leftCorner": {
              "x": 14.447,
              "y": 5.057,
              "z": 1.477
            },
            "rightCorner": {
              "x": 14.431,
              "y": 4.856,
              "z": 1.477
            },
            "gtin": "7322541068039",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fe2",
            "leftCorner": {
              "x": 14.431,
              "y": 4.84,
              "z": 1.478
            },
            "rightCorner": {
              "x": 14.418,
              "y": 4.664,
              "z": 1.478
            },
            "gtin": "7322541091174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fe3",
            "leftCorner": {
              "x": 14.418,
              "y": 4.664,
              "z": 1.478
            },
            "rightCorner": {
              "x": 14.408,
              "y": 4.527,
              "z": 1.478
            }
          },
          {
            "id": "696ebf7143c343680a271fe4",
            "leftCorner": {
              "x": 14.408,
              "y": 4.527,
              "z": 1.478
            },
            "rightCorner": {
              "x": 14.395,
              "y": 4.354,
              "z": 1.478
            },
            "gtin": "8006540689233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fe5",
            "leftCorner": {
              "x": 14.395,
              "y": 4.354,
              "z": 1.478
            },
            "rightCorner": {
              "x": 14.386,
              "y": 4.23,
              "z": 1.478
            },
            "gtin": "8006540688977",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fe6",
            "leftCorner": {
              "x": 14.386,
              "y": 4.23,
              "z": 1.478
            },
            "rightCorner": {
              "x": 14.378,
              "y": 4.119,
              "z": 1.478
            },
            "gtin": "8006540688977",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fe7",
            "leftCorner": {
              "x": 14.378,
              "y": 4.119,
              "z": 1.478
            },
            "rightCorner": {
              "x": 14.37,
              "y": 4.014,
              "z": 1.478
            },
            "gtin": "8006540688977",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fe8",
            "leftCorner": {
              "x": 14.37,
              "y": 4.014,
              "z": 1.478
            },
            "rightCorner": {
              "x": 14.363,
              "y": 3.911,
              "z": 1.478
            },
            "gtin": "8006540689011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fe9",
            "leftCorner": {
              "x": 14.363,
              "y": 3.911,
              "z": 1.478
            },
            "rightCorner": {
              "x": 14.354,
              "y": 3.794,
              "z": 1.478
            },
            "gtin": "8006540689011",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bf0",
        "height": 1.7692,
        "facings": [
          {
            "id": "696ebf6e43c343680a27066c",
            "leftCorner": {
              "x": 14.441,
              "y": 4.967,
              "z": 1.769
            },
            "rightCorner": {
              "x": 14.429,
              "y": 4.805,
              "z": 1.769
            },
            "gtin": "8700216179430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27066d",
            "leftCorner": {
              "x": 14.429,
              "y": 4.805,
              "z": 1.769
            },
            "rightCorner": {
              "x": 14.426,
              "y": 4.756,
              "z": 1.769
            }
          },
          {
            "id": "696ebf6e43c343680a27066e",
            "leftCorner": {
              "x": 14.426,
              "y": 4.756,
              "z": 1.769
            },
            "rightCorner": {
              "x": 14.418,
              "y": 4.642,
              "z": 1.769
            },
            "gtin": "8700216179133",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27066f",
            "leftCorner": {
              "x": 14.418,
              "y": 4.642,
              "z": 1.769
            },
            "rightCorner": {
              "x": 14.407,
              "y": 4.495,
              "z": 1.769
            },
            "gtin": "8700216179041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270670",
            "leftCorner": {
              "x": 14.407,
              "y": 4.495,
              "z": 1.769
            },
            "rightCorner": {
              "x": 14.394,
              "y": 4.317,
              "z": 1.769
            },
            "gtin": "8006540221549",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270671",
            "leftCorner": {
              "x": 14.394,
              "y": 4.317,
              "z": 1.769
            },
            "rightCorner": {
              "x": 14.386,
              "y": 4.216,
              "z": 1.769
            },
            "gtin": "8006540689196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270672",
            "leftCorner": {
              "x": 14.386,
              "y": 4.216,
              "z": 1.769
            },
            "rightCorner": {
              "x": 14.374,
              "y": 4.051,
              "z": 1.769
            },
            "gtin": "8006540689271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270673",
            "leftCorner": {
              "x": 14.374,
              "y": 4.051,
              "z": 1.769
            },
            "rightCorner": {
              "x": 14.362,
              "y": 3.893,
              "z": 1.769
            },
            "gtin": "8006540689158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270674",
            "leftCorner": {
              "x": 14.362,
              "y": 3.893,
              "z": 1.769
            },
            "rightCorner": {
              "x": 14.35,
              "y": 3.719,
              "z": 1.769
            },
            "gtin": "8006540791394",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7566db5fe7bc04695984c",
    "name": "68e7566db5fe7bc04695984c",
    "x": 14.395,
    "y": 3.7898,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73329,
      "w": 0.67991
    },
    "statistics": {
      "hasStockCount": 18,
      "noStockCount": 0,
      "unknownStockCount": 20
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73bf8",
        "height": 0.19614,
        "facings": [
          {
            "id": "696ebf6e43c343680a2706af",
            "leftCorner": {
              "x": 14.35,
              "y": 3.778,
              "z": 0.196
            },
            "rightCorner": {
              "x": 14.338,
              "y": 3.62,
              "z": 0.196
            },
            "gtin": "4066447140262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706b0",
            "leftCorner": {
              "x": 14.338,
              "y": 3.62,
              "z": 0.196
            },
            "rightCorner": {
              "x": 14.323,
              "y": 3.425,
              "z": 0.196
            },
            "gtin": "4066447140262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706b1",
            "leftCorner": {
              "x": 14.323,
              "y": 3.425,
              "z": 0.196
            },
            "rightCorner": {
              "x": 14.314,
              "y": 3.312,
              "z": 0.196
            }
          },
          {
            "id": "696ebf6e43c343680a2706b2",
            "leftCorner": {
              "x": 14.314,
              "y": 3.312,
              "z": 0.196
            },
            "rightCorner": {
              "x": 14.294,
              "y": 3.039,
              "z": 0.196
            },
            "gtin": "4066447085112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706b3",
            "leftCorner": {
              "x": 14.294,
              "y": 3.039,
              "z": 0.196
            },
            "rightCorner": {
              "x": 14.288,
              "y": 2.959,
              "z": 0.196
            },
            "gtin": "4066447085112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706b4",
            "leftCorner": {
              "x": 14.288,
              "y": 2.959,
              "z": 0.196
            },
            "rightCorner": {
              "x": 14.272,
              "y": 2.747,
              "z": 0.196
            },
            "gtin": "4066447122961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706b5",
            "leftCorner": {
              "x": 14.272,
              "y": 2.747,
              "z": 0.196
            },
            "rightCorner": {
              "x": 14.263,
              "y": 2.639,
              "z": 0.196
            }
          },
          {
            "id": "696ebf6e43c343680a2706b6",
            "leftCorner": {
              "x": 14.263,
              "y": 2.639,
              "z": 0.196
            },
            "rightCorner": {
              "x": 14.256,
              "y": 2.543,
              "z": 0.196
            },
            "gtin": "4066447085099",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bf6",
        "height": 0.50755,
        "facings": [
          {
            "id": "696ebf7143c343680a271fae",
            "leftCorner": {
              "x": 14.349,
              "y": 3.775,
              "z": 0.508
            },
            "rightCorner": {
              "x": 14.333,
              "y": 3.566,
              "z": 0.508
            },
            "gtin": "8006540460016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271faf",
            "leftCorner": {
              "x": 14.333,
              "y": 3.566,
              "z": 0.508
            },
            "rightCorner": {
              "x": 14.313,
              "y": 3.296,
              "z": 0.508
            },
            "gtin": "8006540451991",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fb0",
            "leftCorner": {
              "x": 14.313,
              "y": 3.296,
              "z": 0.508
            },
            "rightCorner": {
              "x": 14.295,
              "y": 3.062,
              "z": 0.508
            },
            "gtin": "8006540530832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fb1",
            "leftCorner": {
              "x": 14.295,
              "y": 3.062,
              "z": 0.508
            },
            "rightCorner": {
              "x": 14.275,
              "y": 2.791,
              "z": 0.508
            },
            "gtin": "8006530017770",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fb2",
            "leftCorner": {
              "x": 14.275,
              "y": 2.791,
              "z": 0.508
            },
            "rightCorner": {
              "x": 14.257,
              "y": 2.559,
              "z": 0.508
            },
            "gtin": "8006530018029",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bfa",
        "height": 0.79811,
        "facings": [
          {
            "id": "696ebf7143c343680a271ff3",
            "leftCorner": {
              "x": 14.351,
              "y": 3.793,
              "z": 0.798
            },
            "rightCorner": {
              "x": 14.324,
              "y": 3.442,
              "z": 0.798
            },
            "gtin": "4066447122848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ff4",
            "leftCorner": {
              "x": 14.324,
              "y": 3.442,
              "z": 0.798
            },
            "rightCorner": {
              "x": 14.305,
              "y": 3.192,
              "z": 0.798
            },
            "gtin": "4066447122824",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ff5",
            "leftCorner": {
              "x": 14.305,
              "y": 3.192,
              "z": 0.798
            },
            "rightCorner": {
              "x": 14.286,
              "y": 2.932,
              "z": 0.798
            },
            "gtin": "4066447140248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ff6",
            "leftCorner": {
              "x": 14.286,
              "y": 2.932,
              "z": 0.798
            },
            "rightCorner": {
              "x": 14.272,
              "y": 2.753,
              "z": 0.798
            },
            "gtin": "4009408040904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ff7",
            "leftCorner": {
              "x": 14.272,
              "y": 2.753,
              "z": 0.798
            },
            "rightCorner": {
              "x": 14.257,
              "y": 2.554,
              "z": 0.798
            },
            "gtin": "4066447140255",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bfb",
        "height": 1.1807,
        "facings": [
          {
            "id": "696ebf7143c343680a271f95",
            "leftCorner": {
              "x": 14.358,
              "y": 3.797,
              "z": 1.182
            },
            "rightCorner": {
              "x": 14.348,
              "y": 3.661,
              "z": 1.182
            },
            "gtin": "4066447093285",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f96",
            "leftCorner": {
              "x": 14.335,
              "y": 3.664,
              "z": 1.181
            },
            "rightCorner": {
              "x": 14.328,
              "y": 3.57,
              "z": 1.181
            },
            "gtin": "4066447093285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f97",
            "leftCorner": {
              "x": 14.328,
              "y": 3.57,
              "z": 1.181
            },
            "rightCorner": {
              "x": 14.321,
              "y": 3.48,
              "z": 1.181
            }
          },
          {
            "id": "696ebf7143c343680a271f98",
            "leftCorner": {
              "x": 14.321,
              "y": 3.48,
              "z": 1.181
            },
            "rightCorner": {
              "x": 14.319,
              "y": 3.443,
              "z": 1.181
            }
          },
          {
            "id": "696ebf7143c343680a271f99",
            "leftCorner": {
              "x": 14.319,
              "y": 3.443,
              "z": 1.181
            },
            "rightCorner": {
              "x": 14.308,
              "y": 3.296,
              "z": 1.181
            },
            "gtin": "4058172923982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f9a",
            "leftCorner": {
              "x": 14.308,
              "y": 3.296,
              "z": 1.181
            },
            "rightCorner": {
              "x": 14.297,
              "y": 3.157,
              "z": 1.181
            },
            "gtin": "4058172923982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f9b",
            "leftCorner": {
              "x": 14.297,
              "y": 3.157,
              "z": 1.181
            },
            "rightCorner": {
              "x": 14.286,
              "y": 3.007,
              "z": 1.181
            },
            "gtin": "4058172923982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f9c",
            "leftCorner": {
              "x": 14.286,
              "y": 3.007,
              "z": 1.181
            },
            "rightCorner": {
              "x": 14.276,
              "y": 2.877,
              "z": 1.181
            },
            "gtin": "4066447122800",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f78",
            "leftCorner": {
              "x": 14.276,
              "y": 2.877,
              "z": 1.181
            },
            "rightCorner": {
              "x": 14.251,
              "y": 2.547,
              "z": 1.181
            },
            "gtin": "4067796000665",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bf9",
        "height": 1.4762,
        "facings": [
          {
            "id": "696ebf7143c343680a271fea",
            "leftCorner": {
              "x": 14.354,
              "y": 3.794,
              "z": 1.478
            },
            "rightCorner": {
              "x": 14.343,
              "y": 3.646,
              "z": 1.478
            },
            "gtin": "8006540688939",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271feb",
            "leftCorner": {
              "x": 14.334,
              "y": 3.649,
              "z": 1.476
            },
            "rightCorner": {
              "x": 14.324,
              "y": 3.529,
              "z": 1.476
            },
            "gtin": "8006540688939",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fec",
            "leftCorner": {
              "x": 14.324,
              "y": 3.529,
              "z": 1.476
            },
            "rightCorner": {
              "x": 14.312,
              "y": 3.364,
              "z": 1.476
            },
            "gtin": "3574661661995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fed",
            "leftCorner": {
              "x": 14.312,
              "y": 3.364,
              "z": 1.476
            },
            "rightCorner": {
              "x": 14.301,
              "y": 3.224,
              "z": 1.476
            },
            "gtin": "3574661661995",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fee",
            "leftCorner": {
              "x": 14.301,
              "y": 3.224,
              "z": 1.476
            },
            "rightCorner": {
              "x": 14.292,
              "y": 3.099,
              "z": 1.476
            },
            "gtin": "3574661661988",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fef",
            "leftCorner": {
              "x": 14.292,
              "y": 3.099,
              "z": 1.476
            },
            "rightCorner": {
              "x": 14.282,
              "y": 2.967,
              "z": 1.476
            }
          },
          {
            "id": "696ebf7143c343680a271ff0",
            "leftCorner": {
              "x": 14.282,
              "y": 2.967,
              "z": 1.476
            },
            "rightCorner": {
              "x": 14.275,
              "y": 2.868,
              "z": 1.476
            }
          },
          {
            "id": "696ebf7143c343680a271ff1",
            "leftCorner": {
              "x": 14.275,
              "y": 2.868,
              "z": 1.476
            },
            "rightCorner": {
              "x": 14.267,
              "y": 2.765,
              "z": 1.476
            },
            "gtin": "3574661661940",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ff2",
            "leftCorner": {
              "x": 14.267,
              "y": 2.765,
              "z": 1.476
            },
            "rightCorner": {
              "x": 14.259,
              "y": 2.665,
              "z": 1.476
            },
            "gtin": "3574661500324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fd1",
            "leftCorner": {
              "x": 14.259,
              "y": 2.665,
              "z": 1.476
            },
            "rightCorner": {
              "x": 14.25,
              "y": 2.547,
              "z": 1.476
            },
            "gtin": "3574661500324",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bf7",
        "height": 1.7668,
        "facings": [
          {
            "id": "696ebf6e43c343680a270675",
            "leftCorner": {
              "x": 14.335,
              "y": 3.723,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.321,
              "y": 3.537,
              "z": 1.767
            },
            "gtin": "8006540689110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270676",
            "leftCorner": {
              "x": 14.321,
              "y": 3.537,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.307,
              "y": 3.351,
              "z": 1.767
            },
            "gtin": "3574661486314",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270677",
            "leftCorner": {
              "x": 14.307,
              "y": 3.351,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.297,
              "y": 3.211,
              "z": 1.767
            },
            "gtin": "3574661486307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270678",
            "leftCorner": {
              "x": 14.297,
              "y": 3.211,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.286,
              "y": 3.067,
              "z": 1.767
            },
            "gtin": "3574661486321",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270679",
            "leftCorner": {
              "x": 14.286,
              "y": 3.067,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.275,
              "y": 2.932,
              "z": 1.767
            },
            "gtin": "3574661482194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27067a",
            "leftCorner": {
              "x": 14.275,
              "y": 2.932,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.262,
              "y": 2.753,
              "z": 1.767
            },
            "gtin": "3574661482187",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27067b",
            "leftCorner": {
              "x": 14.262,
              "y": 2.753,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.251,
              "y": 2.607,
              "z": 1.767
            },
            "gtin": "4002448030805",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7566db5fe7bc04695984d",
    "name": "68e7566db5fe7bc04695984d",
    "x": 14.303,
    "y": 2.5348,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73646,
      "w": 0.67648
    },
    "statistics": {
      "hasStockCount": 46,
      "noStockCount": 2,
      "unknownStockCount": 24
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73c00",
        "height": 0.19457,
        "facings": [
          {
            "id": "696ebf6e43c343680a2706b7",
            "leftCorner": {
              "x": 14.256,
              "y": 2.543,
              "z": 0.196
            },
            "rightCorner": {
              "x": 14.248,
              "y": 2.434,
              "z": 0.196
            },
            "gtin": "4067796276817",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706b8",
            "leftCorner": {
              "x": 14.249,
              "y": 2.426,
              "z": 0.195
            },
            "rightCorner": {
              "x": 14.243,
              "y": 2.355,
              "z": 0.195
            },
            "gtin": "4066447109634",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706b9",
            "leftCorner": {
              "x": 14.243,
              "y": 2.355,
              "z": 0.195
            },
            "rightCorner": {
              "x": 14.225,
              "y": 2.141,
              "z": 0.195
            },
            "gtin": "4066447122909",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706ba",
            "leftCorner": {
              "x": 14.225,
              "y": 2.141,
              "z": 0.195
            },
            "rightCorner": {
              "x": 14.206,
              "y": 1.925,
              "z": 0.195
            },
            "gtin": "4066447122923",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706bb",
            "leftCorner": {
              "x": 14.206,
              "y": 1.925,
              "z": 0.195
            },
            "rightCorner": {
              "x": 14.198,
              "y": 1.824,
              "z": 0.195
            },
            "gtin": "4067796000474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706bc",
            "leftCorner": {
              "x": 14.198,
              "y": 1.824,
              "z": 0.195
            },
            "rightCorner": {
              "x": 14.19,
              "y": 1.733,
              "z": 0.195
            }
          },
          {
            "id": "696ebf6e43c343680a2706bd",
            "leftCorner": {
              "x": 14.19,
              "y": 1.733,
              "z": 0.195
            },
            "rightCorner": {
              "x": 14.174,
              "y": 1.548,
              "z": 0.195
            },
            "gtin": "4066447122947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27068e",
            "leftCorner": {
              "x": 14.174,
              "y": 1.548,
              "z": 0.195
            },
            "rightCorner": {
              "x": 14.152,
              "y": 1.293,
              "z": 0.195
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c02",
        "height": 0.50531,
        "facings": [
          {
            "id": "696ebf7143c343680a271fb3",
            "leftCorner": {
              "x": 14.257,
              "y": 2.559,
              "z": 0.508
            },
            "rightCorner": {
              "x": 14.241,
              "y": 2.347,
              "z": 0.508
            },
            "gtin": "8006530017633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fb4",
            "leftCorner": {
              "x": 14.242,
              "y": 2.339,
              "z": 0.505
            },
            "rightCorner": {
              "x": 14.22,
              "y": 2.073,
              "z": 0.505
            },
            "gtin": "8006530017640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fb5",
            "leftCorner": {
              "x": 14.22,
              "y": 2.073,
              "z": 0.505
            },
            "rightCorner": {
              "x": 14.198,
              "y": 1.818,
              "z": 0.505
            },
            "gtin": "8006530017862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fb6",
            "leftCorner": {
              "x": 14.198,
              "y": 1.818,
              "z": 0.505
            },
            "rightCorner": {
              "x": 14.187,
              "y": 1.692,
              "z": 0.505
            },
            "gtin": "8006530017930",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271fb7",
            "leftCorner": {
              "x": 14.187,
              "y": 1.692,
              "z": 0.505
            },
            "rightCorner": {
              "x": 14.176,
              "y": 1.563,
              "z": 0.505
            },
            "gtin": "8006530017930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fb8",
            "leftCorner": {
              "x": 14.176,
              "y": 1.563,
              "z": 0.505
            },
            "rightCorner": {
              "x": 14.165,
              "y": 1.433,
              "z": 0.505
            }
          },
          {
            "id": "696ebf7143c343680a271fb9",
            "leftCorner": {
              "x": 14.165,
              "y": 1.433,
              "z": 0.505
            },
            "rightCorner": {
              "x": 14.153,
              "y": 1.286,
              "z": 0.505
            },
            "gtin": "8700216213837",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bff",
        "height": 0.80084,
        "facings": [
          {
            "id": "696ebf7143c343680a271ff8",
            "leftCorner": {
              "x": 14.257,
              "y": 2.554,
              "z": 0.798
            },
            "rightCorner": {
              "x": 14.253,
              "y": 2.494,
              "z": 0.798
            },
            "gtin": "3574661866192",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ff9",
            "leftCorner": {
              "x": 14.254,
              "y": 2.486,
              "z": 0.801
            },
            "rightCorner": {
              "x": 14.249,
              "y": 2.421,
              "z": 0.801
            }
          },
          {
            "id": "696ebf7143c343680a271ffa",
            "leftCorner": {
              "x": 14.249,
              "y": 2.421,
              "z": 0.801
            },
            "rightCorner": {
              "x": 14.242,
              "y": 2.338,
              "z": 0.801
            },
            "gtin": "3574661776644",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ffb",
            "leftCorner": {
              "x": 14.242,
              "y": 2.338,
              "z": 0.801
            },
            "rightCorner": {
              "x": 14.234,
              "y": 2.24,
              "z": 0.801
            },
            "gtin": "3574661776699",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ffc",
            "leftCorner": {
              "x": 14.234,
              "y": 2.24,
              "z": 0.801
            },
            "rightCorner": {
              "x": 14.227,
              "y": 2.162,
              "z": 0.801
            },
            "gtin": "3574661776729",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ffd",
            "leftCorner": {
              "x": 14.227,
              "y": 2.162,
              "z": 0.801
            },
            "rightCorner": {
              "x": 14.222,
              "y": 2.102,
              "z": 0.801
            },
            "gtin": "9120133546617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ffe",
            "leftCorner": {
              "x": 14.222,
              "y": 2.102,
              "z": 0.801
            },
            "rightCorner": {
              "x": 14.217,
              "y": 2.049,
              "z": 0.801
            },
            "gtin": "9120133546587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271fff",
            "leftCorner": {
              "x": 14.217,
              "y": 2.049,
              "z": 0.801
            },
            "rightCorner": {
              "x": 14.212,
              "y": 1.983,
              "z": 0.801
            },
            "gtin": "4067796103885",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272000",
            "leftCorner": {
              "x": 14.212,
              "y": 1.983,
              "z": 0.801
            },
            "rightCorner": {
              "x": 14.204,
              "y": 1.896,
              "z": 0.801
            },
            "gtin": "4067796103847",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272001",
            "leftCorner": {
              "x": 14.204,
              "y": 1.896,
              "z": 0.801
            },
            "rightCorner": {
              "x": 14.195,
              "y": 1.788,
              "z": 0.801
            },
            "gtin": "4067796073430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272002",
            "leftCorner": {
              "x": 14.195,
              "y": 1.788,
              "z": 0.801
            },
            "rightCorner": {
              "x": 14.188,
              "y": 1.709,
              "z": 0.801
            },
            "gtin": "4067796073416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272003",
            "leftCorner": {
              "x": 14.188,
              "y": 1.709,
              "z": 0.801
            },
            "rightCorner": {
              "x": 14.182,
              "y": 1.639,
              "z": 0.801
            },
            "gtin": "4067796272253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272004",
            "leftCorner": {
              "x": 14.182,
              "y": 1.639,
              "z": 0.801
            },
            "rightCorner": {
              "x": 14.177,
              "y": 1.58,
              "z": 0.801
            },
            "gtin": "4262382544114",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272005",
            "leftCorner": {
              "x": 14.177,
              "y": 1.58,
              "z": 0.801
            },
            "rightCorner": {
              "x": 14.171,
              "y": 1.5,
              "z": 0.801
            },
            "gtin": "4262382544107",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272006",
            "leftCorner": {
              "x": 14.171,
              "y": 1.5,
              "z": 0.801
            },
            "rightCorner": {
              "x": 14.164,
              "y": 1.425,
              "z": 0.801
            },
            "gtin": "4262382544091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272007",
            "leftCorner": {
              "x": 14.164,
              "y": 1.425,
              "z": 0.801
            },
            "rightCorner": {
              "x": 14.154,
              "y": 1.301,
              "z": 0.801
            },
            "gtin": "8006540538227",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bfe",
        "height": 1.0539,
        "facings": [
          {
            "id": "696ebf7143c343680a272021",
            "leftCorner": {
              "x": 14.258,
              "y": 2.539,
              "z": 1.054
            },
            "rightCorner": {
              "x": 14.25,
              "y": 2.45,
              "z": 1.054
            },
            "gtin": "4067796100051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272023",
            "leftCorner": {
              "x": 14.25,
              "y": 2.45,
              "z": 1.054
            },
            "rightCorner": {
              "x": 14.241,
              "y": 2.345,
              "z": 1.054
            },
            "gtin": "4066447084931",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272024",
            "leftCorner": {
              "x": 14.241,
              "y": 2.345,
              "z": 1.054
            },
            "rightCorner": {
              "x": 14.231,
              "y": 2.226,
              "z": 1.054
            },
            "gtin": "4066447084931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272025",
            "leftCorner": {
              "x": 14.231,
              "y": 2.226,
              "z": 1.054
            },
            "rightCorner": {
              "x": 14.221,
              "y": 2.102,
              "z": 1.054
            },
            "gtin": "4066447084979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272026",
            "leftCorner": {
              "x": 14.221,
              "y": 2.102,
              "z": 1.054
            },
            "rightCorner": {
              "x": 14.209,
              "y": 1.969,
              "z": 1.054
            }
          },
          {
            "id": "696ebf7143c343680a272027",
            "leftCorner": {
              "x": 14.209,
              "y": 1.969,
              "z": 1.054
            },
            "rightCorner": {
              "x": 14.2,
              "y": 1.853,
              "z": 1.054
            },
            "gtin": "4067796001563",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a272028",
            "leftCorner": {
              "x": 14.2,
              "y": 1.853,
              "z": 1.054
            },
            "rightCorner": {
              "x": 14.188,
              "y": 1.714,
              "z": 1.054
            }
          },
          {
            "id": "696ebf7143c343680a272029",
            "leftCorner": {
              "x": 14.188,
              "y": 1.714,
              "z": 1.054
            },
            "rightCorner": {
              "x": 14.162,
              "y": 1.416,
              "z": 1.054
            },
            "gtin": "4067796001006",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a272022",
            "leftCorner": {
              "x": 14.162,
              "y": 1.416,
              "z": 1.054
            },
            "rightCorner": {
              "x": 14.152,
              "y": 1.293,
              "z": 1.054
            },
            "gtin": "4067796000962",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bfc",
        "height": 1.306,
        "facings": [
          {
            "id": "696ebf7143c343680a272008",
            "leftCorner": {
              "x": 14.257,
              "y": 2.532,
              "z": 1.306
            },
            "rightCorner": {
              "x": 14.253,
              "y": 2.478,
              "z": 1.306
            },
            "gtin": "4260508540217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272009",
            "leftCorner": {
              "x": 14.253,
              "y": 2.478,
              "z": 1.306
            },
            "rightCorner": {
              "x": 14.248,
              "y": 2.428,
              "z": 1.306
            },
            "gtin": "4260508540217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27200a",
            "leftCorner": {
              "x": 14.248,
              "y": 2.428,
              "z": 1.306
            },
            "rightCorner": {
              "x": 14.244,
              "y": 2.372,
              "z": 1.306
            },
            "gtin": "4260508540224",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27200b",
            "leftCorner": {
              "x": 14.244,
              "y": 2.372,
              "z": 1.306
            },
            "rightCorner": {
              "x": 14.239,
              "y": 2.313,
              "z": 1.306
            },
            "gtin": "4260508540224",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27200c",
            "leftCorner": {
              "x": 14.239,
              "y": 2.313,
              "z": 1.306
            },
            "rightCorner": {
              "x": 14.233,
              "y": 2.252,
              "z": 1.306
            },
            "gtin": "4260508540231",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27200d",
            "leftCorner": {
              "x": 14.233,
              "y": 2.252,
              "z": 1.306
            },
            "rightCorner": {
              "x": 14.229,
              "y": 2.196,
              "z": 1.306
            },
            "gtin": "4260508540231",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27200e",
            "leftCorner": {
              "x": 14.229,
              "y": 2.196,
              "z": 1.306
            },
            "rightCorner": {
              "x": 14.221,
              "y": 2.101,
              "z": 1.306
            },
            "gtin": "4001683011426",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27200f",
            "leftCorner": {
              "x": 14.221,
              "y": 2.101,
              "z": 1.306
            },
            "rightCorner": {
              "x": 14.213,
              "y": 2.013,
              "z": 1.306
            },
            "gtin": "3574661582481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272010",
            "leftCorner": {
              "x": 14.213,
              "y": 2.013,
              "z": 1.306
            },
            "rightCorner": {
              "x": 14.202,
              "y": 1.885,
              "z": 1.306
            },
            "gtin": "3574660235982",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272011",
            "leftCorner": {
              "x": 14.202,
              "y": 1.885,
              "z": 1.306
            },
            "rightCorner": {
              "x": 14.19,
              "y": 1.74,
              "z": 1.306
            },
            "gtin": "3574661587134",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272012",
            "leftCorner": {
              "x": 14.19,
              "y": 1.74,
              "z": 1.306
            },
            "rightCorner": {
              "x": 14.18,
              "y": 1.623,
              "z": 1.306
            },
            "gtin": "3574660235951",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272013",
            "leftCorner": {
              "x": 14.18,
              "y": 1.623,
              "z": 1.306
            },
            "rightCorner": {
              "x": 14.166,
              "y": 1.461,
              "z": 1.306
            },
            "gtin": "3574661587110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272014",
            "leftCorner": {
              "x": 14.166,
              "y": 1.461,
              "z": 1.306
            },
            "rightCorner": {
              "x": 14.153,
              "y": 1.303,
              "z": 1.306
            },
            "gtin": "4066447242430",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bfd",
        "height": 1.5145,
        "facings": [
          {
            "id": "696ebf7143c343680a272015",
            "leftCorner": {
              "x": 14.251,
              "y": 2.539,
              "z": 1.514
            },
            "rightCorner": {
              "x": 14.24,
              "y": 2.417,
              "z": 1.514
            },
            "gtin": "4042441018356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272017",
            "leftCorner": {
              "x": 14.24,
              "y": 2.417,
              "z": 1.514
            },
            "rightCorner": {
              "x": 14.232,
              "y": 2.313,
              "z": 1.514
            },
            "gtin": "4262362450558",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272018",
            "leftCorner": {
              "x": 14.232,
              "y": 2.313,
              "z": 1.514
            },
            "rightCorner": {
              "x": 14.223,
              "y": 2.208,
              "z": 1.514
            },
            "gtin": "3574661567310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272019",
            "leftCorner": {
              "x": 14.223,
              "y": 2.208,
              "z": 1.514
            },
            "rightCorner": {
              "x": 14.211,
              "y": 2.071,
              "z": 1.514
            },
            "gtin": "3574661582467",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27201a",
            "leftCorner": {
              "x": 14.211,
              "y": 2.071,
              "z": 1.514
            },
            "rightCorner": {
              "x": 14.201,
              "y": 1.952,
              "z": 1.514
            },
            "gtin": "3574661567327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a27201b",
            "leftCorner": {
              "x": 14.201,
              "y": 1.952,
              "z": 1.514
            },
            "rightCorner": {
              "x": 14.191,
              "y": 1.838,
              "z": 1.514
            },
            "gtin": "3574661567327",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27201c",
            "leftCorner": {
              "x": 14.191,
              "y": 1.838,
              "z": 1.514
            },
            "rightCorner": {
              "x": 14.181,
              "y": 1.722,
              "z": 1.514
            },
            "gtin": "3574661582474",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27201d",
            "leftCorner": {
              "x": 14.181,
              "y": 1.722,
              "z": 1.514
            },
            "rightCorner": {
              "x": 14.171,
              "y": 1.605,
              "z": 1.514
            },
            "gtin": "3574661577852",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27201e",
            "leftCorner": {
              "x": 14.171,
              "y": 1.605,
              "z": 1.514
            },
            "rightCorner": {
              "x": 14.16,
              "y": 1.473,
              "z": 1.514
            },
            "gtin": "3574661577845",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27201f",
            "leftCorner": {
              "x": 14.16,
              "y": 1.473,
              "z": 1.514
            },
            "rightCorner": {
              "x": 14.154,
              "y": 1.398,
              "z": 1.514
            },
            "gtin": "3574661577869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272020",
            "leftCorner": {
              "x": 14.154,
              "y": 1.398,
              "z": 1.514
            },
            "rightCorner": {
              "x": 14.151,
              "y": 1.372,
              "z": 1.514
            }
          },
          {
            "id": "696ebf7143c343680a272016",
            "leftCorner": {
              "x": 14.151,
              "y": 1.372,
              "z": 1.514
            },
            "rightCorner": {
              "x": 14.145,
              "y": 1.294,
              "z": 1.514
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c01",
        "height": 1.7634,
        "facings": [
          {
            "id": "696ebf6e43c343680a27067c",
            "leftCorner": {
              "x": 14.251,
              "y": 2.607,
              "z": 1.767
            },
            "rightCorner": {
              "x": 14.242,
              "y": 2.497,
              "z": 1.767
            },
            "gtin": "4066447068252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27067d",
            "leftCorner": {
              "x": 14.245,
              "y": 2.489,
              "z": 1.763
            },
            "rightCorner": {
              "x": 14.241,
              "y": 2.441,
              "z": 1.763
            },
            "gtin": "4066447249958",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27067e",
            "leftCorner": {
              "x": 14.241,
              "y": 2.441,
              "z": 1.763
            },
            "rightCorner": {
              "x": 14.237,
              "y": 2.397,
              "z": 1.763
            },
            "gtin": "4067796139952",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27067f",
            "leftCorner": {
              "x": 14.237,
              "y": 2.397,
              "z": 1.763
            },
            "rightCorner": {
              "x": 14.23,
              "y": 2.308,
              "z": 1.763
            },
            "gtin": "4067796000894",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270680",
            "leftCorner": {
              "x": 14.23,
              "y": 2.308,
              "z": 1.763
            },
            "rightCorner": {
              "x": 14.224,
              "y": 2.234,
              "z": 1.763
            },
            "gtin": "4067796000894",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270681",
            "leftCorner": {
              "x": 14.224,
              "y": 2.234,
              "z": 1.763
            },
            "rightCorner": {
              "x": 14.216,
              "y": 2.14,
              "z": 1.763
            },
            "gtin": "4067796000917",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270682",
            "leftCorner": {
              "x": 14.216,
              "y": 2.14,
              "z": 1.763
            },
            "rightCorner": {
              "x": 14.209,
              "y": 2.058,
              "z": 1.763
            },
            "gtin": "4067796000917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270683",
            "leftCorner": {
              "x": 14.209,
              "y": 2.058,
              "z": 1.763
            },
            "rightCorner": {
              "x": 14.199,
              "y": 1.945,
              "z": 1.763
            },
            "gtin": "4005808019588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270684",
            "leftCorner": {
              "x": 14.199,
              "y": 1.945,
              "z": 1.763
            },
            "rightCorner": {
              "x": 14.191,
              "y": 1.853,
              "z": 1.763
            },
            "gtin": "4005900216878",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270685",
            "leftCorner": {
              "x": 14.191,
              "y": 1.853,
              "z": 1.763
            },
            "rightCorner": {
              "x": 14.183,
              "y": 1.755,
              "z": 1.763
            }
          },
          {
            "id": "696ebf6e43c343680a270686",
            "leftCorner": {
              "x": 14.183,
              "y": 1.755,
              "z": 1.763
            },
            "rightCorner": {
              "x": 14.176,
              "y": 1.674,
              "z": 1.763
            },
            "gtin": "4045612009139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270687",
            "leftCorner": {
              "x": 14.176,
              "y": 1.674,
              "z": 1.763
            },
            "rightCorner": {
              "x": 14.172,
              "y": 1.626,
              "z": 1.763
            },
            "gtin": "5010934005205",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270688",
            "leftCorner": {
              "x": 14.172,
              "y": 1.626,
              "z": 1.763
            },
            "rightCorner": {
              "x": 14.163,
              "y": 1.526,
              "z": 1.763
            },
            "gtin": "7350068604560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270689",
            "leftCorner": {
              "x": 14.163,
              "y": 1.526,
              "z": 1.763
            },
            "rightCorner": {
              "x": 14.155,
              "y": 1.424,
              "z": 1.763
            },
            "gtin": "8714207452501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27068a",
            "leftCorner": {
              "x": 14.155,
              "y": 1.424,
              "z": 1.763
            },
            "rightCorner": {
              "x": 14.149,
              "y": 1.355,
              "z": 1.763
            },
            "gtin": "4260018197017",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270632",
            "leftCorner": {
              "x": 14.149,
              "y": 1.355,
              "z": 1.763
            },
            "rightCorner": {
              "x": 14.144,
              "y": 1.294,
              "z": 1.763
            },
            "gtin": "4260018197017",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7566db5fe7bc04695984e",
    "name": "68e7566db5fe7bc04695984e",
    "x": 14.291,
    "y": 1.1792,
    "width": 0.8,
    "height": 1.8,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.727,
      "w": 0.68663
    },
    "statistics": {
      "hasStockCount": 5,
      "noStockCount": 0,
      "unknownStockCount": 7
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73c03",
        "height": 1.5607,
        "facings": [
          {
            "id": "696ebf6e43c343680a2706d0",
            "leftCorner": {
              "x": 14.133,
              "y": 1.188,
              "z": 1.561
            },
            "rightCorner": {
              "x": 14.129,
              "y": 1.105,
              "z": 1.561
            }
          },
          {
            "id": "696ebf6e43c343680a2706d1",
            "leftCorner": {
              "x": 14.129,
              "y": 1.105,
              "z": 1.561
            },
            "rightCorner": {
              "x": 14.115,
              "y": 0.872,
              "z": 1.561
            },
            "gtin": "4066447016734",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706d2",
            "leftCorner": {
              "x": 14.115,
              "y": 0.872,
              "z": 1.561
            },
            "rightCorner": {
              "x": 14.104,
              "y": 0.68,
              "z": 1.561
            },
            "gtin": "4066447016710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706d3",
            "leftCorner": {
              "x": 14.104,
              "y": 0.68,
              "z": 1.561
            },
            "rightCorner": {
              "x": 14.092,
              "y": 0.458,
              "z": 1.561
            },
            "gtin": "4000576027230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706d4",
            "leftCorner": {
              "x": 14.092,
              "y": 0.458,
              "z": 1.561
            },
            "rightCorner": {
              "x": 14.085,
              "y": 0.348,
              "z": 1.561
            },
            "gtin": "4000576027308",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c08",
        "height": 0.29884,
        "facings": []
      },
      {
        "id": "696ead8e3b88e258afd73c07",
        "height": 0.66519,
        "facings": []
      },
      {
        "id": "696ead8e3b88e258afd73c05",
        "height": 1.0033,
        "facings": []
      },
      {
        "id": "696ead8e3b88e258afd73c04",
        "height": 1.266,
        "facings": [
          {
            "id": "696ebf7143c343680a27202a",
            "leftCorner": {
              "x": 14.136,
              "y": 1.188,
              "z": 1.266
            },
            "rightCorner": {
              "x": 14.129,
              "y": 1.071,
              "z": 1.266
            },
            "gtin": "3228061018506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a27202c",
            "leftCorner": {
              "x": 14.129,
              "y": 1.071,
              "z": 1.266
            },
            "rightCorner": {
              "x": 14.117,
              "y": 0.858,
              "z": 1.266
            },
            "gtin": "7322541343372",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27202d",
            "leftCorner": {
              "x": 14.117,
              "y": 0.858,
              "z": 1.266
            },
            "rightCorner": {
              "x": 14.109,
              "y": 0.722,
              "z": 1.266
            }
          },
          {
            "id": "696ebf7143c343680a27202e",
            "leftCorner": {
              "x": 14.109,
              "y": 0.722,
              "z": 1.266
            },
            "rightCorner": {
              "x": 14.1,
              "y": 0.563,
              "z": 1.266
            },
            "gtin": "4066447015591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a27202f",
            "leftCorner": {
              "x": 14.1,
              "y": 0.563,
              "z": 1.266
            },
            "rightCorner": {
              "x": 14.094,
              "y": 0.454,
              "z": 1.266
            }
          },
          {
            "id": "696ebf7143c343680a27202b",
            "leftCorner": {
              "x": 14.094,
              "y": 0.454,
              "z": 1.266
            },
            "rightCorner": {
              "x": 14.09,
              "y": 0.389,
              "z": 1.266
            },
            "gtin": "4066447490619",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c06",
        "height": 1.8547,
        "facings": [
          {
            "id": "696ebf6e43c343680a2706db",
            "leftCorner": {
              "x": 14.123,
              "y": 1.189,
              "z": 1.855
            },
            "rightCorner": {
              "x": 14.114,
              "y": 1.033,
              "z": 1.855
            },
            "gtin": "4066447016741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706dd",
            "leftCorner": {
              "x": 14.114,
              "y": 1.033,
              "z": 1.855
            },
            "rightCorner": {
              "x": 14.102,
              "y": 0.823,
              "z": 1.855
            },
            "gtin": "4066447016703",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706de",
            "leftCorner": {
              "x": 14.102,
              "y": 0.823,
              "z": 1.855
            },
            "rightCorner": {
              "x": 14.087,
              "y": 0.546,
              "z": 1.855
            },
            "gtin": "4067796120622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706df",
            "leftCorner": {
              "x": 14.087,
              "y": 0.546,
              "z": 1.855
            },
            "rightCorner": {
              "x": 14.078,
              "y": 0.39,
              "z": 1.855
            },
            "gtin": "4010355918680",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e756b7b5fe7bc046959868",
    "name": "68e756b7b5fe7bc046959868",
    "x": 14.139,
    "y": 0.29631,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.74249,
      "w": 0.66986
    },
    "statistics": {
      "hasStockCount": 15,
      "noStockCount": 1,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd7398f",
        "height": 0.19722,
        "facings": [
          {
            "id": "696ebf6e43c343680a2706ce",
            "leftCorner": {
              "x": 14.094,
              "y": 0.301,
              "z": 0.197
            },
            "rightCorner": {
              "x": 14.045,
              "y": -0.175,
              "z": 0.197
            },
            "gtin": "4058172286346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706cf",
            "leftCorner": {
              "x": 14.045,
              "y": -0.175,
              "z": 0.197
            },
            "rightCorner": {
              "x": 13.991,
              "y": -0.694,
              "z": 0.197
            },
            "gtin": "4066447484571",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73993",
        "height": 0.59259,
        "facings": [
          {
            "id": "696ebf6e43c343680a2706e7",
            "leftCorner": {
              "x": 14.098,
              "y": 0.301,
              "z": 0.593
            },
            "rightCorner": {
              "x": 14.069,
              "y": 0.025,
              "z": 0.593
            },
            "gtin": "4058172286360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706e9",
            "leftCorner": {
              "x": 14.069,
              "y": 0.025,
              "z": 0.593
            },
            "rightCorner": {
              "x": 14.045,
              "y": -0.213,
              "z": 0.593
            },
            "gtin": "4066447603248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706e8",
            "leftCorner": {
              "x": 14.045,
              "y": -0.213,
              "z": 0.593
            },
            "rightCorner": {
              "x": 13.995,
              "y": -0.694,
              "z": 0.593
            },
            "gtin": "4058172932380",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73992",
        "height": 1.0166,
        "facings": [
          {
            "id": "696ebf6e43c343680a2706e5",
            "leftCorner": {
              "x": 14.095,
              "y": 0.301,
              "z": 1.017
            },
            "rightCorner": {
              "x": 14.018,
              "y": -0.444,
              "z": 1.017
            },
            "gtin": "4058172932212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706e6",
            "leftCorner": {
              "x": 14.018,
              "y": -0.444,
              "z": 1.017
            },
            "rightCorner": {
              "x": 13.994,
              "y": -0.681,
              "z": 1.017
            },
            "gtin": "5029053579290",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7398e",
        "height": 1.3108,
        "facings": [
          {
            "id": "696ebf6e43c343680a2706be",
            "leftCorner": {
              "x": 14.095,
              "y": 0.305,
              "z": 1.311
            },
            "rightCorner": {
              "x": 14.089,
              "y": 0.244,
              "z": 1.311
            },
            "gtin": "4066447054255",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706bf",
            "leftCorner": {
              "x": 14.089,
              "y": 0.244,
              "z": 1.311
            },
            "rightCorner": {
              "x": 14.083,
              "y": 0.18,
              "z": 1.311
            },
            "gtin": "4066447054255",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706c0",
            "leftCorner": {
              "x": 14.083,
              "y": 0.18,
              "z": 1.311
            },
            "rightCorner": {
              "x": 14.075,
              "y": 0.111,
              "z": 1.311
            },
            "gtin": "4066447079432",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706c1",
            "leftCorner": {
              "x": 14.075,
              "y": 0.111,
              "z": 1.311
            },
            "rightCorner": {
              "x": 14.07,
              "y": 0.053,
              "z": 1.311
            },
            "gtin": "4067796182729",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706c2",
            "leftCorner": {
              "x": 14.07,
              "y": 0.053,
              "z": 1.311
            },
            "rightCorner": {
              "x": 14.064,
              "y": -0.002,
              "z": 1.311
            },
            "gtin": "4067796182729",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706c3",
            "leftCorner": {
              "x": 14.064,
              "y": -0.002,
              "z": 1.311
            },
            "rightCorner": {
              "x": 14.058,
              "y": -0.054,
              "z": 1.311
            },
            "gtin": "4066447467499",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706c4",
            "leftCorner": {
              "x": 14.058,
              "y": -0.054,
              "z": 1.311
            },
            "rightCorner": {
              "x": 14.051,
              "y": -0.126,
              "z": 1.311
            },
            "gtin": "4066447467499",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706c5",
            "leftCorner": {
              "x": 14.051,
              "y": -0.126,
              "z": 1.311
            },
            "rightCorner": {
              "x": 14.041,
              "y": -0.222,
              "z": 1.311
            },
            "gtin": "4067796166132",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706c6",
            "leftCorner": {
              "x": 14.041,
              "y": -0.222,
              "z": 1.311
            },
            "rightCorner": {
              "x": 14.035,
              "y": -0.283,
              "z": 1.311
            }
          },
          {
            "id": "696ebf6e43c343680a2706c7",
            "leftCorner": {
              "x": 14.035,
              "y": -0.283,
              "z": 1.311
            },
            "rightCorner": {
              "x": 14.029,
              "y": -0.341,
              "z": 1.311
            },
            "gtin": "4066447467376",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706c8",
            "leftCorner": {
              "x": 14.029,
              "y": -0.341,
              "z": 1.311
            },
            "rightCorner": {
              "x": 14.023,
              "y": -0.394,
              "z": 1.311
            },
            "gtin": "4066447467390",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706c9",
            "leftCorner": {
              "x": 14.023,
              "y": -0.394,
              "z": 1.311
            },
            "rightCorner": {
              "x": 14.018,
              "y": -0.442,
              "z": 1.311
            },
            "gtin": "4066447467390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706ca",
            "leftCorner": {
              "x": 14.018,
              "y": -0.442,
              "z": 1.311
            },
            "rightCorner": {
              "x": 14.012,
              "y": -0.503,
              "z": 1.311
            },
            "gtin": "4066447467451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706cb",
            "leftCorner": {
              "x": 14.012,
              "y": -0.503,
              "z": 1.311
            },
            "rightCorner": {
              "x": 14.004,
              "y": -0.58,
              "z": 1.311
            },
            "gtin": "4066447467451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706cc",
            "leftCorner": {
              "x": 14.004,
              "y": -0.58,
              "z": 1.311
            },
            "rightCorner": {
              "x": 14.0,
              "y": -0.621,
              "z": 1.311
            },
            "gtin": "4058172996511",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706cd",
            "leftCorner": {
              "x": 14.0,
              "y": -0.621,
              "z": 1.311
            },
            "rightCorner": {
              "x": 13.994,
              "y": -0.684,
              "z": 1.311
            },
            "gtin": "4058172996511",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73990",
        "height": 1.5627,
        "facings": [
          {
            "id": "696ebf6e43c343680a2706d5",
            "leftCorner": {
              "x": 14.093,
              "y": 0.259,
              "z": 1.563
            },
            "rightCorner": {
              "x": 14.084,
              "y": 0.169,
              "z": 1.563
            },
            "gtin": "4260620680143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706d6",
            "leftCorner": {
              "x": 14.084,
              "y": 0.169,
              "z": 1.563
            },
            "rightCorner": {
              "x": 14.07,
              "y": 0.033,
              "z": 1.563
            },
            "gtin": "4058172996276",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706d7",
            "leftCorner": {
              "x": 14.07,
              "y": 0.033,
              "z": 1.563
            },
            "rightCorner": {
              "x": 14.053,
              "y": -0.126,
              "z": 1.563
            },
            "gtin": "4058172996191",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706d8",
            "leftCorner": {
              "x": 14.053,
              "y": -0.126,
              "z": 1.563
            },
            "rightCorner": {
              "x": 14.038,
              "y": -0.275,
              "z": 1.563
            },
            "gtin": "4067796195880",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706d9",
            "leftCorner": {
              "x": 14.038,
              "y": -0.275,
              "z": 1.563
            },
            "rightCorner": {
              "x": 14.021,
              "y": -0.435,
              "z": 1.563
            },
            "gtin": "4058172996290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706da",
            "leftCorner": {
              "x": 14.021,
              "y": -0.435,
              "z": 1.563
            },
            "rightCorner": {
              "x": 13.996,
              "y": -0.682,
              "z": 1.563
            },
            "gtin": "4058172996252",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73991",
        "height": 1.8543,
        "facings": [
          {
            "id": "696ebf6e43c343680a2706e0",
            "leftCorner": {
              "x": 14.09,
              "y": 0.301,
              "z": 1.854
            },
            "rightCorner": {
              "x": 14.08,
              "y": 0.118,
              "z": 1.854
            },
            "gtin": "4066447015911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706e1",
            "leftCorner": {
              "x": 14.071,
              "y": 0.119,
              "z": 1.854
            },
            "rightCorner": {
              "x": 14.05,
              "y": -0.087,
              "z": 1.854
            },
            "gtin": "4066447054798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706e2",
            "leftCorner": {
              "x": 14.05,
              "y": -0.087,
              "z": 1.854
            },
            "rightCorner": {
              "x": 14.046,
              "y": -0.127,
              "z": 1.854
            }
          },
          {
            "id": "696ebf6e43c343680a2706e3",
            "leftCorner": {
              "x": 14.046,
              "y": -0.127,
              "z": 1.854
            },
            "rightCorner": {
              "x": 14.029,
              "y": -0.291,
              "z": 1.854
            },
            "gtin": "4058172932540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706e4",
            "leftCorner": {
              "x": 14.029,
              "y": -0.291,
              "z": 1.854
            },
            "rightCorner": {
              "x": 14.012,
              "y": -0.462,
              "z": 1.854
            },
            "gtin": "4058172996238",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706dc",
            "leftCorner": {
              "x": 14.012,
              "y": -0.462,
              "z": 1.854
            },
            "rightCorner": {
              "x": 13.988,
              "y": -0.693,
              "z": 1.854
            },
            "gtin": "4010355918666",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e756ecb5fe7bc0469598a5",
    "name": "68e756ecb5fe7bc0469598a5",
    "x": 14.381,
    "y": -0.76898,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72393,
      "w": 0.68987
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73994",
        "height": 0.59184,
        "facings": []
      }
    ]
  },
  {
    "id": "68e756ecb5fe7bc0469598a6",
    "name": "68e756ecb5fe7bc0469598a6",
    "x": 14.33,
    "y": -1.7727,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73786,
      "w": 0.67496
    },
    "layers": []
  },
  {
    "id": "68e756ecb5fe7bc0469598a7",
    "name": "68e756ecb5fe7bc0469598a7",
    "x": 14.243,
    "y": -2.773,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73354,
      "w": 0.67964
    },
    "layers": []
  },
  {
    "id": "68e756ecb5fe7bc0469598a8",
    "name": "68e756ecb5fe7bc0469598a8",
    "x": 14.172,
    "y": -3.7566,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72795,
      "w": 0.68563
    },
    "layers": []
  },
  {
    "id": "68e756ecb5fe7bc0469598a9",
    "name": "68e756ecb5fe7bc0469598a9",
    "x": 14.112,
    "y": -4.77,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.7408,
      "w": 0.67172
    },
    "layers": []
  },
  {
    "id": "68e756ecb5fe7bc0469598aa",
    "name": "68e756ecb5fe7bc0469598aa",
    "x": 14.016,
    "y": -5.7645,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.7348,
      "w": 0.67829
    },
    "layers": []
  },
  {
    "id": "68e756ecb5fe7bc0469598ab",
    "name": "68e756ecb5fe7bc0469598ab",
    "x": 13.936,
    "y": -6.7516,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73539,
      "w": 0.67765
    },
    "layers": []
  },
  {
    "id": "68e756ecb5fe7bc0469598ac",
    "name": "68e756ecb5fe7bc0469598ac",
    "x": 13.855,
    "y": -7.7546,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73023,
      "w": 0.6832
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73995",
        "height": 1.4657,
        "facings": []
      }
    ]
  },
  {
    "id": "68e756ecb5fe7bc0469598ad",
    "name": "68e756ecb5fe7bc0469598ad",
    "x": 13.787,
    "y": -8.7516,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73342,
      "w": 0.67978
    },
    "layers": []
  },
  {
    "id": "68e756ecb5fe7bc0469598ae",
    "name": "68e756ecb5fe7bc0469598ae",
    "x": 13.714,
    "y": -9.7347,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73627,
      "w": 0.67669
    },
    "layers": []
  },
  {
    "id": "68e756ecb5fe7bc0469598af",
    "name": "68e756ecb5fe7bc0469598af",
    "x": 13.634,
    "y": -10.729,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72923,
      "w": 0.68427
    },
    "layers": []
  },
  {
    "id": "68e756ecb5fe7bc0469598b0",
    "name": "68e756ecb5fe7bc0469598b0",
    "x": 13.57,
    "y": -11.723,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72242,
      "w": 0.69145
    },
    "layers": []
  },
  {
    "id": "68e756ecb5fe7bc0469598b1",
    "name": "68e756ecb5fe7bc0469598b1",
    "x": 13.526,
    "y": -12.738,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73431,
      "w": 0.67881
    },
    "layers": []
  },
  {
    "id": "68e756ecb5fe7bc0469598b2",
    "name": "68e756ecb5fe7bc0469598b2",
    "x": 13.444,
    "y": -13.748,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73671,
      "w": 0.67621
    },
    "layers": []
  },
  {
    "id": "68e756ecb5fe7bc0469598b3",
    "name": "68e756ecb5fe7bc0469598b3",
    "x": 13.361,
    "y": -14.738,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72624,
      "w": 0.68744
    },
    "layers": []
  },
  {
    "id": "68e756ecb5fe7bc0469598b4",
    "name": "68e756ecb5fe7bc0469598b4",
    "x": 13.302,
    "y": -15.731,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73562,
      "w": 0.6774
    },
    "statistics": {
      "hasStockCount": 67,
      "noStockCount": 0,
      "unknownStockCount": 25,
      "shelfCategory": "PARFUM"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73998",
        "height": 0.31012,
        "facings": [
          {
            "id": "696ebf6e43c343680a27073f",
            "leftCorner": {
              "x": 13.233,
              "y": -15.725,
              "z": 0.31
            },
            "rightCorner": {
              "x": 13.22,
              "y": -15.877,
              "z": 0.31
            },
            "gtin": "4011700740000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270741",
            "leftCorner": {
              "x": 13.22,
              "y": -15.877,
              "z": 0.31
            },
            "rightCorner": {
              "x": 13.211,
              "y": -15.985,
              "z": 0.31
            },
            "gtin": "4011700740338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270742",
            "leftCorner": {
              "x": 13.211,
              "y": -15.985,
              "z": 0.31
            },
            "rightCorner": {
              "x": 13.205,
              "y": -16.062,
              "z": 0.31
            },
            "gtin": "4011700313143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270743",
            "leftCorner": {
              "x": 13.205,
              "y": -16.062,
              "z": 0.31
            },
            "rightCorner": {
              "x": 13.202,
              "y": -16.1,
              "z": 0.31
            },
            "gtin": "4011700607099",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270744",
            "leftCorner": {
              "x": 13.202,
              "y": -16.1,
              "z": 0.31
            },
            "rightCorner": {
              "x": 13.2,
              "y": -16.127,
              "z": 0.31
            },
            "gtin": "4011700607099",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270745",
            "leftCorner": {
              "x": 13.2,
              "y": -16.127,
              "z": 0.31
            },
            "rightCorner": {
              "x": 13.195,
              "y": -16.184,
              "z": 0.31
            },
            "gtin": "3607346516737",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270746",
            "leftCorner": {
              "x": 13.195,
              "y": -16.184,
              "z": 0.31
            },
            "rightCorner": {
              "x": 13.191,
              "y": -16.23,
              "z": 0.31
            },
            "gtin": "3607346511107",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270747",
            "leftCorner": {
              "x": 13.191,
              "y": -16.23,
              "z": 0.31
            },
            "rightCorner": {
              "x": 13.187,
              "y": -16.274,
              "z": 0.31
            },
            "gtin": "3607346511299",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270748",
            "leftCorner": {
              "x": 13.187,
              "y": -16.274,
              "z": 0.31
            },
            "rightCorner": {
              "x": 13.182,
              "y": -16.338,
              "z": 0.31
            },
            "gtin": "3616305952967",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270749",
            "leftCorner": {
              "x": 13.182,
              "y": -16.338,
              "z": 0.31
            },
            "rightCorner": {
              "x": 13.177,
              "y": -16.404,
              "z": 0.31
            },
            "gtin": "8005610325569",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27074a",
            "leftCorner": {
              "x": 13.177,
              "y": -16.404,
              "z": 0.31
            },
            "rightCorner": {
              "x": 13.171,
              "y": -16.47,
              "z": 0.31
            },
            "gtin": "5050456079773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27074b",
            "leftCorner": {
              "x": 13.171,
              "y": -16.47,
              "z": 0.31
            },
            "rightCorner": {
              "x": 13.165,
              "y": -16.545,
              "z": 0.31
            },
            "gtin": "3326240005115",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27074c",
            "leftCorner": {
              "x": 13.165,
              "y": -16.545,
              "z": 0.31
            },
            "rightCorner": {
              "x": 13.161,
              "y": -16.591,
              "z": 0.31
            },
            "gtin": "3326240005320",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27074d",
            "leftCorner": {
              "x": 13.161,
              "y": -16.591,
              "z": 0.31
            },
            "rightCorner": {
              "x": 13.159,
              "y": -16.621,
              "z": 0.31
            },
            "gtin": "3326240005320",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27074e",
            "leftCorner": {
              "x": 13.159,
              "y": -16.621,
              "z": 0.31
            },
            "rightCorner": {
              "x": 13.155,
              "y": -16.664,
              "z": 0.31
            },
            "gtin": "3326240036690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27074f",
            "leftCorner": {
              "x": 13.155,
              "y": -16.664,
              "z": 0.31
            },
            "rightCorner": {
              "x": 13.153,
              "y": -16.693,
              "z": 0.31
            },
            "gtin": "3326240003814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270750",
            "leftCorner": {
              "x": 13.153,
              "y": -16.693,
              "z": 0.31
            },
            "rightCorner": {
              "x": 13.149,
              "y": -16.745,
              "z": 0.31
            },
            "gtin": "3326240003814",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73999",
        "height": 0.54962,
        "facings": [
          {
            "id": "696ebf6e43c343680a270779",
            "leftCorner": {
              "x": 13.199,
              "y": -16.067,
              "z": 0.55
            },
            "rightCorner": {
              "x": 13.196,
              "y": -16.105,
              "z": 0.55
            },
            "gtin": "9120130823261",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270773",
            "leftCorner": {
              "x": 13.227,
              "y": -15.725,
              "z": 0.55
            },
            "rightCorner": {
              "x": 13.217,
              "y": -15.845,
              "z": 0.55
            },
            "gtin": "9120130826262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270775",
            "leftCorner": {
              "x": 13.217,
              "y": -15.845,
              "z": 0.55
            },
            "rightCorner": {
              "x": 13.212,
              "y": -15.906,
              "z": 0.55
            },
            "gtin": "9120130824350",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270776",
            "leftCorner": {
              "x": 13.212,
              "y": -15.906,
              "z": 0.55
            },
            "rightCorner": {
              "x": 13.207,
              "y": -15.965,
              "z": 0.55
            },
            "gtin": "9120130822059",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270777",
            "leftCorner": {
              "x": 13.207,
              "y": -15.965,
              "z": 0.55
            },
            "rightCorner": {
              "x": 13.203,
              "y": -16.018,
              "z": 0.55
            },
            "gtin": "9120130823285",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270778",
            "leftCorner": {
              "x": 13.203,
              "y": -16.018,
              "z": 0.55
            },
            "rightCorner": {
              "x": 13.199,
              "y": -16.067,
              "z": 0.55
            },
            "gtin": "9120130823308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27077a",
            "leftCorner": {
              "x": 13.196,
              "y": -16.105,
              "z": 0.55
            },
            "rightCorner": {
              "x": 13.192,
              "y": -16.152,
              "z": 0.55
            },
            "gtin": "9120130823261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27077b",
            "leftCorner": {
              "x": 13.192,
              "y": -16.152,
              "z": 0.55
            },
            "rightCorner": {
              "x": 13.189,
              "y": -16.182,
              "z": 0.55
            },
            "gtin": "9120130824947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27077c",
            "leftCorner": {
              "x": 13.189,
              "y": -16.182,
              "z": 0.55
            },
            "rightCorner": {
              "x": 13.182,
              "y": -16.272,
              "z": 0.55
            },
            "gtin": "9120112222754",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27077d",
            "leftCorner": {
              "x": 13.182,
              "y": -16.272,
              "z": 0.55
            },
            "rightCorner": {
              "x": 13.175,
              "y": -16.358,
              "z": 0.55
            },
            "gtin": "9120058162534",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27077e",
            "leftCorner": {
              "x": 13.175,
              "y": -16.358,
              "z": 0.55
            },
            "rightCorner": {
              "x": 13.168,
              "y": -16.443,
              "z": 0.55
            },
            "gtin": "9120130824091",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27077f",
            "leftCorner": {
              "x": 13.168,
              "y": -16.443,
              "z": 0.55
            },
            "rightCorner": {
              "x": 13.16,
              "y": -16.534,
              "z": 0.55
            },
            "gtin": "9120130826347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270780",
            "leftCorner": {
              "x": 13.16,
              "y": -16.534,
              "z": 0.55
            },
            "rightCorner": {
              "x": 13.153,
              "y": -16.625,
              "z": 0.55
            },
            "gtin": "9120130820321",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270781",
            "leftCorner": {
              "x": 13.153,
              "y": -16.625,
              "z": 0.55
            },
            "rightCorner": {
              "x": 13.147,
              "y": -16.7,
              "z": 0.55
            },
            "gtin": "9120130825968",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270782",
            "leftCorner": {
              "x": 13.147,
              "y": -16.7,
              "z": 0.55
            },
            "rightCorner": {
              "x": 13.141,
              "y": -16.765,
              "z": 0.55
            },
            "gtin": "9120130826002",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7399a",
        "height": 0.80125,
        "facings": [
          {
            "id": "696ebf6e43c343680a2707aa",
            "leftCorner": {
              "x": 13.233,
              "y": -15.726,
              "z": 0.801
            },
            "rightCorner": {
              "x": 13.227,
              "y": -15.805,
              "z": 0.801
            },
            "gtin": "4011700341139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2707ac",
            "leftCorner": {
              "x": 13.227,
              "y": -15.805,
              "z": 0.801
            },
            "rightCorner": {
              "x": 13.22,
              "y": -15.883,
              "z": 0.801
            },
            "gtin": "4011700310449",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707ad",
            "leftCorner": {
              "x": 13.22,
              "y": -15.883,
              "z": 0.801
            },
            "rightCorner": {
              "x": 13.215,
              "y": -15.95,
              "z": 0.801
            },
            "gtin": "4011700352456",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707ae",
            "leftCorner": {
              "x": 13.215,
              "y": -15.95,
              "z": 0.801
            },
            "rightCorner": {
              "x": 13.21,
              "y": -16.012,
              "z": 0.801
            },
            "gtin": "4011700352043",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707af",
            "leftCorner": {
              "x": 13.21,
              "y": -16.012,
              "z": 0.801
            },
            "rightCorner": {
              "x": 13.203,
              "y": -16.093,
              "z": 0.801
            },
            "gtin": "4011700848010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707b0",
            "leftCorner": {
              "x": 13.203,
              "y": -16.093,
              "z": 0.801
            },
            "rightCorner": {
              "x": 13.198,
              "y": -16.151,
              "z": 0.801
            },
            "gtin": "9120112225809",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707b1",
            "leftCorner": {
              "x": 13.198,
              "y": -16.151,
              "z": 0.801
            },
            "rightCorner": {
              "x": 13.196,
              "y": -16.179,
              "z": 0.801
            },
            "gtin": "9120112225809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2707b2",
            "leftCorner": {
              "x": 13.196,
              "y": -16.179,
              "z": 0.801
            },
            "rightCorner": {
              "x": 13.192,
              "y": -16.225,
              "z": 0.801
            },
            "gtin": "9120130824398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2707b3",
            "leftCorner": {
              "x": 13.192,
              "y": -16.225,
              "z": 0.801
            },
            "rightCorner": {
              "x": 13.19,
              "y": -16.257,
              "z": 0.801
            },
            "gtin": "9120130824398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2707b4",
            "leftCorner": {
              "x": 13.19,
              "y": -16.257,
              "z": 0.801
            },
            "rightCorner": {
              "x": 13.185,
              "y": -16.313,
              "z": 0.801
            },
            "gtin": "4066447870794",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707b5",
            "leftCorner": {
              "x": 13.185,
              "y": -16.313,
              "z": 0.801
            },
            "rightCorner": {
              "x": 13.18,
              "y": -16.368,
              "z": 0.801
            },
            "gtin": "4066447863161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707b6",
            "leftCorner": {
              "x": 13.18,
              "y": -16.368,
              "z": 0.801
            },
            "rightCorner": {
              "x": 13.175,
              "y": -16.434,
              "z": 0.801
            },
            "gtin": "8008970059488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707b7",
            "leftCorner": {
              "x": 13.175,
              "y": -16.434,
              "z": 0.801
            },
            "rightCorner": {
              "x": 13.169,
              "y": -16.505,
              "z": 0.801
            },
            "gtin": "8008970057804",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707b8",
            "leftCorner": {
              "x": 13.169,
              "y": -16.505,
              "z": 0.801
            },
            "rightCorner": {
              "x": 13.164,
              "y": -16.569,
              "z": 0.801
            },
            "gtin": "8008970058634",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707b9",
            "leftCorner": {
              "x": 13.164,
              "y": -16.569,
              "z": 0.801
            },
            "rightCorner": {
              "x": 13.159,
              "y": -16.631,
              "z": 0.801
            },
            "gtin": "8008970057811",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707ba",
            "leftCorner": {
              "x": 13.159,
              "y": -16.631,
              "z": 0.801
            },
            "rightCorner": {
              "x": 13.156,
              "y": -16.662,
              "z": 0.801
            },
            "gtin": "8008970057811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2707bb",
            "leftCorner": {
              "x": 13.156,
              "y": -16.662,
              "z": 0.801
            },
            "rightCorner": {
              "x": 13.151,
              "y": -16.726,
              "z": 0.801
            },
            "gtin": "8008970060453",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7399b",
        "height": 1.056,
        "facings": [
          {
            "id": "696ebf6e43c343680a2707df",
            "leftCorner": {
              "x": 13.231,
              "y": -15.725,
              "z": 1.056
            },
            "rightCorner": {
              "x": 13.224,
              "y": -15.809,
              "z": 1.056
            },
            "gtin": "4011700337118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2707e1",
            "leftCorner": {
              "x": 13.224,
              "y": -15.809,
              "z": 1.056
            },
            "rightCorner": {
              "x": 13.217,
              "y": -15.894,
              "z": 1.056
            },
            "gtin": "4011700339242",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707e2",
            "leftCorner": {
              "x": 13.217,
              "y": -15.894,
              "z": 1.056
            },
            "rightCorner": {
              "x": 13.211,
              "y": -15.967,
              "z": 1.056
            },
            "gtin": "4011700339259",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707e3",
            "leftCorner": {
              "x": 13.211,
              "y": -15.967,
              "z": 1.056
            },
            "rightCorner": {
              "x": 13.204,
              "y": -16.056,
              "z": 1.056
            },
            "gtin": "4011700336029",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707e4",
            "leftCorner": {
              "x": 13.204,
              "y": -16.056,
              "z": 1.056
            },
            "rightCorner": {
              "x": 13.199,
              "y": -16.108,
              "z": 1.056
            },
            "gtin": "4262401738494",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707e5",
            "leftCorner": {
              "x": 13.199,
              "y": -16.108,
              "z": 1.056
            },
            "rightCorner": {
              "x": 13.195,
              "y": -16.162,
              "z": 1.056
            },
            "gtin": "4262500780172",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707e6",
            "leftCorner": {
              "x": 13.195,
              "y": -16.162,
              "z": 1.056
            },
            "rightCorner": {
              "x": 13.191,
              "y": -16.208,
              "z": 1.056
            },
            "gtin": "4262401738432",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707e7",
            "leftCorner": {
              "x": 13.191,
              "y": -16.208,
              "z": 1.056
            },
            "rightCorner": {
              "x": 13.187,
              "y": -16.258,
              "z": 1.056
            },
            "gtin": "4262401738371",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707e8",
            "leftCorner": {
              "x": 13.187,
              "y": -16.258,
              "z": 1.056
            },
            "rightCorner": {
              "x": 13.181,
              "y": -16.325,
              "z": 1.056
            },
            "gtin": "4051395291203",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707e9",
            "leftCorner": {
              "x": 13.181,
              "y": -16.325,
              "z": 1.056
            },
            "rightCorner": {
              "x": 13.175,
              "y": -16.4,
              "z": 1.056
            },
            "gtin": "4051395221118",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707ea",
            "leftCorner": {
              "x": 13.175,
              "y": -16.4,
              "z": 1.056
            },
            "rightCorner": {
              "x": 13.17,
              "y": -16.469,
              "z": 1.056
            },
            "gtin": "4051395271113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707eb",
            "leftCorner": {
              "x": 13.17,
              "y": -16.469,
              "z": 1.056
            },
            "rightCorner": {
              "x": 13.164,
              "y": -16.539,
              "z": 1.056
            },
            "gtin": "4051395241116",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707ec",
            "leftCorner": {
              "x": 13.164,
              "y": -16.539,
              "z": 1.056
            },
            "rightCorner": {
              "x": 13.158,
              "y": -16.611,
              "z": 1.056
            },
            "gtin": "4051395271120",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707ed",
            "leftCorner": {
              "x": 13.158,
              "y": -16.611,
              "z": 1.056
            },
            "rightCorner": {
              "x": 13.151,
              "y": -16.691,
              "z": 1.056
            },
            "gtin": "4051395261114",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7399c",
        "height": 1.302,
        "facings": [
          {
            "id": "696ebf6e43c343680a270814",
            "leftCorner": {
              "x": 13.231,
              "y": -15.725,
              "z": 1.302
            },
            "rightCorner": {
              "x": 13.222,
              "y": -15.833,
              "z": 1.302
            },
            "gtin": "4011700367009",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270816",
            "leftCorner": {
              "x": 13.222,
              "y": -15.833,
              "z": 1.302
            },
            "rightCorner": {
              "x": 13.214,
              "y": -15.926,
              "z": 1.302
            },
            "gtin": "719346218412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270817",
            "leftCorner": {
              "x": 13.214,
              "y": -15.926,
              "z": 1.302
            },
            "rightCorner": {
              "x": 13.209,
              "y": -15.981,
              "z": 1.302
            },
            "gtin": "719346218405",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270818",
            "leftCorner": {
              "x": 13.209,
              "y": -15.981,
              "z": 1.302
            },
            "rightCorner": {
              "x": 13.201,
              "y": -16.086,
              "z": 1.302
            },
            "gtin": "719346648820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270819",
            "leftCorner": {
              "x": 13.201,
              "y": -16.086,
              "z": 1.302
            },
            "rightCorner": {
              "x": 13.197,
              "y": -16.129,
              "z": 1.302
            },
            "gtin": "719346648813",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27081a",
            "leftCorner": {
              "x": 13.197,
              "y": -16.129,
              "z": 1.302
            },
            "rightCorner": {
              "x": 13.195,
              "y": -16.159,
              "z": 1.302
            }
          },
          {
            "id": "696ebf6e43c343680a27081b",
            "leftCorner": {
              "x": 13.195,
              "y": -16.159,
              "z": 1.302
            },
            "rightCorner": {
              "x": 13.19,
              "y": -16.212,
              "z": 1.302
            },
            "gtin": "719346218542",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27081c",
            "leftCorner": {
              "x": 13.19,
              "y": -16.212,
              "z": 1.302
            },
            "rightCorner": {
              "x": 13.148,
              "y": -16.722,
              "z": 1.302
            },
            "gtin": "719346235297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27081d",
            "leftCorner": {
              "x": 13.145,
              "y": -16.736,
              "z": 1.299
            },
            "rightCorner": {
              "x": 13.14,
              "y": -16.798,
              "z": 1.299
            },
            "gtin": "4011700822010",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73997",
        "height": 1.5515,
        "facings": [
          {
            "id": "696ebf6e43c343680a270717",
            "leftCorner": {
              "x": 13.226,
              "y": -15.725,
              "z": 1.552
            },
            "rightCorner": {
              "x": 13.219,
              "y": -15.804,
              "z": 1.552
            }
          },
          {
            "id": "696ebf6e43c343680a270719",
            "leftCorner": {
              "x": 13.219,
              "y": -15.804,
              "z": 1.552
            },
            "rightCorner": {
              "x": 13.211,
              "y": -15.908,
              "z": 1.552
            },
            "gtin": "719346841580",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27071a",
            "leftCorner": {
              "x": 13.211,
              "y": -15.908,
              "z": 1.552
            },
            "rightCorner": {
              "x": 13.203,
              "y": -16.003,
              "z": 1.552
            },
            "gtin": "719346841573",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27071b",
            "leftCorner": {
              "x": 13.203,
              "y": -16.003,
              "z": 1.552
            },
            "rightCorner": {
              "x": 13.198,
              "y": -16.063,
              "z": 1.552
            },
            "gtin": "719346842570",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27071c",
            "leftCorner": {
              "x": 13.198,
              "y": -16.063,
              "z": 1.552
            },
            "rightCorner": {
              "x": 13.193,
              "y": -16.122,
              "z": 1.552
            },
            "gtin": "9120130826309",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27071d",
            "leftCorner": {
              "x": 13.193,
              "y": -16.122,
              "z": 1.552
            },
            "rightCorner": {
              "x": 13.189,
              "y": -16.172,
              "z": 1.552
            },
            "gtin": "9120112224512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27071e",
            "leftCorner": {
              "x": 13.189,
              "y": -16.172,
              "z": 1.552
            },
            "rightCorner": {
              "x": 13.187,
              "y": -16.201,
              "z": 1.552
            },
            "gtin": "9120112224512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27071f",
            "leftCorner": {
              "x": 13.187,
              "y": -16.201,
              "z": 1.552
            },
            "rightCorner": {
              "x": 13.144,
              "y": -16.721,
              "z": 1.552
            },
            "gtin": "9120130821960",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73996",
        "height": 1.8108,
        "facings": [
          {
            "id": "696ebf6e43c343680a2706ea",
            "leftCorner": {
              "x": 13.222,
              "y": -15.725,
              "z": 1.811
            },
            "rightCorner": {
              "x": 13.215,
              "y": -15.813,
              "z": 1.811
            },
            "gtin": "9120112227636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706ec",
            "leftCorner": {
              "x": 13.215,
              "y": -15.813,
              "z": 1.811
            },
            "rightCorner": {
              "x": 13.208,
              "y": -15.893,
              "z": 1.811
            },
            "gtin": "9120112221184",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706ed",
            "leftCorner": {
              "x": 13.208,
              "y": -15.893,
              "z": 1.811
            },
            "rightCorner": {
              "x": 13.202,
              "y": -15.97,
              "z": 1.811
            },
            "gtin": "9120112228893",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706ee",
            "leftCorner": {
              "x": 13.202,
              "y": -15.97,
              "z": 1.811
            },
            "rightCorner": {
              "x": 13.195,
              "y": -16.055,
              "z": 1.811
            },
            "gtin": "9120130824299",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706ef",
            "leftCorner": {
              "x": 13.195,
              "y": -16.055,
              "z": 1.811
            },
            "rightCorner": {
              "x": 13.189,
              "y": -16.129,
              "z": 1.811
            },
            "gtin": "9120112229685",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706f0",
            "leftCorner": {
              "x": 13.189,
              "y": -16.129,
              "z": 1.811
            },
            "rightCorner": {
              "x": 13.185,
              "y": -16.172,
              "z": 1.811
            },
            "gtin": "9120130824558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706f1",
            "leftCorner": {
              "x": 13.185,
              "y": -16.172,
              "z": 1.811
            },
            "rightCorner": {
              "x": 13.183,
              "y": -16.202,
              "z": 1.811
            },
            "gtin": "9120130824558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706f2",
            "leftCorner": {
              "x": 13.183,
              "y": -16.202,
              "z": 1.811
            },
            "rightCorner": {
              "x": 13.177,
              "y": -16.273,
              "z": 1.811
            },
            "gtin": "9120130822271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706f3",
            "leftCorner": {
              "x": 13.177,
              "y": -16.273,
              "z": 1.811
            },
            "rightCorner": {
              "x": 13.171,
              "y": -16.341,
              "z": 1.811
            },
            "gtin": "9120130826200",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706f4",
            "leftCorner": {
              "x": 13.171,
              "y": -16.341,
              "z": 1.811
            },
            "rightCorner": {
              "x": 13.167,
              "y": -16.396,
              "z": 1.811
            },
            "gtin": "3616306970434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706f5",
            "leftCorner": {
              "x": 13.167,
              "y": -16.396,
              "z": 1.811
            },
            "rightCorner": {
              "x": 13.162,
              "y": -16.449,
              "z": 1.811
            },
            "gtin": "3616305616050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706f6",
            "leftCorner": {
              "x": 13.162,
              "y": -16.449,
              "z": 1.811
            },
            "rightCorner": {
              "x": 13.156,
              "y": -16.531,
              "z": 1.811
            },
            "gtin": "3616305616050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706f7",
            "leftCorner": {
              "x": 13.156,
              "y": -16.531,
              "z": 1.811
            },
            "rightCorner": {
              "x": 13.153,
              "y": -16.561,
              "z": 1.811
            }
          },
          {
            "id": "696ebf6e43c343680a2706f8",
            "leftCorner": {
              "x": 13.153,
              "y": -16.561,
              "z": 1.811
            },
            "rightCorner": {
              "x": 13.149,
              "y": -16.613,
              "z": 1.811
            },
            "gtin": "4022343084109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2706f9",
            "leftCorner": {
              "x": 13.149,
              "y": -16.613,
              "z": 1.811
            },
            "rightCorner": {
              "x": 13.146,
              "y": -16.643,
              "z": 1.811
            }
          },
          {
            "id": "696ebf6e43c343680a2706fa",
            "leftCorner": {
              "x": 13.146,
              "y": -16.643,
              "z": 1.811
            },
            "rightCorner": {
              "x": 13.14,
              "y": -16.725,
              "z": 1.811
            },
            "gtin": "4260309920294",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e756ecb5fe7bc0469598b5",
    "name": "68e756ecb5fe7bc0469598b5",
    "x": 13.221,
    "y": -16.74,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.7289,
      "w": 0.68462
    },
    "statistics": {
      "hasStockCount": 82,
      "noStockCount": 1,
      "unknownStockCount": 11,
      "shelfCategory": "PARFUM"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd7399f",
        "height": 0.30742,
        "facings": [
          {
            "id": "696ebf6e43c343680a270751",
            "leftCorner": {
              "x": 13.147,
              "y": -16.758,
              "z": 0.307
            },
            "rightCorner": {
              "x": 13.142,
              "y": -16.835,
              "z": 0.307
            },
            "gtin": "3326240005368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270752",
            "leftCorner": {
              "x": 13.142,
              "y": -16.835,
              "z": 0.307
            },
            "rightCorner": {
              "x": 13.137,
              "y": -16.912,
              "z": 0.307
            },
            "gtin": "3326240006136",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270753",
            "leftCorner": {
              "x": 13.137,
              "y": -16.912,
              "z": 0.307
            },
            "rightCorner": {
              "x": 13.133,
              "y": -16.987,
              "z": 0.307
            },
            "gtin": "3326240053277",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270754",
            "leftCorner": {
              "x": 13.133,
              "y": -16.987,
              "z": 0.307
            },
            "rightCorner": {
              "x": 13.128,
              "y": -17.061,
              "z": 0.307
            },
            "gtin": "3326240005351",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270755",
            "leftCorner": {
              "x": 13.128,
              "y": -17.061,
              "z": 0.307
            },
            "rightCorner": {
              "x": 13.123,
              "y": -17.132,
              "z": 0.307
            },
            "gtin": "3760104917372",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270756",
            "leftCorner": {
              "x": 13.123,
              "y": -17.132,
              "z": 0.307
            },
            "rightCorner": {
              "x": 13.119,
              "y": -17.203,
              "z": 0.307
            },
            "gtin": "3760104917396",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270757",
            "leftCorner": {
              "x": 13.119,
              "y": -17.203,
              "z": 0.307
            },
            "rightCorner": {
              "x": 13.114,
              "y": -17.279,
              "z": 0.307
            },
            "gtin": "5903719647526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270758",
            "leftCorner": {
              "x": 13.114,
              "y": -17.279,
              "z": 0.307
            },
            "rightCorner": {
              "x": 13.11,
              "y": -17.352,
              "z": 0.307
            },
            "gtin": "5903719647519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270759",
            "leftCorner": {
              "x": 13.11,
              "y": -17.352,
              "z": 0.307
            },
            "rightCorner": {
              "x": 13.105,
              "y": -17.431,
              "z": 0.307
            },
            "gtin": "5903719647533",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27075a",
            "leftCorner": {
              "x": 13.105,
              "y": -17.431,
              "z": 0.307
            },
            "rightCorner": {
              "x": 13.099,
              "y": -17.526,
              "z": 0.307
            },
            "gtin": "5903719643726",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27075b",
            "leftCorner": {
              "x": 13.099,
              "y": -17.526,
              "z": 0.307
            },
            "rightCorner": {
              "x": 13.094,
              "y": -17.601,
              "z": 0.307
            },
            "gtin": "5903719643795",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27075c",
            "leftCorner": {
              "x": 13.094,
              "y": -17.601,
              "z": 0.307
            },
            "rightCorner": {
              "x": 13.089,
              "y": -17.685,
              "z": 0.307
            },
            "gtin": "5903719643733",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27075d",
            "leftCorner": {
              "x": 13.089,
              "y": -17.685,
              "z": 0.307
            },
            "rightCorner": {
              "x": 13.083,
              "y": -17.774,
              "z": 0.307
            },
            "gtin": "5906735231144",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739a3",
        "height": 0.54328,
        "facings": [
          {
            "id": "696ebf6e43c343680a270783",
            "leftCorner": {
              "x": 13.143,
              "y": -16.779,
              "z": 0.543
            },
            "rightCorner": {
              "x": 13.139,
              "y": -16.849,
              "z": 0.543
            },
            "gtin": "9120130826125",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270784",
            "leftCorner": {
              "x": 13.139,
              "y": -16.849,
              "z": 0.543
            },
            "rightCorner": {
              "x": 13.134,
              "y": -16.92,
              "z": 0.543
            },
            "gtin": "9120130824657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270785",
            "leftCorner": {
              "x": 13.134,
              "y": -16.92,
              "z": 0.543
            },
            "rightCorner": {
              "x": 13.129,
              "y": -16.997,
              "z": 0.543
            },
            "gtin": "9120112221122",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270786",
            "leftCorner": {
              "x": 13.129,
              "y": -16.997,
              "z": 0.543
            },
            "rightCorner": {
              "x": 13.125,
              "y": -17.067,
              "z": 0.543
            },
            "gtin": "9120130823360",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270787",
            "leftCorner": {
              "x": 13.125,
              "y": -17.067,
              "z": 0.543
            },
            "rightCorner": {
              "x": 13.12,
              "y": -17.138,
              "z": 0.543
            },
            "gtin": "9120082229210",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270788",
            "leftCorner": {
              "x": 13.12,
              "y": -17.138,
              "z": 0.543
            },
            "rightCorner": {
              "x": 13.116,
              "y": -17.209,
              "z": 0.543
            },
            "gtin": "9120130821687",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270789",
            "leftCorner": {
              "x": 13.116,
              "y": -17.209,
              "z": 0.543
            },
            "rightCorner": {
              "x": 13.111,
              "y": -17.28,
              "z": 0.543
            },
            "gtin": "9120112229555",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27078a",
            "leftCorner": {
              "x": 13.111,
              "y": -17.28,
              "z": 0.543
            },
            "rightCorner": {
              "x": 13.107,
              "y": -17.352,
              "z": 0.543
            },
            "gtin": "9120130824695",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27078b",
            "leftCorner": {
              "x": 13.107,
              "y": -17.352,
              "z": 0.543
            },
            "rightCorner": {
              "x": 13.101,
              "y": -17.44,
              "z": 0.543
            },
            "gtin": "9120130821021",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27078c",
            "leftCorner": {
              "x": 13.101,
              "y": -17.44,
              "z": 0.543
            },
            "rightCorner": {
              "x": 13.097,
              "y": -17.514,
              "z": 0.543
            },
            "gtin": "9120112223850",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27078d",
            "leftCorner": {
              "x": 13.097,
              "y": -17.514,
              "z": 0.543
            },
            "rightCorner": {
              "x": 13.092,
              "y": -17.588,
              "z": 0.543
            },
            "gtin": "9120112227438",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27078e",
            "leftCorner": {
              "x": 13.092,
              "y": -17.588,
              "z": 0.543
            },
            "rightCorner": {
              "x": 13.089,
              "y": -17.641,
              "z": 0.543
            },
            "gtin": "5903719644150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27078f",
            "leftCorner": {
              "x": 13.089,
              "y": -17.641,
              "z": 0.543
            },
            "rightCorner": {
              "x": 13.085,
              "y": -17.695,
              "z": 0.543
            },
            "gtin": "5903719640749",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270790",
            "leftCorner": {
              "x": 13.085,
              "y": -17.695,
              "z": 0.543
            },
            "rightCorner": {
              "x": 13.084,
              "y": -17.725,
              "z": 0.543
            },
            "gtin": "5903719640763",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739a1",
        "height": 0.79515,
        "facings": [
          {
            "id": "696ebf6e43c343680a2707bc",
            "leftCorner": {
              "x": 13.151,
              "y": -16.726,
              "z": 0.801
            },
            "rightCorner": {
              "x": 13.146,
              "y": -16.78,
              "z": 0.801
            },
            "gtin": "3616305447234",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707bd",
            "leftCorner": {
              "x": 13.145,
              "y": -16.794,
              "z": 0.795
            },
            "rightCorner": {
              "x": 13.14,
              "y": -16.859,
              "z": 0.795
            },
            "gtin": "3616305447128",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707be",
            "leftCorner": {
              "x": 13.14,
              "y": -16.859,
              "z": 0.795
            },
            "rightCorner": {
              "x": 13.135,
              "y": -16.943,
              "z": 0.795
            },
            "gtin": "5024693211654",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707bf",
            "leftCorner": {
              "x": 13.135,
              "y": -16.943,
              "z": 0.795
            },
            "rightCorner": {
              "x": 13.13,
              "y": -17.024,
              "z": 0.795
            },
            "gtin": "5024693211715",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707c0",
            "leftCorner": {
              "x": 13.13,
              "y": -17.024,
              "z": 0.795
            },
            "rightCorner": {
              "x": 13.125,
              "y": -17.103,
              "z": 0.795
            },
            "gtin": "5024693211685",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707c1",
            "leftCorner": {
              "x": 13.125,
              "y": -17.103,
              "z": 0.795
            },
            "rightCorner": {
              "x": 13.12,
              "y": -17.184,
              "z": 0.795
            },
            "gtin": "5024693225576",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707c2",
            "leftCorner": {
              "x": 13.12,
              "y": -17.184,
              "z": 0.795
            },
            "rightCorner": {
              "x": 13.116,
              "y": -17.257,
              "z": 0.795
            },
            "gtin": "5024693234547",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707c3",
            "leftCorner": {
              "x": 13.116,
              "y": -17.257,
              "z": 0.795
            },
            "rightCorner": {
              "x": 13.111,
              "y": -17.321,
              "z": 0.795
            },
            "gtin": "085715270061",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707c4",
            "leftCorner": {
              "x": 13.111,
              "y": -17.321,
              "z": 0.795
            },
            "rightCorner": {
              "x": 13.105,
              "y": -17.421,
              "z": 0.795
            },
            "gtin": "085715268037",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707c5",
            "leftCorner": {
              "x": 13.105,
              "y": -17.421,
              "z": 0.795
            },
            "rightCorner": {
              "x": 13.101,
              "y": -17.486,
              "z": 0.795
            },
            "gtin": "9120130826088",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707c6",
            "leftCorner": {
              "x": 13.101,
              "y": -17.486,
              "z": 0.795
            },
            "rightCorner": {
              "x": 13.097,
              "y": -17.549,
              "z": 0.795
            },
            "gtin": "9120130820666",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707c7",
            "leftCorner": {
              "x": 13.097,
              "y": -17.549,
              "z": 0.795
            },
            "rightCorner": {
              "x": 13.093,
              "y": -17.609,
              "z": 0.795
            },
            "gtin": "9120130820659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707c8",
            "leftCorner": {
              "x": 13.093,
              "y": -17.609,
              "z": 0.795
            },
            "rightCorner": {
              "x": 13.09,
              "y": -17.67,
              "z": 0.795
            },
            "gtin": "9120130824275",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707c9",
            "leftCorner": {
              "x": 13.09,
              "y": -17.67,
              "z": 0.795
            },
            "rightCorner": {
              "x": 13.086,
              "y": -17.73,
              "z": 0.795
            },
            "gtin": "4011700311309",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739a0",
        "height": 1.0482,
        "facings": [
          {
            "id": "696ebf6e43c343680a2707ee",
            "leftCorner": {
              "x": 13.151,
              "y": -16.691,
              "z": 1.056
            },
            "rightCorner": {
              "x": 13.145,
              "y": -16.769,
              "z": 1.056
            },
            "gtin": "4051395251184",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707ef",
            "leftCorner": {
              "x": 13.145,
              "y": -16.783,
              "z": 1.048
            },
            "rightCorner": {
              "x": 13.14,
              "y": -16.862,
              "z": 1.048
            },
            "gtin": "4051395251108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707f0",
            "leftCorner": {
              "x": 13.14,
              "y": -16.862,
              "z": 1.048
            },
            "rightCorner": {
              "x": 13.136,
              "y": -16.927,
              "z": 1.048
            },
            "gtin": "4051395281129",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707f1",
            "leftCorner": {
              "x": 13.136,
              "y": -16.927,
              "z": 1.048
            },
            "rightCorner": {
              "x": 13.132,
              "y": -16.99,
              "z": 1.048
            },
            "gtin": "4051395251115",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707f2",
            "leftCorner": {
              "x": 13.132,
              "y": -16.99,
              "z": 1.048
            },
            "rightCorner": {
              "x": 13.128,
              "y": -17.05,
              "z": 1.048
            },
            "gtin": "3616305168948",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707f3",
            "leftCorner": {
              "x": 13.128,
              "y": -17.05,
              "z": 1.048
            },
            "rightCorner": {
              "x": 13.124,
              "y": -17.118,
              "z": 1.048
            },
            "gtin": "3616305169006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707f4",
            "leftCorner": {
              "x": 13.124,
              "y": -17.118,
              "z": 1.048
            },
            "rightCorner": {
              "x": 13.119,
              "y": -17.199,
              "z": 1.048
            },
            "gtin": "3616305168979",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707f5",
            "leftCorner": {
              "x": 13.119,
              "y": -17.199,
              "z": 1.048
            },
            "rightCorner": {
              "x": 13.115,
              "y": -17.258,
              "z": 1.048
            },
            "gtin": "3616305169013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2707f6",
            "leftCorner": {
              "x": 13.115,
              "y": -17.258,
              "z": 1.048
            },
            "rightCorner": {
              "x": 13.11,
              "y": -17.341,
              "z": 1.048
            },
            "gtin": "3616305169020",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707f7",
            "leftCorner": {
              "x": 13.11,
              "y": -17.341,
              "z": 1.048
            },
            "rightCorner": {
              "x": 13.105,
              "y": -17.419,
              "z": 1.048
            },
            "gtin": "3616305169471",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707f8",
            "leftCorner": {
              "x": 13.105,
              "y": -17.419,
              "z": 1.048
            },
            "rightCorner": {
              "x": 13.099,
              "y": -17.52,
              "z": 1.048
            },
            "gtin": "3616305169433",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707f9",
            "leftCorner": {
              "x": 13.099,
              "y": -17.52,
              "z": 1.048
            },
            "rightCorner": {
              "x": 13.094,
              "y": -17.599,
              "z": 1.048
            },
            "gtin": "3616306970458",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707fa",
            "leftCorner": {
              "x": 13.094,
              "y": -17.599,
              "z": 1.048
            },
            "rightCorner": {
              "x": 13.09,
              "y": -17.658,
              "z": 1.048
            },
            "gtin": "3616305616074",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707fb",
            "leftCorner": {
              "x": 13.09,
              "y": -17.658,
              "z": 1.048
            },
            "rightCorner": {
              "x": 13.087,
              "y": -17.713,
              "z": 1.048
            },
            "gtin": "3616305616074",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739a2",
        "height": 1.2994,
        "facings": [
          {
            "id": "696ebf6e43c343680a27081e",
            "leftCorner": {
              "x": 13.141,
              "y": -16.798,
              "z": 1.299
            },
            "rightCorner": {
              "x": 13.136,
              "y": -16.872,
              "z": 1.299
            }
          },
          {
            "id": "696ebf6e43c343680a27081f",
            "leftCorner": {
              "x": 13.136,
              "y": -16.872,
              "z": 1.299
            },
            "rightCorner": {
              "x": 13.132,
              "y": -16.938,
              "z": 1.299
            },
            "gtin": "4011700879274",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270820",
            "leftCorner": {
              "x": 13.132,
              "y": -16.938,
              "z": 1.299
            },
            "rightCorner": {
              "x": 13.128,
              "y": -17.0,
              "z": 1.299
            },
            "gtin": "4011700879045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270821",
            "leftCorner": {
              "x": 13.128,
              "y": -17.0,
              "z": 1.299
            },
            "rightCorner": {
              "x": 13.124,
              "y": -17.063,
              "z": 1.299
            },
            "gtin": "4011700886029",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270822",
            "leftCorner": {
              "x": 13.124,
              "y": -17.063,
              "z": 1.299
            },
            "rightCorner": {
              "x": 13.12,
              "y": -17.131,
              "z": 1.299
            },
            "gtin": "4011700886005",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270823",
            "leftCorner": {
              "x": 13.12,
              "y": -17.131,
              "z": 1.299
            },
            "rightCorner": {
              "x": 13.117,
              "y": -17.174,
              "z": 1.299
            },
            "gtin": "3616305274748",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270824",
            "leftCorner": {
              "x": 13.117,
              "y": -17.174,
              "z": 1.299
            },
            "rightCorner": {
              "x": 13.115,
              "y": -17.219,
              "z": 1.299
            },
            "gtin": "3616305274755",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270825",
            "leftCorner": {
              "x": 13.115,
              "y": -17.219,
              "z": 1.299
            },
            "rightCorner": {
              "x": 13.112,
              "y": -17.265,
              "z": 1.299
            },
            "gtin": "3616305169068",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270826",
            "leftCorner": {
              "x": 13.112,
              "y": -17.265,
              "z": 1.299
            },
            "rightCorner": {
              "x": 13.108,
              "y": -17.327,
              "z": 1.299
            },
            "gtin": "3616305624703",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270827",
            "leftCorner": {
              "x": 13.108,
              "y": -17.327,
              "z": 1.299
            },
            "rightCorner": {
              "x": 13.104,
              "y": -17.39,
              "z": 1.299
            },
            "gtin": "3616304940668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270828",
            "leftCorner": {
              "x": 13.104,
              "y": -17.39,
              "z": 1.299
            },
            "rightCorner": {
              "x": 13.098,
              "y": -17.486,
              "z": 1.299
            },
            "gtin": "4051395491139",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270829",
            "leftCorner": {
              "x": 13.098,
              "y": -17.486,
              "z": 1.299
            },
            "rightCorner": {
              "x": 13.094,
              "y": -17.556,
              "z": 1.299
            },
            "gtin": "3616301641070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27082a",
            "leftCorner": {
              "x": 13.094,
              "y": -17.556,
              "z": 1.299
            },
            "rightCorner": {
              "x": 13.089,
              "y": -17.629,
              "z": 1.299
            },
            "gtin": "3616301640967",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27082b",
            "leftCorner": {
              "x": 13.089,
              "y": -17.629,
              "z": 1.299
            },
            "rightCorner": {
              "x": 13.084,
              "y": -17.703,
              "z": 1.299
            },
            "gtin": "3616301640998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27082c",
            "leftCorner": {
              "x": 13.084,
              "y": -17.703,
              "z": 1.299
            },
            "rightCorner": {
              "x": 13.081,
              "y": -17.759,
              "z": 1.299
            },
            "gtin": "3616301640981",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7399d",
        "height": 1.5575,
        "facings": [
          {
            "id": "696ebf6e43c343680a270720",
            "leftCorner": {
              "x": 13.14,
              "y": -16.735,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.134,
              "y": -16.812,
              "z": 1.557
            },
            "gtin": "4011700855025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270721",
            "leftCorner": {
              "x": 13.136,
              "y": -16.812,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.131,
              "y": -16.894,
              "z": 1.557
            },
            "gtin": "4011700855001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270722",
            "leftCorner": {
              "x": 13.131,
              "y": -16.894,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.127,
              "y": -16.946,
              "z": 1.557
            },
            "gtin": "4011700820085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270723",
            "leftCorner": {
              "x": 13.127,
              "y": -16.946,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.122,
              "y": -17.023,
              "z": 1.557
            },
            "gtin": "4011700820054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270724",
            "leftCorner": {
              "x": 13.122,
              "y": -17.023,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.118,
              "y": -17.087,
              "z": 1.557
            },
            "gtin": "4011700863051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270725",
            "leftCorner": {
              "x": 13.118,
              "y": -17.087,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.114,
              "y": -17.161,
              "z": 1.557
            },
            "gtin": "4011700896097",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270726",
            "leftCorner": {
              "x": 13.114,
              "y": -17.161,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.109,
              "y": -17.233,
              "z": 1.557
            },
            "gtin": "4011700813049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270727",
            "leftCorner": {
              "x": 13.109,
              "y": -17.233,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.105,
              "y": -17.304,
              "z": 1.557
            },
            "gtin": "085715320131",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270728",
            "leftCorner": {
              "x": 13.105,
              "y": -17.304,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.1,
              "y": -17.377,
              "z": 1.557
            },
            "gtin": "085715320230",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270729",
            "leftCorner": {
              "x": 13.1,
              "y": -17.377,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.095,
              "y": -17.463,
              "z": 1.557
            },
            "gtin": "085715000040",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27072a",
            "leftCorner": {
              "x": 13.095,
              "y": -17.463,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.09,
              "y": -17.54,
              "z": 1.557
            },
            "gtin": "085715322418",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27072b",
            "leftCorner": {
              "x": 13.09,
              "y": -17.54,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.085,
              "y": -17.613,
              "z": 1.557
            },
            "gtin": "085715324306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27072c",
            "leftCorner": {
              "x": 13.085,
              "y": -17.613,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.081,
              "y": -17.69,
              "z": 1.557
            },
            "gtin": "085715331533",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27072d",
            "leftCorner": {
              "x": 13.081,
              "y": -17.69,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.077,
              "y": -17.74,
              "z": 1.557
            },
            "gtin": "4051395171130",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7399e",
        "height": 1.8038,
        "facings": [
          {
            "id": "696ebf6e43c343680a2706fb",
            "leftCorner": {
              "x": 13.138,
              "y": -16.739,
              "z": 1.804
            },
            "rightCorner": {
              "x": 13.133,
              "y": -16.822,
              "z": 1.804
            },
            "gtin": "4063528097545",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706fc",
            "leftCorner": {
              "x": 13.133,
              "y": -16.822,
              "z": 1.804
            },
            "rightCorner": {
              "x": 13.128,
              "y": -16.897,
              "z": 1.804
            },
            "gtin": "4063528093486",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706fd",
            "leftCorner": {
              "x": 13.128,
              "y": -16.897,
              "z": 1.804
            },
            "rightCorner": {
              "x": 13.123,
              "y": -16.975,
              "z": 1.804
            },
            "gtin": "4063528093509",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706fe",
            "leftCorner": {
              "x": 13.123,
              "y": -16.975,
              "z": 1.804
            },
            "rightCorner": {
              "x": 13.118,
              "y": -17.055,
              "z": 1.804
            },
            "gtin": "4063528097576",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2706ff",
            "leftCorner": {
              "x": 13.118,
              "y": -17.055,
              "z": 1.804
            },
            "rightCorner": {
              "x": 13.113,
              "y": -17.134,
              "z": 1.804
            },
            "gtin": "4063528093516",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270700",
            "leftCorner": {
              "x": 13.113,
              "y": -17.134,
              "z": 1.804
            },
            "rightCorner": {
              "x": 13.108,
              "y": -17.211,
              "z": 1.804
            },
            "gtin": "4063528093547",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270701",
            "leftCorner": {
              "x": 13.108,
              "y": -17.211,
              "z": 1.804
            },
            "rightCorner": {
              "x": 13.098,
              "y": -17.367,
              "z": 1.804
            },
            "gtin": "4005900722218",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270702",
            "leftCorner": {
              "x": 13.098,
              "y": -17.367,
              "z": 1.804
            },
            "rightCorner": {
              "x": 13.088,
              "y": -17.537,
              "z": 1.804
            },
            "gtin": "4005900616975",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270703",
            "leftCorner": {
              "x": 13.088,
              "y": -17.537,
              "z": 1.804
            },
            "rightCorner": {
              "x": 13.084,
              "y": -17.602,
              "z": 1.804
            },
            "gtin": "3414201002683",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270704",
            "leftCorner": {
              "x": 13.084,
              "y": -17.602,
              "z": 1.804
            },
            "rightCorner": {
              "x": 13.079,
              "y": -17.677,
              "z": 1.804
            },
            "gtin": "3386460059121",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270705",
            "leftCorner": {
              "x": 13.079,
              "y": -17.677,
              "z": 1.804
            },
            "rightCorner": {
              "x": 13.075,
              "y": -17.733,
              "z": 1.804
            },
            "gtin": "3386460146036",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e756ecb5fe7bc0469598b6",
    "name": "68e756ecb5fe7bc0469598b6",
    "x": 13.161,
    "y": -17.763,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.731,
      "w": 0.68238
    },
    "statistics": {
      "hasStockCount": 82,
      "noStockCount": 0,
      "unknownStockCount": 13,
      "shelfCategory": "PARFUM"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd739aa",
        "height": 0.31086,
        "facings": [
          {
            "id": "696ebf6e43c343680a27075f",
            "leftCorner": {
              "x": 13.086,
              "y": -17.853,
              "z": 0.311
            },
            "rightCorner": {
              "x": 13.079,
              "y": -17.96,
              "z": 0.311
            },
            "gtin": "5901832069980",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27075e",
            "leftCorner": {
              "x": 13.09,
              "y": -17.798,
              "z": 0.311
            },
            "rightCorner": {
              "x": 13.086,
              "y": -17.853,
              "z": 0.311
            },
            "gtin": "5901832063094",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270760",
            "leftCorner": {
              "x": 13.079,
              "y": -17.96,
              "z": 0.311
            },
            "rightCorner": {
              "x": 13.073,
              "y": -18.045,
              "z": 0.311
            },
            "gtin": "5906735232592",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270761",
            "leftCorner": {
              "x": 13.073,
              "y": -18.045,
              "z": 0.311
            },
            "rightCorner": {
              "x": 13.066,
              "y": -18.138,
              "z": 0.311
            },
            "gtin": "5901832065265",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270762",
            "leftCorner": {
              "x": 13.066,
              "y": -18.138,
              "z": 0.311
            },
            "rightCorner": {
              "x": 13.06,
              "y": -18.224,
              "z": 0.311
            },
            "gtin": "5903719644358",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270763",
            "leftCorner": {
              "x": 13.06,
              "y": -18.224,
              "z": 0.311
            },
            "rightCorner": {
              "x": 13.055,
              "y": -18.309,
              "z": 0.311
            },
            "gtin": "5901832067139",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270764",
            "leftCorner": {
              "x": 13.055,
              "y": -18.309,
              "z": 0.311
            },
            "rightCorner": {
              "x": 13.048,
              "y": -18.401,
              "z": 0.311
            },
            "gtin": "5903719644136",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270765",
            "leftCorner": {
              "x": 13.048,
              "y": -18.401,
              "z": 0.311
            },
            "rightCorner": {
              "x": 13.042,
              "y": -18.484,
              "z": 0.311
            },
            "gtin": "5903719644822",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270766",
            "leftCorner": {
              "x": 13.042,
              "y": -18.484,
              "z": 0.311
            },
            "rightCorner": {
              "x": 13.037,
              "y": -18.569,
              "z": 0.311
            },
            "gtin": "5906735232011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270767",
            "leftCorner": {
              "x": 13.037,
              "y": -18.569,
              "z": 0.311
            },
            "rightCorner": {
              "x": 13.031,
              "y": -18.653,
              "z": 0.311
            },
            "gtin": "5903719644860",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270768",
            "leftCorner": {
              "x": 13.031,
              "y": -18.653,
              "z": 0.311
            },
            "rightCorner": {
              "x": 13.024,
              "y": -18.748,
              "z": 0.311
            },
            "gtin": "5901832067122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270769",
            "leftCorner": {
              "x": 13.024,
              "y": -18.748,
              "z": 0.311
            },
            "rightCorner": {
              "x": 13.018,
              "y": -18.843,
              "z": 0.311
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739a7",
        "height": 0.54581,
        "facings": [
          {
            "id": "696ebf6e43c343680a270791",
            "leftCorner": {
              "x": 13.087,
              "y": -17.749,
              "z": 0.546
            },
            "rightCorner": {
              "x": 13.082,
              "y": -17.82,
              "z": 0.546
            },
            "gtin": "5903719640909",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270792",
            "leftCorner": {
              "x": 13.082,
              "y": -17.82,
              "z": 0.546
            },
            "rightCorner": {
              "x": 13.077,
              "y": -17.882,
              "z": 0.546
            },
            "gtin": "5901832061182",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270793",
            "leftCorner": {
              "x": 13.077,
              "y": -17.882,
              "z": 0.546
            },
            "rightCorner": {
              "x": 13.073,
              "y": -17.949,
              "z": 0.546
            },
            "gtin": "5903719647045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270794",
            "leftCorner": {
              "x": 13.073,
              "y": -17.949,
              "z": 0.546
            },
            "rightCorner": {
              "x": 13.069,
              "y": -18.009,
              "z": 0.546
            },
            "gtin": "5903719643276",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270795",
            "leftCorner": {
              "x": 13.069,
              "y": -18.009,
              "z": 0.546
            },
            "rightCorner": {
              "x": 13.063,
              "y": -18.093,
              "z": 0.546
            },
            "gtin": "5903719643481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270796",
            "leftCorner": {
              "x": 13.063,
              "y": -18.093,
              "z": 0.546
            },
            "rightCorner": {
              "x": 13.058,
              "y": -18.17,
              "z": 0.546
            },
            "gtin": "5903719644730",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270797",
            "leftCorner": {
              "x": 13.058,
              "y": -18.17,
              "z": 0.546
            },
            "rightCorner": {
              "x": 13.053,
              "y": -18.237,
              "z": 0.546
            },
            "gtin": "5903719644969",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270798",
            "leftCorner": {
              "x": 13.053,
              "y": -18.237,
              "z": 0.546
            },
            "rightCorner": {
              "x": 13.049,
              "y": -18.299,
              "z": 0.546
            },
            "gtin": "5901832066071",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270799",
            "leftCorner": {
              "x": 13.049,
              "y": -18.299,
              "z": 0.546
            },
            "rightCorner": {
              "x": 13.045,
              "y": -18.359,
              "z": 0.546
            },
            "gtin": "5903719642682",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27079a",
            "leftCorner": {
              "x": 13.045,
              "y": -18.359,
              "z": 0.546
            },
            "rightCorner": {
              "x": 13.04,
              "y": -18.428,
              "z": 0.546
            },
            "gtin": "5903719642378",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27079b",
            "leftCorner": {
              "x": 13.04,
              "y": -18.428,
              "z": 0.546
            },
            "rightCorner": {
              "x": 13.035,
              "y": -18.5,
              "z": 0.546
            },
            "gtin": "5901832060130",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27079c",
            "leftCorner": {
              "x": 13.035,
              "y": -18.5,
              "z": 0.546
            },
            "rightCorner": {
              "x": 13.031,
              "y": -18.564,
              "z": 0.546
            },
            "gtin": "5901832068679",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27079d",
            "leftCorner": {
              "x": 13.031,
              "y": -18.564,
              "z": 0.546
            },
            "rightCorner": {
              "x": 13.027,
              "y": -18.62,
              "z": 0.546
            },
            "gtin": "5906735232066",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27079e",
            "leftCorner": {
              "x": 13.027,
              "y": -18.62,
              "z": 0.546
            },
            "rightCorner": {
              "x": 13.022,
              "y": -18.685,
              "z": 0.546
            },
            "gtin": "5901832060147",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27079f",
            "leftCorner": {
              "x": 13.022,
              "y": -18.685,
              "z": 0.546
            },
            "rightCorner": {
              "x": 13.017,
              "y": -18.755,
              "z": 0.546
            },
            "gtin": "5906735232028",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739a9",
        "height": 0.79852,
        "facings": [
          {
            "id": "696ebf6e43c343680a2707ca",
            "leftCorner": {
              "x": 13.086,
              "y": -17.73,
              "z": 0.795
            },
            "rightCorner": {
              "x": 13.084,
              "y": -17.76,
              "z": 0.795
            },
            "gtin": "4011700879236",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707cb",
            "leftCorner": {
              "x": 13.088,
              "y": -17.784,
              "z": 0.799
            },
            "rightCorner": {
              "x": 13.084,
              "y": -17.841,
              "z": 0.799
            },
            "gtin": "4011700896073",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707cc",
            "leftCorner": {
              "x": 13.084,
              "y": -17.841,
              "z": 0.799
            },
            "rightCorner": {
              "x": 13.081,
              "y": -17.893,
              "z": 0.799
            },
            "gtin": "4011700896073",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707cd",
            "leftCorner": {
              "x": 13.081,
              "y": -17.893,
              "z": 0.799
            },
            "rightCorner": {
              "x": 13.077,
              "y": -17.95,
              "z": 0.799
            },
            "gtin": "5050456008162",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707ce",
            "leftCorner": {
              "x": 13.077,
              "y": -17.95,
              "z": 0.799
            },
            "rightCorner": {
              "x": 13.073,
              "y": -18.007,
              "z": 0.799
            },
            "gtin": "5050456009442",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707cf",
            "leftCorner": {
              "x": 13.073,
              "y": -18.007,
              "z": 0.799
            },
            "rightCorner": {
              "x": 13.069,
              "y": -18.066,
              "z": 0.799
            },
            "gtin": "5050456009459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2707d0",
            "leftCorner": {
              "x": 13.069,
              "y": -18.066,
              "z": 0.799
            },
            "rightCorner": {
              "x": 13.065,
              "y": -18.124,
              "z": 0.799
            },
            "gtin": "5050456009435",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707d1",
            "leftCorner": {
              "x": 13.065,
              "y": -18.124,
              "z": 0.799
            },
            "rightCorner": {
              "x": 13.06,
              "y": -18.195,
              "z": 0.799
            },
            "gtin": "5050456007134",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707d2",
            "leftCorner": {
              "x": 13.06,
              "y": -18.195,
              "z": 0.799
            },
            "rightCorner": {
              "x": 13.054,
              "y": -18.28,
              "z": 0.799
            },
            "gtin": "5050456007165",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707d3",
            "leftCorner": {
              "x": 13.054,
              "y": -18.28,
              "z": 0.799
            },
            "rightCorner": {
              "x": 13.049,
              "y": -18.356,
              "z": 0.799
            },
            "gtin": "5050456007080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2707d4",
            "leftCorner": {
              "x": 13.049,
              "y": -18.356,
              "z": 0.799
            },
            "rightCorner": {
              "x": 13.043,
              "y": -18.445,
              "z": 0.799
            },
            "gtin": "9120130826040",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707d5",
            "leftCorner": {
              "x": 13.043,
              "y": -18.445,
              "z": 0.799
            },
            "rightCorner": {
              "x": 13.037,
              "y": -18.53,
              "z": 0.799
            },
            "gtin": "9120130826163",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707d6",
            "leftCorner": {
              "x": 13.037,
              "y": -18.53,
              "z": 0.799
            },
            "rightCorner": {
              "x": 13.031,
              "y": -18.614,
              "z": 0.799
            },
            "gtin": "9120130824619",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707d7",
            "leftCorner": {
              "x": 13.031,
              "y": -18.614,
              "z": 0.799
            },
            "rightCorner": {
              "x": 13.024,
              "y": -18.714,
              "z": 0.799
            },
            "gtin": "9120112229647",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707d8",
            "leftCorner": {
              "x": 13.024,
              "y": -18.714,
              "z": 0.799
            },
            "rightCorner": {
              "x": 13.017,
              "y": -18.822,
              "z": 0.799
            },
            "gtin": "9120112221443",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739a8",
        "height": 1.0509,
        "facings": [
          {
            "id": "696ebf6e43c343680a2707fc",
            "leftCorner": {
              "x": 13.087,
              "y": -17.713,
              "z": 1.048
            },
            "rightCorner": {
              "x": 13.084,
              "y": -17.754,
              "z": 1.048
            },
            "gtin": "085715322432",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707fd",
            "leftCorner": {
              "x": 13.085,
              "y": -17.778,
              "z": 1.051
            },
            "rightCorner": {
              "x": 13.081,
              "y": -17.84,
              "z": 1.051
            },
            "gtin": "085715331540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707fe",
            "leftCorner": {
              "x": 13.081,
              "y": -17.84,
              "z": 1.051
            },
            "rightCorner": {
              "x": 13.077,
              "y": -17.896,
              "z": 1.051
            },
            "gtin": "719346643870",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707ff",
            "leftCorner": {
              "x": 13.077,
              "y": -17.896,
              "z": 1.051
            },
            "rightCorner": {
              "x": 13.071,
              "y": -17.977,
              "z": 1.051
            },
            "gtin": "719346648837",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270800",
            "leftCorner": {
              "x": 13.071,
              "y": -17.977,
              "z": 1.051
            },
            "rightCorner": {
              "x": 13.065,
              "y": -18.06,
              "z": 1.051
            },
            "gtin": "719346235310",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270801",
            "leftCorner": {
              "x": 13.065,
              "y": -18.06,
              "z": 1.051
            },
            "rightCorner": {
              "x": 13.061,
              "y": -18.12,
              "z": 1.051
            },
            "gtin": "719346657334",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270802",
            "leftCorner": {
              "x": 13.061,
              "y": -18.12,
              "z": 1.051
            },
            "rightCorner": {
              "x": 13.057,
              "y": -18.176,
              "z": 1.051
            },
            "gtin": "3616305261472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270803",
            "leftCorner": {
              "x": 13.057,
              "y": -18.176,
              "z": 1.051
            },
            "rightCorner": {
              "x": 13.053,
              "y": -18.235,
              "z": 1.051
            },
            "gtin": "3616304077364",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270804",
            "leftCorner": {
              "x": 13.053,
              "y": -18.235,
              "z": 1.051
            },
            "rightCorner": {
              "x": 13.05,
              "y": -18.289,
              "z": 1.051
            },
            "gtin": "3616302039913",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270805",
            "leftCorner": {
              "x": 13.05,
              "y": -18.289,
              "z": 1.051
            },
            "rightCorner": {
              "x": 13.046,
              "y": -18.343,
              "z": 1.051
            },
            "gtin": "3616301641209",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270806",
            "leftCorner": {
              "x": 13.046,
              "y": -18.343,
              "z": 1.051
            },
            "rightCorner": {
              "x": 13.042,
              "y": -18.401,
              "z": 1.051
            },
            "gtin": "3616306131774",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270807",
            "leftCorner": {
              "x": 13.042,
              "y": -18.401,
              "z": 1.051
            },
            "rightCorner": {
              "x": 13.037,
              "y": -18.473,
              "z": 1.051
            },
            "gtin": "3616306395220",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270808",
            "leftCorner": {
              "x": 13.037,
              "y": -18.473,
              "z": 1.051
            },
            "rightCorner": {
              "x": 13.032,
              "y": -18.54,
              "z": 1.051
            },
            "gtin": "3616306395237",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270809",
            "leftCorner": {
              "x": 13.032,
              "y": -18.54,
              "z": 1.051
            },
            "rightCorner": {
              "x": 13.028,
              "y": -18.608,
              "z": 1.051
            },
            "gtin": "3616305806901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27080a",
            "leftCorner": {
              "x": 13.028,
              "y": -18.608,
              "z": 1.051
            },
            "rightCorner": {
              "x": 13.023,
              "y": -18.68,
              "z": 1.051
            },
            "gtin": "3616305261458",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27080b",
            "leftCorner": {
              "x": 13.023,
              "y": -18.68,
              "z": 1.051
            },
            "rightCorner": {
              "x": 13.018,
              "y": -18.755,
              "z": 1.051
            },
            "gtin": "3616305261465",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739a5",
        "height": 1.3041,
        "facings": [
          {
            "id": "696ebf6e43c343680a27082d",
            "leftCorner": {
              "x": 13.08,
              "y": -17.782,
              "z": 1.304
            },
            "rightCorner": {
              "x": 13.075,
              "y": -17.857,
              "z": 1.304
            },
            "gtin": "3616301641162",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27082e",
            "leftCorner": {
              "x": 13.075,
              "y": -17.857,
              "z": 1.304
            },
            "rightCorner": {
              "x": 13.07,
              "y": -17.926,
              "z": 1.304
            },
            "gtin": "3616305886668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27082f",
            "leftCorner": {
              "x": 13.07,
              "y": -17.926,
              "z": 1.304
            },
            "rightCorner": {
              "x": 13.065,
              "y": -18.001,
              "z": 1.304
            },
            "gtin": "3616305886675",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270830",
            "leftCorner": {
              "x": 13.065,
              "y": -18.001,
              "z": 1.304
            },
            "rightCorner": {
              "x": 13.06,
              "y": -18.077,
              "z": 1.304
            },
            "gtin": "3616301640769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270831",
            "leftCorner": {
              "x": 13.06,
              "y": -18.077,
              "z": 1.304
            },
            "rightCorner": {
              "x": 13.054,
              "y": -18.162,
              "z": 1.304
            },
            "gtin": "3616301640790",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270832",
            "leftCorner": {
              "x": 13.054,
              "y": -18.162,
              "z": 1.304
            },
            "rightCorner": {
              "x": 13.05,
              "y": -18.223,
              "z": 1.304
            },
            "gtin": "3616301640776",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270833",
            "leftCorner": {
              "x": 13.05,
              "y": -18.223,
              "z": 1.304
            },
            "rightCorner": {
              "x": 13.044,
              "y": -18.307,
              "z": 1.304
            },
            "gtin": "3616301640776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270834",
            "leftCorner": {
              "x": 13.044,
              "y": -18.307,
              "z": 1.304
            },
            "rightCorner": {
              "x": 13.038,
              "y": -18.388,
              "z": 1.304
            },
            "gtin": "3616301640745",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270835",
            "leftCorner": {
              "x": 13.038,
              "y": -18.388,
              "z": 1.304
            },
            "rightCorner": {
              "x": 13.033,
              "y": -18.474,
              "z": 1.304
            },
            "gtin": "3616301640783",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270836",
            "leftCorner": {
              "x": 13.033,
              "y": -18.474,
              "z": 1.304
            },
            "rightCorner": {
              "x": 13.028,
              "y": -18.545,
              "z": 1.304
            },
            "gtin": "3616305274779",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270837",
            "leftCorner": {
              "x": 13.028,
              "y": -18.545,
              "z": 1.304
            },
            "rightCorner": {
              "x": 13.023,
              "y": -18.614,
              "z": 1.304
            },
            "gtin": "3616305161222",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270838",
            "leftCorner": {
              "x": 13.023,
              "y": -18.614,
              "z": 1.304
            },
            "rightCorner": {
              "x": 13.018,
              "y": -18.685,
              "z": 1.304
            },
            "gtin": "3616305161239",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270839",
            "leftCorner": {
              "x": 13.018,
              "y": -18.685,
              "z": 1.304
            },
            "rightCorner": {
              "x": 12.982,
              "y": -19.215,
              "z": 1.304
            },
            "gtin": "3616305161246",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739a4",
        "height": 1.5567,
        "facings": [
          {
            "id": "696ebf6e43c343680a27072e",
            "leftCorner": {
              "x": 13.075,
              "y": -17.763,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.069,
              "y": -17.845,
              "z": 1.557
            },
            "gtin": "4011700603183",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27072f",
            "leftCorner": {
              "x": 13.069,
              "y": -17.845,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.064,
              "y": -17.925,
              "z": 1.557
            },
            "gtin": "4011700603268",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270730",
            "leftCorner": {
              "x": 13.064,
              "y": -17.925,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.058,
              "y": -18.004,
              "z": 1.557
            },
            "gtin": "4051395182112",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270731",
            "leftCorner": {
              "x": 13.058,
              "y": -18.004,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.052,
              "y": -18.091,
              "z": 1.557
            },
            "gtin": "4011700603022",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270732",
            "leftCorner": {
              "x": 13.052,
              "y": -18.091,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.047,
              "y": -18.167,
              "z": 1.557
            },
            "gtin": "4051395172144",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270733",
            "leftCorner": {
              "x": 13.047,
              "y": -18.167,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.04,
              "y": -18.272,
              "z": 1.557
            },
            "gtin": "4051395413186",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270734",
            "leftCorner": {
              "x": 13.04,
              "y": -18.272,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.033,
              "y": -18.368,
              "z": 1.557
            },
            "gtin": "4051395413179",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270735",
            "leftCorner": {
              "x": 13.033,
              "y": -18.368,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.028,
              "y": -18.436,
              "z": 1.557
            },
            "gtin": "4051395414169",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270736",
            "leftCorner": {
              "x": 13.028,
              "y": -18.436,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.024,
              "y": -18.498,
              "z": 1.557
            },
            "gtin": "4051395414183",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270737",
            "leftCorner": {
              "x": 13.024,
              "y": -18.498,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.019,
              "y": -18.568,
              "z": 1.557
            },
            "gtin": "4051395412165",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270738",
            "leftCorner": {
              "x": 13.019,
              "y": -18.568,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.015,
              "y": -18.633,
              "z": 1.557
            },
            "gtin": "4051395412196",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270739",
            "leftCorner": {
              "x": 13.015,
              "y": -18.633,
              "z": 1.557
            },
            "rightCorner": {
              "x": 13.01,
              "y": -18.698,
              "z": 1.557
            },
            "gtin": "4051395412189",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27073a",
            "leftCorner": {
              "x": 13.01,
              "y": -18.698,
              "z": 1.557
            },
            "rightCorner": {
              "x": 12.973,
              "y": -19.244,
              "z": 1.557
            },
            "gtin": "4051395412172",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739a6",
        "height": 1.8064,
        "facings": [
          {
            "id": "696ebf6e43c343680a270706",
            "leftCorner": {
              "x": 13.069,
              "y": -17.757,
              "z": 1.806
            },
            "rightCorner": {
              "x": 13.065,
              "y": -17.803,
              "z": 1.806
            },
            "gtin": "7640496670115",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270707",
            "leftCorner": {
              "x": 13.065,
              "y": -17.803,
              "z": 1.806
            },
            "rightCorner": {
              "x": 13.061,
              "y": -17.861,
              "z": 1.806
            },
            "gtin": "4051395451126",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270708",
            "leftCorner": {
              "x": 13.061,
              "y": -17.861,
              "z": 1.806
            },
            "rightCorner": {
              "x": 13.055,
              "y": -17.95,
              "z": 1.806
            },
            "gtin": "4051395491160",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270709",
            "leftCorner": {
              "x": 13.055,
              "y": -17.95,
              "z": 1.806
            },
            "rightCorner": {
              "x": 13.05,
              "y": -18.027,
              "z": 1.806
            },
            "gtin": "4051395421167",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27070a",
            "leftCorner": {
              "x": 13.05,
              "y": -18.027,
              "z": 1.806
            },
            "rightCorner": {
              "x": 13.044,
              "y": -18.115,
              "z": 1.806
            },
            "gtin": "4051395431135",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27070b",
            "leftCorner": {
              "x": 13.044,
              "y": -18.115,
              "z": 1.806
            },
            "rightCorner": {
              "x": 13.037,
              "y": -18.211,
              "z": 1.806
            },
            "gtin": "4051395415159",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27070c",
            "leftCorner": {
              "x": 13.037,
              "y": -18.211,
              "z": 1.806
            },
            "rightCorner": {
              "x": 13.03,
              "y": -18.311,
              "z": 1.806
            },
            "gtin": "4051395415166",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27070d",
            "leftCorner": {
              "x": 13.03,
              "y": -18.311,
              "z": 1.806
            },
            "rightCorner": {
              "x": 13.024,
              "y": -18.409,
              "z": 1.806
            },
            "gtin": "4051395402180",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27070e",
            "leftCorner": {
              "x": 13.024,
              "y": -18.409,
              "z": 1.806
            },
            "rightCorner": {
              "x": 13.016,
              "y": -18.518,
              "z": 1.806
            },
            "gtin": "4051395402142",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27070f",
            "leftCorner": {
              "x": 13.016,
              "y": -18.518,
              "z": 1.806
            },
            "rightCorner": {
              "x": 13.009,
              "y": -18.615,
              "z": 1.806
            },
            "gtin": "4051395402135",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270710",
            "leftCorner": {
              "x": 13.009,
              "y": -18.615,
              "z": 1.806
            },
            "rightCorner": {
              "x": 13.004,
              "y": -18.691,
              "z": 1.806
            },
            "gtin": "3414202000510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270711",
            "leftCorner": {
              "x": 13.001,
              "y": -18.669,
              "z": 1.806
            },
            "rightCorner": {
              "x": 12.996,
              "y": -18.742,
              "z": 1.806
            },
            "gtin": "3414202000510",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e756ecb5fe7bc0469598b7",
    "name": "68e756ecb5fe7bc0469598b7",
    "x": 13.089,
    "y": -18.738,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72983,
      "w": 0.68363
    },
    "statistics": {
      "hasStockCount": 23,
      "noStockCount": 0,
      "unknownStockCount": 11
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73c0c",
        "height": 0.31062,
        "facings": [
          {
            "id": "696ebf6e43c343680a27076a",
            "leftCorner": {
              "x": 13.011,
              "y": -18.821,
              "z": 0.311
            },
            "rightCorner": {
              "x": 13.009,
              "y": -18.851,
              "z": 0.311
            },
            "gtin": "5906735232493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27076b",
            "leftCorner": {
              "x": 13.009,
              "y": -18.851,
              "z": 0.311
            },
            "rightCorner": {
              "x": 13.005,
              "y": -18.908,
              "z": 0.311
            },
            "gtin": "5906735232493",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27076c",
            "leftCorner": {
              "x": 13.005,
              "y": -18.908,
              "z": 0.311
            },
            "rightCorner": {
              "x": 13.0,
              "y": -18.999,
              "z": 0.311
            },
            "gtin": "5906735234411",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27076d",
            "leftCorner": {
              "x": 13.0,
              "y": -18.999,
              "z": 0.311
            },
            "rightCorner": {
              "x": 12.994,
              "y": -19.09,
              "z": 0.311
            },
            "gtin": "5906735234053",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27076e",
            "leftCorner": {
              "x": 12.994,
              "y": -19.09,
              "z": 0.311
            },
            "rightCorner": {
              "x": 12.988,
              "y": -19.174,
              "z": 0.311
            },
            "gtin": "5906735234060",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27076f",
            "leftCorner": {
              "x": 12.988,
              "y": -19.174,
              "z": 0.311
            },
            "rightCorner": {
              "x": 12.983,
              "y": -19.247,
              "z": 0.311
            },
            "gtin": "5901832065272",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270770",
            "leftCorner": {
              "x": 12.983,
              "y": -19.247,
              "z": 0.311
            },
            "rightCorner": {
              "x": 12.978,
              "y": -19.322,
              "z": 0.311
            }
          },
          {
            "id": "696ebf6e43c343680a270771",
            "leftCorner": {
              "x": 12.978,
              "y": -19.322,
              "z": 0.311
            },
            "rightCorner": {
              "x": 12.976,
              "y": -19.359,
              "z": 0.311
            }
          },
          {
            "id": "696ebf6e43c343680a270772",
            "leftCorner": {
              "x": 12.976,
              "y": -19.359,
              "z": 0.311
            },
            "rightCorner": {
              "x": 12.973,
              "y": -19.399,
              "z": 0.311
            }
          },
          {
            "id": "696ebf6e43c343680a270740",
            "leftCorner": {
              "x": 12.973,
              "y": -19.399,
              "z": 0.311
            },
            "rightCorner": {
              "x": 12.952,
              "y": -19.731,
              "z": 0.311
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c0b",
        "height": 0.54585,
        "facings": [
          {
            "id": "696ebf6e43c343680a2707a0",
            "leftCorner": {
              "x": 13.015,
              "y": -18.733,
              "z": 0.546
            },
            "rightCorner": {
              "x": 13.005,
              "y": -18.868,
              "z": 0.546
            },
            "gtin": "5903719644921",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707a1",
            "leftCorner": {
              "x": 13.006,
              "y": -18.868,
              "z": 0.546
            },
            "rightCorner": {
              "x": 13.003,
              "y": -18.91,
              "z": 0.546
            },
            "gtin": "5903719640916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2707a2",
            "leftCorner": {
              "x": 13.003,
              "y": -18.91,
              "z": 0.546
            },
            "rightCorner": {
              "x": 12.999,
              "y": -18.968,
              "z": 0.546
            },
            "gtin": "5903719640916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2707a3",
            "leftCorner": {
              "x": 12.999,
              "y": -18.968,
              "z": 0.546
            },
            "rightCorner": {
              "x": 12.997,
              "y": -19.007,
              "z": 0.546
            },
            "gtin": "5901832060154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707a4",
            "leftCorner": {
              "x": 12.997,
              "y": -19.007,
              "z": 0.546
            },
            "rightCorner": {
              "x": 12.993,
              "y": -19.06,
              "z": 0.546
            },
            "gtin": "5901832060154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707a5",
            "leftCorner": {
              "x": 12.993,
              "y": -19.06,
              "z": 0.546
            },
            "rightCorner": {
              "x": 12.987,
              "y": -19.155,
              "z": 0.546
            },
            "gtin": "5903719643474",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707a6",
            "leftCorner": {
              "x": 12.987,
              "y": -19.155,
              "z": 0.546
            },
            "rightCorner": {
              "x": 12.979,
              "y": -19.283,
              "z": 0.546
            },
            "gtin": "5901832063223",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707a7",
            "leftCorner": {
              "x": 12.979,
              "y": -19.283,
              "z": 0.546
            },
            "rightCorner": {
              "x": 12.977,
              "y": -19.31,
              "z": 0.546
            }
          },
          {
            "id": "696ebf6e43c343680a2707a8",
            "leftCorner": {
              "x": 12.977,
              "y": -19.31,
              "z": 0.546
            },
            "rightCorner": {
              "x": 12.973,
              "y": -19.373,
              "z": 0.546
            }
          },
          {
            "id": "696ebf6e43c343680a2707a9",
            "leftCorner": {
              "x": 12.973,
              "y": -19.373,
              "z": 0.546
            },
            "rightCorner": {
              "x": 12.97,
              "y": -19.416,
              "z": 0.546
            }
          },
          {
            "id": "696ebf6e43c343680a270774",
            "leftCorner": {
              "x": 12.97,
              "y": -19.416,
              "z": 0.546
            },
            "rightCorner": {
              "x": 12.949,
              "y": -19.731,
              "z": 0.546
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c0d",
        "height": 0.79838,
        "facings": [
          {
            "id": "696ebf6e43c343680a2707d9",
            "leftCorner": {
              "x": 13.01,
              "y": -18.8,
              "z": 0.798
            },
            "rightCorner": {
              "x": 13.005,
              "y": -18.879,
              "z": 0.798
            },
            "gtin": "9120130821366",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707da",
            "leftCorner": {
              "x": 13.005,
              "y": -18.879,
              "z": 0.798
            },
            "rightCorner": {
              "x": 13.003,
              "y": -18.914,
              "z": 0.798
            },
            "gtin": "9120112224031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2707db",
            "leftCorner": {
              "x": 13.003,
              "y": -18.914,
              "z": 0.798
            },
            "rightCorner": {
              "x": 12.995,
              "y": -19.035,
              "z": 0.798
            },
            "gtin": "9120112221528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2707dc",
            "leftCorner": {
              "x": 12.995,
              "y": -19.035,
              "z": 0.798
            },
            "rightCorner": {
              "x": 12.982,
              "y": -19.233,
              "z": 0.798
            },
            "gtin": "4008268043841",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707dd",
            "leftCorner": {
              "x": 12.982,
              "y": -19.233,
              "z": 0.798
            },
            "rightCorner": {
              "x": 12.975,
              "y": -19.335,
              "z": 0.798
            },
            "gtin": "3326240006099",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707de",
            "leftCorner": {
              "x": 12.975,
              "y": -19.335,
              "z": 0.798
            },
            "rightCorner": {
              "x": 12.973,
              "y": -19.37,
              "z": 0.798
            }
          },
          {
            "id": "696ebf6e43c343680a2707ab",
            "leftCorner": {
              "x": 12.973,
              "y": -19.37,
              "z": 0.798
            },
            "rightCorner": {
              "x": 12.949,
              "y": -19.731,
              "z": 0.798
            },
            "gtin": "3326240006099",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c0a",
        "height": 1.0508,
        "facings": [
          {
            "id": "696ebf6e43c343680a27080c",
            "leftCorner": {
              "x": 13.014,
              "y": -18.733,
              "z": 1.051
            },
            "rightCorner": {
              "x": 13.007,
              "y": -18.833,
              "z": 1.051
            },
            "gtin": "3616305053213",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27080d",
            "leftCorner": {
              "x": 13.008,
              "y": -18.833,
              "z": 1.051
            },
            "rightCorner": {
              "x": 13.001,
              "y": -18.937,
              "z": 1.051
            },
            "gtin": "3616301640868",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27080e",
            "leftCorner": {
              "x": 13.001,
              "y": -18.937,
              "z": 1.051
            },
            "rightCorner": {
              "x": 12.999,
              "y": -18.972,
              "z": 1.051
            },
            "gtin": "3616301640813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27080f",
            "leftCorner": {
              "x": 12.999,
              "y": -18.972,
              "z": 1.051
            },
            "rightCorner": {
              "x": 12.994,
              "y": -19.045,
              "z": 1.051
            },
            "gtin": "3616305169044",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270810",
            "leftCorner": {
              "x": 12.994,
              "y": -19.045,
              "z": 1.051
            },
            "rightCorner": {
              "x": 12.984,
              "y": -19.193,
              "z": 1.051
            },
            "gtin": "3616305169488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270811",
            "leftCorner": {
              "x": 12.984,
              "y": -19.193,
              "z": 1.051
            },
            "rightCorner": {
              "x": 12.98,
              "y": -19.259,
              "z": 1.051
            },
            "gtin": "4058172926105",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270812",
            "leftCorner": {
              "x": 12.98,
              "y": -19.259,
              "z": 1.051
            },
            "rightCorner": {
              "x": 12.977,
              "y": -19.303,
              "z": 1.051
            },
            "gtin": "4058172926082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270813",
            "leftCorner": {
              "x": 12.977,
              "y": -19.303,
              "z": 1.051
            },
            "rightCorner": {
              "x": 12.969,
              "y": -19.425,
              "z": 1.051
            },
            "gtin": "4058172926082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2707e0",
            "leftCorner": {
              "x": 12.969,
              "y": -19.425,
              "z": 1.051
            },
            "rightCorner": {
              "x": 12.949,
              "y": -19.731,
              "z": 1.051
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c10",
        "height": 1.3038,
        "facings": [
          {
            "id": "696ebf6e43c343680a27083a",
            "leftCorner": {
              "x": 12.978,
              "y": -19.192,
              "z": 1.304
            },
            "rightCorner": {
              "x": 12.975,
              "y": -19.228,
              "z": 1.304
            }
          },
          {
            "id": "696ebf6e43c343680a27083b",
            "leftCorner": {
              "x": 12.975,
              "y": -19.228,
              "z": 1.304
            },
            "rightCorner": {
              "x": 12.968,
              "y": -19.343,
              "z": 1.304
            },
            "gtin": "4011700885015",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270815",
            "leftCorner": {
              "x": 12.968,
              "y": -19.343,
              "z": 1.304
            },
            "rightCorner": {
              "x": 12.943,
              "y": -19.73,
              "z": 1.304
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c0f",
        "height": 1.5548,
        "facings": [
          {
            "id": "696ebf6e43c343680a27073b",
            "leftCorner": {
              "x": 12.977,
              "y": -19.222,
              "z": 1.555
            },
            "rightCorner": {
              "x": 12.975,
              "y": -19.25,
              "z": 1.555
            }
          },
          {
            "id": "696ebf6e43c343680a27073c",
            "leftCorner": {
              "x": 12.975,
              "y": -19.25,
              "z": 1.555
            },
            "rightCorner": {
              "x": 12.972,
              "y": -19.307,
              "z": 1.555
            },
            "gtin": "4011700852291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27073d",
            "leftCorner": {
              "x": 12.972,
              "y": -19.307,
              "z": 1.555
            },
            "rightCorner": {
              "x": 12.969,
              "y": -19.341,
              "z": 1.555
            },
            "gtin": "4011700852291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27073e",
            "leftCorner": {
              "x": 12.969,
              "y": -19.341,
              "z": 1.555
            },
            "rightCorner": {
              "x": 12.965,
              "y": -19.414,
              "z": 1.555
            }
          },
          {
            "id": "696ebf6e43c343680a270718",
            "leftCorner": {
              "x": 12.965,
              "y": -19.414,
              "z": 1.555
            },
            "rightCorner": {
              "x": 12.944,
              "y": -19.73,
              "z": 1.555
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c09",
        "height": 1.8063,
        "facings": [
          {
            "id": "696ebf6e43c343680a270712",
            "leftCorner": {
              "x": 12.997,
              "y": -18.742,
              "z": 1.806
            },
            "rightCorner": {
              "x": 12.99,
              "y": -18.841,
              "z": 1.806
            },
            "gtin": "3414206000592",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270713",
            "leftCorner": {
              "x": 12.99,
              "y": -18.841,
              "z": 1.806
            },
            "rightCorner": {
              "x": 12.978,
              "y": -19.021,
              "z": 1.806
            },
            "gtin": "4250081229791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270714",
            "leftCorner": {
              "x": 12.978,
              "y": -19.021,
              "z": 1.806
            },
            "rightCorner": {
              "x": 12.969,
              "y": -19.165,
              "z": 1.806
            },
            "gtin": "7640171193366",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270715",
            "leftCorner": {
              "x": 12.969,
              "y": -19.165,
              "z": 1.806
            },
            "rightCorner": {
              "x": 12.961,
              "y": -19.281,
              "z": 1.806
            },
            "gtin": "3562700373145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270716",
            "leftCorner": {
              "x": 12.961,
              "y": -19.281,
              "z": 1.806
            },
            "rightCorner": {
              "x": 12.958,
              "y": -19.331,
              "z": 1.806
            }
          },
          {
            "id": "696ebf6e43c343680a2706eb",
            "leftCorner": {
              "x": 12.958,
              "y": -19.331,
              "z": 1.806
            },
            "rightCorner": {
              "x": 12.932,
              "y": -19.73,
              "z": 1.806
            }
          }
        ]
      }
    ]
  },
  {
    "id": "68e75706b5fe7bc0469598de",
    "name": "68e75706b5fe7bc0469598de",
    "x": 2.8036,
    "y": -12.439,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.34136,
      "w": 0.93993
    },
    "statistics": {
      "hasStockCount": 6,
      "noStockCount": 1,
      "unknownStockCount": 21
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd739c1",
        "height": 0.18169,
        "facings": [
          {
            "id": "696ebf6e43c343680a2708fc",
            "leftCorner": {
              "x": 2.775,
              "y": -12.473,
              "z": 0.182
            },
            "rightCorner": {
              "x": 2.877,
              "y": -12.559,
              "z": 0.182
            },
            "gtin": "4066447513134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708fe",
            "leftCorner": {
              "x": 2.877,
              "y": -12.559,
              "z": 0.182
            },
            "rightCorner": {
              "x": 2.983,
              "y": -12.648,
              "z": 0.182
            },
            "gtin": "4066447325485",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708ff",
            "leftCorner": {
              "x": 2.983,
              "y": -12.648,
              "z": 0.182
            },
            "rightCorner": {
              "x": 3.009,
              "y": -12.669,
              "z": 0.182
            },
            "gtin": "4066447325485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270900",
            "leftCorner": {
              "x": 3.009,
              "y": -12.669,
              "z": 0.182
            },
            "rightCorner": {
              "x": 3.093,
              "y": -12.74,
              "z": 0.182
            },
            "gtin": "4067796161168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270901",
            "leftCorner": {
              "x": 3.093,
              "y": -12.74,
              "z": 0.182
            },
            "rightCorner": {
              "x": 3.239,
              "y": -12.862,
              "z": 0.182
            },
            "gtin": "4066447325546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270902",
            "leftCorner": {
              "x": 3.239,
              "y": -12.862,
              "z": 0.182
            },
            "rightCorner": {
              "x": 3.514,
              "y": -13.092,
              "z": 0.182
            },
            "gtin": "4008339158214",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739bf",
        "height": 0.48919,
        "facings": [
          {
            "id": "696ebf6e43c343680a2708df",
            "leftCorner": {
              "x": 2.863,
              "y": -12.409,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.998,
              "y": -12.523,
              "z": 0.489
            },
            "gtin": "4066447414493",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708e0",
            "leftCorner": {
              "x": 2.998,
              "y": -12.523,
              "z": 0.489
            },
            "rightCorner": {
              "x": 3.026,
              "y": -12.546,
              "z": 0.489
            }
          },
          {
            "id": "696ebf6e43c343680a2708e1",
            "leftCorner": {
              "x": 3.026,
              "y": -12.546,
              "z": 0.489
            },
            "rightCorner": {
              "x": 3.124,
              "y": -12.628,
              "z": 0.489
            },
            "gtin": "4066447414523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708e2",
            "leftCorner": {
              "x": 3.124,
              "y": -12.628,
              "z": 0.489
            },
            "rightCorner": {
              "x": 3.264,
              "y": -12.745,
              "z": 0.489
            },
            "gtin": "4066447887556",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708e3",
            "leftCorner": {
              "x": 3.264,
              "y": -12.745,
              "z": 0.489
            },
            "rightCorner": {
              "x": 3.4,
              "y": -12.859,
              "z": 0.489
            },
            "gtin": "4066447887587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708e4",
            "leftCorner": {
              "x": 3.4,
              "y": -12.859,
              "z": 0.489
            },
            "rightCorner": {
              "x": 3.61,
              "y": -13.034,
              "z": 0.489
            },
            "gtin": "4066447457100",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739c2",
        "height": 0.77881,
        "facings": [
          {
            "id": "696ebf6e43c343680a270908",
            "leftCorner": {
              "x": 2.847,
              "y": -12.387,
              "z": 0.779
            },
            "rightCorner": {
              "x": 2.951,
              "y": -12.474,
              "z": 0.779
            },
            "gtin": "4067796180381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27090a",
            "leftCorner": {
              "x": 2.951,
              "y": -12.474,
              "z": 0.779
            },
            "rightCorner": {
              "x": 2.972,
              "y": -12.491,
              "z": 0.779
            }
          },
          {
            "id": "696ebf6e43c343680a27090b",
            "leftCorner": {
              "x": 2.972,
              "y": -12.491,
              "z": 0.779
            },
            "rightCorner": {
              "x": 3.081,
              "y": -12.582,
              "z": 0.779
            },
            "gtin": "4066447414349",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27090c",
            "leftCorner": {
              "x": 3.081,
              "y": -12.582,
              "z": 0.779
            },
            "rightCorner": {
              "x": 3.208,
              "y": -12.688,
              "z": 0.779
            },
            "gtin": "4066447678499",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27090d",
            "leftCorner": {
              "x": 3.208,
              "y": -12.688,
              "z": 0.779
            },
            "rightCorner": {
              "x": 3.319,
              "y": -12.781,
              "z": 0.779
            },
            "gtin": "4066447414370",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27090e",
            "leftCorner": {
              "x": 3.319,
              "y": -12.781,
              "z": 0.779
            },
            "rightCorner": {
              "x": 3.344,
              "y": -12.803,
              "z": 0.779
            }
          },
          {
            "id": "696ebf6e43c343680a27090f",
            "leftCorner": {
              "x": 3.344,
              "y": -12.803,
              "z": 0.779
            },
            "rightCorner": {
              "x": 3.472,
              "y": -12.91,
              "z": 0.779
            },
            "gtin": "4066447887464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270909",
            "leftCorner": {
              "x": 3.472,
              "y": -12.91,
              "z": 0.779
            },
            "rightCorner": {
              "x": 3.614,
              "y": -13.029,
              "z": 0.779
            },
            "gtin": "4066447414462",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739c0",
        "height": 1.1881,
        "facings": [
          {
            "id": "696ebf6e43c343680a2708ef",
            "leftCorner": {
              "x": 2.795,
              "y": -12.449,
              "z": 1.188
            },
            "rightCorner": {
              "x": 2.865,
              "y": -12.508,
              "z": 1.188
            },
            "gtin": "4066447402346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708f0",
            "leftCorner": {
              "x": 2.865,
              "y": -12.508,
              "z": 1.188
            },
            "rightCorner": {
              "x": 3.303,
              "y": -12.874,
              "z": 1.188
            },
            "gtin": "4066447272871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708f1",
            "leftCorner": {
              "x": 3.303,
              "y": -12.874,
              "z": 1.188
            },
            "rightCorner": {
              "x": 3.424,
              "y": -12.975,
              "z": 1.188
            },
            "gtin": "4066447513103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708f2",
            "leftCorner": {
              "x": 3.417,
              "y": -12.967,
              "z": 1.191
            },
            "rightCorner": {
              "x": 3.496,
              "y": -13.033,
              "z": 1.191
            },
            "gtin": "4067796161076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708f3",
            "leftCorner": {
              "x": 3.495,
              "y": -13.034,
              "z": 1.191
            },
            "rightCorner": {
              "x": 3.557,
              "y": -13.085,
              "z": 1.191
            },
            "gtin": "4066447121285",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739be",
        "height": 1.5287,
        "facings": [
          {
            "id": "696ebf6e43c343680a2708db",
            "leftCorner": {
              "x": 2.793,
              "y": -12.452,
              "z": 1.529
            },
            "rightCorner": {
              "x": 2.866,
              "y": -12.513,
              "z": 1.529
            },
            "gtin": "4066447197419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708dd",
            "leftCorner": {
              "x": 2.866,
              "y": -12.513,
              "z": 1.529
            },
            "rightCorner": {
              "x": 2.905,
              "y": -12.545,
              "z": 1.529
            },
            "gtin": "4066447402018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708de",
            "leftCorner": {
              "x": 2.905,
              "y": -12.545,
              "z": 1.529
            },
            "rightCorner": {
              "x": 3.041,
              "y": -12.659,
              "z": 1.529
            },
            "gtin": "4066447197921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708dc",
            "leftCorner": {
              "x": 3.041,
              "y": -12.659,
              "z": 1.529
            },
            "rightCorner": {
              "x": 3.56,
              "y": -13.093,
              "z": 1.529
            },
            "gtin": "4066447272789",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739bd",
        "height": 1.7732,
        "facings": [
          {
            "id": "696ebf6e43c343680a2708d9",
            "leftCorner": {
              "x": 2.794,
              "y": -12.451,
              "z": 1.773
            },
            "rightCorner": {
              "x": 3.058,
              "y": -12.672,
              "z": 1.773
            },
            "gtin": "4066447513073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708da",
            "leftCorner": {
              "x": 3.058,
              "y": -12.672,
              "z": 1.773
            },
            "rightCorner": {
              "x": 3.561,
              "y": -13.092,
              "z": 1.773
            },
            "gtin": "4066447411539",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e75706b5fe7bc0469598df",
    "name": "68e75706b5fe7bc0469598df",
    "x": 3.559,
    "y": -13.079,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.34629,
      "w": 0.93813
    },
    "statistics": {
      "hasStockCount": 22,
      "noStockCount": 0,
      "unknownStockCount": 29
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd739c6",
        "height": 0.17737,
        "facings": [
          {
            "id": "696ebf6e43c343680a270903",
            "leftCorner": {
              "x": 3.514,
              "y": -13.092,
              "z": 0.182
            },
            "rightCorner": {
              "x": 3.837,
              "y": -13.362,
              "z": 0.182
            },
            "gtin": "4067796146196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270904",
            "leftCorner": {
              "x": 3.823,
              "y": -13.362,
              "z": 0.177
            },
            "rightCorner": {
              "x": 3.892,
              "y": -13.421,
              "z": 0.177
            },
            "gtin": "4066447499681",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270905",
            "leftCorner": {
              "x": 3.892,
              "y": -13.421,
              "z": 0.177
            },
            "rightCorner": {
              "x": 4.032,
              "y": -13.54,
              "z": 0.177
            },
            "gtin": "4014531690919",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270906",
            "leftCorner": {
              "x": 4.032,
              "y": -13.54,
              "z": 0.177
            },
            "rightCorner": {
              "x": 4.054,
              "y": -13.559,
              "z": 0.177
            }
          },
          {
            "id": "696ebf6e43c343680a270907",
            "leftCorner": {
              "x": 4.054,
              "y": -13.559,
              "z": 0.177
            },
            "rightCorner": {
              "x": 4.215,
              "y": -13.697,
              "z": 0.177
            },
            "gtin": "4066447267181",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708fd",
            "leftCorner": {
              "x": 4.215,
              "y": -13.697,
              "z": 0.177
            },
            "rightCorner": {
              "x": 4.291,
              "y": -13.762,
              "z": 0.177
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739c5",
        "height": 0.48137,
        "facings": [
          {
            "id": "696ebf6e43c343680a2708e5",
            "leftCorner": {
              "x": 3.531,
              "y": -13.111,
              "z": 0.481
            },
            "rightCorner": {
              "x": 3.605,
              "y": -13.173,
              "z": 0.481
            },
            "gtin": "4066447400267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708e6",
            "leftCorner": {
              "x": 3.605,
              "y": -13.174,
              "z": 0.481
            },
            "rightCorner": {
              "x": 3.663,
              "y": -13.224,
              "z": 0.481
            },
            "gtin": "4066447402100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708e7",
            "leftCorner": {
              "x": 3.663,
              "y": -13.224,
              "z": 0.481
            },
            "rightCorner": {
              "x": 3.735,
              "y": -13.285,
              "z": 0.481
            },
            "gtin": "4014531690070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708e8",
            "leftCorner": {
              "x": 3.735,
              "y": -13.285,
              "z": 0.481
            },
            "rightCorner": {
              "x": 3.811,
              "y": -13.35,
              "z": 0.481
            },
            "gtin": "4014531012230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708e9",
            "leftCorner": {
              "x": 3.811,
              "y": -13.35,
              "z": 0.481
            },
            "rightCorner": {
              "x": 3.912,
              "y": -13.436,
              "z": 0.481
            },
            "gtin": "8711603455990",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708ea",
            "leftCorner": {
              "x": 3.912,
              "y": -13.436,
              "z": 0.481
            },
            "rightCorner": {
              "x": 4.037,
              "y": -13.543,
              "z": 0.481
            },
            "gtin": "4066447619348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708eb",
            "leftCorner": {
              "x": 4.037,
              "y": -13.543,
              "z": 0.481
            },
            "rightCorner": {
              "x": 4.056,
              "y": -13.56,
              "z": 0.481
            }
          },
          {
            "id": "696ebf6e43c343680a2708ec",
            "leftCorner": {
              "x": 4.056,
              "y": -13.56,
              "z": 0.481
            },
            "rightCorner": {
              "x": 4.16,
              "y": -13.649,
              "z": 0.481
            },
            "gtin": "4014531011066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708ed",
            "leftCorner": {
              "x": 4.16,
              "y": -13.649,
              "z": 0.481
            },
            "rightCorner": {
              "x": 4.222,
              "y": -13.702,
              "z": 0.481
            },
            "gtin": "4066447913040",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708ee",
            "leftCorner": {
              "x": 4.222,
              "y": -13.702,
              "z": 0.481
            },
            "rightCorner": {
              "x": 4.281,
              "y": -13.752,
              "z": 0.481
            },
            "gtin": "4066447913101",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739c4",
        "height": 0.72375,
        "facings": [
          {
            "id": "696ebf6e43c343680a270920",
            "leftCorner": {
              "x": 3.558,
              "y": -13.08,
              "z": 0.724
            },
            "rightCorner": {
              "x": 3.651,
              "y": -13.16,
              "z": 0.724
            },
            "gtin": "4066447695427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270922",
            "leftCorner": {
              "x": 3.651,
              "y": -13.16,
              "z": 0.724
            },
            "rightCorner": {
              "x": 3.712,
              "y": -13.212,
              "z": 0.724
            },
            "gtin": "4066447272932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270923",
            "leftCorner": {
              "x": 3.712,
              "y": -13.212,
              "z": 0.724
            },
            "rightCorner": {
              "x": 3.767,
              "y": -13.259,
              "z": 0.724
            },
            "gtin": "4066447273083",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270924",
            "leftCorner": {
              "x": 3.767,
              "y": -13.259,
              "z": 0.724
            },
            "rightCorner": {
              "x": 3.817,
              "y": -13.302,
              "z": 0.724
            },
            "gtin": "4066447695489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270925",
            "leftCorner": {
              "x": 3.817,
              "y": -13.302,
              "z": 0.724
            },
            "rightCorner": {
              "x": 3.888,
              "y": -13.362,
              "z": 0.724
            },
            "gtin": "4066447619010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270926",
            "leftCorner": {
              "x": 3.888,
              "y": -13.362,
              "z": 0.724
            },
            "rightCorner": {
              "x": 3.95,
              "y": -13.415,
              "z": 0.724
            },
            "gtin": "4066447325706",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270927",
            "leftCorner": {
              "x": 3.95,
              "y": -13.415,
              "z": 0.724
            },
            "rightCorner": {
              "x": 4.008,
              "y": -13.465,
              "z": 0.724
            },
            "gtin": "4014531681696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270928",
            "leftCorner": {
              "x": 4.008,
              "y": -13.465,
              "z": 0.724
            },
            "rightCorner": {
              "x": 4.027,
              "y": -13.482,
              "z": 0.724
            },
            "gtin": "4066447399578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270929",
            "leftCorner": {
              "x": 4.027,
              "y": -13.482,
              "z": 0.724
            },
            "rightCorner": {
              "x": 4.057,
              "y": -13.507,
              "z": 0.724
            },
            "gtin": "4066447399578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27092a",
            "leftCorner": {
              "x": 4.057,
              "y": -13.507,
              "z": 0.724
            },
            "rightCorner": {
              "x": 4.08,
              "y": -13.527,
              "z": 0.724
            }
          },
          {
            "id": "696ebf6e43c343680a27092b",
            "leftCorner": {
              "x": 4.08,
              "y": -13.527,
              "z": 0.724
            },
            "rightCorner": {
              "x": 4.143,
              "y": -13.58,
              "z": 0.724
            },
            "gtin": "4066447743722",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27092c",
            "leftCorner": {
              "x": 4.143,
              "y": -13.58,
              "z": 0.724
            },
            "rightCorner": {
              "x": 4.207,
              "y": -13.635,
              "z": 0.724
            },
            "gtin": "4014531690834",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27092d",
            "leftCorner": {
              "x": 4.207,
              "y": -13.635,
              "z": 0.724
            },
            "rightCorner": {
              "x": 4.261,
              "y": -13.681,
              "z": 0.724
            },
            "gtin": "4066447402667",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270921",
            "leftCorner": {
              "x": 4.261,
              "y": -13.681,
              "z": 0.724
            },
            "rightCorner": {
              "x": 4.318,
              "y": -13.73,
              "z": 0.724
            },
            "gtin": "4066447513011",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739c9",
        "height": 0.97688,
        "facings": [
          {
            "id": "696ebf6e43c343680a27093c",
            "leftCorner": {
              "x": 3.557,
              "y": -13.081,
              "z": 0.977
            },
            "rightCorner": {
              "x": 3.687,
              "y": -13.193,
              "z": 0.977
            },
            "gtin": "4014531690742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27093e",
            "leftCorner": {
              "x": 3.687,
              "y": -13.193,
              "z": 0.977
            },
            "rightCorner": {
              "x": 3.8,
              "y": -13.29,
              "z": 0.977
            },
            "gtin": "4014531690735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27093f",
            "leftCorner": {
              "x": 3.8,
              "y": -13.29,
              "z": 0.977
            },
            "rightCorner": {
              "x": 3.907,
              "y": -13.381,
              "z": 0.977
            }
          },
          {
            "id": "696ebf6e43c343680a270940",
            "leftCorner": {
              "x": 3.907,
              "y": -13.381,
              "z": 0.977
            },
            "rightCorner": {
              "x": 3.941,
              "y": -13.41,
              "z": 0.977
            },
            "gtin": "4014531691039",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270941",
            "leftCorner": {
              "x": 3.941,
              "y": -13.41,
              "z": 0.977
            },
            "rightCorner": {
              "x": 3.98,
              "y": -13.443,
              "z": 0.977
            },
            "gtin": "4014531691022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270942",
            "leftCorner": {
              "x": 3.98,
              "y": -13.443,
              "z": 0.977
            },
            "rightCorner": {
              "x": 4.003,
              "y": -13.463,
              "z": 0.977
            },
            "gtin": "4014531691022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270943",
            "leftCorner": {
              "x": 4.003,
              "y": -13.463,
              "z": 0.977
            },
            "rightCorner": {
              "x": 4.091,
              "y": -13.538,
              "z": 0.977
            },
            "gtin": "4066447514506",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270944",
            "leftCorner": {
              "x": 4.091,
              "y": -13.538,
              "z": 0.977
            },
            "rightCorner": {
              "x": 4.186,
              "y": -13.619,
              "z": 0.977
            },
            "gtin": "4014531691046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270945",
            "leftCorner": {
              "x": 4.186,
              "y": -13.619,
              "z": 0.977
            },
            "rightCorner": {
              "x": 4.244,
              "y": -13.669,
              "z": 0.977
            },
            "gtin": "4014531690728",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27093d",
            "leftCorner": {
              "x": 4.244,
              "y": -13.669,
              "z": 0.977
            },
            "rightCorner": {
              "x": 4.317,
              "y": -13.731,
              "z": 0.977
            },
            "gtin": "4014531690711",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739c7",
        "height": 1.1913,
        "facings": [
          {
            "id": "696ebf6e43c343680a2708f4",
            "leftCorner": {
              "x": 3.556,
              "y": -13.086,
              "z": 1.191
            },
            "rightCorner": {
              "x": 3.669,
              "y": -13.18,
              "z": 1.191
            },
            "gtin": "4014531690698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708f5",
            "leftCorner": {
              "x": 3.668,
              "y": -13.181,
              "z": 1.191
            },
            "rightCorner": {
              "x": 3.781,
              "y": -13.278,
              "z": 1.191
            },
            "gtin": "4014531690681",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708f6",
            "leftCorner": {
              "x": 3.781,
              "y": -13.278,
              "z": 1.191
            },
            "rightCorner": {
              "x": 3.936,
              "y": -13.41,
              "z": 1.191
            },
            "gtin": "4014531690766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708f7",
            "leftCorner": {
              "x": 3.936,
              "y": -13.41,
              "z": 1.191
            },
            "rightCorner": {
              "x": 3.958,
              "y": -13.429,
              "z": 1.191
            }
          },
          {
            "id": "696ebf6e43c343680a2708f8",
            "leftCorner": {
              "x": 3.958,
              "y": -13.429,
              "z": 1.191
            },
            "rightCorner": {
              "x": 4.115,
              "y": -13.564,
              "z": 1.191
            },
            "gtin": "4014531690759",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708f9",
            "leftCorner": {
              "x": 4.115,
              "y": -13.564,
              "z": 1.191
            },
            "rightCorner": {
              "x": 4.214,
              "y": -13.648,
              "z": 1.191
            },
            "gtin": "4014531691008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708fa",
            "leftCorner": {
              "x": 4.214,
              "y": -13.648,
              "z": 1.191
            },
            "rightCorner": {
              "x": 4.272,
              "y": -13.698,
              "z": 1.191
            },
            "gtin": "4014531690827",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708fb",
            "leftCorner": {
              "x": 4.272,
              "y": -13.698,
              "z": 1.191
            },
            "rightCorner": {
              "x": 4.316,
              "y": -13.735,
              "z": 1.191
            },
            "gtin": "4014531690810",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739c8",
        "height": 1.4851,
        "facings": [
          {
            "id": "696ebf6e43c343680a27092e",
            "leftCorner": {
              "x": 3.555,
              "y": -13.084,
              "z": 1.485
            },
            "rightCorner": {
              "x": 3.668,
              "y": -13.181,
              "z": 1.485
            },
            "gtin": "4014531250366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27092f",
            "leftCorner": {
              "x": 3.668,
              "y": -13.181,
              "z": 1.485
            },
            "rightCorner": {
              "x": 3.764,
              "y": -13.263,
              "z": 1.485
            },
            "gtin": "4014531682631",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270930",
            "leftCorner": {
              "x": 3.764,
              "y": -13.263,
              "z": 1.485
            },
            "rightCorner": {
              "x": 3.914,
              "y": -13.391,
              "z": 1.485
            },
            "gtin": "4014531691152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270931",
            "leftCorner": {
              "x": 3.914,
              "y": -13.391,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.041,
              "y": -13.5,
              "z": 1.485
            },
            "gtin": "4014531691145",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270932",
            "leftCorner": {
              "x": 4.041,
              "y": -13.5,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.064,
              "y": -13.519,
              "z": 1.485
            }
          },
          {
            "id": "696ebf6e43c343680a270933",
            "leftCorner": {
              "x": 4.064,
              "y": -13.519,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.126,
              "y": -13.573,
              "z": 1.485
            },
            "gtin": "4014531690995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270934",
            "leftCorner": {
              "x": 4.126,
              "y": -13.573,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.192,
              "y": -13.629,
              "z": 1.485
            },
            "gtin": "4014531690988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270935",
            "leftCorner": {
              "x": 4.192,
              "y": -13.629,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.309,
              "y": -13.728,
              "z": 1.485
            },
            "gtin": "4014531690841",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739c3",
        "height": 1.7363,
        "facings": [
          {
            "id": "696ebf6e43c343680a270910",
            "leftCorner": {
              "x": 3.555,
              "y": -13.083,
              "z": 1.736
            },
            "rightCorner": {
              "x": 3.696,
              "y": -13.203,
              "z": 1.736
            },
            "gtin": "4014531690704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270911",
            "leftCorner": {
              "x": 3.696,
              "y": -13.203,
              "z": 1.736
            },
            "rightCorner": {
              "x": 3.979,
              "y": -13.445,
              "z": 1.736
            },
            "gtin": "4014531689937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270912",
            "leftCorner": {
              "x": 3.979,
              "y": -13.445,
              "z": 1.736
            },
            "rightCorner": {
              "x": 4.001,
              "y": -13.464,
              "z": 1.736
            }
          },
          {
            "id": "696ebf6e43c343680a270913",
            "leftCorner": {
              "x": 4.001,
              "y": -13.464,
              "z": 1.736
            },
            "rightCorner": {
              "x": 4.191,
              "y": -13.626,
              "z": 1.736
            }
          },
          {
            "id": "696ebf6e43c343680a270914",
            "leftCorner": {
              "x": 4.191,
              "y": -13.626,
              "z": 1.736
            },
            "rightCorner": {
              "x": 4.225,
              "y": -13.655,
              "z": 1.736
            }
          },
          {
            "id": "696ebf6e43c343680a270915",
            "leftCorner": {
              "x": 4.225,
              "y": -13.655,
              "z": 1.736
            },
            "rightCorner": {
              "x": 4.247,
              "y": -13.674,
              "z": 1.736
            }
          },
          {
            "id": "696ebf6e43c343680a270916",
            "leftCorner": {
              "x": 4.247,
              "y": -13.674,
              "z": 1.736
            },
            "rightCorner": {
              "x": 4.332,
              "y": -13.747,
              "z": 1.736
            }
          }
        ]
      }
    ]
  },
  {
    "id": "68e75706b5fe7bc0469598e0",
    "name": "68e75706b5fe7bc0469598e0",
    "x": 4.3918,
    "y": -13.667,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.36006,
      "w": 0.93293
    },
    "statistics": {
      "hasStockCount": 11,
      "noStockCount": 1,
      "unknownStockCount": 3
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd739cc",
        "height": 1.1421,
        "facings": [
          {
            "id": "696ebf6e43c343680a270947",
            "leftCorner": {
              "x": 4.329,
              "y": -13.754,
              "z": 1.142
            },
            "rightCorner": {
              "x": 4.384,
              "y": -13.803,
              "z": 1.142
            }
          },
          {
            "id": "696ebf6e43c343680a270948",
            "leftCorner": {
              "x": 4.384,
              "y": -13.803,
              "z": 1.142
            },
            "rightCorner": {
              "x": 4.44,
              "y": -13.854,
              "z": 1.142
            }
          },
          {
            "id": "696ebf6e43c343680a270949",
            "leftCorner": {
              "x": 4.44,
              "y": -13.854,
              "z": 1.142
            },
            "rightCorner": {
              "x": 4.523,
              "y": -13.929,
              "z": 1.142
            }
          },
          {
            "id": "696ebf6e43c343680a27094a",
            "leftCorner": {
              "x": 4.523,
              "y": -13.929,
              "z": 1.142
            },
            "rightCorner": {
              "x": 4.576,
              "y": -13.977,
              "z": 1.142
            },
            "gtin": "4008491108522",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27094b",
            "leftCorner": {
              "x": 4.576,
              "y": -13.977,
              "z": 1.142
            },
            "rightCorner": {
              "x": 4.694,
              "y": -14.084,
              "z": 1.142
            },
            "gtin": "4014531690018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27094c",
            "leftCorner": {
              "x": 4.694,
              "y": -14.084,
              "z": 1.142
            },
            "rightCorner": {
              "x": 4.842,
              "y": -14.219,
              "z": 1.142
            },
            "gtin": "4030651050617",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27094d",
            "leftCorner": {
              "x": 4.842,
              "y": -14.219,
              "z": 1.142
            },
            "rightCorner": {
              "x": 4.972,
              "y": -14.336,
              "z": 1.142
            },
            "gtin": "4066447671940",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270946",
            "leftCorner": {
              "x": 4.972,
              "y": -14.336,
              "z": 1.142
            },
            "rightCorner": {
              "x": 5.061,
              "y": -14.417,
              "z": 1.142
            },
            "gtin": "4014531690025",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739ca",
        "height": 1.4828,
        "facings": [
          {
            "id": "696ebf6e43c343680a270936",
            "leftCorner": {
              "x": 4.309,
              "y": -13.728,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.416,
              "y": -13.82,
              "z": 1.485
            },
            "gtin": "4014531690087",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270937",
            "leftCorner": {
              "x": 4.42,
              "y": -13.834,
              "z": 1.483
            },
            "rightCorner": {
              "x": 4.656,
              "y": -14.048,
              "z": 1.483
            },
            "gtin": "4014531026008",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270938",
            "leftCorner": {
              "x": 4.656,
              "y": -14.048,
              "z": 1.483
            },
            "rightCorner": {
              "x": 4.785,
              "y": -14.165,
              "z": 1.483
            },
            "gtin": "4066447676938",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270939",
            "leftCorner": {
              "x": 4.785,
              "y": -14.165,
              "z": 1.483
            },
            "rightCorner": {
              "x": 4.904,
              "y": -14.273,
              "z": 1.483
            },
            "gtin": "4066447517880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27093a",
            "leftCorner": {
              "x": 4.904,
              "y": -14.273,
              "z": 1.483
            },
            "rightCorner": {
              "x": 4.978,
              "y": -14.34,
              "z": 1.483
            },
            "gtin": "4014531982113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27093b",
            "leftCorner": {
              "x": 4.978,
              "y": -14.34,
              "z": 1.483
            },
            "rightCorner": {
              "x": 5.047,
              "y": -14.403,
              "z": 1.483
            },
            "gtin": "4014531900278",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739cd",
        "height": 1.7421,
        "facings": [
          {
            "id": "696ebf6e43c343680a270917",
            "leftCorner": {
              "x": 4.368,
              "y": -13.724,
              "z": 1.742
            },
            "rightCorner": {
              "x": 4.498,
              "y": -13.842,
              "z": 1.742
            }
          },
          {
            "id": "696ebf6e43c343680a270918",
            "leftCorner": {
              "x": 4.498,
              "y": -13.842,
              "z": 1.742
            },
            "rightCorner": {
              "x": 4.553,
              "y": -13.891,
              "z": 1.742
            }
          },
          {
            "id": "696ebf6e43c343680a270919",
            "leftCorner": {
              "x": 4.553,
              "y": -13.891,
              "z": 1.742
            },
            "rightCorner": {
              "x": 4.68,
              "y": -14.007,
              "z": 1.742
            }
          },
          {
            "id": "696ebf6e43c343680a27091a",
            "leftCorner": {
              "x": 4.68,
              "y": -14.007,
              "z": 1.742
            },
            "rightCorner": {
              "x": 4.772,
              "y": -14.09,
              "z": 1.742
            }
          },
          {
            "id": "696ebf6e43c343680a27091b",
            "leftCorner": {
              "x": 4.772,
              "y": -14.09,
              "z": 1.742
            },
            "rightCorner": {
              "x": 4.855,
              "y": -14.166,
              "z": 1.742
            }
          },
          {
            "id": "696ebf6e43c343680a27091c",
            "leftCorner": {
              "x": 4.855,
              "y": -14.166,
              "z": 1.742
            },
            "rightCorner": {
              "x": 4.884,
              "y": -14.192,
              "z": 1.742
            },
            "gtin": "4014531900261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27091d",
            "leftCorner": {
              "x": 4.884,
              "y": -14.192,
              "z": 1.742
            },
            "rightCorner": {
              "x": 4.918,
              "y": -14.222,
              "z": 1.742
            },
            "gtin": "4014531900261",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27091e",
            "leftCorner": {
              "x": 4.918,
              "y": -14.222,
              "z": 1.742
            },
            "rightCorner": {
              "x": 5.001,
              "y": -14.298,
              "z": 1.742
            },
            "gtin": "4009839493959",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27091f",
            "leftCorner": {
              "x": 5.001,
              "y": -14.298,
              "z": 1.742
            },
            "rightCorner": {
              "x": 5.076,
              "y": -14.366,
              "z": 1.742
            },
            "gtin": "4066447011364",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e75706b5fe7bc0469598e1",
    "name": "68e75706b5fe7bc0469598e1",
    "x": 5.8383,
    "y": -13.562,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93675,
      "w": 0.34999
    },
    "statistics": {
      "hasStockCount": 24,
      "noStockCount": 0,
      "unknownStockCount": 7
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd739ad",
        "height": 0.18062,
        "facings": [
          {
            "id": "696ebf6e43c343680a270854",
            "leftCorner": {
              "x": 5.868,
              "y": -13.528,
              "z": 0.181
            },
            "rightCorner": {
              "x": 5.815,
              "y": -13.482,
              "z": 0.181
            },
            "gtin": "4067796242591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270855",
            "leftCorner": {
              "x": 5.815,
              "y": -13.482,
              "z": 0.181
            },
            "rightCorner": {
              "x": 5.749,
              "y": -13.425,
              "z": 0.181
            },
            "gtin": "4066447567281",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270856",
            "leftCorner": {
              "x": 5.749,
              "y": -13.425,
              "z": 0.181
            },
            "rightCorner": {
              "x": 5.674,
              "y": -13.359,
              "z": 0.181
            },
            "gtin": "4066447824902",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270857",
            "leftCorner": {
              "x": 5.674,
              "y": -13.359,
              "z": 0.181
            },
            "rightCorner": {
              "x": 5.597,
              "y": -13.292,
              "z": 0.181
            },
            "gtin": "4066447825039",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270858",
            "leftCorner": {
              "x": 5.597,
              "y": -13.292,
              "z": 0.181
            },
            "rightCorner": {
              "x": 5.523,
              "y": -13.228,
              "z": 0.181
            },
            "gtin": "4066447140378",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270859",
            "leftCorner": {
              "x": 5.523,
              "y": -13.228,
              "z": 0.181
            },
            "rightCorner": {
              "x": 5.448,
              "y": -13.163,
              "z": 0.181
            },
            "gtin": "4067796240450",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27085a",
            "leftCorner": {
              "x": 5.448,
              "y": -13.163,
              "z": 0.181
            },
            "rightCorner": {
              "x": 5.422,
              "y": -13.14,
              "z": 0.181
            }
          },
          {
            "id": "696ebf6e43c343680a27085b",
            "leftCorner": {
              "x": 5.422,
              "y": -13.14,
              "z": 0.181
            },
            "rightCorner": {
              "x": 5.376,
              "y": -13.1,
              "z": 0.181
            },
            "gtin": "4067796239386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27085c",
            "leftCorner": {
              "x": 5.376,
              "y": -13.1,
              "z": 0.181
            },
            "rightCorner": {
              "x": 5.352,
              "y": -13.08,
              "z": 0.181
            },
            "gtin": "4067796239386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27085d",
            "leftCorner": {
              "x": 5.352,
              "y": -13.08,
              "z": 0.181
            },
            "rightCorner": {
              "x": 5.285,
              "y": -13.021,
              "z": 0.181
            },
            "gtin": "4067796240580",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27085e",
            "leftCorner": {
              "x": 5.285,
              "y": -13.021,
              "z": 0.181
            },
            "rightCorner": {
              "x": 5.213,
              "y": -12.959,
              "z": 0.181
            },
            "gtin": "4058172726132",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27085f",
            "leftCorner": {
              "x": 5.213,
              "y": -12.959,
              "z": 0.181
            },
            "rightCorner": {
              "x": 5.142,
              "y": -12.897,
              "z": 0.181
            },
            "gtin": "4067796239966",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739ab",
        "height": 0.43896,
        "facings": [
          {
            "id": "696ebf6e43c343680a27083c",
            "leftCorner": {
              "x": 5.808,
              "y": -13.597,
              "z": 0.439
            },
            "rightCorner": {
              "x": 5.743,
              "y": -13.54,
              "z": 0.439
            },
            "gtin": "4067796242140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27083d",
            "leftCorner": {
              "x": 5.743,
              "y": -13.54,
              "z": 0.439
            },
            "rightCorner": {
              "x": 5.664,
              "y": -13.471,
              "z": 0.439
            },
            "gtin": "4067796237450",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27083e",
            "leftCorner": {
              "x": 5.664,
              "y": -13.471,
              "z": 0.439
            },
            "rightCorner": {
              "x": 5.595,
              "y": -13.411,
              "z": 0.439
            }
          },
          {
            "id": "696ebf6e43c343680a27083f",
            "leftCorner": {
              "x": 5.595,
              "y": -13.411,
              "z": 0.439
            },
            "rightCorner": {
              "x": 5.512,
              "y": -13.34,
              "z": 0.439
            },
            "gtin": "4058172992117",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270840",
            "leftCorner": {
              "x": 5.512,
              "y": -13.34,
              "z": 0.439
            },
            "rightCorner": {
              "x": 5.447,
              "y": -13.283,
              "z": 0.439
            },
            "gtin": "4066447567199",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270841",
            "leftCorner": {
              "x": 5.447,
              "y": -13.283,
              "z": 0.439
            },
            "rightCorner": {
              "x": 5.424,
              "y": -13.263,
              "z": 0.439
            }
          },
          {
            "id": "696ebf6e43c343680a270842",
            "leftCorner": {
              "x": 5.424,
              "y": -13.263,
              "z": 0.439
            },
            "rightCorner": {
              "x": 5.374,
              "y": -13.22,
              "z": 0.439
            },
            "gtin": "4066447418736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270843",
            "leftCorner": {
              "x": 5.374,
              "y": -13.22,
              "z": 0.439
            },
            "rightCorner": {
              "x": 5.353,
              "y": -13.201,
              "z": 0.439
            }
          },
          {
            "id": "696ebf6e43c343680a270844",
            "leftCorner": {
              "x": 5.353,
              "y": -13.201,
              "z": 0.439
            },
            "rightCorner": {
              "x": 5.289,
              "y": -13.146,
              "z": 0.439
            },
            "gtin": "4067796237726",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270845",
            "leftCorner": {
              "x": 5.289,
              "y": -13.146,
              "z": 0.439
            },
            "rightCorner": {
              "x": 5.211,
              "y": -13.078,
              "z": 0.439
            },
            "gtin": "4058172726408",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270846",
            "leftCorner": {
              "x": 5.211,
              "y": -13.078,
              "z": 0.439
            },
            "rightCorner": {
              "x": 5.136,
              "y": -13.013,
              "z": 0.439
            },
            "gtin": "4066447763577",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270847",
            "leftCorner": {
              "x": 5.136,
              "y": -13.013,
              "z": 0.439
            },
            "rightCorner": {
              "x": 5.076,
              "y": -12.961,
              "z": 0.439
            },
            "gtin": "4066447137040",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739ac",
        "height": 0.68577,
        "facings": [
          {
            "id": "696ebf6e43c343680a270848",
            "leftCorner": {
              "x": 5.805,
              "y": -13.6,
              "z": 0.686
            },
            "rightCorner": {
              "x": 5.749,
              "y": -13.551,
              "z": 0.686
            },
            "gtin": "4066447418620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270849",
            "leftCorner": {
              "x": 5.749,
              "y": -13.551,
              "z": 0.686
            },
            "rightCorner": {
              "x": 5.673,
              "y": -13.485,
              "z": 0.686
            },
            "gtin": "4066447418668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27084a",
            "leftCorner": {
              "x": 5.673,
              "y": -13.485,
              "z": 0.686
            },
            "rightCorner": {
              "x": 5.598,
              "y": -13.42,
              "z": 0.686
            },
            "gtin": "4066447418675",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27084b",
            "leftCorner": {
              "x": 5.598,
              "y": -13.42,
              "z": 0.686
            },
            "rightCorner": {
              "x": 5.521,
              "y": -13.353,
              "z": 0.686
            },
            "gtin": "4066447824841",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27084c",
            "leftCorner": {
              "x": 5.521,
              "y": -13.353,
              "z": 0.686
            },
            "rightCorner": {
              "x": 5.448,
              "y": -13.29,
              "z": 0.686
            },
            "gtin": "4066447727104",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27084d",
            "leftCorner": {
              "x": 5.448,
              "y": -13.29,
              "z": 0.686
            },
            "rightCorner": {
              "x": 5.426,
              "y": -13.271,
              "z": 0.686
            }
          },
          {
            "id": "696ebf6e43c343680a27084e",
            "leftCorner": {
              "x": 5.426,
              "y": -13.271,
              "z": 0.686
            },
            "rightCorner": {
              "x": 5.365,
              "y": -13.217,
              "z": 0.686
            },
            "gtin": "4066447001075",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27084f",
            "leftCorner": {
              "x": 5.365,
              "y": -13.217,
              "z": 0.686
            },
            "rightCorner": {
              "x": 5.289,
              "y": -13.151,
              "z": 0.686
            },
            "gtin": "4066447824872",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270850",
            "leftCorner": {
              "x": 5.289,
              "y": -13.151,
              "z": 0.686
            },
            "rightCorner": {
              "x": 5.216,
              "y": -13.088,
              "z": 0.686
            },
            "gtin": "4067796235388",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270851",
            "leftCorner": {
              "x": 5.216,
              "y": -13.088,
              "z": 0.686
            },
            "rightCorner": {
              "x": 5.138,
              "y": -13.021,
              "z": 0.686
            },
            "gtin": "4066447137026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270852",
            "leftCorner": {
              "x": 5.138,
              "y": -13.021,
              "z": 0.686
            },
            "rightCorner": {
              "x": 5.068,
              "y": -12.959,
              "z": 0.686
            },
            "gtin": "4067796235982",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270853",
            "leftCorner": {
              "x": 5.068,
              "y": -12.959,
              "z": 0.686
            },
            "rightCorner": {
              "x": 5.048,
              "y": -12.942,
              "z": 0.686
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739af",
        "height": 1.2265,
        "facings": []
      },
      {
        "id": "696ead8c3b88e258afd739b0",
        "height": 1.5223,
        "facings": [
          {
            "id": "696ebf6e43c343680a270860",
            "leftCorner": {
              "x": 5.794,
              "y": -13.614,
              "z": 1.522
            },
            "rightCorner": {
              "x": 5.381,
              "y": -13.255,
              "z": 1.522
            }
          },
          {
            "id": "696ebf6e43c343680a270861",
            "leftCorner": {
              "x": 5.381,
              "y": -13.255,
              "z": 1.522
            },
            "rightCorner": {
              "x": 5.039,
              "y": -12.958,
              "z": 1.522
            },
            "gtin": "4067796245646",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739ae",
        "height": 1.772,
        "facings": []
      }
    ]
  },
  {
    "id": "68e75706b5fe7bc0469598e2",
    "name": "68e75706b5fe7bc0469598e2",
    "x": 5.0685,
    "y": -12.905,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93852,
      "w": 0.34521
    },
    "statistics": {
      "hasStockCount": 44,
      "noStockCount": 1,
      "unknownStockCount": 14
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd739b6",
        "height": 0.17463,
        "facings": []
      },
      {
        "id": "696ead8c3b88e258afd739b5",
        "height": 0.61758,
        "facings": [
          {
            "id": "696ebf6e43c343680a2708c0",
            "leftCorner": {
              "x": 5.105,
              "y": -12.863,
              "z": 0.618
            },
            "rightCorner": {
              "x": 5.057,
              "y": -12.822,
              "z": 0.618
            },
            "gtin": "4042441020496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708c2",
            "leftCorner": {
              "x": 5.057,
              "y": -12.822,
              "z": 0.618
            },
            "rightCorner": {
              "x": 4.997,
              "y": -12.771,
              "z": 0.618
            },
            "gtin": "4066447616521",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708c3",
            "leftCorner": {
              "x": 4.997,
              "y": -12.771,
              "z": 0.618
            },
            "rightCorner": {
              "x": 4.949,
              "y": -12.73,
              "z": 0.618
            }
          },
          {
            "id": "696ebf6e43c343680a2708c4",
            "leftCorner": {
              "x": 4.949,
              "y": -12.73,
              "z": 0.618
            },
            "rightCorner": {
              "x": 4.858,
              "y": -12.653,
              "z": 0.618
            },
            "gtin": "4066447704273",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708c5",
            "leftCorner": {
              "x": 4.858,
              "y": -12.653,
              "z": 0.618
            },
            "rightCorner": {
              "x": 4.786,
              "y": -12.591,
              "z": 0.618
            },
            "gtin": "4066447438413",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708c6",
            "leftCorner": {
              "x": 4.786,
              "y": -12.591,
              "z": 0.618
            },
            "rightCorner": {
              "x": 4.75,
              "y": -12.56,
              "z": 0.618
            },
            "gtin": "4036581537389",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708c7",
            "leftCorner": {
              "x": 4.75,
              "y": -12.56,
              "z": 0.618
            },
            "rightCorner": {
              "x": 4.687,
              "y": -12.507,
              "z": 0.618
            },
            "gtin": "4036581540020",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708c8",
            "leftCorner": {
              "x": 4.687,
              "y": -12.507,
              "z": 0.618
            },
            "rightCorner": {
              "x": 4.622,
              "y": -12.452,
              "z": 0.618
            },
            "gtin": "4036581524914",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708c9",
            "leftCorner": {
              "x": 4.622,
              "y": -12.452,
              "z": 0.618
            },
            "rightCorner": {
              "x": 4.559,
              "y": -12.398,
              "z": 0.618
            },
            "gtin": "4083700303455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708ca",
            "leftCorner": {
              "x": 4.559,
              "y": -12.398,
              "z": 0.618
            },
            "rightCorner": {
              "x": 4.489,
              "y": -12.338,
              "z": 0.618
            },
            "gtin": "4008491751483",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708cb",
            "leftCorner": {
              "x": 4.489,
              "y": -12.338,
              "z": 0.618
            },
            "rightCorner": {
              "x": 4.433,
              "y": -12.291,
              "z": 0.618
            },
            "gtin": "4008491109444",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708cc",
            "leftCorner": {
              "x": 4.433,
              "y": -12.291,
              "z": 0.618
            },
            "rightCorner": {
              "x": 4.373,
              "y": -12.24,
              "z": 0.618
            },
            "gtin": "4008491751520",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708c1",
            "leftCorner": {
              "x": 4.373,
              "y": -12.24,
              "z": 0.618
            },
            "rightCorner": {
              "x": 4.343,
              "y": -12.215,
              "z": 0.618
            },
            "gtin": "4036581532650",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739b2",
        "height": 0.86177,
        "facings": [
          {
            "id": "696ebf6e43c343680a27087b",
            "leftCorner": {
              "x": 5.11,
              "y": -12.87,
              "z": 0.862
            },
            "rightCorner": {
              "x": 5.043,
              "y": -12.813,
              "z": 0.862
            },
            "gtin": "8712175936467",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27087c",
            "leftCorner": {
              "x": 5.043,
              "y": -12.813,
              "z": 0.862
            },
            "rightCorner": {
              "x": 4.988,
              "y": -12.766,
              "z": 0.862
            },
            "gtin": "8712175936467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27087d",
            "leftCorner": {
              "x": 4.988,
              "y": -12.766,
              "z": 0.862
            },
            "rightCorner": {
              "x": 4.939,
              "y": -12.724,
              "z": 0.862
            }
          },
          {
            "id": "696ebf6e43c343680a27087e",
            "leftCorner": {
              "x": 4.939,
              "y": -12.724,
              "z": 0.862
            },
            "rightCorner": {
              "x": 4.881,
              "y": -12.676,
              "z": 0.862
            },
            "gtin": "4066447496314",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27087f",
            "leftCorner": {
              "x": 4.881,
              "y": -12.676,
              "z": 0.862
            },
            "rightCorner": {
              "x": 4.822,
              "y": -12.625,
              "z": 0.862
            },
            "gtin": "4066447496345",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270880",
            "leftCorner": {
              "x": 4.822,
              "y": -12.625,
              "z": 0.862
            },
            "rightCorner": {
              "x": 4.767,
              "y": -12.578,
              "z": 0.862
            },
            "gtin": "4006671031011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270881",
            "leftCorner": {
              "x": 4.767,
              "y": -12.578,
              "z": 0.862
            },
            "rightCorner": {
              "x": 4.726,
              "y": -12.544,
              "z": 0.862
            },
            "gtin": "4002448152682",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270882",
            "leftCorner": {
              "x": 4.726,
              "y": -12.544,
              "z": 0.862
            },
            "rightCorner": {
              "x": 4.662,
              "y": -12.489,
              "z": 0.862
            },
            "gtin": "4005800359002",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270883",
            "leftCorner": {
              "x": 4.662,
              "y": -12.489,
              "z": 0.862
            },
            "rightCorner": {
              "x": 4.599,
              "y": -12.436,
              "z": 0.862
            },
            "gtin": "4005800486005",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270884",
            "leftCorner": {
              "x": 4.599,
              "y": -12.436,
              "z": 0.862
            },
            "rightCorner": {
              "x": 4.539,
              "y": -12.384,
              "z": 0.862
            },
            "gtin": "4036581533602",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270885",
            "leftCorner": {
              "x": 4.539,
              "y": -12.384,
              "z": 0.862
            },
            "rightCorner": {
              "x": 4.481,
              "y": -12.335,
              "z": 0.862
            },
            "gtin": "4067796175844",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270886",
            "leftCorner": {
              "x": 4.481,
              "y": -12.335,
              "z": 0.862
            },
            "rightCorner": {
              "x": 4.423,
              "y": -12.285,
              "z": 0.862
            },
            "gtin": "4067796205404",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270887",
            "leftCorner": {
              "x": 4.423,
              "y": -12.285,
              "z": 0.862
            },
            "rightCorner": {
              "x": 4.359,
              "y": -12.231,
              "z": 0.862
            },
            "gtin": "8712175936498",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739b3",
        "height": 1.1192,
        "facings": [
          {
            "id": "696ebf6e43c343680a270896",
            "leftCorner": {
              "x": 5.103,
              "y": -12.865,
              "z": 1.119
            },
            "rightCorner": {
              "x": 5.062,
              "y": -12.83,
              "z": 1.119
            },
            "gtin": "8712175936528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270898",
            "leftCorner": {
              "x": 5.062,
              "y": -12.83,
              "z": 1.119
            },
            "rightCorner": {
              "x": 5.008,
              "y": -12.784,
              "z": 1.119
            },
            "gtin": "4042441017472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270899",
            "leftCorner": {
              "x": 5.008,
              "y": -12.784,
              "z": 1.119
            },
            "rightCorner": {
              "x": 4.96,
              "y": -12.744,
              "z": 1.119
            }
          },
          {
            "id": "696ebf6e43c343680a27089a",
            "leftCorner": {
              "x": 4.96,
              "y": -12.744,
              "z": 1.119
            },
            "rightCorner": {
              "x": 4.905,
              "y": -12.697,
              "z": 1.119
            },
            "gtin": "3663555004335",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27089b",
            "leftCorner": {
              "x": 4.905,
              "y": -12.697,
              "z": 1.119
            },
            "rightCorner": {
              "x": 4.85,
              "y": -12.65,
              "z": 1.119
            },
            "gtin": "3663555003789",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27089c",
            "leftCorner": {
              "x": 4.85,
              "y": -12.65,
              "z": 1.119
            },
            "rightCorner": {
              "x": 4.798,
              "y": -12.605,
              "z": 1.119
            },
            "gtin": "3663555003796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27089d",
            "leftCorner": {
              "x": 4.798,
              "y": -12.605,
              "z": 1.119
            },
            "rightCorner": {
              "x": 4.745,
              "y": -12.561,
              "z": 1.119
            },
            "gtin": "3663555003802",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27089e",
            "leftCorner": {
              "x": 4.745,
              "y": -12.561,
              "z": 1.119
            },
            "rightCorner": {
              "x": 4.685,
              "y": -12.51,
              "z": 1.119
            },
            "gtin": "3663555002768",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27089f",
            "leftCorner": {
              "x": 4.685,
              "y": -12.51,
              "z": 1.119
            },
            "rightCorner": {
              "x": 4.636,
              "y": -12.468,
              "z": 1.119
            },
            "gtin": "3663555003826",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708a0",
            "leftCorner": {
              "x": 4.636,
              "y": -12.468,
              "z": 1.119
            },
            "rightCorner": {
              "x": 4.579,
              "y": -12.419,
              "z": 1.119
            },
            "gtin": "3663555004342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708a1",
            "leftCorner": {
              "x": 4.579,
              "y": -12.419,
              "z": 1.119
            },
            "rightCorner": {
              "x": 4.507,
              "y": -12.358,
              "z": 1.119
            },
            "gtin": "4005800345012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708a2",
            "leftCorner": {
              "x": 4.507,
              "y": -12.358,
              "z": 1.119
            },
            "rightCorner": {
              "x": 4.454,
              "y": -12.313,
              "z": 1.119
            },
            "gtin": "4006293719328",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708a3",
            "leftCorner": {
              "x": 4.454,
              "y": -12.313,
              "z": 1.119
            },
            "rightCorner": {
              "x": 4.397,
              "y": -12.265,
              "z": 1.119
            },
            "gtin": "4006293088622",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708a4",
            "leftCorner": {
              "x": 4.397,
              "y": -12.265,
              "z": 1.119
            },
            "rightCorner": {
              "x": 4.344,
              "y": -12.219,
              "z": 1.119
            },
            "gtin": "4006293365822",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739b4",
        "height": 1.4007,
        "facings": [
          {
            "id": "696ebf6e43c343680a2708b2",
            "leftCorner": {
              "x": 5.109,
              "y": -12.872,
              "z": 1.401
            },
            "rightCorner": {
              "x": 5.025,
              "y": -12.801,
              "z": 1.401
            },
            "gtin": "4067796143379",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708b3",
            "leftCorner": {
              "x": 5.025,
              "y": -12.801,
              "z": 1.401
            },
            "rightCorner": {
              "x": 4.968,
              "y": -12.753,
              "z": 1.401
            },
            "gtin": "4066447496581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2708b4",
            "leftCorner": {
              "x": 4.968,
              "y": -12.753,
              "z": 1.401
            },
            "rightCorner": {
              "x": 4.854,
              "y": -12.655,
              "z": 1.401
            },
            "gtin": "4002448137634",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708b5",
            "leftCorner": {
              "x": 4.854,
              "y": -12.655,
              "z": 1.401
            },
            "rightCorner": {
              "x": 4.793,
              "y": -12.603,
              "z": 1.401
            },
            "gtin": "5708932019583",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708b6",
            "leftCorner": {
              "x": 4.793,
              "y": -12.603,
              "z": 1.401
            },
            "rightCorner": {
              "x": 4.732,
              "y": -12.552,
              "z": 1.401
            },
            "gtin": "4002448110743",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708b7",
            "leftCorner": {
              "x": 4.732,
              "y": -12.552,
              "z": 1.401
            },
            "rightCorner": {
              "x": 4.67,
              "y": -12.499,
              "z": 1.401
            },
            "gtin": "4002448110774",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708b8",
            "leftCorner": {
              "x": 4.67,
              "y": -12.499,
              "z": 1.401
            },
            "rightCorner": {
              "x": 4.625,
              "y": -12.46,
              "z": 1.401
            },
            "gtin": "4067796174793",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708b9",
            "leftCorner": {
              "x": 4.625,
              "y": -12.46,
              "z": 1.401
            },
            "rightCorner": {
              "x": 4.567,
              "y": -12.411,
              "z": 1.401
            },
            "gtin": "4067796183948",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708ba",
            "leftCorner": {
              "x": 4.567,
              "y": -12.411,
              "z": 1.401
            },
            "rightCorner": {
              "x": 4.351,
              "y": -12.227,
              "z": 1.401
            },
            "gtin": "5052197006308",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739b1",
        "height": 1.6553,
        "facings": [
          {
            "id": "696ebf6e43c343680a270862",
            "leftCorner": {
              "x": 5.102,
              "y": -12.866,
              "z": 1.655
            },
            "rightCorner": {
              "x": 5.054,
              "y": -12.824,
              "z": 1.655
            },
            "gtin": "4066447496697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270864",
            "leftCorner": {
              "x": 5.054,
              "y": -12.824,
              "z": 1.655
            },
            "rightCorner": {
              "x": 5.015,
              "y": -12.791,
              "z": 1.655
            },
            "gtin": "4066447496598",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270865",
            "leftCorner": {
              "x": 5.015,
              "y": -12.791,
              "z": 1.655
            },
            "rightCorner": {
              "x": 4.973,
              "y": -12.756,
              "z": 1.655
            },
            "gtin": "4066447496598",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270866",
            "leftCorner": {
              "x": 4.973,
              "y": -12.756,
              "z": 1.655
            },
            "rightCorner": {
              "x": 4.949,
              "y": -12.735,
              "z": 1.655
            },
            "gtin": "4066447496628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270867",
            "leftCorner": {
              "x": 4.949,
              "y": -12.735,
              "z": 1.655
            },
            "rightCorner": {
              "x": 4.922,
              "y": -12.713,
              "z": 1.655
            }
          },
          {
            "id": "696ebf6e43c343680a270868",
            "leftCorner": {
              "x": 4.922,
              "y": -12.713,
              "z": 1.655
            },
            "rightCorner": {
              "x": 4.859,
              "y": -12.659,
              "z": 1.655
            },
            "gtin": "4058172198205",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270869",
            "leftCorner": {
              "x": 4.859,
              "y": -12.659,
              "z": 1.655
            },
            "rightCorner": {
              "x": 4.81,
              "y": -12.617,
              "z": 1.655
            },
            "gtin": "4066447496635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27086a",
            "leftCorner": {
              "x": 4.81,
              "y": -12.617,
              "z": 1.655
            },
            "rightCorner": {
              "x": 4.762,
              "y": -12.576,
              "z": 1.655
            },
            "gtin": "4058172198175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27086b",
            "leftCorner": {
              "x": 4.762,
              "y": -12.576,
              "z": 1.655
            },
            "rightCorner": {
              "x": 4.708,
              "y": -12.531,
              "z": 1.655
            },
            "gtin": "4006671299008",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27086c",
            "leftCorner": {
              "x": 4.708,
              "y": -12.531,
              "z": 1.655
            },
            "rightCorner": {
              "x": 4.646,
              "y": -12.477,
              "z": 1.655
            }
          },
          {
            "id": "696ebf6e43c343680a27086d",
            "leftCorner": {
              "x": 4.646,
              "y": -12.477,
              "z": 1.655
            },
            "rightCorner": {
              "x": 4.614,
              "y": -12.45,
              "z": 1.655
            },
            "gtin": "4006293018643",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27086e",
            "leftCorner": {
              "x": 4.614,
              "y": -12.45,
              "z": 1.655
            },
            "rightCorner": {
              "x": 4.546,
              "y": -12.392,
              "z": 1.655
            },
            "gtin": "4006293718222",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27086f",
            "leftCorner": {
              "x": 4.546,
              "y": -12.392,
              "z": 1.655
            },
            "rightCorner": {
              "x": 4.463,
              "y": -12.322,
              "z": 1.655
            },
            "gtin": "4006293023449",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270870",
            "leftCorner": {
              "x": 4.463,
              "y": -12.322,
              "z": 1.655
            },
            "rightCorner": {
              "x": 4.398,
              "y": -12.266,
              "z": 1.655
            },
            "gtin": "4006293027348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270871",
            "leftCorner": {
              "x": 4.398,
              "y": -12.266,
              "z": 1.655
            },
            "rightCorner": {
              "x": 4.357,
              "y": -12.231,
              "z": 1.655
            },
            "gtin": "4006293736462",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e75706b5fe7bc0469598e3",
    "name": "68e75706b5fe7bc0469598e3",
    "x": 4.311,
    "y": -12.263,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93591,
      "w": 0.35223
    },
    "statistics": {
      "hasStockCount": 45,
      "noStockCount": 0,
      "unknownStockCount": 7
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd739bb",
        "height": 0.17693,
        "facings": []
      },
      {
        "id": "696ead8c3b88e258afd739b7",
        "height": 0.603,
        "facings": [
          {
            "id": "696ebf6e43c343680a2708cd",
            "leftCorner": {
              "x": 4.342,
              "y": -12.227,
              "z": 0.603
            },
            "rightCorner": {
              "x": 4.314,
              "y": -12.202,
              "z": 0.603
            }
          },
          {
            "id": "696ebf6e43c343680a2708cf",
            "leftCorner": {
              "x": 4.314,
              "y": -12.202,
              "z": 0.603
            },
            "rightCorner": {
              "x": 4.259,
              "y": -12.153,
              "z": 0.603
            },
            "gtin": "4058172925771",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708d0",
            "leftCorner": {
              "x": 4.259,
              "y": -12.153,
              "z": 0.603
            },
            "rightCorner": {
              "x": 4.219,
              "y": -12.119,
              "z": 0.603
            },
            "gtin": "4058172925771",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708d1",
            "leftCorner": {
              "x": 4.219,
              "y": -12.119,
              "z": 0.603
            },
            "rightCorner": {
              "x": 4.183,
              "y": -12.087,
              "z": 0.603
            },
            "gtin": "4066447231298",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708d2",
            "leftCorner": {
              "x": 4.183,
              "y": -12.087,
              "z": 0.603
            },
            "rightCorner": {
              "x": 4.136,
              "y": -12.046,
              "z": 0.603
            },
            "gtin": "4066447496680",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708d3",
            "leftCorner": {
              "x": 4.136,
              "y": -12.046,
              "z": 0.603
            },
            "rightCorner": {
              "x": 4.074,
              "y": -11.992,
              "z": 0.603
            },
            "gtin": "4008233137001",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708d4",
            "leftCorner": {
              "x": 4.074,
              "y": -11.992,
              "z": 0.603
            },
            "rightCorner": {
              "x": 4.012,
              "y": -11.937,
              "z": 0.603
            },
            "gtin": "4008233157276",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708d5",
            "leftCorner": {
              "x": 4.012,
              "y": -11.937,
              "z": 0.603
            },
            "rightCorner": {
              "x": 3.962,
              "y": -11.893,
              "z": 0.603
            },
            "gtin": "5056585804866",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708d6",
            "leftCorner": {
              "x": 3.962,
              "y": -11.893,
              "z": 0.603
            },
            "rightCorner": {
              "x": 3.905,
              "y": -11.843,
              "z": 0.603
            },
            "gtin": "5056585803661",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708d7",
            "leftCorner": {
              "x": 3.905,
              "y": -11.843,
              "z": 0.603
            },
            "rightCorner": {
              "x": 3.841,
              "y": -11.787,
              "z": 0.603
            }
          },
          {
            "id": "696ebf6e43c343680a2708d8",
            "leftCorner": {
              "x": 3.841,
              "y": -11.787,
              "z": 0.603
            },
            "rightCorner": {
              "x": 3.697,
              "y": -11.661,
              "z": 0.603
            },
            "gtin": "5038483502662",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708ce",
            "leftCorner": {
              "x": 3.697,
              "y": -11.661,
              "z": 0.603
            },
            "rightCorner": {
              "x": 3.591,
              "y": -11.568,
              "z": 0.603
            },
            "gtin": "5056585803098",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739bc",
        "height": 0.85542,
        "facings": [
          {
            "id": "696ebf6e43c343680a270888",
            "leftCorner": {
              "x": 4.359,
              "y": -12.231,
              "z": 0.862
            },
            "rightCorner": {
              "x": 4.285,
              "y": -12.168,
              "z": 0.862
            },
            "gtin": "4006671036115",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270889",
            "leftCorner": {
              "x": 4.288,
              "y": -12.176,
              "z": 0.855
            },
            "rightCorner": {
              "x": 4.236,
              "y": -12.13,
              "z": 0.855
            },
            "gtin": "4066447341690",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27088a",
            "leftCorner": {
              "x": 4.236,
              "y": -12.13,
              "z": 0.855
            },
            "rightCorner": {
              "x": 4.186,
              "y": -12.087,
              "z": 0.855
            }
          },
          {
            "id": "696ebf6e43c343680a27088b",
            "leftCorner": {
              "x": 4.186,
              "y": -12.087,
              "z": 0.855
            },
            "rightCorner": {
              "x": 4.142,
              "y": -12.048,
              "z": 0.855
            },
            "gtin": "4067796174823",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27088c",
            "leftCorner": {
              "x": 4.142,
              "y": -12.048,
              "z": 0.855
            },
            "rightCorner": {
              "x": 4.109,
              "y": -12.019,
              "z": 0.855
            },
            "gtin": "4066447492583",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27088d",
            "leftCorner": {
              "x": 4.109,
              "y": -12.019,
              "z": 0.855
            },
            "rightCorner": {
              "x": 4.038,
              "y": -11.957,
              "z": 0.855
            },
            "gtin": "4066447439786",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27088e",
            "leftCorner": {
              "x": 4.038,
              "y": -11.957,
              "z": 0.855
            },
            "rightCorner": {
              "x": 3.976,
              "y": -11.902,
              "z": 0.855
            },
            "gtin": "4066447524024",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27088f",
            "leftCorner": {
              "x": 3.976,
              "y": -11.902,
              "z": 0.855
            },
            "rightCorner": {
              "x": 3.941,
              "y": -11.872,
              "z": 0.855
            },
            "gtin": "4066447231212",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270890",
            "leftCorner": {
              "x": 3.941,
              "y": -11.872,
              "z": 0.855
            },
            "rightCorner": {
              "x": 3.888,
              "y": -11.825,
              "z": 0.855
            },
            "gtin": "4066447496703",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270891",
            "leftCorner": {
              "x": 3.888,
              "y": -11.825,
              "z": 0.855
            },
            "rightCorner": {
              "x": 3.857,
              "y": -11.798,
              "z": 0.855
            },
            "gtin": "5038483501092",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270892",
            "leftCorner": {
              "x": 3.857,
              "y": -11.798,
              "z": 0.855
            },
            "rightCorner": {
              "x": 3.83,
              "y": -11.774,
              "z": 0.855
            },
            "gtin": "4006671002011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270893",
            "leftCorner": {
              "x": 3.83,
              "y": -11.774,
              "z": 0.855
            },
            "rightCorner": {
              "x": 3.803,
              "y": -11.75,
              "z": 0.855
            },
            "gtin": "4006671002011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270894",
            "leftCorner": {
              "x": 3.803,
              "y": -11.75,
              "z": 0.855
            },
            "rightCorner": {
              "x": 3.706,
              "y": -11.666,
              "z": 0.855
            },
            "gtin": "4008491751445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270895",
            "leftCorner": {
              "x": 3.706,
              "y": -11.666,
              "z": 0.855
            },
            "rightCorner": {
              "x": 3.627,
              "y": -11.596,
              "z": 0.855
            },
            "gtin": "5038483253908",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27087a",
            "leftCorner": {
              "x": 3.627,
              "y": -11.596,
              "z": 0.855
            },
            "rightCorner": {
              "x": 3.592,
              "y": -11.566,
              "z": 0.855
            },
            "gtin": "4008491751599",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739b8",
        "height": 1.1212,
        "facings": [
          {
            "id": "696ebf6e43c343680a2708a5",
            "leftCorner": {
              "x": 4.344,
              "y": -12.219,
              "z": 1.119
            },
            "rightCorner": {
              "x": 4.291,
              "y": -12.174,
              "z": 1.119
            },
            "gtin": "4066447231250",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708a6",
            "leftCorner": {
              "x": 4.298,
              "y": -12.177,
              "z": 1.121
            },
            "rightCorner": {
              "x": 4.261,
              "y": -12.145,
              "z": 1.121
            },
            "gtin": "4066447231250",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708a7",
            "leftCorner": {
              "x": 4.261,
              "y": -12.145,
              "z": 1.121
            },
            "rightCorner": {
              "x": 4.226,
              "y": -12.115,
              "z": 1.121
            },
            "gtin": "4066447377262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708a8",
            "leftCorner": {
              "x": 4.226,
              "y": -12.115,
              "z": 1.121
            },
            "rightCorner": {
              "x": 4.193,
              "y": -12.086,
              "z": 1.121
            },
            "gtin": "4058172784477",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708a9",
            "leftCorner": {
              "x": 4.193,
              "y": -12.086,
              "z": 1.121
            },
            "rightCorner": {
              "x": 4.156,
              "y": -12.053,
              "z": 1.121
            },
            "gtin": "4058172784477",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708aa",
            "leftCorner": {
              "x": 4.156,
              "y": -12.053,
              "z": 1.121
            },
            "rightCorner": {
              "x": 4.116,
              "y": -12.018,
              "z": 1.121
            },
            "gtin": "4066447438451",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708ab",
            "leftCorner": {
              "x": 4.116,
              "y": -12.018,
              "z": 1.121
            },
            "rightCorner": {
              "x": 4.08,
              "y": -11.986,
              "z": 1.121
            },
            "gtin": "4066447231311",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708ac",
            "leftCorner": {
              "x": 4.08,
              "y": -11.986,
              "z": 1.121
            },
            "rightCorner": {
              "x": 4.024,
              "y": -11.937,
              "z": 1.121
            },
            "gtin": "4066447440010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708ad",
            "leftCorner": {
              "x": 4.024,
              "y": -11.937,
              "z": 1.121
            },
            "rightCorner": {
              "x": 3.975,
              "y": -11.894,
              "z": 1.121
            },
            "gtin": "4066447872934",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708ae",
            "leftCorner": {
              "x": 3.975,
              "y": -11.894,
              "z": 1.121
            },
            "rightCorner": {
              "x": 3.896,
              "y": -11.825,
              "z": 1.121
            },
            "gtin": "4066447870930",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708af",
            "leftCorner": {
              "x": 3.896,
              "y": -11.825,
              "z": 1.121
            },
            "rightCorner": {
              "x": 3.81,
              "y": -11.75,
              "z": 1.121
            },
            "gtin": "4066447864236",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708b0",
            "leftCorner": {
              "x": 3.81,
              "y": -11.75,
              "z": 1.121
            },
            "rightCorner": {
              "x": 3.706,
              "y": -11.658,
              "z": 1.121
            },
            "gtin": "4066447396539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270897",
            "leftCorner": {
              "x": 3.706,
              "y": -11.658,
              "z": 1.121
            },
            "rightCorner": {
              "x": 3.596,
              "y": -11.562,
              "z": 1.121
            },
            "gtin": "5704947015121",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739ba",
        "height": 1.4061,
        "facings": [
          {
            "id": "696ebf6e43c343680a2708bb",
            "leftCorner": {
              "x": 4.35,
              "y": -12.227,
              "z": 1.401
            },
            "rightCorner": {
              "x": 4.273,
              "y": -12.162,
              "z": 1.401
            },
            "gtin": "4066447078398",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708bc",
            "leftCorner": {
              "x": 4.279,
              "y": -12.166,
              "z": 1.406
            },
            "rightCorner": {
              "x": 4.07,
              "y": -11.983,
              "z": 1.406
            },
            "gtin": "4066447439434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708bd",
            "leftCorner": {
              "x": 4.07,
              "y": -11.983,
              "z": 1.406
            },
            "rightCorner": {
              "x": 4.004,
              "y": -11.925,
              "z": 1.406
            },
            "gtin": "4066447439502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708be",
            "leftCorner": {
              "x": 4.004,
              "y": -11.925,
              "z": 1.406
            },
            "rightCorner": {
              "x": 3.939,
              "y": -11.868,
              "z": 1.406
            },
            "gtin": "4066447439809",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708bf",
            "leftCorner": {
              "x": 3.939,
              "y": -11.868,
              "z": 1.406
            },
            "rightCorner": {
              "x": 3.757,
              "y": -11.708,
              "z": 1.406
            },
            "gtin": "4008233170503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2708b1",
            "leftCorner": {
              "x": 3.757,
              "y": -11.708,
              "z": 1.406
            },
            "rightCorner": {
              "x": 3.593,
              "y": -11.565,
              "z": 1.406
            },
            "gtin": "4021457613700",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739b9",
        "height": 1.6577,
        "facings": [
          {
            "id": "696ebf6e43c343680a270872",
            "leftCorner": {
              "x": 4.356,
              "y": -12.231,
              "z": 1.655
            },
            "rightCorner": {
              "x": 4.3,
              "y": -12.183,
              "z": 1.655
            },
            "gtin": "5056585803036",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270873",
            "leftCorner": {
              "x": 4.305,
              "y": -12.188,
              "z": 1.658
            },
            "rightCorner": {
              "x": 4.213,
              "y": -12.107,
              "z": 1.658
            },
            "gtin": "5056585802022",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270874",
            "leftCorner": {
              "x": 4.213,
              "y": -12.107,
              "z": 1.658
            },
            "rightCorner": {
              "x": 4.129,
              "y": -12.033,
              "z": 1.658
            },
            "gtin": "4002448153184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270875",
            "leftCorner": {
              "x": 4.129,
              "y": -12.033,
              "z": 1.658
            },
            "rightCorner": {
              "x": 4.054,
              "y": -11.968,
              "z": 1.658
            },
            "gtin": "4008491109482",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270876",
            "leftCorner": {
              "x": 4.054,
              "y": -11.968,
              "z": 1.658
            },
            "rightCorner": {
              "x": 3.985,
              "y": -11.907,
              "z": 1.658
            },
            "gtin": "4008491100632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270877",
            "leftCorner": {
              "x": 3.985,
              "y": -11.907,
              "z": 1.658
            },
            "rightCorner": {
              "x": 3.915,
              "y": -11.846,
              "z": 1.658
            },
            "gtin": "4003573021720",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270878",
            "leftCorner": {
              "x": 3.915,
              "y": -11.846,
              "z": 1.658
            },
            "rightCorner": {
              "x": 3.848,
              "y": -11.788,
              "z": 1.658
            },
            "gtin": "4003573021560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270879",
            "leftCorner": {
              "x": 3.848,
              "y": -11.788,
              "z": 1.658
            },
            "rightCorner": {
              "x": 3.734,
              "y": -11.688,
              "z": 1.658
            },
            "gtin": "4260560834521",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270863",
            "leftCorner": {
              "x": 3.734,
              "y": -11.688,
              "z": 1.658
            },
            "rightCorner": {
              "x": 3.594,
              "y": -11.564,
              "z": 1.658
            },
            "gtin": "4058172544149",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc0469598f0",
    "name": "68e7571db5fe7bc0469598f0",
    "x": 2.8074,
    "y": -8.5149,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.3395,
      "w": 0.94061
    },
    "statistics": {
      "hasStockCount": 52,
      "noStockCount": 0,
      "unknownStockCount": 30
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73a24",
        "height": 0.16971,
        "facings": [
          {
            "id": "696ebf6f43c343680a270e7e",
            "leftCorner": {
              "x": 2.779,
              "y": -8.55,
              "z": 0.17
            },
            "rightCorner": {
              "x": 2.836,
              "y": -8.597,
              "z": 0.17
            },
            "gtin": "4066447054613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e80",
            "leftCorner": {
              "x": 2.836,
              "y": -8.597,
              "z": 0.17
            },
            "rightCorner": {
              "x": 2.895,
              "y": -8.646,
              "z": 0.17
            },
            "gtin": "4066447054613",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e81",
            "leftCorner": {
              "x": 2.895,
              "y": -8.646,
              "z": 0.17
            },
            "rightCorner": {
              "x": 2.954,
              "y": -8.695,
              "z": 0.17
            },
            "gtin": "4066447054613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e82",
            "leftCorner": {
              "x": 2.954,
              "y": -8.695,
              "z": 0.17
            },
            "rightCorner": {
              "x": 3.014,
              "y": -8.745,
              "z": 0.17
            },
            "gtin": "4066447887440",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e83",
            "leftCorner": {
              "x": 3.014,
              "y": -8.745,
              "z": 0.17
            },
            "rightCorner": {
              "x": 3.08,
              "y": -8.8,
              "z": 0.17
            },
            "gtin": "4066447887440",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e84",
            "leftCorner": {
              "x": 3.08,
              "y": -8.8,
              "z": 0.17
            },
            "rightCorner": {
              "x": 3.14,
              "y": -8.85,
              "z": 0.17
            },
            "gtin": "4066447349290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e85",
            "leftCorner": {
              "x": 3.14,
              "y": -8.85,
              "z": 0.17
            },
            "rightCorner": {
              "x": 3.199,
              "y": -8.898,
              "z": 0.17
            },
            "gtin": "4066447349290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e86",
            "leftCorner": {
              "x": 3.199,
              "y": -8.898,
              "z": 0.17
            },
            "rightCorner": {
              "x": 3.265,
              "y": -8.953,
              "z": 0.17
            }
          },
          {
            "id": "696ebf6f43c343680a270e87",
            "leftCorner": {
              "x": 3.265,
              "y": -8.953,
              "z": 0.17
            },
            "rightCorner": {
              "x": 3.321,
              "y": -8.999,
              "z": 0.17
            }
          },
          {
            "id": "696ebf6f43c343680a270e88",
            "leftCorner": {
              "x": 3.321,
              "y": -8.999,
              "z": 0.17
            },
            "rightCorner": {
              "x": 3.382,
              "y": -9.05,
              "z": 0.17
            },
            "gtin": "4066447349337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e89",
            "leftCorner": {
              "x": 3.382,
              "y": -9.05,
              "z": 0.17
            },
            "rightCorner": {
              "x": 3.461,
              "y": -9.116,
              "z": 0.17
            }
          },
          {
            "id": "696ebf6f43c343680a270e8a",
            "leftCorner": {
              "x": 3.461,
              "y": -9.116,
              "z": 0.17
            },
            "rightCorner": {
              "x": 3.495,
              "y": -9.145,
              "z": 0.17
            },
            "gtin": "4066447054637",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e8b",
            "leftCorner": {
              "x": 3.495,
              "y": -9.145,
              "z": 0.17
            },
            "rightCorner": {
              "x": 3.537,
              "y": -9.179,
              "z": 0.17
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a20",
        "height": 0.3913,
        "facings": [
          {
            "id": "696ebf6f43c343680a270dd8",
            "leftCorner": {
              "x": 2.779,
              "y": -8.549,
              "z": 0.391
            },
            "rightCorner": {
              "x": 2.918,
              "y": -8.663,
              "z": 0.391
            },
            "gtin": "4067796168365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270dda",
            "leftCorner": {
              "x": 2.918,
              "y": -8.663,
              "z": 0.391
            },
            "rightCorner": {
              "x": 2.989,
              "y": -8.722,
              "z": 0.391
            },
            "gtin": "4066447349313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ddb",
            "leftCorner": {
              "x": 2.989,
              "y": -8.722,
              "z": 0.391
            },
            "rightCorner": {
              "x": 3.039,
              "y": -8.764,
              "z": 0.391
            },
            "gtin": "4066447054651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ddc",
            "leftCorner": {
              "x": 3.039,
              "y": -8.764,
              "z": 0.391
            },
            "rightCorner": {
              "x": 3.099,
              "y": -8.814,
              "z": 0.391
            },
            "gtin": "4066447054651",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ddd",
            "leftCorner": {
              "x": 3.099,
              "y": -8.814,
              "z": 0.391
            },
            "rightCorner": {
              "x": 3.158,
              "y": -8.863,
              "z": 0.391
            },
            "gtin": "4066447054651",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dde",
            "leftCorner": {
              "x": 3.158,
              "y": -8.863,
              "z": 0.391
            },
            "rightCorner": {
              "x": 3.213,
              "y": -8.909,
              "z": 0.391
            },
            "gtin": "4066447054651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ddf",
            "leftCorner": {
              "x": 3.213,
              "y": -8.909,
              "z": 0.391
            },
            "rightCorner": {
              "x": 3.285,
              "y": -8.968,
              "z": 0.391
            },
            "gtin": "4066447231526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270de0",
            "leftCorner": {
              "x": 3.285,
              "y": -8.968,
              "z": 0.391
            },
            "rightCorner": {
              "x": 3.344,
              "y": -9.017,
              "z": 0.391
            },
            "gtin": "4066447239492",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270de1",
            "leftCorner": {
              "x": 3.344,
              "y": -9.017,
              "z": 0.391
            },
            "rightCorner": {
              "x": 3.406,
              "y": -9.069,
              "z": 0.391
            }
          },
          {
            "id": "696ebf6f43c343680a270de2",
            "leftCorner": {
              "x": 3.406,
              "y": -9.069,
              "z": 0.391
            },
            "rightCorner": {
              "x": 3.47,
              "y": -9.121,
              "z": 0.391
            },
            "gtin": "4066447239515",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270de3",
            "leftCorner": {
              "x": 3.47,
              "y": -9.121,
              "z": 0.391
            },
            "rightCorner": {
              "x": 3.53,
              "y": -9.172,
              "z": 0.391
            },
            "gtin": "4066447239539",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270de4",
            "leftCorner": {
              "x": 3.53,
              "y": -9.172,
              "z": 0.391
            },
            "rightCorner": {
              "x": 3.592,
              "y": -9.223,
              "z": 0.391
            },
            "gtin": "4066447239539",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a1f",
        "height": 0.63935,
        "facings": [
          {
            "id": "696ebf6f43c343680a270db8",
            "leftCorner": {
              "x": 2.783,
              "y": -8.545,
              "z": 0.639
            },
            "rightCorner": {
              "x": 2.859,
              "y": -8.608,
              "z": 0.639
            },
            "gtin": "4006000158747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270db9",
            "leftCorner": {
              "x": 2.859,
              "y": -8.608,
              "z": 0.639
            },
            "rightCorner": {
              "x": 2.914,
              "y": -8.654,
              "z": 0.639
            },
            "gtin": "4006000158747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270dba",
            "leftCorner": {
              "x": 2.914,
              "y": -8.654,
              "z": 0.639
            },
            "rightCorner": {
              "x": 2.979,
              "y": -8.708,
              "z": 0.639
            },
            "gtin": "4006000158747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270dbb",
            "leftCorner": {
              "x": 2.979,
              "y": -8.708,
              "z": 0.639
            },
            "rightCorner": {
              "x": 3.032,
              "y": -8.752,
              "z": 0.639
            },
            "gtin": "4006000063676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270dbc",
            "leftCorner": {
              "x": 3.032,
              "y": -8.752,
              "z": 0.639
            },
            "rightCorner": {
              "x": 3.085,
              "y": -8.796,
              "z": 0.639
            },
            "gtin": "4006000063836",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dbd",
            "leftCorner": {
              "x": 3.085,
              "y": -8.796,
              "z": 0.639
            },
            "rightCorner": {
              "x": 3.14,
              "y": -8.841,
              "z": 0.639
            },
            "gtin": "4006000063836",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dbe",
            "leftCorner": {
              "x": 3.14,
              "y": -8.841,
              "z": 0.639
            },
            "rightCorner": {
              "x": 3.193,
              "y": -8.885,
              "z": 0.639
            },
            "gtin": "4006000063836",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dbf",
            "leftCorner": {
              "x": 3.193,
              "y": -8.885,
              "z": 0.639
            },
            "rightCorner": {
              "x": 3.252,
              "y": -8.935,
              "z": 0.639
            },
            "gtin": "4006000063874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270dc0",
            "leftCorner": {
              "x": 3.252,
              "y": -8.935,
              "z": 0.639
            },
            "rightCorner": {
              "x": 3.309,
              "y": -8.982,
              "z": 0.639
            }
          },
          {
            "id": "696ebf6f43c343680a270dc1",
            "leftCorner": {
              "x": 3.309,
              "y": -8.982,
              "z": 0.639
            },
            "rightCorner": {
              "x": 3.376,
              "y": -9.038,
              "z": 0.639
            },
            "gtin": "4006000063591",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dc2",
            "leftCorner": {
              "x": 3.376,
              "y": -9.038,
              "z": 0.639
            },
            "rightCorner": {
              "x": 3.428,
              "y": -9.081,
              "z": 0.639
            },
            "gtin": "4006000063713",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dc3",
            "leftCorner": {
              "x": 3.428,
              "y": -9.081,
              "z": 0.639
            },
            "rightCorner": {
              "x": 3.48,
              "y": -9.123,
              "z": 0.639
            }
          },
          {
            "id": "696ebf6f43c343680a270dc4",
            "leftCorner": {
              "x": 3.48,
              "y": -9.123,
              "z": 0.639
            },
            "rightCorner": {
              "x": 3.55,
              "y": -9.182,
              "z": 0.639
            },
            "gtin": "5050456006793",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a21",
        "height": 0.89585,
        "facings": [
          {
            "id": "696ebf6f43c343680a270e04",
            "leftCorner": {
              "x": 2.779,
              "y": -8.549,
              "z": 0.896
            },
            "rightCorner": {
              "x": 2.841,
              "y": -8.601,
              "z": 0.896
            },
            "gtin": "3616303458904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e06",
            "leftCorner": {
              "x": 2.841,
              "y": -8.601,
              "z": 0.896
            },
            "rightCorner": {
              "x": 2.909,
              "y": -8.658,
              "z": 0.896
            },
            "gtin": "3616303458973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e07",
            "leftCorner": {
              "x": 2.909,
              "y": -8.658,
              "z": 0.896
            },
            "rightCorner": {
              "x": 2.957,
              "y": -8.697,
              "z": 0.896
            },
            "gtin": "8700216752589",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e08",
            "leftCorner": {
              "x": 2.957,
              "y": -8.697,
              "z": 0.896
            },
            "rightCorner": {
              "x": 3.002,
              "y": -8.734,
              "z": 0.896
            },
            "gtin": "8700216747592",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e09",
            "leftCorner": {
              "x": 3.002,
              "y": -8.734,
              "z": 0.896
            },
            "rightCorner": {
              "x": 3.041,
              "y": -8.767,
              "z": 0.896
            },
            "gtin": "8006540838945",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e0a",
            "leftCorner": {
              "x": 3.041,
              "y": -8.767,
              "z": 0.896
            },
            "rightCorner": {
              "x": 3.085,
              "y": -8.803,
              "z": 0.896
            },
            "gtin": "8006540842409",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e0b",
            "leftCorner": {
              "x": 3.085,
              "y": -8.803,
              "z": 0.896
            },
            "rightCorner": {
              "x": 3.146,
              "y": -8.854,
              "z": 0.896
            },
            "gtin": "5050456006885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e0c",
            "leftCorner": {
              "x": 3.146,
              "y": -8.854,
              "z": 0.896
            },
            "rightCorner": {
              "x": 3.21,
              "y": -8.907,
              "z": 0.896
            },
            "gtin": "8710447284117",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e0d",
            "leftCorner": {
              "x": 3.21,
              "y": -8.907,
              "z": 0.896
            },
            "rightCorner": {
              "x": 3.263,
              "y": -8.951,
              "z": 0.896
            },
            "gtin": "4015100864199",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e0e",
            "leftCorner": {
              "x": 3.263,
              "y": -8.951,
              "z": 0.896
            },
            "rightCorner": {
              "x": 3.303,
              "y": -8.985,
              "z": 0.896
            },
            "gtin": "4015100864212",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e0f",
            "leftCorner": {
              "x": 3.303,
              "y": -8.985,
              "z": 0.896
            },
            "rightCorner": {
              "x": 3.354,
              "y": -9.026,
              "z": 0.896
            },
            "gtin": "4015100864212",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e10",
            "leftCorner": {
              "x": 3.354,
              "y": -9.026,
              "z": 0.896
            },
            "rightCorner": {
              "x": 3.413,
              "y": -9.076,
              "z": 0.896
            },
            "gtin": "4015100864175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e11",
            "leftCorner": {
              "x": 3.413,
              "y": -9.076,
              "z": 0.896
            },
            "rightCorner": {
              "x": 3.462,
              "y": -9.116,
              "z": 0.896
            },
            "gtin": "4015100864175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e12",
            "leftCorner": {
              "x": 3.462,
              "y": -9.116,
              "z": 0.896
            },
            "rightCorner": {
              "x": 3.505,
              "y": -9.153,
              "z": 0.896
            },
            "gtin": "3616302035427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e13",
            "leftCorner": {
              "x": 3.505,
              "y": -9.153,
              "z": 0.896
            },
            "rightCorner": {
              "x": 3.542,
              "y": -9.183,
              "z": 0.896
            },
            "gtin": "3616302035465",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e14",
            "leftCorner": {
              "x": 3.547,
              "y": -9.193,
              "z": 0.898
            },
            "rightCorner": {
              "x": 3.583,
              "y": -9.222,
              "z": 0.898
            },
            "gtin": "3616302035458",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a22",
        "height": 1.1501,
        "facings": [
          {
            "id": "696ebf6f43c343680a270e37",
            "leftCorner": {
              "x": 2.782,
              "y": -8.546,
              "z": 1.15
            },
            "rightCorner": {
              "x": 2.843,
              "y": -8.596,
              "z": 1.15
            },
            "gtin": "4008890027011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e38",
            "leftCorner": {
              "x": 2.843,
              "y": -8.596,
              "z": 1.15
            },
            "rightCorner": {
              "x": 2.895,
              "y": -8.639,
              "z": 1.15
            },
            "gtin": "8720181302336",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e39",
            "leftCorner": {
              "x": 2.895,
              "y": -8.639,
              "z": 1.15
            },
            "rightCorner": {
              "x": 2.946,
              "y": -8.682,
              "z": 1.15
            },
            "gtin": "8720181302336",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e3a",
            "leftCorner": {
              "x": 2.946,
              "y": -8.682,
              "z": 1.15
            },
            "rightCorner": {
              "x": 3.003,
              "y": -8.729,
              "z": 1.15
            }
          },
          {
            "id": "696ebf6f43c343680a270e3b",
            "leftCorner": {
              "x": 3.003,
              "y": -8.729,
              "z": 1.15
            },
            "rightCorner": {
              "x": 3.063,
              "y": -8.779,
              "z": 1.15
            },
            "gtin": "8720181302053",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e3c",
            "leftCorner": {
              "x": 3.063,
              "y": -8.779,
              "z": 1.15
            },
            "rightCorner": {
              "x": 3.122,
              "y": -8.828,
              "z": 1.15
            },
            "gtin": "8720181302046",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e3d",
            "leftCorner": {
              "x": 3.122,
              "y": -8.828,
              "z": 1.15
            },
            "rightCorner": {
              "x": 3.202,
              "y": -8.894,
              "z": 1.15
            },
            "gtin": "4008268044459",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e3e",
            "leftCorner": {
              "x": 3.202,
              "y": -8.894,
              "z": 1.15
            },
            "rightCorner": {
              "x": 3.269,
              "y": -8.95,
              "z": 1.15
            },
            "gtin": "4008268044459",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e3f",
            "leftCorner": {
              "x": 3.269,
              "y": -8.95,
              "z": 1.15
            },
            "rightCorner": {
              "x": 3.339,
              "y": -9.008,
              "z": 1.15
            },
            "gtin": "4008268043605",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e40",
            "leftCorner": {
              "x": 3.339,
              "y": -9.008,
              "z": 1.15
            },
            "rightCorner": {
              "x": 3.395,
              "y": -9.054,
              "z": 1.15
            },
            "gtin": "3616305448286",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e41",
            "leftCorner": {
              "x": 3.395,
              "y": -9.054,
              "z": 1.15
            },
            "rightCorner": {
              "x": 3.45,
              "y": -9.1,
              "z": 1.15
            },
            "gtin": "3616305448378",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e42",
            "leftCorner": {
              "x": 3.45,
              "y": -9.1,
              "z": 1.15
            },
            "rightCorner": {
              "x": 3.5,
              "y": -9.141,
              "z": 1.15
            },
            "gtin": "8717163961988",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e43",
            "leftCorner": {
              "x": 3.5,
              "y": -9.141,
              "z": 1.15
            },
            "rightCorner": {
              "x": 3.541,
              "y": -9.175,
              "z": 1.15
            },
            "gtin": "8717163961988",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a23",
        "height": 1.4056,
        "facings": [
          {
            "id": "696ebf6f43c343680a270e65",
            "leftCorner": {
              "x": 2.785,
              "y": -8.542,
              "z": 1.406
            },
            "rightCorner": {
              "x": 2.85,
              "y": -8.597,
              "z": 1.406
            },
            "gtin": "8720181204081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e66",
            "leftCorner": {
              "x": 2.85,
              "y": -8.597,
              "z": 1.406
            },
            "rightCorner": {
              "x": 2.907,
              "y": -8.644,
              "z": 1.406
            },
            "gtin": "8720181204081",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e67",
            "leftCorner": {
              "x": 2.907,
              "y": -8.644,
              "z": 1.406
            },
            "rightCorner": {
              "x": 2.966,
              "y": -8.692,
              "z": 1.406
            },
            "gtin": "8710447276594",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e68",
            "leftCorner": {
              "x": 2.966,
              "y": -8.692,
              "z": 1.406
            },
            "rightCorner": {
              "x": 3.018,
              "y": -8.736,
              "z": 1.406
            },
            "gtin": "8720181601965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e69",
            "leftCorner": {
              "x": 3.018,
              "y": -8.736,
              "z": 1.406
            },
            "rightCorner": {
              "x": 3.08,
              "y": -8.787,
              "z": 1.406
            },
            "gtin": "8720181601941",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e6a",
            "leftCorner": {
              "x": 3.08,
              "y": -8.787,
              "z": 1.406
            },
            "rightCorner": {
              "x": 3.137,
              "y": -8.835,
              "z": 1.406
            },
            "gtin": "8720181208096",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e6b",
            "leftCorner": {
              "x": 3.137,
              "y": -8.835,
              "z": 1.406
            },
            "rightCorner": {
              "x": 3.196,
              "y": -8.884,
              "z": 1.406
            },
            "gtin": "3600524036607",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e6c",
            "leftCorner": {
              "x": 3.196,
              "y": -8.884,
              "z": 1.406
            },
            "rightCorner": {
              "x": 3.261,
              "y": -8.937,
              "z": 1.406
            },
            "gtin": "3600524036638",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e6d",
            "leftCorner": {
              "x": 3.261,
              "y": -8.937,
              "z": 1.406
            },
            "rightCorner": {
              "x": 3.33,
              "y": -8.995,
              "z": 1.406
            },
            "gtin": "3600524070328",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e6e",
            "leftCorner": {
              "x": 3.33,
              "y": -8.995,
              "z": 1.406
            },
            "rightCorner": {
              "x": 3.391,
              "y": -9.045,
              "z": 1.406
            },
            "gtin": "3600524187286",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e6f",
            "leftCorner": {
              "x": 3.391,
              "y": -9.045,
              "z": 1.406
            },
            "rightCorner": {
              "x": 3.453,
              "y": -9.097,
              "z": 1.406
            },
            "gtin": "3600524036621",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e70",
            "leftCorner": {
              "x": 3.453,
              "y": -9.097,
              "z": 1.406
            },
            "rightCorner": {
              "x": 3.554,
              "y": -9.181,
              "z": 1.406
            },
            "gtin": "4009800010888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e71",
            "leftCorner": {
              "x": 3.549,
              "y": -9.191,
              "z": 1.409
            },
            "rightCorner": {
              "x": 3.573,
              "y": -9.211,
              "z": 1.409
            },
            "gtin": "4009800010871",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a1e",
        "height": 1.6133,
        "facings": [
          {
            "id": "696ebf6f43c343680a270d80",
            "leftCorner": {
              "x": 2.78,
              "y": -8.548,
              "z": 1.613
            },
            "rightCorner": {
              "x": 2.863,
              "y": -8.618,
              "z": 1.613
            },
            "gtin": "4008233129518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d82",
            "leftCorner": {
              "x": 2.863,
              "y": -8.618,
              "z": 1.613
            },
            "rightCorner": {
              "x": 2.911,
              "y": -8.657,
              "z": 1.613
            },
            "gtin": "4009800010970",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d83",
            "leftCorner": {
              "x": 2.911,
              "y": -8.657,
              "z": 1.613
            },
            "rightCorner": {
              "x": 2.96,
              "y": -8.698,
              "z": 1.613
            }
          },
          {
            "id": "696ebf6f43c343680a270d84",
            "leftCorner": {
              "x": 2.96,
              "y": -8.698,
              "z": 1.613
            },
            "rightCorner": {
              "x": 3.004,
              "y": -8.735,
              "z": 1.613
            },
            "gtin": "4260380014608",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d85",
            "leftCorner": {
              "x": 3.004,
              "y": -8.735,
              "z": 1.613
            },
            "rightCorner": {
              "x": 3.133,
              "y": -8.841,
              "z": 1.613
            },
            "gtin": "7611916153600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d86",
            "leftCorner": {
              "x": 3.133,
              "y": -8.841,
              "z": 1.613
            },
            "rightCorner": {
              "x": 3.302,
              "y": -8.982,
              "z": 1.613
            },
            "gtin": "4066447523966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d87",
            "leftCorner": {
              "x": 3.302,
              "y": -8.982,
              "z": 1.613
            },
            "rightCorner": {
              "x": 3.355,
              "y": -9.026,
              "z": 1.613
            },
            "gtin": "4066447878240",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d88",
            "leftCorner": {
              "x": 3.355,
              "y": -9.026,
              "z": 1.613
            },
            "rightCorner": {
              "x": 3.411,
              "y": -9.072,
              "z": 1.613
            },
            "gtin": "4066447384055",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d89",
            "leftCorner": {
              "x": 3.411,
              "y": -9.072,
              "z": 1.613
            },
            "rightCorner": {
              "x": 3.483,
              "y": -9.132,
              "z": 1.613
            },
            "gtin": "4063528017796",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d8a",
            "leftCorner": {
              "x": 3.483,
              "y": -9.132,
              "z": 1.613
            },
            "rightCorner": {
              "x": 3.514,
              "y": -9.158,
              "z": 1.613
            },
            "gtin": "4063528008831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d8b",
            "leftCorner": {
              "x": 3.514,
              "y": -9.163,
              "z": 1.618
            },
            "rightCorner": {
              "x": 3.546,
              "y": -9.189,
              "z": 1.618
            },
            "gtin": "4066447710755",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc0469598f1",
    "name": "68e7571db5fe7bc0469598f1",
    "x": 3.5792,
    "y": -9.1563,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.35273,
      "w": 0.93572
    },
    "statistics": {
      "hasStockCount": 87,
      "noStockCount": 1,
      "unknownStockCount": 24
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73a2a",
        "height": 0.17338,
        "facings": [
          {
            "id": "696ebf6f43c343680a270e8c",
            "leftCorner": {
              "x": 3.537,
              "y": -9.179,
              "z": 0.17
            },
            "rightCorner": {
              "x": 3.59,
              "y": -9.223,
              "z": 0.17
            },
            "gtin": "4058172784316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e8d",
            "leftCorner": {
              "x": 3.589,
              "y": -9.227,
              "z": 0.173
            },
            "rightCorner": {
              "x": 3.644,
              "y": -9.274,
              "z": 0.173
            },
            "gtin": "4058172784316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e8e",
            "leftCorner": {
              "x": 3.644,
              "y": -9.274,
              "z": 0.173
            },
            "rightCorner": {
              "x": 3.687,
              "y": -9.313,
              "z": 0.173
            },
            "gtin": "4066447439229",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e8f",
            "leftCorner": {
              "x": 3.687,
              "y": -9.313,
              "z": 0.173
            },
            "rightCorner": {
              "x": 3.743,
              "y": -9.361,
              "z": 0.173
            },
            "gtin": "4066447413076",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e90",
            "leftCorner": {
              "x": 3.743,
              "y": -9.361,
              "z": 0.173
            },
            "rightCorner": {
              "x": 3.785,
              "y": -9.399,
              "z": 0.173
            },
            "gtin": "4066447413076",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e91",
            "leftCorner": {
              "x": 3.785,
              "y": -9.399,
              "z": 0.173
            },
            "rightCorner": {
              "x": 3.83,
              "y": -9.438,
              "z": 0.173
            }
          },
          {
            "id": "696ebf6f43c343680a270e92",
            "leftCorner": {
              "x": 3.83,
              "y": -9.438,
              "z": 0.173
            },
            "rightCorner": {
              "x": 3.872,
              "y": -9.475,
              "z": 0.173
            },
            "gtin": "4067796217759",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e93",
            "leftCorner": {
              "x": 3.872,
              "y": -9.475,
              "z": 0.173
            },
            "rightCorner": {
              "x": 3.917,
              "y": -9.514,
              "z": 0.173
            },
            "gtin": "4067796217759",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e94",
            "leftCorner": {
              "x": 3.917,
              "y": -9.514,
              "z": 0.173
            },
            "rightCorner": {
              "x": 3.96,
              "y": -9.553,
              "z": 0.173
            },
            "gtin": "4066447413113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e95",
            "leftCorner": {
              "x": 3.96,
              "y": -9.553,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.004,
              "y": -9.591,
              "z": 0.173
            },
            "gtin": "4066447413113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e96",
            "leftCorner": {
              "x": 4.004,
              "y": -9.591,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.04,
              "y": -9.623,
              "z": 0.173
            },
            "gtin": "4066447413083",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e97",
            "leftCorner": {
              "x": 4.04,
              "y": -9.623,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.085,
              "y": -9.662,
              "z": 0.173
            },
            "gtin": "4066447413083",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e98",
            "leftCorner": {
              "x": 4.085,
              "y": -9.662,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.12,
              "y": -9.693,
              "z": 0.173
            },
            "gtin": "4066447413083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e99",
            "leftCorner": {
              "x": 4.12,
              "y": -9.693,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.16,
              "y": -9.728,
              "z": 0.173
            },
            "gtin": "4066447413083",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e9a",
            "leftCorner": {
              "x": 4.16,
              "y": -9.728,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.203,
              "y": -9.766,
              "z": 0.173
            },
            "gtin": "4066447413090",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e9b",
            "leftCorner": {
              "x": 4.203,
              "y": -9.766,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.25,
              "y": -9.807,
              "z": 0.173
            },
            "gtin": "4066447413106",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e9c",
            "leftCorner": {
              "x": 4.25,
              "y": -9.807,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.289,
              "y": -9.841,
              "z": 0.173
            },
            "gtin": "4066447413106",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a25",
        "height": 0.39511,
        "facings": [
          {
            "id": "696ebf6f43c343680a270de5",
            "leftCorner": {
              "x": 3.59,
              "y": -9.228,
              "z": 0.395
            },
            "rightCorner": {
              "x": 3.652,
              "y": -9.282,
              "z": 0.395
            },
            "gtin": "8008970061061",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270de6",
            "leftCorner": {
              "x": 3.652,
              "y": -9.282,
              "z": 0.395
            },
            "rightCorner": {
              "x": 3.709,
              "y": -9.332,
              "z": 0.395
            },
            "gtin": "8008970061061",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270de7",
            "leftCorner": {
              "x": 3.709,
              "y": -9.332,
              "z": 0.395
            },
            "rightCorner": {
              "x": 3.752,
              "y": -9.37,
              "z": 0.395
            },
            "gtin": "8008970061054",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270de8",
            "leftCorner": {
              "x": 3.752,
              "y": -9.37,
              "z": 0.395
            },
            "rightCorner": {
              "x": 3.796,
              "y": -9.409,
              "z": 0.395
            },
            "gtin": "4066447276862",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270de9",
            "leftCorner": {
              "x": 3.796,
              "y": -9.409,
              "z": 0.395
            },
            "rightCorner": {
              "x": 3.838,
              "y": -9.446,
              "z": 0.395
            },
            "gtin": "4066447276862",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dea",
            "leftCorner": {
              "x": 3.838,
              "y": -9.446,
              "z": 0.395
            },
            "rightCorner": {
              "x": 3.887,
              "y": -9.489,
              "z": 0.395
            },
            "gtin": "4066447276848",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270deb",
            "leftCorner": {
              "x": 3.887,
              "y": -9.489,
              "z": 0.395
            },
            "rightCorner": {
              "x": 3.934,
              "y": -9.53,
              "z": 0.395
            },
            "gtin": "4066447276848",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dec",
            "leftCorner": {
              "x": 3.934,
              "y": -9.53,
              "z": 0.395
            },
            "rightCorner": {
              "x": 3.976,
              "y": -9.567,
              "z": 0.395
            },
            "gtin": "4066447276886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ded",
            "leftCorner": {
              "x": 3.976,
              "y": -9.567,
              "z": 0.395
            },
            "rightCorner": {
              "x": 4.018,
              "y": -9.604,
              "z": 0.395
            },
            "gtin": "4066447276886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270dee",
            "leftCorner": {
              "x": 4.018,
              "y": -9.604,
              "z": 0.395
            },
            "rightCorner": {
              "x": 4.055,
              "y": -9.637,
              "z": 0.395
            },
            "gtin": "8717524074951",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270def",
            "leftCorner": {
              "x": 4.055,
              "y": -9.637,
              "z": 0.395
            },
            "rightCorner": {
              "x": 4.095,
              "y": -9.671,
              "z": 0.395
            },
            "gtin": "8720181819391",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270df0",
            "leftCorner": {
              "x": 4.095,
              "y": -9.671,
              "z": 0.395
            },
            "rightCorner": {
              "x": 4.128,
              "y": -9.701,
              "z": 0.395
            },
            "gtin": "8712561254595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270df1",
            "leftCorner": {
              "x": 4.128,
              "y": -9.701,
              "z": 0.395
            },
            "rightCorner": {
              "x": 4.161,
              "y": -9.73,
              "z": 0.395
            },
            "gtin": "8712561254595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270df2",
            "leftCorner": {
              "x": 4.161,
              "y": -9.73,
              "z": 0.395
            },
            "rightCorner": {
              "x": 4.197,
              "y": -9.761,
              "z": 0.395
            },
            "gtin": "8720181296642",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270df3",
            "leftCorner": {
              "x": 4.197,
              "y": -9.761,
              "z": 0.395
            },
            "rightCorner": {
              "x": 4.238,
              "y": -9.797,
              "z": 0.395
            },
            "gtin": "8720181296642",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270df4",
            "leftCorner": {
              "x": 4.238,
              "y": -9.797,
              "z": 0.395
            },
            "rightCorner": {
              "x": 4.275,
              "y": -9.829,
              "z": 0.395
            },
            "gtin": "8720181284366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270df5",
            "leftCorner": {
              "x": 4.275,
              "y": -9.829,
              "z": 0.395
            },
            "rightCorner": {
              "x": 4.312,
              "y": -9.862,
              "z": 0.395
            },
            "gtin": "8720181284366",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a29",
        "height": 0.64466,
        "facings": [
          {
            "id": "696ebf6f43c343680a270dc5",
            "leftCorner": {
              "x": 3.55,
              "y": -9.182,
              "z": 0.639
            },
            "rightCorner": {
              "x": 3.597,
              "y": -9.22,
              "z": 0.639
            },
            "gtin": "4006000131467",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dc6",
            "leftCorner": {
              "x": 3.593,
              "y": -9.229,
              "z": 0.645
            },
            "rightCorner": {
              "x": 3.63,
              "y": -9.262,
              "z": 0.645
            }
          },
          {
            "id": "696ebf6f43c343680a270dc7",
            "leftCorner": {
              "x": 3.63,
              "y": -9.262,
              "z": 0.645
            },
            "rightCorner": {
              "x": 3.676,
              "y": -9.302,
              "z": 0.645
            },
            "gtin": "4006000092775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270dc8",
            "leftCorner": {
              "x": 3.676,
              "y": -9.302,
              "z": 0.645
            },
            "rightCorner": {
              "x": 3.704,
              "y": -9.327,
              "z": 0.645
            },
            "gtin": "4006000092775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270dc9",
            "leftCorner": {
              "x": 3.704,
              "y": -9.327,
              "z": 0.645
            },
            "rightCorner": {
              "x": 3.741,
              "y": -9.359,
              "z": 0.645
            }
          },
          {
            "id": "696ebf6f43c343680a270dca",
            "leftCorner": {
              "x": 3.741,
              "y": -9.359,
              "z": 0.645
            },
            "rightCorner": {
              "x": 3.775,
              "y": -9.389,
              "z": 0.645
            },
            "gtin": "4006000094212",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dcb",
            "leftCorner": {
              "x": 3.775,
              "y": -9.389,
              "z": 0.645
            },
            "rightCorner": {
              "x": 3.816,
              "y": -9.425,
              "z": 0.645
            },
            "gtin": "4006000094212",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dcc",
            "leftCorner": {
              "x": 3.816,
              "y": -9.425,
              "z": 0.645
            },
            "rightCorner": {
              "x": 3.847,
              "y": -9.452,
              "z": 0.645
            },
            "gtin": "4006000094175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dcd",
            "leftCorner": {
              "x": 3.847,
              "y": -9.452,
              "z": 0.645
            },
            "rightCorner": {
              "x": 3.883,
              "y": -9.484,
              "z": 0.645
            },
            "gtin": "4006000094175",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dce",
            "leftCorner": {
              "x": 3.883,
              "y": -9.484,
              "z": 0.645
            },
            "rightCorner": {
              "x": 3.922,
              "y": -9.518,
              "z": 0.645
            },
            "gtin": "4006000170466",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dcf",
            "leftCorner": {
              "x": 3.922,
              "y": -9.518,
              "z": 0.645
            },
            "rightCorner": {
              "x": 3.975,
              "y": -9.564,
              "z": 0.645
            }
          },
          {
            "id": "696ebf6f43c343680a270dd0",
            "leftCorner": {
              "x": 3.975,
              "y": -9.564,
              "z": 0.645
            },
            "rightCorner": {
              "x": 4.033,
              "y": -9.616,
              "z": 0.645
            },
            "gtin": "4006000168197",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270dd1",
            "leftCorner": {
              "x": 4.033,
              "y": -9.616,
              "z": 0.645
            },
            "rightCorner": {
              "x": 4.068,
              "y": -9.646,
              "z": 0.645
            },
            "gtin": "4006000094137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dd2",
            "leftCorner": {
              "x": 4.068,
              "y": -9.646,
              "z": 0.645
            },
            "rightCorner": {
              "x": 4.104,
              "y": -9.679,
              "z": 0.645
            },
            "gtin": "4006000094137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dd3",
            "leftCorner": {
              "x": 4.104,
              "y": -9.679,
              "z": 0.645
            },
            "rightCorner": {
              "x": 4.142,
              "y": -9.712,
              "z": 0.645
            },
            "gtin": "4015100863796",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dd4",
            "leftCorner": {
              "x": 4.142,
              "y": -9.712,
              "z": 0.645
            },
            "rightCorner": {
              "x": 4.183,
              "y": -9.748,
              "z": 0.645
            },
            "gtin": "4015100863796",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dd5",
            "leftCorner": {
              "x": 4.183,
              "y": -9.748,
              "z": 0.645
            },
            "rightCorner": {
              "x": 4.218,
              "y": -9.778,
              "z": 0.645
            },
            "gtin": "4015100863772",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dd6",
            "leftCorner": {
              "x": 4.218,
              "y": -9.778,
              "z": 0.645
            },
            "rightCorner": {
              "x": 4.252,
              "y": -9.808,
              "z": 0.645
            },
            "gtin": "3616307110730",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dd7",
            "leftCorner": {
              "x": 4.252,
              "y": -9.808,
              "z": 0.645
            },
            "rightCorner": {
              "x": 4.291,
              "y": -9.843,
              "z": 0.645
            },
            "gtin": "3616307110730",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a27",
        "height": 0.89835,
        "facings": [
          {
            "id": "696ebf6f43c343680a270e15",
            "leftCorner": {
              "x": 3.582,
              "y": -9.223,
              "z": 0.898
            },
            "rightCorner": {
              "x": 3.624,
              "y": -9.26,
              "z": 0.898
            },
            "gtin": "3616302035397",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e16",
            "leftCorner": {
              "x": 3.624,
              "y": -9.26,
              "z": 0.898
            },
            "rightCorner": {
              "x": 3.667,
              "y": -9.298,
              "z": 0.898
            },
            "gtin": "3616305886705",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e17",
            "leftCorner": {
              "x": 3.667,
              "y": -9.298,
              "z": 0.898
            },
            "rightCorner": {
              "x": 3.702,
              "y": -9.328,
              "z": 0.898
            },
            "gtin": "8720181452604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e18",
            "leftCorner": {
              "x": 3.702,
              "y": -9.328,
              "z": 0.898
            },
            "rightCorner": {
              "x": 3.739,
              "y": -9.361,
              "z": 0.898
            },
            "gtin": "8710447493953",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e19",
            "leftCorner": {
              "x": 3.739,
              "y": -9.361,
              "z": 0.898
            },
            "rightCorner": {
              "x": 3.772,
              "y": -9.39,
              "z": 0.898
            },
            "gtin": "8720181438752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e1a",
            "leftCorner": {
              "x": 3.772,
              "y": -9.39,
              "z": 0.898
            },
            "rightCorner": {
              "x": 3.826,
              "y": -9.437,
              "z": 0.898
            },
            "gtin": "8710447493915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e1b",
            "leftCorner": {
              "x": 3.826,
              "y": -9.437,
              "z": 0.898
            },
            "rightCorner": {
              "x": 3.881,
              "y": -9.486,
              "z": 0.898
            },
            "gtin": "8720181438738",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e1c",
            "leftCorner": {
              "x": 3.881,
              "y": -9.486,
              "z": 0.898
            },
            "rightCorner": {
              "x": 3.922,
              "y": -9.522,
              "z": 0.898
            },
            "gtin": "3600523715435",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e1d",
            "leftCorner": {
              "x": 3.922,
              "y": -9.522,
              "z": 0.898
            },
            "rightCorner": {
              "x": 3.962,
              "y": -9.557,
              "z": 0.898
            },
            "gtin": "3600523715473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e1e",
            "leftCorner": {
              "x": 3.962,
              "y": -9.557,
              "z": 0.898
            },
            "rightCorner": {
              "x": 3.997,
              "y": -9.588,
              "z": 0.898
            },
            "gtin": "3600523715473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e1f",
            "leftCorner": {
              "x": 3.997,
              "y": -9.588,
              "z": 0.898
            },
            "rightCorner": {
              "x": 4.042,
              "y": -9.627,
              "z": 0.898
            },
            "gtin": "3600524076672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e20",
            "leftCorner": {
              "x": 4.042,
              "y": -9.627,
              "z": 0.898
            },
            "rightCorner": {
              "x": 4.08,
              "y": -9.661,
              "z": 0.898
            },
            "gtin": "3600524076672",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e21",
            "leftCorner": {
              "x": 4.08,
              "y": -9.661,
              "z": 0.898
            },
            "rightCorner": {
              "x": 4.116,
              "y": -9.692,
              "z": 0.898
            },
            "gtin": "8700216606066",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e22",
            "leftCorner": {
              "x": 4.116,
              "y": -9.692,
              "z": 0.898
            },
            "rightCorner": {
              "x": 4.15,
              "y": -9.723,
              "z": 0.898
            },
            "gtin": "8700216605960",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e23",
            "leftCorner": {
              "x": 4.15,
              "y": -9.723,
              "z": 0.898
            },
            "rightCorner": {
              "x": 4.183,
              "y": -9.751,
              "z": 0.898
            },
            "gtin": "8700216606134",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e24",
            "leftCorner": {
              "x": 4.183,
              "y": -9.751,
              "z": 0.898
            },
            "rightCorner": {
              "x": 4.226,
              "y": -9.789,
              "z": 0.898
            },
            "gtin": "8700216606257",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e25",
            "leftCorner": {
              "x": 4.226,
              "y": -9.789,
              "z": 0.898
            },
            "rightCorner": {
              "x": 4.255,
              "y": -9.815,
              "z": 0.898
            },
            "gtin": "4058172508554",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e26",
            "leftCorner": {
              "x": 4.255,
              "y": -9.815,
              "z": 0.898
            },
            "rightCorner": {
              "x": 4.298,
              "y": -9.852,
              "z": 0.898
            },
            "gtin": "4066447855135",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a28",
        "height": 1.1545,
        "facings": [
          {
            "id": "696ebf6f43c343680a270e44",
            "leftCorner": {
              "x": 3.541,
              "y": -9.175,
              "z": 1.15
            },
            "rightCorner": {
              "x": 3.582,
              "y": -9.21,
              "z": 1.15
            },
            "gtin": "3014230021404",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e45",
            "leftCorner": {
              "x": 3.579,
              "y": -9.217,
              "z": 1.154
            },
            "rightCorner": {
              "x": 3.628,
              "y": -9.26,
              "z": 1.154
            },
            "gtin": "8720181205378",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e46",
            "leftCorner": {
              "x": 3.628,
              "y": -9.26,
              "z": 1.154
            },
            "rightCorner": {
              "x": 3.675,
              "y": -9.301,
              "z": 1.154
            },
            "gtin": "8720181590832",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e47",
            "leftCorner": {
              "x": 3.675,
              "y": -9.301,
              "z": 1.154
            },
            "rightCorner": {
              "x": 3.709,
              "y": -9.33,
              "z": 1.154
            },
            "gtin": "8720181025921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e48",
            "leftCorner": {
              "x": 3.709,
              "y": -9.33,
              "z": 1.154
            },
            "rightCorner": {
              "x": 3.749,
              "y": -9.365,
              "z": 1.154
            },
            "gtin": "8717163640777",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e49",
            "leftCorner": {
              "x": 3.749,
              "y": -9.365,
              "z": 1.154
            },
            "rightCorner": {
              "x": 3.785,
              "y": -9.398,
              "z": 1.154
            },
            "gtin": "8717163640777",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e4a",
            "leftCorner": {
              "x": 3.785,
              "y": -9.398,
              "z": 1.154
            },
            "rightCorner": {
              "x": 3.831,
              "y": -9.438,
              "z": 1.154
            },
            "gtin": "8710522368541",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e4b",
            "leftCorner": {
              "x": 3.831,
              "y": -9.438,
              "z": 1.154
            },
            "rightCorner": {
              "x": 3.87,
              "y": -9.472,
              "z": 1.154
            },
            "gtin": "8710522368541",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e4c",
            "leftCorner": {
              "x": 3.87,
              "y": -9.472,
              "z": 1.154
            },
            "rightCorner": {
              "x": 3.911,
              "y": -9.508,
              "z": 1.154
            },
            "gtin": "8720181434518",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e4d",
            "leftCorner": {
              "x": 3.911,
              "y": -9.508,
              "z": 1.154
            },
            "rightCorner": {
              "x": 3.952,
              "y": -9.544,
              "z": 1.154
            },
            "gtin": "8720181434518",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e4e",
            "leftCorner": {
              "x": 3.952,
              "y": -9.544,
              "z": 1.154
            },
            "rightCorner": {
              "x": 4.002,
              "y": -9.588,
              "z": 1.154
            },
            "gtin": "8710447484265",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e4f",
            "leftCorner": {
              "x": 4.002,
              "y": -9.588,
              "z": 1.154
            },
            "rightCorner": {
              "x": 4.045,
              "y": -9.626,
              "z": 1.154
            },
            "gtin": "8710447484265",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e50",
            "leftCorner": {
              "x": 4.045,
              "y": -9.626,
              "z": 1.154
            },
            "rightCorner": {
              "x": 4.086,
              "y": -9.661,
              "z": 1.154
            },
            "gtin": "8720181192098",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e51",
            "leftCorner": {
              "x": 4.086,
              "y": -9.661,
              "z": 1.154
            },
            "rightCorner": {
              "x": 4.123,
              "y": -9.694,
              "z": 1.154
            },
            "gtin": "8720181297601",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e52",
            "leftCorner": {
              "x": 4.123,
              "y": -9.694,
              "z": 1.154
            },
            "rightCorner": {
              "x": 4.165,
              "y": -9.731,
              "z": 1.154
            },
            "gtin": "8720181555671",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e53",
            "leftCorner": {
              "x": 4.165,
              "y": -9.731,
              "z": 1.154
            },
            "rightCorner": {
              "x": 4.215,
              "y": -9.775,
              "z": 1.154
            },
            "gtin": "8720181418402",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e54",
            "leftCorner": {
              "x": 4.215,
              "y": -9.775,
              "z": 1.154
            },
            "rightCorner": {
              "x": 4.253,
              "y": -9.809,
              "z": 1.154
            },
            "gtin": "59002192",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e55",
            "leftCorner": {
              "x": 4.253,
              "y": -9.809,
              "z": 1.154
            },
            "rightCorner": {
              "x": 4.292,
              "y": -9.843,
              "z": 1.154
            },
            "gtin": "8710447484296",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a2b",
        "height": 1.4086,
        "facings": [
          {
            "id": "696ebf6f43c343680a270e72",
            "leftCorner": {
              "x": 3.572,
              "y": -9.212,
              "z": 1.409
            },
            "rightCorner": {
              "x": 3.705,
              "y": -9.328,
              "z": 1.409
            },
            "gtin": "4067796183887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e73",
            "leftCorner": {
              "x": 3.705,
              "y": -9.328,
              "z": 1.409
            },
            "rightCorner": {
              "x": 3.784,
              "y": -9.398,
              "z": 1.409
            },
            "gtin": "4066447750652",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e74",
            "leftCorner": {
              "x": 3.784,
              "y": -9.398,
              "z": 1.409
            },
            "rightCorner": {
              "x": 3.86,
              "y": -9.465,
              "z": 1.409
            },
            "gtin": "4058172738999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e75",
            "leftCorner": {
              "x": 3.86,
              "y": -9.465,
              "z": 1.409
            },
            "rightCorner": {
              "x": 3.938,
              "y": -9.533,
              "z": 1.409
            },
            "gtin": "3600524196417",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e76",
            "leftCorner": {
              "x": 3.938,
              "y": -9.533,
              "z": 1.409
            },
            "rightCorner": {
              "x": 4.024,
              "y": -9.609,
              "z": 1.409
            },
            "gtin": "3600523741465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e77",
            "leftCorner": {
              "x": 4.024,
              "y": -9.609,
              "z": 1.409
            },
            "rightCorner": {
              "x": 4.1,
              "y": -9.676,
              "z": 1.409
            },
            "gtin": "3600523741427",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e78",
            "leftCorner": {
              "x": 4.1,
              "y": -9.676,
              "z": 1.409
            },
            "rightCorner": {
              "x": 4.135,
              "y": -9.706,
              "z": 1.409
            },
            "gtin": "42467434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e79",
            "leftCorner": {
              "x": 4.135,
              "y": -9.706,
              "z": 1.409
            },
            "rightCorner": {
              "x": 4.168,
              "y": -9.735,
              "z": 1.409
            },
            "gtin": "42449508",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e7a",
            "leftCorner": {
              "x": 4.168,
              "y": -9.735,
              "z": 1.409
            },
            "rightCorner": {
              "x": 4.201,
              "y": -9.764,
              "z": 1.409
            },
            "gtin": "42449294",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e7b",
            "leftCorner": {
              "x": 4.201,
              "y": -9.764,
              "z": 1.409
            },
            "rightCorner": {
              "x": 4.236,
              "y": -9.795,
              "z": 1.409
            },
            "gtin": "42449294",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e7c",
            "leftCorner": {
              "x": 4.236,
              "y": -9.795,
              "z": 1.409
            },
            "rightCorner": {
              "x": 4.267,
              "y": -9.823,
              "z": 1.409
            },
            "gtin": "42449249",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e7d",
            "leftCorner": {
              "x": 4.267,
              "y": -9.823,
              "z": 1.409
            },
            "rightCorner": {
              "x": 4.3,
              "y": -9.852,
              "z": 1.409
            },
            "gtin": "4006000099231",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a26",
        "height": 1.6175,
        "facings": [
          {
            "id": "696ebf6f43c343680a270d8c",
            "leftCorner": {
              "x": 3.545,
              "y": -9.19,
              "z": 1.617
            },
            "rightCorner": {
              "x": 3.58,
              "y": -9.219,
              "z": 1.617
            },
            "gtin": "4066447710731",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d8d",
            "leftCorner": {
              "x": 3.579,
              "y": -9.22,
              "z": 1.617
            },
            "rightCorner": {
              "x": 3.607,
              "y": -9.243,
              "z": 1.617
            },
            "gtin": "4066447330892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d8e",
            "leftCorner": {
              "x": 3.606,
              "y": -9.244,
              "z": 1.617
            },
            "rightCorner": {
              "x": 3.749,
              "y": -9.369,
              "z": 1.617
            },
            "gtin": "8700216203838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d8f",
            "leftCorner": {
              "x": 3.749,
              "y": -9.369,
              "z": 1.617
            },
            "rightCorner": {
              "x": 3.8,
              "y": -9.415,
              "z": 1.617
            },
            "gtin": "8001841923727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d90",
            "leftCorner": {
              "x": 3.8,
              "y": -9.415,
              "z": 1.617
            },
            "rightCorner": {
              "x": 3.849,
              "y": -9.457,
              "z": 1.617
            },
            "gtin": "8001841923802",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d91",
            "leftCorner": {
              "x": 3.849,
              "y": -9.457,
              "z": 1.617
            },
            "rightCorner": {
              "x": 3.9,
              "y": -9.502,
              "z": 1.617
            },
            "gtin": "8001841923840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d92",
            "leftCorner": {
              "x": 3.9,
              "y": -9.502,
              "z": 1.617
            },
            "rightCorner": {
              "x": 3.952,
              "y": -9.548,
              "z": 1.617
            },
            "gtin": "8700216607421",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d93",
            "leftCorner": {
              "x": 3.952,
              "y": -9.548,
              "z": 1.617
            },
            "rightCorner": {
              "x": 4.002,
              "y": -9.592,
              "z": 1.617
            },
            "gtin": "59002192",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d94",
            "leftCorner": {
              "x": 4.002,
              "y": -9.592,
              "z": 1.617
            },
            "rightCorner": {
              "x": 4.041,
              "y": -9.626,
              "z": 1.617
            },
            "gtin": "4067796217735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d95",
            "leftCorner": {
              "x": 4.041,
              "y": -9.626,
              "z": 1.617
            },
            "rightCorner": {
              "x": 4.08,
              "y": -9.661,
              "z": 1.617
            },
            "gtin": "59097990",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d96",
            "leftCorner": {
              "x": 4.08,
              "y": -9.661,
              "z": 1.617
            },
            "rightCorner": {
              "x": 4.126,
              "y": -9.701,
              "z": 1.617
            },
            "gtin": "59097983",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d97",
            "leftCorner": {
              "x": 4.126,
              "y": -9.701,
              "z": 1.617
            },
            "rightCorner": {
              "x": 4.156,
              "y": -9.727,
              "z": 1.617
            },
            "gtin": "59097730",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d98",
            "leftCorner": {
              "x": 4.156,
              "y": -9.727,
              "z": 1.617
            },
            "rightCorner": {
              "x": 4.202,
              "y": -9.768,
              "z": 1.617
            },
            "gtin": "8718114202402",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d99",
            "leftCorner": {
              "x": 4.202,
              "y": -9.768,
              "z": 1.617
            },
            "rightCorner": {
              "x": 4.271,
              "y": -9.828,
              "z": 1.617
            },
            "gtin": "59099727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d9a",
            "leftCorner": {
              "x": 4.271,
              "y": -9.828,
              "z": 1.617
            },
            "rightCorner": {
              "x": 4.321,
              "y": -9.872,
              "z": 1.617
            },
            "gtin": "59092575",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc0469598f2",
    "name": "68e7571db5fe7bc0469598f2",
    "x": 4.3283,
    "y": -9.8223,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.35525,
      "w": 0.93477
    },
    "statistics": {
      "hasStockCount": 80,
      "noStockCount": 1,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73a33",
        "height": 0.17264,
        "facings": [
          {
            "id": "696ebf6f43c343680a270e9d",
            "leftCorner": {
              "x": 4.289,
              "y": -9.841,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.335,
              "y": -9.882,
              "z": 0.173
            },
            "gtin": "4001638098816",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e9e",
            "leftCorner": {
              "x": 4.333,
              "y": -9.887,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.383,
              "y": -9.931,
              "z": 0.173
            },
            "gtin": "4001638095747",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e9f",
            "leftCorner": {
              "x": 4.383,
              "y": -9.931,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.438,
              "y": -9.98,
              "z": 0.173
            },
            "gtin": "4009800001855",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ea0",
            "leftCorner": {
              "x": 4.438,
              "y": -9.98,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.507,
              "y": -10.041,
              "z": 0.173
            },
            "gtin": "4006000195230",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ea1",
            "leftCorner": {
              "x": 4.507,
              "y": -10.041,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.563,
              "y": -10.091,
              "z": 0.173
            },
            "gtin": "4006000195032",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ea2",
            "leftCorner": {
              "x": 4.563,
              "y": -10.091,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.64,
              "y": -10.159,
              "z": 0.173
            },
            "gtin": "4006000195070",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ea3",
            "leftCorner": {
              "x": 4.64,
              "y": -10.159,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.683,
              "y": -10.198,
              "z": 0.173
            },
            "gtin": "4027800325405",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ea4",
            "leftCorner": {
              "x": 4.683,
              "y": -10.198,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.739,
              "y": -10.247,
              "z": 0.173
            },
            "gtin": "4058172926341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ea5",
            "leftCorner": {
              "x": 4.739,
              "y": -10.247,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.786,
              "y": -10.289,
              "z": 0.173
            },
            "gtin": "4066447710618",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ea6",
            "leftCorner": {
              "x": 4.786,
              "y": -10.289,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.838,
              "y": -10.336,
              "z": 0.173
            },
            "gtin": "4066447506280",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ea7",
            "leftCorner": {
              "x": 4.838,
              "y": -10.336,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.894,
              "y": -10.385,
              "z": 0.173
            },
            "gtin": "4066447506259",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ea8",
            "leftCorner": {
              "x": 4.894,
              "y": -10.385,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.966,
              "y": -10.449,
              "z": 0.173
            },
            "gtin": "4066447506273",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ea9",
            "leftCorner": {
              "x": 4.966,
              "y": -10.449,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.999,
              "y": -10.478,
              "z": 0.173
            },
            "gtin": "4001638098809",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270eaa",
            "leftCorner": {
              "x": 5.012,
              "y": -10.489,
              "z": 0.176
            },
            "rightCorner": {
              "x": 5.052,
              "y": -10.524,
              "z": 0.176
            },
            "gtin": "4001638086561",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a32",
        "height": 0.39662,
        "facings": [
          {
            "id": "696ebf6f43c343680a270df6",
            "leftCorner": {
              "x": 4.317,
              "y": -9.86,
              "z": 0.397
            },
            "rightCorner": {
              "x": 4.357,
              "y": -9.896,
              "z": 0.397
            },
            "gtin": "4058172702952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270df7",
            "leftCorner": {
              "x": 4.357,
              "y": -9.896,
              "z": 0.397
            },
            "rightCorner": {
              "x": 4.398,
              "y": -9.933,
              "z": 0.397
            },
            "gtin": "4058172508493",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270df8",
            "leftCorner": {
              "x": 4.398,
              "y": -9.933,
              "z": 0.397
            },
            "rightCorner": {
              "x": 4.458,
              "y": -9.986,
              "z": 0.397
            },
            "gtin": "4058172773440",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270df9",
            "leftCorner": {
              "x": 4.458,
              "y": -9.986,
              "z": 0.397
            },
            "rightCorner": {
              "x": 4.51,
              "y": -10.032,
              "z": 0.397
            },
            "gtin": "4066447854992",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dfa",
            "leftCorner": {
              "x": 4.51,
              "y": -10.032,
              "z": 0.397
            },
            "rightCorner": {
              "x": 4.575,
              "y": -10.09,
              "z": 0.397
            },
            "gtin": "4066447854824",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dfb",
            "leftCorner": {
              "x": 4.575,
              "y": -10.09,
              "z": 0.397
            },
            "rightCorner": {
              "x": 4.601,
              "y": -10.113,
              "z": 0.397
            },
            "gtin": "4066447855050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dfc",
            "leftCorner": {
              "x": 4.601,
              "y": -10.113,
              "z": 0.397
            },
            "rightCorner": {
              "x": 4.627,
              "y": -10.136,
              "z": 0.397
            },
            "gtin": "4066447855050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dfd",
            "leftCorner": {
              "x": 4.627,
              "y": -10.136,
              "z": 0.397
            },
            "rightCorner": {
              "x": 4.651,
              "y": -10.157,
              "z": 0.397
            },
            "gtin": "4058172879609",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dfe",
            "leftCorner": {
              "x": 4.651,
              "y": -10.157,
              "z": 0.397
            },
            "rightCorner": {
              "x": 4.696,
              "y": -10.197,
              "z": 0.397
            },
            "gtin": "4066447855210",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dff",
            "leftCorner": {
              "x": 4.696,
              "y": -10.197,
              "z": 0.397
            },
            "rightCorner": {
              "x": 4.754,
              "y": -10.249,
              "z": 0.397
            },
            "gtin": "4066447245165",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e00",
            "leftCorner": {
              "x": 4.754,
              "y": -10.249,
              "z": 0.397
            },
            "rightCorner": {
              "x": 4.824,
              "y": -10.311,
              "z": 0.397
            },
            "gtin": "4066447854886",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e01",
            "leftCorner": {
              "x": 4.824,
              "y": -10.311,
              "z": 0.397
            },
            "rightCorner": {
              "x": 4.865,
              "y": -10.348,
              "z": 0.397
            },
            "gtin": "4066447876055",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e02",
            "leftCorner": {
              "x": 4.865,
              "y": -10.348,
              "z": 0.397
            },
            "rightCorner": {
              "x": 4.925,
              "y": -10.401,
              "z": 0.397
            },
            "gtin": "4066447382211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e03",
            "leftCorner": {
              "x": 4.925,
              "y": -10.401,
              "z": 0.397
            },
            "rightCorner": {
              "x": 4.98,
              "y": -10.45,
              "z": 0.397
            },
            "gtin": "4066447245134",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dd9",
            "leftCorner": {
              "x": 4.98,
              "y": -10.45,
              "z": 0.397
            },
            "rightCorner": {
              "x": 5.052,
              "y": -10.513,
              "z": 0.397
            },
            "gtin": "4066447245103",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a31",
        "height": 0.6267,
        "facings": [
          {
            "id": "696ebf6f43c343680a270efa",
            "leftCorner": {
              "x": 4.295,
              "y": -9.859,
              "z": 0.627
            },
            "rightCorner": {
              "x": 4.354,
              "y": -9.912,
              "z": 0.627
            },
            "gtin": "4066447501179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270efc",
            "leftCorner": {
              "x": 4.354,
              "y": -9.912,
              "z": 0.627
            },
            "rightCorner": {
              "x": 4.398,
              "y": -9.951,
              "z": 0.627
            },
            "gtin": "4058172508455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270efd",
            "leftCorner": {
              "x": 4.398,
              "y": -9.951,
              "z": 0.627
            },
            "rightCorner": {
              "x": 4.467,
              "y": -10.012,
              "z": 0.627
            },
            "gtin": "4058172937811",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270efe",
            "leftCorner": {
              "x": 4.467,
              "y": -10.012,
              "z": 0.627
            },
            "rightCorner": {
              "x": 4.502,
              "y": -10.044,
              "z": 0.627
            },
            "gtin": "4058172823084",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270eff",
            "leftCorner": {
              "x": 4.502,
              "y": -10.044,
              "z": 0.627
            },
            "rightCorner": {
              "x": 4.53,
              "y": -10.068,
              "z": 0.627
            },
            "gtin": "4067796180305",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f00",
            "leftCorner": {
              "x": 4.53,
              "y": -10.068,
              "z": 0.627
            },
            "rightCorner": {
              "x": 4.595,
              "y": -10.126,
              "z": 0.627
            },
            "gtin": "4066447492200",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f01",
            "leftCorner": {
              "x": 4.595,
              "y": -10.126,
              "z": 0.627
            },
            "rightCorner": {
              "x": 4.646,
              "y": -10.171,
              "z": 0.627
            },
            "gtin": "4066447855357",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f02",
            "leftCorner": {
              "x": 4.646,
              "y": -10.171,
              "z": 0.627
            },
            "rightCorner": {
              "x": 4.68,
              "y": -10.202,
              "z": 0.627
            },
            "gtin": "4058172508578",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f03",
            "leftCorner": {
              "x": 4.68,
              "y": -10.202,
              "z": 0.627
            },
            "rightCorner": {
              "x": 4.725,
              "y": -10.242,
              "z": 0.627
            },
            "gtin": "4066447855234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f04",
            "leftCorner": {
              "x": 4.725,
              "y": -10.242,
              "z": 0.627
            },
            "rightCorner": {
              "x": 4.796,
              "y": -10.305,
              "z": 0.627
            },
            "gtin": "4066447855111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f05",
            "leftCorner": {
              "x": 4.796,
              "y": -10.305,
              "z": 0.627
            },
            "rightCorner": {
              "x": 4.866,
              "y": -10.366,
              "z": 0.627
            },
            "gtin": "4067796148787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f06",
            "leftCorner": {
              "x": 4.866,
              "y": -10.366,
              "z": 0.627
            },
            "rightCorner": {
              "x": 4.893,
              "y": -10.391,
              "z": 0.627
            },
            "gtin": "4058172681646",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f07",
            "leftCorner": {
              "x": 4.893,
              "y": -10.391,
              "z": 0.627
            },
            "rightCorner": {
              "x": 4.953,
              "y": -10.444,
              "z": 0.627
            },
            "gtin": "4066447302219",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270efb",
            "leftCorner": {
              "x": 4.953,
              "y": -10.444,
              "z": 0.627
            },
            "rightCorner": {
              "x": 5.043,
              "y": -10.524,
              "z": 0.627
            },
            "gtin": "4066447710540",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a2e",
        "height": 0.9001,
        "facings": [
          {
            "id": "696ebf6f43c343680a270e27",
            "leftCorner": {
              "x": 4.298,
              "y": -9.852,
              "z": 0.898
            },
            "rightCorner": {
              "x": 4.341,
              "y": -9.89,
              "z": 0.898
            },
            "gtin": "4058172923890",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e28",
            "leftCorner": {
              "x": 4.346,
              "y": -9.888,
              "z": 0.9
            },
            "rightCorner": {
              "x": 4.393,
              "y": -9.93,
              "z": 0.9
            },
            "gtin": "3600524195632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e29",
            "leftCorner": {
              "x": 4.393,
              "y": -9.93,
              "z": 0.9
            },
            "rightCorner": {
              "x": 4.433,
              "y": -9.966,
              "z": 0.9
            },
            "gtin": "3600524190439",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e2a",
            "leftCorner": {
              "x": 4.433,
              "y": -9.966,
              "z": 0.9
            },
            "rightCorner": {
              "x": 4.47,
              "y": -9.998,
              "z": 0.9
            },
            "gtin": "3600524191047",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e2b",
            "leftCorner": {
              "x": 4.47,
              "y": -9.998,
              "z": 0.9
            },
            "rightCorner": {
              "x": 4.506,
              "y": -10.031,
              "z": 0.9
            },
            "gtin": "3600523718207",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e2c",
            "leftCorner": {
              "x": 4.506,
              "y": -10.031,
              "z": 0.9
            },
            "rightCorner": {
              "x": 4.543,
              "y": -10.063,
              "z": 0.9
            },
            "gtin": "3600523950102",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e2d",
            "leftCorner": {
              "x": 4.543,
              "y": -10.063,
              "z": 0.9
            },
            "rightCorner": {
              "x": 4.587,
              "y": -10.103,
              "z": 0.9
            },
            "gtin": "3600524070779",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e2e",
            "leftCorner": {
              "x": 4.587,
              "y": -10.103,
              "z": 0.9
            },
            "rightCorner": {
              "x": 4.628,
              "y": -10.139,
              "z": 0.9
            },
            "gtin": "3600524070762",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e2f",
            "leftCorner": {
              "x": 4.628,
              "y": -10.139,
              "z": 0.9
            },
            "rightCorner": {
              "x": 4.668,
              "y": -10.174,
              "z": 0.9
            },
            "gtin": "3600524070793",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e30",
            "leftCorner": {
              "x": 4.668,
              "y": -10.174,
              "z": 0.9
            },
            "rightCorner": {
              "x": 4.706,
              "y": -10.209,
              "z": 0.9
            },
            "gtin": "3600523708024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e31",
            "leftCorner": {
              "x": 4.706,
              "y": -10.209,
              "z": 0.9
            },
            "rightCorner": {
              "x": 4.763,
              "y": -10.259,
              "z": 0.9
            },
            "gtin": "3600522233039",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e32",
            "leftCorner": {
              "x": 4.763,
              "y": -10.259,
              "z": 0.9
            },
            "rightCorner": {
              "x": 4.805,
              "y": -10.296,
              "z": 0.9
            },
            "gtin": "3600524070755",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e33",
            "leftCorner": {
              "x": 4.805,
              "y": -10.296,
              "z": 0.9
            },
            "rightCorner": {
              "x": 4.847,
              "y": -10.334,
              "z": 0.9
            },
            "gtin": "3600524071004",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e34",
            "leftCorner": {
              "x": 4.847,
              "y": -10.334,
              "z": 0.9
            },
            "rightCorner": {
              "x": 4.888,
              "y": -10.37,
              "z": 0.9
            },
            "gtin": "3600524125752",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e35",
            "leftCorner": {
              "x": 4.888,
              "y": -10.37,
              "z": 0.9
            },
            "rightCorner": {
              "x": 4.93,
              "y": -10.407,
              "z": 0.9
            },
            "gtin": "3600524125752",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e36",
            "leftCorner": {
              "x": 4.93,
              "y": -10.407,
              "z": 0.9
            },
            "rightCorner": {
              "x": 5.006,
              "y": -10.474,
              "z": 0.9
            },
            "gtin": "3600524075835",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e05",
            "leftCorner": {
              "x": 5.006,
              "y": -10.474,
              "z": 0.9
            },
            "rightCorner": {
              "x": 5.051,
              "y": -10.515,
              "z": 0.9
            },
            "gtin": "3600524074494",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a2f",
        "height": 1.157,
        "facings": [
          {
            "id": "696ebf6f43c343680a270e56",
            "leftCorner": {
              "x": 4.292,
              "y": -9.843,
              "z": 1.154
            },
            "rightCorner": {
              "x": 4.332,
              "y": -9.878,
              "z": 1.154
            },
            "gtin": "3600524195670",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e57",
            "leftCorner": {
              "x": 4.332,
              "y": -9.882,
              "z": 1.157
            },
            "rightCorner": {
              "x": 4.373,
              "y": -9.918,
              "z": 1.157
            },
            "gtin": "4262391992531",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e58",
            "leftCorner": {
              "x": 4.373,
              "y": -9.918,
              "z": 1.157
            },
            "rightCorner": {
              "x": 4.413,
              "y": -9.953,
              "z": 1.157
            },
            "gtin": "4262391992494",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e59",
            "leftCorner": {
              "x": 4.413,
              "y": -9.953,
              "z": 1.157
            },
            "rightCorner": {
              "x": 4.487,
              "y": -10.019,
              "z": 1.157
            },
            "gtin": "4005900107305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270e5a",
            "leftCorner": {
              "x": 4.487,
              "y": -10.019,
              "z": 1.157
            },
            "rightCorner": {
              "x": 4.529,
              "y": -10.056,
              "z": 1.157
            },
            "gtin": "4006000164700",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e5b",
            "leftCorner": {
              "x": 4.529,
              "y": -10.056,
              "z": 1.157
            },
            "rightCorner": {
              "x": 4.565,
              "y": -10.088,
              "z": 1.157
            },
            "gtin": "4006000164502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e5c",
            "leftCorner": {
              "x": 4.565,
              "y": -10.088,
              "z": 1.157
            },
            "rightCorner": {
              "x": 4.586,
              "y": -10.107,
              "z": 1.157
            },
            "gtin": "4006000020068",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e5d",
            "leftCorner": {
              "x": 4.586,
              "y": -10.107,
              "z": 1.157
            },
            "rightCorner": {
              "x": 4.627,
              "y": -10.143,
              "z": 1.157
            },
            "gtin": "4006000020068",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e5e",
            "leftCorner": {
              "x": 4.627,
              "y": -10.143,
              "z": 1.157
            },
            "rightCorner": {
              "x": 4.704,
              "y": -10.212,
              "z": 1.157
            },
            "gtin": "4006000002217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e5f",
            "leftCorner": {
              "x": 4.704,
              "y": -10.212,
              "z": 1.157
            },
            "rightCorner": {
              "x": 4.766,
              "y": -10.267,
              "z": 1.157
            },
            "gtin": "4006000164625",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e60",
            "leftCorner": {
              "x": 4.766,
              "y": -10.267,
              "z": 1.157
            },
            "rightCorner": {
              "x": 4.818,
              "y": -10.313,
              "z": 1.157
            },
            "gtin": "4006000196398",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e61",
            "leftCorner": {
              "x": 4.818,
              "y": -10.313,
              "z": 1.157
            },
            "rightCorner": {
              "x": 4.871,
              "y": -10.361,
              "z": 1.157
            },
            "gtin": "4006000196350",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e62",
            "leftCorner": {
              "x": 4.871,
              "y": -10.361,
              "z": 1.157
            },
            "rightCorner": {
              "x": 4.945,
              "y": -10.426,
              "z": 1.157
            },
            "gtin": "4006000164588",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e63",
            "leftCorner": {
              "x": 4.945,
              "y": -10.426,
              "z": 1.157
            },
            "rightCorner": {
              "x": 5.003,
              "y": -10.478,
              "z": 1.157
            },
            "gtin": "4006000164663",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270e64",
            "leftCorner": {
              "x": 5.003,
              "y": -10.478,
              "z": 1.157
            },
            "rightCorner": {
              "x": 5.046,
              "y": -10.516,
              "z": 1.157
            },
            "gtin": "4006000164748",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a30",
        "height": 1.3684,
        "facings": [
          {
            "id": "696ebf6f43c343680a270eed",
            "leftCorner": {
              "x": 4.305,
              "y": -9.849,
              "z": 1.368
            },
            "rightCorner": {
              "x": 4.399,
              "y": -9.933,
              "z": 1.368
            },
            "gtin": "4037900600029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270eee",
            "leftCorner": {
              "x": 4.399,
              "y": -9.933,
              "z": 1.368
            },
            "rightCorner": {
              "x": 4.437,
              "y": -9.966,
              "z": 1.368
            },
            "gtin": "7350113022257",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270eef",
            "leftCorner": {
              "x": 4.437,
              "y": -9.966,
              "z": 1.368
            },
            "rightCorner": {
              "x": 4.489,
              "y": -10.012,
              "z": 1.368
            },
            "gtin": "4006000121116",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ef0",
            "leftCorner": {
              "x": 4.489,
              "y": -10.012,
              "z": 1.368
            },
            "rightCorner": {
              "x": 4.524,
              "y": -10.044,
              "z": 1.368
            },
            "gtin": "4260380010679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ef1",
            "leftCorner": {
              "x": 4.524,
              "y": -10.044,
              "z": 1.368
            },
            "rightCorner": {
              "x": 4.597,
              "y": -10.109,
              "z": 1.368
            },
            "gtin": "4260380010662",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ef2",
            "leftCorner": {
              "x": 4.597,
              "y": -10.109,
              "z": 1.368
            },
            "rightCorner": {
              "x": 4.669,
              "y": -10.173,
              "z": 1.368
            },
            "gtin": "4260380014134",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ef3",
            "leftCorner": {
              "x": 4.669,
              "y": -10.173,
              "z": 1.368
            },
            "rightCorner": {
              "x": 4.728,
              "y": -10.225,
              "z": 1.368
            },
            "gtin": "4066447341881",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ef4",
            "leftCorner": {
              "x": 4.728,
              "y": -10.225,
              "z": 1.368
            },
            "rightCorner": {
              "x": 4.81,
              "y": -10.298,
              "z": 1.368
            },
            "gtin": "4066447277241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ef5",
            "leftCorner": {
              "x": 4.81,
              "y": -10.298,
              "z": 1.368
            },
            "rightCorner": {
              "x": 4.867,
              "y": -10.349,
              "z": 1.368
            },
            "gtin": "4067796069204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ef6",
            "leftCorner": {
              "x": 4.867,
              "y": -10.349,
              "z": 1.368
            },
            "rightCorner": {
              "x": 4.913,
              "y": -10.389,
              "z": 1.368
            },
            "gtin": "4058172785085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ef7",
            "leftCorner": {
              "x": 4.913,
              "y": -10.389,
              "z": 1.368
            },
            "rightCorner": {
              "x": 4.948,
              "y": -10.42,
              "z": 1.368
            },
            "gtin": "4066447871159",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ef8",
            "leftCorner": {
              "x": 4.948,
              "y": -10.42,
              "z": 1.368
            },
            "rightCorner": {
              "x": 4.992,
              "y": -10.46,
              "z": 1.368
            },
            "gtin": "4066447053579",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ef9",
            "leftCorner": {
              "x": 4.992,
              "y": -10.46,
              "z": 1.368
            },
            "rightCorner": {
              "x": 5.033,
              "y": -10.496,
              "z": 1.368
            },
            "gtin": "4262391992470",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a2d",
        "height": 1.62,
        "facings": [
          {
            "id": "696ebf6f43c343680a270d9b",
            "leftCorner": {
              "x": 4.326,
              "y": -9.871,
              "z": 1.62
            },
            "rightCorner": {
              "x": 4.376,
              "y": -9.915,
              "z": 1.62
            },
            "gtin": "3600524062651",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d9c",
            "leftCorner": {
              "x": 4.376,
              "y": -9.915,
              "z": 1.62
            },
            "rightCorner": {
              "x": 4.419,
              "y": -9.953,
              "z": 1.62
            },
            "gtin": "3600523526109",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d9d",
            "leftCorner": {
              "x": 4.419,
              "y": -9.953,
              "z": 1.62
            },
            "rightCorner": {
              "x": 4.47,
              "y": -9.999,
              "z": 1.62
            },
            "gtin": "3600523816262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d9e",
            "leftCorner": {
              "x": 4.47,
              "y": -9.999,
              "z": 1.62
            },
            "rightCorner": {
              "x": 4.528,
              "y": -10.051,
              "z": 1.62
            },
            "gtin": "8001841693934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d9f",
            "leftCorner": {
              "x": 4.528,
              "y": -10.051,
              "z": 1.62
            },
            "rightCorner": {
              "x": 4.603,
              "y": -10.117,
              "z": 1.62
            },
            "gtin": "8001841694016",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270da0",
            "leftCorner": {
              "x": 4.603,
              "y": -10.117,
              "z": 1.62
            },
            "rightCorner": {
              "x": 4.658,
              "y": -10.166,
              "z": 1.62
            },
            "gtin": "8006540470374",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270da1",
            "leftCorner": {
              "x": 4.658,
              "y": -10.166,
              "z": 1.62
            },
            "rightCorner": {
              "x": 4.727,
              "y": -10.227,
              "z": 1.62
            },
            "gtin": "4066447341867",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270da2",
            "leftCorner": {
              "x": 4.727,
              "y": -10.227,
              "z": 1.62
            },
            "rightCorner": {
              "x": 4.816,
              "y": -10.306,
              "z": 1.62
            },
            "gtin": "4058172432088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270da3",
            "leftCorner": {
              "x": 4.816,
              "y": -10.306,
              "z": 1.62
            },
            "rightCorner": {
              "x": 4.948,
              "y": -10.423,
              "z": 1.62
            },
            "gtin": "4066447107111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270da4",
            "leftCorner": {
              "x": 4.948,
              "y": -10.423,
              "z": 1.62
            },
            "rightCorner": {
              "x": 4.974,
              "y": -10.447,
              "z": 1.62
            },
            "gtin": "4067796178500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270da5",
            "leftCorner": {
              "x": 4.986,
              "y": -10.459,
              "z": 1.623
            },
            "rightCorner": {
              "x": 5.016,
              "y": -10.486,
              "z": 1.623
            },
            "gtin": "5060896576893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270da6",
            "leftCorner": {
              "x": 5.016,
              "y": -10.485,
              "z": 1.623
            },
            "rightCorner": {
              "x": 5.05,
              "y": -10.516,
              "z": 1.623
            },
            "gtin": "5060896573571",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc0469598f3",
    "name": "68e7571db5fe7bc0469598f3",
    "x": 5.0892,
    "y": -10.496,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.35133,
      "w": 0.93625
    },
    "statistics": {
      "hasStockCount": 38,
      "noStockCount": 0,
      "unknownStockCount": 13
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73a38",
        "height": 0.17649,
        "facings": [
          {
            "id": "696ebf6f43c343680a270eab",
            "leftCorner": {
              "x": 5.052,
              "y": -10.523,
              "z": 0.176
            },
            "rightCorner": {
              "x": 5.079,
              "y": -10.547,
              "z": 0.176
            },
            "gtin": "4009800001701",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270eac",
            "leftCorner": {
              "x": 5.079,
              "y": -10.547,
              "z": 0.176
            },
            "rightCorner": {
              "x": 5.218,
              "y": -10.668,
              "z": 0.176
            },
            "gtin": "4009800003927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ead",
            "leftCorner": {
              "x": 5.218,
              "y": -10.668,
              "z": 0.176
            },
            "rightCorner": {
              "x": 5.321,
              "y": -10.758,
              "z": 0.176
            },
            "gtin": "4002448189596",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270eae",
            "leftCorner": {
              "x": 5.321,
              "y": -10.758,
              "z": 0.176
            },
            "rightCorner": {
              "x": 5.377,
              "y": -10.807,
              "z": 0.176
            },
            "gtin": "9300631115434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270eaf",
            "leftCorner": {
              "x": 5.377,
              "y": -10.807,
              "z": 0.176
            },
            "rightCorner": {
              "x": 5.414,
              "y": -10.84,
              "z": 0.176
            },
            "gtin": "4006000196312",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270eb0",
            "leftCorner": {
              "x": 5.414,
              "y": -10.84,
              "z": 0.176
            },
            "rightCorner": {
              "x": 5.474,
              "y": -10.892,
              "z": 0.176
            },
            "gtin": "3015810608817",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270eb1",
            "leftCorner": {
              "x": 5.474,
              "y": -10.892,
              "z": 0.176
            },
            "rightCorner": {
              "x": 5.534,
              "y": -10.945,
              "z": 0.176
            },
            "gtin": "4058172926327",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270eb2",
            "leftCorner": {
              "x": 5.534,
              "y": -10.945,
              "z": 0.176
            },
            "rightCorner": {
              "x": 5.579,
              "y": -10.984,
              "z": 0.176
            },
            "gtin": "4010355351043",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270eb3",
            "leftCorner": {
              "x": 5.579,
              "y": -10.984,
              "z": 0.176
            },
            "rightCorner": {
              "x": 5.63,
              "y": -11.028,
              "z": 0.176
            },
            "gtin": "4010355351012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270eb4",
            "leftCorner": {
              "x": 5.63,
              "y": -11.028,
              "z": 0.176
            },
            "rightCorner": {
              "x": 5.804,
              "y": -11.18,
              "z": 0.176
            },
            "gtin": "8006540733905",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a39",
        "height": 0.48193,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f28",
            "leftCorner": {
              "x": 5.087,
              "y": -10.55,
              "z": 0.482
            },
            "rightCorner": {
              "x": 5.132,
              "y": -10.59,
              "z": 0.482
            },
            "gtin": "4009800001763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f29",
            "leftCorner": {
              "x": 5.132,
              "y": -10.59,
              "z": 0.482
            },
            "rightCorner": {
              "x": 5.175,
              "y": -10.627,
              "z": 0.482
            },
            "gtin": "7702018621255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f2a",
            "leftCorner": {
              "x": 5.175,
              "y": -10.627,
              "z": 0.482
            },
            "rightCorner": {
              "x": 5.234,
              "y": -10.679,
              "z": 0.482
            },
            "gtin": "7702018620371",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f2b",
            "leftCorner": {
              "x": 5.234,
              "y": -10.679,
              "z": 0.482
            },
            "rightCorner": {
              "x": 5.315,
              "y": -10.749,
              "z": 0.482
            },
            "gtin": "7702018620371",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f2c",
            "leftCorner": {
              "x": 5.315,
              "y": -10.749,
              "z": 0.482
            },
            "rightCorner": {
              "x": 5.357,
              "y": -10.786,
              "z": 0.482
            },
            "gtin": "7702018621293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f2d",
            "leftCorner": {
              "x": 5.357,
              "y": -10.786,
              "z": 0.482
            },
            "rightCorner": {
              "x": 5.4,
              "y": -10.824,
              "z": 0.482
            },
            "gtin": "7702018622016",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f2e",
            "leftCorner": {
              "x": 5.4,
              "y": -10.824,
              "z": 0.482
            },
            "rightCorner": {
              "x": 5.456,
              "y": -10.873,
              "z": 0.482
            },
            "gtin": "8714789849164",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f2f",
            "leftCorner": {
              "x": 5.456,
              "y": -10.873,
              "z": 0.482
            },
            "rightCorner": {
              "x": 5.501,
              "y": -10.912,
              "z": 0.482
            },
            "gtin": "8714789849164",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f30",
            "leftCorner": {
              "x": 5.501,
              "y": -10.912,
              "z": 0.482
            },
            "rightCorner": {
              "x": 5.544,
              "y": -10.95,
              "z": 0.482
            },
            "gtin": "4027800324903",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f31",
            "leftCorner": {
              "x": 5.544,
              "y": -10.95,
              "z": 0.482
            },
            "rightCorner": {
              "x": 5.588,
              "y": -10.988,
              "z": 0.482
            },
            "gtin": "4005900918628",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f32",
            "leftCorner": {
              "x": 5.588,
              "y": -10.988,
              "z": 0.482
            },
            "rightCorner": {
              "x": 5.638,
              "y": -11.032,
              "z": 0.482
            },
            "gtin": "4006000169019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f33",
            "leftCorner": {
              "x": 5.638,
              "y": -11.032,
              "z": 0.482
            },
            "rightCorner": {
              "x": 5.681,
              "y": -11.069,
              "z": 0.482
            },
            "gtin": "4006000169019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f34",
            "leftCorner": {
              "x": 5.681,
              "y": -11.069,
              "z": 0.482
            },
            "rightCorner": {
              "x": 5.725,
              "y": -11.108,
              "z": 0.482
            },
            "gtin": "4006000170091",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f35",
            "leftCorner": {
              "x": 5.725,
              "y": -11.108,
              "z": 0.482
            },
            "rightCorner": {
              "x": 5.766,
              "y": -11.144,
              "z": 0.482
            },
            "gtin": "4066447893243",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f36",
            "leftCorner": {
              "x": 5.766,
              "y": -11.144,
              "z": 0.482
            },
            "rightCorner": {
              "x": 5.803,
              "y": -11.176,
              "z": 0.482
            }
          },
          {
            "id": "696ebf6f43c343680a270f37",
            "leftCorner": {
              "x": 5.803,
              "y": -11.176,
              "z": 0.482
            },
            "rightCorner": {
              "x": 5.864,
              "y": -11.229,
              "z": 0.482
            },
            "gtin": "4058172488177",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a36",
        "height": 0.77746,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f15",
            "leftCorner": {
              "x": 5.072,
              "y": -10.536,
              "z": 0.777
            },
            "rightCorner": {
              "x": 5.149,
              "y": -10.603,
              "z": 0.777
            },
            "gtin": "8700216036788",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f16",
            "leftCorner": {
              "x": 5.149,
              "y": -10.603,
              "z": 0.777
            },
            "rightCorner": {
              "x": 5.237,
              "y": -10.68,
              "z": 0.777
            },
            "gtin": "8001090560858",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f17",
            "leftCorner": {
              "x": 5.237,
              "y": -10.68,
              "z": 0.777
            },
            "rightCorner": {
              "x": 5.322,
              "y": -10.754,
              "z": 0.777
            },
            "gtin": "8700216609029",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f18",
            "leftCorner": {
              "x": 5.322,
              "y": -10.754,
              "z": 0.777
            },
            "rightCorner": {
              "x": 5.408,
              "y": -10.829,
              "z": 0.777
            },
            "gtin": "8001090565129",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f19",
            "leftCorner": {
              "x": 5.408,
              "y": -10.829,
              "z": 0.777
            },
            "rightCorner": {
              "x": 5.495,
              "y": -10.906,
              "z": 0.777
            },
            "gtin": "8700216519212",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f1a",
            "leftCorner": {
              "x": 5.495,
              "y": -10.906,
              "z": 0.777
            },
            "rightCorner": {
              "x": 5.567,
              "y": -10.968,
              "z": 0.777
            },
            "gtin": "8700216478908",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f1b",
            "leftCorner": {
              "x": 5.567,
              "y": -10.968,
              "z": 0.777
            },
            "rightCorner": {
              "x": 5.651,
              "y": -11.041,
              "z": 0.777
            },
            "gtin": "8700216478700",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f1c",
            "leftCorner": {
              "x": 5.651,
              "y": -11.041,
              "z": 0.777
            },
            "rightCorner": {
              "x": 5.718,
              "y": -11.1,
              "z": 0.777
            },
            "gtin": "8700216478335",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f1d",
            "leftCorner": {
              "x": 5.718,
              "y": -11.1,
              "z": 0.777
            },
            "rightCorner": {
              "x": 5.801,
              "y": -11.172,
              "z": 0.777
            },
            "gtin": "8700216987042",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a35",
        "height": 1.0315,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f08",
            "leftCorner": {
              "x": 5.064,
              "y": -10.525,
              "z": 1.031
            },
            "rightCorner": {
              "x": 5.146,
              "y": -10.597,
              "z": 1.031
            },
            "gtin": "8700216036887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f0a",
            "leftCorner": {
              "x": 5.146,
              "y": -10.597,
              "z": 1.031
            },
            "rightCorner": {
              "x": 5.232,
              "y": -10.672,
              "z": 1.031
            },
            "gtin": "8700216660716",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f0b",
            "leftCorner": {
              "x": 5.232,
              "y": -10.672,
              "z": 1.031
            },
            "rightCorner": {
              "x": 5.412,
              "y": -10.829,
              "z": 1.031
            },
            "gtin": "8700216791816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f0c",
            "leftCorner": {
              "x": 5.412,
              "y": -10.829,
              "z": 1.031
            },
            "rightCorner": {
              "x": 5.565,
              "y": -10.963,
              "z": 1.031
            },
            "gtin": "8700216519267",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f0d",
            "leftCorner": {
              "x": 5.565,
              "y": -10.963,
              "z": 1.031
            },
            "rightCorner": {
              "x": 5.641,
              "y": -11.03,
              "z": 1.031
            },
            "gtin": "8700216478397",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f0e",
            "leftCorner": {
              "x": 5.641,
              "y": -11.03,
              "z": 1.031
            },
            "rightCorner": {
              "x": 5.712,
              "y": -11.091,
              "z": 1.031
            },
            "gtin": "8700216503457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f0f",
            "leftCorner": {
              "x": 5.694,
              "y": -11.089,
              "z": 1.031
            },
            "rightCorner": {
              "x": 5.79,
              "y": -11.172,
              "z": 1.031
            },
            "gtin": "7702018417759",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a37",
        "height": 1.2865,
        "facings": []
      },
      {
        "id": "696ead8d3b88e258afd73a34",
        "height": 1.6231,
        "facings": [
          {
            "id": "696ebf6f43c343680a270da7",
            "leftCorner": {
              "x": 5.051,
              "y": -10.516,
              "z": 1.623
            },
            "rightCorner": {
              "x": 5.085,
              "y": -10.546,
              "z": 1.623
            },
            "gtin": "5060896573618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270da8",
            "leftCorner": {
              "x": 5.085,
              "y": -10.546,
              "z": 1.623
            },
            "rightCorner": {
              "x": 5.28,
              "y": -10.716,
              "z": 1.623
            },
            "gtin": "8700216568814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270da9",
            "leftCorner": {
              "x": 5.28,
              "y": -10.716,
              "z": 1.623
            },
            "rightCorner": {
              "x": 5.359,
              "y": -10.785,
              "z": 1.623
            },
            "gtin": "8001090634924",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270daa",
            "leftCorner": {
              "x": 5.359,
              "y": -10.785,
              "z": 1.623
            },
            "rightCorner": {
              "x": 5.452,
              "y": -10.866,
              "z": 1.623
            },
            "gtin": "4027800551101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270dab",
            "leftCorner": {
              "x": 5.452,
              "y": -10.866,
              "z": 1.623
            },
            "rightCorner": {
              "x": 5.526,
              "y": -10.931,
              "z": 1.623
            },
            "gtin": "4027800513109",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dac",
            "leftCorner": {
              "x": 5.526,
              "y": -10.931,
              "z": 1.623
            },
            "rightCorner": {
              "x": 5.562,
              "y": -10.962,
              "z": 1.623
            },
            "gtin": "4260380014011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dad",
            "leftCorner": {
              "x": 5.562,
              "y": -10.962,
              "z": 1.623
            },
            "rightCorner": {
              "x": 5.643,
              "y": -11.033,
              "z": 1.623
            },
            "gtin": "7702018545247",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270dae",
            "leftCorner": {
              "x": 5.643,
              "y": -11.033,
              "z": 1.623
            },
            "rightCorner": {
              "x": 5.692,
              "y": -11.076,
              "z": 1.623
            },
            "gtin": "7702018544707",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270daf",
            "leftCorner": {
              "x": 5.692,
              "y": -11.076,
              "z": 1.623
            },
            "rightCorner": {
              "x": 5.735,
              "y": -11.114,
              "z": 1.623
            },
            "gtin": "7702018544677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270db0",
            "leftCorner": {
              "x": 5.735,
              "y": -11.114,
              "z": 1.623
            },
            "rightCorner": {
              "x": 5.808,
              "y": -11.177,
              "z": 1.623
            },
            "gtin": "4027800846009",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc0469598f4",
    "name": "68e7571db5fe7bc0469598f4",
    "x": 5.8255,
    "y": -11.15,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.34556,
      "w": 0.9384
    },
    "statistics": {
      "hasStockCount": 25,
      "noStockCount": 1,
      "unknownStockCount": 15
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73c1b",
        "height": 0.18099,
        "facings": [
          {
            "id": "696ebf6f43c343680a270eb5",
            "leftCorner": {
              "x": 5.804,
              "y": -11.18,
              "z": 0.176
            },
            "rightCorner": {
              "x": 5.892,
              "y": -11.257,
              "z": 0.176
            },
            "gtin": "4027800400201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270eb6",
            "leftCorner": {
              "x": 5.876,
              "y": -11.253,
              "z": 0.181
            },
            "rightCorner": {
              "x": 5.967,
              "y": -11.331,
              "z": 0.181
            },
            "gtin": "4027800106806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270eb7",
            "leftCorner": {
              "x": 5.967,
              "y": -11.331,
              "z": 0.181
            },
            "rightCorner": {
              "x": 6.096,
              "y": -11.44,
              "z": 0.181
            },
            "gtin": "4027800080137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270eb8",
            "leftCorner": {
              "x": 6.096,
              "y": -11.44,
              "z": 0.181
            },
            "rightCorner": {
              "x": 6.278,
              "y": -11.596,
              "z": 0.181
            },
            "gtin": "4066447044454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270eb9",
            "leftCorner": {
              "x": 6.278,
              "y": -11.596,
              "z": 0.181
            },
            "rightCorner": {
              "x": 6.494,
              "y": -11.78,
              "z": 0.181
            },
            "gtin": "4066447044430",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270eba",
            "leftCorner": {
              "x": 6.494,
              "y": -11.78,
              "z": 0.181
            },
            "rightCorner": {
              "x": 6.589,
              "y": -11.86,
              "z": 0.181
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c18",
        "height": 0.48631,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f38",
            "leftCorner": {
              "x": 5.848,
              "y": -11.225,
              "z": 0.486
            },
            "rightCorner": {
              "x": 5.893,
              "y": -11.263,
              "z": 0.486
            },
            "gtin": "4067796065848",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f39",
            "leftCorner": {
              "x": 5.893,
              "y": -11.263,
              "z": 0.486
            },
            "rightCorner": {
              "x": 5.937,
              "y": -11.3,
              "z": 0.486
            },
            "gtin": "4067796065848",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f3a",
            "leftCorner": {
              "x": 5.937,
              "y": -11.3,
              "z": 0.486
            },
            "rightCorner": {
              "x": 5.982,
              "y": -11.338,
              "z": 0.486
            },
            "gtin": "4058172925733",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f3b",
            "leftCorner": {
              "x": 5.982,
              "y": -11.338,
              "z": 0.486
            },
            "rightCorner": {
              "x": 6.025,
              "y": -11.376,
              "z": 0.486
            },
            "gtin": "4058172925733",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f3c",
            "leftCorner": {
              "x": 6.025,
              "y": -11.376,
              "z": 0.486
            },
            "rightCorner": {
              "x": 6.07,
              "y": -11.414,
              "z": 0.486
            }
          },
          {
            "id": "696ebf6f43c343680a270f3d",
            "leftCorner": {
              "x": 6.07,
              "y": -11.414,
              "z": 0.486
            },
            "rightCorner": {
              "x": 6.116,
              "y": -11.453,
              "z": 0.486
            },
            "gtin": "4066447277463",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f3e",
            "leftCorner": {
              "x": 6.116,
              "y": -11.453,
              "z": 0.486
            },
            "rightCorner": {
              "x": 6.158,
              "y": -11.488,
              "z": 0.486
            },
            "gtin": "4067796065787",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f3f",
            "leftCorner": {
              "x": 6.158,
              "y": -11.488,
              "z": 0.486
            },
            "rightCorner": {
              "x": 6.202,
              "y": -11.526,
              "z": 0.486
            },
            "gtin": "4067796065787",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f40",
            "leftCorner": {
              "x": 6.202,
              "y": -11.526,
              "z": 0.486
            },
            "rightCorner": {
              "x": 6.249,
              "y": -11.567,
              "z": 0.486
            },
            "gtin": "4058172925672",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f41",
            "leftCorner": {
              "x": 6.249,
              "y": -11.567,
              "z": 0.486
            },
            "rightCorner": {
              "x": 6.297,
              "y": -11.607,
              "z": 0.486
            },
            "gtin": "4058172925672",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f42",
            "leftCorner": {
              "x": 6.297,
              "y": -11.607,
              "z": 0.486
            },
            "rightCorner": {
              "x": 6.339,
              "y": -11.643,
              "z": 0.486
            },
            "gtin": "7350113021113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f43",
            "leftCorner": {
              "x": 6.339,
              "y": -11.643,
              "z": 0.486
            },
            "rightCorner": {
              "x": 6.414,
              "y": -11.707,
              "z": 0.486
            },
            "gtin": "7350113020710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f44",
            "leftCorner": {
              "x": 6.414,
              "y": -11.707,
              "z": 0.486
            },
            "rightCorner": {
              "x": 6.502,
              "y": -11.782,
              "z": 0.486
            },
            "gtin": "7350113020741",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f27",
            "leftCorner": {
              "x": 6.502,
              "y": -11.782,
              "z": 0.486
            },
            "rightCorner": {
              "x": 6.559,
              "y": -11.831,
              "z": 0.486
            },
            "gtin": "7350113020727",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c1e",
        "height": 0.76862,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f1e",
            "leftCorner": {
              "x": 5.801,
              "y": -11.172,
              "z": 0.777
            },
            "rightCorner": {
              "x": 5.876,
              "y": -11.238,
              "z": 0.777
            },
            "gtin": "8700216503563",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f1f",
            "leftCorner": {
              "x": 5.862,
              "y": -11.231,
              "z": 0.769
            },
            "rightCorner": {
              "x": 5.943,
              "y": -11.3,
              "z": 0.769
            },
            "gtin": "5060144646361",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f20",
            "leftCorner": {
              "x": 5.943,
              "y": -11.3,
              "z": 0.769
            },
            "rightCorner": {
              "x": 6.019,
              "y": -11.366,
              "z": 0.769
            },
            "gtin": "5060896573946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f21",
            "leftCorner": {
              "x": 6.019,
              "y": -11.366,
              "z": 0.769
            },
            "rightCorner": {
              "x": 6.108,
              "y": -11.441,
              "z": 0.769
            },
            "gtin": "4027800402373",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f22",
            "leftCorner": {
              "x": 6.108,
              "y": -11.441,
              "z": 0.769
            },
            "rightCorner": {
              "x": 6.22,
              "y": -11.536,
              "z": 0.769
            },
            "gtin": "4027800402175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f23",
            "leftCorner": {
              "x": 6.22,
              "y": -11.536,
              "z": 0.769
            },
            "rightCorner": {
              "x": 6.32,
              "y": -11.622,
              "z": 0.769
            },
            "gtin": "4027800373406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f24",
            "leftCorner": {
              "x": 6.32,
              "y": -11.622,
              "z": 0.769
            },
            "rightCorner": {
              "x": 6.404,
              "y": -11.693,
              "z": 0.769
            },
            "gtin": "4066447119442",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f25",
            "leftCorner": {
              "x": 6.404,
              "y": -11.693,
              "z": 0.769
            },
            "rightCorner": {
              "x": 6.5,
              "y": -11.775,
              "z": 0.769
            },
            "gtin": "4067796153941",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f14",
            "leftCorner": {
              "x": 6.5,
              "y": -11.775,
              "z": 0.769
            },
            "rightCorner": {
              "x": 6.562,
              "y": -11.828,
              "z": 0.769
            },
            "gtin": "4066447562842",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c1d",
        "height": 1.0309,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f10",
            "leftCorner": {
              "x": 5.791,
              "y": -11.171,
              "z": 1.031
            },
            "rightCorner": {
              "x": 5.893,
              "y": -11.26,
              "z": 1.031
            },
            "gtin": "8700216503419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f11",
            "leftCorner": {
              "x": 5.894,
              "y": -11.258,
              "z": 1.031
            },
            "rightCorner": {
              "x": 5.969,
              "y": -11.324,
              "z": 1.031
            },
            "gtin": "4027800402205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f12",
            "leftCorner": {
              "x": 5.97,
              "y": -11.323,
              "z": 1.031
            },
            "rightCorner": {
              "x": 6.075,
              "y": -11.415,
              "z": 1.031
            },
            "gtin": "4027800143801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f13",
            "leftCorner": {
              "x": 6.076,
              "y": -11.414,
              "z": 1.031
            },
            "rightCorner": {
              "x": 6.477,
              "y": -11.755,
              "z": 1.031
            },
            "gtin": "4067796153927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f09",
            "leftCorner": {
              "x": 6.477,
              "y": -11.755,
              "z": 1.031
            },
            "rightCorner": {
              "x": 6.562,
              "y": -11.828,
              "z": 1.031
            },
            "gtin": "4058172631801",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c1c",
        "height": 1.287,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f26",
            "leftCorner": {
              "x": 6.469,
              "y": -11.746,
              "z": 1.287
            },
            "rightCorner": {
              "x": 6.563,
              "y": -11.826,
              "z": 1.287
            },
            "gtin": "4066447870732",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c1a",
        "height": 1.6258,
        "facings": [
          {
            "id": "696ebf6f43c343680a270db1",
            "leftCorner": {
              "x": 5.808,
              "y": -11.177,
              "z": 1.623
            },
            "rightCorner": {
              "x": 5.886,
              "y": -11.245,
              "z": 1.623
            },
            "gtin": "8720689000468",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270db2",
            "leftCorner": {
              "x": 5.871,
              "y": -11.24,
              "z": 1.626
            },
            "rightCorner": {
              "x": 5.963,
              "y": -11.319,
              "z": 1.626
            },
            "gtin": "4262405640137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270db3",
            "leftCorner": {
              "x": 5.963,
              "y": -11.319,
              "z": 1.626
            },
            "rightCorner": {
              "x": 6.06,
              "y": -11.401,
              "z": 1.626
            },
            "gtin": "7500435206327",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270db4",
            "leftCorner": {
              "x": 6.06,
              "y": -11.401,
              "z": 1.626
            },
            "rightCorner": {
              "x": 6.165,
              "y": -11.49,
              "z": 1.626
            },
            "gtin": "7500435245180",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270db5",
            "leftCorner": {
              "x": 6.165,
              "y": -11.49,
              "z": 1.626
            },
            "rightCorner": {
              "x": 6.25,
              "y": -11.563,
              "z": 1.626
            },
            "gtin": "8720689029100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270db6",
            "leftCorner": {
              "x": 6.25,
              "y": -11.563,
              "z": 1.626
            },
            "rightCorner": {
              "x": 6.33,
              "y": -11.631,
              "z": 1.626
            },
            "gtin": "8720689031653",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270db7",
            "leftCorner": {
              "x": 6.33,
              "y": -11.631,
              "z": 1.626
            },
            "rightCorner": {
              "x": 6.408,
              "y": -11.697,
              "z": 1.626
            },
            "gtin": "8720689029070",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d81",
            "leftCorner": {
              "x": 6.408,
              "y": -11.697,
              "z": 1.626
            },
            "rightCorner": {
              "x": 6.561,
              "y": -11.828,
              "z": 1.626
            },
            "gtin": "8710103997122",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc0469598f5",
    "name": "68e7571db5fe7bc0469598f5",
    "x": 6.5634,
    "y": -11.808,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.32549,
      "w": 0.94555
    },
    "statistics": {
      "hasStockCount": 30,
      "noStockCount": 0,
      "unknownStockCount": 29
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73a40",
        "height": 0.17935,
        "facings": [
          {
            "id": "696ebf6f43c343680a270ebb",
            "leftCorner": {
              "x": 6.569,
              "y": -11.869,
              "z": 0.179
            },
            "rightCorner": {
              "x": 6.646,
              "y": -11.93,
              "z": 0.179
            },
            "gtin": "4058172063466",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ebc",
            "leftCorner": {
              "x": 6.646,
              "y": -11.93,
              "z": 0.179
            },
            "rightCorner": {
              "x": 6.746,
              "y": -12.008,
              "z": 0.179
            },
            "gtin": "4066447749540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ebd",
            "leftCorner": {
              "x": 6.746,
              "y": -12.008,
              "z": 0.179
            },
            "rightCorner": {
              "x": 6.851,
              "y": -12.09,
              "z": 0.179
            },
            "gtin": "4066447749526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ebe",
            "leftCorner": {
              "x": 6.851,
              "y": -12.09,
              "z": 0.179
            },
            "rightCorner": {
              "x": 6.944,
              "y": -12.162,
              "z": 0.179
            }
          },
          {
            "id": "696ebf6f43c343680a270ebf",
            "leftCorner": {
              "x": 6.944,
              "y": -12.162,
              "z": 0.179
            },
            "rightCorner": {
              "x": 7.019,
              "y": -12.221,
              "z": 0.179
            },
            "gtin": "5054563091970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ec0",
            "leftCorner": {
              "x": 7.019,
              "y": -12.221,
              "z": 0.179
            },
            "rightCorner": {
              "x": 7.144,
              "y": -12.319,
              "z": 0.179
            },
            "gtin": "4002448213604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ec1",
            "leftCorner": {
              "x": 7.144,
              "y": -12.319,
              "z": 0.179
            },
            "rightCorner": {
              "x": 7.223,
              "y": -12.381,
              "z": 0.179
            },
            "gtin": "4002448038900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ec2",
            "leftCorner": {
              "x": 7.254,
              "y": -12.438,
              "z": 0.18
            },
            "rightCorner": {
              "x": 7.321,
              "y": -12.49,
              "z": 0.18
            },
            "gtin": "4066447273021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ec3",
            "leftCorner": {
              "x": 7.317,
              "y": -12.494,
              "z": 0.18
            },
            "rightCorner": {
              "x": 7.397,
              "y": -12.556,
              "z": 0.18
            },
            "gtin": "4066447273021",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a3f",
        "height": 0.44087,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f9c",
            "leftCorner": {
              "x": 6.538,
              "y": -11.841,
              "z": 0.441
            },
            "rightCorner": {
              "x": 6.662,
              "y": -11.939,
              "z": 0.441
            },
            "gtin": "4066447776539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f9e",
            "leftCorner": {
              "x": 6.662,
              "y": -11.939,
              "z": 0.441
            },
            "rightCorner": {
              "x": 6.782,
              "y": -12.032,
              "z": 0.441
            },
            "gtin": "4026600851503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f9f",
            "leftCorner": {
              "x": 6.782,
              "y": -12.032,
              "z": 0.441
            },
            "rightCorner": {
              "x": 6.887,
              "y": -12.114,
              "z": 0.441
            },
            "gtin": "8700216795944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270fa0",
            "leftCorner": {
              "x": 6.887,
              "y": -12.114,
              "z": 0.441
            },
            "rightCorner": {
              "x": 6.956,
              "y": -12.168,
              "z": 0.441
            },
            "gtin": "8700216623650",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fa1",
            "leftCorner": {
              "x": 6.956,
              "y": -12.168,
              "z": 0.441
            },
            "rightCorner": {
              "x": 6.989,
              "y": -12.194,
              "z": 0.441
            },
            "gtin": "8700216623650",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fa2",
            "leftCorner": {
              "x": 6.989,
              "y": -12.194,
              "z": 0.441
            },
            "rightCorner": {
              "x": 7.027,
              "y": -12.224,
              "z": 0.441
            },
            "gtin": "8700216623711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270fa3",
            "leftCorner": {
              "x": 7.027,
              "y": -12.224,
              "z": 0.441
            },
            "rightCorner": {
              "x": 7.099,
              "y": -12.28,
              "z": 0.441
            },
            "gtin": "8700216619943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270fa4",
            "leftCorner": {
              "x": 7.099,
              "y": -12.28,
              "z": 0.441
            },
            "rightCorner": {
              "x": 7.161,
              "y": -12.329,
              "z": 0.441
            },
            "gtin": "4009932002218",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fa5",
            "leftCorner": {
              "x": 7.161,
              "y": -12.329,
              "z": 0.441
            },
            "rightCorner": {
              "x": 7.296,
              "y": -12.434,
              "z": 0.441
            },
            "gtin": "8001090573049",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a3c",
        "height": 0.6925,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f69",
            "leftCorner": {
              "x": 6.543,
              "y": -11.835,
              "z": 0.693
            },
            "rightCorner": {
              "x": 6.725,
              "y": -11.977,
              "z": 0.693
            },
            "gtin": "8718951035461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f6b",
            "leftCorner": {
              "x": 6.725,
              "y": -11.977,
              "z": 0.693
            },
            "rightCorner": {
              "x": 6.878,
              "y": -12.096,
              "z": 0.693
            },
            "gtin": "8718951035430",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f6c",
            "leftCorner": {
              "x": 6.878,
              "y": -12.096,
              "z": 0.693
            },
            "rightCorner": {
              "x": 7.049,
              "y": -12.23,
              "z": 0.693
            },
            "gtin": "5054563191458",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f6d",
            "leftCorner": {
              "x": 7.049,
              "y": -12.23,
              "z": 0.693
            },
            "rightCorner": {
              "x": 7.213,
              "y": -12.358,
              "z": 0.693
            },
            "gtin": "5054563191397",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f6e",
            "leftCorner": {
              "x": 7.213,
              "y": -12.358,
              "z": 0.693
            },
            "rightCorner": {
              "x": 7.335,
              "y": -12.454,
              "z": 0.693
            },
            "gtin": "8006540947050",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a3e",
        "height": 0.86165,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f91",
            "leftCorner": {
              "x": 6.533,
              "y": -11.847,
              "z": 0.862
            },
            "rightCorner": {
              "x": 6.621,
              "y": -11.915,
              "z": 0.862
            },
            "gtin": "4008666830074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f93",
            "leftCorner": {
              "x": 6.621,
              "y": -11.915,
              "z": 0.862
            },
            "rightCorner": {
              "x": 6.782,
              "y": -12.041,
              "z": 0.862
            },
            "gtin": "4067796183900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f94",
            "leftCorner": {
              "x": 6.782,
              "y": -12.041,
              "z": 0.862
            },
            "rightCorner": {
              "x": 6.938,
              "y": -12.163,
              "z": 0.862
            },
            "gtin": "4066447711769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f95",
            "leftCorner": {
              "x": 6.938,
              "y": -12.163,
              "z": 0.862
            },
            "rightCorner": {
              "x": 7.099,
              "y": -12.289,
              "z": 0.862
            },
            "gtin": "4066447277388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f96",
            "leftCorner": {
              "x": 7.099,
              "y": -12.289,
              "z": 0.862
            },
            "rightCorner": {
              "x": 7.251,
              "y": -12.407,
              "z": 0.862
            },
            "gtin": "4067796157932",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f97",
            "leftCorner": {
              "x": 7.251,
              "y": -12.407,
              "z": 0.862
            },
            "rightCorner": {
              "x": 7.374,
              "y": -12.503,
              "z": 0.862
            },
            "gtin": "4066447776515",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a3b",
        "height": 1.1157,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f5e",
            "leftCorner": {
              "x": 6.536,
              "y": -11.843,
              "z": 1.116
            },
            "rightCorner": {
              "x": 6.756,
              "y": -12.015,
              "z": 1.116
            },
            "gtin": "4008666831170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f60",
            "leftCorner": {
              "x": 6.756,
              "y": -12.015,
              "z": 1.116
            },
            "rightCorner": {
              "x": 6.902,
              "y": -12.128,
              "z": 1.116
            },
            "gtin": "4008666831125",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f61",
            "leftCorner": {
              "x": 6.902,
              "y": -12.128,
              "z": 1.116
            },
            "rightCorner": {
              "x": 7.033,
              "y": -12.231,
              "z": 1.116
            },
            "gtin": "5054563234124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f62",
            "leftCorner": {
              "x": 7.033,
              "y": -12.231,
              "z": 1.116
            },
            "rightCorner": {
              "x": 7.169,
              "y": -12.337,
              "z": 1.116
            },
            "gtin": "5054563231673",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f63",
            "leftCorner": {
              "x": 7.169,
              "y": -12.337,
              "z": 1.116
            },
            "rightCorner": {
              "x": 7.267,
              "y": -12.413,
              "z": 1.116
            },
            "gtin": "5054563207296",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f64",
            "leftCorner": {
              "x": 7.267,
              "y": -12.413,
              "z": 1.116
            },
            "rightCorner": {
              "x": 7.368,
              "y": -12.492,
              "z": 1.116
            },
            "gtin": "5054563210180",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a41",
        "height": 1.3295,
        "facings": [
          {
            "id": "696ebf6f43c343680a270fcd",
            "leftCorner": {
              "x": 6.538,
              "y": -11.841,
              "z": 1.33
            },
            "rightCorner": {
              "x": 6.655,
              "y": -11.931,
              "z": 1.33
            },
            "gtin": "4008666860002",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fcf",
            "leftCorner": {
              "x": 6.655,
              "y": -11.931,
              "z": 1.33
            },
            "rightCorner": {
              "x": 6.801,
              "y": -12.046,
              "z": 1.33
            },
            "gtin": "5054563240828",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fd0",
            "leftCorner": {
              "x": 6.801,
              "y": -12.046,
              "z": 1.33
            },
            "rightCorner": {
              "x": 6.952,
              "y": -12.164,
              "z": 1.33
            },
            "gtin": "8718951570412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fd1",
            "leftCorner": {
              "x": 6.952,
              "y": -12.164,
              "z": 1.33
            },
            "rightCorner": {
              "x": 7.087,
              "y": -12.269,
              "z": 1.33
            },
            "gtin": "7610108047536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270fd2",
            "leftCorner": {
              "x": 7.087,
              "y": -12.269,
              "z": 1.33
            },
            "rightCorner": {
              "x": 7.22,
              "y": -12.373,
              "z": 1.33
            },
            "gtin": "8718951419902",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fd3",
            "leftCorner": {
              "x": 7.22,
              "y": -12.373,
              "z": 1.33
            },
            "rightCorner": {
              "x": 7.328,
              "y": -12.457,
              "z": 1.33
            },
            "gtin": "7610108059249",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a3d",
        "height": 1.5414,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f84",
            "leftCorner": {
              "x": 6.54,
              "y": -11.838,
              "z": 1.541
            },
            "rightCorner": {
              "x": 6.681,
              "y": -11.948,
              "z": 1.541
            },
            "gtin": "4251867800777",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f86",
            "leftCorner": {
              "x": 6.681,
              "y": -11.948,
              "z": 1.541
            },
            "rightCorner": {
              "x": 6.727,
              "y": -11.983,
              "z": 1.541
            },
            "gtin": "4251867800760",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f87",
            "leftCorner": {
              "x": 6.727,
              "y": -11.983,
              "z": 1.541
            },
            "rightCorner": {
              "x": 6.766,
              "y": -12.014,
              "z": 1.541
            }
          },
          {
            "id": "696ebf6f43c343680a270f88",
            "leftCorner": {
              "x": 6.766,
              "y": -12.014,
              "z": 1.541
            },
            "rightCorner": {
              "x": 6.91,
              "y": -12.126,
              "z": 1.541
            },
            "gtin": "5054563085917",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f89",
            "leftCorner": {
              "x": 6.91,
              "y": -12.126,
              "z": 1.541
            },
            "rightCorner": {
              "x": 7.052,
              "y": -12.238,
              "z": 1.541
            },
            "gtin": "5054563085863",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f8a",
            "leftCorner": {
              "x": 7.052,
              "y": -12.238,
              "z": 1.541
            },
            "rightCorner": {
              "x": 7.181,
              "y": -12.338,
              "z": 1.541
            },
            "gtin": "5054563104144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f8b",
            "leftCorner": {
              "x": 7.181,
              "y": -12.338,
              "z": 1.541
            },
            "rightCorner": {
              "x": 7.313,
              "y": -12.442,
              "z": 1.541
            },
            "gtin": "4067796120585",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a3a",
        "height": 1.7479,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f45",
            "leftCorner": {
              "x": 6.534,
              "y": -11.846,
              "z": 1.748
            },
            "rightCorner": {
              "x": 6.665,
              "y": -11.948,
              "z": 1.748
            },
            "gtin": "8718951724181",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f47",
            "leftCorner": {
              "x": 6.665,
              "y": -11.948,
              "z": 1.748
            },
            "rightCorner": {
              "x": 6.767,
              "y": -12.028,
              "z": 1.748
            },
            "gtin": "8718951505537",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f48",
            "leftCorner": {
              "x": 6.767,
              "y": -12.028,
              "z": 1.748
            },
            "rightCorner": {
              "x": 6.799,
              "y": -12.053,
              "z": 1.748
            },
            "gtin": "4045612009764",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f49",
            "leftCorner": {
              "x": 6.799,
              "y": -12.053,
              "z": 1.748
            },
            "rightCorner": {
              "x": 6.852,
              "y": -12.094,
              "z": 1.748
            },
            "gtin": "4045612009764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f4a",
            "leftCorner": {
              "x": 6.852,
              "y": -12.094,
              "z": 1.748
            },
            "rightCorner": {
              "x": 6.918,
              "y": -12.146,
              "z": 1.748
            },
            "gtin": "4008890009031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f4b",
            "leftCorner": {
              "x": 6.918,
              "y": -12.146,
              "z": 1.748
            },
            "rightCorner": {
              "x": 6.974,
              "y": -12.19,
              "z": 1.748
            },
            "gtin": "4008890009437",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f4c",
            "leftCorner": {
              "x": 6.974,
              "y": -12.19,
              "z": 1.748
            },
            "rightCorner": {
              "x": 7.029,
              "y": -12.233,
              "z": 1.748
            }
          },
          {
            "id": "696ebf6f43c343680a270f4d",
            "leftCorner": {
              "x": 7.029,
              "y": -12.233,
              "z": 1.748
            },
            "rightCorner": {
              "x": 7.086,
              "y": -12.277,
              "z": 1.748
            },
            "gtin": "8712561437370",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f4e",
            "leftCorner": {
              "x": 7.086,
              "y": -12.277,
              "z": 1.748
            },
            "rightCorner": {
              "x": 7.129,
              "y": -12.31,
              "z": 1.748
            },
            "gtin": "4260486336291",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f4f",
            "leftCorner": {
              "x": 7.129,
              "y": -12.31,
              "z": 1.748
            },
            "rightCorner": {
              "x": 7.168,
              "y": -12.341,
              "z": 1.748
            },
            "gtin": "4260486336543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f50",
            "leftCorner": {
              "x": 7.168,
              "y": -12.341,
              "z": 1.748
            },
            "rightCorner": {
              "x": 7.193,
              "y": -12.36,
              "z": 1.748
            },
            "gtin": "5054563177421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f51",
            "leftCorner": {
              "x": 7.231,
              "y": -12.409,
              "z": 1.749
            },
            "rightCorner": {
              "x": 7.279,
              "y": -12.446,
              "z": 1.749
            },
            "gtin": "5054563949363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f52",
            "leftCorner": {
              "x": 7.276,
              "y": -12.448,
              "z": 1.749
            },
            "rightCorner": {
              "x": 7.327,
              "y": -12.488,
              "z": 1.749
            },
            "gtin": "5054563264084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f53",
            "leftCorner": {
              "x": 7.324,
              "y": -12.491,
              "z": 1.749
            },
            "rightCorner": {
              "x": 7.356,
              "y": -12.516,
              "z": 1.749
            },
            "gtin": "5054563264084",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc0469598f6",
    "name": "68e7571db5fe7bc0469598f6",
    "x": 7.3794,
    "y": -12.489,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.3547,
      "w": 0.93498
    },
    "statistics": {
      "hasStockCount": 30,
      "noStockCount": 1,
      "unknownStockCount": 28
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73a48",
        "height": 0.18033,
        "facings": [
          {
            "id": "696ebf6f43c343680a270ec4",
            "leftCorner": {
              "x": 7.393,
              "y": -12.561,
              "z": 0.18
            },
            "rightCorner": {
              "x": 7.452,
              "y": -12.614,
              "z": 0.18
            },
            "gtin": "4067796143805",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ec5",
            "leftCorner": {
              "x": 7.452,
              "y": -12.614,
              "z": 0.18
            },
            "rightCorner": {
              "x": 7.51,
              "y": -12.665,
              "z": 0.18
            },
            "gtin": "4067796143751",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ec6",
            "leftCorner": {
              "x": 7.51,
              "y": -12.665,
              "z": 0.18
            },
            "rightCorner": {
              "x": 7.562,
              "y": -12.711,
              "z": 0.18
            },
            "gtin": "4067796143751",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ec7",
            "leftCorner": {
              "x": 7.562,
              "y": -12.711,
              "z": 0.18
            },
            "rightCorner": {
              "x": 7.646,
              "y": -12.786,
              "z": 0.18
            },
            "gtin": "7610108059416",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ec8",
            "leftCorner": {
              "x": 7.646,
              "y": -12.786,
              "z": 0.18
            },
            "rightCorner": {
              "x": 7.705,
              "y": -12.838,
              "z": 0.18
            },
            "gtin": "8718951560772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ec9",
            "leftCorner": {
              "x": 7.705,
              "y": -12.838,
              "z": 0.18
            },
            "rightCorner": {
              "x": 7.764,
              "y": -12.89,
              "z": 0.18
            },
            "gtin": "8718951560772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270eca",
            "leftCorner": {
              "x": 7.764,
              "y": -12.89,
              "z": 0.18
            },
            "rightCorner": {
              "x": 7.819,
              "y": -12.939,
              "z": 0.18
            },
            "gtin": "8718951560772",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ecb",
            "leftCorner": {
              "x": 7.819,
              "y": -12.939,
              "z": 0.18
            },
            "rightCorner": {
              "x": 7.869,
              "y": -12.983,
              "z": 0.18
            },
            "gtin": "8718951560772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ecc",
            "leftCorner": {
              "x": 7.869,
              "y": -12.983,
              "z": 0.18
            },
            "rightCorner": {
              "x": 7.92,
              "y": -13.028,
              "z": 0.18
            },
            "gtin": "7610108059317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ecd",
            "leftCorner": {
              "x": 7.92,
              "y": -13.028,
              "z": 0.18
            },
            "rightCorner": {
              "x": 7.996,
              "y": -13.096,
              "z": 0.18
            },
            "gtin": "5054563129598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ece",
            "leftCorner": {
              "x": 7.996,
              "y": -13.096,
              "z": 0.18
            },
            "rightCorner": {
              "x": 8.098,
              "y": -13.186,
              "z": 0.18
            },
            "gtin": "4066447277449",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a46",
        "height": 0.44373,
        "facings": [
          {
            "id": "696ebf6f43c343680a270fa6",
            "leftCorner": {
              "x": 7.296,
              "y": -12.434,
              "z": 0.441
            },
            "rightCorner": {
              "x": 7.406,
              "y": -12.52,
              "z": 0.441
            },
            "gtin": "8718951227262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fa7",
            "leftCorner": {
              "x": 7.43,
              "y": -12.584,
              "z": 0.444
            },
            "rightCorner": {
              "x": 7.565,
              "y": -12.704,
              "z": 0.444
            },
            "gtin": "8718951227323",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fa8",
            "leftCorner": {
              "x": 7.565,
              "y": -12.704,
              "z": 0.444
            },
            "rightCorner": {
              "x": 7.702,
              "y": -12.825,
              "z": 0.444
            },
            "gtin": "8718951313224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270fa9",
            "leftCorner": {
              "x": 7.702,
              "y": -12.825,
              "z": 0.444
            },
            "rightCorner": {
              "x": 7.723,
              "y": -12.843,
              "z": 0.444
            }
          },
          {
            "id": "696ebf6f43c343680a270faa",
            "leftCorner": {
              "x": 7.723,
              "y": -12.843,
              "z": 0.444
            },
            "rightCorner": {
              "x": 7.86,
              "y": -12.965,
              "z": 0.444
            },
            "gtin": "8718951314535",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fab",
            "leftCorner": {
              "x": 7.86,
              "y": -12.965,
              "z": 0.444
            },
            "rightCorner": {
              "x": 8.002,
              "y": -13.091,
              "z": 0.444
            },
            "gtin": "8718951249981",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fac",
            "leftCorner": {
              "x": 8.002,
              "y": -13.091,
              "z": 0.444
            },
            "rightCorner": {
              "x": 8.107,
              "y": -13.184,
              "z": 0.444
            },
            "gtin": "4007965146008",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a47",
        "height": 0.69561,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f6f",
            "leftCorner": {
              "x": 7.358,
              "y": -12.522,
              "z": 0.696
            },
            "rightCorner": {
              "x": 7.505,
              "y": -12.652,
              "z": 0.696
            },
            "gtin": "8006540946930",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f70",
            "leftCorner": {
              "x": 7.505,
              "y": -12.652,
              "z": 0.696
            },
            "rightCorner": {
              "x": 7.631,
              "y": -12.764,
              "z": 0.696
            },
            "gtin": "7610108053421",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f71",
            "leftCorner": {
              "x": 7.631,
              "y": -12.764,
              "z": 0.696
            },
            "rightCorner": {
              "x": 7.717,
              "y": -12.84,
              "z": 0.696
            },
            "gtin": "4068101000042",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f72",
            "leftCorner": {
              "x": 7.717,
              "y": -12.84,
              "z": 0.696
            },
            "rightCorner": {
              "x": 7.741,
              "y": -12.861,
              "z": 0.696
            }
          },
          {
            "id": "696ebf6f43c343680a270f73",
            "leftCorner": {
              "x": 7.741,
              "y": -12.861,
              "z": 0.696
            },
            "rightCorner": {
              "x": 7.83,
              "y": -12.94,
              "z": 0.696
            },
            "gtin": "4009903011119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f74",
            "leftCorner": {
              "x": 7.83,
              "y": -12.94,
              "z": 0.696
            },
            "rightCorner": {
              "x": 7.875,
              "y": -12.98,
              "z": 0.696
            },
            "gtin": "4270004717303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f75",
            "leftCorner": {
              "x": 7.875,
              "y": -12.98,
              "z": 0.696
            },
            "rightCorner": {
              "x": 7.9,
              "y": -13.003,
              "z": 0.696
            },
            "gtin": "4270004717303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f76",
            "leftCorner": {
              "x": 7.9,
              "y": -13.003,
              "z": 0.696
            },
            "rightCorner": {
              "x": 7.926,
              "y": -13.025,
              "z": 0.696
            },
            "gtin": "4260457770710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f77",
            "leftCorner": {
              "x": 7.926,
              "y": -13.025,
              "z": 0.696
            },
            "rightCorner": {
              "x": 8.069,
              "y": -13.152,
              "z": 0.696
            },
            "gtin": "4019338609249",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f78",
            "leftCorner": {
              "x": 8.069,
              "y": -13.152,
              "z": 0.696
            },
            "rightCorner": {
              "x": 8.124,
              "y": -13.201,
              "z": 0.696
            },
            "gtin": "4058172778537",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a44",
        "height": 0.86601,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f98",
            "leftCorner": {
              "x": 7.4,
              "y": -12.565,
              "z": 0.866
            },
            "rightCorner": {
              "x": 7.537,
              "y": -12.686,
              "z": 0.866
            },
            "gtin": "8718951453395",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f99",
            "leftCorner": {
              "x": 7.537,
              "y": -12.686,
              "z": 0.866
            },
            "rightCorner": {
              "x": 7.698,
              "y": -12.828,
              "z": 0.866
            },
            "gtin": "4007965015557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f9a",
            "leftCorner": {
              "x": 7.698,
              "y": -12.828,
              "z": 0.866
            },
            "rightCorner": {
              "x": 7.838,
              "y": -12.953,
              "z": 0.866
            },
            "gtin": "4007965015007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f9b",
            "leftCorner": {
              "x": 7.838,
              "y": -12.953,
              "z": 0.866
            },
            "rightCorner": {
              "x": 7.968,
              "y": -13.068,
              "z": 0.866
            },
            "gtin": "7610108056316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f92",
            "leftCorner": {
              "x": 7.968,
              "y": -13.068,
              "z": 0.866
            },
            "rightCorner": {
              "x": 8.099,
              "y": -13.184,
              "z": 0.866
            },
            "gtin": "8718951032644",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a45",
        "height": 1.1205,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f65",
            "leftCorner": {
              "x": 7.392,
              "y": -12.557,
              "z": 1.12
            },
            "rightCorner": {
              "x": 7.531,
              "y": -12.68,
              "z": 1.12
            },
            "gtin": "5054563186188",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f66",
            "leftCorner": {
              "x": 7.531,
              "y": -12.68,
              "z": 1.12
            },
            "rightCorner": {
              "x": 7.692,
              "y": -12.823,
              "z": 1.12
            },
            "gtin": "5054563099587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f67",
            "leftCorner": {
              "x": 7.692,
              "y": -12.823,
              "z": 1.12
            },
            "rightCorner": {
              "x": 7.822,
              "y": -12.938,
              "z": 1.12
            },
            "gtin": "5054563209238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f68",
            "leftCorner": {
              "x": 7.822,
              "y": -12.938,
              "z": 1.12
            },
            "rightCorner": {
              "x": 7.948,
              "y": -13.05,
              "z": 1.12
            },
            "gtin": "5054563209269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f5f",
            "leftCorner": {
              "x": 7.948,
              "y": -13.05,
              "z": 1.12
            },
            "rightCorner": {
              "x": 8.1,
              "y": -13.184,
              "z": 1.12
            },
            "gtin": "5054563209290",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a49",
        "height": 1.3325,
        "facings": [
          {
            "id": "696ebf6f43c343680a270fd4",
            "leftCorner": {
              "x": 7.359,
              "y": -12.515,
              "z": 1.332
            },
            "rightCorner": {
              "x": 7.51,
              "y": -12.649,
              "z": 1.332
            },
            "gtin": "7610108053568",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fd5",
            "leftCorner": {
              "x": 7.51,
              "y": -12.649,
              "z": 1.332
            },
            "rightCorner": {
              "x": 7.629,
              "y": -12.755,
              "z": 1.332
            },
            "gtin": "7610108059287",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fd6",
            "leftCorner": {
              "x": 7.629,
              "y": -12.755,
              "z": 1.332
            },
            "rightCorner": {
              "x": 7.657,
              "y": -12.78,
              "z": 1.332
            }
          },
          {
            "id": "696ebf6f43c343680a270fd7",
            "leftCorner": {
              "x": 7.657,
              "y": -12.78,
              "z": 1.332
            },
            "rightCorner": {
              "x": 7.764,
              "y": -12.875,
              "z": 1.332
            },
            "gtin": "8718951080041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270fd8",
            "leftCorner": {
              "x": 7.764,
              "y": -12.875,
              "z": 1.332
            },
            "rightCorner": {
              "x": 7.787,
              "y": -12.896,
              "z": 1.332
            }
          },
          {
            "id": "696ebf6f43c343680a270fd9",
            "leftCorner": {
              "x": 7.787,
              "y": -12.896,
              "z": 1.332
            },
            "rightCorner": {
              "x": 7.869,
              "y": -12.968,
              "z": 1.332
            },
            "gtin": "8718951031876",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fda",
            "leftCorner": {
              "x": 7.869,
              "y": -12.968,
              "z": 1.332
            },
            "rightCorner": {
              "x": 7.898,
              "y": -12.994,
              "z": 1.332
            }
          },
          {
            "id": "696ebf6f43c343680a270fdb",
            "leftCorner": {
              "x": 7.898,
              "y": -12.994,
              "z": 1.332
            },
            "rightCorner": {
              "x": 7.951,
              "y": -13.041,
              "z": 1.332
            },
            "gtin": "8720181603167",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fdc",
            "leftCorner": {
              "x": 7.951,
              "y": -13.041,
              "z": 1.332
            },
            "rightCorner": {
              "x": 8.049,
              "y": -13.127,
              "z": 1.332
            },
            "gtin": "8720181604348",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fce",
            "leftCorner": {
              "x": 8.049,
              "y": -13.127,
              "z": 1.332
            },
            "rightCorner": {
              "x": 8.105,
              "y": -13.177,
              "z": 1.332
            },
            "gtin": "4260457770918",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a43",
        "height": 1.5407,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f8c",
            "leftCorner": {
              "x": 7.313,
              "y": -12.442,
              "z": 1.541
            },
            "rightCorner": {
              "x": 7.391,
              "y": -12.502,
              "z": 1.541
            },
            "gtin": "4067796120608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f8d",
            "leftCorner": {
              "x": 7.413,
              "y": -12.571,
              "z": 1.541
            },
            "rightCorner": {
              "x": 7.545,
              "y": -12.689,
              "z": 1.541
            },
            "gtin": "7610108059461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f8e",
            "leftCorner": {
              "x": 7.545,
              "y": -12.689,
              "z": 1.541
            },
            "rightCorner": {
              "x": 7.703,
              "y": -12.829,
              "z": 1.541
            },
            "gtin": "7610108059508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f8f",
            "leftCorner": {
              "x": 7.703,
              "y": -12.829,
              "z": 1.541
            },
            "rightCorner": {
              "x": 7.835,
              "y": -12.946,
              "z": 1.541
            },
            "gtin": "8714789921006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f90",
            "leftCorner": {
              "x": 7.835,
              "y": -12.946,
              "z": 1.541
            },
            "rightCorner": {
              "x": 7.96,
              "y": -13.057,
              "z": 1.541
            },
            "gtin": "8718951115446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f85",
            "leftCorner": {
              "x": 7.96,
              "y": -13.057,
              "z": 1.541
            },
            "rightCorner": {
              "x": 8.101,
              "y": -13.182,
              "z": 1.541
            },
            "gtin": "8006530040976",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a42",
        "height": 1.7494,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f54",
            "leftCorner": {
              "x": 7.354,
              "y": -12.517,
              "z": 1.749
            },
            "rightCorner": {
              "x": 7.392,
              "y": -12.547,
              "z": 1.749
            },
            "gtin": "5054563949486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f55",
            "leftCorner": {
              "x": 7.39,
              "y": -12.549,
              "z": 1.749
            },
            "rightCorner": {
              "x": 7.44,
              "y": -12.588,
              "z": 1.749
            },
            "gtin": "4016369461334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f56",
            "leftCorner": {
              "x": 7.437,
              "y": -12.591,
              "z": 1.749
            },
            "rightCorner": {
              "x": 7.527,
              "y": -12.661,
              "z": 1.749
            },
            "gtin": "4016369461495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f57",
            "leftCorner": {
              "x": 7.522,
              "y": -12.667,
              "z": 1.749
            },
            "rightCorner": {
              "x": 7.622,
              "y": -12.755,
              "z": 1.749
            },
            "gtin": "8006530040792",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f58",
            "leftCorner": {
              "x": 7.622,
              "y": -12.755,
              "z": 1.749
            },
            "rightCorner": {
              "x": 7.645,
              "y": -12.776,
              "z": 1.749
            }
          },
          {
            "id": "696ebf6f43c343680a270f59",
            "leftCorner": {
              "x": 7.645,
              "y": -12.776,
              "z": 1.749
            },
            "rightCorner": {
              "x": 7.672,
              "y": -12.799,
              "z": 1.749
            },
            "gtin": "8006540217733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f5a",
            "leftCorner": {
              "x": 7.672,
              "y": -12.799,
              "z": 1.749
            },
            "rightCorner": {
              "x": 7.708,
              "y": -12.831,
              "z": 1.749
            },
            "gtin": "8006540217733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f5b",
            "leftCorner": {
              "x": 7.708,
              "y": -12.831,
              "z": 1.749
            },
            "rightCorner": {
              "x": 7.823,
              "y": -12.933,
              "z": 1.749
            },
            "gtin": "8700216666329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f5c",
            "leftCorner": {
              "x": 7.823,
              "y": -12.933,
              "z": 1.749
            },
            "rightCorner": {
              "x": 7.968,
              "y": -13.062,
              "z": 1.749
            },
            "gtin": "8700216666619",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f5d",
            "leftCorner": {
              "x": 7.968,
              "y": -13.062,
              "z": 1.749
            },
            "rightCorner": {
              "x": 8.066,
              "y": -13.149,
              "z": 1.749
            },
            "gtin": "4066447673074",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f46",
            "leftCorner": {
              "x": 8.066,
              "y": -13.149,
              "z": 1.749
            },
            "rightCorner": {
              "x": 8.102,
              "y": -13.181,
              "z": 1.749
            },
            "gtin": "5054563063410",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc0469598f7",
    "name": "68e7571db5fe7bc0469598f7",
    "x": 8.1377,
    "y": -13.158,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.35679,
      "w": 0.93418
    },
    "statistics": {
      "hasStockCount": 19,
      "noStockCount": 1,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73a4f",
        "height": 0.17982,
        "facings": [
          {
            "id": "696ebf6f43c343680a270ecf",
            "leftCorner": {
              "x": 8.108,
              "y": -13.191,
              "z": 0.18
            },
            "rightCorner": {
              "x": 8.151,
              "y": -13.229,
              "z": 0.18
            },
            "gtin": "8718951483668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ed0",
            "leftCorner": {
              "x": 8.151,
              "y": -13.229,
              "z": 0.18
            },
            "rightCorner": {
              "x": 8.214,
              "y": -13.286,
              "z": 0.18
            },
            "gtin": "8718951483668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ed1",
            "leftCorner": {
              "x": 8.214,
              "y": -13.286,
              "z": 0.18
            },
            "rightCorner": {
              "x": 8.296,
              "y": -13.359,
              "z": 0.18
            },
            "gtin": "8718951483729",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ed2",
            "leftCorner": {
              "x": 8.296,
              "y": -13.359,
              "z": 0.18
            },
            "rightCorner": {
              "x": 8.381,
              "y": -13.435,
              "z": 0.18
            },
            "gtin": "5054563101105",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ed3",
            "leftCorner": {
              "x": 8.381,
              "y": -13.435,
              "z": 0.18
            },
            "rightCorner": {
              "x": 8.442,
              "y": -13.49,
              "z": 0.18
            }
          },
          {
            "id": "696ebf6f43c343680a270ed4",
            "leftCorner": {
              "x": 8.442,
              "y": -13.49,
              "z": 0.18
            },
            "rightCorner": {
              "x": 8.491,
              "y": -13.534,
              "z": 0.18
            },
            "gtin": "5054563123923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ed5",
            "leftCorner": {
              "x": 8.491,
              "y": -13.534,
              "z": 0.18
            },
            "rightCorner": {
              "x": 8.515,
              "y": -13.555,
              "z": 0.18
            },
            "gtin": "5054563123923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ed6",
            "leftCorner": {
              "x": 8.515,
              "y": -13.555,
              "z": 0.18
            },
            "rightCorner": {
              "x": 8.588,
              "y": -13.62,
              "z": 0.18
            },
            "gtin": "4066447580211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ed7",
            "leftCorner": {
              "x": 8.588,
              "y": -13.62,
              "z": 0.18
            },
            "rightCorner": {
              "x": 8.653,
              "y": -13.679,
              "z": 0.18
            },
            "gtin": "4066447580211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ed8",
            "leftCorner": {
              "x": 8.653,
              "y": -13.679,
              "z": 0.18
            },
            "rightCorner": {
              "x": 8.723,
              "y": -13.741,
              "z": 0.18
            }
          },
          {
            "id": "696ebf6f43c343680a270ed9",
            "leftCorner": {
              "x": 8.723,
              "y": -13.741,
              "z": 0.18
            },
            "rightCorner": {
              "x": 8.785,
              "y": -13.796,
              "z": 0.18
            },
            "gtin": "4066447705515",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a4d",
        "height": 0.44379,
        "facings": [
          {
            "id": "696ebf6f43c343680a270fad",
            "leftCorner": {
              "x": 8.107,
              "y": -13.184,
              "z": 0.444
            },
            "rightCorner": {
              "x": 8.181,
              "y": -13.249,
              "z": 0.444
            },
            "gtin": "7610108060252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270fae",
            "leftCorner": {
              "x": 8.187,
              "y": -13.258,
              "z": 0.444
            },
            "rightCorner": {
              "x": 8.261,
              "y": -13.324,
              "z": 0.444
            },
            "gtin": "5054563219206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270faf",
            "leftCorner": {
              "x": 8.261,
              "y": -13.324,
              "z": 0.444
            },
            "rightCorner": {
              "x": 8.314,
              "y": -13.371,
              "z": 0.444
            },
            "gtin": "5054563219657",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fb0",
            "leftCorner": {
              "x": 8.314,
              "y": -13.371,
              "z": 0.444
            },
            "rightCorner": {
              "x": 8.336,
              "y": -13.391,
              "z": 0.444
            }
          },
          {
            "id": "696ebf6f43c343680a270fb1",
            "leftCorner": {
              "x": 8.336,
              "y": -13.391,
              "z": 0.444
            },
            "rightCorner": {
              "x": 8.361,
              "y": -13.414,
              "z": 0.444
            }
          },
          {
            "id": "696ebf6f43c343680a270fb2",
            "leftCorner": {
              "x": 8.361,
              "y": -13.414,
              "z": 0.444
            },
            "rightCorner": {
              "x": 8.412,
              "y": -13.459,
              "z": 0.444
            },
            "gtin": "5054563193445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fb3",
            "leftCorner": {
              "x": 8.412,
              "y": -13.459,
              "z": 0.444
            },
            "rightCorner": {
              "x": 8.493,
              "y": -13.531,
              "z": 0.444
            },
            "gtin": "5054563193414",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fb4",
            "leftCorner": {
              "x": 8.493,
              "y": -13.531,
              "z": 0.444
            },
            "rightCorner": {
              "x": 8.563,
              "y": -13.594,
              "z": 0.444
            },
            "gtin": "4008666812162",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fb5",
            "leftCorner": {
              "x": 8.563,
              "y": -13.594,
              "z": 0.444
            },
            "rightCorner": {
              "x": 8.589,
              "y": -13.618,
              "z": 0.444
            }
          },
          {
            "id": "696ebf6f43c343680a270fb6",
            "leftCorner": {
              "x": 8.589,
              "y": -13.618,
              "z": 0.444
            },
            "rightCorner": {
              "x": 8.67,
              "y": -13.69,
              "z": 0.444
            },
            "gtin": "4008666812186",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fb7",
            "leftCorner": {
              "x": 8.67,
              "y": -13.69,
              "z": 0.444
            },
            "rightCorner": {
              "x": 8.711,
              "y": -13.726,
              "z": 0.444
            },
            "gtin": "4102963001257",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fb8",
            "leftCorner": {
              "x": 8.711,
              "y": -13.726,
              "z": 0.444
            },
            "rightCorner": {
              "x": 8.758,
              "y": -13.768,
              "z": 0.444
            },
            "gtin": "4102963001158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fb9",
            "leftCorner": {
              "x": 8.758,
              "y": -13.768,
              "z": 0.444
            },
            "rightCorner": {
              "x": 8.817,
              "y": -13.821,
              "z": 0.444
            },
            "gtin": "5054563160461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fba",
            "leftCorner": {
              "x": 8.817,
              "y": -13.821,
              "z": 0.444
            },
            "rightCorner": {
              "x": 8.875,
              "y": -13.873,
              "z": 0.444
            },
            "gtin": "4058172333873",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a4c",
        "height": 0.69614,
        "facings": [
          {
            "id": "696ebf6f43c343680a270f79",
            "leftCorner": {
              "x": 8.134,
              "y": -13.207,
              "z": 0.696
            },
            "rightCorner": {
              "x": 8.236,
              "y": -13.299,
              "z": 0.696
            },
            "gtin": "4068101000004",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f7a",
            "leftCorner": {
              "x": 8.236,
              "y": -13.299,
              "z": 0.696
            },
            "rightCorner": {
              "x": 8.326,
              "y": -13.38,
              "z": 0.696
            },
            "gtin": "4021457650736",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f7b",
            "leftCorner": {
              "x": 8.326,
              "y": -13.38,
              "z": 0.696
            },
            "rightCorner": {
              "x": 8.375,
              "y": -13.424,
              "z": 0.696
            },
            "gtin": "4066447341508",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f7c",
            "leftCorner": {
              "x": 8.375,
              "y": -13.424,
              "z": 0.696
            },
            "rightCorner": {
              "x": 8.483,
              "y": -13.52,
              "z": 0.696
            },
            "gtin": "4260486333924",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f7d",
            "leftCorner": {
              "x": 8.483,
              "y": -13.52,
              "z": 0.696
            },
            "rightCorner": {
              "x": 8.54,
              "y": -13.571,
              "z": 0.696
            },
            "gtin": "4101160100503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f7e",
            "leftCorner": {
              "x": 8.54,
              "y": -13.571,
              "z": 0.696
            },
            "rightCorner": {
              "x": 8.566,
              "y": -13.595,
              "z": 0.696
            },
            "gtin": "4101160100503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f7f",
            "leftCorner": {
              "x": 8.566,
              "y": -13.595,
              "z": 0.696
            },
            "rightCorner": {
              "x": 8.606,
              "y": -13.63,
              "z": 0.696
            },
            "gtin": "4066447467833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f80",
            "leftCorner": {
              "x": 8.606,
              "y": -13.63,
              "z": 0.696
            },
            "rightCorner": {
              "x": 8.641,
              "y": -13.661,
              "z": 0.696
            },
            "gtin": "4001638098014",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f81",
            "leftCorner": {
              "x": 8.641,
              "y": -13.661,
              "z": 0.696
            },
            "rightCorner": {
              "x": 8.683,
              "y": -13.699,
              "z": 0.696
            },
            "gtin": "4001638098090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f82",
            "leftCorner": {
              "x": 8.683,
              "y": -13.699,
              "z": 0.696
            },
            "rightCorner": {
              "x": 8.726,
              "y": -13.737,
              "z": 0.696
            },
            "gtin": "4001638098090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270f83",
            "leftCorner": {
              "x": 8.726,
              "y": -13.737,
              "z": 0.696
            },
            "rightCorner": {
              "x": 8.79,
              "y": -13.795,
              "z": 0.696
            },
            "gtin": "4066447715835",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f6a",
            "leftCorner": {
              "x": 8.79,
              "y": -13.795,
              "z": 0.696
            },
            "rightCorner": {
              "x": 8.857,
              "y": -13.854,
              "z": 0.696
            },
            "gtin": "4260066813006",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a4a",
        "height": 1.1712,
        "facings": [
          {
            "id": "696ebf6f43c343680a270fdd",
            "leftCorner": {
              "x": 8.129,
              "y": -13.168,
              "z": 1.171
            },
            "rightCorner": {
              "x": 8.751,
              "y": -13.724,
              "z": 1.171
            },
            "gtin": "4058172881367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270fde",
            "leftCorner": {
              "x": 8.751,
              "y": -13.724,
              "z": 1.171
            },
            "rightCorner": {
              "x": 8.874,
              "y": -13.834,
              "z": 1.171
            },
            "gtin": "4066447782158",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a50",
        "height": 1.3618,
        "facings": [
          {
            "id": "696ebf6f43c343680a270fdf",
            "leftCorner": {
              "x": 8.131,
              "y": -13.166,
              "z": 1.362
            },
            "rightCorner": {
              "x": 8.602,
              "y": -13.588,
              "z": 1.362
            },
            "gtin": "4260620680662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270fe1",
            "leftCorner": {
              "x": 8.602,
              "y": -13.588,
              "z": 1.362
            },
            "rightCorner": {
              "x": 8.665,
              "y": -13.644,
              "z": 1.362
            },
            "gtin": "047701130100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270fe2",
            "leftCorner": {
              "x": 8.665,
              "y": -13.644,
              "z": 1.362
            },
            "rightCorner": {
              "x": 8.773,
              "y": -13.741,
              "z": 1.362
            },
            "gtin": "8700216386760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270fe0",
            "leftCorner": {
              "x": 8.773,
              "y": -13.741,
              "z": 1.362
            },
            "rightCorner": {
              "x": 8.876,
              "y": -13.833,
              "z": 1.362
            },
            "gtin": "8006540491782",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a4e",
        "height": 1.5656,
        "facings": []
      },
      {
        "id": "696ead8d3b88e258afd73a4b",
        "height": 1.7736,
        "facings": []
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc0469598f8",
    "name": "68e7571db5fe7bc0469598f8",
    "x": 8.8734,
    "y": -13.826,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.34619,
      "w": 0.93816
    },
    "statistics": {
      "hasStockCount": 15,
      "noStockCount": 0,
      "unknownStockCount": 10
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73c25",
        "height": 0.17741,
        "facings": [
          {
            "id": "696ebf6f43c343680a270eda",
            "leftCorner": {
              "x": 8.785,
              "y": -13.796,
              "z": 0.18
            },
            "rightCorner": {
              "x": 8.878,
              "y": -13.88,
              "z": 0.18
            },
            "gtin": "4066447878226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270edb",
            "leftCorner": {
              "x": 8.87,
              "y": -13.882,
              "z": 0.177
            },
            "rightCorner": {
              "x": 8.948,
              "y": -13.949,
              "z": 0.177
            },
            "gtin": "4066447878226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270edc",
            "leftCorner": {
              "x": 8.948,
              "y": -13.949,
              "z": 0.177
            },
            "rightCorner": {
              "x": 9.017,
              "y": -14.007,
              "z": 0.177
            }
          },
          {
            "id": "696ebf6f43c343680a270edd",
            "leftCorner": {
              "x": 9.017,
              "y": -14.007,
              "z": 0.177
            },
            "rightCorner": {
              "x": 9.097,
              "y": -14.076,
              "z": 0.177
            },
            "gtin": "4058172925931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ede",
            "leftCorner": {
              "x": 9.097,
              "y": -14.076,
              "z": 0.177
            },
            "rightCorner": {
              "x": 9.16,
              "y": -14.13,
              "z": 0.177
            },
            "gtin": "4058172925931",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270edf",
            "leftCorner": {
              "x": 9.16,
              "y": -14.13,
              "z": 0.177
            },
            "rightCorner": {
              "x": 9.246,
              "y": -14.203,
              "z": 0.177
            },
            "gtin": "4066447774306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ee0",
            "leftCorner": {
              "x": 9.246,
              "y": -14.203,
              "z": 0.177
            },
            "rightCorner": {
              "x": 9.33,
              "y": -14.275,
              "z": 0.177
            },
            "gtin": "4066447774306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ee1",
            "leftCorner": {
              "x": 9.33,
              "y": -14.275,
              "z": 0.177
            },
            "rightCorner": {
              "x": 9.407,
              "y": -14.341,
              "z": 0.177
            },
            "gtin": "3574661859576",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ee2",
            "leftCorner": {
              "x": 9.407,
              "y": -14.341,
              "z": 0.177
            },
            "rightCorner": {
              "x": 9.48,
              "y": -14.403,
              "z": 0.177
            },
            "gtin": "3574661860527",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ee3",
            "leftCorner": {
              "x": 9.48,
              "y": -14.403,
              "z": 0.177
            },
            "rightCorner": {
              "x": 9.551,
              "y": -14.464,
              "z": 0.177
            },
            "gtin": "3574661731131",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ee4",
            "leftCorner": {
              "x": 9.551,
              "y": -14.464,
              "z": 0.177
            },
            "rightCorner": {
              "x": 9.632,
              "y": -14.533,
              "z": 0.177
            },
            "gtin": "3574661731131",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c24",
        "height": 0.44037,
        "facings": [
          {
            "id": "696ebf6f43c343680a270fbb",
            "leftCorner": {
              "x": 8.869,
              "y": -13.872,
              "z": 0.44
            },
            "rightCorner": {
              "x": 8.933,
              "y": -13.927,
              "z": 0.44
            },
            "gtin": "8718951582378",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fbc",
            "leftCorner": {
              "x": 8.933,
              "y": -13.927,
              "z": 0.44
            },
            "rightCorner": {
              "x": 9.027,
              "y": -14.007,
              "z": 0.44
            },
            "gtin": "8718951271234",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fbd",
            "leftCorner": {
              "x": 9.027,
              "y": -14.007,
              "z": 0.44
            },
            "rightCorner": {
              "x": 9.074,
              "y": -14.047,
              "z": 0.44
            },
            "gtin": "4001638081863",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fbe",
            "leftCorner": {
              "x": 9.074,
              "y": -14.047,
              "z": 0.44
            },
            "rightCorner": {
              "x": 9.124,
              "y": -14.09,
              "z": 0.44
            },
            "gtin": "4066447384680",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fbf",
            "leftCorner": {
              "x": 9.124,
              "y": -14.09,
              "z": 0.44
            },
            "rightCorner": {
              "x": 9.275,
              "y": -14.219,
              "z": 0.44
            },
            "gtin": "8720181501456",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fc0",
            "leftCorner": {
              "x": 9.275,
              "y": -14.219,
              "z": 0.44
            },
            "rightCorner": {
              "x": 9.367,
              "y": -14.298,
              "z": 0.44
            },
            "gtin": "4066447717648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270fc1",
            "leftCorner": {
              "x": 9.367,
              "y": -14.298,
              "z": 0.44
            },
            "rightCorner": {
              "x": 9.453,
              "y": -14.372,
              "z": 0.44
            },
            "gtin": "4066447719123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270fc2",
            "leftCorner": {
              "x": 9.453,
              "y": -14.372,
              "z": 0.44
            },
            "rightCorner": {
              "x": 9.511,
              "y": -14.421,
              "z": 0.44
            },
            "gtin": "4066447732429",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fc3",
            "leftCorner": {
              "x": 9.511,
              "y": -14.421,
              "z": 0.44
            },
            "rightCorner": {
              "x": 9.561,
              "y": -14.463,
              "z": 0.44
            },
            "gtin": "4066447732429",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fc4",
            "leftCorner": {
              "x": 9.561,
              "y": -14.463,
              "z": 0.44
            },
            "rightCorner": {
              "x": 9.62,
              "y": -14.514,
              "z": 0.44
            },
            "gtin": "4066447732481",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c21",
        "height": 0.90802,
        "facings": [
          {
            "id": "696ebf7143c343680a272041",
            "leftCorner": {
              "x": 8.867,
              "y": -13.833,
              "z": 0.908
            },
            "rightCorner": {
              "x": 9.319,
              "y": -14.218,
              "z": 0.908
            },
            "gtin": "4067796111057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272042",
            "leftCorner": {
              "x": 9.319,
              "y": -14.218,
              "z": 0.908
            },
            "rightCorner": {
              "x": 9.628,
              "y": -14.482,
              "z": 0.908
            },
            "gtin": "4066447232394",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c23",
        "height": 1.15,
        "facings": []
      },
      {
        "id": "696ead8e3b88e258afd73c20",
        "height": 1.4827,
        "facings": [
          {
            "id": "696ebf7143c343680a27203e",
            "leftCorner": {
              "x": 8.866,
              "y": -13.834,
              "z": 1.483
            },
            "rightCorner": {
              "x": 9.441,
              "y": -14.326,
              "z": 1.483
            },
            "gtin": "4260486334976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272040",
            "leftCorner": {
              "x": 9.441,
              "y": -14.326,
              "z": 1.483
            },
            "rightCorner": {
              "x": 9.515,
              "y": -14.389,
              "z": 1.483
            },
            "gtin": "4260486335720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a27203f",
            "leftCorner": {
              "x": 9.515,
              "y": -14.389,
              "z": 1.483
            },
            "rightCorner": {
              "x": 9.626,
              "y": -14.484,
              "z": 1.483
            },
            "gtin": "4260620680013",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c22",
        "height": 1.7659,
        "facings": []
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc0469598f9",
    "name": "68e7571db5fe7bc0469598f9",
    "x": 9.6298,
    "y": -14.482,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.37419,
      "w": 0.92735
    },
    "statistics": {
      "hasStockCount": 20,
      "noStockCount": 1,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73a55",
        "height": 0.17488,
        "facings": [
          {
            "id": "696ebf6f43c343680a270ee5",
            "leftCorner": {
              "x": 9.625,
              "y": -14.54,
              "z": 0.175
            },
            "rightCorner": {
              "x": 9.7,
              "y": -14.613,
              "z": 0.175
            },
            "gtin": "3574661745619",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ee6",
            "leftCorner": {
              "x": 9.7,
              "y": -14.613,
              "z": 0.175
            },
            "rightCorner": {
              "x": 9.771,
              "y": -14.681,
              "z": 0.175
            },
            "gtin": "3574661778310",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ee7",
            "leftCorner": {
              "x": 9.771,
              "y": -14.681,
              "z": 0.175
            },
            "rightCorner": {
              "x": 9.856,
              "y": -14.763,
              "z": 0.175
            },
            "gtin": "3574661730967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ee8",
            "leftCorner": {
              "x": 9.856,
              "y": -14.763,
              "z": 0.175
            },
            "rightCorner": {
              "x": 9.926,
              "y": -14.83,
              "z": 0.175
            },
            "gtin": "3574661731001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ee9",
            "leftCorner": {
              "x": 9.926,
              "y": -14.83,
              "z": 0.175
            },
            "rightCorner": {
              "x": 9.992,
              "y": -14.894,
              "z": 0.175
            },
            "gtin": "3574661731001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270eea",
            "leftCorner": {
              "x": 9.992,
              "y": -14.894,
              "z": 0.175
            },
            "rightCorner": {
              "x": 10.057,
              "y": -14.957,
              "z": 0.175
            },
            "gtin": "3574661731025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270eeb",
            "leftCorner": {
              "x": 10.057,
              "y": -14.957,
              "z": 0.175
            },
            "rightCorner": {
              "x": 10.122,
              "y": -15.019,
              "z": 0.175
            },
            "gtin": "3574661731056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270eec",
            "leftCorner": {
              "x": 10.122,
              "y": -15.019,
              "z": 0.175
            },
            "rightCorner": {
              "x": 10.212,
              "y": -15.106,
              "z": 0.175
            }
          },
          {
            "id": "696ebf6f43c343680a270e7f",
            "leftCorner": {
              "x": 10.212,
              "y": -15.106,
              "z": 0.175
            },
            "rightCorner": {
              "x": 10.318,
              "y": -15.209,
              "z": 0.175
            },
            "gtin": "3574661731049",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a52",
        "height": 0.43735,
        "facings": [
          {
            "id": "696ebf6f43c343680a270fc5",
            "leftCorner": {
              "x": 9.612,
              "y": -14.522,
              "z": 0.437
            },
            "rightCorner": {
              "x": 9.671,
              "y": -14.578,
              "z": 0.437
            },
            "gtin": "4066447732450",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fc6",
            "leftCorner": {
              "x": 9.671,
              "y": -14.578,
              "z": 0.437
            },
            "rightCorner": {
              "x": 9.758,
              "y": -14.662,
              "z": 0.437
            },
            "gtin": "4066447773262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fc7",
            "leftCorner": {
              "x": 9.758,
              "y": -14.662,
              "z": 0.437
            },
            "rightCorner": {
              "x": 9.837,
              "y": -14.738,
              "z": 0.437
            },
            "gtin": "4066447398809",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fc8",
            "leftCorner": {
              "x": 9.837,
              "y": -14.738,
              "z": 0.437
            },
            "rightCorner": {
              "x": 9.923,
              "y": -14.821,
              "z": 0.437
            },
            "gtin": "8700216932820",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fc9",
            "leftCorner": {
              "x": 9.923,
              "y": -14.821,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.004,
              "y": -14.899,
              "z": 0.437
            },
            "gtin": "8700216931663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270fca",
            "leftCorner": {
              "x": 10.004,
              "y": -14.899,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.078,
              "y": -14.97,
              "z": 0.437
            }
          },
          {
            "id": "696ebf6f43c343680a270fcb",
            "leftCorner": {
              "x": 10.078,
              "y": -14.97,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.154,
              "y": -15.044,
              "z": 0.437
            },
            "gtin": "8720689025416",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fcc",
            "leftCorner": {
              "x": 10.154,
              "y": -15.044,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.238,
              "y": -15.125,
              "z": 0.437
            },
            "gtin": "8710103985570",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270f9d",
            "leftCorner": {
              "x": 10.238,
              "y": -15.125,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.322,
              "y": -15.205,
              "z": 0.437
            },
            "gtin": "8720689029032",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a54",
        "height": 0.77292,
        "facings": [
          {
            "id": "696ebf6f43c343680a270ff2",
            "leftCorner": {
              "x": 9.603,
              "y": -14.51,
              "z": 0.773
            },
            "rightCorner": {
              "x": 9.681,
              "y": -14.585,
              "z": 0.773
            },
            "gtin": "8006540772409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ff4",
            "leftCorner": {
              "x": 9.681,
              "y": -14.585,
              "z": 0.773
            },
            "rightCorner": {
              "x": 9.759,
              "y": -14.66,
              "z": 0.773
            },
            "gtin": "8006540772768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ff5",
            "leftCorner": {
              "x": 9.759,
              "y": -14.66,
              "z": 0.773
            },
            "rightCorner": {
              "x": 9.824,
              "y": -14.723,
              "z": 0.773
            },
            "gtin": "4260486336086",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ff6",
            "leftCorner": {
              "x": 9.824,
              "y": -14.723,
              "z": 0.773
            },
            "rightCorner": {
              "x": 9.899,
              "y": -14.795,
              "z": 0.773
            },
            "gtin": "4210201427063",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ff7",
            "leftCorner": {
              "x": 9.899,
              "y": -14.795,
              "z": 0.773
            },
            "rightCorner": {
              "x": 9.967,
              "y": -14.861,
              "z": 0.773
            },
            "gtin": "4210201426967",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ff8",
            "leftCorner": {
              "x": 9.967,
              "y": -14.861,
              "z": 0.773
            },
            "rightCorner": {
              "x": 10.03,
              "y": -14.922,
              "z": 0.773
            },
            "gtin": "8700216012935",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ff9",
            "leftCorner": {
              "x": 10.03,
              "y": -14.922,
              "z": 0.773
            },
            "rightCorner": {
              "x": 10.143,
              "y": -15.031,
              "z": 0.773
            },
            "gtin": "4210201445111",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ffa",
            "leftCorner": {
              "x": 10.143,
              "y": -15.031,
              "z": 0.773
            },
            "rightCorner": {
              "x": 10.237,
              "y": -15.121,
              "z": 0.773
            },
            "gtin": "8700216615303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ff3",
            "leftCorner": {
              "x": 10.237,
              "y": -15.121,
              "z": 0.773
            },
            "rightCorner": {
              "x": 10.323,
              "y": -15.204,
              "z": 0.773
            },
            "gtin": "8006540730744",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a51",
        "height": 1.1177,
        "facings": [
          {
            "id": "696ebf6f43c343680a270fe3",
            "leftCorner": {
              "x": 9.654,
              "y": -14.457,
              "z": 1.118
            },
            "rightCorner": {
              "x": 9.808,
              "y": -14.605,
              "z": 1.118
            },
            "gtin": "8700216932820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270fe4",
            "leftCorner": {
              "x": 9.808,
              "y": -14.605,
              "z": 1.118
            },
            "rightCorner": {
              "x": 10.374,
              "y": -15.151,
              "z": 1.118
            },
            "gtin": "8710103985570",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a53",
        "height": 1.6617,
        "facings": [
          {
            "id": "696ebf6f43c343680a270fe6",
            "leftCorner": {
              "x": 9.625,
              "y": -14.529,
              "z": 1.662
            },
            "rightCorner": {
              "x": 9.674,
              "y": -14.576,
              "z": 1.662
            },
            "gtin": "8006540861165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270fe7",
            "leftCorner": {
              "x": 9.674,
              "y": -14.576,
              "z": 1.662
            },
            "rightCorner": {
              "x": 9.725,
              "y": -14.626,
              "z": 1.662
            },
            "gtin": "8006540861257",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fe8",
            "leftCorner": {
              "x": 9.725,
              "y": -14.626,
              "z": 1.662
            },
            "rightCorner": {
              "x": 9.776,
              "y": -14.674,
              "z": 1.662
            },
            "gtin": "8006540861455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fe9",
            "leftCorner": {
              "x": 9.776,
              "y": -14.674,
              "z": 1.662
            },
            "rightCorner": {
              "x": 9.823,
              "y": -14.72,
              "z": 1.662
            },
            "gtin": "8006540860236",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fea",
            "leftCorner": {
              "x": 9.823,
              "y": -14.72,
              "z": 1.662
            },
            "rightCorner": {
              "x": 9.871,
              "y": -14.767,
              "z": 1.662
            },
            "gtin": "8006540861448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270feb",
            "leftCorner": {
              "x": 9.871,
              "y": -14.767,
              "z": 1.662
            },
            "rightCorner": {
              "x": 9.932,
              "y": -14.825,
              "z": 1.662
            },
            "gtin": "8006540860717",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fec",
            "leftCorner": {
              "x": 9.932,
              "y": -14.825,
              "z": 1.662
            },
            "rightCorner": {
              "x": 9.979,
              "y": -14.87,
              "z": 1.662
            }
          },
          {
            "id": "696ebf6f43c343680a270fed",
            "leftCorner": {
              "x": 9.979,
              "y": -14.87,
              "z": 1.662
            },
            "rightCorner": {
              "x": 10.026,
              "y": -14.916,
              "z": 1.662
            }
          },
          {
            "id": "696ebf6f43c343680a270fee",
            "leftCorner": {
              "x": 10.026,
              "y": -14.916,
              "z": 1.662
            },
            "rightCorner": {
              "x": 10.07,
              "y": -14.958,
              "z": 1.662
            },
            "gtin": "8700216195027",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fef",
            "leftCorner": {
              "x": 10.07,
              "y": -14.958,
              "z": 1.662
            },
            "rightCorner": {
              "x": 10.108,
              "y": -14.995,
              "z": 1.662
            },
            "gtin": "8700216194969",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ff0",
            "leftCorner": {
              "x": 10.108,
              "y": -14.995,
              "z": 1.662
            },
            "rightCorner": {
              "x": 10.148,
              "y": -15.033,
              "z": 1.662
            },
            "gtin": "8720689036771",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ff1",
            "leftCorner": {
              "x": 10.148,
              "y": -15.033,
              "z": 1.662
            },
            "rightCorner": {
              "x": 10.253,
              "y": -15.134,
              "z": 1.662
            },
            "gtin": "8720689036894",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fe5",
            "leftCorner": {
              "x": 10.253,
              "y": -15.134,
              "z": 1.662
            },
            "rightCorner": {
              "x": 10.324,
              "y": -15.203,
              "z": 1.662
            },
            "gtin": "8720689036900",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc0469598fa",
    "name": "68e7571db5fe7bc0469598fa",
    "x": 11.145,
    "y": -14.26,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93655,
      "w": 0.35053
    },
    "statistics": {
      "hasStockCount": 55,
      "noStockCount": 0,
      "unknownStockCount": 27
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73c17",
        "height": 0.17938,
        "facings": [
          {
            "id": "696ebf6f43c343680a2710aa",
            "leftCorner": {
              "x": 11.175,
              "y": -14.225,
              "z": 0.179
            },
            "rightCorner": {
              "x": 11.119,
              "y": -14.177,
              "z": 0.179
            },
            "gtin": "4066447578393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710ab",
            "leftCorner": {
              "x": 11.119,
              "y": -14.177,
              "z": 0.179
            },
            "rightCorner": {
              "x": 11.071,
              "y": -14.135,
              "z": 0.179
            },
            "gtin": "4066447578393",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710ac",
            "leftCorner": {
              "x": 11.071,
              "y": -14.135,
              "z": 0.179
            },
            "rightCorner": {
              "x": 11.021,
              "y": -14.091,
              "z": 0.179
            },
            "gtin": "4066447578416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710ad",
            "leftCorner": {
              "x": 11.021,
              "y": -14.091,
              "z": 0.179
            },
            "rightCorner": {
              "x": 10.973,
              "y": -14.049,
              "z": 0.179
            },
            "gtin": "4066447106091",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710ae",
            "leftCorner": {
              "x": 10.973,
              "y": -14.049,
              "z": 0.179
            },
            "rightCorner": {
              "x": 10.925,
              "y": -14.007,
              "z": 0.179
            },
            "gtin": "4066447106091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710af",
            "leftCorner": {
              "x": 10.925,
              "y": -14.007,
              "z": 0.179
            },
            "rightCorner": {
              "x": 10.874,
              "y": -13.963,
              "z": 0.179
            },
            "gtin": "4066447331073",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710b0",
            "leftCorner": {
              "x": 10.874,
              "y": -13.963,
              "z": 0.179
            },
            "rightCorner": {
              "x": 10.852,
              "y": -13.944,
              "z": 0.179
            }
          },
          {
            "id": "696ebf6f43c343680a2710b1",
            "leftCorner": {
              "x": 10.852,
              "y": -13.944,
              "z": 0.179
            },
            "rightCorner": {
              "x": 10.817,
              "y": -13.913,
              "z": 0.179
            },
            "gtin": "4066447106473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710b2",
            "leftCorner": {
              "x": 10.817,
              "y": -13.913,
              "z": 0.179
            },
            "rightCorner": {
              "x": 10.753,
              "y": -13.858,
              "z": 0.179
            },
            "gtin": "4066447106473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710b3",
            "leftCorner": {
              "x": 10.753,
              "y": -13.858,
              "z": 0.179
            },
            "rightCorner": {
              "x": 10.706,
              "y": -13.817,
              "z": 0.179
            }
          },
          {
            "id": "696ebf6f43c343680a2710b4",
            "leftCorner": {
              "x": 10.706,
              "y": -13.817,
              "z": 0.179
            },
            "rightCorner": {
              "x": 10.651,
              "y": -13.769,
              "z": 0.179
            }
          },
          {
            "id": "696ebf6f43c343680a2710b5",
            "leftCorner": {
              "x": 10.651,
              "y": -13.769,
              "z": 0.179
            },
            "rightCorner": {
              "x": 10.542,
              "y": -13.674,
              "z": 0.179
            },
            "gtin": "4058172862908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710b6",
            "leftCorner": {
              "x": 10.542,
              "y": -13.674,
              "z": 0.179
            },
            "rightCorner": {
              "x": 10.468,
              "y": -13.609,
              "z": 0.179
            },
            "gtin": "850278004084",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710b7",
            "leftCorner": {
              "x": 10.468,
              "y": -13.609,
              "z": 0.179
            },
            "rightCorner": {
              "x": 10.391,
              "y": -13.543,
              "z": 0.179
            },
            "gtin": "850278004053",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c16",
        "height": 0.4371,
        "facings": [
          {
            "id": "696ebf6f43c343680a2711a9",
            "leftCorner": {
              "x": 11.149,
              "y": -14.203,
              "z": 0.437
            },
            "rightCorner": {
              "x": 11.095,
              "y": -14.156,
              "z": 0.437
            },
            "gtin": "4066447578492",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711aa",
            "leftCorner": {
              "x": 11.095,
              "y": -14.156,
              "z": 0.437
            },
            "rightCorner": {
              "x": 11.041,
              "y": -14.109,
              "z": 0.437
            },
            "gtin": "4066447578492",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711ab",
            "leftCorner": {
              "x": 11.041,
              "y": -14.109,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.995,
              "y": -14.068,
              "z": 0.437
            },
            "gtin": "4066447578492",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711ac",
            "leftCorner": {
              "x": 10.995,
              "y": -14.068,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.939,
              "y": -14.019,
              "z": 0.437
            },
            "gtin": "4066447578515",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711ad",
            "leftCorner": {
              "x": 10.939,
              "y": -14.019,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.887,
              "y": -13.974,
              "z": 0.437
            },
            "gtin": "4066447578515",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711ae",
            "leftCorner": {
              "x": 10.887,
              "y": -13.974,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.833,
              "y": -13.927,
              "z": 0.437
            }
          },
          {
            "id": "696ebf6f43c343680a2711af",
            "leftCorner": {
              "x": 10.833,
              "y": -13.927,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.765,
              "y": -13.868,
              "z": 0.437
            },
            "gtin": "4066447785715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711b0",
            "leftCorner": {
              "x": 10.765,
              "y": -13.868,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.712,
              "y": -13.822,
              "z": 0.437
            }
          },
          {
            "id": "696ebf6f43c343680a2711b1",
            "leftCorner": {
              "x": 10.712,
              "y": -13.822,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.651,
              "y": -13.769,
              "z": 0.437
            },
            "gtin": "4066447106350",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711b2",
            "leftCorner": {
              "x": 10.651,
              "y": -13.769,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.578,
              "y": -13.705,
              "z": 0.437
            },
            "gtin": "4066447106350",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711b3",
            "leftCorner": {
              "x": 10.578,
              "y": -13.705,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.497,
              "y": -13.635,
              "z": 0.437
            },
            "gtin": "4066447578553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711b4",
            "leftCorner": {
              "x": 10.497,
              "y": -13.635,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.399,
              "y": -13.549,
              "z": 0.437
            },
            "gtin": "4066447502909",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c12",
        "height": 0.7315,
        "facings": [
          {
            "id": "696ebf6f43c343680a270ffb",
            "leftCorner": {
              "x": 11.174,
              "y": -14.226,
              "z": 0.731
            },
            "rightCorner": {
              "x": 11.137,
              "y": -14.193,
              "z": 0.731
            },
            "gtin": "4066447106053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ffd",
            "leftCorner": {
              "x": 11.137,
              "y": -14.193,
              "z": 0.731
            },
            "rightCorner": {
              "x": 11.094,
              "y": -14.156,
              "z": 0.731
            }
          },
          {
            "id": "696ebf6f43c343680a270ffe",
            "leftCorner": {
              "x": 11.094,
              "y": -14.156,
              "z": 0.731
            },
            "rightCorner": {
              "x": 11.052,
              "y": -14.12,
              "z": 0.731
            },
            "gtin": "4066447579734",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270fff",
            "leftCorner": {
              "x": 11.052,
              "y": -14.12,
              "z": 0.731
            },
            "rightCorner": {
              "x": 11.016,
              "y": -14.088,
              "z": 0.731
            },
            "gtin": "4066447579734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271000",
            "leftCorner": {
              "x": 11.016,
              "y": -14.088,
              "z": 0.731
            },
            "rightCorner": {
              "x": 10.969,
              "y": -14.047,
              "z": 0.731
            },
            "gtin": "4066447579772",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271001",
            "leftCorner": {
              "x": 10.969,
              "y": -14.047,
              "z": 0.731
            },
            "rightCorner": {
              "x": 10.93,
              "y": -14.014,
              "z": 0.731
            },
            "gtin": "4066447579772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271002",
            "leftCorner": {
              "x": 10.93,
              "y": -14.014,
              "z": 0.731
            },
            "rightCorner": {
              "x": 10.861,
              "y": -13.953,
              "z": 0.731
            },
            "gtin": "4066447579659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271003",
            "leftCorner": {
              "x": 10.861,
              "y": -13.953,
              "z": 0.731
            },
            "rightCorner": {
              "x": 10.76,
              "y": -13.866,
              "z": 0.731
            },
            "gtin": "4066447787283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271004",
            "leftCorner": {
              "x": 10.76,
              "y": -13.866,
              "z": 0.731
            },
            "rightCorner": {
              "x": 10.709,
              "y": -13.821,
              "z": 0.731
            },
            "gtin": "4066447787290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271005",
            "leftCorner": {
              "x": 10.709,
              "y": -13.821,
              "z": 0.731
            },
            "rightCorner": {
              "x": 10.662,
              "y": -13.78,
              "z": 0.731
            },
            "gtin": "4066447787290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271006",
            "leftCorner": {
              "x": 10.662,
              "y": -13.78,
              "z": 0.731
            },
            "rightCorner": {
              "x": 10.61,
              "y": -13.735,
              "z": 0.731
            },
            "gtin": "4066447787306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271007",
            "leftCorner": {
              "x": 10.61,
              "y": -13.735,
              "z": 0.731
            },
            "rightCorner": {
              "x": 10.554,
              "y": -13.686,
              "z": 0.731
            },
            "gtin": "4066447502824",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271008",
            "leftCorner": {
              "x": 10.554,
              "y": -13.686,
              "z": 0.731
            },
            "rightCorner": {
              "x": 10.477,
              "y": -13.619,
              "z": 0.731
            },
            "gtin": "4066447301458",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271009",
            "leftCorner": {
              "x": 10.477,
              "y": -13.619,
              "z": 0.731
            },
            "rightCorner": {
              "x": 10.367,
              "y": -13.523,
              "z": 0.731
            },
            "gtin": "4066447106039",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c14",
        "height": 0.98513,
        "facings": [
          {
            "id": "696ebf6f43c343680a271141",
            "leftCorner": {
              "x": 11.159,
              "y": -14.208,
              "z": 0.985
            },
            "rightCorner": {
              "x": 11.111,
              "y": -14.166,
              "z": 0.985
            },
            "gtin": "4066447105933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271142",
            "leftCorner": {
              "x": 11.111,
              "y": -14.166,
              "z": 0.985
            },
            "rightCorner": {
              "x": 11.057,
              "y": -14.119,
              "z": 0.985
            }
          },
          {
            "id": "696ebf6f43c343680a271143",
            "leftCorner": {
              "x": 11.057,
              "y": -14.119,
              "z": 0.985
            },
            "rightCorner": {
              "x": 11.015,
              "y": -14.082,
              "z": 0.985
            },
            "gtin": "4066447105957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271144",
            "leftCorner": {
              "x": 11.015,
              "y": -14.082,
              "z": 0.985
            },
            "rightCorner": {
              "x": 10.963,
              "y": -14.037,
              "z": 0.985
            },
            "gtin": "4066447578478",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271145",
            "leftCorner": {
              "x": 10.963,
              "y": -14.037,
              "z": 0.985
            },
            "rightCorner": {
              "x": 10.885,
              "y": -13.97,
              "z": 0.985
            },
            "gtin": "4066447107210",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271146",
            "leftCorner": {
              "x": 10.885,
              "y": -13.97,
              "z": 0.985
            },
            "rightCorner": {
              "x": 10.809,
              "y": -13.903,
              "z": 0.985
            },
            "gtin": "4066447787450",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271147",
            "leftCorner": {
              "x": 10.809,
              "y": -13.903,
              "z": 0.985
            },
            "rightCorner": {
              "x": 10.775,
              "y": -13.873,
              "z": 0.985
            }
          },
          {
            "id": "696ebf6f43c343680a271148",
            "leftCorner": {
              "x": 10.775,
              "y": -13.873,
              "z": 0.985
            },
            "rightCorner": {
              "x": 10.726,
              "y": -13.831,
              "z": 0.985
            },
            "gtin": "4066447786255",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271149",
            "leftCorner": {
              "x": 10.726,
              "y": -13.831,
              "z": 0.985
            },
            "rightCorner": {
              "x": 10.682,
              "y": -13.793,
              "z": 0.985
            },
            "gtin": "4066447786255",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27114a",
            "leftCorner": {
              "x": 10.682,
              "y": -13.793,
              "z": 0.985
            },
            "rightCorner": {
              "x": 10.628,
              "y": -13.745,
              "z": 0.985
            },
            "gtin": "4066447786316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27114b",
            "leftCorner": {
              "x": 10.628,
              "y": -13.745,
              "z": 0.985
            },
            "rightCorner": {
              "x": 10.573,
              "y": -13.698,
              "z": 0.985
            },
            "gtin": "4066447786316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27114c",
            "leftCorner": {
              "x": 10.573,
              "y": -13.698,
              "z": 0.985
            },
            "rightCorner": {
              "x": 10.5,
              "y": -13.634,
              "z": 0.985
            },
            "gtin": "4066447578430",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27114d",
            "leftCorner": {
              "x": 10.5,
              "y": -13.634,
              "z": 0.985
            },
            "rightCorner": {
              "x": 10.404,
              "y": -13.55,
              "z": 0.985
            },
            "gtin": "4066447578577",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c15",
        "height": 1.1964,
        "facings": [
          {
            "id": "696ebf7143c343680a272030",
            "leftCorner": {
              "x": 11.181,
              "y": -14.219,
              "z": 1.196
            },
            "rightCorner": {
              "x": 11.149,
              "y": -14.191,
              "z": 1.196
            },
            "gtin": "4260672140039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272032",
            "leftCorner": {
              "x": 11.149,
              "y": -14.191,
              "z": 1.196
            },
            "rightCorner": {
              "x": 11.112,
              "y": -14.158,
              "z": 1.196
            },
            "gtin": "4260672140039",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272033",
            "leftCorner": {
              "x": 11.112,
              "y": -14.158,
              "z": 1.196
            },
            "rightCorner": {
              "x": 11.061,
              "y": -14.114,
              "z": 1.196
            },
            "gtin": "5099821109219",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272034",
            "leftCorner": {
              "x": 11.061,
              "y": -14.114,
              "z": 1.196
            },
            "rightCorner": {
              "x": 11.011,
              "y": -14.07,
              "z": 1.196
            },
            "gtin": "5099821001070",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272035",
            "leftCorner": {
              "x": 11.011,
              "y": -14.07,
              "z": 1.196
            },
            "rightCorner": {
              "x": 10.964,
              "y": -14.029,
              "z": 1.196
            },
            "gtin": "5099821001834",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272036",
            "leftCorner": {
              "x": 10.964,
              "y": -14.029,
              "z": 1.196
            },
            "rightCorner": {
              "x": 10.871,
              "y": -13.948,
              "z": 1.196
            },
            "gtin": "5099821001858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272037",
            "leftCorner": {
              "x": 10.871,
              "y": -13.948,
              "z": 1.196
            },
            "rightCorner": {
              "x": 10.811,
              "y": -13.896,
              "z": 1.196
            },
            "gtin": "5099821002770",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272038",
            "leftCorner": {
              "x": 10.811,
              "y": -13.896,
              "z": 1.196
            },
            "rightCorner": {
              "x": 10.763,
              "y": -13.855,
              "z": 1.196
            },
            "gtin": "3600542624756",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272039",
            "leftCorner": {
              "x": 10.763,
              "y": -13.855,
              "z": 1.196
            },
            "rightCorner": {
              "x": 10.717,
              "y": -13.814,
              "z": 1.196
            },
            "gtin": "3600540134318",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27203a",
            "leftCorner": {
              "x": 10.717,
              "y": -13.814,
              "z": 1.196
            },
            "rightCorner": {
              "x": 10.668,
              "y": -13.772,
              "z": 1.196
            },
            "gtin": "3600540134318",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27203b",
            "leftCorner": {
              "x": 10.668,
              "y": -13.772,
              "z": 1.196
            },
            "rightCorner": {
              "x": 10.617,
              "y": -13.727,
              "z": 1.196
            },
            "gtin": "3600542452519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27203c",
            "leftCorner": {
              "x": 10.617,
              "y": -13.727,
              "z": 1.196
            },
            "rightCorner": {
              "x": 10.569,
              "y": -13.686,
              "z": 1.196
            },
            "gtin": "3600542452519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27203d",
            "leftCorner": {
              "x": 10.569,
              "y": -13.686,
              "z": 1.196
            },
            "rightCorner": {
              "x": 10.482,
              "y": -13.61,
              "z": 1.196
            },
            "gtin": "3600540362025",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272031",
            "leftCorner": {
              "x": 10.482,
              "y": -13.61,
              "z": 1.196
            },
            "rightCorner": {
              "x": 10.427,
              "y": -13.562,
              "z": 1.196
            },
            "gtin": "3600540569158",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c13",
        "height": 1.4506,
        "facings": [
          {
            "id": "696ebf6f43c343680a271110",
            "leftCorner": {
              "x": 11.183,
              "y": -14.217,
              "z": 1.451
            },
            "rightCorner": {
              "x": 11.146,
              "y": -14.185,
              "z": 1.451
            },
            "gtin": "4260401410358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271112",
            "leftCorner": {
              "x": 11.146,
              "y": -14.185,
              "z": 1.451
            },
            "rightCorner": {
              "x": 11.108,
              "y": -14.151,
              "z": 1.451
            },
            "gtin": "4260401410358",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271113",
            "leftCorner": {
              "x": 11.108,
              "y": -14.151,
              "z": 1.451
            },
            "rightCorner": {
              "x": 11.04,
              "y": -14.092,
              "z": 1.451
            },
            "gtin": "4260401412963",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271114",
            "leftCorner": {
              "x": 11.04,
              "y": -14.092,
              "z": 1.451
            },
            "rightCorner": {
              "x": 11.002,
              "y": -14.06,
              "z": 1.451
            },
            "gtin": "4260401414370",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271115",
            "leftCorner": {
              "x": 11.002,
              "y": -14.06,
              "z": 1.451
            },
            "rightCorner": {
              "x": 10.953,
              "y": -14.017,
              "z": 1.451
            },
            "gtin": "4260401414349",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271116",
            "leftCorner": {
              "x": 10.953,
              "y": -14.017,
              "z": 1.451
            },
            "rightCorner": {
              "x": 10.879,
              "y": -13.952,
              "z": 1.451
            },
            "gtin": "4260401415520",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271117",
            "leftCorner": {
              "x": 10.879,
              "y": -13.952,
              "z": 1.451
            },
            "rightCorner": {
              "x": 10.752,
              "y": -13.842,
              "z": 1.451
            },
            "gtin": "4066447787498",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271118",
            "leftCorner": {
              "x": 10.752,
              "y": -13.842,
              "z": 1.451
            },
            "rightCorner": {
              "x": 10.706,
              "y": -13.802,
              "z": 1.451
            },
            "gtin": "4066447501131",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271119",
            "leftCorner": {
              "x": 10.706,
              "y": -13.802,
              "z": 1.451
            },
            "rightCorner": {
              "x": 10.678,
              "y": -13.777,
              "z": 1.451
            }
          },
          {
            "id": "696ebf6f43c343680a27111a",
            "leftCorner": {
              "x": 10.678,
              "y": -13.777,
              "z": 1.451
            },
            "rightCorner": {
              "x": 10.635,
              "y": -13.74,
              "z": 1.451
            },
            "gtin": "4067796279436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27111b",
            "leftCorner": {
              "x": 10.635,
              "y": -13.74,
              "z": 1.451
            },
            "rightCorner": {
              "x": 10.563,
              "y": -13.677,
              "z": 1.451
            },
            "gtin": "4066447783070",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27111c",
            "leftCorner": {
              "x": 10.563,
              "y": -13.677,
              "z": 1.451
            },
            "rightCorner": {
              "x": 10.507,
              "y": -13.629,
              "z": 1.451
            },
            "gtin": "4066447579529",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27111d",
            "leftCorner": {
              "x": 10.507,
              "y": -13.629,
              "z": 1.451
            },
            "rightCorner": {
              "x": 10.434,
              "y": -13.565,
              "z": 1.451
            },
            "gtin": "4066447783056",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c11",
        "height": 1.6561,
        "facings": [
          {
            "id": "696ebf6f43c343680a271031",
            "leftCorner": {
              "x": 11.184,
              "y": -14.215,
              "z": 1.656
            },
            "rightCorner": {
              "x": 11.138,
              "y": -14.174,
              "z": 1.656
            },
            "gtin": "4066447565362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271032",
            "leftCorner": {
              "x": 11.138,
              "y": -14.174,
              "z": 1.656
            },
            "rightCorner": {
              "x": 11.089,
              "y": -14.132,
              "z": 1.656
            },
            "gtin": "4066447565362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271033",
            "leftCorner": {
              "x": 11.089,
              "y": -14.132,
              "z": 1.656
            },
            "rightCorner": {
              "x": 11.042,
              "y": -14.091,
              "z": 1.656
            },
            "gtin": "4066447107173",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271034",
            "leftCorner": {
              "x": 11.042,
              "y": -14.091,
              "z": 1.656
            },
            "rightCorner": {
              "x": 11.002,
              "y": -14.056,
              "z": 1.656
            },
            "gtin": "4066447579505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271035",
            "leftCorner": {
              "x": 11.002,
              "y": -14.056,
              "z": 1.656
            },
            "rightCorner": {
              "x": 10.901,
              "y": -13.968,
              "z": 1.656
            },
            "gtin": "4280001383845",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271036",
            "leftCorner": {
              "x": 10.901,
              "y": -13.968,
              "z": 1.656
            },
            "rightCorner": {
              "x": 10.766,
              "y": -13.851,
              "z": 1.656
            },
            "gtin": "4260602129301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271037",
            "leftCorner": {
              "x": 10.766,
              "y": -13.851,
              "z": 1.656
            },
            "rightCorner": {
              "x": 10.73,
              "y": -13.819,
              "z": 1.656
            },
            "gtin": "4260702189731",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271038",
            "leftCorner": {
              "x": 10.73,
              "y": -13.819,
              "z": 1.656
            },
            "rightCorner": {
              "x": 10.699,
              "y": -13.792,
              "z": 1.656
            },
            "gtin": "4260372938943",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271039",
            "leftCorner": {
              "x": 10.699,
              "y": -13.792,
              "z": 1.656
            },
            "rightCorner": {
              "x": 10.599,
              "y": -13.705,
              "z": 1.656
            },
            "gtin": "4262500781865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27103a",
            "leftCorner": {
              "x": 10.599,
              "y": -13.705,
              "z": 1.656
            },
            "rightCorner": {
              "x": 10.499,
              "y": -13.618,
              "z": 1.656
            },
            "gtin": "5000204094015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27103b",
            "leftCorner": {
              "x": 10.499,
              "y": -13.618,
              "z": 1.656
            },
            "rightCorner": {
              "x": 10.429,
              "y": -13.558,
              "z": 1.656
            },
            "gtin": "5000204285802",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc0469598fb",
    "name": "68e7571db5fe7bc0469598fb",
    "x": 10.412,
    "y": -13.607,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93275,
      "w": 0.36052
    },
    "statistics": {
      "hasStockCount": 80,
      "noStockCount": 0,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73a58",
        "height": 0.17302,
        "facings": [
          {
            "id": "696ebf6f43c343680a2710b8",
            "leftCorner": {
              "x": 10.413,
              "y": -13.547,
              "z": 0.173
            },
            "rightCorner": {
              "x": 10.374,
              "y": -13.512,
              "z": 0.173
            },
            "gtin": "850278004046",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710b9",
            "leftCorner": {
              "x": 10.374,
              "y": -13.512,
              "z": 0.173
            },
            "rightCorner": {
              "x": 10.315,
              "y": -13.458,
              "z": 0.173
            },
            "gtin": "4066447577655",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710ba",
            "leftCorner": {
              "x": 10.315,
              "y": -13.458,
              "z": 0.173
            },
            "rightCorner": {
              "x": 10.266,
              "y": -13.413,
              "z": 0.173
            },
            "gtin": "4066447785616",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710bb",
            "leftCorner": {
              "x": 10.266,
              "y": -13.413,
              "z": 0.173
            },
            "rightCorner": {
              "x": 10.213,
              "y": -13.366,
              "z": 0.173
            },
            "gtin": "4066447105773",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710bc",
            "leftCorner": {
              "x": 10.213,
              "y": -13.366,
              "z": 0.173
            },
            "rightCorner": {
              "x": 10.165,
              "y": -13.322,
              "z": 0.173
            },
            "gtin": "4066447106312",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710bd",
            "leftCorner": {
              "x": 10.165,
              "y": -13.322,
              "z": 0.173
            },
            "rightCorner": {
              "x": 10.131,
              "y": -13.291,
              "z": 0.173
            },
            "gtin": "4066447439168",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710be",
            "leftCorner": {
              "x": 10.131,
              "y": -13.291,
              "z": 0.173
            },
            "rightCorner": {
              "x": 10.103,
              "y": -13.266,
              "z": 0.173
            },
            "gtin": "4066447492248",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710bf",
            "leftCorner": {
              "x": 10.103,
              "y": -13.266,
              "z": 0.173
            },
            "rightCorner": {
              "x": 10.066,
              "y": -13.232,
              "z": 0.173
            },
            "gtin": "4066447468366",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710c0",
            "leftCorner": {
              "x": 10.066,
              "y": -13.232,
              "z": 0.173
            },
            "rightCorner": {
              "x": 10.032,
              "y": -13.201,
              "z": 0.173
            },
            "gtin": "5060427353344",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710c1",
            "leftCorner": {
              "x": 10.032,
              "y": -13.201,
              "z": 0.173
            },
            "rightCorner": {
              "x": 10.005,
              "y": -13.176,
              "z": 0.173
            },
            "gtin": "5060950961306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710c2",
            "leftCorner": {
              "x": 10.005,
              "y": -13.176,
              "z": 0.173
            },
            "rightCorner": {
              "x": 9.971,
              "y": -13.145,
              "z": 0.173
            },
            "gtin": "5060950961306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710c3",
            "leftCorner": {
              "x": 9.971,
              "y": -13.145,
              "z": 0.173
            },
            "rightCorner": {
              "x": 9.9,
              "y": -13.081,
              "z": 0.173
            },
            "gtin": "5060427354761",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710c4",
            "leftCorner": {
              "x": 9.9,
              "y": -13.081,
              "z": 0.173
            },
            "rightCorner": {
              "x": 9.814,
              "y": -13.003,
              "z": 0.173
            },
            "gtin": "5060950960071",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710c5",
            "leftCorner": {
              "x": 9.814,
              "y": -13.003,
              "z": 0.173
            },
            "rightCorner": {
              "x": 9.742,
              "y": -12.937,
              "z": 0.173
            },
            "gtin": "4066447234411",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710c6",
            "leftCorner": {
              "x": 9.742,
              "y": -12.937,
              "z": 0.173
            },
            "rightCorner": {
              "x": 9.695,
              "y": -12.894,
              "z": 0.173
            },
            "gtin": "4066447234411",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a5c",
        "height": 0.43501,
        "facings": [
          {
            "id": "696ebf6f43c343680a2711b5",
            "leftCorner": {
              "x": 10.421,
              "y": -13.553,
              "z": 0.435
            },
            "rightCorner": {
              "x": 10.375,
              "y": -13.511,
              "z": 0.435
            },
            "gtin": "4066447502701",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711b6",
            "leftCorner": {
              "x": 10.375,
              "y": -13.511,
              "z": 0.435
            },
            "rightCorner": {
              "x": 10.331,
              "y": -13.471,
              "z": 0.435
            }
          },
          {
            "id": "696ebf6f43c343680a2711b7",
            "leftCorner": {
              "x": 10.331,
              "y": -13.471,
              "z": 0.435
            },
            "rightCorner": {
              "x": 10.271,
              "y": -13.417,
              "z": 0.435
            },
            "gtin": "4066447787078",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711b8",
            "leftCorner": {
              "x": 10.271,
              "y": -13.417,
              "z": 0.435
            },
            "rightCorner": {
              "x": 10.244,
              "y": -13.392,
              "z": 0.435
            }
          },
          {
            "id": "696ebf6f43c343680a2711b9",
            "leftCorner": {
              "x": 10.244,
              "y": -13.392,
              "z": 0.435
            },
            "rightCorner": {
              "x": 10.217,
              "y": -13.367,
              "z": 0.435
            },
            "gtin": "4066447502862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711ba",
            "leftCorner": {
              "x": 10.217,
              "y": -13.367,
              "z": 0.435
            },
            "rightCorner": {
              "x": 10.17,
              "y": -13.324,
              "z": 0.435
            },
            "gtin": "4066447502862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711bb",
            "leftCorner": {
              "x": 10.17,
              "y": -13.324,
              "z": 0.435
            },
            "rightCorner": {
              "x": 10.11,
              "y": -13.27,
              "z": 0.435
            },
            "gtin": "4066447787061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711bc",
            "leftCorner": {
              "x": 10.11,
              "y": -13.27,
              "z": 0.435
            },
            "rightCorner": {
              "x": 10.044,
              "y": -13.211,
              "z": 0.435
            },
            "gtin": "4066447787061",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711bd",
            "leftCorner": {
              "x": 10.044,
              "y": -13.211,
              "z": 0.435
            },
            "rightCorner": {
              "x": 10.009,
              "y": -13.178,
              "z": 0.435
            },
            "gtin": "4066447787573",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711be",
            "leftCorner": {
              "x": 10.009,
              "y": -13.178,
              "z": 0.435
            },
            "rightCorner": {
              "x": 9.98,
              "y": -13.152,
              "z": 0.435
            },
            "gtin": "4066447787573",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711bf",
            "leftCorner": {
              "x": 9.98,
              "y": -13.152,
              "z": 0.435
            },
            "rightCorner": {
              "x": 9.943,
              "y": -13.119,
              "z": 0.435
            },
            "gtin": "4066447787467",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711c0",
            "leftCorner": {
              "x": 9.943,
              "y": -13.119,
              "z": 0.435
            },
            "rightCorner": {
              "x": 9.901,
              "y": -13.08,
              "z": 0.435
            },
            "gtin": "4066447787467",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711c1",
            "leftCorner": {
              "x": 9.901,
              "y": -13.08,
              "z": 0.435
            },
            "rightCorner": {
              "x": 9.864,
              "y": -13.047,
              "z": 0.435
            },
            "gtin": "4066447429473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711c2",
            "leftCorner": {
              "x": 9.864,
              "y": -13.047,
              "z": 0.435
            },
            "rightCorner": {
              "x": 9.809,
              "y": -12.996,
              "z": 0.435
            },
            "gtin": "4066447429473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711c3",
            "leftCorner": {
              "x": 9.809,
              "y": -12.996,
              "z": 0.435
            },
            "rightCorner": {
              "x": 9.77,
              "y": -12.961,
              "z": 0.435
            },
            "gtin": "4067796163407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711c4",
            "leftCorner": {
              "x": 9.77,
              "y": -12.961,
              "z": 0.435
            },
            "rightCorner": {
              "x": 9.728,
              "y": -12.923,
              "z": 0.435
            },
            "gtin": "4067796244984",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711c5",
            "leftCorner": {
              "x": 9.728,
              "y": -12.923,
              "z": 0.435
            },
            "rightCorner": {
              "x": 9.683,
              "y": -12.882,
              "z": 0.435
            },
            "gtin": "4067796244984",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a56",
        "height": 0.7269,
        "facings": [
          {
            "id": "696ebf6f43c343680a27100a",
            "leftCorner": {
              "x": 10.395,
              "y": -13.521,
              "z": 0.727
            },
            "rightCorner": {
              "x": 10.302,
              "y": -13.437,
              "z": 0.727
            },
            "gtin": "4066447578034",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27100b",
            "leftCorner": {
              "x": 10.302,
              "y": -13.437,
              "z": 0.727
            },
            "rightCorner": {
              "x": 10.252,
              "y": -13.391,
              "z": 0.727
            }
          },
          {
            "id": "696ebf6f43c343680a27100c",
            "leftCorner": {
              "x": 10.252,
              "y": -13.391,
              "z": 0.727
            },
            "rightCorner": {
              "x": 10.174,
              "y": -13.32,
              "z": 0.727
            },
            "gtin": "4006000131030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27100d",
            "leftCorner": {
              "x": 10.174,
              "y": -13.32,
              "z": 0.727
            },
            "rightCorner": {
              "x": 10.125,
              "y": -13.275,
              "z": 0.727
            },
            "gtin": "4006000139395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27100e",
            "leftCorner": {
              "x": 10.125,
              "y": -13.275,
              "z": 0.727
            },
            "rightCorner": {
              "x": 10.072,
              "y": -13.228,
              "z": 0.727
            },
            "gtin": "4006000139395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27100f",
            "leftCorner": {
              "x": 10.072,
              "y": -13.228,
              "z": 0.727
            },
            "rightCorner": {
              "x": 10.025,
              "y": -13.184,
              "z": 0.727
            },
            "gtin": "4006000130996",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271010",
            "leftCorner": {
              "x": 10.025,
              "y": -13.184,
              "z": 0.727
            },
            "rightCorner": {
              "x": 9.98,
              "y": -13.144,
              "z": 0.727
            },
            "gtin": "4006000139319",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271011",
            "leftCorner": {
              "x": 9.98,
              "y": -13.144,
              "z": 0.727
            },
            "rightCorner": {
              "x": 9.929,
              "y": -13.097,
              "z": 0.727
            },
            "gtin": "4005900468222",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271012",
            "leftCorner": {
              "x": 9.929,
              "y": -13.097,
              "z": 0.727
            },
            "rightCorner": {
              "x": 9.883,
              "y": -13.055,
              "z": 0.727
            },
            "gtin": "4005900997937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271013",
            "leftCorner": {
              "x": 9.883,
              "y": -13.055,
              "z": 0.727
            },
            "rightCorner": {
              "x": 9.846,
              "y": -13.022,
              "z": 0.727
            },
            "gtin": "4005900691774",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271014",
            "leftCorner": {
              "x": 9.846,
              "y": -13.022,
              "z": 0.727
            },
            "rightCorner": {
              "x": 9.817,
              "y": -12.996,
              "z": 0.727
            },
            "gtin": "4005900870407",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271015",
            "leftCorner": {
              "x": 9.817,
              "y": -12.996,
              "z": 0.727
            },
            "rightCorner": {
              "x": 9.759,
              "y": -12.943,
              "z": 0.727
            },
            "gtin": "4006000136264",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271016",
            "leftCorner": {
              "x": 9.759,
              "y": -12.943,
              "z": 0.727
            },
            "rightCorner": {
              "x": 9.707,
              "y": -12.896,
              "z": 0.727
            },
            "gtin": "4006000131078",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a5a",
        "height": 0.97912,
        "facings": [
          {
            "id": "696ebf6f43c343680a27114e",
            "leftCorner": {
              "x": 10.43,
              "y": -13.549,
              "z": 0.979
            },
            "rightCorner": {
              "x": 10.38,
              "y": -13.504,
              "z": 0.979
            },
            "gtin": "4066447578591",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27114f",
            "leftCorner": {
              "x": 10.38,
              "y": -13.504,
              "z": 0.979
            },
            "rightCorner": {
              "x": 10.328,
              "y": -13.456,
              "z": 0.979
            }
          },
          {
            "id": "696ebf6f43c343680a271150",
            "leftCorner": {
              "x": 10.328,
              "y": -13.456,
              "z": 0.979
            },
            "rightCorner": {
              "x": 10.274,
              "y": -13.407,
              "z": 0.979
            },
            "gtin": "3600542520416",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271151",
            "leftCorner": {
              "x": 10.274,
              "y": -13.407,
              "z": 0.979
            },
            "rightCorner": {
              "x": 10.246,
              "y": -13.382,
              "z": 0.979
            },
            "gtin": "3600542520300",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271152",
            "leftCorner": {
              "x": 10.246,
              "y": -13.382,
              "z": 0.979
            },
            "rightCorner": {
              "x": 10.219,
              "y": -13.357,
              "z": 0.979
            },
            "gtin": "3600542520300",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271153",
            "leftCorner": {
              "x": 10.219,
              "y": -13.357,
              "z": 0.979
            },
            "rightCorner": {
              "x": 10.171,
              "y": -13.314,
              "z": 0.979
            },
            "gtin": "3600542624909",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271154",
            "leftCorner": {
              "x": 10.171,
              "y": -13.314,
              "z": 0.979
            },
            "rightCorner": {
              "x": 10.124,
              "y": -13.271,
              "z": 0.979
            },
            "gtin": "3600542624909",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271155",
            "leftCorner": {
              "x": 10.124,
              "y": -13.271,
              "z": 0.979
            },
            "rightCorner": {
              "x": 10.077,
              "y": -13.229,
              "z": 0.979
            },
            "gtin": "3600542572729",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271156",
            "leftCorner": {
              "x": 10.077,
              "y": -13.229,
              "z": 0.979
            },
            "rightCorner": {
              "x": 10.039,
              "y": -13.194,
              "z": 0.979
            },
            "gtin": "4006000130910",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271157",
            "leftCorner": {
              "x": 10.039,
              "y": -13.194,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.988,
              "y": -13.147,
              "z": 0.979
            },
            "gtin": "4005900695826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271158",
            "leftCorner": {
              "x": 9.988,
              "y": -13.147,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.94,
              "y": -13.104,
              "z": 0.979
            },
            "gtin": "4005809854027",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271159",
            "leftCorner": {
              "x": 9.94,
              "y": -13.104,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.889,
              "y": -13.058,
              "z": 0.979
            },
            "gtin": "4005809854027",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27115a",
            "leftCorner": {
              "x": 9.889,
              "y": -13.058,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.838,
              "y": -13.011,
              "z": 0.979
            },
            "gtin": "4005808856695",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27115b",
            "leftCorner": {
              "x": 9.838,
              "y": -13.011,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.79,
              "y": -12.968,
              "z": 0.979
            },
            "gtin": "4005900609045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27115c",
            "leftCorner": {
              "x": 9.79,
              "y": -12.968,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.757,
              "y": -12.938,
              "z": 0.979
            }
          },
          {
            "id": "696ebf6f43c343680a27115d",
            "leftCorner": {
              "x": 9.757,
              "y": -12.938,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.716,
              "y": -12.9,
              "z": 0.979
            }
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a5b",
        "height": 1.2331,
        "facings": [
          {
            "id": "696ebf6f43c343680a271177",
            "leftCorner": {
              "x": 10.43,
              "y": -13.544,
              "z": 1.233
            },
            "rightCorner": {
              "x": 10.385,
              "y": -13.503,
              "z": 1.233
            },
            "gtin": "3600542573740",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271178",
            "leftCorner": {
              "x": 10.385,
              "y": -13.503,
              "z": 1.233
            },
            "rightCorner": {
              "x": 10.346,
              "y": -13.468,
              "z": 1.233
            },
            "gtin": "3600542573795",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271179",
            "leftCorner": {
              "x": 10.346,
              "y": -13.468,
              "z": 1.233
            },
            "rightCorner": {
              "x": 10.314,
              "y": -13.439,
              "z": 1.233
            },
            "gtin": "3600542513913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27117a",
            "leftCorner": {
              "x": 10.314,
              "y": -13.439,
              "z": 1.233
            },
            "rightCorner": {
              "x": 10.284,
              "y": -13.412,
              "z": 1.233
            },
            "gtin": "3600542298209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27117b",
            "leftCorner": {
              "x": 10.284,
              "y": -13.412,
              "z": 1.233
            },
            "rightCorner": {
              "x": 10.259,
              "y": -13.388,
              "z": 1.233
            },
            "gtin": "3600542298209",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27117c",
            "leftCorner": {
              "x": 10.259,
              "y": -13.388,
              "z": 1.233
            },
            "rightCorner": {
              "x": 10.221,
              "y": -13.354,
              "z": 1.233
            },
            "gtin": "3600542518390",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27117d",
            "leftCorner": {
              "x": 10.221,
              "y": -13.354,
              "z": 1.233
            },
            "rightCorner": {
              "x": 10.178,
              "y": -13.314,
              "z": 1.233
            },
            "gtin": "3600542397735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27117e",
            "leftCorner": {
              "x": 10.178,
              "y": -13.314,
              "z": 1.233
            },
            "rightCorner": {
              "x": 10.151,
              "y": -13.291,
              "z": 1.233
            },
            "gtin": "3600542624619",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27117f",
            "leftCorner": {
              "x": 10.151,
              "y": -13.291,
              "z": 1.233
            },
            "rightCorner": {
              "x": 10.118,
              "y": -13.261,
              "z": 1.233
            },
            "gtin": "4005900599100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271180",
            "leftCorner": {
              "x": 10.118,
              "y": -13.261,
              "z": 1.233
            },
            "rightCorner": {
              "x": 10.08,
              "y": -13.226,
              "z": 1.233
            },
            "gtin": "4006000061887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271181",
            "leftCorner": {
              "x": 10.08,
              "y": -13.226,
              "z": 1.233
            },
            "rightCorner": {
              "x": 10.045,
              "y": -13.194,
              "z": 1.233
            },
            "gtin": "4005900481597",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271182",
            "leftCorner": {
              "x": 10.045,
              "y": -13.194,
              "z": 1.233
            },
            "rightCorner": {
              "x": 10.013,
              "y": -13.165,
              "z": 1.233
            },
            "gtin": "4005900475626",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271183",
            "leftCorner": {
              "x": 10.013,
              "y": -13.165,
              "z": 1.233
            },
            "rightCorner": {
              "x": 9.981,
              "y": -13.135,
              "z": 1.233
            },
            "gtin": "4006000136295",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271184",
            "leftCorner": {
              "x": 9.981,
              "y": -13.135,
              "z": 1.233
            },
            "rightCorner": {
              "x": 9.943,
              "y": -13.101,
              "z": 1.233
            },
            "gtin": "4005900998088",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271185",
            "leftCorner": {
              "x": 9.943,
              "y": -13.101,
              "z": 1.233
            },
            "rightCorner": {
              "x": 9.899,
              "y": -13.061,
              "z": 1.233
            },
            "gtin": "4006000128221",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271186",
            "leftCorner": {
              "x": 9.899,
              "y": -13.061,
              "z": 1.233
            },
            "rightCorner": {
              "x": 9.854,
              "y": -13.02,
              "z": 1.233
            },
            "gtin": "4006000172378",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271187",
            "leftCorner": {
              "x": 9.854,
              "y": -13.02,
              "z": 1.233
            },
            "rightCorner": {
              "x": 9.825,
              "y": -12.994,
              "z": 1.233
            },
            "gtin": "42417941",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271188",
            "leftCorner": {
              "x": 9.825,
              "y": -12.994,
              "z": 1.233
            },
            "rightCorner": {
              "x": 9.804,
              "y": -12.975,
              "z": 1.233
            },
            "gtin": "42417941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271189",
            "leftCorner": {
              "x": 9.804,
              "y": -12.975,
              "z": 1.233
            },
            "rightCorner": {
              "x": 9.764,
              "y": -12.938,
              "z": 1.233
            },
            "gtin": "5017634276041",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27118a",
            "leftCorner": {
              "x": 9.764,
              "y": -12.938,
              "z": 1.233
            },
            "rightCorner": {
              "x": 9.723,
              "y": -12.901,
              "z": 1.233
            },
            "gtin": "5017634295813",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a59",
        "height": 1.446,
        "facings": [
          {
            "id": "696ebf6f43c343680a27111e",
            "leftCorner": {
              "x": 10.46,
              "y": -13.566,
              "z": 1.446
            },
            "rightCorner": {
              "x": 10.364,
              "y": -13.479,
              "z": 1.446
            },
            "gtin": "4006000077963",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27111f",
            "leftCorner": {
              "x": 10.364,
              "y": -13.479,
              "z": 1.446
            },
            "rightCorner": {
              "x": 10.248,
              "y": -13.374,
              "z": 1.446
            },
            "gtin": "4066447565669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271120",
            "leftCorner": {
              "x": 10.248,
              "y": -13.374,
              "z": 1.446
            },
            "rightCorner": {
              "x": 10.17,
              "y": -13.303,
              "z": 1.446
            },
            "gtin": "4067796135732",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271121",
            "leftCorner": {
              "x": 10.17,
              "y": -13.303,
              "z": 1.446
            },
            "rightCorner": {
              "x": 10.129,
              "y": -13.265,
              "z": 1.446
            },
            "gtin": "4066447105711",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271122",
            "leftCorner": {
              "x": 10.129,
              "y": -13.265,
              "z": 1.446
            },
            "rightCorner": {
              "x": 10.087,
              "y": -13.227,
              "z": 1.446
            },
            "gtin": "4066447577952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271123",
            "leftCorner": {
              "x": 10.087,
              "y": -13.227,
              "z": 1.446
            },
            "rightCorner": {
              "x": 10.043,
              "y": -13.187,
              "z": 1.446
            },
            "gtin": "4066447577891",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271124",
            "leftCorner": {
              "x": 10.043,
              "y": -13.187,
              "z": 1.446
            },
            "rightCorner": {
              "x": 9.999,
              "y": -13.148,
              "z": 1.446
            },
            "gtin": "4066447577914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271125",
            "leftCorner": {
              "x": 9.999,
              "y": -13.148,
              "z": 1.446
            },
            "rightCorner": {
              "x": 9.96,
              "y": -13.112,
              "z": 1.446
            },
            "gtin": "4066447106381",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271126",
            "leftCorner": {
              "x": 9.96,
              "y": -13.112,
              "z": 1.446
            },
            "rightCorner": {
              "x": 9.901,
              "y": -13.058,
              "z": 1.446
            },
            "gtin": "4067796119114",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271127",
            "leftCorner": {
              "x": 9.901,
              "y": -13.058,
              "z": 1.446
            },
            "rightCorner": {
              "x": 9.846,
              "y": -13.008,
              "z": 1.446
            },
            "gtin": "4066447786323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271128",
            "leftCorner": {
              "x": 9.846,
              "y": -13.008,
              "z": 1.446
            },
            "rightCorner": {
              "x": 9.801,
              "y": -12.967,
              "z": 1.446
            },
            "gtin": "4066447105650",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271129",
            "leftCorner": {
              "x": 9.801,
              "y": -12.967,
              "z": 1.446
            },
            "rightCorner": {
              "x": 9.761,
              "y": -12.931,
              "z": 1.446
            },
            "gtin": "4066447105650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27112a",
            "leftCorner": {
              "x": 9.761,
              "y": -12.931,
              "z": 1.446
            },
            "rightCorner": {
              "x": 9.72,
              "y": -12.894,
              "z": 1.446
            },
            "gtin": "4066447577976",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a57",
        "height": 1.6524,
        "facings": [
          {
            "id": "696ebf6f43c343680a27103c",
            "leftCorner": {
              "x": 10.454,
              "y": -13.559,
              "z": 1.652
            },
            "rightCorner": {
              "x": 10.412,
              "y": -13.52,
              "z": 1.652
            },
            "gtin": "5000204093711",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27103d",
            "leftCorner": {
              "x": 10.412,
              "y": -13.52,
              "z": 1.652
            },
            "rightCorner": {
              "x": 10.354,
              "y": -13.468,
              "z": 1.652
            },
            "gtin": "5000204093681",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27103e",
            "leftCorner": {
              "x": 10.354,
              "y": -13.468,
              "z": 1.652
            },
            "rightCorner": {
              "x": 10.286,
              "y": -13.405,
              "z": 1.652
            },
            "gtin": "4066447639339",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27103f",
            "leftCorner": {
              "x": 10.286,
              "y": -13.405,
              "z": 1.652
            },
            "rightCorner": {
              "x": 10.236,
              "y": -13.36,
              "z": 1.652
            },
            "gtin": "4067796149234",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271040",
            "leftCorner": {
              "x": 10.236,
              "y": -13.36,
              "z": 1.652
            },
            "rightCorner": {
              "x": 10.202,
              "y": -13.33,
              "z": 1.652
            },
            "gtin": "4067796149234",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271041",
            "leftCorner": {
              "x": 10.202,
              "y": -13.33,
              "z": 1.652
            },
            "rightCorner": {
              "x": 10.154,
              "y": -13.285,
              "z": 1.652
            },
            "gtin": "4067796149258",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271042",
            "leftCorner": {
              "x": 10.154,
              "y": -13.285,
              "z": 1.652
            },
            "rightCorner": {
              "x": 10.118,
              "y": -13.253,
              "z": 1.652
            },
            "gtin": "4067796149258",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271043",
            "leftCorner": {
              "x": 10.118,
              "y": -13.253,
              "z": 1.652
            },
            "rightCorner": {
              "x": 10.085,
              "y": -13.223,
              "z": 1.652
            }
          },
          {
            "id": "696ebf6f43c343680a271044",
            "leftCorner": {
              "x": 10.085,
              "y": -13.223,
              "z": 1.652
            },
            "rightCorner": {
              "x": 10.054,
              "y": -13.195,
              "z": 1.652
            },
            "gtin": "4067796149050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271045",
            "leftCorner": {
              "x": 10.054,
              "y": -13.195,
              "z": 1.652
            },
            "rightCorner": {
              "x": 10.022,
              "y": -13.166,
              "z": 1.652
            },
            "gtin": "4067796149050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271046",
            "leftCorner": {
              "x": 10.022,
              "y": -13.166,
              "z": 1.652
            },
            "rightCorner": {
              "x": 9.985,
              "y": -13.132,
              "z": 1.652
            }
          },
          {
            "id": "696ebf6f43c343680a271047",
            "leftCorner": {
              "x": 9.985,
              "y": -13.132,
              "z": 1.652
            },
            "rightCorner": {
              "x": 9.946,
              "y": -13.097,
              "z": 1.652
            },
            "gtin": "4067796150391",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271048",
            "leftCorner": {
              "x": 9.946,
              "y": -13.097,
              "z": 1.652
            },
            "rightCorner": {
              "x": 9.899,
              "y": -13.054,
              "z": 1.652
            },
            "gtin": "4066447639353",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271049",
            "leftCorner": {
              "x": 9.899,
              "y": -13.054,
              "z": 1.652
            },
            "rightCorner": {
              "x": 9.843,
              "y": -13.003,
              "z": 1.652
            },
            "gtin": "4083700304582",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27104a",
            "leftCorner": {
              "x": 9.843,
              "y": -13.003,
              "z": 1.652
            },
            "rightCorner": {
              "x": 9.775,
              "y": -12.941,
              "z": 1.652
            },
            "gtin": "4260624040639",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27104b",
            "leftCorner": {
              "x": 9.775,
              "y": -12.941,
              "z": 1.652
            },
            "rightCorner": {
              "x": 9.731,
              "y": -12.901,
              "z": 1.652
            },
            "gtin": "4006000216959",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc0469598fc",
    "name": "68e7571db5fe7bc0469598fc",
    "x": 9.642,
    "y": -12.917,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93425,
      "w": 0.35662
    },
    "statistics": {
      "hasStockCount": 21,
      "noStockCount": 0,
      "unknownStockCount": 40,
      "shelfCategory": "DEO"
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73a62",
        "height": 0.17906,
        "facings": [
          {
            "id": "696ebf6f43c343680a2710c7",
            "leftCorner": {
              "x": 9.664,
              "y": -12.876,
              "z": 0.179
            },
            "rightCorner": {
              "x": 9.556,
              "y": -12.779,
              "z": 0.179
            }
          },
          {
            "id": "696ebf6f43c343680a2710c8",
            "leftCorner": {
              "x": 9.556,
              "y": -12.779,
              "z": 0.179
            },
            "rightCorner": {
              "x": 9.506,
              "y": -12.735,
              "z": 0.179
            },
            "gtin": "4066447575804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710c9",
            "leftCorner": {
              "x": 9.506,
              "y": -12.735,
              "z": 0.179
            },
            "rightCorner": {
              "x": 9.449,
              "y": -12.684,
              "z": 0.179
            }
          },
          {
            "id": "696ebf6f43c343680a2710ca",
            "leftCorner": {
              "x": 9.449,
              "y": -12.684,
              "z": 0.179
            },
            "rightCorner": {
              "x": 9.381,
              "y": -12.623,
              "z": 0.179
            },
            "gtin": "4066447240276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710cb",
            "leftCorner": {
              "x": 9.381,
              "y": -12.623,
              "z": 0.179
            },
            "rightCorner": {
              "x": 9.268,
              "y": -12.522,
              "z": 0.179
            },
            "gtin": "4067796164824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710cc",
            "leftCorner": {
              "x": 9.268,
              "y": -12.522,
              "z": 0.179
            },
            "rightCorner": {
              "x": 9.137,
              "y": -12.405,
              "z": 0.179
            },
            "gtin": "4067796080957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710cd",
            "leftCorner": {
              "x": 9.137,
              "y": -12.405,
              "z": 0.179
            },
            "rightCorner": {
              "x": 9.039,
              "y": -12.317,
              "z": 0.179
            },
            "gtin": "4066447873108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710ce",
            "leftCorner": {
              "x": 9.039,
              "y": -12.317,
              "z": 0.179
            },
            "rightCorner": {
              "x": 8.973,
              "y": -12.258,
              "z": 0.179
            },
            "gtin": "4066447873108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710cf",
            "leftCorner": {
              "x": 8.973,
              "y": -12.258,
              "z": 0.179
            },
            "rightCorner": {
              "x": 8.898,
              "y": -12.192,
              "z": 0.179
            },
            "gtin": "4066447234633",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a63",
        "height": 0.43839,
        "facings": [
          {
            "id": "696ebf6f43c343680a2711c6",
            "leftCorner": {
              "x": 9.651,
              "y": -12.867,
              "z": 0.438
            },
            "rightCorner": {
              "x": 9.611,
              "y": -12.832,
              "z": 0.438
            },
            "gtin": "4066447410549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711c7",
            "leftCorner": {
              "x": 9.611,
              "y": -12.832,
              "z": 0.438
            },
            "rightCorner": {
              "x": 9.575,
              "y": -12.799,
              "z": 0.438
            },
            "gtin": "4066447410549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711c8",
            "leftCorner": {
              "x": 9.575,
              "y": -12.799,
              "z": 0.438
            },
            "rightCorner": {
              "x": 9.535,
              "y": -12.763,
              "z": 0.438
            }
          },
          {
            "id": "696ebf6f43c343680a2711c9",
            "leftCorner": {
              "x": 9.535,
              "y": -12.763,
              "z": 0.438
            },
            "rightCorner": {
              "x": 9.498,
              "y": -12.73,
              "z": 0.438
            },
            "gtin": "4067796069792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711ca",
            "leftCorner": {
              "x": 9.498,
              "y": -12.73,
              "z": 0.438
            },
            "rightCorner": {
              "x": 9.453,
              "y": -12.69,
              "z": 0.438
            },
            "gtin": "4066447410464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711cb",
            "leftCorner": {
              "x": 9.453,
              "y": -12.69,
              "z": 0.438
            },
            "rightCorner": {
              "x": 9.423,
              "y": -12.663,
              "z": 0.438
            },
            "gtin": "4066447410464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711cc",
            "leftCorner": {
              "x": 9.423,
              "y": -12.663,
              "z": 0.438
            },
            "rightCorner": {
              "x": 9.296,
              "y": -12.55,
              "z": 0.438
            },
            "gtin": "4066447410525",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711cd",
            "leftCorner": {
              "x": 9.296,
              "y": -12.55,
              "z": 0.438
            },
            "rightCorner": {
              "x": 9.063,
              "y": -12.341,
              "z": 0.438
            },
            "gtin": "4066447410488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711ce",
            "leftCorner": {
              "x": 9.063,
              "y": -12.341,
              "z": 0.438
            },
            "rightCorner": {
              "x": 8.937,
              "y": -12.229,
              "z": 0.438
            },
            "gtin": "4058172784552",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a5e",
        "height": 0.73079,
        "facings": [
          {
            "id": "696ebf6f43c343680a271017",
            "leftCorner": {
              "x": 9.673,
              "y": -12.882,
              "z": 0.731
            },
            "rightCorner": {
              "x": 9.644,
              "y": -12.855,
              "z": 0.731
            },
            "gtin": "4015100863635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271018",
            "leftCorner": {
              "x": 9.643,
              "y": -12.855,
              "z": 0.731
            },
            "rightCorner": {
              "x": 9.605,
              "y": -12.821,
              "z": 0.731
            },
            "gtin": "4015100863635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271019",
            "leftCorner": {
              "x": 9.605,
              "y": -12.821,
              "z": 0.731
            },
            "rightCorner": {
              "x": 9.577,
              "y": -12.796,
              "z": 0.731
            },
            "gtin": "4015100863659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27101a",
            "leftCorner": {
              "x": 9.577,
              "y": -12.796,
              "z": 0.731
            },
            "rightCorner": {
              "x": 9.547,
              "y": -12.769,
              "z": 0.731
            },
            "gtin": "4015100429022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27101b",
            "leftCorner": {
              "x": 9.547,
              "y": -12.769,
              "z": 0.731
            },
            "rightCorner": {
              "x": 9.51,
              "y": -12.736,
              "z": 0.731
            },
            "gtin": "4006000092621",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27101c",
            "leftCorner": {
              "x": 9.51,
              "y": -12.736,
              "z": 0.731
            },
            "rightCorner": {
              "x": 9.475,
              "y": -12.705,
              "z": 0.731
            },
            "gtin": "4006000092621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27101d",
            "leftCorner": {
              "x": 9.475,
              "y": -12.705,
              "z": 0.731
            },
            "rightCorner": {
              "x": 9.329,
              "y": -12.574,
              "z": 0.731
            },
            "gtin": "4006000094250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27101e",
            "leftCorner": {
              "x": 9.329,
              "y": -12.574,
              "z": 0.731
            },
            "rightCorner": {
              "x": 9.084,
              "y": -12.356,
              "z": 0.731
            },
            "gtin": "4006000092706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27101f",
            "leftCorner": {
              "x": 9.084,
              "y": -12.356,
              "z": 0.731
            },
            "rightCorner": {
              "x": 8.956,
              "y": -12.241,
              "z": 0.731
            },
            "gtin": "4006000092973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271020",
            "leftCorner": {
              "x": 8.956,
              "y": -12.241,
              "z": 0.731
            },
            "rightCorner": {
              "x": 8.92,
              "y": -12.209,
              "z": 0.731
            },
            "gtin": "4006000168159",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a5d",
        "height": 0.9844,
        "facings": [
          {
            "id": "696ebf6f43c343680a27115e",
            "leftCorner": {
              "x": 9.67,
              "y": -12.877,
              "z": 0.984
            },
            "rightCorner": {
              "x": 9.63,
              "y": -12.842,
              "z": 0.984
            },
            "gtin": "8008970059761",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27115f",
            "leftCorner": {
              "x": 9.63,
              "y": -12.842,
              "z": 0.984
            },
            "rightCorner": {
              "x": 9.597,
              "y": -12.812,
              "z": 0.984
            },
            "gtin": "8008970060460",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271160",
            "leftCorner": {
              "x": 9.597,
              "y": -12.812,
              "z": 0.984
            },
            "rightCorner": {
              "x": 9.558,
              "y": -12.777,
              "z": 0.984
            },
            "gtin": "4006000160450",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271161",
            "leftCorner": {
              "x": 9.558,
              "y": -12.777,
              "z": 0.984
            },
            "rightCorner": {
              "x": 9.522,
              "y": -12.745,
              "z": 0.984
            },
            "gtin": "4006000172590",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271162",
            "leftCorner": {
              "x": 9.522,
              "y": -12.745,
              "z": 0.984
            },
            "rightCorner": {
              "x": 9.486,
              "y": -12.713,
              "z": 0.984
            },
            "gtin": "4006000170534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271163",
            "leftCorner": {
              "x": 9.486,
              "y": -12.713,
              "z": 0.984
            },
            "rightCorner": {
              "x": 9.451,
              "y": -12.682,
              "z": 0.984
            },
            "gtin": "4006000160214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271164",
            "leftCorner": {
              "x": 9.451,
              "y": -12.682,
              "z": 0.984
            },
            "rightCorner": {
              "x": 9.376,
              "y": -12.615,
              "z": 0.984
            },
            "gtin": "4006000160290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271165",
            "leftCorner": {
              "x": 9.376,
              "y": -12.615,
              "z": 0.984
            },
            "rightCorner": {
              "x": 9.148,
              "y": -12.411,
              "z": 0.984
            },
            "gtin": "8720181437755",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271166",
            "leftCorner": {
              "x": 9.148,
              "y": -12.411,
              "z": 0.984
            },
            "rightCorner": {
              "x": 8.931,
              "y": -12.216,
              "z": 0.984
            },
            "gtin": "8720181437762",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a61",
        "height": 1.2369,
        "facings": [
          {
            "id": "696ebf6f43c343680a27118b",
            "leftCorner": {
              "x": 9.678,
              "y": -12.875,
              "z": 1.237
            },
            "rightCorner": {
              "x": 9.645,
              "y": -12.846,
              "z": 1.237
            },
            "gtin": "4033419231013",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27118c",
            "leftCorner": {
              "x": 9.645,
              "y": -12.846,
              "z": 1.237
            },
            "rightCorner": {
              "x": 9.616,
              "y": -12.82,
              "z": 1.237
            },
            "gtin": "4033419251011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27118d",
            "leftCorner": {
              "x": 9.616,
              "y": -12.82,
              "z": 1.237
            },
            "rightCorner": {
              "x": 9.591,
              "y": -12.797,
              "z": 1.237
            },
            "gtin": "4033419103105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27118e",
            "leftCorner": {
              "x": 9.591,
              "y": -12.797,
              "z": 1.237
            },
            "rightCorner": {
              "x": 9.557,
              "y": -12.767,
              "z": 1.237
            },
            "gtin": "4066447502978",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27118f",
            "leftCorner": {
              "x": 9.557,
              "y": -12.767,
              "z": 1.237
            },
            "rightCorner": {
              "x": 9.528,
              "y": -12.741,
              "z": 1.237
            },
            "gtin": "4066447502978",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271190",
            "leftCorner": {
              "x": 9.528,
              "y": -12.741,
              "z": 1.237
            },
            "rightCorner": {
              "x": 9.493,
              "y": -12.71,
              "z": 1.237
            },
            "gtin": "4009800001671",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271191",
            "leftCorner": {
              "x": 9.493,
              "y": -12.71,
              "z": 1.237
            },
            "rightCorner": {
              "x": 9.465,
              "y": -12.685,
              "z": 1.237
            },
            "gtin": "4010355559616",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271192",
            "leftCorner": {
              "x": 9.465,
              "y": -12.685,
              "z": 1.237
            },
            "rightCorner": {
              "x": 9.436,
              "y": -12.659,
              "z": 1.237
            },
            "gtin": "4010355559616",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271193",
            "leftCorner": {
              "x": 9.436,
              "y": -12.659,
              "z": 1.237
            },
            "rightCorner": {
              "x": 9.18,
              "y": -12.43,
              "z": 1.237
            },
            "gtin": "4045612010555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271194",
            "leftCorner": {
              "x": 9.18,
              "y": -12.43,
              "z": 1.237
            },
            "rightCorner": {
              "x": 9.133,
              "y": -12.388,
              "z": 1.237
            },
            "gtin": "4045612007906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271195",
            "leftCorner": {
              "x": 9.103,
              "y": -12.341,
              "z": 1.235
            },
            "rightCorner": {
              "x": 9.037,
              "y": -12.282,
              "z": 1.235
            },
            "gtin": "5014697017086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271196",
            "leftCorner": {
              "x": 9.037,
              "y": -12.282,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.969,
              "y": -12.221,
              "z": 1.235
            },
            "gtin": "4006000102962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271197",
            "leftCorner": {
              "x": 8.969,
              "y": -12.221,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.913,
              "y": -12.172,
              "z": 1.235
            },
            "gtin": "8001280026102",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a5f",
        "height": 1.4512,
        "facings": [
          {
            "id": "696ebf6f43c343680a27112b",
            "leftCorner": {
              "x": 9.676,
              "y": -12.866,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.643,
              "y": -12.837,
              "z": 1.451
            },
            "gtin": "4103040036742",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27112c",
            "leftCorner": {
              "x": 9.643,
              "y": -12.837,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.605,
              "y": -12.803,
              "z": 1.451
            },
            "gtin": "4103040036728",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27112d",
            "leftCorner": {
              "x": 9.605,
              "y": -12.803,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.572,
              "y": -12.774,
              "z": 1.451
            },
            "gtin": "4103040036766",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27112e",
            "leftCorner": {
              "x": 9.572,
              "y": -12.774,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.539,
              "y": -12.744,
              "z": 1.451
            },
            "gtin": "4009800001602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27112f",
            "leftCorner": {
              "x": 9.539,
              "y": -12.744,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.509,
              "y": -12.718,
              "z": 1.451
            },
            "gtin": "4009800002005",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271130",
            "leftCorner": {
              "x": 9.509,
              "y": -12.718,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.226,
              "y": -12.465,
              "z": 1.451
            },
            "gtin": "4066447354393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271131",
            "leftCorner": {
              "x": 9.226,
              "y": -12.465,
              "z": 1.451
            },
            "rightCorner": {
              "x": 8.939,
              "y": -12.208,
              "z": 1.451
            },
            "gtin": "4067796081978",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a60",
        "height": 1.6593,
        "facings": [
          {
            "id": "696ebf6f43c343680a27104c",
            "leftCorner": {
              "x": 9.687,
              "y": -12.877,
              "z": 1.659
            },
            "rightCorner": {
              "x": 9.649,
              "y": -12.843,
              "z": 1.659
            }
          },
          {
            "id": "696ebf6f43c343680a27104d",
            "leftCorner": {
              "x": 9.649,
              "y": -12.843,
              "z": 1.659
            },
            "rightCorner": {
              "x": 9.615,
              "y": -12.812,
              "z": 1.659
            },
            "gtin": "4006000131511",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27104e",
            "leftCorner": {
              "x": 9.615,
              "y": -12.812,
              "z": 1.659
            },
            "rightCorner": {
              "x": 9.58,
              "y": -12.782,
              "z": 1.659
            },
            "gtin": "4006000088549",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27104f",
            "leftCorner": {
              "x": 9.58,
              "y": -12.782,
              "z": 1.659
            },
            "rightCorner": {
              "x": 9.554,
              "y": -12.758,
              "z": 1.659
            },
            "gtin": "4006000121062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271050",
            "leftCorner": {
              "x": 9.554,
              "y": -12.758,
              "z": 1.659
            },
            "rightCorner": {
              "x": 9.514,
              "y": -12.722,
              "z": 1.659
            },
            "gtin": "4006000127767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271051",
            "leftCorner": {
              "x": 9.514,
              "y": -12.722,
              "z": 1.659
            },
            "rightCorner": {
              "x": 9.471,
              "y": -12.684,
              "z": 1.659
            },
            "gtin": "4006000129792",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271052",
            "leftCorner": {
              "x": 9.471,
              "y": -12.684,
              "z": 1.659
            },
            "rightCorner": {
              "x": 9.186,
              "y": -12.43,
              "z": 1.659
            },
            "gtin": "8720181585128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271053",
            "leftCorner": {
              "x": 9.186,
              "y": -12.43,
              "z": 1.659
            },
            "rightCorner": {
              "x": 8.943,
              "y": -12.212,
              "z": 1.659
            },
            "gtin": "8712561521840",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc0469598fd",
    "name": "68e7571db5fe7bc0469598fd",
    "x": 8.8667,
    "y": -12.203,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93431,
      "w": 0.35646
    },
    "statistics": {
      "hasStockCount": 58,
      "noStockCount": 1,
      "unknownStockCount": 47,
      "shelfCategory": "DEO"
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73a6a",
        "height": 0.17461,
        "facings": [
          {
            "id": "696ebf6f43c343680a2710d0",
            "leftCorner": {
              "x": 8.869,
              "y": -12.144,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.8,
              "y": -12.083,
              "z": 0.175
            },
            "gtin": "4066447873092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710d1",
            "leftCorner": {
              "x": 8.8,
              "y": -12.083,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.739,
              "y": -12.029,
              "z": 0.175
            },
            "gtin": "4066447873092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710d2",
            "leftCorner": {
              "x": 8.739,
              "y": -12.029,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.684,
              "y": -11.98,
              "z": 0.175
            },
            "gtin": "4066447873092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710d3",
            "leftCorner": {
              "x": 8.684,
              "y": -11.98,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.63,
              "y": -11.931,
              "z": 0.175
            },
            "gtin": "4066447873092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710d4",
            "leftCorner": {
              "x": 8.63,
              "y": -11.931,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.574,
              "y": -11.881,
              "z": 0.175
            },
            "gtin": "4066447395303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710d5",
            "leftCorner": {
              "x": 8.574,
              "y": -11.881,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.516,
              "y": -11.83,
              "z": 0.175
            }
          },
          {
            "id": "696ebf6f43c343680a2710d6",
            "leftCorner": {
              "x": 8.516,
              "y": -11.83,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.462,
              "y": -11.781,
              "z": 0.175
            },
            "gtin": "4066447878103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710d7",
            "leftCorner": {
              "x": 8.462,
              "y": -11.781,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.41,
              "y": -11.735,
              "z": 0.175
            },
            "gtin": "4066447878103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710d8",
            "leftCorner": {
              "x": 8.41,
              "y": -11.735,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.349,
              "y": -11.68,
              "z": 0.175
            },
            "gtin": "4066447873115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710d9",
            "leftCorner": {
              "x": 8.349,
              "y": -11.68,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.282,
              "y": -11.62,
              "z": 0.175
            },
            "gtin": "4066447873115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710da",
            "leftCorner": {
              "x": 8.282,
              "y": -11.62,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.227,
              "y": -11.571,
              "z": 0.175
            },
            "gtin": "4067796199574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710db",
            "leftCorner": {
              "x": 8.227,
              "y": -11.571,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.176,
              "y": -11.525,
              "z": 0.175
            },
            "gtin": "4067796199574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710dc",
            "leftCorner": {
              "x": 8.176,
              "y": -11.525,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.124,
              "y": -11.479,
              "z": 0.175
            }
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a68",
        "height": 0.43478,
        "facings": [
          {
            "id": "696ebf6f43c343680a2711cf",
            "leftCorner": {
              "x": 8.937,
              "y": -12.229,
              "z": 0.438
            },
            "rightCorner": {
              "x": 8.827,
              "y": -12.13,
              "z": 0.438
            },
            "gtin": "4058172784576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711d0",
            "leftCorner": {
              "x": 8.8,
              "y": -12.08,
              "z": 0.435
            },
            "rightCorner": {
              "x": 8.7,
              "y": -11.991,
              "z": 0.435
            },
            "gtin": "4066447068443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711d1",
            "leftCorner": {
              "x": 8.7,
              "y": -11.991,
              "z": 0.435
            },
            "rightCorner": {
              "x": 8.648,
              "y": -11.945,
              "z": 0.435
            },
            "gtin": "5000468000609",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711d2",
            "leftCorner": {
              "x": 8.648,
              "y": -11.945,
              "z": 0.435
            },
            "rightCorner": {
              "x": 8.613,
              "y": -11.913,
              "z": 0.435
            },
            "gtin": "4045612011088",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711d3",
            "leftCorner": {
              "x": 8.613,
              "y": -11.913,
              "z": 0.435
            },
            "rightCorner": {
              "x": 8.582,
              "y": -11.885,
              "z": 0.435
            },
            "gtin": "4045612011392",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711d4",
            "leftCorner": {
              "x": 8.582,
              "y": -11.885,
              "z": 0.435
            },
            "rightCorner": {
              "x": 8.551,
              "y": -11.858,
              "z": 0.435
            },
            "gtin": "4045612011392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711d5",
            "leftCorner": {
              "x": 8.551,
              "y": -11.858,
              "z": 0.435
            },
            "rightCorner": {
              "x": 8.517,
              "y": -11.827,
              "z": 0.435
            },
            "gtin": "3600542227360",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711d6",
            "leftCorner": {
              "x": 8.517,
              "y": -11.827,
              "z": 0.435
            },
            "rightCorner": {
              "x": 8.485,
              "y": -11.8,
              "z": 0.435
            },
            "gtin": "4260527730453",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711d7",
            "leftCorner": {
              "x": 8.485,
              "y": -11.8,
              "z": 0.435
            },
            "rightCorner": {
              "x": 8.448,
              "y": -11.766,
              "z": 0.435
            },
            "gtin": "8002410045741",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711d8",
            "leftCorner": {
              "x": 8.448,
              "y": -11.766,
              "z": 0.435
            },
            "rightCorner": {
              "x": 8.413,
              "y": -11.735,
              "z": 0.435
            },
            "gtin": "8002410045079",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711d9",
            "leftCorner": {
              "x": 8.413,
              "y": -11.735,
              "z": 0.435
            },
            "rightCorner": {
              "x": 8.376,
              "y": -11.702,
              "z": 0.435
            },
            "gtin": "8002410046298",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711da",
            "leftCorner": {
              "x": 8.376,
              "y": -11.702,
              "z": 0.435
            },
            "rightCorner": {
              "x": 8.295,
              "y": -11.63,
              "z": 0.435
            },
            "gtin": "4058172997181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711db",
            "leftCorner": {
              "x": 8.295,
              "y": -11.63,
              "z": 0.435
            },
            "rightCorner": {
              "x": 8.221,
              "y": -11.564,
              "z": 0.435
            },
            "gtin": "4058172493584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711a8",
            "leftCorner": {
              "x": 8.221,
              "y": -11.564,
              "z": 0.435
            },
            "rightCorner": {
              "x": 8.152,
              "y": -11.502,
              "z": 0.435
            },
            "gtin": "4058172493553",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a64",
        "height": 0.72767,
        "facings": [
          {
            "id": "696ebf6f43c343680a271021",
            "leftCorner": {
              "x": 8.892,
              "y": -12.162,
              "z": 0.728
            },
            "rightCorner": {
              "x": 8.836,
              "y": -12.112,
              "z": 0.728
            },
            "gtin": "8720181565816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271022",
            "leftCorner": {
              "x": 8.836,
              "y": -12.112,
              "z": 0.728
            },
            "rightCorner": {
              "x": 8.768,
              "y": -12.052,
              "z": 0.728
            },
            "gtin": "8720181277771",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271023",
            "leftCorner": {
              "x": 8.768,
              "y": -12.052,
              "z": 0.728
            },
            "rightCorner": {
              "x": 8.725,
              "y": -12.013,
              "z": 0.728
            },
            "gtin": "8720181277771",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271024",
            "leftCorner": {
              "x": 8.725,
              "y": -12.013,
              "z": 0.728
            },
            "rightCorner": {
              "x": 8.69,
              "y": -11.982,
              "z": 0.728
            },
            "gtin": "8720181774317",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271025",
            "leftCorner": {
              "x": 8.69,
              "y": -11.982,
              "z": 0.728
            },
            "rightCorner": {
              "x": 8.61,
              "y": -11.91,
              "z": 0.728
            },
            "gtin": "8720181774317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271026",
            "leftCorner": {
              "x": 8.61,
              "y": -11.91,
              "z": 0.728
            },
            "rightCorner": {
              "x": 8.573,
              "y": -11.878,
              "z": 0.728
            }
          },
          {
            "id": "696ebf6f43c343680a271027",
            "leftCorner": {
              "x": 8.573,
              "y": -11.878,
              "z": 0.728
            },
            "rightCorner": {
              "x": 8.538,
              "y": -11.846,
              "z": 0.728
            },
            "gtin": "8720181291920",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271028",
            "leftCorner": {
              "x": 8.538,
              "y": -11.846,
              "z": 0.728
            },
            "rightCorner": {
              "x": 8.504,
              "y": -11.815,
              "z": 0.728
            },
            "gtin": "8720181291920",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271029",
            "leftCorner": {
              "x": 8.504,
              "y": -11.815,
              "z": 0.728
            },
            "rightCorner": {
              "x": 8.468,
              "y": -11.784,
              "z": 0.728
            },
            "gtin": "8712561315975",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27102a",
            "leftCorner": {
              "x": 8.468,
              "y": -11.784,
              "z": 0.728
            },
            "rightCorner": {
              "x": 8.432,
              "y": -11.751,
              "z": 0.728
            },
            "gtin": "8720181594984",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27102b",
            "leftCorner": {
              "x": 8.432,
              "y": -11.751,
              "z": 0.728
            },
            "rightCorner": {
              "x": 8.394,
              "y": -11.718,
              "z": 0.728
            },
            "gtin": "8720181565878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27102c",
            "leftCorner": {
              "x": 8.394,
              "y": -11.718,
              "z": 0.728
            },
            "rightCorner": {
              "x": 8.353,
              "y": -11.681,
              "z": 0.728
            },
            "gtin": "8720181565878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27102d",
            "leftCorner": {
              "x": 8.353,
              "y": -11.681,
              "z": 0.728
            },
            "rightCorner": {
              "x": 8.298,
              "y": -11.632,
              "z": 0.728
            },
            "gtin": "8712561820899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27102e",
            "leftCorner": {
              "x": 8.298,
              "y": -11.632,
              "z": 0.728
            },
            "rightCorner": {
              "x": 8.252,
              "y": -11.591,
              "z": 0.728
            },
            "gtin": "5063651000046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27102f",
            "leftCorner": {
              "x": 8.252,
              "y": -11.591,
              "z": 0.728
            },
            "rightCorner": {
              "x": 8.22,
              "y": -11.562,
              "z": 0.728
            },
            "gtin": "5063651000053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271030",
            "leftCorner": {
              "x": 8.22,
              "y": -11.562,
              "z": 0.728
            },
            "rightCorner": {
              "x": 8.183,
              "y": -11.529,
              "z": 0.728
            },
            "gtin": "4013162030286",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ffc",
            "leftCorner": {
              "x": 8.183,
              "y": -11.529,
              "z": 0.728
            },
            "rightCorner": {
              "x": 8.152,
              "y": -11.502,
              "z": 0.728
            },
            "gtin": "4013162030286",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a69",
        "height": 0.98316,
        "facings": [
          {
            "id": "696ebf6f43c343680a271167",
            "leftCorner": {
              "x": 8.898,
              "y": -12.163,
              "z": 0.983
            },
            "rightCorner": {
              "x": 8.809,
              "y": -12.084,
              "z": 0.983
            },
            "gtin": "8710447492246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271168",
            "leftCorner": {
              "x": 8.809,
              "y": -12.084,
              "z": 0.983
            },
            "rightCorner": {
              "x": 8.709,
              "y": -11.995,
              "z": 0.983
            },
            "gtin": "59097778",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271169",
            "leftCorner": {
              "x": 8.709,
              "y": -11.995,
              "z": 0.983
            },
            "rightCorner": {
              "x": 8.651,
              "y": -11.943,
              "z": 0.983
            },
            "gtin": "59097761",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27116a",
            "leftCorner": {
              "x": 8.651,
              "y": -11.943,
              "z": 0.983
            },
            "rightCorner": {
              "x": 8.622,
              "y": -11.917,
              "z": 0.983
            },
            "gtin": "59097754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27116b",
            "leftCorner": {
              "x": 8.622,
              "y": -11.917,
              "z": 0.983
            },
            "rightCorner": {
              "x": 8.582,
              "y": -11.881,
              "z": 0.983
            },
            "gtin": "80780458",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27116c",
            "leftCorner": {
              "x": 8.582,
              "y": -11.881,
              "z": 0.983
            },
            "rightCorner": {
              "x": 8.54,
              "y": -11.844,
              "z": 0.983
            },
            "gtin": "80816614",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27116d",
            "leftCorner": {
              "x": 8.54,
              "y": -11.844,
              "z": 0.983
            },
            "rightCorner": {
              "x": 8.502,
              "y": -11.81,
              "z": 0.983
            },
            "gtin": "4058172830501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27116e",
            "leftCorner": {
              "x": 8.502,
              "y": -11.81,
              "z": 0.983
            },
            "rightCorner": {
              "x": 8.467,
              "y": -11.778,
              "z": 0.983
            },
            "gtin": "4058172830501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27116f",
            "leftCorner": {
              "x": 8.467,
              "y": -11.778,
              "z": 0.983
            },
            "rightCorner": {
              "x": 8.429,
              "y": -11.745,
              "z": 0.983
            },
            "gtin": "4066447591989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271170",
            "leftCorner": {
              "x": 8.429,
              "y": -11.745,
              "z": 0.983
            },
            "rightCorner": {
              "x": 8.39,
              "y": -11.71,
              "z": 0.983
            },
            "gtin": "4066447591989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271171",
            "leftCorner": {
              "x": 8.39,
              "y": -11.71,
              "z": 0.983
            },
            "rightCorner": {
              "x": 8.345,
              "y": -11.67,
              "z": 0.983
            },
            "gtin": "4058172921308",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271172",
            "leftCorner": {
              "x": 8.345,
              "y": -11.67,
              "z": 0.983
            },
            "rightCorner": {
              "x": 8.304,
              "y": -11.633,
              "z": 0.983
            },
            "gtin": "4058172921308",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271173",
            "leftCorner": {
              "x": 8.304,
              "y": -11.633,
              "z": 0.983
            },
            "rightCorner": {
              "x": 8.264,
              "y": -11.598,
              "z": 0.983
            },
            "gtin": "4058172739118",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271174",
            "leftCorner": {
              "x": 8.264,
              "y": -11.598,
              "z": 0.983
            },
            "rightCorner": {
              "x": 8.227,
              "y": -11.565,
              "z": 0.983
            },
            "gtin": "4058172739118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271175",
            "leftCorner": {
              "x": 8.227,
              "y": -11.565,
              "z": 0.983
            },
            "rightCorner": {
              "x": 8.192,
              "y": -11.534,
              "z": 0.983
            },
            "gtin": "4058172739132",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271140",
            "leftCorner": {
              "x": 8.192,
              "y": -11.534,
              "z": 0.983
            },
            "rightCorner": {
              "x": 8.154,
              "y": -11.499,
              "z": 0.983
            },
            "gtin": "4058172739132",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a65",
        "height": 1.235,
        "facings": [
          {
            "id": "696ebf6f43c343680a271198",
            "leftCorner": {
              "x": 8.913,
              "y": -12.172,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.877,
              "y": -12.14,
              "z": 1.235
            },
            "gtin": "4066447377989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271199",
            "leftCorner": {
              "x": 8.877,
              "y": -12.14,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.844,
              "y": -12.11,
              "z": 1.235
            },
            "gtin": "59095842",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27119a",
            "leftCorner": {
              "x": 8.844,
              "y": -12.11,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.798,
              "y": -12.068,
              "z": 1.235
            },
            "gtin": "59083856",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27119b",
            "leftCorner": {
              "x": 8.798,
              "y": -12.068,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.758,
              "y": -12.033,
              "z": 1.235
            },
            "gtin": "59002154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27119c",
            "leftCorner": {
              "x": 8.758,
              "y": -12.033,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.716,
              "y": -11.995,
              "z": 1.235
            },
            "gtin": "42449386",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27119d",
            "leftCorner": {
              "x": 8.716,
              "y": -11.995,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.684,
              "y": -11.967,
              "z": 1.235
            },
            "gtin": "42467601",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27119e",
            "leftCorner": {
              "x": 8.684,
              "y": -11.967,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.652,
              "y": -11.939,
              "z": 1.235
            }
          },
          {
            "id": "696ebf6f43c343680a27119f",
            "leftCorner": {
              "x": 8.652,
              "y": -11.939,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.619,
              "y": -11.909,
              "z": 1.235
            },
            "gtin": "42449263",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711a0",
            "leftCorner": {
              "x": 8.619,
              "y": -11.909,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.588,
              "y": -11.881,
              "z": 1.235
            },
            "gtin": "42449300",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711a1",
            "leftCorner": {
              "x": 8.588,
              "y": -11.881,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.557,
              "y": -11.853,
              "z": 1.235
            },
            "gtin": "42449300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711a2",
            "leftCorner": {
              "x": 8.557,
              "y": -11.853,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.525,
              "y": -11.825,
              "z": 1.235
            },
            "gtin": "42449492",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711a3",
            "leftCorner": {
              "x": 8.525,
              "y": -11.825,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.495,
              "y": -11.798,
              "z": 1.235
            },
            "gtin": "42467458",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711a4",
            "leftCorner": {
              "x": 8.495,
              "y": -11.798,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.464,
              "y": -11.77,
              "z": 1.235
            },
            "gtin": "42467465",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711a5",
            "leftCorner": {
              "x": 8.464,
              "y": -11.77,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.42,
              "y": -11.731,
              "z": 1.235
            },
            "gtin": "4006000170619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711a6",
            "leftCorner": {
              "x": 8.42,
              "y": -11.731,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.313,
              "y": -11.636,
              "z": 1.235
            },
            "gtin": "3600542227384",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711a7",
            "leftCorner": {
              "x": 8.313,
              "y": -11.636,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.213,
              "y": -11.546,
              "z": 1.235
            },
            "gtin": "3600542227322",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271176",
            "leftCorner": {
              "x": 8.213,
              "y": -11.546,
              "z": 1.235
            },
            "rightCorner": {
              "x": 8.157,
              "y": -11.496,
              "z": 1.235
            },
            "gtin": "4064133000050",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a66",
        "height": 1.4482,
        "facings": [
          {
            "id": "696ebf6f43c343680a271132",
            "leftCorner": {
              "x": 8.896,
              "y": -12.147,
              "z": 1.448
            },
            "rightCorner": {
              "x": 8.841,
              "y": -12.098,
              "z": 1.448
            },
            "gtin": "4067796210057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271133",
            "leftCorner": {
              "x": 8.841,
              "y": -12.098,
              "z": 1.448
            },
            "rightCorner": {
              "x": 8.784,
              "y": -12.047,
              "z": 1.448
            },
            "gtin": "8717644566237",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271134",
            "leftCorner": {
              "x": 8.784,
              "y": -12.047,
              "z": 1.448
            },
            "rightCorner": {
              "x": 8.714,
              "y": -11.985,
              "z": 1.448
            },
            "gtin": "8711600841499",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271135",
            "leftCorner": {
              "x": 8.714,
              "y": -11.985,
              "z": 1.448
            },
            "rightCorner": {
              "x": 8.653,
              "y": -11.93,
              "z": 1.448
            },
            "gtin": "8720181594809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271136",
            "leftCorner": {
              "x": 8.653,
              "y": -11.93,
              "z": 1.448
            },
            "rightCorner": {
              "x": 8.627,
              "y": -11.907,
              "z": 1.448
            },
            "gtin": "4006000111537",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271137",
            "leftCorner": {
              "x": 8.627,
              "y": -11.907,
              "z": 1.448
            },
            "rightCorner": {
              "x": 8.581,
              "y": -11.866,
              "z": 1.448
            },
            "gtin": "42449775",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271138",
            "leftCorner": {
              "x": 8.581,
              "y": -11.866,
              "z": 1.448
            },
            "rightCorner": {
              "x": 8.536,
              "y": -11.826,
              "z": 1.448
            },
            "gtin": "42449782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271139",
            "leftCorner": {
              "x": 8.536,
              "y": -11.826,
              "z": 1.448
            },
            "rightCorner": {
              "x": 8.495,
              "y": -11.789,
              "z": 1.448
            },
            "gtin": "42449881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27113a",
            "leftCorner": {
              "x": 8.495,
              "y": -11.789,
              "z": 1.448
            },
            "rightCorner": {
              "x": 8.445,
              "y": -11.745,
              "z": 1.448
            },
            "gtin": "59099604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27113b",
            "leftCorner": {
              "x": 8.445,
              "y": -11.745,
              "z": 1.448
            },
            "rightCorner": {
              "x": 8.401,
              "y": -11.706,
              "z": 1.448
            },
            "gtin": "59097891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27113c",
            "leftCorner": {
              "x": 8.401,
              "y": -11.706,
              "z": 1.448
            },
            "rightCorner": {
              "x": 8.34,
              "y": -11.651,
              "z": 1.448
            },
            "gtin": "59097884",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27113d",
            "leftCorner": {
              "x": 8.34,
              "y": -11.651,
              "z": 1.448
            },
            "rightCorner": {
              "x": 8.278,
              "y": -11.595,
              "z": 1.448
            },
            "gtin": "4066447945072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27113e",
            "leftCorner": {
              "x": 8.278,
              "y": -11.595,
              "z": 1.448
            },
            "rightCorner": {
              "x": 8.246,
              "y": -11.567,
              "z": 1.448
            },
            "gtin": "4063528031655",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27113f",
            "leftCorner": {
              "x": 8.246,
              "y": -11.567,
              "z": 1.448
            },
            "rightCorner": {
              "x": 8.216,
              "y": -11.54,
              "z": 1.448
            },
            "gtin": "4063528031594",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271111",
            "leftCorner": {
              "x": 8.216,
              "y": -11.54,
              "z": 1.448
            },
            "rightCorner": {
              "x": 8.161,
              "y": -11.491,
              "z": 1.448
            },
            "gtin": "4036581541485",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a67",
        "height": 1.6553,
        "facings": [
          {
            "id": "696ebf6f43c343680a271054",
            "leftCorner": {
              "x": 8.896,
              "y": -12.15,
              "z": 1.655
            },
            "rightCorner": {
              "x": 8.851,
              "y": -12.109,
              "z": 1.655
            },
            "gtin": "8720181534836",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271055",
            "leftCorner": {
              "x": 8.851,
              "y": -12.109,
              "z": 1.655
            },
            "rightCorner": {
              "x": 8.795,
              "y": -12.06,
              "z": 1.655
            },
            "gtin": "8711600504141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271056",
            "leftCorner": {
              "x": 8.795,
              "y": -12.06,
              "z": 1.655
            },
            "rightCorner": {
              "x": 8.751,
              "y": -12.021,
              "z": 1.655
            },
            "gtin": "4045612010869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271057",
            "leftCorner": {
              "x": 8.751,
              "y": -12.021,
              "z": 1.655
            },
            "rightCorner": {
              "x": 8.704,
              "y": -11.978,
              "z": 1.655
            },
            "gtin": "4045612009634",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271058",
            "leftCorner": {
              "x": 8.704,
              "y": -11.978,
              "z": 1.655
            },
            "rightCorner": {
              "x": 8.671,
              "y": -11.949,
              "z": 1.655
            },
            "gtin": "4045612010845",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271059",
            "leftCorner": {
              "x": 8.671,
              "y": -11.949,
              "z": 1.655
            },
            "rightCorner": {
              "x": 8.635,
              "y": -11.917,
              "z": 1.655
            },
            "gtin": "4003086005309",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27105a",
            "leftCorner": {
              "x": 8.635,
              "y": -11.917,
              "z": 1.655
            },
            "rightCorner": {
              "x": 8.605,
              "y": -11.89,
              "z": 1.655
            },
            "gtin": "4028615070054",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27105b",
            "leftCorner": {
              "x": 8.605,
              "y": -11.89,
              "z": 1.655
            },
            "rightCorner": {
              "x": 8.573,
              "y": -11.861,
              "z": 1.655
            },
            "gtin": "4028615071051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27105c",
            "leftCorner": {
              "x": 8.573,
              "y": -11.861,
              "z": 1.655
            },
            "rightCorner": {
              "x": 8.54,
              "y": -11.832,
              "z": 1.655
            },
            "gtin": "4033419520100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27105d",
            "leftCorner": {
              "x": 8.54,
              "y": -11.832,
              "z": 1.655
            },
            "rightCorner": {
              "x": 8.513,
              "y": -11.808,
              "z": 1.655
            },
            "gtin": "80808756",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27105e",
            "leftCorner": {
              "x": 8.513,
              "y": -11.808,
              "z": 1.655
            },
            "rightCorner": {
              "x": 8.461,
              "y": -11.761,
              "z": 1.655
            },
            "gtin": "5065003990357",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27105f",
            "leftCorner": {
              "x": 8.461,
              "y": -11.761,
              "z": 1.655
            },
            "rightCorner": {
              "x": 8.41,
              "y": -11.715,
              "z": 1.655
            },
            "gtin": "5060968414917",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271060",
            "leftCorner": {
              "x": 8.41,
              "y": -11.715,
              "z": 1.655
            },
            "rightCorner": {
              "x": 8.365,
              "y": -11.676,
              "z": 1.655
            },
            "gtin": "5065003990388",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271061",
            "leftCorner": {
              "x": 8.365,
              "y": -11.676,
              "z": 1.655
            },
            "rightCorner": {
              "x": 8.313,
              "y": -11.629,
              "z": 1.655
            },
            "gtin": "5060968411589",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271062",
            "leftCorner": {
              "x": 8.313,
              "y": -11.629,
              "z": 1.655
            },
            "rightCorner": {
              "x": 8.269,
              "y": -11.59,
              "z": 1.655
            },
            "gtin": "5065003990401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271063",
            "leftCorner": {
              "x": 8.269,
              "y": -11.59,
              "z": 1.655
            },
            "rightCorner": {
              "x": 8.221,
              "y": -11.547,
              "z": 1.655
            },
            "gtin": "5065003990364",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271064",
            "leftCorner": {
              "x": 8.221,
              "y": -11.547,
              "z": 1.655
            },
            "rightCorner": {
              "x": 8.176,
              "y": -11.507,
              "z": 1.655
            },
            "gtin": "5060968414610",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271065",
            "leftCorner": {
              "x": 8.176,
              "y": -11.507,
              "z": 1.655
            },
            "rightCorner": {
              "x": 8.137,
              "y": -11.472,
              "z": 1.655
            },
            "gtin": "4260491224446",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc0469598fe",
    "name": "68e7571db5fe7bc0469598fe",
    "x": 8.112,
    "y": -11.538,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93819,
      "w": 0.34613
    },
    "statistics": {
      "hasStockCount": 41,
      "noStockCount": 0,
      "unknownStockCount": 31,
      "shelfCategory": "SHOWER_GEL"
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73a6f",
        "height": 0.17217,
        "facings": [
          {
            "id": "696ebf6f43c343680a2710dd",
            "leftCorner": {
              "x": 8.113,
              "y": -11.481,
              "z": 0.172
            },
            "rightCorner": {
              "x": 8.057,
              "y": -11.434,
              "z": 0.172
            },
            "gtin": "4010355039491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710de",
            "leftCorner": {
              "x": 8.057,
              "y": -11.434,
              "z": 0.172
            },
            "rightCorner": {
              "x": 7.974,
              "y": -11.362,
              "z": 0.172
            },
            "gtin": "4066447671889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710df",
            "leftCorner": {
              "x": 7.974,
              "y": -11.362,
              "z": 0.172
            },
            "rightCorner": {
              "x": 7.896,
              "y": -11.295,
              "z": 0.172
            }
          },
          {
            "id": "696ebf6f43c343680a2710e0",
            "leftCorner": {
              "x": 7.896,
              "y": -11.295,
              "z": 0.172
            },
            "rightCorner": {
              "x": 7.84,
              "y": -11.248,
              "z": 0.172
            },
            "gtin": "4066447429411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710e1",
            "leftCorner": {
              "x": 7.84,
              "y": -11.248,
              "z": 0.172
            },
            "rightCorner": {
              "x": 7.782,
              "y": -11.198,
              "z": 0.172
            }
          },
          {
            "id": "696ebf6f43c343680a2710e2",
            "leftCorner": {
              "x": 7.782,
              "y": -11.198,
              "z": 0.172
            },
            "rightCorner": {
              "x": 7.709,
              "y": -11.136,
              "z": 0.172
            },
            "gtin": "4066447237627",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710e3",
            "leftCorner": {
              "x": 7.709,
              "y": -11.136,
              "z": 0.172
            },
            "rightCorner": {
              "x": 7.636,
              "y": -11.074,
              "z": 0.172
            },
            "gtin": "4067796199291",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710e4",
            "leftCorner": {
              "x": 7.636,
              "y": -11.074,
              "z": 0.172
            },
            "rightCorner": {
              "x": 7.575,
              "y": -11.022,
              "z": 0.172
            },
            "gtin": "4067796199291",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710e5",
            "leftCorner": {
              "x": 7.575,
              "y": -11.022,
              "z": 0.172
            },
            "rightCorner": {
              "x": 7.504,
              "y": -10.961,
              "z": 0.172
            },
            "gtin": "4067796199277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710e6",
            "leftCorner": {
              "x": 7.504,
              "y": -10.961,
              "z": 0.172
            },
            "rightCorner": {
              "x": 7.432,
              "y": -10.9,
              "z": 0.172
            }
          },
          {
            "id": "696ebf6f43c343680a2710e7",
            "leftCorner": {
              "x": 7.432,
              "y": -10.9,
              "z": 0.172
            },
            "rightCorner": {
              "x": 7.371,
              "y": -10.848,
              "z": 0.172
            },
            "gtin": "4066447239430",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a6d",
        "height": 0.47232,
        "facings": [
          {
            "id": "696ebf6f43c343680a2711f6",
            "leftCorner": {
              "x": 8.132,
              "y": -11.499,
              "z": 0.472
            },
            "rightCorner": {
              "x": 8.043,
              "y": -11.424,
              "z": 0.472
            },
            "gtin": "4066447238839",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711f7",
            "leftCorner": {
              "x": 8.043,
              "y": -11.424,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.978,
              "y": -11.368,
              "z": 0.472
            },
            "gtin": "4066447238853",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711f8",
            "leftCorner": {
              "x": 7.978,
              "y": -11.368,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.911,
              "y": -11.311,
              "z": 0.472
            },
            "gtin": "4066447237603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711f9",
            "leftCorner": {
              "x": 7.911,
              "y": -11.311,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.859,
              "y": -11.267,
              "z": 0.472
            },
            "gtin": "4005900972750",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711fa",
            "leftCorner": {
              "x": 7.859,
              "y": -11.267,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.822,
              "y": -11.235,
              "z": 0.472
            },
            "gtin": "4067796157765",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711fb",
            "leftCorner": {
              "x": 7.822,
              "y": -11.235,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.778,
              "y": -11.198,
              "z": 0.472
            },
            "gtin": "4066447646375",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711fc",
            "leftCorner": {
              "x": 7.778,
              "y": -11.198,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.735,
              "y": -11.161,
              "z": 0.472
            },
            "gtin": "4066447646375",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711fd",
            "leftCorner": {
              "x": 7.735,
              "y": -11.161,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.694,
              "y": -11.125,
              "z": 0.472
            },
            "gtin": "4066447190991",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711fe",
            "leftCorner": {
              "x": 7.694,
              "y": -11.125,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.65,
              "y": -11.088,
              "z": 0.472
            },
            "gtin": "4066447190977",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711ff",
            "leftCorner": {
              "x": 7.65,
              "y": -11.088,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.613,
              "y": -11.056,
              "z": 0.472
            },
            "gtin": "4066447190977",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271200",
            "leftCorner": {
              "x": 7.613,
              "y": -11.056,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.562,
              "y": -11.013,
              "z": 0.472
            },
            "gtin": "4067796164220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271201",
            "leftCorner": {
              "x": 7.562,
              "y": -11.013,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.517,
              "y": -10.974,
              "z": 0.472
            },
            "gtin": "4067796147773",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271202",
            "leftCorner": {
              "x": 7.517,
              "y": -10.974,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.473,
              "y": -10.937,
              "z": 0.472
            },
            "gtin": "4067796164244",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271203",
            "leftCorner": {
              "x": 7.473,
              "y": -10.937,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.398,
              "y": -10.873,
              "z": 0.472
            },
            "gtin": "4066447719161",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a6b",
        "height": 0.76586,
        "facings": [
          {
            "id": "696ebf6f43c343680a2711dc",
            "leftCorner": {
              "x": 8.142,
              "y": -11.503,
              "z": 0.766
            },
            "rightCorner": {
              "x": 8.084,
              "y": -11.454,
              "z": 0.766
            },
            "gtin": "4006000137438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711dd",
            "leftCorner": {
              "x": 8.084,
              "y": -11.454,
              "z": 0.766
            },
            "rightCorner": {
              "x": 8.025,
              "y": -11.403,
              "z": 0.766
            },
            "gtin": "4006000137827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711de",
            "leftCorner": {
              "x": 8.025,
              "y": -11.403,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.967,
              "y": -11.354,
              "z": 0.766
            },
            "gtin": "4006000137827",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711df",
            "leftCorner": {
              "x": 7.967,
              "y": -11.354,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.917,
              "y": -11.311,
              "z": 0.766
            },
            "gtin": "4006000137513",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711e0",
            "leftCorner": {
              "x": 7.917,
              "y": -11.311,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.852,
              "y": -11.255,
              "z": 0.766
            },
            "gtin": "4006000137674",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711e1",
            "leftCorner": {
              "x": 7.852,
              "y": -11.255,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.805,
              "y": -11.215,
              "z": 0.766
            },
            "gtin": "4006000137391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711e2",
            "leftCorner": {
              "x": 7.805,
              "y": -11.215,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.733,
              "y": -11.154,
              "z": 0.766
            },
            "gtin": "4006000137599",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711e3",
            "leftCorner": {
              "x": 7.733,
              "y": -11.154,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.659,
              "y": -11.091,
              "z": 0.766
            },
            "gtin": "4006000170428",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711e4",
            "leftCorner": {
              "x": 7.659,
              "y": -11.091,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.626,
              "y": -11.062,
              "z": 0.766
            },
            "gtin": "4006000144030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711e5",
            "leftCorner": {
              "x": 7.626,
              "y": -11.062,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.571,
              "y": -11.015,
              "z": 0.766
            },
            "gtin": "4006000143996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711e6",
            "leftCorner": {
              "x": 7.571,
              "y": -11.015,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.493,
              "y": -10.949,
              "z": 0.766
            },
            "gtin": "4006000137865",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711e7",
            "leftCorner": {
              "x": 7.493,
              "y": -10.949,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.436,
              "y": -10.901,
              "z": 0.766
            },
            "gtin": "4006000158822",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711e8",
            "leftCorner": {
              "x": 7.436,
              "y": -10.901,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.37,
              "y": -10.844,
              "z": 0.766
            },
            "gtin": "4006000137551",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a70",
        "height": 1.0614,
        "facings": [
          {
            "id": "696ebf6f43c343680a27122e",
            "leftCorner": {
              "x": 8.142,
              "y": -11.503,
              "z": 1.061
            },
            "rightCorner": {
              "x": 8.077,
              "y": -11.448,
              "z": 1.061
            },
            "gtin": "8720181466373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271230",
            "leftCorner": {
              "x": 8.077,
              "y": -11.448,
              "z": 1.061
            },
            "rightCorner": {
              "x": 8.018,
              "y": -11.397,
              "z": 1.061
            },
            "gtin": "8720181466526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271231",
            "leftCorner": {
              "x": 8.018,
              "y": -11.397,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.961,
              "y": -11.348,
              "z": 1.061
            }
          },
          {
            "id": "696ebf6f43c343680a271232",
            "leftCorner": {
              "x": 7.961,
              "y": -11.348,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.898,
              "y": -11.295,
              "z": 1.061
            },
            "gtin": "8720181468520",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271233",
            "leftCorner": {
              "x": 7.898,
              "y": -11.295,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.843,
              "y": -11.248,
              "z": 1.061
            },
            "gtin": "8720181443459",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271234",
            "leftCorner": {
              "x": 7.843,
              "y": -11.248,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.786,
              "y": -11.199,
              "z": 1.061
            },
            "gtin": "8720181460029",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271235",
            "leftCorner": {
              "x": 7.786,
              "y": -11.199,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.728,
              "y": -11.15,
              "z": 1.061
            },
            "gtin": "8720181491948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271236",
            "leftCorner": {
              "x": 7.728,
              "y": -11.15,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.672,
              "y": -11.102,
              "z": 1.061
            },
            "gtin": "8720181608278",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271237",
            "leftCorner": {
              "x": 7.672,
              "y": -11.102,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.615,
              "y": -11.053,
              "z": 1.061
            },
            "gtin": "8720181797934",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271238",
            "leftCorner": {
              "x": 7.615,
              "y": -11.053,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.576,
              "y": -11.019,
              "z": 1.061
            },
            "gtin": "4260437291723",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271239",
            "leftCorner": {
              "x": 7.576,
              "y": -11.019,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.532,
              "y": -10.982,
              "z": 1.061
            },
            "gtin": "4260437291471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27123a",
            "leftCorner": {
              "x": 7.532,
              "y": -10.982,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.49,
              "y": -10.946,
              "z": 1.061
            },
            "gtin": "4260437291471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27123b",
            "leftCorner": {
              "x": 7.49,
              "y": -10.946,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.411,
              "y": -10.879,
              "z": 1.061
            },
            "gtin": "42424536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27123c",
            "leftCorner": {
              "x": 7.411,
              "y": -10.879,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.382,
              "y": -10.854,
              "z": 1.061
            },
            "gtin": "42415787",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a6e",
        "height": 1.3571,
        "facings": [
          {
            "id": "696ebf6f43c343680a271210",
            "leftCorner": {
              "x": 8.145,
              "y": -11.5,
              "z": 1.357
            },
            "rightCorner": {
              "x": 8.093,
              "y": -11.456,
              "z": 1.357
            },
            "gtin": "4260307629977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271212",
            "leftCorner": {
              "x": 8.093,
              "y": -11.456,
              "z": 1.357
            },
            "rightCorner": {
              "x": 8.029,
              "y": -11.401,
              "z": 1.357
            },
            "gtin": "4260307639938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271213",
            "leftCorner": {
              "x": 8.029,
              "y": -11.401,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.972,
              "y": -11.352,
              "z": 1.357
            },
            "gtin": "4260307628673",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271214",
            "leftCorner": {
              "x": 7.972,
              "y": -11.352,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.907,
              "y": -11.297,
              "z": 1.357
            },
            "gtin": "4260307628727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271215",
            "leftCorner": {
              "x": 7.907,
              "y": -11.297,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.864,
              "y": -11.26,
              "z": 1.357
            },
            "gtin": "4260307628352",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271216",
            "leftCorner": {
              "x": 7.864,
              "y": -11.26,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.828,
              "y": -11.229,
              "z": 1.357
            },
            "gtin": "8008970056586",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271217",
            "leftCorner": {
              "x": 7.828,
              "y": -11.229,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.788,
              "y": -11.195,
              "z": 1.357
            },
            "gtin": "8008970056609",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271218",
            "leftCorner": {
              "x": 7.788,
              "y": -11.195,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.725,
              "y": -11.141,
              "z": 1.357
            },
            "gtin": "8008970060446",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271219",
            "leftCorner": {
              "x": 7.725,
              "y": -11.141,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.65,
              "y": -11.077,
              "z": 1.357
            },
            "gtin": "8008970059600",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27121a",
            "leftCorner": {
              "x": 7.65,
              "y": -11.077,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.578,
              "y": -11.016,
              "z": 1.357
            },
            "gtin": "8008970059129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27121b",
            "leftCorner": {
              "x": 7.578,
              "y": -11.016,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.538,
              "y": -10.981,
              "z": 1.357
            },
            "gtin": "4008233126326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27121c",
            "leftCorner": {
              "x": 7.538,
              "y": -10.981,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.471,
              "y": -10.924,
              "z": 1.357
            },
            "gtin": "4008233165523",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27121d",
            "leftCorner": {
              "x": 7.471,
              "y": -10.924,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.411,
              "y": -10.873,
              "z": 1.357
            },
            "gtin": "4008233171791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27121e",
            "leftCorner": {
              "x": 7.411,
              "y": -10.873,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.384,
              "y": -10.85,
              "z": 1.357
            }
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a6c",
        "height": 1.651,
        "facings": [
          {
            "id": "696ebf6f43c343680a271066",
            "leftCorner": {
              "x": 8.124,
              "y": -11.477,
              "z": 1.651
            },
            "rightCorner": {
              "x": 8.045,
              "y": -11.409,
              "z": 1.651
            },
            "gtin": "4103040041937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271067",
            "leftCorner": {
              "x": 8.045,
              "y": -11.409,
              "z": 1.651
            },
            "rightCorner": {
              "x": 7.977,
              "y": -11.352,
              "z": 1.651
            },
            "gtin": "4103040797018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271068",
            "leftCorner": {
              "x": 7.977,
              "y": -11.352,
              "z": 1.651
            },
            "rightCorner": {
              "x": 7.903,
              "y": -11.288,
              "z": 1.651
            },
            "gtin": "4103040341013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271069",
            "leftCorner": {
              "x": 7.903,
              "y": -11.288,
              "z": 1.651
            },
            "rightCorner": {
              "x": 7.843,
              "y": -11.237,
              "z": 1.651
            },
            "gtin": "4103040184153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27106a",
            "leftCorner": {
              "x": 7.843,
              "y": -11.237,
              "z": 1.651
            },
            "rightCorner": {
              "x": 7.787,
              "y": -11.189,
              "z": 1.651
            },
            "gtin": "4103040908100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27106b",
            "leftCorner": {
              "x": 7.787,
              "y": -11.189,
              "z": 1.651
            },
            "rightCorner": {
              "x": 7.718,
              "y": -11.13,
              "z": 1.651
            },
            "gtin": "4066447237863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27106c",
            "leftCorner": {
              "x": 7.718,
              "y": -11.13,
              "z": 1.651
            },
            "rightCorner": {
              "x": 7.655,
              "y": -11.077,
              "z": 1.651
            },
            "gtin": "4058172830808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27106d",
            "leftCorner": {
              "x": 7.655,
              "y": -11.077,
              "z": 1.651
            },
            "rightCorner": {
              "x": 7.592,
              "y": -11.022,
              "z": 1.651
            },
            "gtin": "4058172830808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27106e",
            "leftCorner": {
              "x": 7.592,
              "y": -11.022,
              "z": 1.651
            },
            "rightCorner": {
              "x": 7.547,
              "y": -10.984,
              "z": 1.651
            },
            "gtin": "4058172830822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27106f",
            "leftCorner": {
              "x": 7.547,
              "y": -10.984,
              "z": 1.651
            },
            "rightCorner": {
              "x": 7.442,
              "y": -10.895,
              "z": 1.651
            },
            "gtin": "4066447725254",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271070",
            "leftCorner": {
              "x": 7.442,
              "y": -10.895,
              "z": 1.651
            },
            "rightCorner": {
              "x": 7.38,
              "y": -10.842,
              "z": 1.651
            },
            "gtin": "4066447101638",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc0469598ff",
    "name": "68e7571db5fe7bc0469598ff",
    "x": 7.3473,
    "y": -10.877,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.92956,
      "w": 0.36866
    },
    "statistics": {
      "hasStockCount": 45,
      "noStockCount": 2,
      "unknownStockCount": 29,
      "shelfCategory": "SHOWER_GEL"
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73a76",
        "height": 0.17168,
        "facings": [
          {
            "id": "696ebf6f43c343680a2710e8",
            "leftCorner": {
              "x": 7.369,
              "y": -10.837,
              "z": 0.172
            },
            "rightCorner": {
              "x": 7.292,
              "y": -10.764,
              "z": 0.172
            },
            "gtin": "8718951761322",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710e9",
            "leftCorner": {
              "x": 7.292,
              "y": -10.764,
              "z": 0.172
            },
            "rightCorner": {
              "x": 7.228,
              "y": -10.704,
              "z": 0.172
            },
            "gtin": "8714789939803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710ea",
            "leftCorner": {
              "x": 7.228,
              "y": -10.704,
              "z": 0.172
            },
            "rightCorner": {
              "x": 7.163,
              "y": -10.642,
              "z": 0.172
            },
            "gtin": "8714789946269",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710eb",
            "leftCorner": {
              "x": 7.163,
              "y": -10.642,
              "z": 0.172
            },
            "rightCorner": {
              "x": 7.038,
              "y": -10.525,
              "z": 0.172
            },
            "gtin": "8718951425163",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710ec",
            "leftCorner": {
              "x": 7.038,
              "y": -10.525,
              "z": 0.172
            },
            "rightCorner": {
              "x": 6.974,
              "y": -10.465,
              "z": 0.172
            },
            "gtin": "4005900934383",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710ed",
            "leftCorner": {
              "x": 6.974,
              "y": -10.465,
              "z": 0.172
            },
            "rightCorner": {
              "x": 6.883,
              "y": -10.379,
              "z": 0.172
            },
            "gtin": "8711700927536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710ee",
            "leftCorner": {
              "x": 6.883,
              "y": -10.379,
              "z": 0.172
            },
            "rightCorner": {
              "x": 6.819,
              "y": -10.319,
              "z": 0.172
            },
            "gtin": "8717163429884",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710ef",
            "leftCorner": {
              "x": 6.819,
              "y": -10.319,
              "z": 0.172
            },
            "rightCorner": {
              "x": 6.755,
              "y": -10.259,
              "z": 0.172
            },
            "gtin": "8717163429884",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710f0",
            "leftCorner": {
              "x": 6.755,
              "y": -10.259,
              "z": 0.172
            },
            "rightCorner": {
              "x": 6.675,
              "y": -10.183,
              "z": 0.172
            }
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a75",
        "height": 0.47226,
        "facings": [
          {
            "id": "696ebf6f43c343680a271204",
            "leftCorner": {
              "x": 7.398,
              "y": -10.873,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.334,
              "y": -10.818,
              "z": 0.472
            },
            "gtin": "4067796157895",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271205",
            "leftCorner": {
              "x": 7.339,
              "y": -10.799,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.301,
              "y": -10.763,
              "z": 0.472
            },
            "gtin": "3574661384382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271206",
            "leftCorner": {
              "x": 7.301,
              "y": -10.763,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.279,
              "y": -10.742,
              "z": 0.472
            },
            "gtin": "3574661384382",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271207",
            "leftCorner": {
              "x": 7.279,
              "y": -10.742,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.19,
              "y": -10.658,
              "z": 0.472
            },
            "gtin": "4013162019236",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271208",
            "leftCorner": {
              "x": 7.19,
              "y": -10.658,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.119,
              "y": -10.592,
              "z": 0.472
            },
            "gtin": "4008268002800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271209",
            "leftCorner": {
              "x": 7.119,
              "y": -10.592,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.068,
              "y": -10.544,
              "z": 0.472
            },
            "gtin": "8714789732886",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27120a",
            "leftCorner": {
              "x": 7.068,
              "y": -10.544,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.02,
              "y": -10.499,
              "z": 0.472
            },
            "gtin": "8714789732916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27120b",
            "leftCorner": {
              "x": 7.02,
              "y": -10.499,
              "z": 0.472
            },
            "rightCorner": {
              "x": 6.949,
              "y": -10.431,
              "z": 0.472
            },
            "gtin": "8718951076228",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27120c",
            "leftCorner": {
              "x": 6.949,
              "y": -10.431,
              "z": 0.472
            },
            "rightCorner": {
              "x": 6.886,
              "y": -10.372,
              "z": 0.472
            },
            "gtin": "8718951424647",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27120d",
            "leftCorner": {
              "x": 6.886,
              "y": -10.372,
              "z": 0.472
            },
            "rightCorner": {
              "x": 6.831,
              "y": -10.321,
              "z": 0.472
            },
            "gtin": "8718951076181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27120e",
            "leftCorner": {
              "x": 6.831,
              "y": -10.321,
              "z": 0.472
            },
            "rightCorner": {
              "x": 6.771,
              "y": -10.264,
              "z": 0.472
            },
            "gtin": "8718951427471",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27120f",
            "leftCorner": {
              "x": 6.771,
              "y": -10.264,
              "z": 0.472
            },
            "rightCorner": {
              "x": 6.703,
              "y": -10.201,
              "z": 0.472
            },
            "gtin": "4260620681072",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711f5",
            "leftCorner": {
              "x": 6.703,
              "y": -10.201,
              "z": 0.472
            },
            "rightCorner": {
              "x": 6.654,
              "y": -10.154,
              "z": 0.472
            },
            "gtin": "4260620681089",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a72",
        "height": 0.76571,
        "facings": [
          {
            "id": "696ebf6f43c343680a2711e9",
            "leftCorner": {
              "x": 7.372,
              "y": -10.829,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.33,
              "y": -10.79,
              "z": 0.766
            },
            "gtin": "4006000186511",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711ea",
            "leftCorner": {
              "x": 7.33,
              "y": -10.79,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.245,
              "y": -10.71,
              "z": 0.766
            },
            "gtin": "8710447217054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711eb",
            "leftCorner": {
              "x": 7.245,
              "y": -10.71,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.187,
              "y": -10.655,
              "z": 0.766
            },
            "gtin": "4262401739835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711ec",
            "leftCorner": {
              "x": 7.187,
              "y": -10.655,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.131,
              "y": -10.603,
              "z": 0.766
            },
            "gtin": "4262401732409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711ed",
            "leftCorner": {
              "x": 7.131,
              "y": -10.603,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.059,
              "y": -10.535,
              "z": 0.766
            },
            "gtin": "4262401732997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711ee",
            "leftCorner": {
              "x": 7.059,
              "y": -10.535,
              "z": 0.766
            },
            "rightCorner": {
              "x": 6.988,
              "y": -10.468,
              "z": 0.766
            },
            "gtin": "4015100864090",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711ef",
            "leftCorner": {
              "x": 6.988,
              "y": -10.468,
              "z": 0.766
            },
            "rightCorner": {
              "x": 6.943,
              "y": -10.426,
              "z": 0.766
            },
            "gtin": "4015100864137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711f0",
            "leftCorner": {
              "x": 6.943,
              "y": -10.426,
              "z": 0.766
            },
            "rightCorner": {
              "x": 6.881,
              "y": -10.368,
              "z": 0.766
            },
            "gtin": "4015100863970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711f1",
            "leftCorner": {
              "x": 6.881,
              "y": -10.368,
              "z": 0.766
            },
            "rightCorner": {
              "x": 6.843,
              "y": -10.332,
              "z": 0.766
            }
          },
          {
            "id": "696ebf6f43c343680a2711f2",
            "leftCorner": {
              "x": 6.843,
              "y": -10.332,
              "z": 0.766
            },
            "rightCorner": {
              "x": 6.784,
              "y": -10.276,
              "z": 0.766
            },
            "gtin": "4045612010685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2711f3",
            "leftCorner": {
              "x": 6.784,
              "y": -10.276,
              "z": 0.766
            },
            "rightCorner": {
              "x": 6.73,
              "y": -10.226,
              "z": 0.766
            },
            "gtin": "4045612010692",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2711f4",
            "leftCorner": {
              "x": 6.73,
              "y": -10.226,
              "z": 0.766
            },
            "rightCorner": {
              "x": 6.659,
              "y": -10.158,
              "z": 0.766
            },
            "gtin": "4015100865554",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a71",
        "height": 1.0606,
        "facings": [
          {
            "id": "696ebf6f43c343680a27123d",
            "leftCorner": {
              "x": 7.388,
              "y": -10.833,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.344,
              "y": -10.796,
              "z": 1.061
            },
            "gtin": "42453031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27123e",
            "leftCorner": {
              "x": 7.346,
              "y": -10.794,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.303,
              "y": -10.754,
              "z": 1.061
            },
            "gtin": "42453031",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27123f",
            "leftCorner": {
              "x": 7.303,
              "y": -10.754,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.279,
              "y": -10.731,
              "z": 1.061
            },
            "gtin": "42426356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271240",
            "leftCorner": {
              "x": 7.279,
              "y": -10.731,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.235,
              "y": -10.69,
              "z": 1.061
            },
            "gtin": "42493303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271241",
            "leftCorner": {
              "x": 7.235,
              "y": -10.69,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.187,
              "y": -10.644,
              "z": 1.061
            },
            "gtin": "4069826000324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271242",
            "leftCorner": {
              "x": 7.187,
              "y": -10.644,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.139,
              "y": -10.599,
              "z": 1.061
            },
            "gtin": "4069826000188",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271243",
            "leftCorner": {
              "x": 7.139,
              "y": -10.599,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.077,
              "y": -10.541,
              "z": 1.061
            },
            "gtin": "4069826000232",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271244",
            "leftCorner": {
              "x": 7.077,
              "y": -10.541,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.029,
              "y": -10.495,
              "z": 1.061
            },
            "gtin": "4066447088397",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271245",
            "leftCorner": {
              "x": 7.029,
              "y": -10.495,
              "z": 1.061
            },
            "rightCorner": {
              "x": 6.984,
              "y": -10.453,
              "z": 1.061
            },
            "gtin": "4067796157895",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271246",
            "leftCorner": {
              "x": 6.984,
              "y": -10.453,
              "z": 1.061
            },
            "rightCorner": {
              "x": 6.926,
              "y": -10.399,
              "z": 1.061
            },
            "gtin": "4064133007721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271247",
            "leftCorner": {
              "x": 6.926,
              "y": -10.399,
              "z": 1.061
            },
            "rightCorner": {
              "x": 6.879,
              "y": -10.354,
              "z": 1.061
            },
            "gtin": "4066447704389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271248",
            "leftCorner": {
              "x": 6.879,
              "y": -10.354,
              "z": 1.061
            },
            "rightCorner": {
              "x": 6.831,
              "y": -10.31,
              "z": 1.061
            },
            "gtin": "4260620680433",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271249",
            "leftCorner": {
              "x": 6.831,
              "y": -10.31,
              "z": 1.061
            },
            "rightCorner": {
              "x": 6.772,
              "y": -10.253,
              "z": 1.061
            },
            "gtin": "4063528076472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27124a",
            "leftCorner": {
              "x": 6.772,
              "y": -10.253,
              "z": 1.061
            },
            "rightCorner": {
              "x": 6.715,
              "y": -10.2,
              "z": 1.061
            },
            "gtin": "4063528099129",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27122f",
            "leftCorner": {
              "x": 6.715,
              "y": -10.2,
              "z": 1.061
            },
            "rightCorner": {
              "x": 6.66,
              "y": -10.148,
              "z": 1.061
            },
            "gtin": "4063528008879",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a74",
        "height": 1.3577,
        "facings": [
          {
            "id": "696ebf6f43c343680a27121f",
            "leftCorner": {
              "x": 7.39,
              "y": -10.831,
              "z": 1.358
            },
            "rightCorner": {
              "x": 7.349,
              "y": -10.796,
              "z": 1.358
            },
            "gtin": "4008233042541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271220",
            "leftCorner": {
              "x": 7.351,
              "y": -10.794,
              "z": 1.358
            },
            "rightCorner": {
              "x": 7.31,
              "y": -10.756,
              "z": 1.358
            },
            "gtin": "4008233042541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271221",
            "leftCorner": {
              "x": 7.31,
              "y": -10.756,
              "z": 1.358
            },
            "rightCorner": {
              "x": 7.272,
              "y": -10.72,
              "z": 1.358
            },
            "gtin": "4008233181653",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271222",
            "leftCorner": {
              "x": 7.272,
              "y": -10.72,
              "z": 1.358
            },
            "rightCorner": {
              "x": 7.224,
              "y": -10.675,
              "z": 1.358
            },
            "gtin": "4008233142302",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271223",
            "leftCorner": {
              "x": 7.224,
              "y": -10.675,
              "z": 1.358
            },
            "rightCorner": {
              "x": 7.187,
              "y": -10.64,
              "z": 1.358
            },
            "gtin": "4008233176901",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271224",
            "leftCorner": {
              "x": 7.187,
              "y": -10.64,
              "z": 1.358
            },
            "rightCorner": {
              "x": 7.14,
              "y": -10.596,
              "z": 1.358
            },
            "gtin": "4066447378375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271225",
            "leftCorner": {
              "x": 7.14,
              "y": -10.596,
              "z": 1.358
            },
            "rightCorner": {
              "x": 7.107,
              "y": -10.565,
              "z": 1.358
            },
            "gtin": "4066447353846",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271226",
            "leftCorner": {
              "x": 7.107,
              "y": -10.565,
              "z": 1.358
            },
            "rightCorner": {
              "x": 7.06,
              "y": -10.52,
              "z": 1.358
            },
            "gtin": "4066447870893",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271227",
            "leftCorner": {
              "x": 7.06,
              "y": -10.52,
              "z": 1.358
            },
            "rightCorner": {
              "x": 7.008,
              "y": -10.472,
              "z": 1.358
            },
            "gtin": "4066447870893",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271228",
            "leftCorner": {
              "x": 7.008,
              "y": -10.472,
              "z": 1.358
            },
            "rightCorner": {
              "x": 6.96,
              "y": -10.427,
              "z": 1.358
            },
            "gtin": "4066447870916",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271229",
            "leftCorner": {
              "x": 6.96,
              "y": -10.427,
              "z": 1.358
            },
            "rightCorner": {
              "x": 6.907,
              "y": -10.377,
              "z": 1.358
            },
            "gtin": "4066447234992",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27122a",
            "leftCorner": {
              "x": 6.907,
              "y": -10.377,
              "z": 1.358
            },
            "rightCorner": {
              "x": 6.863,
              "y": -10.336,
              "z": 1.358
            },
            "gtin": "4066447396393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27122b",
            "leftCorner": {
              "x": 6.863,
              "y": -10.336,
              "z": 1.358
            },
            "rightCorner": {
              "x": 6.825,
              "y": -10.299,
              "z": 1.358
            },
            "gtin": "4066447771824",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27122c",
            "leftCorner": {
              "x": 6.825,
              "y": -10.299,
              "z": 1.358
            },
            "rightCorner": {
              "x": 6.754,
              "y": -10.233,
              "z": 1.358
            },
            "gtin": "4066447396430",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27122d",
            "leftCorner": {
              "x": 6.754,
              "y": -10.233,
              "z": 1.358
            },
            "rightCorner": {
              "x": 6.712,
              "y": -10.193,
              "z": 1.358
            },
            "gtin": "4066447235098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271211",
            "leftCorner": {
              "x": 6.712,
              "y": -10.193,
              "z": 1.358
            },
            "rightCorner": {
              "x": 6.662,
              "y": -10.146,
              "z": 1.358
            },
            "gtin": "4066447235036",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a73",
        "height": 1.65,
        "facings": [
          {
            "id": "696ebf6f43c343680a271071",
            "leftCorner": {
              "x": 7.385,
              "y": -10.825,
              "z": 1.65
            },
            "rightCorner": {
              "x": 7.324,
              "y": -10.768,
              "z": 1.65
            },
            "gtin": "4008890006436",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271072",
            "leftCorner": {
              "x": 7.324,
              "y": -10.768,
              "z": 1.65
            },
            "rightCorner": {
              "x": 7.268,
              "y": -10.715,
              "z": 1.65
            },
            "gtin": "4003086360002",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271073",
            "leftCorner": {
              "x": 7.268,
              "y": -10.715,
              "z": 1.65
            },
            "rightCorner": {
              "x": 7.217,
              "y": -10.667,
              "z": 1.65
            },
            "gtin": "4021457648412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271074",
            "leftCorner": {
              "x": 7.217,
              "y": -10.667,
              "z": 1.65
            },
            "rightCorner": {
              "x": 7.171,
              "y": -10.624,
              "z": 1.65
            },
            "gtin": "4021457648443",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271075",
            "leftCorner": {
              "x": 7.171,
              "y": -10.624,
              "z": 1.65
            },
            "rightCorner": {
              "x": 7.133,
              "y": -10.588,
              "z": 1.65
            },
            "gtin": "7611916125720",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271076",
            "leftCorner": {
              "x": 7.133,
              "y": -10.588,
              "z": 1.65
            },
            "rightCorner": {
              "x": 7.091,
              "y": -10.549,
              "z": 1.65
            },
            "gtin": "7611916124518",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271077",
            "leftCorner": {
              "x": 7.091,
              "y": -10.549,
              "z": 1.65
            },
            "rightCorner": {
              "x": 7.048,
              "y": -10.508,
              "z": 1.65
            },
            "gtin": "7611916124501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271078",
            "leftCorner": {
              "x": 7.048,
              "y": -10.508,
              "z": 1.65
            },
            "rightCorner": {
              "x": 7.009,
              "y": -10.471,
              "z": 1.65
            },
            "gtin": "7611916164965",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271079",
            "leftCorner": {
              "x": 7.009,
              "y": -10.471,
              "z": 1.65
            },
            "rightCorner": {
              "x": 6.966,
              "y": -10.43,
              "z": 1.65
            },
            "gtin": "7611916164965",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27107a",
            "leftCorner": {
              "x": 6.966,
              "y": -10.43,
              "z": 1.65
            },
            "rightCorner": {
              "x": 6.908,
              "y": -10.376,
              "z": 1.65
            },
            "gtin": "4009800001480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27107b",
            "leftCorner": {
              "x": 6.908,
              "y": -10.376,
              "z": 1.65
            },
            "rightCorner": {
              "x": 6.867,
              "y": -10.337,
              "z": 1.65
            },
            "gtin": "4001499943973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27107c",
            "leftCorner": {
              "x": 6.867,
              "y": -10.337,
              "z": 1.65
            },
            "rightCorner": {
              "x": 6.828,
              "y": -10.301,
              "z": 1.65
            },
            "gtin": "4001499943973",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27107d",
            "leftCorner": {
              "x": 6.828,
              "y": -10.301,
              "z": 1.65
            },
            "rightCorner": {
              "x": 6.754,
              "y": -10.231,
              "z": 1.65
            }
          },
          {
            "id": "696ebf6f43c343680a27107e",
            "leftCorner": {
              "x": 6.754,
              "y": -10.231,
              "z": 1.65
            },
            "rightCorner": {
              "x": 6.685,
              "y": -10.166,
              "z": 1.65
            },
            "gtin": "4001499972416",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc046959900",
    "name": "68e7571db5fe7bc046959900",
    "x": 6.6158,
    "y": -10.186,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93845,
      "w": 0.34542
    },
    "statistics": {
      "hasStockCount": 43,
      "noStockCount": 5,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73a7e",
        "height": 0.17116,
        "facings": [
          {
            "id": "696ebf6f43c343680a2710f1",
            "leftCorner": {
              "x": 6.675,
              "y": -10.183,
              "z": 0.172
            },
            "rightCorner": {
              "x": 6.621,
              "y": -10.132,
              "z": 0.172
            },
            "gtin": "4013718065014",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710f2",
            "leftCorner": {
              "x": 6.615,
              "y": -10.126,
              "z": 0.171
            },
            "rightCorner": {
              "x": 6.556,
              "y": -10.076,
              "z": 0.171
            },
            "gtin": "8710447262696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710f3",
            "leftCorner": {
              "x": 6.556,
              "y": -10.076,
              "z": 0.171
            },
            "rightCorner": {
              "x": 6.492,
              "y": -10.021,
              "z": 0.171
            },
            "gtin": "4058172738098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710f4",
            "leftCorner": {
              "x": 6.492,
              "y": -10.021,
              "z": 0.171
            },
            "rightCorner": {
              "x": 6.429,
              "y": -9.968,
              "z": 0.171
            },
            "gtin": "4058172738098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710f5",
            "leftCorner": {
              "x": 6.429,
              "y": -9.968,
              "z": 0.171
            },
            "rightCorner": {
              "x": 6.368,
              "y": -9.916,
              "z": 0.171
            },
            "gtin": "4058172738111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710f6",
            "leftCorner": {
              "x": 6.368,
              "y": -9.916,
              "z": 0.171
            },
            "rightCorner": {
              "x": 6.3,
              "y": -9.857,
              "z": 0.171
            },
            "gtin": "4058172738135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710f7",
            "leftCorner": {
              "x": 6.3,
              "y": -9.857,
              "z": 0.171
            },
            "rightCorner": {
              "x": 6.267,
              "y": -9.83,
              "z": 0.171
            },
            "gtin": "4017512213909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710f8",
            "leftCorner": {
              "x": 6.267,
              "y": -9.83,
              "z": 0.171
            },
            "rightCorner": {
              "x": 6.245,
              "y": -9.811,
              "z": 0.171
            },
            "gtin": "4017512214005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710f9",
            "leftCorner": {
              "x": 6.245,
              "y": -9.811,
              "z": 0.171
            },
            "rightCorner": {
              "x": 6.197,
              "y": -9.77,
              "z": 0.171
            },
            "gtin": "4017512213909",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710fa",
            "leftCorner": {
              "x": 6.197,
              "y": -9.77,
              "z": 0.171
            },
            "rightCorner": {
              "x": 6.153,
              "y": -9.732,
              "z": 0.171
            }
          },
          {
            "id": "696ebf6f43c343680a2710fb",
            "leftCorner": {
              "x": 6.153,
              "y": -9.732,
              "z": 0.171
            },
            "rightCorner": {
              "x": 6.079,
              "y": -9.67,
              "z": 0.171
            },
            "gtin": "4066447015287",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710fc",
            "leftCorner": {
              "x": 6.079,
              "y": -9.67,
              "z": 0.171
            },
            "rightCorner": {
              "x": 6.012,
              "y": -9.612,
              "z": 0.171
            },
            "gtin": "4066447322460",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710fd",
            "leftCorner": {
              "x": 6.012,
              "y": -9.612,
              "z": 0.171
            },
            "rightCorner": {
              "x": 5.896,
              "y": -9.514,
              "z": 0.171
            },
            "gtin": "4066447322460",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710fe",
            "leftCorner": {
              "x": 5.896,
              "y": -9.514,
              "z": 0.171
            },
            "rightCorner": {
              "x": 5.778,
              "y": -9.413,
              "z": 0.171
            },
            "gtin": "4058172309915",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a7f",
        "height": 0.51443,
        "facings": [
          {
            "id": "696ebf6f43c343680a27129c",
            "leftCorner": {
              "x": 6.646,
              "y": -10.15,
              "z": 0.514
            },
            "rightCorner": {
              "x": 6.592,
              "y": -10.104,
              "z": 0.514
            },
            "gtin": "4008233157214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27129e",
            "leftCorner": {
              "x": 6.592,
              "y": -10.104,
              "z": 0.514
            },
            "rightCorner": {
              "x": 6.531,
              "y": -10.052,
              "z": 0.514
            },
            "gtin": "4008233157214",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27129f",
            "leftCorner": {
              "x": 6.531,
              "y": -10.052,
              "z": 0.514
            },
            "rightCorner": {
              "x": 6.47,
              "y": -10.0,
              "z": 0.514
            },
            "gtin": "4008233157221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712a0",
            "leftCorner": {
              "x": 6.47,
              "y": -10.0,
              "z": 0.514
            },
            "rightCorner": {
              "x": 6.408,
              "y": -9.948,
              "z": 0.514
            },
            "gtin": "4008233157221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712a1",
            "leftCorner": {
              "x": 6.408,
              "y": -9.948,
              "z": 0.514
            },
            "rightCorner": {
              "x": 6.354,
              "y": -9.901,
              "z": 0.514
            },
            "gtin": "8008970050799",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712a2",
            "leftCorner": {
              "x": 6.354,
              "y": -9.901,
              "z": 0.514
            },
            "rightCorner": {
              "x": 6.304,
              "y": -9.859,
              "z": 0.514
            },
            "gtin": "8008970056579",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712a3",
            "leftCorner": {
              "x": 6.304,
              "y": -9.859,
              "z": 0.514
            },
            "rightCorner": {
              "x": 6.265,
              "y": -9.825,
              "z": 0.514
            },
            "gtin": "8008970056562",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712a4",
            "leftCorner": {
              "x": 6.265,
              "y": -9.825,
              "z": 0.514
            },
            "rightCorner": {
              "x": 6.245,
              "y": -9.809,
              "z": 0.514
            },
            "gtin": "8008970056562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712a5",
            "leftCorner": {
              "x": 6.245,
              "y": -9.809,
              "z": 0.514
            },
            "rightCorner": {
              "x": 6.186,
              "y": -9.758,
              "z": 0.514
            },
            "gtin": "4008233165745",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712a6",
            "leftCorner": {
              "x": 6.186,
              "y": -9.758,
              "z": 0.514
            },
            "rightCorner": {
              "x": 6.137,
              "y": -9.717,
              "z": 0.514
            },
            "gtin": "4008233145853",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712a7",
            "leftCorner": {
              "x": 6.137,
              "y": -9.717,
              "z": 0.514
            },
            "rightCorner": {
              "x": 6.082,
              "y": -9.67,
              "z": 0.514
            },
            "gtin": "4008233176635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712a8",
            "leftCorner": {
              "x": 6.082,
              "y": -9.67,
              "z": 0.514
            },
            "rightCorner": {
              "x": 6.035,
              "y": -9.63,
              "z": 0.514
            },
            "gtin": "4008233104003",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712a9",
            "leftCorner": {
              "x": 6.035,
              "y": -9.63,
              "z": 0.514
            },
            "rightCorner": {
              "x": 5.989,
              "y": -9.591,
              "z": 0.514
            },
            "gtin": "4008233109121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712aa",
            "leftCorner": {
              "x": 5.989,
              "y": -9.591,
              "z": 0.514
            },
            "rightCorner": {
              "x": 5.936,
              "y": -9.545,
              "z": 0.514
            },
            "gtin": "4008233158211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27129d",
            "leftCorner": {
              "x": 5.936,
              "y": -9.545,
              "z": 0.514
            },
            "rightCorner": {
              "x": 5.885,
              "y": -9.502,
              "z": 0.514
            },
            "gtin": "4008233168685",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a7c",
        "height": 0.80927,
        "facings": [
          {
            "id": "696ebf6f43c343680a271280",
            "leftCorner": {
              "x": 6.648,
              "y": -10.148,
              "z": 0.809
            },
            "rightCorner": {
              "x": 6.619,
              "y": -10.123,
              "z": 0.809
            }
          },
          {
            "id": "696ebf6f43c343680a271282",
            "leftCorner": {
              "x": 6.619,
              "y": -10.123,
              "z": 0.809
            },
            "rightCorner": {
              "x": 6.559,
              "y": -10.072,
              "z": 0.809
            },
            "gtin": "4017512157746",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271283",
            "leftCorner": {
              "x": 6.559,
              "y": -10.072,
              "z": 0.809
            },
            "rightCorner": {
              "x": 6.511,
              "y": -10.031,
              "z": 0.809
            },
            "gtin": "4017512176679",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271284",
            "leftCorner": {
              "x": 6.511,
              "y": -10.031,
              "z": 0.809
            },
            "rightCorner": {
              "x": 6.44,
              "y": -9.971,
              "z": 0.809
            },
            "gtin": "4017512157883",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271285",
            "leftCorner": {
              "x": 6.44,
              "y": -9.971,
              "z": 0.809
            },
            "rightCorner": {
              "x": 6.39,
              "y": -9.928,
              "z": 0.809
            },
            "gtin": "4008491283328",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271286",
            "leftCorner": {
              "x": 6.39,
              "y": -9.928,
              "z": 0.809
            },
            "rightCorner": {
              "x": 6.348,
              "y": -9.892,
              "z": 0.809
            },
            "gtin": "4008491283328",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271287",
            "leftCorner": {
              "x": 6.348,
              "y": -9.892,
              "z": 0.809
            },
            "rightCorner": {
              "x": 6.3,
              "y": -9.852,
              "z": 0.809
            },
            "gtin": "4008491112154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271288",
            "leftCorner": {
              "x": 6.3,
              "y": -9.852,
              "z": 0.809
            },
            "rightCorner": {
              "x": 6.248,
              "y": -9.807,
              "z": 0.809
            },
            "gtin": "4008491112154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271289",
            "leftCorner": {
              "x": 6.248,
              "y": -9.807,
              "z": 0.809
            },
            "rightCorner": {
              "x": 6.222,
              "y": -9.786,
              "z": 0.809
            },
            "gtin": "4008491119405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27128a",
            "leftCorner": {
              "x": 6.222,
              "y": -9.786,
              "z": 0.809
            },
            "rightCorner": {
              "x": 6.202,
              "y": -9.768,
              "z": 0.809
            },
            "gtin": "4008491119405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27128b",
            "leftCorner": {
              "x": 6.202,
              "y": -9.768,
              "z": 0.809
            },
            "rightCorner": {
              "x": 6.161,
              "y": -9.733,
              "z": 0.809
            },
            "gtin": "4008233177625",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27128c",
            "leftCorner": {
              "x": 6.161,
              "y": -9.733,
              "z": 0.809
            },
            "rightCorner": {
              "x": 6.12,
              "y": -9.698,
              "z": 0.809
            },
            "gtin": "4008233061580",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27128d",
            "leftCorner": {
              "x": 6.12,
              "y": -9.698,
              "z": 0.809
            },
            "rightCorner": {
              "x": 6.077,
              "y": -9.662,
              "z": 0.809
            },
            "gtin": "4008233119984",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27128e",
            "leftCorner": {
              "x": 6.077,
              "y": -9.662,
              "z": 0.809
            },
            "rightCorner": {
              "x": 6.035,
              "y": -9.626,
              "z": 0.809
            },
            "gtin": "4008233052250",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27128f",
            "leftCorner": {
              "x": 6.035,
              "y": -9.626,
              "z": 0.809
            },
            "rightCorner": {
              "x": 5.989,
              "y": -9.587,
              "z": 0.809
            },
            "gtin": "4008233038438",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271281",
            "leftCorner": {
              "x": 5.989,
              "y": -9.587,
              "z": 0.809
            },
            "rightCorner": {
              "x": 5.887,
              "y": -9.5,
              "z": 0.809
            },
            "gtin": "4013162033256",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a7b",
        "height": 1.0185,
        "facings": [
          {
            "id": "696ebf6f43c343680a271276",
            "leftCorner": {
              "x": 6.651,
              "y": -10.151,
              "z": 1.019
            },
            "rightCorner": {
              "x": 6.574,
              "y": -10.087,
              "z": 1.019
            },
            "gtin": "4008233153544",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271277",
            "leftCorner": {
              "x": 6.574,
              "y": -10.087,
              "z": 1.019
            },
            "rightCorner": {
              "x": 6.503,
              "y": -10.026,
              "z": 1.019
            },
            "gtin": "4008233156200",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271278",
            "leftCorner": {
              "x": 6.503,
              "y": -10.026,
              "z": 1.019
            },
            "rightCorner": {
              "x": 6.433,
              "y": -9.966,
              "z": 1.019
            },
            "gtin": "4008233172439",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271279",
            "leftCorner": {
              "x": 6.433,
              "y": -9.966,
              "z": 1.019
            },
            "rightCorner": {
              "x": 6.335,
              "y": -9.883,
              "z": 1.019
            },
            "gtin": "4008233181288",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27127a",
            "leftCorner": {
              "x": 6.335,
              "y": -9.883,
              "z": 1.019
            },
            "rightCorner": {
              "x": 6.277,
              "y": -9.833,
              "z": 1.019
            },
            "gtin": "4008233165301",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27127b",
            "leftCorner": {
              "x": 6.277,
              "y": -9.833,
              "z": 1.019
            },
            "rightCorner": {
              "x": 6.258,
              "y": -9.817,
              "z": 1.019
            }
          },
          {
            "id": "696ebf6f43c343680a27127c",
            "leftCorner": {
              "x": 6.258,
              "y": -9.817,
              "z": 1.019
            },
            "rightCorner": {
              "x": 6.187,
              "y": -9.757,
              "z": 1.019
            },
            "gtin": "4008233129761",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27127d",
            "leftCorner": {
              "x": 6.187,
              "y": -9.757,
              "z": 1.019
            },
            "rightCorner": {
              "x": 6.117,
              "y": -9.697,
              "z": 1.019
            },
            "gtin": "4008233150963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27127e",
            "leftCorner": {
              "x": 6.117,
              "y": -9.697,
              "z": 1.019
            },
            "rightCorner": {
              "x": 6.045,
              "y": -9.636,
              "z": 1.019
            },
            "gtin": "4008233165240",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27127f",
            "leftCorner": {
              "x": 6.045,
              "y": -9.636,
              "z": 1.019
            },
            "rightCorner": {
              "x": 5.965,
              "y": -9.567,
              "z": 1.019
            },
            "gtin": "4008233046068",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271275",
            "leftCorner": {
              "x": 5.965,
              "y": -9.567,
              "z": 1.019
            },
            "rightCorner": {
              "x": 5.886,
              "y": -9.5,
              "z": 1.019
            },
            "gtin": "4008233128009",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a7d",
        "height": 1.2303,
        "facings": [
          {
            "id": "696ebf6f43c343680a271291",
            "leftCorner": {
              "x": 6.648,
              "y": -10.139,
              "z": 1.23
            },
            "rightCorner": {
              "x": 6.577,
              "y": -10.079,
              "z": 1.23
            },
            "gtin": "4008491122610",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271292",
            "leftCorner": {
              "x": 6.577,
              "y": -10.079,
              "z": 1.23
            },
            "rightCorner": {
              "x": 6.495,
              "y": -10.009,
              "z": 1.23
            },
            "gtin": "4008491106993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271293",
            "leftCorner": {
              "x": 6.495,
              "y": -10.009,
              "z": 1.23
            },
            "rightCorner": {
              "x": 6.422,
              "y": -9.947,
              "z": 1.23
            },
            "gtin": "4008491103213",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271294",
            "leftCorner": {
              "x": 6.422,
              "y": -9.947,
              "z": 1.23
            },
            "rightCorner": {
              "x": 6.351,
              "y": -9.886,
              "z": 1.23
            },
            "gtin": "4008491480420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271295",
            "leftCorner": {
              "x": 6.351,
              "y": -9.886,
              "z": 1.23
            },
            "rightCorner": {
              "x": 6.295,
              "y": -9.838,
              "z": 1.23
            },
            "gtin": "4008491480697",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271296",
            "leftCorner": {
              "x": 6.295,
              "y": -9.838,
              "z": 1.23
            },
            "rightCorner": {
              "x": 6.273,
              "y": -9.82,
              "z": 1.23
            },
            "gtin": "4008491480697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271297",
            "leftCorner": {
              "x": 6.273,
              "y": -9.82,
              "z": 1.23
            },
            "rightCorner": {
              "x": 6.215,
              "y": -9.77,
              "z": 1.23
            },
            "gtin": "4067796080452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271298",
            "leftCorner": {
              "x": 6.215,
              "y": -9.77,
              "z": 1.23
            },
            "rightCorner": {
              "x": 6.152,
              "y": -9.716,
              "z": 1.23
            },
            "gtin": "4066447877083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271299",
            "leftCorner": {
              "x": 6.152,
              "y": -9.716,
              "z": 1.23
            },
            "rightCorner": {
              "x": 6.088,
              "y": -9.662,
              "z": 1.23
            },
            "gtin": "4066447715620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27129a",
            "leftCorner": {
              "x": 6.088,
              "y": -9.662,
              "z": 1.23
            },
            "rightCorner": {
              "x": 6.027,
              "y": -9.61,
              "z": 1.23
            },
            "gtin": "4066447877434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27129b",
            "leftCorner": {
              "x": 6.027,
              "y": -9.61,
              "z": 1.23
            },
            "rightCorner": {
              "x": 5.964,
              "y": -9.556,
              "z": 1.23
            },
            "gtin": "4066447521405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271290",
            "leftCorner": {
              "x": 5.964,
              "y": -9.556,
              "z": 1.23
            },
            "rightCorner": {
              "x": 5.891,
              "y": -9.494,
              "z": 1.23
            },
            "gtin": "4066447877458",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a7a",
        "height": 1.4443,
        "facings": [
          {
            "id": "696ebf6f43c343680a27124c",
            "leftCorner": {
              "x": 6.648,
              "y": -10.139,
              "z": 1.444
            },
            "rightCorner": {
              "x": 6.585,
              "y": -10.085,
              "z": 1.444
            },
            "gtin": "4008491122658",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27124d",
            "leftCorner": {
              "x": 6.585,
              "y": -10.085,
              "z": 1.444
            },
            "rightCorner": {
              "x": 6.511,
              "y": -10.022,
              "z": 1.444
            },
            "gtin": "4008491122573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27124e",
            "leftCorner": {
              "x": 6.511,
              "y": -10.022,
              "z": 1.444
            },
            "rightCorner": {
              "x": 6.428,
              "y": -9.951,
              "z": 1.444
            },
            "gtin": "4260307627935",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27124f",
            "leftCorner": {
              "x": 6.428,
              "y": -9.951,
              "z": 1.444
            },
            "rightCorner": {
              "x": 6.351,
              "y": -9.886,
              "z": 1.444
            },
            "gtin": "4260307630461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271250",
            "leftCorner": {
              "x": 6.351,
              "y": -9.886,
              "z": 1.444
            },
            "rightCorner": {
              "x": 6.296,
              "y": -9.839,
              "z": 1.444
            },
            "gtin": "4260307631956",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271251",
            "leftCorner": {
              "x": 6.296,
              "y": -9.839,
              "z": 1.444
            },
            "rightCorner": {
              "x": 6.275,
              "y": -9.821,
              "z": 1.444
            },
            "gtin": "4260307631956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271252",
            "leftCorner": {
              "x": 6.275,
              "y": -9.821,
              "z": 1.444
            },
            "rightCorner": {
              "x": 6.197,
              "y": -9.754,
              "z": 1.444
            },
            "gtin": "4260307628505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271253",
            "leftCorner": {
              "x": 6.197,
              "y": -9.754,
              "z": 1.444
            },
            "rightCorner": {
              "x": 6.119,
              "y": -9.688,
              "z": 1.444
            },
            "gtin": "4260307628666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271254",
            "leftCorner": {
              "x": 6.119,
              "y": -9.688,
              "z": 1.444
            },
            "rightCorner": {
              "x": 6.022,
              "y": -9.605,
              "z": 1.444
            },
            "gtin": "4260307630072",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271255",
            "leftCorner": {
              "x": 6.022,
              "y": -9.605,
              "z": 1.444
            },
            "rightCorner": {
              "x": 5.951,
              "y": -9.545,
              "z": 1.444
            },
            "gtin": "4017512213305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271256",
            "leftCorner": {
              "x": 5.951,
              "y": -9.545,
              "z": 1.444
            },
            "rightCorner": {
              "x": 5.894,
              "y": -9.496,
              "z": 1.444
            },
            "gtin": "4017512213107",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271257",
            "leftCorner": {
              "x": 5.894,
              "y": -9.496,
              "z": 1.444
            },
            "rightCorner": {
              "x": 5.868,
              "y": -9.475,
              "z": 1.444
            }
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a79",
        "height": 1.6505,
        "facings": [
          {
            "id": "696ebf6f43c343680a27107f",
            "leftCorner": {
              "x": 6.685,
              "y": -10.166,
              "z": 1.65
            },
            "rightCorner": {
              "x": 6.603,
              "y": -10.089,
              "z": 1.65
            },
            "gtin": "5060968419912",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271080",
            "leftCorner": {
              "x": 6.592,
              "y": -10.086,
              "z": 1.651
            },
            "rightCorner": {
              "x": 6.527,
              "y": -10.031,
              "z": 1.651
            },
            "gtin": "4017512213206",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271081",
            "leftCorner": {
              "x": 6.527,
              "y": -10.031,
              "z": 1.651
            },
            "rightCorner": {
              "x": 6.455,
              "y": -9.969,
              "z": 1.651
            },
            "gtin": "4260307628642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271082",
            "leftCorner": {
              "x": 6.455,
              "y": -9.969,
              "z": 1.651
            },
            "rightCorner": {
              "x": 6.393,
              "y": -9.916,
              "z": 1.651
            },
            "gtin": "8008970060361",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271083",
            "leftCorner": {
              "x": 6.393,
              "y": -9.916,
              "z": 1.651
            },
            "rightCorner": {
              "x": 6.329,
              "y": -9.862,
              "z": 1.651
            },
            "gtin": "8008970060385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271084",
            "leftCorner": {
              "x": 6.329,
              "y": -9.862,
              "z": 1.651
            },
            "rightCorner": {
              "x": 6.271,
              "y": -9.813,
              "z": 1.651
            },
            "gtin": "4017512212902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271085",
            "leftCorner": {
              "x": 6.271,
              "y": -9.813,
              "z": 1.651
            },
            "rightCorner": {
              "x": 6.249,
              "y": -9.794,
              "z": 1.651
            },
            "gtin": "4017512212902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271086",
            "leftCorner": {
              "x": 6.249,
              "y": -9.794,
              "z": 1.651
            },
            "rightCorner": {
              "x": 6.173,
              "y": -9.729,
              "z": 1.651
            },
            "gtin": "4017512213008",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271087",
            "leftCorner": {
              "x": 6.173,
              "y": -9.729,
              "z": 1.651
            },
            "rightCorner": {
              "x": 6.097,
              "y": -9.664,
              "z": 1.651
            },
            "gtin": "4017512157371",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271088",
            "leftCorner": {
              "x": 6.097,
              "y": -9.664,
              "z": 1.651
            },
            "rightCorner": {
              "x": 6.025,
              "y": -9.603,
              "z": 1.651
            },
            "gtin": "4017512157043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271089",
            "leftCorner": {
              "x": 6.025,
              "y": -9.603,
              "z": 1.651
            },
            "rightCorner": {
              "x": 5.941,
              "y": -9.532,
              "z": 1.651
            },
            "gtin": "4017512212704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27108a",
            "leftCorner": {
              "x": 5.941,
              "y": -9.532,
              "z": 1.651
            },
            "rightCorner": {
              "x": 5.843,
              "y": -9.448,
              "z": 1.651
            }
          }
        ]
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc046959901",
    "name": "68e7571db5fe7bc046959901",
    "x": 5.8501,
    "y": -9.5322,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93593,
      "w": 0.35218
    },
    "statistics": {
      "hasStockCount": 30,
      "noStockCount": 2,
      "unknownStockCount": 27
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73a85",
        "height": 0.17267,
        "facings": [
          {
            "id": "696ebf6f43c343680a2710ff",
            "leftCorner": {
              "x": 5.775,
              "y": -9.407,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.665,
              "y": -9.31,
              "z": 0.173
            },
            "gtin": "4008890006504",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271100",
            "leftCorner": {
              "x": 5.665,
              "y": -9.31,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.586,
              "y": -9.241,
              "z": 0.173
            },
            "gtin": "8718951727465",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271101",
            "leftCorner": {
              "x": 5.586,
              "y": -9.241,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.567,
              "y": -9.224,
              "z": 0.173
            }
          },
          {
            "id": "696ebf6f43c343680a271102",
            "leftCorner": {
              "x": 5.567,
              "y": -9.224,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.44,
              "y": -9.113,
              "z": 0.173
            },
            "gtin": "8718951727502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271103",
            "leftCorner": {
              "x": 5.44,
              "y": -9.113,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.349,
              "y": -9.033,
              "z": 0.173
            },
            "gtin": "4001499967429",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271104",
            "leftCorner": {
              "x": 5.349,
              "y": -9.033,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.326,
              "y": -9.013,
              "z": 0.173
            }
          },
          {
            "id": "696ebf6f43c343680a271105",
            "leftCorner": {
              "x": 5.326,
              "y": -9.013,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.253,
              "y": -8.949,
              "z": 0.173
            },
            "gtin": "4001499967443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271106",
            "leftCorner": {
              "x": 5.253,
              "y": -8.949,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.199,
              "y": -8.901,
              "z": 0.173
            }
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a81",
        "height": 0.4318,
        "facings": [
          {
            "id": "696ebf6f43c343680a2712ca",
            "leftCorner": {
              "x": 5.884,
              "y": -9.506,
              "z": 0.432
            },
            "rightCorner": {
              "x": 5.856,
              "y": -9.482,
              "z": 0.432
            },
            "gtin": "8718951257818",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712cb",
            "leftCorner": {
              "x": 5.856,
              "y": -9.482,
              "z": 0.432
            },
            "rightCorner": {
              "x": 5.818,
              "y": -9.448,
              "z": 0.432
            },
            "gtin": "8718951257818",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712cc",
            "leftCorner": {
              "x": 5.818,
              "y": -9.448,
              "z": 0.432
            },
            "rightCorner": {
              "x": 5.752,
              "y": -9.39,
              "z": 0.432
            },
            "gtin": "8714789964157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712cd",
            "leftCorner": {
              "x": 5.752,
              "y": -9.39,
              "z": 0.432
            },
            "rightCorner": {
              "x": 5.667,
              "y": -9.316,
              "z": 0.432
            },
            "gtin": "8714789964157",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712ce",
            "leftCorner": {
              "x": 5.667,
              "y": -9.316,
              "z": 0.432
            },
            "rightCorner": {
              "x": 5.591,
              "y": -9.249,
              "z": 0.432
            }
          },
          {
            "id": "696ebf6f43c343680a2712cf",
            "leftCorner": {
              "x": 5.591,
              "y": -9.249,
              "z": 0.432
            },
            "rightCorner": {
              "x": 5.517,
              "y": -9.185,
              "z": 0.432
            },
            "gtin": "8714789673653",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712d0",
            "leftCorner": {
              "x": 5.517,
              "y": -9.185,
              "z": 0.432
            },
            "rightCorner": {
              "x": 5.428,
              "y": -9.106,
              "z": 0.432
            },
            "gtin": "8003520012944",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712d1",
            "leftCorner": {
              "x": 5.428,
              "y": -9.106,
              "z": 0.432
            },
            "rightCorner": {
              "x": 5.267,
              "y": -8.965,
              "z": 0.432
            },
            "gtin": "8714789939681",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712d2",
            "leftCorner": {
              "x": 5.267,
              "y": -8.965,
              "z": 0.432
            },
            "rightCorner": {
              "x": 5.126,
              "y": -8.841,
              "z": 0.432
            },
            "gtin": "8003520013040",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a80",
        "height": 0.68126,
        "facings": [
          {
            "id": "696ebf6f43c343680a2712ab",
            "leftCorner": {
              "x": 5.879,
              "y": -9.5,
              "z": 0.681
            },
            "rightCorner": {
              "x": 5.801,
              "y": -9.431,
              "z": 0.681
            },
            "gtin": "4251758434616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712ac",
            "leftCorner": {
              "x": 5.801,
              "y": -9.431,
              "z": 0.681
            },
            "rightCorner": {
              "x": 5.733,
              "y": -9.372,
              "z": 0.681
            },
            "gtin": "4251758405562",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712ad",
            "leftCorner": {
              "x": 5.733,
              "y": -9.372,
              "z": 0.681
            },
            "rightCorner": {
              "x": 5.698,
              "y": -9.341,
              "z": 0.681
            }
          },
          {
            "id": "696ebf6f43c343680a2712ae",
            "leftCorner": {
              "x": 5.698,
              "y": -9.341,
              "z": 0.681
            },
            "rightCorner": {
              "x": 5.661,
              "y": -9.308,
              "z": 0.681
            }
          },
          {
            "id": "696ebf6f43c343680a2712af",
            "leftCorner": {
              "x": 5.661,
              "y": -9.308,
              "z": 0.681
            },
            "rightCorner": {
              "x": 5.605,
              "y": -9.26,
              "z": 0.681
            },
            "gtin": "4251758434715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712b0",
            "leftCorner": {
              "x": 5.605,
              "y": -9.26,
              "z": 0.681
            },
            "rightCorner": {
              "x": 5.51,
              "y": -9.176,
              "z": 0.681
            },
            "gtin": "4002448122500",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712b1",
            "leftCorner": {
              "x": 5.51,
              "y": -9.176,
              "z": 0.681
            },
            "rightCorner": {
              "x": 5.432,
              "y": -9.108,
              "z": 0.681
            },
            "gtin": "4251758416926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712b2",
            "leftCorner": {
              "x": 5.432,
              "y": -9.108,
              "z": 0.681
            },
            "rightCorner": {
              "x": 5.376,
              "y": -9.059,
              "z": 0.681
            },
            "gtin": "4251758434227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712b3",
            "leftCorner": {
              "x": 5.376,
              "y": -9.059,
              "z": 0.681
            },
            "rightCorner": {
              "x": 5.307,
              "y": -8.998,
              "z": 0.681
            },
            "gtin": "4002448099871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712b4",
            "leftCorner": {
              "x": 5.307,
              "y": -8.998,
              "z": 0.681
            },
            "rightCorner": {
              "x": 5.235,
              "y": -8.935,
              "z": 0.681
            },
            "gtin": "4002448101659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712b5",
            "leftCorner": {
              "x": 5.235,
              "y": -8.935,
              "z": 0.681
            },
            "rightCorner": {
              "x": 5.179,
              "y": -8.887,
              "z": 0.681
            },
            "gtin": "4002448101635",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712b6",
            "leftCorner": {
              "x": 5.179,
              "y": -8.887,
              "z": 0.681
            },
            "rightCorner": {
              "x": 5.111,
              "y": -8.826,
              "z": 0.681
            },
            "gtin": "4251758435279",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a84",
        "height": 0.93537,
        "facings": [
          {
            "id": "696ebf6f43c343680a2712e8",
            "leftCorner": {
              "x": 5.879,
              "y": -9.499,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.749,
              "y": -9.385,
              "z": 0.935
            },
            "gtin": "4066447378313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712ea",
            "leftCorner": {
              "x": 5.749,
              "y": -9.385,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.639,
              "y": -9.288,
              "z": 0.935
            },
            "gtin": "4066447374278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712eb",
            "leftCorner": {
              "x": 5.639,
              "y": -9.288,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.57,
              "y": -9.228,
              "z": 0.935
            },
            "gtin": "4036581534654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712ec",
            "leftCorner": {
              "x": 5.57,
              "y": -9.228,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.548,
              "y": -9.208,
              "z": 0.935
            },
            "gtin": "4002448128991",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712ed",
            "leftCorner": {
              "x": 5.548,
              "y": -9.208,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.514,
              "y": -9.179,
              "z": 0.935
            },
            "gtin": "4002448128274",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712ee",
            "leftCorner": {
              "x": 5.514,
              "y": -9.179,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.487,
              "y": -9.155,
              "z": 0.935
            }
          },
          {
            "id": "696ebf6f43c343680a2712ef",
            "leftCorner": {
              "x": 5.487,
              "y": -9.155,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.455,
              "y": -9.127,
              "z": 0.935
            },
            "gtin": "4062196135122",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712f0",
            "leftCorner": {
              "x": 5.455,
              "y": -9.127,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.402,
              "y": -9.08,
              "z": 0.935
            },
            "gtin": "4062196149839",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712f1",
            "leftCorner": {
              "x": 5.402,
              "y": -9.08,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.343,
              "y": -9.029,
              "z": 0.935
            },
            "gtin": "4062196348690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712f2",
            "leftCorner": {
              "x": 5.343,
              "y": -9.029,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.303,
              "y": -8.994,
              "z": 0.935
            },
            "gtin": "4062196348690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712f3",
            "leftCorner": {
              "x": 5.303,
              "y": -8.994,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.253,
              "y": -8.95,
              "z": 0.935
            },
            "gtin": "4062196348690",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712f4",
            "leftCorner": {
              "x": 5.253,
              "y": -8.95,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.209,
              "y": -8.911,
              "z": 0.935
            }
          },
          {
            "id": "696ebf6f43c343680a2712f5",
            "leftCorner": {
              "x": 5.209,
              "y": -8.911,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.188,
              "y": -8.893,
              "z": 0.935
            }
          },
          {
            "id": "696ebf6f43c343680a2712f6",
            "leftCorner": {
              "x": 5.188,
              "y": -8.893,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.14,
              "y": -8.851,
              "z": 0.935
            },
            "gtin": "4066447376920",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712f7",
            "leftCorner": {
              "x": 5.14,
              "y": -8.851,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.074,
              "y": -8.793,
              "z": 0.935
            },
            "gtin": "4066447376920",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a86",
        "height": 1.1899,
        "facings": [
          {
            "id": "696ebf6f43c343680a271311",
            "leftCorner": {
              "x": 5.881,
              "y": -9.497,
              "z": 1.19
            },
            "rightCorner": {
              "x": 5.827,
              "y": -9.45,
              "z": 1.19
            }
          },
          {
            "id": "696ebf6f43c343680a271313",
            "leftCorner": {
              "x": 5.827,
              "y": -9.45,
              "z": 1.19
            },
            "rightCorner": {
              "x": 5.754,
              "y": -9.386,
              "z": 1.19
            },
            "gtin": "4066447376906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271314",
            "leftCorner": {
              "x": 5.754,
              "y": -9.386,
              "z": 1.19
            },
            "rightCorner": {
              "x": 5.723,
              "y": -9.359,
              "z": 1.19
            }
          },
          {
            "id": "696ebf6f43c343680a271315",
            "leftCorner": {
              "x": 5.723,
              "y": -9.359,
              "z": 1.19
            },
            "rightCorner": {
              "x": 5.667,
              "y": -9.31,
              "z": 1.19
            },
            "gtin": "4066447591781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271316",
            "leftCorner": {
              "x": 5.667,
              "y": -9.31,
              "z": 1.19
            },
            "rightCorner": {
              "x": 5.468,
              "y": -9.136,
              "z": 1.19
            },
            "gtin": "4066447591781",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271317",
            "leftCorner": {
              "x": 5.468,
              "y": -9.136,
              "z": 1.19
            },
            "rightCorner": {
              "x": 5.385,
              "y": -9.063,
              "z": 1.19
            }
          },
          {
            "id": "696ebf6f43c343680a271318",
            "leftCorner": {
              "x": 5.385,
              "y": -9.063,
              "z": 1.19
            },
            "rightCorner": {
              "x": 5.246,
              "y": -8.941,
              "z": 1.19
            },
            "gtin": "4066447237948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271319",
            "leftCorner": {
              "x": 5.246,
              "y": -8.941,
              "z": 1.19
            },
            "rightCorner": {
              "x": 5.191,
              "y": -8.893,
              "z": 1.19
            },
            "gtin": "017854100169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27131a",
            "leftCorner": {
              "x": 5.191,
              "y": -8.893,
              "z": 1.19
            },
            "rightCorner": {
              "x": 5.133,
              "y": -8.842,
              "z": 1.19
            },
            "gtin": "017854100176",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a83",
        "height": 1.4446,
        "facings": [
          {
            "id": "696ebf6f43c343680a271258",
            "leftCorner": {
              "x": 5.862,
              "y": -9.474,
              "z": 1.445
            },
            "rightCorner": {
              "x": 5.775,
              "y": -9.398,
              "z": 1.445
            },
            "gtin": "4002942537466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271259",
            "leftCorner": {
              "x": 5.775,
              "y": -9.398,
              "z": 1.445
            },
            "rightCorner": {
              "x": 5.749,
              "y": -9.375,
              "z": 1.445
            },
            "gtin": "4051281978461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27125a",
            "leftCorner": {
              "x": 5.749,
              "y": -9.375,
              "z": 1.445
            },
            "rightCorner": {
              "x": 5.72,
              "y": -9.35,
              "z": 1.445
            },
            "gtin": "4051281978461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27125b",
            "leftCorner": {
              "x": 5.72,
              "y": -9.35,
              "z": 1.445
            },
            "rightCorner": {
              "x": 5.65,
              "y": -9.288,
              "z": 1.445
            },
            "gtin": "4001499968181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27125c",
            "leftCorner": {
              "x": 5.65,
              "y": -9.288,
              "z": 1.445
            },
            "rightCorner": {
              "x": 5.595,
              "y": -9.24,
              "z": 1.445
            },
            "gtin": "4001499930676",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27125d",
            "leftCorner": {
              "x": 5.595,
              "y": -9.24,
              "z": 1.445
            },
            "rightCorner": {
              "x": 5.542,
              "y": -9.193,
              "z": 1.445
            },
            "gtin": "4066447384093",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27125e",
            "leftCorner": {
              "x": 5.542,
              "y": -9.193,
              "z": 1.445
            },
            "rightCorner": {
              "x": 5.486,
              "y": -9.144,
              "z": 1.445
            },
            "gtin": "4066447384093",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27125f",
            "leftCorner": {
              "x": 5.486,
              "y": -9.144,
              "z": 1.445
            },
            "rightCorner": {
              "x": 5.399,
              "y": -9.068,
              "z": 1.445
            },
            "gtin": "4262401736766",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271260",
            "leftCorner": {
              "x": 5.399,
              "y": -9.068,
              "z": 1.445
            },
            "rightCorner": {
              "x": 5.326,
              "y": -9.004,
              "z": 1.445
            },
            "gtin": "4260372933740",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271261",
            "leftCorner": {
              "x": 5.326,
              "y": -9.004,
              "z": 1.445
            },
            "rightCorner": {
              "x": 5.276,
              "y": -8.96,
              "z": 1.445
            }
          },
          {
            "id": "696ebf6f43c343680a271262",
            "leftCorner": {
              "x": 5.276,
              "y": -8.96,
              "z": 1.445
            },
            "rightCorner": {
              "x": 5.205,
              "y": -8.898,
              "z": 1.445
            },
            "gtin": "4262401736742",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271263",
            "leftCorner": {
              "x": 5.205,
              "y": -8.898,
              "z": 1.445
            },
            "rightCorner": {
              "x": 5.14,
              "y": -8.841,
              "z": 1.445
            },
            "gtin": "4260702180813",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a82",
        "height": 1.6516,
        "facings": [
          {
            "id": "696ebf6f43c343680a27108b",
            "leftCorner": {
              "x": 5.836,
              "y": -9.447,
              "z": 1.652
            },
            "rightCorner": {
              "x": 5.779,
              "y": -9.397,
              "z": 1.652
            }
          },
          {
            "id": "696ebf6f43c343680a27108c",
            "leftCorner": {
              "x": 5.779,
              "y": -9.397,
              "z": 1.652
            },
            "rightCorner": {
              "x": 5.712,
              "y": -9.338,
              "z": 1.652
            },
            "gtin": "4021457632947",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27108d",
            "leftCorner": {
              "x": 5.712,
              "y": -9.338,
              "z": 1.652
            },
            "rightCorner": {
              "x": 5.62,
              "y": -9.257,
              "z": 1.652
            }
          },
          {
            "id": "696ebf6f43c343680a27108e",
            "leftCorner": {
              "x": 5.62,
              "y": -9.257,
              "z": 1.652
            },
            "rightCorner": {
              "x": 5.544,
              "y": -9.19,
              "z": 1.652
            },
            "gtin": "4066447591729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27108f",
            "leftCorner": {
              "x": 5.544,
              "y": -9.19,
              "z": 1.652
            },
            "rightCorner": {
              "x": 5.479,
              "y": -9.133,
              "z": 1.652
            },
            "gtin": "4066447523546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271090",
            "leftCorner": {
              "x": 5.479,
              "y": -9.133,
              "z": 1.652
            },
            "rightCorner": {
              "x": 5.418,
              "y": -9.08,
              "z": 1.652
            },
            "gtin": "4066447523645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271091",
            "leftCorner": {
              "x": 5.418,
              "y": -9.08,
              "z": 1.652
            },
            "rightCorner": {
              "x": 5.394,
              "y": -9.059,
              "z": 1.652
            }
          },
          {
            "id": "696ebf6f43c343680a271092",
            "leftCorner": {
              "x": 5.394,
              "y": -9.059,
              "z": 1.652
            },
            "rightCorner": {
              "x": 5.33,
              "y": -9.003,
              "z": 1.652
            },
            "gtin": "4066447396690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271093",
            "leftCorner": {
              "x": 5.33,
              "y": -9.003,
              "z": 1.652
            },
            "rightCorner": {
              "x": 5.269,
              "y": -8.95,
              "z": 1.652
            }
          },
          {
            "id": "696ebf6f43c343680a271094",
            "leftCorner": {
              "x": 5.269,
              "y": -8.95,
              "z": 1.652
            },
            "rightCorner": {
              "x": 5.221,
              "y": -8.908,
              "z": 1.652
            },
            "gtin": "4066447396676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271095",
            "leftCorner": {
              "x": 5.221,
              "y": -8.908,
              "z": 1.652
            },
            "rightCorner": {
              "x": 5.134,
              "y": -8.832,
              "z": 1.652
            },
            "gtin": "4067796071207",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc046959902",
    "name": "68e7571db5fe7bc046959902",
    "x": 5.0965,
    "y": -8.8713,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93607,
      "w": 0.35181
    },
    "statistics": {
      "hasStockCount": 33,
      "noStockCount": 1,
      "unknownStockCount": 25
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73a8d",
        "height": 0.17371,
        "facings": [
          {
            "id": "696ebf6f43c343680a271107",
            "leftCorner": {
              "x": 5.198,
              "y": -8.901,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.08,
              "y": -8.797,
              "z": 0.173
            },
            "gtin": "4067796170375",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271108",
            "leftCorner": {
              "x": 5.078,
              "y": -8.795,
              "z": 0.174
            },
            "rightCorner": {
              "x": 4.913,
              "y": -8.651,
              "z": 0.174
            },
            "gtin": "4058172491979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271109",
            "leftCorner": {
              "x": 4.913,
              "y": -8.651,
              "z": 0.174
            },
            "rightCorner": {
              "x": 4.27,
              "y": -8.088,
              "z": 0.174
            },
            "gtin": "4066447376982",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a88",
        "height": 0.43203,
        "facings": [
          {
            "id": "696ebf6f43c343680a2712d3",
            "leftCorner": {
              "x": 5.124,
              "y": -8.84,
              "z": 0.432
            },
            "rightCorner": {
              "x": 5.098,
              "y": -8.817,
              "z": 0.432
            },
            "gtin": "4262469953259",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712d4",
            "leftCorner": {
              "x": 5.098,
              "y": -8.817,
              "z": 0.432
            },
            "rightCorner": {
              "x": 5.047,
              "y": -8.772,
              "z": 0.432
            },
            "gtin": "4262469953259",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712d5",
            "leftCorner": {
              "x": 5.047,
              "y": -8.772,
              "z": 0.432
            },
            "rightCorner": {
              "x": 5.024,
              "y": -8.752,
              "z": 0.432
            },
            "gtin": "4262469953235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712d6",
            "leftCorner": {
              "x": 5.024,
              "y": -8.752,
              "z": 0.432
            },
            "rightCorner": {
              "x": 4.983,
              "y": -8.717,
              "z": 0.432
            },
            "gtin": "4262469951620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712d7",
            "leftCorner": {
              "x": 4.983,
              "y": -8.717,
              "z": 0.432
            },
            "rightCorner": {
              "x": 4.924,
              "y": -8.664,
              "z": 0.432
            },
            "gtin": "4262469951606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712d8",
            "leftCorner": {
              "x": 4.924,
              "y": -8.664,
              "z": 0.432
            },
            "rightCorner": {
              "x": 4.868,
              "y": -8.616,
              "z": 0.432
            },
            "gtin": "4262376082141",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712d9",
            "leftCorner": {
              "x": 4.868,
              "y": -8.616,
              "z": 0.432
            },
            "rightCorner": {
              "x": 4.807,
              "y": -8.562,
              "z": 0.432
            },
            "gtin": "4262376082158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712da",
            "leftCorner": {
              "x": 4.807,
              "y": -8.562,
              "z": 0.432
            },
            "rightCorner": {
              "x": 4.752,
              "y": -8.514,
              "z": 0.432
            },
            "gtin": "4260307631208",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712db",
            "leftCorner": {
              "x": 4.752,
              "y": -8.514,
              "z": 0.432
            },
            "rightCorner": {
              "x": 4.699,
              "y": -8.468,
              "z": 0.432
            },
            "gtin": "4260307631161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712dc",
            "leftCorner": {
              "x": 4.699,
              "y": -8.468,
              "z": 0.432
            },
            "rightCorner": {
              "x": 4.588,
              "y": -8.37,
              "z": 0.432
            },
            "gtin": "4260307629908",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712dd",
            "leftCorner": {
              "x": 4.588,
              "y": -8.37,
              "z": 0.432
            },
            "rightCorner": {
              "x": 4.254,
              "y": -8.078,
              "z": 0.432
            },
            "gtin": "4066447377088",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a8a",
        "height": 0.68404,
        "facings": [
          {
            "id": "696ebf6f43c343680a2712b7",
            "leftCorner": {
              "x": 5.106,
              "y": -8.828,
              "z": 0.684
            },
            "rightCorner": {
              "x": 5.028,
              "y": -8.76,
              "z": 0.684
            },
            "gtin": "4251758435576",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712b8",
            "leftCorner": {
              "x": 5.028,
              "y": -8.76,
              "z": 0.684
            },
            "rightCorner": {
              "x": 4.965,
              "y": -8.704,
              "z": 0.684
            },
            "gtin": "4005808807000",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712b9",
            "leftCorner": {
              "x": 4.965,
              "y": -8.704,
              "z": 0.684
            },
            "rightCorner": {
              "x": 4.867,
              "y": -8.619,
              "z": 0.684
            },
            "gtin": "4005808807017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712ba",
            "leftCorner": {
              "x": 4.867,
              "y": -8.619,
              "z": 0.684
            },
            "rightCorner": {
              "x": 4.753,
              "y": -8.519,
              "z": 0.684
            },
            "gtin": "4000388179004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712bb",
            "leftCorner": {
              "x": 4.753,
              "y": -8.519,
              "z": 0.684
            },
            "rightCorner": {
              "x": 4.664,
              "y": -8.441,
              "z": 0.684
            }
          },
          {
            "id": "696ebf6f43c343680a2712bc",
            "leftCorner": {
              "x": 4.664,
              "y": -8.441,
              "z": 0.684
            },
            "rightCorner": {
              "x": 4.569,
              "y": -8.358,
              "z": 0.684
            },
            "gtin": "4066447383713",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712bd",
            "leftCorner": {
              "x": 4.569,
              "y": -8.358,
              "z": 0.684
            },
            "rightCorner": {
              "x": 4.456,
              "y": -8.259,
              "z": 0.684
            }
          },
          {
            "id": "696ebf6f43c343680a2712be",
            "leftCorner": {
              "x": 4.456,
              "y": -8.259,
              "z": 0.684
            },
            "rightCorner": {
              "x": 4.375,
              "y": -8.188,
              "z": 0.684
            }
          },
          {
            "id": "696ebf6f43c343680a2712bf",
            "leftCorner": {
              "x": 4.375,
              "y": -8.188,
              "z": 0.684
            },
            "rightCorner": {
              "x": 4.278,
              "y": -8.103,
              "z": 0.684
            }
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a8c",
        "height": 0.93811,
        "facings": [
          {
            "id": "696ebf6f43c343680a2712f8",
            "leftCorner": {
              "x": 5.073,
              "y": -8.79,
              "z": 0.938
            },
            "rightCorner": {
              "x": 5.015,
              "y": -8.74,
              "z": 0.938
            }
          },
          {
            "id": "696ebf6f43c343680a2712f9",
            "leftCorner": {
              "x": 5.015,
              "y": -8.74,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.962,
              "y": -8.693,
              "z": 0.938
            },
            "gtin": "4066447376944",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712fa",
            "leftCorner": {
              "x": 4.962,
              "y": -8.693,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.918,
              "y": -8.655,
              "z": 0.938
            },
            "gtin": "4066447376944",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712fb",
            "leftCorner": {
              "x": 4.918,
              "y": -8.655,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.867,
              "y": -8.611,
              "z": 0.938
            },
            "gtin": "4067796137668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712fc",
            "leftCorner": {
              "x": 4.867,
              "y": -8.611,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.813,
              "y": -8.563,
              "z": 0.938
            },
            "gtin": "4067796139006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712fd",
            "leftCorner": {
              "x": 4.813,
              "y": -8.563,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.714,
              "y": -8.476,
              "z": 0.938
            },
            "gtin": "4066447921793",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712fe",
            "leftCorner": {
              "x": 4.714,
              "y": -8.476,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.665,
              "y": -8.434,
              "z": 0.938
            },
            "gtin": "4067796125092",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712ff",
            "leftCorner": {
              "x": 4.665,
              "y": -8.434,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.612,
              "y": -8.387,
              "z": 0.938
            },
            "gtin": "4067796125092",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271300",
            "leftCorner": {
              "x": 4.612,
              "y": -8.387,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.488,
              "y": -8.278,
              "z": 0.938
            },
            "gtin": "4066447646399",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271301",
            "leftCorner": {
              "x": 4.488,
              "y": -8.278,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.425,
              "y": -8.223,
              "z": 0.938
            },
            "gtin": "4045612009993",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271302",
            "leftCorner": {
              "x": 4.434,
              "y": -8.228,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.39,
              "y": -8.189,
              "z": 0.938
            },
            "gtin": "4045612007036",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a89",
        "height": 1.192,
        "facings": [
          {
            "id": "696ebf6f43c343680a27131b",
            "leftCorner": {
              "x": 5.133,
              "y": -8.842,
              "z": 1.19
            },
            "rightCorner": {
              "x": 5.09,
              "y": -8.804,
              "z": 1.19
            },
            "gtin": "017854116535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27131c",
            "leftCorner": {
              "x": 5.088,
              "y": -8.803,
              "z": 1.192
            },
            "rightCorner": {
              "x": 5.064,
              "y": -8.782,
              "z": 1.192
            },
            "gtin": "017854116535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27131d",
            "leftCorner": {
              "x": 5.064,
              "y": -8.782,
              "z": 1.192
            },
            "rightCorner": {
              "x": 5.011,
              "y": -8.736,
              "z": 1.192
            },
            "gtin": "4103040524010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27131e",
            "leftCorner": {
              "x": 5.011,
              "y": -8.736,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.95,
              "y": -8.682,
              "z": 1.192
            },
            "gtin": "4103040051912",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27131f",
            "leftCorner": {
              "x": 4.95,
              "y": -8.682,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.911,
              "y": -8.648,
              "z": 1.192
            },
            "gtin": "4103040052018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271320",
            "leftCorner": {
              "x": 4.911,
              "y": -8.648,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.861,
              "y": -8.604,
              "z": 1.192
            },
            "gtin": "4103040051639",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271321",
            "leftCorner": {
              "x": 4.861,
              "y": -8.604,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.82,
              "y": -8.568,
              "z": 1.192
            },
            "gtin": "4009800005204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271322",
            "leftCorner": {
              "x": 4.82,
              "y": -8.568,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.773,
              "y": -8.527,
              "z": 1.192
            },
            "gtin": "4066447380545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271323",
            "leftCorner": {
              "x": 4.773,
              "y": -8.527,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.705,
              "y": -8.468,
              "z": 1.192
            },
            "gtin": "4066447313611",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271324",
            "leftCorner": {
              "x": 4.705,
              "y": -8.468,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.479,
              "y": -8.27,
              "z": 1.192
            },
            "gtin": "4066447377125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271325",
            "leftCorner": {
              "x": 4.479,
              "y": -8.27,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.374,
              "y": -8.178,
              "z": 1.192
            },
            "gtin": "4066447375985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271326",
            "leftCorner": {
              "x": 4.387,
              "y": -8.18,
              "z": 1.194
            },
            "rightCorner": {
              "x": 4.313,
              "y": -8.115,
              "z": 1.194
            },
            "gtin": "4066447231052",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a8b",
        "height": 1.4467,
        "facings": [
          {
            "id": "696ebf6f43c343680a271264",
            "leftCorner": {
              "x": 5.139,
              "y": -8.841,
              "z": 1.445
            },
            "rightCorner": {
              "x": 5.084,
              "y": -8.792,
              "z": 1.445
            },
            "gtin": "4262401739606",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271265",
            "leftCorner": {
              "x": 5.082,
              "y": -8.792,
              "z": 1.447
            },
            "rightCorner": {
              "x": 4.999,
              "y": -8.719,
              "z": 1.447
            },
            "gtin": "4262401739620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271266",
            "leftCorner": {
              "x": 4.999,
              "y": -8.719,
              "z": 1.447
            },
            "rightCorner": {
              "x": 4.921,
              "y": -8.651,
              "z": 1.447
            },
            "gtin": "4260702185818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271267",
            "leftCorner": {
              "x": 4.921,
              "y": -8.651,
              "z": 1.447
            },
            "rightCorner": {
              "x": 4.799,
              "y": -8.544,
              "z": 1.447
            },
            "gtin": "4260702187003",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271268",
            "leftCorner": {
              "x": 4.799,
              "y": -8.544,
              "z": 1.447
            },
            "rightCorner": {
              "x": 4.716,
              "y": -8.471,
              "z": 1.447
            },
            "gtin": "3600551043203",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271269",
            "leftCorner": {
              "x": 4.716,
              "y": -8.471,
              "z": 1.447
            },
            "rightCorner": {
              "x": 4.494,
              "y": -8.277,
              "z": 1.447
            },
            "gtin": "4021457645022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27126a",
            "leftCorner": {
              "x": 4.494,
              "y": -8.277,
              "z": 1.447
            },
            "rightCorner": {
              "x": 4.454,
              "y": -8.242,
              "z": 1.447
            },
            "gtin": "4021457645145",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27126b",
            "leftCorner": {
              "x": 4.463,
              "y": -8.248,
              "z": 1.45
            },
            "rightCorner": {
              "x": 4.429,
              "y": -8.218,
              "z": 1.45
            },
            "gtin": "4021457645145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27126c",
            "leftCorner": {
              "x": 4.429,
              "y": -8.217,
              "z": 1.45
            },
            "rightCorner": {
              "x": 4.384,
              "y": -8.178,
              "z": 1.45
            },
            "gtin": "4066447467796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27126d",
            "leftCorner": {
              "x": 4.385,
              "y": -8.178,
              "z": 1.45
            },
            "rightCorner": {
              "x": 4.314,
              "y": -8.116,
              "z": 1.45
            },
            "gtin": "4066447467796",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a87",
        "height": 1.6543,
        "facings": [
          {
            "id": "696ebf6f43c343680a271096",
            "leftCorner": {
              "x": 5.128,
              "y": -8.836,
              "z": 1.654
            },
            "rightCorner": {
              "x": 5.082,
              "y": -8.795,
              "z": 1.654
            },
            "gtin": "4066447342901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271097",
            "leftCorner": {
              "x": 5.082,
              "y": -8.795,
              "z": 1.654
            },
            "rightCorner": {
              "x": 4.927,
              "y": -8.659,
              "z": 1.654
            },
            "gtin": "4262414871355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271098",
            "leftCorner": {
              "x": 4.927,
              "y": -8.659,
              "z": 1.654
            },
            "rightCorner": {
              "x": 4.881,
              "y": -8.619,
              "z": 1.654
            },
            "gtin": "4009800001008",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271099",
            "leftCorner": {
              "x": 4.881,
              "y": -8.619,
              "z": 1.654
            },
            "rightCorner": {
              "x": 4.828,
              "y": -8.573,
              "z": 1.654
            },
            "gtin": "4009800004603",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27109a",
            "leftCorner": {
              "x": 4.828,
              "y": -8.573,
              "z": 1.654
            },
            "rightCorner": {
              "x": 4.773,
              "y": -8.525,
              "z": 1.654
            },
            "gtin": "4045612009412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27109b",
            "leftCorner": {
              "x": 4.773,
              "y": -8.525,
              "z": 1.654
            },
            "rightCorner": {
              "x": 4.618,
              "y": -8.389,
              "z": 1.654
            },
            "gtin": "4066447355963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27109c",
            "leftCorner": {
              "x": 4.618,
              "y": -8.389,
              "z": 1.654
            },
            "rightCorner": {
              "x": 4.431,
              "y": -8.226,
              "z": 1.654
            },
            "gtin": "4066447933697",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27109d",
            "leftCorner": {
              "x": 4.431,
              "y": -8.226,
              "z": 1.654
            },
            "rightCorner": {
              "x": 4.354,
              "y": -8.158,
              "z": 1.654
            },
            "gtin": "8714789700045",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7571db5fe7bc046959903",
    "name": "68e7571db5fe7bc046959903",
    "x": 4.3574,
    "y": -8.2126,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93409,
      "w": 0.35703
    },
    "statistics": {
      "hasStockCount": 28,
      "noStockCount": 0,
      "unknownStockCount": 30
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73a94",
        "height": 0.43525,
        "facings": [
          {
            "id": "696ebf6f43c343680a2712df",
            "leftCorner": {
              "x": 4.194,
              "y": -8.017,
              "z": 0.435
            },
            "rightCorner": {
              "x": 4.126,
              "y": -7.955,
              "z": 0.435
            },
            "gtin": "4058172779091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712de",
            "leftCorner": {
              "x": 4.265,
              "y": -8.08,
              "z": 0.435
            },
            "rightCorner": {
              "x": 4.194,
              "y": -8.017,
              "z": 0.435
            },
            "gtin": "4058172779091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712e0",
            "leftCorner": {
              "x": 4.126,
              "y": -7.955,
              "z": 0.435
            },
            "rightCorner": {
              "x": 4.055,
              "y": -7.892,
              "z": 0.435
            },
            "gtin": "4058172779091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712e1",
            "leftCorner": {
              "x": 4.055,
              "y": -7.892,
              "z": 0.435
            },
            "rightCorner": {
              "x": 3.972,
              "y": -7.818,
              "z": 0.435
            }
          },
          {
            "id": "696ebf6f43c343680a2712e2",
            "leftCorner": {
              "x": 3.972,
              "y": -7.818,
              "z": 0.435
            },
            "rightCorner": {
              "x": 3.855,
              "y": -7.713,
              "z": 0.435
            },
            "gtin": "4058172779138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712e3",
            "leftCorner": {
              "x": 3.855,
              "y": -7.713,
              "z": 0.435
            },
            "rightCorner": {
              "x": 3.804,
              "y": -7.667,
              "z": 0.435
            }
          },
          {
            "id": "696ebf6f43c343680a2712e4",
            "leftCorner": {
              "x": 3.804,
              "y": -7.667,
              "z": 0.435
            },
            "rightCorner": {
              "x": 3.785,
              "y": -7.65,
              "z": 0.435
            }
          },
          {
            "id": "696ebf6f43c343680a2712e5",
            "leftCorner": {
              "x": 3.785,
              "y": -7.65,
              "z": 0.435
            },
            "rightCorner": {
              "x": 3.721,
              "y": -7.593,
              "z": 0.435
            },
            "gtin": "4058172779114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712e6",
            "leftCorner": {
              "x": 3.721,
              "y": -7.593,
              "z": 0.435
            },
            "rightCorner": {
              "x": 3.675,
              "y": -7.552,
              "z": 0.435
            }
          },
          {
            "id": "696ebf6f43c343680a2712e7",
            "leftCorner": {
              "x": 3.675,
              "y": -7.552,
              "z": 0.435
            },
            "rightCorner": {
              "x": 3.651,
              "y": -7.53,
              "z": 0.435
            }
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a93",
        "height": 0.17041,
        "facings": [
          {
            "id": "696ebf6f43c343680a27110a",
            "leftCorner": {
              "x": 4.284,
              "y": -8.087,
              "z": 0.17
            },
            "rightCorner": {
              "x": 4.065,
              "y": -7.89,
              "z": 0.17
            },
            "gtin": "4066447383737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27110b",
            "leftCorner": {
              "x": 4.065,
              "y": -7.89,
              "z": 0.17
            },
            "rightCorner": {
              "x": 3.86,
              "y": -7.707,
              "z": 0.17
            },
            "gtin": "4066447890655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27110c",
            "leftCorner": {
              "x": 3.86,
              "y": -7.707,
              "z": 0.17
            },
            "rightCorner": {
              "x": 3.732,
              "y": -7.592,
              "z": 0.17
            },
            "gtin": "4058172778834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27110d",
            "leftCorner": {
              "x": 3.732,
              "y": -7.592,
              "z": 0.17
            },
            "rightCorner": {
              "x": 3.709,
              "y": -7.572,
              "z": 0.17
            }
          },
          {
            "id": "696ebf6f43c343680a27110e",
            "leftCorner": {
              "x": 3.709,
              "y": -7.572,
              "z": 0.17
            },
            "rightCorner": {
              "x": 3.672,
              "y": -7.539,
              "z": 0.17
            }
          },
          {
            "id": "696ebf6f43c343680a27110f",
            "leftCorner": {
              "x": 3.672,
              "y": -7.539,
              "z": 0.17
            },
            "rightCorner": {
              "x": 3.649,
              "y": -7.518,
              "z": 0.17
            }
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a91",
        "height": 0.68716,
        "facings": [
          {
            "id": "696ebf6f43c343680a2712c0",
            "leftCorner": {
              "x": 4.293,
              "y": -8.101,
              "z": 0.687
            },
            "rightCorner": {
              "x": 4.216,
              "y": -8.033,
              "z": 0.687
            },
            "gtin": "4066447863222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712c1",
            "leftCorner": {
              "x": 4.216,
              "y": -8.033,
              "z": 0.687
            },
            "rightCorner": {
              "x": 4.141,
              "y": -7.965,
              "z": 0.687
            }
          },
          {
            "id": "696ebf6f43c343680a2712c2",
            "leftCorner": {
              "x": 4.141,
              "y": -7.965,
              "z": 0.687
            },
            "rightCorner": {
              "x": 4.084,
              "y": -7.914,
              "z": 0.687
            }
          },
          {
            "id": "696ebf6f43c343680a2712c3",
            "leftCorner": {
              "x": 4.084,
              "y": -7.914,
              "z": 0.687
            },
            "rightCorner": {
              "x": 3.994,
              "y": -7.834,
              "z": 0.687
            }
          },
          {
            "id": "696ebf6f43c343680a2712c4",
            "leftCorner": {
              "x": 3.994,
              "y": -7.834,
              "z": 0.687
            },
            "rightCorner": {
              "x": 3.925,
              "y": -7.772,
              "z": 0.687
            },
            "gtin": "4066447863208",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712c5",
            "leftCorner": {
              "x": 3.925,
              "y": -7.772,
              "z": 0.687
            },
            "rightCorner": {
              "x": 3.851,
              "y": -7.706,
              "z": 0.687
            }
          },
          {
            "id": "696ebf6f43c343680a2712c6",
            "leftCorner": {
              "x": 3.851,
              "y": -7.706,
              "z": 0.687
            },
            "rightCorner": {
              "x": 3.781,
              "y": -7.643,
              "z": 0.687
            },
            "gtin": "4066447383652",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2712c7",
            "leftCorner": {
              "x": 3.781,
              "y": -7.643,
              "z": 0.687
            },
            "rightCorner": {
              "x": 3.717,
              "y": -7.586,
              "z": 0.687
            },
            "gtin": "4066447383652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712c8",
            "leftCorner": {
              "x": 3.717,
              "y": -7.586,
              "z": 0.687
            },
            "rightCorner": {
              "x": 3.673,
              "y": -7.546,
              "z": 0.687
            }
          },
          {
            "id": "696ebf6f43c343680a2712c9",
            "leftCorner": {
              "x": 3.673,
              "y": -7.546,
              "z": 0.687
            },
            "rightCorner": {
              "x": 3.651,
              "y": -7.526,
              "z": 0.687
            }
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a90",
        "height": 0.93831,
        "facings": [
          {
            "id": "696ebf6f43c343680a271303",
            "leftCorner": {
              "x": 4.39,
              "y": -8.189,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.353,
              "y": -8.157,
              "z": 0.938
            },
            "gtin": "3574661687018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271304",
            "leftCorner": {
              "x": 4.354,
              "y": -8.156,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.326,
              "y": -8.131,
              "z": 0.938
            },
            "gtin": "3574661687018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271305",
            "leftCorner": {
              "x": 4.326,
              "y": -8.131,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.284,
              "y": -8.094,
              "z": 0.938
            },
            "gtin": "3574661800769",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271306",
            "leftCorner": {
              "x": 4.284,
              "y": -8.094,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.26,
              "y": -8.072,
              "z": 0.938
            },
            "gtin": "3574661685960",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271307",
            "leftCorner": {
              "x": 4.26,
              "y": -8.072,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.236,
              "y": -8.051,
              "z": 0.938
            },
            "gtin": "3574661685960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271308",
            "leftCorner": {
              "x": 4.236,
              "y": -8.051,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.205,
              "y": -8.023,
              "z": 0.938
            },
            "gtin": "3574661687049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271309",
            "leftCorner": {
              "x": 4.205,
              "y": -8.023,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.165,
              "y": -7.987,
              "z": 0.938
            },
            "gtin": "3574661687049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27130a",
            "leftCorner": {
              "x": 4.165,
              "y": -7.987,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.1,
              "y": -7.929,
              "z": 0.938
            },
            "gtin": "42417514",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27130b",
            "leftCorner": {
              "x": 4.1,
              "y": -7.929,
              "z": 0.938
            },
            "rightCorner": {
              "x": 4.003,
              "y": -7.842,
              "z": 0.938
            },
            "gtin": "4262401739668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27130c",
            "leftCorner": {
              "x": 4.003,
              "y": -7.842,
              "z": 0.938
            },
            "rightCorner": {
              "x": 3.889,
              "y": -7.74,
              "z": 0.938
            },
            "gtin": "4000196031846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27130d",
            "leftCorner": {
              "x": 3.889,
              "y": -7.74,
              "z": 0.938
            },
            "rightCorner": {
              "x": 3.815,
              "y": -7.674,
              "z": 0.938
            },
            "gtin": "4000196031136",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27130e",
            "leftCorner": {
              "x": 3.815,
              "y": -7.674,
              "z": 0.938
            },
            "rightCorner": {
              "x": 3.793,
              "y": -7.655,
              "z": 0.938
            },
            "gtin": "4000196031136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27130f",
            "leftCorner": {
              "x": 3.793,
              "y": -7.655,
              "z": 0.938
            },
            "rightCorner": {
              "x": 3.746,
              "y": -7.612,
              "z": 0.938
            },
            "gtin": "4000196031099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271310",
            "leftCorner": {
              "x": 3.746,
              "y": -7.612,
              "z": 0.938
            },
            "rightCorner": {
              "x": 3.727,
              "y": -7.595,
              "z": 0.938
            },
            "gtin": "4000196031099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2712e9",
            "leftCorner": {
              "x": 3.727,
              "y": -7.595,
              "z": 0.938
            },
            "rightCorner": {
              "x": 3.639,
              "y": -7.516,
              "z": 0.938
            },
            "gtin": "4013718021898",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a8e",
        "height": 1.1941,
        "facings": [
          {
            "id": "696ebf6f43c343680a271327",
            "leftCorner": {
              "x": 4.313,
              "y": -8.114,
              "z": 1.194
            },
            "rightCorner": {
              "x": 4.279,
              "y": -8.083,
              "z": 1.194
            },
            "gtin": "4066447492668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271328",
            "leftCorner": {
              "x": 4.279,
              "y": -8.083,
              "z": 1.194
            },
            "rightCorner": {
              "x": 4.243,
              "y": -8.051,
              "z": 1.194
            },
            "gtin": "4067796148763",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271329",
            "leftCorner": {
              "x": 4.243,
              "y": -8.051,
              "z": 1.194
            },
            "rightCorner": {
              "x": 4.182,
              "y": -7.996,
              "z": 1.194
            },
            "gtin": "4066447411140",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27132a",
            "leftCorner": {
              "x": 4.182,
              "y": -7.996,
              "z": 1.194
            },
            "rightCorner": {
              "x": 4.098,
              "y": -7.922,
              "z": 1.194
            },
            "gtin": "4067796189056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27132b",
            "leftCorner": {
              "x": 4.098,
              "y": -7.922,
              "z": 1.194
            },
            "rightCorner": {
              "x": 4.026,
              "y": -7.857,
              "z": 1.194
            },
            "gtin": "4066447348507",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27132c",
            "leftCorner": {
              "x": 4.026,
              "y": -7.857,
              "z": 1.194
            },
            "rightCorner": {
              "x": 3.971,
              "y": -7.808,
              "z": 1.194
            },
            "gtin": "4262469954379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27132d",
            "leftCorner": {
              "x": 3.971,
              "y": -7.808,
              "z": 1.194
            },
            "rightCorner": {
              "x": 3.926,
              "y": -7.767,
              "z": 1.194
            },
            "gtin": "4262469954317",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27132e",
            "leftCorner": {
              "x": 3.926,
              "y": -7.767,
              "z": 1.194
            },
            "rightCorner": {
              "x": 3.881,
              "y": -7.727,
              "z": 1.194
            },
            "gtin": "4260560835955",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27132f",
            "leftCorner": {
              "x": 3.881,
              "y": -7.727,
              "z": 1.194
            },
            "rightCorner": {
              "x": 3.803,
              "y": -7.657,
              "z": 1.194
            },
            "gtin": "4262469951477",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271330",
            "leftCorner": {
              "x": 3.803,
              "y": -7.657,
              "z": 1.194
            },
            "rightCorner": {
              "x": 3.781,
              "y": -7.638,
              "z": 1.194
            }
          },
          {
            "id": "696ebf6f43c343680a271331",
            "leftCorner": {
              "x": 3.781,
              "y": -7.638,
              "z": 1.194
            },
            "rightCorner": {
              "x": 3.71,
              "y": -7.574,
              "z": 1.194
            },
            "gtin": "4262469951521",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271332",
            "leftCorner": {
              "x": 3.71,
              "y": -7.574,
              "z": 1.194
            },
            "rightCorner": {
              "x": 3.689,
              "y": -7.555,
              "z": 1.194
            },
            "gtin": "4260401411676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271312",
            "leftCorner": {
              "x": 3.689,
              "y": -7.555,
              "z": 1.194
            },
            "rightCorner": {
              "x": 3.642,
              "y": -7.513,
              "z": 1.194
            },
            "gtin": "4260401411676",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a92",
        "height": 1.4497,
        "facings": [
          {
            "id": "696ebf6f43c343680a27126e",
            "leftCorner": {
              "x": 4.315,
              "y": -8.115,
              "z": 1.45
            },
            "rightCorner": {
              "x": 4.28,
              "y": -8.084,
              "z": 1.45
            }
          },
          {
            "id": "696ebf6f43c343680a27126f",
            "leftCorner": {
              "x": 4.28,
              "y": -8.084,
              "z": 1.45
            },
            "rightCorner": {
              "x": 4.185,
              "y": -7.999,
              "z": 1.45
            },
            "gtin": "4066447429527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271270",
            "leftCorner": {
              "x": 4.185,
              "y": -7.999,
              "z": 1.45
            },
            "rightCorner": {
              "x": 4.082,
              "y": -7.907,
              "z": 1.45
            },
            "gtin": "4066447241310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271271",
            "leftCorner": {
              "x": 4.082,
              "y": -7.907,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.911,
              "y": -7.754,
              "z": 1.45
            },
            "gtin": "4001638590570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271272",
            "leftCorner": {
              "x": 3.911,
              "y": -7.754,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.826,
              "y": -7.678,
              "z": 1.45
            },
            "gtin": "4001638088459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271273",
            "leftCorner": {
              "x": 3.826,
              "y": -7.678,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.747,
              "y": -7.607,
              "z": 1.45
            },
            "gtin": "4066447078589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271274",
            "leftCorner": {
              "x": 3.747,
              "y": -7.607,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.677,
              "y": -7.544,
              "z": 1.45
            },
            "gtin": "4066447668032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27124b",
            "leftCorner": {
              "x": 3.677,
              "y": -7.544,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.642,
              "y": -7.513,
              "z": 1.45
            },
            "gtin": "4066447439946",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a8f",
        "height": 1.6561,
        "facings": [
          {
            "id": "696ebf6f43c343680a27109e",
            "leftCorner": {
              "x": 4.365,
              "y": -8.162,
              "z": 1.656
            },
            "rightCorner": {
              "x": 4.298,
              "y": -8.102,
              "z": 1.656
            },
            "gtin": "8714789700069",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27109f",
            "leftCorner": {
              "x": 4.298,
              "y": -8.102,
              "z": 1.656
            },
            "rightCorner": {
              "x": 4.256,
              "y": -8.064,
              "z": 1.656
            },
            "gtin": "4005900939616",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710a0",
            "leftCorner": {
              "x": 4.256,
              "y": -8.064,
              "z": 1.656
            },
            "rightCorner": {
              "x": 4.187,
              "y": -8.002,
              "z": 1.656
            },
            "gtin": "8720181717604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710a1",
            "leftCorner": {
              "x": 4.187,
              "y": -8.002,
              "z": 1.656
            },
            "rightCorner": {
              "x": 4.121,
              "y": -7.944,
              "z": 1.656
            },
            "gtin": "8720181481239",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710a2",
            "leftCorner": {
              "x": 4.121,
              "y": -7.944,
              "z": 1.656
            },
            "rightCorner": {
              "x": 4.058,
              "y": -7.887,
              "z": 1.656
            },
            "gtin": "4012400532612",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710a3",
            "leftCorner": {
              "x": 4.058,
              "y": -7.887,
              "z": 1.656
            },
            "rightCorner": {
              "x": 3.963,
              "y": -7.802,
              "z": 1.656
            },
            "gtin": "4012400532872",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710a4",
            "leftCorner": {
              "x": 3.963,
              "y": -7.802,
              "z": 1.656
            },
            "rightCorner": {
              "x": 3.915,
              "y": -7.759,
              "z": 1.656
            },
            "gtin": "4400086010133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710a5",
            "leftCorner": {
              "x": 3.915,
              "y": -7.759,
              "z": 1.656
            },
            "rightCorner": {
              "x": 3.856,
              "y": -7.706,
              "z": 1.656
            },
            "gtin": "5704947015862",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a2710a6",
            "leftCorner": {
              "x": 3.856,
              "y": -7.706,
              "z": 1.656
            },
            "rightCorner": {
              "x": 3.815,
              "y": -7.669,
              "z": 1.656
            },
            "gtin": "5704947015138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710a7",
            "leftCorner": {
              "x": 3.815,
              "y": -7.669,
              "z": 1.656
            },
            "rightCorner": {
              "x": 3.795,
              "y": -7.651,
              "z": 1.656
            },
            "gtin": "5704947015138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710a8",
            "leftCorner": {
              "x": 3.795,
              "y": -7.651,
              "z": 1.656
            },
            "rightCorner": {
              "x": 3.727,
              "y": -7.59,
              "z": 1.656
            },
            "gtin": "4006000057927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a2710a9",
            "leftCorner": {
              "x": 3.727,
              "y": -7.59,
              "z": 1.656
            },
            "rightCorner": {
              "x": 3.658,
              "y": -7.529,
              "z": 1.656
            },
            "gtin": "4006000061221",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc04695992c",
    "name": "68e7572eb5fe7bc04695992c",
    "x": 3.0848,
    "y": -4.6891,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.35339,
      "w": 0.93548
    },
    "statistics": {
      "hasStockCount": 60,
      "noStockCount": 1,
      "unknownStockCount": 36
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73a9c",
        "height": 0.17802,
        "facings": [
          {
            "id": "696ebf7043c343680a2713da",
            "leftCorner": {
              "x": 3.055,
              "y": -4.723,
              "z": 0.178
            },
            "rightCorner": {
              "x": 3.091,
              "y": -4.755,
              "z": 0.178
            },
            "gtin": "4067796161410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713dc",
            "leftCorner": {
              "x": 3.091,
              "y": -4.755,
              "z": 0.178
            },
            "rightCorner": {
              "x": 3.124,
              "y": -4.783,
              "z": 0.178
            },
            "gtin": "4067796161410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713dd",
            "leftCorner": {
              "x": 3.124,
              "y": -4.783,
              "z": 0.178
            },
            "rightCorner": {
              "x": 3.173,
              "y": -4.827,
              "z": 0.178
            },
            "gtin": "4067796161410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713de",
            "leftCorner": {
              "x": 3.173,
              "y": -4.827,
              "z": 0.178
            },
            "rightCorner": {
              "x": 3.202,
              "y": -4.852,
              "z": 0.178
            }
          },
          {
            "id": "696ebf7043c343680a2713df",
            "leftCorner": {
              "x": 3.202,
              "y": -4.852,
              "z": 0.178
            },
            "rightCorner": {
              "x": 3.247,
              "y": -4.892,
              "z": 0.178
            }
          },
          {
            "id": "696ebf7043c343680a2713e0",
            "leftCorner": {
              "x": 3.247,
              "y": -4.892,
              "z": 0.178
            },
            "rightCorner": {
              "x": 3.289,
              "y": -4.929,
              "z": 0.178
            }
          },
          {
            "id": "696ebf7043c343680a2713e1",
            "leftCorner": {
              "x": 3.289,
              "y": -4.929,
              "z": 0.178
            },
            "rightCorner": {
              "x": 3.328,
              "y": -4.964,
              "z": 0.178
            },
            "gtin": "4067796161434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713e2",
            "leftCorner": {
              "x": 3.328,
              "y": -4.964,
              "z": 0.178
            },
            "rightCorner": {
              "x": 3.371,
              "y": -5.002,
              "z": 0.178
            },
            "gtin": "4067796161434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713e3",
            "leftCorner": {
              "x": 3.371,
              "y": -5.002,
              "z": 0.178
            },
            "rightCorner": {
              "x": 3.44,
              "y": -5.063,
              "z": 0.178
            }
          },
          {
            "id": "696ebf7043c343680a2713e4",
            "leftCorner": {
              "x": 3.44,
              "y": -5.063,
              "z": 0.178
            },
            "rightCorner": {
              "x": 3.503,
              "y": -5.118,
              "z": 0.178
            },
            "gtin": "4066447366044",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713e5",
            "leftCorner": {
              "x": 3.503,
              "y": -5.118,
              "z": 0.178
            },
            "rightCorner": {
              "x": 3.572,
              "y": -5.178,
              "z": 0.178
            },
            "gtin": "4066447366020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713e6",
            "leftCorner": {
              "x": 3.572,
              "y": -5.178,
              "z": 0.178
            },
            "rightCorner": {
              "x": 3.63,
              "y": -5.229,
              "z": 0.178
            },
            "gtin": "4066447366020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713e7",
            "leftCorner": {
              "x": 3.63,
              "y": -5.229,
              "z": 0.178
            },
            "rightCorner": {
              "x": 3.692,
              "y": -5.284,
              "z": 0.178
            },
            "gtin": "4066447366129",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713e8",
            "leftCorner": {
              "x": 3.692,
              "y": -5.284,
              "z": 0.178
            },
            "rightCorner": {
              "x": 3.766,
              "y": -5.349,
              "z": 0.178
            },
            "gtin": "4066447366105",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a99",
        "height": 0.43985,
        "facings": [
          {
            "id": "696ebf7043c343680a27138f",
            "leftCorner": {
              "x": 3.078,
              "y": -4.745,
              "z": 0.44
            },
            "rightCorner": {
              "x": 3.156,
              "y": -4.814,
              "z": 0.44
            },
            "gtin": "4013162025534",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271390",
            "leftCorner": {
              "x": 3.156,
              "y": -4.814,
              "z": 0.44
            },
            "rightCorner": {
              "x": 3.215,
              "y": -4.866,
              "z": 0.44
            },
            "gtin": "4008268002817",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271391",
            "leftCorner": {
              "x": 3.215,
              "y": -4.866,
              "z": 0.44
            },
            "rightCorner": {
              "x": 3.281,
              "y": -4.924,
              "z": 0.44
            },
            "gtin": "4008268002817",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271392",
            "leftCorner": {
              "x": 3.281,
              "y": -4.924,
              "z": 0.44
            },
            "rightCorner": {
              "x": 3.342,
              "y": -4.978,
              "z": 0.44
            },
            "gtin": "8720181085666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271393",
            "leftCorner": {
              "x": 3.342,
              "y": -4.978,
              "z": 0.44
            },
            "rightCorner": {
              "x": 3.401,
              "y": -5.03,
              "z": 0.44
            },
            "gtin": "8720181085666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271394",
            "leftCorner": {
              "x": 3.401,
              "y": -5.03,
              "z": 0.44
            },
            "rightCorner": {
              "x": 3.458,
              "y": -5.08,
              "z": 0.44
            },
            "gtin": "8720181085710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271395",
            "leftCorner": {
              "x": 3.458,
              "y": -5.08,
              "z": 0.44
            },
            "rightCorner": {
              "x": 3.526,
              "y": -5.14,
              "z": 0.44
            },
            "gtin": "8720181085659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271396",
            "leftCorner": {
              "x": 3.526,
              "y": -5.14,
              "z": 0.44
            },
            "rightCorner": {
              "x": 3.58,
              "y": -5.188,
              "z": 0.44
            },
            "gtin": "8720181085659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271397",
            "leftCorner": {
              "x": 3.58,
              "y": -5.188,
              "z": 0.44
            },
            "rightCorner": {
              "x": 3.63,
              "y": -5.232,
              "z": 0.44
            },
            "gtin": "8720181085642",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271398",
            "leftCorner": {
              "x": 3.63,
              "y": -5.232,
              "z": 0.44
            },
            "rightCorner": {
              "x": 3.694,
              "y": -5.288,
              "z": 0.44
            },
            "gtin": "8720181085642",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271399",
            "leftCorner": {
              "x": 3.694,
              "y": -5.288,
              "z": 0.44
            },
            "rightCorner": {
              "x": 3.737,
              "y": -5.326,
              "z": 0.44
            },
            "gtin": "8717163693162",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27139a",
            "leftCorner": {
              "x": 3.737,
              "y": -5.326,
              "z": 0.44
            },
            "rightCorner": {
              "x": 3.786,
              "y": -5.369,
              "z": 0.44
            },
            "gtin": "8717163693162",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27139b",
            "leftCorner": {
              "x": 3.786,
              "y": -5.369,
              "z": 0.44
            },
            "rightCorner": {
              "x": 3.837,
              "y": -5.414,
              "z": 0.44
            },
            "gtin": "8720181260537",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a98",
        "height": 0.7298,
        "facings": [
          {
            "id": "696ebf7043c343680a271373",
            "leftCorner": {
              "x": 3.055,
              "y": -4.723,
              "z": 0.73
            },
            "rightCorner": {
              "x": 3.117,
              "y": -4.777,
              "z": 0.73
            },
            "gtin": "4066447109511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271375",
            "leftCorner": {
              "x": 3.117,
              "y": -4.777,
              "z": 0.73
            },
            "rightCorner": {
              "x": 3.164,
              "y": -4.819,
              "z": 0.73
            },
            "gtin": "4066447109559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271376",
            "leftCorner": {
              "x": 3.164,
              "y": -4.819,
              "z": 0.73
            },
            "rightCorner": {
              "x": 3.2,
              "y": -4.851,
              "z": 0.73
            },
            "gtin": "4066447875256",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271377",
            "leftCorner": {
              "x": 3.2,
              "y": -4.851,
              "z": 0.73
            },
            "rightCorner": {
              "x": 3.264,
              "y": -4.907,
              "z": 0.73
            },
            "gtin": "4066447108774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271378",
            "leftCorner": {
              "x": 3.264,
              "y": -4.907,
              "z": 0.73
            },
            "rightCorner": {
              "x": 3.323,
              "y": -4.959,
              "z": 0.73
            },
            "gtin": "4066447108774",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271379",
            "leftCorner": {
              "x": 3.323,
              "y": -4.959,
              "z": 0.73
            },
            "rightCorner": {
              "x": 3.389,
              "y": -5.017,
              "z": 0.73
            },
            "gtin": "4066447591880",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27137a",
            "leftCorner": {
              "x": 3.389,
              "y": -5.017,
              "z": 0.73
            },
            "rightCorner": {
              "x": 3.445,
              "y": -5.067,
              "z": 0.73
            },
            "gtin": "4067796165180",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27137b",
            "leftCorner": {
              "x": 3.445,
              "y": -5.067,
              "z": 0.73
            },
            "rightCorner": {
              "x": 3.486,
              "y": -5.102,
              "z": 0.73
            },
            "gtin": "4066447366181",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27137c",
            "leftCorner": {
              "x": 3.486,
              "y": -5.102,
              "z": 0.73
            },
            "rightCorner": {
              "x": 3.524,
              "y": -5.136,
              "z": 0.73
            },
            "gtin": "4066447876109",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27137d",
            "leftCorner": {
              "x": 3.524,
              "y": -5.136,
              "z": 0.73
            },
            "rightCorner": {
              "x": 3.561,
              "y": -5.168,
              "z": 0.73
            },
            "gtin": "4066447467598",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27137e",
            "leftCorner": {
              "x": 3.561,
              "y": -5.168,
              "z": 0.73
            },
            "rightCorner": {
              "x": 3.6,
              "y": -5.203,
              "z": 0.73
            },
            "gtin": "4066447467598",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27137f",
            "leftCorner": {
              "x": 3.6,
              "y": -5.203,
              "z": 0.73
            },
            "rightCorner": {
              "x": 3.647,
              "y": -5.244,
              "z": 0.73
            },
            "gtin": "4066447876123",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271380",
            "leftCorner": {
              "x": 3.647,
              "y": -5.244,
              "z": 0.73
            },
            "rightCorner": {
              "x": 3.726,
              "y": -5.315,
              "z": 0.73
            },
            "gtin": "4000196001146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271381",
            "leftCorner": {
              "x": 3.726,
              "y": -5.315,
              "z": 0.73
            },
            "rightCorner": {
              "x": 3.81,
              "y": -5.389,
              "z": 0.73
            },
            "gtin": "4066447109535",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a97",
        "height": 0.98338,
        "facings": [
          {
            "id": "696ebf6f43c343680a271356",
            "leftCorner": {
              "x": 3.052,
              "y": -4.726,
              "z": 0.983
            },
            "rightCorner": {
              "x": 3.107,
              "y": -4.774,
              "z": 0.983
            },
            "gtin": "4066447366143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271358",
            "leftCorner": {
              "x": 3.107,
              "y": -4.774,
              "z": 0.983
            },
            "rightCorner": {
              "x": 3.147,
              "y": -4.809,
              "z": 0.983
            },
            "gtin": "4067796165920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271359",
            "leftCorner": {
              "x": 3.147,
              "y": -4.809,
              "z": 0.983
            },
            "rightCorner": {
              "x": 3.188,
              "y": -4.846,
              "z": 0.983
            },
            "gtin": "4066447671964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27135a",
            "leftCorner": {
              "x": 3.188,
              "y": -4.846,
              "z": 0.983
            },
            "rightCorner": {
              "x": 3.225,
              "y": -4.878,
              "z": 0.983
            },
            "gtin": "4066447670578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27135b",
            "leftCorner": {
              "x": 3.225,
              "y": -4.878,
              "z": 0.983
            },
            "rightCorner": {
              "x": 3.292,
              "y": -4.937,
              "z": 0.983
            },
            "gtin": "4066447876161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27135c",
            "leftCorner": {
              "x": 3.292,
              "y": -4.937,
              "z": 0.983
            },
            "rightCorner": {
              "x": 3.36,
              "y": -4.997,
              "z": 0.983
            },
            "gtin": "4066447878189",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27135d",
            "leftCorner": {
              "x": 3.36,
              "y": -4.997,
              "z": 0.983
            },
            "rightCorner": {
              "x": 3.416,
              "y": -5.047,
              "z": 0.983
            },
            "gtin": "4066447878165",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27135e",
            "leftCorner": {
              "x": 3.416,
              "y": -5.047,
              "z": 0.983
            },
            "rightCorner": {
              "x": 3.461,
              "y": -5.086,
              "z": 0.983
            },
            "gtin": "4067796162967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27135f",
            "leftCorner": {
              "x": 3.461,
              "y": -5.086,
              "z": 0.983
            },
            "rightCorner": {
              "x": 3.507,
              "y": -5.127,
              "z": 0.983
            },
            "gtin": "4067796195736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271360",
            "leftCorner": {
              "x": 3.507,
              "y": -5.127,
              "z": 0.983
            },
            "rightCorner": {
              "x": 3.549,
              "y": -5.164,
              "z": 0.983
            },
            "gtin": "4066447670714",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271361",
            "leftCorner": {
              "x": 3.549,
              "y": -5.164,
              "z": 0.983
            },
            "rightCorner": {
              "x": 3.586,
              "y": -5.197,
              "z": 0.983
            },
            "gtin": "4262401735196",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271362",
            "leftCorner": {
              "x": 3.586,
              "y": -5.197,
              "z": 0.983
            },
            "rightCorner": {
              "x": 3.624,
              "y": -5.23,
              "z": 0.983
            },
            "gtin": "4260702189113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271363",
            "leftCorner": {
              "x": 3.624,
              "y": -5.23,
              "z": 0.983
            },
            "rightCorner": {
              "x": 3.667,
              "y": -5.267,
              "z": 0.983
            },
            "gtin": "8008970060903",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271364",
            "leftCorner": {
              "x": 3.667,
              "y": -5.267,
              "z": 0.983
            },
            "rightCorner": {
              "x": 3.704,
              "y": -5.3,
              "z": 0.983
            },
            "gtin": "8008970060002",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271365",
            "leftCorner": {
              "x": 3.704,
              "y": -5.3,
              "z": 0.983
            },
            "rightCorner": {
              "x": 3.742,
              "y": -5.334,
              "z": 0.983
            },
            "gtin": "8008970059990",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271366",
            "leftCorner": {
              "x": 3.742,
              "y": -5.334,
              "z": 0.983
            },
            "rightCorner": {
              "x": 3.785,
              "y": -5.372,
              "z": 0.983
            },
            "gtin": "4006000158389",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271367",
            "leftCorner": {
              "x": 3.785,
              "y": -5.372,
              "z": 0.983
            },
            "rightCorner": {
              "x": 3.832,
              "y": -5.413,
              "z": 0.983
            },
            "gtin": "4006000016375",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a9b",
        "height": 1.2359,
        "facings": [
          {
            "id": "696ebf7043c343680a2713c2",
            "leftCorner": {
              "x": 3.077,
              "y": -4.747,
              "z": 1.236
            },
            "rightCorner": {
              "x": 3.107,
              "y": -4.773,
              "z": 1.236
            },
            "gtin": "4067796161298",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713c3",
            "leftCorner": {
              "x": 3.107,
              "y": -4.773,
              "z": 1.236
            },
            "rightCorner": {
              "x": 3.164,
              "y": -4.823,
              "z": 1.236
            },
            "gtin": "4067796161250",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713c4",
            "leftCorner": {
              "x": 3.164,
              "y": -4.823,
              "z": 1.236
            },
            "rightCorner": {
              "x": 3.248,
              "y": -4.897,
              "z": 1.236
            },
            "gtin": "4015953747809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713c5",
            "leftCorner": {
              "x": 3.248,
              "y": -4.897,
              "z": 1.236
            },
            "rightCorner": {
              "x": 3.309,
              "y": -4.951,
              "z": 1.236
            },
            "gtin": "4066447276800",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713c6",
            "leftCorner": {
              "x": 3.309,
              "y": -4.951,
              "z": 1.236
            },
            "rightCorner": {
              "x": 3.361,
              "y": -4.997,
              "z": 1.236
            },
            "gtin": "4069826000348",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713c7",
            "leftCorner": {
              "x": 3.361,
              "y": -4.997,
              "z": 1.236
            },
            "rightCorner": {
              "x": 3.425,
              "y": -5.053,
              "z": 1.236
            },
            "gtin": "4069826000300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713c8",
            "leftCorner": {
              "x": 3.425,
              "y": -5.053,
              "z": 1.236
            },
            "rightCorner": {
              "x": 3.487,
              "y": -5.108,
              "z": 1.236
            },
            "gtin": "4069826000201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713c9",
            "leftCorner": {
              "x": 3.487,
              "y": -5.108,
              "z": 1.236
            },
            "rightCorner": {
              "x": 3.544,
              "y": -5.158,
              "z": 1.236
            },
            "gtin": "4069826000225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713ca",
            "leftCorner": {
              "x": 3.544,
              "y": -5.158,
              "z": 1.236
            },
            "rightCorner": {
              "x": 3.592,
              "y": -5.201,
              "z": 1.236
            }
          },
          {
            "id": "696ebf7043c343680a2713cb",
            "leftCorner": {
              "x": 3.592,
              "y": -5.201,
              "z": 1.236
            },
            "rightCorner": {
              "x": 3.63,
              "y": -5.234,
              "z": 1.236
            },
            "gtin": "4008233174570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713cc",
            "leftCorner": {
              "x": 3.63,
              "y": -5.234,
              "z": 1.236
            },
            "rightCorner": {
              "x": 3.669,
              "y": -5.268,
              "z": 1.236
            },
            "gtin": "4008233180441",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713cd",
            "leftCorner": {
              "x": 3.669,
              "y": -5.268,
              "z": 1.236
            },
            "rightCorner": {
              "x": 3.714,
              "y": -5.308,
              "z": 1.236
            },
            "gtin": "4008233176611",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713ce",
            "leftCorner": {
              "x": 3.714,
              "y": -5.308,
              "z": 1.236
            },
            "rightCorner": {
              "x": 3.765,
              "y": -5.353,
              "z": 1.236
            },
            "gtin": "4008233181707",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713cf",
            "leftCorner": {
              "x": 3.765,
              "y": -5.353,
              "z": 1.236
            },
            "rightCorner": {
              "x": 3.809,
              "y": -5.391,
              "z": 1.236
            },
            "gtin": "4008233180199",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713d0",
            "leftCorner": {
              "x": 3.825,
              "y": -5.4,
              "z": 1.234
            },
            "rightCorner": {
              "x": 3.848,
              "y": -5.42,
              "z": 1.234
            },
            "gtin": "6001159111375",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a9a",
        "height": 1.4498,
        "facings": [
          {
            "id": "696ebf7043c343680a2713a7",
            "leftCorner": {
              "x": 3.047,
              "y": -4.732,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.1,
              "y": -4.778,
              "z": 1.45
            },
            "gtin": "4066447354645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713a9",
            "leftCorner": {
              "x": 3.1,
              "y": -4.778,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.157,
              "y": -4.828,
              "z": 1.45
            },
            "gtin": "4066447396553",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713aa",
            "leftCorner": {
              "x": 3.157,
              "y": -4.828,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.202,
              "y": -4.868,
              "z": 1.45
            },
            "gtin": "4067796225716",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713ab",
            "leftCorner": {
              "x": 3.202,
              "y": -4.868,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.246,
              "y": -4.907,
              "z": 1.45
            },
            "gtin": "4066447876680",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713ac",
            "leftCorner": {
              "x": 3.246,
              "y": -4.907,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.291,
              "y": -4.946,
              "z": 1.45
            },
            "gtin": "4067796167535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713ad",
            "leftCorner": {
              "x": 3.291,
              "y": -4.946,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.331,
              "y": -4.982,
              "z": 1.45
            },
            "gtin": "4066447876703",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713ae",
            "leftCorner": {
              "x": 3.331,
              "y": -4.982,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.376,
              "y": -5.021,
              "z": 1.45
            },
            "gtin": "4066447238020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713af",
            "leftCorner": {
              "x": 3.376,
              "y": -5.021,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.416,
              "y": -5.056,
              "z": 1.45
            },
            "gtin": "4066447238020",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713b0",
            "leftCorner": {
              "x": 3.416,
              "y": -5.056,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.461,
              "y": -5.097,
              "z": 1.45
            },
            "gtin": "4066447354331",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713b1",
            "leftCorner": {
              "x": 3.461,
              "y": -5.097,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.513,
              "y": -5.142,
              "z": 1.45
            },
            "gtin": "4066447523928",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713b2",
            "leftCorner": {
              "x": 3.513,
              "y": -5.142,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.556,
              "y": -5.18,
              "z": 1.45
            },
            "gtin": "4066447354317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713b3",
            "leftCorner": {
              "x": 3.556,
              "y": -5.18,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.603,
              "y": -5.221,
              "z": 1.45
            },
            "gtin": "4001638500814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713b4",
            "leftCorner": {
              "x": 3.603,
              "y": -5.221,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.647,
              "y": -5.26,
              "z": 1.45
            },
            "gtin": "4001638500807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713b5",
            "leftCorner": {
              "x": 3.647,
              "y": -5.26,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.696,
              "y": -5.304,
              "z": 1.45
            },
            "gtin": "4001638500852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713b6",
            "leftCorner": {
              "x": 3.696,
              "y": -5.304,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.749,
              "y": -5.35,
              "z": 1.45
            },
            "gtin": "3574661751627",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713b7",
            "leftCorner": {
              "x": 3.749,
              "y": -5.35,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.795,
              "y": -5.391,
              "z": 1.45
            },
            "gtin": "3574661751603",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a96",
        "height": 1.6994,
        "facings": [
          {
            "id": "696ebf6f43c343680a271333",
            "leftCorner": {
              "x": 3.064,
              "y": -4.753,
              "z": 1.699
            },
            "rightCorner": {
              "x": 3.112,
              "y": -4.795,
              "z": 1.699
            },
            "gtin": "4066447354232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271334",
            "leftCorner": {
              "x": 3.112,
              "y": -4.795,
              "z": 1.699
            },
            "rightCorner": {
              "x": 3.206,
              "y": -4.878,
              "z": 1.699
            },
            "gtin": "4066447876666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271335",
            "leftCorner": {
              "x": 3.206,
              "y": -4.878,
              "z": 1.699
            },
            "rightCorner": {
              "x": 3.27,
              "y": -4.934,
              "z": 1.699
            },
            "gtin": "4067796227796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271336",
            "leftCorner": {
              "x": 3.27,
              "y": -4.934,
              "z": 1.699
            },
            "rightCorner": {
              "x": 3.332,
              "y": -4.989,
              "z": 1.699
            },
            "gtin": "4001638526708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271337",
            "leftCorner": {
              "x": 3.332,
              "y": -4.989,
              "z": 1.699
            },
            "rightCorner": {
              "x": 3.378,
              "y": -5.03,
              "z": 1.699
            },
            "gtin": "4001638590464",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271338",
            "leftCorner": {
              "x": 3.378,
              "y": -5.03,
              "z": 1.699
            },
            "rightCorner": {
              "x": 3.418,
              "y": -5.065,
              "z": 1.699
            },
            "gtin": "4001638590488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271339",
            "leftCorner": {
              "x": 3.418,
              "y": -5.065,
              "z": 1.699
            },
            "rightCorner": {
              "x": 3.473,
              "y": -5.114,
              "z": 1.699
            },
            "gtin": "4001638590501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27133a",
            "leftCorner": {
              "x": 3.473,
              "y": -5.114,
              "z": 1.699
            },
            "rightCorner": {
              "x": 3.538,
              "y": -5.171,
              "z": 1.699
            },
            "gtin": "4021457637416",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27133b",
            "leftCorner": {
              "x": 3.538,
              "y": -5.171,
              "z": 1.699
            },
            "rightCorner": {
              "x": 3.583,
              "y": -5.21,
              "z": 1.699
            },
            "gtin": "4021457637485",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27133c",
            "leftCorner": {
              "x": 3.583,
              "y": -5.21,
              "z": 1.699
            },
            "rightCorner": {
              "x": 3.622,
              "y": -5.245,
              "z": 1.699
            },
            "gtin": "4021457663705",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27133d",
            "leftCorner": {
              "x": 3.622,
              "y": -5.245,
              "z": 1.699
            },
            "rightCorner": {
              "x": 3.668,
              "y": -5.285,
              "z": 1.699
            },
            "gtin": "3600551164526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27133e",
            "leftCorner": {
              "x": 3.668,
              "y": -5.285,
              "z": 1.699
            },
            "rightCorner": {
              "x": 3.727,
              "y": -5.337,
              "z": 1.699
            },
            "gtin": "3600551033204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27133f",
            "leftCorner": {
              "x": 3.727,
              "y": -5.337,
              "z": 1.699
            },
            "rightCorner": {
              "x": 3.794,
              "y": -5.397,
              "z": 1.699
            },
            "gtin": "3600551033129",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc04695992d",
    "name": "68e7572eb5fe7bc04695992d",
    "x": 3.8448,
    "y": -5.3514,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.34094,
      "w": 0.94008
    },
    "statistics": {
      "hasStockCount": 48,
      "noStockCount": 0,
      "unknownStockCount": 27
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73aa3",
        "height": 0.1755,
        "facings": [
          {
            "id": "696ebf7043c343680a2713e9",
            "leftCorner": {
              "x": 3.766,
              "y": -5.349,
              "z": 0.178
            },
            "rightCorner": {
              "x": 3.845,
              "y": -5.42,
              "z": 0.178
            },
            "gtin": "4066447875270",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713ea",
            "leftCorner": {
              "x": 3.856,
              "y": -5.421,
              "z": 0.175
            },
            "rightCorner": {
              "x": 3.912,
              "y": -5.468,
              "z": 0.175
            },
            "gtin": "4066447875270",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713eb",
            "leftCorner": {
              "x": 3.912,
              "y": -5.468,
              "z": 0.175
            },
            "rightCorner": {
              "x": 3.933,
              "y": -5.485,
              "z": 0.175
            }
          },
          {
            "id": "696ebf7043c343680a2713ec",
            "leftCorner": {
              "x": 3.933,
              "y": -5.485,
              "z": 0.175
            },
            "rightCorner": {
              "x": 3.975,
              "y": -5.52,
              "z": 0.175
            }
          },
          {
            "id": "696ebf7043c343680a2713ed",
            "leftCorner": {
              "x": 3.975,
              "y": -5.52,
              "z": 0.175
            },
            "rightCorner": {
              "x": 4.041,
              "y": -5.575,
              "z": 0.175
            },
            "gtin": "4066447378214",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713ee",
            "leftCorner": {
              "x": 4.041,
              "y": -5.575,
              "z": 0.175
            },
            "rightCorner": {
              "x": 4.116,
              "y": -5.637,
              "z": 0.175
            },
            "gtin": "4066447366068",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713ef",
            "leftCorner": {
              "x": 4.116,
              "y": -5.637,
              "z": 0.175
            },
            "rightCorner": {
              "x": 4.187,
              "y": -5.697,
              "z": 0.175
            },
            "gtin": "4066447366082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713f0",
            "leftCorner": {
              "x": 4.187,
              "y": -5.697,
              "z": 0.175
            },
            "rightCorner": {
              "x": 4.26,
              "y": -5.758,
              "z": 0.175
            },
            "gtin": "4066447756883",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713f1",
            "leftCorner": {
              "x": 4.26,
              "y": -5.758,
              "z": 0.175
            },
            "rightCorner": {
              "x": 4.353,
              "y": -5.836,
              "z": 0.175
            },
            "gtin": "4066447109412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713f2",
            "leftCorner": {
              "x": 4.353,
              "y": -5.836,
              "z": 0.175
            },
            "rightCorner": {
              "x": 4.447,
              "y": -5.914,
              "z": 0.175
            },
            "gtin": "4066447109412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713f3",
            "leftCorner": {
              "x": 4.447,
              "y": -5.914,
              "z": 0.175
            },
            "rightCorner": {
              "x": 4.56,
              "y": -6.009,
              "z": 0.175
            },
            "gtin": "4066447109399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713f4",
            "leftCorner": {
              "x": 4.56,
              "y": -6.009,
              "z": 0.175
            },
            "rightCorner": {
              "x": 4.583,
              "y": -6.028,
              "z": 0.175
            },
            "gtin": "4260560839731",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a9d",
        "height": 0.43545,
        "facings": [
          {
            "id": "696ebf7043c343680a27139c",
            "leftCorner": {
              "x": 3.847,
              "y": -5.416,
              "z": 0.435
            },
            "rightCorner": {
              "x": 3.894,
              "y": -5.455,
              "z": 0.435
            }
          },
          {
            "id": "696ebf7043c343680a27139d",
            "leftCorner": {
              "x": 3.894,
              "y": -5.455,
              "z": 0.435
            },
            "rightCorner": {
              "x": 3.918,
              "y": -5.475,
              "z": 0.435
            },
            "gtin": "4045612009627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27139e",
            "leftCorner": {
              "x": 3.918,
              "y": -5.475,
              "z": 0.435
            },
            "rightCorner": {
              "x": 3.961,
              "y": -5.511,
              "z": 0.435
            },
            "gtin": "4045612009627",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27139f",
            "leftCorner": {
              "x": 3.961,
              "y": -5.511,
              "z": 0.435
            },
            "rightCorner": {
              "x": 4.027,
              "y": -5.566,
              "z": 0.435
            },
            "gtin": "3600541544024",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713a0",
            "leftCorner": {
              "x": 4.027,
              "y": -5.566,
              "z": 0.435
            },
            "rightCorner": {
              "x": 4.108,
              "y": -5.634,
              "z": 0.435
            },
            "gtin": "3600540299178",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713a1",
            "leftCorner": {
              "x": 4.108,
              "y": -5.634,
              "z": 0.435
            },
            "rightCorner": {
              "x": 4.18,
              "y": -5.693,
              "z": 0.435
            },
            "gtin": "3600541334496",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713a2",
            "leftCorner": {
              "x": 4.18,
              "y": -5.693,
              "z": 0.435
            },
            "rightCorner": {
              "x": 4.261,
              "y": -5.761,
              "z": 0.435
            },
            "gtin": "3600541334496",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713a3",
            "leftCorner": {
              "x": 4.261,
              "y": -5.761,
              "z": 0.435
            },
            "rightCorner": {
              "x": 4.334,
              "y": -5.822,
              "z": 0.435
            },
            "gtin": "3600541334458",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713a4",
            "leftCorner": {
              "x": 4.334,
              "y": -5.822,
              "z": 0.435
            },
            "rightCorner": {
              "x": 4.403,
              "y": -5.88,
              "z": 0.435
            },
            "gtin": "4066447874471",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713a5",
            "leftCorner": {
              "x": 4.403,
              "y": -5.88,
              "z": 0.435
            },
            "rightCorner": {
              "x": 4.476,
              "y": -5.941,
              "z": 0.435
            },
            "gtin": "4066447875553",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713a6",
            "leftCorner": {
              "x": 4.476,
              "y": -5.941,
              "z": 0.435
            },
            "rightCorner": {
              "x": 4.526,
              "y": -5.983,
              "z": 0.435
            },
            "gtin": "4006000043487",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27138e",
            "leftCorner": {
              "x": 4.526,
              "y": -5.983,
              "z": 0.435
            },
            "rightCorner": {
              "x": 4.582,
              "y": -6.029,
              "z": 0.435
            },
            "gtin": "4006000043487",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a9e",
        "height": 0.72685,
        "facings": [
          {
            "id": "696ebf7043c343680a271382",
            "leftCorner": {
              "x": 3.81,
              "y": -5.389,
              "z": 0.73
            },
            "rightCorner": {
              "x": 3.857,
              "y": -5.43,
              "z": 0.73
            },
            "gtin": "4066447109474",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271383",
            "leftCorner": {
              "x": 3.867,
              "y": -5.433,
              "z": 0.727
            },
            "rightCorner": {
              "x": 3.891,
              "y": -5.453,
              "z": 0.727
            }
          },
          {
            "id": "696ebf7043c343680a271384",
            "leftCorner": {
              "x": 3.891,
              "y": -5.453,
              "z": 0.727
            },
            "rightCorner": {
              "x": 3.932,
              "y": -5.487,
              "z": 0.727
            },
            "gtin": "4005900964526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271385",
            "leftCorner": {
              "x": 3.932,
              "y": -5.487,
              "z": 0.727
            },
            "rightCorner": {
              "x": 3.953,
              "y": -5.505,
              "z": 0.727
            },
            "gtin": "4005900964526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271386",
            "leftCorner": {
              "x": 3.953,
              "y": -5.505,
              "z": 0.727
            },
            "rightCorner": {
              "x": 3.986,
              "y": -5.533,
              "z": 0.727
            },
            "gtin": "4005900980687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271387",
            "leftCorner": {
              "x": 3.986,
              "y": -5.533,
              "z": 0.727
            },
            "rightCorner": {
              "x": 4.057,
              "y": -5.592,
              "z": 0.727
            },
            "gtin": "4005900980687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271388",
            "leftCorner": {
              "x": 4.057,
              "y": -5.592,
              "z": 0.727
            },
            "rightCorner": {
              "x": 4.132,
              "y": -5.654,
              "z": 0.727
            },
            "gtin": "4005900964441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271389",
            "leftCorner": {
              "x": 4.132,
              "y": -5.654,
              "z": 0.727
            },
            "rightCorner": {
              "x": 4.211,
              "y": -5.721,
              "z": 0.727
            }
          },
          {
            "id": "696ebf7043c343680a27138a",
            "leftCorner": {
              "x": 4.211,
              "y": -5.721,
              "z": 0.727
            },
            "rightCorner": {
              "x": 4.3,
              "y": -5.795,
              "z": 0.727
            },
            "gtin": "4005900964403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27138b",
            "leftCorner": {
              "x": 4.3,
              "y": -5.795,
              "z": 0.727
            },
            "rightCorner": {
              "x": 4.377,
              "y": -5.86,
              "z": 0.727
            },
            "gtin": "42449829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27138c",
            "leftCorner": {
              "x": 4.377,
              "y": -5.86,
              "z": 0.727
            },
            "rightCorner": {
              "x": 4.455,
              "y": -5.924,
              "z": 0.727
            },
            "gtin": "42449836",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27138d",
            "leftCorner": {
              "x": 4.455,
              "y": -5.924,
              "z": 0.727
            },
            "rightCorner": {
              "x": 4.535,
              "y": -5.991,
              "z": 0.727
            },
            "gtin": "4006000122571",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271374",
            "leftCorner": {
              "x": 4.535,
              "y": -5.991,
              "z": 0.727
            },
            "rightCorner": {
              "x": 4.581,
              "y": -6.03,
              "z": 0.727
            },
            "gtin": "4006000149868",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aa0",
        "height": 0.97974,
        "facings": [
          {
            "id": "696ebf6f43c343680a271368",
            "leftCorner": {
              "x": 3.845,
              "y": -5.412,
              "z": 0.98
            },
            "rightCorner": {
              "x": 3.903,
              "y": -5.46,
              "z": 0.98
            },
            "gtin": "4006000194158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271369",
            "leftCorner": {
              "x": 3.903,
              "y": -5.46,
              "z": 0.98
            },
            "rightCorner": {
              "x": 3.936,
              "y": -5.489,
              "z": 0.98
            },
            "gtin": "4006000147635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27136a",
            "leftCorner": {
              "x": 3.936,
              "y": -5.489,
              "z": 0.98
            },
            "rightCorner": {
              "x": 3.986,
              "y": -5.53,
              "z": 0.98
            },
            "gtin": "4005900811615",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27136b",
            "leftCorner": {
              "x": 3.986,
              "y": -5.53,
              "z": 0.98
            },
            "rightCorner": {
              "x": 4.041,
              "y": -5.576,
              "z": 0.98
            },
            "gtin": "4005900637086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a27136c",
            "leftCorner": {
              "x": 4.041,
              "y": -5.576,
              "z": 0.98
            },
            "rightCorner": {
              "x": 4.117,
              "y": -5.639,
              "z": 0.98
            },
            "gtin": "4006000083698",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27136d",
            "leftCorner": {
              "x": 4.117,
              "y": -5.639,
              "z": 0.98
            },
            "rightCorner": {
              "x": 4.163,
              "y": -5.678,
              "z": 0.98
            },
            "gtin": "4006000083513",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27136e",
            "leftCorner": {
              "x": 4.163,
              "y": -5.678,
              "z": 0.98
            },
            "rightCorner": {
              "x": 4.215,
              "y": -5.721,
              "z": 0.98
            },
            "gtin": "4006000083650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27136f",
            "leftCorner": {
              "x": 4.215,
              "y": -5.721,
              "z": 0.98
            },
            "rightCorner": {
              "x": 4.31,
              "y": -5.801,
              "z": 0.98
            },
            "gtin": "4005808802623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271370",
            "leftCorner": {
              "x": 4.31,
              "y": -5.801,
              "z": 0.98
            },
            "rightCorner": {
              "x": 4.409,
              "y": -5.883,
              "z": 0.98
            },
            "gtin": "4006000083315",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271371",
            "leftCorner": {
              "x": 4.409,
              "y": -5.883,
              "z": 0.98
            },
            "rightCorner": {
              "x": 4.481,
              "y": -5.943,
              "z": 0.98
            },
            "gtin": "4006000083476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271372",
            "leftCorner": {
              "x": 4.481,
              "y": -5.943,
              "z": 0.98
            },
            "rightCorner": {
              "x": 4.545,
              "y": -5.997,
              "z": 0.98
            },
            "gtin": "4006000147482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271357",
            "leftCorner": {
              "x": 4.545,
              "y": -5.997,
              "z": 0.98
            },
            "rightCorner": {
              "x": 4.582,
              "y": -6.028,
              "z": 0.98
            },
            "gtin": "4006000083353",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aa1",
        "height": 1.2344,
        "facings": [
          {
            "id": "696ebf7043c343680a2713d1",
            "leftCorner": {
              "x": 3.848,
              "y": -5.42,
              "z": 1.234
            },
            "rightCorner": {
              "x": 3.893,
              "y": -5.457,
              "z": 1.234
            },
            "gtin": "6001159111382",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713d2",
            "leftCorner": {
              "x": 3.893,
              "y": -5.457,
              "z": 1.234
            },
            "rightCorner": {
              "x": 3.939,
              "y": -5.495,
              "z": 1.234
            },
            "gtin": "4005900927545",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713d3",
            "leftCorner": {
              "x": 3.939,
              "y": -5.495,
              "z": 1.234
            },
            "rightCorner": {
              "x": 3.979,
              "y": -5.529,
              "z": 1.234
            },
            "gtin": "4066447109597",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713d4",
            "leftCorner": {
              "x": 3.979,
              "y": -5.529,
              "z": 1.234
            },
            "rightCorner": {
              "x": 4.071,
              "y": -5.606,
              "z": 1.234
            },
            "gtin": "4006000244211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713d5",
            "leftCorner": {
              "x": 4.071,
              "y": -5.606,
              "z": 1.234
            },
            "rightCorner": {
              "x": 4.146,
              "y": -5.669,
              "z": 1.234
            },
            "gtin": "42428985",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713d6",
            "leftCorner": {
              "x": 4.146,
              "y": -5.669,
              "z": 1.234
            },
            "rightCorner": {
              "x": 4.245,
              "y": -5.751,
              "z": 1.234
            },
            "gtin": "4005900917133",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713d7",
            "leftCorner": {
              "x": 4.245,
              "y": -5.751,
              "z": 1.234
            },
            "rightCorner": {
              "x": 4.321,
              "y": -5.815,
              "z": 1.234
            }
          },
          {
            "id": "696ebf7043c343680a2713d8",
            "leftCorner": {
              "x": 4.321,
              "y": -5.815,
              "z": 1.234
            },
            "rightCorner": {
              "x": 4.43,
              "y": -5.906,
              "z": 1.234
            },
            "gtin": "4005900917171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713d9",
            "leftCorner": {
              "x": 4.43,
              "y": -5.906,
              "z": 1.234
            },
            "rightCorner": {
              "x": 4.523,
              "y": -5.983,
              "z": 1.234
            },
            "gtin": "4005900917218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713c1",
            "leftCorner": {
              "x": 4.523,
              "y": -5.983,
              "z": 1.234
            },
            "rightCorner": {
              "x": 4.58,
              "y": -6.031,
              "z": 1.234
            },
            "gtin": "42429050",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aa2",
        "height": 1.4467,
        "facings": [
          {
            "id": "696ebf7043c343680a2713b8",
            "leftCorner": {
              "x": 3.795,
              "y": -5.391,
              "z": 1.45
            },
            "rightCorner": {
              "x": 3.839,
              "y": -5.429,
              "z": 1.45
            },
            "gtin": "3574661842608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713b9",
            "leftCorner": {
              "x": 3.851,
              "y": -5.43,
              "z": 1.447
            },
            "rightCorner": {
              "x": 3.903,
              "y": -5.474,
              "z": 1.447
            },
            "gtin": "3574661849348",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713ba",
            "leftCorner": {
              "x": 3.903,
              "y": -5.474,
              "z": 1.447
            },
            "rightCorner": {
              "x": 3.956,
              "y": -5.518,
              "z": 1.447
            },
            "gtin": "3574661751610",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713bb",
            "leftCorner": {
              "x": 3.956,
              "y": -5.518,
              "z": 1.447
            },
            "rightCorner": {
              "x": 4.054,
              "y": -5.6,
              "z": 1.447
            },
            "gtin": "3574661750521",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713bc",
            "leftCorner": {
              "x": 4.054,
              "y": -5.6,
              "z": 1.447
            },
            "rightCorner": {
              "x": 4.12,
              "y": -5.655,
              "z": 1.447
            },
            "gtin": "4066447591569",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713bd",
            "leftCorner": {
              "x": 4.12,
              "y": -5.655,
              "z": 1.447
            },
            "rightCorner": {
              "x": 4.185,
              "y": -5.709,
              "z": 1.447
            },
            "gtin": "4066447078428",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713be",
            "leftCorner": {
              "x": 4.185,
              "y": -5.709,
              "z": 1.447
            },
            "rightCorner": {
              "x": 4.242,
              "y": -5.757,
              "z": 1.447
            },
            "gtin": "4066447237887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713bf",
            "leftCorner": {
              "x": 4.242,
              "y": -5.757,
              "z": 1.447
            },
            "rightCorner": {
              "x": 4.38,
              "y": -5.872,
              "z": 1.447
            },
            "gtin": "4066447240306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713c0",
            "leftCorner": {
              "x": 4.38,
              "y": -5.872,
              "z": 1.447
            },
            "rightCorner": {
              "x": 4.521,
              "y": -5.99,
              "z": 1.447
            },
            "gtin": "4103040048622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713a8",
            "leftCorner": {
              "x": 4.521,
              "y": -5.99,
              "z": 1.447
            },
            "rightCorner": {
              "x": 4.576,
              "y": -6.036,
              "z": 1.447
            },
            "gtin": "4103040051431",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73a9f",
        "height": 1.6978,
        "facings": [
          {
            "id": "696ebf6f43c343680a271340",
            "leftCorner": {
              "x": 3.818,
              "y": -5.403,
              "z": 1.698
            },
            "rightCorner": {
              "x": 3.882,
              "y": -5.456,
              "z": 1.698
            },
            "gtin": "3600551033082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271341",
            "leftCorner": {
              "x": 3.882,
              "y": -5.456,
              "z": 1.698
            },
            "rightCorner": {
              "x": 3.924,
              "y": -5.491,
              "z": 1.698
            },
            "gtin": "3600551057705",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271342",
            "leftCorner": {
              "x": 3.924,
              "y": -5.491,
              "z": 1.698
            },
            "rightCorner": {
              "x": 3.957,
              "y": -5.519,
              "z": 1.698
            },
            "gtin": "3600551164410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271343",
            "leftCorner": {
              "x": 3.957,
              "y": -5.519,
              "z": 1.698
            },
            "rightCorner": {
              "x": 4.008,
              "y": -5.561,
              "z": 1.698
            },
            "gtin": "3600551164564",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271344",
            "leftCorner": {
              "x": 4.008,
              "y": -5.561,
              "z": 1.698
            },
            "rightCorner": {
              "x": 4.097,
              "y": -5.635,
              "z": 1.698
            },
            "gtin": "3600551124803",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271345",
            "leftCorner": {
              "x": 4.097,
              "y": -5.635,
              "z": 1.698
            },
            "rightCorner": {
              "x": 4.179,
              "y": -5.704,
              "z": 1.698
            },
            "gtin": "3600551164465",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271346",
            "leftCorner": {
              "x": 4.179,
              "y": -5.704,
              "z": 1.698
            },
            "rightCorner": {
              "x": 4.261,
              "y": -5.772,
              "z": 1.698
            },
            "gtin": "3600551068749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271347",
            "leftCorner": {
              "x": 4.261,
              "y": -5.772,
              "z": 1.698
            },
            "rightCorner": {
              "x": 4.345,
              "y": -5.842,
              "z": 1.698
            },
            "gtin": "3600551057712",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271348",
            "leftCorner": {
              "x": 4.345,
              "y": -5.842,
              "z": 1.698
            },
            "rightCorner": {
              "x": 4.425,
              "y": -5.909,
              "z": 1.698
            },
            "gtin": "3600551147307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a271349",
            "leftCorner": {
              "x": 4.425,
              "y": -5.909,
              "z": 1.698
            },
            "rightCorner": {
              "x": 4.477,
              "y": -5.953,
              "z": 1.698
            },
            "gtin": "4103040051479",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27134a",
            "leftCorner": {
              "x": 4.477,
              "y": -5.953,
              "z": 1.698
            },
            "rightCorner": {
              "x": 4.537,
              "y": -6.003,
              "z": 1.698
            },
            "gtin": "4103040902146",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27134b",
            "leftCorner": {
              "x": 4.537,
              "y": -6.003,
              "z": 1.698
            },
            "rightCorner": {
              "x": 4.575,
              "y": -6.035,
              "z": 1.698
            },
            "gtin": "4103040002150",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc04695992e",
    "name": "68e7572eb5fe7bc04695992e",
    "x": 4.621,
    "y": -6.0258,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.35052,
      "w": 0.93656
    },
    "statistics": {
      "hasStockCount": 67,
      "noStockCount": 0,
      "unknownStockCount": 13
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73aaa",
        "height": 0.17863,
        "facings": [
          {
            "id": "696ebf7043c343680a2713f5",
            "leftCorner": {
              "x": 4.591,
              "y": -6.06,
              "z": 0.179
            },
            "rightCorner": {
              "x": 4.726,
              "y": -6.172,
              "z": 0.179
            },
            "gtin": "4066447379846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713f6",
            "leftCorner": {
              "x": 4.723,
              "y": -6.175,
              "z": 0.179
            },
            "rightCorner": {
              "x": 4.841,
              "y": -6.277,
              "z": 0.179
            },
            "gtin": "4066447380422",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713f7",
            "leftCorner": {
              "x": 4.841,
              "y": -6.277,
              "z": 0.179
            },
            "rightCorner": {
              "x": 4.938,
              "y": -6.362,
              "z": 0.179
            },
            "gtin": "7702018070794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713f8",
            "leftCorner": {
              "x": 4.938,
              "y": -6.362,
              "z": 0.179
            },
            "rightCorner": {
              "x": 5.066,
              "y": -6.473,
              "z": 0.179
            },
            "gtin": "4027800571482",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713f9",
            "leftCorner": {
              "x": 5.066,
              "y": -6.473,
              "z": 0.179
            },
            "rightCorner": {
              "x": 5.149,
              "y": -6.545,
              "z": 0.179
            },
            "gtin": "4066447239218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2713fa",
            "leftCorner": {
              "x": 5.149,
              "y": -6.545,
              "z": 0.179
            },
            "rightCorner": {
              "x": 5.196,
              "y": -6.586,
              "z": 0.179
            },
            "gtin": "4066447857993",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713fb",
            "leftCorner": {
              "x": 5.196,
              "y": -6.586,
              "z": 0.179
            },
            "rightCorner": {
              "x": 5.237,
              "y": -6.622,
              "z": 0.179
            },
            "gtin": "4067796154276",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713fc",
            "leftCorner": {
              "x": 5.237,
              "y": -6.622,
              "z": 0.179
            },
            "rightCorner": {
              "x": 5.283,
              "y": -6.661,
              "z": 0.179
            },
            "gtin": "4067796154276",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713fd",
            "leftCorner": {
              "x": 5.283,
              "y": -6.661,
              "z": 0.179
            },
            "rightCorner": {
              "x": 5.324,
              "y": -6.698,
              "z": 0.179
            },
            "gtin": "4066447294859",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713fe",
            "leftCorner": {
              "x": 5.324,
              "y": -6.698,
              "z": 0.179
            },
            "rightCorner": {
              "x": 5.375,
              "y": -6.742,
              "z": 0.179
            },
            "gtin": "4066447294859",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aa4",
        "height": 0.51956,
        "facings": [
          {
            "id": "696ebf7043c343680a271451",
            "leftCorner": {
              "x": 4.587,
              "y": -6.064,
              "z": 0.52
            },
            "rightCorner": {
              "x": 4.656,
              "y": -6.124,
              "z": 0.52
            },
            "gtin": "4066447757156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271453",
            "leftCorner": {
              "x": 4.656,
              "y": -6.124,
              "z": 0.52
            },
            "rightCorner": {
              "x": 4.713,
              "y": -6.173,
              "z": 0.52
            },
            "gtin": "4066447757279",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271454",
            "leftCorner": {
              "x": 4.713,
              "y": -6.173,
              "z": 0.52
            },
            "rightCorner": {
              "x": 4.767,
              "y": -6.221,
              "z": 0.52
            },
            "gtin": "4066447757217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271455",
            "leftCorner": {
              "x": 4.767,
              "y": -6.221,
              "z": 0.52
            },
            "rightCorner": {
              "x": 4.79,
              "y": -6.241,
              "z": 0.52
            },
            "gtin": "4067796182026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271456",
            "leftCorner": {
              "x": 4.79,
              "y": -6.241,
              "z": 0.52
            },
            "rightCorner": {
              "x": 4.848,
              "y": -6.291,
              "z": 0.52
            },
            "gtin": "4066447380453",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271457",
            "leftCorner": {
              "x": 4.848,
              "y": -6.291,
              "z": 0.52
            },
            "rightCorner": {
              "x": 4.889,
              "y": -6.327,
              "z": 0.52
            },
            "gtin": "4066447371659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271458",
            "leftCorner": {
              "x": 4.889,
              "y": -6.327,
              "z": 0.52
            },
            "rightCorner": {
              "x": 4.941,
              "y": -6.372,
              "z": 0.52
            },
            "gtin": "4066447440942",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271459",
            "leftCorner": {
              "x": 4.941,
              "y": -6.372,
              "z": 0.52
            },
            "rightCorner": {
              "x": 4.994,
              "y": -6.418,
              "z": 0.52
            },
            "gtin": "4066447277487",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27145a",
            "leftCorner": {
              "x": 4.994,
              "y": -6.418,
              "z": 0.52
            },
            "rightCorner": {
              "x": 5.075,
              "y": -6.489,
              "z": 0.52
            },
            "gtin": "4066447237542",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27145b",
            "leftCorner": {
              "x": 5.075,
              "y": -6.489,
              "z": 0.52
            },
            "rightCorner": {
              "x": 5.112,
              "y": -6.521,
              "z": 0.52
            },
            "gtin": "4066447239294",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27145c",
            "leftCorner": {
              "x": 5.112,
              "y": -6.521,
              "z": 0.52
            },
            "rightCorner": {
              "x": 5.143,
              "y": -6.548,
              "z": 0.52
            },
            "gtin": "4066447239270",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27145d",
            "leftCorner": {
              "x": 5.143,
              "y": -6.548,
              "z": 0.52
            },
            "rightCorner": {
              "x": 5.182,
              "y": -6.582,
              "z": 0.52
            },
            "gtin": "4066447397222",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27145e",
            "leftCorner": {
              "x": 5.182,
              "y": -6.582,
              "z": 0.52
            },
            "rightCorner": {
              "x": 5.219,
              "y": -6.614,
              "z": 0.52
            },
            "gtin": "4066447591767",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27145f",
            "leftCorner": {
              "x": 5.219,
              "y": -6.614,
              "z": 0.52
            },
            "rightCorner": {
              "x": 5.261,
              "y": -6.65,
              "z": 0.52
            },
            "gtin": "8700216013291",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271460",
            "leftCorner": {
              "x": 5.261,
              "y": -6.65,
              "z": 0.52
            },
            "rightCorner": {
              "x": 5.303,
              "y": -6.687,
              "z": 0.52
            },
            "gtin": "8006540768808",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271452",
            "leftCorner": {
              "x": 5.303,
              "y": -6.687,
              "z": 0.52
            },
            "rightCorner": {
              "x": 5.342,
              "y": -6.721,
              "z": 0.52
            },
            "gtin": "7702018015030",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aa5",
        "height": 0.81421,
        "facings": [
          {
            "id": "696ebf7043c343680a271461",
            "leftCorner": {
              "x": 4.584,
              "y": -6.068,
              "z": 0.814
            },
            "rightCorner": {
              "x": 4.64,
              "y": -6.117,
              "z": 0.814
            },
            "gtin": "4002448101185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271462",
            "leftCorner": {
              "x": 4.64,
              "y": -6.117,
              "z": 0.814
            },
            "rightCorner": {
              "x": 4.722,
              "y": -6.188,
              "z": 0.814
            },
            "gtin": "4002448122296",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271463",
            "leftCorner": {
              "x": 4.722,
              "y": -6.188,
              "z": 0.814
            },
            "rightCorner": {
              "x": 4.783,
              "y": -6.241,
              "z": 0.814
            },
            "gtin": "4002448114017",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271464",
            "leftCorner": {
              "x": 4.783,
              "y": -6.241,
              "z": 0.814
            },
            "rightCorner": {
              "x": 4.837,
              "y": -6.289,
              "z": 0.814
            },
            "gtin": "8002340018266",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271465",
            "leftCorner": {
              "x": 4.837,
              "y": -6.289,
              "z": 0.814
            },
            "rightCorner": {
              "x": 4.902,
              "y": -6.345,
              "z": 0.814
            },
            "gtin": "4002448203148",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271466",
            "leftCorner": {
              "x": 4.902,
              "y": -6.345,
              "z": 0.814
            },
            "rightCorner": {
              "x": 4.958,
              "y": -6.394,
              "z": 0.814
            },
            "gtin": "4002448190080",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271467",
            "leftCorner": {
              "x": 4.958,
              "y": -6.394,
              "z": 0.814
            },
            "rightCorner": {
              "x": 5.032,
              "y": -6.458,
              "z": 0.814
            },
            "gtin": "9000300128108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271468",
            "leftCorner": {
              "x": 5.032,
              "y": -6.458,
              "z": 0.814
            },
            "rightCorner": {
              "x": 5.081,
              "y": -6.501,
              "z": 0.814
            },
            "gtin": "4066447383942",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271469",
            "leftCorner": {
              "x": 5.081,
              "y": -6.501,
              "z": 0.814
            },
            "rightCorner": {
              "x": 5.128,
              "y": -6.542,
              "z": 0.814
            },
            "gtin": "4066447379983",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27146a",
            "leftCorner": {
              "x": 5.128,
              "y": -6.542,
              "z": 0.814
            },
            "rightCorner": {
              "x": 5.163,
              "y": -6.572,
              "z": 0.814
            },
            "gtin": "4066447858013",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27146b",
            "leftCorner": {
              "x": 5.163,
              "y": -6.572,
              "z": 0.814
            },
            "rightCorner": {
              "x": 5.198,
              "y": -6.603,
              "z": 0.814
            },
            "gtin": "4066447858013",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27146c",
            "leftCorner": {
              "x": 5.198,
              "y": -6.603,
              "z": 0.814
            },
            "rightCorner": {
              "x": 5.234,
              "y": -6.634,
              "z": 0.814
            },
            "gtin": "4066447239256",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27146d",
            "leftCorner": {
              "x": 5.234,
              "y": -6.634,
              "z": 0.814
            },
            "rightCorner": {
              "x": 5.271,
              "y": -6.666,
              "z": 0.814
            },
            "gtin": "4067796147957",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27146e",
            "leftCorner": {
              "x": 5.271,
              "y": -6.666,
              "z": 0.814
            },
            "rightCorner": {
              "x": 5.337,
              "y": -6.723,
              "z": 0.814
            },
            "gtin": "4027800081158",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aa8",
        "height": 1.0699,
        "facings": [
          {
            "id": "696ebf7043c343680a271479",
            "leftCorner": {
              "x": 4.587,
              "y": -6.065,
              "z": 1.07
            },
            "rightCorner": {
              "x": 4.64,
              "y": -6.111,
              "z": 1.07
            },
            "gtin": "4066447638868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27147a",
            "leftCorner": {
              "x": 4.64,
              "y": -6.111,
              "z": 1.07
            },
            "rightCorner": {
              "x": 4.738,
              "y": -6.196,
              "z": 1.07
            },
            "gtin": "4210201423508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27147b",
            "leftCorner": {
              "x": 4.738,
              "y": -6.196,
              "z": 1.07
            },
            "rightCorner": {
              "x": 4.812,
              "y": -6.261,
              "z": 1.07
            },
            "gtin": "4027800239702",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27147c",
            "leftCorner": {
              "x": 4.812,
              "y": -6.261,
              "z": 1.07
            },
            "rightCorner": {
              "x": 4.892,
              "y": -6.33,
              "z": 1.07
            },
            "gtin": "4027800965038",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27147d",
            "leftCorner": {
              "x": 4.892,
              "y": -6.33,
              "z": 1.07
            },
            "rightCorner": {
              "x": 4.959,
              "y": -6.389,
              "z": 1.07
            },
            "gtin": "4027800255702",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27147e",
            "leftCorner": {
              "x": 4.959,
              "y": -6.389,
              "z": 1.07
            },
            "rightCorner": {
              "x": 5.005,
              "y": -6.428,
              "z": 1.07
            },
            "gtin": "4066447440805",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27147f",
            "leftCorner": {
              "x": 5.005,
              "y": -6.428,
              "z": 1.07
            },
            "rightCorner": {
              "x": 5.091,
              "y": -6.503,
              "z": 1.07
            },
            "gtin": "7350113020758",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271480",
            "leftCorner": {
              "x": 5.091,
              "y": -6.503,
              "z": 1.07
            },
            "rightCorner": {
              "x": 5.168,
              "y": -6.571,
              "z": 1.07
            },
            "gtin": "7350113020307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271481",
            "leftCorner": {
              "x": 5.168,
              "y": -6.571,
              "z": 1.07
            },
            "rightCorner": {
              "x": 5.24,
              "y": -6.633,
              "z": 1.07
            },
            "gtin": "4067796158151",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271482",
            "leftCorner": {
              "x": 5.24,
              "y": -6.633,
              "z": 1.07
            },
            "rightCorner": {
              "x": 5.317,
              "y": -6.7,
              "z": 1.07
            },
            "gtin": "7350113021137",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aa9",
        "height": 1.3251,
        "facings": [
          {
            "id": "696ebf7043c343680a271483",
            "leftCorner": {
              "x": 4.582,
              "y": -6.07,
              "z": 1.325
            },
            "rightCorner": {
              "x": 4.663,
              "y": -6.141,
              "z": 1.325
            },
            "gtin": "4066447757248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271485",
            "leftCorner": {
              "x": 4.663,
              "y": -6.141,
              "z": 1.325
            },
            "rightCorner": {
              "x": 4.721,
              "y": -6.191,
              "z": 1.325
            },
            "gtin": "4066447757309",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271486",
            "leftCorner": {
              "x": 4.721,
              "y": -6.191,
              "z": 1.325
            },
            "rightCorner": {
              "x": 4.794,
              "y": -6.254,
              "z": 1.325
            },
            "gtin": "4066447562750",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271487",
            "leftCorner": {
              "x": 4.794,
              "y": -6.254,
              "z": 1.325
            },
            "rightCorner": {
              "x": 4.866,
              "y": -6.318,
              "z": 1.325
            },
            "gtin": "4027800407002",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271488",
            "leftCorner": {
              "x": 4.866,
              "y": -6.318,
              "z": 1.325
            },
            "rightCorner": {
              "x": 4.94,
              "y": -6.382,
              "z": 1.325
            },
            "gtin": "4027800006502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271489",
            "leftCorner": {
              "x": 4.94,
              "y": -6.382,
              "z": 1.325
            },
            "rightCorner": {
              "x": 5.017,
              "y": -6.449,
              "z": 1.325
            },
            "gtin": "8700216495561",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27148a",
            "leftCorner": {
              "x": 5.017,
              "y": -6.449,
              "z": 1.325
            },
            "rightCorner": {
              "x": 5.099,
              "y": -6.52,
              "z": 1.325
            },
            "gtin": "8700216494137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27148b",
            "leftCorner": {
              "x": 5.099,
              "y": -6.52,
              "z": 1.325
            },
            "rightCorner": {
              "x": 5.17,
              "y": -6.582,
              "z": 1.325
            },
            "gtin": "7702018401208",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27148c",
            "leftCorner": {
              "x": 5.17,
              "y": -6.582,
              "z": 1.325
            },
            "rightCorner": {
              "x": 5.254,
              "y": -6.655,
              "z": 1.325
            },
            "gtin": "8700216493925",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271484",
            "leftCorner": {
              "x": 5.254,
              "y": -6.655,
              "z": 1.325
            },
            "rightCorner": {
              "x": 5.337,
              "y": -6.727,
              "z": 1.325
            },
            "gtin": "7350113021144",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aa6",
        "height": 1.5386,
        "facings": [
          {
            "id": "696ebf7043c343680a27146f",
            "leftCorner": {
              "x": 4.648,
              "y": -5.995,
              "z": 1.539
            },
            "rightCorner": {
              "x": 4.727,
              "y": -6.064,
              "z": 1.539
            },
            "gtin": "4066447562712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271471",
            "leftCorner": {
              "x": 4.727,
              "y": -6.064,
              "z": 1.539
            },
            "rightCorner": {
              "x": 4.8,
              "y": -6.128,
              "z": 1.539
            },
            "gtin": "4067796187335",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271472",
            "leftCorner": {
              "x": 4.8,
              "y": -6.128,
              "z": 1.539
            },
            "rightCorner": {
              "x": 4.874,
              "y": -6.193,
              "z": 1.539
            },
            "gtin": "4066447562743",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271473",
            "leftCorner": {
              "x": 4.874,
              "y": -6.193,
              "z": 1.539
            },
            "rightCorner": {
              "x": 4.948,
              "y": -6.257,
              "z": 1.539
            },
            "gtin": "4027800969012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271474",
            "leftCorner": {
              "x": 4.948,
              "y": -6.257,
              "z": 1.539
            },
            "rightCorner": {
              "x": 5.024,
              "y": -6.323,
              "z": 1.539
            },
            "gtin": "4027800006304",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271475",
            "leftCorner": {
              "x": 5.024,
              "y": -6.323,
              "z": 1.539
            },
            "rightCorner": {
              "x": 5.107,
              "y": -6.395,
              "z": 1.539
            },
            "gtin": "8001090594204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271476",
            "leftCorner": {
              "x": 5.107,
              "y": -6.395,
              "z": 1.539
            },
            "rightCorner": {
              "x": 5.182,
              "y": -6.46,
              "z": 1.539
            },
            "gtin": "8700216495424",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271477",
            "leftCorner": {
              "x": 5.182,
              "y": -6.46,
              "z": 1.539
            },
            "rightCorner": {
              "x": 5.252,
              "y": -6.522,
              "z": 1.539
            },
            "gtin": "8700216187497",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271478",
            "leftCorner": {
              "x": 5.252,
              "y": -6.522,
              "z": 1.539
            },
            "rightCorner": {
              "x": 5.33,
              "y": -6.589,
              "z": 1.539
            },
            "gtin": "8001090598455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271470",
            "leftCorner": {
              "x": 5.33,
              "y": -6.589,
              "z": 1.539
            },
            "rightCorner": {
              "x": 5.402,
              "y": -6.652,
              "z": 1.539
            },
            "gtin": "8001090598455",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aa7",
        "height": 1.704,
        "facings": [
          {
            "id": "696ebf6f43c343680a27134c",
            "leftCorner": {
              "x": 4.644,
              "y": -5.998,
              "z": 1.704
            },
            "rightCorner": {
              "x": 4.73,
              "y": -6.073,
              "z": 1.704
            },
            "gtin": "4066447562705",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27134d",
            "leftCorner": {
              "x": 4.73,
              "y": -6.073,
              "z": 1.704
            },
            "rightCorner": {
              "x": 4.807,
              "y": -6.141,
              "z": 1.704
            },
            "gtin": "4067796187298",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27134e",
            "leftCorner": {
              "x": 4.807,
              "y": -6.141,
              "z": 1.704
            },
            "rightCorner": {
              "x": 4.881,
              "y": -6.205,
              "z": 1.704
            },
            "gtin": "4066447562736",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a27134f",
            "leftCorner": {
              "x": 4.881,
              "y": -6.205,
              "z": 1.704
            },
            "rightCorner": {
              "x": 4.936,
              "y": -6.253,
              "z": 1.704
            },
            "gtin": "4027800416004",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271350",
            "leftCorner": {
              "x": 4.936,
              "y": -6.253,
              "z": 1.704
            },
            "rightCorner": {
              "x": 5.009,
              "y": -6.316,
              "z": 1.704
            },
            "gtin": "4027800656103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271351",
            "leftCorner": {
              "x": 5.009,
              "y": -6.316,
              "z": 1.704
            },
            "rightCorner": {
              "x": 5.089,
              "y": -6.386,
              "z": 1.704
            },
            "gtin": "3014260285425",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271352",
            "leftCorner": {
              "x": 5.089,
              "y": -6.386,
              "z": 1.704
            },
            "rightCorner": {
              "x": 5.165,
              "y": -6.452,
              "z": 1.704
            },
            "gtin": "7702018322862",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271353",
            "leftCorner": {
              "x": 5.165,
              "y": -6.452,
              "z": 1.704
            },
            "rightCorner": {
              "x": 5.24,
              "y": -6.517,
              "z": 1.704
            },
            "gtin": "8700216568944",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271354",
            "leftCorner": {
              "x": 5.24,
              "y": -6.517,
              "z": 1.704
            },
            "rightCorner": {
              "x": 5.32,
              "y": -6.587,
              "z": 1.704
            },
            "gtin": "8700216187220",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a271355",
            "leftCorner": {
              "x": 5.32,
              "y": -6.587,
              "z": 1.704
            },
            "rightCorner": {
              "x": 5.398,
              "y": -6.655,
              "z": 1.704
            },
            "gtin": "8700216489720",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc04695992f",
    "name": "68e7572eb5fe7bc04695992f",
    "x": 5.3618,
    "y": -6.6763,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.35026,
      "w": 0.93665
    },
    "statistics": {
      "hasStockCount": 23,
      "noStockCount": 1,
      "unknownStockCount": 14
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73aaf",
        "height": 0.17998,
        "facings": [
          {
            "id": "696ebf7043c343680a2713ff",
            "leftCorner": {
              "x": 5.362,
              "y": -6.736,
              "z": 0.18
            },
            "rightCorner": {
              "x": 5.42,
              "y": -6.786,
              "z": 0.18
            },
            "gtin": "4066447245554",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271400",
            "leftCorner": {
              "x": 5.42,
              "y": -6.786,
              "z": 0.18
            },
            "rightCorner": {
              "x": 5.48,
              "y": -6.839,
              "z": 0.18
            },
            "gtin": "4066447245578",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271401",
            "leftCorner": {
              "x": 5.48,
              "y": -6.839,
              "z": 0.18
            },
            "rightCorner": {
              "x": 5.554,
              "y": -6.903,
              "z": 0.18
            },
            "gtin": "4066447245530",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271402",
            "leftCorner": {
              "x": 5.554,
              "y": -6.903,
              "z": 0.18
            },
            "rightCorner": {
              "x": 5.612,
              "y": -6.954,
              "z": 0.18
            },
            "gtin": "4066447245516",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271403",
            "leftCorner": {
              "x": 5.612,
              "y": -6.954,
              "z": 0.18
            },
            "rightCorner": {
              "x": 5.668,
              "y": -7.002,
              "z": 0.18
            },
            "gtin": "4066447245639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271404",
            "leftCorner": {
              "x": 5.668,
              "y": -7.002,
              "z": 0.18
            },
            "rightCorner": {
              "x": 5.744,
              "y": -7.068,
              "z": 0.18
            },
            "gtin": "4066447343632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271405",
            "leftCorner": {
              "x": 5.744,
              "y": -7.068,
              "z": 0.18
            },
            "rightCorner": {
              "x": 5.824,
              "y": -7.138,
              "z": 0.18
            },
            "gtin": "4066447382624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271406",
            "leftCorner": {
              "x": 5.824,
              "y": -7.138,
              "z": 0.18
            },
            "rightCorner": {
              "x": 5.901,
              "y": -7.204,
              "z": 0.18
            },
            "gtin": "4066447522006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271407",
            "leftCorner": {
              "x": 5.901,
              "y": -7.204,
              "z": 0.18
            },
            "rightCorner": {
              "x": 5.973,
              "y": -7.267,
              "z": 0.18
            },
            "gtin": "4066447877519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271408",
            "leftCorner": {
              "x": 5.973,
              "y": -7.267,
              "z": 0.18
            },
            "rightCorner": {
              "x": 6.039,
              "y": -7.324,
              "z": 0.18
            },
            "gtin": "4066447878066",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271409",
            "leftCorner": {
              "x": 6.039,
              "y": -7.324,
              "z": 0.18
            },
            "rightCorner": {
              "x": 6.102,
              "y": -7.379,
              "z": 0.18
            },
            "gtin": "4066447521856",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ab1",
        "height": 0.43974,
        "facings": [
          {
            "id": "696ebf7043c343680a271520",
            "leftCorner": {
              "x": 5.398,
              "y": -6.634,
              "z": 0.44
            },
            "rightCorner": {
              "x": 5.52,
              "y": -6.74,
              "z": 0.44
            },
            "gtin": "4058172997143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271521",
            "leftCorner": {
              "x": 5.52,
              "y": -6.74,
              "z": 0.44
            },
            "rightCorner": {
              "x": 5.642,
              "y": -6.846,
              "z": 0.44
            },
            "gtin": "4066447374544",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271522",
            "leftCorner": {
              "x": 5.642,
              "y": -6.846,
              "z": 0.44
            },
            "rightCorner": {
              "x": 5.752,
              "y": -6.942,
              "z": 0.44
            },
            "gtin": "4066447374544",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271523",
            "leftCorner": {
              "x": 5.752,
              "y": -6.942,
              "z": 0.44
            },
            "rightCorner": {
              "x": 5.841,
              "y": -7.019,
              "z": 0.44
            }
          },
          {
            "id": "696ebf7043c343680a271524",
            "leftCorner": {
              "x": 5.841,
              "y": -7.019,
              "z": 0.44
            },
            "rightCorner": {
              "x": 5.925,
              "y": -7.092,
              "z": 0.44
            },
            "gtin": "4066447875973",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271525",
            "leftCorner": {
              "x": 5.925,
              "y": -7.092,
              "z": 0.44
            },
            "rightCorner": {
              "x": 6.002,
              "y": -7.159,
              "z": 0.44
            },
            "gtin": "4066447314540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271526",
            "leftCorner": {
              "x": 6.002,
              "y": -7.159,
              "z": 0.44
            },
            "rightCorner": {
              "x": 6.071,
              "y": -7.219,
              "z": 0.44
            },
            "gtin": "4066447314540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271527",
            "leftCorner": {
              "x": 6.071,
              "y": -7.219,
              "z": 0.44
            },
            "rightCorner": {
              "x": 6.12,
              "y": -7.261,
              "z": 0.44
            }
          },
          {
            "id": "696ebf7043c343680a271528",
            "leftCorner": {
              "x": 6.12,
              "y": -7.261,
              "z": 0.44
            },
            "rightCorner": {
              "x": 6.153,
              "y": -7.29,
              "z": 0.44
            },
            "gtin": "4066447365962",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ab0",
        "height": 0.68966,
        "facings": [
          {
            "id": "696ebf7043c343680a2714db",
            "leftCorner": {
              "x": 5.397,
              "y": -6.636,
              "z": 0.69
            },
            "rightCorner": {
              "x": 5.509,
              "y": -6.733,
              "z": 0.69
            },
            "gtin": "3574661826165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714dd",
            "leftCorner": {
              "x": 5.509,
              "y": -6.733,
              "z": 0.69
            },
            "rightCorner": {
              "x": 5.615,
              "y": -6.826,
              "z": 0.69
            },
            "gtin": "3574661826073",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714de",
            "leftCorner": {
              "x": 5.615,
              "y": -6.826,
              "z": 0.69
            },
            "rightCorner": {
              "x": 5.723,
              "y": -6.92,
              "z": 0.69
            },
            "gtin": "3574661826073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714df",
            "leftCorner": {
              "x": 5.723,
              "y": -6.92,
              "z": 0.69
            },
            "rightCorner": {
              "x": 5.838,
              "y": -7.02,
              "z": 0.69
            },
            "gtin": "4066447857351",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714e0",
            "leftCorner": {
              "x": 5.838,
              "y": -7.02,
              "z": 0.69
            },
            "rightCorner": {
              "x": 5.949,
              "y": -7.116,
              "z": 0.69
            }
          },
          {
            "id": "696ebf7043c343680a2714e1",
            "leftCorner": {
              "x": 5.949,
              "y": -7.116,
              "z": 0.69
            },
            "rightCorner": {
              "x": 6.079,
              "y": -7.229,
              "z": 0.69
            },
            "gtin": "4067796081909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714e2",
            "leftCorner": {
              "x": 6.079,
              "y": -7.229,
              "z": 0.69
            },
            "rightCorner": {
              "x": 6.173,
              "y": -7.311,
              "z": 0.69
            },
            "gtin": "4005900983534",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aad",
        "height": 0.94534,
        "facings": [
          {
            "id": "696ebf7043c343680a27148d",
            "leftCorner": {
              "x": 5.399,
              "y": -6.634,
              "z": 0.945
            },
            "rightCorner": {
              "x": 5.474,
              "y": -6.699,
              "z": 0.945
            },
            "gtin": "4066447373455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27148f",
            "leftCorner": {
              "x": 5.474,
              "y": -6.699,
              "z": 0.945
            },
            "rightCorner": {
              "x": 5.527,
              "y": -6.745,
              "z": 0.945
            },
            "gtin": "4066447373479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271490",
            "leftCorner": {
              "x": 5.527,
              "y": -6.745,
              "z": 0.945
            },
            "rightCorner": {
              "x": 5.619,
              "y": -6.825,
              "z": 0.945
            },
            "gtin": "4066447234176",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271491",
            "leftCorner": {
              "x": 5.619,
              "y": -6.825,
              "z": 0.945
            },
            "rightCorner": {
              "x": 5.716,
              "y": -6.909,
              "z": 0.945
            },
            "gtin": "4066447429121",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271492",
            "leftCorner": {
              "x": 5.716,
              "y": -6.909,
              "z": 0.945
            },
            "rightCorner": {
              "x": 5.764,
              "y": -6.95,
              "z": 0.945
            },
            "gtin": "4084200550202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271493",
            "leftCorner": {
              "x": 5.764,
              "y": -6.95,
              "z": 0.945
            },
            "rightCorner": {
              "x": 5.814,
              "y": -6.994,
              "z": 0.945
            },
            "gtin": "4037900013041",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271494",
            "leftCorner": {
              "x": 5.814,
              "y": -6.994,
              "z": 0.945
            },
            "rightCorner": {
              "x": 5.861,
              "y": -7.035,
              "z": 0.945
            },
            "gtin": "3600541698475",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271495",
            "leftCorner": {
              "x": 5.861,
              "y": -7.035,
              "z": 0.945
            },
            "rightCorner": {
              "x": 5.906,
              "y": -7.075,
              "z": 0.945
            },
            "gtin": "4005900788573",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271496",
            "leftCorner": {
              "x": 5.906,
              "y": -7.075,
              "z": 0.945
            },
            "rightCorner": {
              "x": 5.949,
              "y": -7.111,
              "z": 0.945
            },
            "gtin": "4005900805928",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271497",
            "leftCorner": {
              "x": 5.949,
              "y": -7.111,
              "z": 0.945
            },
            "rightCorner": {
              "x": 5.992,
              "y": -7.149,
              "z": 0.945
            },
            "gtin": "4005900805966",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271498",
            "leftCorner": {
              "x": 5.992,
              "y": -7.149,
              "z": 0.945
            },
            "rightCorner": {
              "x": 6.067,
              "y": -7.214,
              "z": 0.945
            },
            "gtin": "4066447244908",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271499",
            "leftCorner": {
              "x": 6.067,
              "y": -7.214,
              "z": 0.945
            },
            "rightCorner": {
              "x": 6.154,
              "y": -7.29,
              "z": 0.945
            },
            "gtin": "4066447233728",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aab",
        "height": 1.3515,
        "facings": []
      },
      {
        "id": "696ead8d3b88e258afd73aae",
        "height": 1.5625,
        "facings": [
          {
            "id": "696ebf7043c343680a2714d9",
            "leftCorner": {
              "x": 5.415,
              "y": -6.615,
              "z": 1.562
            },
            "rightCorner": {
              "x": 5.711,
              "y": -6.873,
              "z": 1.562
            },
            "gtin": "4005900980083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714da",
            "leftCorner": {
              "x": 5.711,
              "y": -6.873,
              "z": 1.562
            },
            "rightCorner": {
              "x": 6.17,
              "y": -7.271,
              "z": 1.562
            },
            "gtin": "3574660085563",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aac",
        "height": 1.7702,
        "facings": []
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc046959930",
    "name": "68e7572eb5fe7bc046959930",
    "x": 6.123,
    "y": -7.3575,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.33777,
      "w": 0.94123
    },
    "statistics": {
      "hasStockCount": 60,
      "noStockCount": 1,
      "unknownStockCount": 32
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73ab8",
        "height": 0.17752,
        "facings": [
          {
            "id": "696ebf7043c343680a27140a",
            "leftCorner": {
              "x": 6.109,
              "y": -7.405,
              "z": 0.178
            },
            "rightCorner": {
              "x": 6.177,
              "y": -7.461,
              "z": 0.178
            },
            "gtin": "4066447521979",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27140b",
            "leftCorner": {
              "x": 6.177,
              "y": -7.461,
              "z": 0.178
            },
            "rightCorner": {
              "x": 6.202,
              "y": -7.481,
              "z": 0.178
            }
          },
          {
            "id": "696ebf7043c343680a27140c",
            "leftCorner": {
              "x": 6.202,
              "y": -7.481,
              "z": 0.178
            },
            "rightCorner": {
              "x": 6.273,
              "y": -7.539,
              "z": 0.178
            },
            "gtin": "4066447313857",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27140d",
            "leftCorner": {
              "x": 6.273,
              "y": -7.539,
              "z": 0.178
            },
            "rightCorner": {
              "x": 6.368,
              "y": -7.618,
              "z": 0.178
            },
            "gtin": "4066447313833",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27140e",
            "leftCorner": {
              "x": 6.368,
              "y": -7.618,
              "z": 0.178
            },
            "rightCorner": {
              "x": 6.423,
              "y": -7.663,
              "z": 0.178
            },
            "gtin": "4066447875997",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27140f",
            "leftCorner": {
              "x": 6.423,
              "y": -7.663,
              "z": 0.178
            },
            "rightCorner": {
              "x": 6.485,
              "y": -7.714,
              "z": 0.178
            },
            "gtin": "4066447382341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271410",
            "leftCorner": {
              "x": 6.485,
              "y": -7.714,
              "z": 0.178
            },
            "rightCorner": {
              "x": 6.536,
              "y": -7.756,
              "z": 0.178
            },
            "gtin": "4066447245318",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271411",
            "leftCorner": {
              "x": 6.536,
              "y": -7.756,
              "z": 0.178
            },
            "rightCorner": {
              "x": 6.558,
              "y": -7.775,
              "z": 0.178
            }
          },
          {
            "id": "696ebf7043c343680a271412",
            "leftCorner": {
              "x": 6.558,
              "y": -7.775,
              "z": 0.178
            },
            "rightCorner": {
              "x": 6.588,
              "y": -7.799,
              "z": 0.178
            },
            "gtin": "4067796180114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271413",
            "leftCorner": {
              "x": 6.588,
              "y": -7.799,
              "z": 0.178
            },
            "rightCorner": {
              "x": 6.609,
              "y": -7.817,
              "z": 0.178
            },
            "gtin": "4067796180114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271414",
            "leftCorner": {
              "x": 6.609,
              "y": -7.817,
              "z": 0.178
            },
            "rightCorner": {
              "x": 6.659,
              "y": -7.857,
              "z": 0.178
            },
            "gtin": "4067796161748",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271415",
            "leftCorner": {
              "x": 6.659,
              "y": -7.857,
              "z": 0.178
            },
            "rightCorner": {
              "x": 6.709,
              "y": -7.898,
              "z": 0.178
            },
            "gtin": "4066447245295",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271416",
            "leftCorner": {
              "x": 6.709,
              "y": -7.898,
              "z": 0.178
            },
            "rightCorner": {
              "x": 6.764,
              "y": -7.944,
              "z": 0.178
            },
            "gtin": "4066447245370",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271417",
            "leftCorner": {
              "x": 6.764,
              "y": -7.944,
              "z": 0.178
            },
            "rightCorner": {
              "x": 6.816,
              "y": -7.987,
              "z": 0.178
            },
            "gtin": "4066447245356",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271418",
            "leftCorner": {
              "x": 6.816,
              "y": -7.987,
              "z": 0.178
            },
            "rightCorner": {
              "x": 6.866,
              "y": -8.028,
              "z": 0.178
            },
            "gtin": "4066447342000",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ab7",
        "height": 0.43842,
        "facings": [
          {
            "id": "696ebf7043c343680a271529",
            "leftCorner": {
              "x": 6.159,
              "y": -7.314,
              "z": 0.438
            },
            "rightCorner": {
              "x": 6.249,
              "y": -7.392,
              "z": 0.438
            },
            "gtin": "4066447365382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27152a",
            "leftCorner": {
              "x": 6.251,
              "y": -7.39,
              "z": 0.438
            },
            "rightCorner": {
              "x": 6.399,
              "y": -7.511,
              "z": 0.438
            },
            "gtin": "4066447341904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27152b",
            "leftCorner": {
              "x": 6.399,
              "y": -7.511,
              "z": 0.438
            },
            "rightCorner": {
              "x": 6.439,
              "y": -7.545,
              "z": 0.438
            },
            "gtin": "4066447240702",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a27152c",
            "leftCorner": {
              "x": 6.439,
              "y": -7.545,
              "z": 0.438
            },
            "rightCorner": {
              "x": 6.481,
              "y": -7.579,
              "z": 0.438
            },
            "gtin": "4066447231014",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27152d",
            "leftCorner": {
              "x": 6.481,
              "y": -7.579,
              "z": 0.438
            },
            "rightCorner": {
              "x": 6.525,
              "y": -7.615,
              "z": 0.438
            },
            "gtin": "4066447231014",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27152e",
            "leftCorner": {
              "x": 6.525,
              "y": -7.615,
              "z": 0.438
            },
            "rightCorner": {
              "x": 6.548,
              "y": -7.634,
              "z": 0.438
            },
            "gtin": "4067796126051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27152f",
            "leftCorner": {
              "x": 6.548,
              "y": -7.634,
              "z": 0.438
            },
            "rightCorner": {
              "x": 6.574,
              "y": -7.656,
              "z": 0.438
            },
            "gtin": "4067796126051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271530",
            "leftCorner": {
              "x": 6.574,
              "y": -7.656,
              "z": 0.438
            },
            "rightCorner": {
              "x": 6.595,
              "y": -7.673,
              "z": 0.438
            },
            "gtin": "4066447245479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271531",
            "leftCorner": {
              "x": 6.595,
              "y": -7.673,
              "z": 0.438
            },
            "rightCorner": {
              "x": 6.63,
              "y": -7.702,
              "z": 0.438
            },
            "gtin": "4066447245479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271532",
            "leftCorner": {
              "x": 6.63,
              "y": -7.702,
              "z": 0.438
            },
            "rightCorner": {
              "x": 6.651,
              "y": -7.719,
              "z": 0.438
            },
            "gtin": "4066447771756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271533",
            "leftCorner": {
              "x": 6.651,
              "y": -7.719,
              "z": 0.438
            },
            "rightCorner": {
              "x": 6.678,
              "y": -7.742,
              "z": 0.438
            },
            "gtin": "4066447245233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271534",
            "leftCorner": {
              "x": 6.678,
              "y": -7.742,
              "z": 0.438
            },
            "rightCorner": {
              "x": 6.711,
              "y": -7.769,
              "z": 0.438
            },
            "gtin": "4066447245233",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271535",
            "leftCorner": {
              "x": 6.711,
              "y": -7.769,
              "z": 0.438
            },
            "rightCorner": {
              "x": 6.739,
              "y": -7.792,
              "z": 0.438
            },
            "gtin": "4066447245219",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271536",
            "leftCorner": {
              "x": 6.739,
              "y": -7.792,
              "z": 0.438
            },
            "rightCorner": {
              "x": 6.838,
              "y": -7.873,
              "z": 0.438
            },
            "gtin": "4066447242539",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271537",
            "leftCorner": {
              "x": 6.838,
              "y": -7.873,
              "z": 0.438
            },
            "rightCorner": {
              "x": 6.899,
              "y": -7.924,
              "z": 0.438
            },
            "gtin": "4066447245431",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271538",
            "leftCorner": {
              "x": 6.899,
              "y": -7.924,
              "z": 0.438
            },
            "rightCorner": {
              "x": 6.931,
              "y": -7.95,
              "z": 0.438
            },
            "gtin": "4066447245455",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ab6",
        "height": 0.68936,
        "facings": [
          {
            "id": "696ebf7043c343680a2714e3",
            "leftCorner": {
              "x": 6.184,
              "y": -7.328,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.346,
              "y": -7.462,
              "z": 0.689
            },
            "gtin": "4058172997129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714e4",
            "leftCorner": {
              "x": 6.346,
              "y": -7.462,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.452,
              "y": -7.549,
              "z": 0.689
            },
            "gtin": "4066447101874",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714e5",
            "leftCorner": {
              "x": 6.452,
              "y": -7.549,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.499,
              "y": -7.588,
              "z": 0.689
            },
            "gtin": "4066447154887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714e6",
            "leftCorner": {
              "x": 6.499,
              "y": -7.588,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.553,
              "y": -7.632,
              "z": 0.689
            },
            "gtin": "4066447154900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714e7",
            "leftCorner": {
              "x": 6.553,
              "y": -7.632,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.618,
              "y": -7.686,
              "z": 0.689
            },
            "gtin": "4066447365405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714e8",
            "leftCorner": {
              "x": 6.618,
              "y": -7.686,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.688,
              "y": -7.744,
              "z": 0.689
            },
            "gtin": "4066447244786",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714e9",
            "leftCorner": {
              "x": 6.688,
              "y": -7.744,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.73,
              "y": -7.778,
              "z": 0.689
            }
          },
          {
            "id": "696ebf7043c343680a2714ea",
            "leftCorner": {
              "x": 6.73,
              "y": -7.778,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.754,
              "y": -7.798,
              "z": 0.689
            },
            "gtin": "4066447429657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714eb",
            "leftCorner": {
              "x": 6.754,
              "y": -7.798,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.827,
              "y": -7.858,
              "z": 0.689
            },
            "gtin": "4058172681462",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714ec",
            "leftCorner": {
              "x": 6.827,
              "y": -7.858,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.905,
              "y": -7.923,
              "z": 0.689
            },
            "gtin": "4066447244960",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714ed",
            "leftCorner": {
              "x": 6.905,
              "y": -7.923,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.934,
              "y": -7.946,
              "z": 0.689
            },
            "gtin": "4067796107067",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ab3",
        "height": 0.94213,
        "facings": [
          {
            "id": "696ebf7043c343680a27149a",
            "leftCorner": {
              "x": 6.158,
              "y": -7.315,
              "z": 0.942
            },
            "rightCorner": {
              "x": 6.208,
              "y": -7.358,
              "z": 0.942
            },
            "gtin": "4066447233766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27149b",
            "leftCorner": {
              "x": 6.21,
              "y": -7.357,
              "z": 0.942
            },
            "rightCorner": {
              "x": 6.39,
              "y": -7.505,
              "z": 0.942
            },
            "gtin": "4066447492163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27149c",
            "leftCorner": {
              "x": 6.39,
              "y": -7.505,
              "z": 0.942
            },
            "rightCorner": {
              "x": 6.438,
              "y": -7.545,
              "z": 0.942
            },
            "gtin": "4066447101850",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27149d",
            "leftCorner": {
              "x": 6.438,
              "y": -7.545,
              "z": 0.942
            },
            "rightCorner": {
              "x": 6.472,
              "y": -7.573,
              "z": 0.942
            },
            "gtin": "4066447233926",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27149e",
            "leftCorner": {
              "x": 6.472,
              "y": -7.573,
              "z": 0.942
            },
            "rightCorner": {
              "x": 6.549,
              "y": -7.636,
              "z": 0.942
            },
            "gtin": "4066447382020",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27149f",
            "leftCorner": {
              "x": 6.549,
              "y": -7.636,
              "z": 0.942
            },
            "rightCorner": {
              "x": 6.599,
              "y": -7.677,
              "z": 0.942
            },
            "gtin": "4058172738012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714a0",
            "leftCorner": {
              "x": 6.599,
              "y": -7.677,
              "z": 0.942
            },
            "rightCorner": {
              "x": 6.618,
              "y": -7.694,
              "z": 0.942
            }
          },
          {
            "id": "696ebf7043c343680a2714a1",
            "leftCorner": {
              "x": 6.618,
              "y": -7.694,
              "z": 0.942
            },
            "rightCorner": {
              "x": 6.65,
              "y": -7.72,
              "z": 0.942
            },
            "gtin": "4066447492484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714a2",
            "leftCorner": {
              "x": 6.65,
              "y": -7.72,
              "z": 0.942
            },
            "rightCorner": {
              "x": 6.703,
              "y": -7.763,
              "z": 0.942
            },
            "gtin": "4066447492484",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714a3",
            "leftCorner": {
              "x": 6.703,
              "y": -7.763,
              "z": 0.942
            },
            "rightCorner": {
              "x": 6.76,
              "y": -7.81,
              "z": 0.942
            },
            "gtin": "4066447234046",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714a4",
            "leftCorner": {
              "x": 6.76,
              "y": -7.81,
              "z": 0.942
            },
            "rightCorner": {
              "x": 6.795,
              "y": -7.839,
              "z": 0.942
            },
            "gtin": "4066447428940",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714a5",
            "leftCorner": {
              "x": 6.795,
              "y": -7.839,
              "z": 0.942
            },
            "rightCorner": {
              "x": 6.834,
              "y": -7.871,
              "z": 0.942
            },
            "gtin": "4066447234718",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714a6",
            "leftCorner": {
              "x": 6.834,
              "y": -7.871,
              "z": 0.942
            },
            "rightCorner": {
              "x": 6.872,
              "y": -7.903,
              "z": 0.942
            },
            "gtin": "4066447428766",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714a7",
            "leftCorner": {
              "x": 6.872,
              "y": -7.903,
              "z": 0.942
            },
            "rightCorner": {
              "x": 6.912,
              "y": -7.936,
              "z": 0.942
            },
            "gtin": "4066447438888",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ab5",
        "height": 1.198,
        "facings": [
          {
            "id": "696ebf7043c343680a271603",
            "leftCorner": {
              "x": 6.157,
              "y": -7.316,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.215,
              "y": -7.363,
              "z": 1.198
            },
            "gtin": "4067796062632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271605",
            "leftCorner": {
              "x": 6.215,
              "y": -7.363,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.235,
              "y": -7.38,
              "z": 1.198
            },
            "gtin": "4066447382310",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271606",
            "leftCorner": {
              "x": 6.235,
              "y": -7.38,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.311,
              "y": -7.442,
              "z": 1.198
            },
            "gtin": "4066447428780",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271607",
            "leftCorner": {
              "x": 6.311,
              "y": -7.442,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.366,
              "y": -7.488,
              "z": 1.198
            },
            "gtin": "4066447713480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271608",
            "leftCorner": {
              "x": 6.366,
              "y": -7.488,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.422,
              "y": -7.534,
              "z": 1.198
            },
            "gtin": "4066447233841",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271609",
            "leftCorner": {
              "x": 6.422,
              "y": -7.534,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.452,
              "y": -7.558,
              "z": 1.198
            },
            "gtin": "4066447233827",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27160a",
            "leftCorner": {
              "x": 6.452,
              "y": -7.558,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.502,
              "y": -7.599,
              "z": 1.198
            },
            "gtin": "4066447429350",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27160b",
            "leftCorner": {
              "x": 6.502,
              "y": -7.599,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.55,
              "y": -7.639,
              "z": 1.198
            },
            "gtin": "4066447240436",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27160c",
            "leftCorner": {
              "x": 6.55,
              "y": -7.639,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.598,
              "y": -7.679,
              "z": 1.198
            },
            "gtin": "4066447215434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27160d",
            "leftCorner": {
              "x": 6.598,
              "y": -7.679,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.633,
              "y": -7.708,
              "z": 1.198
            },
            "gtin": "4066447240375",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27160e",
            "leftCorner": {
              "x": 6.633,
              "y": -7.708,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.682,
              "y": -7.748,
              "z": 1.198
            },
            "gtin": "4066447880472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27160f",
            "leftCorner": {
              "x": 6.682,
              "y": -7.748,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.711,
              "y": -7.772,
              "z": 1.198
            },
            "gtin": "4066447880496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271610",
            "leftCorner": {
              "x": 6.711,
              "y": -7.772,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.749,
              "y": -7.803,
              "z": 1.198
            },
            "gtin": "4066447859690",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271611",
            "leftCorner": {
              "x": 6.749,
              "y": -7.803,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.809,
              "y": -7.853,
              "z": 1.198
            },
            "gtin": "4067796153828",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271612",
            "leftCorner": {
              "x": 6.809,
              "y": -7.853,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.862,
              "y": -7.897,
              "z": 1.198
            },
            "gtin": "4066447577433",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271613",
            "leftCorner": {
              "x": 6.862,
              "y": -7.897,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.885,
              "y": -7.915,
              "z": 1.198
            },
            "gtin": "4066447577433",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271614",
            "leftCorner": {
              "x": 6.885,
              "y": -7.915,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.927,
              "y": -7.95,
              "z": 1.198
            },
            "gtin": "4066447879780",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271615",
            "leftCorner": {
              "x": 6.927,
              "y": -7.95,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.983,
              "y": -7.996,
              "z": 1.198
            },
            "gtin": "4066447465341",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ab2",
        "height": 1.4516,
        "facings": [
          {
            "id": "696ebf7043c343680a271575",
            "leftCorner": {
              "x": 6.157,
              "y": -7.316,
              "z": 1.452
            },
            "rightCorner": {
              "x": 6.185,
              "y": -7.339,
              "z": 1.452
            },
            "gtin": "4067796202830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271577",
            "leftCorner": {
              "x": 6.185,
              "y": -7.339,
              "z": 1.452
            },
            "rightCorner": {
              "x": 6.265,
              "y": -7.405,
              "z": 1.452
            },
            "gtin": "4066447438765",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271578",
            "leftCorner": {
              "x": 6.265,
              "y": -7.405,
              "z": 1.452
            },
            "rightCorner": {
              "x": 6.435,
              "y": -7.545,
              "z": 1.452
            },
            "gtin": "4066447411126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271579",
            "leftCorner": {
              "x": 6.435,
              "y": -7.545,
              "z": 1.452
            },
            "rightCorner": {
              "x": 6.478,
              "y": -7.58,
              "z": 1.452
            },
            "gtin": "4066447215939",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27157a",
            "leftCorner": {
              "x": 6.478,
              "y": -7.58,
              "z": 1.452
            },
            "rightCorner": {
              "x": 6.518,
              "y": -7.614,
              "z": 1.452
            },
            "gtin": "4066447892710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27157b",
            "leftCorner": {
              "x": 6.518,
              "y": -7.614,
              "z": 1.452
            },
            "rightCorner": {
              "x": 6.654,
              "y": -7.726,
              "z": 1.452
            },
            "gtin": "4067796166682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27157c",
            "leftCorner": {
              "x": 6.654,
              "y": -7.726,
              "z": 1.452
            },
            "rightCorner": {
              "x": 6.824,
              "y": -7.865,
              "z": 1.452
            },
            "gtin": "4066447245028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27157d",
            "leftCorner": {
              "x": 6.824,
              "y": -7.865,
              "z": 1.452
            },
            "rightCorner": {
              "x": 6.904,
              "y": -7.931,
              "z": 1.452
            },
            "gtin": "4058172681523",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27157e",
            "leftCorner": {
              "x": 6.904,
              "y": -7.931,
              "z": 1.452
            },
            "rightCorner": {
              "x": 6.929,
              "y": -7.952,
              "z": 1.452
            },
            "gtin": "4066447234084",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ab4",
        "height": 1.7007,
        "facings": [
          {
            "id": "696ebf7043c343680a2715b4",
            "leftCorner": {
              "x": 6.154,
              "y": -7.319,
              "z": 1.701
            },
            "rightCorner": {
              "x": 6.185,
              "y": -7.345,
              "z": 1.701
            },
            "gtin": "4066447215595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715b6",
            "leftCorner": {
              "x": 6.185,
              "y": -7.345,
              "z": 1.701
            },
            "rightCorner": {
              "x": 6.211,
              "y": -7.366,
              "z": 1.701
            },
            "gtin": "4006000097893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715b7",
            "leftCorner": {
              "x": 6.211,
              "y": -7.366,
              "z": 1.701
            },
            "rightCorner": {
              "x": 6.256,
              "y": -7.403,
              "z": 1.701
            },
            "gtin": "4058172681615",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715b8",
            "leftCorner": {
              "x": 6.256,
              "y": -7.403,
              "z": 1.701
            },
            "rightCorner": {
              "x": 6.356,
              "y": -7.486,
              "z": 1.701
            },
            "gtin": "4066447215786",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715b9",
            "leftCorner": {
              "x": 6.356,
              "y": -7.486,
              "z": 1.701
            },
            "rightCorner": {
              "x": 6.409,
              "y": -7.53,
              "z": 1.701
            },
            "gtin": "4066447215762",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715ba",
            "leftCorner": {
              "x": 6.409,
              "y": -7.53,
              "z": 1.701
            },
            "rightCorner": {
              "x": 6.442,
              "y": -7.556,
              "z": 1.701
            },
            "gtin": "4066447321333",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715bb",
            "leftCorner": {
              "x": 6.442,
              "y": -7.556,
              "z": 1.701
            },
            "rightCorner": {
              "x": 6.496,
              "y": -7.601,
              "z": 1.701
            },
            "gtin": "4066447428872",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715bc",
            "leftCorner": {
              "x": 6.496,
              "y": -7.601,
              "z": 1.701
            },
            "rightCorner": {
              "x": 6.554,
              "y": -7.649,
              "z": 1.701
            },
            "gtin": "4066447428865",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715bd",
            "leftCorner": {
              "x": 6.554,
              "y": -7.649,
              "z": 1.701
            },
            "rightCorner": {
              "x": 6.61,
              "y": -7.695,
              "z": 1.701
            },
            "gtin": "4066447245042",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715be",
            "leftCorner": {
              "x": 6.61,
              "y": -7.695,
              "z": 1.701
            },
            "rightCorner": {
              "x": 6.664,
              "y": -7.739,
              "z": 1.701
            },
            "gtin": "4058172701634",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715bf",
            "leftCorner": {
              "x": 6.664,
              "y": -7.739,
              "z": 1.701
            },
            "rightCorner": {
              "x": 6.722,
              "y": -7.787,
              "z": 1.701
            },
            "gtin": "4066447101751",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715c0",
            "leftCorner": {
              "x": 6.722,
              "y": -7.787,
              "z": 1.701
            },
            "rightCorner": {
              "x": 6.79,
              "y": -7.843,
              "z": 1.701
            },
            "gtin": "4066447101799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715c1",
            "leftCorner": {
              "x": 6.79,
              "y": -7.843,
              "z": 1.701
            },
            "rightCorner": {
              "x": 6.847,
              "y": -7.89,
              "z": 1.701
            },
            "gtin": "4066447244847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715c2",
            "leftCorner": {
              "x": 6.847,
              "y": -7.89,
              "z": 1.701
            },
            "rightCorner": {
              "x": 6.926,
              "y": -7.955,
              "z": 1.701
            },
            "gtin": "4058172938207",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc046959931",
    "name": "68e7572eb5fe7bc046959931",
    "x": 6.9241,
    "y": -8.0265,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.36209,
      "w": 0.93214
    },
    "statistics": {
      "hasStockCount": 52,
      "noStockCount": 3,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73abf",
        "height": 0.17443,
        "facings": [
          {
            "id": "696ebf7043c343680a271419",
            "leftCorner": {
              "x": 6.893,
              "y": -8.06,
              "z": 0.174
            },
            "rightCorner": {
              "x": 6.962,
              "y": -8.118,
              "z": 0.174
            },
            "gtin": "4003573020068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27141a",
            "leftCorner": {
              "x": 6.959,
              "y": -8.121,
              "z": 0.174
            },
            "rightCorner": {
              "x": 7.026,
              "y": -8.182,
              "z": 0.174
            },
            "gtin": "4003573020044",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27141b",
            "leftCorner": {
              "x": 7.026,
              "y": -8.182,
              "z": 0.174
            },
            "rightCorner": {
              "x": 7.056,
              "y": -8.209,
              "z": 0.174
            },
            "gtin": "4003573115030",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27141c",
            "leftCorner": {
              "x": 7.056,
              "y": -8.209,
              "z": 0.174
            },
            "rightCorner": {
              "x": 7.087,
              "y": -8.238,
              "z": 0.174
            },
            "gtin": "4003573115030",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27141d",
            "leftCorner": {
              "x": 7.087,
              "y": -8.238,
              "z": 0.174
            },
            "rightCorner": {
              "x": 7.138,
              "y": -8.285,
              "z": 0.174
            },
            "gtin": "4003573021850",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27141e",
            "leftCorner": {
              "x": 7.138,
              "y": -8.285,
              "z": 0.174
            },
            "rightCorner": {
              "x": 7.216,
              "y": -8.357,
              "z": 0.174
            },
            "gtin": "4003573023137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27141f",
            "leftCorner": {
              "x": 7.216,
              "y": -8.357,
              "z": 0.174
            },
            "rightCorner": {
              "x": 7.293,
              "y": -8.427,
              "z": 0.174
            },
            "gtin": "4003573023137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271420",
            "leftCorner": {
              "x": 7.293,
              "y": -8.427,
              "z": 0.174
            },
            "rightCorner": {
              "x": 7.361,
              "y": -8.489,
              "z": 0.174
            },
            "gtin": "4003573021072",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271421",
            "leftCorner": {
              "x": 7.361,
              "y": -8.489,
              "z": 0.174
            },
            "rightCorner": {
              "x": 7.424,
              "y": -8.547,
              "z": 0.174
            },
            "gtin": "4003573020143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271422",
            "leftCorner": {
              "x": 7.424,
              "y": -8.547,
              "z": 0.174
            },
            "rightCorner": {
              "x": 7.505,
              "y": -8.621,
              "z": 0.174
            },
            "gtin": "4003573023250",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271423",
            "leftCorner": {
              "x": 7.505,
              "y": -8.621,
              "z": 0.174
            },
            "rightCorner": {
              "x": 7.577,
              "y": -8.687,
              "z": 0.174
            },
            "gtin": "4003573023113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271424",
            "leftCorner": {
              "x": 7.577,
              "y": -8.687,
              "z": 0.174
            },
            "rightCorner": {
              "x": 7.639,
              "y": -8.743,
              "z": 0.174
            },
            "gtin": "4003573121543",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73abc",
        "height": 0.43768,
        "facings": [
          {
            "id": "696ebf7043c343680a271539",
            "leftCorner": {
              "x": 6.963,
              "y": -7.984,
              "z": 0.438
            },
            "rightCorner": {
              "x": 7.033,
              "y": -8.042,
              "z": 0.438
            },
            "gtin": "4003573124063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27153a",
            "leftCorner": {
              "x": 7.03,
              "y": -8.046,
              "z": 0.438
            },
            "rightCorner": {
              "x": 7.106,
              "y": -8.115,
              "z": 0.438
            },
            "gtin": "4003573021348",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27153b",
            "leftCorner": {
              "x": 7.106,
              "y": -8.115,
              "z": 0.438
            },
            "rightCorner": {
              "x": 7.191,
              "y": -8.193,
              "z": 0.438
            },
            "gtin": "4003573021331",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27153c",
            "leftCorner": {
              "x": 7.191,
              "y": -8.193,
              "z": 0.438
            },
            "rightCorner": {
              "x": 7.263,
              "y": -8.259,
              "z": 0.438
            },
            "gtin": "4003573021355",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27153d",
            "leftCorner": {
              "x": 7.263,
              "y": -8.259,
              "z": 0.438
            },
            "rightCorner": {
              "x": 7.355,
              "y": -8.343,
              "z": 0.438
            },
            "gtin": "4003573121222",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27153e",
            "leftCorner": {
              "x": 7.355,
              "y": -8.343,
              "z": 0.438
            },
            "rightCorner": {
              "x": 7.428,
              "y": -8.409,
              "z": 0.438
            },
            "gtin": "4003573023144",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27153f",
            "leftCorner": {
              "x": 7.428,
              "y": -8.409,
              "z": 0.438
            },
            "rightCorner": {
              "x": 7.499,
              "y": -8.475,
              "z": 0.438
            },
            "gtin": "4003573023120",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271540",
            "leftCorner": {
              "x": 7.499,
              "y": -8.475,
              "z": 0.438
            },
            "rightCorner": {
              "x": 7.563,
              "y": -8.533,
              "z": 0.438
            },
            "gtin": "4003573023151",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271541",
            "leftCorner": {
              "x": 7.563,
              "y": -8.533,
              "z": 0.438
            },
            "rightCorner": {
              "x": 7.629,
              "y": -8.594,
              "z": 0.438
            },
            "gtin": "5010724000434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271542",
            "leftCorner": {
              "x": 7.629,
              "y": -8.594,
              "z": 0.438
            },
            "rightCorner": {
              "x": 7.701,
              "y": -8.659,
              "z": 0.438
            },
            "gtin": "5010724000328",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ab9",
        "height": 0.68849,
        "facings": [
          {
            "id": "696ebf7043c343680a2714ee",
            "leftCorner": {
              "x": 6.965,
              "y": -7.982,
              "z": 0.688
            },
            "rightCorner": {
              "x": 7.037,
              "y": -8.042,
              "z": 0.688
            },
            "gtin": "4003573022130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714ef",
            "leftCorner": {
              "x": 7.034,
              "y": -8.046,
              "z": 0.688
            },
            "rightCorner": {
              "x": 7.105,
              "y": -8.111,
              "z": 0.688
            },
            "gtin": "4003573022000",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714f0",
            "leftCorner": {
              "x": 7.105,
              "y": -8.111,
              "z": 0.688
            },
            "rightCorner": {
              "x": 7.192,
              "y": -8.19,
              "z": 0.688
            },
            "gtin": "4003573022154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714f1",
            "leftCorner": {
              "x": 7.192,
              "y": -8.19,
              "z": 0.688
            },
            "rightCorner": {
              "x": 7.265,
              "y": -8.257,
              "z": 0.688
            },
            "gtin": "4260199896570",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714f2",
            "leftCorner": {
              "x": 7.265,
              "y": -8.257,
              "z": 0.688
            },
            "rightCorner": {
              "x": 7.335,
              "y": -8.321,
              "z": 0.688
            },
            "gtin": "4260199892572",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714f3",
            "leftCorner": {
              "x": 7.335,
              "y": -8.321,
              "z": 0.688
            },
            "rightCorner": {
              "x": 7.408,
              "y": -8.388,
              "z": 0.688
            },
            "gtin": "4260199892503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714f4",
            "leftCorner": {
              "x": 7.408,
              "y": -8.388,
              "z": 0.688
            },
            "rightCorner": {
              "x": 7.476,
              "y": -8.45,
              "z": 0.688
            },
            "gtin": "4260199892473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714f5",
            "leftCorner": {
              "x": 7.476,
              "y": -8.45,
              "z": 0.688
            },
            "rightCorner": {
              "x": 7.545,
              "y": -8.513,
              "z": 0.688
            },
            "gtin": "4260199892305",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714f6",
            "leftCorner": {
              "x": 7.545,
              "y": -8.513,
              "z": 0.688
            },
            "rightCorner": {
              "x": 7.63,
              "y": -8.591,
              "z": 0.688
            },
            "gtin": "4260199895580",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714f7",
            "leftCorner": {
              "x": 7.63,
              "y": -8.591,
              "z": 0.688
            },
            "rightCorner": {
              "x": 7.741,
              "y": -8.693,
              "z": 0.688
            },
            "gtin": "4260199896037",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73abe",
        "height": 0.93971,
        "facings": [
          {
            "id": "696ebf7043c343680a2714a8",
            "leftCorner": {
              "x": 6.964,
              "y": -7.983,
              "z": 0.94
            },
            "rightCorner": {
              "x": 7.039,
              "y": -8.045,
              "z": 0.94
            },
            "gtin": "3600542500500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714a9",
            "leftCorner": {
              "x": 7.036,
              "y": -8.049,
              "z": 0.94
            },
            "rightCorner": {
              "x": 7.139,
              "y": -8.142,
              "z": 0.94
            },
            "gtin": "3600542383523",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714aa",
            "leftCorner": {
              "x": 7.139,
              "y": -8.142,
              "z": 0.94
            },
            "rightCorner": {
              "x": 7.232,
              "y": -8.228,
              "z": 0.94
            },
            "gtin": "3600541943506",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714ab",
            "leftCorner": {
              "x": 7.232,
              "y": -8.228,
              "z": 0.94
            },
            "rightCorner": {
              "x": 7.326,
              "y": -8.314,
              "z": 0.94
            },
            "gtin": "3600542427531",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714ac",
            "leftCorner": {
              "x": 7.326,
              "y": -8.314,
              "z": 0.94
            },
            "rightCorner": {
              "x": 7.42,
              "y": -8.4,
              "z": 0.94
            },
            "gtin": "3600542545228",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714ad",
            "leftCorner": {
              "x": 7.42,
              "y": -8.4,
              "z": 0.94
            },
            "rightCorner": {
              "x": 7.512,
              "y": -8.484,
              "z": 0.94
            },
            "gtin": "3600542649490",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714ae",
            "leftCorner": {
              "x": 7.512,
              "y": -8.484,
              "z": 0.94
            },
            "rightCorner": {
              "x": 7.606,
              "y": -8.57,
              "z": 0.94
            },
            "gtin": "4260544081828",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73abd",
        "height": 1.1966,
        "facings": [
          {
            "id": "696ebf7043c343680a271616",
            "leftCorner": {
              "x": 7.011,
              "y": -8.035,
              "z": 1.197
            },
            "rightCorner": {
              "x": 7.066,
              "y": -8.086,
              "z": 1.197
            },
            "gtin": "4084200772901",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271617",
            "leftCorner": {
              "x": 7.066,
              "y": -8.086,
              "z": 1.197
            },
            "rightCorner": {
              "x": 7.12,
              "y": -8.135,
              "z": 1.197
            },
            "gtin": "4084200771904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271618",
            "leftCorner": {
              "x": 7.12,
              "y": -8.135,
              "z": 1.197
            },
            "rightCorner": {
              "x": 7.17,
              "y": -8.181,
              "z": 1.197
            },
            "gtin": "3600541594838",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271619",
            "leftCorner": {
              "x": 7.17,
              "y": -8.181,
              "z": 1.197
            },
            "rightCorner": {
              "x": 7.217,
              "y": -8.224,
              "z": 1.197
            },
            "gtin": "3600540885036",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27161a",
            "leftCorner": {
              "x": 7.217,
              "y": -8.224,
              "z": 1.197
            },
            "rightCorner": {
              "x": 7.281,
              "y": -8.283,
              "z": 1.197
            },
            "gtin": "3600542488037",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27161b",
            "leftCorner": {
              "x": 7.281,
              "y": -8.283,
              "z": 1.197
            },
            "rightCorner": {
              "x": 7.344,
              "y": -8.34,
              "z": 1.197
            },
            "gtin": "3600542648547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27161c",
            "leftCorner": {
              "x": 7.344,
              "y": -8.34,
              "z": 1.197
            },
            "rightCorner": {
              "x": 7.401,
              "y": -8.393,
              "z": 1.197
            },
            "gtin": "3600542317016",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27161d",
            "leftCorner": {
              "x": 7.401,
              "y": -8.393,
              "z": 1.197
            },
            "rightCorner": {
              "x": 7.486,
              "y": -8.47,
              "z": 1.197
            },
            "gtin": "3600542317016",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27161e",
            "leftCorner": {
              "x": 7.486,
              "y": -8.47,
              "z": 1.197
            },
            "rightCorner": {
              "x": 7.575,
              "y": -8.551,
              "z": 1.197
            },
            "gtin": "4084200774905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27161f",
            "leftCorner": {
              "x": 7.575,
              "y": -8.551,
              "z": 1.197
            },
            "rightCorner": {
              "x": 7.687,
              "y": -8.654,
              "z": 1.197
            },
            "gtin": "3600542497916",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73abb",
        "height": 1.4484,
        "facings": [
          {
            "id": "696ebf7043c343680a27157f",
            "leftCorner": {
              "x": 6.96,
              "y": -7.988,
              "z": 1.448
            },
            "rightCorner": {
              "x": 7.026,
              "y": -8.042,
              "z": 1.448
            },
            "gtin": "4058172681554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271580",
            "leftCorner": {
              "x": 7.023,
              "y": -8.045,
              "z": 1.448
            },
            "rightCorner": {
              "x": 7.068,
              "y": -8.087,
              "z": 1.448
            },
            "gtin": "3600541698482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271581",
            "leftCorner": {
              "x": 7.068,
              "y": -8.087,
              "z": 1.448
            },
            "rightCorner": {
              "x": 7.12,
              "y": -8.134,
              "z": 1.448
            },
            "gtin": "3600542411608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271582",
            "leftCorner": {
              "x": 7.12,
              "y": -8.134,
              "z": 1.448
            },
            "rightCorner": {
              "x": 7.183,
              "y": -8.192,
              "z": 1.448
            },
            "gtin": "3600542098052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271583",
            "leftCorner": {
              "x": 7.183,
              "y": -8.192,
              "z": 1.448
            },
            "rightCorner": {
              "x": 7.233,
              "y": -8.238,
              "z": 1.448
            },
            "gtin": "3600541594814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271584",
            "leftCorner": {
              "x": 7.233,
              "y": -8.238,
              "z": 1.448
            },
            "rightCorner": {
              "x": 7.284,
              "y": -8.284,
              "z": 1.448
            },
            "gtin": "3600542326254",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271585",
            "leftCorner": {
              "x": 7.284,
              "y": -8.284,
              "z": 1.448
            },
            "rightCorner": {
              "x": 7.336,
              "y": -8.332,
              "z": 1.448
            },
            "gtin": "3600542326254",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271586",
            "leftCorner": {
              "x": 7.336,
              "y": -8.332,
              "z": 1.448
            },
            "rightCorner": {
              "x": 7.381,
              "y": -8.373,
              "z": 1.448
            },
            "gtin": "3600541744554",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271587",
            "leftCorner": {
              "x": 7.381,
              "y": -8.373,
              "z": 1.448
            },
            "rightCorner": {
              "x": 7.514,
              "y": -8.495,
              "z": 1.448
            },
            "gtin": "3600542633628",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271588",
            "leftCorner": {
              "x": 7.514,
              "y": -8.495,
              "z": 1.448
            },
            "rightCorner": {
              "x": 7.602,
              "y": -8.575,
              "z": 1.448
            },
            "gtin": "3600542628549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271589",
            "leftCorner": {
              "x": 7.602,
              "y": -8.575,
              "z": 1.448
            },
            "rightCorner": {
              "x": 7.633,
              "y": -8.604,
              "z": 1.448
            },
            "gtin": "4006000197869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27158a",
            "leftCorner": {
              "x": 7.629,
              "y": -8.612,
              "z": 1.451
            },
            "rightCorner": {
              "x": 7.673,
              "y": -8.652,
              "z": 1.451
            },
            "gtin": "4006000154626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27158b",
            "leftCorner": {
              "x": 7.674,
              "y": -8.651,
              "z": 1.451
            },
            "rightCorner": {
              "x": 7.704,
              "y": -8.678,
              "z": 1.451
            },
            "gtin": "4006000054810",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aba",
        "height": 1.7006,
        "facings": [
          {
            "id": "696ebf7043c343680a2715c3",
            "leftCorner": {
              "x": 6.959,
              "y": -7.988,
              "z": 1.701
            },
            "rightCorner": {
              "x": 7.013,
              "y": -8.033,
              "z": 1.701
            },
            "gtin": "3600542415095",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715c4",
            "leftCorner": {
              "x": 7.01,
              "y": -8.035,
              "z": 1.701
            },
            "rightCorner": {
              "x": 7.055,
              "y": -8.076,
              "z": 1.701
            },
            "gtin": "3600542414975",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715c5",
            "leftCorner": {
              "x": 7.055,
              "y": -8.076,
              "z": 1.701
            },
            "rightCorner": {
              "x": 7.103,
              "y": -8.12,
              "z": 1.701
            },
            "gtin": "3600541163638",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715c6",
            "leftCorner": {
              "x": 7.103,
              "y": -8.12,
              "z": 1.701
            },
            "rightCorner": {
              "x": 7.148,
              "y": -8.161,
              "z": 1.701
            },
            "gtin": "3600541163645",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715c7",
            "leftCorner": {
              "x": 7.148,
              "y": -8.161,
              "z": 1.701
            },
            "rightCorner": {
              "x": 7.21,
              "y": -8.218,
              "z": 1.701
            },
            "gtin": "3600542642897",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715c8",
            "leftCorner": {
              "x": 7.21,
              "y": -8.218,
              "z": 1.701
            },
            "rightCorner": {
              "x": 7.264,
              "y": -8.268,
              "z": 1.701
            },
            "gtin": "3600542648523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715c9",
            "leftCorner": {
              "x": 7.264,
              "y": -8.268,
              "z": 1.701
            },
            "rightCorner": {
              "x": 7.364,
              "y": -8.359,
              "z": 1.701
            },
            "gtin": "3600542642903",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715ca",
            "leftCorner": {
              "x": 7.364,
              "y": -8.359,
              "z": 1.701
            },
            "rightCorner": {
              "x": 7.454,
              "y": -8.442,
              "z": 1.701
            },
            "gtin": "3600542595971",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715cb",
            "leftCorner": {
              "x": 7.454,
              "y": -8.442,
              "z": 1.701
            },
            "rightCorner": {
              "x": 7.561,
              "y": -8.539,
              "z": 1.701
            },
            "gtin": "3600542514118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715cc",
            "leftCorner": {
              "x": 7.561,
              "y": -8.539,
              "z": 1.701
            },
            "rightCorner": {
              "x": 7.605,
              "y": -8.58,
              "z": 1.701
            },
            "gtin": "3600542541398",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715cd",
            "leftCorner": {
              "x": 7.605,
              "y": -8.58,
              "z": 1.701
            },
            "rightCorner": {
              "x": 7.663,
              "y": -8.633,
              "z": 1.701
            },
            "gtin": "3600542658317",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715ce",
            "leftCorner": {
              "x": 7.663,
              "y": -8.633,
              "z": 1.701
            },
            "rightCorner": {
              "x": 7.698,
              "y": -8.665,
              "z": 1.701
            },
            "gtin": "3600542658423",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc046959932",
    "name": "68e7572eb5fe7bc046959932",
    "x": 7.6618,
    "y": -8.7065,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.34843,
      "w": 0.93734
    },
    "statistics": {
      "hasStockCount": 36,
      "noStockCount": 9,
      "unknownStockCount": 33
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73ac7",
        "height": 0.17565,
        "facings": [
          {
            "id": "696ebf7043c343680a271425",
            "leftCorner": {
              "x": 7.641,
              "y": -8.748,
              "z": 0.176
            },
            "rightCorner": {
              "x": 7.717,
              "y": -8.814,
              "z": 0.176
            },
            "gtin": "4003573020860",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271426",
            "leftCorner": {
              "x": 7.717,
              "y": -8.814,
              "z": 0.176
            },
            "rightCorner": {
              "x": 7.777,
              "y": -8.865,
              "z": 0.176
            },
            "gtin": "4003573023168",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271427",
            "leftCorner": {
              "x": 7.777,
              "y": -8.865,
              "z": 0.176
            },
            "rightCorner": {
              "x": 7.848,
              "y": -8.927,
              "z": 0.176
            },
            "gtin": "4003573021393",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271428",
            "leftCorner": {
              "x": 7.848,
              "y": -8.927,
              "z": 0.176
            },
            "rightCorner": {
              "x": 7.925,
              "y": -8.993,
              "z": 0.176
            },
            "gtin": "4005120141035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271429",
            "leftCorner": {
              "x": 7.925,
              "y": -8.993,
              "z": 0.176
            },
            "rightCorner": {
              "x": 7.987,
              "y": -9.046,
              "z": 0.176
            },
            "gtin": "4005120412036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27142a",
            "leftCorner": {
              "x": 7.987,
              "y": -9.046,
              "z": 0.176
            },
            "rightCorner": {
              "x": 8.049,
              "y": -9.1,
              "z": 0.176
            },
            "gtin": "4063528090751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27142b",
            "leftCorner": {
              "x": 8.049,
              "y": -9.1,
              "z": 0.176
            },
            "rightCorner": {
              "x": 8.112,
              "y": -9.155,
              "z": 0.176
            },
            "gtin": "4063528090744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27142c",
            "leftCorner": {
              "x": 8.112,
              "y": -9.155,
              "z": 0.176
            },
            "rightCorner": {
              "x": 8.133,
              "y": -9.172,
              "z": 0.176
            }
          },
          {
            "id": "696ebf7043c343680a27142d",
            "leftCorner": {
              "x": 8.133,
              "y": -9.172,
              "z": 0.176
            },
            "rightCorner": {
              "x": 8.184,
              "y": -9.216,
              "z": 0.176
            },
            "gtin": "4002448044185",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27142e",
            "leftCorner": {
              "x": 8.184,
              "y": -9.216,
              "z": 0.176
            },
            "rightCorner": {
              "x": 8.342,
              "y": -9.353,
              "z": 0.176
            },
            "gtin": "4042763424293",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ac3",
        "height": 0.43614,
        "facings": [
          {
            "id": "696ebf7043c343680a271543",
            "leftCorner": {
              "x": 7.7,
              "y": -8.663,
              "z": 0.436
            },
            "rightCorner": {
              "x": 7.727,
              "y": -8.688,
              "z": 0.436
            },
            "gtin": "5010724000526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271544",
            "leftCorner": {
              "x": 7.728,
              "y": -8.687,
              "z": 0.436
            },
            "rightCorner": {
              "x": 7.806,
              "y": -8.754,
              "z": 0.436
            },
            "gtin": "4036581540266",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271545",
            "leftCorner": {
              "x": 7.806,
              "y": -8.754,
              "z": 0.436
            },
            "rightCorner": {
              "x": 7.913,
              "y": -8.846,
              "z": 0.436
            },
            "gtin": "4260544087899",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271546",
            "leftCorner": {
              "x": 7.913,
              "y": -8.846,
              "z": 0.436
            },
            "rightCorner": {
              "x": 7.981,
              "y": -8.905,
              "z": 0.436
            },
            "gtin": "4260560832817",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271547",
            "leftCorner": {
              "x": 7.981,
              "y": -8.905,
              "z": 0.436
            },
            "rightCorner": {
              "x": 8.017,
              "y": -8.936,
              "z": 0.436
            },
            "gtin": "4260560831063",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271548",
            "leftCorner": {
              "x": 8.017,
              "y": -8.936,
              "z": 0.436
            },
            "rightCorner": {
              "x": 8.057,
              "y": -8.971,
              "z": 0.436
            },
            "gtin": "4005900973924",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271549",
            "leftCorner": {
              "x": 8.057,
              "y": -8.971,
              "z": 0.436
            },
            "rightCorner": {
              "x": 8.107,
              "y": -9.014,
              "z": 0.436
            },
            "gtin": "4006000110974",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27154a",
            "leftCorner": {
              "x": 8.107,
              "y": -9.014,
              "z": 0.436
            },
            "rightCorner": {
              "x": 8.152,
              "y": -9.053,
              "z": 0.436
            },
            "gtin": "4005900973887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27154b",
            "leftCorner": {
              "x": 8.152,
              "y": -9.053,
              "z": 0.436
            },
            "rightCorner": {
              "x": 8.215,
              "y": -9.107,
              "z": 0.436
            },
            "gtin": "4006000092423",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27154c",
            "leftCorner": {
              "x": 8.215,
              "y": -9.107,
              "z": 0.436
            },
            "rightCorner": {
              "x": 8.275,
              "y": -9.159,
              "z": 0.436
            },
            "gtin": "4006000174341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27154d",
            "leftCorner": {
              "x": 8.275,
              "y": -9.159,
              "z": 0.436
            },
            "rightCorner": {
              "x": 8.301,
              "y": -9.181,
              "z": 0.436
            },
            "gtin": "4006000174341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27154e",
            "leftCorner": {
              "x": 8.301,
              "y": -9.181,
              "z": 0.436
            },
            "rightCorner": {
              "x": 8.354,
              "y": -9.227,
              "z": 0.436
            },
            "gtin": "4006000004662",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27154f",
            "leftCorner": {
              "x": 8.354,
              "y": -9.227,
              "z": 0.436
            },
            "rightCorner": {
              "x": 8.422,
              "y": -9.286,
              "z": 0.436
            },
            "gtin": "4005900973962",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271550",
            "leftCorner": {
              "x": 8.422,
              "y": -9.286,
              "z": 0.436
            },
            "rightCorner": {
              "x": 8.478,
              "y": -9.334,
              "z": 0.436
            },
            "gtin": "4006000085845",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ac6",
        "height": 0.68567,
        "facings": [
          {
            "id": "696ebf7043c343680a2714fb",
            "leftCorner": {
              "x": 7.994,
              "y": -8.917,
              "z": 0.686
            },
            "rightCorner": {
              "x": 8.018,
              "y": -8.938,
              "z": 0.686
            }
          },
          {
            "id": "696ebf7043c343680a2714f8",
            "leftCorner": {
              "x": 7.74,
              "y": -8.698,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.843,
              "y": -8.787,
              "z": 0.686
            },
            "gtin": "8809747963751",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714f9",
            "leftCorner": {
              "x": 7.843,
              "y": -8.787,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.925,
              "y": -8.858,
              "z": 0.686
            },
            "gtin": "8809747963805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714fa",
            "leftCorner": {
              "x": 7.925,
              "y": -8.858,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.994,
              "y": -8.917,
              "z": 0.686
            },
            "gtin": "4006000182674",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714fc",
            "leftCorner": {
              "x": 8.018,
              "y": -8.938,
              "z": 0.686
            },
            "rightCorner": {
              "x": 8.065,
              "y": -8.979,
              "z": 0.686
            },
            "gtin": "4006000019178",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714fd",
            "leftCorner": {
              "x": 8.065,
              "y": -8.979,
              "z": 0.686
            },
            "rightCorner": {
              "x": 8.112,
              "y": -9.019,
              "z": 0.686
            },
            "gtin": "4006000019215",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714fe",
            "leftCorner": {
              "x": 8.112,
              "y": -9.019,
              "z": 0.686
            },
            "rightCorner": {
              "x": 8.162,
              "y": -9.062,
              "z": 0.686
            },
            "gtin": "4006000019253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714ff",
            "leftCorner": {
              "x": 8.162,
              "y": -9.062,
              "z": 0.686
            },
            "rightCorner": {
              "x": 8.225,
              "y": -9.117,
              "z": 0.686
            },
            "gtin": "4006000068237",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271500",
            "leftCorner": {
              "x": 8.225,
              "y": -9.117,
              "z": 0.686
            },
            "rightCorner": {
              "x": 8.358,
              "y": -9.231,
              "z": 0.686
            },
            "gtin": "4006000004471",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271501",
            "leftCorner": {
              "x": 8.358,
              "y": -9.231,
              "z": 0.686
            },
            "rightCorner": {
              "x": 8.382,
              "y": -9.252,
              "z": 0.686
            },
            "gtin": "4005900682758",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271502",
            "leftCorner": {
              "x": 8.384,
              "y": -9.258,
              "z": 0.686
            },
            "rightCorner": {
              "x": 8.431,
              "y": -9.299,
              "z": 0.686
            },
            "gtin": "4005900803238",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ac4",
        "height": 0.9388,
        "facings": [
          {
            "id": "696ebf7043c343680a2714af",
            "leftCorner": {
              "x": 7.606,
              "y": -8.57,
              "z": 0.94
            },
            "rightCorner": {
              "x": 7.763,
              "y": -8.714,
              "z": 0.94
            },
            "gtin": "4006000085517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714b0",
            "leftCorner": {
              "x": 7.762,
              "y": -8.717,
              "z": 0.939
            },
            "rightCorner": {
              "x": 7.861,
              "y": -8.802,
              "z": 0.939
            },
            "gtin": "4006000087719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714b1",
            "leftCorner": {
              "x": 7.861,
              "y": -8.802,
              "z": 0.939
            },
            "rightCorner": {
              "x": 7.924,
              "y": -8.856,
              "z": 0.939
            },
            "gtin": "4006000085241",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714b2",
            "leftCorner": {
              "x": 7.924,
              "y": -8.856,
              "z": 0.939
            },
            "rightCorner": {
              "x": 7.977,
              "y": -8.902,
              "z": 0.939
            },
            "gtin": "4006000085241",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714b3",
            "leftCorner": {
              "x": 7.977,
              "y": -8.902,
              "z": 0.939
            },
            "rightCorner": {
              "x": 8.007,
              "y": -8.928,
              "z": 0.939
            },
            "gtin": "4005900935304",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714b4",
            "leftCorner": {
              "x": 8.007,
              "y": -8.928,
              "z": 0.939
            },
            "rightCorner": {
              "x": 8.032,
              "y": -8.95,
              "z": 0.939
            },
            "gtin": "4005900935304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714b5",
            "leftCorner": {
              "x": 8.032,
              "y": -8.95,
              "z": 0.939
            },
            "rightCorner": {
              "x": 8.084,
              "y": -8.995,
              "z": 0.939
            },
            "gtin": "4005900935342",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714b6",
            "leftCorner": {
              "x": 8.084,
              "y": -8.995,
              "z": 0.939
            },
            "rightCorner": {
              "x": 8.107,
              "y": -9.014,
              "z": 0.939
            },
            "gtin": "4005900737427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714b7",
            "leftCorner": {
              "x": 8.107,
              "y": -9.014,
              "z": 0.939
            },
            "rightCorner": {
              "x": 8.147,
              "y": -9.049,
              "z": 0.939
            },
            "gtin": "4005900737427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714b8",
            "leftCorner": {
              "x": 8.147,
              "y": -9.049,
              "z": 0.939
            },
            "rightCorner": {
              "x": 8.168,
              "y": -9.067,
              "z": 0.939
            }
          },
          {
            "id": "696ebf7043c343680a2714b9",
            "leftCorner": {
              "x": 8.168,
              "y": -9.067,
              "z": 0.939
            },
            "rightCorner": {
              "x": 8.251,
              "y": -9.139,
              "z": 0.939
            },
            "gtin": "4005900935267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714ba",
            "leftCorner": {
              "x": 8.251,
              "y": -9.139,
              "z": 0.939
            },
            "rightCorner": {
              "x": 8.394,
              "y": -9.262,
              "z": 0.939
            },
            "gtin": "4005808195862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714bb",
            "leftCorner": {
              "x": 8.394,
              "y": -9.262,
              "z": 0.939
            },
            "rightCorner": {
              "x": 8.496,
              "y": -9.35,
              "z": 0.939
            }
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ac5",
        "height": 1.1954,
        "facings": [
          {
            "id": "696ebf7043c343680a271620",
            "leftCorner": {
              "x": 7.699,
              "y": -8.664,
              "z": 1.195
            },
            "rightCorner": {
              "x": 7.809,
              "y": -8.765,
              "z": 1.195
            },
            "gtin": "4006000111650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271621",
            "leftCorner": {
              "x": 7.812,
              "y": -8.762,
              "z": 1.195
            },
            "rightCorner": {
              "x": 7.875,
              "y": -8.816,
              "z": 1.195
            },
            "gtin": "4005900933522",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271622",
            "leftCorner": {
              "x": 7.875,
              "y": -8.816,
              "z": 1.195
            },
            "rightCorner": {
              "x": 7.931,
              "y": -8.864,
              "z": 1.195
            },
            "gtin": "4006000111735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271623",
            "leftCorner": {
              "x": 7.931,
              "y": -8.864,
              "z": 1.195
            },
            "rightCorner": {
              "x": 7.988,
              "y": -8.914,
              "z": 1.195
            },
            "gtin": "4006000111773",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271624",
            "leftCorner": {
              "x": 7.988,
              "y": -8.914,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.018,
              "y": -8.94,
              "z": 1.195
            },
            "gtin": "4006000085203",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271625",
            "leftCorner": {
              "x": 8.018,
              "y": -8.94,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.046,
              "y": -8.964,
              "z": 1.195
            },
            "gtin": "4006000085203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271626",
            "leftCorner": {
              "x": 8.046,
              "y": -8.964,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.104,
              "y": -9.013,
              "z": 1.195
            },
            "gtin": "4006000085036",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271627",
            "leftCorner": {
              "x": 8.104,
              "y": -9.013,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.154,
              "y": -9.056,
              "z": 1.195
            },
            "gtin": "4006000085166",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271628",
            "leftCorner": {
              "x": 8.154,
              "y": -9.056,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.208,
              "y": -9.103,
              "z": 1.195
            },
            "gtin": "4006000085166",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271629",
            "leftCorner": {
              "x": 8.208,
              "y": -9.103,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.344,
              "y": -9.22,
              "z": 1.195
            },
            "gtin": "4006000180298",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27162a",
            "leftCorner": {
              "x": 8.344,
              "y": -9.22,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.391,
              "y": -9.261,
              "z": 1.195
            },
            "gtin": "4006000093222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27162b",
            "leftCorner": {
              "x": 8.39,
              "y": -9.27,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.451,
              "y": -9.322,
              "z": 1.195
            },
            "gtin": "4006000163475",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ac2",
        "height": 1.4508,
        "facings": [
          {
            "id": "696ebf7043c343680a27158c",
            "leftCorner": {
              "x": 7.705,
              "y": -8.677,
              "z": 1.451
            },
            "rightCorner": {
              "x": 7.735,
              "y": -8.705,
              "z": 1.451
            },
            "gtin": "4005900954848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27158d",
            "leftCorner": {
              "x": 7.736,
              "y": -8.704,
              "z": 1.451
            },
            "rightCorner": {
              "x": 7.763,
              "y": -8.729,
              "z": 1.451
            },
            "gtin": "4005900956941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27158e",
            "leftCorner": {
              "x": 7.763,
              "y": -8.728,
              "z": 1.451
            },
            "rightCorner": {
              "x": 8.094,
              "y": -9.013,
              "z": 1.451
            },
            "gtin": "4006000088150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27158f",
            "leftCorner": {
              "x": 8.094,
              "y": -9.013,
              "z": 1.451
            },
            "rightCorner": {
              "x": 8.14,
              "y": -9.053,
              "z": 1.451
            },
            "gtin": "4006000088198",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271590",
            "leftCorner": {
              "x": 8.14,
              "y": -9.053,
              "z": 1.451
            },
            "rightCorner": {
              "x": 8.197,
              "y": -9.102,
              "z": 1.451
            },
            "gtin": "4005900884107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271591",
            "leftCorner": {
              "x": 8.197,
              "y": -9.102,
              "z": 1.451
            },
            "rightCorner": {
              "x": 8.269,
              "y": -9.164,
              "z": 1.451
            },
            "gtin": "4005900897367",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271592",
            "leftCorner": {
              "x": 8.269,
              "y": -9.164,
              "z": 1.451
            },
            "rightCorner": {
              "x": 8.359,
              "y": -9.241,
              "z": 1.451
            },
            "gtin": "4005900897336",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271593",
            "leftCorner": {
              "x": 8.359,
              "y": -9.241,
              "z": 1.451
            },
            "rightCorner": {
              "x": 8.397,
              "y": -9.274,
              "z": 1.451
            },
            "gtin": "4005900935427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271594",
            "leftCorner": {
              "x": 8.397,
              "y": -9.274,
              "z": 1.451
            },
            "rightCorner": {
              "x": 8.452,
              "y": -9.322,
              "z": 1.451
            },
            "gtin": "4006000168234",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ac1",
        "height": 1.6995,
        "facings": [
          {
            "id": "696ebf7043c343680a2715cf",
            "leftCorner": {
              "x": 7.696,
              "y": -8.67,
              "z": 1.7
            },
            "rightCorner": {
              "x": 7.738,
              "y": -8.709,
              "z": 1.7
            },
            "gtin": "3600542449595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715d0",
            "leftCorner": {
              "x": 7.739,
              "y": -8.708,
              "z": 1.7
            },
            "rightCorner": {
              "x": 7.774,
              "y": -8.74,
              "z": 1.7
            },
            "gtin": "3600542648615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715d1",
            "leftCorner": {
              "x": 7.775,
              "y": -8.739,
              "z": 1.7
            },
            "rightCorner": {
              "x": 7.799,
              "y": -8.761,
              "z": 1.7
            },
            "gtin": "3600542648615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715d2",
            "leftCorner": {
              "x": 7.8,
              "y": -8.76,
              "z": 1.7
            },
            "rightCorner": {
              "x": 7.933,
              "y": -8.875,
              "z": 1.7
            },
            "gtin": "3600542628365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715d3",
            "leftCorner": {
              "x": 7.933,
              "y": -8.875,
              "z": 1.7
            },
            "rightCorner": {
              "x": 8.011,
              "y": -8.942,
              "z": 1.7
            },
            "gtin": "4005900933560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715d4",
            "leftCorner": {
              "x": 8.011,
              "y": -8.942,
              "z": 1.7
            },
            "rightCorner": {
              "x": 8.07,
              "y": -8.993,
              "z": 1.7
            },
            "gtin": "4006000043364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715d5",
            "leftCorner": {
              "x": 8.07,
              "y": -8.993,
              "z": 1.7
            },
            "rightCorner": {
              "x": 8.092,
              "y": -9.012,
              "z": 1.7
            },
            "gtin": "4006000054858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715d6",
            "leftCorner": {
              "x": 8.092,
              "y": -9.012,
              "z": 1.7
            },
            "rightCorner": {
              "x": 8.122,
              "y": -9.038,
              "z": 1.7
            },
            "gtin": "4006000054858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715d7",
            "leftCorner": {
              "x": 8.122,
              "y": -9.038,
              "z": 1.7
            },
            "rightCorner": {
              "x": 8.143,
              "y": -9.056,
              "z": 1.7
            }
          },
          {
            "id": "696ebf7043c343680a2715d8",
            "leftCorner": {
              "x": 8.143,
              "y": -9.056,
              "z": 1.7
            },
            "rightCorner": {
              "x": 8.188,
              "y": -9.095,
              "z": 1.7
            },
            "gtin": "4006000043128",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715d9",
            "leftCorner": {
              "x": 8.188,
              "y": -9.095,
              "z": 1.7
            },
            "rightCorner": {
              "x": 8.231,
              "y": -9.132,
              "z": 1.7
            },
            "gtin": "4006000054957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715da",
            "leftCorner": {
              "x": 8.231,
              "y": -9.132,
              "z": 1.7
            },
            "rightCorner": {
              "x": 8.253,
              "y": -9.151,
              "z": 1.7
            }
          },
          {
            "id": "696ebf7043c343680a2715db",
            "leftCorner": {
              "x": 8.253,
              "y": -9.151,
              "z": 1.7
            },
            "rightCorner": {
              "x": 8.323,
              "y": -9.212,
              "z": 1.7
            },
            "gtin": "4006000043203",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715dc",
            "leftCorner": {
              "x": 8.323,
              "y": -9.212,
              "z": 1.7
            },
            "rightCorner": {
              "x": 8.389,
              "y": -9.269,
              "z": 1.7
            },
            "gtin": "4006000043289",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715dd",
            "leftCorner": {
              "x": 8.389,
              "y": -9.269,
              "z": 1.7
            },
            "rightCorner": {
              "x": 8.474,
              "y": -9.342,
              "z": 1.7
            },
            "gtin": "4006000054919",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc046959933",
    "name": "68e7572eb5fe7bc046959933",
    "x": 8.4208,
    "y": -9.3655,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.35275,
      "w": 0.93572
    },
    "statistics": {
      "hasStockCount": 47,
      "noStockCount": 3,
      "unknownStockCount": 50
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73ace",
        "height": 0.17518,
        "facings": [
          {
            "id": "696ebf7043c343680a27142f",
            "leftCorner": {
              "x": 8.342,
              "y": -9.353,
              "z": 0.176
            },
            "rightCorner": {
              "x": 8.447,
              "y": -9.443,
              "z": 0.176
            },
            "gtin": "3574661690483",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271430",
            "leftCorner": {
              "x": 8.448,
              "y": -9.449,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.506,
              "y": -9.5,
              "z": 0.175
            },
            "gtin": "3574661690520",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271431",
            "leftCorner": {
              "x": 8.506,
              "y": -9.5,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.53,
              "y": -9.521,
              "z": 0.175
            },
            "gtin": "3574661690520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271432",
            "leftCorner": {
              "x": 8.53,
              "y": -9.521,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.616,
              "y": -9.597,
              "z": 0.175
            },
            "gtin": "3574661690537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271433",
            "leftCorner": {
              "x": 8.616,
              "y": -9.597,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.664,
              "y": -9.639,
              "z": 0.175
            },
            "gtin": "3574661690544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271434",
            "leftCorner": {
              "x": 8.664,
              "y": -9.639,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.741,
              "y": -9.706,
              "z": 0.175
            },
            "gtin": "8717524078492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271435",
            "leftCorner": {
              "x": 8.741,
              "y": -9.706,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.779,
              "y": -9.74,
              "z": 0.175
            },
            "gtin": "4067796106688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271436",
            "leftCorner": {
              "x": 8.779,
              "y": -9.74,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.818,
              "y": -9.775,
              "z": 0.175
            },
            "gtin": "4066447321456",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271437",
            "leftCorner": {
              "x": 8.818,
              "y": -9.775,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.854,
              "y": -9.806,
              "z": 0.175
            },
            "gtin": "4067796106701",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271438",
            "leftCorner": {
              "x": 8.854,
              "y": -9.806,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.904,
              "y": -9.85,
              "z": 0.175
            },
            "gtin": "4005900108623",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271439",
            "leftCorner": {
              "x": 8.904,
              "y": -9.85,
              "z": 0.175
            },
            "rightCorner": {
              "x": 8.961,
              "y": -9.9,
              "z": 0.175
            },
            "gtin": "4005900108586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27143a",
            "leftCorner": {
              "x": 8.961,
              "y": -9.9,
              "z": 0.175
            },
            "rightCorner": {
              "x": 9.017,
              "y": -9.95,
              "z": 0.175
            },
            "gtin": "4005900108586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27143b",
            "leftCorner": {
              "x": 9.017,
              "y": -9.95,
              "z": 0.175
            },
            "rightCorner": {
              "x": 9.095,
              "y": -10.018,
              "z": 0.175
            },
            "gtin": "4066447382242",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27143c",
            "leftCorner": {
              "x": 9.095,
              "y": -10.018,
              "z": 0.175
            },
            "rightCorner": {
              "x": 9.142,
              "y": -10.059,
              "z": 0.175
            },
            "gtin": "4066447237764",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ac9",
        "height": 0.43701,
        "facings": [
          {
            "id": "696ebf7043c343680a271560",
            "leftCorner": {
              "x": 9.166,
              "y": -9.948,
              "z": 0.436
            },
            "rightCorner": {
              "x": 9.21,
              "y": -9.987,
              "z": 0.436
            },
            "gtin": "3600551186849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271551",
            "leftCorner": {
              "x": 8.479,
              "y": -9.34,
              "z": 0.437
            },
            "rightCorner": {
              "x": 8.536,
              "y": -9.39,
              "z": 0.437
            },
            "gtin": "5900116036502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271552",
            "leftCorner": {
              "x": 8.536,
              "y": -9.39,
              "z": 0.437
            },
            "rightCorner": {
              "x": 8.574,
              "y": -9.423,
              "z": 0.437
            },
            "gtin": "4260189522830",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271553",
            "leftCorner": {
              "x": 8.574,
              "y": -9.423,
              "z": 0.437
            },
            "rightCorner": {
              "x": 8.626,
              "y": -9.469,
              "z": 0.437
            },
            "gtin": "4260189522847",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271554",
            "leftCorner": {
              "x": 8.626,
              "y": -9.469,
              "z": 0.437
            },
            "rightCorner": {
              "x": 8.702,
              "y": -9.536,
              "z": 0.437
            },
            "gtin": "4260189522816",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271555",
            "leftCorner": {
              "x": 8.702,
              "y": -9.536,
              "z": 0.437
            },
            "rightCorner": {
              "x": 8.763,
              "y": -9.589,
              "z": 0.437
            },
            "gtin": "8717524075255",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271556",
            "leftCorner": {
              "x": 8.763,
              "y": -9.589,
              "z": 0.437
            },
            "rightCorner": {
              "x": 8.79,
              "y": -9.613,
              "z": 0.437
            },
            "gtin": "8717524075255",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271557",
            "leftCorner": {
              "x": 8.79,
              "y": -9.613,
              "z": 0.437
            },
            "rightCorner": {
              "x": 8.815,
              "y": -9.635,
              "z": 0.437
            }
          },
          {
            "id": "696ebf7043c343680a271558",
            "leftCorner": {
              "x": 8.815,
              "y": -9.635,
              "z": 0.437
            },
            "rightCorner": {
              "x": 8.846,
              "y": -9.663,
              "z": 0.437
            },
            "gtin": "4015000528931",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271559",
            "leftCorner": {
              "x": 8.846,
              "y": -9.663,
              "z": 0.437
            },
            "rightCorner": {
              "x": 8.896,
              "y": -9.707,
              "z": 0.437
            },
            "gtin": "8717524075316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27155a",
            "leftCorner": {
              "x": 8.896,
              "y": -9.707,
              "z": 0.437
            },
            "rightCorner": {
              "x": 8.94,
              "y": -9.745,
              "z": 0.437
            },
            "gtin": "3600551158341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27155b",
            "leftCorner": {
              "x": 8.94,
              "y": -9.745,
              "z": 0.437
            },
            "rightCorner": {
              "x": 8.979,
              "y": -9.78,
              "z": 0.437
            },
            "gtin": "3600551156668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27155c",
            "leftCorner": {
              "x": 8.979,
              "y": -9.78,
              "z": 0.437
            },
            "rightCorner": {
              "x": 9.029,
              "y": -9.824,
              "z": 0.437
            },
            "gtin": "3600551159607",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27155d",
            "leftCorner": {
              "x": 9.029,
              "y": -9.824,
              "z": 0.437
            },
            "rightCorner": {
              "x": 9.062,
              "y": -9.853,
              "z": 0.437
            },
            "gtin": "3600551156682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27155e",
            "leftCorner": {
              "x": 9.069,
              "y": -9.86,
              "z": 0.436
            },
            "rightCorner": {
              "x": 9.114,
              "y": -9.9,
              "z": 0.436
            },
            "gtin": "3600551183398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27155f",
            "leftCorner": {
              "x": 9.113,
              "y": -9.901,
              "z": 0.436
            },
            "rightCorner": {
              "x": 9.167,
              "y": -9.947,
              "z": 0.436
            },
            "gtin": "3600551187679",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aca",
        "height": 0.68624,
        "facings": [
          {
            "id": "696ebf7043c343680a271503",
            "leftCorner": {
              "x": 8.431,
              "y": -9.299,
              "z": 0.686
            },
            "rightCorner": {
              "x": 8.494,
              "y": -9.354,
              "z": 0.686
            },
            "gtin": "4015001014143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271504",
            "leftCorner": {
              "x": 8.493,
              "y": -9.354,
              "z": 0.686
            },
            "rightCorner": {
              "x": 8.524,
              "y": -9.382,
              "z": 0.686
            },
            "gtin": "4015001014426",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271505",
            "leftCorner": {
              "x": 8.524,
              "y": -9.382,
              "z": 0.686
            },
            "rightCorner": {
              "x": 8.616,
              "y": -9.462,
              "z": 0.686
            },
            "gtin": "4015100435405",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271506",
            "leftCorner": {
              "x": 8.616,
              "y": -9.462,
              "z": 0.686
            },
            "rightCorner": {
              "x": 8.729,
              "y": -9.562,
              "z": 0.686
            },
            "gtin": "4015100192032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271507",
            "leftCorner": {
              "x": 8.729,
              "y": -9.562,
              "z": 0.686
            },
            "rightCorner": {
              "x": 8.789,
              "y": -9.614,
              "z": 0.686
            },
            "gtin": "4015100201642",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271508",
            "leftCorner": {
              "x": 8.789,
              "y": -9.614,
              "z": 0.686
            },
            "rightCorner": {
              "x": 8.839,
              "y": -9.659,
              "z": 0.686
            },
            "gtin": "4015100801194",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271509",
            "leftCorner": {
              "x": 8.839,
              "y": -9.659,
              "z": 0.686
            },
            "rightCorner": {
              "x": 8.889,
              "y": -9.702,
              "z": 0.686
            },
            "gtin": "8693347001681",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27150a",
            "leftCorner": {
              "x": 8.889,
              "y": -9.702,
              "z": 0.686
            },
            "rightCorner": {
              "x": 8.928,
              "y": -9.737,
              "z": 0.686
            },
            "gtin": "4004704104091",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27150b",
            "leftCorner": {
              "x": 8.928,
              "y": -9.737,
              "z": 0.686
            },
            "rightCorner": {
              "x": 8.967,
              "y": -9.771,
              "z": 0.686
            },
            "gtin": "4084200110505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27150c",
            "leftCorner": {
              "x": 8.967,
              "y": -9.771,
              "z": 0.686
            },
            "rightCorner": {
              "x": 8.996,
              "y": -9.797,
              "z": 0.686
            },
            "gtin": "4260524942354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27150d",
            "leftCorner": {
              "x": 9.002,
              "y": -9.804,
              "z": 0.685
            },
            "rightCorner": {
              "x": 9.039,
              "y": -9.836,
              "z": 0.685
            },
            "gtin": "4260524942385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27150e",
            "leftCorner": {
              "x": 9.038,
              "y": -9.837,
              "z": 0.685
            },
            "rightCorner": {
              "x": 9.075,
              "y": -9.869,
              "z": 0.685
            },
            "gtin": "4260524943306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27150f",
            "leftCorner": {
              "x": 9.074,
              "y": -9.869,
              "z": 0.685
            },
            "rightCorner": {
              "x": 9.118,
              "y": -9.908,
              "z": 0.685
            },
            "gtin": "4260524942255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271510",
            "leftCorner": {
              "x": 9.118,
              "y": -9.908,
              "z": 0.685
            },
            "rightCorner": {
              "x": 9.175,
              "y": -9.958,
              "z": 0.685
            },
            "gtin": "4260524941487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271511",
            "leftCorner": {
              "x": 9.174,
              "y": -9.959,
              "z": 0.685
            },
            "rightCorner": {
              "x": 9.223,
              "y": -10.002,
              "z": 0.685
            },
            "gtin": "4260524943450",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73acb",
        "height": 0.93902,
        "facings": [
          {
            "id": "696ebf7043c343680a2714bc",
            "leftCorner": {
              "x": 8.494,
              "y": -9.361,
              "z": 0.939
            },
            "rightCorner": {
              "x": 8.549,
              "y": -9.41,
              "z": 0.939
            },
            "gtin": "3600522020837",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714bd",
            "leftCorner": {
              "x": 8.549,
              "y": -9.41,
              "z": 0.939
            },
            "rightCorner": {
              "x": 8.607,
              "y": -9.461,
              "z": 0.939
            },
            "gtin": "3600523183739",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714be",
            "leftCorner": {
              "x": 8.607,
              "y": -9.461,
              "z": 0.939
            },
            "rightCorner": {
              "x": 8.667,
              "y": -9.513,
              "z": 0.939
            },
            "gtin": "3600523183746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714bf",
            "leftCorner": {
              "x": 8.667,
              "y": -9.513,
              "z": 0.939
            },
            "rightCorner": {
              "x": 8.709,
              "y": -9.551,
              "z": 0.939
            },
            "gtin": "3600524185428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714c0",
            "leftCorner": {
              "x": 8.709,
              "y": -9.551,
              "z": 0.939
            },
            "rightCorner": {
              "x": 8.757,
              "y": -9.592,
              "z": 0.939
            },
            "gtin": "3600523363254",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714c1",
            "leftCorner": {
              "x": 8.757,
              "y": -9.592,
              "z": 0.939
            },
            "rightCorner": {
              "x": 8.795,
              "y": -9.626,
              "z": 0.939
            },
            "gtin": "3600523464562",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714c2",
            "leftCorner": {
              "x": 8.795,
              "y": -9.626,
              "z": 0.939
            },
            "rightCorner": {
              "x": 8.836,
              "y": -9.662,
              "z": 0.939
            },
            "gtin": "3600523363278",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714c3",
            "leftCorner": {
              "x": 8.836,
              "y": -9.662,
              "z": 0.939
            },
            "rightCorner": {
              "x": 8.919,
              "y": -9.736,
              "z": 0.939
            },
            "gtin": "3600524122669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714c4",
            "leftCorner": {
              "x": 8.919,
              "y": -9.736,
              "z": 0.939
            },
            "rightCorner": {
              "x": 8.979,
              "y": -9.788,
              "z": 0.939
            },
            "gtin": "5999566330148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714c5",
            "leftCorner": {
              "x": 8.99,
              "y": -9.791,
              "z": 0.937
            },
            "rightCorner": {
              "x": 9.045,
              "y": -9.84,
              "z": 0.937
            },
            "gtin": "5999566330483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714c6",
            "leftCorner": {
              "x": 9.045,
              "y": -9.84,
              "z": 0.937
            },
            "rightCorner": {
              "x": 9.095,
              "y": -9.885,
              "z": 0.937
            },
            "gtin": "5999566330360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714c7",
            "leftCorner": {
              "x": 9.094,
              "y": -9.885,
              "z": 0.937
            },
            "rightCorner": {
              "x": 9.135,
              "y": -9.921,
              "z": 0.937
            },
            "gtin": "5999566330384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714c8",
            "leftCorner": {
              "x": 9.134,
              "y": -9.921,
              "z": 0.937
            },
            "rightCorner": {
              "x": 9.175,
              "y": -9.957,
              "z": 0.937
            },
            "gtin": "5999566330131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714c9",
            "leftCorner": {
              "x": 9.175,
              "y": -9.958,
              "z": 0.937
            },
            "rightCorner": {
              "x": 9.209,
              "y": -9.988,
              "z": 0.937
            },
            "gtin": "5999566330261",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73acd",
        "height": 1.1953,
        "facings": [
          {
            "id": "696ebf7043c343680a27162c",
            "leftCorner": {
              "x": 8.451,
              "y": -9.323,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.495,
              "y": -9.361,
              "z": 1.195
            },
            "gtin": "3600523428052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27162d",
            "leftCorner": {
              "x": 8.495,
              "y": -9.362,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.549,
              "y": -9.409,
              "z": 1.195
            },
            "gtin": "3600523428045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27162e",
            "leftCorner": {
              "x": 8.549,
              "y": -9.409,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.596,
              "y": -9.451,
              "z": 1.195
            },
            "gtin": "3600523183753",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27162f",
            "leftCorner": {
              "x": 8.596,
              "y": -9.451,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.664,
              "y": -9.51,
              "z": 1.195
            },
            "gtin": "3600523350186",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271630",
            "leftCorner": {
              "x": 8.664,
              "y": -9.51,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.721,
              "y": -9.56,
              "z": 1.195
            },
            "gtin": "3600523985319",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271631",
            "leftCorner": {
              "x": 8.721,
              "y": -9.56,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.776,
              "y": -9.609,
              "z": 1.195
            },
            "gtin": "3600524003975",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271632",
            "leftCorner": {
              "x": 8.776,
              "y": -9.609,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.808,
              "y": -9.637,
              "z": 1.195
            },
            "gtin": "3600524104139",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271633",
            "leftCorner": {
              "x": 8.808,
              "y": -9.637,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.844,
              "y": -9.668,
              "z": 1.195
            },
            "gtin": "3600523873814",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271634",
            "leftCorner": {
              "x": 8.844,
              "y": -9.668,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.878,
              "y": -9.698,
              "z": 1.195
            },
            "gtin": "3600523954919",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271635",
            "leftCorner": {
              "x": 8.878,
              "y": -9.698,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.921,
              "y": -9.736,
              "z": 1.195
            },
            "gtin": "3600523954919",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271636",
            "leftCorner": {
              "x": 8.921,
              "y": -9.736,
              "z": 1.195
            },
            "rightCorner": {
              "x": 8.971,
              "y": -9.78,
              "z": 1.195
            }
          },
          {
            "id": "696ebf7043c343680a271637",
            "leftCorner": {
              "x": 8.971,
              "y": -9.78,
              "z": 1.195
            },
            "rightCorner": {
              "x": 9.01,
              "y": -9.815,
              "z": 1.195
            },
            "gtin": "3600524244439",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271638",
            "leftCorner": {
              "x": 9.01,
              "y": -9.815,
              "z": 1.195
            },
            "rightCorner": {
              "x": 9.061,
              "y": -9.859,
              "z": 1.195
            },
            "gtin": "3600524244569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271639",
            "leftCorner": {
              "x": 9.068,
              "y": -9.867,
              "z": 1.194
            },
            "rightCorner": {
              "x": 9.127,
              "y": -9.919,
              "z": 1.194
            },
            "gtin": "3600524169626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27163a",
            "leftCorner": {
              "x": 9.126,
              "y": -9.92,
              "z": 1.194
            },
            "rightCorner": {
              "x": 9.176,
              "y": -9.964,
              "z": 1.194
            },
            "gtin": "3600524076047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27163b",
            "leftCorner": {
              "x": 9.176,
              "y": -9.964,
              "z": 1.194
            },
            "rightCorner": {
              "x": 9.22,
              "y": -10.004,
              "z": 1.194
            },
            "gtin": "3600524069742",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73acc",
        "height": 1.4511,
        "facings": [
          {
            "id": "696ebf7043c343680a271595",
            "leftCorner": {
              "x": 8.453,
              "y": -9.329,
              "z": 1.451
            },
            "rightCorner": {
              "x": 8.506,
              "y": -9.375,
              "z": 1.451
            },
            "gtin": "3600523670611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271596",
            "leftCorner": {
              "x": 8.505,
              "y": -9.376,
              "z": 1.451
            },
            "rightCorner": {
              "x": 8.614,
              "y": -9.471,
              "z": 1.451
            },
            "gtin": "3600523670628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271597",
            "leftCorner": {
              "x": 8.614,
              "y": -9.471,
              "z": 1.451
            },
            "rightCorner": {
              "x": 8.691,
              "y": -9.539,
              "z": 1.451
            },
            "gtin": "3600523716487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271598",
            "leftCorner": {
              "x": 8.691,
              "y": -9.539,
              "z": 1.451
            },
            "rightCorner": {
              "x": 8.733,
              "y": -9.576,
              "z": 1.451
            },
            "gtin": "3600523436064",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271599",
            "leftCorner": {
              "x": 8.733,
              "y": -9.576,
              "z": 1.451
            },
            "rightCorner": {
              "x": 8.785,
              "y": -9.621,
              "z": 1.451
            },
            "gtin": "3600524055721",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27159a",
            "leftCorner": {
              "x": 8.785,
              "y": -9.621,
              "z": 1.451
            },
            "rightCorner": {
              "x": 8.826,
              "y": -9.657,
              "z": 1.451
            },
            "gtin": "3600524197674",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27159b",
            "leftCorner": {
              "x": 8.826,
              "y": -9.657,
              "z": 1.451
            },
            "rightCorner": {
              "x": 8.864,
              "y": -9.691,
              "z": 1.451
            },
            "gtin": "3600522249238",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27159c",
            "leftCorner": {
              "x": 8.864,
              "y": -9.691,
              "z": 1.451
            },
            "rightCorner": {
              "x": 8.905,
              "y": -9.727,
              "z": 1.451
            },
            "gtin": "3600524186296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27159d",
            "leftCorner": {
              "x": 8.905,
              "y": -9.727,
              "z": 1.451
            },
            "rightCorner": {
              "x": 8.953,
              "y": -9.769,
              "z": 1.451
            },
            "gtin": "3600524055745",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27159e",
            "leftCorner": {
              "x": 8.953,
              "y": -9.769,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.008,
              "y": -9.817,
              "z": 1.451
            },
            "gtin": "3600524055738",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27159f",
            "leftCorner": {
              "x": 9.008,
              "y": -9.817,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.06,
              "y": -9.863,
              "z": 1.451
            },
            "gtin": "3600524070625",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715a0",
            "leftCorner": {
              "x": 9.06,
              "y": -9.863,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.099,
              "y": -9.897,
              "z": 1.451
            },
            "gtin": "3600524129057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715a1",
            "leftCorner": {
              "x": 9.105,
              "y": -9.905,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.16,
              "y": -9.954,
              "z": 1.451
            },
            "gtin": "3600523216451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715a2",
            "leftCorner": {
              "x": 9.16,
              "y": -9.954,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.21,
              "y": -9.998,
              "z": 1.451
            },
            "gtin": "9120130825487",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ac8",
        "height": 1.7009,
        "facings": [
          {
            "id": "696ebf7043c343680a2715de",
            "leftCorner": {
              "x": 8.476,
              "y": -9.348,
              "z": 1.701
            },
            "rightCorner": {
              "x": 8.503,
              "y": -9.371,
              "z": 1.701
            }
          },
          {
            "id": "696ebf7043c343680a2715df",
            "leftCorner": {
              "x": 8.503,
              "y": -9.371,
              "z": 1.701
            },
            "rightCorner": {
              "x": 8.527,
              "y": -9.392,
              "z": 1.701
            },
            "gtin": "3600523639465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715e0",
            "leftCorner": {
              "x": 8.527,
              "y": -9.392,
              "z": 1.701
            },
            "rightCorner": {
              "x": 8.554,
              "y": -9.416,
              "z": 1.701
            },
            "gtin": "3600523639465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715e1",
            "leftCorner": {
              "x": 8.554,
              "y": -9.416,
              "z": 1.701
            },
            "rightCorner": {
              "x": 8.584,
              "y": -9.442,
              "z": 1.701
            },
            "gtin": "3600523216468",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715e2",
            "leftCorner": {
              "x": 8.584,
              "y": -9.442,
              "z": 1.701
            },
            "rightCorner": {
              "x": 8.656,
              "y": -9.506,
              "z": 1.701
            },
            "gtin": "3600523242696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715e3",
            "leftCorner": {
              "x": 8.656,
              "y": -9.506,
              "z": 1.701
            },
            "rightCorner": {
              "x": 8.705,
              "y": -9.549,
              "z": 1.701
            },
            "gtin": "3600523814060",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715e4",
            "leftCorner": {
              "x": 8.705,
              "y": -9.549,
              "z": 1.701
            },
            "rightCorner": {
              "x": 8.747,
              "y": -9.586,
              "z": 1.701
            },
            "gtin": "3600523814053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715e5",
            "leftCorner": {
              "x": 8.747,
              "y": -9.586,
              "z": 1.701
            },
            "rightCorner": {
              "x": 8.801,
              "y": -9.633,
              "z": 1.701
            },
            "gtin": "3600523970827",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715e6",
            "leftCorner": {
              "x": 8.801,
              "y": -9.633,
              "z": 1.701
            },
            "rightCorner": {
              "x": 8.864,
              "y": -9.688,
              "z": 1.701
            },
            "gtin": "3600523970834",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715e7",
            "leftCorner": {
              "x": 8.864,
              "y": -9.688,
              "z": 1.701
            },
            "rightCorner": {
              "x": 9.013,
              "y": -9.819,
              "z": 1.701
            },
            "gtin": "3600524066512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715e8",
            "leftCorner": {
              "x": 9.013,
              "y": -9.819,
              "z": 1.701
            },
            "rightCorner": {
              "x": 9.083,
              "y": -9.881,
              "z": 1.701
            },
            "gtin": "3600524162528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715e9",
            "leftCorner": {
              "x": 9.087,
              "y": -9.892,
              "z": 1.699
            },
            "rightCorner": {
              "x": 9.131,
              "y": -9.931,
              "z": 1.699
            },
            "gtin": "4260544080050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715ea",
            "leftCorner": {
              "x": 9.13,
              "y": -9.931,
              "z": 1.699
            },
            "rightCorner": {
              "x": 9.18,
              "y": -9.974,
              "z": 1.699
            },
            "gtin": "9120112226813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715eb",
            "leftCorner": {
              "x": 9.179,
              "y": -9.975,
              "z": 1.699
            },
            "rightCorner": {
              "x": 9.223,
              "y": -10.014,
              "z": 1.699
            },
            "gtin": "9120112226783",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc046959934",
    "name": "68e7572eb5fe7bc046959934",
    "x": 9.1743,
    "y": -10.037,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.35882,
      "w": 0.93341
    },
    "statistics": {
      "hasStockCount": 36,
      "noStockCount": 1,
      "unknownStockCount": 34
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73ad6",
        "height": 0.17793,
        "facings": [
          {
            "id": "696ebf7043c343680a27143d",
            "leftCorner": {
              "x": 9.144,
              "y": -10.07,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.216,
              "y": -10.134,
              "z": 0.178
            },
            "gtin": "4066447233964",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27143e",
            "leftCorner": {
              "x": 9.216,
              "y": -10.135,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.33,
              "y": -10.238,
              "z": 0.178
            },
            "gtin": "4066447429220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27143f",
            "leftCorner": {
              "x": 9.33,
              "y": -10.238,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.392,
              "y": -10.293,
              "z": 0.178
            },
            "gtin": "4066447429220",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271440",
            "leftCorner": {
              "x": 9.392,
              "y": -10.293,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.435,
              "y": -10.332,
              "z": 0.178
            },
            "gtin": "4066447874266",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271441",
            "leftCorner": {
              "x": 9.435,
              "y": -10.332,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.466,
              "y": -10.36,
              "z": 0.178
            },
            "gtin": "4066447234008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271442",
            "leftCorner": {
              "x": 9.466,
              "y": -10.36,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.497,
              "y": -10.388,
              "z": 0.178
            },
            "gtin": "4066447234008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271443",
            "leftCorner": {
              "x": 9.497,
              "y": -10.388,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.535,
              "y": -10.423,
              "z": 0.178
            },
            "gtin": "4066447379150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271444",
            "leftCorner": {
              "x": 9.535,
              "y": -10.423,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.581,
              "y": -10.464,
              "z": 0.178
            },
            "gtin": "4066447874181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271445",
            "leftCorner": {
              "x": 9.581,
              "y": -10.464,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.62,
              "y": -10.5,
              "z": 0.178
            },
            "gtin": "4066447468137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271446",
            "leftCorner": {
              "x": 9.62,
              "y": -10.5,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.654,
              "y": -10.53,
              "z": 0.178
            },
            "gtin": "4066447468090",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271447",
            "leftCorner": {
              "x": 9.654,
              "y": -10.53,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.689,
              "y": -10.562,
              "z": 0.178
            },
            "gtin": "4066447468113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271448",
            "leftCorner": {
              "x": 9.689,
              "y": -10.562,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.727,
              "y": -10.596,
              "z": 0.178
            },
            "gtin": "4066447241419",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271449",
            "leftCorner": {
              "x": 9.727,
              "y": -10.596,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.761,
              "y": -10.627,
              "z": 0.178
            },
            "gtin": "4036581538744",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27144a",
            "leftCorner": {
              "x": 9.761,
              "y": -10.627,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.793,
              "y": -10.655,
              "z": 0.178
            },
            "gtin": "4036581531936",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27144b",
            "leftCorner": {
              "x": 9.793,
              "y": -10.655,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.824,
              "y": -10.683,
              "z": 0.178
            },
            "gtin": "4036581531936",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27144c",
            "leftCorner": {
              "x": 9.824,
              "y": -10.683,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.938,
              "y": -10.787,
              "z": 0.178
            },
            "gtin": "4036581526482",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ad5",
        "height": 0.43595,
        "facings": [
          {
            "id": "696ebf7043c343680a271561",
            "leftCorner": {
              "x": 9.209,
              "y": -9.987,
              "z": 0.436
            },
            "rightCorner": {
              "x": 9.265,
              "y": -10.036,
              "z": 0.436
            },
            "gtin": "3600551186894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271562",
            "leftCorner": {
              "x": 9.264,
              "y": -10.037,
              "z": 0.436
            },
            "rightCorner": {
              "x": 9.484,
              "y": -10.235,
              "z": 0.436
            },
            "gtin": "4103040047694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271563",
            "leftCorner": {
              "x": 9.484,
              "y": -10.235,
              "z": 0.436
            },
            "rightCorner": {
              "x": 9.518,
              "y": -10.265,
              "z": 0.436
            },
            "gtin": "4103040047717",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271564",
            "leftCorner": {
              "x": 9.518,
              "y": -10.265,
              "z": 0.436
            },
            "rightCorner": {
              "x": 9.541,
              "y": -10.287,
              "z": 0.436
            },
            "gtin": "4103040918390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271565",
            "leftCorner": {
              "x": 9.541,
              "y": -10.287,
              "z": 0.436
            },
            "rightCorner": {
              "x": 9.587,
              "y": -10.328,
              "z": 0.436
            },
            "gtin": "4103040918390",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271566",
            "leftCorner": {
              "x": 9.587,
              "y": -10.328,
              "z": 0.436
            },
            "rightCorner": {
              "x": 9.639,
              "y": -10.375,
              "z": 0.436
            },
            "gtin": "4103040048523",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271567",
            "leftCorner": {
              "x": 9.639,
              "y": -10.375,
              "z": 0.436
            },
            "rightCorner": {
              "x": 9.694,
              "y": -10.425,
              "z": 0.436
            },
            "gtin": "4103040019899",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271568",
            "leftCorner": {
              "x": 9.694,
              "y": -10.425,
              "z": 0.436
            },
            "rightCorner": {
              "x": 9.724,
              "y": -10.451,
              "z": 0.436
            },
            "gtin": "4103040019899",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271569",
            "leftCorner": {
              "x": 9.724,
              "y": -10.451,
              "z": 0.436
            },
            "rightCorner": {
              "x": 9.747,
              "y": -10.473,
              "z": 0.436
            },
            "gtin": "4066447678871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27156a",
            "leftCorner": {
              "x": 9.747,
              "y": -10.473,
              "z": 0.436
            },
            "rightCorner": {
              "x": 9.836,
              "y": -10.553,
              "z": 0.436
            },
            "gtin": "4066447678840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27156b",
            "leftCorner": {
              "x": 9.836,
              "y": -10.553,
              "z": 0.436
            },
            "rightCorner": {
              "x": 9.904,
              "y": -10.614,
              "z": 0.436
            },
            "gtin": "4066447678758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27156c",
            "leftCorner": {
              "x": 9.904,
              "y": -10.614,
              "z": 0.436
            },
            "rightCorner": {
              "x": 9.946,
              "y": -10.652,
              "z": 0.436
            },
            "gtin": "4066447884920",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ad3",
        "height": 0.68474,
        "facings": [
          {
            "id": "696ebf7043c343680a271512",
            "leftCorner": {
              "x": 9.223,
              "y": -10.003,
              "z": 0.685
            },
            "rightCorner": {
              "x": 9.258,
              "y": -10.034,
              "z": 0.685
            },
            "gtin": "4260524942286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271513",
            "leftCorner": {
              "x": 9.258,
              "y": -10.035,
              "z": 0.685
            },
            "rightCorner": {
              "x": 9.605,
              "y": -10.348,
              "z": 0.685
            },
            "gtin": "4260524940190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271514",
            "leftCorner": {
              "x": 9.605,
              "y": -10.348,
              "z": 0.685
            },
            "rightCorner": {
              "x": 9.696,
              "y": -10.43,
              "z": 0.685
            },
            "gtin": "4260524943429",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271515",
            "leftCorner": {
              "x": 9.696,
              "y": -10.43,
              "z": 0.685
            },
            "rightCorner": {
              "x": 9.727,
              "y": -10.458,
              "z": 0.685
            },
            "gtin": "4260524943429",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271516",
            "leftCorner": {
              "x": 9.727,
              "y": -10.458,
              "z": 0.685
            },
            "rightCorner": {
              "x": 9.839,
              "y": -10.559,
              "z": 0.685
            },
            "gtin": "4260524943344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271517",
            "leftCorner": {
              "x": 9.839,
              "y": -10.559,
              "z": 0.685
            },
            "rightCorner": {
              "x": 9.92,
              "y": -10.632,
              "z": 0.685
            },
            "gtin": "4260524942651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271518",
            "leftCorner": {
              "x": 9.92,
              "y": -10.632,
              "z": 0.685
            },
            "rightCorner": {
              "x": 9.978,
              "y": -10.685,
              "z": 0.685
            },
            "gtin": "4260524941210",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ad1",
        "height": 0.93728,
        "facings": [
          {
            "id": "696ebf7043c343680a2714ca",
            "leftCorner": {
              "x": 9.209,
              "y": -9.988,
              "z": 0.937
            },
            "rightCorner": {
              "x": 9.247,
              "y": -10.022,
              "z": 0.937
            },
            "gtin": "5999566330643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714cb",
            "leftCorner": {
              "x": 9.247,
              "y": -10.023,
              "z": 0.937
            },
            "rightCorner": {
              "x": 9.282,
              "y": -10.054,
              "z": 0.937
            },
            "gtin": "5999566330247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714cc",
            "leftCorner": {
              "x": 9.281,
              "y": -10.054,
              "z": 0.937
            },
            "rightCorner": {
              "x": 9.308,
              "y": -10.077,
              "z": 0.937
            },
            "gtin": "5999566330162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714cd",
            "leftCorner": {
              "x": 9.307,
              "y": -10.077,
              "z": 0.937
            },
            "rightCorner": {
              "x": 9.683,
              "y": -10.416,
              "z": 0.937
            },
            "gtin": "4049639455689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714ce",
            "leftCorner": {
              "x": 9.683,
              "y": -10.416,
              "z": 0.937
            },
            "rightCorner": {
              "x": 9.806,
              "y": -10.527,
              "z": 0.937
            },
            "gtin": "4049639448773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714cf",
            "leftCorner": {
              "x": 9.806,
              "y": -10.527,
              "z": 0.937
            },
            "rightCorner": {
              "x": 9.881,
              "y": -10.595,
              "z": 0.937
            },
            "gtin": "4049639434110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714d0",
            "leftCorner": {
              "x": 9.881,
              "y": -10.595,
              "z": 0.937
            },
            "rightCorner": {
              "x": 9.92,
              "y": -10.63,
              "z": 0.937
            },
            "gtin": "3574661749532",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ad2",
        "height": 1.1943,
        "facings": [
          {
            "id": "696ebf7043c343680a27163c",
            "leftCorner": {
              "x": 9.22,
              "y": -10.004,
              "z": 1.194
            },
            "rightCorner": {
              "x": 9.432,
              "y": -10.196,
              "z": 1.194
            },
            "gtin": "3574661864280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27163d",
            "leftCorner": {
              "x": 9.432,
              "y": -10.196,
              "z": 1.194
            },
            "rightCorner": {
              "x": 9.574,
              "y": -10.324,
              "z": 1.194
            },
            "gtin": "3574661430706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27163e",
            "leftCorner": {
              "x": 9.574,
              "y": -10.324,
              "z": 1.194
            },
            "rightCorner": {
              "x": 9.657,
              "y": -10.399,
              "z": 1.194
            },
            "gtin": "3574661450544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27163f",
            "leftCorner": {
              "x": 9.657,
              "y": -10.399,
              "z": 1.194
            },
            "rightCorner": {
              "x": 9.713,
              "y": -10.45,
              "z": 1.194
            },
            "gtin": "3574661525556",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271640",
            "leftCorner": {
              "x": 9.713,
              "y": -10.45,
              "z": 1.194
            },
            "rightCorner": {
              "x": 9.75,
              "y": -10.483,
              "z": 1.194
            },
            "gtin": "3574661588353",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271641",
            "leftCorner": {
              "x": 9.75,
              "y": -10.483,
              "z": 1.194
            },
            "rightCorner": {
              "x": 9.824,
              "y": -10.549,
              "z": 1.194
            },
            "gtin": "3574661332574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271642",
            "leftCorner": {
              "x": 9.824,
              "y": -10.549,
              "z": 1.194
            },
            "rightCorner": {
              "x": 9.878,
              "y": -10.598,
              "z": 1.194
            },
            "gtin": "3574661336640",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271643",
            "leftCorner": {
              "x": 9.878,
              "y": -10.598,
              "z": 1.194
            },
            "rightCorner": {
              "x": 9.922,
              "y": -10.638,
              "z": 1.194
            },
            "gtin": "3574661333625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271644",
            "leftCorner": {
              "x": 9.922,
              "y": -10.638,
              "z": 1.194
            },
            "rightCorner": {
              "x": 9.953,
              "y": -10.666,
              "z": 1.194
            },
            "gtin": "3574661332628",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ad4",
        "height": 1.4507,
        "facings": [
          {
            "id": "696ebf7043c343680a2715a3",
            "leftCorner": {
              "x": 9.209,
              "y": -9.999,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.257,
              "y": -10.041,
              "z": 1.451
            },
            "gtin": "9120130822592",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715a4",
            "leftCorner": {
              "x": 9.256,
              "y": -10.042,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.442,
              "y": -10.209,
              "z": 1.451
            },
            "gtin": "9120130821298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715a5",
            "leftCorner": {
              "x": 9.442,
              "y": -10.209,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.569,
              "y": -10.324,
              "z": 1.451
            },
            "gtin": "9120130821236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715a6",
            "leftCorner": {
              "x": 9.569,
              "y": -10.324,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.61,
              "y": -10.361,
              "z": 1.451
            },
            "gtin": "3574661813899",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715a7",
            "leftCorner": {
              "x": 9.61,
              "y": -10.361,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.65,
              "y": -10.397,
              "z": 1.451
            },
            "gtin": "3574661632919",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715a8",
            "leftCorner": {
              "x": 9.65,
              "y": -10.397,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.764,
              "y": -10.5,
              "z": 1.451
            },
            "gtin": "3574661533551",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715a9",
            "leftCorner": {
              "x": 9.764,
              "y": -10.5,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.814,
              "y": -10.545,
              "z": 1.451
            },
            "gtin": "3574661320700",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715aa",
            "leftCorner": {
              "x": 9.814,
              "y": -10.545,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.866,
              "y": -10.591,
              "z": 1.451
            },
            "gtin": "3574661554280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715ab",
            "leftCorner": {
              "x": 9.866,
              "y": -10.591,
              "z": 1.451
            },
            "rightCorner": {
              "x": 9.919,
              "y": -10.639,
              "z": 1.451
            },
            "gtin": "3574661554297",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ad0",
        "height": 1.699,
        "facings": [
          {
            "id": "696ebf7043c343680a2715ec",
            "leftCorner": {
              "x": 9.222,
              "y": -10.014,
              "z": 1.699
            },
            "rightCorner": {
              "x": 9.392,
              "y": -10.167,
              "z": 1.699
            },
            "gtin": "9120130822486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715ed",
            "leftCorner": {
              "x": 9.392,
              "y": -10.167,
              "z": 1.699
            },
            "rightCorner": {
              "x": 9.458,
              "y": -10.226,
              "z": 1.699
            },
            "gtin": "9120130822516",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715ee",
            "leftCorner": {
              "x": 9.458,
              "y": -10.226,
              "z": 1.699
            },
            "rightCorner": {
              "x": 9.498,
              "y": -10.263,
              "z": 1.699
            },
            "gtin": "9120130822455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715ef",
            "leftCorner": {
              "x": 9.498,
              "y": -10.263,
              "z": 1.699
            },
            "rightCorner": {
              "x": 9.551,
              "y": -10.311,
              "z": 1.699
            },
            "gtin": "9120058169496",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715f0",
            "leftCorner": {
              "x": 9.551,
              "y": -10.311,
              "z": 1.699
            },
            "rightCorner": {
              "x": 9.623,
              "y": -10.376,
              "z": 1.699
            },
            "gtin": "9120112222839",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715f1",
            "leftCorner": {
              "x": 9.623,
              "y": -10.376,
              "z": 1.699
            },
            "rightCorner": {
              "x": 9.682,
              "y": -10.428,
              "z": 1.699
            },
            "gtin": "9120130824039",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715f2",
            "leftCorner": {
              "x": 9.682,
              "y": -10.428,
              "z": 1.699
            },
            "rightCorner": {
              "x": 9.728,
              "y": -10.47,
              "z": 1.699
            },
            "gtin": "9120130823971",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715f3",
            "leftCorner": {
              "x": 9.728,
              "y": -10.47,
              "z": 1.699
            },
            "rightCorner": {
              "x": 9.773,
              "y": -10.51,
              "z": 1.699
            },
            "gtin": "9120130821298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715f4",
            "leftCorner": {
              "x": 9.773,
              "y": -10.51,
              "z": 1.699
            },
            "rightCorner": {
              "x": 9.825,
              "y": -10.558,
              "z": 1.699
            },
            "gtin": "9120130825609",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715f5",
            "leftCorner": {
              "x": 9.825,
              "y": -10.558,
              "z": 1.699
            },
            "rightCorner": {
              "x": 9.885,
              "y": -10.612,
              "z": 1.699
            },
            "gtin": "9120130820307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715f6",
            "leftCorner": {
              "x": 9.885,
              "y": -10.612,
              "z": 1.699
            },
            "rightCorner": {
              "x": 9.922,
              "y": -10.645,
              "z": 1.699
            },
            "gtin": "9120112226561",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc046959935",
    "name": "68e7572eb5fe7bc046959935",
    "x": 9.9156,
    "y": -10.688,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.35896,
      "w": 0.93335
    },
    "statistics": {
      "hasStockCount": 39,
      "noStockCount": 0,
      "unknownStockCount": 24
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73add",
        "height": 0.17191,
        "facings": [
          {
            "id": "696ebf7043c343680a27144d",
            "leftCorner": {
              "x": 9.936,
              "y": -10.768,
              "z": 0.172
            },
            "rightCorner": {
              "x": 10.042,
              "y": -10.864,
              "z": 0.172
            },
            "gtin": "4066447103779",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27144e",
            "leftCorner": {
              "x": 10.042,
              "y": -10.864,
              "z": 0.172
            },
            "rightCorner": {
              "x": 10.191,
              "y": -10.998,
              "z": 0.172
            },
            "gtin": "4066447107036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27144f",
            "leftCorner": {
              "x": 10.191,
              "y": -10.998,
              "z": 0.172
            },
            "rightCorner": {
              "x": 10.268,
              "y": -11.067,
              "z": 0.172
            },
            "gtin": "4066447384215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271450",
            "leftCorner": {
              "x": 10.268,
              "y": -11.067,
              "z": 0.172
            },
            "rightCorner": {
              "x": 10.363,
              "y": -11.153,
              "z": 0.172
            },
            "gtin": "4066447397901",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2713db",
            "leftCorner": {
              "x": 10.363,
              "y": -11.153,
              "z": 0.172
            },
            "rightCorner": {
              "x": 10.627,
              "y": -11.392,
              "z": 0.172
            },
            "gtin": "4066447501070",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ad7",
        "height": 0.43359,
        "facings": [
          {
            "id": "696ebf7043c343680a27156d",
            "leftCorner": {
              "x": 9.953,
              "y": -10.646,
              "z": 0.434
            },
            "rightCorner": {
              "x": 10.062,
              "y": -10.744,
              "z": 0.434
            },
            "gtin": "4066447705485",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27156e",
            "leftCorner": {
              "x": 10.062,
              "y": -10.744,
              "z": 0.434
            },
            "rightCorner": {
              "x": 10.262,
              "y": -10.924,
              "z": 0.434
            },
            "gtin": "4067796212075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27156f",
            "leftCorner": {
              "x": 10.262,
              "y": -10.924,
              "z": 0.434
            },
            "rightCorner": {
              "x": 10.332,
              "y": -10.988,
              "z": 0.434
            },
            "gtin": "4066447502411",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271570",
            "leftCorner": {
              "x": 10.332,
              "y": -10.988,
              "z": 0.434
            },
            "rightCorner": {
              "x": 10.377,
              "y": -11.029,
              "z": 0.434
            },
            "gtin": "4066447599084",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271571",
            "leftCorner": {
              "x": 10.377,
              "y": -11.029,
              "z": 0.434
            },
            "rightCorner": {
              "x": 10.418,
              "y": -11.066,
              "z": 0.434
            },
            "gtin": "4067796085198",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271572",
            "leftCorner": {
              "x": 10.418,
              "y": -11.066,
              "z": 0.434
            },
            "rightCorner": {
              "x": 10.463,
              "y": -11.106,
              "z": 0.434
            },
            "gtin": "4067796085198",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271573",
            "leftCorner": {
              "x": 10.463,
              "y": -11.106,
              "z": 0.434
            },
            "rightCorner": {
              "x": 10.585,
              "y": -11.216,
              "z": 0.434
            },
            "gtin": "4066447161489",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271574",
            "leftCorner": {
              "x": 10.585,
              "y": -11.216,
              "z": 0.434
            },
            "rightCorner": {
              "x": 10.675,
              "y": -11.298,
              "z": 0.434
            },
            "gtin": "4066447302189",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73adc",
        "height": 0.68268,
        "facings": [
          {
            "id": "696ebf7043c343680a271519",
            "leftCorner": {
              "x": 9.979,
              "y": -10.664,
              "z": 0.683
            },
            "rightCorner": {
              "x": 10.057,
              "y": -10.734,
              "z": 0.683
            },
            "gtin": "4066447235456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27151a",
            "leftCorner": {
              "x": 10.057,
              "y": -10.734,
              "z": 0.683
            },
            "rightCorner": {
              "x": 10.118,
              "y": -10.789,
              "z": 0.683
            },
            "gtin": "4066447235470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27151b",
            "leftCorner": {
              "x": 10.118,
              "y": -10.789,
              "z": 0.683
            },
            "rightCorner": {
              "x": 10.334,
              "y": -10.984,
              "z": 0.683
            },
            "gtin": "4066447103151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27151c",
            "leftCorner": {
              "x": 10.334,
              "y": -10.984,
              "z": 0.683
            },
            "rightCorner": {
              "x": 10.381,
              "y": -11.026,
              "z": 0.683
            },
            "gtin": "4066447103151",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27151d",
            "leftCorner": {
              "x": 10.381,
              "y": -11.026,
              "z": 0.683
            },
            "rightCorner": {
              "x": 10.434,
              "y": -11.074,
              "z": 0.683
            },
            "gtin": "4066447235593",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27151e",
            "leftCorner": {
              "x": 10.434,
              "y": -11.074,
              "z": 0.683
            },
            "rightCorner": {
              "x": 10.482,
              "y": -11.117,
              "z": 0.683
            },
            "gtin": "4058172681677",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27151f",
            "leftCorner": {
              "x": 10.482,
              "y": -11.117,
              "z": 0.683
            },
            "rightCorner": {
              "x": 10.597,
              "y": -11.221,
              "z": 0.683
            },
            "gtin": "4066447215571",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714dc",
            "leftCorner": {
              "x": 10.597,
              "y": -11.221,
              "z": 0.683
            },
            "rightCorner": {
              "x": 10.698,
              "y": -11.313,
              "z": 0.683
            },
            "gtin": "4066447813333",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ad9",
        "height": 0.9344,
        "facings": [
          {
            "id": "696ebf7043c343680a2714d1",
            "leftCorner": {
              "x": 9.92,
              "y": -10.63,
              "z": 0.937
            },
            "rightCorner": {
              "x": 10.002,
              "y": -10.704,
              "z": 0.937
            },
            "gtin": "4066447216004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714d2",
            "leftCorner": {
              "x": 10.002,
              "y": -10.683,
              "z": 0.934
            },
            "rightCorner": {
              "x": 10.036,
              "y": -10.713,
              "z": 0.934
            },
            "gtin": "4066447216028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714d3",
            "leftCorner": {
              "x": 10.036,
              "y": -10.713,
              "z": 0.934
            },
            "rightCorner": {
              "x": 10.073,
              "y": -10.747,
              "z": 0.934
            },
            "gtin": "4066447215977",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714d4",
            "leftCorner": {
              "x": 10.073,
              "y": -10.747,
              "z": 0.934
            },
            "rightCorner": {
              "x": 10.311,
              "y": -10.962,
              "z": 0.934
            },
            "gtin": "4051424570019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2714d5",
            "leftCorner": {
              "x": 10.311,
              "y": -10.962,
              "z": 0.934
            },
            "rightCorner": {
              "x": 10.349,
              "y": -10.996,
              "z": 0.934
            },
            "gtin": "4021457660230",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714d6",
            "leftCorner": {
              "x": 10.349,
              "y": -10.996,
              "z": 0.934
            },
            "rightCorner": {
              "x": 10.406,
              "y": -11.048,
              "z": 0.934
            },
            "gtin": "4021457664238",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714d7",
            "leftCorner": {
              "x": 10.406,
              "y": -11.048,
              "z": 0.934
            },
            "rightCorner": {
              "x": 10.449,
              "y": -11.086,
              "z": 0.934
            },
            "gtin": "4021457664290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2714d8",
            "leftCorner": {
              "x": 10.449,
              "y": -11.086,
              "z": 0.934
            },
            "rightCorner": {
              "x": 10.571,
              "y": -11.196,
              "z": 0.934
            },
            "gtin": "4021457664207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27148e",
            "leftCorner": {
              "x": 10.571,
              "y": -11.196,
              "z": 0.934
            },
            "rightCorner": {
              "x": 10.699,
              "y": -11.312,
              "z": 0.934
            },
            "gtin": "4021457653508",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73adb",
        "height": 1.1923,
        "facings": [
          {
            "id": "696ebf7043c343680a271645",
            "leftCorner": {
              "x": 9.953,
              "y": -10.646,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.037,
              "y": -10.721,
              "z": 1.192
            },
            "gtin": "4021457638369",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271646",
            "leftCorner": {
              "x": 10.037,
              "y": -10.721,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.093,
              "y": -10.772,
              "z": 1.192
            },
            "gtin": "4021457638307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271647",
            "leftCorner": {
              "x": 10.093,
              "y": -10.772,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.143,
              "y": -10.817,
              "z": 1.192
            },
            "gtin": "4021457638338",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271648",
            "leftCorner": {
              "x": 10.143,
              "y": -10.817,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.2,
              "y": -10.868,
              "z": 1.192
            },
            "gtin": "4021457638512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271649",
            "leftCorner": {
              "x": 10.2,
              "y": -10.868,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.275,
              "y": -10.936,
              "z": 1.192
            },
            "gtin": "4021457637478",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27164a",
            "leftCorner": {
              "x": 10.275,
              "y": -10.936,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.339,
              "y": -10.994,
              "z": 1.192
            },
            "gtin": "4021457665501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27164b",
            "leftCorner": {
              "x": 10.339,
              "y": -10.994,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.38,
              "y": -11.031,
              "z": 1.192
            },
            "gtin": "4021457658770",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27164c",
            "leftCorner": {
              "x": 10.38,
              "y": -11.031,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.42,
              "y": -11.066,
              "z": 1.192
            },
            "gtin": "4021457661077",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27164d",
            "leftCorner": {
              "x": 10.42,
              "y": -11.066,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.457,
              "y": -11.1,
              "z": 1.192
            },
            "gtin": "4021457661138",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27164e",
            "leftCorner": {
              "x": 10.457,
              "y": -11.1,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.498,
              "y": -11.137,
              "z": 1.192
            },
            "gtin": "4021457661015",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27164f",
            "leftCorner": {
              "x": 10.498,
              "y": -11.137,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.59,
              "y": -11.22,
              "z": 1.192
            },
            "gtin": "4021457650095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271604",
            "leftCorner": {
              "x": 10.59,
              "y": -11.22,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.696,
              "y": -11.316,
              "z": 1.192
            },
            "gtin": "4021457650033",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ada",
        "height": 1.448,
        "facings": [
          {
            "id": "696ebf7043c343680a2715ac",
            "leftCorner": {
              "x": 9.919,
              "y": -10.639,
              "z": 1.451
            },
            "rightCorner": {
              "x": 10.011,
              "y": -10.722,
              "z": 1.451
            },
            "gtin": "4021457635498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715ad",
            "leftCorner": {
              "x": 10.014,
              "y": -10.698,
              "z": 1.448
            },
            "rightCorner": {
              "x": 10.069,
              "y": -10.748,
              "z": 1.448
            },
            "gtin": "4021457635528",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715ae",
            "leftCorner": {
              "x": 10.069,
              "y": -10.748,
              "z": 1.448
            },
            "rightCorner": {
              "x": 10.143,
              "y": -10.814,
              "z": 1.448
            },
            "gtin": "4021457649266",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715af",
            "leftCorner": {
              "x": 10.143,
              "y": -10.814,
              "z": 1.448
            },
            "rightCorner": {
              "x": 10.207,
              "y": -10.873,
              "z": 1.448
            },
            "gtin": "4021457649204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715b0",
            "leftCorner": {
              "x": 10.207,
              "y": -10.873,
              "z": 1.448
            },
            "rightCorner": {
              "x": 10.264,
              "y": -10.923,
              "z": 1.448
            },
            "gtin": "4021457649174",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715b1",
            "leftCorner": {
              "x": 10.264,
              "y": -10.923,
              "z": 1.448
            },
            "rightCorner": {
              "x": 10.316,
              "y": -10.97,
              "z": 1.448
            },
            "gtin": "4021457635641",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715b2",
            "leftCorner": {
              "x": 10.316,
              "y": -10.97,
              "z": 1.448
            },
            "rightCorner": {
              "x": 10.366,
              "y": -11.016,
              "z": 1.448
            },
            "gtin": "4001638088381",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715b3",
            "leftCorner": {
              "x": 10.366,
              "y": -11.016,
              "z": 1.448
            },
            "rightCorner": {
              "x": 10.628,
              "y": -11.252,
              "z": 1.448
            },
            "gtin": "7611916164026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271576",
            "leftCorner": {
              "x": 10.628,
              "y": -11.252,
              "z": 1.448
            },
            "rightCorner": {
              "x": 10.697,
              "y": -11.314,
              "z": 1.448
            },
            "gtin": "7611916163876",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ad8",
        "height": 1.6956,
        "facings": [
          {
            "id": "696ebf7043c343680a2715f7",
            "leftCorner": {
              "x": 9.921,
              "y": -10.645,
              "z": 1.699
            },
            "rightCorner": {
              "x": 10.007,
              "y": -10.722,
              "z": 1.699
            },
            "gtin": "4001638500050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715f8",
            "leftCorner": {
              "x": 10.012,
              "y": -10.696,
              "z": 1.696
            },
            "rightCorner": {
              "x": 10.061,
              "y": -10.74,
              "z": 1.696
            },
            "gtin": "4001638590075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715f9",
            "leftCorner": {
              "x": 10.061,
              "y": -10.74,
              "z": 1.696
            },
            "rightCorner": {
              "x": 10.1,
              "y": -10.775,
              "z": 1.696
            },
            "gtin": "4001638590129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715fa",
            "leftCorner": {
              "x": 10.1,
              "y": -10.775,
              "z": 1.696
            },
            "rightCorner": {
              "x": 10.276,
              "y": -10.934,
              "z": 1.696
            },
            "gtin": "4001638501491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715fb",
            "leftCorner": {
              "x": 10.276,
              "y": -10.934,
              "z": 1.696
            },
            "rightCorner": {
              "x": 10.33,
              "y": -10.983,
              "z": 1.696
            },
            "gtin": "4001638580090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715fc",
            "leftCorner": {
              "x": 10.33,
              "y": -10.983,
              "z": 1.696
            },
            "rightCorner": {
              "x": 10.388,
              "y": -11.035,
              "z": 1.696
            },
            "gtin": "4001638580045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715fd",
            "leftCorner": {
              "x": 10.388,
              "y": -11.035,
              "z": 1.696
            },
            "rightCorner": {
              "x": 10.428,
              "y": -11.071,
              "z": 1.696
            },
            "gtin": "4001638579995",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715fe",
            "leftCorner": {
              "x": 10.428,
              "y": -11.071,
              "z": 1.696
            },
            "rightCorner": {
              "x": 10.481,
              "y": -11.119,
              "z": 1.696
            },
            "gtin": "4001638590112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2715ff",
            "leftCorner": {
              "x": 10.481,
              "y": -11.119,
              "z": 1.696
            },
            "rightCorner": {
              "x": 10.526,
              "y": -11.159,
              "z": 1.696
            },
            "gtin": "7611916163227",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271600",
            "leftCorner": {
              "x": 10.526,
              "y": -11.159,
              "z": 1.696
            },
            "rightCorner": {
              "x": 10.569,
              "y": -11.198,
              "z": 1.696
            },
            "gtin": "7611916163234",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271601",
            "leftCorner": {
              "x": 10.569,
              "y": -11.198,
              "z": 1.696
            },
            "rightCorner": {
              "x": 10.608,
              "y": -11.233,
              "z": 1.696
            },
            "gtin": "7611916163241",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271602",
            "leftCorner": {
              "x": 10.608,
              "y": -11.233,
              "z": 1.696
            },
            "rightCorner": {
              "x": 10.641,
              "y": -11.263,
              "z": 1.696
            },
            "gtin": "7611916163241",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2715b5",
            "leftCorner": {
              "x": 10.641,
              "y": -11.263,
              "z": 1.696
            },
            "rightCorner": {
              "x": 10.697,
              "y": -11.314,
              "z": 1.696
            }
          }
        ]
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc046959936",
    "name": "68e7572eb5fe7bc046959936",
    "x": 11.514,
    "y": -10.349,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93668,
      "w": 0.35019
    },
    "statistics": {
      "hasStockCount": 1,
      "noStockCount": 0,
      "unknownStockCount": 1
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73c29",
        "height": 1.6102,
        "facings": []
      },
      {
        "id": "696ead8e3b88e258afd73c2a",
        "height": 1.789,
        "facings": [
          {
            "id": "696ebf7143c343680a272043",
            "leftCorner": {
              "x": 11.461,
              "y": -10.411,
              "z": 1.789
            },
            "rightCorner": {
              "x": 11.4,
              "y": -10.358,
              "z": 1.789
            }
          },
          {
            "id": "696ebf7143c343680a272045",
            "leftCorner": {
              "x": 11.4,
              "y": -10.358,
              "z": 1.789
            },
            "rightCorner": {
              "x": 11.307,
              "y": -10.278,
              "z": 1.789
            }
          },
          {
            "id": "696ebf7143c343680a272046",
            "leftCorner": {
              "x": 11.307,
              "y": -10.278,
              "z": 1.789
            },
            "rightCorner": {
              "x": 11.192,
              "y": -10.177,
              "z": 1.789
            }
          },
          {
            "id": "696ebf7143c343680a272047",
            "leftCorner": {
              "x": 11.192,
              "y": -10.177,
              "z": 1.789
            },
            "rightCorner": {
              "x": 11.096,
              "y": -10.094,
              "z": 1.789
            }
          },
          {
            "id": "696ebf7143c343680a272048",
            "leftCorner": {
              "x": 11.096,
              "y": -10.094,
              "z": 1.789
            },
            "rightCorner": {
              "x": 11.003,
              "y": -10.014,
              "z": 1.789
            }
          },
          {
            "id": "696ebf7143c343680a272049",
            "leftCorner": {
              "x": 11.003,
              "y": -10.014,
              "z": 1.789
            },
            "rightCorner": {
              "x": 10.836,
              "y": -9.868,
              "z": 1.789
            },
            "gtin": "4011700821723",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272044",
            "leftCorner": {
              "x": 10.836,
              "y": -9.868,
              "z": 1.789
            },
            "rightCorner": {
              "x": 10.706,
              "y": -9.755,
              "z": 1.789
            },
            "gtin": "4066447600469",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c27",
        "height": 0.58906,
        "facings": []
      },
      {
        "id": "696ead8e3b88e258afd73c26",
        "height": 0.9252,
        "facings": []
      },
      {
        "id": "696ead8e3b88e258afd73c28",
        "height": 1.2671,
        "facings": []
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc046959937",
    "name": "68e7572eb5fe7bc046959937",
    "x": 10.647,
    "y": -9.8239,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93421,
      "w": 0.35672
    },
    "layers": []
  },
  {
    "id": "68e7572eb5fe7bc046959938",
    "name": "68e7572eb5fe7bc046959938",
    "x": 9.8696,
    "y": -9.1938,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93366,
      "w": 0.35817
    },
    "statistics": {
      "hasStockCount": 3,
      "noStockCount": 0,
      "unknownStockCount": 0
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73ade",
        "height": 0.51113,
        "facings": []
      },
      {
        "id": "696ead8d3b88e258afd73ae0",
        "height": 0.80505,
        "facings": []
      },
      {
        "id": "696ead8d3b88e258afd73adf",
        "height": 1.0637,
        "facings": []
      },
      {
        "id": "696ead8d3b88e258afd73ae3",
        "height": 1.2714,
        "facings": []
      },
      {
        "id": "696ead8d3b88e258afd73ae4",
        "height": 1.4016,
        "facings": []
      },
      {
        "id": "696ead8d3b88e258afd73ae2",
        "height": 1.6476,
        "facings": []
      },
      {
        "id": "696ead8d3b88e258afd73ae1",
        "height": 1.7878,
        "facings": [
          {
            "id": "696ebf7043c343680a271656",
            "leftCorner": {
              "x": 9.432,
              "y": -8.602,
              "z": 1.788
            },
            "rightCorner": {
              "x": 9.334,
              "y": -8.514,
              "z": 1.788
            },
            "gtin": "4006000194332",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271650",
            "leftCorner": {
              "x": 9.958,
              "y": -9.075,
              "z": 1.788
            },
            "rightCorner": {
              "x": 9.858,
              "y": -8.986,
              "z": 1.788
            }
          },
          {
            "id": "696ebf7043c343680a271651",
            "leftCorner": {
              "x": 9.858,
              "y": -8.986,
              "z": 1.788
            },
            "rightCorner": {
              "x": 9.766,
              "y": -8.903,
              "z": 1.788
            }
          },
          {
            "id": "696ebf7043c343680a271652",
            "leftCorner": {
              "x": 9.766,
              "y": -8.903,
              "z": 1.788
            },
            "rightCorner": {
              "x": 9.689,
              "y": -8.834,
              "z": 1.788
            }
          },
          {
            "id": "696ebf7043c343680a271653",
            "leftCorner": {
              "x": 9.689,
              "y": -8.834,
              "z": 1.788
            },
            "rightCorner": {
              "x": 9.667,
              "y": -8.814,
              "z": 1.788
            }
          },
          {
            "id": "696ebf7043c343680a271654",
            "leftCorner": {
              "x": 9.667,
              "y": -8.814,
              "z": 1.788
            },
            "rightCorner": {
              "x": 9.531,
              "y": -8.691,
              "z": 1.788
            }
          },
          {
            "id": "696ebf7043c343680a271655",
            "leftCorner": {
              "x": 9.531,
              "y": -8.691,
              "z": 1.788
            },
            "rightCorner": {
              "x": 9.432,
              "y": -8.602,
              "z": 1.788
            },
            "gtin": "4006000188317",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271657",
            "leftCorner": {
              "x": 9.334,
              "y": -8.514,
              "z": 1.788
            },
            "rightCorner": {
              "x": 9.236,
              "y": -8.426,
              "z": 1.788
            },
            "gtin": "4006000188348",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc046959939",
    "name": "68e7572eb5fe7bc046959939",
    "x": 9.1902,
    "y": -8.4451,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93218,
      "w": 0.362
    },
    "statistics": {
      "hasStockCount": 22,
      "noStockCount": 1,
      "unknownStockCount": 50
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73ae5",
        "height": 0.17791,
        "facings": [
          {
            "id": "696ebf7043c343680a271658",
            "leftCorner": {
              "x": 9.221,
              "y": -8.411,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.093,
              "y": -8.295,
              "z": 0.178
            },
            "gtin": "4013162008216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271659",
            "leftCorner": {
              "x": 9.093,
              "y": -8.295,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.059,
              "y": -8.263,
              "z": 0.178
            },
            "gtin": "42422778",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27165a",
            "leftCorner": {
              "x": 9.059,
              "y": -8.263,
              "z": 0.178
            },
            "rightCorner": {
              "x": 9.023,
              "y": -8.23,
              "z": 0.178
            },
            "gtin": "4066447790351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27165b",
            "leftCorner": {
              "x": 9.023,
              "y": -8.23,
              "z": 0.178
            },
            "rightCorner": {
              "x": 8.983,
              "y": -8.194,
              "z": 0.178
            },
            "gtin": "4066447790351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27165c",
            "leftCorner": {
              "x": 8.983,
              "y": -8.194,
              "z": 0.178
            },
            "rightCorner": {
              "x": 8.952,
              "y": -8.166,
              "z": 0.178
            },
            "gtin": "4002448017790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27165d",
            "leftCorner": {
              "x": 8.952,
              "y": -8.166,
              "z": 0.178
            },
            "rightCorner": {
              "x": 8.93,
              "y": -8.145,
              "z": 0.178
            },
            "gtin": "4002448017790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27165e",
            "leftCorner": {
              "x": 8.93,
              "y": -8.145,
              "z": 0.178
            },
            "rightCorner": {
              "x": 8.897,
              "y": -8.115,
              "z": 0.178
            }
          },
          {
            "id": "696ebf7043c343680a27165f",
            "leftCorner": {
              "x": 8.897,
              "y": -8.115,
              "z": 0.178
            },
            "rightCorner": {
              "x": 8.865,
              "y": -8.086,
              "z": 0.178
            },
            "gtin": "4036581540365",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271660",
            "leftCorner": {
              "x": 8.865,
              "y": -8.086,
              "z": 0.178
            },
            "rightCorner": {
              "x": 8.835,
              "y": -8.058,
              "z": 0.178
            },
            "gtin": "4036581536306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271661",
            "leftCorner": {
              "x": 8.835,
              "y": -8.058,
              "z": 0.178
            },
            "rightCorner": {
              "x": 8.809,
              "y": -8.034,
              "z": 0.178
            },
            "gtin": "4036581536306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271662",
            "leftCorner": {
              "x": 8.809,
              "y": -8.034,
              "z": 0.178
            },
            "rightCorner": {
              "x": 8.705,
              "y": -7.94,
              "z": 0.178
            }
          },
          {
            "id": "696ebf7043c343680a271663",
            "leftCorner": {
              "x": 8.705,
              "y": -7.94,
              "z": 0.178
            },
            "rightCorner": {
              "x": 8.592,
              "y": -7.836,
              "z": 0.178
            },
            "gtin": "4058172801440",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271664",
            "leftCorner": {
              "x": 8.592,
              "y": -7.836,
              "z": 0.178
            },
            "rightCorner": {
              "x": 8.511,
              "y": -7.762,
              "z": 0.178
            },
            "gtin": "7322540728439",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aea",
        "height": 0.3996,
        "facings": [
          {
            "id": "696ebf7043c343680a2716fd",
            "leftCorner": {
              "x": 9.218,
              "y": -8.414,
              "z": 0.4
            },
            "rightCorner": {
              "x": 9.101,
              "y": -8.307,
              "z": 0.4
            },
            "gtin": "4260678845020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716ff",
            "leftCorner": {
              "x": 9.101,
              "y": -8.307,
              "z": 0.4
            },
            "rightCorner": {
              "x": 8.984,
              "y": -8.2,
              "z": 0.4
            },
            "gtin": "4260678845051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271700",
            "leftCorner": {
              "x": 8.984,
              "y": -8.2,
              "z": 0.4
            },
            "rightCorner": {
              "x": 8.963,
              "y": -8.181,
              "z": 0.4
            }
          },
          {
            "id": "696ebf7043c343680a271701",
            "leftCorner": {
              "x": 8.963,
              "y": -8.181,
              "z": 0.4
            },
            "rightCorner": {
              "x": 8.897,
              "y": -8.12,
              "z": 0.4
            },
            "gtin": "40623474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271702",
            "leftCorner": {
              "x": 8.897,
              "y": -8.12,
              "z": 0.4
            },
            "rightCorner": {
              "x": 8.875,
              "y": -8.1,
              "z": 0.4
            }
          },
          {
            "id": "696ebf7043c343680a271703",
            "leftCorner": {
              "x": 8.875,
              "y": -8.1,
              "z": 0.4
            },
            "rightCorner": {
              "x": 8.816,
              "y": -8.047,
              "z": 0.4
            },
            "gtin": "4058172996955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271704",
            "leftCorner": {
              "x": 8.816,
              "y": -8.047,
              "z": 0.4
            },
            "rightCorner": {
              "x": 8.796,
              "y": -8.028,
              "z": 0.4
            }
          },
          {
            "id": "696ebf7043c343680a271705",
            "leftCorner": {
              "x": 8.796,
              "y": -8.028,
              "z": 0.4
            },
            "rightCorner": {
              "x": 8.68,
              "y": -7.923,
              "z": 0.4
            },
            "gtin": "4004191015405",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271706",
            "leftCorner": {
              "x": 8.68,
              "y": -7.923,
              "z": 0.4
            },
            "rightCorner": {
              "x": 8.61,
              "y": -7.858,
              "z": 0.4
            },
            "gtin": "4004191015757",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271707",
            "leftCorner": {
              "x": 8.61,
              "y": -7.858,
              "z": 0.4
            },
            "rightCorner": {
              "x": 8.513,
              "y": -7.77,
              "z": 0.4
            },
            "gtin": "4004191012565",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271708",
            "leftCorner": {
              "x": 8.513,
              "y": -7.77,
              "z": 0.4
            },
            "rightCorner": {
              "x": 8.41,
              "y": -7.676,
              "z": 0.4
            },
            "gtin": "4004191012565",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ae8",
        "height": 0.64853,
        "facings": [
          {
            "id": "696ebf7043c343680a2716d3",
            "leftCorner": {
              "x": 9.221,
              "y": -8.412,
              "z": 0.649
            },
            "rightCorner": {
              "x": 9.154,
              "y": -8.351,
              "z": 0.649
            },
            "gtin": "4067796182064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716d4",
            "leftCorner": {
              "x": 9.154,
              "y": -8.351,
              "z": 0.649
            },
            "rightCorner": {
              "x": 9.079,
              "y": -8.282,
              "z": 0.649
            },
            "gtin": "8001090592385",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716d5",
            "leftCorner": {
              "x": 9.079,
              "y": -8.282,
              "z": 0.649
            },
            "rightCorner": {
              "x": 8.995,
              "y": -8.205,
              "z": 0.649
            },
            "gtin": "4027800149902",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716d6",
            "leftCorner": {
              "x": 8.995,
              "y": -8.205,
              "z": 0.649
            },
            "rightCorner": {
              "x": 8.96,
              "y": -8.173,
              "z": 0.649
            },
            "gtin": "4027800383207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716d7",
            "leftCorner": {
              "x": 8.96,
              "y": -8.173,
              "z": 0.649
            },
            "rightCorner": {
              "x": 8.938,
              "y": -8.153,
              "z": 0.649
            },
            "gtin": "4065331001047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716d8",
            "leftCorner": {
              "x": 8.938,
              "y": -8.153,
              "z": 0.649
            },
            "rightCorner": {
              "x": 8.907,
              "y": -8.125,
              "z": 0.649
            },
            "gtin": "4065331001047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716d9",
            "leftCorner": {
              "x": 8.907,
              "y": -8.125,
              "z": 0.649
            },
            "rightCorner": {
              "x": 8.875,
              "y": -8.095,
              "z": 0.649
            },
            "gtin": "4065331000989",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716da",
            "leftCorner": {
              "x": 8.875,
              "y": -8.095,
              "z": 0.649
            },
            "rightCorner": {
              "x": 8.843,
              "y": -8.067,
              "z": 0.649
            },
            "gtin": "4065331000989",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716db",
            "leftCorner": {
              "x": 8.843,
              "y": -8.067,
              "z": 0.649
            },
            "rightCorner": {
              "x": 8.814,
              "y": -8.039,
              "z": 0.649
            },
            "gtin": "4065331000989",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716dc",
            "leftCorner": {
              "x": 8.814,
              "y": -8.039,
              "z": 0.649
            },
            "rightCorner": {
              "x": 8.785,
              "y": -8.013,
              "z": 0.649
            },
            "gtin": "4065331000989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716dd",
            "leftCorner": {
              "x": 8.785,
              "y": -8.013,
              "z": 0.649
            },
            "rightCorner": {
              "x": 8.755,
              "y": -7.986,
              "z": 0.649
            },
            "gtin": "4066447858914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716de",
            "leftCorner": {
              "x": 8.755,
              "y": -7.986,
              "z": 0.649
            },
            "rightCorner": {
              "x": 8.725,
              "y": -7.958,
              "z": 0.649
            },
            "gtin": "4066447524086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716df",
            "leftCorner": {
              "x": 8.725,
              "y": -7.958,
              "z": 0.649
            },
            "rightCorner": {
              "x": 8.696,
              "y": -7.932,
              "z": 0.649
            },
            "gtin": "4066447524086",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716e0",
            "leftCorner": {
              "x": 8.696,
              "y": -7.932,
              "z": 0.649
            },
            "rightCorner": {
              "x": 8.669,
              "y": -7.907,
              "z": 0.649
            },
            "gtin": "4066447787320",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716e1",
            "leftCorner": {
              "x": 8.669,
              "y": -7.907,
              "z": 0.649
            },
            "rightCorner": {
              "x": 8.527,
              "y": -7.777,
              "z": 0.649
            },
            "gtin": "4066447577792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716e2",
            "leftCorner": {
              "x": 8.527,
              "y": -7.777,
              "z": 0.649
            },
            "rightCorner": {
              "x": 8.483,
              "y": -7.737,
              "z": 0.649
            },
            "gtin": "4066447105575",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aec",
        "height": 0.9017,
        "facings": [
          {
            "id": "696ebf7043c343680a271711",
            "leftCorner": {
              "x": 9.22,
              "y": -8.412,
              "z": 0.902
            },
            "rightCorner": {
              "x": 9.02,
              "y": -8.23,
              "z": 0.902
            },
            "gtin": "42104308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271713",
            "leftCorner": {
              "x": 9.02,
              "y": -8.23,
              "z": 0.902
            },
            "rightCorner": {
              "x": 8.9,
              "y": -8.12,
              "z": 0.902
            },
            "gtin": "42467038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271714",
            "leftCorner": {
              "x": 8.9,
              "y": -8.12,
              "z": 0.902
            },
            "rightCorner": {
              "x": 8.865,
              "y": -8.087,
              "z": 0.902
            },
            "gtin": "42275640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271715",
            "leftCorner": {
              "x": 8.865,
              "y": -8.087,
              "z": 0.902
            },
            "rightCorner": {
              "x": 8.837,
              "y": -8.062,
              "z": 0.902
            },
            "gtin": "42275640",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271716",
            "leftCorner": {
              "x": 8.837,
              "y": -8.062,
              "z": 0.902
            },
            "rightCorner": {
              "x": 8.808,
              "y": -8.036,
              "z": 0.902
            },
            "gtin": "42389590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271717",
            "leftCorner": {
              "x": 8.808,
              "y": -8.036,
              "z": 0.902
            },
            "rightCorner": {
              "x": 8.784,
              "y": -8.014,
              "z": 0.902
            },
            "gtin": "50051656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271718",
            "leftCorner": {
              "x": 8.784,
              "y": -8.014,
              "z": 0.902
            },
            "rightCorner": {
              "x": 8.762,
              "y": -7.993,
              "z": 0.902
            },
            "gtin": "50051656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271719",
            "leftCorner": {
              "x": 8.762,
              "y": -7.993,
              "z": 0.902
            },
            "rightCorner": {
              "x": 8.732,
              "y": -7.966,
              "z": 0.902
            },
            "gtin": "59096085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27171a",
            "leftCorner": {
              "x": 8.732,
              "y": -7.966,
              "z": 0.902
            },
            "rightCorner": {
              "x": 8.704,
              "y": -7.941,
              "z": 0.902
            },
            "gtin": "59097785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27171b",
            "leftCorner": {
              "x": 8.704,
              "y": -7.941,
              "z": 0.902
            },
            "rightCorner": {
              "x": 8.677,
              "y": -7.916,
              "z": 0.902
            }
          },
          {
            "id": "696ebf7043c343680a27171c",
            "leftCorner": {
              "x": 8.677,
              "y": -7.916,
              "z": 0.902
            },
            "rightCorner": {
              "x": 8.513,
              "y": -7.766,
              "z": 0.902
            },
            "gtin": "4066447410501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27171d",
            "leftCorner": {
              "x": 8.513,
              "y": -7.766,
              "z": 0.902
            },
            "rightCorner": {
              "x": 8.471,
              "y": -7.728,
              "z": 0.902
            },
            "gtin": "4103040049209",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ae9",
        "height": 1.1579,
        "facings": [
          {
            "id": "696ebf7043c343680a2716e9",
            "leftCorner": {
              "x": 9.224,
              "y": -8.408,
              "z": 1.158
            },
            "rightCorner": {
              "x": 9.118,
              "y": -8.31,
              "z": 1.158
            },
            "gtin": "5010724526804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716eb",
            "leftCorner": {
              "x": 9.118,
              "y": -8.31,
              "z": 1.158
            },
            "rightCorner": {
              "x": 8.992,
              "y": -8.195,
              "z": 1.158
            },
            "gtin": "4058172320828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716ec",
            "leftCorner": {
              "x": 8.992,
              "y": -8.195,
              "z": 1.158
            },
            "rightCorner": {
              "x": 8.874,
              "y": -8.088,
              "z": 1.158
            },
            "gtin": "4064666594125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716ed",
            "leftCorner": {
              "x": 8.874,
              "y": -8.088,
              "z": 1.158
            },
            "rightCorner": {
              "x": 8.839,
              "y": -8.056,
              "z": 1.158
            },
            "gtin": "4064666594125",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716ee",
            "leftCorner": {
              "x": 8.839,
              "y": -8.056,
              "z": 1.158
            },
            "rightCorner": {
              "x": 8.813,
              "y": -8.031,
              "z": 1.158
            },
            "gtin": "4064666045092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716ef",
            "leftCorner": {
              "x": 8.813,
              "y": -8.031,
              "z": 1.158
            },
            "rightCorner": {
              "x": 8.788,
              "y": -8.009,
              "z": 1.158
            },
            "gtin": "4015100810745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716f0",
            "leftCorner": {
              "x": 8.788,
              "y": -8.009,
              "z": 1.158
            },
            "rightCorner": {
              "x": 8.763,
              "y": -7.986,
              "z": 1.158
            },
            "gtin": "4015100810707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716f1",
            "leftCorner": {
              "x": 8.763,
              "y": -7.986,
              "z": 1.158
            },
            "rightCorner": {
              "x": 8.734,
              "y": -7.959,
              "z": 1.158
            },
            "gtin": "4067796218329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716f2",
            "leftCorner": {
              "x": 8.734,
              "y": -7.959,
              "z": 1.158
            },
            "rightCorner": {
              "x": 8.711,
              "y": -7.939,
              "z": 1.158
            },
            "gtin": "4067796218329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716f3",
            "leftCorner": {
              "x": 8.711,
              "y": -7.939,
              "z": 1.158
            },
            "rightCorner": {
              "x": 8.689,
              "y": -7.918,
              "z": 1.158
            }
          },
          {
            "id": "696ebf7043c343680a2716f4",
            "leftCorner": {
              "x": 8.689,
              "y": -7.918,
              "z": 1.158
            },
            "rightCorner": {
              "x": 8.661,
              "y": -7.893,
              "z": 1.158
            },
            "gtin": "4262391991565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716f5",
            "leftCorner": {
              "x": 8.661,
              "y": -7.893,
              "z": 1.158
            },
            "rightCorner": {
              "x": 8.621,
              "y": -7.856,
              "z": 1.158
            },
            "gtin": "4008666272546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716f6",
            "leftCorner": {
              "x": 8.621,
              "y": -7.856,
              "z": 1.158
            },
            "rightCorner": {
              "x": 8.487,
              "y": -7.733,
              "z": 1.158
            },
            "gtin": "4058172925696",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73ae7",
        "height": 1.4123,
        "facings": [
          {
            "id": "696ebf7043c343680a271693",
            "leftCorner": {
              "x": 9.222,
              "y": -8.41,
              "z": 1.412
            },
            "rightCorner": {
              "x": 9.115,
              "y": -8.312,
              "z": 1.412
            },
            "gtin": "5037156288704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271694",
            "leftCorner": {
              "x": 9.115,
              "y": -8.312,
              "z": 1.412
            },
            "rightCorner": {
              "x": 8.982,
              "y": -8.19,
              "z": 1.412
            },
            "gtin": "4066447378856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271695",
            "leftCorner": {
              "x": 8.982,
              "y": -8.19,
              "z": 1.412
            },
            "rightCorner": {
              "x": 8.882,
              "y": -8.099,
              "z": 1.412
            },
            "gtin": "4066447365481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271696",
            "leftCorner": {
              "x": 8.882,
              "y": -8.099,
              "z": 1.412
            },
            "rightCorner": {
              "x": 8.852,
              "y": -8.072,
              "z": 1.412
            },
            "gtin": "4066447365504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271697",
            "leftCorner": {
              "x": 8.852,
              "y": -8.072,
              "z": 1.412
            },
            "rightCorner": {
              "x": 8.824,
              "y": -8.046,
              "z": 1.412
            },
            "gtin": "4015100814736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271698",
            "leftCorner": {
              "x": 8.824,
              "y": -8.046,
              "z": 1.412
            },
            "rightCorner": {
              "x": 8.793,
              "y": -8.017,
              "z": 1.412
            },
            "gtin": "4066447793505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271699",
            "leftCorner": {
              "x": 8.793,
              "y": -8.017,
              "z": 1.412
            },
            "rightCorner": {
              "x": 8.765,
              "y": -7.992,
              "z": 1.412
            },
            "gtin": "4066447332247",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27169a",
            "leftCorner": {
              "x": 8.765,
              "y": -7.992,
              "z": 1.412
            },
            "rightCorner": {
              "x": 8.733,
              "y": -7.963,
              "z": 1.412
            },
            "gtin": "4066447332247",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27169b",
            "leftCorner": {
              "x": 8.733,
              "y": -7.963,
              "z": 1.412
            },
            "rightCorner": {
              "x": 8.7,
              "y": -7.932,
              "z": 1.412
            },
            "gtin": "4066447237528",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27169c",
            "leftCorner": {
              "x": 8.7,
              "y": -7.932,
              "z": 1.412
            },
            "rightCorner": {
              "x": 8.645,
              "y": -7.882,
              "z": 1.412
            },
            "gtin": "4066447237504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27169d",
            "leftCorner": {
              "x": 8.645,
              "y": -7.882,
              "z": 1.412
            },
            "rightCorner": {
              "x": 8.508,
              "y": -7.757,
              "z": 1.412
            },
            "gtin": "4058172920660",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aee",
        "height": 1.6631,
        "facings": [
          {
            "id": "696ebf7043c343680a271729",
            "leftCorner": {
              "x": 9.224,
              "y": -8.409,
              "z": 1.663
            },
            "rightCorner": {
              "x": 8.997,
              "y": -8.201,
              "z": 1.663
            },
            "gtin": "42417309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27172a",
            "leftCorner": {
              "x": 8.997,
              "y": -8.201,
              "z": 1.663
            },
            "rightCorner": {
              "x": 8.651,
              "y": -7.885,
              "z": 1.663
            },
            "gtin": "4066447429305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27172b",
            "leftCorner": {
              "x": 8.651,
              "y": -7.885,
              "z": 1.663
            },
            "rightCorner": {
              "x": 8.518,
              "y": -7.763,
              "z": 1.663
            },
            "gtin": "4066447863246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27172c",
            "leftCorner": {
              "x": 8.518,
              "y": -7.763,
              "z": 1.663
            },
            "rightCorner": {
              "x": 8.486,
              "y": -7.734,
              "z": 1.663
            },
            "gtin": "4067796174762",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc04695993a",
    "name": "68e7572eb5fe7bc04695993a",
    "x": 8.4515,
    "y": -7.7722,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93418,
      "w": 0.35679
    },
    "statistics": {
      "hasStockCount": 16,
      "noStockCount": 0,
      "unknownStockCount": 41
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73af5",
        "height": 0.17878,
        "facings": [
          {
            "id": "696ebf7043c343680a271665",
            "leftCorner": {
              "x": 8.511,
              "y": -7.762,
              "z": 0.178
            },
            "rightCorner": {
              "x": 8.397,
              "y": -7.658,
              "z": 0.178
            },
            "gtin": "4010355486714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271666",
            "leftCorner": {
              "x": 8.395,
              "y": -7.661,
              "z": 0.179
            },
            "rightCorner": {
              "x": 8.278,
              "y": -7.557,
              "z": 0.179
            },
            "gtin": "4067796253740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271667",
            "leftCorner": {
              "x": 8.278,
              "y": -7.557,
              "z": 0.179
            },
            "rightCorner": {
              "x": 8.157,
              "y": -7.448,
              "z": 0.179
            },
            "gtin": "4066447696653",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271668",
            "leftCorner": {
              "x": 8.157,
              "y": -7.448,
              "z": 0.179
            },
            "rightCorner": {
              "x": 7.869,
              "y": -7.191,
              "z": 0.179
            },
            "gtin": "4014531982137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271669",
            "leftCorner": {
              "x": 7.869,
              "y": -7.191,
              "z": 0.179
            },
            "rightCorner": {
              "x": 7.826,
              "y": -7.152,
              "z": 0.179
            },
            "gtin": "4066447758672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27166a",
            "leftCorner": {
              "x": 7.82,
              "y": -7.149,
              "z": 0.179
            },
            "rightCorner": {
              "x": 7.746,
              "y": -7.083,
              "z": 0.179
            },
            "gtin": "4066447858242",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73af4",
        "height": 0.40129,
        "facings": [
          {
            "id": "696ebf7043c343680a271709",
            "leftCorner": {
              "x": 8.407,
              "y": -7.68,
              "z": 0.401
            },
            "rightCorner": {
              "x": 8.288,
              "y": -7.573,
              "z": 0.401
            },
            "gtin": "4004191015849",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27170a",
            "leftCorner": {
              "x": 8.288,
              "y": -7.573,
              "z": 0.401
            },
            "rightCorner": {
              "x": 8.219,
              "y": -7.512,
              "z": 0.401
            }
          },
          {
            "id": "696ebf7043c343680a27170b",
            "leftCorner": {
              "x": 8.219,
              "y": -7.512,
              "z": 0.401
            },
            "rightCorner": {
              "x": 8.178,
              "y": -7.475,
              "z": 0.401
            }
          },
          {
            "id": "696ebf7043c343680a27170c",
            "leftCorner": {
              "x": 8.178,
              "y": -7.475,
              "z": 0.401
            },
            "rightCorner": {
              "x": 8.06,
              "y": -7.369,
              "z": 0.401
            },
            "gtin": "4006000028262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27170d",
            "leftCorner": {
              "x": 8.06,
              "y": -7.369,
              "z": 0.401
            },
            "rightCorner": {
              "x": 8.006,
              "y": -7.321,
              "z": 0.401
            },
            "gtin": "4021457660414",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27170e",
            "leftCorner": {
              "x": 8.006,
              "y": -7.321,
              "z": 0.401
            },
            "rightCorner": {
              "x": 7.975,
              "y": -7.293,
              "z": 0.401
            },
            "gtin": "4058172030055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27170f",
            "leftCorner": {
              "x": 7.975,
              "y": -7.293,
              "z": 0.401
            },
            "rightCorner": {
              "x": 7.928,
              "y": -7.251,
              "z": 0.401
            },
            "gtin": "5052197051629",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271710",
            "leftCorner": {
              "x": 7.928,
              "y": -7.251,
              "z": 0.401
            },
            "rightCorner": {
              "x": 7.827,
              "y": -7.161,
              "z": 0.401
            },
            "gtin": "4066447232097",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716fe",
            "leftCorner": {
              "x": 7.827,
              "y": -7.161,
              "z": 0.401
            },
            "rightCorner": {
              "x": 7.732,
              "y": -7.076,
              "z": 0.401
            },
            "gtin": "4066447016727",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73af3",
        "height": 0.65074,
        "facings": [
          {
            "id": "696ebf7043c343680a2716e3",
            "leftCorner": {
              "x": 8.48,
              "y": -7.74,
              "z": 0.651
            },
            "rightCorner": {
              "x": 8.365,
              "y": -7.635,
              "z": 0.651
            },
            "gtin": "4066447190274",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716e4",
            "leftCorner": {
              "x": 8.364,
              "y": -7.637,
              "z": 0.651
            },
            "rightCorner": {
              "x": 8.297,
              "y": -7.577,
              "z": 0.651
            },
            "gtin": "3574661833842",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716e5",
            "leftCorner": {
              "x": 8.297,
              "y": -7.577,
              "z": 0.651
            },
            "rightCorner": {
              "x": 8.264,
              "y": -7.547,
              "z": 0.651
            },
            "gtin": "3574661833736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716e6",
            "leftCorner": {
              "x": 8.264,
              "y": -7.547,
              "z": 0.651
            },
            "rightCorner": {
              "x": 8.224,
              "y": -7.512,
              "z": 0.651
            },
            "gtin": "3574661833736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716e7",
            "leftCorner": {
              "x": 8.224,
              "y": -7.512,
              "z": 0.651
            },
            "rightCorner": {
              "x": 8.095,
              "y": -7.396,
              "z": 0.651
            },
            "gtin": "4007965133800",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716e8",
            "leftCorner": {
              "x": 8.095,
              "y": -7.396,
              "z": 0.651
            },
            "rightCorner": {
              "x": 7.732,
              "y": -7.071,
              "z": 0.651
            },
            "gtin": "4058172172199",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73af0",
        "height": 0.90501,
        "facings": [
          {
            "id": "696ebf7043c343680a27171e",
            "leftCorner": {
              "x": 8.47,
              "y": -7.729,
              "z": 0.905
            },
            "rightCorner": {
              "x": 8.416,
              "y": -7.68,
              "z": 0.905
            },
            "gtin": "42429166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27171f",
            "leftCorner": {
              "x": 8.416,
              "y": -7.681,
              "z": 0.905
            },
            "rightCorner": {
              "x": 8.373,
              "y": -7.642,
              "z": 0.905
            },
            "gtin": "4066447396294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271720",
            "leftCorner": {
              "x": 8.373,
              "y": -7.642,
              "z": 0.905
            },
            "rightCorner": {
              "x": 8.329,
              "y": -7.602,
              "z": 0.905
            },
            "gtin": "4066447234336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271721",
            "leftCorner": {
              "x": 8.328,
              "y": -7.602,
              "z": 0.905
            },
            "rightCorner": {
              "x": 8.295,
              "y": -7.572,
              "z": 0.905
            },
            "gtin": "4066447234374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271722",
            "leftCorner": {
              "x": 8.295,
              "y": -7.573,
              "z": 0.905
            },
            "rightCorner": {
              "x": 8.274,
              "y": -7.554,
              "z": 0.905
            },
            "gtin": "4066447234374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271723",
            "leftCorner": {
              "x": 8.274,
              "y": -7.554,
              "z": 0.905
            },
            "rightCorner": {
              "x": 8.242,
              "y": -7.525,
              "z": 0.905
            },
            "gtin": "4067796162264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271724",
            "leftCorner": {
              "x": 8.242,
              "y": -7.525,
              "z": 0.905
            },
            "rightCorner": {
              "x": 8.16,
              "y": -7.452,
              "z": 0.905
            },
            "gtin": "4001499967788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271725",
            "leftCorner": {
              "x": 8.16,
              "y": -7.452,
              "z": 0.905
            },
            "rightCorner": {
              "x": 8.046,
              "y": -7.35,
              "z": 0.905
            },
            "gtin": "4001499967788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271726",
            "leftCorner": {
              "x": 8.046,
              "y": -7.35,
              "z": 0.905
            },
            "rightCorner": {
              "x": 7.985,
              "y": -7.295,
              "z": 0.905
            },
            "gtin": "42490999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271727",
            "leftCorner": {
              "x": 7.985,
              "y": -7.295,
              "z": 0.905
            },
            "rightCorner": {
              "x": 7.954,
              "y": -7.268,
              "z": 0.905
            }
          },
          {
            "id": "696ebf7043c343680a271728",
            "leftCorner": {
              "x": 7.954,
              "y": -7.268,
              "z": 0.905
            },
            "rightCorner": {
              "x": 7.833,
              "y": -7.159,
              "z": 0.905
            },
            "gtin": "42506577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271712",
            "leftCorner": {
              "x": 7.833,
              "y": -7.159,
              "z": 0.905
            },
            "rightCorner": {
              "x": 7.736,
              "y": -7.073,
              "z": 0.905
            },
            "gtin": "8008970059921",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73af2",
        "height": 1.1602,
        "facings": [
          {
            "id": "696ebf7043c343680a2716f7",
            "leftCorner": {
              "x": 8.482,
              "y": -7.738,
              "z": 1.16
            },
            "rightCorner": {
              "x": 8.309,
              "y": -7.579,
              "z": 1.16
            },
            "gtin": "42467342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716f8",
            "leftCorner": {
              "x": 8.307,
              "y": -7.581,
              "z": 1.16
            },
            "rightCorner": {
              "x": 8.258,
              "y": -7.537,
              "z": 1.16
            },
            "gtin": "42449515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716f9",
            "leftCorner": {
              "x": 8.258,
              "y": -7.537,
              "z": 1.16
            },
            "rightCorner": {
              "x": 8.206,
              "y": -7.491,
              "z": 1.16
            },
            "gtin": "42269663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716fa",
            "leftCorner": {
              "x": 8.206,
              "y": -7.491,
              "z": 1.16
            },
            "rightCorner": {
              "x": 8.158,
              "y": -7.448,
              "z": 1.16
            },
            "gtin": "42269663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716fb",
            "leftCorner": {
              "x": 8.158,
              "y": -7.448,
              "z": 1.16
            },
            "rightCorner": {
              "x": 8.068,
              "y": -7.367,
              "z": 1.16
            },
            "gtin": "3616302035403",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716fc",
            "leftCorner": {
              "x": 8.068,
              "y": -7.367,
              "z": 1.16
            },
            "rightCorner": {
              "x": 7.859,
              "y": -7.18,
              "z": 1.16
            },
            "gtin": "42389583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716ea",
            "leftCorner": {
              "x": 7.859,
              "y": -7.18,
              "z": 1.16
            },
            "rightCorner": {
              "x": 7.737,
              "y": -7.071,
              "z": 1.16
            },
            "gtin": "4066447600117",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73af1",
        "height": 1.4148,
        "facings": [
          {
            "id": "696ebf7043c343680a27169e",
            "leftCorner": {
              "x": 8.508,
              "y": -7.757,
              "z": 1.412
            },
            "rightCorner": {
              "x": 8.438,
              "y": -7.693,
              "z": 1.412
            },
            "gtin": "4067796002751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27169f",
            "leftCorner": {
              "x": 8.434,
              "y": -7.698,
              "z": 1.415
            },
            "rightCorner": {
              "x": 8.393,
              "y": -7.66,
              "z": 1.415
            },
            "gtin": "8700216260497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716a0",
            "leftCorner": {
              "x": 8.392,
              "y": -7.661,
              "z": 1.415
            },
            "rightCorner": {
              "x": 8.339,
              "y": -7.612,
              "z": 1.415
            },
            "gtin": "4066447870275",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716a1",
            "leftCorner": {
              "x": 8.338,
              "y": -7.612,
              "z": 1.415
            },
            "rightCorner": {
              "x": 8.238,
              "y": -7.522,
              "z": 1.415
            },
            "gtin": "4066447591682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716a2",
            "leftCorner": {
              "x": 8.238,
              "y": -7.522,
              "z": 1.415
            },
            "rightCorner": {
              "x": 8.204,
              "y": -7.492,
              "z": 1.415
            },
            "gtin": "4103040051530",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716a3",
            "leftCorner": {
              "x": 8.204,
              "y": -7.492,
              "z": 1.415
            },
            "rightCorner": {
              "x": 8.171,
              "y": -7.463,
              "z": 1.415
            },
            "gtin": "4066447877533",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716a4",
            "leftCorner": {
              "x": 8.171,
              "y": -7.463,
              "z": 1.415
            },
            "rightCorner": {
              "x": 8.117,
              "y": -7.414,
              "z": 1.415
            },
            "gtin": "4011448001005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716a5",
            "leftCorner": {
              "x": 8.117,
              "y": -7.414,
              "z": 1.415
            },
            "rightCorner": {
              "x": 8.07,
              "y": -7.373,
              "z": 1.415
            },
            "gtin": "42428978",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716a6",
            "leftCorner": {
              "x": 8.07,
              "y": -7.373,
              "z": 1.415
            },
            "rightCorner": {
              "x": 8.025,
              "y": -7.333,
              "z": 1.415
            },
            "gtin": "42269670",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716a7",
            "leftCorner": {
              "x": 8.025,
              "y": -7.333,
              "z": 1.415
            },
            "rightCorner": {
              "x": 7.988,
              "y": -7.299,
              "z": 1.415
            },
            "gtin": "42429784",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716a8",
            "leftCorner": {
              "x": 7.988,
              "y": -7.299,
              "z": 1.415
            },
            "rightCorner": {
              "x": 7.942,
              "y": -7.258,
              "z": 1.415
            },
            "gtin": "4066447109498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716a9",
            "leftCorner": {
              "x": 7.942,
              "y": -7.258,
              "z": 1.415
            },
            "rightCorner": {
              "x": 7.855,
              "y": -7.18,
              "z": 1.415
            },
            "gtin": "3574661750538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716aa",
            "leftCorner": {
              "x": 7.855,
              "y": -7.18,
              "z": 1.415
            },
            "rightCorner": {
              "x": 7.738,
              "y": -7.076,
              "z": 1.415
            },
            "gtin": "4066447366006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716ab",
            "leftCorner": {
              "x": 7.738,
              "y": -7.076,
              "z": 1.415
            },
            "rightCorner": {
              "x": 7.68,
              "y": -7.024,
              "z": 1.415
            },
            "gtin": "4008137015177",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aef",
        "height": 1.6662,
        "facings": [
          {
            "id": "696ebf7043c343680a27172d",
            "leftCorner": {
              "x": 8.482,
              "y": -7.738,
              "z": 1.666
            },
            "rightCorner": {
              "x": 8.373,
              "y": -7.638,
              "z": 1.666
            },
            "gtin": "4066447898804",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27172e",
            "leftCorner": {
              "x": 8.372,
              "y": -7.639,
              "z": 1.666
            },
            "rightCorner": {
              "x": 8.3,
              "y": -7.575,
              "z": 1.666
            },
            "gtin": "42439110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27172f",
            "leftCorner": {
              "x": 8.3,
              "y": -7.575,
              "z": 1.666
            },
            "rightCorner": {
              "x": 8.188,
              "y": -7.475,
              "z": 1.666
            },
            "gtin": "4066447429596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271730",
            "leftCorner": {
              "x": 8.188,
              "y": -7.475,
              "z": 1.666
            },
            "rightCorner": {
              "x": 7.97,
              "y": -7.279,
              "z": 1.666
            },
            "gtin": "4066447429619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271731",
            "leftCorner": {
              "x": 7.97,
              "y": -7.279,
              "z": 1.666
            },
            "rightCorner": {
              "x": 7.905,
              "y": -7.221,
              "z": 1.666
            },
            "gtin": "4066447600346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271732",
            "leftCorner": {
              "x": 7.905,
              "y": -7.221,
              "z": 1.666
            },
            "rightCorner": {
              "x": 7.78,
              "y": -7.11,
              "z": 1.666
            },
            "gtin": "4067796167474",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc04695993b",
    "name": "68e7572eb5fe7bc04695993b",
    "x": 7.7004,
    "y": -7.1041,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93576,
      "w": 0.35263
    },
    "statistics": {
      "hasStockCount": 32,
      "noStockCount": 3,
      "unknownStockCount": 27
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73afc",
        "height": 0.17863,
        "facings": [
          {
            "id": "696ebf7043c343680a27166b",
            "leftCorner": {
              "x": 7.746,
              "y": -7.084,
              "z": 0.179
            },
            "rightCorner": {
              "x": 7.616,
              "y": -6.968,
              "z": 0.179
            },
            "gtin": "4058172309212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27166c",
            "leftCorner": {
              "x": 7.615,
              "y": -6.969,
              "z": 0.179
            },
            "rightCorner": {
              "x": 7.492,
              "y": -6.861,
              "z": 0.179
            },
            "gtin": "4058172310157",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27166d",
            "leftCorner": {
              "x": 7.492,
              "y": -6.861,
              "z": 0.179
            },
            "rightCorner": {
              "x": 7.37,
              "y": -6.754,
              "z": 0.179
            },
            "gtin": "4066447228250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27166e",
            "leftCorner": {
              "x": 7.37,
              "y": -6.754,
              "z": 0.179
            },
            "rightCorner": {
              "x": 7.256,
              "y": -6.653,
              "z": 0.179
            },
            "gtin": "4066447072983",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27166f",
            "leftCorner": {
              "x": 7.256,
              "y": -6.653,
              "z": 0.179
            },
            "rightCorner": {
              "x": 7.139,
              "y": -6.551,
              "z": 0.179
            },
            "gtin": "4058172309137",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271670",
            "leftCorner": {
              "x": 7.139,
              "y": -6.551,
              "z": 0.179
            },
            "rightCorner": {
              "x": 7.037,
              "y": -6.461,
              "z": 0.179
            },
            "gtin": "4066447045901",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73af6",
        "height": 0.43918,
        "facings": [
          {
            "id": "696ebf7043c343680a271757",
            "leftCorner": {
              "x": 7.73,
              "y": -7.071,
              "z": 0.439
            },
            "rightCorner": {
              "x": 7.578,
              "y": -6.937,
              "z": 0.439
            },
            "gtin": "4067796184723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271759",
            "leftCorner": {
              "x": 7.578,
              "y": -6.937,
              "z": 0.439
            },
            "rightCorner": {
              "x": 7.453,
              "y": -6.828,
              "z": 0.439
            },
            "gtin": "4066447212143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27175a",
            "leftCorner": {
              "x": 7.453,
              "y": -6.828,
              "z": 0.439
            },
            "rightCorner": {
              "x": 7.323,
              "y": -6.714,
              "z": 0.439
            },
            "gtin": "4066447212167",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27175b",
            "leftCorner": {
              "x": 7.323,
              "y": -6.714,
              "z": 0.439
            },
            "rightCorner": {
              "x": 7.21,
              "y": -6.615,
              "z": 0.439
            },
            "gtin": "4066447600735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27175c",
            "leftCorner": {
              "x": 7.21,
              "y": -6.615,
              "z": 0.439
            },
            "rightCorner": {
              "x": 7.088,
              "y": -6.508,
              "z": 0.439
            },
            "gtin": "4066447212129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27175d",
            "leftCorner": {
              "x": 7.088,
              "y": -6.508,
              "z": 0.439
            },
            "rightCorner": {
              "x": 6.972,
              "y": -6.405,
              "z": 0.439
            },
            "gtin": "4058172309892",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73afa",
        "height": 0.6914,
        "facings": [
          {
            "id": "696ebf7043c343680a2717ca",
            "leftCorner": {
              "x": 7.73,
              "y": -7.071,
              "z": 0.691
            },
            "rightCorner": {
              "x": 7.6,
              "y": -6.957,
              "z": 0.691
            },
            "gtin": "4058172308710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717cc",
            "leftCorner": {
              "x": 7.6,
              "y": -6.957,
              "z": 0.691
            },
            "rightCorner": {
              "x": 7.48,
              "y": -6.852,
              "z": 0.691
            },
            "gtin": "4058172308314",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717cd",
            "leftCorner": {
              "x": 7.48,
              "y": -6.852,
              "z": 0.691
            },
            "rightCorner": {
              "x": 7.348,
              "y": -6.736,
              "z": 0.691
            },
            "gtin": "4058172309694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717ce",
            "leftCorner": {
              "x": 7.348,
              "y": -6.736,
              "z": 0.691
            },
            "rightCorner": {
              "x": 7.258,
              "y": -6.656,
              "z": 0.691
            },
            "gtin": "4058172308550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717cf",
            "leftCorner": {
              "x": 7.258,
              "y": -6.656,
              "z": 0.691
            },
            "rightCorner": {
              "x": 7.234,
              "y": -6.635,
              "z": 0.691
            }
          },
          {
            "id": "696ebf7043c343680a2717d0",
            "leftCorner": {
              "x": 7.234,
              "y": -6.635,
              "z": 0.691
            },
            "rightCorner": {
              "x": 7.111,
              "y": -6.528,
              "z": 0.691
            },
            "gtin": "4066447517866",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717d1",
            "leftCorner": {
              "x": 7.111,
              "y": -6.528,
              "z": 0.691
            },
            "rightCorner": {
              "x": 7.038,
              "y": -6.463,
              "z": 0.691
            },
            "gtin": "4067796070279",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717d2",
            "leftCorner": {
              "x": 7.038,
              "y": -6.463,
              "z": 0.691
            },
            "rightCorner": {
              "x": 6.972,
              "y": -6.405,
              "z": 0.691
            },
            "gtin": "4067796183474",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73af9",
        "height": 0.94436,
        "facings": [
          {
            "id": "696ebf7043c343680a2717a8",
            "leftCorner": {
              "x": 7.732,
              "y": -7.069,
              "z": 0.944
            },
            "rightCorner": {
              "x": 7.686,
              "y": -7.028,
              "z": 0.944
            },
            "gtin": "4066447518351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717aa",
            "leftCorner": {
              "x": 7.686,
              "y": -7.028,
              "z": 0.944
            },
            "rightCorner": {
              "x": 7.617,
              "y": -6.968,
              "z": 0.944
            },
            "gtin": "4066447890006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717ab",
            "leftCorner": {
              "x": 7.617,
              "y": -6.968,
              "z": 0.944
            },
            "rightCorner": {
              "x": 7.498,
              "y": -6.864,
              "z": 0.944
            },
            "gtin": "4066447342819",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717ac",
            "leftCorner": {
              "x": 7.498,
              "y": -6.864,
              "z": 0.944
            },
            "rightCorner": {
              "x": 7.379,
              "y": -6.759,
              "z": 0.944
            },
            "gtin": "4058172308673",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717ad",
            "leftCorner": {
              "x": 7.379,
              "y": -6.759,
              "z": 0.944
            },
            "rightCorner": {
              "x": 7.322,
              "y": -6.709,
              "z": 0.944
            },
            "gtin": "4058172736810",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717ae",
            "leftCorner": {
              "x": 7.322,
              "y": -6.709,
              "z": 0.944
            },
            "rightCorner": {
              "x": 7.263,
              "y": -6.657,
              "z": 0.944
            },
            "gtin": "4066447889505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717af",
            "leftCorner": {
              "x": 7.263,
              "y": -6.657,
              "z": 0.944
            },
            "rightCorner": {
              "x": 7.217,
              "y": -6.617,
              "z": 0.944
            },
            "gtin": "4008137003037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717b0",
            "leftCorner": {
              "x": 7.217,
              "y": -6.617,
              "z": 0.944
            },
            "rightCorner": {
              "x": 7.169,
              "y": -6.575,
              "z": 0.944
            },
            "gtin": "4066447123333",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717b1",
            "leftCorner": {
              "x": 7.169,
              "y": -6.575,
              "z": 0.944
            },
            "rightCorner": {
              "x": 7.121,
              "y": -6.532,
              "z": 0.944
            },
            "gtin": "4066447123333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717b2",
            "leftCorner": {
              "x": 7.121,
              "y": -6.532,
              "z": 0.944
            },
            "rightCorner": {
              "x": 7.03,
              "y": -6.452,
              "z": 0.944
            },
            "gtin": "4066447517583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717b3",
            "leftCorner": {
              "x": 7.03,
              "y": -6.452,
              "z": 0.944
            },
            "rightCorner": {
              "x": 6.957,
              "y": -6.388,
              "z": 0.944
            },
            "gtin": "4067796063646",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73af7",
        "height": 1.1986,
        "facings": [
          {
            "id": "696ebf7043c343680a271784",
            "leftCorner": {
              "x": 7.733,
              "y": -7.066,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.645,
              "y": -6.988,
              "z": 1.199
            },
            "gtin": "4008137002153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271786",
            "leftCorner": {
              "x": 7.645,
              "y": -6.988,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.56,
              "y": -6.914,
              "z": 1.199
            },
            "gtin": "4008137002955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271787",
            "leftCorner": {
              "x": 7.56,
              "y": -6.914,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.471,
              "y": -6.835,
              "z": 1.199
            },
            "gtin": "4008137002658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271788",
            "leftCorner": {
              "x": 7.471,
              "y": -6.835,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.429,
              "y": -6.799,
              "z": 1.199
            },
            "gtin": "4008137007721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271789",
            "leftCorner": {
              "x": 7.429,
              "y": -6.799,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.409,
              "y": -6.781,
              "z": 1.199
            }
          },
          {
            "id": "696ebf7043c343680a27178a",
            "leftCorner": {
              "x": 7.409,
              "y": -6.781,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.368,
              "y": -6.745,
              "z": 1.199
            },
            "gtin": "4008137002238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27178b",
            "leftCorner": {
              "x": 7.368,
              "y": -6.745,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.279,
              "y": -6.668,
              "z": 1.199
            },
            "gtin": "4008137002894",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27178c",
            "leftCorner": {
              "x": 7.279,
              "y": -6.668,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.182,
              "y": -6.582,
              "z": 1.199
            },
            "gtin": "4008137002603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27178d",
            "leftCorner": {
              "x": 7.182,
              "y": -6.582,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.137,
              "y": -6.542,
              "z": 1.199
            },
            "gtin": "4008137007905",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27178e",
            "leftCorner": {
              "x": 7.137,
              "y": -6.542,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.089,
              "y": -6.5,
              "z": 1.199
            },
            "gtin": "4008137002580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27178f",
            "leftCorner": {
              "x": 7.089,
              "y": -6.5,
              "z": 1.199
            },
            "rightCorner": {
              "x": 6.987,
              "y": -6.41,
              "z": 1.199
            },
            "gtin": "4008137002948",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73afb",
        "height": 1.409,
        "facings": [
          {
            "id": "696ebf7043c343680a2716ac",
            "leftCorner": {
              "x": 7.673,
              "y": -7.023,
              "z": 1.409
            },
            "rightCorner": {
              "x": 7.606,
              "y": -6.965,
              "z": 1.409
            },
            "gtin": "4008137030156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716ad",
            "leftCorner": {
              "x": 7.606,
              "y": -6.965,
              "z": 1.409
            },
            "rightCorner": {
              "x": 7.544,
              "y": -6.91,
              "z": 1.409
            },
            "gtin": "4008137015047",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716ae",
            "leftCorner": {
              "x": 7.544,
              "y": -6.91,
              "z": 1.409
            },
            "rightCorner": {
              "x": 7.523,
              "y": -6.892,
              "z": 1.409
            }
          },
          {
            "id": "696ebf7043c343680a2716af",
            "leftCorner": {
              "x": 7.523,
              "y": -6.892,
              "z": 1.409
            },
            "rightCorner": {
              "x": 7.47,
              "y": -6.845,
              "z": 1.409
            },
            "gtin": "4008137015139",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716b0",
            "leftCorner": {
              "x": 7.47,
              "y": -6.845,
              "z": 1.409
            },
            "rightCorner": {
              "x": 7.413,
              "y": -6.795,
              "z": 1.409
            },
            "gtin": "4008137015085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716b1",
            "leftCorner": {
              "x": 7.413,
              "y": -6.795,
              "z": 1.409
            },
            "rightCorner": {
              "x": 7.393,
              "y": -6.777,
              "z": 1.409
            },
            "gtin": "4008137015085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716b2",
            "leftCorner": {
              "x": 7.393,
              "y": -6.777,
              "z": 1.409
            },
            "rightCorner": {
              "x": 7.318,
              "y": -6.712,
              "z": 1.409
            },
            "gtin": "4008137015016",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716b3",
            "leftCorner": {
              "x": 7.318,
              "y": -6.712,
              "z": 1.409
            },
            "rightCorner": {
              "x": 7.269,
              "y": -6.668,
              "z": 1.409
            },
            "gtin": "4008137002207",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716b4",
            "leftCorner": {
              "x": 7.269,
              "y": -6.668,
              "z": 1.409
            },
            "rightCorner": {
              "x": 7.223,
              "y": -6.629,
              "z": 1.409
            },
            "gtin": "4008137002351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716b5",
            "leftCorner": {
              "x": 7.223,
              "y": -6.629,
              "z": 1.409
            },
            "rightCorner": {
              "x": 7.178,
              "y": -6.589,
              "z": 1.409
            },
            "gtin": "4008137007202",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716b6",
            "leftCorner": {
              "x": 7.178,
              "y": -6.589,
              "z": 1.409
            },
            "rightCorner": {
              "x": 7.133,
              "y": -6.549,
              "z": 1.409
            },
            "gtin": "4008137002528",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716b7",
            "leftCorner": {
              "x": 7.133,
              "y": -6.549,
              "z": 1.409
            },
            "rightCorner": {
              "x": 6.984,
              "y": -6.418,
              "z": 1.409
            },
            "gtin": "4008137005000",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73af8",
        "height": 1.661,
        "facings": [
          {
            "id": "696ebf7043c343680a271733",
            "leftCorner": {
              "x": 7.78,
              "y": -7.11,
              "z": 1.666
            },
            "rightCorner": {
              "x": 7.682,
              "y": -7.022,
              "z": 1.666
            },
            "gtin": "4008137009312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271734",
            "leftCorner": {
              "x": 7.678,
              "y": -7.018,
              "z": 1.661
            },
            "rightCorner": {
              "x": 7.611,
              "y": -6.958,
              "z": 1.661
            },
            "gtin": "4008137015146",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271735",
            "leftCorner": {
              "x": 7.611,
              "y": -6.958,
              "z": 1.661
            },
            "rightCorner": {
              "x": 7.535,
              "y": -6.892,
              "z": 1.661
            },
            "gtin": "4008137009442",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271736",
            "leftCorner": {
              "x": 7.535,
              "y": -6.892,
              "z": 1.661
            },
            "rightCorner": {
              "x": 7.484,
              "y": -6.847,
              "z": 1.661
            },
            "gtin": "4008137009343",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271737",
            "leftCorner": {
              "x": 7.484,
              "y": -6.847,
              "z": 1.661
            },
            "rightCorner": {
              "x": 7.404,
              "y": -6.777,
              "z": 1.661
            },
            "gtin": "4008137009336",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271738",
            "leftCorner": {
              "x": 7.404,
              "y": -6.777,
              "z": 1.661
            },
            "rightCorner": {
              "x": 7.314,
              "y": -6.698,
              "z": 1.661
            },
            "gtin": "4008137002429",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271739",
            "leftCorner": {
              "x": 7.314,
              "y": -6.698,
              "z": 1.661
            },
            "rightCorner": {
              "x": 7.228,
              "y": -6.622,
              "z": 1.661
            },
            "gtin": "4008137002306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27173a",
            "leftCorner": {
              "x": 7.228,
              "y": -6.622,
              "z": 1.661
            },
            "rightCorner": {
              "x": 7.141,
              "y": -6.546,
              "z": 1.661
            },
            "gtin": "4008137002474",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27173b",
            "leftCorner": {
              "x": 7.141,
              "y": -6.546,
              "z": 1.661
            },
            "rightCorner": {
              "x": 7.073,
              "y": -6.486,
              "z": 1.661
            },
            "gtin": "4008137005512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27173c",
            "leftCorner": {
              "x": 7.073,
              "y": -6.486,
              "z": 1.661
            },
            "rightCorner": {
              "x": 7.008,
              "y": -6.429,
              "z": 1.661
            },
            "gtin": "4008137005505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27173d",
            "leftCorner": {
              "x": 7.008,
              "y": -6.429,
              "z": 1.661
            },
            "rightCorner": {
              "x": 6.953,
              "y": -6.381,
              "z": 1.661
            },
            "gtin": "4008137030286",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc04695993c",
    "name": "68e7572eb5fe7bc04695993c",
    "x": 6.9361,
    "y": -6.4373,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93439,
      "w": 0.35624
    },
    "statistics": {
      "hasStockCount": 39,
      "noStockCount": 1,
      "unknownStockCount": 35
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73b03",
        "height": 0.1798,
        "facings": [
          {
            "id": "696ebf7043c343680a271671",
            "leftCorner": {
              "x": 7.037,
              "y": -6.461,
              "z": 0.179
            },
            "rightCorner": {
              "x": 6.872,
              "y": -6.316,
              "z": 0.179
            },
            "gtin": "4001257153002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271672",
            "leftCorner": {
              "x": 6.86,
              "y": -6.308,
              "z": 0.18
            },
            "rightCorner": {
              "x": 6.737,
              "y": -6.198,
              "z": 0.18
            },
            "gtin": "4001257157000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271673",
            "leftCorner": {
              "x": 6.737,
              "y": -6.198,
              "z": 0.18
            },
            "rightCorner": {
              "x": 6.606,
              "y": -6.081,
              "z": 0.18
            },
            "gtin": "4002221009325",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271674",
            "leftCorner": {
              "x": 6.606,
              "y": -6.081,
              "z": 0.18
            },
            "rightCorner": {
              "x": 6.487,
              "y": -5.975,
              "z": 0.18
            },
            "gtin": "4001257154009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271675",
            "leftCorner": {
              "x": 6.487,
              "y": -5.975,
              "z": 0.18
            },
            "rightCorner": {
              "x": 6.36,
              "y": -5.862,
              "z": 0.18
            },
            "gtin": "4001257159004",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271676",
            "leftCorner": {
              "x": 6.36,
              "y": -5.862,
              "z": 0.18
            },
            "rightCorner": {
              "x": 6.232,
              "y": -5.748,
              "z": 0.18
            },
            "gtin": "4002221011311",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b04",
        "height": 0.43951,
        "facings": [
          {
            "id": "696ebf7043c343680a27175e",
            "leftCorner": {
              "x": 6.959,
              "y": -6.398,
              "z": 0.44
            },
            "rightCorner": {
              "x": 6.858,
              "y": -6.308,
              "z": 0.44
            },
            "gtin": "4002221030374",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27175f",
            "leftCorner": {
              "x": 6.858,
              "y": -6.308,
              "z": 0.44
            },
            "rightCorner": {
              "x": 6.749,
              "y": -6.211,
              "z": 0.44
            },
            "gtin": "4002221048362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271760",
            "leftCorner": {
              "x": 6.749,
              "y": -6.211,
              "z": 0.44
            },
            "rightCorner": {
              "x": 6.653,
              "y": -6.125,
              "z": 0.44
            },
            "gtin": "4002221038066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271761",
            "leftCorner": {
              "x": 6.653,
              "y": -6.125,
              "z": 0.44
            },
            "rightCorner": {
              "x": 6.549,
              "y": -6.033,
              "z": 0.44
            },
            "gtin": "4002221038042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271762",
            "leftCorner": {
              "x": 6.549,
              "y": -6.033,
              "z": 0.44
            },
            "rightCorner": {
              "x": 6.448,
              "y": -5.942,
              "z": 0.44
            },
            "gtin": "4002221037946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271763",
            "leftCorner": {
              "x": 6.448,
              "y": -5.942,
              "z": 0.44
            },
            "rightCorner": {
              "x": 6.346,
              "y": -5.851,
              "z": 0.44
            },
            "gtin": "4002221038028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271764",
            "leftCorner": {
              "x": 6.346,
              "y": -5.851,
              "z": 0.44
            },
            "rightCorner": {
              "x": 6.289,
              "y": -5.801,
              "z": 0.44
            },
            "gtin": "4002221040069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271765",
            "leftCorner": {
              "x": 6.289,
              "y": -5.801,
              "z": 0.44
            },
            "rightCorner": {
              "x": 6.22,
              "y": -5.739,
              "z": 0.44
            },
            "gtin": "5021991946059",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73afe",
        "height": 0.68896,
        "facings": [
          {
            "id": "696ebf7043c343680a2717d3",
            "leftCorner": {
              "x": 6.961,
              "y": -6.397,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.903,
              "y": -6.346,
              "z": 0.689
            },
            "gtin": "4067796081770",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717d4",
            "leftCorner": {
              "x": 6.903,
              "y": -6.346,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.837,
              "y": -6.287,
              "z": 0.689
            },
            "gtin": "4066447903546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717d5",
            "leftCorner": {
              "x": 6.837,
              "y": -6.287,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.776,
              "y": -6.232,
              "z": 0.689
            },
            "gtin": "4067796081855",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717d6",
            "leftCorner": {
              "x": 6.776,
              "y": -6.232,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.717,
              "y": -6.18,
              "z": 0.689
            },
            "gtin": "4067796081695",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717d7",
            "leftCorner": {
              "x": 6.717,
              "y": -6.18,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.67,
              "y": -6.138,
              "z": 0.689
            },
            "gtin": "4066447888058",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717d8",
            "leftCorner": {
              "x": 6.67,
              "y": -6.138,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.602,
              "y": -6.077,
              "z": 0.689
            },
            "gtin": "4066447903584",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717d9",
            "leftCorner": {
              "x": 6.602,
              "y": -6.077,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.548,
              "y": -6.029,
              "z": 0.689
            },
            "gtin": "4067796188509",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717da",
            "leftCorner": {
              "x": 6.548,
              "y": -6.029,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.489,
              "y": -5.976,
              "z": 0.689
            },
            "gtin": "4066447888072",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717db",
            "leftCorner": {
              "x": 6.489,
              "y": -5.976,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.431,
              "y": -5.925,
              "z": 0.689
            },
            "gtin": "4066447518436",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717dc",
            "leftCorner": {
              "x": 6.431,
              "y": -5.925,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.364,
              "y": -5.865,
              "z": 0.689
            },
            "gtin": "4066447233162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717dd",
            "leftCorner": {
              "x": 6.364,
              "y": -5.865,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.306,
              "y": -5.813,
              "z": 0.689
            },
            "gtin": "4066447219913",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717de",
            "leftCorner": {
              "x": 6.306,
              "y": -5.813,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.248,
              "y": -5.761,
              "z": 0.689
            },
            "gtin": "4066447233100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717df",
            "leftCorner": {
              "x": 6.248,
              "y": -5.761,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.222,
              "y": -5.738,
              "z": 0.689
            }
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b02",
        "height": 0.94638,
        "facings": [
          {
            "id": "696ebf7043c343680a2717b4",
            "leftCorner": {
              "x": 6.945,
              "y": -6.381,
              "z": 0.946
            },
            "rightCorner": {
              "x": 6.778,
              "y": -6.232,
              "z": 0.946
            },
            "gtin": "4067796063585",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717b5",
            "leftCorner": {
              "x": 6.778,
              "y": -6.232,
              "z": 0.946
            },
            "rightCorner": {
              "x": 6.7,
              "y": -6.162,
              "z": 0.946
            },
            "gtin": "4066447231854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717b6",
            "leftCorner": {
              "x": 6.7,
              "y": -6.162,
              "z": 0.946
            },
            "rightCorner": {
              "x": 6.642,
              "y": -6.111,
              "z": 0.946
            },
            "gtin": "4066447519600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717b7",
            "leftCorner": {
              "x": 6.642,
              "y": -6.111,
              "z": 0.946
            },
            "rightCorner": {
              "x": 6.589,
              "y": -6.063,
              "z": 0.946
            },
            "gtin": "4066447518375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717b8",
            "leftCorner": {
              "x": 6.589,
              "y": -6.063,
              "z": 0.946
            },
            "rightCorner": {
              "x": 6.531,
              "y": -6.012,
              "z": 0.946
            },
            "gtin": "4066447519587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717b9",
            "leftCorner": {
              "x": 6.531,
              "y": -6.012,
              "z": 0.946
            },
            "rightCorner": {
              "x": 6.473,
              "y": -5.96,
              "z": 0.946
            },
            "gtin": "4067796133127",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717ba",
            "leftCorner": {
              "x": 6.473,
              "y": -5.96,
              "z": 0.946
            },
            "rightCorner": {
              "x": 6.415,
              "y": -5.908,
              "z": 0.946
            }
          },
          {
            "id": "696ebf7043c343680a2717bb",
            "leftCorner": {
              "x": 6.415,
              "y": -5.908,
              "z": 0.946
            },
            "rightCorner": {
              "x": 6.357,
              "y": -5.856,
              "z": 0.946
            },
            "gtin": "4066447888096",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717bc",
            "leftCorner": {
              "x": 6.357,
              "y": -5.856,
              "z": 0.946
            },
            "rightCorner": {
              "x": 6.293,
              "y": -5.799,
              "z": 0.946
            },
            "gtin": "4012824401648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717bd",
            "leftCorner": {
              "x": 6.293,
              "y": -5.799,
              "z": 0.946
            },
            "rightCorner": {
              "x": 6.233,
              "y": -5.746,
              "z": 0.946
            },
            "gtin": "4012824401396",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b01",
        "height": 1.1982,
        "facings": [
          {
            "id": "696ebf7043c343680a271790",
            "leftCorner": {
              "x": 6.987,
              "y": -6.41,
              "z": 1.199
            },
            "rightCorner": {
              "x": 6.945,
              "y": -6.374,
              "z": 1.199
            },
            "gtin": "4066447342635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271791",
            "leftCorner": {
              "x": 6.933,
              "y": -6.367,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.885,
              "y": -6.324,
              "z": 1.198
            },
            "gtin": "4066447576733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271792",
            "leftCorner": {
              "x": 6.885,
              "y": -6.324,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.827,
              "y": -6.272,
              "z": 1.198
            },
            "gtin": "4067796063929",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271793",
            "leftCorner": {
              "x": 6.827,
              "y": -6.272,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.777,
              "y": -6.228,
              "z": 1.198
            },
            "gtin": "4066447887990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271794",
            "leftCorner": {
              "x": 6.777,
              "y": -6.228,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.725,
              "y": -6.182,
              "z": 1.198
            },
            "gtin": "4066447584134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271795",
            "leftCorner": {
              "x": 6.725,
              "y": -6.182,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.674,
              "y": -6.136,
              "z": 1.198
            },
            "gtin": "4066447191479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271796",
            "leftCorner": {
              "x": 6.674,
              "y": -6.136,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.627,
              "y": -6.094,
              "z": 1.198
            },
            "gtin": "4066447233124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271797",
            "leftCorner": {
              "x": 6.627,
              "y": -6.094,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.578,
              "y": -6.051,
              "z": 1.198
            },
            "gtin": "4066447232042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271798",
            "leftCorner": {
              "x": 6.578,
              "y": -6.051,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.53,
              "y": -6.008,
              "z": 1.198
            },
            "gtin": "4067796075489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271799",
            "leftCorner": {
              "x": 6.53,
              "y": -6.008,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.48,
              "y": -5.963,
              "z": 1.198
            },
            "gtin": "4066447232035",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27179a",
            "leftCorner": {
              "x": 6.48,
              "y": -5.963,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.426,
              "y": -5.915,
              "z": 1.198
            },
            "gtin": "4066447233148",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27179b",
            "leftCorner": {
              "x": 6.426,
              "y": -5.915,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.38,
              "y": -5.874,
              "z": 1.198
            },
            "gtin": "4066447889482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27179c",
            "leftCorner": {
              "x": 6.38,
              "y": -5.874,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.329,
              "y": -5.829,
              "z": 1.198
            },
            "gtin": "4067796066036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27179d",
            "leftCorner": {
              "x": 6.329,
              "y": -5.829,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.28,
              "y": -5.785,
              "z": 1.198
            },
            "gtin": "4067796066036",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27179e",
            "leftCorner": {
              "x": 6.28,
              "y": -5.785,
              "z": 1.198
            },
            "rightCorner": {
              "x": 6.218,
              "y": -5.73,
              "z": 1.198
            },
            "gtin": "5063270102022",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b00",
        "height": 1.4106,
        "facings": [
          {
            "id": "696ebf7043c343680a2716b8",
            "leftCorner": {
              "x": 6.969,
              "y": -6.401,
              "z": 1.411
            },
            "rightCorner": {
              "x": 6.865,
              "y": -6.31,
              "z": 1.411
            },
            "gtin": "4008137030279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716b9",
            "leftCorner": {
              "x": 6.866,
              "y": -6.309,
              "z": 1.411
            },
            "rightCorner": {
              "x": 6.799,
              "y": -6.25,
              "z": 1.411
            },
            "gtin": "4067796149548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716ba",
            "leftCorner": {
              "x": 6.799,
              "y": -6.25,
              "z": 1.411
            },
            "rightCorner": {
              "x": 6.739,
              "y": -6.196,
              "z": 1.411
            },
            "gtin": "4066447888010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716bb",
            "leftCorner": {
              "x": 6.739,
              "y": -6.196,
              "z": 1.411
            },
            "rightCorner": {
              "x": 6.684,
              "y": -6.146,
              "z": 1.411
            },
            "gtin": "4067796158045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716bc",
            "leftCorner": {
              "x": 6.684,
              "y": -6.146,
              "z": 1.411
            },
            "rightCorner": {
              "x": 6.624,
              "y": -6.093,
              "z": 1.411
            },
            "gtin": "4066447562569",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716bd",
            "leftCorner": {
              "x": 6.624,
              "y": -6.093,
              "z": 1.411
            },
            "rightCorner": {
              "x": 6.567,
              "y": -6.042,
              "z": 1.411
            },
            "gtin": "4066447888034",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716be",
            "leftCorner": {
              "x": 6.567,
              "y": -6.042,
              "z": 1.411
            },
            "rightCorner": {
              "x": 6.513,
              "y": -5.995,
              "z": 1.411
            },
            "gtin": "4066447562545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716bf",
            "leftCorner": {
              "x": 6.513,
              "y": -5.995,
              "z": 1.411
            },
            "rightCorner": {
              "x": 6.453,
              "y": -5.941,
              "z": 1.411
            },
            "gtin": "4066447518399",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716c0",
            "leftCorner": {
              "x": 6.453,
              "y": -5.941,
              "z": 1.411
            },
            "rightCorner": {
              "x": 6.393,
              "y": -5.887,
              "z": 1.411
            },
            "gtin": "4066447562521",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716c1",
            "leftCorner": {
              "x": 6.393,
              "y": -5.887,
              "z": 1.411
            },
            "rightCorner": {
              "x": 6.336,
              "y": -5.836,
              "z": 1.411
            },
            "gtin": "4066447219814",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716c2",
            "leftCorner": {
              "x": 6.336,
              "y": -5.836,
              "z": 1.411
            },
            "rightCorner": {
              "x": 6.273,
              "y": -5.78,
              "z": 1.411
            },
            "gtin": "4066447889123",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716c3",
            "leftCorner": {
              "x": 6.273,
              "y": -5.78,
              "z": 1.411
            },
            "rightCorner": {
              "x": 6.245,
              "y": -5.755,
              "z": 1.411
            },
            "gtin": "4058172624414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716c4",
            "leftCorner": {
              "x": 6.245,
              "y": -5.755,
              "z": 1.411
            },
            "rightCorner": {
              "x": 6.203,
              "y": -5.718,
              "z": 1.411
            },
            "gtin": "4058172624414",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73aff",
        "height": 1.6614,
        "facings": [
          {
            "id": "696ebf7043c343680a27173e",
            "leftCorner": {
              "x": 6.942,
              "y": -6.372,
              "z": 1.661
            },
            "rightCorner": {
              "x": 6.882,
              "y": -6.318,
              "z": 1.661
            },
            "gtin": "4008137005185",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27173f",
            "leftCorner": {
              "x": 6.882,
              "y": -6.318,
              "z": 1.661
            },
            "rightCorner": {
              "x": 6.814,
              "y": -6.257,
              "z": 1.661
            },
            "gtin": "4008137030194",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271740",
            "leftCorner": {
              "x": 6.814,
              "y": -6.257,
              "z": 1.661
            },
            "rightCorner": {
              "x": 6.755,
              "y": -6.204,
              "z": 1.661
            },
            "gtin": "4008137030262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271741",
            "leftCorner": {
              "x": 6.755,
              "y": -6.204,
              "z": 1.661
            },
            "rightCorner": {
              "x": 6.707,
              "y": -6.161,
              "z": 1.661
            },
            "gtin": "4066447231373",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271742",
            "leftCorner": {
              "x": 6.707,
              "y": -6.161,
              "z": 1.661
            },
            "rightCorner": {
              "x": 6.652,
              "y": -6.113,
              "z": 1.661
            },
            "gtin": "4066447238402",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271743",
            "leftCorner": {
              "x": 6.652,
              "y": -6.113,
              "z": 1.661
            },
            "rightCorner": {
              "x": 6.586,
              "y": -6.054,
              "z": 1.661
            },
            "gtin": "4066447788037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271744",
            "leftCorner": {
              "x": 6.586,
              "y": -6.054,
              "z": 1.661
            },
            "rightCorner": {
              "x": 6.529,
              "y": -6.003,
              "z": 1.661
            },
            "gtin": "4066447563955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271745",
            "leftCorner": {
              "x": 6.529,
              "y": -6.003,
              "z": 1.661
            },
            "rightCorner": {
              "x": 6.465,
              "y": -5.946,
              "z": 1.661
            },
            "gtin": "4066447788013",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271746",
            "leftCorner": {
              "x": 6.465,
              "y": -5.946,
              "z": 1.661
            },
            "rightCorner": {
              "x": 6.402,
              "y": -5.89,
              "z": 1.661
            },
            "gtin": "4066447788013",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271747",
            "leftCorner": {
              "x": 6.402,
              "y": -5.89,
              "z": 1.661
            },
            "rightCorner": {
              "x": 6.335,
              "y": -5.829,
              "z": 1.661
            },
            "gtin": "4066447920635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271748",
            "leftCorner": {
              "x": 6.335,
              "y": -5.829,
              "z": 1.661
            },
            "rightCorner": {
              "x": 6.257,
              "y": -5.76,
              "z": 1.661
            },
            "gtin": "4066447521429",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271749",
            "leftCorner": {
              "x": 6.257,
              "y": -5.76,
              "z": 1.661
            },
            "rightCorner": {
              "x": 6.201,
              "y": -5.71,
              "z": 1.661
            },
            "gtin": "4066447375527",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc04695993d",
    "name": "68e7572eb5fe7bc04695993d",
    "x": 6.183,
    "y": -5.7651,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93618,
      "w": 0.35153
    },
    "statistics": {
      "hasStockCount": 63,
      "noStockCount": 0,
      "unknownStockCount": 21
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73b0b",
        "height": 0.17805,
        "facings": [
          {
            "id": "696ebf7043c343680a271677",
            "leftCorner": {
              "x": 6.211,
              "y": -5.733,
              "z": 0.178
            },
            "rightCorner": {
              "x": 6.105,
              "y": -5.638,
              "z": 0.178
            },
            "gtin": "4001257152005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271678",
            "leftCorner": {
              "x": 6.104,
              "y": -5.639,
              "z": 0.178
            },
            "rightCorner": {
              "x": 6.003,
              "y": -5.551,
              "z": 0.178
            },
            "gtin": "4002221041578",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271679",
            "leftCorner": {
              "x": 6.003,
              "y": -5.551,
              "z": 0.178
            },
            "rightCorner": {
              "x": 5.94,
              "y": -5.496,
              "z": 0.178
            },
            "gtin": "4002221051294",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27167a",
            "leftCorner": {
              "x": 5.94,
              "y": -5.496,
              "z": 0.178
            },
            "rightCorner": {
              "x": 5.883,
              "y": -5.446,
              "z": 0.178
            },
            "gtin": "4001257218503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27167b",
            "leftCorner": {
              "x": 5.883,
              "y": -5.446,
              "z": 0.178
            },
            "rightCorner": {
              "x": 5.826,
              "y": -5.396,
              "z": 0.178
            },
            "gtin": "4001257214109",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27167c",
            "leftCorner": {
              "x": 5.826,
              "y": -5.396,
              "z": 0.178
            },
            "rightCorner": {
              "x": 5.768,
              "y": -5.346,
              "z": 0.178
            },
            "gtin": "4002221038103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27167d",
            "leftCorner": {
              "x": 5.768,
              "y": -5.346,
              "z": 0.178
            },
            "rightCorner": {
              "x": 5.702,
              "y": -5.287,
              "z": 0.178
            },
            "gtin": "4001257218404",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27167e",
            "leftCorner": {
              "x": 5.702,
              "y": -5.287,
              "z": 0.178
            },
            "rightCorner": {
              "x": 5.594,
              "y": -5.193,
              "z": 0.178
            },
            "gtin": "4260278366116",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27167f",
            "leftCorner": {
              "x": 5.594,
              "y": -5.193,
              "z": 0.178
            },
            "rightCorner": {
              "x": 5.476,
              "y": -5.09,
              "z": 0.178
            },
            "gtin": "4260278363108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271680",
            "leftCorner": {
              "x": 5.476,
              "y": -5.09,
              "z": 0.178
            },
            "rightCorner": {
              "x": 5.449,
              "y": -5.066,
              "z": 0.178
            }
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b0a",
        "height": 0.44151,
        "facings": [
          {
            "id": "696ebf7043c343680a271766",
            "leftCorner": {
              "x": 6.22,
              "y": -5.739,
              "z": 0.44
            },
            "rightCorner": {
              "x": 6.167,
              "y": -5.692,
              "z": 0.44
            },
            "gtin": "5021991946066",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271767",
            "leftCorner": {
              "x": 6.161,
              "y": -5.684,
              "z": 0.442
            },
            "rightCorner": {
              "x": 6.141,
              "y": -5.667,
              "z": 0.442
            },
            "gtin": "4260189965002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271768",
            "leftCorner": {
              "x": 6.141,
              "y": -5.667,
              "z": 0.442
            },
            "rightCorner": {
              "x": 6.093,
              "y": -5.624,
              "z": 0.442
            },
            "gtin": "4260189965002",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271769",
            "leftCorner": {
              "x": 6.093,
              "y": -5.624,
              "z": 0.442
            },
            "rightCorner": {
              "x": 6.029,
              "y": -5.569,
              "z": 0.442
            },
            "gtin": "4260189965019",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27176a",
            "leftCorner": {
              "x": 6.029,
              "y": -5.569,
              "z": 0.442
            },
            "rightCorner": {
              "x": 5.964,
              "y": -5.512,
              "z": 0.442
            },
            "gtin": "4260189965040",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27176b",
            "leftCorner": {
              "x": 5.964,
              "y": -5.512,
              "z": 0.442
            },
            "rightCorner": {
              "x": 5.904,
              "y": -5.46,
              "z": 0.442
            },
            "gtin": "4260189964999",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27176c",
            "leftCorner": {
              "x": 5.904,
              "y": -5.46,
              "z": 0.442
            },
            "rightCorner": {
              "x": 5.848,
              "y": -5.411,
              "z": 0.442
            },
            "gtin": "4260189965033",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27176d",
            "leftCorner": {
              "x": 5.848,
              "y": -5.411,
              "z": 0.442
            },
            "rightCorner": {
              "x": 5.791,
              "y": -5.361,
              "z": 0.442
            },
            "gtin": "4260189965026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27176e",
            "leftCorner": {
              "x": 5.791,
              "y": -5.361,
              "z": 0.442
            },
            "rightCorner": {
              "x": 5.722,
              "y": -5.301,
              "z": 0.442
            },
            "gtin": "5021991941207",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27176f",
            "leftCorner": {
              "x": 5.722,
              "y": -5.301,
              "z": 0.442
            },
            "rightCorner": {
              "x": 5.666,
              "y": -5.251,
              "z": 0.442
            },
            "gtin": "5021991939051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271770",
            "leftCorner": {
              "x": 5.666,
              "y": -5.251,
              "z": 0.442
            },
            "rightCorner": {
              "x": 5.596,
              "y": -5.191,
              "z": 0.442
            },
            "gtin": "5021991939051",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271771",
            "leftCorner": {
              "x": 5.596,
              "y": -5.191,
              "z": 0.442
            },
            "rightCorner": {
              "x": 5.535,
              "y": -5.137,
              "z": 0.442
            },
            "gtin": "5021991940460",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271772",
            "leftCorner": {
              "x": 5.535,
              "y": -5.137,
              "z": 0.442
            },
            "rightCorner": {
              "x": 5.468,
              "y": -5.079,
              "z": 0.442
            },
            "gtin": "5021991940934",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271773",
            "leftCorner": {
              "x": 5.468,
              "y": -5.079,
              "z": 0.442
            },
            "rightCorner": {
              "x": 5.444,
              "y": -5.058,
              "z": 0.442
            }
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b09",
        "height": 0.69364,
        "facings": [
          {
            "id": "696ebf7043c343680a2717e0",
            "leftCorner": {
              "x": 6.222,
              "y": -5.738,
              "z": 0.689
            },
            "rightCorner": {
              "x": 6.178,
              "y": -5.699,
              "z": 0.689
            },
            "gtin": "4012824406537",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717e1",
            "leftCorner": {
              "x": 6.169,
              "y": -5.694,
              "z": 0.694
            },
            "rightCorner": {
              "x": 6.112,
              "y": -5.644,
              "z": 0.694
            },
            "gtin": "4012824406599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717e2",
            "leftCorner": {
              "x": 6.112,
              "y": -5.644,
              "z": 0.694
            },
            "rightCorner": {
              "x": 6.052,
              "y": -5.591,
              "z": 0.694
            },
            "gtin": "4012824405974",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717e3",
            "leftCorner": {
              "x": 6.052,
              "y": -5.591,
              "z": 0.694
            },
            "rightCorner": {
              "x": 5.989,
              "y": -5.536,
              "z": 0.694
            },
            "gtin": "5021991939648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717e4",
            "leftCorner": {
              "x": 5.989,
              "y": -5.536,
              "z": 0.694
            },
            "rightCorner": {
              "x": 5.921,
              "y": -5.477,
              "z": 0.694
            },
            "gtin": "5021991939044",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717e5",
            "leftCorner": {
              "x": 5.921,
              "y": -5.477,
              "z": 0.694
            },
            "rightCorner": {
              "x": 5.865,
              "y": -5.428,
              "z": 0.694
            },
            "gtin": "5021991939020",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717e6",
            "leftCorner": {
              "x": 5.865,
              "y": -5.428,
              "z": 0.694
            },
            "rightCorner": {
              "x": 5.796,
              "y": -5.367,
              "z": 0.694
            },
            "gtin": "5021991940231",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717e7",
            "leftCorner": {
              "x": 5.796,
              "y": -5.367,
              "z": 0.694
            },
            "rightCorner": {
              "x": 5.716,
              "y": -5.298,
              "z": 0.694
            },
            "gtin": "5021991944789",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717e8",
            "leftCorner": {
              "x": 5.716,
              "y": -5.298,
              "z": 0.694
            },
            "rightCorner": {
              "x": 5.665,
              "y": -5.254,
              "z": 0.694
            },
            "gtin": "5021991944765",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717e9",
            "leftCorner": {
              "x": 5.665,
              "y": -5.254,
              "z": 0.694
            },
            "rightCorner": {
              "x": 5.595,
              "y": -5.192,
              "z": 0.694
            },
            "gtin": "5021991946073",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717ea",
            "leftCorner": {
              "x": 5.595,
              "y": -5.192,
              "z": 0.694
            },
            "rightCorner": {
              "x": 5.531,
              "y": -5.136,
              "z": 0.694
            },
            "gtin": "4012824401211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717cb",
            "leftCorner": {
              "x": 5.531,
              "y": -5.136,
              "z": 0.694
            },
            "rightCorner": {
              "x": 5.459,
              "y": -5.073,
              "z": 0.694
            },
            "gtin": "4012824401211",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b0c",
        "height": 0.94785,
        "facings": [
          {
            "id": "696ebf7043c343680a2717be",
            "leftCorner": {
              "x": 6.233,
              "y": -5.746,
              "z": 0.946
            },
            "rightCorner": {
              "x": 6.174,
              "y": -5.693,
              "z": 0.946
            },
            "gtin": "4012824403185",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717bf",
            "leftCorner": {
              "x": 6.162,
              "y": -5.691,
              "z": 0.948
            },
            "rightCorner": {
              "x": 6.089,
              "y": -5.628,
              "z": 0.948
            },
            "gtin": "4012824404243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717c0",
            "leftCorner": {
              "x": 6.089,
              "y": -5.628,
              "z": 0.948
            },
            "rightCorner": {
              "x": 6.023,
              "y": -5.57,
              "z": 0.948
            },
            "gtin": "4012824401303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717c1",
            "leftCorner": {
              "x": 6.023,
              "y": -5.57,
              "z": 0.948
            },
            "rightCorner": {
              "x": 5.961,
              "y": -5.516,
              "z": 0.948
            },
            "gtin": "4012824401730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717c2",
            "leftCorner": {
              "x": 5.961,
              "y": -5.516,
              "z": 0.948
            },
            "rightCorner": {
              "x": 5.904,
              "y": -5.466,
              "z": 0.948
            },
            "gtin": "4012824404120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717c3",
            "leftCorner": {
              "x": 5.904,
              "y": -5.466,
              "z": 0.948
            },
            "rightCorner": {
              "x": 5.843,
              "y": -5.413,
              "z": 0.948
            },
            "gtin": "4012824401686",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717c4",
            "leftCorner": {
              "x": 5.843,
              "y": -5.413,
              "z": 0.948
            },
            "rightCorner": {
              "x": 5.782,
              "y": -5.359,
              "z": 0.948
            },
            "gtin": "4012824401464",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717c5",
            "leftCorner": {
              "x": 5.782,
              "y": -5.359,
              "z": 0.948
            },
            "rightCorner": {
              "x": 5.711,
              "y": -5.298,
              "z": 0.948
            },
            "gtin": "4012824400016",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717c6",
            "leftCorner": {
              "x": 5.711,
              "y": -5.298,
              "z": 0.948
            },
            "rightCorner": {
              "x": 5.652,
              "y": -5.246,
              "z": 0.948
            },
            "gtin": "4012824401921",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717c7",
            "leftCorner": {
              "x": 5.652,
              "y": -5.246,
              "z": 0.948
            },
            "rightCorner": {
              "x": 5.591,
              "y": -5.192,
              "z": 0.948
            },
            "gtin": "4012824406285",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717c8",
            "leftCorner": {
              "x": 5.591,
              "y": -5.192,
              "z": 0.948
            },
            "rightCorner": {
              "x": 5.519,
              "y": -5.13,
              "z": 0.948
            },
            "gtin": "4012824405493",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717c9",
            "leftCorner": {
              "x": 5.519,
              "y": -5.13,
              "z": 0.948
            },
            "rightCorner": {
              "x": 5.487,
              "y": -5.101,
              "z": 0.948
            },
            "gtin": "5060229014252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717a9",
            "leftCorner": {
              "x": 5.487,
              "y": -5.101,
              "z": 0.948
            },
            "rightCorner": {
              "x": 5.457,
              "y": -5.076,
              "z": 0.948
            },
            "gtin": "5060229014252",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b08",
        "height": 1.2011,
        "facings": [
          {
            "id": "696ebf7043c343680a27179f",
            "leftCorner": {
              "x": 6.206,
              "y": -5.729,
              "z": 1.201
            },
            "rightCorner": {
              "x": 6.147,
              "y": -5.678,
              "z": 1.201
            },
            "gtin": "5060229014146",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717a0",
            "leftCorner": {
              "x": 6.147,
              "y": -5.678,
              "z": 1.201
            },
            "rightCorner": {
              "x": 6.063,
              "y": -5.604,
              "z": 1.201
            },
            "gtin": "5060519145482",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717a1",
            "leftCorner": {
              "x": 6.063,
              "y": -5.604,
              "z": 1.201
            },
            "rightCorner": {
              "x": 5.999,
              "y": -5.548,
              "z": 1.201
            },
            "gtin": "5063270119358",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717a2",
            "leftCorner": {
              "x": 5.999,
              "y": -5.548,
              "z": 1.201
            },
            "rightCorner": {
              "x": 5.939,
              "y": -5.495,
              "z": 1.201
            },
            "gtin": "5060519144126",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717a3",
            "leftCorner": {
              "x": 5.939,
              "y": -5.495,
              "z": 1.201
            },
            "rightCorner": {
              "x": 5.865,
              "y": -5.431,
              "z": 1.201
            },
            "gtin": "5060229014122",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717a4",
            "leftCorner": {
              "x": 5.865,
              "y": -5.431,
              "z": 1.201
            },
            "rightCorner": {
              "x": 5.793,
              "y": -5.368,
              "z": 1.201
            },
            "gtin": "5060519148322",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717a5",
            "leftCorner": {
              "x": 5.793,
              "y": -5.368,
              "z": 1.201
            },
            "rightCorner": {
              "x": 5.672,
              "y": -5.262,
              "z": 1.201
            },
            "gtin": "5060229014351",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717a6",
            "leftCorner": {
              "x": 5.672,
              "y": -5.262,
              "z": 1.201
            },
            "rightCorner": {
              "x": 5.595,
              "y": -5.195,
              "z": 1.201
            },
            "gtin": "5060229014160",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717a7",
            "leftCorner": {
              "x": 5.595,
              "y": -5.195,
              "z": 1.201
            },
            "rightCorner": {
              "x": 5.525,
              "y": -5.134,
              "z": 1.201
            },
            "gtin": "5063270115510",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271785",
            "leftCorner": {
              "x": 5.525,
              "y": -5.134,
              "z": 1.201
            },
            "rightCorner": {
              "x": 5.458,
              "y": -5.075,
              "z": 1.201
            },
            "gtin": "5063270114438",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b06",
        "height": 1.4139,
        "facings": [
          {
            "id": "696ebf7043c343680a2716c5",
            "leftCorner": {
              "x": 6.19,
              "y": -5.717,
              "z": 1.414
            },
            "rightCorner": {
              "x": 6.136,
              "y": -5.67,
              "z": 1.414
            },
            "gtin": "4012346001463",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716c6",
            "leftCorner": {
              "x": 6.136,
              "y": -5.67,
              "z": 1.414
            },
            "rightCorner": {
              "x": 6.098,
              "y": -5.636,
              "z": 1.414
            },
            "gtin": "4012346001531",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716c7",
            "leftCorner": {
              "x": 6.098,
              "y": -5.636,
              "z": 1.414
            },
            "rightCorner": {
              "x": 6.037,
              "y": -5.583,
              "z": 1.414
            },
            "gtin": "4012346525105",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716c8",
            "leftCorner": {
              "x": 6.037,
              "y": -5.583,
              "z": 1.414
            },
            "rightCorner": {
              "x": 5.987,
              "y": -5.539,
              "z": 1.414
            },
            "gtin": "4012346527000",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716c9",
            "leftCorner": {
              "x": 5.987,
              "y": -5.539,
              "z": 1.414
            },
            "rightCorner": {
              "x": 5.924,
              "y": -5.485,
              "z": 1.414
            },
            "gtin": "4012346000602",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716ca",
            "leftCorner": {
              "x": 5.924,
              "y": -5.485,
              "z": 1.414
            },
            "rightCorner": {
              "x": 5.877,
              "y": -5.443,
              "z": 1.414
            },
            "gtin": "4012346001302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716cb",
            "leftCorner": {
              "x": 5.877,
              "y": -5.443,
              "z": 1.414
            },
            "rightCorner": {
              "x": 5.826,
              "y": -5.398,
              "z": 1.414
            },
            "gtin": "4012346286303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716cc",
            "leftCorner": {
              "x": 5.826,
              "y": -5.398,
              "z": 1.414
            },
            "rightCorner": {
              "x": 5.771,
              "y": -5.35,
              "z": 1.414
            },
            "gtin": "4012346261508",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716cd",
            "leftCorner": {
              "x": 5.771,
              "y": -5.35,
              "z": 1.414
            },
            "rightCorner": {
              "x": 5.711,
              "y": -5.298,
              "z": 1.414
            },
            "gtin": "4012346282602",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716ce",
            "leftCorner": {
              "x": 5.711,
              "y": -5.298,
              "z": 1.414
            },
            "rightCorner": {
              "x": 5.665,
              "y": -5.258,
              "z": 1.414
            },
            "gtin": "4012346277202",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716cf",
            "leftCorner": {
              "x": 5.665,
              "y": -5.258,
              "z": 1.414
            },
            "rightCorner": {
              "x": 5.609,
              "y": -5.209,
              "z": 1.414
            },
            "gtin": "4012346277004",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2716d0",
            "leftCorner": {
              "x": 5.609,
              "y": -5.209,
              "z": 1.414
            },
            "rightCorner": {
              "x": 5.558,
              "y": -5.164,
              "z": 1.414
            },
            "gtin": "4012346277608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716d1",
            "leftCorner": {
              "x": 5.558,
              "y": -5.164,
              "z": 1.414
            },
            "rightCorner": {
              "x": 5.505,
              "y": -5.118,
              "z": 1.414
            },
            "gtin": "4012346278001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2716d2",
            "leftCorner": {
              "x": 5.505,
              "y": -5.118,
              "z": 1.414
            },
            "rightCorner": {
              "x": 5.472,
              "y": -5.089,
              "z": 1.414
            },
            "gtin": "4012346509303",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b07",
        "height": 1.665,
        "facings": [
          {
            "id": "696ebf7043c343680a27174a",
            "leftCorner": {
              "x": 6.185,
              "y": -5.713,
              "z": 1.665
            },
            "rightCorner": {
              "x": 6.111,
              "y": -5.648,
              "z": 1.665
            },
            "gtin": "4012346223209",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27174b",
            "leftCorner": {
              "x": 6.111,
              "y": -5.648,
              "z": 1.665
            },
            "rightCorner": {
              "x": 6.048,
              "y": -5.593,
              "z": 1.665
            },
            "gtin": "4012346222301",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27174c",
            "leftCorner": {
              "x": 6.048,
              "y": -5.593,
              "z": 1.665
            },
            "rightCorner": {
              "x": 5.989,
              "y": -5.542,
              "z": 1.665
            },
            "gtin": "4012346222400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27174d",
            "leftCorner": {
              "x": 5.989,
              "y": -5.542,
              "z": 1.665
            },
            "rightCorner": {
              "x": 5.925,
              "y": -5.486,
              "z": 1.665
            },
            "gtin": "4012346222806",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27174e",
            "leftCorner": {
              "x": 5.925,
              "y": -5.486,
              "z": 1.665
            },
            "rightCorner": {
              "x": 5.872,
              "y": -5.439,
              "z": 1.665
            },
            "gtin": "4012346222608",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27174f",
            "leftCorner": {
              "x": 5.872,
              "y": -5.439,
              "z": 1.665
            },
            "rightCorner": {
              "x": 5.808,
              "y": -5.384,
              "z": 1.665
            },
            "gtin": "4012346225203",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271750",
            "leftCorner": {
              "x": 5.808,
              "y": -5.384,
              "z": 1.665
            },
            "rightCorner": {
              "x": 5.748,
              "y": -5.331,
              "z": 1.665
            },
            "gtin": "4012346204505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271751",
            "leftCorner": {
              "x": 5.748,
              "y": -5.331,
              "z": 1.665
            },
            "rightCorner": {
              "x": 5.689,
              "y": -5.28,
              "z": 1.665
            },
            "gtin": "4012346209302",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271752",
            "leftCorner": {
              "x": 5.689,
              "y": -5.28,
              "z": 1.665
            },
            "rightCorner": {
              "x": 5.631,
              "y": -5.229,
              "z": 1.665
            },
            "gtin": "4012346225302",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271753",
            "leftCorner": {
              "x": 5.631,
              "y": -5.229,
              "z": 1.665
            },
            "rightCorner": {
              "x": 5.574,
              "y": -5.179,
              "z": 1.665
            },
            "gtin": "4012346222905",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271754",
            "leftCorner": {
              "x": 5.574,
              "y": -5.179,
              "z": 1.665
            },
            "rightCorner": {
              "x": 5.517,
              "y": -5.129,
              "z": 1.665
            },
            "gtin": "4012346205700",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271755",
            "leftCorner": {
              "x": 5.517,
              "y": -5.129,
              "z": 1.665
            },
            "rightCorner": {
              "x": 5.484,
              "y": -5.1,
              "z": 1.665
            },
            "gtin": "4012346204208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271756",
            "leftCorner": {
              "x": 5.484,
              "y": -5.1,
              "z": 1.665
            },
            "rightCorner": {
              "x": 5.461,
              "y": -5.08,
              "z": 1.665
            },
            "gtin": "4012346204208",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc04695993e",
    "name": "68e7572eb5fe7bc04695993e",
    "x": 5.4294,
    "y": -5.0946,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9364,
      "w": 0.35092
    },
    "statistics": {
      "hasStockCount": 48,
      "noStockCount": 0,
      "unknownStockCount": 29
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73b14",
        "height": 0.18373,
        "facings": [
          {
            "id": "696ebf7043c343680a271681",
            "leftCorner": {
              "x": 5.45,
              "y": -5.053,
              "z": 0.184
            },
            "rightCorner": {
              "x": 5.36,
              "y": -4.975,
              "z": 0.184
            },
            "gtin": "3663458005682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271682",
            "leftCorner": {
              "x": 5.36,
              "y": -4.975,
              "z": 0.184
            },
            "rightCorner": {
              "x": 5.256,
              "y": -4.884,
              "z": 0.184
            },
            "gtin": "4260680635237",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271683",
            "leftCorner": {
              "x": 5.256,
              "y": -4.884,
              "z": 0.184
            },
            "rightCorner": {
              "x": 5.147,
              "y": -4.789,
              "z": 0.184
            },
            "gtin": "4260680635213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271684",
            "leftCorner": {
              "x": 5.147,
              "y": -4.789,
              "z": 0.184
            },
            "rightCorner": {
              "x": 5.046,
              "y": -4.701,
              "z": 0.184
            },
            "gtin": "4260680634919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271685",
            "leftCorner": {
              "x": 5.046,
              "y": -4.701,
              "z": 0.184
            },
            "rightCorner": {
              "x": 5.02,
              "y": -4.678,
              "z": 0.184
            }
          },
          {
            "id": "696ebf7043c343680a271686",
            "leftCorner": {
              "x": 5.02,
              "y": -4.678,
              "z": 0.184
            },
            "rightCorner": {
              "x": 4.923,
              "y": -4.593,
              "z": 0.184
            },
            "gtin": "4260680634896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271687",
            "leftCorner": {
              "x": 4.923,
              "y": -4.593,
              "z": 0.184
            },
            "rightCorner": {
              "x": 4.81,
              "y": -4.495,
              "z": 0.184
            },
            "gtin": "3663458006788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271688",
            "leftCorner": {
              "x": 4.81,
              "y": -4.495,
              "z": 0.184
            },
            "rightCorner": {
              "x": 4.712,
              "y": -4.41,
              "z": 0.184
            },
            "gtin": "3663458006559",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b15",
        "height": 0.4465,
        "facings": [
          {
            "id": "696ebf7043c343680a271774",
            "leftCorner": {
              "x": 5.438,
              "y": -5.051,
              "z": 0.446
            },
            "rightCorner": {
              "x": 5.396,
              "y": -5.014,
              "z": 0.446
            },
            "gtin": "4002590140124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271775",
            "leftCorner": {
              "x": 5.396,
              "y": -5.014,
              "z": 0.446
            },
            "rightCorner": {
              "x": 5.329,
              "y": -4.955,
              "z": 0.446
            },
            "gtin": "4002590705354",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271776",
            "leftCorner": {
              "x": 5.329,
              "y": -4.955,
              "z": 0.446
            },
            "rightCorner": {
              "x": 5.257,
              "y": -4.893,
              "z": 0.446
            }
          },
          {
            "id": "696ebf7043c343680a271777",
            "leftCorner": {
              "x": 5.257,
              "y": -4.893,
              "z": 0.446
            },
            "rightCorner": {
              "x": 5.192,
              "y": -4.836,
              "z": 0.446
            }
          },
          {
            "id": "696ebf7043c343680a271778",
            "leftCorner": {
              "x": 5.192,
              "y": -4.836,
              "z": 0.446
            },
            "rightCorner": {
              "x": 5.122,
              "y": -4.775,
              "z": 0.446
            },
            "gtin": "4011932229335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271779",
            "leftCorner": {
              "x": 5.122,
              "y": -4.775,
              "z": 0.446
            },
            "rightCorner": {
              "x": 5.037,
              "y": -4.701,
              "z": 0.446
            },
            "gtin": "4011932250018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27177a",
            "leftCorner": {
              "x": 5.037,
              "y": -4.701,
              "z": 0.446
            },
            "rightCorner": {
              "x": 4.958,
              "y": -4.633,
              "z": 0.446
            },
            "gtin": "4011932250018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27177b",
            "leftCorner": {
              "x": 4.958,
              "y": -4.633,
              "z": 0.446
            },
            "rightCorner": {
              "x": 4.888,
              "y": -4.571,
              "z": 0.446
            },
            "gtin": "4011932228284",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27177c",
            "leftCorner": {
              "x": 4.888,
              "y": -4.571,
              "z": 0.446
            },
            "rightCorner": {
              "x": 4.735,
              "y": -4.438,
              "z": 0.446
            },
            "gtin": "4066447638783",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27177d",
            "leftCorner": {
              "x": 4.735,
              "y": -4.438,
              "z": 0.446
            },
            "rightCorner": {
              "x": 4.701,
              "y": -4.408,
              "z": 0.446
            },
            "gtin": "4066447638806",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b0d",
        "height": 0.65532,
        "facings": [
          {
            "id": "696ebf7043c343680a2717eb",
            "leftCorner": {
              "x": 5.454,
              "y": -5.066,
              "z": 0.655
            },
            "rightCorner": {
              "x": 5.229,
              "y": -4.871,
              "z": 0.655
            },
            "gtin": "7610700600054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717ed",
            "leftCorner": {
              "x": 5.229,
              "y": -4.871,
              "z": 0.655
            },
            "rightCorner": {
              "x": 5.175,
              "y": -4.823,
              "z": 0.655
            },
            "gtin": "7610700946398",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717ee",
            "leftCorner": {
              "x": 5.175,
              "y": -4.823,
              "z": 0.655
            },
            "rightCorner": {
              "x": 5.055,
              "y": -4.719,
              "z": 0.655
            },
            "gtin": "7610700018545",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717ef",
            "leftCorner": {
              "x": 5.055,
              "y": -4.719,
              "z": 0.655
            },
            "rightCorner": {
              "x": 4.956,
              "y": -4.632,
              "z": 0.655
            },
            "gtin": "7610700946008",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717f0",
            "leftCorner": {
              "x": 4.956,
              "y": -4.632,
              "z": 0.655
            },
            "rightCorner": {
              "x": 4.893,
              "y": -4.577,
              "z": 0.655
            },
            "gtin": "7610700946053",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717f1",
            "leftCorner": {
              "x": 4.893,
              "y": -4.577,
              "z": 0.655
            },
            "rightCorner": {
              "x": 4.799,
              "y": -4.495,
              "z": 0.655
            },
            "gtin": "7610700946541",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717ec",
            "leftCorner": {
              "x": 4.799,
              "y": -4.495,
              "z": 0.655
            },
            "rightCorner": {
              "x": 4.7,
              "y": -4.409,
              "z": 0.655
            },
            "gtin": "7610700946442",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b0e",
        "height": 0.82519,
        "facings": [
          {
            "id": "696ebf7043c343680a2717f2",
            "leftCorner": {
              "x": 5.455,
              "y": -5.065,
              "z": 0.825
            },
            "rightCorner": {
              "x": 5.377,
              "y": -4.996,
              "z": 0.825
            },
            "gtin": "4058172314414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717f4",
            "leftCorner": {
              "x": 5.377,
              "y": -4.996,
              "z": 0.825
            },
            "rightCorner": {
              "x": 5.306,
              "y": -4.935,
              "z": 0.825
            },
            "gtin": "4058172314445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717f5",
            "leftCorner": {
              "x": 5.306,
              "y": -4.935,
              "z": 0.825
            },
            "rightCorner": {
              "x": 5.232,
              "y": -4.87,
              "z": 0.825
            },
            "gtin": "4067796148824",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717f6",
            "leftCorner": {
              "x": 5.232,
              "y": -4.87,
              "z": 0.825
            },
            "rightCorner": {
              "x": 5.16,
              "y": -4.807,
              "z": 0.825
            },
            "gtin": "50836383",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717f7",
            "leftCorner": {
              "x": 5.16,
              "y": -4.807,
              "z": 0.825
            },
            "rightCorner": {
              "x": 5.069,
              "y": -4.728,
              "z": 0.825
            },
            "gtin": "96060636",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717f8",
            "leftCorner": {
              "x": 5.069,
              "y": -4.728,
              "z": 0.825
            },
            "rightCorner": {
              "x": 5.0,
              "y": -4.668,
              "z": 0.825
            },
            "gtin": "50357437",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717f9",
            "leftCorner": {
              "x": 5.0,
              "y": -4.668,
              "z": 0.825
            },
            "rightCorner": {
              "x": 4.974,
              "y": -4.645,
              "z": 0.825
            },
            "gtin": "50357437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717fa",
            "leftCorner": {
              "x": 4.974,
              "y": -4.645,
              "z": 0.825
            },
            "rightCorner": {
              "x": 4.892,
              "y": -4.574,
              "z": 0.825
            },
            "gtin": "50357826",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717fb",
            "leftCorner": {
              "x": 4.892,
              "y": -4.574,
              "z": 0.825
            },
            "rightCorner": {
              "x": 4.805,
              "y": -4.497,
              "z": 0.825
            },
            "gtin": "96130780",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717f3",
            "leftCorner": {
              "x": 4.805,
              "y": -4.497,
              "z": 0.825
            },
            "rightCorner": {
              "x": 4.702,
              "y": -4.408,
              "z": 0.825
            },
            "gtin": "4030300022125",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b10",
        "height": 0.99638,
        "facings": [
          {
            "id": "696ebf7043c343680a271806",
            "leftCorner": {
              "x": 5.452,
              "y": -5.062,
              "z": 0.996
            },
            "rightCorner": {
              "x": 5.385,
              "y": -5.004,
              "z": 0.996
            },
            "gtin": "4260484418272",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271807",
            "leftCorner": {
              "x": 5.385,
              "y": -5.004,
              "z": 0.996
            },
            "rightCorner": {
              "x": 5.288,
              "y": -4.919,
              "z": 0.996
            },
            "gtin": "4066447763201",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271808",
            "leftCorner": {
              "x": 5.288,
              "y": -4.919,
              "z": 0.996
            },
            "rightCorner": {
              "x": 5.175,
              "y": -4.82,
              "z": 0.996
            },
            "gtin": "4066447763225",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271809",
            "leftCorner": {
              "x": 5.175,
              "y": -4.82,
              "z": 0.996
            },
            "rightCorner": {
              "x": 5.111,
              "y": -4.765,
              "z": 0.996
            },
            "gtin": "4009900548861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27180a",
            "leftCorner": {
              "x": 5.111,
              "y": -4.765,
              "z": 0.996
            },
            "rightCorner": {
              "x": 5.039,
              "y": -4.702,
              "z": 0.996
            },
            "gtin": "4009900548755",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27180b",
            "leftCorner": {
              "x": 5.039,
              "y": -4.702,
              "z": 0.996
            },
            "rightCorner": {
              "x": 5.002,
              "y": -4.67,
              "z": 0.996
            },
            "gtin": "4009900547307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27180c",
            "leftCorner": {
              "x": 5.002,
              "y": -4.67,
              "z": 0.996
            },
            "rightCorner": {
              "x": 4.971,
              "y": -4.642,
              "z": 0.996
            },
            "gtin": "4009900547307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27180d",
            "leftCorner": {
              "x": 4.971,
              "y": -4.642,
              "z": 0.996
            },
            "rightCorner": {
              "x": 4.901,
              "y": -4.582,
              "z": 0.996
            },
            "gtin": "40468709",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27180e",
            "leftCorner": {
              "x": 4.901,
              "y": -4.582,
              "z": 0.996
            },
            "rightCorner": {
              "x": 4.798,
              "y": -4.492,
              "z": 0.996
            },
            "gtin": "40468259",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271805",
            "leftCorner": {
              "x": 4.798,
              "y": -4.492,
              "z": 0.996
            },
            "rightCorner": {
              "x": 4.702,
              "y": -4.408,
              "z": 0.996
            },
            "gtin": "42214663",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b12",
        "height": 1.1663,
        "facings": [
          {
            "id": "696ebf7043c343680a271818",
            "leftCorner": {
              "x": 5.454,
              "y": -5.067,
              "z": 1.166
            },
            "rightCorner": {
              "x": 5.365,
              "y": -4.989,
              "z": 1.166
            },
            "gtin": "4009900580533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27181a",
            "leftCorner": {
              "x": 5.365,
              "y": -4.989,
              "z": 1.166
            },
            "rightCorner": {
              "x": 5.264,
              "y": -4.901,
              "z": 1.166
            },
            "gtin": "4009900580502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27181b",
            "leftCorner": {
              "x": 5.264,
              "y": -4.901,
              "z": 1.166
            },
            "rightCorner": {
              "x": 5.221,
              "y": -4.864,
              "z": 1.166
            },
            "gtin": "4009900447300",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27181c",
            "leftCorner": {
              "x": 5.221,
              "y": -4.864,
              "z": 1.166
            },
            "rightCorner": {
              "x": 5.184,
              "y": -4.831,
              "z": 1.166
            },
            "gtin": "4009900447249",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27181d",
            "leftCorner": {
              "x": 5.184,
              "y": -4.831,
              "z": 1.166
            },
            "rightCorner": {
              "x": 5.146,
              "y": -4.798,
              "z": 1.166
            },
            "gtin": "4009900447249",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27181e",
            "leftCorner": {
              "x": 5.146,
              "y": -4.798,
              "z": 1.166
            },
            "rightCorner": {
              "x": 5.023,
              "y": -4.691,
              "z": 1.166
            },
            "gtin": "4009900548915",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27181f",
            "leftCorner": {
              "x": 5.023,
              "y": -4.691,
              "z": 1.166
            },
            "rightCorner": {
              "x": 4.889,
              "y": -4.574,
              "z": 1.166
            },
            "gtin": "4009900549103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271820",
            "leftCorner": {
              "x": 4.889,
              "y": -4.574,
              "z": 1.166
            },
            "rightCorner": {
              "x": 4.794,
              "y": -4.491,
              "z": 1.166
            },
            "gtin": "4009900543705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271819",
            "leftCorner": {
              "x": 4.794,
              "y": -4.491,
              "z": 1.166
            },
            "rightCorner": {
              "x": 4.7,
              "y": -4.409,
              "z": 1.166
            },
            "gtin": "4009900544177",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b11",
        "height": 1.3786,
        "facings": [
          {
            "id": "696ebf7043c343680a27180f",
            "leftCorner": {
              "x": 5.454,
              "y": -5.066,
              "z": 1.379
            },
            "rightCorner": {
              "x": 5.379,
              "y": -5.0,
              "z": 1.379
            },
            "gtin": "5700002082503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271811",
            "leftCorner": {
              "x": 5.379,
              "y": -5.0,
              "z": 1.379
            },
            "rightCorner": {
              "x": 5.276,
              "y": -4.91,
              "z": 1.379
            },
            "gtin": "80746829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271812",
            "leftCorner": {
              "x": 5.276,
              "y": -4.91,
              "z": 1.379
            },
            "rightCorner": {
              "x": 5.199,
              "y": -4.843,
              "z": 1.379
            },
            "gtin": "80731566",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271813",
            "leftCorner": {
              "x": 5.199,
              "y": -4.843,
              "z": 1.379
            },
            "rightCorner": {
              "x": 5.11,
              "y": -4.765,
              "z": 1.379
            },
            "gtin": "4009900544276",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271814",
            "leftCorner": {
              "x": 5.11,
              "y": -4.765,
              "z": 1.379
            },
            "rightCorner": {
              "x": 5.03,
              "y": -4.695,
              "z": 1.379
            },
            "gtin": "4009900544245",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271815",
            "leftCorner": {
              "x": 5.03,
              "y": -4.695,
              "z": 1.379
            },
            "rightCorner": {
              "x": 5.0,
              "y": -4.669,
              "z": 1.379
            }
          },
          {
            "id": "696ebf7043c343680a271816",
            "leftCorner": {
              "x": 5.0,
              "y": -4.669,
              "z": 1.379
            },
            "rightCorner": {
              "x": 4.89,
              "y": -4.574,
              "z": 1.379
            },
            "gtin": "4009900543989",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271817",
            "leftCorner": {
              "x": 4.89,
              "y": -4.574,
              "z": 1.379
            },
            "rightCorner": {
              "x": 4.802,
              "y": -4.497,
              "z": 1.379
            },
            "gtin": "4009900544078",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271810",
            "leftCorner": {
              "x": 4.802,
              "y": -4.497,
              "z": 1.379
            },
            "rightCorner": {
              "x": 4.701,
              "y": -4.409,
              "z": 1.379
            },
            "gtin": "4009900544467",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b0f",
        "height": 1.5455,
        "facings": [
          {
            "id": "696ebf7043c343680a2717fc",
            "leftCorner": {
              "x": 5.452,
              "y": -5.063,
              "z": 1.545
            },
            "rightCorner": {
              "x": 5.325,
              "y": -4.952,
              "z": 1.545
            },
            "gtin": "4260680630379",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2717fd",
            "leftCorner": {
              "x": 5.325,
              "y": -4.952,
              "z": 1.545
            },
            "rightCorner": {
              "x": 5.173,
              "y": -4.819,
              "z": 1.545
            },
            "gtin": "84199485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717fe",
            "leftCorner": {
              "x": 5.173,
              "y": -4.819,
              "z": 1.545
            },
            "rightCorner": {
              "x": 5.098,
              "y": -4.753,
              "z": 1.545
            },
            "gtin": "8723400795438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2717ff",
            "leftCorner": {
              "x": 5.098,
              "y": -4.753,
              "z": 1.545
            },
            "rightCorner": {
              "x": 5.017,
              "y": -4.683,
              "z": 1.545
            },
            "gtin": "8723400798880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271800",
            "leftCorner": {
              "x": 5.017,
              "y": -4.683,
              "z": 1.545
            },
            "rightCorner": {
              "x": 4.959,
              "y": -4.632,
              "z": 1.545
            },
            "gtin": "42123767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271801",
            "leftCorner": {
              "x": 4.959,
              "y": -4.632,
              "z": 1.545
            },
            "rightCorner": {
              "x": 4.89,
              "y": -4.572,
              "z": 1.545
            },
            "gtin": "42113317",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271802",
            "leftCorner": {
              "x": 4.89,
              "y": -4.572,
              "z": 1.545
            },
            "rightCorner": {
              "x": 4.831,
              "y": -4.521,
              "z": 1.545
            },
            "gtin": "42113461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271803",
            "leftCorner": {
              "x": 4.831,
              "y": -4.521,
              "z": 1.545
            },
            "rightCorner": {
              "x": 4.771,
              "y": -4.468,
              "z": 1.545
            },
            "gtin": "42123842",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271804",
            "leftCorner": {
              "x": 4.771,
              "y": -4.468,
              "z": 1.545
            },
            "rightCorner": {
              "x": 4.704,
              "y": -4.41,
              "z": 1.545
            },
            "gtin": "80880974",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b13",
        "height": 1.7111,
        "facings": [
          {
            "id": "696ebf7043c343680a271821",
            "leftCorner": {
              "x": 5.453,
              "y": -5.067,
              "z": 1.711
            },
            "rightCorner": {
              "x": 5.425,
              "y": -5.042,
              "z": 1.711
            }
          },
          {
            "id": "696ebf7043c343680a271822",
            "leftCorner": {
              "x": 5.425,
              "y": -5.042,
              "z": 1.711
            },
            "rightCorner": {
              "x": 5.341,
              "y": -4.969,
              "z": 1.711
            },
            "gtin": "4067796064735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271823",
            "leftCorner": {
              "x": 5.341,
              "y": -4.969,
              "z": 1.711
            },
            "rightCorner": {
              "x": 5.267,
              "y": -4.904,
              "z": 1.711
            },
            "gtin": "4067796160338",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271824",
            "leftCorner": {
              "x": 5.267,
              "y": -4.904,
              "z": 1.711
            },
            "rightCorner": {
              "x": 5.202,
              "y": -4.847,
              "z": 1.711
            },
            "gtin": "4067796064728",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271825",
            "leftCorner": {
              "x": 5.202,
              "y": -4.847,
              "z": 1.711
            },
            "rightCorner": {
              "x": 5.103,
              "y": -4.761,
              "z": 1.711
            },
            "gtin": "4058172420566",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271826",
            "leftCorner": {
              "x": 5.103,
              "y": -4.761,
              "z": 1.711
            },
            "rightCorner": {
              "x": 5.022,
              "y": -4.691,
              "z": 1.711
            },
            "gtin": "4067796160314",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271827",
            "leftCorner": {
              "x": 5.022,
              "y": -4.691,
              "z": 1.711
            },
            "rightCorner": {
              "x": 4.941,
              "y": -4.62,
              "z": 1.711
            },
            "gtin": "4260137743836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271828",
            "leftCorner": {
              "x": 4.941,
              "y": -4.62,
              "z": 1.711
            },
            "rightCorner": {
              "x": 4.866,
              "y": -4.554,
              "z": 1.711
            },
            "gtin": "3609200003070",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271829",
            "leftCorner": {
              "x": 4.866,
              "y": -4.554,
              "z": 1.711
            },
            "rightCorner": {
              "x": 4.777,
              "y": -4.477,
              "z": 1.711
            },
            "gtin": "3609200008495",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27182a",
            "leftCorner": {
              "x": 4.777,
              "y": -4.477,
              "z": 1.711
            },
            "rightCorner": {
              "x": 4.702,
              "y": -4.412,
              "z": 1.711
            },
            "gtin": "3609200003087",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7572eb5fe7bc04695993f",
    "name": "68e7572eb5fe7bc04695993f",
    "x": 4.6762,
    "y": -4.4379,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93623,
      "w": 0.35138
    },
    "statistics": {
      "hasStockCount": 25,
      "noStockCount": 1,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73b1c",
        "height": 0.18238,
        "facings": [
          {
            "id": "696ebf7043c343680a271689",
            "leftCorner": {
              "x": 4.712,
              "y": -4.41,
              "z": 0.184
            },
            "rightCorner": {
              "x": 4.611,
              "y": -4.321,
              "z": 0.184
            },
            "gtin": "4066447607437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27168a",
            "leftCorner": {
              "x": 4.612,
              "y": -4.322,
              "z": 0.182
            },
            "rightCorner": {
              "x": 4.524,
              "y": -4.245,
              "z": 0.182
            },
            "gtin": "4066447607413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27168b",
            "leftCorner": {
              "x": 4.524,
              "y": -4.245,
              "z": 0.182
            },
            "rightCorner": {
              "x": 4.503,
              "y": -4.227,
              "z": 0.182
            }
          },
          {
            "id": "696ebf7043c343680a27168c",
            "leftCorner": {
              "x": 4.503,
              "y": -4.227,
              "z": 0.182
            },
            "rightCorner": {
              "x": 4.423,
              "y": -4.157,
              "z": 0.182
            },
            "gtin": "4066447398823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27168d",
            "leftCorner": {
              "x": 4.423,
              "y": -4.157,
              "z": 0.182
            },
            "rightCorner": {
              "x": 4.402,
              "y": -4.138,
              "z": 0.182
            }
          },
          {
            "id": "696ebf7043c343680a27168e",
            "leftCorner": {
              "x": 4.402,
              "y": -4.138,
              "z": 0.182
            },
            "rightCorner": {
              "x": 4.291,
              "y": -4.042,
              "z": 0.182
            },
            "gtin": "4066447725216",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27168f",
            "leftCorner": {
              "x": 4.291,
              "y": -4.042,
              "z": 0.182
            },
            "rightCorner": {
              "x": 4.184,
              "y": -3.948,
              "z": 0.182
            },
            "gtin": "4066447725216",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271690",
            "leftCorner": {
              "x": 4.184,
              "y": -3.948,
              "z": 0.182
            },
            "rightCorner": {
              "x": 4.074,
              "y": -3.852,
              "z": 0.182
            },
            "gtin": "4066447725230",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271691",
            "leftCorner": {
              "x": 4.074,
              "y": -3.852,
              "z": 0.182
            },
            "rightCorner": {
              "x": 4.052,
              "y": -3.833,
              "z": 0.182
            }
          },
          {
            "id": "696ebf7043c343680a271692",
            "leftCorner": {
              "x": 4.052,
              "y": -3.833,
              "z": 0.182
            },
            "rightCorner": {
              "x": 3.959,
              "y": -3.752,
              "z": 0.182
            },
            "gtin": "4066447399103",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b16",
        "height": 0.44596,
        "facings": [
          {
            "id": "696ebf7043c343680a27177e",
            "leftCorner": {
              "x": 4.704,
              "y": -4.406,
              "z": 0.446
            },
            "rightCorner": {
              "x": 4.646,
              "y": -4.356,
              "z": 0.446
            },
            "gtin": "4066447668179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27177f",
            "leftCorner": {
              "x": 4.646,
              "y": -4.356,
              "z": 0.446
            },
            "rightCorner": {
              "x": 4.602,
              "y": -4.318,
              "z": 0.446
            },
            "gtin": "4066447668193",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271780",
            "leftCorner": {
              "x": 4.602,
              "y": -4.318,
              "z": 0.446
            },
            "rightCorner": {
              "x": 4.446,
              "y": -4.181,
              "z": 0.446
            },
            "gtin": "4066447668193",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271781",
            "leftCorner": {
              "x": 4.446,
              "y": -4.181,
              "z": 0.446
            },
            "rightCorner": {
              "x": 4.425,
              "y": -4.163,
              "z": 0.446
            }
          },
          {
            "id": "696ebf7043c343680a271782",
            "leftCorner": {
              "x": 4.425,
              "y": -4.163,
              "z": 0.446
            },
            "rightCorner": {
              "x": 4.247,
              "y": -4.007,
              "z": 0.446
            },
            "gtin": "4066447607475",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271783",
            "leftCorner": {
              "x": 4.247,
              "y": -4.007,
              "z": 0.446
            },
            "rightCorner": {
              "x": 4.047,
              "y": -3.832,
              "z": 0.446
            },
            "gtin": "4066447607451",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271758",
            "leftCorner": {
              "x": 4.047,
              "y": -3.832,
              "z": 0.446
            },
            "rightCorner": {
              "x": 3.951,
              "y": -3.749,
              "z": 0.446
            },
            "gtin": "4066447871043",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b18",
        "height": 0.69747,
        "facings": [
          {
            "id": "696ebf7043c343680a27183b",
            "leftCorner": {
              "x": 4.704,
              "y": -4.406,
              "z": 0.697
            },
            "rightCorner": {
              "x": 4.595,
              "y": -4.311,
              "z": 0.697
            },
            "gtin": "4054411260627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27183d",
            "leftCorner": {
              "x": 4.595,
              "y": -4.311,
              "z": 0.697
            },
            "rightCorner": {
              "x": 4.482,
              "y": -4.213,
              "z": 0.697
            },
            "gtin": "4054411260504",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27183e",
            "leftCorner": {
              "x": 4.482,
              "y": -4.213,
              "z": 0.697
            },
            "rightCorner": {
              "x": 4.376,
              "y": -4.12,
              "z": 0.697
            },
            "gtin": "4009077026087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27183f",
            "leftCorner": {
              "x": 4.376,
              "y": -4.12,
              "z": 0.697
            },
            "rightCorner": {
              "x": 4.275,
              "y": -4.032,
              "z": 0.697
            },
            "gtin": "4260024450281",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271840",
            "leftCorner": {
              "x": 4.275,
              "y": -4.032,
              "z": 0.697
            },
            "rightCorner": {
              "x": 4.165,
              "y": -3.936,
              "z": 0.697
            },
            "gtin": "4066447614381",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271841",
            "leftCorner": {
              "x": 4.165,
              "y": -3.936,
              "z": 0.697
            },
            "rightCorner": {
              "x": 4.062,
              "y": -3.846,
              "z": 0.697
            },
            "gtin": "4058172308772",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27183c",
            "leftCorner": {
              "x": 4.062,
              "y": -3.846,
              "z": 0.697
            },
            "rightCorner": {
              "x": 3.951,
              "y": -3.748,
              "z": 0.697
            },
            "gtin": "4058172308796",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b17",
        "height": 0.95167,
        "facings": [
          {
            "id": "696ebf7043c343680a271833",
            "leftCorner": {
              "x": 4.701,
              "y": -4.409,
              "z": 0.952
            },
            "rightCorner": {
              "x": 4.596,
              "y": -4.317,
              "z": 0.952
            },
            "gtin": "4030300022088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271835",
            "leftCorner": {
              "x": 4.596,
              "y": -4.317,
              "z": 0.952
            },
            "rightCorner": {
              "x": 4.498,
              "y": -4.231,
              "z": 0.952
            },
            "gtin": "4030300022033",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271836",
            "leftCorner": {
              "x": 4.498,
              "y": -4.231,
              "z": 0.952
            },
            "rightCorner": {
              "x": 4.383,
              "y": -4.131,
              "z": 0.952
            },
            "gtin": "4030300573122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271837",
            "leftCorner": {
              "x": 4.383,
              "y": -4.131,
              "z": 0.952
            },
            "rightCorner": {
              "x": 4.276,
              "y": -4.038,
              "z": 0.952
            },
            "gtin": "4009077081208",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271838",
            "leftCorner": {
              "x": 4.276,
              "y": -4.038,
              "z": 0.952
            },
            "rightCorner": {
              "x": 4.204,
              "y": -3.975,
              "z": 0.952
            },
            "gtin": "4009077020122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271839",
            "leftCorner": {
              "x": 4.204,
              "y": -3.975,
              "z": 0.952
            },
            "rightCorner": {
              "x": 4.135,
              "y": -3.914,
              "z": 0.952
            },
            "gtin": "4009077020559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27183a",
            "leftCorner": {
              "x": 4.135,
              "y": -3.914,
              "z": 0.952
            },
            "rightCorner": {
              "x": 4.013,
              "y": -3.807,
              "z": 0.952
            },
            "gtin": "4009077555235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271834",
            "leftCorner": {
              "x": 4.013,
              "y": -3.807,
              "z": 0.952
            },
            "rightCorner": {
              "x": 3.948,
              "y": -3.751,
              "z": 0.952
            },
            "gtin": "4260024451691",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b1b",
        "height": 1.2064,
        "facings": [
          {
            "id": "696ebf7043c343680a271849",
            "leftCorner": {
              "x": 4.702,
              "y": -4.408,
              "z": 1.206
            },
            "rightCorner": {
              "x": 4.585,
              "y": -4.307,
              "z": 1.206
            },
            "gtin": "4009077024106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27184b",
            "leftCorner": {
              "x": 4.585,
              "y": -4.307,
              "z": 1.206
            },
            "rightCorner": {
              "x": 4.478,
              "y": -4.213,
              "z": 1.206
            },
            "gtin": "4009077031388",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27184c",
            "leftCorner": {
              "x": 4.478,
              "y": -4.213,
              "z": 1.206
            },
            "rightCorner": {
              "x": 4.361,
              "y": -4.11,
              "z": 1.206
            },
            "gtin": "4009077031333",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27184d",
            "leftCorner": {
              "x": 4.361,
              "y": -4.11,
              "z": 1.206
            },
            "rightCorner": {
              "x": 4.26,
              "y": -4.022,
              "z": 1.206
            },
            "gtin": "4009077031562",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27184e",
            "leftCorner": {
              "x": 4.26,
              "y": -4.022,
              "z": 1.206
            },
            "rightCorner": {
              "x": 4.152,
              "y": -3.928,
              "z": 1.206
            },
            "gtin": "4009077026070",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27184f",
            "leftCorner": {
              "x": 4.152,
              "y": -3.928,
              "z": 1.206
            },
            "rightCorner": {
              "x": 4.019,
              "y": -3.812,
              "z": 1.206
            },
            "gtin": "4009077026094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27184a",
            "leftCorner": {
              "x": 4.019,
              "y": -3.812,
              "z": 1.206
            },
            "rightCorner": {
              "x": 3.949,
              "y": -3.75,
              "z": 1.206
            },
            "gtin": "4009077026117",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b1a",
        "height": 1.4623,
        "facings": [
          {
            "id": "696ebf7043c343680a271842",
            "leftCorner": {
              "x": 4.696,
              "y": -4.415,
              "z": 1.462
            },
            "rightCorner": {
              "x": 4.583,
              "y": -4.316,
              "z": 1.462
            },
            "gtin": "4009077024007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271844",
            "leftCorner": {
              "x": 4.583,
              "y": -4.316,
              "z": 1.462
            },
            "rightCorner": {
              "x": 4.481,
              "y": -4.226,
              "z": 1.462
            },
            "gtin": "4009077024458",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271845",
            "leftCorner": {
              "x": 4.481,
              "y": -4.226,
              "z": 1.462
            },
            "rightCorner": {
              "x": 4.346,
              "y": -4.109,
              "z": 1.462
            },
            "gtin": "4009077024601",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271846",
            "leftCorner": {
              "x": 4.346,
              "y": -4.109,
              "z": 1.462
            },
            "rightCorner": {
              "x": 4.234,
              "y": -4.011,
              "z": 1.462
            },
            "gtin": "4009077024656",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271847",
            "leftCorner": {
              "x": 4.234,
              "y": -4.011,
              "z": 1.462
            },
            "rightCorner": {
              "x": 4.131,
              "y": -3.921,
              "z": 1.462
            }
          },
          {
            "id": "696ebf7043c343680a271848",
            "leftCorner": {
              "x": 4.131,
              "y": -3.921,
              "z": 1.462
            },
            "rightCorner": {
              "x": 4.009,
              "y": -3.814,
              "z": 1.462
            },
            "gtin": "4009077026018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271843",
            "leftCorner": {
              "x": 4.009,
              "y": -3.814,
              "z": 1.462
            },
            "rightCorner": {
              "x": 3.943,
              "y": -3.757,
              "z": 1.462
            },
            "gtin": "4009077024151",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b19",
        "height": 1.7114,
        "facings": [
          {
            "id": "696ebf7043c343680a27182b",
            "leftCorner": {
              "x": 4.702,
              "y": -4.412,
              "z": 1.711
            },
            "rightCorner": {
              "x": 4.576,
              "y": -4.301,
              "z": 1.711
            },
            "gtin": "7610700025093",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27182c",
            "leftCorner": {
              "x": 4.574,
              "y": -4.304,
              "z": 1.711
            },
            "rightCorner": {
              "x": 4.469,
              "y": -4.213,
              "z": 1.711
            },
            "gtin": "7610700025116",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27182d",
            "leftCorner": {
              "x": 4.469,
              "y": -4.213,
              "z": 1.711
            },
            "rightCorner": {
              "x": 4.358,
              "y": -4.115,
              "z": 1.711
            },
            "gtin": "7610700025154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27182e",
            "leftCorner": {
              "x": 4.358,
              "y": -4.115,
              "z": 1.711
            },
            "rightCorner": {
              "x": 4.264,
              "y": -4.033,
              "z": 1.711
            },
            "gtin": "7610700025215",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27182f",
            "leftCorner": {
              "x": 4.264,
              "y": -4.033,
              "z": 1.711
            },
            "rightCorner": {
              "x": 4.17,
              "y": -3.951,
              "z": 1.711
            },
            "gtin": "7610700025291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271830",
            "leftCorner": {
              "x": 4.17,
              "y": -3.951,
              "z": 1.711
            },
            "rightCorner": {
              "x": 4.076,
              "y": -3.869,
              "z": 1.711
            },
            "gtin": "7610700025253",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271831",
            "leftCorner": {
              "x": 4.076,
              "y": -3.869,
              "z": 1.711
            },
            "rightCorner": {
              "x": 4.056,
              "y": -3.851,
              "z": 1.711
            }
          },
          {
            "id": "696ebf7043c343680a271832",
            "leftCorner": {
              "x": 4.056,
              "y": -3.851,
              "z": 1.711
            },
            "rightCorner": {
              "x": 3.953,
              "y": -3.761,
              "z": 1.711
            },
            "gtin": "7610700025079",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7575bb5fe7bc0469599a4",
    "name": "68e7575bb5fe7bc0469599a4",
    "x": 3.9096,
    "y": -1.3096,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.35995,
      "w": 0.93297
    },
    "statistics": {
      "hasStockCount": 51,
      "noStockCount": 1,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73c30",
        "height": 0.21378,
        "facings": [
          {
            "id": "696ebf7143c343680a272083",
            "leftCorner": {
              "x": 3.897,
              "y": -1.359,
              "z": 0.214
            },
            "rightCorner": {
              "x": 4.394,
              "y": -1.81,
              "z": 0.214
            },
            "gtin": "6976202760032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272084",
            "leftCorner": {
              "x": 4.394,
              "y": -1.81,
              "z": 0.214
            },
            "rightCorner": {
              "x": 4.499,
              "y": -1.905,
              "z": 0.214
            },
            "gtin": "4066447675122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272082",
            "leftCorner": {
              "x": 4.499,
              "y": -1.905,
              "z": 0.214
            },
            "rightCorner": {
              "x": 4.62,
              "y": -2.015,
              "z": 0.214
            },
            "gtin": "4042441020410",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c31",
        "height": 0.51773,
        "facings": [
          {
            "id": "696ebf7143c343680a272085",
            "leftCorner": {
              "x": 3.95,
              "y": -1.265,
              "z": 0.518
            },
            "rightCorner": {
              "x": 4.027,
              "y": -1.334,
              "z": 0.518
            },
            "gtin": "4058172323485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272086",
            "leftCorner": {
              "x": 4.027,
              "y": -1.334,
              "z": 0.518
            },
            "rightCorner": {
              "x": 4.095,
              "y": -1.395,
              "z": 0.518
            }
          },
          {
            "id": "696ebf7143c343680a272087",
            "leftCorner": {
              "x": 4.095,
              "y": -1.395,
              "z": 0.518
            },
            "rightCorner": {
              "x": 4.139,
              "y": -1.435,
              "z": 0.518
            },
            "gtin": "4058172309595",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272088",
            "leftCorner": {
              "x": 4.139,
              "y": -1.435,
              "z": 0.518
            },
            "rightCorner": {
              "x": 4.194,
              "y": -1.486,
              "z": 0.518
            },
            "gtin": "4058172778131",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272089",
            "leftCorner": {
              "x": 4.194,
              "y": -1.486,
              "z": 0.518
            },
            "rightCorner": {
              "x": 4.251,
              "y": -1.537,
              "z": 0.518
            },
            "gtin": "4003626908114",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27208a",
            "leftCorner": {
              "x": 4.251,
              "y": -1.537,
              "z": 0.518
            },
            "rightCorner": {
              "x": 4.302,
              "y": -1.584,
              "z": 0.518
            },
            "gtin": "4003626111217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27208b",
            "leftCorner": {
              "x": 4.302,
              "y": -1.584,
              "z": 0.518
            },
            "rightCorner": {
              "x": 4.415,
              "y": -1.686,
              "z": 0.518
            },
            "gtin": "3663555002072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a27208c",
            "leftCorner": {
              "x": 4.415,
              "y": -1.686,
              "z": 0.518
            },
            "rightCorner": {
              "x": 4.483,
              "y": -1.748,
              "z": 0.518
            },
            "gtin": "4036581526253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a27208d",
            "leftCorner": {
              "x": 4.483,
              "y": -1.748,
              "z": 0.518
            },
            "rightCorner": {
              "x": 4.551,
              "y": -1.809,
              "z": 0.518
            },
            "gtin": "4036581534005",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27208e",
            "leftCorner": {
              "x": 4.551,
              "y": -1.809,
              "z": 0.518
            },
            "rightCorner": {
              "x": 4.6,
              "y": -1.853,
              "z": 0.518
            },
            "gtin": "4036581526949",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27208f",
            "leftCorner": {
              "x": 4.6,
              "y": -1.853,
              "z": 0.518
            },
            "rightCorner": {
              "x": 4.646,
              "y": -1.895,
              "z": 0.518
            },
            "gtin": "4036581526871",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272090",
            "leftCorner": {
              "x": 4.646,
              "y": -1.895,
              "z": 0.518
            },
            "rightCorner": {
              "x": 4.688,
              "y": -1.933,
              "z": 0.518
            },
            "gtin": "4036581531257",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c2b",
        "height": 0.76954,
        "facings": [
          {
            "id": "696ebf7143c343680a27204b",
            "leftCorner": {
              "x": 3.969,
              "y": -1.279,
              "z": 0.77
            },
            "rightCorner": {
              "x": 4.027,
              "y": -1.332,
              "z": 0.77
            },
            "gtin": "4001669420013",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27204c",
            "leftCorner": {
              "x": 4.027,
              "y": -1.332,
              "z": 0.77
            },
            "rightCorner": {
              "x": 4.085,
              "y": -1.384,
              "z": 0.77
            },
            "gtin": "4001669410014",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27204d",
            "leftCorner": {
              "x": 4.085,
              "y": -1.384,
              "z": 0.77
            },
            "rightCorner": {
              "x": 4.151,
              "y": -1.444,
              "z": 0.77
            },
            "gtin": "4001669412100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27204e",
            "leftCorner": {
              "x": 4.151,
              "y": -1.444,
              "z": 0.77
            },
            "rightCorner": {
              "x": 4.209,
              "y": -1.497,
              "z": 0.77
            },
            "gtin": "4001669418041",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27204f",
            "leftCorner": {
              "x": 4.209,
              "y": -1.497,
              "z": 0.77
            },
            "rightCorner": {
              "x": 4.275,
              "y": -1.557,
              "z": 0.77
            },
            "gtin": "4001669410328",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272050",
            "leftCorner": {
              "x": 4.275,
              "y": -1.557,
              "z": 0.77
            },
            "rightCorner": {
              "x": 4.337,
              "y": -1.613,
              "z": 0.77
            },
            "gtin": "4001669418027",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272051",
            "leftCorner": {
              "x": 4.337,
              "y": -1.613,
              "z": 0.77
            },
            "rightCorner": {
              "x": 4.393,
              "y": -1.664,
              "z": 0.77
            },
            "gtin": "4001669408035",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272052",
            "leftCorner": {
              "x": 4.393,
              "y": -1.664,
              "z": 0.77
            },
            "rightCorner": {
              "x": 4.444,
              "y": -1.71,
              "z": 0.77
            },
            "gtin": "4001669412070",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272053",
            "leftCorner": {
              "x": 4.444,
              "y": -1.71,
              "z": 0.77
            },
            "rightCorner": {
              "x": 4.507,
              "y": -1.767,
              "z": 0.77
            },
            "gtin": "4036581531196",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272054",
            "leftCorner": {
              "x": 4.507,
              "y": -1.767,
              "z": 0.77
            },
            "rightCorner": {
              "x": 4.565,
              "y": -1.819,
              "z": 0.77
            },
            "gtin": "4044571221217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272055",
            "leftCorner": {
              "x": 4.565,
              "y": -1.819,
              "z": 0.77
            },
            "rightCorner": {
              "x": 4.619,
              "y": -1.869,
              "z": 0.77
            },
            "gtin": "4044571240218",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27204a",
            "leftCorner": {
              "x": 4.619,
              "y": -1.869,
              "z": 0.77
            },
            "rightCorner": {
              "x": 4.692,
              "y": -1.935,
              "z": 0.77
            },
            "gtin": "4044571240232",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c2f",
        "height": 1.024,
        "facings": [
          {
            "id": "696ebf7143c343680a272076",
            "leftCorner": {
              "x": 3.955,
              "y": -1.259,
              "z": 1.024
            },
            "rightCorner": {
              "x": 4.01,
              "y": -1.308,
              "z": 1.024
            },
            "gtin": "4002448204114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272078",
            "leftCorner": {
              "x": 4.01,
              "y": -1.308,
              "z": 1.024
            },
            "rightCorner": {
              "x": 4.073,
              "y": -1.366,
              "z": 1.024
            },
            "gtin": "4002448190493",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272079",
            "leftCorner": {
              "x": 4.073,
              "y": -1.366,
              "z": 1.024
            },
            "rightCorner": {
              "x": 4.142,
              "y": -1.428,
              "z": 1.024
            },
            "gtin": "4002448204299",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27207a",
            "leftCorner": {
              "x": 4.142,
              "y": -1.428,
              "z": 1.024
            },
            "rightCorner": {
              "x": 4.202,
              "y": -1.482,
              "z": 1.024
            },
            "gtin": "4002448204145",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27207b",
            "leftCorner": {
              "x": 4.202,
              "y": -1.482,
              "z": 1.024
            },
            "rightCorner": {
              "x": 4.265,
              "y": -1.539,
              "z": 1.024
            },
            "gtin": "4002448204190",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27207c",
            "leftCorner": {
              "x": 4.265,
              "y": -1.539,
              "z": 1.024
            },
            "rightCorner": {
              "x": 4.327,
              "y": -1.596,
              "z": 1.024
            },
            "gtin": "4002448189404",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27207d",
            "leftCorner": {
              "x": 4.327,
              "y": -1.596,
              "z": 1.024
            },
            "rightCorner": {
              "x": 4.39,
              "y": -1.653,
              "z": 1.024
            },
            "gtin": "4008600448709",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27207e",
            "leftCorner": {
              "x": 4.39,
              "y": -1.653,
              "z": 1.024
            },
            "rightCorner": {
              "x": 4.447,
              "y": -1.705,
              "z": 1.024
            },
            "gtin": "4008600433743",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27207f",
            "leftCorner": {
              "x": 4.447,
              "y": -1.705,
              "z": 1.024
            },
            "rightCorner": {
              "x": 4.515,
              "y": -1.766,
              "z": 1.024
            },
            "gtin": "4008600433712",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272080",
            "leftCorner": {
              "x": 4.515,
              "y": -1.766,
              "z": 1.024
            },
            "rightCorner": {
              "x": 4.572,
              "y": -1.818,
              "z": 1.024
            },
            "gtin": "4008600433736",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272081",
            "leftCorner": {
              "x": 4.572,
              "y": -1.818,
              "z": 1.024
            },
            "rightCorner": {
              "x": 4.63,
              "y": -1.871,
              "z": 1.024
            },
            "gtin": "4008600433729",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272077",
            "leftCorner": {
              "x": 4.63,
              "y": -1.871,
              "z": 1.024
            },
            "rightCorner": {
              "x": 4.696,
              "y": -1.931,
              "z": 1.024
            },
            "gtin": "4044571240225",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c2e",
        "height": 1.2793,
        "facings": [
          {
            "id": "696ebf7143c343680a272070",
            "leftCorner": {
              "x": 4.247,
              "y": -1.517,
              "z": 1.279
            },
            "rightCorner": {
              "x": 4.309,
              "y": -1.573,
              "z": 1.279
            },
            "gtin": "4002448190325",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27206b",
            "leftCorner": {
              "x": 3.959,
              "y": -1.256,
              "z": 1.279
            },
            "rightCorner": {
              "x": 4.008,
              "y": -1.301,
              "z": 1.279
            },
            "gtin": "4002448131601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a27206d",
            "leftCorner": {
              "x": 4.008,
              "y": -1.301,
              "z": 1.279
            },
            "rightCorner": {
              "x": 4.12,
              "y": -1.402,
              "z": 1.279
            },
            "gtin": "4002448190295",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27206e",
            "leftCorner": {
              "x": 4.12,
              "y": -1.402,
              "z": 1.279
            },
            "rightCorner": {
              "x": 4.182,
              "y": -1.458,
              "z": 1.279
            },
            "gtin": "4002448131663",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27206f",
            "leftCorner": {
              "x": 4.182,
              "y": -1.458,
              "z": 1.279
            },
            "rightCorner": {
              "x": 4.247,
              "y": -1.517,
              "z": 1.279
            },
            "gtin": "4260508540330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272071",
            "leftCorner": {
              "x": 4.309,
              "y": -1.573,
              "z": 1.279
            },
            "rightCorner": {
              "x": 4.373,
              "y": -1.631,
              "z": 1.279
            },
            "gtin": "4002448190325",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272072",
            "leftCorner": {
              "x": 4.373,
              "y": -1.631,
              "z": 1.279
            },
            "rightCorner": {
              "x": 4.447,
              "y": -1.699,
              "z": 1.279
            },
            "gtin": "4251460624633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272073",
            "leftCorner": {
              "x": 4.447,
              "y": -1.699,
              "z": 1.279
            },
            "rightCorner": {
              "x": 4.506,
              "y": -1.752,
              "z": 1.279
            },
            "gtin": "4251665310379",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272074",
            "leftCorner": {
              "x": 4.506,
              "y": -1.752,
              "z": 1.279
            },
            "rightCorner": {
              "x": 4.567,
              "y": -1.807,
              "z": 1.279
            },
            "gtin": "4251665310447",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272075",
            "leftCorner": {
              "x": 4.567,
              "y": -1.807,
              "z": 1.279
            },
            "rightCorner": {
              "x": 4.628,
              "y": -1.862,
              "z": 1.279
            },
            "gtin": "4251665310362",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27206c",
            "leftCorner": {
              "x": 4.628,
              "y": -1.862,
              "z": 1.279
            },
            "rightCorner": {
              "x": 4.699,
              "y": -1.927,
              "z": 1.279
            },
            "gtin": "4251665310362",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c2c",
        "height": 1.533,
        "facings": [
          {
            "id": "696ebf7143c343680a272056",
            "leftCorner": {
              "x": 3.957,
              "y": -1.257,
              "z": 1.533
            },
            "rightCorner": {
              "x": 4.038,
              "y": -1.33,
              "z": 1.533
            },
            "gtin": "5038483959374",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272057",
            "leftCorner": {
              "x": 4.038,
              "y": -1.33,
              "z": 1.533
            },
            "rightCorner": {
              "x": 4.224,
              "y": -1.499,
              "z": 1.533
            },
            "gtin": "4002448189350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272058",
            "leftCorner": {
              "x": 4.224,
              "y": -1.499,
              "z": 1.533
            },
            "rightCorner": {
              "x": 4.335,
              "y": -1.599,
              "z": 1.533
            },
            "gtin": "4001669090070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272059",
            "leftCorner": {
              "x": 4.335,
              "y": -1.599,
              "z": 1.533
            },
            "rightCorner": {
              "x": 4.389,
              "y": -1.648,
              "z": 1.533
            },
            "gtin": "4001669091527",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27205a",
            "leftCorner": {
              "x": 4.389,
              "y": -1.648,
              "z": 1.533
            },
            "rightCorner": {
              "x": 4.457,
              "y": -1.71,
              "z": 1.533
            },
            "gtin": "4044571095009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a27205b",
            "leftCorner": {
              "x": 4.457,
              "y": -1.71,
              "z": 1.533
            },
            "rightCorner": {
              "x": 4.531,
              "y": -1.777,
              "z": 1.533
            },
            "gtin": "4002448191094",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27205c",
            "leftCorner": {
              "x": 4.531,
              "y": -1.777,
              "z": 1.533
            },
            "rightCorner": {
              "x": 4.607,
              "y": -1.845,
              "z": 1.533
            },
            "gtin": "4251665310911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a27205d",
            "leftCorner": {
              "x": 4.607,
              "y": -1.845,
              "z": 1.533
            },
            "rightCorner": {
              "x": 4.68,
              "y": -1.911,
              "z": 1.533
            },
            "gtin": "4001669090131",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c2d",
        "height": 1.7824,
        "facings": [
          {
            "id": "696ebf7143c343680a27205e",
            "leftCorner": {
              "x": 3.959,
              "y": -1.255,
              "z": 1.782
            },
            "rightCorner": {
              "x": 4.029,
              "y": -1.318,
              "z": 1.782
            },
            "gtin": "4067796070293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272060",
            "leftCorner": {
              "x": 4.029,
              "y": -1.318,
              "z": 1.782
            },
            "rightCorner": {
              "x": 4.133,
              "y": -1.412,
              "z": 1.782
            },
            "gtin": "4066447878271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272061",
            "leftCorner": {
              "x": 4.133,
              "y": -1.412,
              "z": 1.782
            },
            "rightCorner": {
              "x": 4.202,
              "y": -1.475,
              "z": 1.782
            },
            "gtin": "8700216945455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272062",
            "leftCorner": {
              "x": 4.202,
              "y": -1.475,
              "z": 1.782
            },
            "rightCorner": {
              "x": 4.251,
              "y": -1.52,
              "z": 1.782
            },
            "gtin": "8001841235592",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a272063",
            "leftCorner": {
              "x": 4.251,
              "y": -1.52,
              "z": 1.782
            },
            "rightCorner": {
              "x": 4.302,
              "y": -1.565,
              "z": 1.782
            },
            "gtin": "8001841235561",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272064",
            "leftCorner": {
              "x": 4.302,
              "y": -1.565,
              "z": 1.782
            },
            "rightCorner": {
              "x": 4.361,
              "y": -1.619,
              "z": 1.782
            },
            "gtin": "8700216474641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272065",
            "leftCorner": {
              "x": 4.361,
              "y": -1.619,
              "z": 1.782
            },
            "rightCorner": {
              "x": 4.405,
              "y": -1.659,
              "z": 1.782
            },
            "gtin": "4103040032607",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272066",
            "leftCorner": {
              "x": 4.405,
              "y": -1.659,
              "z": 1.782
            },
            "rightCorner": {
              "x": 4.45,
              "y": -1.7,
              "z": 1.782
            },
            "gtin": "4260058866300",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272067",
            "leftCorner": {
              "x": 4.45,
              "y": -1.7,
              "z": 1.782
            },
            "rightCorner": {
              "x": 4.5,
              "y": -1.745,
              "z": 1.782
            },
            "gtin": "4260058866355",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272068",
            "leftCorner": {
              "x": 4.5,
              "y": -1.745,
              "z": 1.782
            },
            "rightCorner": {
              "x": 4.545,
              "y": -1.786,
              "z": 1.782
            },
            "gtin": "4260058866386",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272069",
            "leftCorner": {
              "x": 4.545,
              "y": -1.786,
              "z": 1.782
            },
            "rightCorner": {
              "x": 4.593,
              "y": -1.829,
              "z": 1.782
            },
            "gtin": "4260058861107",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27206a",
            "leftCorner": {
              "x": 4.593,
              "y": -1.829,
              "z": 1.782
            },
            "rightCorner": {
              "x": 4.638,
              "y": -1.87,
              "z": 1.782
            },
            "gtin": "4260598960438",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27205f",
            "leftCorner": {
              "x": 4.638,
              "y": -1.87,
              "z": 1.782
            },
            "rightCorner": {
              "x": 4.7,
              "y": -1.926,
              "z": 1.782
            }
          }
        ]
      }
    ]
  },
  {
    "id": "68e7575bb5fe7bc0469599a6",
    "name": "68e7575bb5fe7bc0469599a6",
    "x": 5.4444,
    "y": -2.6814,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.35635,
      "w": 0.93435
    },
    "statistics": {
      "hasStockCount": 67,
      "noStockCount": 2,
      "unknownStockCount": 25
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73c39",
        "height": 0.21477,
        "facings": [
          {
            "id": "696ebf7043c343680a2719e2",
            "leftCorner": {
              "x": 5.427,
              "y": -2.726,
              "z": 0.215
            },
            "rightCorner": {
              "x": 5.509,
              "y": -2.799,
              "z": 0.215
            },
            "gtin": "8718469200627",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719e3",
            "leftCorner": {
              "x": 5.509,
              "y": -2.799,
              "z": 0.215
            },
            "rightCorner": {
              "x": 5.539,
              "y": -2.827,
              "z": 0.215
            },
            "gtin": "4250752202634",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719e4",
            "leftCorner": {
              "x": 5.539,
              "y": -2.827,
              "z": 0.215
            },
            "rightCorner": {
              "x": 5.581,
              "y": -2.864,
              "z": 0.215
            },
            "gtin": "4066447249330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719e5",
            "leftCorner": {
              "x": 5.581,
              "y": -2.864,
              "z": 0.215
            },
            "rightCorner": {
              "x": 5.62,
              "y": -2.899,
              "z": 0.215
            },
            "gtin": "4036581537570",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719e6",
            "leftCorner": {
              "x": 5.62,
              "y": -2.899,
              "z": 0.215
            },
            "rightCorner": {
              "x": 5.665,
              "y": -2.939,
              "z": 0.215
            },
            "gtin": "4058172311956",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719e7",
            "leftCorner": {
              "x": 5.665,
              "y": -2.939,
              "z": 0.215
            },
            "rightCorner": {
              "x": 5.729,
              "y": -2.996,
              "z": 0.215
            },
            "gtin": "4009932006605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2719e8",
            "leftCorner": {
              "x": 5.729,
              "y": -2.996,
              "z": 0.215
            },
            "rightCorner": {
              "x": 5.785,
              "y": -3.046,
              "z": 0.215
            },
            "gtin": "4008491107211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719e9",
            "leftCorner": {
              "x": 5.785,
              "y": -3.046,
              "z": 0.215
            },
            "rightCorner": {
              "x": 5.836,
              "y": -3.091,
              "z": 0.215
            },
            "gtin": "4008233177694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2719ea",
            "leftCorner": {
              "x": 5.836,
              "y": -3.091,
              "z": 0.215
            },
            "rightCorner": {
              "x": 5.875,
              "y": -3.126,
              "z": 0.215
            },
            "gtin": "4008233046631",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719eb",
            "leftCorner": {
              "x": 5.875,
              "y": -3.126,
              "z": 0.215
            },
            "rightCorner": {
              "x": 5.917,
              "y": -3.163,
              "z": 0.215
            },
            "gtin": "4008233010946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2719ec",
            "leftCorner": {
              "x": 5.917,
              "y": -3.163,
              "z": 0.215
            },
            "rightCorner": {
              "x": 5.955,
              "y": -3.197,
              "z": 0.215
            },
            "gtin": "4066447249194",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719ed",
            "leftCorner": {
              "x": 5.955,
              "y": -3.197,
              "z": 0.215
            },
            "rightCorner": {
              "x": 5.999,
              "y": -3.236,
              "z": 0.215
            },
            "gtin": "4008617006800",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719ee",
            "leftCorner": {
              "x": 5.999,
              "y": -3.236,
              "z": 0.215
            },
            "rightCorner": {
              "x": 6.044,
              "y": -3.277,
              "z": 0.215
            },
            "gtin": "4008617005292",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719ef",
            "leftCorner": {
              "x": 6.044,
              "y": -3.277,
              "z": 0.215
            },
            "rightCorner": {
              "x": 6.086,
              "y": -3.314,
              "z": 0.215
            },
            "gtin": "4008617138822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2719f0",
            "leftCorner": {
              "x": 6.086,
              "y": -3.314,
              "z": 0.215
            },
            "rightCorner": {
              "x": 6.129,
              "y": -3.353,
              "z": 0.215
            },
            "gtin": "4008617010517",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719f1",
            "leftCorner": {
              "x": 6.129,
              "y": -3.353,
              "z": 0.215
            },
            "rightCorner": {
              "x": 6.166,
              "y": -3.386,
              "z": 0.215
            },
            "gtin": "4008617403746",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c38",
        "height": 0.4779,
        "facings": [
          {
            "id": "696ebf7143c343680a2720c2",
            "leftCorner": {
              "x": 5.481,
              "y": -2.64,
              "z": 0.478
            },
            "rightCorner": {
              "x": 5.601,
              "y": -2.747,
              "z": 0.478
            },
            "gtin": "8718469200634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a2720c4",
            "leftCorner": {
              "x": 5.601,
              "y": -2.747,
              "z": 0.478
            },
            "rightCorner": {
              "x": 5.663,
              "y": -2.802,
              "z": 0.478
            },
            "gtin": "8712175936351",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720c5",
            "leftCorner": {
              "x": 5.663,
              "y": -2.802,
              "z": 0.478
            },
            "rightCorner": {
              "x": 5.707,
              "y": -2.842,
              "z": 0.478
            },
            "gtin": "4036581536429",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720c6",
            "leftCorner": {
              "x": 5.707,
              "y": -2.842,
              "z": 0.478
            },
            "rightCorner": {
              "x": 5.767,
              "y": -2.895,
              "z": 0.478
            },
            "gtin": "8888650407132",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720c7",
            "leftCorner": {
              "x": 5.767,
              "y": -2.895,
              "z": 0.478
            },
            "rightCorner": {
              "x": 5.813,
              "y": -2.936,
              "z": 0.478
            },
            "gtin": "4008233176048",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720c8",
            "leftCorner": {
              "x": 5.813,
              "y": -2.936,
              "z": 0.478
            },
            "rightCorner": {
              "x": 5.881,
              "y": -2.997,
              "z": 0.478
            },
            "gtin": "737669029454",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720c9",
            "leftCorner": {
              "x": 5.881,
              "y": -2.997,
              "z": 0.478
            },
            "rightCorner": {
              "x": 6.051,
              "y": -3.149,
              "z": 0.478
            },
            "gtin": "4033082021454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a2720ca",
            "leftCorner": {
              "x": 6.051,
              "y": -3.149,
              "z": 0.478
            },
            "rightCorner": {
              "x": 6.092,
              "y": -3.185,
              "z": 0.478
            },
            "gtin": "4033082021225",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720cb",
            "leftCorner": {
              "x": 6.092,
              "y": -3.185,
              "z": 0.478
            },
            "rightCorner": {
              "x": 6.133,
              "y": -3.222,
              "z": 0.478
            },
            "gtin": "4067796148893",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720cc",
            "leftCorner": {
              "x": 6.133,
              "y": -3.222,
              "z": 0.478
            },
            "rightCorner": {
              "x": 6.173,
              "y": -3.258,
              "z": 0.478
            },
            "gtin": "4058172695452",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720c3",
            "leftCorner": {
              "x": 6.173,
              "y": -3.258,
              "z": 0.478
            },
            "rightCorner": {
              "x": 6.227,
              "y": -3.306,
              "z": 0.478
            },
            "gtin": "4036581533138",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c34",
        "height": 0.72845,
        "facings": [
          {
            "id": "696ebf7143c343680a2720a8",
            "leftCorner": {
              "x": 5.483,
              "y": -2.639,
              "z": 0.728
            },
            "rightCorner": {
              "x": 5.538,
              "y": -2.688,
              "z": 0.728
            },
            "gtin": "4260473283027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a2720aa",
            "leftCorner": {
              "x": 5.538,
              "y": -2.688,
              "z": 0.728
            },
            "rightCorner": {
              "x": 5.601,
              "y": -2.744,
              "z": 0.728
            },
            "gtin": "4260473283027",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720ab",
            "leftCorner": {
              "x": 5.601,
              "y": -2.744,
              "z": 0.728
            },
            "rightCorner": {
              "x": 5.653,
              "y": -2.791,
              "z": 0.728
            },
            "gtin": "8712175936801",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720ac",
            "leftCorner": {
              "x": 5.653,
              "y": -2.791,
              "z": 0.728
            },
            "rightCorner": {
              "x": 5.703,
              "y": -2.835,
              "z": 0.728
            }
          },
          {
            "id": "696ebf7143c343680a2720ad",
            "leftCorner": {
              "x": 5.703,
              "y": -2.835,
              "z": 0.728
            },
            "rightCorner": {
              "x": 5.752,
              "y": -2.879,
              "z": 0.728
            },
            "gtin": "4058172312526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720ae",
            "leftCorner": {
              "x": 5.752,
              "y": -2.879,
              "z": 0.728
            },
            "rightCorner": {
              "x": 5.799,
              "y": -2.921,
              "z": 0.728
            },
            "gtin": "4058172312168",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720af",
            "leftCorner": {
              "x": 5.799,
              "y": -2.921,
              "z": 0.728
            },
            "rightCorner": {
              "x": 5.844,
              "y": -2.961,
              "z": 0.728
            },
            "gtin": "4058172312168",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720b0",
            "leftCorner": {
              "x": 5.844,
              "y": -2.961,
              "z": 0.728
            },
            "rightCorner": {
              "x": 5.903,
              "y": -3.014,
              "z": 0.728
            },
            "gtin": "8712175936894",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720b1",
            "leftCorner": {
              "x": 5.903,
              "y": -3.014,
              "z": 0.728
            },
            "rightCorner": {
              "x": 5.965,
              "y": -3.069,
              "z": 0.728
            },
            "gtin": "8712175936894",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720b2",
            "leftCorner": {
              "x": 5.965,
              "y": -3.069,
              "z": 0.728
            },
            "rightCorner": {
              "x": 6.01,
              "y": -3.109,
              "z": 0.728
            },
            "gtin": "4066447207781",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720b3",
            "leftCorner": {
              "x": 6.01,
              "y": -3.109,
              "z": 0.728
            },
            "rightCorner": {
              "x": 6.065,
              "y": -3.159,
              "z": 0.728
            },
            "gtin": "4066447207781",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720b4",
            "leftCorner": {
              "x": 6.065,
              "y": -3.159,
              "z": 0.728
            },
            "rightCorner": {
              "x": 6.118,
              "y": -3.206,
              "z": 0.728
            },
            "gtin": "4058172311659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720b5",
            "leftCorner": {
              "x": 6.118,
              "y": -3.206,
              "z": 0.728
            },
            "rightCorner": {
              "x": 6.168,
              "y": -3.251,
              "z": 0.728
            },
            "gtin": "4058172311659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720a9",
            "leftCorner": {
              "x": 6.168,
              "y": -3.251,
              "z": 0.728
            },
            "rightCorner": {
              "x": 6.229,
              "y": -3.304,
              "z": 0.728
            },
            "gtin": "4058172311659",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c32",
        "height": 0.90011,
        "facings": [
          {
            "id": "696ebf7143c343680a272091",
            "leftCorner": {
              "x": 5.482,
              "y": -2.639,
              "z": 0.9
            },
            "rightCorner": {
              "x": 5.539,
              "y": -2.69,
              "z": 0.9
            },
            "gtin": "4058172310782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272093",
            "leftCorner": {
              "x": 5.539,
              "y": -2.69,
              "z": 0.9
            },
            "rightCorner": {
              "x": 5.598,
              "y": -2.742,
              "z": 0.9
            },
            "gtin": "4058172310782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a272094",
            "leftCorner": {
              "x": 5.598,
              "y": -2.742,
              "z": 0.9
            },
            "rightCorner": {
              "x": 5.653,
              "y": -2.792,
              "z": 0.9
            },
            "gtin": "4058172662768",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272095",
            "leftCorner": {
              "x": 5.653,
              "y": -2.792,
              "z": 0.9
            },
            "rightCorner": {
              "x": 5.71,
              "y": -2.843,
              "z": 0.9
            },
            "gtin": "4101230034196",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272096",
            "leftCorner": {
              "x": 5.71,
              "y": -2.843,
              "z": 0.9
            },
            "rightCorner": {
              "x": 5.766,
              "y": -2.892,
              "z": 0.9
            },
            "gtin": "4101230033885",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272097",
            "leftCorner": {
              "x": 5.766,
              "y": -2.892,
              "z": 0.9
            },
            "rightCorner": {
              "x": 5.825,
              "y": -2.945,
              "z": 0.9
            },
            "gtin": "4101230033885",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272098",
            "leftCorner": {
              "x": 5.825,
              "y": -2.945,
              "z": 0.9
            },
            "rightCorner": {
              "x": 5.876,
              "y": -2.99,
              "z": 0.9
            },
            "gtin": "4042441015232",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272099",
            "leftCorner": {
              "x": 5.876,
              "y": -2.99,
              "z": 0.9
            },
            "rightCorner": {
              "x": 5.933,
              "y": -3.042,
              "z": 0.9
            },
            "gtin": "8712175936702",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27209a",
            "leftCorner": {
              "x": 5.933,
              "y": -3.042,
              "z": 0.9
            },
            "rightCorner": {
              "x": 5.989,
              "y": -3.092,
              "z": 0.9
            },
            "gtin": "4058172312496",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27209b",
            "leftCorner": {
              "x": 5.989,
              "y": -3.092,
              "z": 0.9
            },
            "rightCorner": {
              "x": 6.048,
              "y": -3.144,
              "z": 0.9
            },
            "gtin": "4042441020816",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27209c",
            "leftCorner": {
              "x": 6.048,
              "y": -3.144,
              "z": 0.9
            },
            "rightCorner": {
              "x": 6.11,
              "y": -3.2,
              "z": 0.9
            },
            "gtin": "4058172312434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27209d",
            "leftCorner": {
              "x": 6.11,
              "y": -3.2,
              "z": 0.9
            },
            "rightCorner": {
              "x": 6.162,
              "y": -3.246,
              "z": 0.9
            },
            "gtin": "4058172312465",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a272092",
            "leftCorner": {
              "x": 6.162,
              "y": -3.246,
              "z": 0.9
            },
            "rightCorner": {
              "x": 6.228,
              "y": -3.305,
              "z": 0.9
            },
            "gtin": "4101230034257",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c33",
        "height": 1.1129,
        "facings": [
          {
            "id": "696ebf7143c343680a27209e",
            "leftCorner": {
              "x": 5.482,
              "y": -2.639,
              "z": 1.113
            },
            "rightCorner": {
              "x": 5.583,
              "y": -2.728,
              "z": 1.113
            },
            "gtin": "4042441015591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a2720a0",
            "leftCorner": {
              "x": 5.583,
              "y": -2.728,
              "z": 1.113
            },
            "rightCorner": {
              "x": 5.677,
              "y": -2.812,
              "z": 1.113
            },
            "gtin": "4058172737138",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720a1",
            "leftCorner": {
              "x": 5.677,
              "y": -2.812,
              "z": 1.113
            },
            "rightCorner": {
              "x": 5.766,
              "y": -2.892,
              "z": 1.113
            },
            "gtin": "4058172312199",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720a2",
            "leftCorner": {
              "x": 5.766,
              "y": -2.892,
              "z": 1.113
            },
            "rightCorner": {
              "x": 5.826,
              "y": -2.945,
              "z": 1.113
            },
            "gtin": "4042441017410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720a3",
            "leftCorner": {
              "x": 5.826,
              "y": -2.945,
              "z": 1.113
            },
            "rightCorner": {
              "x": 5.892,
              "y": -3.004,
              "z": 1.113
            },
            "gtin": "4058172314384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a2720a4",
            "leftCorner": {
              "x": 5.892,
              "y": -3.004,
              "z": 1.113
            },
            "rightCorner": {
              "x": 5.957,
              "y": -3.062,
              "z": 1.113
            },
            "gtin": "4101230033793",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720a5",
            "leftCorner": {
              "x": 5.957,
              "y": -3.062,
              "z": 1.113
            },
            "rightCorner": {
              "x": 6.018,
              "y": -3.117,
              "z": 1.113
            },
            "gtin": "4063528086129",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720a6",
            "leftCorner": {
              "x": 6.018,
              "y": -3.117,
              "z": 1.113
            },
            "rightCorner": {
              "x": 6.08,
              "y": -3.172,
              "z": 1.113
            },
            "gtin": "4063528077158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720a7",
            "leftCorner": {
              "x": 6.08,
              "y": -3.172,
              "z": 1.113
            },
            "rightCorner": {
              "x": 6.153,
              "y": -3.237,
              "z": 1.113
            },
            "gtin": "4063528086211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a27209f",
            "leftCorner": {
              "x": 6.153,
              "y": -3.237,
              "z": 1.113
            },
            "rightCorner": {
              "x": 6.228,
              "y": -3.305,
              "z": 1.113
            },
            "gtin": "4063528077301",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c36",
        "height": 1.3673,
        "facings": [
          {
            "id": "696ebf7043c343680a27194a",
            "leftCorner": {
              "x": 5.482,
              "y": -2.639,
              "z": 1.367
            },
            "rightCorner": {
              "x": 5.566,
              "y": -2.714,
              "z": 1.367
            },
            "gtin": "4005800278549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27194c",
            "leftCorner": {
              "x": 5.566,
              "y": -2.714,
              "z": 1.367
            },
            "rightCorner": {
              "x": 5.629,
              "y": -2.77,
              "z": 1.367
            },
            "gtin": "4005800278563",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27194d",
            "leftCorner": {
              "x": 5.629,
              "y": -2.77,
              "z": 1.367
            },
            "rightCorner": {
              "x": 5.691,
              "y": -2.825,
              "z": 1.367
            },
            "gtin": "4005800283888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27194e",
            "leftCorner": {
              "x": 5.691,
              "y": -2.825,
              "z": 1.367
            },
            "rightCorner": {
              "x": 5.757,
              "y": -2.884,
              "z": 1.367
            },
            "gtin": "4005800315190",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27194f",
            "leftCorner": {
              "x": 5.757,
              "y": -2.884,
              "z": 1.367
            },
            "rightCorner": {
              "x": 5.823,
              "y": -2.942,
              "z": 1.367
            },
            "gtin": "4005800279119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271950",
            "leftCorner": {
              "x": 5.823,
              "y": -2.942,
              "z": 1.367
            },
            "rightCorner": {
              "x": 5.89,
              "y": -3.003,
              "z": 1.367
            },
            "gtin": "4005800279133",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271951",
            "leftCorner": {
              "x": 5.89,
              "y": -3.003,
              "z": 1.367
            },
            "rightCorner": {
              "x": 5.953,
              "y": -3.059,
              "z": 1.367
            },
            "gtin": "4005800280689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271952",
            "leftCorner": {
              "x": 5.953,
              "y": -3.059,
              "z": 1.367
            },
            "rightCorner": {
              "x": 6.019,
              "y": -3.118,
              "z": 1.367
            },
            "gtin": "4005800402982",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271953",
            "leftCorner": {
              "x": 6.019,
              "y": -3.118,
              "z": 1.367
            },
            "rightCorner": {
              "x": 6.086,
              "y": -3.178,
              "z": 1.367
            },
            "gtin": "4005800001710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271954",
            "leftCorner": {
              "x": 6.086,
              "y": -3.178,
              "z": 1.367
            },
            "rightCorner": {
              "x": 6.151,
              "y": -3.235,
              "z": 1.367
            },
            "gtin": "4005800278501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271955",
            "leftCorner": {
              "x": 6.151,
              "y": -3.235,
              "z": 1.367
            },
            "rightCorner": {
              "x": 6.228,
              "y": -3.305,
              "z": 1.367
            },
            "gtin": "4005800325489",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c35",
        "height": 1.5353,
        "facings": [
          {
            "id": "696ebf7143c343680a2720b6",
            "leftCorner": {
              "x": 5.481,
              "y": -2.641,
              "z": 1.535
            },
            "rightCorner": {
              "x": 5.533,
              "y": -2.687,
              "z": 1.535
            },
            "gtin": "4032651214181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a2720b8",
            "leftCorner": {
              "x": 5.533,
              "y": -2.687,
              "z": 1.535
            },
            "rightCorner": {
              "x": 5.578,
              "y": -2.727,
              "z": 1.535
            },
            "gtin": "4005800197277",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720b9",
            "leftCorner": {
              "x": 5.578,
              "y": -2.727,
              "z": 1.535
            },
            "rightCorner": {
              "x": 5.647,
              "y": -2.789,
              "z": 1.535
            },
            "gtin": "4066447015461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720ba",
            "leftCorner": {
              "x": 5.647,
              "y": -2.789,
              "z": 1.535
            },
            "rightCorner": {
              "x": 5.723,
              "y": -2.857,
              "z": 1.535
            },
            "gtin": "4058172695872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a2720bb",
            "leftCorner": {
              "x": 5.723,
              "y": -2.857,
              "z": 1.535
            },
            "rightCorner": {
              "x": 5.757,
              "y": -2.887,
              "z": 1.535
            },
            "gtin": "4058172695582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a2720bc",
            "leftCorner": {
              "x": 5.757,
              "y": -2.887,
              "z": 1.535
            },
            "rightCorner": {
              "x": 5.815,
              "y": -2.939,
              "z": 1.535
            },
            "gtin": "4066447352313",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720bd",
            "leftCorner": {
              "x": 5.815,
              "y": -2.939,
              "z": 1.535
            },
            "rightCorner": {
              "x": 5.896,
              "y": -3.011,
              "z": 1.535
            },
            "gtin": "4058172696046",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720be",
            "leftCorner": {
              "x": 5.896,
              "y": -3.011,
              "z": 1.535
            },
            "rightCorner": {
              "x": 5.982,
              "y": -3.088,
              "z": 1.535
            },
            "gtin": "4009241392000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a2720bf",
            "leftCorner": {
              "x": 5.982,
              "y": -3.088,
              "z": 1.535
            },
            "rightCorner": {
              "x": 6.015,
              "y": -3.117,
              "z": 1.535
            },
            "gtin": "4008491223751",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720c0",
            "leftCorner": {
              "x": 6.015,
              "y": -3.117,
              "z": 1.535
            },
            "rightCorner": {
              "x": 6.093,
              "y": -3.186,
              "z": 1.535
            },
            "gtin": "4008617009962",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720c1",
            "leftCorner": {
              "x": 6.093,
              "y": -3.186,
              "z": 1.535
            },
            "rightCorner": {
              "x": 6.167,
              "y": -3.253,
              "z": 1.535
            },
            "gtin": "4022167330307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a2720b7",
            "leftCorner": {
              "x": 6.167,
              "y": -3.253,
              "z": 1.535
            },
            "rightCorner": {
              "x": 6.227,
              "y": -3.306,
              "z": 1.535
            },
            "gtin": "4066447120653",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c37",
        "height": 1.7833,
        "facings": [
          {
            "id": "696ebf7043c343680a271900",
            "leftCorner": {
              "x": 5.492,
              "y": -2.655,
              "z": 1.783
            },
            "rightCorner": {
              "x": 5.593,
              "y": -2.745,
              "z": 1.783
            },
            "gtin": "4042441017380",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271901",
            "leftCorner": {
              "x": 5.593,
              "y": -2.745,
              "z": 1.783
            },
            "rightCorner": {
              "x": 5.66,
              "y": -2.804,
              "z": 1.783
            },
            "gtin": "4036581540754",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271902",
            "leftCorner": {
              "x": 5.66,
              "y": -2.804,
              "z": 1.783
            },
            "rightCorner": {
              "x": 5.741,
              "y": -2.877,
              "z": 1.783
            },
            "gtin": "4036581541171",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271903",
            "leftCorner": {
              "x": 5.741,
              "y": -2.877,
              "z": 1.783
            },
            "rightCorner": {
              "x": 5.832,
              "y": -2.957,
              "z": 1.783
            },
            "gtin": "4036581540730",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271904",
            "leftCorner": {
              "x": 5.832,
              "y": -2.957,
              "z": 1.783
            },
            "rightCorner": {
              "x": 5.923,
              "y": -3.039,
              "z": 1.783
            },
            "gtin": "4036581541157",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271905",
            "leftCorner": {
              "x": 5.923,
              "y": -3.039,
              "z": 1.783
            },
            "rightCorner": {
              "x": 5.989,
              "y": -3.098,
              "z": 1.783
            },
            "gtin": "4036581540716",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271906",
            "leftCorner": {
              "x": 5.989,
              "y": -3.098,
              "z": 1.783
            },
            "rightCorner": {
              "x": 6.112,
              "y": -3.208,
              "z": 1.783
            },
            "gtin": "4066447087604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271907",
            "leftCorner": {
              "x": 6.112,
              "y": -3.208,
              "z": 1.783
            },
            "rightCorner": {
              "x": 6.201,
              "y": -3.287,
              "z": 1.783
            },
            "gtin": "4066447109658",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7575bb5fe7bc0469599a7",
    "name": "68e7575bb5fe7bc0469599a7",
    "x": 6.1923,
    "y": -3.3552,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.35894,
      "w": 0.93336
    },
    "statistics": {
      "hasStockCount": 64,
      "noStockCount": 5,
      "unknownStockCount": 18,
      "shelfCategory": "HEALTH"
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73b23",
        "height": 0.20974,
        "facings": [
          {
            "id": "696ebf7043c343680a2719f2",
            "leftCorner": {
              "x": 6.168,
              "y": -3.393,
              "z": 0.21
            },
            "rightCorner": {
              "x": 6.227,
              "y": -3.446,
              "z": 0.21
            },
            "gtin": "4008617009368",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719f3",
            "leftCorner": {
              "x": 6.227,
              "y": -3.446,
              "z": 0.21
            },
            "rightCorner": {
              "x": 6.275,
              "y": -3.489,
              "z": 0.21
            },
            "gtin": "4003573288017",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719f4",
            "leftCorner": {
              "x": 6.275,
              "y": -3.489,
              "z": 0.21
            },
            "rightCorner": {
              "x": 6.382,
              "y": -3.586,
              "z": 0.21
            },
            "gtin": "4250752203044",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719f5",
            "leftCorner": {
              "x": 6.382,
              "y": -3.586,
              "z": 0.21
            },
            "rightCorner": {
              "x": 6.442,
              "y": -3.64,
              "z": 0.21
            },
            "gtin": "2050000050152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2719f6",
            "leftCorner": {
              "x": 6.442,
              "y": -3.64,
              "z": 0.21
            },
            "rightCorner": {
              "x": 6.511,
              "y": -3.702,
              "z": 0.21
            },
            "gtin": "4066447250046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2719f7",
            "leftCorner": {
              "x": 6.511,
              "y": -3.702,
              "z": 0.21
            },
            "rightCorner": {
              "x": 6.534,
              "y": -3.723,
              "z": 0.21
            }
          },
          {
            "id": "696ebf7043c343680a2719f8",
            "leftCorner": {
              "x": 6.534,
              "y": -3.723,
              "z": 0.21
            },
            "rightCorner": {
              "x": 6.586,
              "y": -3.771,
              "z": 0.21
            },
            "gtin": "4262394850340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2719f9",
            "leftCorner": {
              "x": 6.586,
              "y": -3.771,
              "z": 0.21
            },
            "rightCorner": {
              "x": 6.631,
              "y": -3.811,
              "z": 0.21
            },
            "gtin": "4008617001058",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719fa",
            "leftCorner": {
              "x": 6.631,
              "y": -3.811,
              "z": 0.21
            },
            "rightCorner": {
              "x": 6.678,
              "y": -3.853,
              "z": 0.21
            },
            "gtin": "4008617001096",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719fb",
            "leftCorner": {
              "x": 6.678,
              "y": -3.853,
              "z": 0.21
            },
            "rightCorner": {
              "x": 6.74,
              "y": -3.909,
              "z": 0.21
            },
            "gtin": "4008617001119",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719fc",
            "leftCorner": {
              "x": 6.74,
              "y": -3.909,
              "z": 0.21
            },
            "rightCorner": {
              "x": 6.791,
              "y": -3.955,
              "z": 0.21
            },
            "gtin": "4036581252817",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719fd",
            "leftCorner": {
              "x": 6.791,
              "y": -3.955,
              "z": 0.21
            },
            "rightCorner": {
              "x": 6.846,
              "y": -4.005,
              "z": 0.21
            },
            "gtin": "4036581252817",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719fe",
            "leftCorner": {
              "x": 6.846,
              "y": -4.005,
              "z": 0.21
            },
            "rightCorner": {
              "x": 6.888,
              "y": -4.043,
              "z": 0.21
            }
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b1d",
        "height": 0.55737,
        "facings": [
          {
            "id": "696ebf7043c343680a271850",
            "leftCorner": {
              "x": 6.23,
              "y": -3.313,
              "z": 0.557
            },
            "rightCorner": {
              "x": 6.285,
              "y": -3.363,
              "z": 0.557
            },
            "gtin": "4009932004526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271852",
            "leftCorner": {
              "x": 6.285,
              "y": -3.363,
              "z": 0.557
            },
            "rightCorner": {
              "x": 6.36,
              "y": -3.43,
              "z": 0.557
            },
            "gtin": "4008233101484",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271853",
            "leftCorner": {
              "x": 6.36,
              "y": -3.43,
              "z": 0.557
            },
            "rightCorner": {
              "x": 6.457,
              "y": -3.518,
              "z": 0.557
            },
            "gtin": "4009932135459",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271854",
            "leftCorner": {
              "x": 6.457,
              "y": -3.518,
              "z": 0.557
            },
            "rightCorner": {
              "x": 6.537,
              "y": -3.59,
              "z": 0.557
            },
            "gtin": "4058172695896",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271855",
            "leftCorner": {
              "x": 6.537,
              "y": -3.59,
              "z": 0.557
            },
            "rightCorner": {
              "x": 6.623,
              "y": -3.667,
              "z": 0.557
            },
            "gtin": "4058172695896",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271856",
            "leftCorner": {
              "x": 6.623,
              "y": -3.667,
              "z": 0.557
            },
            "rightCorner": {
              "x": 6.693,
              "y": -3.73,
              "z": 0.557
            },
            "gtin": "4009932137606",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271857",
            "leftCorner": {
              "x": 6.693,
              "y": -3.73,
              "z": 0.557
            },
            "rightCorner": {
              "x": 6.761,
              "y": -3.792,
              "z": 0.557
            },
            "gtin": "4009932132786",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271858",
            "leftCorner": {
              "x": 6.761,
              "y": -3.792,
              "z": 0.557
            },
            "rightCorner": {
              "x": 6.832,
              "y": -3.856,
              "z": 0.557
            }
          },
          {
            "id": "696ebf7043c343680a271859",
            "leftCorner": {
              "x": 6.832,
              "y": -3.856,
              "z": 0.557
            },
            "rightCorner": {
              "x": 6.904,
              "y": -3.921,
              "z": 0.557
            },
            "gtin": "4003573488509",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27185a",
            "leftCorner": {
              "x": 6.904,
              "y": -3.921,
              "z": 0.557
            },
            "rightCorner": {
              "x": 6.962,
              "y": -3.973,
              "z": 0.557
            },
            "gtin": "4066447756838",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b24",
        "height": 0.76843,
        "facings": [
          {
            "id": "696ebf7043c343680a271a21",
            "leftCorner": {
              "x": 6.233,
              "y": -3.31,
              "z": 0.768
            },
            "rightCorner": {
              "x": 6.305,
              "y": -3.375,
              "z": 0.768
            },
            "gtin": "4009932003215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a22",
            "leftCorner": {
              "x": 6.305,
              "y": -3.375,
              "z": 0.768
            },
            "rightCorner": {
              "x": 6.391,
              "y": -3.452,
              "z": 0.768
            },
            "gtin": "4009932003215",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a23",
            "leftCorner": {
              "x": 6.391,
              "y": -3.452,
              "z": 0.768
            },
            "rightCorner": {
              "x": 6.483,
              "y": -3.535,
              "z": 0.768
            },
            "gtin": "4260488132617",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a24",
            "leftCorner": {
              "x": 6.483,
              "y": -3.535,
              "z": 0.768
            },
            "rightCorner": {
              "x": 6.601,
              "y": -3.642,
              "z": 0.768
            },
            "gtin": "4066447656794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a25",
            "leftCorner": {
              "x": 6.601,
              "y": -3.642,
              "z": 0.768
            },
            "rightCorner": {
              "x": 6.679,
              "y": -3.712,
              "z": 0.768
            },
            "gtin": "4067796161670",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a26",
            "leftCorner": {
              "x": 6.679,
              "y": -3.712,
              "z": 0.768
            },
            "rightCorner": {
              "x": 6.745,
              "y": -3.772,
              "z": 0.768
            },
            "gtin": "4067796161670",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a27",
            "leftCorner": {
              "x": 6.745,
              "y": -3.772,
              "z": 0.768
            },
            "rightCorner": {
              "x": 6.812,
              "y": -3.832,
              "z": 0.768
            },
            "gtin": "4270002260818",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a28",
            "leftCorner": {
              "x": 6.812,
              "y": -3.832,
              "z": 0.768
            },
            "rightCorner": {
              "x": 6.919,
              "y": -3.93,
              "z": 0.768
            },
            "gtin": "4262393840021",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a29",
            "leftCorner": {
              "x": 6.919,
              "y": -3.93,
              "z": 0.768
            },
            "rightCorner": {
              "x": 6.975,
              "y": -3.98,
              "z": 0.768
            },
            "gtin": "4058172695537",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b22",
        "height": 0.98082,
        "facings": [
          {
            "id": "696ebf7043c343680a27199d",
            "leftCorner": {
              "x": 6.234,
              "y": -3.309,
              "z": 0.981
            },
            "rightCorner": {
              "x": 6.269,
              "y": -3.341,
              "z": 0.981
            },
            "gtin": "4009932131703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27199f",
            "leftCorner": {
              "x": 6.269,
              "y": -3.341,
              "z": 0.981
            },
            "rightCorner": {
              "x": 6.348,
              "y": -3.413,
              "z": 0.981
            },
            "gtin": "4008617016137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719a0",
            "leftCorner": {
              "x": 6.348,
              "y": -3.413,
              "z": 0.981
            },
            "rightCorner": {
              "x": 6.408,
              "y": -3.467,
              "z": 0.981
            },
            "gtin": "4008617027249",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719a1",
            "leftCorner": {
              "x": 6.408,
              "y": -3.467,
              "z": 0.981
            },
            "rightCorner": {
              "x": 6.492,
              "y": -3.543,
              "z": 0.981
            },
            "gtin": "4008617261421",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719a2",
            "leftCorner": {
              "x": 6.492,
              "y": -3.543,
              "z": 0.981
            },
            "rightCorner": {
              "x": 6.566,
              "y": -3.61,
              "z": 0.981
            },
            "gtin": "4066447871357",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719a3",
            "leftCorner": {
              "x": 6.566,
              "y": -3.61,
              "z": 0.981
            },
            "rightCorner": {
              "x": 6.645,
              "y": -3.68,
              "z": 0.981
            },
            "gtin": "4066447015225",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719a4",
            "leftCorner": {
              "x": 6.645,
              "y": -3.68,
              "z": 0.981
            },
            "rightCorner": {
              "x": 6.712,
              "y": -3.741,
              "z": 0.981
            },
            "gtin": "4009932134971",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719a5",
            "leftCorner": {
              "x": 6.712,
              "y": -3.741,
              "z": 0.981
            },
            "rightCorner": {
              "x": 6.779,
              "y": -3.802,
              "z": 0.981
            },
            "gtin": "4009932133530",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719a6",
            "leftCorner": {
              "x": 6.779,
              "y": -3.802,
              "z": 0.981
            },
            "rightCorner": {
              "x": 6.844,
              "y": -3.86,
              "z": 0.981
            },
            "gtin": "4008491117203",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719a7",
            "leftCorner": {
              "x": 6.844,
              "y": -3.86,
              "z": 0.981
            },
            "rightCorner": {
              "x": 6.901,
              "y": -3.912,
              "z": 0.981
            },
            "gtin": "4026600501002",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719a8",
            "leftCorner": {
              "x": 6.901,
              "y": -3.912,
              "z": 0.981
            },
            "rightCorner": {
              "x": 6.948,
              "y": -3.954,
              "z": 0.981
            },
            "gtin": "9120113407860",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719a9",
            "leftCorner": {
              "x": 6.948,
              "y": -3.954,
              "z": 0.981
            },
            "rightCorner": {
              "x": 6.976,
              "y": -3.979,
              "z": 0.981
            },
            "gtin": "4260159457292",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b1e",
        "height": 1.1925,
        "facings": [
          {
            "id": "696ebf7043c343680a271875",
            "leftCorner": {
              "x": 6.231,
              "y": -3.313,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.281,
              "y": -3.358,
              "z": 1.192
            },
            "gtin": "4009932004700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271877",
            "leftCorner": {
              "x": 6.281,
              "y": -3.358,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.346,
              "y": -3.417,
              "z": 1.192
            },
            "gtin": "4066447219173",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271878",
            "leftCorner": {
              "x": 6.346,
              "y": -3.417,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.412,
              "y": -3.477,
              "z": 1.192
            },
            "gtin": "4009932137187",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271879",
            "leftCorner": {
              "x": 6.412,
              "y": -3.477,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.479,
              "y": -3.537,
              "z": 1.192
            },
            "gtin": "4008617988564",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27187a",
            "leftCorner": {
              "x": 6.479,
              "y": -3.537,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.566,
              "y": -3.615,
              "z": 1.192
            },
            "gtin": "4066447249415",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27187b",
            "leftCorner": {
              "x": 6.566,
              "y": -3.615,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.594,
              "y": -3.64,
              "z": 1.192
            },
            "gtin": "4260703371982",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27187c",
            "leftCorner": {
              "x": 6.594,
              "y": -3.64,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.648,
              "y": -3.689,
              "z": 1.192
            },
            "gtin": "4066447219432",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27187d",
            "leftCorner": {
              "x": 6.648,
              "y": -3.689,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.714,
              "y": -3.748,
              "z": 1.192
            },
            "gtin": "4009932132069",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27187e",
            "leftCorner": {
              "x": 6.714,
              "y": -3.748,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.773,
              "y": -3.802,
              "z": 1.192
            },
            "gtin": "4066447249057",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27187f",
            "leftCorner": {
              "x": 6.773,
              "y": -3.802,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.806,
              "y": -3.832,
              "z": 1.192
            },
            "gtin": "4008233176284",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271880",
            "leftCorner": {
              "x": 6.806,
              "y": -3.832,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.877,
              "y": -3.896,
              "z": 1.192
            },
            "gtin": "5000488301748",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271881",
            "leftCorner": {
              "x": 6.877,
              "y": -3.896,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.926,
              "y": -3.941,
              "z": 1.192
            },
            "gtin": "5000488304527",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271882",
            "leftCorner": {
              "x": 6.926,
              "y": -3.941,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.963,
              "y": -3.974,
              "z": 1.192
            },
            "gtin": "4066447362886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271883",
            "leftCorner": {
              "x": 6.963,
              "y": -3.974,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.988,
              "y": -3.996,
              "z": 1.192
            },
            "gtin": "4058172311802",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b21",
        "height": 1.3598,
        "facings": [
          {
            "id": "696ebf7043c343680a271956",
            "leftCorner": {
              "x": 6.234,
              "y": -3.309,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.279,
              "y": -3.349,
              "z": 1.36
            },
            "gtin": "4008491121323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271957",
            "leftCorner": {
              "x": 6.279,
              "y": -3.349,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.345,
              "y": -3.409,
              "z": 1.36
            },
            "gtin": "4008233175317",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271958",
            "leftCorner": {
              "x": 6.345,
              "y": -3.409,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.404,
              "y": -3.462,
              "z": 1.36
            },
            "gtin": "4008491104098",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271959",
            "leftCorner": {
              "x": 6.404,
              "y": -3.462,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.473,
              "y": -3.524,
              "z": 1.36
            },
            "gtin": "4009932131208",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27195a",
            "leftCorner": {
              "x": 6.473,
              "y": -3.524,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.526,
              "y": -3.573,
              "z": 1.36
            },
            "gtin": "4260488132297",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27195b",
            "leftCorner": {
              "x": 6.526,
              "y": -3.573,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.599,
              "y": -3.638,
              "z": 1.36
            },
            "gtin": "4003087422051",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27195c",
            "leftCorner": {
              "x": 6.599,
              "y": -3.638,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.67,
              "y": -3.702,
              "z": 1.36
            },
            "gtin": "4008233124384",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27195d",
            "leftCorner": {
              "x": 6.67,
              "y": -3.702,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.739,
              "y": -3.765,
              "z": 1.36
            },
            "gtin": "4015588510731",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27195e",
            "leftCorner": {
              "x": 6.739,
              "y": -3.765,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.843,
              "y": -3.859,
              "z": 1.36
            },
            "gtin": "4015588995026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27195f",
            "leftCorner": {
              "x": 6.843,
              "y": -3.859,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.943,
              "y": -3.948,
              "z": 1.36
            },
            "gtin": "4103040030597",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271960",
            "leftCorner": {
              "x": 6.943,
              "y": -3.948,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.976,
              "y": -3.979,
              "z": 1.36
            },
            "gtin": "4103040897411",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b1f",
        "height": 1.5719,
        "facings": [
          {
            "id": "696ebf7043c343680a2718bd",
            "leftCorner": {
              "x": 6.234,
              "y": -3.309,
              "z": 1.572
            },
            "rightCorner": {
              "x": 6.264,
              "y": -3.336,
              "z": 1.572
            },
            "gtin": "4058172323652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2718bf",
            "leftCorner": {
              "x": 6.264,
              "y": -3.336,
              "z": 1.572
            },
            "rightCorner": {
              "x": 6.389,
              "y": -3.449,
              "z": 1.572
            },
            "gtin": "4066447219258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2718c0",
            "leftCorner": {
              "x": 6.389,
              "y": -3.449,
              "z": 1.572
            },
            "rightCorner": {
              "x": 6.551,
              "y": -3.596,
              "z": 1.572
            },
            "gtin": "4026600430005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2718c1",
            "leftCorner": {
              "x": 6.551,
              "y": -3.596,
              "z": 1.572
            },
            "rightCorner": {
              "x": 6.609,
              "y": -3.648,
              "z": 1.572
            },
            "gtin": "4262458340015",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718c2",
            "leftCorner": {
              "x": 6.609,
              "y": -3.648,
              "z": 1.572
            },
            "rightCorner": {
              "x": 6.68,
              "y": -3.712,
              "z": 1.572
            },
            "gtin": "4066447248975",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718c3",
            "leftCorner": {
              "x": 6.68,
              "y": -3.712,
              "z": 1.572
            },
            "rightCorner": {
              "x": 6.742,
              "y": -3.768,
              "z": 1.572
            },
            "gtin": "4067796184914",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718c4",
            "leftCorner": {
              "x": 6.742,
              "y": -3.768,
              "z": 1.572
            },
            "rightCorner": {
              "x": 6.812,
              "y": -3.832,
              "z": 1.572
            },
            "gtin": "4010160001850",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718c5",
            "leftCorner": {
              "x": 6.812,
              "y": -3.832,
              "z": 1.572
            },
            "rightCorner": {
              "x": 6.871,
              "y": -3.884,
              "z": 1.572
            },
            "gtin": "4008617012627",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718c6",
            "leftCorner": {
              "x": 6.871,
              "y": -3.884,
              "z": 1.572
            },
            "rightCorner": {
              "x": 6.907,
              "y": -3.917,
              "z": 1.572
            },
            "gtin": "4009932131284",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2718c7",
            "leftCorner": {
              "x": 6.907,
              "y": -3.917,
              "z": 1.572
            },
            "rightCorner": {
              "x": 6.955,
              "y": -3.96,
              "z": 1.572
            },
            "gtin": "4009932131284",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718c8",
            "leftCorner": {
              "x": 6.955,
              "y": -3.96,
              "z": 1.572
            },
            "rightCorner": {
              "x": 6.998,
              "y": -3.999,
              "z": 1.572
            },
            "gtin": "4003573289069",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b20",
        "height": 1.779,
        "facings": [
          {
            "id": "696ebf7043c343680a271908",
            "leftCorner": {
              "x": 6.201,
              "y": -3.287,
              "z": 1.783
            },
            "rightCorner": {
              "x": 6.262,
              "y": -3.342,
              "z": 1.783
            },
            "gtin": "4008233125824",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271909",
            "leftCorner": {
              "x": 6.269,
              "y": -3.344,
              "z": 1.779
            },
            "rightCorner": {
              "x": 6.328,
              "y": -3.398,
              "z": 1.779
            },
            "gtin": "4260457778600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27190a",
            "leftCorner": {
              "x": 6.328,
              "y": -3.398,
              "z": 1.779
            },
            "rightCorner": {
              "x": 6.397,
              "y": -3.459,
              "z": 1.779
            },
            "gtin": "4008233175379",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27190b",
            "leftCorner": {
              "x": 6.397,
              "y": -3.459,
              "z": 1.779
            },
            "rightCorner": {
              "x": 6.46,
              "y": -3.517,
              "z": 1.779
            },
            "gtin": "4008491117777",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27190c",
            "leftCorner": {
              "x": 6.46,
              "y": -3.517,
              "z": 1.779
            },
            "rightCorner": {
              "x": 6.59,
              "y": -3.634,
              "z": 1.779
            },
            "gtin": "4009932135923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27190d",
            "leftCorner": {
              "x": 6.59,
              "y": -3.634,
              "z": 1.779
            },
            "rightCorner": {
              "x": 6.724,
              "y": -3.755,
              "z": 1.779
            },
            "gtin": "4262393840427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27190e",
            "leftCorner": {
              "x": 6.724,
              "y": -3.755,
              "z": 1.779
            },
            "rightCorner": {
              "x": 6.78,
              "y": -3.805,
              "z": 1.779
            },
            "gtin": "4008617403227",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27190f",
            "leftCorner": {
              "x": 6.78,
              "y": -3.805,
              "z": 1.779
            },
            "rightCorner": {
              "x": 6.84,
              "y": -3.859,
              "z": 1.779
            },
            "gtin": "4008617988694",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271910",
            "leftCorner": {
              "x": 6.84,
              "y": -3.859,
              "z": 1.779
            },
            "rightCorner": {
              "x": 6.947,
              "y": -3.956,
              "z": 1.779
            },
            "gtin": "4008233179452",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271911",
            "leftCorner": {
              "x": 6.947,
              "y": -3.956,
              "z": 1.779
            },
            "rightCorner": {
              "x": 6.974,
              "y": -3.981,
              "z": 1.779
            },
            "gtin": "8006540273722",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7575bb5fe7bc0469599a8",
    "name": "68e7575bb5fe7bc0469599a8",
    "x": 6.9571,
    "y": -4.0507,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.35225,
      "w": 0.93591
    },
    "statistics": {
      "hasStockCount": 69,
      "noStockCount": 1,
      "unknownStockCount": 15,
      "shelfCategory": "HEALTH"
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73b2d",
        "height": 0.21094,
        "facings": [
          {
            "id": "696ebf7043c343680a2719ff",
            "leftCorner": {
              "x": 6.927,
              "y": -4.084,
              "z": 0.211
            },
            "rightCorner": {
              "x": 7.007,
              "y": -4.155,
              "z": 0.211
            },
            "gtin": "4009932136135",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a00",
            "leftCorner": {
              "x": 7.007,
              "y": -4.155,
              "z": 0.211
            },
            "rightCorner": {
              "x": 7.096,
              "y": -4.232,
              "z": 0.211
            },
            "gtin": "4260165270045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a01",
            "leftCorner": {
              "x": 7.096,
              "y": -4.232,
              "z": 0.211
            },
            "rightCorner": {
              "x": 7.173,
              "y": -4.3,
              "z": 0.211
            },
            "gtin": "4043027011242",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a02",
            "leftCorner": {
              "x": 7.173,
              "y": -4.3,
              "z": 0.211
            },
            "rightCorner": {
              "x": 7.258,
              "y": -4.375,
              "z": 0.211
            }
          },
          {
            "id": "696ebf7043c343680a271a03",
            "leftCorner": {
              "x": 7.258,
              "y": -4.375,
              "z": 0.211
            },
            "rightCorner": {
              "x": 7.36,
              "y": -4.464,
              "z": 0.211
            },
            "gtin": "4058172309397",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a04",
            "leftCorner": {
              "x": 7.36,
              "y": -4.464,
              "z": 0.211
            },
            "rightCorner": {
              "x": 7.467,
              "y": -4.558,
              "z": 0.211
            },
            "gtin": "4066447219463",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a05",
            "leftCorner": {
              "x": 7.467,
              "y": -4.558,
              "z": 0.211
            },
            "rightCorner": {
              "x": 7.543,
              "y": -4.624,
              "z": 0.211
            },
            "gtin": "4003573189024",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a06",
            "leftCorner": {
              "x": 7.543,
              "y": -4.624,
              "z": 0.211
            },
            "rightCorner": {
              "x": 7.602,
              "y": -4.676,
              "z": 0.211
            },
            "gtin": "4058172309656",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a07",
            "leftCorner": {
              "x": 7.602,
              "y": -4.676,
              "z": 0.211
            },
            "rightCorner": {
              "x": 7.677,
              "y": -4.742,
              "z": 0.211
            },
            "gtin": "4250529300006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a08",
            "leftCorner": {
              "x": 7.677,
              "y": -4.742,
              "z": 0.211
            },
            "rightCorner": {
              "x": 7.749,
              "y": -4.805,
              "z": 0.211
            }
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b2a",
        "height": 0.55682,
        "facings": [
          {
            "id": "696ebf7043c343680a27185b",
            "leftCorner": {
              "x": 6.962,
              "y": -3.973,
              "z": 0.557
            },
            "rightCorner": {
              "x": 7.009,
              "y": -4.015,
              "z": 0.557
            },
            "gtin": "4009932132601",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27185c",
            "leftCorner": {
              "x": 7.032,
              "y": -4.039,
              "z": 0.557
            },
            "rightCorner": {
              "x": 7.121,
              "y": -4.117,
              "z": 0.557
            },
            "gtin": "4036581252411",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27185d",
            "leftCorner": {
              "x": 7.121,
              "y": -4.117,
              "z": 0.557
            },
            "rightCorner": {
              "x": 7.182,
              "y": -4.171,
              "z": 0.557
            },
            "gtin": "4036581252381",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27185e",
            "leftCorner": {
              "x": 7.182,
              "y": -4.171,
              "z": 0.557
            },
            "rightCorner": {
              "x": 7.24,
              "y": -4.222,
              "z": 0.557
            },
            "gtin": "4036581252589",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27185f",
            "leftCorner": {
              "x": 7.24,
              "y": -4.222,
              "z": 0.557
            },
            "rightCorner": {
              "x": 7.3,
              "y": -4.274,
              "z": 0.557
            },
            "gtin": "4036581252589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271860",
            "leftCorner": {
              "x": 7.3,
              "y": -4.274,
              "z": 0.557
            },
            "rightCorner": {
              "x": 7.319,
              "y": -4.291,
              "z": 0.557
            }
          },
          {
            "id": "696ebf7043c343680a271861",
            "leftCorner": {
              "x": 7.319,
              "y": -4.291,
              "z": 0.557
            },
            "rightCorner": {
              "x": 7.361,
              "y": -4.328,
              "z": 0.557
            }
          },
          {
            "id": "696ebf7043c343680a271862",
            "leftCorner": {
              "x": 7.361,
              "y": -4.328,
              "z": 0.557
            },
            "rightCorner": {
              "x": 7.388,
              "y": -4.352,
              "z": 0.557
            }
          },
          {
            "id": "696ebf7043c343680a271863",
            "leftCorner": {
              "x": 7.388,
              "y": -4.352,
              "z": 0.557
            },
            "rightCorner": {
              "x": 7.443,
              "y": -4.4,
              "z": 0.557
            },
            "gtin": "4058172308390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271864",
            "leftCorner": {
              "x": 7.443,
              "y": -4.4,
              "z": 0.557
            },
            "rightCorner": {
              "x": 7.509,
              "y": -4.457,
              "z": 0.557
            },
            "gtin": "4067796168518",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271865",
            "leftCorner": {
              "x": 7.509,
              "y": -4.457,
              "z": 0.557
            },
            "rightCorner": {
              "x": 7.578,
              "y": -4.518,
              "z": 0.557
            },
            "gtin": "4067796168518",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271866",
            "leftCorner": {
              "x": 7.578,
              "y": -4.518,
              "z": 0.557
            },
            "rightCorner": {
              "x": 7.666,
              "y": -4.596,
              "z": 0.557
            },
            "gtin": "4036581251421",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271867",
            "leftCorner": {
              "x": 7.666,
              "y": -4.596,
              "z": 0.557
            },
            "rightCorner": {
              "x": 7.751,
              "y": -4.67,
              "z": 0.557
            },
            "gtin": "4036581252282",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b2c",
        "height": 0.76633,
        "facings": [
          {
            "id": "696ebf7043c343680a271a2a",
            "leftCorner": {
              "x": 6.996,
              "y": -4.006,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.04,
              "y": -4.045,
              "z": 0.766
            },
            "gtin": "4008617404637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a2b",
            "leftCorner": {
              "x": 7.04,
              "y": -4.045,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.106,
              "y": -4.103,
              "z": 0.766
            },
            "gtin": "4008617404637",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a2c",
            "leftCorner": {
              "x": 7.106,
              "y": -4.103,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.144,
              "y": -4.136,
              "z": 0.766
            }
          },
          {
            "id": "696ebf7043c343680a271a2d",
            "leftCorner": {
              "x": 7.144,
              "y": -4.136,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.201,
              "y": -4.186,
              "z": 0.766
            },
            "gtin": "4036581253388",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a2e",
            "leftCorner": {
              "x": 7.201,
              "y": -4.186,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.271,
              "y": -4.248,
              "z": 0.766
            },
            "gtin": "4009932131215",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a2f",
            "leftCorner": {
              "x": 7.271,
              "y": -4.248,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.34,
              "y": -4.308,
              "z": 0.766
            },
            "gtin": "4250752204744",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a30",
            "leftCorner": {
              "x": 7.34,
              "y": -4.308,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.385,
              "y": -4.347,
              "z": 0.766
            },
            "gtin": "4067796166743",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a31",
            "leftCorner": {
              "x": 7.385,
              "y": -4.347,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.415,
              "y": -4.374,
              "z": 0.766
            },
            "gtin": "4067796166743",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a32",
            "leftCorner": {
              "x": 7.415,
              "y": -4.374,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.474,
              "y": -4.426,
              "z": 0.766
            },
            "gtin": "4067796139167",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a33",
            "leftCorner": {
              "x": 7.474,
              "y": -4.426,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.585,
              "y": -4.522,
              "z": 0.766
            },
            "gtin": "4260609512052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a34",
            "leftCorner": {
              "x": 7.585,
              "y": -4.522,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.695,
              "y": -4.619,
              "z": 0.766
            },
            "gtin": "4260609513769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a35",
            "leftCorner": {
              "x": 7.695,
              "y": -4.619,
              "z": 0.766
            },
            "rightCorner": {
              "x": 7.747,
              "y": -4.665,
              "z": 0.766
            },
            "gtin": "4260697147143",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b2b",
        "height": 0.97872,
        "facings": [
          {
            "id": "696ebf7043c343680a2719aa",
            "leftCorner": {
              "x": 6.999,
              "y": -4.003,
              "z": 0.979
            },
            "rightCorner": {
              "x": 7.076,
              "y": -4.073,
              "z": 0.979
            },
            "gtin": "4008491105965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2719ab",
            "leftCorner": {
              "x": 7.077,
              "y": -4.072,
              "z": 0.979
            },
            "rightCorner": {
              "x": 7.146,
              "y": -4.133,
              "z": 0.979
            },
            "gtin": "4058172696244",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719ac",
            "leftCorner": {
              "x": 7.146,
              "y": -4.133,
              "z": 0.979
            },
            "rightCorner": {
              "x": 7.201,
              "y": -4.18,
              "z": 0.979
            },
            "gtin": "4058172696244",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719ad",
            "leftCorner": {
              "x": 7.201,
              "y": -4.18,
              "z": 0.979
            },
            "rightCorner": {
              "x": 7.276,
              "y": -4.246,
              "z": 0.979
            },
            "gtin": "4009932001327",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719ae",
            "leftCorner": {
              "x": 7.276,
              "y": -4.246,
              "z": 0.979
            },
            "rightCorner": {
              "x": 7.345,
              "y": -4.307,
              "z": 0.979
            },
            "gtin": "4003087446651",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719af",
            "leftCorner": {
              "x": 7.345,
              "y": -4.307,
              "z": 0.979
            },
            "rightCorner": {
              "x": 7.389,
              "y": -4.346,
              "z": 0.979
            },
            "gtin": "4066447015348",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719b0",
            "leftCorner": {
              "x": 7.389,
              "y": -4.346,
              "z": 0.979
            },
            "rightCorner": {
              "x": 7.42,
              "y": -4.373,
              "z": 0.979
            },
            "gtin": "4066447015348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2719b1",
            "leftCorner": {
              "x": 7.42,
              "y": -4.373,
              "z": 0.979
            },
            "rightCorner": {
              "x": 7.524,
              "y": -4.464,
              "z": 0.979
            },
            "gtin": "4008491107112",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719b2",
            "leftCorner": {
              "x": 7.524,
              "y": -4.464,
              "z": 0.979
            },
            "rightCorner": {
              "x": 7.66,
              "y": -4.583,
              "z": 0.979
            },
            "gtin": "4010160001188",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719b3",
            "leftCorner": {
              "x": 7.66,
              "y": -4.583,
              "z": 0.979
            },
            "rightCorner": {
              "x": 7.736,
              "y": -4.65,
              "z": 0.979
            },
            "gtin": "4260697146764",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b26",
        "height": 1.1914,
        "facings": [
          {
            "id": "696ebf7043c343680a271884",
            "leftCorner": {
              "x": 7.014,
              "y": -4.017,
              "z": 1.191
            },
            "rightCorner": {
              "x": 7.088,
              "y": -4.083,
              "z": 1.191
            },
            "gtin": "4008455033914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271885",
            "leftCorner": {
              "x": 7.088,
              "y": -4.083,
              "z": 1.191
            },
            "rightCorner": {
              "x": 7.155,
              "y": -4.142,
              "z": 1.191
            },
            "gtin": "4005120605056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271886",
            "leftCorner": {
              "x": 7.155,
              "y": -4.142,
              "z": 1.191
            },
            "rightCorner": {
              "x": 7.22,
              "y": -4.198,
              "z": 1.191
            },
            "gtin": "4005120170325",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271887",
            "leftCorner": {
              "x": 7.22,
              "y": -4.198,
              "z": 1.191
            },
            "rightCorner": {
              "x": 7.29,
              "y": -4.26,
              "z": 1.191
            },
            "gtin": "4008455037615",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271888",
            "leftCorner": {
              "x": 7.29,
              "y": -4.26,
              "z": 1.191
            },
            "rightCorner": {
              "x": 7.378,
              "y": -4.337,
              "z": 1.191
            },
            "gtin": "4008455037813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271889",
            "leftCorner": {
              "x": 7.378,
              "y": -4.337,
              "z": 1.191
            },
            "rightCorner": {
              "x": 7.422,
              "y": -4.375,
              "z": 1.191
            },
            "gtin": "4058172921896",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27188a",
            "leftCorner": {
              "x": 7.422,
              "y": -4.375,
              "z": 1.191
            },
            "rightCorner": {
              "x": 7.473,
              "y": -4.42,
              "z": 1.191
            },
            "gtin": "4058172921896",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27188b",
            "leftCorner": {
              "x": 7.473,
              "y": -4.42,
              "z": 1.191
            },
            "rightCorner": {
              "x": 7.546,
              "y": -4.484,
              "z": 1.191
            },
            "gtin": "4260159456738",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27188c",
            "leftCorner": {
              "x": 7.546,
              "y": -4.484,
              "z": 1.191
            },
            "rightCorner": {
              "x": 7.644,
              "y": -4.57,
              "z": 1.191
            },
            "gtin": "4003087433057",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27188d",
            "leftCorner": {
              "x": 7.644,
              "y": -4.57,
              "z": 1.191
            },
            "rightCorner": {
              "x": 7.72,
              "y": -4.637,
              "z": 1.191
            },
            "gtin": "4067796158823",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27188e",
            "leftCorner": {
              "x": 7.72,
              "y": -4.637,
              "z": 1.191
            },
            "rightCorner": {
              "x": 7.757,
              "y": -4.669,
              "z": 1.191
            }
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b27",
        "height": 1.3603,
        "facings": [
          {
            "id": "696ebf7043c343680a271961",
            "leftCorner": {
              "x": 6.998,
              "y": -4.004,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.084,
              "y": -4.082,
              "z": 1.36
            },
            "gtin": "4005120170318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271962",
            "leftCorner": {
              "x": 7.085,
              "y": -4.081,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.158,
              "y": -4.144,
              "z": 1.36
            },
            "gtin": "4008455033518",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271963",
            "leftCorner": {
              "x": 7.158,
              "y": -4.144,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.229,
              "y": -4.207,
              "z": 1.36
            },
            "gtin": "4005120412012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271964",
            "leftCorner": {
              "x": 7.229,
              "y": -4.207,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.309,
              "y": -4.277,
              "z": 1.36
            },
            "gtin": "4036581540792",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271965",
            "leftCorner": {
              "x": 7.309,
              "y": -4.277,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.384,
              "y": -4.343,
              "z": 1.36
            },
            "gtin": "4260173433944",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271966",
            "leftCorner": {
              "x": 7.384,
              "y": -4.343,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.432,
              "y": -4.385,
              "z": 1.36
            },
            "gtin": "4067796102451",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271967",
            "leftCorner": {
              "x": 7.432,
              "y": -4.385,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.484,
              "y": -4.431,
              "z": 1.36
            },
            "gtin": "4067796102512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271968",
            "leftCorner": {
              "x": 7.484,
              "y": -4.431,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.538,
              "y": -4.478,
              "z": 1.36
            },
            "gtin": "4036581537532",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271969",
            "leftCorner": {
              "x": 7.538,
              "y": -4.478,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.586,
              "y": -4.52,
              "z": 1.36
            },
            "gtin": "4036581526970",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27196a",
            "leftCorner": {
              "x": 7.586,
              "y": -4.52,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.649,
              "y": -4.575,
              "z": 1.36
            },
            "gtin": "4008491116527",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27196b",
            "leftCorner": {
              "x": 7.649,
              "y": -4.575,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.71,
              "y": -4.629,
              "z": 1.36
            },
            "gtin": "4008491225007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27196c",
            "leftCorner": {
              "x": 7.71,
              "y": -4.629,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.753,
              "y": -4.666,
              "z": 1.36
            }
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b29",
        "height": 1.5702,
        "facings": [
          {
            "id": "696ebf7043c343680a2718c9",
            "leftCorner": {
              "x": 7.02,
              "y": -4.024,
              "z": 1.57
            },
            "rightCorner": {
              "x": 7.064,
              "y": -4.062,
              "z": 1.57
            },
            "gtin": "4066447833959",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718ca",
            "leftCorner": {
              "x": 7.064,
              "y": -4.062,
              "z": 1.57
            },
            "rightCorner": {
              "x": 7.126,
              "y": -4.117,
              "z": 1.57
            },
            "gtin": "4010160001461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718cb",
            "leftCorner": {
              "x": 7.126,
              "y": -4.117,
              "z": 1.57
            },
            "rightCorner": {
              "x": 7.18,
              "y": -4.164,
              "z": 1.57
            },
            "gtin": "4026600366212",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718cc",
            "leftCorner": {
              "x": 7.18,
              "y": -4.164,
              "z": 1.57
            },
            "rightCorner": {
              "x": 7.243,
              "y": -4.219,
              "z": 1.57
            },
            "gtin": "2050000042409",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718cd",
            "leftCorner": {
              "x": 7.243,
              "y": -4.219,
              "z": 1.57
            },
            "rightCorner": {
              "x": 7.304,
              "y": -4.272,
              "z": 1.57
            },
            "gtin": "4009932131024",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718ce",
            "leftCorner": {
              "x": 7.304,
              "y": -4.272,
              "z": 1.57
            },
            "rightCorner": {
              "x": 7.339,
              "y": -4.303,
              "z": 1.57
            },
            "gtin": "4005120000141",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718cf",
            "leftCorner": {
              "x": 7.339,
              "y": -4.303,
              "z": 1.57
            },
            "rightCorner": {
              "x": 7.365,
              "y": -4.326,
              "z": 1.57
            },
            "gtin": "4005120000141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2718d0",
            "leftCorner": {
              "x": 7.365,
              "y": -4.326,
              "z": 1.57
            },
            "rightCorner": {
              "x": 7.423,
              "y": -4.377,
              "z": 1.57
            },
            "gtin": "4058172924606",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718d1",
            "leftCorner": {
              "x": 7.423,
              "y": -4.377,
              "z": 1.57
            },
            "rightCorner": {
              "x": 7.479,
              "y": -4.426,
              "z": 1.57
            },
            "gtin": "4009932134513",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718d2",
            "leftCorner": {
              "x": 7.479,
              "y": -4.426,
              "z": 1.57
            },
            "rightCorner": {
              "x": 7.541,
              "y": -4.48,
              "z": 1.57
            },
            "gtin": "4026600352000",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718d3",
            "leftCorner": {
              "x": 7.541,
              "y": -4.48,
              "z": 1.57
            },
            "rightCorner": {
              "x": 7.607,
              "y": -4.538,
              "z": 1.57
            },
            "gtin": "4008491111935",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718d4",
            "leftCorner": {
              "x": 7.607,
              "y": -4.538,
              "z": 1.57
            },
            "rightCorner": {
              "x": 7.664,
              "y": -4.589,
              "z": 1.57
            },
            "gtin": "4009932131260",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718d5",
            "leftCorner": {
              "x": 7.664,
              "y": -4.589,
              "z": 1.57
            },
            "rightCorner": {
              "x": 7.75,
              "y": -4.664,
              "z": 1.57
            },
            "gtin": "4067796168495",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b28",
        "height": 1.7781,
        "facings": [
          {
            "id": "696ebf7043c343680a271912",
            "leftCorner": {
              "x": 6.998,
              "y": -4.005,
              "z": 1.778
            },
            "rightCorner": {
              "x": 7.05,
              "y": -4.052,
              "z": 1.778
            },
            "gtin": "4260697143947",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271913",
            "leftCorner": {
              "x": 7.05,
              "y": -4.051,
              "z": 1.778
            },
            "rightCorner": {
              "x": 7.095,
              "y": -4.09,
              "z": 1.778
            }
          },
          {
            "id": "696ebf7043c343680a271914",
            "leftCorner": {
              "x": 7.095,
              "y": -4.09,
              "z": 1.778
            },
            "rightCorner": {
              "x": 7.149,
              "y": -4.138,
              "z": 1.778
            },
            "gtin": "4003087433453",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271915",
            "leftCorner": {
              "x": 7.149,
              "y": -4.138,
              "z": 1.778
            },
            "rightCorner": {
              "x": 7.201,
              "y": -4.183,
              "z": 1.778
            },
            "gtin": "4003087441953",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271916",
            "leftCorner": {
              "x": 7.201,
              "y": -4.183,
              "z": 1.778
            },
            "rightCorner": {
              "x": 7.262,
              "y": -4.237,
              "z": 1.778
            },
            "gtin": "4003087432456",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271917",
            "leftCorner": {
              "x": 7.262,
              "y": -4.237,
              "z": 1.778
            },
            "rightCorner": {
              "x": 7.317,
              "y": -4.285,
              "z": 1.778
            },
            "gtin": "4058172921810",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271918",
            "leftCorner": {
              "x": 7.317,
              "y": -4.285,
              "z": 1.778
            },
            "rightCorner": {
              "x": 7.342,
              "y": -4.306,
              "z": 1.778
            }
          },
          {
            "id": "696ebf7043c343680a271919",
            "leftCorner": {
              "x": 7.342,
              "y": -4.306,
              "z": 1.778
            },
            "rightCorner": {
              "x": 7.377,
              "y": -4.337,
              "z": 1.778
            },
            "gtin": "4058172921834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27191a",
            "leftCorner": {
              "x": 7.377,
              "y": -4.337,
              "z": 1.778
            },
            "rightCorner": {
              "x": 7.407,
              "y": -4.364,
              "z": 1.778
            },
            "gtin": "4058172921834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27191b",
            "leftCorner": {
              "x": 7.407,
              "y": -4.364,
              "z": 1.778
            },
            "rightCorner": {
              "x": 7.47,
              "y": -4.419,
              "z": 1.778
            },
            "gtin": "4008491130981",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27191c",
            "leftCorner": {
              "x": 7.47,
              "y": -4.419,
              "z": 1.778
            },
            "rightCorner": {
              "x": 7.537,
              "y": -4.478,
              "z": 1.778
            },
            "gtin": "4003087448754",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27191d",
            "leftCorner": {
              "x": 7.537,
              "y": -4.478,
              "z": 1.778
            },
            "rightCorner": {
              "x": 7.586,
              "y": -4.52,
              "z": 1.778
            },
            "gtin": "4067796102437",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27191e",
            "leftCorner": {
              "x": 7.586,
              "y": -4.52,
              "z": 1.778
            },
            "rightCorner": {
              "x": 7.671,
              "y": -4.595,
              "z": 1.778
            },
            "gtin": "4066447880779",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27191f",
            "leftCorner": {
              "x": 7.671,
              "y": -4.595,
              "z": 1.778
            },
            "rightCorner": {
              "x": 7.744,
              "y": -4.66,
              "z": 1.778
            },
            "gtin": "4058172684128",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7575bb5fe7bc0469599a9",
    "name": "68e7575bb5fe7bc0469599a9",
    "x": 7.7213,
    "y": -4.7189,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.34897,
      "w": 0.93713
    },
    "statistics": {
      "hasStockCount": 71,
      "noStockCount": 2,
      "unknownStockCount": 14
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73b34",
        "height": 0.20887,
        "facings": [
          {
            "id": "696ebf7043c343680a271a09",
            "leftCorner": {
              "x": 7.762,
              "y": -4.814,
              "z": 0.209
            },
            "rightCorner": {
              "x": 7.817,
              "y": -4.862,
              "z": 0.209
            },
            "gtin": "4004191008445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a0a",
            "leftCorner": {
              "x": 7.817,
              "y": -4.862,
              "z": 0.209
            },
            "rightCorner": {
              "x": 7.873,
              "y": -4.91,
              "z": 0.209
            },
            "gtin": "4004191008445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a0b",
            "leftCorner": {
              "x": 7.873,
              "y": -4.91,
              "z": 0.209
            },
            "rightCorner": {
              "x": 7.936,
              "y": -4.965,
              "z": 0.209
            },
            "gtin": "4004194008404",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a0c",
            "leftCorner": {
              "x": 7.936,
              "y": -4.965,
              "z": 0.209
            },
            "rightCorner": {
              "x": 8.004,
              "y": -5.024,
              "z": 0.209
            },
            "gtin": "4004194008404",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a0d",
            "leftCorner": {
              "x": 8.004,
              "y": -5.024,
              "z": 0.209
            },
            "rightCorner": {
              "x": 8.053,
              "y": -5.066,
              "z": 0.209
            },
            "gtin": "4004191016525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a0e",
            "leftCorner": {
              "x": 8.053,
              "y": -5.066,
              "z": 0.209
            },
            "rightCorner": {
              "x": 8.107,
              "y": -5.113,
              "z": 0.209
            },
            "gtin": "4004191016563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a0f",
            "leftCorner": {
              "x": 8.107,
              "y": -5.113,
              "z": 0.209
            },
            "rightCorner": {
              "x": 8.162,
              "y": -5.16,
              "z": 0.209
            },
            "gtin": "4004191016518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a10",
            "leftCorner": {
              "x": 8.162,
              "y": -5.16,
              "z": 0.209
            },
            "rightCorner": {
              "x": 8.258,
              "y": -5.244,
              "z": 0.209
            },
            "gtin": "4043027007344",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a11",
            "leftCorner": {
              "x": 8.258,
              "y": -5.244,
              "z": 0.209
            },
            "rightCorner": {
              "x": 8.343,
              "y": -5.317,
              "z": 0.209
            },
            "gtin": "4043027010207",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a12",
            "leftCorner": {
              "x": 8.343,
              "y": -5.317,
              "z": 0.209
            },
            "rightCorner": {
              "x": 8.386,
              "y": -5.354,
              "z": 0.209
            },
            "gtin": "4083700305503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a13",
            "leftCorner": {
              "x": 8.386,
              "y": -5.354,
              "z": 0.209
            },
            "rightCorner": {
              "x": 8.424,
              "y": -5.387,
              "z": 0.209
            },
            "gtin": "4083700305510",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a14",
            "leftCorner": {
              "x": 8.424,
              "y": -5.387,
              "z": 0.209
            },
            "rightCorner": {
              "x": 8.488,
              "y": -5.442,
              "z": 0.209
            },
            "gtin": "4083700305527",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b32",
        "height": 0.55587,
        "facings": [
          {
            "id": "696ebf7043c343680a271868",
            "leftCorner": {
              "x": 7.751,
              "y": -4.67,
              "z": 0.557
            },
            "rightCorner": {
              "x": 7.804,
              "y": -4.716,
              "z": 0.557
            },
            "gtin": "4008491130035",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271869",
            "leftCorner": {
              "x": 7.814,
              "y": -4.727,
              "z": 0.556
            },
            "rightCorner": {
              "x": 7.88,
              "y": -4.783,
              "z": 0.556
            },
            "gtin": "4009932131093",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27186a",
            "leftCorner": {
              "x": 7.88,
              "y": -4.783,
              "z": 0.556
            },
            "rightCorner": {
              "x": 7.923,
              "y": -4.821,
              "z": 0.556
            },
            "gtin": "2099999063354",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27186b",
            "leftCorner": {
              "x": 7.923,
              "y": -4.821,
              "z": 0.556
            },
            "rightCorner": {
              "x": 7.962,
              "y": -4.855,
              "z": 0.556
            },
            "gtin": "2090000368932",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27186c",
            "leftCorner": {
              "x": 7.962,
              "y": -4.855,
              "z": 0.556
            },
            "rightCorner": {
              "x": 8.024,
              "y": -4.908,
              "z": 0.556
            },
            "gtin": "4008491108560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27186d",
            "leftCorner": {
              "x": 8.024,
              "y": -4.908,
              "z": 0.556
            },
            "rightCorner": {
              "x": 8.087,
              "y": -4.962,
              "z": 0.556
            },
            "gtin": "4066447794793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27186e",
            "leftCorner": {
              "x": 8.087,
              "y": -4.962,
              "z": 0.556
            },
            "rightCorner": {
              "x": 8.148,
              "y": -5.015,
              "z": 0.556
            },
            "gtin": "4066447794779",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27186f",
            "leftCorner": {
              "x": 8.148,
              "y": -5.015,
              "z": 0.556
            },
            "rightCorner": {
              "x": 8.203,
              "y": -5.063,
              "z": 0.556
            },
            "gtin": "4010160001164",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271870",
            "leftCorner": {
              "x": 8.203,
              "y": -5.063,
              "z": 0.556
            },
            "rightCorner": {
              "x": 8.281,
              "y": -5.13,
              "z": 0.556
            },
            "gtin": "4066447416541",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271871",
            "leftCorner": {
              "x": 8.281,
              "y": -5.13,
              "z": 0.556
            },
            "rightCorner": {
              "x": 8.328,
              "y": -5.171,
              "z": 0.556
            }
          },
          {
            "id": "696ebf7043c343680a271872",
            "leftCorner": {
              "x": 8.328,
              "y": -5.171,
              "z": 0.556
            },
            "rightCorner": {
              "x": 8.374,
              "y": -5.211,
              "z": 0.556
            },
            "gtin": "4066447857979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271873",
            "leftCorner": {
              "x": 8.374,
              "y": -5.211,
              "z": 0.556
            },
            "rightCorner": {
              "x": 8.432,
              "y": -5.261,
              "z": 0.556
            },
            "gtin": "4058172777790",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271874",
            "leftCorner": {
              "x": 8.432,
              "y": -5.261,
              "z": 0.556
            },
            "rightCorner": {
              "x": 8.477,
              "y": -5.3,
              "z": 0.556
            },
            "gtin": "4043027007436",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271851",
            "leftCorner": {
              "x": 8.477,
              "y": -5.3,
              "z": 0.556
            },
            "rightCorner": {
              "x": 8.514,
              "y": -5.331,
              "z": 0.556
            },
            "gtin": "4043027007887",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b2f",
        "height": 0.76538,
        "facings": [
          {
            "id": "696ebf7043c343680a271a38",
            "leftCorner": {
              "x": 7.855,
              "y": -4.757,
              "z": 0.765
            },
            "rightCorner": {
              "x": 7.899,
              "y": -4.795,
              "z": 0.765
            },
            "gtin": "4260488132334",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a36",
            "leftCorner": {
              "x": 7.758,
              "y": -4.674,
              "z": 0.765
            },
            "rightCorner": {
              "x": 7.798,
              "y": -4.708,
              "z": 0.765
            },
            "gtin": "2099999063361",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a37",
            "leftCorner": {
              "x": 7.798,
              "y": -4.708,
              "z": 0.765
            },
            "rightCorner": {
              "x": 7.855,
              "y": -4.757,
              "z": 0.765
            },
            "gtin": "4067796070101",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a39",
            "leftCorner": {
              "x": 7.899,
              "y": -4.795,
              "z": 0.765
            },
            "rightCorner": {
              "x": 7.965,
              "y": -4.852,
              "z": 0.765
            },
            "gtin": "4003087448457",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a3a",
            "leftCorner": {
              "x": 7.965,
              "y": -4.852,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.036,
              "y": -4.914,
              "z": 0.765
            },
            "gtin": "4003087448457",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a3b",
            "leftCorner": {
              "x": 8.036,
              "y": -4.914,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.072,
              "y": -4.945,
              "z": 0.765
            },
            "gtin": "4058172937088",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a3c",
            "leftCorner": {
              "x": 8.072,
              "y": -4.945,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.093,
              "y": -4.963,
              "z": 0.765
            },
            "gtin": "4058172937088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a3d",
            "leftCorner": {
              "x": 8.093,
              "y": -4.963,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.161,
              "y": -5.022,
              "z": 0.765
            },
            "gtin": "4009932002454",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a3e",
            "leftCorner": {
              "x": 8.161,
              "y": -5.022,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.233,
              "y": -5.084,
              "z": 0.765
            },
            "gtin": "4009932006025",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a3f",
            "leftCorner": {
              "x": 8.233,
              "y": -5.084,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.302,
              "y": -5.144,
              "z": 0.765
            }
          },
          {
            "id": "696ebf7043c343680a271a40",
            "leftCorner": {
              "x": 8.302,
              "y": -5.144,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.364,
              "y": -5.197,
              "z": 0.765
            },
            "gtin": "4008233180243",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a41",
            "leftCorner": {
              "x": 8.364,
              "y": -5.197,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.425,
              "y": -5.25,
              "z": 0.765
            },
            "gtin": "4260744131255",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a42",
            "leftCorner": {
              "x": 8.425,
              "y": -5.25,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.483,
              "y": -5.3,
              "z": 0.765
            },
            "gtin": "4262390680088",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b36",
        "height": 0.97853,
        "facings": [
          {
            "id": "696ebf7043c343680a2719b4",
            "leftCorner": {
              "x": 7.736,
              "y": -4.65,
              "z": 0.979
            },
            "rightCorner": {
              "x": 7.906,
              "y": -4.799,
              "z": 0.979
            },
            "gtin": "4000401300187",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719b5",
            "leftCorner": {
              "x": 7.915,
              "y": -4.81,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.013,
              "y": -4.895,
              "z": 0.979
            },
            "gtin": "4000401300064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2719b6",
            "leftCorner": {
              "x": 8.013,
              "y": -4.895,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.105,
              "y": -4.974,
              "z": 0.979
            },
            "gtin": "4058172309878",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719b7",
            "leftCorner": {
              "x": 8.105,
              "y": -4.974,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.173,
              "y": -5.033,
              "z": 0.979
            },
            "gtin": "4066447861549",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719b8",
            "leftCorner": {
              "x": 8.173,
              "y": -5.033,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.241,
              "y": -5.092,
              "z": 0.979
            }
          },
          {
            "id": "696ebf7043c343680a2719b9",
            "leftCorner": {
              "x": 8.241,
              "y": -5.092,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.302,
              "y": -5.145,
              "z": 0.979
            },
            "gtin": "4066447394870",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719ba",
            "leftCorner": {
              "x": 8.302,
              "y": -5.145,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.35,
              "y": -5.186,
              "z": 0.979
            },
            "gtin": "4260609512076",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719bb",
            "leftCorner": {
              "x": 8.35,
              "y": -5.186,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.411,
              "y": -5.239,
              "z": 0.979
            },
            "gtin": "4260729423092",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719bc",
            "leftCorner": {
              "x": 8.411,
              "y": -5.239,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.469,
              "y": -5.289,
              "z": 0.979
            },
            "gtin": "4260729424105",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719bd",
            "leftCorner": {
              "x": 8.469,
              "y": -5.289,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.562,
              "y": -5.369,
              "z": 0.979
            },
            "gtin": "4008233033037",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b35",
        "height": 1.1912,
        "facings": [
          {
            "id": "696ebf7043c343680a27188f",
            "leftCorner": {
              "x": 7.766,
              "y": -4.68,
              "z": 1.191
            },
            "rightCorner": {
              "x": 7.885,
              "y": -4.783,
              "z": 1.191
            },
            "gtin": "4005120202019",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271890",
            "leftCorner": {
              "x": 7.885,
              "y": -4.783,
              "z": 1.191
            },
            "rightCorner": {
              "x": 7.942,
              "y": -4.832,
              "z": 1.191
            },
            "gtin": "4058172922138",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271891",
            "leftCorner": {
              "x": 7.942,
              "y": -4.832,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.012,
              "y": -4.892,
              "z": 1.191
            },
            "gtin": "4066447248715",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271892",
            "leftCorner": {
              "x": 8.012,
              "y": -4.892,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.072,
              "y": -4.945,
              "z": 1.191
            },
            "gtin": "4008491104159",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271893",
            "leftCorner": {
              "x": 8.072,
              "y": -4.945,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.117,
              "y": -4.984,
              "z": 1.191
            },
            "gtin": "4260488132303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271894",
            "leftCorner": {
              "x": 8.117,
              "y": -4.984,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.171,
              "y": -5.031,
              "z": 1.191
            },
            "gtin": "4008491108683",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271895",
            "leftCorner": {
              "x": 8.171,
              "y": -5.031,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.228,
              "y": -5.079,
              "z": 1.191
            },
            "gtin": "4008491108607",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271896",
            "leftCorner": {
              "x": 8.228,
              "y": -5.079,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.347,
              "y": -5.182,
              "z": 1.191
            },
            "gtin": "2050000040306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271897",
            "leftCorner": {
              "x": 8.347,
              "y": -5.182,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.407,
              "y": -5.234,
              "z": 1.191
            },
            "gtin": "4250752205444",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271898",
            "leftCorner": {
              "x": 8.407,
              "y": -5.234,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.467,
              "y": -5.286,
              "z": 1.191
            },
            "gtin": "4066447248869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271899",
            "leftCorner": {
              "x": 8.467,
              "y": -5.286,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.522,
              "y": -5.334,
              "z": 1.191
            },
            "gtin": "4058172101311",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b30",
        "height": 1.3607,
        "facings": [
          {
            "id": "696ebf7043c343680a27196d",
            "leftCorner": {
              "x": 7.763,
              "y": -4.676,
              "z": 1.361
            },
            "rightCorner": {
              "x": 7.814,
              "y": -4.72,
              "z": 1.361
            },
            "gtin": "4067796195750",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27196e",
            "leftCorner": {
              "x": 7.814,
              "y": -4.72,
              "z": 1.361
            },
            "rightCorner": {
              "x": 7.879,
              "y": -4.776,
              "z": 1.361
            },
            "gtin": "4009932004908",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27196f",
            "leftCorner": {
              "x": 7.879,
              "y": -4.776,
              "z": 1.361
            },
            "rightCorner": {
              "x": 7.954,
              "y": -4.841,
              "z": 1.361
            }
          },
          {
            "id": "696ebf7043c343680a271970",
            "leftCorner": {
              "x": 7.954,
              "y": -4.841,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.029,
              "y": -4.906,
              "z": 1.361
            },
            "gtin": "4005120170400",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271971",
            "leftCorner": {
              "x": 8.029,
              "y": -4.906,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.097,
              "y": -4.965,
              "z": 1.361
            },
            "gtin": "4005120163198",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271972",
            "leftCorner": {
              "x": 8.097,
              "y": -4.965,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.134,
              "y": -4.996,
              "z": 1.361
            },
            "gtin": "4008455036113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271973",
            "leftCorner": {
              "x": 8.134,
              "y": -4.996,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.208,
              "y": -5.061,
              "z": 1.361
            },
            "gtin": "4003573488400",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271974",
            "leftCorner": {
              "x": 8.208,
              "y": -5.061,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.275,
              "y": -5.119,
              "z": 1.361
            },
            "gtin": "4009241527006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271975",
            "leftCorner": {
              "x": 8.275,
              "y": -5.119,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.335,
              "y": -5.171,
              "z": 1.361
            },
            "gtin": "4250752206519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271976",
            "leftCorner": {
              "x": 8.335,
              "y": -5.171,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.398,
              "y": -5.225,
              "z": 1.361
            },
            "gtin": "4008491108287",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271977",
            "leftCorner": {
              "x": 8.398,
              "y": -5.225,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.456,
              "y": -5.276,
              "z": 1.361
            },
            "gtin": "4008491103558",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271978",
            "leftCorner": {
              "x": 8.456,
              "y": -5.276,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.516,
              "y": -5.327,
              "z": 1.361
            },
            "gtin": "4058172694080",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b33",
        "height": 1.5685,
        "facings": [
          {
            "id": "696ebf7043c343680a2718d6",
            "leftCorner": {
              "x": 7.76,
              "y": -4.674,
              "z": 1.568
            },
            "rightCorner": {
              "x": 7.784,
              "y": -4.695,
              "z": 1.568
            }
          },
          {
            "id": "696ebf7043c343680a2718d7",
            "leftCorner": {
              "x": 7.784,
              "y": -4.695,
              "z": 1.568
            },
            "rightCorner": {
              "x": 7.852,
              "y": -4.753,
              "z": 1.568
            },
            "gtin": "4009932136272",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718d8",
            "leftCorner": {
              "x": 7.852,
              "y": -4.753,
              "z": 1.568
            },
            "rightCorner": {
              "x": 7.923,
              "y": -4.815,
              "z": 1.568
            },
            "gtin": "4009932137217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718d9",
            "leftCorner": {
              "x": 7.923,
              "y": -4.815,
              "z": 1.568
            },
            "rightCorner": {
              "x": 7.983,
              "y": -4.867,
              "z": 1.568
            },
            "gtin": "4008491121002",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718da",
            "leftCorner": {
              "x": 7.983,
              "y": -4.867,
              "z": 1.568
            },
            "rightCorner": {
              "x": 8.046,
              "y": -4.921,
              "z": 1.568
            },
            "gtin": "4008491104142",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718db",
            "leftCorner": {
              "x": 8.046,
              "y": -4.921,
              "z": 1.568
            },
            "rightCorner": {
              "x": 8.093,
              "y": -4.962,
              "z": 1.568
            },
            "gtin": "4260488132280",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718dc",
            "leftCorner": {
              "x": 8.093,
              "y": -4.962,
              "z": 1.568
            },
            "rightCorner": {
              "x": 8.136,
              "y": -4.999,
              "z": 1.568
            },
            "gtin": "4260488132495",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718dd",
            "leftCorner": {
              "x": 8.136,
              "y": -4.999,
              "z": 1.568
            },
            "rightCorner": {
              "x": 8.221,
              "y": -5.072,
              "z": 1.568
            },
            "gtin": "4009932132632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718de",
            "leftCorner": {
              "x": 8.221,
              "y": -5.072,
              "z": 1.568
            },
            "rightCorner": {
              "x": 8.289,
              "y": -5.132,
              "z": 1.568
            },
            "gtin": "4009932133769",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718df",
            "leftCorner": {
              "x": 8.289,
              "y": -5.132,
              "z": 1.568
            },
            "rightCorner": {
              "x": 8.35,
              "y": -5.184,
              "z": 1.568
            },
            "gtin": "4008491132916",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718e0",
            "leftCorner": {
              "x": 8.35,
              "y": -5.184,
              "z": 1.568
            },
            "rightCorner": {
              "x": 8.402,
              "y": -5.229,
              "z": 1.568
            },
            "gtin": "4009932131161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718e1",
            "leftCorner": {
              "x": 8.402,
              "y": -5.229,
              "z": 1.568
            },
            "rightCorner": {
              "x": 8.447,
              "y": -5.268,
              "z": 1.568
            }
          },
          {
            "id": "696ebf7043c343680a2718e2",
            "leftCorner": {
              "x": 8.447,
              "y": -5.268,
              "z": 1.568
            },
            "rightCorner": {
              "x": 8.517,
              "y": -5.328,
              "z": 1.568
            },
            "gtin": "4009932136203",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b31",
        "height": 1.7776,
        "facings": [
          {
            "id": "696ebf7043c343680a271920",
            "leftCorner": {
              "x": 7.744,
              "y": -4.66,
              "z": 1.778
            },
            "rightCorner": {
              "x": 7.823,
              "y": -4.729,
              "z": 1.778
            },
            "gtin": "4008491108447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271921",
            "leftCorner": {
              "x": 7.832,
              "y": -4.741,
              "z": 1.778
            },
            "rightCorner": {
              "x": 7.912,
              "y": -4.81,
              "z": 1.778
            },
            "gtin": "4250752203204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271922",
            "leftCorner": {
              "x": 7.912,
              "y": -4.81,
              "z": 1.778
            },
            "rightCorner": {
              "x": 7.985,
              "y": -4.874,
              "z": 1.778
            },
            "gtin": "4010160001287",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271923",
            "leftCorner": {
              "x": 7.985,
              "y": -4.874,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.036,
              "y": -4.918,
              "z": 1.778
            },
            "gtin": "4010160001232",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271924",
            "leftCorner": {
              "x": 8.036,
              "y": -4.918,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.058,
              "y": -4.937,
              "z": 1.778
            }
          },
          {
            "id": "696ebf7043c343680a271925",
            "leftCorner": {
              "x": 8.058,
              "y": -4.937,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.172,
              "y": -5.036,
              "z": 1.778
            },
            "gtin": "4262354841128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271926",
            "leftCorner": {
              "x": 8.172,
              "y": -5.036,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.238,
              "y": -5.093,
              "z": 1.778
            },
            "gtin": "4262354841128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271927",
            "leftCorner": {
              "x": 8.238,
              "y": -5.093,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.278,
              "y": -5.127,
              "z": 1.778
            }
          },
          {
            "id": "696ebf7043c343680a271928",
            "leftCorner": {
              "x": 8.278,
              "y": -5.127,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.427,
              "y": -5.255,
              "z": 1.778
            },
            "gtin": "4262354841395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271929",
            "leftCorner": {
              "x": 8.427,
              "y": -5.255,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.511,
              "y": -5.329,
              "z": 1.778
            },
            "gtin": "4009932135244",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7575bb5fe7bc0469599aa",
    "name": "68e7575bb5fe7bc0469599aa",
    "x": 8.4551,
    "y": -5.3524,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.34773,
      "w": 0.9376
    },
    "statistics": {
      "hasStockCount": 77,
      "noStockCount": 2,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73b3c",
        "height": 0.20885,
        "facings": [
          {
            "id": "696ebf7043c343680a271a15",
            "leftCorner": {
              "x": 8.466,
              "y": -5.421,
              "z": 0.209
            },
            "rightCorner": {
              "x": 8.509,
              "y": -5.458,
              "z": 0.209
            }
          },
          {
            "id": "696ebf7043c343680a271a16",
            "leftCorner": {
              "x": 8.509,
              "y": -5.458,
              "z": 0.209
            },
            "rightCorner": {
              "x": 8.546,
              "y": -5.49,
              "z": 0.209
            },
            "gtin": "4066447921540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a17",
            "leftCorner": {
              "x": 8.546,
              "y": -5.49,
              "z": 0.209
            },
            "rightCorner": {
              "x": 8.611,
              "y": -5.546,
              "z": 0.209
            },
            "gtin": "4066447921540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a18",
            "leftCorner": {
              "x": 8.611,
              "y": -5.546,
              "z": 0.209
            },
            "rightCorner": {
              "x": 8.632,
              "y": -5.564,
              "z": 0.209
            }
          },
          {
            "id": "696ebf7043c343680a271a19",
            "leftCorner": {
              "x": 8.632,
              "y": -5.564,
              "z": 0.209
            },
            "rightCorner": {
              "x": 8.69,
              "y": -5.614,
              "z": 0.209
            },
            "gtin": "8710428019677",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a1a",
            "leftCorner": {
              "x": 8.69,
              "y": -5.614,
              "z": 0.209
            },
            "rightCorner": {
              "x": 8.763,
              "y": -5.676,
              "z": 0.209
            },
            "gtin": "4009932134117",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a1b",
            "leftCorner": {
              "x": 8.763,
              "y": -5.676,
              "z": 0.209
            },
            "rightCorner": {
              "x": 8.829,
              "y": -5.734,
              "z": 0.209
            },
            "gtin": "4004148313523",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a1c",
            "leftCorner": {
              "x": 8.829,
              "y": -5.734,
              "z": 0.209
            },
            "rightCorner": {
              "x": 8.874,
              "y": -5.772,
              "z": 0.209
            },
            "gtin": "4067796161830",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a1d",
            "leftCorner": {
              "x": 8.874,
              "y": -5.772,
              "z": 0.209
            },
            "rightCorner": {
              "x": 8.945,
              "y": -5.833,
              "z": 0.209
            },
            "gtin": "4008617040293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a1e",
            "leftCorner": {
              "x": 8.945,
              "y": -5.833,
              "z": 0.209
            },
            "rightCorner": {
              "x": 9.006,
              "y": -5.886,
              "z": 0.209
            },
            "gtin": "4008617121626",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a1f",
            "leftCorner": {
              "x": 9.006,
              "y": -5.886,
              "z": 0.209
            },
            "rightCorner": {
              "x": 9.076,
              "y": -5.946,
              "z": 0.209
            },
            "gtin": "4009932009064",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a20",
            "leftCorner": {
              "x": 9.076,
              "y": -5.946,
              "z": 0.209
            },
            "rightCorner": {
              "x": 9.122,
              "y": -5.986,
              "z": 0.209
            },
            "gtin": "4058172696183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2719e1",
            "leftCorner": {
              "x": 9.122,
              "y": -5.986,
              "z": 0.209
            },
            "rightCorner": {
              "x": 9.184,
              "y": -6.039,
              "z": 0.209
            },
            "gtin": "4067796102413",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b37",
        "height": 0.51395,
        "facings": [
          {
            "id": "696ebf7043c343680a271a63",
            "leftCorner": {
              "x": 8.491,
              "y": -5.311,
              "z": 0.514
            },
            "rightCorner": {
              "x": 8.524,
              "y": -5.339,
              "z": 0.514
            }
          },
          {
            "id": "696ebf7043c343680a271a65",
            "leftCorner": {
              "x": 8.524,
              "y": -5.339,
              "z": 0.514
            },
            "rightCorner": {
              "x": 8.584,
              "y": -5.391,
              "z": 0.514
            },
            "gtin": "4009932136302",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a66",
            "leftCorner": {
              "x": 8.584,
              "y": -5.391,
              "z": 0.514
            },
            "rightCorner": {
              "x": 8.641,
              "y": -5.44,
              "z": 0.514
            },
            "gtin": "4058172694622",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a67",
            "leftCorner": {
              "x": 8.641,
              "y": -5.44,
              "z": 0.514
            },
            "rightCorner": {
              "x": 8.706,
              "y": -5.496,
              "z": 0.514
            },
            "gtin": "4008491117449",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a68",
            "leftCorner": {
              "x": 8.706,
              "y": -5.496,
              "z": 0.514
            },
            "rightCorner": {
              "x": 8.789,
              "y": -5.567,
              "z": 0.514
            },
            "gtin": "4066447876215",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a69",
            "leftCorner": {
              "x": 8.789,
              "y": -5.567,
              "z": 0.514
            },
            "rightCorner": {
              "x": 8.869,
              "y": -5.636,
              "z": 0.514
            },
            "gtin": "4008617032168",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a6a",
            "leftCorner": {
              "x": 8.869,
              "y": -5.636,
              "z": 0.514
            },
            "rightCorner": {
              "x": 8.939,
              "y": -5.697,
              "z": 0.514
            },
            "gtin": "4008491277297",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a6b",
            "leftCorner": {
              "x": 8.939,
              "y": -5.697,
              "z": 0.514
            },
            "rightCorner": {
              "x": 8.995,
              "y": -5.744,
              "z": 0.514
            },
            "gtin": "4008491116855",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a6c",
            "leftCorner": {
              "x": 8.995,
              "y": -5.744,
              "z": 0.514
            },
            "rightCorner": {
              "x": 9.055,
              "y": -5.796,
              "z": 0.514
            },
            "gtin": "4008491105224",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a6d",
            "leftCorner": {
              "x": 9.055,
              "y": -5.796,
              "z": 0.514
            },
            "rightCorner": {
              "x": 9.11,
              "y": -5.843,
              "z": 0.514
            },
            "gtin": "4067796102314",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a6e",
            "leftCorner": {
              "x": 9.11,
              "y": -5.843,
              "z": 0.514
            },
            "rightCorner": {
              "x": 9.183,
              "y": -5.906,
              "z": 0.514
            },
            "gtin": "4009932134001",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a6f",
            "leftCorner": {
              "x": 9.183,
              "y": -5.906,
              "z": 0.514
            },
            "rightCorner": {
              "x": 9.247,
              "y": -5.961,
              "z": 0.514
            },
            "gtin": "4058172694400",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b3d",
        "height": 0.76534,
        "facings": [
          {
            "id": "696ebf7043c343680a271a43",
            "leftCorner": {
              "x": 8.483,
              "y": -5.3,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.57,
              "y": -5.376,
              "z": 0.765
            },
            "gtin": "4009932005554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a44",
            "leftCorner": {
              "x": 8.548,
              "y": -5.354,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.602,
              "y": -5.4,
              "z": 0.765
            },
            "gtin": "4009932005554",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a45",
            "leftCorner": {
              "x": 8.602,
              "y": -5.4,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.671,
              "y": -5.459,
              "z": 0.765
            },
            "gtin": "4009932002010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a46",
            "leftCorner": {
              "x": 8.671,
              "y": -5.459,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.741,
              "y": -5.519,
              "z": 0.765
            },
            "gtin": "4260253660222",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a47",
            "leftCorner": {
              "x": 8.741,
              "y": -5.519,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.824,
              "y": -5.591,
              "z": 0.765
            },
            "gtin": "4009932133165",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a48",
            "leftCorner": {
              "x": 8.824,
              "y": -5.591,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.883,
              "y": -5.642,
              "z": 0.765
            },
            "gtin": "4066447788426",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a49",
            "leftCorner": {
              "x": 8.883,
              "y": -5.642,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.931,
              "y": -5.683,
              "z": 0.765
            },
            "gtin": "4066447788426",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a4a",
            "leftCorner": {
              "x": 8.931,
              "y": -5.683,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.981,
              "y": -5.726,
              "z": 0.765
            },
            "gtin": "4270000185700",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a4b",
            "leftCorner": {
              "x": 8.981,
              "y": -5.726,
              "z": 0.765
            },
            "rightCorner": {
              "x": 9.045,
              "y": -5.781,
              "z": 0.765
            },
            "gtin": "4009932131253",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a4c",
            "leftCorner": {
              "x": 9.045,
              "y": -5.781,
              "z": 0.765
            },
            "rightCorner": {
              "x": 9.102,
              "y": -5.83,
              "z": 0.765
            },
            "gtin": "4058172694820",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a4d",
            "leftCorner": {
              "x": 9.102,
              "y": -5.83,
              "z": 0.765
            },
            "rightCorner": {
              "x": 9.168,
              "y": -5.887,
              "z": 0.765
            },
            "gtin": "4008491105385",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a4e",
            "leftCorner": {
              "x": 9.168,
              "y": -5.887,
              "z": 0.765
            },
            "rightCorner": {
              "x": 9.209,
              "y": -5.922,
              "z": 0.765
            },
            "gtin": "4009932131604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a4f",
            "leftCorner": {
              "x": 9.209,
              "y": -5.922,
              "z": 0.765
            },
            "rightCorner": {
              "x": 9.282,
              "y": -5.985,
              "z": 0.765
            },
            "gtin": "4009932131604",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b3b",
        "height": 0.97882,
        "facings": [
          {
            "id": "696ebf7043c343680a2719be",
            "leftCorner": {
              "x": 8.541,
              "y": -5.347,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.591,
              "y": -5.39,
              "z": 0.979
            },
            "gtin": "4008491122047",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719bf",
            "leftCorner": {
              "x": 8.591,
              "y": -5.39,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.656,
              "y": -5.446,
              "z": 0.979
            },
            "gtin": "4009932136616",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719c0",
            "leftCorner": {
              "x": 8.656,
              "y": -5.446,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.729,
              "y": -5.509,
              "z": 0.979
            },
            "gtin": "4026600533614",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719c1",
            "leftCorner": {
              "x": 8.729,
              "y": -5.509,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.79,
              "y": -5.561,
              "z": 0.979
            },
            "gtin": "4058172937200",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719c2",
            "leftCorner": {
              "x": 8.79,
              "y": -5.561,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.856,
              "y": -5.619,
              "z": 0.979
            },
            "gtin": "4009932134605",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719c3",
            "leftCorner": {
              "x": 8.856,
              "y": -5.619,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.914,
              "y": -5.668,
              "z": 0.979
            },
            "gtin": "4009932008999",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719c4",
            "leftCorner": {
              "x": 8.914,
              "y": -5.668,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.969,
              "y": -5.716,
              "z": 0.979
            },
            "gtin": "4009932002645",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719c5",
            "leftCorner": {
              "x": 8.969,
              "y": -5.716,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.03,
              "y": -5.768,
              "z": 0.979
            },
            "gtin": "4003087445807",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719c6",
            "leftCorner": {
              "x": 9.03,
              "y": -5.768,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.092,
              "y": -5.821,
              "z": 0.979
            },
            "gtin": "4003087445807",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719c7",
            "leftCorner": {
              "x": 9.092,
              "y": -5.821,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.149,
              "y": -5.87,
              "z": 0.979
            },
            "gtin": "4003087442257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2719c8",
            "leftCorner": {
              "x": 9.149,
              "y": -5.87,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.211,
              "y": -5.924,
              "z": 0.979
            },
            "gtin": "4008233179674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2719c9",
            "leftCorner": {
              "x": 9.211,
              "y": -5.924,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.291,
              "y": -5.992,
              "z": 0.979
            },
            "gtin": "4036581583737",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b3a",
        "height": 1.1912,
        "facings": [
          {
            "id": "696ebf7043c343680a27189a",
            "leftCorner": {
              "x": 8.522,
              "y": -5.334,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.584,
              "y": -5.388,
              "z": 1.191
            },
            "gtin": "4262393840502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27189b",
            "leftCorner": {
              "x": 8.562,
              "y": -5.366,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.626,
              "y": -5.421,
              "z": 1.191
            },
            "gtin": "2050000040764",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27189c",
            "leftCorner": {
              "x": 8.626,
              "y": -5.421,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.678,
              "y": -5.465,
              "z": 1.191
            },
            "gtin": "4008233177007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27189d",
            "leftCorner": {
              "x": 8.678,
              "y": -5.465,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.727,
              "y": -5.508,
              "z": 1.191
            },
            "gtin": "4008233177007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27189e",
            "leftCorner": {
              "x": 8.727,
              "y": -5.508,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.801,
              "y": -5.571,
              "z": 1.191
            },
            "gtin": "4058172101410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27189f",
            "leftCorner": {
              "x": 8.801,
              "y": -5.571,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.845,
              "y": -5.609,
              "z": 1.191
            },
            "gtin": "4058172101410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718a0",
            "leftCorner": {
              "x": 8.845,
              "y": -5.609,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.891,
              "y": -5.649,
              "z": 1.191
            }
          },
          {
            "id": "696ebf7043c343680a2718a1",
            "leftCorner": {
              "x": 8.891,
              "y": -5.649,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.91,
              "y": -5.666,
              "z": 1.191
            }
          },
          {
            "id": "696ebf7043c343680a2718a2",
            "leftCorner": {
              "x": 8.91,
              "y": -5.666,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.966,
              "y": -5.713,
              "z": 1.191
            },
            "gtin": "4066447788464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2718a3",
            "leftCorner": {
              "x": 8.966,
              "y": -5.713,
              "z": 1.191
            },
            "rightCorner": {
              "x": 9.027,
              "y": -5.766,
              "z": 1.191
            }
          },
          {
            "id": "696ebf7043c343680a2718a4",
            "leftCorner": {
              "x": 9.027,
              "y": -5.766,
              "z": 1.191
            },
            "rightCorner": {
              "x": 9.083,
              "y": -5.814,
              "z": 1.191
            },
            "gtin": "4058172922190",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718a5",
            "leftCorner": {
              "x": 9.083,
              "y": -5.814,
              "z": 1.191
            },
            "rightCorner": {
              "x": 9.143,
              "y": -5.866,
              "z": 1.191
            },
            "gtin": "4066447249132",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718a6",
            "leftCorner": {
              "x": 9.143,
              "y": -5.866,
              "z": 1.191
            },
            "rightCorner": {
              "x": 9.214,
              "y": -5.927,
              "z": 1.191
            },
            "gtin": "4066447249132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2718a7",
            "leftCorner": {
              "x": 9.214,
              "y": -5.927,
              "z": 1.191
            },
            "rightCorner": {
              "x": 9.251,
              "y": -5.959,
              "z": 1.191
            },
            "gtin": "4058172694493",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718a8",
            "leftCorner": {
              "x": 9.251,
              "y": -5.959,
              "z": 1.191
            },
            "rightCorner": {
              "x": 9.321,
              "y": -6.019,
              "z": 1.191
            },
            "gtin": "4058172694493",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b39",
        "height": 1.3596,
        "facings": [
          {
            "id": "696ebf7043c343680a271979",
            "leftCorner": {
              "x": 8.495,
              "y": -5.306,
              "z": 1.36
            },
            "rightCorner": {
              "x": 8.62,
              "y": -5.415,
              "z": 1.36
            },
            "gtin": "4003087448556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27197a",
            "leftCorner": {
              "x": 8.62,
              "y": -5.415,
              "z": 1.36
            },
            "rightCorner": {
              "x": 8.691,
              "y": -5.475,
              "z": 1.36
            },
            "gtin": "4008617173960",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27197b",
            "leftCorner": {
              "x": 8.691,
              "y": -5.475,
              "z": 1.36
            },
            "rightCorner": {
              "x": 8.76,
              "y": -5.535,
              "z": 1.36
            },
            "gtin": "4008617008170",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27197c",
            "leftCorner": {
              "x": 8.76,
              "y": -5.535,
              "z": 1.36
            },
            "rightCorner": {
              "x": 8.835,
              "y": -5.599,
              "z": 1.36
            },
            "gtin": "4008617015604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27197d",
            "leftCorner": {
              "x": 8.835,
              "y": -5.599,
              "z": 1.36
            },
            "rightCorner": {
              "x": 8.901,
              "y": -5.656,
              "z": 1.36
            },
            "gtin": "4008617011859",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27197e",
            "leftCorner": {
              "x": 8.901,
              "y": -5.656,
              "z": 1.36
            },
            "rightCorner": {
              "x": 8.963,
              "y": -5.709,
              "z": 1.36
            },
            "gtin": "4008617036333",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27197f",
            "leftCorner": {
              "x": 8.963,
              "y": -5.709,
              "z": 1.36
            },
            "rightCorner": {
              "x": 9.022,
              "y": -5.76,
              "z": 1.36
            },
            "gtin": "4058172922114",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271980",
            "leftCorner": {
              "x": 9.022,
              "y": -5.76,
              "z": 1.36
            },
            "rightCorner": {
              "x": 9.086,
              "y": -5.815,
              "z": 1.36
            },
            "gtin": "4058172309335",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271981",
            "leftCorner": {
              "x": 9.086,
              "y": -5.815,
              "z": 1.36
            },
            "rightCorner": {
              "x": 9.153,
              "y": -5.873,
              "z": 1.36
            },
            "gtin": "4066447412758",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271982",
            "leftCorner": {
              "x": 9.153,
              "y": -5.873,
              "z": 1.36
            },
            "rightCorner": {
              "x": 9.21,
              "y": -5.922,
              "z": 1.36
            },
            "gtin": "4058172922176",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271983",
            "leftCorner": {
              "x": 9.21,
              "y": -5.922,
              "z": 1.36
            },
            "rightCorner": {
              "x": 9.256,
              "y": -5.961,
              "z": 1.36
            },
            "gtin": "4260159457223",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b3e",
        "height": 1.5681,
        "facings": [
          {
            "id": "696ebf7043c343680a2718e3",
            "leftCorner": {
              "x": 8.495,
              "y": -5.306,
              "z": 1.568
            },
            "rightCorner": {
              "x": 8.535,
              "y": -5.341,
              "z": 1.568
            },
            "gtin": "4009932131291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2718e4",
            "leftCorner": {
              "x": 8.535,
              "y": -5.341,
              "z": 1.568
            },
            "rightCorner": {
              "x": 8.585,
              "y": -5.384,
              "z": 1.568
            },
            "gtin": "4009932131291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2718e5",
            "leftCorner": {
              "x": 8.585,
              "y": -5.384,
              "z": 1.568
            },
            "rightCorner": {
              "x": 8.653,
              "y": -5.443,
              "z": 1.568
            },
            "gtin": "4008491114622",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718e6",
            "leftCorner": {
              "x": 8.653,
              "y": -5.443,
              "z": 1.568
            },
            "rightCorner": {
              "x": 8.718,
              "y": -5.498,
              "z": 1.568
            },
            "gtin": "4008491114622",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718e7",
            "leftCorner": {
              "x": 8.718,
              "y": -5.498,
              "z": 1.568
            },
            "rightCorner": {
              "x": 8.789,
              "y": -5.559,
              "z": 1.568
            },
            "gtin": "4008491276290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718e8",
            "leftCorner": {
              "x": 8.789,
              "y": -5.559,
              "z": 1.568
            },
            "rightCorner": {
              "x": 8.855,
              "y": -5.616,
              "z": 1.568
            },
            "gtin": "4008491101905",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718e9",
            "leftCorner": {
              "x": 8.855,
              "y": -5.616,
              "z": 1.568
            },
            "rightCorner": {
              "x": 8.911,
              "y": -5.664,
              "z": 1.568
            },
            "gtin": "4008491131940",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718ea",
            "leftCorner": {
              "x": 8.911,
              "y": -5.664,
              "z": 1.568
            },
            "rightCorner": {
              "x": 8.965,
              "y": -5.711,
              "z": 1.568
            },
            "gtin": "4008491110921",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718eb",
            "leftCorner": {
              "x": 8.965,
              "y": -5.711,
              "z": 1.568
            },
            "rightCorner": {
              "x": 9.031,
              "y": -5.767,
              "z": 1.568
            },
            "gtin": "4250752206533",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718ec",
            "leftCorner": {
              "x": 9.031,
              "y": -5.767,
              "z": 1.568
            },
            "rightCorner": {
              "x": 9.089,
              "y": -5.818,
              "z": 1.568
            },
            "gtin": "4250752204867",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718ed",
            "leftCorner": {
              "x": 9.089,
              "y": -5.818,
              "z": 1.568
            },
            "rightCorner": {
              "x": 9.173,
              "y": -5.889,
              "z": 1.568
            },
            "gtin": "4009932008463",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718ee",
            "leftCorner": {
              "x": 9.173,
              "y": -5.889,
              "z": 1.568
            },
            "rightCorner": {
              "x": 9.23,
              "y": -5.939,
              "z": 1.568
            },
            "gtin": "4058172937057",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718ef",
            "leftCorner": {
              "x": 9.23,
              "y": -5.939,
              "z": 1.568
            },
            "rightCorner": {
              "x": 9.254,
              "y": -5.959,
              "z": 1.568
            },
            "gtin": "8588009456599",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718f0",
            "leftCorner": {
              "x": 9.254,
              "y": -5.959,
              "z": 1.568
            },
            "rightCorner": {
              "x": 9.326,
              "y": -6.021,
              "z": 1.568
            },
            "gtin": "8588009456599",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b38",
        "height": 1.778,
        "facings": [
          {
            "id": "696ebf7043c343680a27192a",
            "leftCorner": {
              "x": 8.512,
              "y": -5.329,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.6,
              "y": -5.405,
              "z": 1.778
            },
            "gtin": "4009932133127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27192b",
            "leftCorner": {
              "x": 8.579,
              "y": -5.382,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.634,
              "y": -5.429,
              "z": 1.778
            },
            "gtin": "4009932001990",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27192c",
            "leftCorner": {
              "x": 8.634,
              "y": -5.429,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.654,
              "y": -5.446,
              "z": 1.778
            }
          },
          {
            "id": "696ebf7043c343680a27192d",
            "leftCorner": {
              "x": 8.654,
              "y": -5.446,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.706,
              "y": -5.491,
              "z": 1.778
            },
            "gtin": "4009932001891",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27192e",
            "leftCorner": {
              "x": 8.706,
              "y": -5.491,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.774,
              "y": -5.549,
              "z": 1.778
            },
            "gtin": "4009932004731",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27192f",
            "leftCorner": {
              "x": 8.774,
              "y": -5.549,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.839,
              "y": -5.605,
              "z": 1.778
            },
            "gtin": "4009932002560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271930",
            "leftCorner": {
              "x": 8.839,
              "y": -5.605,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.894,
              "y": -5.653,
              "z": 1.778
            },
            "gtin": "4009932135206",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271931",
            "leftCorner": {
              "x": 8.894,
              "y": -5.653,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.951,
              "y": -5.701,
              "z": 1.778
            },
            "gtin": "4009932131376",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271932",
            "leftCorner": {
              "x": 8.951,
              "y": -5.701,
              "z": 1.778
            },
            "rightCorner": {
              "x": 9.013,
              "y": -5.755,
              "z": 1.778
            },
            "gtin": "4009932137026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271933",
            "leftCorner": {
              "x": 9.013,
              "y": -5.755,
              "z": 1.778
            },
            "rightCorner": {
              "x": 9.075,
              "y": -5.808,
              "z": 1.778
            },
            "gtin": "4009932134926",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271934",
            "leftCorner": {
              "x": 9.075,
              "y": -5.808,
              "z": 1.778
            },
            "rightCorner": {
              "x": 9.141,
              "y": -5.865,
              "z": 1.778
            },
            "gtin": "4009932007084",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271935",
            "leftCorner": {
              "x": 9.141,
              "y": -5.865,
              "z": 1.778
            },
            "rightCorner": {
              "x": 9.2,
              "y": -5.915,
              "z": 1.778
            },
            "gtin": "4009932132243",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271936",
            "leftCorner": {
              "x": 9.2,
              "y": -5.915,
              "z": 1.778
            },
            "rightCorner": {
              "x": 9.284,
              "y": -5.987,
              "z": 1.778
            },
            "gtin": "4009932001983",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7575bb5fe7bc0469599ab",
    "name": "68e7575bb5fe7bc0469599ab",
    "x": 9.2549,
    "y": -5.913,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.36179,
      "w": 0.93226
    },
    "statistics": {
      "hasStockCount": 57,
      "noStockCount": 3,
      "unknownStockCount": 8
    },
    "layers": [
      {
        "id": "696ead8d3b88e258afd73b46",
        "height": 0.3039,
        "facings": [
          {
            "id": "696ebf7043c343680a271a85",
            "leftCorner": {
              "x": 9.157,
              "y": -6.049,
              "z": 0.304
            },
            "rightCorner": {
              "x": 9.881,
              "y": -6.71,
              "z": 0.304
            },
            "gtin": "4058172310232",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b45",
        "height": 0.5168,
        "facings": [
          {
            "id": "696ebf7043c343680a271a70",
            "leftCorner": {
              "x": 9.246,
              "y": -5.961,
              "z": 0.514
            },
            "rightCorner": {
              "x": 9.316,
              "y": -6.021,
              "z": 0.514
            },
            "gtin": "4066447249163",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a71",
            "leftCorner": {
              "x": 9.294,
              "y": -6.002,
              "z": 0.517
            },
            "rightCorner": {
              "x": 9.344,
              "y": -6.048,
              "z": 0.517
            },
            "gtin": "4066447249163",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a72",
            "leftCorner": {
              "x": 9.344,
              "y": -6.048,
              "z": 0.517
            },
            "rightCorner": {
              "x": 9.409,
              "y": -6.107,
              "z": 0.517
            },
            "gtin": "4058172695797",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a73",
            "leftCorner": {
              "x": 9.409,
              "y": -6.107,
              "z": 0.517
            },
            "rightCorner": {
              "x": 9.465,
              "y": -6.158,
              "z": 0.517
            },
            "gtin": "4058172922039",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a74",
            "leftCorner": {
              "x": 9.465,
              "y": -6.158,
              "z": 0.517
            },
            "rightCorner": {
              "x": 9.54,
              "y": -6.227,
              "z": 0.517
            },
            "gtin": "4008617140177",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a75",
            "leftCorner": {
              "x": 9.54,
              "y": -6.227,
              "z": 0.517
            },
            "rightCorner": {
              "x": 9.645,
              "y": -6.323,
              "z": 0.517
            },
            "gtin": "4008491110341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a76",
            "leftCorner": {
              "x": 9.645,
              "y": -6.323,
              "z": 0.517
            },
            "rightCorner": {
              "x": 9.75,
              "y": -6.419,
              "z": 0.517
            },
            "gtin": "4008617042587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a77",
            "leftCorner": {
              "x": 9.75,
              "y": -6.419,
              "z": 0.517
            },
            "rightCorner": {
              "x": 9.804,
              "y": -6.468,
              "z": 0.517
            },
            "gtin": "4250752205154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a78",
            "leftCorner": {
              "x": 9.804,
              "y": -6.468,
              "z": 0.517
            },
            "rightCorner": {
              "x": 9.854,
              "y": -6.514,
              "z": 0.517
            },
            "gtin": "4009932131888",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a79",
            "leftCorner": {
              "x": 9.854,
              "y": -6.514,
              "z": 0.517
            },
            "rightCorner": {
              "x": 9.916,
              "y": -6.571,
              "z": 0.517
            },
            "gtin": "4009932133431",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a7a",
            "leftCorner": {
              "x": 9.916,
              "y": -6.571,
              "z": 0.517
            },
            "rightCorner": {
              "x": 9.971,
              "y": -6.621,
              "z": 0.517
            },
            "gtin": "4008617880523",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b42",
        "height": 0.76746,
        "facings": [
          {
            "id": "696ebf7043c343680a271a50",
            "leftCorner": {
              "x": 9.26,
              "y": -5.966,
              "z": 0.767
            },
            "rightCorner": {
              "x": 9.325,
              "y": -6.025,
              "z": 0.767
            },
            "gtin": "4009932134483",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a51",
            "leftCorner": {
              "x": 9.325,
              "y": -6.025,
              "z": 0.767
            },
            "rightCorner": {
              "x": 9.393,
              "y": -6.088,
              "z": 0.767
            },
            "gtin": "4066447219319",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a52",
            "leftCorner": {
              "x": 9.393,
              "y": -6.088,
              "z": 0.767
            },
            "rightCorner": {
              "x": 9.454,
              "y": -6.143,
              "z": 0.767
            },
            "gtin": "4066447336986",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a53",
            "leftCorner": {
              "x": 9.454,
              "y": -6.143,
              "z": 0.767
            },
            "rightCorner": {
              "x": 9.515,
              "y": -6.199,
              "z": 0.767
            },
            "gtin": "4003087422150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a54",
            "leftCorner": {
              "x": 9.515,
              "y": -6.199,
              "z": 0.767
            },
            "rightCorner": {
              "x": 9.599,
              "y": -6.276,
              "z": 0.767
            },
            "gtin": "4066447880755",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a55",
            "leftCorner": {
              "x": 9.599,
              "y": -6.276,
              "z": 0.767
            },
            "rightCorner": {
              "x": 9.673,
              "y": -6.343,
              "z": 0.767
            },
            "gtin": "4003087444602",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a56",
            "leftCorner": {
              "x": 9.673,
              "y": -6.343,
              "z": 0.767
            },
            "rightCorner": {
              "x": 9.759,
              "y": -6.422,
              "z": 0.767
            },
            "gtin": "4008617742630",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a57",
            "leftCorner": {
              "x": 9.759,
              "y": -6.422,
              "z": 0.767
            },
            "rightCorner": {
              "x": 9.9,
              "y": -6.551,
              "z": 0.767
            },
            "gtin": "4008491108409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a58",
            "leftCorner": {
              "x": 9.9,
              "y": -6.551,
              "z": 0.767
            },
            "rightCorner": {
              "x": 9.969,
              "y": -6.614,
              "z": 0.767
            },
            "gtin": "4009932133394",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b43",
        "height": 0.97941,
        "facings": [
          {
            "id": "696ebf7043c343680a2719ca",
            "leftCorner": {
              "x": 9.268,
              "y": -5.974,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.318,
              "y": -6.019,
              "z": 0.979
            },
            "gtin": "4260613230027",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719cb",
            "leftCorner": {
              "x": 9.318,
              "y": -6.019,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.38,
              "y": -6.076,
              "z": 0.979
            },
            "gtin": "4255707873501",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719cc",
            "leftCorner": {
              "x": 9.38,
              "y": -6.076,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.457,
              "y": -6.146,
              "z": 0.979
            },
            "gtin": "4058172695940",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719cd",
            "leftCorner": {
              "x": 9.457,
              "y": -6.146,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.53,
              "y": -6.213,
              "z": 0.979
            },
            "gtin": "4008617040644",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719ce",
            "leftCorner": {
              "x": 9.53,
              "y": -6.213,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.644,
              "y": -6.317,
              "z": 0.979
            },
            "gtin": "4009932138382",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719cf",
            "leftCorner": {
              "x": 9.644,
              "y": -6.317,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.745,
              "y": -6.41,
              "z": 0.979
            },
            "gtin": "4250752201057",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719d0",
            "leftCorner": {
              "x": 9.745,
              "y": -6.41,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.807,
              "y": -6.467,
              "z": 0.979
            },
            "gtin": "4008491276528",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719d1",
            "leftCorner": {
              "x": 9.807,
              "y": -6.467,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.861,
              "y": -6.516,
              "z": 0.979
            },
            "gtin": "4009932004533",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719d2",
            "leftCorner": {
              "x": 9.861,
              "y": -6.516,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.925,
              "y": -6.574,
              "z": 0.979
            },
            "gtin": "4250752203990",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719d3",
            "leftCorner": {
              "x": 9.925,
              "y": -6.574,
              "z": 0.979
            },
            "rightCorner": {
              "x": 9.983,
              "y": -6.627,
              "z": 0.979
            },
            "gtin": "4260639690072",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b44",
        "height": 1.1947,
        "facings": [
          {
            "id": "696ebf7043c343680a2718a9",
            "leftCorner": {
              "x": 9.297,
              "y": -6.003,
              "z": 1.195
            },
            "rightCorner": {
              "x": 9.34,
              "y": -6.043,
              "z": 1.195
            }
          },
          {
            "id": "696ebf7043c343680a2718aa",
            "leftCorner": {
              "x": 9.34,
              "y": -6.043,
              "z": 1.195
            },
            "rightCorner": {
              "x": 9.41,
              "y": -6.106,
              "z": 1.195
            },
            "gtin": "4009932002546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718ab",
            "leftCorner": {
              "x": 9.41,
              "y": -6.106,
              "z": 1.195
            },
            "rightCorner": {
              "x": 9.494,
              "y": -6.183,
              "z": 1.195
            },
            "gtin": "4003087410157",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718ac",
            "leftCorner": {
              "x": 9.494,
              "y": -6.183,
              "z": 1.195
            },
            "rightCorner": {
              "x": 9.559,
              "y": -6.242,
              "z": 1.195
            },
            "gtin": "4008491117050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718ad",
            "leftCorner": {
              "x": 9.559,
              "y": -6.242,
              "z": 1.195
            },
            "rightCorner": {
              "x": 9.622,
              "y": -6.3,
              "z": 1.195
            },
            "gtin": "4008491119771",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718ae",
            "leftCorner": {
              "x": 9.622,
              "y": -6.3,
              "z": 1.195
            },
            "rightCorner": {
              "x": 9.706,
              "y": -6.377,
              "z": 1.195
            },
            "gtin": "4008491112901",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718af",
            "leftCorner": {
              "x": 9.706,
              "y": -6.377,
              "z": 1.195
            },
            "rightCorner": {
              "x": 9.86,
              "y": -6.517,
              "z": 1.195
            },
            "gtin": "4009932135589",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718b0",
            "leftCorner": {
              "x": 9.86,
              "y": -6.517,
              "z": 1.195
            },
            "rightCorner": {
              "x": 9.968,
              "y": -6.616,
              "z": 1.195
            },
            "gtin": "4058172922053",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b41",
        "height": 1.3631,
        "facings": [
          {
            "id": "696ebf7043c343680a271984",
            "leftCorner": {
              "x": 9.256,
              "y": -5.961,
              "z": 1.36
            },
            "rightCorner": {
              "x": 9.34,
              "y": -6.033,
              "z": 1.36
            },
            "gtin": "4058172694271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271985",
            "leftCorner": {
              "x": 9.316,
              "y": -6.016,
              "z": 1.363
            },
            "rightCorner": {
              "x": 9.383,
              "y": -6.077,
              "z": 1.363
            },
            "gtin": "4058172921919",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271986",
            "leftCorner": {
              "x": 9.383,
              "y": -6.077,
              "z": 1.363
            },
            "rightCorner": {
              "x": 9.446,
              "y": -6.135,
              "z": 1.363
            },
            "gtin": "4058172936999",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271987",
            "leftCorner": {
              "x": 9.446,
              "y": -6.135,
              "z": 1.363
            },
            "rightCorner": {
              "x": 9.507,
              "y": -6.191,
              "z": 1.363
            },
            "gtin": "4066447015072",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271988",
            "leftCorner": {
              "x": 9.507,
              "y": -6.191,
              "z": 1.363
            },
            "rightCorner": {
              "x": 9.586,
              "y": -6.262,
              "z": 1.363
            },
            "gtin": "4008617027751",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271989",
            "leftCorner": {
              "x": 9.586,
              "y": -6.262,
              "z": 1.363
            },
            "rightCorner": {
              "x": 9.664,
              "y": -6.334,
              "z": 1.363
            },
            "gtin": "4008617037125",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27198a",
            "leftCorner": {
              "x": 9.664,
              "y": -6.334,
              "z": 1.363
            },
            "rightCorner": {
              "x": 9.733,
              "y": -6.397,
              "z": 1.363
            },
            "gtin": "4008491105187",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27198b",
            "leftCorner": {
              "x": 9.733,
              "y": -6.397,
              "z": 1.363
            },
            "rightCorner": {
              "x": 9.79,
              "y": -6.45,
              "z": 1.363
            },
            "gtin": "4003087449454",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27198c",
            "leftCorner": {
              "x": 9.79,
              "y": -6.45,
              "z": 1.363
            },
            "rightCorner": {
              "x": 9.811,
              "y": -6.469,
              "z": 1.363
            },
            "gtin": "4009932134919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a27198d",
            "leftCorner": {
              "x": 9.811,
              "y": -6.469,
              "z": 1.363
            },
            "rightCorner": {
              "x": 9.84,
              "y": -6.495,
              "z": 1.363
            },
            "gtin": "4009932134919",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27198e",
            "leftCorner": {
              "x": 9.84,
              "y": -6.495,
              "z": 1.363
            },
            "rightCorner": {
              "x": 9.903,
              "y": -6.552,
              "z": 1.363
            },
            "gtin": "4009932135565",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27198f",
            "leftCorner": {
              "x": 9.903,
              "y": -6.552,
              "z": 1.363
            },
            "rightCorner": {
              "x": 9.973,
              "y": -6.616,
              "z": 1.363
            },
            "gtin": "4008617011668",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b3f",
        "height": 1.5735,
        "facings": [
          {
            "id": "696ebf7043c343680a2718f1",
            "leftCorner": {
              "x": 9.302,
              "y": -6.004,
              "z": 1.574
            },
            "rightCorner": {
              "x": 9.368,
              "y": -6.065,
              "z": 1.574
            },
            "gtin": "4003087449355",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718f2",
            "leftCorner": {
              "x": 9.368,
              "y": -6.065,
              "z": 1.574
            },
            "rightCorner": {
              "x": 9.438,
              "y": -6.129,
              "z": 1.574
            },
            "gtin": "4003087410850",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718f3",
            "leftCorner": {
              "x": 9.438,
              "y": -6.129,
              "z": 1.574
            },
            "rightCorner": {
              "x": 9.511,
              "y": -6.195,
              "z": 1.574
            },
            "gtin": "4003573488486",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718f4",
            "leftCorner": {
              "x": 9.511,
              "y": -6.195,
              "z": 1.574
            },
            "rightCorner": {
              "x": 9.641,
              "y": -6.314,
              "z": 1.574
            },
            "gtin": "4008617007975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2718f5",
            "leftCorner": {
              "x": 9.641,
              "y": -6.314,
              "z": 1.574
            },
            "rightCorner": {
              "x": 9.761,
              "y": -6.424,
              "z": 1.574
            },
            "gtin": "4066447412789",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718f6",
            "leftCorner": {
              "x": 9.761,
              "y": -6.424,
              "z": 1.574
            },
            "rightCorner": {
              "x": 9.877,
              "y": -6.53,
              "z": 1.574
            },
            "gtin": "4067796079012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718f7",
            "leftCorner": {
              "x": 9.877,
              "y": -6.53,
              "z": 1.574
            },
            "rightCorner": {
              "x": 9.98,
              "y": -6.624,
              "z": 1.574
            },
            "gtin": "4066447248746",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b40",
        "height": 1.7808,
        "facings": [
          {
            "id": "696ebf7043c343680a271937",
            "leftCorner": {
              "x": 9.262,
              "y": -5.968,
              "z": 1.781
            },
            "rightCorner": {
              "x": 9.317,
              "y": -6.018,
              "z": 1.781
            },
            "gtin": "4009932008937",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271938",
            "leftCorner": {
              "x": 9.317,
              "y": -6.018,
              "z": 1.781
            },
            "rightCorner": {
              "x": 9.362,
              "y": -6.059,
              "z": 1.781
            },
            "gtin": "4008617260202",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271939",
            "leftCorner": {
              "x": 9.362,
              "y": -6.059,
              "z": 1.781
            },
            "rightCorner": {
              "x": 9.449,
              "y": -6.138,
              "z": 1.781
            },
            "gtin": "4008617133957",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27193a",
            "leftCorner": {
              "x": 9.449,
              "y": -6.138,
              "z": 1.781
            },
            "rightCorner": {
              "x": 9.524,
              "y": -6.208,
              "z": 1.781
            },
            "gtin": "4008617133919",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a27193b",
            "leftCorner": {
              "x": 9.524,
              "y": -6.208,
              "z": 1.781
            },
            "rightCorner": {
              "x": 9.607,
              "y": -6.283,
              "z": 1.781
            },
            "gtin": "4009932131406",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27193c",
            "leftCorner": {
              "x": 9.607,
              "y": -6.283,
              "z": 1.781
            },
            "rightCorner": {
              "x": 9.696,
              "y": -6.365,
              "z": 1.781
            },
            "gtin": "4009932131406",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27193d",
            "leftCorner": {
              "x": 9.696,
              "y": -6.365,
              "z": 1.781
            },
            "rightCorner": {
              "x": 9.756,
              "y": -6.42,
              "z": 1.781
            },
            "gtin": "4058172658204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27193e",
            "leftCorner": {
              "x": 9.756,
              "y": -6.42,
              "z": 1.781
            },
            "rightCorner": {
              "x": 9.823,
              "y": -6.481,
              "z": 1.781
            },
            "gtin": "4066447231731",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27193f",
            "leftCorner": {
              "x": 9.823,
              "y": -6.481,
              "z": 1.781
            },
            "rightCorner": {
              "x": 9.894,
              "y": -6.546,
              "z": 1.781
            },
            "gtin": "4067796171228",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271940",
            "leftCorner": {
              "x": 9.894,
              "y": -6.546,
              "z": 1.781
            },
            "rightCorner": {
              "x": 9.947,
              "y": -6.594,
              "z": 1.781
            },
            "gtin": "4009932135404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271941",
            "leftCorner": {
              "x": 9.941,
              "y": -6.618,
              "z": 1.783
            },
            "rightCorner": {
              "x": 9.98,
              "y": -6.654,
              "z": 1.783
            },
            "gtin": "5010724538623",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7575bb5fe7bc0469599ac",
    "name": "68e7575bb5fe7bc0469599ac",
    "x": 9.9344,
    "y": -6.6698,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.35386,
      "w": 0.9353
    },
    "statistics": {
      "hasStockCount": 53,
      "noStockCount": 5,
      "unknownStockCount": 28
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73b4d",
        "height": 0.51802,
        "facings": [
          {
            "id": "696ebf7043c343680a271a7c",
            "leftCorner": {
              "x": 10.045,
              "y": -6.702,
              "z": 0.518
            },
            "rightCorner": {
              "x": 10.099,
              "y": -6.749,
              "z": 0.518
            }
          },
          {
            "id": "696ebf7043c343680a271a7b",
            "leftCorner": {
              "x": 9.972,
              "y": -6.637,
              "z": 0.518
            },
            "rightCorner": {
              "x": 10.045,
              "y": -6.702,
              "z": 0.518
            },
            "gtin": "4066447714425",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a7d",
            "leftCorner": {
              "x": 10.099,
              "y": -6.749,
              "z": 0.518
            },
            "rightCorner": {
              "x": 10.207,
              "y": -6.845,
              "z": 0.518
            },
            "gtin": "4066447518610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a7e",
            "leftCorner": {
              "x": 10.207,
              "y": -6.845,
              "z": 0.518
            },
            "rightCorner": {
              "x": 10.296,
              "y": -6.923,
              "z": 0.518
            },
            "gtin": "4008617131113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a7f",
            "leftCorner": {
              "x": 10.296,
              "y": -6.923,
              "z": 0.518
            },
            "rightCorner": {
              "x": 10.348,
              "y": -6.969,
              "z": 0.518
            },
            "gtin": "4008491112581",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a80",
            "leftCorner": {
              "x": 10.348,
              "y": -6.969,
              "z": 0.518
            },
            "rightCorner": {
              "x": 10.392,
              "y": -7.008,
              "z": 0.518
            },
            "gtin": "4008491111928",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a81",
            "leftCorner": {
              "x": 10.392,
              "y": -7.008,
              "z": 0.518
            },
            "rightCorner": {
              "x": 10.437,
              "y": -7.048,
              "z": 0.518
            },
            "gtin": "4008491223362",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a82",
            "leftCorner": {
              "x": 10.437,
              "y": -7.048,
              "z": 0.518
            },
            "rightCorner": {
              "x": 10.481,
              "y": -7.087,
              "z": 0.518
            },
            "gtin": "4008491223362",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a83",
            "leftCorner": {
              "x": 10.481,
              "y": -7.087,
              "z": 0.518
            },
            "rightCorner": {
              "x": 10.526,
              "y": -7.126,
              "z": 0.518
            },
            "gtin": "4008491223362",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a84",
            "leftCorner": {
              "x": 10.526,
              "y": -7.126,
              "z": 0.518
            },
            "rightCorner": {
              "x": 10.619,
              "y": -7.209,
              "z": 0.518
            },
            "gtin": "4008617405214",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a64",
            "leftCorner": {
              "x": 10.619,
              "y": -7.209,
              "z": 0.518
            },
            "rightCorner": {
              "x": 10.717,
              "y": -7.295,
              "z": 0.518
            },
            "gtin": "4008617136675",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b4e",
        "height": 0.21076,
        "facings": [
          {
            "id": "696ebf7043c343680a271a86",
            "leftCorner": {
              "x": 9.904,
              "y": -6.704,
              "z": 0.211
            },
            "rightCorner": {
              "x": 9.959,
              "y": -6.752,
              "z": 0.211
            },
            "gtin": "4058172695643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a88",
            "leftCorner": {
              "x": 9.959,
              "y": -6.752,
              "z": 0.211
            },
            "rightCorner": {
              "x": 10.018,
              "y": -6.804,
              "z": 0.211
            },
            "gtin": "4015588545900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a89",
            "leftCorner": {
              "x": 10.018,
              "y": -6.804,
              "z": 0.211
            },
            "rightCorner": {
              "x": 10.109,
              "y": -6.884,
              "z": 0.211
            },
            "gtin": "4022167130150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a8a",
            "leftCorner": {
              "x": 10.109,
              "y": -6.884,
              "z": 0.211
            },
            "rightCorner": {
              "x": 10.128,
              "y": -6.902,
              "z": 0.211
            },
            "gtin": "4022167700094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a8b",
            "leftCorner": {
              "x": 10.128,
              "y": -6.902,
              "z": 0.211
            },
            "rightCorner": {
              "x": 10.187,
              "y": -6.954,
              "z": 0.211
            },
            "gtin": "4022167700094",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a8c",
            "leftCorner": {
              "x": 10.187,
              "y": -6.954,
              "z": 0.211
            },
            "rightCorner": {
              "x": 10.243,
              "y": -7.003,
              "z": 0.211
            },
            "gtin": "4015600141004",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a8d",
            "leftCorner": {
              "x": 10.243,
              "y": -7.003,
              "z": 0.211
            },
            "rightCorner": {
              "x": 10.277,
              "y": -7.033,
              "z": 0.211
            },
            "gtin": "5410076765812",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a8e",
            "leftCorner": {
              "x": 10.277,
              "y": -7.033,
              "z": 0.211
            },
            "rightCorner": {
              "x": 10.303,
              "y": -7.055,
              "z": 0.211
            },
            "gtin": "4006309035015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a8f",
            "leftCorner": {
              "x": 10.303,
              "y": -7.055,
              "z": 0.211
            },
            "rightCorner": {
              "x": 10.365,
              "y": -7.11,
              "z": 0.211
            },
            "gtin": "4008617136651",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a90",
            "leftCorner": {
              "x": 10.365,
              "y": -7.11,
              "z": 0.211
            },
            "rightCorner": {
              "x": 10.441,
              "y": -7.178,
              "z": 0.211
            },
            "gtin": "4009932006612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a91",
            "leftCorner": {
              "x": 10.441,
              "y": -7.178,
              "z": 0.211
            },
            "rightCorner": {
              "x": 10.478,
              "y": -7.21,
              "z": 0.211
            },
            "gtin": "4008233181042",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a92",
            "leftCorner": {
              "x": 10.478,
              "y": -7.21,
              "z": 0.211
            },
            "rightCorner": {
              "x": 10.522,
              "y": -7.249,
              "z": 0.211
            },
            "gtin": "4058172695858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a93",
            "leftCorner": {
              "x": 10.522,
              "y": -7.249,
              "z": 0.211
            },
            "rightCorner": {
              "x": 10.589,
              "y": -7.308,
              "z": 0.211
            },
            "gtin": "4067796107128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a87",
            "leftCorner": {
              "x": 10.589,
              "y": -7.308,
              "z": 0.211
            },
            "rightCorner": {
              "x": 10.654,
              "y": -7.366,
              "z": 0.211
            },
            "gtin": "4066447584585",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b4a",
        "height": 0.76924,
        "facings": [
          {
            "id": "696ebf7043c343680a271a59",
            "leftCorner": {
              "x": 9.984,
              "y": -6.647,
              "z": 0.769
            },
            "rightCorner": {
              "x": 10.043,
              "y": -6.699,
              "z": 0.769
            }
          },
          {
            "id": "696ebf7043c343680a271a5a",
            "leftCorner": {
              "x": 10.043,
              "y": -6.699,
              "z": 0.769
            },
            "rightCorner": {
              "x": 10.143,
              "y": -6.787,
              "z": 0.769
            },
            "gtin": "4058172323881",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a5b",
            "leftCorner": {
              "x": 10.143,
              "y": -6.787,
              "z": 0.769
            },
            "rightCorner": {
              "x": 10.283,
              "y": -6.911,
              "z": 0.769
            },
            "gtin": "4008617136552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a5c",
            "leftCorner": {
              "x": 10.283,
              "y": -6.911,
              "z": 0.769
            },
            "rightCorner": {
              "x": 10.34,
              "y": -6.962,
              "z": 0.769
            },
            "gtin": "2050000040405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a5d",
            "leftCorner": {
              "x": 10.34,
              "y": -6.962,
              "z": 0.769
            },
            "rightCorner": {
              "x": 10.361,
              "y": -6.98,
              "z": 0.769
            }
          },
          {
            "id": "696ebf7043c343680a271a5e",
            "leftCorner": {
              "x": 10.361,
              "y": -6.98,
              "z": 0.769
            },
            "rightCorner": {
              "x": 10.397,
              "y": -7.012,
              "z": 0.769
            },
            "gtin": "4104480465826",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a5f",
            "leftCorner": {
              "x": 10.397,
              "y": -7.012,
              "z": 0.769
            },
            "rightCorner": {
              "x": 10.439,
              "y": -7.049,
              "z": 0.769
            },
            "gtin": "4104480465826",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a60",
            "leftCorner": {
              "x": 10.439,
              "y": -7.049,
              "z": 0.769
            },
            "rightCorner": {
              "x": 10.484,
              "y": -7.089,
              "z": 0.769
            },
            "gtin": "4104480465628",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a61",
            "leftCorner": {
              "x": 10.484,
              "y": -7.089,
              "z": 0.769
            },
            "rightCorner": {
              "x": 10.593,
              "y": -7.185,
              "z": 0.769
            },
            "gtin": "4008491115933",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a62",
            "leftCorner": {
              "x": 10.593,
              "y": -7.185,
              "z": 0.769
            },
            "rightCorner": {
              "x": 10.697,
              "y": -7.277,
              "z": 0.769
            },
            "gtin": "4058172312137",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b4b",
        "height": 0.9829,
        "facings": [
          {
            "id": "696ebf7043c343680a2719d4",
            "leftCorner": {
              "x": 9.983,
              "y": -6.644,
              "z": 0.983
            },
            "rightCorner": {
              "x": 10.028,
              "y": -6.684,
              "z": 0.983
            },
            "gtin": "4083700305275",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719d5",
            "leftCorner": {
              "x": 10.028,
              "y": -6.684,
              "z": 0.983
            },
            "rightCorner": {
              "x": 10.076,
              "y": -6.726,
              "z": 0.983
            },
            "gtin": "4083700305244",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719d6",
            "leftCorner": {
              "x": 10.076,
              "y": -6.726,
              "z": 0.983
            },
            "rightCorner": {
              "x": 10.126,
              "y": -6.77,
              "z": 0.983
            },
            "gtin": "4083700305176",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719d7",
            "leftCorner": {
              "x": 10.126,
              "y": -6.77,
              "z": 0.983
            },
            "rightCorner": {
              "x": 10.154,
              "y": -6.795,
              "z": 0.983
            },
            "gtin": "4008617880585",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719d8",
            "leftCorner": {
              "x": 10.154,
              "y": -6.795,
              "z": 0.983
            },
            "rightCorner": {
              "x": 10.186,
              "y": -6.824,
              "z": 0.983
            },
            "gtin": "4058172695384",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719d9",
            "leftCorner": {
              "x": 10.186,
              "y": -6.824,
              "z": 0.983
            },
            "rightCorner": {
              "x": 10.229,
              "y": -6.861,
              "z": 0.983
            },
            "gtin": "4058172695384",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719da",
            "leftCorner": {
              "x": 10.229,
              "y": -6.861,
              "z": 0.983
            },
            "rightCorner": {
              "x": 10.288,
              "y": -6.913,
              "z": 0.983
            },
            "gtin": "4066447870688",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719db",
            "leftCorner": {
              "x": 10.288,
              "y": -6.913,
              "z": 0.983
            },
            "rightCorner": {
              "x": 10.351,
              "y": -6.969,
              "z": 0.983
            },
            "gtin": "4058172320934",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719dc",
            "leftCorner": {
              "x": 10.351,
              "y": -6.969,
              "z": 0.983
            },
            "rightCorner": {
              "x": 10.414,
              "y": -7.024,
              "z": 0.983
            },
            "gtin": "4008491118712",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719dd",
            "leftCorner": {
              "x": 10.414,
              "y": -7.024,
              "z": 0.983
            },
            "rightCorner": {
              "x": 10.459,
              "y": -7.064,
              "z": 0.983
            },
            "gtin": "4008617880585",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719de",
            "leftCorner": {
              "x": 10.459,
              "y": -7.064,
              "z": 0.983
            },
            "rightCorner": {
              "x": 10.527,
              "y": -7.124,
              "z": 0.983
            },
            "gtin": "4008617134909",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719df",
            "leftCorner": {
              "x": 10.527,
              "y": -7.124,
              "z": 0.983
            },
            "rightCorner": {
              "x": 10.59,
              "y": -7.18,
              "z": 0.983
            },
            "gtin": "4008617137092",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2719e0",
            "leftCorner": {
              "x": 10.59,
              "y": -7.18,
              "z": 0.983
            },
            "rightCorner": {
              "x": 10.654,
              "y": -7.237,
              "z": 0.983
            },
            "gtin": "4008617134220",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27199e",
            "leftCorner": {
              "x": 10.654,
              "y": -7.237,
              "z": 0.983
            },
            "rightCorner": {
              "x": 10.718,
              "y": -7.293,
              "z": 0.983
            },
            "gtin": "4008491115759",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b47",
        "height": 1.1952,
        "facings": [
          {
            "id": "696ebf7043c343680a2718b1",
            "leftCorner": {
              "x": 9.965,
              "y": -6.635,
              "z": 1.195
            },
            "rightCorner": {
              "x": 10.001,
              "y": -6.667,
              "z": 1.195
            }
          },
          {
            "id": "696ebf7043c343680a2718b2",
            "leftCorner": {
              "x": 10.002,
              "y": -6.667,
              "z": 1.195
            },
            "rightCorner": {
              "x": 10.069,
              "y": -6.727,
              "z": 1.195
            },
            "gtin": "4008491116138",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718b3",
            "leftCorner": {
              "x": 10.069,
              "y": -6.727,
              "z": 1.195
            },
            "rightCorner": {
              "x": 10.138,
              "y": -6.787,
              "z": 1.195
            },
            "gtin": "4008491129404",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718b4",
            "leftCorner": {
              "x": 10.138,
              "y": -6.787,
              "z": 1.195
            },
            "rightCorner": {
              "x": 10.162,
              "y": -6.809,
              "z": 1.195
            }
          },
          {
            "id": "696ebf7043c343680a2718b5",
            "leftCorner": {
              "x": 10.162,
              "y": -6.809,
              "z": 1.195
            },
            "rightCorner": {
              "x": 10.216,
              "y": -6.856,
              "z": 1.195
            },
            "gtin": "4011932229335",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718b6",
            "leftCorner": {
              "x": 10.216,
              "y": -6.856,
              "z": 1.195
            },
            "rightCorner": {
              "x": 10.287,
              "y": -6.919,
              "z": 1.195
            },
            "gtin": "4011932229335",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718b7",
            "leftCorner": {
              "x": 10.287,
              "y": -6.919,
              "z": 1.195
            },
            "rightCorner": {
              "x": 10.35,
              "y": -6.975,
              "z": 1.195
            },
            "gtin": "4011932228284",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718b8",
            "leftCorner": {
              "x": 10.35,
              "y": -6.975,
              "z": 1.195
            },
            "rightCorner": {
              "x": 10.43,
              "y": -7.045,
              "z": 1.195
            },
            "gtin": "4011932228284",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718b9",
            "leftCorner": {
              "x": 10.43,
              "y": -7.045,
              "z": 1.195
            },
            "rightCorner": {
              "x": 10.486,
              "y": -7.095,
              "z": 1.195
            },
            "gtin": "4036581583508",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718ba",
            "leftCorner": {
              "x": 10.486,
              "y": -7.095,
              "z": 1.195
            },
            "rightCorner": {
              "x": 10.558,
              "y": -7.158,
              "z": 1.195
            },
            "gtin": "4036581583461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718bb",
            "leftCorner": {
              "x": 10.558,
              "y": -7.158,
              "z": 1.195
            },
            "rightCorner": {
              "x": 10.64,
              "y": -7.23,
              "z": 1.195
            },
            "gtin": "4066447086706",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718bc",
            "leftCorner": {
              "x": 10.64,
              "y": -7.23,
              "z": 1.195
            },
            "rightCorner": {
              "x": 10.673,
              "y": -7.26,
              "z": 1.195
            },
            "gtin": "4008617141211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271876",
            "leftCorner": {
              "x": 10.673,
              "y": -7.26,
              "z": 1.195
            },
            "rightCorner": {
              "x": 10.715,
              "y": -7.297,
              "z": 1.195
            },
            "gtin": "4008617141297",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b49",
        "height": 1.3651,
        "facings": [
          {
            "id": "696ebf7043c343680a271990",
            "leftCorner": {
              "x": 9.973,
              "y": -6.616,
              "z": 1.363
            },
            "rightCorner": {
              "x": 10.018,
              "y": -6.658,
              "z": 1.363
            },
            "gtin": "4008491125598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271991",
            "leftCorner": {
              "x": 10.015,
              "y": -6.678,
              "z": 1.365
            },
            "rightCorner": {
              "x": 10.094,
              "y": -6.748,
              "z": 1.365
            },
            "gtin": "4066447248777",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271992",
            "leftCorner": {
              "x": 10.094,
              "y": -6.748,
              "z": 1.365
            },
            "rightCorner": {
              "x": 10.125,
              "y": -6.776,
              "z": 1.365
            },
            "gtin": "4008617152606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271993",
            "leftCorner": {
              "x": 10.125,
              "y": -6.776,
              "z": 1.365
            },
            "rightCorner": {
              "x": 10.17,
              "y": -6.816,
              "z": 1.365
            },
            "gtin": "4008617152606",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271994",
            "leftCorner": {
              "x": 10.17,
              "y": -6.816,
              "z": 1.365
            },
            "rightCorner": {
              "x": 10.234,
              "y": -6.872,
              "z": 1.365
            },
            "gtin": "4008617517160",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271995",
            "leftCorner": {
              "x": 10.234,
              "y": -6.872,
              "z": 1.365
            },
            "rightCorner": {
              "x": 10.296,
              "y": -6.926,
              "z": 1.365
            }
          },
          {
            "id": "696ebf7043c343680a271996",
            "leftCorner": {
              "x": 10.296,
              "y": -6.926,
              "z": 1.365
            },
            "rightCorner": {
              "x": 10.358,
              "y": -6.981,
              "z": 1.365
            },
            "gtin": "4008617141341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271997",
            "leftCorner": {
              "x": 10.358,
              "y": -6.981,
              "z": 1.365
            },
            "rightCorner": {
              "x": 10.413,
              "y": -7.03,
              "z": 1.365
            },
            "gtin": "4002448089735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271998",
            "leftCorner": {
              "x": 10.413,
              "y": -7.03,
              "z": 1.365
            },
            "rightCorner": {
              "x": 10.474,
              "y": -7.084,
              "z": 1.365
            },
            "gtin": "4002448089797",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271999",
            "leftCorner": {
              "x": 10.474,
              "y": -7.084,
              "z": 1.365
            },
            "rightCorner": {
              "x": 10.499,
              "y": -7.106,
              "z": 1.365
            }
          },
          {
            "id": "696ebf7043c343680a27199a",
            "leftCorner": {
              "x": 10.499,
              "y": -7.106,
              "z": 1.365
            },
            "rightCorner": {
              "x": 10.548,
              "y": -7.149,
              "z": 1.365
            },
            "gtin": "4002448220565",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27199b",
            "leftCorner": {
              "x": 10.548,
              "y": -7.149,
              "z": 1.365
            },
            "rightCorner": {
              "x": 10.608,
              "y": -7.202,
              "z": 1.365
            },
            "gtin": "4008491225137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27199c",
            "leftCorner": {
              "x": 10.608,
              "y": -7.202,
              "z": 1.365
            },
            "rightCorner": {
              "x": 10.669,
              "y": -7.256,
              "z": 1.365
            },
            "gtin": "4008491281423",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a27194b",
            "leftCorner": {
              "x": 10.669,
              "y": -7.256,
              "z": 1.365
            },
            "rightCorner": {
              "x": 10.715,
              "y": -7.296,
              "z": 1.365
            },
            "gtin": "4008491216494",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b48",
        "height": 1.574,
        "facings": [
          {
            "id": "696ebf7043c343680a2718f8",
            "leftCorner": {
              "x": 9.976,
              "y": -6.646,
              "z": 1.574
            },
            "rightCorner": {
              "x": 10.072,
              "y": -6.73,
              "z": 1.574
            },
            "gtin": "4058172938863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2718f9",
            "leftCorner": {
              "x": 10.072,
              "y": -6.73,
              "z": 1.574
            },
            "rightCorner": {
              "x": 10.15,
              "y": -6.8,
              "z": 1.574
            },
            "gtin": "4058172938887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2718fa",
            "leftCorner": {
              "x": 10.15,
              "y": -6.8,
              "z": 1.574
            },
            "rightCorner": {
              "x": 10.216,
              "y": -6.859,
              "z": 1.574
            },
            "gtin": "4058172938849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2718fb",
            "leftCorner": {
              "x": 10.216,
              "y": -6.859,
              "z": 1.574
            },
            "rightCorner": {
              "x": 10.288,
              "y": -6.922,
              "z": 1.574
            },
            "gtin": "4010355500090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2718fc",
            "leftCorner": {
              "x": 10.288,
              "y": -6.922,
              "z": 1.574
            },
            "rightCorner": {
              "x": 10.371,
              "y": -6.995,
              "z": 1.574
            },
            "gtin": "4058172938900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2718fd",
            "leftCorner": {
              "x": 10.371,
              "y": -6.995,
              "z": 1.574
            },
            "rightCorner": {
              "x": 10.445,
              "y": -7.06,
              "z": 1.574
            },
            "gtin": "4066447423129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a2718fe",
            "leftCorner": {
              "x": 10.445,
              "y": -7.06,
              "z": 1.574
            },
            "rightCorner": {
              "x": 10.576,
              "y": -7.176,
              "z": 1.574
            },
            "gtin": "4250752204942",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718be",
            "leftCorner": {
              "x": 10.576,
              "y": -7.176,
              "z": 1.574
            },
            "rightCorner": {
              "x": 10.714,
              "y": -7.298,
              "z": 1.574
            },
            "gtin": "4008491116121",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8d3b88e258afd73b4c",
        "height": 1.7825,
        "facings": [
          {
            "id": "696ebf7043c343680a271942",
            "leftCorner": {
              "x": 9.98,
              "y": -6.653,
              "z": 1.783
            },
            "rightCorner": {
              "x": 10.019,
              "y": -6.689,
              "z": 1.783
            },
            "gtin": "5010724525517",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271943",
            "leftCorner": {
              "x": 10.02,
              "y": -6.688,
              "z": 1.783
            },
            "rightCorner": {
              "x": 10.211,
              "y": -6.857,
              "z": 1.783
            },
            "gtin": "4083700302281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271944",
            "leftCorner": {
              "x": 10.211,
              "y": -6.857,
              "z": 1.783
            },
            "rightCorner": {
              "x": 10.293,
              "y": -6.93,
              "z": 1.783
            },
            "gtin": "4083700301956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271945",
            "leftCorner": {
              "x": 10.293,
              "y": -6.93,
              "z": 1.783
            },
            "rightCorner": {
              "x": 10.354,
              "y": -6.983,
              "z": 1.783
            },
            "gtin": "4067796183962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271946",
            "leftCorner": {
              "x": 10.354,
              "y": -6.983,
              "z": 1.783
            },
            "rightCorner": {
              "x": 10.409,
              "y": -7.032,
              "z": 1.783
            },
            "gtin": "4008491115612",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271947",
            "leftCorner": {
              "x": 10.409,
              "y": -7.032,
              "z": 1.783
            },
            "rightCorner": {
              "x": 10.477,
              "y": -7.092,
              "z": 1.783
            },
            "gtin": "4008491444200",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271948",
            "leftCorner": {
              "x": 10.477,
              "y": -7.092,
              "z": 1.783
            },
            "rightCorner": {
              "x": 10.552,
              "y": -7.159,
              "z": 1.783
            },
            "gtin": "4008491261708",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271949",
            "leftCorner": {
              "x": 10.552,
              "y": -7.159,
              "z": 1.783
            },
            "rightCorner": {
              "x": 10.634,
              "y": -7.231,
              "z": 1.783
            },
            "gtin": "4008491221870",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a2718ff",
            "leftCorner": {
              "x": 10.634,
              "y": -7.231,
              "z": 1.783
            },
            "rightCorner": {
              "x": 10.712,
              "y": -7.3,
              "z": 1.783
            },
            "gtin": "4251778105466",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7575bb5fe7bc0469599ad",
    "name": "68e7575bb5fe7bc0469599ad",
    "x": 11.499,
    "y": -6.4084,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93327,
      "w": 0.35916
    },
    "statistics": {
      "hasStockCount": 45,
      "noStockCount": 2,
      "unknownStockCount": 26
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73b54",
        "height": 0.20718,
        "facings": [
          {
            "id": "696ebf7043c343680a271b29",
            "leftCorner": {
              "x": 11.53,
              "y": -6.375,
              "z": 0.207
            },
            "rightCorner": {
              "x": 11.46,
              "y": -6.312,
              "z": 0.207
            },
            "gtin": "4015637826417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b2b",
            "leftCorner": {
              "x": 11.46,
              "y": -6.312,
              "z": 0.207
            },
            "rightCorner": {
              "x": 11.389,
              "y": -6.248,
              "z": 0.207
            },
            "gtin": "4015637827377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b2c",
            "leftCorner": {
              "x": 11.389,
              "y": -6.248,
              "z": 0.207
            },
            "rightCorner": {
              "x": 11.258,
              "y": -6.129,
              "z": 0.207
            },
            "gtin": "4015637822990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b2d",
            "leftCorner": {
              "x": 11.258,
              "y": -6.129,
              "z": 0.207
            },
            "rightCorner": {
              "x": 11.136,
              "y": -6.019,
              "z": 0.207
            },
            "gtin": "4015637006659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b2e",
            "leftCorner": {
              "x": 11.136,
              "y": -6.019,
              "z": 0.207
            },
            "rightCorner": {
              "x": 11.083,
              "y": -5.972,
              "z": 0.207
            },
            "gtin": "8053323643869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b2f",
            "leftCorner": {
              "x": 11.083,
              "y": -5.972,
              "z": 0.207
            },
            "rightCorner": {
              "x": 11.017,
              "y": -5.912,
              "z": 0.207
            },
            "gtin": "8018759003939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b30",
            "leftCorner": {
              "x": 11.017,
              "y": -5.912,
              "z": 0.207
            },
            "rightCorner": {
              "x": 10.965,
              "y": -5.865,
              "z": 0.207
            },
            "gtin": "8018759003649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b31",
            "leftCorner": {
              "x": 10.965,
              "y": -5.865,
              "z": 0.207
            },
            "rightCorner": {
              "x": 10.924,
              "y": -5.828,
              "z": 0.207
            },
            "gtin": "8018759001911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b32",
            "leftCorner": {
              "x": 10.924,
              "y": -5.828,
              "z": 0.207
            },
            "rightCorner": {
              "x": 10.883,
              "y": -5.791,
              "z": 0.207
            },
            "gtin": "8018759001294",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b33",
            "leftCorner": {
              "x": 10.883,
              "y": -5.791,
              "z": 0.207
            },
            "rightCorner": {
              "x": 10.835,
              "y": -5.748,
              "z": 0.207
            },
            "gtin": "8053323643883",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b2a",
            "leftCorner": {
              "x": 10.835,
              "y": -5.748,
              "z": 0.207
            },
            "rightCorner": {
              "x": 10.788,
              "y": -5.705,
              "z": 0.207
            },
            "gtin": "8018759001263",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b53",
        "height": 0.55456,
        "facings": [
          {
            "id": "696ebf7043c343680a271b1e",
            "leftCorner": {
              "x": 11.534,
              "y": -6.37,
              "z": 0.555
            },
            "rightCorner": {
              "x": 11.464,
              "y": -6.306,
              "z": 0.555
            },
            "gtin": "4015637007250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b1f",
            "leftCorner": {
              "x": 11.464,
              "y": -6.306,
              "z": 0.555
            },
            "rightCorner": {
              "x": 11.393,
              "y": -6.243,
              "z": 0.555
            },
            "gtin": "4015637827445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b20",
            "leftCorner": {
              "x": 11.393,
              "y": -6.243,
              "z": 0.555
            },
            "rightCorner": {
              "x": 11.309,
              "y": -6.167,
              "z": 0.555
            },
            "gtin": "4015637827438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b21",
            "leftCorner": {
              "x": 11.309,
              "y": -6.167,
              "z": 0.555
            },
            "rightCorner": {
              "x": 11.221,
              "y": -6.087,
              "z": 0.555
            },
            "gtin": "4015637024943",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b22",
            "leftCorner": {
              "x": 11.221,
              "y": -6.087,
              "z": 0.555
            },
            "rightCorner": {
              "x": 11.141,
              "y": -6.015,
              "z": 0.555
            },
            "gtin": "8018759003342",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b23",
            "leftCorner": {
              "x": 11.141,
              "y": -6.015,
              "z": 0.555
            },
            "rightCorner": {
              "x": 11.08,
              "y": -5.959,
              "z": 0.555
            },
            "gtin": "8018759003168",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b24",
            "leftCorner": {
              "x": 11.08,
              "y": -5.959,
              "z": 0.555
            },
            "rightCorner": {
              "x": 11.032,
              "y": -5.916,
              "z": 0.555
            },
            "gtin": "8018759003168",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b25",
            "leftCorner": {
              "x": 11.032,
              "y": -5.916,
              "z": 0.555
            },
            "rightCorner": {
              "x": 10.969,
              "y": -5.859,
              "z": 0.555
            },
            "gtin": "8018759000037",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b26",
            "leftCorner": {
              "x": 10.969,
              "y": -5.859,
              "z": 0.555
            },
            "rightCorner": {
              "x": 10.913,
              "y": -5.809,
              "z": 0.555
            },
            "gtin": "8018759001553",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b27",
            "leftCorner": {
              "x": 10.913,
              "y": -5.809,
              "z": 0.555
            },
            "rightCorner": {
              "x": 10.857,
              "y": -5.758,
              "z": 0.555
            },
            "gtin": "8018759000785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b28",
            "leftCorner": {
              "x": 10.857,
              "y": -5.758,
              "z": 0.555
            },
            "rightCorner": {
              "x": 10.808,
              "y": -5.714,
              "z": 0.555
            },
            "gtin": "8018759003533",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b51",
        "height": 0.84933,
        "facings": [
          {
            "id": "696ebf7043c343680a271b02",
            "leftCorner": {
              "x": 11.532,
              "y": -6.372,
              "z": 0.849
            },
            "rightCorner": {
              "x": 11.465,
              "y": -6.312,
              "z": 0.849
            },
            "gtin": "4015637019246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b03",
            "leftCorner": {
              "x": 11.465,
              "y": -6.312,
              "z": 0.849
            },
            "rightCorner": {
              "x": 11.393,
              "y": -6.247,
              "z": 0.849
            },
            "gtin": "4015637822952",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b04",
            "leftCorner": {
              "x": 11.393,
              "y": -6.247,
              "z": 0.849
            },
            "rightCorner": {
              "x": 11.306,
              "y": -6.168,
              "z": 0.849
            },
            "gtin": "4015637004945",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b05",
            "leftCorner": {
              "x": 11.306,
              "y": -6.168,
              "z": 0.849
            },
            "rightCorner": {
              "x": 11.214,
              "y": -6.085,
              "z": 0.849
            },
            "gtin": "4015637019284",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b06",
            "leftCorner": {
              "x": 11.214,
              "y": -6.085,
              "z": 0.849
            },
            "rightCorner": {
              "x": 11.175,
              "y": -6.05,
              "z": 0.849
            },
            "gtin": "8018759000341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b07",
            "leftCorner": {
              "x": 11.175,
              "y": -6.05,
              "z": 0.849
            },
            "rightCorner": {
              "x": 11.133,
              "y": -6.012,
              "z": 0.849
            },
            "gtin": "8018759001836",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b08",
            "leftCorner": {
              "x": 11.133,
              "y": -6.012,
              "z": 0.849
            },
            "rightCorner": {
              "x": 11.092,
              "y": -5.975,
              "z": 0.849
            },
            "gtin": "8053323641155",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b09",
            "leftCorner": {
              "x": 11.092,
              "y": -5.975,
              "z": 0.849
            },
            "rightCorner": {
              "x": 11.034,
              "y": -5.922,
              "z": 0.849
            },
            "gtin": "8018759000105",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b0a",
            "leftCorner": {
              "x": 11.034,
              "y": -5.922,
              "z": 0.849
            },
            "rightCorner": {
              "x": 10.988,
              "y": -5.881,
              "z": 0.849
            },
            "gtin": "8018759000136",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b0b",
            "leftCorner": {
              "x": 10.988,
              "y": -5.881,
              "z": 0.849
            },
            "rightCorner": {
              "x": 10.94,
              "y": -5.838,
              "z": 0.849
            },
            "gtin": "8018759000549",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b0c",
            "leftCorner": {
              "x": 10.94,
              "y": -5.838,
              "z": 0.849
            },
            "rightCorner": {
              "x": 10.896,
              "y": -5.798,
              "z": 0.849
            },
            "gtin": "8018759000297",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b0d",
            "leftCorner": {
              "x": 10.896,
              "y": -5.798,
              "z": 0.849
            },
            "rightCorner": {
              "x": 10.855,
              "y": -5.761,
              "z": 0.849
            },
            "gtin": "8018759002246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b0e",
            "leftCorner": {
              "x": 10.855,
              "y": -5.761,
              "z": 0.849
            },
            "rightCorner": {
              "x": 10.807,
              "y": -5.717,
              "z": 0.849
            },
            "gtin": "8018759003670",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b50",
        "height": 1.1036,
        "facings": [
          {
            "id": "696ebf7043c343680a271aec",
            "leftCorner": {
              "x": 11.527,
              "y": -6.368,
              "z": 1.104
            },
            "rightCorner": {
              "x": 11.489,
              "y": -6.333,
              "z": 1.104
            },
            "gtin": "4066447893175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271aed",
            "leftCorner": {
              "x": 11.489,
              "y": -6.333,
              "z": 1.104
            },
            "rightCorner": {
              "x": 11.446,
              "y": -6.294,
              "z": 1.104
            },
            "gtin": "4066447878417",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271aee",
            "leftCorner": {
              "x": 11.446,
              "y": -6.294,
              "z": 1.104
            },
            "rightCorner": {
              "x": 11.399,
              "y": -6.251,
              "z": 1.104
            },
            "gtin": "4066447670554",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271aef",
            "leftCorner": {
              "x": 11.399,
              "y": -6.251,
              "z": 1.104
            },
            "rightCorner": {
              "x": 11.339,
              "y": -6.197,
              "z": 1.104
            },
            "gtin": "4066447670530",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271af0",
            "leftCorner": {
              "x": 11.339,
              "y": -6.197,
              "z": 1.104
            },
            "rightCorner": {
              "x": 11.282,
              "y": -6.146,
              "z": 1.104
            },
            "gtin": "4066447877021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271af1",
            "leftCorner": {
              "x": 11.282,
              "y": -6.146,
              "z": 1.104
            },
            "rightCorner": {
              "x": 11.211,
              "y": -6.082,
              "z": 1.104
            },
            "gtin": "4066447884562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271af2",
            "leftCorner": {
              "x": 11.211,
              "y": -6.082,
              "z": 1.104
            },
            "rightCorner": {
              "x": 11.099,
              "y": -5.98,
              "z": 1.104
            },
            "gtin": "4067796003505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271af3",
            "leftCorner": {
              "x": 11.099,
              "y": -5.98,
              "z": 1.104
            },
            "rightCorner": {
              "x": 11.032,
              "y": -5.92,
              "z": 1.104
            },
            "gtin": "4066447087314",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271af4",
            "leftCorner": {
              "x": 11.032,
              "y": -5.92,
              "z": 1.104
            },
            "rightCorner": {
              "x": 10.956,
              "y": -5.851,
              "z": 1.104
            },
            "gtin": "4066447087277",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271af5",
            "leftCorner": {
              "x": 10.956,
              "y": -5.851,
              "z": 1.104
            },
            "rightCorner": {
              "x": 10.882,
              "y": -5.785,
              "z": 1.104
            },
            "gtin": "4066447087277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271af6",
            "leftCorner": {
              "x": 10.882,
              "y": -5.785,
              "z": 1.104
            },
            "rightCorner": {
              "x": 10.804,
              "y": -5.714,
              "z": 1.104
            },
            "gtin": "8018759001898",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b55",
        "height": 1.3566,
        "facings": [
          {
            "id": "696ebf7043c343680a271b35",
            "leftCorner": {
              "x": 11.529,
              "y": -6.367,
              "z": 1.357
            },
            "rightCorner": {
              "x": 11.479,
              "y": -6.321,
              "z": 1.357
            },
            "gtin": "4066447413540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b36",
            "leftCorner": {
              "x": 11.479,
              "y": -6.321,
              "z": 1.357
            },
            "rightCorner": {
              "x": 11.433,
              "y": -6.279,
              "z": 1.357
            },
            "gtin": "4066447087161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b37",
            "leftCorner": {
              "x": 11.433,
              "y": -6.279,
              "z": 1.357
            },
            "rightCorner": {
              "x": 11.368,
              "y": -6.221,
              "z": 1.357
            },
            "gtin": "4066447087192",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b38",
            "leftCorner": {
              "x": 11.368,
              "y": -6.221,
              "z": 1.357
            },
            "rightCorner": {
              "x": 11.296,
              "y": -6.156,
              "z": 1.357
            },
            "gtin": "4066447087192",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b39",
            "leftCorner": {
              "x": 11.296,
              "y": -6.156,
              "z": 1.357
            },
            "rightCorner": {
              "x": 11.247,
              "y": -6.112,
              "z": 1.357
            },
            "gtin": "4067796000382",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b3a",
            "leftCorner": {
              "x": 11.247,
              "y": -6.112,
              "z": 1.357
            },
            "rightCorner": {
              "x": 11.181,
              "y": -6.052,
              "z": 1.357
            },
            "gtin": "4066447087215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b3b",
            "leftCorner": {
              "x": 11.181,
              "y": -6.052,
              "z": 1.357
            },
            "rightCorner": {
              "x": 11.128,
              "y": -6.004,
              "z": 1.357
            },
            "gtin": "4066447087215",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b3c",
            "leftCorner": {
              "x": 11.128,
              "y": -6.004,
              "z": 1.357
            },
            "rightCorner": {
              "x": 11.063,
              "y": -5.945,
              "z": 1.357
            },
            "gtin": "4066447121490",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b3d",
            "leftCorner": {
              "x": 11.063,
              "y": -5.945,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.988,
              "y": -5.877,
              "z": 1.357
            },
            "gtin": "4066447399141",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b3e",
            "leftCorner": {
              "x": 10.988,
              "y": -5.877,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.85,
              "y": -5.753,
              "z": 1.357
            },
            "gtin": "4066447087208",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b3f",
            "leftCorner": {
              "x": 10.85,
              "y": -5.753,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.797,
              "y": -5.705,
              "z": 1.357
            },
            "gtin": "4066447933635",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b52",
        "height": 1.5675,
        "facings": [
          {
            "id": "696ebf7043c343680a271b0f",
            "leftCorner": {
              "x": 11.536,
              "y": -6.367,
              "z": 1.567
            },
            "rightCorner": {
              "x": 11.469,
              "y": -6.306,
              "z": 1.567
            },
            "gtin": "4066447087109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b11",
            "leftCorner": {
              "x": 11.469,
              "y": -6.306,
              "z": 1.567
            },
            "rightCorner": {
              "x": 11.353,
              "y": -6.201,
              "z": 1.567
            },
            "gtin": "4066447880595",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b12",
            "leftCorner": {
              "x": 11.353,
              "y": -6.201,
              "z": 1.567
            },
            "rightCorner": {
              "x": 11.306,
              "y": -6.159,
              "z": 1.567
            }
          },
          {
            "id": "696ebf7043c343680a271b13",
            "leftCorner": {
              "x": 11.306,
              "y": -6.159,
              "z": 1.567
            },
            "rightCorner": {
              "x": 11.248,
              "y": -6.106,
              "z": 1.567
            },
            "gtin": "4066447369526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b14",
            "leftCorner": {
              "x": 11.248,
              "y": -6.106,
              "z": 1.567
            },
            "rightCorner": {
              "x": 11.176,
              "y": -6.042,
              "z": 1.567
            },
            "gtin": "4067796196313",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b15",
            "leftCorner": {
              "x": 11.176,
              "y": -6.042,
              "z": 1.567
            },
            "rightCorner": {
              "x": 11.118,
              "y": -5.989,
              "z": 1.567
            },
            "gtin": "4066447010367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b16",
            "leftCorner": {
              "x": 11.118,
              "y": -5.989,
              "z": 1.567
            },
            "rightCorner": {
              "x": 11.059,
              "y": -5.936,
              "z": 1.567
            },
            "gtin": "4066447010367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b17",
            "leftCorner": {
              "x": 11.059,
              "y": -5.936,
              "z": 1.567
            },
            "rightCorner": {
              "x": 10.988,
              "y": -5.872,
              "z": 1.567
            },
            "gtin": "4066447010367",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b18",
            "leftCorner": {
              "x": 10.988,
              "y": -5.872,
              "z": 1.567
            },
            "rightCorner": {
              "x": 10.925,
              "y": -5.815,
              "z": 1.567
            },
            "gtin": "4066447087130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b19",
            "leftCorner": {
              "x": 10.925,
              "y": -5.815,
              "z": 1.567
            },
            "rightCorner": {
              "x": 10.785,
              "y": -5.689,
              "z": 1.567
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b4f",
        "height": 1.7758,
        "facings": [
          {
            "id": "696ebf7043c343680a271a95",
            "leftCorner": {
              "x": 11.532,
              "y": -6.361,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.391,
              "y": -6.235,
              "z": 1.776
            },
            "gtin": "4066447087123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a96",
            "leftCorner": {
              "x": 11.391,
              "y": -6.235,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.272,
              "y": -6.127,
              "z": 1.776
            },
            "gtin": "4067796039078",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a97",
            "leftCorner": {
              "x": 11.272,
              "y": -6.127,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.19,
              "y": -6.053,
              "z": 1.776
            },
            "gtin": "4066447087086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a98",
            "leftCorner": {
              "x": 11.19,
              "y": -6.053,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.149,
              "y": -6.016,
              "z": 1.776
            },
            "gtin": "4067796072945",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a99",
            "leftCorner": {
              "x": 11.149,
              "y": -6.016,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.1,
              "y": -5.972,
              "z": 1.776
            },
            "gtin": "4066447874600",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a9a",
            "leftCorner": {
              "x": 11.1,
              "y": -5.972,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.042,
              "y": -5.919,
              "z": 1.776
            },
            "gtin": "4066447876574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a9b",
            "leftCorner": {
              "x": 11.042,
              "y": -5.919,
              "z": 1.776
            },
            "rightCorner": {
              "x": 10.996,
              "y": -5.877,
              "z": 1.776
            }
          },
          {
            "id": "696ebf7043c343680a271a9c",
            "leftCorner": {
              "x": 10.996,
              "y": -5.877,
              "z": 1.776
            },
            "rightCorner": {
              "x": 10.928,
              "y": -5.816,
              "z": 1.776
            },
            "gtin": "4066447867893",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271a9d",
            "leftCorner": {
              "x": 10.928,
              "y": -5.816,
              "z": 1.776
            },
            "rightCorner": {
              "x": 10.82,
              "y": -5.719,
              "z": 1.776
            },
            "gtin": "4066447862577",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7575bb5fe7bc0469599ae",
    "name": "68e7575bb5fe7bc0469599ae",
    "x": 10.694,
    "y": -5.8095,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9336,
      "w": 0.35832
    },
    "statistics": {
      "hasStockCount": 11,
      "noStockCount": 0,
      "unknownStockCount": 28
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73b59",
        "height": 0.30469,
        "facings": []
      },
      {
        "id": "696ead8e3b88e258afd73b5a",
        "height": 0.54323,
        "facings": []
      },
      {
        "id": "696ead8e3b88e258afd73b56",
        "height": 0.7616,
        "facings": [
          {
            "id": "696ebf7043c343680a271b4b",
            "leftCorner": {
              "x": 10.79,
              "y": -5.703,
              "z": 0.762
            },
            "rightCorner": {
              "x": 10.756,
              "y": -5.672,
              "z": 0.762
            },
            "gtin": "4066447518238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b4d",
            "leftCorner": {
              "x": 10.756,
              "y": -5.672,
              "z": 0.762
            },
            "rightCorner": {
              "x": 10.703,
              "y": -5.625,
              "z": 0.762
            },
            "gtin": "4058172287459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b4e",
            "leftCorner": {
              "x": 10.703,
              "y": -5.625,
              "z": 0.762
            },
            "rightCorner": {
              "x": 10.649,
              "y": -5.576,
              "z": 0.762
            },
            "gtin": "4058172287459",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b4f",
            "leftCorner": {
              "x": 10.649,
              "y": -5.576,
              "z": 0.762
            },
            "rightCorner": {
              "x": 10.545,
              "y": -5.482,
              "z": 0.762
            },
            "gtin": "4058172268717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b50",
            "leftCorner": {
              "x": 10.545,
              "y": -5.482,
              "z": 0.762
            },
            "rightCorner": {
              "x": 10.49,
              "y": -5.433,
              "z": 0.762
            },
            "gtin": "4066447887730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b4c",
            "leftCorner": {
              "x": 10.49,
              "y": -5.433,
              "z": 0.762
            },
            "rightCorner": {
              "x": 10.047,
              "y": -5.034,
              "z": 0.762
            },
            "gtin": "4067796208788",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b57",
        "height": 1.1009,
        "facings": [
          {
            "id": "696ebf7043c343680a271af7",
            "leftCorner": {
              "x": 10.804,
              "y": -5.714,
              "z": 1.104
            },
            "rightCorner": {
              "x": 10.736,
              "y": -5.652,
              "z": 1.104
            },
            "gtin": "4058172943591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271af8",
            "leftCorner": {
              "x": 10.738,
              "y": -5.65,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.672,
              "y": -5.591,
              "z": 1.101
            },
            "gtin": "4058172943591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271af9",
            "leftCorner": {
              "x": 10.672,
              "y": -5.591,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.607,
              "y": -5.532,
              "z": 1.101
            },
            "gtin": "4058172943591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271afa",
            "leftCorner": {
              "x": 10.607,
              "y": -5.532,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.549,
              "y": -5.48,
              "z": 1.101
            }
          },
          {
            "id": "696ebf7043c343680a271afb",
            "leftCorner": {
              "x": 10.549,
              "y": -5.48,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.48,
              "y": -5.418,
              "z": 1.101
            },
            "gtin": "4067796061901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271afc",
            "leftCorner": {
              "x": 10.48,
              "y": -5.418,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.41,
              "y": -5.355,
              "z": 1.101
            },
            "gtin": "4067796061901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271afd",
            "leftCorner": {
              "x": 10.41,
              "y": -5.355,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.344,
              "y": -5.295,
              "z": 1.101
            },
            "gtin": "4067796075892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271afe",
            "leftCorner": {
              "x": 10.344,
              "y": -5.295,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.272,
              "y": -5.231,
              "z": 1.101
            },
            "gtin": "4066447887761",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271aff",
            "leftCorner": {
              "x": 10.272,
              "y": -5.231,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.198,
              "y": -5.164,
              "z": 1.101
            }
          },
          {
            "id": "696ebf7043c343680a271b00",
            "leftCorner": {
              "x": 10.198,
              "y": -5.164,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.129,
              "y": -5.102,
              "z": 1.101
            },
            "gtin": "4066447265316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b01",
            "leftCorner": {
              "x": 10.129,
              "y": -5.102,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.064,
              "y": -5.043,
              "z": 1.101
            },
            "gtin": "4066447265330",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b58",
        "height": 1.3559,
        "facings": [
          {
            "id": "696ebf7043c343680a271b40",
            "leftCorner": {
              "x": 10.792,
              "y": -5.7,
              "z": 1.356
            },
            "rightCorner": {
              "x": 10.715,
              "y": -5.63,
              "z": 1.356
            },
            "gtin": "4066447671278",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b41",
            "leftCorner": {
              "x": 10.715,
              "y": -5.63,
              "z": 1.356
            },
            "rightCorner": {
              "x": 10.649,
              "y": -5.571,
              "z": 1.356
            },
            "gtin": "4066447887808",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b42",
            "leftCorner": {
              "x": 10.649,
              "y": -5.571,
              "z": 1.356
            },
            "rightCorner": {
              "x": 10.595,
              "y": -5.522,
              "z": 1.356
            },
            "gtin": "7640143671120",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b43",
            "leftCorner": {
              "x": 10.595,
              "y": -5.522,
              "z": 1.356
            },
            "rightCorner": {
              "x": 10.519,
              "y": -5.454,
              "z": 1.356
            },
            "gtin": "7640143671113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b44",
            "leftCorner": {
              "x": 10.519,
              "y": -5.454,
              "z": 1.356
            },
            "rightCorner": {
              "x": 10.447,
              "y": -5.389,
              "z": 1.356
            },
            "gtin": "7640143674152",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b45",
            "leftCorner": {
              "x": 10.447,
              "y": -5.389,
              "z": 1.356
            },
            "rightCorner": {
              "x": 10.388,
              "y": -5.336,
              "z": 1.356
            },
            "gtin": "7640143674107",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b46",
            "leftCorner": {
              "x": 10.388,
              "y": -5.336,
              "z": 1.356
            },
            "rightCorner": {
              "x": 10.323,
              "y": -5.277,
              "z": 1.356
            },
            "gtin": "7640143674107",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b47",
            "leftCorner": {
              "x": 10.323,
              "y": -5.277,
              "z": 1.356
            },
            "rightCorner": {
              "x": 10.267,
              "y": -5.226,
              "z": 1.356
            },
            "gtin": "7640143674145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b48",
            "leftCorner": {
              "x": 10.267,
              "y": -5.226,
              "z": 1.356
            },
            "rightCorner": {
              "x": 10.207,
              "y": -5.173,
              "z": 1.356
            },
            "gtin": "7640143674145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b49",
            "leftCorner": {
              "x": 10.207,
              "y": -5.173,
              "z": 1.356
            },
            "rightCorner": {
              "x": 10.147,
              "y": -5.119,
              "z": 1.356
            },
            "gtin": "7640143674138",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271b4a",
            "leftCorner": {
              "x": 10.147,
              "y": -5.119,
              "z": 1.356
            },
            "rightCorner": {
              "x": 10.099,
              "y": -5.075,
              "z": 1.356
            },
            "gtin": "7640143674138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b34",
            "leftCorner": {
              "x": 10.099,
              "y": -5.075,
              "z": 1.356
            },
            "rightCorner": {
              "x": 10.049,
              "y": -5.031,
              "z": 1.356
            },
            "gtin": "7640143674121",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b5b",
        "height": 1.5655,
        "facings": [
          {
            "id": "696ebf7043c343680a271b1a",
            "leftCorner": {
              "x": 10.79,
              "y": -5.684,
              "z": 1.566
            },
            "rightCorner": {
              "x": 10.714,
              "y": -5.616,
              "z": 1.566
            },
            "gtin": "8008343300032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b1b",
            "leftCorner": {
              "x": 10.714,
              "y": -5.616,
              "z": 1.566
            },
            "rightCorner": {
              "x": 10.589,
              "y": -5.503,
              "z": 1.566
            },
            "gtin": "8008343700139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b1c",
            "leftCorner": {
              "x": 10.589,
              "y": -5.503,
              "z": 1.566
            },
            "rightCorner": {
              "x": 10.381,
              "y": -5.316,
              "z": 1.566
            },
            "gtin": "4066447470932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b1d",
            "leftCorner": {
              "x": 10.381,
              "y": -5.316,
              "z": 1.566
            },
            "rightCorner": {
              "x": 10.154,
              "y": -5.111,
              "z": 1.566
            },
            "gtin": "4067796064834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271b10",
            "leftCorner": {
              "x": 10.154,
              "y": -5.111,
              "z": 1.566
            },
            "rightCorner": {
              "x": 10.056,
              "y": -5.023,
              "z": 1.566
            },
            "gtin": "4066447951493",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b5c",
        "height": 1.7751,
        "facings": [
          {
            "id": "696ebf7043c343680a271a9e",
            "leftCorner": {
              "x": 10.82,
              "y": -5.719,
              "z": 1.776
            },
            "rightCorner": {
              "x": 10.733,
              "y": -5.64,
              "z": 1.776
            },
            "gtin": "8008343300483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a9f",
            "leftCorner": {
              "x": 10.736,
              "y": -5.637,
              "z": 1.775
            },
            "rightCorner": {
              "x": 10.648,
              "y": -5.557,
              "z": 1.775
            },
            "gtin": "8008343300483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271aa0",
            "leftCorner": {
              "x": 10.648,
              "y": -5.557,
              "z": 1.775
            },
            "rightCorner": {
              "x": 10.548,
              "y": -5.468,
              "z": 1.775
            },
            "gtin": "8008343700511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271aa1",
            "leftCorner": {
              "x": 10.548,
              "y": -5.468,
              "z": 1.775
            },
            "rightCorner": {
              "x": 10.42,
              "y": -5.352,
              "z": 1.775
            },
            "gtin": "7640143670345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271aa2",
            "leftCorner": {
              "x": 10.42,
              "y": -5.352,
              "z": 1.775
            },
            "rightCorner": {
              "x": 10.311,
              "y": -5.254,
              "z": 1.775
            },
            "gtin": "7640143670161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271aa3",
            "leftCorner": {
              "x": 10.311,
              "y": -5.254,
              "z": 1.775
            },
            "rightCorner": {
              "x": 10.178,
              "y": -5.134,
              "z": 1.775
            },
            "gtin": "4066447876505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271aa4",
            "leftCorner": {
              "x": 10.178,
              "y": -5.134,
              "z": 1.775
            },
            "rightCorner": {
              "x": 10.06,
              "y": -5.028,
              "z": 1.775
            },
            "gtin": "4066447876505",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7575bb5fe7bc0469599af",
    "name": "68e7575bb5fe7bc0469599af",
    "x": 10.015,
    "y": -5.0651,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93452,
      "w": 0.3559
    },
    "statistics": {
      "hasStockCount": 30,
      "noStockCount": 3,
      "unknownStockCount": 35
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73b60",
        "height": 0.21168,
        "facings": [
          {
            "id": "696ebf7143c343680a271b75",
            "leftCorner": {
              "x": 10.044,
              "y": -5.033,
              "z": 0.212
            },
            "rightCorner": {
              "x": 9.801,
              "y": -4.816,
              "z": 0.212
            },
            "gtin": "4066447610048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b76",
            "leftCorner": {
              "x": 9.801,
              "y": -4.816,
              "z": 0.212
            },
            "rightCorner": {
              "x": 9.745,
              "y": -4.766,
              "z": 0.212
            }
          },
          {
            "id": "696ebf7143c343680a271b77",
            "leftCorner": {
              "x": 9.745,
              "y": -4.766,
              "z": 0.212
            },
            "rightCorner": {
              "x": 9.693,
              "y": -4.72,
              "z": 0.212
            },
            "gtin": "4067796064810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b78",
            "leftCorner": {
              "x": 9.693,
              "y": -4.72,
              "z": 0.212
            },
            "rightCorner": {
              "x": 9.637,
              "y": -4.671,
              "z": 0.212
            },
            "gtin": "4067796066722",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b79",
            "leftCorner": {
              "x": 9.637,
              "y": -4.671,
              "z": 0.212
            },
            "rightCorner": {
              "x": 9.585,
              "y": -4.623,
              "z": 0.212
            },
            "gtin": "4067796066722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b7a",
            "leftCorner": {
              "x": 9.585,
              "y": -4.623,
              "z": 0.212
            },
            "rightCorner": {
              "x": 9.555,
              "y": -4.597,
              "z": 0.212
            },
            "gtin": "4067796167351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b7b",
            "leftCorner": {
              "x": 9.555,
              "y": -4.597,
              "z": 0.212
            },
            "rightCorner": {
              "x": 9.526,
              "y": -4.571,
              "z": 0.212
            },
            "gtin": "4067796167351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b7c",
            "leftCorner": {
              "x": 9.526,
              "y": -4.571,
              "z": 0.212
            },
            "rightCorner": {
              "x": 9.487,
              "y": -4.536,
              "z": 0.212
            },
            "gtin": "4067796167337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b7d",
            "leftCorner": {
              "x": 9.487,
              "y": -4.536,
              "z": 0.212
            },
            "rightCorner": {
              "x": 9.441,
              "y": -4.496,
              "z": 0.212
            },
            "gtin": "4067796150513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b7e",
            "leftCorner": {
              "x": 9.441,
              "y": -4.496,
              "z": 0.212
            },
            "rightCorner": {
              "x": 9.393,
              "y": -4.453,
              "z": 0.212
            },
            "gtin": "4260742566011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b7f",
            "leftCorner": {
              "x": 9.393,
              "y": -4.453,
              "z": 0.212
            },
            "rightCorner": {
              "x": 9.291,
              "y": -4.362,
              "z": 0.212
            },
            "gtin": "4067796085013",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b62",
        "height": 0.55712,
        "facings": [
          {
            "id": "696ebf7143c343680a271bb0",
            "leftCorner": {
              "x": 10.046,
              "y": -5.03,
              "z": 0.557
            },
            "rightCorner": {
              "x": 9.988,
              "y": -4.979,
              "z": 0.557
            },
            "gtin": "4066447875669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bb2",
            "leftCorner": {
              "x": 9.988,
              "y": -4.979,
              "z": 0.557
            },
            "rightCorner": {
              "x": 9.929,
              "y": -4.926,
              "z": 0.557
            },
            "gtin": "4066447875669",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bb3",
            "leftCorner": {
              "x": 9.929,
              "y": -4.926,
              "z": 0.557
            },
            "rightCorner": {
              "x": 9.865,
              "y": -4.869,
              "z": 0.557
            },
            "gtin": "4067796202854",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bb4",
            "leftCorner": {
              "x": 9.865,
              "y": -4.869,
              "z": 0.557
            },
            "rightCorner": {
              "x": 9.789,
              "y": -4.801,
              "z": 0.557
            },
            "gtin": "4019339487204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bb5",
            "leftCorner": {
              "x": 9.789,
              "y": -4.801,
              "z": 0.557
            },
            "rightCorner": {
              "x": 9.741,
              "y": -4.759,
              "z": 0.557
            },
            "gtin": "4019339487198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bb6",
            "leftCorner": {
              "x": 9.741,
              "y": -4.759,
              "z": 0.557
            },
            "rightCorner": {
              "x": 9.681,
              "y": -4.705,
              "z": 0.557
            },
            "gtin": "4019339487129",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bb7",
            "leftCorner": {
              "x": 9.681,
              "y": -4.705,
              "z": 0.557
            },
            "rightCorner": {
              "x": 9.493,
              "y": -4.538,
              "z": 0.557
            },
            "gtin": "4066447327885",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bb8",
            "leftCorner": {
              "x": 9.493,
              "y": -4.538,
              "z": 0.557
            },
            "rightCorner": {
              "x": 9.295,
              "y": -4.361,
              "z": 0.557
            },
            "gtin": "4066447327908",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b5f",
        "height": 0.84913,
        "facings": [
          {
            "id": "696ebf7143c343680a271b67",
            "leftCorner": {
              "x": 10.045,
              "y": -5.031,
              "z": 0.849
            },
            "rightCorner": {
              "x": 9.991,
              "y": -4.983,
              "z": 0.849
            },
            "gtin": "4067796187038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b68",
            "leftCorner": {
              "x": 9.991,
              "y": -4.983,
              "z": 0.849
            },
            "rightCorner": {
              "x": 9.936,
              "y": -4.933,
              "z": 0.849
            },
            "gtin": "4067796187038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b69",
            "leftCorner": {
              "x": 9.936,
              "y": -4.933,
              "z": 0.849
            },
            "rightCorner": {
              "x": 9.872,
              "y": -4.877,
              "z": 0.849
            },
            "gtin": "4067796187052",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b6a",
            "leftCorner": {
              "x": 9.872,
              "y": -4.877,
              "z": 0.849
            },
            "rightCorner": {
              "x": 9.816,
              "y": -4.827,
              "z": 0.849
            },
            "gtin": "4066447373189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b6b",
            "leftCorner": {
              "x": 9.816,
              "y": -4.827,
              "z": 0.849
            },
            "rightCorner": {
              "x": 9.768,
              "y": -4.784,
              "z": 0.849
            },
            "gtin": "4066447373189",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b6c",
            "leftCorner": {
              "x": 9.768,
              "y": -4.784,
              "z": 0.849
            },
            "rightCorner": {
              "x": 9.703,
              "y": -4.726,
              "z": 0.849
            },
            "gtin": "4058172824470",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b6d",
            "leftCorner": {
              "x": 9.703,
              "y": -4.726,
              "z": 0.849
            },
            "rightCorner": {
              "x": 9.653,
              "y": -4.682,
              "z": 0.849
            }
          },
          {
            "id": "696ebf7143c343680a271b6e",
            "leftCorner": {
              "x": 9.653,
              "y": -4.682,
              "z": 0.849
            },
            "rightCorner": {
              "x": 9.596,
              "y": -4.631,
              "z": 0.849
            },
            "gtin": "4066447366204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b6f",
            "leftCorner": {
              "x": 9.596,
              "y": -4.631,
              "z": 0.849
            },
            "rightCorner": {
              "x": 9.576,
              "y": -4.613,
              "z": 0.849
            },
            "gtin": "4066447366204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b70",
            "leftCorner": {
              "x": 9.576,
              "y": -4.613,
              "z": 0.849
            },
            "rightCorner": {
              "x": 9.537,
              "y": -4.578,
              "z": 0.849
            }
          },
          {
            "id": "696ebf7143c343680a271b71",
            "leftCorner": {
              "x": 9.537,
              "y": -4.578,
              "z": 0.849
            },
            "rightCorner": {
              "x": 9.477,
              "y": -4.525,
              "z": 0.849
            },
            "gtin": "4067796062519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b72",
            "leftCorner": {
              "x": 9.477,
              "y": -4.525,
              "z": 0.849
            },
            "rightCorner": {
              "x": 9.425,
              "y": -4.478,
              "z": 0.849
            },
            "gtin": "4067796062519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b73",
            "leftCorner": {
              "x": 9.425,
              "y": -4.478,
              "z": 0.849
            },
            "rightCorner": {
              "x": 9.371,
              "y": -4.431,
              "z": 0.849
            },
            "gtin": "4067796097184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b74",
            "leftCorner": {
              "x": 9.371,
              "y": -4.431,
              "z": 0.849
            },
            "rightCorner": {
              "x": 9.311,
              "y": -4.377,
              "z": 0.849
            },
            "gtin": "4067796097184",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b5d",
        "height": 1.0584,
        "facings": [
          {
            "id": "696ebf7143c343680a271b51",
            "leftCorner": {
              "x": 10.045,
              "y": -5.031,
              "z": 1.058
            },
            "rightCorner": {
              "x": 9.979,
              "y": -4.972,
              "z": 1.058
            },
            "gtin": "4014829743006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b53",
            "leftCorner": {
              "x": 9.979,
              "y": -4.972,
              "z": 1.058
            },
            "rightCorner": {
              "x": 9.908,
              "y": -4.909,
              "z": 1.058
            },
            "gtin": "4260189689038",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b54",
            "leftCorner": {
              "x": 9.908,
              "y": -4.909,
              "z": 1.058
            },
            "rightCorner": {
              "x": 9.826,
              "y": -4.836,
              "z": 1.058
            },
            "gtin": "4260189689021",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b55",
            "leftCorner": {
              "x": 9.826,
              "y": -4.836,
              "z": 1.058
            },
            "rightCorner": {
              "x": 9.768,
              "y": -4.785,
              "z": 1.058
            },
            "gtin": "4260189683630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b56",
            "leftCorner": {
              "x": 9.768,
              "y": -4.785,
              "z": 1.058
            },
            "rightCorner": {
              "x": 9.703,
              "y": -4.727,
              "z": 1.058
            },
            "gtin": "4260189683630",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b57",
            "leftCorner": {
              "x": 9.703,
              "y": -4.727,
              "z": 1.058
            },
            "rightCorner": {
              "x": 9.649,
              "y": -4.678,
              "z": 1.058
            },
            "gtin": "4260189683609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b58",
            "leftCorner": {
              "x": 9.649,
              "y": -4.678,
              "z": 1.058
            },
            "rightCorner": {
              "x": 9.587,
              "y": -4.623,
              "z": 1.058
            },
            "gtin": "4260189683609",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b59",
            "leftCorner": {
              "x": 9.587,
              "y": -4.623,
              "z": 1.058
            },
            "rightCorner": {
              "x": 9.524,
              "y": -4.567,
              "z": 1.058
            },
            "gtin": "4260195540293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b5a",
            "leftCorner": {
              "x": 9.524,
              "y": -4.567,
              "z": 1.058
            },
            "rightCorner": {
              "x": 9.47,
              "y": -4.519,
              "z": 1.058
            },
            "gtin": "4260195540286",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b5b",
            "leftCorner": {
              "x": 9.47,
              "y": -4.519,
              "z": 1.058
            },
            "rightCorner": {
              "x": 9.41,
              "y": -4.465,
              "z": 1.058
            },
            "gtin": "4260195540286",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b5c",
            "leftCorner": {
              "x": 9.41,
              "y": -4.465,
              "z": 1.058
            },
            "rightCorner": {
              "x": 9.347,
              "y": -4.409,
              "z": 1.058
            },
            "gtin": "4066447675887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b52",
            "leftCorner": {
              "x": 9.347,
              "y": -4.409,
              "z": 1.058
            },
            "rightCorner": {
              "x": 9.299,
              "y": -4.366,
              "z": 1.058
            },
            "gtin": "4067796097245",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b5e",
        "height": 1.3142,
        "facings": [
          {
            "id": "696ebf7143c343680a271b5e",
            "leftCorner": {
              "x": 10.033,
              "y": -5.023,
              "z": 1.314
            },
            "rightCorner": {
              "x": 9.985,
              "y": -4.979,
              "z": 1.314
            },
            "gtin": "4005394200643",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b5f",
            "leftCorner": {
              "x": 9.985,
              "y": -4.979,
              "z": 1.314
            },
            "rightCorner": {
              "x": 9.904,
              "y": -4.908,
              "z": 1.314
            },
            "gtin": "4019339646007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b60",
            "leftCorner": {
              "x": 9.904,
              "y": -4.908,
              "z": 1.314
            },
            "rightCorner": {
              "x": 9.826,
              "y": -4.838,
              "z": 1.314
            },
            "gtin": "4019339646144",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b61",
            "leftCorner": {
              "x": 9.826,
              "y": -4.838,
              "z": 1.314
            },
            "rightCorner": {
              "x": 9.754,
              "y": -4.774,
              "z": 1.314
            },
            "gtin": "4019339646052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b62",
            "leftCorner": {
              "x": 9.754,
              "y": -4.774,
              "z": 1.314
            },
            "rightCorner": {
              "x": 9.683,
              "y": -4.71,
              "z": 1.314
            },
            "gtin": "4019339646113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b63",
            "leftCorner": {
              "x": 9.683,
              "y": -4.71,
              "z": 1.314
            },
            "rightCorner": {
              "x": 9.607,
              "y": -4.643,
              "z": 1.314
            },
            "gtin": "4019339646182",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b64",
            "leftCorner": {
              "x": 9.607,
              "y": -4.643,
              "z": 1.314
            },
            "rightCorner": {
              "x": 9.538,
              "y": -4.581,
              "z": 1.314
            },
            "gtin": "4019339646168",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b65",
            "leftCorner": {
              "x": 9.538,
              "y": -4.581,
              "z": 1.314
            },
            "rightCorner": {
              "x": 9.465,
              "y": -4.517,
              "z": 1.314
            },
            "gtin": "4019339641835",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b66",
            "leftCorner": {
              "x": 9.465,
              "y": -4.517,
              "z": 1.314
            },
            "rightCorner": {
              "x": 9.41,
              "y": -4.467,
              "z": 1.314
            },
            "gtin": "4019339641828",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b5d",
            "leftCorner": {
              "x": 9.41,
              "y": -4.467,
              "z": 1.314
            },
            "rightCorner": {
              "x": 9.297,
              "y": -4.367,
              "z": 1.314
            },
            "gtin": "4066447677652",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b63",
        "height": 1.5269,
        "facings": [
          {
            "id": "696ebf7143c343680a271bc4",
            "leftCorner": {
              "x": 10.051,
              "y": -5.025,
              "z": 1.527
            },
            "rightCorner": {
              "x": 9.947,
              "y": -4.932,
              "z": 1.527
            },
            "gtin": "4066447185324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bc5",
            "leftCorner": {
              "x": 9.947,
              "y": -4.932,
              "z": 1.527
            },
            "rightCorner": {
              "x": 9.839,
              "y": -4.835,
              "z": 1.527
            },
            "gtin": "4067796155204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bc6",
            "leftCorner": {
              "x": 9.839,
              "y": -4.835,
              "z": 1.527
            },
            "rightCorner": {
              "x": 9.72,
              "y": -4.729,
              "z": 1.527
            },
            "gtin": "4058172848742",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bc7",
            "leftCorner": {
              "x": 9.72,
              "y": -4.729,
              "z": 1.527
            },
            "rightCorner": {
              "x": 9.599,
              "y": -4.622,
              "z": 1.527
            },
            "gtin": "4066447884685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bc8",
            "leftCorner": {
              "x": 9.599,
              "y": -4.622,
              "z": 1.527
            },
            "rightCorner": {
              "x": 9.521,
              "y": -4.553,
              "z": 1.527
            },
            "gtin": "4067796196917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bc9",
            "leftCorner": {
              "x": 9.521,
              "y": -4.553,
              "z": 1.527
            },
            "rightCorner": {
              "x": 9.456,
              "y": -4.494,
              "z": 1.527
            },
            "gtin": "4066447580617",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bca",
            "leftCorner": {
              "x": 9.456,
              "y": -4.494,
              "z": 1.527
            },
            "rightCorner": {
              "x": 9.391,
              "y": -4.436,
              "z": 1.527
            },
            "gtin": "4067796196870",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bcb",
            "leftCorner": {
              "x": 9.391,
              "y": -4.436,
              "z": 1.527
            },
            "rightCorner": {
              "x": 9.325,
              "y": -4.378,
              "z": 1.527
            },
            "gtin": "4066447570007",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b61",
        "height": 1.7765,
        "facings": [
          {
            "id": "696ebf7043c343680a271aa5",
            "leftCorner": {
              "x": 10.06,
              "y": -5.028,
              "z": 1.775
            },
            "rightCorner": {
              "x": 9.989,
              "y": -4.964,
              "z": 1.775
            },
            "gtin": "4067796060959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271aa6",
            "leftCorner": {
              "x": 9.983,
              "y": -4.966,
              "z": 1.776
            },
            "rightCorner": {
              "x": 9.87,
              "y": -4.865,
              "z": 1.776
            },
            "gtin": "4067796002546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271aa7",
            "leftCorner": {
              "x": 9.87,
              "y": -4.865,
              "z": 1.776
            },
            "rightCorner": {
              "x": 9.752,
              "y": -4.759,
              "z": 1.776
            },
            "gtin": "4067796236194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271aa8",
            "leftCorner": {
              "x": 9.752,
              "y": -4.759,
              "z": 1.776
            },
            "rightCorner": {
              "x": 9.647,
              "y": -4.666,
              "z": 1.776
            }
          },
          {
            "id": "696ebf7043c343680a271aa9",
            "leftCorner": {
              "x": 9.647,
              "y": -4.666,
              "z": 1.776
            },
            "rightCorner": {
              "x": 9.565,
              "y": -4.593,
              "z": 1.776
            },
            "gtin": "4067796096347",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271aaa",
            "leftCorner": {
              "x": 9.565,
              "y": -4.593,
              "z": 1.776
            },
            "rightCorner": {
              "x": 9.478,
              "y": -4.515,
              "z": 1.776
            },
            "gtin": "4067796097337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271aab",
            "leftCorner": {
              "x": 9.478,
              "y": -4.515,
              "z": 1.776
            },
            "rightCorner": {
              "x": 9.393,
              "y": -4.44,
              "z": 1.776
            },
            "gtin": "4067796203028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271aac",
            "leftCorner": {
              "x": 9.393,
              "y": -4.44,
              "z": 1.776
            },
            "rightCorner": {
              "x": 9.347,
              "y": -4.399,
              "z": 1.776
            },
            "gtin": "4067796080599",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271aad",
            "leftCorner": {
              "x": 9.347,
              "y": -4.399,
              "z": 1.776
            },
            "rightCorner": {
              "x": 9.273,
              "y": -4.333,
              "z": 1.776
            },
            "gtin": "4067796066906",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7575bb5fe7bc0469599b0",
    "name": "68e7575bb5fe7bc0469599b0",
    "x": 9.2626,
    "y": -4.389,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93424,
      "w": 0.35665
    },
    "statistics": {
      "hasStockCount": 36,
      "noStockCount": 6,
      "unknownStockCount": 40
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73b68",
        "height": 0.20788,
        "facings": [
          {
            "id": "696ebf7143c343680a271b80",
            "leftCorner": {
              "x": 9.291,
              "y": -4.362,
              "z": 0.212
            },
            "rightCorner": {
              "x": 9.226,
              "y": -4.304,
              "z": 0.212
            },
            "gtin": "4067796083712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b81",
            "leftCorner": {
              "x": 9.221,
              "y": -4.292,
              "z": 0.208
            },
            "rightCorner": {
              "x": 9.16,
              "y": -4.237,
              "z": 0.208
            },
            "gtin": "4066447423761",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b82",
            "leftCorner": {
              "x": 9.16,
              "y": -4.237,
              "z": 0.208
            },
            "rightCorner": {
              "x": 9.111,
              "y": -4.193,
              "z": 0.208
            },
            "gtin": "4066447876383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b83",
            "leftCorner": {
              "x": 9.111,
              "y": -4.193,
              "z": 0.208
            },
            "rightCorner": {
              "x": 9.071,
              "y": -4.158,
              "z": 0.208
            },
            "gtin": "4066447876383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b84",
            "leftCorner": {
              "x": 9.071,
              "y": -4.158,
              "z": 0.208
            },
            "rightCorner": {
              "x": 9.036,
              "y": -4.127,
              "z": 0.208
            }
          },
          {
            "id": "696ebf7143c343680a271b85",
            "leftCorner": {
              "x": 9.036,
              "y": -4.127,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.996,
              "y": -4.09,
              "z": 0.208
            },
            "gtin": "4066447443332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b86",
            "leftCorner": {
              "x": 8.996,
              "y": -4.09,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.955,
              "y": -4.053,
              "z": 0.208
            },
            "gtin": "4067796032987",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b87",
            "leftCorner": {
              "x": 8.955,
              "y": -4.053,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.899,
              "y": -4.004,
              "z": 0.208
            },
            "gtin": "4067796083699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b88",
            "leftCorner": {
              "x": 8.899,
              "y": -4.004,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.849,
              "y": -3.959,
              "z": 0.208
            }
          },
          {
            "id": "696ebf7143c343680a271b89",
            "leftCorner": {
              "x": 8.849,
              "y": -3.959,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.817,
              "y": -3.931,
              "z": 0.208
            },
            "gtin": "4067796191264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b8a",
            "leftCorner": {
              "x": 8.817,
              "y": -3.931,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.784,
              "y": -3.901,
              "z": 0.208
            },
            "gtin": "4067796191288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b8b",
            "leftCorner": {
              "x": 8.784,
              "y": -3.901,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.749,
              "y": -3.869,
              "z": 0.208
            },
            "gtin": "4066447888119",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b8c",
            "leftCorner": {
              "x": 8.749,
              "y": -3.869,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.699,
              "y": -3.825,
              "z": 0.208
            },
            "gtin": "4066447888119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b8d",
            "leftCorner": {
              "x": 8.699,
              "y": -3.825,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.634,
              "y": -3.767,
              "z": 0.208
            },
            "gtin": "4066447195057",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b8e",
            "leftCorner": {
              "x": 8.634,
              "y": -3.767,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.559,
              "y": -3.7,
              "z": 0.208
            },
            "gtin": "4067796002423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b8f",
            "leftCorner": {
              "x": 8.559,
              "y": -3.7,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.508,
              "y": -3.654,
              "z": 0.208
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b66",
        "height": 0.55704,
        "facings": [
          {
            "id": "696ebf7143c343680a271bb9",
            "leftCorner": {
              "x": 9.287,
              "y": -4.353,
              "z": 0.557
            },
            "rightCorner": {
              "x": 9.23,
              "y": -4.302,
              "z": 0.557
            }
          },
          {
            "id": "696ebf7143c343680a271bba",
            "leftCorner": {
              "x": 9.23,
              "y": -4.302,
              "z": 0.557
            },
            "rightCorner": {
              "x": 9.144,
              "y": -4.225,
              "z": 0.557
            },
            "gtin": "4066447602685",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bbb",
            "leftCorner": {
              "x": 9.144,
              "y": -4.225,
              "z": 0.557
            },
            "rightCorner": {
              "x": 9.078,
              "y": -4.166,
              "z": 0.557
            },
            "gtin": "4058172504969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bbc",
            "leftCorner": {
              "x": 9.078,
              "y": -4.166,
              "z": 0.557
            },
            "rightCorner": {
              "x": 9.01,
              "y": -4.105,
              "z": 0.557
            },
            "gtin": "4058172504969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bbd",
            "leftCorner": {
              "x": 9.01,
              "y": -4.105,
              "z": 0.557
            },
            "rightCorner": {
              "x": 8.986,
              "y": -4.084,
              "z": 0.557
            }
          },
          {
            "id": "696ebf7143c343680a271bbe",
            "leftCorner": {
              "x": 8.986,
              "y": -4.084,
              "z": 0.557
            },
            "rightCorner": {
              "x": 8.905,
              "y": -4.011,
              "z": 0.557
            },
            "gtin": "4067796075519",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bbf",
            "leftCorner": {
              "x": 8.905,
              "y": -4.011,
              "z": 0.557
            },
            "rightCorner": {
              "x": 8.848,
              "y": -3.961,
              "z": 0.557
            },
            "gtin": "4066447490725",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bc0",
            "leftCorner": {
              "x": 8.848,
              "y": -3.961,
              "z": 0.557
            },
            "rightCorner": {
              "x": 8.8,
              "y": -3.918,
              "z": 0.557
            }
          },
          {
            "id": "696ebf7143c343680a271bc1",
            "leftCorner": {
              "x": 8.8,
              "y": -3.918,
              "z": 0.557
            },
            "rightCorner": {
              "x": 8.743,
              "y": -3.867,
              "z": 0.557
            },
            "gtin": "4067796063882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bc2",
            "leftCorner": {
              "x": 8.743,
              "y": -3.867,
              "z": 0.557
            },
            "rightCorner": {
              "x": 8.668,
              "y": -3.8,
              "z": 0.557
            },
            "gtin": "4067796063882",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bc3",
            "leftCorner": {
              "x": 8.668,
              "y": -3.8,
              "z": 0.557
            },
            "rightCorner": {
              "x": 8.608,
              "y": -3.746,
              "z": 0.557
            },
            "gtin": "4067796175318",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bb1",
            "leftCorner": {
              "x": 8.608,
              "y": -3.746,
              "z": 0.557
            },
            "rightCorner": {
              "x": 8.546,
              "y": -3.69,
              "z": 0.557
            },
            "gtin": "4067796175318",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b65",
        "height": 0.80784,
        "facings": [
          {
            "id": "696ebf7143c343680a271bf6",
            "leftCorner": {
              "x": 9.288,
              "y": -4.36,
              "z": 0.808
            },
            "rightCorner": {
              "x": 9.222,
              "y": -4.301,
              "z": 0.808
            },
            "gtin": "4250073450639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bf7",
            "leftCorner": {
              "x": 9.222,
              "y": -4.301,
              "z": 0.808
            },
            "rightCorner": {
              "x": 9.151,
              "y": -4.238,
              "z": 0.808
            },
            "gtin": "4250073450653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bf8",
            "leftCorner": {
              "x": 9.151,
              "y": -4.238,
              "z": 0.808
            },
            "rightCorner": {
              "x": 9.106,
              "y": -4.198,
              "z": 0.808
            },
            "gtin": "4250073461574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bf9",
            "leftCorner": {
              "x": 9.106,
              "y": -4.198,
              "z": 0.808
            },
            "rightCorner": {
              "x": 9.059,
              "y": -4.155,
              "z": 0.808
            },
            "gtin": "4250073462199",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bfa",
            "leftCorner": {
              "x": 9.059,
              "y": -4.155,
              "z": 0.808
            },
            "rightCorner": {
              "x": 9.007,
              "y": -4.109,
              "z": 0.808
            },
            "gtin": "4067796013702",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bfb",
            "leftCorner": {
              "x": 9.007,
              "y": -4.109,
              "z": 0.808
            },
            "rightCorner": {
              "x": 8.98,
              "y": -4.085,
              "z": 0.808
            }
          },
          {
            "id": "696ebf7143c343680a271bfc",
            "leftCorner": {
              "x": 8.98,
              "y": -4.085,
              "z": 0.808
            },
            "rightCorner": {
              "x": 8.956,
              "y": -4.064,
              "z": 0.808
            },
            "gtin": "4067796064308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bfd",
            "leftCorner": {
              "x": 8.956,
              "y": -4.064,
              "z": 0.808
            },
            "rightCorner": {
              "x": 8.933,
              "y": -4.043,
              "z": 0.808
            },
            "gtin": "4067796064308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bfe",
            "leftCorner": {
              "x": 8.933,
              "y": -4.043,
              "z": 0.808
            },
            "rightCorner": {
              "x": 8.911,
              "y": -4.023,
              "z": 0.808
            },
            "gtin": "4066447876468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bff",
            "leftCorner": {
              "x": 8.911,
              "y": -4.023,
              "z": 0.808
            },
            "rightCorner": {
              "x": 8.891,
              "y": -4.006,
              "z": 0.808
            },
            "gtin": "4066447876468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c00",
            "leftCorner": {
              "x": 8.891,
              "y": -4.006,
              "z": 0.808
            },
            "rightCorner": {
              "x": 8.816,
              "y": -3.938,
              "z": 0.808
            },
            "gtin": "4066447870770",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c01",
            "leftCorner": {
              "x": 8.816,
              "y": -3.938,
              "z": 0.808
            },
            "rightCorner": {
              "x": 8.766,
              "y": -3.894,
              "z": 0.808
            },
            "gtin": "4066447870411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c02",
            "leftCorner": {
              "x": 8.766,
              "y": -3.894,
              "z": 0.808
            },
            "rightCorner": {
              "x": 8.708,
              "y": -3.842,
              "z": 0.808
            },
            "gtin": "4067796147001",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c03",
            "leftCorner": {
              "x": 8.708,
              "y": -3.842,
              "z": 0.808
            },
            "rightCorner": {
              "x": 8.649,
              "y": -3.789,
              "z": 0.808
            },
            "gtin": "4067796147001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c04",
            "leftCorner": {
              "x": 8.649,
              "y": -3.789,
              "z": 0.808
            },
            "rightCorner": {
              "x": 8.559,
              "y": -3.709,
              "z": 0.808
            },
            "gtin": "4005394200650",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b67",
        "height": 1.0187,
        "facings": [
          {
            "id": "696ebf7143c343680a271c05",
            "leftCorner": {
              "x": 9.291,
              "y": -4.357,
              "z": 1.019
            },
            "rightCorner": {
              "x": 9.245,
              "y": -4.315,
              "z": 1.019
            },
            "gtin": "4066447377903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c06",
            "leftCorner": {
              "x": 9.245,
              "y": -4.315,
              "z": 1.019
            },
            "rightCorner": {
              "x": 9.193,
              "y": -4.269,
              "z": 1.019
            },
            "gtin": "4066447520590",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c07",
            "leftCorner": {
              "x": 9.193,
              "y": -4.269,
              "z": 1.019
            },
            "rightCorner": {
              "x": 9.152,
              "y": -4.232,
              "z": 1.019
            },
            "gtin": "4066447656909",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c08",
            "leftCorner": {
              "x": 9.152,
              "y": -4.232,
              "z": 1.019
            },
            "rightCorner": {
              "x": 9.105,
              "y": -4.19,
              "z": 1.019
            },
            "gtin": "4066447068184",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c09",
            "leftCorner": {
              "x": 9.105,
              "y": -4.19,
              "z": 1.019
            },
            "rightCorner": {
              "x": 9.035,
              "y": -4.127,
              "z": 1.019
            },
            "gtin": "4058172507960",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c0a",
            "leftCorner": {
              "x": 9.035,
              "y": -4.127,
              "z": 1.019
            },
            "rightCorner": {
              "x": 8.985,
              "y": -4.082,
              "z": 1.019
            },
            "gtin": "4058172507984",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c0b",
            "leftCorner": {
              "x": 8.985,
              "y": -4.082,
              "z": 1.019
            },
            "rightCorner": {
              "x": 8.961,
              "y": -4.061,
              "z": 1.019
            },
            "gtin": "4067796188356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c0c",
            "leftCorner": {
              "x": 8.961,
              "y": -4.061,
              "z": 1.019
            },
            "rightCorner": {
              "x": 8.936,
              "y": -4.039,
              "z": 1.019
            },
            "gtin": "4067796188356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c0d",
            "leftCorner": {
              "x": 8.936,
              "y": -4.039,
              "z": 1.019
            },
            "rightCorner": {
              "x": 8.886,
              "y": -3.995,
              "z": 1.019
            },
            "gtin": "4066447878295",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c0e",
            "leftCorner": {
              "x": 8.886,
              "y": -3.995,
              "z": 1.019
            },
            "rightCorner": {
              "x": 8.848,
              "y": -3.96,
              "z": 1.019
            },
            "gtin": "4066447672466",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c0f",
            "leftCorner": {
              "x": 8.848,
              "y": -3.96,
              "z": 1.019
            },
            "rightCorner": {
              "x": 8.794,
              "y": -3.912,
              "z": 1.019
            },
            "gtin": "4012346519104",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c10",
            "leftCorner": {
              "x": 8.794,
              "y": -3.912,
              "z": 1.019
            },
            "rightCorner": {
              "x": 8.747,
              "y": -3.87,
              "z": 1.019
            },
            "gtin": "4012346153605",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c11",
            "leftCorner": {
              "x": 8.747,
              "y": -3.87,
              "z": 1.019
            },
            "rightCorner": {
              "x": 8.686,
              "y": -3.815,
              "z": 1.019
            },
            "gtin": "4012346155104",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c12",
            "leftCorner": {
              "x": 8.686,
              "y": -3.815,
              "z": 1.019
            },
            "rightCorner": {
              "x": 8.614,
              "y": -3.752,
              "z": 1.019
            },
            "gtin": "4066447672480",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c13",
            "leftCorner": {
              "x": 8.614,
              "y": -3.752,
              "z": 1.019
            },
            "rightCorner": {
              "x": 8.546,
              "y": -3.691,
              "z": 1.019
            },
            "gtin": "4066447495409",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b69",
        "height": 1.2713,
        "facings": [
          {
            "id": "696ebf7143c343680a271c47",
            "leftCorner": {
              "x": 9.3,
              "y": -4.361,
              "z": 1.271
            },
            "rightCorner": {
              "x": 9.215,
              "y": -4.285,
              "z": 1.271
            },
            "gtin": "4066447375701",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c48",
            "leftCorner": {
              "x": 9.215,
              "y": -4.285,
              "z": 1.271
            },
            "rightCorner": {
              "x": 9.143,
              "y": -4.22,
              "z": 1.271
            },
            "gtin": "4058172333323",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c49",
            "leftCorner": {
              "x": 9.143,
              "y": -4.22,
              "z": 1.271
            },
            "rightCorner": {
              "x": 9.08,
              "y": -4.165,
              "z": 1.271
            },
            "gtin": "4058172989308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c4a",
            "leftCorner": {
              "x": 9.08,
              "y": -4.165,
              "z": 1.271
            },
            "rightCorner": {
              "x": 9.057,
              "y": -4.144,
              "z": 1.271
            },
            "gtin": "4058172989308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c4b",
            "leftCorner": {
              "x": 9.057,
              "y": -4.144,
              "z": 1.271
            },
            "rightCorner": {
              "x": 9.006,
              "y": -4.098,
              "z": 1.271
            }
          },
          {
            "id": "696ebf7143c343680a271c4c",
            "leftCorner": {
              "x": 9.006,
              "y": -4.098,
              "z": 1.271
            },
            "rightCorner": {
              "x": 8.983,
              "y": -4.078,
              "z": 1.271
            }
          },
          {
            "id": "696ebf7143c343680a271c4d",
            "leftCorner": {
              "x": 8.983,
              "y": -4.078,
              "z": 1.271
            },
            "rightCorner": {
              "x": 8.936,
              "y": -4.036,
              "z": 1.271
            },
            "gtin": "4058172989285",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c4e",
            "leftCorner": {
              "x": 8.936,
              "y": -4.036,
              "z": 1.271
            },
            "rightCorner": {
              "x": 8.915,
              "y": -4.017,
              "z": 1.271
            }
          },
          {
            "id": "696ebf7143c343680a271c4f",
            "leftCorner": {
              "x": 8.915,
              "y": -4.017,
              "z": 1.271
            },
            "rightCorner": {
              "x": 8.863,
              "y": -3.971,
              "z": 1.271
            },
            "gtin": "4058172989285",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c50",
            "leftCorner": {
              "x": 8.863,
              "y": -3.971,
              "z": 1.271
            },
            "rightCorner": {
              "x": 8.825,
              "y": -3.936,
              "z": 1.271
            },
            "gtin": "4058172640858",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c51",
            "leftCorner": {
              "x": 8.825,
              "y": -3.936,
              "z": 1.271
            },
            "rightCorner": {
              "x": 8.686,
              "y": -3.812,
              "z": 1.271
            },
            "gtin": "4005924108029",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c52",
            "leftCorner": {
              "x": 8.686,
              "y": -3.812,
              "z": 1.271
            },
            "rightCorner": {
              "x": 8.568,
              "y": -3.707,
              "z": 1.271
            },
            "gtin": "4005924108036",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b6a",
        "height": 1.526,
        "facings": [
          {
            "id": "696ebf7143c343680a271bcc",
            "leftCorner": {
              "x": 9.325,
              "y": -4.378,
              "z": 1.527
            },
            "rightCorner": {
              "x": 9.268,
              "y": -4.327,
              "z": 1.527
            },
            "gtin": "4067796202731",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bcd",
            "leftCorner": {
              "x": 9.26,
              "y": -4.319,
              "z": 1.526
            },
            "rightCorner": {
              "x": 9.187,
              "y": -4.254,
              "z": 1.526
            },
            "gtin": "4067796252019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bce",
            "leftCorner": {
              "x": 9.187,
              "y": -4.254,
              "z": 1.526
            },
            "rightCorner": {
              "x": 9.11,
              "y": -4.186,
              "z": 1.526
            },
            "gtin": "4067796251999",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bcf",
            "leftCorner": {
              "x": 9.11,
              "y": -4.186,
              "z": 1.526
            },
            "rightCorner": {
              "x": 9.046,
              "y": -4.128,
              "z": 1.526
            },
            "gtin": "4067796066883",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bd0",
            "leftCorner": {
              "x": 9.046,
              "y": -4.128,
              "z": 1.526
            },
            "rightCorner": {
              "x": 9.021,
              "y": -4.106,
              "z": 1.526
            }
          },
          {
            "id": "696ebf7143c343680a271bd1",
            "leftCorner": {
              "x": 9.021,
              "y": -4.106,
              "z": 1.526
            },
            "rightCorner": {
              "x": 8.974,
              "y": -4.064,
              "z": 1.526
            },
            "gtin": "4067796251913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bd2",
            "leftCorner": {
              "x": 8.974,
              "y": -4.064,
              "z": 1.526
            },
            "rightCorner": {
              "x": 8.952,
              "y": -4.044,
              "z": 1.526
            },
            "gtin": "4067796251913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bd3",
            "leftCorner": {
              "x": 8.952,
              "y": -4.044,
              "z": 1.526
            },
            "rightCorner": {
              "x": 8.854,
              "y": -3.957,
              "z": 1.526
            },
            "gtin": "4066447884883",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bd4",
            "leftCorner": {
              "x": 8.854,
              "y": -3.957,
              "z": 1.526
            },
            "rightCorner": {
              "x": 8.773,
              "y": -3.885,
              "z": 1.526
            },
            "gtin": "4019339437124",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bd5",
            "leftCorner": {
              "x": 8.773,
              "y": -3.885,
              "z": 1.526
            },
            "rightCorner": {
              "x": 8.67,
              "y": -3.792,
              "z": 1.526
            },
            "gtin": "4005394287866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bd6",
            "leftCorner": {
              "x": 8.67,
              "y": -3.792,
              "z": 1.526
            },
            "rightCorner": {
              "x": 8.583,
              "y": -3.714,
              "z": 1.526
            },
            "gtin": "4005394287675",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bd7",
            "leftCorner": {
              "x": 8.583,
              "y": -3.714,
              "z": 1.526
            },
            "rightCorner": {
              "x": 8.532,
              "y": -3.669,
              "z": 1.526
            },
            "gtin": "4005394287675",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b64",
        "height": 1.7757,
        "facings": [
          {
            "id": "696ebf7043c343680a271aae",
            "leftCorner": {
              "x": 9.269,
              "y": -4.32,
              "z": 1.776
            },
            "rightCorner": {
              "x": 9.171,
              "y": -4.232,
              "z": 1.776
            },
            "gtin": "4066447377941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271aaf",
            "leftCorner": {
              "x": 9.171,
              "y": -4.232,
              "z": 1.776
            },
            "rightCorner": {
              "x": 9.12,
              "y": -4.186,
              "z": 1.776
            },
            "gtin": "4067796185195",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ab0",
            "leftCorner": {
              "x": 9.12,
              "y": -4.186,
              "z": 1.776
            },
            "rightCorner": {
              "x": 9.069,
              "y": -4.14,
              "z": 1.776
            },
            "gtin": "4066447443318",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ab1",
            "leftCorner": {
              "x": 9.069,
              "y": -4.14,
              "z": 1.776
            },
            "rightCorner": {
              "x": 9.041,
              "y": -4.115,
              "z": 1.776
            },
            "gtin": "4066447443318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271ab2",
            "leftCorner": {
              "x": 9.041,
              "y": -4.115,
              "z": 1.776
            },
            "rightCorner": {
              "x": 8.978,
              "y": -4.059,
              "z": 1.776
            },
            "gtin": "4066447519662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271ab3",
            "leftCorner": {
              "x": 8.978,
              "y": -4.059,
              "z": 1.776
            },
            "rightCorner": {
              "x": 8.955,
              "y": -4.039,
              "z": 1.776
            }
          },
          {
            "id": "696ebf7043c343680a271ab4",
            "leftCorner": {
              "x": 8.955,
              "y": -4.039,
              "z": 1.776
            },
            "rightCorner": {
              "x": 8.882,
              "y": -3.974,
              "z": 1.776
            },
            "gtin": "4067796066418",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ab5",
            "leftCorner": {
              "x": 8.882,
              "y": -3.974,
              "z": 1.776
            },
            "rightCorner": {
              "x": 8.811,
              "y": -3.91,
              "z": 1.776
            },
            "gtin": "4066447600612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271ab6",
            "leftCorner": {
              "x": 8.811,
              "y": -3.91,
              "z": 1.776
            },
            "rightCorner": {
              "x": 8.712,
              "y": -3.822,
              "z": 1.776
            },
            "gtin": "4005394200681",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ab7",
            "leftCorner": {
              "x": 8.712,
              "y": -3.822,
              "z": 1.776
            },
            "rightCorner": {
              "x": 8.66,
              "y": -3.775,
              "z": 1.776
            },
            "gtin": "4005394201459",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ab8",
            "leftCorner": {
              "x": 8.66,
              "y": -3.775,
              "z": 1.776
            },
            "rightCorner": {
              "x": 8.637,
              "y": -3.755,
              "z": 1.776
            },
            "gtin": "4005394201459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271ab9",
            "leftCorner": {
              "x": 8.637,
              "y": -3.755,
              "z": 1.776
            },
            "rightCorner": {
              "x": 8.55,
              "y": -3.677,
              "z": 1.776
            },
            "gtin": "4005394200766",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7575bb5fe7bc0469599b1",
    "name": "68e7575bb5fe7bc0469599b1",
    "x": 8.5035,
    "y": -3.7194,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93406,
      "w": 0.35711
    },
    "statistics": {
      "hasStockCount": 17,
      "noStockCount": 4,
      "unknownStockCount": 49
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73b70",
        "height": 0.20442,
        "facings": [
          {
            "id": "696ebf7143c343680a271b90",
            "leftCorner": {
              "x": 8.494,
              "y": -3.651,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.438,
              "y": -3.6,
              "z": 0.204
            },
            "gtin": "4058172783319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b91",
            "leftCorner": {
              "x": 8.438,
              "y": -3.6,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.411,
              "y": -3.576,
              "z": 0.204
            }
          },
          {
            "id": "696ebf7143c343680a271b92",
            "leftCorner": {
              "x": 8.411,
              "y": -3.576,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.39,
              "y": -3.557,
              "z": 0.204
            }
          },
          {
            "id": "696ebf7143c343680a271b93",
            "leftCorner": {
              "x": 8.39,
              "y": -3.557,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.344,
              "y": -3.516,
              "z": 0.204
            },
            "gtin": "4066447104318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b94",
            "leftCorner": {
              "x": 8.344,
              "y": -3.516,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.267,
              "y": -3.447,
              "z": 0.204
            },
            "gtin": "4058172830488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b95",
            "leftCorner": {
              "x": 8.267,
              "y": -3.447,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.191,
              "y": -3.379,
              "z": 0.204
            },
            "gtin": "4066447104332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b96",
            "leftCorner": {
              "x": 8.191,
              "y": -3.379,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.026,
              "y": -3.231,
              "z": 0.204
            },
            "gtin": "4066447416275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b97",
            "leftCorner": {
              "x": 8.026,
              "y": -3.231,
              "z": 0.204
            },
            "rightCorner": {
              "x": 7.963,
              "y": -3.175,
              "z": 0.204
            },
            "gtin": "4066447104417",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b98",
            "leftCorner": {
              "x": 7.963,
              "y": -3.175,
              "z": 0.204
            },
            "rightCorner": {
              "x": 7.877,
              "y": -3.098,
              "z": 0.204
            },
            "gtin": "4066447104417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b99",
            "leftCorner": {
              "x": 7.877,
              "y": -3.098,
              "z": 0.204
            },
            "rightCorner": {
              "x": 7.79,
              "y": -3.02,
              "z": 0.204
            },
            "gtin": "4066447104394",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b71",
        "height": 0.47152,
        "facings": [
          {
            "id": "696ebf7143c343680a271c7a",
            "leftCorner": {
              "x": 8.528,
              "y": -3.692,
              "z": 0.472
            },
            "rightCorner": {
              "x": 8.443,
              "y": -3.616,
              "z": 0.472
            },
            "gtin": "4067796011968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c7c",
            "leftCorner": {
              "x": 8.443,
              "y": -3.616,
              "z": 0.472
            },
            "rightCorner": {
              "x": 8.421,
              "y": -3.596,
              "z": 0.472
            }
          },
          {
            "id": "696ebf7143c343680a271c7d",
            "leftCorner": {
              "x": 8.421,
              "y": -3.596,
              "z": 0.472
            },
            "rightCorner": {
              "x": 8.389,
              "y": -3.567,
              "z": 0.472
            }
          },
          {
            "id": "696ebf7143c343680a271c7e",
            "leftCorner": {
              "x": 8.389,
              "y": -3.567,
              "z": 0.472
            },
            "rightCorner": {
              "x": 8.328,
              "y": -3.513,
              "z": 0.472
            },
            "gtin": "4066447796193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c7f",
            "leftCorner": {
              "x": 8.328,
              "y": -3.513,
              "z": 0.472
            },
            "rightCorner": {
              "x": 8.265,
              "y": -3.456,
              "z": 0.472
            },
            "gtin": "4058172329098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c80",
            "leftCorner": {
              "x": 8.265,
              "y": -3.456,
              "z": 0.472
            },
            "rightCorner": {
              "x": 8.191,
              "y": -3.39,
              "z": 0.472
            },
            "gtin": "4066447759099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c81",
            "leftCorner": {
              "x": 8.191,
              "y": -3.39,
              "z": 0.472
            },
            "rightCorner": {
              "x": 8.082,
              "y": -3.292,
              "z": 0.472
            },
            "gtin": "4066447475944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c82",
            "leftCorner": {
              "x": 8.082,
              "y": -3.292,
              "z": 0.472
            },
            "rightCorner": {
              "x": 8.015,
              "y": -3.232,
              "z": 0.472
            },
            "gtin": "4066447600698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c83",
            "leftCorner": {
              "x": 8.015,
              "y": -3.232,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.925,
              "y": -3.152,
              "z": 0.472
            },
            "gtin": "4066447600650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c84",
            "leftCorner": {
              "x": 7.925,
              "y": -3.152,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.835,
              "y": -3.071,
              "z": 0.472
            },
            "gtin": "4066447600674",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c85",
            "leftCorner": {
              "x": 7.835,
              "y": -3.071,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.755,
              "y": -2.999,
              "z": 0.472
            },
            "gtin": "4066447767377",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b6c",
        "height": 0.72143,
        "facings": [
          {
            "id": "696ebf7143c343680a271c6e",
            "leftCorner": {
              "x": 8.534,
              "y": -3.685,
              "z": 0.721
            },
            "rightCorner": {
              "x": 8.444,
              "y": -3.605,
              "z": 0.721
            },
            "gtin": "4066447980868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c6f",
            "leftCorner": {
              "x": 8.444,
              "y": -3.605,
              "z": 0.721
            },
            "rightCorner": {
              "x": 8.422,
              "y": -3.585,
              "z": 0.721
            },
            "gtin": "4066447619911",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c70",
            "leftCorner": {
              "x": 8.422,
              "y": -3.585,
              "z": 0.721
            },
            "rightCorner": {
              "x": 8.383,
              "y": -3.55,
              "z": 0.721
            },
            "gtin": "4066447619911",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c71",
            "leftCorner": {
              "x": 8.383,
              "y": -3.55,
              "z": 0.721
            },
            "rightCorner": {
              "x": 8.324,
              "y": -3.497,
              "z": 0.721
            },
            "gtin": "4067796175295",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c72",
            "leftCorner": {
              "x": 8.324,
              "y": -3.497,
              "z": 0.721
            },
            "rightCorner": {
              "x": 8.277,
              "y": -3.455,
              "z": 0.721
            },
            "gtin": "4058172389528",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c73",
            "leftCorner": {
              "x": 8.277,
              "y": -3.455,
              "z": 0.721
            },
            "rightCorner": {
              "x": 8.187,
              "y": -3.374,
              "z": 0.721
            },
            "gtin": "4066447759129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c74",
            "leftCorner": {
              "x": 8.187,
              "y": -3.374,
              "z": 0.721
            },
            "rightCorner": {
              "x": 8.118,
              "y": -3.313,
              "z": 0.721
            },
            "gtin": "4066447732559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c75",
            "leftCorner": {
              "x": 8.118,
              "y": -3.313,
              "z": 0.721
            },
            "rightCorner": {
              "x": 8.059,
              "y": -3.26,
              "z": 0.721
            },
            "gtin": "4066447867664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c76",
            "leftCorner": {
              "x": 8.059,
              "y": -3.26,
              "z": 0.721
            },
            "rightCorner": {
              "x": 7.991,
              "y": -3.199,
              "z": 0.721
            },
            "gtin": "4058172470158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c77",
            "leftCorner": {
              "x": 7.991,
              "y": -3.199,
              "z": 0.721
            },
            "rightCorner": {
              "x": 7.922,
              "y": -3.138,
              "z": 0.721
            }
          },
          {
            "id": "696ebf7143c343680a271c78",
            "leftCorner": {
              "x": 7.922,
              "y": -3.138,
              "z": 0.721
            },
            "rightCorner": {
              "x": 7.855,
              "y": -3.077,
              "z": 0.721
            },
            "gtin": "4066447576283",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c79",
            "leftCorner": {
              "x": 7.855,
              "y": -3.077,
              "z": 0.721
            },
            "rightCorner": {
              "x": 7.809,
              "y": -3.036,
              "z": 0.721
            },
            "gtin": "4066447104806",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b6b",
        "height": 1.0169,
        "facings": [
          {
            "id": "696ebf7143c343680a271c14",
            "leftCorner": {
              "x": 8.537,
              "y": -3.682,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.479,
              "y": -3.63,
              "z": 1.017
            },
            "gtin": "4066447874143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c15",
            "leftCorner": {
              "x": 8.479,
              "y": -3.63,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.454,
              "y": -3.607,
              "z": 1.017
            },
            "gtin": "4066447874167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c16",
            "leftCorner": {
              "x": 8.454,
              "y": -3.607,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.393,
              "y": -3.553,
              "z": 1.017
            },
            "gtin": "4066447874167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c17",
            "leftCorner": {
              "x": 8.393,
              "y": -3.553,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.278,
              "y": -3.45,
              "z": 1.017
            },
            "gtin": "4066447672688",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c18",
            "leftCorner": {
              "x": 8.278,
              "y": -3.45,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.208,
              "y": -3.388,
              "z": 1.017
            },
            "gtin": "4058172716232",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c19",
            "leftCorner": {
              "x": 8.208,
              "y": -3.388,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.15,
              "y": -3.336,
              "z": 1.017
            },
            "gtin": "4066447680300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c1a",
            "leftCorner": {
              "x": 8.15,
              "y": -3.336,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.117,
              "y": -3.306,
              "z": 1.017
            },
            "gtin": "4066447680300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c1b",
            "leftCorner": {
              "x": 8.117,
              "y": -3.306,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.035,
              "y": -3.233,
              "z": 1.017
            },
            "gtin": "4066447510089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c1c",
            "leftCorner": {
              "x": 8.035,
              "y": -3.233,
              "z": 1.017
            },
            "rightCorner": {
              "x": 7.949,
              "y": -3.155,
              "z": 1.017
            },
            "gtin": "4066447758849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c1d",
            "leftCorner": {
              "x": 7.949,
              "y": -3.155,
              "z": 1.017
            },
            "rightCorner": {
              "x": 7.869,
              "y": -3.084,
              "z": 1.017
            },
            "gtin": "4070765007411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c1e",
            "leftCorner": {
              "x": 7.869,
              "y": -3.084,
              "z": 1.017
            },
            "rightCorner": {
              "x": 7.792,
              "y": -3.015,
              "z": 1.017
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b6d",
        "height": 1.2689,
        "facings": [
          {
            "id": "696ebf7143c343680a271c53",
            "leftCorner": {
              "x": 8.568,
              "y": -3.707,
              "z": 1.271
            },
            "rightCorner": {
              "x": 8.52,
              "y": -3.664,
              "z": 1.271
            },
            "gtin": "4066447973952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c54",
            "leftCorner": {
              "x": 8.511,
              "y": -3.656,
              "z": 1.269
            },
            "rightCorner": {
              "x": 8.478,
              "y": -3.627,
              "z": 1.269
            },
            "gtin": "4066447973952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c55",
            "leftCorner": {
              "x": 8.478,
              "y": -3.627,
              "z": 1.269
            },
            "rightCorner": {
              "x": 8.431,
              "y": -3.585,
              "z": 1.269
            },
            "gtin": "4066447973952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c56",
            "leftCorner": {
              "x": 8.431,
              "y": -3.585,
              "z": 1.269
            },
            "rightCorner": {
              "x": 8.398,
              "y": -3.555,
              "z": 1.269
            },
            "gtin": "4066447105414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c57",
            "leftCorner": {
              "x": 8.398,
              "y": -3.555,
              "z": 1.269
            },
            "rightCorner": {
              "x": 8.304,
              "y": -3.471,
              "z": 1.269
            },
            "gtin": "4066447105438",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c58",
            "leftCorner": {
              "x": 8.304,
              "y": -3.471,
              "z": 1.269
            },
            "rightCorner": {
              "x": 8.24,
              "y": -3.414,
              "z": 1.269
            },
            "gtin": "4058172330087",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c59",
            "leftCorner": {
              "x": 8.24,
              "y": -3.414,
              "z": 1.269
            },
            "rightCorner": {
              "x": 8.16,
              "y": -3.342,
              "z": 1.269
            },
            "gtin": "4066447784404",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c5a",
            "leftCorner": {
              "x": 8.16,
              "y": -3.342,
              "z": 1.269
            },
            "rightCorner": {
              "x": 8.06,
              "y": -3.253,
              "z": 1.269
            },
            "gtin": "4066447884869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c5b",
            "leftCorner": {
              "x": 8.06,
              "y": -3.253,
              "z": 1.269
            },
            "rightCorner": {
              "x": 7.976,
              "y": -3.177,
              "z": 1.269
            },
            "gtin": "4066447732672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c5c",
            "leftCorner": {
              "x": 7.976,
              "y": -3.177,
              "z": 1.269
            },
            "rightCorner": {
              "x": 7.816,
              "y": -3.035,
              "z": 1.269
            },
            "gtin": "4066447707540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c5d",
            "leftCorner": {
              "x": 7.816,
              "y": -3.035,
              "z": 1.269
            },
            "rightCorner": {
              "x": 7.737,
              "y": -2.964,
              "z": 1.269
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b6e",
        "height": 1.5241,
        "facings": [
          {
            "id": "696ebf7143c343680a271bd8",
            "leftCorner": {
              "x": 8.525,
              "y": -3.658,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.502,
              "y": -3.637,
              "z": 1.524
            }
          },
          {
            "id": "696ebf7143c343680a271bd9",
            "leftCorner": {
              "x": 8.502,
              "y": -3.637,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.451,
              "y": -3.592,
              "z": 1.524
            },
            "gtin": "4066447212426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bda",
            "leftCorner": {
              "x": 8.451,
              "y": -3.592,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.411,
              "y": -3.556,
              "z": 1.524
            },
            "gtin": "4066447212426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bdb",
            "leftCorner": {
              "x": 8.411,
              "y": -3.556,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.348,
              "y": -3.5,
              "z": 1.524
            },
            "gtin": "4066447671803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bdc",
            "leftCorner": {
              "x": 8.348,
              "y": -3.5,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.284,
              "y": -3.442,
              "z": 1.524
            },
            "gtin": "4067796054149",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bdd",
            "leftCorner": {
              "x": 8.284,
              "y": -3.442,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.21,
              "y": -3.376,
              "z": 1.524
            },
            "gtin": "4066447248692",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bde",
            "leftCorner": {
              "x": 8.21,
              "y": -3.376,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.141,
              "y": -3.315,
              "z": 1.524
            },
            "gtin": "4066447304954",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bdf",
            "leftCorner": {
              "x": 8.141,
              "y": -3.315,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.058,
              "y": -3.24,
              "z": 1.524
            },
            "gtin": "4066447703863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271be0",
            "leftCorner": {
              "x": 8.058,
              "y": -3.24,
              "z": 1.524
            },
            "rightCorner": {
              "x": 7.984,
              "y": -3.174,
              "z": 1.524
            },
            "gtin": "4066447375800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271be1",
            "leftCorner": {
              "x": 7.984,
              "y": -3.174,
              "z": 1.524
            },
            "rightCorner": {
              "x": 7.915,
              "y": -3.112,
              "z": 1.524
            },
            "gtin": "4066447375848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271be2",
            "leftCorner": {
              "x": 7.915,
              "y": -3.112,
              "z": 1.524
            },
            "rightCorner": {
              "x": 7.799,
              "y": -3.008,
              "z": 1.524
            },
            "gtin": "4066447873238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271be3",
            "leftCorner": {
              "x": 7.817,
              "y": -3.015,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.792,
              "y": -2.993,
              "z": 1.526
            },
            "gtin": "4067796210644",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b6f",
        "height": 1.7748,
        "facings": [
          {
            "id": "696ebf7043c343680a271aba",
            "leftCorner": {
              "x": 8.55,
              "y": -3.677,
              "z": 1.776
            },
            "rightCorner": {
              "x": 8.5,
              "y": -3.632,
              "z": 1.776
            },
            "gtin": "4066447985191",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271abb",
            "leftCorner": {
              "x": 8.488,
              "y": -3.627,
              "z": 1.775
            },
            "rightCorner": {
              "x": 8.429,
              "y": -3.574,
              "z": 1.775
            },
            "gtin": "4066447873214",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271abc",
            "leftCorner": {
              "x": 8.429,
              "y": -3.574,
              "z": 1.775
            },
            "rightCorner": {
              "x": 8.372,
              "y": -3.523,
              "z": 1.775
            },
            "gtin": "4066447763270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271abd",
            "leftCorner": {
              "x": 8.372,
              "y": -3.523,
              "z": 1.775
            },
            "rightCorner": {
              "x": 8.303,
              "y": -3.461,
              "z": 1.775
            },
            "gtin": "4066447874587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271abe",
            "leftCorner": {
              "x": 8.303,
              "y": -3.461,
              "z": 1.775
            },
            "rightCorner": {
              "x": 8.218,
              "y": -3.385,
              "z": 1.775
            },
            "gtin": "4058172925146",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271abf",
            "leftCorner": {
              "x": 8.218,
              "y": -3.385,
              "z": 1.775
            },
            "rightCorner": {
              "x": 8.139,
              "y": -3.314,
              "z": 1.775
            },
            "gtin": "4066447889444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271ac0",
            "leftCorner": {
              "x": 8.139,
              "y": -3.314,
              "z": 1.775
            },
            "rightCorner": {
              "x": 8.08,
              "y": -3.261,
              "z": 1.775
            },
            "gtin": "4066447395440",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ac1",
            "leftCorner": {
              "x": 8.08,
              "y": -3.261,
              "z": 1.775
            },
            "rightCorner": {
              "x": 8.01,
              "y": -3.199,
              "z": 1.775
            },
            "gtin": "4067796166040",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ac2",
            "leftCorner": {
              "x": 8.01,
              "y": -3.199,
              "z": 1.775
            },
            "rightCorner": {
              "x": 7.914,
              "y": -3.113,
              "z": 1.775
            },
            "gtin": "4066447656879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271ac3",
            "leftCorner": {
              "x": 7.914,
              "y": -3.113,
              "z": 1.775
            },
            "rightCorner": {
              "x": 7.813,
              "y": -3.022,
              "z": 1.775
            },
            "gtin": "4066447761290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271ac4",
            "leftCorner": {
              "x": 7.813,
              "y": -3.022,
              "z": 1.775
            },
            "rightCorner": {
              "x": 7.733,
              "y": -2.951,
              "z": 1.775
            },
            "gtin": "4058172893094",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7575bb5fe7bc0469599b2",
    "name": "68e7575bb5fe7bc0469599b2",
    "x": 7.7757,
    "y": -3.0618,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93384,
      "w": 0.35769
    },
    "statistics": {
      "hasStockCount": 24,
      "noStockCount": 6,
      "unknownStockCount": 23
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73b79",
        "height": 0.21084,
        "facings": [
          {
            "id": "696ebf7143c343680a271b9a",
            "leftCorner": {
              "x": 7.79,
              "y": -3.02,
              "z": 0.204
            },
            "rightCorner": {
              "x": 7.7,
              "y": -2.94,
              "z": 0.204
            },
            "gtin": "4067796181463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b9b",
            "leftCorner": {
              "x": 7.717,
              "y": -2.949,
              "z": 0.211
            },
            "rightCorner": {
              "x": 7.632,
              "y": -2.872,
              "z": 0.211
            }
          },
          {
            "id": "696ebf7143c343680a271b9c",
            "leftCorner": {
              "x": 7.632,
              "y": -2.872,
              "z": 0.211
            },
            "rightCorner": {
              "x": 7.562,
              "y": -2.809,
              "z": 0.211
            }
          },
          {
            "id": "696ebf7143c343680a271b9d",
            "leftCorner": {
              "x": 7.562,
              "y": -2.809,
              "z": 0.211
            },
            "rightCorner": {
              "x": 7.376,
              "y": -2.643,
              "z": 0.211
            },
            "gtin": "4067796180091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271b9e",
            "leftCorner": {
              "x": 7.376,
              "y": -2.643,
              "z": 0.211
            },
            "rightCorner": {
              "x": 7.278,
              "y": -2.555,
              "z": 0.211
            },
            "gtin": "4067796181487",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271b9f",
            "leftCorner": {
              "x": 7.278,
              "y": -2.555,
              "z": 0.211
            },
            "rightCorner": {
              "x": 7.165,
              "y": -2.453,
              "z": 0.211
            }
          },
          {
            "id": "696ebf7143c343680a271ba0",
            "leftCorner": {
              "x": 7.165,
              "y": -2.453,
              "z": 0.211
            },
            "rightCorner": {
              "x": 7.065,
              "y": -2.364,
              "z": 0.211
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b78",
        "height": 0.47252,
        "facings": [
          {
            "id": "696ebf7143c343680a271c86",
            "leftCorner": {
              "x": 7.776,
              "y": -3.004,
              "z": 0.473
            },
            "rightCorner": {
              "x": 7.701,
              "y": -2.937,
              "z": 0.473
            },
            "gtin": "4058172307461",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c87",
            "leftCorner": {
              "x": 7.701,
              "y": -2.937,
              "z": 0.473
            },
            "rightCorner": {
              "x": 7.63,
              "y": -2.874,
              "z": 0.473
            }
          },
          {
            "id": "696ebf7143c343680a271c88",
            "leftCorner": {
              "x": 7.63,
              "y": -2.874,
              "z": 0.473
            },
            "rightCorner": {
              "x": 7.543,
              "y": -2.795,
              "z": 0.473
            },
            "gtin": "4067796181500",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c89",
            "leftCorner": {
              "x": 7.543,
              "y": -2.795,
              "z": 0.473
            },
            "rightCorner": {
              "x": 7.453,
              "y": -2.714,
              "z": 0.473
            },
            "gtin": "4067796081466",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c8a",
            "leftCorner": {
              "x": 7.453,
              "y": -2.714,
              "z": 0.473
            },
            "rightCorner": {
              "x": 7.36,
              "y": -2.631,
              "z": 0.473
            },
            "gtin": "4067796081428",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c8b",
            "leftCorner": {
              "x": 7.36,
              "y": -2.631,
              "z": 0.473
            },
            "rightCorner": {
              "x": 7.284,
              "y": -2.562,
              "z": 0.473
            },
            "gtin": "4058172464522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c8c",
            "leftCorner": {
              "x": 7.284,
              "y": -2.562,
              "z": 0.473
            },
            "rightCorner": {
              "x": 7.224,
              "y": -2.509,
              "z": 0.473
            },
            "gtin": "4058172464522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c8d",
            "leftCorner": {
              "x": 7.224,
              "y": -2.509,
              "z": 0.473
            },
            "rightCorner": {
              "x": 7.155,
              "y": -2.447,
              "z": 0.473
            },
            "gtin": "4067796149012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c8e",
            "leftCorner": {
              "x": 7.155,
              "y": -2.447,
              "z": 0.473
            },
            "rightCorner": {
              "x": 7.089,
              "y": -2.387,
              "z": 0.473
            },
            "gtin": "4067796149012",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b73",
        "height": 0.76317,
        "facings": [
          {
            "id": "696ebf7143c343680a271ca6",
            "leftCorner": {
              "x": 7.806,
              "y": -3.028,
              "z": 0.763
            },
            "rightCorner": {
              "x": 7.73,
              "y": -2.96,
              "z": 0.763
            },
            "gtin": "4067796063332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ca8",
            "leftCorner": {
              "x": 7.73,
              "y": -2.96,
              "z": 0.763
            },
            "rightCorner": {
              "x": 7.669,
              "y": -2.906,
              "z": 0.763
            },
            "gtin": "4067796063332",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ca9",
            "leftCorner": {
              "x": 7.669,
              "y": -2.906,
              "z": 0.763
            },
            "rightCorner": {
              "x": 7.6,
              "y": -2.844,
              "z": 0.763
            },
            "gtin": "4067796063332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271caa",
            "leftCorner": {
              "x": 7.6,
              "y": -2.844,
              "z": 0.763
            },
            "rightCorner": {
              "x": 7.536,
              "y": -2.786,
              "z": 0.763
            }
          },
          {
            "id": "696ebf7143c343680a271cab",
            "leftCorner": {
              "x": 7.536,
              "y": -2.786,
              "z": 0.763
            },
            "rightCorner": {
              "x": 7.471,
              "y": -2.727,
              "z": 0.763
            },
            "gtin": "4067796063318",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cac",
            "leftCorner": {
              "x": 7.471,
              "y": -2.727,
              "z": 0.763
            },
            "rightCorner": {
              "x": 7.412,
              "y": -2.675,
              "z": 0.763
            },
            "gtin": "4067796193893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cad",
            "leftCorner": {
              "x": 7.412,
              "y": -2.675,
              "z": 0.763
            },
            "rightCorner": {
              "x": 7.349,
              "y": -2.618,
              "z": 0.763
            },
            "gtin": "4067796217407",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cae",
            "leftCorner": {
              "x": 7.349,
              "y": -2.618,
              "z": 0.763
            },
            "rightCorner": {
              "x": 7.267,
              "y": -2.545,
              "z": 0.763
            }
          },
          {
            "id": "696ebf7143c343680a271caf",
            "leftCorner": {
              "x": 7.267,
              "y": -2.545,
              "z": 0.763
            },
            "rightCorner": {
              "x": 7.212,
              "y": -2.495,
              "z": 0.763
            },
            "gtin": "4067796063295",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cb0",
            "leftCorner": {
              "x": 7.212,
              "y": -2.495,
              "z": 0.763
            },
            "rightCorner": {
              "x": 7.152,
              "y": -2.442,
              "z": 0.763
            },
            "gtin": "4067796063295",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cb1",
            "leftCorner": {
              "x": 7.152,
              "y": -2.442,
              "z": 0.763
            },
            "rightCorner": {
              "x": 7.095,
              "y": -2.39,
              "z": 0.763
            },
            "gtin": "4067796063295",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b74",
        "height": 1.0174,
        "facings": [
          {
            "id": "696ebf7143c343680a271c1f",
            "leftCorner": {
              "x": 7.792,
              "y": -3.015,
              "z": 1.017
            },
            "rightCorner": {
              "x": 7.72,
              "y": -2.95,
              "z": 1.017
            },
            "gtin": "4066447148220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c20",
            "leftCorner": {
              "x": 7.736,
              "y": -2.962,
              "z": 1.017
            },
            "rightCorner": {
              "x": 7.665,
              "y": -2.898,
              "z": 1.017
            },
            "gtin": "4067796156591",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c21",
            "leftCorner": {
              "x": 7.665,
              "y": -2.898,
              "z": 1.017
            },
            "rightCorner": {
              "x": 7.576,
              "y": -2.818,
              "z": 1.017
            },
            "gtin": "4066447678598",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c22",
            "leftCorner": {
              "x": 7.576,
              "y": -2.818,
              "z": 1.017
            },
            "rightCorner": {
              "x": 7.498,
              "y": -2.748,
              "z": 1.017
            },
            "gtin": "4067796194036",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c23",
            "leftCorner": {
              "x": 7.498,
              "y": -2.748,
              "z": 1.017
            },
            "rightCorner": {
              "x": 7.423,
              "y": -2.681,
              "z": 1.017
            },
            "gtin": "4066447148190",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c24",
            "leftCorner": {
              "x": 7.423,
              "y": -2.681,
              "z": 1.017
            },
            "rightCorner": {
              "x": 7.366,
              "y": -2.629,
              "z": 1.017
            },
            "gtin": "4066447148190",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c25",
            "leftCorner": {
              "x": 7.366,
              "y": -2.629,
              "z": 1.017
            },
            "rightCorner": {
              "x": 7.305,
              "y": -2.575,
              "z": 1.017
            },
            "gtin": "4066447877007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c26",
            "leftCorner": {
              "x": 7.305,
              "y": -2.575,
              "z": 1.017
            },
            "rightCorner": {
              "x": 7.155,
              "y": -2.44,
              "z": 1.017
            },
            "gtin": "4067796010398",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c27",
            "leftCorner": {
              "x": 7.155,
              "y": -2.44,
              "z": 1.017
            },
            "rightCorner": {
              "x": 7.085,
              "y": -2.377,
              "z": 1.017
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b75",
        "height": 1.2719,
        "facings": [
          {
            "id": "696ebf7143c343680a271c5e",
            "leftCorner": {
              "x": 7.757,
              "y": -2.971,
              "z": 1.272
            },
            "rightCorner": {
              "x": 7.681,
              "y": -2.903,
              "z": 1.272
            },
            "gtin": "4066447607543",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c5f",
            "leftCorner": {
              "x": 7.681,
              "y": -2.903,
              "z": 1.272
            },
            "rightCorner": {
              "x": 7.61,
              "y": -2.839,
              "z": 1.272
            },
            "gtin": "4066447607543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c60",
            "leftCorner": {
              "x": 7.61,
              "y": -2.839,
              "z": 1.272
            },
            "rightCorner": {
              "x": 7.535,
              "y": -2.772,
              "z": 1.272
            },
            "gtin": "4066447607529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c61",
            "leftCorner": {
              "x": 7.535,
              "y": -2.772,
              "z": 1.272
            },
            "rightCorner": {
              "x": 7.452,
              "y": -2.697,
              "z": 1.272
            },
            "gtin": "4066447607529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c62",
            "leftCorner": {
              "x": 7.452,
              "y": -2.697,
              "z": 1.272
            },
            "rightCorner": {
              "x": 7.378,
              "y": -2.631,
              "z": 1.272
            },
            "gtin": "4067796081626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c63",
            "leftCorner": {
              "x": 7.378,
              "y": -2.631,
              "z": 1.272
            },
            "rightCorner": {
              "x": 7.303,
              "y": -2.564,
              "z": 1.272
            },
            "gtin": "4067796081626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c64",
            "leftCorner": {
              "x": 7.303,
              "y": -2.564,
              "z": 1.272
            },
            "rightCorner": {
              "x": 7.221,
              "y": -2.49,
              "z": 1.272
            },
            "gtin": "4066447615968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c65",
            "leftCorner": {
              "x": 7.221,
              "y": -2.49,
              "z": 1.272
            },
            "rightCorner": {
              "x": 7.14,
              "y": -2.418,
              "z": 1.272
            }
          },
          {
            "id": "696ebf7143c343680a271c66",
            "leftCorner": {
              "x": 7.14,
              "y": -2.418,
              "z": 1.272
            },
            "rightCorner": {
              "x": 7.052,
              "y": -2.339,
              "z": 1.272
            },
            "gtin": "4067796079401",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b76",
        "height": 1.5256,
        "facings": [
          {
            "id": "696ebf7143c343680a271be4",
            "leftCorner": {
              "x": 7.792,
              "y": -2.993,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.717,
              "y": -2.926,
              "z": 1.526
            },
            "gtin": "4067796210620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271be5",
            "leftCorner": {
              "x": 7.717,
              "y": -2.926,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.648,
              "y": -2.863,
              "z": 1.526
            },
            "gtin": "4019339636183",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271be6",
            "leftCorner": {
              "x": 7.648,
              "y": -2.863,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.573,
              "y": -2.796,
              "z": 1.526
            },
            "gtin": "4019339636022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271be7",
            "leftCorner": {
              "x": 7.573,
              "y": -2.796,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.496,
              "y": -2.727,
              "z": 1.526
            },
            "gtin": "4019339636107",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271be8",
            "leftCorner": {
              "x": 7.496,
              "y": -2.727,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.415,
              "y": -2.654,
              "z": 1.526
            },
            "gtin": "4260697373320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271be9",
            "leftCorner": {
              "x": 7.415,
              "y": -2.654,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.331,
              "y": -2.579,
              "z": 1.526
            },
            "gtin": "4260697373153",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bea",
            "leftCorner": {
              "x": 7.331,
              "y": -2.579,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.266,
              "y": -2.52,
              "z": 1.526
            },
            "gtin": "4038507005606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271beb",
            "leftCorner": {
              "x": 7.266,
              "y": -2.52,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.176,
              "y": -2.439,
              "z": 1.526
            },
            "gtin": "9004617067167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bec",
            "leftCorner": {
              "x": 7.176,
              "y": -2.439,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.094,
              "y": -2.366,
              "z": 1.526
            },
            "gtin": "9004617066580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bed",
            "leftCorner": {
              "x": 7.094,
              "y": -2.366,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.073,
              "y": -2.347,
              "z": 1.526
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b77",
        "height": 1.7741,
        "facings": [
          {
            "id": "696ebf7043c343680a271ac5",
            "leftCorner": {
              "x": 7.755,
              "y": -2.955,
              "z": 1.774
            },
            "rightCorner": {
              "x": 7.674,
              "y": -2.882,
              "z": 1.774
            }
          },
          {
            "id": "696ebf7043c343680a271ac6",
            "leftCorner": {
              "x": 7.674,
              "y": -2.882,
              "z": 1.774
            },
            "rightCorner": {
              "x": 7.605,
              "y": -2.821,
              "z": 1.774
            },
            "gtin": "4260686520100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ac7",
            "leftCorner": {
              "x": 7.605,
              "y": -2.821,
              "z": 1.774
            },
            "rightCorner": {
              "x": 7.53,
              "y": -2.753,
              "z": 1.774
            },
            "gtin": "4280001782273",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ac8",
            "leftCorner": {
              "x": 7.53,
              "y": -2.753,
              "z": 1.774
            },
            "rightCorner": {
              "x": 7.461,
              "y": -2.691,
              "z": 1.774
            },
            "gtin": "4260686523132",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ac9",
            "leftCorner": {
              "x": 7.461,
              "y": -2.691,
              "z": 1.774
            },
            "rightCorner": {
              "x": 7.397,
              "y": -2.634,
              "z": 1.774
            },
            "gtin": "4260686523170",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271aca",
            "leftCorner": {
              "x": 7.397,
              "y": -2.634,
              "z": 1.774
            },
            "rightCorner": {
              "x": 7.328,
              "y": -2.572,
              "z": 1.774
            },
            "gtin": "4260686524795",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271acb",
            "leftCorner": {
              "x": 7.328,
              "y": -2.572,
              "z": 1.774
            },
            "rightCorner": {
              "x": 7.268,
              "y": -2.518,
              "z": 1.774
            },
            "gtin": "4260159455502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271acc",
            "leftCorner": {
              "x": 7.268,
              "y": -2.518,
              "z": 1.774
            },
            "rightCorner": {
              "x": 7.181,
              "y": -2.44,
              "z": 1.774
            },
            "gtin": "4260159456271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271acd",
            "leftCorner": {
              "x": 7.181,
              "y": -2.44,
              "z": 1.774
            },
            "rightCorner": {
              "x": 7.091,
              "y": -2.359,
              "z": 1.774
            },
            "gtin": "4260159455519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271ace",
            "leftCorner": {
              "x": 7.091,
              "y": -2.359,
              "z": 1.774
            },
            "rightCorner": {
              "x": 7.072,
              "y": -2.342,
              "z": 1.774
            }
          }
        ]
      }
    ]
  },
  {
    "id": "68e7575bb5fe7bc0469599b3",
    "name": "68e7575bb5fe7bc0469599b3",
    "x": 7.0334,
    "y": -2.3962,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93451,
      "w": 0.35594
    },
    "statistics": {
      "hasStockCount": 15,
      "noStockCount": 3,
      "unknownStockCount": 27
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73b7e",
        "height": 0.20857,
        "facings": [
          {
            "id": "696ebf7143c343680a271ba1",
            "leftCorner": {
              "x": 7.065,
              "y": -2.363,
              "z": 0.211
            },
            "rightCorner": {
              "x": 6.972,
              "y": -2.28,
              "z": 0.211
            },
            "gtin": "4058172307324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ba2",
            "leftCorner": {
              "x": 6.973,
              "y": -2.283,
              "z": 0.209
            },
            "rightCorner": {
              "x": 6.946,
              "y": -2.259,
              "z": 0.209
            }
          },
          {
            "id": "696ebf7143c343680a271ba3",
            "leftCorner": {
              "x": 6.946,
              "y": -2.259,
              "z": 0.209
            },
            "rightCorner": {
              "x": 6.83,
              "y": -2.156,
              "z": 0.209
            },
            "gtin": "4067796147575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ba4",
            "leftCorner": {
              "x": 6.83,
              "y": -2.156,
              "z": 0.209
            },
            "rightCorner": {
              "x": 6.719,
              "y": -2.057,
              "z": 0.209
            }
          },
          {
            "id": "696ebf7143c343680a271ba5",
            "leftCorner": {
              "x": 6.719,
              "y": -2.057,
              "z": 0.209
            },
            "rightCorner": {
              "x": 6.619,
              "y": -1.968,
              "z": 0.209
            },
            "gtin": "4066447663075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ba6",
            "leftCorner": {
              "x": 6.619,
              "y": -1.968,
              "z": 0.209
            },
            "rightCorner": {
              "x": 6.425,
              "y": -1.795,
              "z": 0.209
            }
          },
          {
            "id": "696ebf7143c343680a271ba7",
            "leftCorner": {
              "x": 6.425,
              "y": -1.795,
              "z": 0.209
            },
            "rightCorner": {
              "x": 6.27,
              "y": -1.657,
              "z": 0.209
            },
            "gtin": "4067796081404",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b7c",
        "height": 0.47026,
        "facings": [
          {
            "id": "696ebf7143c343680a271c8f",
            "leftCorner": {
              "x": 7.089,
              "y": -2.387,
              "z": 0.473
            },
            "rightCorner": {
              "x": 6.99,
              "y": -2.299,
              "z": 0.473
            },
            "gtin": "4066447607598",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c90",
            "leftCorner": {
              "x": 6.988,
              "y": -2.305,
              "z": 0.47
            },
            "rightCorner": {
              "x": 6.903,
              "y": -2.23,
              "z": 0.47
            },
            "gtin": "4066447607574",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c91",
            "leftCorner": {
              "x": 6.903,
              "y": -2.23,
              "z": 0.47
            },
            "rightCorner": {
              "x": 6.814,
              "y": -2.15,
              "z": 0.47
            },
            "gtin": "4066447607574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c92",
            "leftCorner": {
              "x": 6.814,
              "y": -2.15,
              "z": 0.47
            },
            "rightCorner": {
              "x": 6.794,
              "y": -2.133,
              "z": 0.47
            }
          },
          {
            "id": "696ebf7143c343680a271c93",
            "leftCorner": {
              "x": 6.794,
              "y": -2.133,
              "z": 0.47
            },
            "rightCorner": {
              "x": 6.73,
              "y": -2.075,
              "z": 0.47
            },
            "gtin": "4066447524772",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c94",
            "leftCorner": {
              "x": 6.73,
              "y": -2.075,
              "z": 0.47
            },
            "rightCorner": {
              "x": 6.637,
              "y": -1.993,
              "z": 0.47
            },
            "gtin": "4066447524772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c95",
            "leftCorner": {
              "x": 6.637,
              "y": -1.993,
              "z": 0.47
            },
            "rightCorner": {
              "x": 6.553,
              "y": -1.917,
              "z": 0.47
            },
            "gtin": "4066447607567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c96",
            "leftCorner": {
              "x": 6.553,
              "y": -1.917,
              "z": 0.47
            },
            "rightCorner": {
              "x": 6.475,
              "y": -1.848,
              "z": 0.47
            }
          },
          {
            "id": "696ebf7143c343680a271c97",
            "leftCorner": {
              "x": 6.475,
              "y": -1.848,
              "z": 0.47
            },
            "rightCorner": {
              "x": 6.394,
              "y": -1.776,
              "z": 0.47
            },
            "gtin": "4066447524413",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c98",
            "leftCorner": {
              "x": 6.394,
              "y": -1.776,
              "z": 0.47
            },
            "rightCorner": {
              "x": 6.304,
              "y": -1.696,
              "z": 0.47
            },
            "gtin": "4066447524413",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b80",
        "height": 0.76203,
        "facings": [
          {
            "id": "696ebf7143c343680a271cb2",
            "leftCorner": {
              "x": 7.095,
              "y": -2.39,
              "z": 0.763
            },
            "rightCorner": {
              "x": 6.997,
              "y": -2.302,
              "z": 0.763
            },
            "gtin": "4067796000283",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cb3",
            "leftCorner": {
              "x": 6.996,
              "y": -2.307,
              "z": 0.762
            },
            "rightCorner": {
              "x": 6.881,
              "y": -2.204,
              "z": 0.762
            }
          },
          {
            "id": "696ebf7143c343680a271cb4",
            "leftCorner": {
              "x": 6.881,
              "y": -2.204,
              "z": 0.762
            },
            "rightCorner": {
              "x": 6.774,
              "y": -2.109,
              "z": 0.762
            }
          },
          {
            "id": "696ebf7143c343680a271cb5",
            "leftCorner": {
              "x": 6.774,
              "y": -2.109,
              "z": 0.762
            },
            "rightCorner": {
              "x": 6.679,
              "y": -2.024,
              "z": 0.762
            },
            "gtin": "4066447530209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cb6",
            "leftCorner": {
              "x": 6.679,
              "y": -2.024,
              "z": 0.762
            },
            "rightCorner": {
              "x": 6.59,
              "y": -1.945,
              "z": 0.762
            }
          },
          {
            "id": "696ebf7143c343680a271cb7",
            "leftCorner": {
              "x": 6.59,
              "y": -1.945,
              "z": 0.762
            },
            "rightCorner": {
              "x": 6.496,
              "y": -1.861,
              "z": 0.762
            },
            "gtin": "4067796000245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cb8",
            "leftCorner": {
              "x": 6.496,
              "y": -1.861,
              "z": 0.762
            },
            "rightCorner": {
              "x": 6.406,
              "y": -1.781,
              "z": 0.762
            },
            "gtin": "4067796000306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ca7",
            "leftCorner": {
              "x": 6.406,
              "y": -1.781,
              "z": 0.762
            },
            "rightCorner": {
              "x": 6.315,
              "y": -1.699,
              "z": 0.762
            },
            "gtin": "4067796000306",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b7a",
        "height": 1.0147,
        "facings": [
          {
            "id": "696ebf7143c343680a271c28",
            "leftCorner": {
              "x": 7.085,
              "y": -2.377,
              "z": 1.017
            },
            "rightCorner": {
              "x": 6.992,
              "y": -2.293,
              "z": 1.017
            },
            "gtin": "4066447607550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c29",
            "leftCorner": {
              "x": 6.983,
              "y": -2.307,
              "z": 1.015
            },
            "rightCorner": {
              "x": 6.874,
              "y": -2.209,
              "z": 1.015
            },
            "gtin": "4067796057089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c2a",
            "leftCorner": {
              "x": 6.874,
              "y": -2.209,
              "z": 1.015
            },
            "rightCorner": {
              "x": 6.785,
              "y": -2.129,
              "z": 1.015
            }
          },
          {
            "id": "696ebf7143c343680a271c2b",
            "leftCorner": {
              "x": 6.785,
              "y": -2.129,
              "z": 1.015
            },
            "rightCorner": {
              "x": 6.681,
              "y": -2.037,
              "z": 1.015
            },
            "gtin": "4067796066760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c2c",
            "leftCorner": {
              "x": 6.681,
              "y": -2.037,
              "z": 1.015
            },
            "rightCorner": {
              "x": 6.595,
              "y": -1.961,
              "z": 1.015
            },
            "gtin": "4067796000221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c2d",
            "leftCorner": {
              "x": 6.595,
              "y": -1.961,
              "z": 1.015
            },
            "rightCorner": {
              "x": 6.507,
              "y": -1.882,
              "z": 1.015
            },
            "gtin": "4067796000221",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c2e",
            "leftCorner": {
              "x": 6.507,
              "y": -1.882,
              "z": 1.015
            },
            "rightCorner": {
              "x": 6.414,
              "y": -1.799,
              "z": 1.015
            },
            "gtin": "4067796000269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c2f",
            "leftCorner": {
              "x": 6.414,
              "y": -1.799,
              "z": 1.015
            },
            "rightCorner": {
              "x": 6.314,
              "y": -1.71,
              "z": 1.015
            },
            "gtin": "4067796000269",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b7f",
        "height": 1.2698,
        "facings": [
          {
            "id": "696ebf7143c343680a271c67",
            "leftCorner": {
              "x": 7.046,
              "y": -2.35,
              "z": 1.27
            },
            "rightCorner": {
              "x": 6.977,
              "y": -2.289,
              "z": 1.27
            },
            "gtin": "4067796062281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c68",
            "leftCorner": {
              "x": 6.977,
              "y": -2.289,
              "z": 1.27
            },
            "rightCorner": {
              "x": 6.952,
              "y": -2.266,
              "z": 1.27
            },
            "gtin": "4067796062281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c69",
            "leftCorner": {
              "x": 6.952,
              "y": -2.266,
              "z": 1.27
            },
            "rightCorner": {
              "x": 6.887,
              "y": -2.208,
              "z": 1.27
            }
          },
          {
            "id": "696ebf7143c343680a271c6a",
            "leftCorner": {
              "x": 6.887,
              "y": -2.208,
              "z": 1.27
            },
            "rightCorner": {
              "x": 6.702,
              "y": -2.043,
              "z": 1.27
            },
            "gtin": "4066447954951",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c6b",
            "leftCorner": {
              "x": 6.702,
              "y": -2.043,
              "z": 1.27
            },
            "rightCorner": {
              "x": 6.547,
              "y": -1.906,
              "z": 1.27
            },
            "gtin": "4067796191325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c6c",
            "leftCorner": {
              "x": 6.547,
              "y": -1.906,
              "z": 1.27
            },
            "rightCorner": {
              "x": 6.466,
              "y": -1.833,
              "z": 1.27
            },
            "gtin": "4260519490525",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c6d",
            "leftCorner": {
              "x": 6.466,
              "y": -1.833,
              "z": 1.27
            },
            "rightCorner": {
              "x": 6.35,
              "y": -1.73,
              "z": 1.27
            },
            "gtin": "4260519490495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c46",
            "leftCorner": {
              "x": 6.35,
              "y": -1.73,
              "z": 1.27
            },
            "rightCorner": {
              "x": 6.315,
              "y": -1.699,
              "z": 1.27
            },
            "gtin": "4260519490518",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b7b",
        "height": 1.5223,
        "facings": [
          {
            "id": "696ebf7143c343680a271bee",
            "leftCorner": {
              "x": 7.068,
              "y": -2.358,
              "z": 1.522
            },
            "rightCorner": {
              "x": 6.852,
              "y": -2.165,
              "z": 1.522
            },
            "gtin": "4066447370072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bef",
            "leftCorner": {
              "x": 6.852,
              "y": -2.165,
              "z": 1.522
            },
            "rightCorner": {
              "x": 6.719,
              "y": -2.047,
              "z": 1.522
            },
            "gtin": "4067796162462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bf0",
            "leftCorner": {
              "x": 6.719,
              "y": -2.047,
              "z": 1.522
            },
            "rightCorner": {
              "x": 6.604,
              "y": -1.945,
              "z": 1.522
            },
            "gtin": "4067796072310",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271bf1",
            "leftCorner": {
              "x": 6.604,
              "y": -1.945,
              "z": 1.522
            },
            "rightCorner": {
              "x": 6.533,
              "y": -1.881,
              "z": 1.522
            },
            "gtin": "4066447707267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bf2",
            "leftCorner": {
              "x": 6.533,
              "y": -1.881,
              "z": 1.522
            },
            "rightCorner": {
              "x": 6.477,
              "y": -1.832,
              "z": 1.522
            }
          },
          {
            "id": "696ebf7143c343680a271bf3",
            "leftCorner": {
              "x": 6.477,
              "y": -1.832,
              "z": 1.522
            },
            "rightCorner": {
              "x": 6.399,
              "y": -1.762,
              "z": 1.522
            }
          },
          {
            "id": "696ebf7143c343680a271bf4",
            "leftCorner": {
              "x": 6.399,
              "y": -1.762,
              "z": 1.522
            },
            "rightCorner": {
              "x": 6.361,
              "y": -1.728,
              "z": 1.522
            },
            "gtin": "4066447707243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bf5",
            "leftCorner": {
              "x": 6.361,
              "y": -1.728,
              "z": 1.522
            },
            "rightCorner": {
              "x": 6.317,
              "y": -1.689,
              "z": 1.522
            },
            "gtin": "4066447707243",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b7d",
        "height": 1.7725,
        "facings": [
          {
            "id": "696ebf7043c343680a271acf",
            "leftCorner": {
              "x": 7.072,
              "y": -2.342,
              "z": 1.774
            },
            "rightCorner": {
              "x": 6.997,
              "y": -2.275,
              "z": 1.774
            },
            "gtin": "4260159450224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271ad0",
            "leftCorner": {
              "x": 6.992,
              "y": -2.285,
              "z": 1.773
            },
            "rightCorner": {
              "x": 6.967,
              "y": -2.262,
              "z": 1.773
            }
          },
          {
            "id": "696ebf7043c343680a271ad1",
            "leftCorner": {
              "x": 6.967,
              "y": -2.262,
              "z": 1.773
            },
            "rightCorner": {
              "x": 6.866,
              "y": -2.172,
              "z": 1.773
            },
            "gtin": "4260467420179",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ad2",
            "leftCorner": {
              "x": 6.866,
              "y": -2.172,
              "z": 1.773
            },
            "rightCorner": {
              "x": 6.762,
              "y": -2.08,
              "z": 1.773
            },
            "gtin": "4066447184303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271ad3",
            "leftCorner": {
              "x": 6.762,
              "y": -2.08,
              "z": 1.773
            },
            "rightCorner": {
              "x": 6.656,
              "y": -1.985,
              "z": 1.773
            },
            "gtin": "4066447869163",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ad4",
            "leftCorner": {
              "x": 6.656,
              "y": -1.985,
              "z": 1.773
            },
            "rightCorner": {
              "x": 6.531,
              "y": -1.873,
              "z": 1.773
            },
            "gtin": "4066447677003",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ad5",
            "leftCorner": {
              "x": 6.531,
              "y": -1.873,
              "z": 1.773
            },
            "rightCorner": {
              "x": 6.485,
              "y": -1.832,
              "z": 1.773
            },
            "gtin": "4058172777912",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ad6",
            "leftCorner": {
              "x": 6.485,
              "y": -1.832,
              "z": 1.773
            },
            "rightCorner": {
              "x": 6.434,
              "y": -1.787,
              "z": 1.773
            },
            "gtin": "4058172777851",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ad7",
            "leftCorner": {
              "x": 6.434,
              "y": -1.787,
              "z": 1.773
            },
            "rightCorner": {
              "x": 6.301,
              "y": -1.669,
              "z": 1.773
            },
            "gtin": "4058172777875",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7575bb5fe7bc0469599b4",
    "name": "68e7575bb5fe7bc0469599b4",
    "x": 6.2792,
    "y": -1.7169,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93645,
      "w": 0.35081
    },
    "statistics": {
      "hasStockCount": 44,
      "noStockCount": 1,
      "unknownStockCount": 37
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73b88",
        "height": 0.20496,
        "facings": [
          {
            "id": "696ebf7143c343680a271ba8",
            "leftCorner": {
              "x": 6.262,
              "y": -1.642,
              "z": 0.205
            },
            "rightCorner": {
              "x": 5.936,
              "y": -1.358,
              "z": 0.205
            },
            "gtin": "4067796000207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ba9",
            "leftCorner": {
              "x": 5.936,
              "y": -1.358,
              "z": 0.205
            },
            "rightCorner": {
              "x": 5.811,
              "y": -1.249,
              "z": 0.205
            },
            "gtin": "4067796002126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271baa",
            "leftCorner": {
              "x": 5.811,
              "y": -1.249,
              "z": 0.205
            },
            "rightCorner": {
              "x": 5.702,
              "y": -1.154,
              "z": 0.205
            },
            "gtin": "4067796002041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bab",
            "leftCorner": {
              "x": 5.702,
              "y": -1.154,
              "z": 0.205
            },
            "rightCorner": {
              "x": 5.556,
              "y": -1.027,
              "z": 0.205
            },
            "gtin": "4067796002041",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b86",
        "height": 0.46603,
        "facings": [
          {
            "id": "696ebf7143c343680a271c99",
            "leftCorner": {
              "x": 6.295,
              "y": -1.682,
              "z": 0.466
            },
            "rightCorner": {
              "x": 6.14,
              "y": -1.547,
              "z": 0.466
            }
          },
          {
            "id": "696ebf7143c343680a271c9a",
            "leftCorner": {
              "x": 6.14,
              "y": -1.547,
              "z": 0.466
            },
            "rightCorner": {
              "x": 5.991,
              "y": -1.417,
              "z": 0.466
            },
            "gtin": "7394376623042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c9b",
            "leftCorner": {
              "x": 5.991,
              "y": -1.417,
              "z": 0.466
            },
            "rightCorner": {
              "x": 5.935,
              "y": -1.369,
              "z": 0.466
            },
            "gtin": "4038375024396",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c9c",
            "leftCorner": {
              "x": 5.935,
              "y": -1.369,
              "z": 0.466
            },
            "rightCorner": {
              "x": 5.915,
              "y": -1.351,
              "z": 0.466
            }
          },
          {
            "id": "696ebf7143c343680a271c9d",
            "leftCorner": {
              "x": 5.915,
              "y": -1.351,
              "z": 0.466
            },
            "rightCorner": {
              "x": 5.805,
              "y": -1.255,
              "z": 0.466
            },
            "gtin": "4038375025928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c9e",
            "leftCorner": {
              "x": 5.805,
              "y": -1.255,
              "z": 0.466
            },
            "rightCorner": {
              "x": 5.694,
              "y": -1.158,
              "z": 0.466
            },
            "gtin": "4038375025300",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c9f",
            "leftCorner": {
              "x": 5.694,
              "y": -1.158,
              "z": 0.466
            },
            "rightCorner": {
              "x": 5.571,
              "y": -1.051,
              "z": 0.466
            },
            "gtin": "4067796002027",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b87",
        "height": 0.80188,
        "facings": [
          {
            "id": "696ebf7143c343680a271ced",
            "leftCorner": {
              "x": 6.305,
              "y": -1.687,
              "z": 0.802
            },
            "rightCorner": {
              "x": 6.245,
              "y": -1.634,
              "z": 0.802
            },
            "gtin": "4067796064759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cee",
            "leftCorner": {
              "x": 6.245,
              "y": -1.634,
              "z": 0.802
            },
            "rightCorner": {
              "x": 6.121,
              "y": -1.526,
              "z": 0.802
            },
            "gtin": "4067796064797",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cef",
            "leftCorner": {
              "x": 6.121,
              "y": -1.526,
              "z": 0.802
            },
            "rightCorner": {
              "x": 6.066,
              "y": -1.478,
              "z": 0.802
            },
            "gtin": "4067796064797",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cf0",
            "leftCorner": {
              "x": 6.066,
              "y": -1.478,
              "z": 0.802
            },
            "rightCorner": {
              "x": 6.016,
              "y": -1.435,
              "z": 0.802
            },
            "gtin": "4066447219951",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cf1",
            "leftCorner": {
              "x": 6.016,
              "y": -1.435,
              "z": 0.802
            },
            "rightCorner": {
              "x": 5.945,
              "y": -1.373,
              "z": 0.802
            },
            "gtin": "4066447219951",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cf2",
            "leftCorner": {
              "x": 5.945,
              "y": -1.373,
              "z": 0.802
            },
            "rightCorner": {
              "x": 5.914,
              "y": -1.346,
              "z": 0.802
            }
          },
          {
            "id": "696ebf7143c343680a271cf3",
            "leftCorner": {
              "x": 5.914,
              "y": -1.346,
              "z": 0.802
            },
            "rightCorner": {
              "x": 5.889,
              "y": -1.324,
              "z": 0.802
            },
            "gtin": "4066447219975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cf4",
            "leftCorner": {
              "x": 5.889,
              "y": -1.324,
              "z": 0.802
            },
            "rightCorner": {
              "x": 5.841,
              "y": -1.282,
              "z": 0.802
            },
            "gtin": "4066447219975",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cf5",
            "leftCorner": {
              "x": 5.841,
              "y": -1.282,
              "z": 0.802
            },
            "rightCorner": {
              "x": 5.785,
              "y": -1.233,
              "z": 0.802
            },
            "gtin": "4066447863567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cf6",
            "leftCorner": {
              "x": 5.785,
              "y": -1.233,
              "z": 0.802
            },
            "rightCorner": {
              "x": 5.737,
              "y": -1.191,
              "z": 0.802
            },
            "gtin": "4066447863567",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cf7",
            "leftCorner": {
              "x": 5.737,
              "y": -1.191,
              "z": 0.802
            },
            "rightCorner": {
              "x": 5.684,
              "y": -1.145,
              "z": 0.802
            },
            "gtin": "4067796072464",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cf8",
            "leftCorner": {
              "x": 5.684,
              "y": -1.145,
              "z": 0.802
            },
            "rightCorner": {
              "x": 5.619,
              "y": -1.088,
              "z": 0.802
            },
            "gtin": "4067796072464",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cf9",
            "leftCorner": {
              "x": 5.619,
              "y": -1.088,
              "z": 0.802
            },
            "rightCorner": {
              "x": 5.57,
              "y": -1.046,
              "z": 0.802
            },
            "gtin": "4067796041491",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b82",
        "height": 1.0164,
        "facings": [
          {
            "id": "696ebf7143c343680a271c30",
            "leftCorner": {
              "x": 6.305,
              "y": -1.688,
              "z": 1.016
            },
            "rightCorner": {
              "x": 6.232,
              "y": -1.623,
              "z": 1.016
            },
            "gtin": "4066447486193",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c31",
            "leftCorner": {
              "x": 6.232,
              "y": -1.624,
              "z": 1.016
            },
            "rightCorner": {
              "x": 6.153,
              "y": -1.555,
              "z": 1.016
            },
            "gtin": "4058172921544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c32",
            "leftCorner": {
              "x": 6.153,
              "y": -1.555,
              "z": 1.016
            },
            "rightCorner": {
              "x": 6.098,
              "y": -1.508,
              "z": 1.016
            },
            "gtin": "4066447709605",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c33",
            "leftCorner": {
              "x": 6.098,
              "y": -1.508,
              "z": 1.016
            },
            "rightCorner": {
              "x": 6.055,
              "y": -1.47,
              "z": 1.016
            },
            "gtin": "4066447486155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c34",
            "leftCorner": {
              "x": 6.055,
              "y": -1.47,
              "z": 1.016
            },
            "rightCorner": {
              "x": 5.992,
              "y": -1.415,
              "z": 1.016
            },
            "gtin": "4066447614503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c35",
            "leftCorner": {
              "x": 5.992,
              "y": -1.415,
              "z": 1.016
            },
            "rightCorner": {
              "x": 5.944,
              "y": -1.373,
              "z": 1.016
            },
            "gtin": "4058172349287",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c36",
            "leftCorner": {
              "x": 5.944,
              "y": -1.373,
              "z": 1.016
            },
            "rightCorner": {
              "x": 5.882,
              "y": -1.319,
              "z": 1.016
            },
            "gtin": "4066447910674",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c37",
            "leftCorner": {
              "x": 5.882,
              "y": -1.319,
              "z": 1.016
            },
            "rightCorner": {
              "x": 5.805,
              "y": -1.252,
              "z": 1.016
            },
            "gtin": "4067796010831",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c38",
            "leftCorner": {
              "x": 5.805,
              "y": -1.252,
              "z": 1.016
            },
            "rightCorner": {
              "x": 5.758,
              "y": -1.211,
              "z": 1.016
            },
            "gtin": "4067796203639",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c39",
            "leftCorner": {
              "x": 5.758,
              "y": -1.211,
              "z": 1.016
            },
            "rightCorner": {
              "x": 5.708,
              "y": -1.168,
              "z": 1.016
            },
            "gtin": "4067796203639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c3a",
            "leftCorner": {
              "x": 5.708,
              "y": -1.168,
              "z": 1.016
            },
            "rightCorner": {
              "x": 5.653,
              "y": -1.12,
              "z": 1.016
            },
            "gtin": "4066447308174",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c3b",
            "leftCorner": {
              "x": 5.653,
              "y": -1.12,
              "z": 1.016
            },
            "rightCorner": {
              "x": 5.603,
              "y": -1.076,
              "z": 1.016
            }
          },
          {
            "id": "696ebf7143c343680a271c3c",
            "leftCorner": {
              "x": 5.603,
              "y": -1.076,
              "z": 1.016
            },
            "rightCorner": {
              "x": 5.541,
              "y": -1.022,
              "z": 1.016
            },
            "gtin": "4067796208856",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b83",
        "height": 1.2247,
        "facings": [
          {
            "id": "696ebf7143c343680a271cc6",
            "leftCorner": {
              "x": 6.31,
              "y": -1.682,
              "z": 1.225
            },
            "rightCorner": {
              "x": 6.26,
              "y": -1.639,
              "z": 1.225
            },
            "gtin": "4005514063240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cc8",
            "leftCorner": {
              "x": 6.26,
              "y": -1.639,
              "z": 1.225
            },
            "rightCorner": {
              "x": 6.204,
              "y": -1.59,
              "z": 1.225
            },
            "gtin": "4005514063240",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cc9",
            "leftCorner": {
              "x": 6.204,
              "y": -1.59,
              "z": 1.225
            },
            "rightCorner": {
              "x": 6.155,
              "y": -1.547,
              "z": 1.225
            },
            "gtin": "4005514081657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cca",
            "leftCorner": {
              "x": 6.155,
              "y": -1.547,
              "z": 1.225
            },
            "rightCorner": {
              "x": 6.113,
              "y": -1.51,
              "z": 1.225
            }
          },
          {
            "id": "696ebf7143c343680a271ccb",
            "leftCorner": {
              "x": 6.113,
              "y": -1.51,
              "z": 1.225
            },
            "rightCorner": {
              "x": 6.065,
              "y": -1.469,
              "z": 1.225
            },
            "gtin": "4005514040975",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ccc",
            "leftCorner": {
              "x": 6.065,
              "y": -1.469,
              "z": 1.225
            },
            "rightCorner": {
              "x": 6.007,
              "y": -1.418,
              "z": 1.225
            },
            "gtin": "4005514040982",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ccd",
            "leftCorner": {
              "x": 6.007,
              "y": -1.418,
              "z": 1.225
            },
            "rightCorner": {
              "x": 5.938,
              "y": -1.358,
              "z": 1.225
            },
            "gtin": "4005514045161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cce",
            "leftCorner": {
              "x": 5.938,
              "y": -1.358,
              "z": 1.225
            },
            "rightCorner": {
              "x": 5.889,
              "y": -1.315,
              "z": 1.225
            },
            "gtin": "4005514045161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ccf",
            "leftCorner": {
              "x": 5.889,
              "y": -1.315,
              "z": 1.225
            },
            "rightCorner": {
              "x": 5.834,
              "y": -1.268,
              "z": 1.225
            },
            "gtin": "4013182024067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cd0",
            "leftCorner": {
              "x": 5.834,
              "y": -1.268,
              "z": 1.225
            },
            "rightCorner": {
              "x": 5.782,
              "y": -1.222,
              "z": 1.225
            },
            "gtin": "4013182024081",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cd1",
            "leftCorner": {
              "x": 5.782,
              "y": -1.222,
              "z": 1.225
            },
            "rightCorner": {
              "x": 5.737,
              "y": -1.182,
              "z": 1.225
            },
            "gtin": "4013182024081",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cd2",
            "leftCorner": {
              "x": 5.737,
              "y": -1.182,
              "z": 1.225
            },
            "rightCorner": {
              "x": 5.687,
              "y": -1.139,
              "z": 1.225
            },
            "gtin": "4013182023831",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cd3",
            "leftCorner": {
              "x": 5.687,
              "y": -1.139,
              "z": 1.225
            },
            "rightCorner": {
              "x": 5.628,
              "y": -1.088,
              "z": 1.225
            },
            "gtin": "4066447424164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cd4",
            "leftCorner": {
              "x": 5.628,
              "y": -1.088,
              "z": 1.225
            },
            "rightCorner": {
              "x": 5.565,
              "y": -1.033,
              "z": 1.225
            },
            "gtin": "4066447910889",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b81",
        "height": 1.3949,
        "facings": [
          {
            "id": "696ebf7143c343680a271cb9",
            "leftCorner": {
              "x": 6.312,
              "y": -1.68,
              "z": 1.395
            },
            "rightCorner": {
              "x": 6.24,
              "y": -1.618,
              "z": 1.395
            },
            "gtin": "4006040007999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cba",
            "leftCorner": {
              "x": 6.24,
              "y": -1.618,
              "z": 1.395
            },
            "rightCorner": {
              "x": 6.177,
              "y": -1.562,
              "z": 1.395
            },
            "gtin": "4066447576245",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cbb",
            "leftCorner": {
              "x": 6.177,
              "y": -1.562,
              "z": 1.395
            },
            "rightCorner": {
              "x": 6.116,
              "y": -1.509,
              "z": 1.395
            }
          },
          {
            "id": "696ebf7143c343680a271cbc",
            "leftCorner": {
              "x": 6.116,
              "y": -1.509,
              "z": 1.395
            },
            "rightCorner": {
              "x": 6.062,
              "y": -1.462,
              "z": 1.395
            },
            "gtin": "4067796079753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cbd",
            "leftCorner": {
              "x": 6.062,
              "y": -1.462,
              "z": 1.395
            },
            "rightCorner": {
              "x": 5.987,
              "y": -1.397,
              "z": 1.395
            },
            "gtin": "4066447576221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cbe",
            "leftCorner": {
              "x": 5.987,
              "y": -1.397,
              "z": 1.395
            },
            "rightCorner": {
              "x": 5.926,
              "y": -1.344,
              "z": 1.395
            },
            "gtin": "4067796245134",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cbf",
            "leftCorner": {
              "x": 5.926,
              "y": -1.344,
              "z": 1.395
            },
            "rightCorner": {
              "x": 5.874,
              "y": -1.299,
              "z": 1.395
            },
            "gtin": "4260686520919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cc0",
            "leftCorner": {
              "x": 5.874,
              "y": -1.299,
              "z": 1.395
            },
            "rightCorner": {
              "x": 5.823,
              "y": -1.254,
              "z": 1.395
            },
            "gtin": "4260686524870",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cc1",
            "leftCorner": {
              "x": 5.823,
              "y": -1.254,
              "z": 1.395
            },
            "rightCorner": {
              "x": 5.777,
              "y": -1.214,
              "z": 1.395
            },
            "gtin": "4260686520940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cc2",
            "leftCorner": {
              "x": 5.777,
              "y": -1.214,
              "z": 1.395
            },
            "rightCorner": {
              "x": 5.723,
              "y": -1.167,
              "z": 1.395
            },
            "gtin": "4260697377045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cc3",
            "leftCorner": {
              "x": 5.723,
              "y": -1.167,
              "z": 1.395
            },
            "rightCorner": {
              "x": 5.677,
              "y": -1.127,
              "z": 1.395
            },
            "gtin": "4260697377199",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cc4",
            "leftCorner": {
              "x": 5.677,
              "y": -1.127,
              "z": 1.395
            },
            "rightCorner": {
              "x": 5.627,
              "y": -1.083,
              "z": 1.395
            },
            "gtin": "4066447857115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cc5",
            "leftCorner": {
              "x": 5.627,
              "y": -1.083,
              "z": 1.395
            },
            "rightCorner": {
              "x": 5.573,
              "y": -1.037,
              "z": 1.395
            },
            "gtin": "4067796065558",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b85",
        "height": 1.563,
        "facings": [
          {
            "id": "696ebf7143c343680a271ce0",
            "leftCorner": {
              "x": 6.314,
              "y": -1.677,
              "z": 1.563
            },
            "rightCorner": {
              "x": 6.263,
              "y": -1.632,
              "z": 1.563
            },
            "gtin": "4260654781366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ce1",
            "leftCorner": {
              "x": 6.263,
              "y": -1.632,
              "z": 1.563
            },
            "rightCorner": {
              "x": 6.186,
              "y": -1.565,
              "z": 1.563
            },
            "gtin": "4260335836354",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ce2",
            "leftCorner": {
              "x": 6.186,
              "y": -1.565,
              "z": 1.563
            },
            "rightCorner": {
              "x": 6.139,
              "y": -1.524,
              "z": 1.563
            },
            "gtin": "4255582815214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ce3",
            "leftCorner": {
              "x": 6.139,
              "y": -1.524,
              "z": 1.563
            },
            "rightCorner": {
              "x": 6.091,
              "y": -1.482,
              "z": 1.563
            },
            "gtin": "4260654783414",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ce4",
            "leftCorner": {
              "x": 6.091,
              "y": -1.482,
              "z": 1.563
            },
            "rightCorner": {
              "x": 6.026,
              "y": -1.426,
              "z": 1.563
            },
            "gtin": "4067796207002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ce5",
            "leftCorner": {
              "x": 6.026,
              "y": -1.426,
              "z": 1.563
            },
            "rightCorner": {
              "x": 5.972,
              "y": -1.378,
              "z": 1.563
            },
            "gtin": "4066447465679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ce6",
            "leftCorner": {
              "x": 5.972,
              "y": -1.378,
              "z": 1.563
            },
            "rightCorner": {
              "x": 5.914,
              "y": -1.328,
              "z": 1.563
            },
            "gtin": "4066447465679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ce7",
            "leftCorner": {
              "x": 5.914,
              "y": -1.328,
              "z": 1.563
            },
            "rightCorner": {
              "x": 5.86,
              "y": -1.281,
              "z": 1.563
            },
            "gtin": "4066447468342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ce8",
            "leftCorner": {
              "x": 5.86,
              "y": -1.281,
              "z": 1.563
            },
            "rightCorner": {
              "x": 5.805,
              "y": -1.233,
              "z": 1.563
            },
            "gtin": "4066447468342",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ce9",
            "leftCorner": {
              "x": 5.805,
              "y": -1.233,
              "z": 1.563
            },
            "rightCorner": {
              "x": 5.763,
              "y": -1.196,
              "z": 1.563
            }
          },
          {
            "id": "696ebf7143c343680a271cea",
            "leftCorner": {
              "x": 5.763,
              "y": -1.196,
              "z": 1.563
            },
            "rightCorner": {
              "x": 5.683,
              "y": -1.127,
              "z": 1.563
            },
            "gtin": "4067796066265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ceb",
            "leftCorner": {
              "x": 5.683,
              "y": -1.127,
              "z": 1.563
            },
            "rightCorner": {
              "x": 5.623,
              "y": -1.075,
              "z": 1.563
            },
            "gtin": "4066447673012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cec",
            "leftCorner": {
              "x": 5.623,
              "y": -1.075,
              "z": 1.563
            },
            "rightCorner": {
              "x": 5.575,
              "y": -1.032,
              "z": 1.563
            },
            "gtin": "4066447673012",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b84",
        "height": 1.7713,
        "facings": [
          {
            "id": "696ebf7043c343680a271ad8",
            "leftCorner": {
              "x": 6.293,
              "y": -1.654,
              "z": 1.771
            },
            "rightCorner": {
              "x": 6.147,
              "y": -1.527,
              "z": 1.771
            },
            "gtin": "4058172777837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271ad9",
            "leftCorner": {
              "x": 6.147,
              "y": -1.527,
              "z": 1.771
            },
            "rightCorner": {
              "x": 6.1,
              "y": -1.486,
              "z": 1.771
            },
            "gtin": "4058172777936",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ada",
            "leftCorner": {
              "x": 6.1,
              "y": -1.486,
              "z": 1.771
            },
            "rightCorner": {
              "x": 6.051,
              "y": -1.443,
              "z": 1.771
            },
            "gtin": "4067796111118",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271adb",
            "leftCorner": {
              "x": 6.051,
              "y": -1.443,
              "z": 1.771
            },
            "rightCorner": {
              "x": 5.997,
              "y": -1.396,
              "z": 1.771
            },
            "gtin": "4067796111095",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271adc",
            "leftCorner": {
              "x": 5.997,
              "y": -1.396,
              "z": 1.771
            },
            "rightCorner": {
              "x": 5.947,
              "y": -1.352,
              "z": 1.771
            },
            "gtin": "4260248063908",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271add",
            "leftCorner": {
              "x": 5.947,
              "y": -1.352,
              "z": 1.771
            },
            "rightCorner": {
              "x": 5.896,
              "y": -1.308,
              "z": 1.771
            },
            "gtin": "4260248063892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ade",
            "leftCorner": {
              "x": 5.896,
              "y": -1.308,
              "z": 1.771
            },
            "rightCorner": {
              "x": 5.835,
              "y": -1.255,
              "z": 1.771
            },
            "gtin": "4058172451430",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271adf",
            "leftCorner": {
              "x": 5.835,
              "y": -1.255,
              "z": 1.771
            },
            "rightCorner": {
              "x": 5.772,
              "y": -1.199,
              "z": 1.771
            },
            "gtin": "4067796162158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ae0",
            "leftCorner": {
              "x": 5.772,
              "y": -1.199,
              "z": 1.771
            },
            "rightCorner": {
              "x": 5.705,
              "y": -1.142,
              "z": 1.771
            },
            "gtin": "4067796162042",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ae1",
            "leftCorner": {
              "x": 5.705,
              "y": -1.142,
              "z": 1.771
            },
            "rightCorner": {
              "x": 5.642,
              "y": -1.086,
              "z": 1.771
            },
            "gtin": "4067796162172",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ae2",
            "leftCorner": {
              "x": 5.642,
              "y": -1.086,
              "z": 1.771
            },
            "rightCorner": {
              "x": 5.615,
              "y": -1.063,
              "z": 1.771
            },
            "gtin": "4066447522488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271ae3",
            "leftCorner": {
              "x": 5.615,
              "y": -1.063,
              "z": 1.771
            },
            "rightCorner": {
              "x": 5.577,
              "y": -1.03,
              "z": 1.771
            },
            "gtin": "4066447522488",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7575bb5fe7bc0469599b5",
    "name": "68e7575bb5fe7bc0469599b5",
    "x": 5.5191,
    "y": -1.0704,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93301,
      "w": 0.35986
    },
    "statistics": {
      "hasStockCount": 31,
      "noStockCount": 0,
      "unknownStockCount": 25
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73b8d",
        "height": 0.20296,
        "facings": [
          {
            "id": "696ebf7143c343680a271bac",
            "leftCorner": {
              "x": 5.556,
              "y": -1.027,
              "z": 0.205
            },
            "rightCorner": {
              "x": 5.409,
              "y": -0.899,
              "z": 0.205
            },
            "gtin": "4067796003079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bad",
            "leftCorner": {
              "x": 5.406,
              "y": -0.907,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.232,
              "y": -0.75,
              "z": 0.203
            },
            "gtin": "4066447577327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271bae",
            "leftCorner": {
              "x": 5.232,
              "y": -0.75,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.098,
              "y": -0.628,
              "z": 0.203
            },
            "gtin": "4067796002065",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271baf",
            "leftCorner": {
              "x": 5.098,
              "y": -0.628,
              "z": 0.203
            },
            "rightCorner": {
              "x": 4.817,
              "y": -0.373,
              "z": 0.203
            },
            "gtin": "4101530007418",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b8f",
        "height": 0.46707,
        "facings": [
          {
            "id": "696ebf7143c343680a271ca0",
            "leftCorner": {
              "x": 5.571,
              "y": -1.051,
              "z": 0.466
            },
            "rightCorner": {
              "x": 5.416,
              "y": -0.917,
              "z": 0.466
            },
            "gtin": "4067796001983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ca1",
            "leftCorner": {
              "x": 5.42,
              "y": -0.917,
              "z": 0.467
            },
            "rightCorner": {
              "x": 5.25,
              "y": -0.762,
              "z": 0.467
            }
          },
          {
            "id": "696ebf7143c343680a271ca2",
            "leftCorner": {
              "x": 5.25,
              "y": -0.762,
              "z": 0.467
            },
            "rightCorner": {
              "x": 5.117,
              "y": -0.641,
              "z": 0.467
            },
            "gtin": "4067796002102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ca3",
            "leftCorner": {
              "x": 5.117,
              "y": -0.641,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.999,
              "y": -0.535,
              "z": 0.467
            },
            "gtin": "4067796002089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ca4",
            "leftCorner": {
              "x": 4.999,
              "y": -0.535,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.941,
              "y": -0.482,
              "z": 0.467
            }
          },
          {
            "id": "696ebf7143c343680a271ca5",
            "leftCorner": {
              "x": 4.941,
              "y": -0.482,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.922,
              "y": -0.465,
              "z": 0.467
            }
          },
          {
            "id": "696ebf7143c343680a271c7b",
            "leftCorner": {
              "x": 4.922,
              "y": -0.465,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.81,
              "y": -0.364,
              "z": 0.467
            },
            "gtin": "4067796048728",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b8e",
        "height": 0.80339,
        "facings": [
          {
            "id": "696ebf7143c343680a271cfa",
            "leftCorner": {
              "x": 5.57,
              "y": -1.046,
              "z": 0.802
            },
            "rightCorner": {
              "x": 5.484,
              "y": -0.971,
              "z": 0.802
            },
            "gtin": "4067796081640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cfb",
            "leftCorner": {
              "x": 5.489,
              "y": -0.97,
              "z": 0.803
            },
            "rightCorner": {
              "x": 5.347,
              "y": -0.841,
              "z": 0.803
            },
            "gtin": "4067796081640",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cfc",
            "leftCorner": {
              "x": 5.347,
              "y": -0.841,
              "z": 0.803
            },
            "rightCorner": {
              "x": 5.244,
              "y": -0.748,
              "z": 0.803
            },
            "gtin": "4066447870718",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cfd",
            "leftCorner": {
              "x": 5.244,
              "y": -0.748,
              "z": 0.803
            },
            "rightCorner": {
              "x": 5.224,
              "y": -0.73,
              "z": 0.803
            }
          },
          {
            "id": "696ebf7143c343680a271cfe",
            "leftCorner": {
              "x": 5.224,
              "y": -0.73,
              "z": 0.803
            },
            "rightCorner": {
              "x": 5.12,
              "y": -0.636,
              "z": 0.803
            },
            "gtin": "4066447608960",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cff",
            "leftCorner": {
              "x": 5.12,
              "y": -0.636,
              "z": 0.803
            },
            "rightCorner": {
              "x": 5.005,
              "y": -0.531,
              "z": 0.803
            },
            "gtin": "4067796017427",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d00",
            "leftCorner": {
              "x": 5.005,
              "y": -0.531,
              "z": 0.803
            },
            "rightCorner": {
              "x": 4.887,
              "y": -0.425,
              "z": 0.803
            },
            "gtin": "42462965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d01",
            "leftCorner": {
              "x": 4.887,
              "y": -0.425,
              "z": 0.803
            },
            "rightCorner": {
              "x": 4.825,
              "y": -0.368,
              "z": 0.803
            },
            "gtin": "42486107",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b89",
        "height": 1.0143,
        "facings": [
          {
            "id": "696ebf7143c343680a271c3d",
            "leftCorner": {
              "x": 5.546,
              "y": -1.021,
              "z": 1.014
            },
            "rightCorner": {
              "x": 5.424,
              "y": -0.91,
              "z": 1.014
            },
            "gtin": "4066447893304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c3e",
            "leftCorner": {
              "x": 5.424,
              "y": -0.91,
              "z": 1.014
            },
            "rightCorner": {
              "x": 5.303,
              "y": -0.801,
              "z": 1.014
            },
            "gtin": "4066447893281",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c3f",
            "leftCorner": {
              "x": 5.303,
              "y": -0.801,
              "z": 1.014
            },
            "rightCorner": {
              "x": 5.188,
              "y": -0.696,
              "z": 1.014
            },
            "gtin": "4066447876642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c40",
            "leftCorner": {
              "x": 5.188,
              "y": -0.696,
              "z": 1.014
            },
            "rightCorner": {
              "x": 5.14,
              "y": -0.653,
              "z": 1.014
            },
            "gtin": "4066447672770",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c41",
            "leftCorner": {
              "x": 5.14,
              "y": -0.653,
              "z": 1.014
            },
            "rightCorner": {
              "x": 5.08,
              "y": -0.598,
              "z": 1.014
            },
            "gtin": "4066447856392",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c42",
            "leftCorner": {
              "x": 5.08,
              "y": -0.598,
              "z": 1.014
            },
            "rightCorner": {
              "x": 5.022,
              "y": -0.546,
              "z": 1.014
            },
            "gtin": "4066447413052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271c43",
            "leftCorner": {
              "x": 5.022,
              "y": -0.546,
              "z": 1.014
            },
            "rightCorner": {
              "x": 4.955,
              "y": -0.485,
              "z": 1.014
            },
            "gtin": "4066447398663",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c44",
            "leftCorner": {
              "x": 4.955,
              "y": -0.485,
              "z": 1.014
            },
            "rightCorner": {
              "x": 4.89,
              "y": -0.427,
              "z": 1.014
            },
            "gtin": "4066447680119",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271c45",
            "leftCorner": {
              "x": 4.89,
              "y": -0.427,
              "z": 1.014
            },
            "rightCorner": {
              "x": 4.82,
              "y": -0.363,
              "z": 1.014
            },
            "gtin": "4066447712971",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b8a",
        "height": 1.2256,
        "facings": [
          {
            "id": "696ebf7143c343680a271cd5",
            "leftCorner": {
              "x": 5.565,
              "y": -1.033,
              "z": 1.225
            },
            "rightCorner": {
              "x": 5.484,
              "y": -0.963,
              "z": 1.225
            },
            "gtin": "4260248060044",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cd6",
            "leftCorner": {
              "x": 5.491,
              "y": -0.96,
              "z": 1.226
            },
            "rightCorner": {
              "x": 5.42,
              "y": -0.895,
              "z": 1.226
            },
            "gtin": "4058172485572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cd7",
            "leftCorner": {
              "x": 5.42,
              "y": -0.895,
              "z": 1.226
            },
            "rightCorner": {
              "x": 5.344,
              "y": -0.826,
              "z": 1.226
            },
            "gtin": "4260407950926",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cd8",
            "leftCorner": {
              "x": 5.344,
              "y": -0.826,
              "z": 1.226
            },
            "rightCorner": {
              "x": 5.293,
              "y": -0.78,
              "z": 1.226
            },
            "gtin": "4260407955099",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cd9",
            "leftCorner": {
              "x": 5.293,
              "y": -0.78,
              "z": 1.226
            },
            "rightCorner": {
              "x": 5.228,
              "y": -0.721,
              "z": 1.226
            },
            "gtin": "4260407953798",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cda",
            "leftCorner": {
              "x": 5.228,
              "y": -0.721,
              "z": 1.226
            },
            "rightCorner": {
              "x": 5.163,
              "y": -0.662,
              "z": 1.226
            },
            "gtin": "4066447983999",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cdb",
            "leftCorner": {
              "x": 5.163,
              "y": -0.662,
              "z": 1.226
            },
            "rightCorner": {
              "x": 5.106,
              "y": -0.611,
              "z": 1.226
            },
            "gtin": "4067796084849",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cdc",
            "leftCorner": {
              "x": 5.106,
              "y": -0.611,
              "z": 1.226
            },
            "rightCorner": {
              "x": 5.026,
              "y": -0.539,
              "z": 1.226
            },
            "gtin": "4067796084863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271cdd",
            "leftCorner": {
              "x": 5.026,
              "y": -0.539,
              "z": 1.226
            },
            "rightCorner": {
              "x": 4.976,
              "y": -0.492,
              "z": 1.226
            },
            "gtin": "4058172775581",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cde",
            "leftCorner": {
              "x": 4.976,
              "y": -0.492,
              "z": 1.226
            },
            "rightCorner": {
              "x": 4.928,
              "y": -0.449,
              "z": 1.226
            },
            "gtin": "4058172775581",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cdf",
            "leftCorner": {
              "x": 4.928,
              "y": -0.449,
              "z": 1.226
            },
            "rightCorner": {
              "x": 4.884,
              "y": -0.41,
              "z": 1.226
            },
            "gtin": "4066447477337",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271cc7",
            "leftCorner": {
              "x": 4.884,
              "y": -0.41,
              "z": 1.226
            },
            "rightCorner": {
              "x": 4.821,
              "y": -0.352,
              "z": 1.226
            },
            "gtin": "4066447373127",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b8c",
        "height": 1.5202,
        "facings": [
          {
            "id": "696ebf7143c343680a271d02",
            "leftCorner": {
              "x": 5.566,
              "y": -1.019,
              "z": 1.52
            },
            "rightCorner": {
              "x": 5.501,
              "y": -0.961,
              "z": 1.52
            },
            "gtin": "4066447522501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d04",
            "leftCorner": {
              "x": 5.501,
              "y": -0.961,
              "z": 1.52
            },
            "rightCorner": {
              "x": 5.432,
              "y": -0.898,
              "z": 1.52
            },
            "gtin": "4260614530737",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d05",
            "leftCorner": {
              "x": 5.432,
              "y": -0.898,
              "z": 1.52
            },
            "rightCorner": {
              "x": 5.37,
              "y": -0.842,
              "z": 1.52
            },
            "gtin": "4260614530218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d06",
            "leftCorner": {
              "x": 5.37,
              "y": -0.842,
              "z": 1.52
            },
            "rightCorner": {
              "x": 5.304,
              "y": -0.782,
              "z": 1.52
            },
            "gtin": "4260614530034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d07",
            "leftCorner": {
              "x": 5.304,
              "y": -0.782,
              "z": 1.52
            },
            "rightCorner": {
              "x": 5.234,
              "y": -0.719,
              "z": 1.52
            },
            "gtin": "4260614530034",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d08",
            "leftCorner": {
              "x": 5.234,
              "y": -0.719,
              "z": 1.52
            },
            "rightCorner": {
              "x": 5.172,
              "y": -0.663,
              "z": 1.52
            },
            "gtin": "4260614530713",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d09",
            "leftCorner": {
              "x": 5.172,
              "y": -0.663,
              "z": 1.52
            },
            "rightCorner": {
              "x": 5.119,
              "y": -0.615,
              "z": 1.52
            },
            "gtin": "4260614530720",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d0a",
            "leftCorner": {
              "x": 5.119,
              "y": -0.615,
              "z": 1.52
            },
            "rightCorner": {
              "x": 5.024,
              "y": -0.529,
              "z": 1.52
            },
            "gtin": "4066447884609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d0b",
            "leftCorner": {
              "x": 5.024,
              "y": -0.529,
              "z": 1.52
            },
            "rightCorner": {
              "x": 4.967,
              "y": -0.477,
              "z": 1.52
            },
            "gtin": "4066447415254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d0c",
            "leftCorner": {
              "x": 4.967,
              "y": -0.477,
              "z": 1.52
            },
            "rightCorner": {
              "x": 4.919,
              "y": -0.433,
              "z": 1.52
            },
            "gtin": "4058172487330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d0d",
            "leftCorner": {
              "x": 4.919,
              "y": -0.433,
              "z": 1.52
            },
            "rightCorner": {
              "x": 4.867,
              "y": -0.386,
              "z": 1.52
            },
            "gtin": "4066447075526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d03",
            "leftCorner": {
              "x": 4.867,
              "y": -0.386,
              "z": 1.52
            },
            "rightCorner": {
              "x": 4.825,
              "y": -0.348,
              "z": 1.52
            },
            "gtin": "4066447075540",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b8b",
        "height": 1.7683,
        "facings": [
          {
            "id": "696ebf7043c343680a271ae4",
            "leftCorner": {
              "x": 5.577,
              "y": -1.03,
              "z": 1.771
            },
            "rightCorner": {
              "x": 5.497,
              "y": -0.96,
              "z": 1.771
            },
            "gtin": "4058172487316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ae5",
            "leftCorner": {
              "x": 5.498,
              "y": -0.964,
              "z": 1.768
            },
            "rightCorner": {
              "x": 5.423,
              "y": -0.896,
              "z": 1.768
            },
            "gtin": "4066447522464",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ae6",
            "leftCorner": {
              "x": 5.423,
              "y": -0.896,
              "z": 1.768
            },
            "rightCorner": {
              "x": 5.355,
              "y": -0.835,
              "z": 1.768
            },
            "gtin": "4066447522440",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ae7",
            "leftCorner": {
              "x": 5.355,
              "y": -0.835,
              "z": 1.768
            },
            "rightCorner": {
              "x": 5.274,
              "y": -0.762,
              "z": 1.768
            },
            "gtin": "4066447522440",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271ae8",
            "leftCorner": {
              "x": 5.274,
              "y": -0.762,
              "z": 1.768
            },
            "rightCorner": {
              "x": 5.187,
              "y": -0.682,
              "z": 1.768
            }
          },
          {
            "id": "696ebf7043c343680a271ae9",
            "leftCorner": {
              "x": 5.187,
              "y": -0.682,
              "z": 1.768
            },
            "rightCorner": {
              "x": 5.078,
              "y": -0.583,
              "z": 1.768
            },
            "gtin": "4067796209259",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7043c343680a271aea",
            "leftCorner": {
              "x": 5.078,
              "y": -0.583,
              "z": 1.768
            },
            "rightCorner": {
              "x": 4.991,
              "y": -0.505,
              "z": 1.768
            },
            "gtin": "4058172684159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271aeb",
            "leftCorner": {
              "x": 4.991,
              "y": -0.505,
              "z": 1.768
            },
            "rightCorner": {
              "x": 4.872,
              "y": -0.397,
              "z": 1.768
            },
            "gtin": "4066447232752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7043c343680a271a94",
            "leftCorner": {
              "x": 4.872,
              "y": -0.397,
              "z": 1.768
            },
            "rightCorner": {
              "x": 4.821,
              "y": -0.351,
              "z": 1.768
            },
            "gtin": "4066447233049",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7578bb5fe7bc0469599f2",
    "name": "68e7578bb5fe7bc0469599f2",
    "x": 8.1665,
    "y": -1.1247,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.35218,
      "w": 0.93593
    },
    "statistics": {
      "hasStockCount": 17,
      "noStockCount": 1,
      "unknownStockCount": 37
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73b97",
        "height": 0.20498,
        "facings": [
          {
            "id": "696ebf7143c343680a271d95",
            "leftCorner": {
              "x": 8.137,
              "y": -1.158,
              "z": 0.205
            },
            "rightCorner": {
              "x": 8.214,
              "y": -1.226,
              "z": 0.205
            },
            "gtin": "4067796080759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d96",
            "leftCorner": {
              "x": 8.214,
              "y": -1.226,
              "z": 0.205
            },
            "rightCorner": {
              "x": 8.437,
              "y": -1.422,
              "z": 0.205
            },
            "gtin": "4067796068610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d97",
            "leftCorner": {
              "x": 8.437,
              "y": -1.422,
              "z": 0.205
            },
            "rightCorner": {
              "x": 8.533,
              "y": -1.506,
              "z": 0.205
            },
            "gtin": "4066447861389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d98",
            "leftCorner": {
              "x": 8.533,
              "y": -1.506,
              "z": 0.205
            },
            "rightCorner": {
              "x": 8.631,
              "y": -1.592,
              "z": 0.205
            },
            "gtin": "4066447861402",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d99",
            "leftCorner": {
              "x": 8.631,
              "y": -1.592,
              "z": 0.205
            },
            "rightCorner": {
              "x": 8.755,
              "y": -1.7,
              "z": 0.205
            },
            "gtin": "4067796068634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d9a",
            "leftCorner": {
              "x": 8.755,
              "y": -1.7,
              "z": 0.205
            },
            "rightCorner": {
              "x": 8.854,
              "y": -1.787,
              "z": 0.205
            },
            "gtin": "4067796068559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d9b",
            "leftCorner": {
              "x": 8.854,
              "y": -1.787,
              "z": 0.205
            },
            "rightCorner": {
              "x": 8.893,
              "y": -1.821,
              "z": 0.205
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b94",
        "height": 0.47291,
        "facings": [
          {
            "id": "696ebf7143c343680a271d53",
            "leftCorner": {
              "x": 8.143,
              "y": -1.151,
              "z": 0.473
            },
            "rightCorner": {
              "x": 8.182,
              "y": -1.184,
              "z": 0.473
            }
          },
          {
            "id": "696ebf7143c343680a271d54",
            "leftCorner": {
              "x": 8.182,
              "y": -1.184,
              "z": 0.473
            },
            "rightCorner": {
              "x": 8.252,
              "y": -1.246,
              "z": 0.473
            },
            "gtin": "4008258130018",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d55",
            "leftCorner": {
              "x": 8.252,
              "y": -1.246,
              "z": 0.473
            },
            "rightCorner": {
              "x": 8.353,
              "y": -1.335,
              "z": 0.473
            },
            "gtin": "4008258130018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d56",
            "leftCorner": {
              "x": 8.353,
              "y": -1.335,
              "z": 0.473
            },
            "rightCorner": {
              "x": 8.471,
              "y": -1.438,
              "z": 0.473
            },
            "gtin": "4008258460009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d57",
            "leftCorner": {
              "x": 8.471,
              "y": -1.438,
              "z": 0.473
            },
            "rightCorner": {
              "x": 8.565,
              "y": -1.52,
              "z": 0.473
            },
            "gtin": "4008258324110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d58",
            "leftCorner": {
              "x": 8.565,
              "y": -1.52,
              "z": 0.473
            },
            "rightCorner": {
              "x": 8.658,
              "y": -1.602,
              "z": 0.473
            },
            "gtin": "4008258276006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d59",
            "leftCorner": {
              "x": 8.658,
              "y": -1.602,
              "z": 0.473
            },
            "rightCorner": {
              "x": 8.748,
              "y": -1.681,
              "z": 0.473
            },
            "gtin": "4008258464007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d5a",
            "leftCorner": {
              "x": 8.748,
              "y": -1.681,
              "z": 0.473
            },
            "rightCorner": {
              "x": 8.865,
              "y": -1.783,
              "z": 0.473
            },
            "gtin": "4008258147009",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d5b",
            "leftCorner": {
              "x": 8.865,
              "y": -1.783,
              "z": 0.473
            },
            "rightCorner": {
              "x": 8.899,
              "y": -1.813,
              "z": 0.473
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b96",
        "height": 0.76759,
        "facings": [
          {
            "id": "696ebf7143c343680a271d86",
            "leftCorner": {
              "x": 8.167,
              "y": -1.168,
              "z": 0.768
            },
            "rightCorner": {
              "x": 8.256,
              "y": -1.246,
              "z": 0.768
            },
            "gtin": "4008258526064",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d87",
            "leftCorner": {
              "x": 8.256,
              "y": -1.246,
              "z": 0.768
            },
            "rightCorner": {
              "x": 8.36,
              "y": -1.338,
              "z": 0.768
            },
            "gtin": "4008258157008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d88",
            "leftCorner": {
              "x": 8.36,
              "y": -1.338,
              "z": 0.768
            },
            "rightCorner": {
              "x": 8.463,
              "y": -1.428,
              "z": 0.768
            },
            "gtin": "4008258158005",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d89",
            "leftCorner": {
              "x": 8.463,
              "y": -1.428,
              "z": 0.768
            },
            "rightCorner": {
              "x": 8.563,
              "y": -1.516,
              "z": 0.768
            },
            "gtin": "4008258150092",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d8a",
            "leftCorner": {
              "x": 8.563,
              "y": -1.516,
              "z": 0.768
            },
            "rightCorner": {
              "x": 8.646,
              "y": -1.588,
              "z": 0.768
            },
            "gtin": "4008258065082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d8b",
            "leftCorner": {
              "x": 8.646,
              "y": -1.588,
              "z": 0.768
            },
            "rightCorner": {
              "x": 8.752,
              "y": -1.681,
              "z": 0.768
            },
            "gtin": "4008258153031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d8c",
            "leftCorner": {
              "x": 8.752,
              "y": -1.681,
              "z": 0.768
            },
            "rightCorner": {
              "x": 8.854,
              "y": -1.771,
              "z": 0.768
            },
            "gtin": "4008258020043",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b95",
        "height": 1.0201,
        "facings": [
          {
            "id": "696ebf7143c343680a271d7b",
            "leftCorner": {
              "x": 8.163,
              "y": -1.162,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.193,
              "y": -1.188,
              "z": 1.02
            }
          },
          {
            "id": "696ebf7143c343680a271d7c",
            "leftCorner": {
              "x": 8.193,
              "y": -1.188,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.247,
              "y": -1.235,
              "z": 1.02
            }
          },
          {
            "id": "696ebf7143c343680a271d7d",
            "leftCorner": {
              "x": 8.247,
              "y": -1.235,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.307,
              "y": -1.288,
              "z": 1.02
            },
            "gtin": "4066447674767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d7e",
            "leftCorner": {
              "x": 8.307,
              "y": -1.288,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.392,
              "y": -1.363,
              "z": 1.02
            }
          },
          {
            "id": "696ebf7143c343680a271d7f",
            "leftCorner": {
              "x": 8.392,
              "y": -1.363,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.464,
              "y": -1.425,
              "z": 1.02
            },
            "gtin": "4066447413427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d80",
            "leftCorner": {
              "x": 8.464,
              "y": -1.425,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.519,
              "y": -1.474,
              "z": 1.02
            },
            "gtin": "4066447413427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d81",
            "leftCorner": {
              "x": 8.519,
              "y": -1.474,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.543,
              "y": -1.494,
              "z": 1.02
            }
          },
          {
            "id": "696ebf7143c343680a271d82",
            "leftCorner": {
              "x": 8.543,
              "y": -1.494,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.59,
              "y": -1.536,
              "z": 1.02
            },
            "gtin": "4067796074079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d83",
            "leftCorner": {
              "x": 8.59,
              "y": -1.536,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.653,
              "y": -1.591,
              "z": 1.02
            },
            "gtin": "4008258120002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d84",
            "leftCorner": {
              "x": 8.653,
              "y": -1.591,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.758,
              "y": -1.683,
              "z": 1.02
            },
            "gtin": "4008258154229",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d7a",
            "leftCorner": {
              "x": 8.758,
              "y": -1.683,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.899,
              "y": -1.806,
              "z": 1.02
            },
            "gtin": "4008258051030",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b92",
        "height": 1.2745,
        "facings": [
          {
            "id": "696ebf7143c343680a271d23",
            "leftCorner": {
              "x": 8.147,
              "y": -1.147,
              "z": 1.274
            },
            "rightCorner": {
              "x": 8.305,
              "y": -1.286,
              "z": 1.274
            },
            "gtin": "4067796166859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d25",
            "leftCorner": {
              "x": 8.305,
              "y": -1.286,
              "z": 1.274
            },
            "rightCorner": {
              "x": 8.396,
              "y": -1.366,
              "z": 1.274
            }
          },
          {
            "id": "696ebf7143c343680a271d26",
            "leftCorner": {
              "x": 8.396,
              "y": -1.366,
              "z": 1.274
            },
            "rightCorner": {
              "x": 8.475,
              "y": -1.435,
              "z": 1.274
            },
            "gtin": "4066447602661",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d27",
            "leftCorner": {
              "x": 8.475,
              "y": -1.435,
              "z": 1.274
            },
            "rightCorner": {
              "x": 8.547,
              "y": -1.498,
              "z": 1.274
            },
            "gtin": "4066447602586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d28",
            "leftCorner": {
              "x": 8.547,
              "y": -1.498,
              "z": 1.274
            },
            "rightCorner": {
              "x": 8.616,
              "y": -1.559,
              "z": 1.274
            },
            "gtin": "4066447602586",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d29",
            "leftCorner": {
              "x": 8.616,
              "y": -1.559,
              "z": 1.274
            },
            "rightCorner": {
              "x": 8.69,
              "y": -1.624,
              "z": 1.274
            },
            "gtin": "4066447615913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d2a",
            "leftCorner": {
              "x": 8.69,
              "y": -1.624,
              "z": 1.274
            },
            "rightCorner": {
              "x": 8.778,
              "y": -1.701,
              "z": 1.274
            },
            "gtin": "4066447615913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d2b",
            "leftCorner": {
              "x": 8.778,
              "y": -1.701,
              "z": 1.274
            },
            "rightCorner": {
              "x": 8.87,
              "y": -1.781,
              "z": 1.274
            },
            "gtin": "4066447614404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d24",
            "leftCorner": {
              "x": 8.87,
              "y": -1.781,
              "z": 1.274
            },
            "rightCorner": {
              "x": 8.899,
              "y": -1.807,
              "z": 1.274
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b91",
        "height": 1.528,
        "facings": [
          {
            "id": "696ebf7143c343680a271d0e",
            "leftCorner": {
              "x": 8.142,
              "y": -1.152,
              "z": 1.528
            },
            "rightCorner": {
              "x": 8.231,
              "y": -1.23,
              "z": 1.528
            },
            "gtin": "4066447874228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d10",
            "leftCorner": {
              "x": 8.231,
              "y": -1.23,
              "z": 1.528
            },
            "rightCorner": {
              "x": 8.286,
              "y": -1.278,
              "z": 1.528
            },
            "gtin": "4067796063905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d11",
            "leftCorner": {
              "x": 8.286,
              "y": -1.278,
              "z": 1.528
            },
            "rightCorner": {
              "x": 8.359,
              "y": -1.343,
              "z": 1.528
            },
            "gtin": "4067796015003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d12",
            "leftCorner": {
              "x": 8.359,
              "y": -1.343,
              "z": 1.528
            },
            "rightCorner": {
              "x": 8.429,
              "y": -1.404,
              "z": 1.528
            },
            "gtin": "4066447602647",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d13",
            "leftCorner": {
              "x": 8.429,
              "y": -1.404,
              "z": 1.528
            },
            "rightCorner": {
              "x": 8.496,
              "y": -1.462,
              "z": 1.528
            },
            "gtin": "4067796063356",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d14",
            "leftCorner": {
              "x": 8.496,
              "y": -1.462,
              "z": 1.528
            },
            "rightCorner": {
              "x": 8.569,
              "y": -1.526,
              "z": 1.528
            },
            "gtin": "4067796185676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d15",
            "leftCorner": {
              "x": 8.569,
              "y": -1.526,
              "z": 1.528
            },
            "rightCorner": {
              "x": 8.67,
              "y": -1.615,
              "z": 1.528
            },
            "gtin": "4067796185676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d16",
            "leftCorner": {
              "x": 8.67,
              "y": -1.615,
              "z": 1.528
            },
            "rightCorner": {
              "x": 8.753,
              "y": -1.688,
              "z": 1.528
            },
            "gtin": "4066447615906",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d17",
            "leftCorner": {
              "x": 8.753,
              "y": -1.688,
              "z": 1.528
            },
            "rightCorner": {
              "x": 8.838,
              "y": -1.763,
              "z": 1.528
            },
            "gtin": "4066447615906",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d18",
            "leftCorner": {
              "x": 8.838,
              "y": -1.763,
              "z": 1.528
            },
            "rightCorner": {
              "x": 8.933,
              "y": -1.845,
              "z": 1.528
            },
            "gtin": "4066447490787",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b93",
        "height": 1.7782,
        "facings": [
          {
            "id": "696ebf7143c343680a271d2c",
            "leftCorner": {
              "x": 8.143,
              "y": -1.151,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.236,
              "y": -1.232,
              "z": 1.778
            },
            "gtin": "4066447615845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d2e",
            "leftCorner": {
              "x": 8.236,
              "y": -1.232,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.299,
              "y": -1.288,
              "z": 1.778
            },
            "gtin": "4066447490800",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d2f",
            "leftCorner": {
              "x": 8.299,
              "y": -1.288,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.374,
              "y": -1.353,
              "z": 1.778
            },
            "gtin": "4066447615784",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d30",
            "leftCorner": {
              "x": 8.374,
              "y": -1.353,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.439,
              "y": -1.411,
              "z": 1.778
            },
            "gtin": "4067796069815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d31",
            "leftCorner": {
              "x": 8.439,
              "y": -1.411,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.508,
              "y": -1.471,
              "z": 1.778
            },
            "gtin": "4067796069853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d32",
            "leftCorner": {
              "x": 8.508,
              "y": -1.471,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.527,
              "y": -1.488,
              "z": 1.778
            }
          },
          {
            "id": "696ebf7143c343680a271d33",
            "leftCorner": {
              "x": 8.527,
              "y": -1.488,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.618,
              "y": -1.567,
              "z": 1.778
            },
            "gtin": "4066447602562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d34",
            "leftCorner": {
              "x": 8.618,
              "y": -1.567,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.683,
              "y": -1.624,
              "z": 1.778
            },
            "gtin": "4066447602692",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d35",
            "leftCorner": {
              "x": 8.683,
              "y": -1.624,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.748,
              "y": -1.681,
              "z": 1.778
            },
            "gtin": "4066447490824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d36",
            "leftCorner": {
              "x": 8.748,
              "y": -1.681,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.813,
              "y": -1.738,
              "z": 1.778
            },
            "gtin": "4066447934359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d37",
            "leftCorner": {
              "x": 8.813,
              "y": -1.738,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.877,
              "y": -1.794,
              "z": 1.778
            },
            "gtin": "4066447615821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d38",
            "leftCorner": {
              "x": 8.877,
              "y": -1.794,
              "z": 1.778
            },
            "rightCorner": {
              "x": 8.953,
              "y": -1.861,
              "z": 1.778
            },
            "gtin": "4066447723045",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7578bb5fe7bc0469599f3",
    "name": "68e7578bb5fe7bc0469599f3",
    "x": 8.9065,
    "y": -1.7592,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.36047,
      "w": 0.93277
    },
    "statistics": {
      "hasStockCount": 23,
      "noStockCount": 0,
      "unknownStockCount": 33
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73b9e",
        "height": 0.20766,
        "facings": [
          {
            "id": "696ebf7143c343680a271d9c",
            "leftCorner": {
              "x": 8.893,
              "y": -1.821,
              "z": 0.205
            },
            "rightCorner": {
              "x": 8.969,
              "y": -1.888,
              "z": 0.205
            },
            "gtin": "8008698004838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d9d",
            "leftCorner": {
              "x": 8.954,
              "y": -1.865,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.999,
              "y": -1.906,
              "z": 0.208
            }
          },
          {
            "id": "696ebf7143c343680a271d9e",
            "leftCorner": {
              "x": 8.999,
              "y": -1.906,
              "z": 0.208
            },
            "rightCorner": {
              "x": 9.096,
              "y": -1.994,
              "z": 0.208
            },
            "gtin": "8008698004869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d9f",
            "leftCorner": {
              "x": 9.096,
              "y": -1.994,
              "z": 0.208
            },
            "rightCorner": {
              "x": 9.208,
              "y": -2.096,
              "z": 0.208
            },
            "gtin": "8008698004869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271da0",
            "leftCorner": {
              "x": 9.208,
              "y": -2.096,
              "z": 0.208
            },
            "rightCorner": {
              "x": 9.301,
              "y": -2.18,
              "z": 0.208
            },
            "gtin": "4015537410426",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271da1",
            "leftCorner": {
              "x": 9.301,
              "y": -2.18,
              "z": 0.208
            },
            "rightCorner": {
              "x": 9.364,
              "y": -2.238,
              "z": 0.208
            },
            "gtin": "4015537442328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271da2",
            "leftCorner": {
              "x": 9.364,
              "y": -2.238,
              "z": 0.208
            },
            "rightCorner": {
              "x": 9.443,
              "y": -2.309,
              "z": 0.208
            },
            "gtin": "4015537475029",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271da3",
            "leftCorner": {
              "x": 9.443,
              "y": -2.309,
              "z": 0.208
            },
            "rightCorner": {
              "x": 9.496,
              "y": -2.358,
              "z": 0.208
            },
            "gtin": "7640143673391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271da4",
            "leftCorner": {
              "x": 9.496,
              "y": -2.358,
              "z": 0.208
            },
            "rightCorner": {
              "x": 9.621,
              "y": -2.471,
              "z": 0.208
            },
            "gtin": "7640143673360",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b9a",
        "height": 0.47469,
        "facings": [
          {
            "id": "696ebf7143c343680a271d5c",
            "leftCorner": {
              "x": 8.899,
              "y": -1.813,
              "z": 0.473
            },
            "rightCorner": {
              "x": 8.94,
              "y": -1.85,
              "z": 0.473
            },
            "gtin": "8008698005491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d5d",
            "leftCorner": {
              "x": 8.923,
              "y": -1.83,
              "z": 0.475
            },
            "rightCorner": {
              "x": 8.946,
              "y": -1.85,
              "z": 0.475
            },
            "gtin": "8008698005491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d5e",
            "leftCorner": {
              "x": 8.946,
              "y": -1.85,
              "z": 0.475
            },
            "rightCorner": {
              "x": 8.986,
              "y": -1.887,
              "z": 0.475
            }
          },
          {
            "id": "696ebf7143c343680a271d5f",
            "leftCorner": {
              "x": 8.986,
              "y": -1.887,
              "z": 0.475
            },
            "rightCorner": {
              "x": 9.053,
              "y": -1.947,
              "z": 0.475
            },
            "gtin": "8008698035245",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d60",
            "leftCorner": {
              "x": 9.053,
              "y": -1.947,
              "z": 0.475
            },
            "rightCorner": {
              "x": 9.112,
              "y": -2.001,
              "z": 0.475
            }
          },
          {
            "id": "696ebf7143c343680a271d61",
            "leftCorner": {
              "x": 9.112,
              "y": -2.001,
              "z": 0.475
            },
            "rightCorner": {
              "x": 9.214,
              "y": -2.094,
              "z": 0.475
            },
            "gtin": "8008698026281",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d62",
            "leftCorner": {
              "x": 9.214,
              "y": -2.094,
              "z": 0.475
            },
            "rightCorner": {
              "x": 9.32,
              "y": -2.19,
              "z": 0.475
            },
            "gtin": "8008698011294",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d63",
            "leftCorner": {
              "x": 9.32,
              "y": -2.19,
              "z": 0.475
            },
            "rightCorner": {
              "x": 9.417,
              "y": -2.278,
              "z": 0.475
            },
            "gtin": "8008698047552",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d64",
            "leftCorner": {
              "x": 9.417,
              "y": -2.278,
              "z": 0.475
            },
            "rightCorner": {
              "x": 9.496,
              "y": -2.35,
              "z": 0.475
            },
            "gtin": "8008698010259",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d65",
            "leftCorner": {
              "x": 9.496,
              "y": -2.35,
              "z": 0.475
            },
            "rightCorner": {
              "x": 9.605,
              "y": -2.449,
              "z": 0.475
            },
            "gtin": "8008698013175",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b9b",
        "height": 0.76695,
        "facings": [
          {
            "id": "696ebf7143c343680a271d8d",
            "leftCorner": {
              "x": 8.854,
              "y": -1.771,
              "z": 0.768
            },
            "rightCorner": {
              "x": 8.892,
              "y": -1.804,
              "z": 0.768
            },
            "gtin": "4008258252062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d8e",
            "leftCorner": {
              "x": 8.892,
              "y": -1.804,
              "z": 0.768
            },
            "rightCorner": {
              "x": 8.93,
              "y": -1.837,
              "z": 0.768
            },
            "gtin": "4008258252062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d8f",
            "leftCorner": {
              "x": 8.912,
              "y": -1.819,
              "z": 0.767
            },
            "rightCorner": {
              "x": 8.957,
              "y": -1.859,
              "z": 0.767
            },
            "gtin": "4008258252062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d90",
            "leftCorner": {
              "x": 8.957,
              "y": -1.859,
              "z": 0.767
            },
            "rightCorner": {
              "x": 8.998,
              "y": -1.897,
              "z": 0.767
            },
            "gtin": "4008258252062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d91",
            "leftCorner": {
              "x": 8.998,
              "y": -1.897,
              "z": 0.767
            },
            "rightCorner": {
              "x": 9.103,
              "y": -1.992,
              "z": 0.767
            },
            "gtin": "8008698002070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d92",
            "leftCorner": {
              "x": 9.103,
              "y": -1.992,
              "z": 0.767
            },
            "rightCorner": {
              "x": 9.315,
              "y": -2.185,
              "z": 0.767
            },
            "gtin": "8008698011683",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d93",
            "leftCorner": {
              "x": 9.315,
              "y": -2.185,
              "z": 0.767
            },
            "rightCorner": {
              "x": 9.417,
              "y": -2.278,
              "z": 0.767
            },
            "gtin": "8008698029060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d94",
            "leftCorner": {
              "x": 9.417,
              "y": -2.278,
              "z": 0.767
            },
            "rightCorner": {
              "x": 9.494,
              "y": -2.347,
              "z": 0.767
            }
          },
          {
            "id": "696ebf7143c343680a271d85",
            "leftCorner": {
              "x": 9.494,
              "y": -2.347,
              "z": 0.767
            },
            "rightCorner": {
              "x": 9.619,
              "y": -2.462,
              "z": 0.767
            },
            "gtin": "8008698028315",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b99",
        "height": 0.98009,
        "facings": [
          {
            "id": "696ebf7143c343680a271db6",
            "leftCorner": {
              "x": 8.88,
              "y": -1.788,
              "z": 0.98
            },
            "rightCorner": {
              "x": 8.941,
              "y": -1.843,
              "z": 0.98
            },
            "gtin": "4022993300208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271db8",
            "leftCorner": {
              "x": 8.941,
              "y": -1.843,
              "z": 0.98
            },
            "rightCorner": {
              "x": 8.983,
              "y": -1.882,
              "z": 0.98
            }
          },
          {
            "id": "696ebf7143c343680a271db9",
            "leftCorner": {
              "x": 8.983,
              "y": -1.882,
              "z": 0.98
            },
            "rightCorner": {
              "x": 9.063,
              "y": -1.955,
              "z": 0.98
            },
            "gtin": "4022993047066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dba",
            "leftCorner": {
              "x": 9.063,
              "y": -1.955,
              "z": 0.98
            },
            "rightCorner": {
              "x": 9.162,
              "y": -2.044,
              "z": 0.98
            },
            "gtin": "4022993047059",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271dbb",
            "leftCorner": {
              "x": 9.162,
              "y": -2.044,
              "z": 0.98
            },
            "rightCorner": {
              "x": 9.244,
              "y": -2.119,
              "z": 0.98
            },
            "gtin": "4022993045406",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271dbc",
            "leftCorner": {
              "x": 9.244,
              "y": -2.119,
              "z": 0.98
            },
            "rightCorner": {
              "x": 9.365,
              "y": -2.229,
              "z": 0.98
            },
            "gtin": "8008698027400",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271dbd",
            "leftCorner": {
              "x": 9.365,
              "y": -2.229,
              "z": 0.98
            },
            "rightCorner": {
              "x": 9.444,
              "y": -2.301,
              "z": 0.98
            },
            "gtin": "8008698038734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dbe",
            "leftCorner": {
              "x": 9.444,
              "y": -2.301,
              "z": 0.98
            },
            "rightCorner": {
              "x": 9.507,
              "y": -2.358,
              "z": 0.98
            },
            "gtin": "8008698038734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271db7",
            "leftCorner": {
              "x": 9.507,
              "y": -2.358,
              "z": 0.98
            },
            "rightCorner": {
              "x": 9.62,
              "y": -2.461,
              "z": 0.98
            },
            "gtin": "8008698027424",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b9d",
        "height": 1.3196,
        "facings": [
          {
            "id": "696ebf7143c343680a271dbf",
            "leftCorner": {
              "x": 8.88,
              "y": -1.789,
              "z": 1.32
            },
            "rightCorner": {
              "x": 8.93,
              "y": -1.834,
              "z": 1.32
            },
            "gtin": "4066447615869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dc0",
            "leftCorner": {
              "x": 8.93,
              "y": -1.834,
              "z": 1.32
            },
            "rightCorner": {
              "x": 8.973,
              "y": -1.874,
              "z": 1.32
            }
          },
          {
            "id": "696ebf7143c343680a271dc1",
            "leftCorner": {
              "x": 8.973,
              "y": -1.874,
              "z": 1.32
            },
            "rightCorner": {
              "x": 8.993,
              "y": -1.892,
              "z": 1.32
            }
          },
          {
            "id": "696ebf7143c343680a271dc2",
            "leftCorner": {
              "x": 8.993,
              "y": -1.892,
              "z": 1.32
            },
            "rightCorner": {
              "x": 9.055,
              "y": -1.948,
              "z": 1.32
            }
          },
          {
            "id": "696ebf7143c343680a271dc3",
            "leftCorner": {
              "x": 9.055,
              "y": -1.948,
              "z": 1.32
            },
            "rightCorner": {
              "x": 9.197,
              "y": -2.077,
              "z": 1.32
            },
            "gtin": "4015537001235",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271dc4",
            "leftCorner": {
              "x": 9.197,
              "y": -2.077,
              "z": 1.32
            },
            "rightCorner": {
              "x": 9.282,
              "y": -2.154,
              "z": 1.32
            },
            "gtin": "4015537002836",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271dc5",
            "leftCorner": {
              "x": 9.282,
              "y": -2.154,
              "z": 1.32
            },
            "rightCorner": {
              "x": 9.348,
              "y": -2.214,
              "z": 1.32
            },
            "gtin": "4015537002744",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271dc6",
            "leftCorner": {
              "x": 9.348,
              "y": -2.214,
              "z": 1.32
            },
            "rightCorner": {
              "x": 9.422,
              "y": -2.281,
              "z": 1.32
            },
            "gtin": "4015537002720",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271dc7",
            "leftCorner": {
              "x": 9.422,
              "y": -2.281,
              "z": 1.32
            },
            "rightCorner": {
              "x": 9.467,
              "y": -2.322,
              "z": 1.32
            },
            "gtin": "4015537001365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dc8",
            "leftCorner": {
              "x": 9.467,
              "y": -2.322,
              "z": 1.32
            },
            "rightCorner": {
              "x": 9.609,
              "y": -2.451,
              "z": 1.32
            },
            "gtin": "4015537003147",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b9c",
        "height": 1.53,
        "facings": [
          {
            "id": "696ebf7143c343680a271d19",
            "leftCorner": {
              "x": 8.911,
              "y": -1.83,
              "z": 1.53
            },
            "rightCorner": {
              "x": 8.948,
              "y": -1.864,
              "z": 1.53
            },
            "gtin": "4067796168402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d1a",
            "leftCorner": {
              "x": 8.948,
              "y": -1.864,
              "z": 1.53
            },
            "rightCorner": {
              "x": 8.976,
              "y": -1.889,
              "z": 1.53
            },
            "gtin": "4067796168402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d1b",
            "leftCorner": {
              "x": 8.976,
              "y": -1.889,
              "z": 1.53
            },
            "rightCorner": {
              "x": 9.023,
              "y": -1.931,
              "z": 1.53
            }
          },
          {
            "id": "696ebf7143c343680a271d1c",
            "leftCorner": {
              "x": 9.023,
              "y": -1.931,
              "z": 1.53
            },
            "rightCorner": {
              "x": 9.082,
              "y": -1.985,
              "z": 1.53
            },
            "gtin": "4066447890044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d1d",
            "leftCorner": {
              "x": 9.082,
              "y": -1.985,
              "z": 1.53
            },
            "rightCorner": {
              "x": 9.166,
              "y": -2.062,
              "z": 1.53
            },
            "gtin": "4067796185690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d1e",
            "leftCorner": {
              "x": 9.166,
              "y": -2.062,
              "z": 1.53
            },
            "rightCorner": {
              "x": 9.246,
              "y": -2.134,
              "z": 1.53
            },
            "gtin": "4067796180411",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d1f",
            "leftCorner": {
              "x": 9.246,
              "y": -2.134,
              "z": 1.53
            },
            "rightCorner": {
              "x": 9.316,
              "y": -2.198,
              "z": 1.53
            },
            "gtin": "4066447422801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d20",
            "leftCorner": {
              "x": 9.316,
              "y": -2.198,
              "z": 1.53
            },
            "rightCorner": {
              "x": 9.383,
              "y": -2.258,
              "z": 1.53
            },
            "gtin": "4066447422948",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d21",
            "leftCorner": {
              "x": 9.383,
              "y": -2.258,
              "z": 1.53
            },
            "rightCorner": {
              "x": 9.44,
              "y": -2.31,
              "z": 1.53
            },
            "gtin": "4066447422924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d22",
            "leftCorner": {
              "x": 9.44,
              "y": -2.31,
              "z": 1.53
            },
            "rightCorner": {
              "x": 9.505,
              "y": -2.369,
              "z": 1.53
            },
            "gtin": "4015537002348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d0f",
            "leftCorner": {
              "x": 9.505,
              "y": -2.369,
              "z": 1.53
            },
            "rightCorner": {
              "x": 9.613,
              "y": -2.468,
              "z": 1.53
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b98",
        "height": 1.7789,
        "facings": [
          {
            "id": "696ebf7143c343680a271d39",
            "leftCorner": {
              "x": 8.933,
              "y": -1.845,
              "z": 1.779
            },
            "rightCorner": {
              "x": 8.978,
              "y": -1.886,
              "z": 1.779
            },
            "gtin": "4066447422900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d3a",
            "leftCorner": {
              "x": 8.978,
              "y": -1.886,
              "z": 1.779
            },
            "rightCorner": {
              "x": 9.03,
              "y": -1.933,
              "z": 1.779
            },
            "gtin": "4066447422900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d3b",
            "leftCorner": {
              "x": 9.03,
              "y": -1.933,
              "z": 1.779
            },
            "rightCorner": {
              "x": 9.16,
              "y": -2.051,
              "z": 1.779
            },
            "gtin": "4066447892406",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d3c",
            "leftCorner": {
              "x": 9.16,
              "y": -2.051,
              "z": 1.779
            },
            "rightCorner": {
              "x": 9.241,
              "y": -2.125,
              "z": 1.779
            },
            "gtin": "4066447422986",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d3d",
            "leftCorner": {
              "x": 9.241,
              "y": -2.125,
              "z": 1.779
            },
            "rightCorner": {
              "x": 9.338,
              "y": -2.212,
              "z": 1.779
            },
            "gtin": "4066447422764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d3e",
            "leftCorner": {
              "x": 9.338,
              "y": -2.212,
              "z": 1.779
            },
            "rightCorner": {
              "x": 9.426,
              "y": -2.293,
              "z": 1.779
            },
            "gtin": "4066447422825",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d3f",
            "leftCorner": {
              "x": 9.426,
              "y": -2.293,
              "z": 1.779
            },
            "rightCorner": {
              "x": 9.579,
              "y": -2.432,
              "z": 1.779
            },
            "gtin": "4066447422849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d40",
            "leftCorner": {
              "x": 9.579,
              "y": -2.432,
              "z": 1.779
            },
            "rightCorner": {
              "x": 9.616,
              "y": -2.465,
              "z": 1.779
            },
            "gtin": "4066447422962",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7578bb5fe7bc0469599f4",
    "name": "68e7578bb5fe7bc0469599f4",
    "x": 9.6531,
    "y": -2.4415,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.35124,
      "w": 0.93629
    },
    "statistics": {
      "hasStockCount": 38,
      "noStockCount": 0,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73ba3",
        "height": 0.20864,
        "facings": [
          {
            "id": "696ebf7143c343680a271da5",
            "leftCorner": {
              "x": 9.621,
              "y": -2.471,
              "z": 0.208
            },
            "rightCorner": {
              "x": 9.716,
              "y": -2.557,
              "z": 0.208
            },
            "gtin": "4066447599466",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271da6",
            "leftCorner": {
              "x": 9.726,
              "y": -2.565,
              "z": 0.209
            },
            "rightCorner": {
              "x": 9.845,
              "y": -2.668,
              "z": 0.209
            },
            "gtin": "4067796162714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271da7",
            "leftCorner": {
              "x": 9.845,
              "y": -2.668,
              "z": 0.209
            },
            "rightCorner": {
              "x": 9.93,
              "y": -2.743,
              "z": 0.209
            },
            "gtin": "4067796156560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271da8",
            "leftCorner": {
              "x": 9.93,
              "y": -2.743,
              "z": 0.209
            },
            "rightCorner": {
              "x": 10.039,
              "y": -2.838,
              "z": 0.209
            },
            "gtin": "4066447599442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271da9",
            "leftCorner": {
              "x": 10.039,
              "y": -2.838,
              "z": 0.209
            },
            "rightCorner": {
              "x": 10.071,
              "y": -2.866,
              "z": 0.209
            },
            "gtin": "4000381080734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271daa",
            "leftCorner": {
              "x": 10.071,
              "y": -2.866,
              "z": 0.209
            },
            "rightCorner": {
              "x": 10.128,
              "y": -2.916,
              "z": 0.209
            },
            "gtin": "4000381080734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dab",
            "leftCorner": {
              "x": 10.128,
              "y": -2.916,
              "z": 0.209
            },
            "rightCorner": {
              "x": 10.158,
              "y": -2.942,
              "z": 0.209
            }
          },
          {
            "id": "696ebf7143c343680a271dac",
            "leftCorner": {
              "x": 10.158,
              "y": -2.942,
              "z": 0.209
            },
            "rightCorner": {
              "x": 10.248,
              "y": -3.021,
              "z": 0.209
            },
            "gtin": "4000381003092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dad",
            "leftCorner": {
              "x": 10.248,
              "y": -3.021,
              "z": 0.209
            },
            "rightCorner": {
              "x": 10.276,
              "y": -3.045,
              "z": 0.209
            }
          },
          {
            "id": "696ebf7143c343680a271dae",
            "leftCorner": {
              "x": 10.276,
              "y": -3.045,
              "z": 0.209
            },
            "rightCorner": {
              "x": 10.349,
              "y": -3.109,
              "z": 0.209
            },
            "gtin": "4000381003085",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73b9f",
        "height": 0.47545,
        "facings": [
          {
            "id": "696ebf7143c343680a271d66",
            "leftCorner": {
              "x": 9.605,
              "y": -2.449,
              "z": 0.475
            },
            "rightCorner": {
              "x": 9.718,
              "y": -2.552,
              "z": 0.475
            },
            "gtin": "4260654783131",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d67",
            "leftCorner": {
              "x": 9.725,
              "y": -2.562,
              "z": 0.475
            },
            "rightCorner": {
              "x": 9.813,
              "y": -2.639,
              "z": 0.475
            },
            "gtin": "4255582813845",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d68",
            "leftCorner": {
              "x": 9.813,
              "y": -2.639,
              "z": 0.475
            },
            "rightCorner": {
              "x": 9.91,
              "y": -2.724,
              "z": 0.475
            },
            "gtin": "4260654782882",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d69",
            "leftCorner": {
              "x": 9.91,
              "y": -2.724,
              "z": 0.475
            },
            "rightCorner": {
              "x": 10.005,
              "y": -2.807,
              "z": 0.475
            },
            "gtin": "4260654789898",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d6a",
            "leftCorner": {
              "x": 10.005,
              "y": -2.807,
              "z": 0.475
            },
            "rightCorner": {
              "x": 10.088,
              "y": -2.88,
              "z": 0.475
            },
            "gtin": "4255582809893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d6b",
            "leftCorner": {
              "x": 10.088,
              "y": -2.88,
              "z": 0.475
            },
            "rightCorner": {
              "x": 10.195,
              "y": -2.973,
              "z": 0.475
            },
            "gtin": "4255582805512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d6c",
            "leftCorner": {
              "x": 10.195,
              "y": -2.973,
              "z": 0.475
            },
            "rightCorner": {
              "x": 10.224,
              "y": -2.998,
              "z": 0.475
            }
          },
          {
            "id": "696ebf7143c343680a271d6d",
            "leftCorner": {
              "x": 10.224,
              "y": -2.998,
              "z": 0.475
            },
            "rightCorner": {
              "x": 10.317,
              "y": -3.079,
              "z": 0.475
            },
            "gtin": "4255582813326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d6e",
            "leftCorner": {
              "x": 10.317,
              "y": -3.079,
              "z": 0.475
            },
            "rightCorner": {
              "x": 10.415,
              "y": -3.165,
              "z": 0.475
            },
            "gtin": "4262354077800",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73ba5",
        "height": 0.68467,
        "facings": [
          {
            "id": "696ebf7143c343680a271dee",
            "leftCorner": {
              "x": 9.624,
              "y": -2.475,
              "z": 0.685
            },
            "rightCorner": {
              "x": 9.733,
              "y": -2.571,
              "z": 0.685
            },
            "gtin": "4260644581266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271def",
            "leftCorner": {
              "x": 9.733,
              "y": -2.571,
              "z": 0.685
            },
            "rightCorner": {
              "x": 9.849,
              "y": -2.672,
              "z": 0.685
            },
            "gtin": "4260644581303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271df0",
            "leftCorner": {
              "x": 9.849,
              "y": -2.672,
              "z": 0.685
            },
            "rightCorner": {
              "x": 9.973,
              "y": -2.78,
              "z": 0.685
            },
            "gtin": "4260644581341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271df1",
            "leftCorner": {
              "x": 9.973,
              "y": -2.78,
              "z": 0.685
            },
            "rightCorner": {
              "x": 10.071,
              "y": -2.865,
              "z": 0.685
            },
            "gtin": "4260159456578",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271df2",
            "leftCorner": {
              "x": 10.071,
              "y": -2.865,
              "z": 0.685
            },
            "rightCorner": {
              "x": 10.1,
              "y": -2.891,
              "z": 0.685
            }
          },
          {
            "id": "696ebf7143c343680a271df3",
            "leftCorner": {
              "x": 10.1,
              "y": -2.891,
              "z": 0.685
            },
            "rightCorner": {
              "x": 10.183,
              "y": -2.964,
              "z": 0.685
            },
            "gtin": "4260159450484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271df4",
            "leftCorner": {
              "x": 10.183,
              "y": -2.964,
              "z": 0.685
            },
            "rightCorner": {
              "x": 10.213,
              "y": -2.989,
              "z": 0.685
            }
          },
          {
            "id": "696ebf7143c343680a271df5",
            "leftCorner": {
              "x": 10.213,
              "y": -2.989,
              "z": 0.685
            },
            "rightCorner": {
              "x": 10.269,
              "y": -3.039,
              "z": 0.685
            },
            "gtin": "4262354077602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271df6",
            "leftCorner": {
              "x": 10.269,
              "y": -3.039,
              "z": 0.685
            },
            "rightCorner": {
              "x": 10.364,
              "y": -3.121,
              "z": 0.685
            },
            "gtin": "4262354077046",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73ba2",
        "height": 0.8544,
        "facings": [
          {
            "id": "696ebf7143c343680a271dd7",
            "leftCorner": {
              "x": 9.619,
              "y": -2.481,
              "z": 0.854
            },
            "rightCorner": {
              "x": 9.709,
              "y": -2.559,
              "z": 0.854
            },
            "gtin": "4260556678344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dd9",
            "leftCorner": {
              "x": 9.709,
              "y": -2.559,
              "z": 0.854
            },
            "rightCorner": {
              "x": 9.814,
              "y": -2.651,
              "z": 0.854
            },
            "gtin": "4260556670935",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271dda",
            "leftCorner": {
              "x": 9.814,
              "y": -2.651,
              "z": 0.854
            },
            "rightCorner": {
              "x": 9.92,
              "y": -2.743,
              "z": 0.854
            },
            "gtin": "4262414872529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ddb",
            "leftCorner": {
              "x": 9.92,
              "y": -2.743,
              "z": 0.854
            },
            "rightCorner": {
              "x": 10.027,
              "y": -2.837,
              "z": 0.854
            },
            "gtin": "4260739994360",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ddc",
            "leftCorner": {
              "x": 10.027,
              "y": -2.837,
              "z": 0.854
            },
            "rightCorner": {
              "x": 10.057,
              "y": -2.863,
              "z": 0.854
            }
          },
          {
            "id": "696ebf7143c343680a271ddd",
            "leftCorner": {
              "x": 10.057,
              "y": -2.863,
              "z": 0.854
            },
            "rightCorner": {
              "x": 10.124,
              "y": -2.921,
              "z": 0.854
            },
            "gtin": "4260697376000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dde",
            "leftCorner": {
              "x": 10.124,
              "y": -2.921,
              "z": 0.854
            },
            "rightCorner": {
              "x": 10.154,
              "y": -2.947,
              "z": 0.854
            }
          },
          {
            "id": "696ebf7143c343680a271ddf",
            "leftCorner": {
              "x": 10.154,
              "y": -2.947,
              "z": 0.854
            },
            "rightCorner": {
              "x": 10.198,
              "y": -2.986,
              "z": 0.854
            },
            "gtin": "4260697376352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271de0",
            "leftCorner": {
              "x": 10.198,
              "y": -2.986,
              "z": 0.854
            },
            "rightCorner": {
              "x": 10.225,
              "y": -3.01,
              "z": 0.854
            }
          },
          {
            "id": "696ebf7143c343680a271de1",
            "leftCorner": {
              "x": 10.225,
              "y": -3.01,
              "z": 0.854
            },
            "rightCorner": {
              "x": 10.313,
              "y": -3.087,
              "z": 0.854
            },
            "gtin": "4067796073355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dd8",
            "leftCorner": {
              "x": 10.313,
              "y": -3.087,
              "z": 0.854
            },
            "rightCorner": {
              "x": 10.372,
              "y": -3.138,
              "z": 0.854
            },
            "gtin": "4262378221401",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73ba4",
        "height": 1.0198,
        "facings": [
          {
            "id": "696ebf7143c343680a271de2",
            "leftCorner": {
              "x": 9.626,
              "y": -2.473,
              "z": 1.02
            },
            "rightCorner": {
              "x": 9.744,
              "y": -2.576,
              "z": 1.02
            },
            "gtin": "4066447203431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271de4",
            "leftCorner": {
              "x": 9.744,
              "y": -2.576,
              "z": 1.02
            },
            "rightCorner": {
              "x": 9.857,
              "y": -2.675,
              "z": 1.02
            },
            "gtin": "4066447084894",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271de5",
            "leftCorner": {
              "x": 9.857,
              "y": -2.675,
              "z": 1.02
            },
            "rightCorner": {
              "x": 9.974,
              "y": -2.777,
              "z": 1.02
            },
            "gtin": "4066447363043",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271de6",
            "leftCorner": {
              "x": 9.974,
              "y": -2.777,
              "z": 1.02
            },
            "rightCorner": {
              "x": 10.091,
              "y": -2.879,
              "z": 1.02
            },
            "gtin": "4066447363036",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271de7",
            "leftCorner": {
              "x": 10.091,
              "y": -2.879,
              "z": 1.02
            },
            "rightCorner": {
              "x": 10.121,
              "y": -2.905,
              "z": 1.02
            }
          },
          {
            "id": "696ebf7143c343680a271de8",
            "leftCorner": {
              "x": 10.121,
              "y": -2.905,
              "z": 1.02
            },
            "rightCorner": {
              "x": 10.197,
              "y": -2.971,
              "z": 1.02
            },
            "gtin": "4066447314632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271de9",
            "leftCorner": {
              "x": 10.197,
              "y": -2.971,
              "z": 1.02
            },
            "rightCorner": {
              "x": 10.297,
              "y": -3.059,
              "z": 1.02
            },
            "gtin": "4058172390340",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271dea",
            "leftCorner": {
              "x": 10.297,
              "y": -3.059,
              "z": 1.02
            },
            "rightCorner": {
              "x": 10.366,
              "y": -3.119,
              "z": 1.02
            },
            "gtin": "4067796067538",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73ba7",
        "height": 1.1929,
        "facings": [
          {
            "id": "696ebf7143c343680a271e00",
            "leftCorner": {
              "x": 9.62,
              "y": -2.479,
              "z": 1.193
            },
            "rightCorner": {
              "x": 9.73,
              "y": -2.576,
              "z": 1.193
            },
            "gtin": "4066447168877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e02",
            "leftCorner": {
              "x": 9.73,
              "y": -2.576,
              "z": 1.193
            },
            "rightCorner": {
              "x": 9.831,
              "y": -2.664,
              "z": 1.193
            },
            "gtin": "4066447218541",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e03",
            "leftCorner": {
              "x": 9.831,
              "y": -2.664,
              "z": 1.193
            },
            "rightCorner": {
              "x": 9.941,
              "y": -2.76,
              "z": 1.193
            },
            "gtin": "4066447218534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e04",
            "leftCorner": {
              "x": 9.941,
              "y": -2.76,
              "z": 1.193
            },
            "rightCorner": {
              "x": 10.06,
              "y": -2.864,
              "z": 1.193
            },
            "gtin": "4066447615982",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e05",
            "leftCorner": {
              "x": 10.06,
              "y": -2.864,
              "z": 1.193
            },
            "rightCorner": {
              "x": 10.179,
              "y": -2.968,
              "z": 1.193
            },
            "gtin": "4066447168884",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e06",
            "leftCorner": {
              "x": 10.179,
              "y": -2.968,
              "z": 1.193
            },
            "rightCorner": {
              "x": 10.245,
              "y": -3.025,
              "z": 1.193
            },
            "gtin": "4067796013023",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e07",
            "leftCorner": {
              "x": 10.245,
              "y": -3.025,
              "z": 1.193
            },
            "rightCorner": {
              "x": 10.299,
              "y": -3.073,
              "z": 1.193
            },
            "gtin": "4067796014280",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e01",
            "leftCorner": {
              "x": 10.299,
              "y": -3.073,
              "z": 1.193
            },
            "rightCorner": {
              "x": 10.373,
              "y": -3.137,
              "z": 1.193
            },
            "gtin": "4066447256628",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73ba6",
        "height": 1.3619,
        "facings": [
          {
            "id": "696ebf7143c343680a271df7",
            "leftCorner": {
              "x": 9.624,
              "y": -2.475,
              "z": 1.362
            },
            "rightCorner": {
              "x": 9.739,
              "y": -2.576,
              "z": 1.362
            },
            "gtin": "4066447225372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271df8",
            "leftCorner": {
              "x": 9.739,
              "y": -2.576,
              "z": 1.362
            },
            "rightCorner": {
              "x": 9.859,
              "y": -2.68,
              "z": 1.362
            },
            "gtin": "4066447225396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271df9",
            "leftCorner": {
              "x": 9.859,
              "y": -2.68,
              "z": 1.362
            },
            "rightCorner": {
              "x": 9.984,
              "y": -2.79,
              "z": 1.362
            },
            "gtin": "4066447229066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dfa",
            "leftCorner": {
              "x": 9.984,
              "y": -2.79,
              "z": 1.362
            },
            "rightCorner": {
              "x": 10.103,
              "y": -2.894,
              "z": 1.362
            },
            "gtin": "4067796041019",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271dfb",
            "leftCorner": {
              "x": 10.103,
              "y": -2.894,
              "z": 1.362
            },
            "rightCorner": {
              "x": 10.134,
              "y": -2.921,
              "z": 1.362
            }
          },
          {
            "id": "696ebf7143c343680a271dfc",
            "leftCorner": {
              "x": 10.134,
              "y": -2.921,
              "z": 1.362
            },
            "rightCorner": {
              "x": 10.223,
              "y": -2.999,
              "z": 1.362
            },
            "gtin": "4066447200287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dfd",
            "leftCorner": {
              "x": 10.223,
              "y": -2.999,
              "z": 1.362
            },
            "rightCorner": {
              "x": 10.258,
              "y": -3.029,
              "z": 1.362
            }
          },
          {
            "id": "696ebf7143c343680a271dfe",
            "leftCorner": {
              "x": 10.258,
              "y": -3.029,
              "z": 1.362
            },
            "rightCorner": {
              "x": 10.335,
              "y": -3.096,
              "z": 1.362
            },
            "gtin": "4066447616477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dff",
            "leftCorner": {
              "x": 10.335,
              "y": -3.096,
              "z": 1.362
            },
            "rightCorner": {
              "x": 10.373,
              "y": -3.13,
              "z": 1.362
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73ba1",
        "height": 1.5715,
        "facings": [
          {
            "id": "696ebf7143c343680a271dc9",
            "leftCorner": {
              "x": 9.62,
              "y": -2.479,
              "z": 1.572
            },
            "rightCorner": {
              "x": 9.678,
              "y": -2.53,
              "z": 1.572
            },
            "gtin": "4067796195361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dca",
            "leftCorner": {
              "x": 9.678,
              "y": -2.53,
              "z": 1.572
            },
            "rightCorner": {
              "x": 9.742,
              "y": -2.586,
              "z": 1.572
            },
            "gtin": "4067796194173",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271dcb",
            "leftCorner": {
              "x": 9.742,
              "y": -2.586,
              "z": 1.572
            },
            "rightCorner": {
              "x": 9.808,
              "y": -2.643,
              "z": 1.572
            },
            "gtin": "4067796194524",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271dcc",
            "leftCorner": {
              "x": 9.808,
              "y": -2.643,
              "z": 1.572
            },
            "rightCorner": {
              "x": 9.868,
              "y": -2.696,
              "z": 1.572
            },
            "gtin": "4067796174373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dcd",
            "leftCorner": {
              "x": 9.868,
              "y": -2.696,
              "z": 1.572
            },
            "rightCorner": {
              "x": 9.932,
              "y": -2.752,
              "z": 1.572
            },
            "gtin": "4067796194548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dce",
            "leftCorner": {
              "x": 9.932,
              "y": -2.752,
              "z": 1.572
            },
            "rightCorner": {
              "x": 10.001,
              "y": -2.813,
              "z": 1.572
            },
            "gtin": "4066447090949",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271dcf",
            "leftCorner": {
              "x": 10.001,
              "y": -2.813,
              "z": 1.572
            },
            "rightCorner": {
              "x": 10.068,
              "y": -2.871,
              "z": 1.572
            },
            "gtin": "4066447703061",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271dd0",
            "leftCorner": {
              "x": 10.068,
              "y": -2.871,
              "z": 1.572
            },
            "rightCorner": {
              "x": 10.101,
              "y": -2.9,
              "z": 1.572
            },
            "gtin": "4067796195385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dd1",
            "leftCorner": {
              "x": 10.101,
              "y": -2.9,
              "z": 1.572
            },
            "rightCorner": {
              "x": 10.135,
              "y": -2.929,
              "z": 1.572
            },
            "gtin": "4067796195385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dd2",
            "leftCorner": {
              "x": 10.135,
              "y": -2.929,
              "z": 1.572
            },
            "rightCorner": {
              "x": 10.182,
              "y": -2.97,
              "z": 1.572
            },
            "gtin": "4066447523409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dd3",
            "leftCorner": {
              "x": 10.182,
              "y": -2.97,
              "z": 1.572
            },
            "rightCorner": {
              "x": 10.228,
              "y": -3.01,
              "z": 1.572
            },
            "gtin": "4067796174359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dd4",
            "leftCorner": {
              "x": 10.228,
              "y": -3.01,
              "z": 1.572
            },
            "rightCorner": {
              "x": 10.273,
              "y": -3.05,
              "z": 1.572
            },
            "gtin": "4067796174410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271dd5",
            "leftCorner": {
              "x": 10.273,
              "y": -3.05,
              "z": 1.572
            },
            "rightCorner": {
              "x": 10.319,
              "y": -3.09,
              "z": 1.572
            },
            "gtin": "4067796194159",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271dd6",
            "leftCorner": {
              "x": 10.319,
              "y": -3.09,
              "z": 1.572
            },
            "rightCorner": {
              "x": 10.366,
              "y": -3.131,
              "z": 1.572
            },
            "gtin": "4067796194159",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73ba0",
        "height": 1.7795,
        "facings": [
          {
            "id": "696ebf7143c343680a271d41",
            "leftCorner": {
              "x": 9.616,
              "y": -2.484,
              "z": 1.78
            },
            "rightCorner": {
              "x": 9.696,
              "y": -2.557,
              "z": 1.78
            },
            "gtin": "5425007881899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d42",
            "leftCorner": {
              "x": 9.698,
              "y": -2.556,
              "z": 1.78
            },
            "rightCorner": {
              "x": 9.769,
              "y": -2.618,
              "z": 1.78
            },
            "gtin": "5425007882643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d43",
            "leftCorner": {
              "x": 9.769,
              "y": -2.618,
              "z": 1.78
            },
            "rightCorner": {
              "x": 9.836,
              "y": -2.676,
              "z": 1.78
            },
            "gtin": "7610815101194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d44",
            "leftCorner": {
              "x": 9.836,
              "y": -2.676,
              "z": 1.78
            },
            "rightCorner": {
              "x": 9.905,
              "y": -2.737,
              "z": 1.78
            },
            "gtin": "7610815028774",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d45",
            "leftCorner": {
              "x": 9.905,
              "y": -2.737,
              "z": 1.78
            },
            "rightCorner": {
              "x": 9.982,
              "y": -2.804,
              "z": 1.78
            }
          },
          {
            "id": "696ebf7143c343680a271d46",
            "leftCorner": {
              "x": 9.982,
              "y": -2.804,
              "z": 1.78
            },
            "rightCorner": {
              "x": 10.033,
              "y": -2.848,
              "z": 1.78
            }
          },
          {
            "id": "696ebf7143c343680a271d47",
            "leftCorner": {
              "x": 10.033,
              "y": -2.848,
              "z": 1.78
            },
            "rightCorner": {
              "x": 10.087,
              "y": -2.895,
              "z": 1.78
            },
            "gtin": "4262414874028",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d48",
            "leftCorner": {
              "x": 10.087,
              "y": -2.895,
              "z": 1.78
            },
            "rightCorner": {
              "x": 10.135,
              "y": -2.938,
              "z": 1.78
            },
            "gtin": "4262414872895",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d49",
            "leftCorner": {
              "x": 10.135,
              "y": -2.938,
              "z": 1.78
            },
            "rightCorner": {
              "x": 10.188,
              "y": -2.984,
              "z": 1.78
            },
            "gtin": "4262414873120",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d4a",
            "leftCorner": {
              "x": 10.188,
              "y": -2.984,
              "z": 1.78
            },
            "rightCorner": {
              "x": 10.235,
              "y": -3.025,
              "z": 1.78
            },
            "gtin": "4262414872888",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d4b",
            "leftCorner": {
              "x": 10.235,
              "y": -3.025,
              "z": 1.78
            },
            "rightCorner": {
              "x": 10.305,
              "y": -3.086,
              "z": 1.78
            },
            "gtin": "4262354071006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d4c",
            "leftCorner": {
              "x": 10.305,
              "y": -3.086,
              "z": 1.78
            },
            "rightCorner": {
              "x": 10.369,
              "y": -3.142,
              "z": 1.78
            },
            "gtin": "4262354071105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d4d",
            "leftCorner": {
              "x": 10.38,
              "y": -3.151,
              "z": 1.781
            },
            "rightCorner": {
              "x": 10.416,
              "y": -3.183,
              "z": 1.781
            },
            "gtin": "4066447704204",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7578bb5fe7bc0469599f5",
    "name": "68e7578bb5fe7bc0469599f5",
    "x": 10.397,
    "y": -3.1037,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.35715,
      "w": 0.93405
    },
    "statistics": {
      "hasStockCount": 14,
      "noStockCount": 0,
      "unknownStockCount": 26
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73bae",
        "height": 0.21014,
        "facings": [
          {
            "id": "696ebf7143c343680a271daf",
            "leftCorner": {
              "x": 10.349,
              "y": -3.109,
              "z": 0.209
            },
            "rightCorner": {
              "x": 10.494,
              "y": -3.236,
              "z": 0.209
            },
            "gtin": "4260350920885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271db0",
            "leftCorner": {
              "x": 10.483,
              "y": -3.241,
              "z": 0.21
            },
            "rightCorner": {
              "x": 10.651,
              "y": -3.392,
              "z": 0.21
            },
            "gtin": "4260350926528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271db1",
            "leftCorner": {
              "x": 10.651,
              "y": -3.392,
              "z": 0.21
            },
            "rightCorner": {
              "x": 10.765,
              "y": -3.494,
              "z": 0.21
            },
            "gtin": "4260350927136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271db2",
            "leftCorner": {
              "x": 10.765,
              "y": -3.494,
              "z": 0.21
            },
            "rightCorner": {
              "x": 10.905,
              "y": -3.62,
              "z": 0.21
            },
            "gtin": "4067796125450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271db3",
            "leftCorner": {
              "x": 10.905,
              "y": -3.62,
              "z": 0.21
            },
            "rightCorner": {
              "x": 10.976,
              "y": -3.683,
              "z": 0.21
            },
            "gtin": "4066447225662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271db4",
            "leftCorner": {
              "x": 10.976,
              "y": -3.683,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.003,
              "y": -3.707,
              "z": 0.21
            },
            "gtin": "4066447225662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271db5",
            "leftCorner": {
              "x": 11.003,
              "y": -3.707,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.095,
              "y": -3.789,
              "z": 0.21
            },
            "gtin": "4066447884906",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73ba8",
        "height": 0.47488,
        "facings": [
          {
            "id": "696ebf7143c343680a271d6f",
            "leftCorner": {
              "x": 10.406,
              "y": -3.169,
              "z": 0.475
            },
            "rightCorner": {
              "x": 10.495,
              "y": -3.248,
              "z": 0.475
            },
            "gtin": "4270001544339",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d70",
            "leftCorner": {
              "x": 10.495,
              "y": -3.248,
              "z": 0.475
            },
            "rightCorner": {
              "x": 10.58,
              "y": -3.324,
              "z": 0.475
            },
            "gtin": "4270001544346",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d71",
            "leftCorner": {
              "x": 10.58,
              "y": -3.324,
              "z": 0.475
            },
            "rightCorner": {
              "x": 10.605,
              "y": -3.347,
              "z": 0.475
            }
          },
          {
            "id": "696ebf7143c343680a271d72",
            "leftCorner": {
              "x": 10.605,
              "y": -3.347,
              "z": 0.475
            },
            "rightCorner": {
              "x": 10.672,
              "y": -3.406,
              "z": 0.475
            },
            "gtin": "4260717840580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d73",
            "leftCorner": {
              "x": 10.672,
              "y": -3.406,
              "z": 0.475
            },
            "rightCorner": {
              "x": 10.694,
              "y": -3.426,
              "z": 0.475
            }
          },
          {
            "id": "696ebf7143c343680a271d74",
            "leftCorner": {
              "x": 10.694,
              "y": -3.426,
              "z": 0.475
            },
            "rightCorner": {
              "x": 10.752,
              "y": -3.478,
              "z": 0.475
            },
            "gtin": "4058172972256",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d75",
            "leftCorner": {
              "x": 10.752,
              "y": -3.478,
              "z": 0.475
            },
            "rightCorner": {
              "x": 10.82,
              "y": -3.539,
              "z": 0.475
            },
            "gtin": "4058172972270",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d76",
            "leftCorner": {
              "x": 10.82,
              "y": -3.539,
              "z": 0.475
            },
            "rightCorner": {
              "x": 10.906,
              "y": -3.616,
              "z": 0.475
            },
            "gtin": "4066447875683",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d77",
            "leftCorner": {
              "x": 10.906,
              "y": -3.616,
              "z": 0.475
            },
            "rightCorner": {
              "x": 10.987,
              "y": -3.689,
              "z": 0.475
            }
          },
          {
            "id": "696ebf7143c343680a271d78",
            "leftCorner": {
              "x": 10.987,
              "y": -3.689,
              "z": 0.475
            },
            "rightCorner": {
              "x": 11.011,
              "y": -3.71,
              "z": 0.475
            },
            "gtin": "4260739998252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d79",
            "leftCorner": {
              "x": 11.011,
              "y": -3.71,
              "z": 0.475
            },
            "rightCorner": {
              "x": 11.091,
              "y": -3.782,
              "z": 0.475
            },
            "gtin": "4260739998252",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73ba9",
        "height": 0.76916,
        "facings": [
          {
            "id": "696ebf7143c343680a271e08",
            "leftCorner": {
              "x": 10.367,
              "y": -3.138,
              "z": 0.769
            },
            "rightCorner": {
              "x": 10.557,
              "y": -3.308,
              "z": 0.769
            },
            "gtin": "4066447584073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e09",
            "leftCorner": {
              "x": 10.557,
              "y": -3.308,
              "z": 0.769
            },
            "rightCorner": {
              "x": 10.581,
              "y": -3.33,
              "z": 0.769
            }
          },
          {
            "id": "696ebf7143c343680a271e0a",
            "leftCorner": {
              "x": 10.581,
              "y": -3.33,
              "z": 0.769
            },
            "rightCorner": {
              "x": 10.768,
              "y": -3.497,
              "z": 0.769
            },
            "gtin": "4066447562682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e0b",
            "leftCorner": {
              "x": 10.768,
              "y": -3.497,
              "z": 0.769
            },
            "rightCorner": {
              "x": 10.989,
              "y": -3.695,
              "z": 0.769
            },
            "gtin": "4066447584035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e0c",
            "leftCorner": {
              "x": 10.989,
              "y": -3.695,
              "z": 0.769
            },
            "rightCorner": {
              "x": 11.017,
              "y": -3.72,
              "z": 0.769
            }
          },
          {
            "id": "696ebf7143c343680a271e0d",
            "leftCorner": {
              "x": 11.017,
              "y": -3.72,
              "z": 0.769
            },
            "rightCorner": {
              "x": 11.098,
              "y": -3.793,
              "z": 0.769
            },
            "gtin": "4016249177713",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73baa",
        "height": 1.0227,
        "facings": [
          {
            "id": "696ebf7143c343680a271deb",
            "leftCorner": {
              "x": 10.366,
              "y": -3.119,
              "z": 1.02
            },
            "rightCorner": {
              "x": 10.665,
              "y": -3.38,
              "z": 1.02
            },
            "gtin": "4066447584059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271dec",
            "leftCorner": {
              "x": 10.654,
              "y": -3.385,
              "z": 1.023
            },
            "rightCorner": {
              "x": 10.674,
              "y": -3.404,
              "z": 1.023
            }
          },
          {
            "id": "696ebf7143c343680a271ded",
            "leftCorner": {
              "x": 10.674,
              "y": -3.404,
              "z": 1.023
            },
            "rightCorner": {
              "x": 10.962,
              "y": -3.662,
              "z": 1.023
            },
            "gtin": "4066447562644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271de3",
            "leftCorner": {
              "x": 10.962,
              "y": -3.662,
              "z": 1.023
            },
            "rightCorner": {
              "x": 11.116,
              "y": -3.8,
              "z": 1.023
            },
            "gtin": "4067796064179",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bab",
        "height": 1.2767,
        "facings": [
          {
            "id": "696ebf7143c343680a271e0e",
            "leftCorner": {
              "x": 10.389,
              "y": -3.157,
              "z": 1.277
            },
            "rightCorner": {
              "x": 10.429,
              "y": -3.192,
              "z": 1.277
            },
            "gtin": "4066447295153",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e0f",
            "leftCorner": {
              "x": 10.429,
              "y": -3.192,
              "z": 1.277
            },
            "rightCorner": {
              "x": 10.504,
              "y": -3.26,
              "z": 1.277
            },
            "gtin": "4066447363159",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e10",
            "leftCorner": {
              "x": 10.504,
              "y": -3.26,
              "z": 1.277
            },
            "rightCorner": {
              "x": 10.609,
              "y": -3.354,
              "z": 1.277
            }
          },
          {
            "id": "696ebf7143c343680a271e11",
            "leftCorner": {
              "x": 10.609,
              "y": -3.354,
              "z": 1.277
            },
            "rightCorner": {
              "x": 10.633,
              "y": -3.375,
              "z": 1.277
            }
          },
          {
            "id": "696ebf7143c343680a271e12",
            "leftCorner": {
              "x": 10.633,
              "y": -3.375,
              "z": 1.277
            },
            "rightCorner": {
              "x": 10.705,
              "y": -3.44,
              "z": 1.277
            },
            "gtin": "4067796067514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e13",
            "leftCorner": {
              "x": 10.705,
              "y": -3.44,
              "z": 1.277
            },
            "rightCorner": {
              "x": 10.867,
              "y": -3.585,
              "z": 1.277
            },
            "gtin": "4066447369595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e14",
            "leftCorner": {
              "x": 10.867,
              "y": -3.585,
              "z": 1.277
            },
            "rightCorner": {
              "x": 10.977,
              "y": -3.683,
              "z": 1.277
            },
            "gtin": "4067796140309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e15",
            "leftCorner": {
              "x": 10.977,
              "y": -3.683,
              "z": 1.277
            },
            "rightCorner": {
              "x": 11.009,
              "y": -3.712,
              "z": 1.277
            }
          },
          {
            "id": "696ebf7143c343680a271e16",
            "leftCorner": {
              "x": 11.009,
              "y": -3.712,
              "z": 1.277
            },
            "rightCorner": {
              "x": 11.106,
              "y": -3.799,
              "z": 1.277
            },
            "gtin": "4066447874389",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bad",
        "height": 1.5305,
        "facings": [
          {
            "id": "696ebf7143c343680a271e17",
            "leftCorner": {
              "x": 10.368,
              "y": -3.136,
              "z": 1.531
            },
            "rightCorner": {
              "x": 10.469,
              "y": -3.226,
              "z": 1.531
            },
            "gtin": "4067796161472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e19",
            "leftCorner": {
              "x": 10.469,
              "y": -3.226,
              "z": 1.531
            },
            "rightCorner": {
              "x": 10.56,
              "y": -3.308,
              "z": 1.531
            },
            "gtin": "4067796161458",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e1a",
            "leftCorner": {
              "x": 10.56,
              "y": -3.308,
              "z": 1.531
            },
            "rightCorner": {
              "x": 10.588,
              "y": -3.333,
              "z": 1.531
            }
          },
          {
            "id": "696ebf7143c343680a271e1b",
            "leftCorner": {
              "x": 10.588,
              "y": -3.333,
              "z": 1.531
            },
            "rightCorner": {
              "x": 10.684,
              "y": -3.419,
              "z": 1.531
            },
            "gtin": "4066447858136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e1c",
            "leftCorner": {
              "x": 10.684,
              "y": -3.419,
              "z": 1.531
            },
            "rightCorner": {
              "x": 10.778,
              "y": -3.503,
              "z": 1.531
            },
            "gtin": "4058172485411",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e1d",
            "leftCorner": {
              "x": 10.778,
              "y": -3.503,
              "z": 1.531
            },
            "rightCorner": {
              "x": 10.928,
              "y": -3.637,
              "z": 1.531
            },
            "gtin": "4066447712865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e1e",
            "leftCorner": {
              "x": 10.928,
              "y": -3.637,
              "z": 1.531
            },
            "rightCorner": {
              "x": 11.04,
              "y": -3.737,
              "z": 1.531
            },
            "gtin": "4066447712865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e18",
            "leftCorner": {
              "x": 11.04,
              "y": -3.737,
              "z": 1.531
            },
            "rightCorner": {
              "x": 11.113,
              "y": -3.803,
              "z": 1.531
            },
            "gtin": "7614800261665",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bac",
        "height": 1.7811,
        "facings": [
          {
            "id": "696ebf7143c343680a271d4e",
            "leftCorner": {
              "x": 10.416,
              "y": -3.183,
              "z": 1.781
            },
            "rightCorner": {
              "x": 10.549,
              "y": -3.302,
              "z": 1.781
            },
            "gtin": "4066447704181",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d4f",
            "leftCorner": {
              "x": 10.549,
              "y": -3.302,
              "z": 1.781
            },
            "rightCorner": {
              "x": 10.578,
              "y": -3.328,
              "z": 1.781
            }
          },
          {
            "id": "696ebf7143c343680a271d50",
            "leftCorner": {
              "x": 10.578,
              "y": -3.328,
              "z": 1.781
            },
            "rightCorner": {
              "x": 10.715,
              "y": -3.45,
              "z": 1.781
            },
            "gtin": "4066447704167",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d51",
            "leftCorner": {
              "x": 10.715,
              "y": -3.45,
              "z": 1.781
            },
            "rightCorner": {
              "x": 10.891,
              "y": -3.608,
              "z": 1.781
            },
            "gtin": "4067796209327",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271d52",
            "leftCorner": {
              "x": 10.891,
              "y": -3.608,
              "z": 1.781
            },
            "rightCorner": {
              "x": 10.988,
              "y": -3.695,
              "z": 1.781
            },
            "gtin": "4066447210224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271d2d",
            "leftCorner": {
              "x": 10.988,
              "y": -3.695,
              "z": 1.781
            },
            "rightCorner": {
              "x": 11.111,
              "y": -3.805,
              "z": 1.781
            },
            "gtin": "4016249080600",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7578bb5fe7bc0469599f6",
    "name": "68e7578bb5fe7bc0469599f6",
    "x": 12.059,
    "y": -2.756,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93347,
      "w": 0.35867
    },
    "statistics": {
      "hasStockCount": 36,
      "noStockCount": 0,
      "unknownStockCount": 25
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73bb7",
        "height": 0.21314,
        "facings": [
          {
            "id": "696ebf7143c343680a271e7d",
            "leftCorner": {
              "x": 12.089,
              "y": -2.723,
              "z": 0.213
            },
            "rightCorner": {
              "x": 12.03,
              "y": -2.669,
              "z": 0.213
            }
          },
          {
            "id": "696ebf7143c343680a271e7f",
            "leftCorner": {
              "x": 12.03,
              "y": -2.669,
              "z": 0.213
            },
            "rightCorner": {
              "x": 11.933,
              "y": -2.582,
              "z": 0.213
            },
            "gtin": "4066447484809",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e80",
            "leftCorner": {
              "x": 11.933,
              "y": -2.582,
              "z": 0.213
            },
            "rightCorner": {
              "x": 11.843,
              "y": -2.501,
              "z": 0.213
            },
            "gtin": "4067796180206",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e81",
            "leftCorner": {
              "x": 11.843,
              "y": -2.501,
              "z": 0.213
            },
            "rightCorner": {
              "x": 11.763,
              "y": -2.428,
              "z": 0.213
            },
            "gtin": "4066447893519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e82",
            "leftCorner": {
              "x": 11.763,
              "y": -2.428,
              "z": 0.213
            },
            "rightCorner": {
              "x": 11.664,
              "y": -2.34,
              "z": 0.213
            },
            "gtin": "4067796187243",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e83",
            "leftCorner": {
              "x": 11.664,
              "y": -2.34,
              "z": 0.213
            },
            "rightCorner": {
              "x": 11.578,
              "y": -2.262,
              "z": 0.213
            },
            "gtin": "4066447603330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e84",
            "leftCorner": {
              "x": 11.578,
              "y": -2.262,
              "z": 0.213
            },
            "rightCorner": {
              "x": 11.497,
              "y": -2.189,
              "z": 0.213
            },
            "gtin": "4066447603316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e85",
            "leftCorner": {
              "x": 11.497,
              "y": -2.189,
              "z": 0.213
            },
            "rightCorner": {
              "x": 11.414,
              "y": -2.114,
              "z": 0.213
            }
          },
          {
            "id": "696ebf7143c343680a271e86",
            "leftCorner": {
              "x": 11.414,
              "y": -2.114,
              "z": 0.213
            },
            "rightCorner": {
              "x": 11.336,
              "y": -2.043,
              "z": 0.213
            },
            "gtin": "4066447603293",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bb6",
        "height": 0.47467,
        "facings": [
          {
            "id": "696ebf7143c343680a271e68",
            "leftCorner": {
              "x": 12.088,
              "y": -2.724,
              "z": 0.475
            },
            "rightCorner": {
              "x": 12.024,
              "y": -2.667,
              "z": 0.475
            },
            "gtin": "4005394201176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e6a",
            "leftCorner": {
              "x": 12.024,
              "y": -2.667,
              "z": 0.475
            },
            "rightCorner": {
              "x": 11.97,
              "y": -2.617,
              "z": 0.475
            },
            "gtin": "4005394201152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e6b",
            "leftCorner": {
              "x": 11.97,
              "y": -2.617,
              "z": 0.475
            },
            "rightCorner": {
              "x": 11.912,
              "y": -2.565,
              "z": 0.475
            },
            "gtin": "4005394201169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e6c",
            "leftCorner": {
              "x": 11.912,
              "y": -2.565,
              "z": 0.475
            },
            "rightCorner": {
              "x": 11.836,
              "y": -2.497,
              "z": 0.475
            },
            "gtin": "4260390243852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e6d",
            "leftCorner": {
              "x": 11.836,
              "y": -2.497,
              "z": 0.475
            },
            "rightCorner": {
              "x": 11.76,
              "y": -2.428,
              "z": 0.475
            },
            "gtin": "4260390244477",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e6e",
            "leftCorner": {
              "x": 11.76,
              "y": -2.428,
              "z": 0.475
            },
            "rightCorner": {
              "x": 11.684,
              "y": -2.36,
              "z": 0.475
            },
            "gtin": "4260390241636",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e6f",
            "leftCorner": {
              "x": 11.684,
              "y": -2.36,
              "z": 0.475
            },
            "rightCorner": {
              "x": 11.619,
              "y": -2.301,
              "z": 0.475
            },
            "gtin": "4260390241629",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e70",
            "leftCorner": {
              "x": 11.619,
              "y": -2.301,
              "z": 0.475
            },
            "rightCorner": {
              "x": 11.599,
              "y": -2.283,
              "z": 0.475
            }
          },
          {
            "id": "696ebf7143c343680a271e71",
            "leftCorner": {
              "x": 11.599,
              "y": -2.283,
              "z": 0.475
            },
            "rightCorner": {
              "x": 11.523,
              "y": -2.215,
              "z": 0.475
            },
            "gtin": "4066447234787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e72",
            "leftCorner": {
              "x": 11.523,
              "y": -2.215,
              "z": 0.475
            },
            "rightCorner": {
              "x": 11.434,
              "y": -2.134,
              "z": 0.475
            },
            "gtin": "4066447530629",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e73",
            "leftCorner": {
              "x": 11.434,
              "y": -2.134,
              "z": 0.475
            },
            "rightCorner": {
              "x": 11.348,
              "y": -2.057,
              "z": 0.475
            },
            "gtin": "4067796160109",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bb1",
        "height": 0.72411,
        "facings": [
          {
            "id": "696ebf7143c343680a271e28",
            "leftCorner": {
              "x": 12.088,
              "y": -2.724,
              "z": 0.724
            },
            "rightCorner": {
              "x": 12.025,
              "y": -2.667,
              "z": 0.724
            },
            "gtin": "4255719302549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e29",
            "leftCorner": {
              "x": 12.025,
              "y": -2.667,
              "z": 0.724
            },
            "rightCorner": {
              "x": 11.924,
              "y": -2.576,
              "z": 0.724
            },
            "gtin": "4255719301115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e2a",
            "leftCorner": {
              "x": 11.924,
              "y": -2.576,
              "z": 0.724
            },
            "rightCorner": {
              "x": 11.805,
              "y": -2.469,
              "z": 0.724
            }
          },
          {
            "id": "696ebf7143c343680a271e2b",
            "leftCorner": {
              "x": 11.805,
              "y": -2.469,
              "z": 0.724
            },
            "rightCorner": {
              "x": 11.722,
              "y": -2.394,
              "z": 0.724
            },
            "gtin": "4067796087307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e2c",
            "leftCorner": {
              "x": 11.722,
              "y": -2.394,
              "z": 0.724
            },
            "rightCorner": {
              "x": 11.626,
              "y": -2.308,
              "z": 0.724
            },
            "gtin": "4066447423082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e2d",
            "leftCorner": {
              "x": 11.626,
              "y": -2.308,
              "z": 0.724
            },
            "rightCorner": {
              "x": 11.54,
              "y": -2.23,
              "z": 0.724
            },
            "gtin": "4066447423082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e2e",
            "leftCorner": {
              "x": 11.54,
              "y": -2.23,
              "z": 0.724
            },
            "rightCorner": {
              "x": 11.44,
              "y": -2.14,
              "z": 0.724
            },
            "gtin": "4066447423082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e2f",
            "leftCorner": {
              "x": 11.44,
              "y": -2.14,
              "z": 0.724
            },
            "rightCorner": {
              "x": 11.363,
              "y": -2.071,
              "z": 0.724
            },
            "gtin": "4066447888140",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bb0",
        "height": 0.97744,
        "facings": [
          {
            "id": "696ebf7143c343680a271e1f",
            "leftCorner": {
              "x": 12.091,
              "y": -2.72,
              "z": 0.977
            },
            "rightCorner": {
              "x": 12.008,
              "y": -2.645,
              "z": 0.977
            },
            "gtin": "4250519679709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e21",
            "leftCorner": {
              "x": 12.008,
              "y": -2.645,
              "z": 0.977
            },
            "rightCorner": {
              "x": 11.933,
              "y": -2.578,
              "z": 0.977
            },
            "gtin": "4250519679471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e22",
            "leftCorner": {
              "x": 11.933,
              "y": -2.578,
              "z": 0.977
            },
            "rightCorner": {
              "x": 11.851,
              "y": -2.504,
              "z": 0.977
            },
            "gtin": "4250519666112",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e23",
            "leftCorner": {
              "x": 11.851,
              "y": -2.504,
              "z": 0.977
            },
            "rightCorner": {
              "x": 11.772,
              "y": -2.433,
              "z": 0.977
            },
            "gtin": "4250519669632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e24",
            "leftCorner": {
              "x": 11.772,
              "y": -2.433,
              "z": 0.977
            },
            "rightCorner": {
              "x": 11.697,
              "y": -2.365,
              "z": 0.977
            },
            "gtin": "4255719301641",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e25",
            "leftCorner": {
              "x": 11.697,
              "y": -2.365,
              "z": 0.977
            },
            "rightCorner": {
              "x": 11.538,
              "y": -2.222,
              "z": 0.977
            },
            "gtin": "4255719310735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e26",
            "leftCorner": {
              "x": 11.538,
              "y": -2.222,
              "z": 0.977
            },
            "rightCorner": {
              "x": 11.463,
              "y": -2.154,
              "z": 0.977
            },
            "gtin": "4067796111729",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e27",
            "leftCorner": {
              "x": 11.463,
              "y": -2.154,
              "z": 0.977
            },
            "rightCorner": {
              "x": 11.389,
              "y": -2.087,
              "z": 0.977
            },
            "gtin": "4066447893427",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e20",
            "leftCorner": {
              "x": 11.389,
              "y": -2.087,
              "z": 0.977
            },
            "rightCorner": {
              "x": 11.348,
              "y": -2.051,
              "z": 0.977
            },
            "gtin": "4066447893441",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bb4",
        "height": 1.1914,
        "facings": [
          {
            "id": "696ebf7143c343680a271e3f",
            "leftCorner": {
              "x": 12.095,
              "y": -2.716,
              "z": 1.191
            },
            "rightCorner": {
              "x": 12.013,
              "y": -2.642,
              "z": 1.191
            },
            "gtin": "4260644048783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e41",
            "leftCorner": {
              "x": 12.013,
              "y": -2.642,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.905,
              "y": -2.545,
              "z": 1.191
            },
            "gtin": "4255719309487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e42",
            "leftCorner": {
              "x": 11.905,
              "y": -2.545,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.798,
              "y": -2.448,
              "z": 1.191
            },
            "gtin": "4255719311633",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e43",
            "leftCorner": {
              "x": 11.798,
              "y": -2.448,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.688,
              "y": -2.349,
              "z": 1.191
            },
            "gtin": "4255719312302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e44",
            "leftCorner": {
              "x": 11.688,
              "y": -2.349,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.568,
              "y": -2.241,
              "z": 1.191
            },
            "gtin": "4255719312326",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e45",
            "leftCorner": {
              "x": 11.568,
              "y": -2.241,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.456,
              "y": -2.14,
              "z": 1.191
            }
          },
          {
            "id": "696ebf7143c343680a271e40",
            "leftCorner": {
              "x": 11.456,
              "y": -2.14,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.352,
              "y": -2.046,
              "z": 1.191
            },
            "gtin": "4260644585813",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bb2",
        "height": 1.3579,
        "facings": [
          {
            "id": "696ebf7143c343680a271e30",
            "leftCorner": {
              "x": 12.093,
              "y": -2.718,
              "z": 1.358
            },
            "rightCorner": {
              "x": 12.017,
              "y": -2.65,
              "z": 1.358
            },
            "gtin": "4260697371487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e32",
            "leftCorner": {
              "x": 12.017,
              "y": -2.65,
              "z": 1.358
            },
            "rightCorner": {
              "x": 11.922,
              "y": -2.564,
              "z": 1.358
            },
            "gtin": "4260697371524",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e33",
            "leftCorner": {
              "x": 11.922,
              "y": -2.564,
              "z": 1.358
            },
            "rightCorner": {
              "x": 11.815,
              "y": -2.468,
              "z": 1.358
            },
            "gtin": "722252387530",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e34",
            "leftCorner": {
              "x": 11.815,
              "y": -2.468,
              "z": 1.358
            },
            "rightCorner": {
              "x": 11.704,
              "y": -2.367,
              "z": 1.358
            },
            "gtin": "7340001807400",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e35",
            "leftCorner": {
              "x": 11.704,
              "y": -2.367,
              "z": 1.358
            },
            "rightCorner": {
              "x": 11.604,
              "y": -2.277,
              "z": 1.358
            },
            "gtin": "7340001806649",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e36",
            "leftCorner": {
              "x": 11.604,
              "y": -2.277,
              "z": 1.358
            },
            "rightCorner": {
              "x": 11.581,
              "y": -2.256,
              "z": 1.358
            }
          },
          {
            "id": "696ebf7143c343680a271e37",
            "leftCorner": {
              "x": 11.581,
              "y": -2.256,
              "z": 1.358
            },
            "rightCorner": {
              "x": 11.463,
              "y": -2.15,
              "z": 1.358
            },
            "gtin": "7340001805512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e31",
            "leftCorner": {
              "x": 11.463,
              "y": -2.15,
              "z": 1.358
            },
            "rightCorner": {
              "x": 11.35,
              "y": -2.048,
              "z": 1.358
            },
            "gtin": "4066447600964",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bb3",
        "height": 1.5284,
        "facings": [
          {
            "id": "696ebf7143c343680a271e38",
            "leftCorner": {
              "x": 12.1,
              "y": -2.711,
              "z": 1.528
            },
            "rightCorner": {
              "x": 12.008,
              "y": -2.628,
              "z": 1.528
            },
            "gtin": "4066447891461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e39",
            "leftCorner": {
              "x": 12.008,
              "y": -2.628,
              "z": 1.528
            },
            "rightCorner": {
              "x": 11.905,
              "y": -2.536,
              "z": 1.528
            },
            "gtin": "4066447614749",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e3a",
            "leftCorner": {
              "x": 11.905,
              "y": -2.536,
              "z": 1.528
            },
            "rightCorner": {
              "x": 11.797,
              "y": -2.438,
              "z": 1.528
            },
            "gtin": "4066447319613",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e3b",
            "leftCorner": {
              "x": 11.797,
              "y": -2.438,
              "z": 1.528
            },
            "rightCorner": {
              "x": 11.702,
              "y": -2.353,
              "z": 1.528
            },
            "gtin": "4066447600988",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e3c",
            "leftCorner": {
              "x": 11.702,
              "y": -2.353,
              "z": 1.528
            },
            "rightCorner": {
              "x": 11.599,
              "y": -2.26,
              "z": 1.528
            },
            "gtin": "4066447731491",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e3d",
            "leftCorner": {
              "x": 11.599,
              "y": -2.26,
              "z": 1.528
            },
            "rightCorner": {
              "x": 11.467,
              "y": -2.14,
              "z": 1.528
            },
            "gtin": "4067796187830",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e3e",
            "leftCorner": {
              "x": 11.467,
              "y": -2.14,
              "z": 1.528
            },
            "rightCorner": {
              "x": 11.368,
              "y": -2.051,
              "z": 1.528
            },
            "gtin": "4067796100112",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bb5",
        "height": 1.6947,
        "facings": [
          {
            "id": "696ebf7143c343680a271e46",
            "leftCorner": {
              "x": 12.095,
              "y": -2.716,
              "z": 1.695
            },
            "rightCorner": {
              "x": 12.021,
              "y": -2.649,
              "z": 1.695
            },
            "gtin": "4066447319637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e48",
            "leftCorner": {
              "x": 12.021,
              "y": -2.649,
              "z": 1.695
            },
            "rightCorner": {
              "x": 11.923,
              "y": -2.561,
              "z": 1.695
            },
            "gtin": "4067796094138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e49",
            "leftCorner": {
              "x": 11.923,
              "y": -2.561,
              "z": 1.695
            },
            "rightCorner": {
              "x": 11.823,
              "y": -2.47,
              "z": 1.695
            },
            "gtin": "4058172969386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e4a",
            "leftCorner": {
              "x": 11.823,
              "y": -2.47,
              "z": 1.695
            },
            "rightCorner": {
              "x": 11.723,
              "y": -2.38,
              "z": 1.695
            },
            "gtin": "4058172969362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e4b",
            "leftCorner": {
              "x": 11.723,
              "y": -2.38,
              "z": 1.695
            },
            "rightCorner": {
              "x": 11.622,
              "y": -2.289,
              "z": 1.695
            },
            "gtin": "4250519677033",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e4c",
            "leftCorner": {
              "x": 11.622,
              "y": -2.289,
              "z": 1.695
            },
            "rightCorner": {
              "x": 11.602,
              "y": -2.271,
              "z": 1.695
            }
          },
          {
            "id": "696ebf7143c343680a271e4d",
            "leftCorner": {
              "x": 11.602,
              "y": -2.271,
              "z": 1.695
            },
            "rightCorner": {
              "x": 11.491,
              "y": -2.171,
              "z": 1.695
            },
            "gtin": "4250519672885",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e4e",
            "leftCorner": {
              "x": 11.491,
              "y": -2.171,
              "z": 1.695
            },
            "rightCorner": {
              "x": 11.374,
              "y": -2.066,
              "z": 1.695
            },
            "gtin": "4250519646527",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e4f",
            "leftCorner": {
              "x": 11.374,
              "y": -2.066,
              "z": 1.695
            },
            "rightCorner": {
              "x": 11.265,
              "y": -1.967,
              "z": 1.695
            },
            "gtin": "4250519647890",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7578bb5fe7bc0469599f7",
    "name": "68e7578bb5fe7bc0469599f7",
    "x": 11.316,
    "y": -2.0832,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93549,
      "w": 0.35335
    },
    "statistics": {
      "hasStockCount": 34,
      "noStockCount": 0,
      "unknownStockCount": 33
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73bbd",
        "height": 0.20925,
        "facings": [
          {
            "id": "696ebf7143c343680a271e87",
            "leftCorner": {
              "x": 11.335,
              "y": -2.04,
              "z": 0.209
            },
            "rightCorner": {
              "x": 11.269,
              "y": -1.981,
              "z": 0.209
            },
            "gtin": "4067796100471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e88",
            "leftCorner": {
              "x": 11.269,
              "y": -1.981,
              "z": 0.209
            },
            "rightCorner": {
              "x": 11.185,
              "y": -1.907,
              "z": 0.209
            },
            "gtin": "4067796188257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e89",
            "leftCorner": {
              "x": 11.185,
              "y": -1.907,
              "z": 0.209
            },
            "rightCorner": {
              "x": 11.111,
              "y": -1.842,
              "z": 0.209
            },
            "gtin": "4066447893014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e8a",
            "leftCorner": {
              "x": 11.111,
              "y": -1.842,
              "z": 0.209
            },
            "rightCorner": {
              "x": 11.077,
              "y": -1.812,
              "z": 0.209
            }
          },
          {
            "id": "696ebf7143c343680a271e8b",
            "leftCorner": {
              "x": 11.077,
              "y": -1.812,
              "z": 0.209
            },
            "rightCorner": {
              "x": 10.998,
              "y": -1.742,
              "z": 0.209
            },
            "gtin": "4066447051933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e8c",
            "leftCorner": {
              "x": 10.998,
              "y": -1.742,
              "z": 0.209
            },
            "rightCorner": {
              "x": 10.943,
              "y": -1.694,
              "z": 0.209
            },
            "gtin": "4066447870398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e8d",
            "leftCorner": {
              "x": 10.943,
              "y": -1.694,
              "z": 0.209
            },
            "rightCorner": {
              "x": 10.897,
              "y": -1.653,
              "z": 0.209
            },
            "gtin": "4067796181616",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e8e",
            "leftCorner": {
              "x": 10.897,
              "y": -1.653,
              "z": 0.209
            },
            "rightCorner": {
              "x": 10.834,
              "y": -1.598,
              "z": 0.209
            },
            "gtin": "4058172969546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e8f",
            "leftCorner": {
              "x": 10.834,
              "y": -1.598,
              "z": 0.209
            },
            "rightCorner": {
              "x": 10.791,
              "y": -1.56,
              "z": 0.209
            },
            "gtin": "4067796178494",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e90",
            "leftCorner": {
              "x": 10.791,
              "y": -1.56,
              "z": 0.209
            },
            "rightCorner": {
              "x": 10.739,
              "y": -1.514,
              "z": 0.209
            },
            "gtin": "4066447484847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e91",
            "leftCorner": {
              "x": 10.739,
              "y": -1.514,
              "z": 0.209
            },
            "rightCorner": {
              "x": 10.692,
              "y": -1.473,
              "z": 0.209
            },
            "gtin": "4066447414837",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e92",
            "leftCorner": {
              "x": 10.692,
              "y": -1.473,
              "z": 0.209
            },
            "rightCorner": {
              "x": 10.65,
              "y": -1.436,
              "z": 0.209
            },
            "gtin": "4066447093605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e93",
            "leftCorner": {
              "x": 10.65,
              "y": -1.436,
              "z": 0.209
            },
            "rightCorner": {
              "x": 10.607,
              "y": -1.398,
              "z": 0.209
            },
            "gtin": "4058172960222",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bb8",
        "height": 0.47306,
        "facings": [
          {
            "id": "696ebf7143c343680a271e74",
            "leftCorner": {
              "x": 11.348,
              "y": -2.057,
              "z": 0.475
            },
            "rightCorner": {
              "x": 11.292,
              "y": -2.006,
              "z": 0.475
            },
            "gtin": "4066447735192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e75",
            "leftCorner": {
              "x": 11.292,
              "y": -2.001,
              "z": 0.473
            },
            "rightCorner": {
              "x": 11.22,
              "y": -1.938,
              "z": 0.473
            },
            "gtin": "4066447735215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e76",
            "leftCorner": {
              "x": 11.22,
              "y": -1.938,
              "z": 0.473
            },
            "rightCorner": {
              "x": 11.16,
              "y": -1.885,
              "z": 0.473
            }
          },
          {
            "id": "696ebf7143c343680a271e77",
            "leftCorner": {
              "x": 11.16,
              "y": -1.885,
              "z": 0.473
            },
            "rightCorner": {
              "x": 11.117,
              "y": -1.847,
              "z": 0.473
            },
            "gtin": "4067796084481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e78",
            "leftCorner": {
              "x": 11.117,
              "y": -1.847,
              "z": 0.473
            },
            "rightCorner": {
              "x": 11.087,
              "y": -1.821,
              "z": 0.473
            },
            "gtin": "4067796084481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e79",
            "leftCorner": {
              "x": 11.087,
              "y": -1.821,
              "z": 0.473
            },
            "rightCorner": {
              "x": 11.014,
              "y": -1.757,
              "z": 0.473
            },
            "gtin": "4058172890284",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e7a",
            "leftCorner": {
              "x": 11.014,
              "y": -1.757,
              "z": 0.473
            },
            "rightCorner": {
              "x": 10.908,
              "y": -1.663,
              "z": 0.473
            },
            "gtin": "4066447600926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e7b",
            "leftCorner": {
              "x": 10.908,
              "y": -1.663,
              "z": 0.473
            },
            "rightCorner": {
              "x": 10.81,
              "y": -1.577,
              "z": 0.473
            },
            "gtin": "4067796127027",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e7c",
            "leftCorner": {
              "x": 10.81,
              "y": -1.577,
              "z": 0.473
            },
            "rightCorner": {
              "x": 10.705,
              "y": -1.484,
              "z": 0.473
            },
            "gtin": "4067796213102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e69",
            "leftCorner": {
              "x": 10.705,
              "y": -1.484,
              "z": 0.473
            },
            "rightCorner": {
              "x": 10.596,
              "y": -1.388,
              "z": 0.473
            },
            "gtin": "4067796149036",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bb9",
        "height": 0.68245,
        "facings": [
          {
            "id": "696ebf7143c343680a271eaf",
            "leftCorner": {
              "x": 11.346,
              "y": -2.049,
              "z": 0.682
            },
            "rightCorner": {
              "x": 11.251,
              "y": -1.965,
              "z": 0.682
            },
            "gtin": "4066447423068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271eb0",
            "leftCorner": {
              "x": 11.251,
              "y": -1.965,
              "z": 0.682
            },
            "rightCorner": {
              "x": 11.195,
              "y": -1.916,
              "z": 0.682
            },
            "gtin": "4036554704343",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eb1",
            "leftCorner": {
              "x": 11.195,
              "y": -1.916,
              "z": 0.682
            },
            "rightCorner": {
              "x": 11.12,
              "y": -1.849,
              "z": 0.682
            },
            "gtin": "4036554704336",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eb2",
            "leftCorner": {
              "x": 11.12,
              "y": -1.849,
              "z": 0.682
            },
            "rightCorner": {
              "x": 11.089,
              "y": -1.822,
              "z": 0.682
            },
            "gtin": "4250519684505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eb3",
            "leftCorner": {
              "x": 11.089,
              "y": -1.822,
              "z": 0.682
            },
            "rightCorner": {
              "x": 11.054,
              "y": -1.791,
              "z": 0.682
            },
            "gtin": "4250519684505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eb4",
            "leftCorner": {
              "x": 11.054,
              "y": -1.791,
              "z": 0.682
            },
            "rightCorner": {
              "x": 11.015,
              "y": -1.757,
              "z": 0.682
            },
            "gtin": "4250519684543",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eb5",
            "leftCorner": {
              "x": 11.015,
              "y": -1.757,
              "z": 0.682
            },
            "rightCorner": {
              "x": 10.963,
              "y": -1.711,
              "z": 0.682
            },
            "gtin": "4250519684598",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eb6",
            "leftCorner": {
              "x": 10.963,
              "y": -1.711,
              "z": 0.682
            },
            "rightCorner": {
              "x": 10.923,
              "y": -1.675,
              "z": 0.682
            },
            "gtin": "4250519684536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271eb7",
            "leftCorner": {
              "x": 10.923,
              "y": -1.675,
              "z": 0.682
            },
            "rightCorner": {
              "x": 10.867,
              "y": -1.626,
              "z": 0.682
            },
            "gtin": "4250519684574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eb8",
            "leftCorner": {
              "x": 10.867,
              "y": -1.626,
              "z": 0.682
            },
            "rightCorner": {
              "x": 10.808,
              "y": -1.574,
              "z": 0.682
            },
            "gtin": "4250519684550",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eb9",
            "leftCorner": {
              "x": 10.808,
              "y": -1.574,
              "z": 0.682
            },
            "rightCorner": {
              "x": 10.744,
              "y": -1.518,
              "z": 0.682
            },
            "gtin": "4250519684604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eba",
            "leftCorner": {
              "x": 10.744,
              "y": -1.518,
              "z": 0.682
            },
            "rightCorner": {
              "x": 10.687,
              "y": -1.468,
              "z": 0.682
            },
            "gtin": "4250519684567",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ebb",
            "leftCorner": {
              "x": 10.687,
              "y": -1.468,
              "z": 0.682
            },
            "rightCorner": {
              "x": 10.614,
              "y": -1.403,
              "z": 0.682
            },
            "gtin": "4250519684529",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bbc",
        "height": 0.93553,
        "facings": [
          {
            "id": "696ebf7143c343680a271ec3",
            "leftCorner": {
              "x": 11.347,
              "y": -2.049,
              "z": 0.936
            },
            "rightCorner": {
              "x": 11.253,
              "y": -1.967,
              "z": 0.936
            },
            "gtin": "4036554703582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ec4",
            "leftCorner": {
              "x": 11.253,
              "y": -1.967,
              "z": 0.936
            },
            "rightCorner": {
              "x": 11.15,
              "y": -1.875,
              "z": 0.936
            },
            "gtin": "4036554703674",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ec5",
            "leftCorner": {
              "x": 11.15,
              "y": -1.875,
              "z": 0.936
            },
            "rightCorner": {
              "x": 11.065,
              "y": -1.801,
              "z": 0.936
            },
            "gtin": "4036554703629",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ec6",
            "leftCorner": {
              "x": 11.065,
              "y": -1.801,
              "z": 0.936
            },
            "rightCorner": {
              "x": 11.027,
              "y": -1.767,
              "z": 0.936
            }
          },
          {
            "id": "696ebf7143c343680a271ec7",
            "leftCorner": {
              "x": 11.027,
              "y": -1.767,
              "z": 0.936
            },
            "rightCorner": {
              "x": 10.935,
              "y": -1.686,
              "z": 0.936
            },
            "gtin": "4006643011850",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ec8",
            "leftCorner": {
              "x": 10.935,
              "y": -1.686,
              "z": 0.936
            },
            "rightCorner": {
              "x": 10.845,
              "y": -1.607,
              "z": 0.936
            },
            "gtin": "4006643011874",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ec9",
            "leftCorner": {
              "x": 10.845,
              "y": -1.607,
              "z": 0.936
            },
            "rightCorner": {
              "x": 10.738,
              "y": -1.513,
              "z": 0.936
            },
            "gtin": "4066447257649",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eca",
            "leftCorner": {
              "x": 10.738,
              "y": -1.513,
              "z": 0.936
            },
            "rightCorner": {
              "x": 10.616,
              "y": -1.405,
              "z": 0.936
            },
            "gtin": "4066447257625",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bbe",
        "height": 1.105,
        "facings": [
          {
            "id": "696ebf7143c343680a271ecb",
            "leftCorner": {
              "x": 11.348,
              "y": -2.048,
              "z": 1.105
            },
            "rightCorner": {
              "x": 11.255,
              "y": -1.966,
              "z": 1.105
            },
            "gtin": "4066447083972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ecd",
            "leftCorner": {
              "x": 11.255,
              "y": -1.966,
              "z": 1.105
            },
            "rightCorner": {
              "x": 11.147,
              "y": -1.871,
              "z": 1.105
            },
            "gtin": "4066447704686",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ece",
            "leftCorner": {
              "x": 11.147,
              "y": -1.871,
              "z": 1.105
            },
            "rightCorner": {
              "x": 11.122,
              "y": -1.849,
              "z": 1.105
            }
          },
          {
            "id": "696ebf7143c343680a271ecf",
            "leftCorner": {
              "x": 11.122,
              "y": -1.849,
              "z": 1.105
            },
            "rightCorner": {
              "x": 11.02,
              "y": -1.759,
              "z": 1.105
            },
            "gtin": "4066447319576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ed0",
            "leftCorner": {
              "x": 11.02,
              "y": -1.759,
              "z": 1.105
            },
            "rightCorner": {
              "x": 10.931,
              "y": -1.68,
              "z": 1.105
            },
            "gtin": "4066447234749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ed1",
            "leftCorner": {
              "x": 10.931,
              "y": -1.68,
              "z": 1.105
            },
            "rightCorner": {
              "x": 10.833,
              "y": -1.594,
              "z": 1.105
            },
            "gtin": "4066447319590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ed2",
            "leftCorner": {
              "x": 10.833,
              "y": -1.594,
              "z": 1.105
            },
            "rightCorner": {
              "x": 10.716,
              "y": -1.491,
              "z": 1.105
            },
            "gtin": "4066447083958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ecc",
            "leftCorner": {
              "x": 10.716,
              "y": -1.491,
              "z": 1.105
            },
            "rightCorner": {
              "x": 10.597,
              "y": -1.387,
              "z": 1.105
            },
            "gtin": "4066447124132",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bbb",
        "height": 1.2734,
        "facings": [
          {
            "id": "696ebf7143c343680a271ebd",
            "leftCorner": {
              "x": 11.337,
              "y": -2.039,
              "z": 1.273
            },
            "rightCorner": {
              "x": 11.216,
              "y": -1.932,
              "z": 1.273
            },
            "gtin": "4260644584199",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ebe",
            "leftCorner": {
              "x": 11.216,
              "y": -1.932,
              "z": 1.273
            },
            "rightCorner": {
              "x": 11.107,
              "y": -1.837,
              "z": 1.273
            },
            "gtin": "4260644584199",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ebf",
            "leftCorner": {
              "x": 11.107,
              "y": -1.837,
              "z": 1.273
            },
            "rightCorner": {
              "x": 11.074,
              "y": -1.807,
              "z": 1.273
            }
          },
          {
            "id": "696ebf7143c343680a271ec0",
            "leftCorner": {
              "x": 11.074,
              "y": -1.807,
              "z": 1.273
            },
            "rightCorner": {
              "x": 10.961,
              "y": -1.708,
              "z": 1.273
            },
            "gtin": "4029679900042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ec1",
            "leftCorner": {
              "x": 10.961,
              "y": -1.708,
              "z": 1.273
            },
            "rightCorner": {
              "x": 10.847,
              "y": -1.607,
              "z": 1.273
            },
            "gtin": "4029679680708",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ec2",
            "leftCorner": {
              "x": 10.847,
              "y": -1.607,
              "z": 1.273
            },
            "rightCorner": {
              "x": 10.715,
              "y": -1.491,
              "z": 1.273
            },
            "gtin": "4029679680142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ebc",
            "leftCorner": {
              "x": 10.715,
              "y": -1.491,
              "z": 1.273
            },
            "rightCorner": {
              "x": 10.597,
              "y": -1.387,
              "z": 1.273
            },
            "gtin": "4061289010155",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bbf",
        "height": 1.4877,
        "facings": [
          {
            "id": "696ebf7143c343680a271ed3",
            "leftCorner": {
              "x": 11.353,
              "y": -2.042,
              "z": 1.488
            },
            "rightCorner": {
              "x": 11.251,
              "y": -1.952,
              "z": 1.488
            },
            "gtin": "4029679669826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ed5",
            "leftCorner": {
              "x": 11.251,
              "y": -1.952,
              "z": 1.488
            },
            "rightCorner": {
              "x": 11.145,
              "y": -1.859,
              "z": 1.488
            },
            "gtin": "4029679854796",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ed6",
            "leftCorner": {
              "x": 11.145,
              "y": -1.859,
              "z": 1.488
            },
            "rightCorner": {
              "x": 11.12,
              "y": -1.837,
              "z": 1.488
            }
          },
          {
            "id": "696ebf7143c343680a271ed7",
            "leftCorner": {
              "x": 11.12,
              "y": -1.837,
              "z": 1.488
            },
            "rightCorner": {
              "x": 11.021,
              "y": -1.749,
              "z": 1.488
            },
            "gtin": "4260044268026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ed8",
            "leftCorner": {
              "x": 11.021,
              "y": -1.749,
              "z": 1.488
            },
            "rightCorner": {
              "x": 10.923,
              "y": -1.662,
              "z": 1.488
            },
            "gtin": "4260044269498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ed9",
            "leftCorner": {
              "x": 10.923,
              "y": -1.662,
              "z": 1.488
            },
            "rightCorner": {
              "x": 10.818,
              "y": -1.57,
              "z": 1.488
            },
            "gtin": "4066447356007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eda",
            "leftCorner": {
              "x": 10.818,
              "y": -1.57,
              "z": 1.488
            },
            "rightCorner": {
              "x": 10.714,
              "y": -1.478,
              "z": 1.488
            },
            "gtin": "4066447356007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271edb",
            "leftCorner": {
              "x": 10.714,
              "y": -1.478,
              "z": 1.488
            },
            "rightCorner": {
              "x": 10.671,
              "y": -1.441,
              "z": 1.488
            }
          },
          {
            "id": "696ebf7143c343680a271edc",
            "leftCorner": {
              "x": 10.671,
              "y": -1.441,
              "z": 1.488
            },
            "rightCorner": {
              "x": 10.582,
              "y": -1.362,
              "z": 1.488
            },
            "gtin": "4066447343083",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bba",
        "height": 1.694,
        "facings": [
          {
            "id": "696ebf7143c343680a271e50",
            "leftCorner": {
              "x": 11.263,
              "y": -1.965,
              "z": 1.694
            },
            "rightCorner": {
              "x": 11.152,
              "y": -1.867,
              "z": 1.694
            },
            "gtin": "4250519646534",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e51",
            "leftCorner": {
              "x": 11.152,
              "y": -1.867,
              "z": 1.694
            },
            "rightCorner": {
              "x": 11.022,
              "y": -1.753,
              "z": 1.694
            },
            "gtin": "4260718295884",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e52",
            "leftCorner": {
              "x": 11.022,
              "y": -1.753,
              "z": 1.694
            },
            "rightCorner": {
              "x": 10.915,
              "y": -1.658,
              "z": 1.694
            },
            "gtin": "4255582814163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e53",
            "leftCorner": {
              "x": 10.915,
              "y": -1.658,
              "z": 1.694
            },
            "rightCorner": {
              "x": 10.805,
              "y": -1.562,
              "z": 1.694
            },
            "gtin": "4255582813593",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e54",
            "leftCorner": {
              "x": 10.805,
              "y": -1.562,
              "z": 1.694
            },
            "rightCorner": {
              "x": 10.69,
              "y": -1.46,
              "z": 1.694
            },
            "gtin": "4255582800487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e55",
            "leftCorner": {
              "x": 10.69,
              "y": -1.46,
              "z": 1.694
            },
            "rightCorner": {
              "x": 10.601,
              "y": -1.382,
              "z": 1.694
            },
            "gtin": "4260654789119",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7578bb5fe7bc0469599f8",
    "name": "68e7578bb5fe7bc0469599f8",
    "x": 10.564,
    "y": -1.4171,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93506,
      "w": 0.3545
    },
    "statistics": {
      "hasStockCount": 35,
      "noStockCount": 0,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73bc2",
        "height": 0.20116,
        "facings": [
          {
            "id": "696ebf7143c343680a271e94",
            "leftCorner": {
              "x": 10.607,
              "y": -1.398,
              "z": 0.209
            },
            "rightCorner": {
              "x": 10.559,
              "y": -1.356,
              "z": 0.209
            },
            "gtin": "4066447497298",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e95",
            "leftCorner": {
              "x": 10.558,
              "y": -1.351,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.501,
              "y": -1.301,
              "z": 0.201
            },
            "gtin": "4066447497298",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e96",
            "leftCorner": {
              "x": 10.501,
              "y": -1.301,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.446,
              "y": -1.252,
              "z": 0.201
            },
            "gtin": "4067796064377",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e97",
            "leftCorner": {
              "x": 10.446,
              "y": -1.252,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.397,
              "y": -1.209,
              "z": 0.201
            },
            "gtin": "4066447506952",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e98",
            "leftCorner": {
              "x": 10.397,
              "y": -1.209,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.34,
              "y": -1.158,
              "z": 0.201
            },
            "gtin": "4066447506976",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e99",
            "leftCorner": {
              "x": 10.34,
              "y": -1.158,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.296,
              "y": -1.119,
              "z": 0.201
            },
            "gtin": "4066447814415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e9a",
            "leftCorner": {
              "x": 10.296,
              "y": -1.119,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.246,
              "y": -1.075,
              "z": 0.201
            },
            "gtin": "4066447814415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e9b",
            "leftCorner": {
              "x": 10.246,
              "y": -1.075,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.199,
              "y": -1.033,
              "z": 0.201
            },
            "gtin": "4066447889598",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e9c",
            "leftCorner": {
              "x": 10.199,
              "y": -1.033,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.131,
              "y": -0.973,
              "z": 0.201
            },
            "gtin": "4066447814378",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e9d",
            "leftCorner": {
              "x": 10.131,
              "y": -0.973,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.066,
              "y": -0.916,
              "z": 0.201
            },
            "gtin": "4066447814354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e9e",
            "leftCorner": {
              "x": 10.066,
              "y": -0.916,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.01,
              "y": -0.866,
              "z": 0.201
            },
            "gtin": "4066447814392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e9f",
            "leftCorner": {
              "x": 10.01,
              "y": -0.866,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.962,
              "y": -0.824,
              "z": 0.201
            },
            "gtin": "4004191502103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ea0",
            "leftCorner": {
              "x": 9.962,
              "y": -0.824,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.899,
              "y": -0.768,
              "z": 0.201
            },
            "gtin": "4004191502103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ea1",
            "leftCorner": {
              "x": 9.899,
              "y": -0.768,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.826,
              "y": -0.703,
              "z": 0.201
            },
            "gtin": "4004191502066",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bc3",
        "height": 0.54174,
        "facings": [
          {
            "id": "696ebf7143c343680a271ef6",
            "leftCorner": {
              "x": 10.592,
              "y": -1.385,
              "z": 0.542
            },
            "rightCorner": {
              "x": 10.553,
              "y": -1.351,
              "z": 0.542
            },
            "gtin": "4066447814293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ef8",
            "leftCorner": {
              "x": 10.553,
              "y": -1.351,
              "z": 0.542
            },
            "rightCorner": {
              "x": 10.405,
              "y": -1.22,
              "z": 0.542
            },
            "gtin": "4066447814316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ef9",
            "leftCorner": {
              "x": 10.405,
              "y": -1.22,
              "z": 0.542
            },
            "rightCorner": {
              "x": 10.353,
              "y": -1.174,
              "z": 0.542
            },
            "gtin": "4066447814330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271efa",
            "leftCorner": {
              "x": 10.353,
              "y": -1.174,
              "z": 0.542
            },
            "rightCorner": {
              "x": 10.304,
              "y": -1.131,
              "z": 0.542
            },
            "gtin": "4066447814330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271efb",
            "leftCorner": {
              "x": 10.304,
              "y": -1.131,
              "z": 0.542
            },
            "rightCorner": {
              "x": 10.253,
              "y": -1.085,
              "z": 0.542
            },
            "gtin": "4066447814330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271efc",
            "leftCorner": {
              "x": 10.253,
              "y": -1.085,
              "z": 0.542
            },
            "rightCorner": {
              "x": 10.2,
              "y": -1.038,
              "z": 0.542
            }
          },
          {
            "id": "696ebf7143c343680a271efd",
            "leftCorner": {
              "x": 10.2,
              "y": -1.038,
              "z": 0.542
            },
            "rightCorner": {
              "x": 10.145,
              "y": -0.99,
              "z": 0.542
            },
            "gtin": "4260556672892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271efe",
            "leftCorner": {
              "x": 10.145,
              "y": -0.99,
              "z": 0.542
            },
            "rightCorner": {
              "x": 10.108,
              "y": -0.957,
              "z": 0.542
            },
            "gtin": "4260556672892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eff",
            "leftCorner": {
              "x": 10.108,
              "y": -0.957,
              "z": 0.542
            },
            "rightCorner": {
              "x": 10.083,
              "y": -0.935,
              "z": 0.542
            },
            "gtin": "4260556672878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f00",
            "leftCorner": {
              "x": 10.083,
              "y": -0.935,
              "z": 0.542
            },
            "rightCorner": {
              "x": 10.046,
              "y": -0.902,
              "z": 0.542
            },
            "gtin": "4260739992953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f01",
            "leftCorner": {
              "x": 10.046,
              "y": -0.902,
              "z": 0.542
            },
            "rightCorner": {
              "x": 10.006,
              "y": -0.867,
              "z": 0.542
            },
            "gtin": "4058172627842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f02",
            "leftCorner": {
              "x": 10.006,
              "y": -0.867,
              "z": 0.542
            },
            "rightCorner": {
              "x": 9.964,
              "y": -0.83,
              "z": 0.542
            },
            "gtin": "4058172627842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f03",
            "leftCorner": {
              "x": 9.964,
              "y": -0.83,
              "z": 0.542
            },
            "rightCorner": {
              "x": 9.927,
              "y": -0.797,
              "z": 0.542
            },
            "gtin": "4058172627842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f04",
            "leftCorner": {
              "x": 9.927,
              "y": -0.797,
              "z": 0.542
            },
            "rightCorner": {
              "x": 9.876,
              "y": -0.752,
              "z": 0.542
            },
            "gtin": "4058172627842",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ef7",
            "leftCorner": {
              "x": 9.876,
              "y": -0.752,
              "z": 0.542
            },
            "rightCorner": {
              "x": 9.843,
              "y": -0.723,
              "z": 0.542
            },
            "gtin": "4058172627842",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bc4",
        "height": 0.87737,
        "facings": [
          {
            "id": "696ebf7143c343680a271f05",
            "leftCorner": {
              "x": 10.592,
              "y": -1.385,
              "z": 0.877
            },
            "rightCorner": {
              "x": 10.538,
              "y": -1.338,
              "z": 0.877
            },
            "gtin": "9009700314944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f06",
            "leftCorner": {
              "x": 10.538,
              "y": -1.338,
              "z": 0.877
            },
            "rightCorner": {
              "x": 10.486,
              "y": -1.292,
              "z": 0.877
            },
            "gtin": "9009700306611",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f07",
            "leftCorner": {
              "x": 10.486,
              "y": -1.292,
              "z": 0.877
            },
            "rightCorner": {
              "x": 10.424,
              "y": -1.236,
              "z": 0.877
            },
            "gtin": "9009700308271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f08",
            "leftCorner": {
              "x": 10.424,
              "y": -1.236,
              "z": 0.877
            },
            "rightCorner": {
              "x": 10.359,
              "y": -1.179,
              "z": 0.877
            },
            "gtin": "9009700308271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f09",
            "leftCorner": {
              "x": 10.359,
              "y": -1.179,
              "z": 0.877
            },
            "rightCorner": {
              "x": 10.308,
              "y": -1.134,
              "z": 0.877
            },
            "gtin": "9009700306604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f0a",
            "leftCorner": {
              "x": 10.308,
              "y": -1.134,
              "z": 0.877
            },
            "rightCorner": {
              "x": 10.246,
              "y": -1.079,
              "z": 0.877
            },
            "gtin": "9009700306604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f0b",
            "leftCorner": {
              "x": 10.246,
              "y": -1.079,
              "z": 0.877
            },
            "rightCorner": {
              "x": 10.2,
              "y": -1.038,
              "z": 0.877
            },
            "gtin": "4066447328899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f0c",
            "leftCorner": {
              "x": 10.2,
              "y": -1.038,
              "z": 0.877
            },
            "rightCorner": {
              "x": 10.143,
              "y": -0.988,
              "z": 0.877
            },
            "gtin": "4066447328882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f0d",
            "leftCorner": {
              "x": 10.143,
              "y": -0.988,
              "z": 0.877
            },
            "rightCorner": {
              "x": 10.091,
              "y": -0.942,
              "z": 0.877
            },
            "gtin": "4066447328882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f0e",
            "leftCorner": {
              "x": 10.091,
              "y": -0.942,
              "z": 0.877
            },
            "rightCorner": {
              "x": 10.044,
              "y": -0.901,
              "z": 0.877
            },
            "gtin": "4066447328905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f0f",
            "leftCorner": {
              "x": 10.044,
              "y": -0.901,
              "z": 0.877
            },
            "rightCorner": {
              "x": 9.995,
              "y": -0.858,
              "z": 0.877
            },
            "gtin": "4260339814013",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f10",
            "leftCorner": {
              "x": 9.995,
              "y": -0.858,
              "z": 0.877
            },
            "rightCorner": {
              "x": 9.951,
              "y": -0.818,
              "z": 0.877
            },
            "gtin": "4260339814006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f11",
            "leftCorner": {
              "x": 9.951,
              "y": -0.818,
              "z": 0.877
            },
            "rightCorner": {
              "x": 9.9,
              "y": -0.773,
              "z": 0.877
            },
            "gtin": "90097287",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f12",
            "leftCorner": {
              "x": 9.9,
              "y": -0.773,
              "z": 0.877
            },
            "rightCorner": {
              "x": 9.856,
              "y": -0.734,
              "z": 0.877
            },
            "gtin": "90097287",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bc1",
        "height": 1.1735,
        "facings": [
          {
            "id": "696ebf7143c343680a271ee8",
            "leftCorner": {
              "x": 10.594,
              "y": -1.383,
              "z": 1.174
            },
            "rightCorner": {
              "x": 10.527,
              "y": -1.323,
              "z": 1.174
            },
            "gtin": "90280443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ee9",
            "leftCorner": {
              "x": 10.527,
              "y": -1.323,
              "z": 1.174
            },
            "rightCorner": {
              "x": 10.44,
              "y": -1.247,
              "z": 1.174
            },
            "gtin": "4067796154504",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eea",
            "leftCorner": {
              "x": 10.44,
              "y": -1.247,
              "z": 1.174
            },
            "rightCorner": {
              "x": 10.391,
              "y": -1.203,
              "z": 1.174
            }
          },
          {
            "id": "696ebf7143c343680a271eeb",
            "leftCorner": {
              "x": 10.391,
              "y": -1.203,
              "z": 1.174
            },
            "rightCorner": {
              "x": 10.339,
              "y": -1.157,
              "z": 1.174
            },
            "gtin": "4260339815072",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eec",
            "leftCorner": {
              "x": 10.339,
              "y": -1.157,
              "z": 1.174
            },
            "rightCorner": {
              "x": 10.29,
              "y": -1.113,
              "z": 1.174
            },
            "gtin": "4260339815171",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eed",
            "leftCorner": {
              "x": 10.29,
              "y": -1.113,
              "z": 1.174
            },
            "rightCorner": {
              "x": 10.239,
              "y": -1.068,
              "z": 1.174
            },
            "gtin": "4067796166705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271eee",
            "leftCorner": {
              "x": 10.239,
              "y": -1.068,
              "z": 1.174
            },
            "rightCorner": {
              "x": 10.193,
              "y": -1.028,
              "z": 1.174
            },
            "gtin": "4066447562620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eef",
            "leftCorner": {
              "x": 10.193,
              "y": -1.028,
              "z": 1.174
            },
            "rightCorner": {
              "x": 10.144,
              "y": -0.984,
              "z": 1.174
            },
            "gtin": "4066447562620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ef0",
            "leftCorner": {
              "x": 10.144,
              "y": -0.984,
              "z": 1.174
            },
            "rightCorner": {
              "x": 10.094,
              "y": -0.94,
              "z": 1.174
            },
            "gtin": "4067796166729",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ef1",
            "leftCorner": {
              "x": 10.094,
              "y": -0.94,
              "z": 1.174
            },
            "rightCorner": {
              "x": 10.037,
              "y": -0.89,
              "z": 1.174
            },
            "gtin": "4066447887358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ef2",
            "leftCorner": {
              "x": 10.037,
              "y": -0.89,
              "z": 1.174
            },
            "rightCorner": {
              "x": 9.991,
              "y": -0.849,
              "z": 1.174
            }
          },
          {
            "id": "696ebf7143c343680a271ef3",
            "leftCorner": {
              "x": 9.991,
              "y": -0.849,
              "z": 1.174
            },
            "rightCorner": {
              "x": 9.949,
              "y": -0.811,
              "z": 1.174
            },
            "gtin": "4066447219791",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ef4",
            "leftCorner": {
              "x": 9.949,
              "y": -0.811,
              "z": 1.174
            },
            "rightCorner": {
              "x": 9.892,
              "y": -0.761,
              "z": 1.174
            },
            "gtin": "9008700230223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ef5",
            "leftCorner": {
              "x": 9.892,
              "y": -0.761,
              "z": 1.174
            },
            "rightCorner": {
              "x": 9.865,
              "y": -0.737,
              "z": 1.174
            },
            "gtin": "9008700230186",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bc5",
        "height": 1.4849,
        "facings": [
          {
            "id": "696ebf7143c343680a271edd",
            "leftCorner": {
              "x": 10.573,
              "y": -1.365,
              "z": 1.485
            },
            "rightCorner": {
              "x": 10.432,
              "y": -1.241,
              "z": 1.485
            },
            "gtin": "4067796001471",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ede",
            "leftCorner": {
              "x": 10.432,
              "y": -1.241,
              "z": 1.485
            },
            "rightCorner": {
              "x": 10.348,
              "y": -1.166,
              "z": 1.485
            },
            "gtin": "4066447855487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271edf",
            "leftCorner": {
              "x": 10.348,
              "y": -1.166,
              "z": 1.485
            },
            "rightCorner": {
              "x": 10.323,
              "y": -1.144,
              "z": 1.485
            },
            "gtin": "4066447855555",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ee0",
            "leftCorner": {
              "x": 10.323,
              "y": -1.144,
              "z": 1.485
            },
            "rightCorner": {
              "x": 10.298,
              "y": -1.122,
              "z": 1.485
            },
            "gtin": "4066447855555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ee1",
            "leftCorner": {
              "x": 10.298,
              "y": -1.122,
              "z": 1.485
            },
            "rightCorner": {
              "x": 10.247,
              "y": -1.077,
              "z": 1.485
            },
            "gtin": "4260739992847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ee2",
            "leftCorner": {
              "x": 10.247,
              "y": -1.077,
              "z": 1.485
            },
            "rightCorner": {
              "x": 10.163,
              "y": -1.002,
              "z": 1.485
            },
            "gtin": "4262414873083",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ee3",
            "leftCorner": {
              "x": 10.163,
              "y": -1.002,
              "z": 1.485
            },
            "rightCorner": {
              "x": 10.091,
              "y": -0.939,
              "z": 1.485
            },
            "gtin": "4067796070194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ee4",
            "leftCorner": {
              "x": 10.091,
              "y": -0.939,
              "z": 1.485
            },
            "rightCorner": {
              "x": 10.048,
              "y": -0.9,
              "z": 1.485
            },
            "gtin": "4058172627767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ee5",
            "leftCorner": {
              "x": 10.048,
              "y": -0.9,
              "z": 1.485
            },
            "rightCorner": {
              "x": 10.004,
              "y": -0.861,
              "z": 1.485
            },
            "gtin": "4066447855463",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ee6",
            "leftCorner": {
              "x": 10.004,
              "y": -0.861,
              "z": 1.485
            },
            "rightCorner": {
              "x": 9.957,
              "y": -0.82,
              "z": 1.485
            },
            "gtin": "4067796070323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ee7",
            "leftCorner": {
              "x": 9.957,
              "y": -0.82,
              "z": 1.485
            },
            "rightCorner": {
              "x": 9.874,
              "y": -0.746,
              "z": 1.485
            },
            "gtin": "4067796108064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ed4",
            "leftCorner": {
              "x": 9.874,
              "y": -0.746,
              "z": 1.485
            },
            "rightCorner": {
              "x": 9.845,
              "y": -0.721,
              "z": 1.485
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bc6",
        "height": 1.6917,
        "facings": [
          {
            "id": "696ebf7143c343680a271e56",
            "leftCorner": {
              "x": 10.593,
              "y": -1.384,
              "z": 1.692
            },
            "rightCorner": {
              "x": 10.547,
              "y": -1.343,
              "z": 1.692
            },
            "gtin": "4260339810299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e57",
            "leftCorner": {
              "x": 10.547,
              "y": -1.343,
              "z": 1.692
            },
            "rightCorner": {
              "x": 10.444,
              "y": -1.252,
              "z": 1.692
            },
            "gtin": "4260339810275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e58",
            "leftCorner": {
              "x": 10.444,
              "y": -1.252,
              "z": 1.692
            },
            "rightCorner": {
              "x": 10.312,
              "y": -1.135,
              "z": 1.692
            },
            "gtin": "4260339810022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e59",
            "leftCorner": {
              "x": 10.312,
              "y": -1.135,
              "z": 1.692
            },
            "rightCorner": {
              "x": 10.245,
              "y": -1.076,
              "z": 1.692
            },
            "gtin": "4260703370558",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e5a",
            "leftCorner": {
              "x": 10.245,
              "y": -1.076,
              "z": 1.692
            },
            "rightCorner": {
              "x": 10.174,
              "y": -1.013,
              "z": 1.692
            },
            "gtin": "4260703370534",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e5b",
            "leftCorner": {
              "x": 10.174,
              "y": -1.013,
              "z": 1.692
            },
            "rightCorner": {
              "x": 10.101,
              "y": -0.948,
              "z": 1.692
            },
            "gtin": "4015533051029",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e5c",
            "leftCorner": {
              "x": 10.101,
              "y": -0.948,
              "z": 1.692
            },
            "rightCorner": {
              "x": 10.03,
              "y": -0.886,
              "z": 1.692
            },
            "gtin": "4015533051043",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e5d",
            "leftCorner": {
              "x": 10.03,
              "y": -0.886,
              "z": 1.692
            },
            "rightCorner": {
              "x": 9.965,
              "y": -0.828,
              "z": 1.692
            },
            "gtin": "4015533051067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e5e",
            "leftCorner": {
              "x": 9.965,
              "y": -0.828,
              "z": 1.692
            },
            "rightCorner": {
              "x": 9.856,
              "y": -0.731,
              "z": 1.692
            },
            "gtin": "4067796162240",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e7578bb5fe7bc0469599f9",
    "name": "68e7578bb5fe7bc0469599f9",
    "x": 9.8212,
    "y": -0.76071,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.93631,
      "w": 0.35119
    },
    "statistics": {
      "hasStockCount": 38,
      "noStockCount": 2,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73bcb",
        "height": 0.20969,
        "facings": [
          {
            "id": "696ebf7143c343680a271ea2",
            "leftCorner": {
              "x": 9.831,
              "y": -0.71,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.806,
              "y": -0.689,
              "z": 0.21
            },
            "gtin": "4004191502011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ea3",
            "leftCorner": {
              "x": 9.806,
              "y": -0.689,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.763,
              "y": -0.651,
              "z": 0.21
            },
            "gtin": "4004191502011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271ea4",
            "leftCorner": {
              "x": 9.763,
              "y": -0.651,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.707,
              "y": -0.602,
              "z": 0.21
            },
            "gtin": "4004191502028",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ea5",
            "leftCorner": {
              "x": 9.707,
              "y": -0.602,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.651,
              "y": -0.553,
              "z": 0.21
            },
            "gtin": "4004191501434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ea6",
            "leftCorner": {
              "x": 9.651,
              "y": -0.553,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.597,
              "y": -0.506,
              "z": 0.21
            },
            "gtin": "4004191501434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ea7",
            "leftCorner": {
              "x": 9.597,
              "y": -0.506,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.538,
              "y": -0.454,
              "z": 0.21
            },
            "gtin": "4004191500048",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ea8",
            "leftCorner": {
              "x": 9.538,
              "y": -0.454,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.494,
              "y": -0.416,
              "z": 0.21
            },
            "gtin": "4004191500017",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ea9",
            "leftCorner": {
              "x": 9.494,
              "y": -0.416,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.474,
              "y": -0.399,
              "z": 0.21
            }
          },
          {
            "id": "696ebf7143c343680a271eaa",
            "leftCorner": {
              "x": 9.474,
              "y": -0.399,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.407,
              "y": -0.34,
              "z": 0.21
            },
            "gtin": "4004191500017",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eab",
            "leftCorner": {
              "x": 9.407,
              "y": -0.34,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.35,
              "y": -0.291,
              "z": 0.21
            },
            "gtin": "4004191505821",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eac",
            "leftCorner": {
              "x": 9.35,
              "y": -0.291,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.282,
              "y": -0.231,
              "z": 0.21
            },
            "gtin": "4004191500086",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271ead",
            "leftCorner": {
              "x": 9.282,
              "y": -0.231,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.232,
              "y": -0.187,
              "z": 0.21
            },
            "gtin": "4004191504299",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271eae",
            "leftCorner": {
              "x": 9.232,
              "y": -0.187,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.183,
              "y": -0.145,
              "z": 0.21
            },
            "gtin": "4015533053849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e7e",
            "leftCorner": {
              "x": 9.183,
              "y": -0.145,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.097,
              "y": -0.07,
              "z": 0.21
            },
            "gtin": "4015533055508",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bc8",
        "height": 0.55506,
        "facings": [
          {
            "id": "696ebf7143c343680a271f13",
            "leftCorner": {
              "x": 9.85,
              "y": -0.728,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.765,
              "y": -0.654,
              "z": 0.555
            },
            "gtin": "4066447855784",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f15",
            "leftCorner": {
              "x": 9.765,
              "y": -0.654,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.649,
              "y": -0.553,
              "z": 0.555
            },
            "gtin": "4066447855791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f16",
            "leftCorner": {
              "x": 9.649,
              "y": -0.553,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.605,
              "y": -0.515,
              "z": 0.555
            },
            "gtin": "4066447477153",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f17",
            "leftCorner": {
              "x": 9.605,
              "y": -0.515,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.564,
              "y": -0.479,
              "z": 0.555
            },
            "gtin": "4066447477153",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f18",
            "leftCorner": {
              "x": 9.564,
              "y": -0.479,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.519,
              "y": -0.439,
              "z": 0.555
            },
            "gtin": "4058172623677",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f19",
            "leftCorner": {
              "x": 9.519,
              "y": -0.439,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.469,
              "y": -0.396,
              "z": 0.555
            },
            "gtin": "4067796000412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f1a",
            "leftCorner": {
              "x": 9.469,
              "y": -0.396,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.413,
              "y": -0.346,
              "z": 0.555
            },
            "gtin": "4058172227943",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f1b",
            "leftCorner": {
              "x": 9.413,
              "y": -0.346,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.367,
              "y": -0.307,
              "z": 0.555
            },
            "gtin": "4066447878509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f1c",
            "leftCorner": {
              "x": 9.367,
              "y": -0.307,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.317,
              "y": -0.263,
              "z": 0.555
            },
            "gtin": "4066447878509",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f1d",
            "leftCorner": {
              "x": 9.317,
              "y": -0.263,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.266,
              "y": -0.219,
              "z": 0.555
            },
            "gtin": "4066447855807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f1e",
            "leftCorner": {
              "x": 9.266,
              "y": -0.219,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.222,
              "y": -0.181,
              "z": 0.555
            }
          },
          {
            "id": "696ebf7143c343680a271f1f",
            "leftCorner": {
              "x": 9.222,
              "y": -0.181,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.146,
              "y": -0.114,
              "z": 0.555
            },
            "gtin": "4066447855760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f14",
            "leftCorner": {
              "x": 9.146,
              "y": -0.114,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.096,
              "y": -0.07,
              "z": 0.555
            },
            "gtin": "4066447855760",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bcd",
        "height": 0.84597,
        "facings": [
          {
            "id": "696ebf7143c343680a271f34",
            "leftCorner": {
              "x": 9.832,
              "y": -0.709,
              "z": 0.846
            },
            "rightCorner": {
              "x": 9.783,
              "y": -0.666,
              "z": 0.846
            },
            "gtin": "4066447355987",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f35",
            "leftCorner": {
              "x": 9.783,
              "y": -0.666,
              "z": 0.846
            },
            "rightCorner": {
              "x": 9.718,
              "y": -0.61,
              "z": 0.846
            },
            "gtin": "4066447355987",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f36",
            "leftCorner": {
              "x": 9.718,
              "y": -0.61,
              "z": 0.846
            },
            "rightCorner": {
              "x": 9.652,
              "y": -0.552,
              "z": 0.846
            },
            "gtin": "4067796175103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f37",
            "leftCorner": {
              "x": 9.652,
              "y": -0.552,
              "z": 0.846
            },
            "rightCorner": {
              "x": 9.602,
              "y": -0.508,
              "z": 0.846
            },
            "gtin": "4067796175103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f38",
            "leftCorner": {
              "x": 9.602,
              "y": -0.508,
              "z": 0.846
            },
            "rightCorner": {
              "x": 9.532,
              "y": -0.448,
              "z": 0.846
            },
            "gtin": "4066447855425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f39",
            "leftCorner": {
              "x": 9.532,
              "y": -0.448,
              "z": 0.846
            },
            "rightCorner": {
              "x": 9.481,
              "y": -0.403,
              "z": 0.846
            },
            "gtin": "4066447855425",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f3a",
            "leftCorner": {
              "x": 9.481,
              "y": -0.403,
              "z": 0.846
            },
            "rightCorner": {
              "x": 9.462,
              "y": -0.386,
              "z": 0.846
            }
          },
          {
            "id": "696ebf7143c343680a271f3b",
            "leftCorner": {
              "x": 9.462,
              "y": -0.386,
              "z": 0.846
            },
            "rightCorner": {
              "x": 9.395,
              "y": -0.327,
              "z": 0.846
            },
            "gtin": "4066447855494",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f3c",
            "leftCorner": {
              "x": 9.395,
              "y": -0.327,
              "z": 0.846
            },
            "rightCorner": {
              "x": 9.331,
              "y": -0.272,
              "z": 0.846
            },
            "gtin": "4066447855494",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f3d",
            "leftCorner": {
              "x": 9.331,
              "y": -0.272,
              "z": 0.846
            },
            "rightCorner": {
              "x": 9.271,
              "y": -0.22,
              "z": 0.846
            },
            "gtin": "4066447343069",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f3e",
            "leftCorner": {
              "x": 9.271,
              "y": -0.22,
              "z": 0.846
            },
            "rightCorner": {
              "x": 9.218,
              "y": -0.173,
              "z": 0.846
            },
            "gtin": "4003488000100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f3f",
            "leftCorner": {
              "x": 9.218,
              "y": -0.173,
              "z": 0.846
            },
            "rightCorner": {
              "x": 9.168,
              "y": -0.129,
              "z": 0.846
            },
            "gtin": "4003488000100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f33",
            "leftCorner": {
              "x": 9.168,
              "y": -0.129,
              "z": 0.846
            },
            "rightCorner": {
              "x": 9.098,
              "y": -0.068,
              "z": 0.846
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bc9",
        "height": 1.1465,
        "facings": [
          {
            "id": "696ebf7143c343680a271f20",
            "leftCorner": {
              "x": 9.849,
              "y": -0.729,
              "z": 1.147
            },
            "rightCorner": {
              "x": 9.775,
              "y": -0.665,
              "z": 1.147
            },
            "gtin": "4058172932526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f22",
            "leftCorner": {
              "x": 9.775,
              "y": -0.665,
              "z": 1.147
            },
            "rightCorner": {
              "x": 9.717,
              "y": -0.614,
              "z": 1.147
            },
            "gtin": "4067796064292",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f23",
            "leftCorner": {
              "x": 9.717,
              "y": -0.614,
              "z": 1.147
            },
            "rightCorner": {
              "x": 9.66,
              "y": -0.565,
              "z": 1.147
            },
            "gtin": "4066447855586",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f24",
            "leftCorner": {
              "x": 9.66,
              "y": -0.565,
              "z": 1.147
            },
            "rightCorner": {
              "x": 9.606,
              "y": -0.517,
              "z": 1.147
            },
            "gtin": "4066447855586",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f25",
            "leftCorner": {
              "x": 9.606,
              "y": -0.517,
              "z": 1.147
            },
            "rightCorner": {
              "x": 9.527,
              "y": -0.449,
              "z": 1.147
            },
            "gtin": "4067796087376",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f26",
            "leftCorner": {
              "x": 9.527,
              "y": -0.449,
              "z": 1.147
            },
            "rightCorner": {
              "x": 9.472,
              "y": -0.401,
              "z": 1.147
            },
            "gtin": "4015533064609",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f27",
            "leftCorner": {
              "x": 9.472,
              "y": -0.401,
              "z": 1.147
            },
            "rightCorner": {
              "x": 9.421,
              "y": -0.356,
              "z": 1.147
            },
            "gtin": "4015533057588",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f28",
            "leftCorner": {
              "x": 9.421,
              "y": -0.356,
              "z": 1.147
            },
            "rightCorner": {
              "x": 9.355,
              "y": -0.299,
              "z": 1.147
            },
            "gtin": "4015533057588",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f29",
            "leftCorner": {
              "x": 9.355,
              "y": -0.299,
              "z": 1.147
            },
            "rightCorner": {
              "x": 9.315,
              "y": -0.264,
              "z": 1.147
            },
            "gtin": "4066447355567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f2a",
            "leftCorner": {
              "x": 9.315,
              "y": -0.264,
              "z": 1.147
            },
            "rightCorner": {
              "x": 9.267,
              "y": -0.222,
              "z": 1.147
            },
            "gtin": "4015533060724",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f2b",
            "leftCorner": {
              "x": 9.267,
              "y": -0.222,
              "z": 1.147
            },
            "rightCorner": {
              "x": 9.225,
              "y": -0.185,
              "z": 1.147
            },
            "gtin": "4015533064500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f2c",
            "leftCorner": {
              "x": 9.225,
              "y": -0.185,
              "z": 1.147
            },
            "rightCorner": {
              "x": 9.144,
              "y": -0.114,
              "z": 1.147
            },
            "gtin": "4015533064500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f21",
            "leftCorner": {
              "x": 9.144,
              "y": -0.114,
              "z": 1.147
            },
            "rightCorner": {
              "x": 9.095,
              "y": -0.072,
              "z": 1.147
            },
            "gtin": "4015533053306",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bca",
        "height": 1.4411,
        "facings": [
          {
            "id": "696ebf7143c343680a271f2d",
            "leftCorner": {
              "x": 9.85,
              "y": -0.727,
              "z": 1.441
            },
            "rightCorner": {
              "x": 9.727,
              "y": -0.619,
              "z": 1.441
            },
            "gtin": "4067796001204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f2f",
            "leftCorner": {
              "x": 9.727,
              "y": -0.619,
              "z": 1.441
            },
            "rightCorner": {
              "x": 9.606,
              "y": -0.514,
              "z": 1.441
            },
            "gtin": "4067796001204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f30",
            "leftCorner": {
              "x": 9.606,
              "y": -0.514,
              "z": 1.441
            },
            "rightCorner": {
              "x": 9.489,
              "y": -0.412,
              "z": 1.441
            },
            "gtin": "4067796001051",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f31",
            "leftCorner": {
              "x": 9.489,
              "y": -0.412,
              "z": 1.441
            },
            "rightCorner": {
              "x": 9.364,
              "y": -0.303,
              "z": 1.441
            },
            "gtin": "4067796001143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f32",
            "leftCorner": {
              "x": 9.364,
              "y": -0.303,
              "z": 1.441
            },
            "rightCorner": {
              "x": 9.255,
              "y": -0.207,
              "z": 1.441
            },
            "gtin": "4066447855630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f2e",
            "leftCorner": {
              "x": 9.255,
              "y": -0.207,
              "z": 1.441
            },
            "rightCorner": {
              "x": 9.097,
              "y": -0.07,
              "z": 1.441
            },
            "gtin": "4067796001181",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bcc",
        "height": 1.6915,
        "facings": [
          {
            "id": "696ebf7143c343680a271e5f",
            "leftCorner": {
              "x": 9.856,
              "y": -0.731,
              "z": 1.692
            },
            "rightCorner": {
              "x": 9.707,
              "y": -0.599,
              "z": 1.692
            },
            "gtin": "4066447199611",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e60",
            "leftCorner": {
              "x": 9.712,
              "y": -0.606,
              "z": 1.692
            },
            "rightCorner": {
              "x": 9.606,
              "y": -0.513,
              "z": 1.692
            },
            "gtin": "4066447199628",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e61",
            "leftCorner": {
              "x": 9.606,
              "y": -0.513,
              "z": 1.692
            },
            "rightCorner": {
              "x": 9.486,
              "y": -0.408,
              "z": 1.692
            },
            "gtin": "4066447638707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271e62",
            "leftCorner": {
              "x": 9.486,
              "y": -0.408,
              "z": 1.692
            },
            "rightCorner": {
              "x": 9.425,
              "y": -0.355,
              "z": 1.692
            }
          },
          {
            "id": "696ebf7143c343680a271e63",
            "leftCorner": {
              "x": 9.425,
              "y": -0.355,
              "z": 1.692
            },
            "rightCorner": {
              "x": 9.375,
              "y": -0.311,
              "z": 1.692
            }
          },
          {
            "id": "696ebf7143c343680a271e64",
            "leftCorner": {
              "x": 9.375,
              "y": -0.311,
              "z": 1.692
            },
            "rightCorner": {
              "x": 9.329,
              "y": -0.271,
              "z": 1.692
            },
            "gtin": "4260407955358",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e65",
            "leftCorner": {
              "x": 9.329,
              "y": -0.271,
              "z": 1.692
            },
            "rightCorner": {
              "x": 9.287,
              "y": -0.235,
              "z": 1.692
            },
            "gtin": "4260407955358",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e66",
            "leftCorner": {
              "x": 9.287,
              "y": -0.235,
              "z": 1.692
            },
            "rightCorner": {
              "x": 9.248,
              "y": -0.2,
              "z": 1.692
            },
            "gtin": "7394376616884",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e67",
            "leftCorner": {
              "x": 9.248,
              "y": -0.2,
              "z": 1.692
            },
            "rightCorner": {
              "x": 9.161,
              "y": -0.124,
              "z": 1.692
            },
            "gtin": "7394376616884",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271e47",
            "leftCorner": {
              "x": 9.161,
              "y": -0.124,
              "z": 1.692
            },
            "rightCorner": {
              "x": 9.097,
              "y": -0.069,
              "z": 1.692
            }
          }
        ]
      }
    ]
  },
  {
    "id": "68e757b7b5fe7bc046959a23",
    "name": "68e757b7b5fe7bc046959a23",
    "x": 3.4939,
    "y": 9.6,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.71819,
      "w": 0.69585
    },
    "statistics": {
      "hasStockCount": 5,
      "noStockCount": 0,
      "unknownStockCount": 11,
      "shelfCategory": "DIAPERS"
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73c3e",
        "height": 0.2065,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fbc8",
            "leftCorner": {
              "x": 3.439,
              "y": 9.602,
              "z": 0.207
            },
            "rightCorner": {
              "x": 3.433,
              "y": 9.393,
              "z": 0.207
            }
          },
          {
            "id": "696ebf6d43c343680a26fbca",
            "leftCorner": {
              "x": 3.433,
              "y": 9.393,
              "z": 0.207
            },
            "rightCorner": {
              "x": 3.425,
              "y": 9.161,
              "z": 0.207
            },
            "gtin": "4895248004820",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbcb",
            "leftCorner": {
              "x": 3.425,
              "y": 9.161,
              "z": 0.207
            },
            "rightCorner": {
              "x": 3.424,
              "y": 9.136,
              "z": 0.207
            }
          },
          {
            "id": "696ebf6d43c343680a26fbcc",
            "leftCorner": {
              "x": 3.424,
              "y": 9.136,
              "z": 0.207
            },
            "rightCorner": {
              "x": 3.408,
              "y": 8.614,
              "z": 0.207
            },
            "gtin": "8006540710494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbcd",
            "leftCorner": {
              "x": 3.408,
              "y": 8.614,
              "z": 0.207
            },
            "rightCorner": {
              "x": 3.398,
              "y": 8.303,
              "z": 0.207
            },
            "gtin": "8700216754156",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c3c",
        "height": 0.76985,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb6d",
            "leftCorner": {
              "x": 3.444,
              "y": 9.602,
              "z": 0.77
            },
            "rightCorner": {
              "x": 3.433,
              "y": 9.253,
              "z": 0.77
            },
            "gtin": "4895248004806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb6f",
            "leftCorner": {
              "x": 3.433,
              "y": 9.253,
              "z": 0.77
            },
            "rightCorner": {
              "x": 3.404,
              "y": 8.326,
              "z": 0.77
            },
            "gtin": "4895248004813",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c3a",
        "height": 1.0692,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fbdd",
            "leftCorner": {
              "x": 3.444,
              "y": 9.602,
              "z": 1.069
            },
            "rightCorner": {
              "x": 3.438,
              "y": 9.42,
              "z": 1.069
            },
            "gtin": "8700216207669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbdf",
            "leftCorner": {
              "x": 3.438,
              "y": 9.42,
              "z": 1.069
            },
            "rightCorner": {
              "x": 3.426,
              "y": 9.027,
              "z": 1.069
            },
            "gtin": "8700216207645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbe0",
            "leftCorner": {
              "x": 3.426,
              "y": 9.027,
              "z": 1.069
            },
            "rightCorner": {
              "x": 3.421,
              "y": 8.859,
              "z": 1.069
            }
          },
          {
            "id": "696ebf6d43c343680a26fbe1",
            "leftCorner": {
              "x": 3.421,
              "y": 8.859,
              "z": 1.069
            },
            "rightCorner": {
              "x": 3.405,
              "y": 8.372,
              "z": 1.069
            },
            "gtin": "8700216664776",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c3b",
        "height": 1.4059,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb85",
            "leftCorner": {
              "x": 3.446,
              "y": 9.602,
              "z": 1.406
            },
            "rightCorner": {
              "x": 3.433,
              "y": 9.194,
              "z": 1.406
            },
            "gtin": "4066447669206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb86",
            "leftCorner": {
              "x": 3.433,
              "y": 9.194,
              "z": 1.406
            },
            "rightCorner": {
              "x": 3.424,
              "y": 8.906,
              "z": 1.406
            },
            "gtin": "4066447248388",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb87",
            "leftCorner": {
              "x": 3.424,
              "y": 8.906,
              "z": 1.406
            },
            "rightCorner": {
              "x": 3.421,
              "y": 8.8,
              "z": 1.406
            }
          },
          {
            "id": "696ebf6d43c343680a26fb88",
            "leftCorner": {
              "x": 3.421,
              "y": 8.8,
              "z": 1.406
            },
            "rightCorner": {
              "x": 3.414,
              "y": 8.598,
              "z": 1.406
            },
            "gtin": "4066447248401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb89",
            "leftCorner": {
              "x": 3.414,
              "y": 8.598,
              "z": 1.406
            },
            "rightCorner": {
              "x": 3.408,
              "y": 8.388,
              "z": 1.406
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c3d",
        "height": 1.7399,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb9c",
            "leftCorner": {
              "x": 3.441,
              "y": 9.602,
              "z": 1.74
            },
            "rightCorner": {
              "x": 3.433,
              "y": 9.35,
              "z": 1.74
            },
            "gtin": "5010415510075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb9d",
            "leftCorner": {
              "x": 3.433,
              "y": 9.35,
              "z": 1.74
            },
            "rightCorner": {
              "x": 3.422,
              "y": 9.018,
              "z": 1.74
            },
            "gtin": "4895248007739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb9e",
            "leftCorner": {
              "x": 3.422,
              "y": 9.018,
              "z": 1.74
            },
            "rightCorner": {
              "x": 3.417,
              "y": 8.847,
              "z": 1.74
            },
            "gtin": "4895248007746",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb9f",
            "leftCorner": {
              "x": 3.417,
              "y": 8.847,
              "z": 1.74
            },
            "rightCorner": {
              "x": 3.412,
              "y": 8.695,
              "z": 1.74
            },
            "gtin": "4895248007746",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fba0",
            "leftCorner": {
              "x": 3.412,
              "y": 8.695,
              "z": 1.74
            },
            "rightCorner": {
              "x": 3.411,
              "y": 8.643,
              "z": 1.74
            }
          },
          {
            "id": "696ebf6d43c343680a26fba1",
            "leftCorner": {
              "x": 3.411,
              "y": 8.643,
              "z": 1.74
            },
            "rightCorner": {
              "x": 3.4,
              "y": 8.297,
              "z": 1.74
            },
            "gtin": "4895248007753",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757b7b5fe7bc046959a24",
    "name": "68e757b7b5fe7bc046959a24",
    "x": 3.5205,
    "y": 8.3472,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72946,
      "w": 0.68403
    },
    "statistics": {
      "hasStockCount": 4,
      "noStockCount": 0,
      "unknownStockCount": 11,
      "shelfCategory": "DIAPERS"
    },
    "layers": [
      {
        "id": "696ead8b3b88e258afd7388b",
        "height": 0.20845,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fbce",
            "leftCorner": {
              "x": 3.375,
              "y": 8.307,
              "z": 0.208
            },
            "rightCorner": {
              "x": 3.355,
              "y": 8.0,
              "z": 0.208
            },
            "gtin": "8700216775755",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbcf",
            "leftCorner": {
              "x": 3.355,
              "y": 8.0,
              "z": 0.208
            },
            "rightCorner": {
              "x": 3.336,
              "y": 7.714,
              "z": 0.208
            }
          },
          {
            "id": "696ebf6d43c343680a26fbd0",
            "leftCorner": {
              "x": 3.336,
              "y": 7.714,
              "z": 0.208
            },
            "rightCorner": {
              "x": 3.3,
              "y": 7.152,
              "z": 0.208
            }
          },
          {
            "id": "696ebf6d43c343680a26fbd1",
            "leftCorner": {
              "x": 3.3,
              "y": 7.152,
              "z": 0.208
            },
            "rightCorner": {
              "x": 3.282,
              "y": 6.873,
              "z": 0.208
            }
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73888",
        "height": 0.76662,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb70",
            "leftCorner": {
              "x": 3.373,
              "y": 8.33,
              "z": 0.767
            },
            "rightCorner": {
              "x": 3.355,
              "y": 8.048,
              "z": 0.767
            },
            "gtin": "8700216775748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb71",
            "leftCorner": {
              "x": 3.355,
              "y": 8.048,
              "z": 0.767
            },
            "rightCorner": {
              "x": 3.339,
              "y": 7.8,
              "z": 0.767
            },
            "gtin": "8700216754088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb72",
            "leftCorner": {
              "x": 3.339,
              "y": 7.8,
              "z": 0.767
            },
            "rightCorner": {
              "x": 3.325,
              "y": 7.578,
              "z": 0.767
            },
            "gtin": "8700216713085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb73",
            "leftCorner": {
              "x": 3.325,
              "y": 7.578,
              "z": 0.767
            },
            "rightCorner": {
              "x": 3.311,
              "y": 7.368,
              "z": 0.767
            }
          },
          {
            "id": "696ebf6d43c343680a26fb74",
            "leftCorner": {
              "x": 3.311,
              "y": 7.368,
              "z": 0.767
            },
            "rightCorner": {
              "x": 3.294,
              "y": 7.101,
              "z": 0.767
            },
            "gtin": "8700216713139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb75",
            "leftCorner": {
              "x": 3.294,
              "y": 7.101,
              "z": 0.767
            },
            "rightCorner": {
              "x": 3.284,
              "y": 6.943,
              "z": 0.767
            }
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd7388c",
        "height": 1.0714,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fbe2",
            "leftCorner": {
              "x": 3.405,
              "y": 8.372,
              "z": 1.069
            },
            "rightCorner": {
              "x": 3.397,
              "y": 8.123,
              "z": 1.069
            },
            "gtin": "8700216665162",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbe3",
            "leftCorner": {
              "x": 3.358,
              "y": 8.128,
              "z": 1.071
            },
            "rightCorner": {
              "x": 3.31,
              "y": 7.383,
              "z": 1.071
            },
            "gtin": "8700216664721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbe4",
            "leftCorner": {
              "x": 3.31,
              "y": 7.383,
              "z": 1.071
            },
            "rightCorner": {
              "x": 3.294,
              "y": 7.13,
              "z": 1.071
            },
            "gtin": "8700216664752",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73889",
        "height": 1.4026,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb8a",
            "leftCorner": {
              "x": 3.408,
              "y": 8.388,
              "z": 1.406
            },
            "rightCorner": {
              "x": 3.398,
              "y": 8.086,
              "z": 1.406
            },
            "gtin": "4066447248425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb8b",
            "leftCorner": {
              "x": 3.354,
              "y": 8.091,
              "z": 1.403
            },
            "rightCorner": {
              "x": 3.307,
              "y": 7.347,
              "z": 1.403
            },
            "gtin": "4066447248449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb8c",
            "leftCorner": {
              "x": 3.307,
              "y": 7.347,
              "z": 1.403
            },
            "rightCorner": {
              "x": 3.292,
              "y": 7.119,
              "z": 1.403
            },
            "gtin": "4066447248463",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd7388a",
        "height": 1.7387,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fba2",
            "leftCorner": {
              "x": 3.368,
              "y": 8.302,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.353,
              "y": 8.078,
              "z": 1.739
            },
            "gtin": "4066447114287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fba3",
            "leftCorner": {
              "x": 3.353,
              "y": 8.078,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.342,
              "y": 7.899,
              "z": 1.739
            },
            "gtin": "4066447873368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fba4",
            "leftCorner": {
              "x": 3.342,
              "y": 7.899,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.325,
              "y": 7.643,
              "z": 1.739
            },
            "gtin": "4066447873429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fba5",
            "leftCorner": {
              "x": 3.325,
              "y": 7.643,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.312,
              "y": 7.428,
              "z": 1.739
            }
          },
          {
            "id": "696ebf6d43c343680a26fba6",
            "leftCorner": {
              "x": 3.312,
              "y": 7.428,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.297,
              "y": 7.195,
              "z": 1.739
            },
            "gtin": "4066447873344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fba7",
            "leftCorner": {
              "x": 3.297,
              "y": 7.195,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.293,
              "y": 7.138,
              "z": 1.739
            }
          }
        ]
      }
    ]
  },
  {
    "id": "68e757b7b5fe7bc046959a25",
    "name": "68e757b7b5fe7bc046959a25",
    "x": 3.3452,
    "y": 7.1085,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73118,
      "w": 0.68219
    },
    "statistics": {
      "hasStockCount": 7,
      "noStockCount": 0,
      "unknownStockCount": 8,
      "shelfCategory": "DIAPERS"
    },
    "layers": [
      {
        "id": "696ead8b3b88e258afd73890",
        "height": 0.20465,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fbd2",
            "leftCorner": {
              "x": 3.283,
              "y": 6.875,
              "z": 0.205
            },
            "rightCorner": {
              "x": 3.251,
              "y": 6.417,
              "z": 0.205
            },
            "gtin": "8700216334976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbd3",
            "leftCorner": {
              "x": 3.251,
              "y": 6.417,
              "z": 0.205
            },
            "rightCorner": {
              "x": 3.235,
              "y": 6.184,
              "z": 0.205
            },
            "gtin": "8006540711569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbd4",
            "leftCorner": {
              "x": 3.235,
              "y": 6.184,
              "z": 0.205
            },
            "rightCorner": {
              "x": 3.219,
              "y": 5.95,
              "z": 0.205
            },
            "gtin": "8006540711910",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd7388e",
        "height": 0.76791,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb76",
            "leftCorner": {
              "x": 3.286,
              "y": 6.946,
              "z": 0.768
            },
            "rightCorner": {
              "x": 3.283,
              "y": 6.904,
              "z": 0.768
            }
          },
          {
            "id": "696ebf6d43c343680a26fb77",
            "leftCorner": {
              "x": 3.283,
              "y": 6.904,
              "z": 0.768
            },
            "rightCorner": {
              "x": 3.27,
              "y": 6.72,
              "z": 0.768
            },
            "gtin": "8700216713160",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb78",
            "leftCorner": {
              "x": 3.27,
              "y": 6.72,
              "z": 0.768
            },
            "rightCorner": {
              "x": 3.258,
              "y": 6.539,
              "z": 0.768
            },
            "gtin": "8700216713160",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb79",
            "leftCorner": {
              "x": 3.258,
              "y": 6.539,
              "z": 0.768
            },
            "rightCorner": {
              "x": 3.248,
              "y": 6.394,
              "z": 0.768
            }
          },
          {
            "id": "696ebf6d43c343680a26fb7a",
            "leftCorner": {
              "x": 3.248,
              "y": 6.394,
              "z": 0.768
            },
            "rightCorner": {
              "x": 3.235,
              "y": 6.217,
              "z": 0.768
            },
            "gtin": "8700216713436",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb7b",
            "leftCorner": {
              "x": 3.235,
              "y": 6.217,
              "z": 0.768
            },
            "rightCorner": {
              "x": 3.211,
              "y": 5.859,
              "z": 0.768
            },
            "gtin": "8700216793469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb7c",
            "leftCorner": {
              "x": 3.211,
              "y": 5.859,
              "z": 0.768
            },
            "rightCorner": {
              "x": 3.208,
              "y": 5.821,
              "z": 0.768
            }
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd7388d",
        "height": 1.0673,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fbe5",
            "leftCorner": {
              "x": 3.294,
              "y": 7.13,
              "z": 1.071
            },
            "rightCorner": {
              "x": 3.257,
              "y": 6.546,
              "z": 1.071
            },
            "gtin": "8700216664622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbe6",
            "leftCorner": {
              "x": 3.257,
              "y": 6.549,
              "z": 1.067
            },
            "rightCorner": {
              "x": 3.249,
              "y": 6.44,
              "z": 1.067
            }
          },
          {
            "id": "696ebf6d43c343680a26fbe7",
            "leftCorner": {
              "x": 3.249,
              "y": 6.44,
              "z": 1.067
            },
            "rightCorner": {
              "x": 3.194,
              "y": 5.652,
              "z": 1.067
            },
            "gtin": "8700216665056",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73891",
        "height": 1.3985,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb8d",
            "leftCorner": {
              "x": 3.296,
              "y": 7.112,
              "z": 1.399
            },
            "rightCorner": {
              "x": 3.233,
              "y": 6.134,
              "z": 1.399
            },
            "gtin": "4066447248487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb8e",
            "leftCorner": {
              "x": 3.228,
              "y": 6.134,
              "z": 1.399
            },
            "rightCorner": {
              "x": 3.212,
              "y": 5.908,
              "z": 1.399
            }
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd7388f",
        "height": 1.7387,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fba8",
            "leftCorner": {
              "x": 3.293,
              "y": 7.138,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.282,
              "y": 6.966,
              "z": 1.739
            },
            "gtin": "4066447873320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fba9",
            "leftCorner": {
              "x": 3.283,
              "y": 6.968,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.28,
              "y": 6.927,
              "z": 1.739
            }
          },
          {
            "id": "696ebf6d43c343680a26fbaa",
            "leftCorner": {
              "x": 3.28,
              "y": 6.927,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.266,
              "y": 6.712,
              "z": 1.739
            },
            "gtin": "4066447873382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbab",
            "leftCorner": {
              "x": 3.266,
              "y": 6.712,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.249,
              "y": 6.468,
              "z": 1.739
            },
            "gtin": "4066447873382",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbac",
            "leftCorner": {
              "x": 3.249,
              "y": 6.468,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.234,
              "y": 6.254,
              "z": 1.739
            },
            "gtin": "4066447878349",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbad",
            "leftCorner": {
              "x": 3.234,
              "y": 6.254,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.214,
              "y": 5.966,
              "z": 1.739
            },
            "gtin": "4066447238662",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbae",
            "leftCorner": {
              "x": 3.214,
              "y": 5.966,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.209,
              "y": 5.901,
              "z": 1.739
            }
          },
          {
            "id": "696ebf6d43c343680a26fbaf",
            "leftCorner": {
              "x": 3.209,
              "y": 5.901,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.193,
              "y": 5.663,
              "z": 1.739
            }
          }
        ]
      }
    ]
  },
  {
    "id": "68e757b7b5fe7bc046959a26",
    "name": "68e757b7b5fe7bc046959a26",
    "x": 3.2546,
    "y": 5.8544,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72992,
      "w": 0.68353
    },
    "statistics": {
      "hasStockCount": 7,
      "noStockCount": 0,
      "unknownStockCount": 12,
      "shelfCategory": "DIAPERS"
    },
    "layers": [
      {
        "id": "696ead8b3b88e258afd73895",
        "height": 0.20704,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fbd5",
            "leftCorner": {
              "x": 3.219,
              "y": 5.95,
              "z": 0.205
            },
            "rightCorner": {
              "x": 3.205,
              "y": 5.746,
              "z": 0.205
            },
            "gtin": "8700216669757",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbd6",
            "leftCorner": {
              "x": 3.202,
              "y": 5.739,
              "z": 0.207
            },
            "rightCorner": {
              "x": 3.186,
              "y": 5.495,
              "z": 0.207
            },
            "gtin": "8700216669757",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbd7",
            "leftCorner": {
              "x": 3.186,
              "y": 5.495,
              "z": 0.207
            },
            "rightCorner": {
              "x": 3.172,
              "y": 5.285,
              "z": 0.207
            },
            "gtin": "8700216595841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbd8",
            "leftCorner": {
              "x": 3.172,
              "y": 5.285,
              "z": 0.207
            },
            "rightCorner": {
              "x": 3.145,
              "y": 4.881,
              "z": 0.207
            },
            "gtin": "8700216595773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbd9",
            "leftCorner": {
              "x": 3.145,
              "y": 4.881,
              "z": 0.207
            },
            "rightCorner": {
              "x": 3.129,
              "y": 4.636,
              "z": 0.207
            },
            "gtin": "8700216679268",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73893",
        "height": 0.76625,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb7d",
            "leftCorner": {
              "x": 3.203,
              "y": 5.814,
              "z": 0.766
            },
            "rightCorner": {
              "x": 3.188,
              "y": 5.595,
              "z": 0.766
            }
          },
          {
            "id": "696ebf6d43c343680a26fb7e",
            "leftCorner": {
              "x": 3.188,
              "y": 5.595,
              "z": 0.766
            },
            "rightCorner": {
              "x": 3.175,
              "y": 5.395,
              "z": 0.766
            },
            "gtin": "8700216670500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb7f",
            "leftCorner": {
              "x": 3.175,
              "y": 5.395,
              "z": 0.766
            },
            "rightCorner": {
              "x": 3.151,
              "y": 5.029,
              "z": 0.766
            },
            "gtin": "8700216670685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb80",
            "leftCorner": {
              "x": 3.151,
              "y": 5.029,
              "z": 0.766
            },
            "rightCorner": {
              "x": 3.124,
              "y": 4.616,
              "z": 0.766
            },
            "gtin": "8700216670647",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73896",
        "height": 1.0653,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fbe8",
            "leftCorner": {
              "x": 3.193,
              "y": 5.645,
              "z": 1.065
            },
            "rightCorner": {
              "x": 3.169,
              "y": 5.29,
              "z": 1.065
            },
            "gtin": "8700216664431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbe9",
            "leftCorner": {
              "x": 3.169,
              "y": 5.29,
              "z": 1.065
            },
            "rightCorner": {
              "x": 3.152,
              "y": 5.029,
              "z": 1.065
            }
          },
          {
            "id": "696ebf6d43c343680a26fbea",
            "leftCorner": {
              "x": 3.152,
              "y": 5.029,
              "z": 1.065
            },
            "rightCorner": {
              "x": 3.125,
              "y": 4.621,
              "z": 1.065
            },
            "gtin": "8700216679015",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73892",
        "height": 1.4024,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb8f",
            "leftCorner": {
              "x": 3.212,
              "y": 5.908,
              "z": 1.398
            },
            "rightCorner": {
              "x": 3.192,
              "y": 5.615,
              "z": 1.398
            },
            "gtin": "4066447248524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb90",
            "leftCorner": {
              "x": 3.188,
              "y": 5.607,
              "z": 1.402
            },
            "rightCorner": {
              "x": 3.157,
              "y": 5.135,
              "z": 1.402
            },
            "gtin": "4066447673982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb91",
            "leftCorner": {
              "x": 3.157,
              "y": 5.135,
              "z": 1.402
            },
            "rightCorner": {
              "x": 3.139,
              "y": 4.859,
              "z": 1.402
            }
          },
          {
            "id": "696ebf6d43c343680a26fb92",
            "leftCorner": {
              "x": 3.139,
              "y": 4.859,
              "z": 1.402
            },
            "rightCorner": {
              "x": 3.124,
              "y": 4.629,
              "z": 1.402
            },
            "gtin": "4067796083217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb93",
            "leftCorner": {
              "x": 3.124,
              "y": 4.629,
              "z": 1.402
            },
            "rightCorner": {
              "x": 3.121,
              "y": 4.589,
              "z": 1.402
            }
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73894",
        "height": 1.7368,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fbb0",
            "leftCorner": {
              "x": 3.189,
              "y": 5.656,
              "z": 1.737
            },
            "rightCorner": {
              "x": 3.177,
              "y": 5.475,
              "z": 1.737
            },
            "gtin": "4066447873269",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbb1",
            "leftCorner": {
              "x": 3.177,
              "y": 5.475,
              "z": 1.737
            },
            "rightCorner": {
              "x": 3.167,
              "y": 5.316,
              "z": 1.737
            },
            "gtin": "4066447873283",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbb2",
            "leftCorner": {
              "x": 3.167,
              "y": 5.316,
              "z": 1.737
            },
            "rightCorner": {
              "x": 3.154,
              "y": 5.121,
              "z": 1.737
            }
          },
          {
            "id": "696ebf6d43c343680a26fbb3",
            "leftCorner": {
              "x": 3.154,
              "y": 5.121,
              "z": 1.737
            },
            "rightCorner": {
              "x": 3.142,
              "y": 4.93,
              "z": 1.737
            },
            "gtin": "4066447873306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbb4",
            "leftCorner": {
              "x": 3.142,
              "y": 4.93,
              "z": 1.737
            },
            "rightCorner": {
              "x": 3.126,
              "y": 4.698,
              "z": 1.737
            },
            "gtin": "4066447873306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbb5",
            "leftCorner": {
              "x": 3.126,
              "y": 4.698,
              "z": 1.737
            },
            "rightCorner": {
              "x": 3.123,
              "y": 4.649,
              "z": 1.737
            },
            "gtin": "8006540630518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbb6",
            "leftCorner": {
              "x": 3.123,
              "y": 4.649,
              "z": 1.737
            },
            "rightCorner": {
              "x": 3.117,
              "y": 4.556,
              "z": 1.737
            },
            "gtin": "8006540630518",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757b7b5fe7bc046959a27",
    "name": "68e757b7b5fe7bc046959a27",
    "x": 3.1717,
    "y": 4.6029,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72851,
      "w": 0.68504
    },
    "statistics": {
      "hasStockCount": 9,
      "noStockCount": 1,
      "unknownStockCount": 15,
      "shelfCategory": "DIAPERS"
    },
    "layers": [
      {
        "id": "696ead8b3b88e258afd7389a",
        "height": 0.2053,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fbda",
            "leftCorner": {
              "x": 3.129,
              "y": 4.636,
              "z": 0.207
            },
            "rightCorner": {
              "x": 3.113,
              "y": 4.383,
              "z": 0.207
            },
            "gtin": "8700216595759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbdb",
            "leftCorner": {
              "x": 3.113,
              "y": 4.379,
              "z": 0.205
            },
            "rightCorner": {
              "x": 3.098,
              "y": 4.132,
              "z": 0.205
            },
            "gtin": "8700216679381",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbdc",
            "leftCorner": {
              "x": 3.098,
              "y": 4.132,
              "z": 0.205
            },
            "rightCorner": {
              "x": 3.064,
              "y": 3.58,
              "z": 0.205
            },
            "gtin": "8700216595704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbc9",
            "leftCorner": {
              "x": 3.064,
              "y": 3.58,
              "z": 0.205
            },
            "rightCorner": {
              "x": 3.05,
              "y": 3.358,
              "z": 0.205
            },
            "gtin": "8700216595858",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73897",
        "height": 0.76699,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb81",
            "leftCorner": {
              "x": 3.124,
              "y": 4.616,
              "z": 0.766
            },
            "rightCorner": {
              "x": 3.113,
              "y": 4.445,
              "z": 0.766
            },
            "gtin": "8700216670456",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb82",
            "leftCorner": {
              "x": 3.113,
              "y": 4.441,
              "z": 0.767
            },
            "rightCorner": {
              "x": 3.101,
              "y": 4.253,
              "z": 0.767
            },
            "gtin": "8700216670456",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fb83",
            "leftCorner": {
              "x": 3.101,
              "y": 4.253,
              "z": 0.767
            },
            "rightCorner": {
              "x": 3.082,
              "y": 3.951,
              "z": 0.767
            },
            "gtin": "4066447185287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb84",
            "leftCorner": {
              "x": 3.082,
              "y": 3.951,
              "z": 0.767
            },
            "rightCorner": {
              "x": 3.065,
              "y": 3.668,
              "z": 0.767
            }
          },
          {
            "id": "696ebf6d43c343680a26fb6e",
            "leftCorner": {
              "x": 3.065,
              "y": 3.668,
              "z": 0.767
            },
            "rightCorner": {
              "x": 3.046,
              "y": 3.358,
              "z": 0.767
            },
            "gtin": "4066447869224",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd7389b",
        "height": 1.0669,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fbeb",
            "leftCorner": {
              "x": 3.125,
              "y": 4.621,
              "z": 1.065
            },
            "rightCorner": {
              "x": 3.116,
              "y": 4.473,
              "z": 1.065
            },
            "gtin": "4067796080391",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbec",
            "leftCorner": {
              "x": 3.115,
              "y": 4.469,
              "z": 1.067
            },
            "rightCorner": {
              "x": 3.105,
              "y": 4.321,
              "z": 1.067
            }
          },
          {
            "id": "696ebf6d43c343680a26fbed",
            "leftCorner": {
              "x": 3.105,
              "y": 4.321,
              "z": 1.067
            },
            "rightCorner": {
              "x": 3.076,
              "y": 3.847,
              "z": 1.067
            },
            "gtin": "4066447668674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbee",
            "leftCorner": {
              "x": 3.076,
              "y": 3.847,
              "z": 1.067
            },
            "rightCorner": {
              "x": 3.062,
              "y": 3.612,
              "z": 1.067
            }
          },
          {
            "id": "696ebf6d43c343680a26fbde",
            "leftCorner": {
              "x": 3.062,
              "y": 3.612,
              "z": 1.067
            },
            "rightCorner": {
              "x": 3.046,
              "y": 3.358,
              "z": 1.067
            },
            "gtin": "4066447874129",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73898",
        "height": 1.4037,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fb94",
            "leftCorner": {
              "x": 3.12,
              "y": 4.584,
              "z": 1.404
            },
            "rightCorner": {
              "x": 3.112,
              "y": 4.445,
              "z": 1.404
            },
            "gtin": "4066447668599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb95",
            "leftCorner": {
              "x": 3.112,
              "y": 4.445,
              "z": 1.404
            },
            "rightCorner": {
              "x": 3.102,
              "y": 4.29,
              "z": 1.404
            },
            "gtin": "4066447668599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb96",
            "leftCorner": {
              "x": 3.102,
              "y": 4.29,
              "z": 1.404
            },
            "rightCorner": {
              "x": 3.093,
              "y": 4.139,
              "z": 1.404
            },
            "gtin": "4058172775680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb97",
            "leftCorner": {
              "x": 3.093,
              "y": 4.139,
              "z": 1.404
            },
            "rightCorner": {
              "x": 3.084,
              "y": 3.991,
              "z": 1.404
            },
            "gtin": "4058172775680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb98",
            "leftCorner": {
              "x": 3.084,
              "y": 3.991,
              "z": 1.404
            },
            "rightCorner": {
              "x": 3.074,
              "y": 3.827,
              "z": 1.404
            },
            "gtin": "4058172775680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb99",
            "leftCorner": {
              "x": 3.074,
              "y": 3.827,
              "z": 1.404
            },
            "rightCorner": {
              "x": 3.064,
              "y": 3.673,
              "z": 1.404
            },
            "gtin": "4066447863468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb9a",
            "leftCorner": {
              "x": 3.064,
              "y": 3.673,
              "z": 1.404
            },
            "rightCorner": {
              "x": 3.056,
              "y": 3.541,
              "z": 1.404
            },
            "gtin": "4066447863468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fb9b",
            "leftCorner": {
              "x": 3.056,
              "y": 3.541,
              "z": 1.404
            },
            "rightCorner": {
              "x": 3.046,
              "y": 3.374,
              "z": 1.404
            },
            "gtin": "4066447412239",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd73899",
        "height": 1.7391,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fbb7",
            "leftCorner": {
              "x": 3.116,
              "y": 4.552,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.108,
              "y": 4.409,
              "z": 1.739
            }
          },
          {
            "id": "696ebf6d43c343680a26fbb8",
            "leftCorner": {
              "x": 3.108,
              "y": 4.409,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.099,
              "y": 4.264,
              "z": 1.739
            },
            "gtin": "8006540630648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbb9",
            "leftCorner": {
              "x": 3.099,
              "y": 4.264,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.089,
              "y": 4.108,
              "z": 1.739
            },
            "gtin": "5029053527581",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbba",
            "leftCorner": {
              "x": 3.089,
              "y": 4.108,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.077,
              "y": 3.911,
              "z": 1.739
            },
            "gtin": "4066447674200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbbb",
            "leftCorner": {
              "x": 3.077,
              "y": 3.911,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.069,
              "y": 3.778,
              "z": 1.739
            }
          },
          {
            "id": "696ebf6d43c343680a26fbbc",
            "leftCorner": {
              "x": 3.069,
              "y": 3.778,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.06,
              "y": 3.635,
              "z": 1.739
            },
            "gtin": "4066447674224",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbbd",
            "leftCorner": {
              "x": 3.06,
              "y": 3.635,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.053,
              "y": 3.521,
              "z": 1.739
            },
            "gtin": "4066447674224",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbbe",
            "leftCorner": {
              "x": 3.053,
              "y": 3.521,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.044,
              "y": 3.379,
              "z": 1.739
            },
            "gtin": "4260343010166",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbbf",
            "leftCorner": {
              "x": 3.044,
              "y": 3.379,
              "z": 1.739
            },
            "rightCorner": {
              "x": 3.033,
              "y": 3.196,
              "z": 1.739
            }
          }
        ]
      }
    ]
  },
  {
    "id": "68e757b7b5fe7bc046959a28",
    "name": "68e757b7b5fe7bc046959a28",
    "x": 3.1898,
    "y": 3.3339,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73383,
      "w": 0.67934
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 4,
      "shelfCategory": "DIAPERS"
    },
    "layers": [
      {
        "id": "696ead8b3b88e258afd7389c",
        "height": 1.7432,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fbc0",
            "leftCorner": {
              "x": 3.034,
              "y": 3.183,
              "z": 1.743
            },
            "rightCorner": {
              "x": 3.022,
              "y": 3.017,
              "z": 1.743
            },
            "gtin": "4066447712957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbc1",
            "leftCorner": {
              "x": 3.022,
              "y": 3.017,
              "z": 1.743
            },
            "rightCorner": {
              "x": 3.01,
              "y": 2.872,
              "z": 1.743
            },
            "gtin": "4066447675290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbc2",
            "leftCorner": {
              "x": 3.01,
              "y": 2.872,
              "z": 1.743
            },
            "rightCorner": {
              "x": 2.997,
              "y": 2.696,
              "z": 1.743
            },
            "gtin": "4066447675290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbc3",
            "leftCorner": {
              "x": 2.997,
              "y": 2.696,
              "z": 1.743
            },
            "rightCorner": {
              "x": 2.985,
              "y": 2.543,
              "z": 1.743
            }
          },
          {
            "id": "696ebf6d43c343680a26fbc4",
            "leftCorner": {
              "x": 2.985,
              "y": 2.543,
              "z": 1.743
            },
            "rightCorner": {
              "x": 2.973,
              "y": 2.388,
              "z": 1.743
            }
          },
          {
            "id": "696ebf6d43c343680a26fbc5",
            "leftCorner": {
              "x": 2.973,
              "y": 2.388,
              "z": 1.743
            },
            "rightCorner": {
              "x": 2.97,
              "y": 2.354,
              "z": 1.743
            }
          },
          {
            "id": "696ebf6d43c343680a26fbc6",
            "leftCorner": {
              "x": 2.97,
              "y": 2.354,
              "z": 1.743
            },
            "rightCorner": {
              "x": 2.961,
              "y": 2.233,
              "z": 1.743
            }
          },
          {
            "id": "696ebf6d43c343680a26fbc7",
            "leftCorner": {
              "x": 2.961,
              "y": 2.233,
              "z": 1.743
            },
            "rightCorner": {
              "x": 2.952,
              "y": 2.119,
              "z": 1.743
            },
            "gtin": "4066447440782",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757b7b5fe7bc046959a29",
    "name": "68e757b7b5fe7bc046959a29",
    "x": 4.5602,
    "y": 1.9911,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68234,
      "w": 0.73104
    },
    "statistics": {
      "hasStockCount": 38,
      "noStockCount": 2,
      "unknownStockCount": 12,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "696ead8b3b88e258afd7389f",
        "height": 0.20629,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fc5b",
            "leftCorner": {
              "x": 4.605,
              "y": 1.988,
              "z": 0.206
            },
            "rightCorner": {
              "x": 4.614,
              "y": 2.111,
              "z": 0.206
            },
            "gtin": "4031244707734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc5d",
            "leftCorner": {
              "x": 4.614,
              "y": 2.111,
              "z": 0.206
            },
            "rightCorner": {
              "x": 4.624,
              "y": 2.257,
              "z": 0.206
            },
            "gtin": "4031244004857",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc5e",
            "leftCorner": {
              "x": 4.624,
              "y": 2.257,
              "z": 0.206
            },
            "rightCorner": {
              "x": 4.632,
              "y": 2.38,
              "z": 0.206
            },
            "gtin": "4251099603481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc5f",
            "leftCorner": {
              "x": 4.632,
              "y": 2.38,
              "z": 0.206
            },
            "rightCorner": {
              "x": 4.643,
              "y": 2.537,
              "z": 0.206
            },
            "gtin": "4031244004291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc60",
            "leftCorner": {
              "x": 4.643,
              "y": 2.537,
              "z": 0.206
            },
            "rightCorner": {
              "x": 4.653,
              "y": 2.687,
              "z": 0.206
            },
            "gtin": "4031244004253",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc61",
            "leftCorner": {
              "x": 4.653,
              "y": 2.687,
              "z": 0.206
            },
            "rightCorner": {
              "x": 4.664,
              "y": 2.841,
              "z": 0.206
            },
            "gtin": "4031244004239",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc62",
            "leftCorner": {
              "x": 4.664,
              "y": 2.841,
              "z": 0.206
            },
            "rightCorner": {
              "x": 4.675,
              "y": 2.999,
              "z": 0.206
            },
            "gtin": "4031244004239",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc63",
            "leftCorner": {
              "x": 4.675,
              "y": 2.999,
              "z": 0.206
            },
            "rightCorner": {
              "x": 4.684,
              "y": 3.13,
              "z": 0.206
            }
          },
          {
            "id": "696ebf6d43c343680a26fc64",
            "leftCorner": {
              "x": 4.684,
              "y": 3.13,
              "z": 0.206
            },
            "rightCorner": {
              "x": 4.695,
              "y": 3.288,
              "z": 0.206
            },
            "gtin": "4251099705550",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738a1",
        "height": 0.51354,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fcc5",
            "leftCorner": {
              "x": 4.611,
              "y": 1.987,
              "z": 0.514
            },
            "rightCorner": {
              "x": 4.619,
              "y": 2.099,
              "z": 0.514
            },
            "gtin": "4066447175721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fcc7",
            "leftCorner": {
              "x": 4.619,
              "y": 2.099,
              "z": 0.514
            },
            "rightCorner": {
              "x": 4.629,
              "y": 2.235,
              "z": 0.514
            }
          },
          {
            "id": "696ebf6d43c343680a26fcc8",
            "leftCorner": {
              "x": 4.629,
              "y": 2.235,
              "z": 0.514
            },
            "rightCorner": {
              "x": 4.638,
              "y": 2.372,
              "z": 0.514
            },
            "gtin": "4066447175745",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcc9",
            "leftCorner": {
              "x": 4.638,
              "y": 2.372,
              "z": 0.514
            },
            "rightCorner": {
              "x": 4.649,
              "y": 2.529,
              "z": 0.514
            },
            "gtin": "4066447208085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcca",
            "leftCorner": {
              "x": 4.649,
              "y": 2.529,
              "z": 0.514
            },
            "rightCorner": {
              "x": 4.658,
              "y": 2.662,
              "z": 0.514
            },
            "gtin": "4066447208108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fccb",
            "leftCorner": {
              "x": 4.658,
              "y": 2.662,
              "z": 0.514
            },
            "rightCorner": {
              "x": 4.667,
              "y": 2.787,
              "z": 0.514
            },
            "gtin": "4018852029762",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fccc",
            "leftCorner": {
              "x": 4.667,
              "y": 2.787,
              "z": 0.514
            },
            "rightCorner": {
              "x": 4.676,
              "y": 2.923,
              "z": 0.514
            },
            "gtin": "4018852031796",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fccd",
            "leftCorner": {
              "x": 4.676,
              "y": 2.923,
              "z": 0.514
            },
            "rightCorner": {
              "x": 4.685,
              "y": 3.054,
              "z": 0.514
            },
            "gtin": "4018852026686",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcce",
            "leftCorner": {
              "x": 4.685,
              "y": 3.054,
              "z": 0.514
            },
            "rightCorner": {
              "x": 4.695,
              "y": 3.199,
              "z": 0.514
            },
            "gtin": "4018852021063",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738a0",
        "height": 0.84803,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fca0",
            "leftCorner": {
              "x": 4.613,
              "y": 1.981,
              "z": 0.848
            },
            "rightCorner": {
              "x": 4.62,
              "y": 2.079,
              "z": 0.848
            },
            "gtin": "8445290945648",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fca1",
            "leftCorner": {
              "x": 4.62,
              "y": 2.079,
              "z": 0.848
            },
            "rightCorner": {
              "x": 4.63,
              "y": 2.238,
              "z": 0.848
            },
            "gtin": "8445290917751",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fca2",
            "leftCorner": {
              "x": 4.63,
              "y": 2.238,
              "z": 0.848
            },
            "rightCorner": {
              "x": 4.641,
              "y": 2.392,
              "z": 0.848
            },
            "gtin": "8445290917751",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fca3",
            "leftCorner": {
              "x": 4.641,
              "y": 2.392,
              "z": 0.848
            },
            "rightCorner": {
              "x": 4.653,
              "y": 2.558,
              "z": 0.848
            }
          },
          {
            "id": "696ebf6d43c343680a26fca4",
            "leftCorner": {
              "x": 4.653,
              "y": 2.558,
              "z": 0.848
            },
            "rightCorner": {
              "x": 4.663,
              "y": 2.702,
              "z": 0.848
            },
            "gtin": "8445290067449",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fca5",
            "leftCorner": {
              "x": 4.663,
              "y": 2.702,
              "z": 0.848
            },
            "rightCorner": {
              "x": 4.672,
              "y": 2.839,
              "z": 0.848
            },
            "gtin": "8445290067449",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fca6",
            "leftCorner": {
              "x": 4.672,
              "y": 2.839,
              "z": 0.848
            },
            "rightCorner": {
              "x": 4.676,
              "y": 2.901,
              "z": 0.848
            },
            "gtin": "8445290478153",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fca7",
            "leftCorner": {
              "x": 4.676,
              "y": 2.901,
              "z": 0.848
            },
            "rightCorner": {
              "x": 4.688,
              "y": 3.065,
              "z": 0.848
            },
            "gtin": "7613038463582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fca8",
            "leftCorner": {
              "x": 4.688,
              "y": 3.065,
              "z": 0.848
            },
            "rightCorner": {
              "x": 4.698,
              "y": 3.211,
              "z": 0.848
            },
            "gtin": "7613038463582",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd7389d",
        "height": 1.1896,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fbef",
            "leftCorner": {
              "x": 4.614,
              "y": 1.987,
              "z": 1.19
            },
            "rightCorner": {
              "x": 4.622,
              "y": 2.101,
              "z": 1.19
            },
            "gtin": "4062300406247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbf1",
            "leftCorner": {
              "x": 4.622,
              "y": 2.101,
              "z": 1.19
            },
            "rightCorner": {
              "x": 4.631,
              "y": 2.24,
              "z": 1.19
            },
            "gtin": "4062300406254",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbf2",
            "leftCorner": {
              "x": 4.631,
              "y": 2.24,
              "z": 1.19
            },
            "rightCorner": {
              "x": 4.635,
              "y": 2.296,
              "z": 1.19
            },
            "gtin": "4062300403765",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbf3",
            "leftCorner": {
              "x": 4.635,
              "y": 2.296,
              "z": 1.19
            },
            "rightCorner": {
              "x": 4.646,
              "y": 2.451,
              "z": 1.19
            },
            "gtin": "4062300402782",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbf4",
            "leftCorner": {
              "x": 4.646,
              "y": 2.451,
              "z": 1.19
            },
            "rightCorner": {
              "x": 4.656,
              "y": 2.594,
              "z": 1.19
            },
            "gtin": "4062300402799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbf5",
            "leftCorner": {
              "x": 4.656,
              "y": 2.594,
              "z": 1.19
            },
            "rightCorner": {
              "x": 4.664,
              "y": 2.718,
              "z": 1.19
            },
            "gtin": "4062300402805",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbf6",
            "leftCorner": {
              "x": 4.664,
              "y": 2.718,
              "z": 1.19
            },
            "rightCorner": {
              "x": 4.672,
              "y": 2.829,
              "z": 1.19
            },
            "gtin": "4062300405714",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbf7",
            "leftCorner": {
              "x": 4.672,
              "y": 2.829,
              "z": 1.19
            },
            "rightCorner": {
              "x": 4.682,
              "y": 2.977,
              "z": 1.19
            },
            "gtin": "4062300398894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbf8",
            "leftCorner": {
              "x": 4.682,
              "y": 2.977,
              "z": 1.19
            },
            "rightCorner": {
              "x": 4.691,
              "y": 3.098,
              "z": 1.19
            },
            "gtin": "4062300398894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fbf9",
            "leftCorner": {
              "x": 4.691,
              "y": 3.098,
              "z": 1.19
            },
            "rightCorner": {
              "x": 4.7,
              "y": 3.232,
              "z": 1.19
            },
            "gtin": "4062300398900",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738a2",
        "height": 1.4848,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fce9",
            "leftCorner": {
              "x": 4.619,
              "y": 1.987,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.625,
              "y": 2.083,
              "z": 1.485
            }
          },
          {
            "id": "696ebf6d43c343680a26fceb",
            "leftCorner": {
              "x": 4.625,
              "y": 2.083,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.635,
              "y": 2.216,
              "z": 1.485
            },
            "gtin": "4056631002209",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcec",
            "leftCorner": {
              "x": 4.635,
              "y": 2.216,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.645,
              "y": 2.363,
              "z": 1.485
            },
            "gtin": "4056631002223",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fced",
            "leftCorner": {
              "x": 4.645,
              "y": 2.363,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.655,
              "y": 2.515,
              "z": 1.485
            },
            "gtin": "4056631003411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fcee",
            "leftCorner": {
              "x": 4.655,
              "y": 2.515,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.664,
              "y": 2.65,
              "z": 1.485
            },
            "gtin": "4056631000472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcef",
            "leftCorner": {
              "x": 4.664,
              "y": 2.65,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.673,
              "y": 2.776,
              "z": 1.485
            },
            "gtin": "4056631000472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcf0",
            "leftCorner": {
              "x": 4.673,
              "y": 2.776,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.682,
              "y": 2.903,
              "z": 1.485
            },
            "gtin": "4056631000496",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcf1",
            "leftCorner": {
              "x": 4.682,
              "y": 2.903,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.691,
              "y": 3.034,
              "z": 1.485
            },
            "gtin": "4056631000519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcf2",
            "leftCorner": {
              "x": 4.691,
              "y": 3.034,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.698,
              "y": 3.136,
              "z": 1.485
            },
            "gtin": "4056631003398",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcf3",
            "leftCorner": {
              "x": 4.698,
              "y": 3.136,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.705,
              "y": 3.242,
              "z": 1.485
            },
            "gtin": "4056631002414",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd7389e",
        "height": 1.7749,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fc1f",
            "leftCorner": {
              "x": 4.694,
              "y": 3.07,
              "z": 1.775
            },
            "rightCorner": {
              "x": 4.703,
              "y": 3.197,
              "z": 1.775
            },
            "gtin": "4056631003565",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc16",
            "leftCorner": {
              "x": 4.619,
              "y": 1.987,
              "z": 1.775
            },
            "rightCorner": {
              "x": 4.623,
              "y": 2.05,
              "z": 1.775
            },
            "gtin": "4008976021896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc18",
            "leftCorner": {
              "x": 4.623,
              "y": 2.05,
              "z": 1.775
            },
            "rightCorner": {
              "x": 4.634,
              "y": 2.2,
              "z": 1.775
            },
            "gtin": "4056631003435",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc19",
            "leftCorner": {
              "x": 4.634,
              "y": 2.2,
              "z": 1.775
            },
            "rightCorner": {
              "x": 4.642,
              "y": 2.321,
              "z": 1.775
            },
            "gtin": "4056631003435",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc1a",
            "leftCorner": {
              "x": 4.642,
              "y": 2.321,
              "z": 1.775
            },
            "rightCorner": {
              "x": 4.653,
              "y": 2.479,
              "z": 1.775
            },
            "gtin": "4056631003459",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc1b",
            "leftCorner": {
              "x": 4.653,
              "y": 2.479,
              "z": 1.775
            },
            "rightCorner": {
              "x": 4.664,
              "y": 2.637,
              "z": 1.775
            },
            "gtin": "4056631003473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc1c",
            "leftCorner": {
              "x": 4.664,
              "y": 2.637,
              "z": 1.775
            },
            "rightCorner": {
              "x": 4.674,
              "y": 2.782,
              "z": 1.775
            },
            "gtin": "4056631003923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc1d",
            "leftCorner": {
              "x": 4.674,
              "y": 2.782,
              "z": 1.775
            },
            "rightCorner": {
              "x": 4.683,
              "y": 2.916,
              "z": 1.775
            },
            "gtin": "4056631003947",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc1e",
            "leftCorner": {
              "x": 4.683,
              "y": 2.916,
              "z": 1.775
            },
            "rightCorner": {
              "x": 4.694,
              "y": 3.07,
              "z": 1.775
            },
            "gtin": "4056631003541",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757b7b5fe7bc046959a2a",
    "name": "68e757b7b5fe7bc046959a2a",
    "x": 4.6494,
    "y": 3.2544,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.6807,
      "w": 0.73257
    },
    "statistics": {
      "hasStockCount": 41,
      "noStockCount": 1,
      "unknownStockCount": 12,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "696ead8b3b88e258afd738a3",
        "height": 0.20635,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fc65",
            "leftCorner": {
              "x": 4.7,
              "y": 3.304,
              "z": 0.206
            },
            "rightCorner": {
              "x": 4.709,
              "y": 3.434,
              "z": 0.206
            },
            "gtin": "4251099645047",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc66",
            "leftCorner": {
              "x": 4.709,
              "y": 3.434,
              "z": 0.206
            },
            "rightCorner": {
              "x": 4.719,
              "y": 3.572,
              "z": 0.206
            },
            "gtin": "4251099645061",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc67",
            "leftCorner": {
              "x": 4.719,
              "y": 3.572,
              "z": 0.206
            },
            "rightCorner": {
              "x": 4.73,
              "y": 3.721,
              "z": 0.206
            },
            "gtin": "4067796003192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc68",
            "leftCorner": {
              "x": 4.73,
              "y": 3.721,
              "z": 0.206
            },
            "rightCorner": {
              "x": 4.74,
              "y": 3.856,
              "z": 0.206
            },
            "gtin": "4067796003192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc69",
            "leftCorner": {
              "x": 4.74,
              "y": 3.856,
              "z": 0.206
            },
            "rightCorner": {
              "x": 4.75,
              "y": 3.99,
              "z": 0.206
            }
          },
          {
            "id": "696ebf6d43c343680a26fc6a",
            "leftCorner": {
              "x": 4.75,
              "y": 3.99,
              "z": 0.206
            },
            "rightCorner": {
              "x": 4.759,
              "y": 4.116,
              "z": 0.206
            },
            "gtin": "4066447342543",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc6b",
            "leftCorner": {
              "x": 4.759,
              "y": 4.116,
              "z": 0.206
            },
            "rightCorner": {
              "x": 4.77,
              "y": 4.257,
              "z": 0.206
            },
            "gtin": "4066447342567",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc6c",
            "leftCorner": {
              "x": 4.77,
              "y": 4.257,
              "z": 0.206
            },
            "rightCorner": {
              "x": 4.781,
              "y": 4.41,
              "z": 0.206
            },
            "gtin": "4066447342567",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738a4",
        "height": 0.50975,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fccf",
            "leftCorner": {
              "x": 4.695,
              "y": 3.199,
              "z": 0.514
            },
            "rightCorner": {
              "x": 4.706,
              "y": 3.364,
              "z": 0.514
            },
            "gtin": "4018852021117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fcd0",
            "leftCorner": {
              "x": 4.708,
              "y": 3.38,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.718,
              "y": 3.507,
              "z": 0.51
            },
            "gtin": "4018852033745",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcd1",
            "leftCorner": {
              "x": 4.718,
              "y": 3.507,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.727,
              "y": 3.633,
              "z": 0.51
            },
            "gtin": "4018852033462",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcd2",
            "leftCorner": {
              "x": 4.727,
              "y": 3.633,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.738,
              "y": 3.779,
              "z": 0.51
            },
            "gtin": "4056631003961",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcd3",
            "leftCorner": {
              "x": 4.738,
              "y": 3.779,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.748,
              "y": 3.92,
              "z": 0.51
            },
            "gtin": "4056631003961",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcd4",
            "leftCorner": {
              "x": 4.748,
              "y": 3.92,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.759,
              "y": 4.065,
              "z": 0.51
            },
            "gtin": "4008976032892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcd5",
            "leftCorner": {
              "x": 4.759,
              "y": 4.065,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.767,
              "y": 4.178,
              "z": 0.51
            },
            "gtin": "4008976032892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcd6",
            "leftCorner": {
              "x": 4.767,
              "y": 4.178,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.778,
              "y": 4.322,
              "z": 0.51
            },
            "gtin": "4008976032861",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcd7",
            "leftCorner": {
              "x": 4.778,
              "y": 4.322,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.788,
              "y": 4.47,
              "z": 0.51
            },
            "gtin": "4056631001790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fcd8",
            "leftCorner": {
              "x": 4.788,
              "y": 4.47,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.8,
              "y": 4.629,
              "z": 0.51
            },
            "gtin": "4056631001790",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738a6",
        "height": 0.84587,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fca9",
            "leftCorner": {
              "x": 4.698,
              "y": 3.211,
              "z": 0.848
            },
            "rightCorner": {
              "x": 4.705,
              "y": 3.316,
              "z": 0.848
            },
            "gtin": "7613038463070",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcaa",
            "leftCorner": {
              "x": 4.708,
              "y": 3.332,
              "z": 0.846
            },
            "rightCorner": {
              "x": 4.718,
              "y": 3.471,
              "z": 0.846
            },
            "gtin": "7613287226631",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcab",
            "leftCorner": {
              "x": 4.718,
              "y": 3.471,
              "z": 0.846
            },
            "rightCorner": {
              "x": 4.727,
              "y": 3.594,
              "z": 0.846
            },
            "gtin": "7613287226631",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcac",
            "leftCorner": {
              "x": 4.727,
              "y": 3.594,
              "z": 0.846
            },
            "rightCorner": {
              "x": 4.747,
              "y": 3.86,
              "z": 0.846
            },
            "gtin": "7613287226679",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcad",
            "leftCorner": {
              "x": 4.747,
              "y": 3.86,
              "z": 0.846
            },
            "rightCorner": {
              "x": 4.764,
              "y": 4.102,
              "z": 0.846
            }
          },
          {
            "id": "696ebf6d43c343680a26fcae",
            "leftCorner": {
              "x": 4.764,
              "y": 4.102,
              "z": 0.846
            },
            "rightCorner": {
              "x": 4.777,
              "y": 4.271,
              "z": 0.846
            },
            "gtin": "7613038463384",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcaf",
            "leftCorner": {
              "x": 4.777,
              "y": 4.271,
              "z": 0.846
            },
            "rightCorner": {
              "x": 4.787,
              "y": 4.406,
              "z": 0.846
            },
            "gtin": "7613038463384",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcb0",
            "leftCorner": {
              "x": 4.787,
              "y": 4.406,
              "z": 0.846
            },
            "rightCorner": {
              "x": 4.794,
              "y": 4.497,
              "z": 0.846
            },
            "gtin": "7613038464244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fcb1",
            "leftCorner": {
              "x": 4.793,
              "y": 4.478,
              "z": 0.845
            },
            "rightCorner": {
              "x": 4.803,
              "y": 4.605,
              "z": 0.845
            },
            "gtin": "7613038464244",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738a8",
        "height": 1.1844,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fbfa",
            "leftCorner": {
              "x": 4.7,
              "y": 3.232,
              "z": 1.19
            },
            "rightCorner": {
              "x": 4.709,
              "y": 3.365,
              "z": 1.19
            },
            "gtin": "4062300398917",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbfb",
            "leftCorner": {
              "x": 4.71,
              "y": 3.381,
              "z": 1.184
            },
            "rightCorner": {
              "x": 4.72,
              "y": 3.516,
              "z": 1.184
            },
            "gtin": "4062300398917",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbfc",
            "leftCorner": {
              "x": 4.72,
              "y": 3.516,
              "z": 1.184
            },
            "rightCorner": {
              "x": 4.73,
              "y": 3.648,
              "z": 1.184
            },
            "gtin": "4062300398924",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbfd",
            "leftCorner": {
              "x": 4.73,
              "y": 3.648,
              "z": 1.184
            },
            "rightCorner": {
              "x": 4.739,
              "y": 3.779,
              "z": 1.184
            },
            "gtin": "4062300447240",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbfe",
            "leftCorner": {
              "x": 4.739,
              "y": 3.779,
              "z": 1.184
            },
            "rightCorner": {
              "x": 4.749,
              "y": 3.908,
              "z": 1.184
            },
            "gtin": "4062300447233",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbff",
            "leftCorner": {
              "x": 4.749,
              "y": 3.908,
              "z": 1.184
            },
            "rightCorner": {
              "x": 4.758,
              "y": 4.027,
              "z": 1.184
            },
            "gtin": "4062300414310",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc00",
            "leftCorner": {
              "x": 4.758,
              "y": 4.027,
              "z": 1.184
            },
            "rightCorner": {
              "x": 4.767,
              "y": 4.149,
              "z": 1.184
            },
            "gtin": "4062300414310",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc01",
            "leftCorner": {
              "x": 4.767,
              "y": 4.149,
              "z": 1.184
            },
            "rightCorner": {
              "x": 4.777,
              "y": 4.294,
              "z": 1.184
            },
            "gtin": "4062300414327",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc02",
            "leftCorner": {
              "x": 4.777,
              "y": 4.294,
              "z": 1.184
            },
            "rightCorner": {
              "x": 4.787,
              "y": 4.425,
              "z": 1.184
            },
            "gtin": "4062300414327",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738a7",
        "height": 1.4802,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fcf4",
            "leftCorner": {
              "x": 4.71,
              "y": 3.258,
              "z": 1.48
            },
            "rightCorner": {
              "x": 4.718,
              "y": 3.376,
              "z": 1.48
            },
            "gtin": "4056631001202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fcf5",
            "leftCorner": {
              "x": 4.718,
              "y": 3.376,
              "z": 1.48
            },
            "rightCorner": {
              "x": 4.73,
              "y": 3.537,
              "z": 1.48
            },
            "gtin": "4056631003701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fcf6",
            "leftCorner": {
              "x": 4.73,
              "y": 3.537,
              "z": 1.48
            },
            "rightCorner": {
              "x": 4.741,
              "y": 3.683,
              "z": 1.48
            },
            "gtin": "4056631003879",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcf7",
            "leftCorner": {
              "x": 4.741,
              "y": 3.683,
              "z": 1.48
            },
            "rightCorner": {
              "x": 4.751,
              "y": 3.813,
              "z": 1.48
            },
            "gtin": "4056631001226",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcf8",
            "leftCorner": {
              "x": 4.751,
              "y": 3.813,
              "z": 1.48
            },
            "rightCorner": {
              "x": 4.755,
              "y": 3.876,
              "z": 1.48
            },
            "gtin": "4056631002438",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcf9",
            "leftCorner": {
              "x": 4.755,
              "y": 3.876,
              "z": 1.48
            },
            "rightCorner": {
              "x": 4.764,
              "y": 3.99,
              "z": 1.48
            },
            "gtin": "4056631001240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fcfa",
            "leftCorner": {
              "x": 4.764,
              "y": 3.99,
              "z": 1.48
            },
            "rightCorner": {
              "x": 4.774,
              "y": 4.132,
              "z": 1.48
            },
            "gtin": "4056631003725",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcfb",
            "leftCorner": {
              "x": 4.774,
              "y": 4.132,
              "z": 1.48
            },
            "rightCorner": {
              "x": 4.785,
              "y": 4.281,
              "z": 1.48
            },
            "gtin": "4056631001264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fcfc",
            "leftCorner": {
              "x": 4.785,
              "y": 4.281,
              "z": 1.48
            },
            "rightCorner": {
              "x": 4.806,
              "y": 4.562,
              "z": 1.48
            },
            "gtin": "4056631003299",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738a5",
        "height": 1.7691,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fc20",
            "leftCorner": {
              "x": 4.703,
              "y": 3.197,
              "z": 1.775
            },
            "rightCorner": {
              "x": 4.709,
              "y": 3.283,
              "z": 1.775
            },
            "gtin": "4260477051424",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc21",
            "leftCorner": {
              "x": 4.714,
              "y": 3.299,
              "z": 1.769
            },
            "rightCorner": {
              "x": 4.722,
              "y": 3.4,
              "z": 1.769
            },
            "gtin": "4260477051394",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc22",
            "leftCorner": {
              "x": 4.722,
              "y": 3.4,
              "z": 1.769
            },
            "rightCorner": {
              "x": 4.729,
              "y": 3.502,
              "z": 1.769
            },
            "gtin": "4028634000117",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc23",
            "leftCorner": {
              "x": 4.729,
              "y": 3.502,
              "z": 1.769
            },
            "rightCorner": {
              "x": 4.737,
              "y": 3.606,
              "z": 1.769
            },
            "gtin": "4028634000285",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc24",
            "leftCorner": {
              "x": 4.737,
              "y": 3.606,
              "z": 1.769
            },
            "rightCorner": {
              "x": 4.746,
              "y": 3.736,
              "z": 1.769
            },
            "gtin": "4062300417311",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc25",
            "leftCorner": {
              "x": 4.746,
              "y": 3.736,
              "z": 1.769
            },
            "rightCorner": {
              "x": 4.756,
              "y": 3.872,
              "z": 1.769
            },
            "gtin": "7640230492058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc26",
            "leftCorner": {
              "x": 4.756,
              "y": 3.872,
              "z": 1.769
            },
            "rightCorner": {
              "x": 4.765,
              "y": 3.991,
              "z": 1.769
            },
            "gtin": "7640230492010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc27",
            "leftCorner": {
              "x": 4.765,
              "y": 3.991,
              "z": 1.769
            },
            "rightCorner": {
              "x": 4.774,
              "y": 4.117,
              "z": 1.769
            },
            "gtin": "7640161879829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc28",
            "leftCorner": {
              "x": 4.774,
              "y": 4.117,
              "z": 1.769
            },
            "rightCorner": {
              "x": 4.785,
              "y": 4.263,
              "z": 1.769
            },
            "gtin": "7640161879829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc29",
            "leftCorner": {
              "x": 4.785,
              "y": 4.263,
              "z": 1.769
            },
            "rightCorner": {
              "x": 4.795,
              "y": 4.403,
              "z": 1.769
            },
            "gtin": "7640230491143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc2a",
            "leftCorner": {
              "x": 4.795,
              "y": 4.403,
              "z": 1.769
            },
            "rightCorner": {
              "x": 4.813,
              "y": 4.639,
              "z": 1.769
            },
            "gtin": "4260477050465",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757b7b5fe7bc046959a2b",
    "name": "68e757b7b5fe7bc046959a2b",
    "x": 4.7465,
    "y": 4.4815,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.67772,
      "w": 0.73532
    },
    "statistics": {
      "hasStockCount": 42,
      "noStockCount": 0,
      "unknownStockCount": 10,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "696ead8b3b88e258afd738ae",
        "height": 0.2068,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fc6d",
            "leftCorner": {
              "x": 4.781,
              "y": 4.41,
              "z": 0.206
            },
            "rightCorner": {
              "x": 4.792,
              "y": 4.559,
              "z": 0.206
            },
            "gtin": "4066447088120",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc6e",
            "leftCorner": {
              "x": 4.796,
              "y": 4.539,
              "z": 0.207
            },
            "rightCorner": {
              "x": 4.807,
              "y": 4.668,
              "z": 0.207
            },
            "gtin": "4066447088120",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc6f",
            "leftCorner": {
              "x": 4.807,
              "y": 4.668,
              "z": 0.207
            },
            "rightCorner": {
              "x": 4.817,
              "y": 4.793,
              "z": 0.207
            },
            "gtin": "4018852030454",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc70",
            "leftCorner": {
              "x": 4.817,
              "y": 4.793,
              "z": 0.207
            },
            "rightCorner": {
              "x": 4.828,
              "y": 4.929,
              "z": 0.207
            },
            "gtin": "4018852030454",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc71",
            "leftCorner": {
              "x": 4.828,
              "y": 4.929,
              "z": 0.207
            },
            "rightCorner": {
              "x": 4.839,
              "y": 5.067,
              "z": 0.207
            },
            "gtin": "4018852026914",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc72",
            "leftCorner": {
              "x": 4.839,
              "y": 5.067,
              "z": 0.207
            },
            "rightCorner": {
              "x": 4.851,
              "y": 5.211,
              "z": 0.207
            }
          },
          {
            "id": "696ebf6d43c343680a26fc73",
            "leftCorner": {
              "x": 4.851,
              "y": 5.211,
              "z": 0.207
            },
            "rightCorner": {
              "x": 4.861,
              "y": 5.33,
              "z": 0.207
            }
          },
          {
            "id": "696ebf6d43c343680a26fc74",
            "leftCorner": {
              "x": 4.861,
              "y": 5.33,
              "z": 0.207
            },
            "rightCorner": {
              "x": 4.871,
              "y": 5.45,
              "z": 0.207
            },
            "gtin": "4018852030072",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc75",
            "leftCorner": {
              "x": 4.871,
              "y": 5.45,
              "z": 0.207
            },
            "rightCorner": {
              "x": 4.881,
              "y": 5.574,
              "z": 0.207
            },
            "gtin": "4018852030201",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc76",
            "leftCorner": {
              "x": 4.881,
              "y": 5.574,
              "z": 0.207
            },
            "rightCorner": {
              "x": 4.892,
              "y": 5.708,
              "z": 0.207
            },
            "gtin": "4018852030201",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738a9",
        "height": 0.5093,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fcd9",
            "leftCorner": {
              "x": 4.803,
              "y": 4.609,
              "z": 0.509
            },
            "rightCorner": {
              "x": 4.814,
              "y": 4.735,
              "z": 0.509
            },
            "gtin": "4056631001813",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcda",
            "leftCorner": {
              "x": 4.814,
              "y": 4.735,
              "z": 0.509
            },
            "rightCorner": {
              "x": 4.825,
              "y": 4.872,
              "z": 0.509
            },
            "gtin": "4008976033257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fcdb",
            "leftCorner": {
              "x": 4.825,
              "y": 4.872,
              "z": 0.509
            },
            "rightCorner": {
              "x": 4.838,
              "y": 5.036,
              "z": 0.509
            },
            "gtin": "4056631004012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcdc",
            "leftCorner": {
              "x": 4.838,
              "y": 5.036,
              "z": 0.509
            },
            "rightCorner": {
              "x": 4.85,
              "y": 5.18,
              "z": 0.509
            },
            "gtin": "4056631002513",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcdd",
            "leftCorner": {
              "x": 4.85,
              "y": 5.18,
              "z": 0.509
            },
            "rightCorner": {
              "x": 4.862,
              "y": 5.328,
              "z": 0.509
            },
            "gtin": "4008976091271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcde",
            "leftCorner": {
              "x": 4.862,
              "y": 5.328,
              "z": 0.509
            },
            "rightCorner": {
              "x": 4.875,
              "y": 5.487,
              "z": 0.509
            },
            "gtin": "5411188141648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcdf",
            "leftCorner": {
              "x": 4.875,
              "y": 5.487,
              "z": 0.509
            },
            "rightCorner": {
              "x": 4.888,
              "y": 5.641,
              "z": 0.509
            },
            "gtin": "8445291988132",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738ac",
        "height": 0.8452,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fcb2",
            "leftCorner": {
              "x": 4.804,
              "y": 4.604,
              "z": 0.845
            },
            "rightCorner": {
              "x": 4.817,
              "y": 4.769,
              "z": 0.845
            },
            "gtin": "8445291074309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fcb3",
            "leftCorner": {
              "x": 4.817,
              "y": 4.769,
              "z": 0.845
            },
            "rightCorner": {
              "x": 4.828,
              "y": 4.902,
              "z": 0.845
            },
            "gtin": "7613038463353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fcb4",
            "leftCorner": {
              "x": 4.828,
              "y": 4.902,
              "z": 0.845
            },
            "rightCorner": {
              "x": 4.84,
              "y": 5.049,
              "z": 0.845
            },
            "gtin": "7613038463681",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcb5",
            "leftCorner": {
              "x": 4.84,
              "y": 5.049,
              "z": 0.845
            },
            "rightCorner": {
              "x": 4.851,
              "y": 5.187,
              "z": 0.845
            },
            "gtin": "8445290945617",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcb6",
            "leftCorner": {
              "x": 4.851,
              "y": 5.187,
              "z": 0.845
            },
            "rightCorner": {
              "x": 4.861,
              "y": 5.312,
              "z": 0.845
            },
            "gtin": "8445290945617",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcb7",
            "leftCorner": {
              "x": 4.861,
              "y": 5.312,
              "z": 0.845
            },
            "rightCorner": {
              "x": 4.871,
              "y": 5.431,
              "z": 0.845
            },
            "gtin": "4000540002508",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcb8",
            "leftCorner": {
              "x": 4.871,
              "y": 5.431,
              "z": 0.845
            },
            "rightCorner": {
              "x": 4.882,
              "y": 5.561,
              "z": 0.845
            },
            "gtin": "4000540002546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcb9",
            "leftCorner": {
              "x": 4.882,
              "y": 5.561,
              "z": 0.845
            },
            "rightCorner": {
              "x": 4.894,
              "y": 5.708,
              "z": 0.845
            },
            "gtin": "4000540002560",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738ad",
        "height": 1.185,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fc03",
            "leftCorner": {
              "x": 4.787,
              "y": 4.425,
              "z": 1.184
            },
            "rightCorner": {
              "x": 4.798,
              "y": 4.576,
              "z": 1.184
            },
            "gtin": "4062300355422",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc04",
            "leftCorner": {
              "x": 4.804,
              "y": 4.556,
              "z": 1.185
            },
            "rightCorner": {
              "x": 4.815,
              "y": 4.68,
              "z": 1.185
            },
            "gtin": "4062300355422",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc05",
            "leftCorner": {
              "x": 4.815,
              "y": 4.68,
              "z": 1.185
            },
            "rightCorner": {
              "x": 4.825,
              "y": 4.803,
              "z": 1.185
            },
            "gtin": "4062300355439",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc06",
            "leftCorner": {
              "x": 4.825,
              "y": 4.803,
              "z": 1.185
            },
            "rightCorner": {
              "x": 4.837,
              "y": 4.949,
              "z": 1.185
            },
            "gtin": "4062300355439",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc07",
            "leftCorner": {
              "x": 4.837,
              "y": 4.949,
              "z": 1.185
            },
            "rightCorner": {
              "x": 4.849,
              "y": 5.098,
              "z": 1.185
            },
            "gtin": "4062300355446",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc08",
            "leftCorner": {
              "x": 4.849,
              "y": 5.098,
              "z": 1.185
            },
            "rightCorner": {
              "x": 4.859,
              "y": 5.22,
              "z": 1.185
            },
            "gtin": "4062300343108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc09",
            "leftCorner": {
              "x": 4.859,
              "y": 5.22,
              "z": 1.185
            },
            "rightCorner": {
              "x": 4.867,
              "y": 5.328,
              "z": 1.185
            },
            "gtin": "4062300343061",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc0a",
            "leftCorner": {
              "x": 4.867,
              "y": 5.328,
              "z": 1.185
            },
            "rightCorner": {
              "x": 4.877,
              "y": 5.448,
              "z": 1.185
            },
            "gtin": "4062300344877",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc0b",
            "leftCorner": {
              "x": 4.877,
              "y": 5.448,
              "z": 1.185
            },
            "rightCorner": {
              "x": 4.888,
              "y": 5.584,
              "z": 1.185
            },
            "gtin": "4062300471504",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc0c",
            "leftCorner": {
              "x": 4.888,
              "y": 5.584,
              "z": 1.185
            },
            "rightCorner": {
              "x": 4.899,
              "y": 5.711,
              "z": 1.185
            },
            "gtin": "4062300471504",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738ab",
        "height": 1.4817,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fcfd",
            "leftCorner": {
              "x": 4.806,
              "y": 4.542,
              "z": 1.482
            },
            "rightCorner": {
              "x": 4.815,
              "y": 4.664,
              "z": 1.482
            },
            "gtin": "4056631003312",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcfe",
            "leftCorner": {
              "x": 4.815,
              "y": 4.664,
              "z": 1.482
            },
            "rightCorner": {
              "x": 4.825,
              "y": 4.783,
              "z": 1.482
            },
            "gtin": "4056631002247",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcff",
            "leftCorner": {
              "x": 4.825,
              "y": 4.783,
              "z": 1.482
            },
            "rightCorner": {
              "x": 4.839,
              "y": 4.958,
              "z": 1.482
            },
            "gtin": "4056631004098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd00",
            "leftCorner": {
              "x": 4.839,
              "y": 4.958,
              "z": 1.482
            },
            "rightCorner": {
              "x": 4.846,
              "y": 5.043,
              "z": 1.482
            },
            "gtin": "9001375008951",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd01",
            "leftCorner": {
              "x": 4.846,
              "y": 5.043,
              "z": 1.482
            },
            "rightCorner": {
              "x": 4.854,
              "y": 5.141,
              "z": 1.482
            },
            "gtin": "4066447872712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd02",
            "leftCorner": {
              "x": 4.854,
              "y": 5.141,
              "z": 1.482
            },
            "rightCorner": {
              "x": 4.864,
              "y": 5.263,
              "z": 1.482
            },
            "gtin": "4066447616002",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd03",
            "leftCorner": {
              "x": 4.864,
              "y": 5.263,
              "z": 1.482
            },
            "rightCorner": {
              "x": 4.873,
              "y": 5.368,
              "z": 1.482
            },
            "gtin": "4058172445545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd04",
            "leftCorner": {
              "x": 4.873,
              "y": 5.368,
              "z": 1.482
            },
            "rightCorner": {
              "x": 4.884,
              "y": 5.498,
              "z": 1.482
            },
            "gtin": "4058172860553",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd05",
            "leftCorner": {
              "x": 4.884,
              "y": 5.498,
              "z": 1.482
            },
            "rightCorner": {
              "x": 4.894,
              "y": 5.632,
              "z": 1.482
            },
            "gtin": "4066447532647",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd06",
            "leftCorner": {
              "x": 4.894,
              "y": 5.632,
              "z": 1.482
            },
            "rightCorner": {
              "x": 4.91,
              "y": 5.818,
              "z": 1.482
            },
            "gtin": "4066447532647",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738aa",
        "height": 1.7711,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fc2b",
            "leftCorner": {
              "x": 4.811,
              "y": 4.619,
              "z": 1.771
            },
            "rightCorner": {
              "x": 4.82,
              "y": 4.735,
              "z": 1.771
            },
            "gtin": "4260477050472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc2c",
            "leftCorner": {
              "x": 4.82,
              "y": 4.735,
              "z": 1.771
            },
            "rightCorner": {
              "x": 4.83,
              "y": 4.857,
              "z": 1.771
            },
            "gtin": "4260477050847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc2d",
            "leftCorner": {
              "x": 4.83,
              "y": 4.857,
              "z": 1.771
            },
            "rightCorner": {
              "x": 4.844,
              "y": 5.025,
              "z": 1.771
            },
            "gtin": "4067796171945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc2e",
            "leftCorner": {
              "x": 4.844,
              "y": 5.025,
              "z": 1.771
            },
            "rightCorner": {
              "x": 4.853,
              "y": 5.14,
              "z": 1.771
            },
            "gtin": "4008976120087",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc2f",
            "leftCorner": {
              "x": 4.853,
              "y": 5.14,
              "z": 1.771
            },
            "rightCorner": {
              "x": 4.864,
              "y": 5.268,
              "z": 1.771
            },
            "gtin": "7640230493314",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc30",
            "leftCorner": {
              "x": 4.864,
              "y": 5.268,
              "z": 1.771
            },
            "rightCorner": {
              "x": 4.873,
              "y": 5.379,
              "z": 1.771
            },
            "gtin": "7640230493338",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc31",
            "leftCorner": {
              "x": 4.873,
              "y": 5.379,
              "z": 1.771
            },
            "rightCorner": {
              "x": 4.887,
              "y": 5.547,
              "z": 1.771
            },
            "gtin": "4062300454101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc32",
            "leftCorner": {
              "x": 4.887,
              "y": 5.547,
              "z": 1.771
            },
            "rightCorner": {
              "x": 4.898,
              "y": 5.684,
              "z": 1.771
            },
            "gtin": "9120111882355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc33",
            "leftCorner": {
              "x": 4.898,
              "y": 5.684,
              "z": 1.771
            },
            "rightCorner": {
              "x": 4.906,
              "y": 5.786,
              "z": 1.771
            },
            "gtin": "9120111881662",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757b7b5fe7bc046959a2c",
    "name": "68e757b7b5fe7bc046959a2c",
    "x": 4.8484,
    "y": 5.7374,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68214,
      "w": 0.73122
    },
    "statistics": {
      "hasStockCount": 37,
      "noStockCount": 2,
      "unknownStockCount": 13,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "696ead8b3b88e258afd738b4",
        "height": 0.20899,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fc77",
            "leftCorner": {
              "x": 4.892,
              "y": 5.708,
              "z": 0.207
            },
            "rightCorner": {
              "x": 4.902,
              "y": 5.839,
              "z": 0.207
            },
            "gtin": "4018852029526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc78",
            "leftCorner": {
              "x": 4.902,
              "y": 5.85,
              "z": 0.209
            },
            "rightCorner": {
              "x": 4.911,
              "y": 5.984,
              "z": 0.209
            },
            "gtin": "4018852029526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc79",
            "leftCorner": {
              "x": 4.911,
              "y": 5.984,
              "z": 0.209
            },
            "rightCorner": {
              "x": 4.92,
              "y": 6.119,
              "z": 0.209
            },
            "gtin": "4018852030348",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc7a",
            "leftCorner": {
              "x": 4.92,
              "y": 6.119,
              "z": 0.209
            },
            "rightCorner": {
              "x": 4.93,
              "y": 6.259,
              "z": 0.209
            },
            "gtin": "4018852030348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc7b",
            "leftCorner": {
              "x": 4.93,
              "y": 6.259,
              "z": 0.209
            },
            "rightCorner": {
              "x": 4.941,
              "y": 6.41,
              "z": 0.209
            },
            "gtin": "4251099845157",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc7c",
            "leftCorner": {
              "x": 4.941,
              "y": 6.41,
              "z": 0.209
            },
            "rightCorner": {
              "x": 4.95,
              "y": 6.544,
              "z": 0.209
            },
            "gtin": "4251099845126",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc7d",
            "leftCorner": {
              "x": 4.95,
              "y": 6.544,
              "z": 0.209
            },
            "rightCorner": {
              "x": 4.958,
              "y": 6.655,
              "z": 0.209
            },
            "gtin": "4000381006840",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc7e",
            "leftCorner": {
              "x": 4.958,
              "y": 6.655,
              "z": 0.209
            },
            "rightCorner": {
              "x": 4.96,
              "y": 6.685,
              "z": 0.209
            }
          },
          {
            "id": "696ebf6d43c343680a26fc7f",
            "leftCorner": {
              "x": 4.96,
              "y": 6.685,
              "z": 0.209
            },
            "rightCorner": {
              "x": 4.968,
              "y": 6.811,
              "z": 0.209
            },
            "gtin": "8445291946187",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc80",
            "leftCorner": {
              "x": 4.968,
              "y": 6.811,
              "z": 0.209
            },
            "rightCorner": {
              "x": 4.977,
              "y": 6.933,
              "z": 0.209
            },
            "gtin": "7616100756865",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738af",
        "height": 0.5128,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fce0",
            "leftCorner": {
              "x": 4.888,
              "y": 5.641,
              "z": 0.509
            },
            "rightCorner": {
              "x": 4.9,
              "y": 5.787,
              "z": 0.509
            },
            "gtin": "8445291987784",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fce1",
            "leftCorner": {
              "x": 4.898,
              "y": 5.798,
              "z": 0.513
            },
            "rightCorner": {
              "x": 4.91,
              "y": 5.965,
              "z": 0.513
            },
            "gtin": "4056631002674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fce2",
            "leftCorner": {
              "x": 4.91,
              "y": 5.965,
              "z": 0.513
            },
            "rightCorner": {
              "x": 4.918,
              "y": 6.079,
              "z": 0.513
            },
            "gtin": "4056631002711",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fce3",
            "leftCorner": {
              "x": 4.918,
              "y": 6.079,
              "z": 0.513
            },
            "rightCorner": {
              "x": 4.929,
              "y": 6.243,
              "z": 0.513
            },
            "gtin": "4056631002834",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fce4",
            "leftCorner": {
              "x": 4.929,
              "y": 6.243,
              "z": 0.513
            },
            "rightCorner": {
              "x": 4.941,
              "y": 6.41,
              "z": 0.513
            },
            "gtin": "4056631002797",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fce5",
            "leftCorner": {
              "x": 4.941,
              "y": 6.41,
              "z": 0.513
            },
            "rightCorner": {
              "x": 4.952,
              "y": 6.563,
              "z": 0.513
            },
            "gtin": "4056631002735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fce6",
            "leftCorner": {
              "x": 4.952,
              "y": 6.563,
              "z": 0.513
            },
            "rightCorner": {
              "x": 4.959,
              "y": 6.671,
              "z": 0.513
            },
            "gtin": "4056631002957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fce7",
            "leftCorner": {
              "x": 4.959,
              "y": 6.671,
              "z": 0.513
            },
            "rightCorner": {
              "x": 4.961,
              "y": 6.7,
              "z": 0.513
            }
          },
          {
            "id": "696ebf6d43c343680a26fce8",
            "leftCorner": {
              "x": 4.961,
              "y": 6.7,
              "z": 0.513
            },
            "rightCorner": {
              "x": 4.972,
              "y": 6.862,
              "z": 0.513
            },
            "gtin": "7640230492409",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcc6",
            "leftCorner": {
              "x": 4.972,
              "y": 6.862,
              "z": 0.513
            },
            "rightCorner": {
              "x": 4.981,
              "y": 6.981,
              "z": 0.513
            },
            "gtin": "7640230493277",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738b3",
        "height": 0.84913,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fcba",
            "leftCorner": {
              "x": 4.894,
              "y": 5.708,
              "z": 0.845
            },
            "rightCorner": {
              "x": 4.904,
              "y": 5.836,
              "z": 0.845
            },
            "gtin": "4067796203066",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcbb",
            "leftCorner": {
              "x": 4.906,
              "y": 5.847,
              "z": 0.849
            },
            "rightCorner": {
              "x": 4.915,
              "y": 5.986,
              "z": 0.849
            },
            "gtin": "4066447355215",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcbc",
            "leftCorner": {
              "x": 4.915,
              "y": 5.986,
              "z": 0.849
            },
            "rightCorner": {
              "x": 4.924,
              "y": 6.107,
              "z": 0.849
            },
            "gtin": "4066447355192",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcbd",
            "leftCorner": {
              "x": 4.924,
              "y": 6.107,
              "z": 0.849
            },
            "rightCorner": {
              "x": 4.933,
              "y": 6.234,
              "z": 0.849
            },
            "gtin": "4067796035414",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcbe",
            "leftCorner": {
              "x": 4.933,
              "y": 6.234,
              "z": 0.849
            },
            "rightCorner": {
              "x": 4.943,
              "y": 6.378,
              "z": 0.849
            },
            "gtin": "4066447289107",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcbf",
            "leftCorner": {
              "x": 4.943,
              "y": 6.378,
              "z": 0.849
            },
            "rightCorner": {
              "x": 4.952,
              "y": 6.508,
              "z": 0.849
            },
            "gtin": "4066447111439",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcc0",
            "leftCorner": {
              "x": 4.952,
              "y": 6.508,
              "z": 0.849
            },
            "rightCorner": {
              "x": 4.961,
              "y": 6.642,
              "z": 0.849
            },
            "gtin": "4067796202502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcc1",
            "leftCorner": {
              "x": 4.961,
              "y": 6.642,
              "z": 0.849
            },
            "rightCorner": {
              "x": 4.963,
              "y": 6.668,
              "z": 0.849
            }
          },
          {
            "id": "696ebf6d43c343680a26fcc2",
            "leftCorner": {
              "x": 4.963,
              "y": 6.668,
              "z": 0.849
            },
            "rightCorner": {
              "x": 4.97,
              "y": 6.772,
              "z": 0.849
            },
            "gtin": "4066447064070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fcc3",
            "leftCorner": {
              "x": 4.97,
              "y": 6.772,
              "z": 0.849
            },
            "rightCorner": {
              "x": 4.974,
              "y": 6.83,
              "z": 0.849
            }
          },
          {
            "id": "696ebf6d43c343680a26fcc4",
            "leftCorner": {
              "x": 4.974,
              "y": 6.83,
              "z": 0.849
            },
            "rightCorner": {
              "x": 4.98,
              "y": 6.908,
              "z": 0.849
            },
            "gtin": "4067796180916",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc9f",
            "leftCorner": {
              "x": 4.98,
              "y": 6.908,
              "z": 0.849
            },
            "rightCorner": {
              "x": 4.985,
              "y": 6.981,
              "z": 0.849
            },
            "gtin": "4067796181081",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738b1",
        "height": 1.1886,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fc0d",
            "leftCorner": {
              "x": 4.899,
              "y": 5.711,
              "z": 1.185
            },
            "rightCorner": {
              "x": 4.91,
              "y": 5.843,
              "z": 1.185
            },
            "gtin": "4062300471658",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc0e",
            "leftCorner": {
              "x": 4.907,
              "y": 5.854,
              "z": 1.189
            },
            "rightCorner": {
              "x": 4.917,
              "y": 5.987,
              "z": 1.189
            },
            "gtin": "4062300471689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc0f",
            "leftCorner": {
              "x": 4.917,
              "y": 5.987,
              "z": 1.189
            },
            "rightCorner": {
              "x": 4.925,
              "y": 6.111,
              "z": 1.189
            },
            "gtin": "4062300471627",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc10",
            "leftCorner": {
              "x": 4.925,
              "y": 6.111,
              "z": 1.189
            },
            "rightCorner": {
              "x": 4.934,
              "y": 6.237,
              "z": 1.189
            },
            "gtin": "4062300378391",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc11",
            "leftCorner": {
              "x": 4.934,
              "y": 6.237,
              "z": 1.189
            },
            "rightCorner": {
              "x": 4.944,
              "y": 6.388,
              "z": 1.189
            },
            "gtin": "4062300256385",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc12",
            "leftCorner": {
              "x": 4.944,
              "y": 6.388,
              "z": 1.189
            },
            "rightCorner": {
              "x": 4.953,
              "y": 6.517,
              "z": 1.189
            },
            "gtin": "4062300294523",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc13",
            "leftCorner": {
              "x": 4.953,
              "y": 6.517,
              "z": 1.189
            },
            "rightCorner": {
              "x": 4.963,
              "y": 6.649,
              "z": 1.189
            },
            "gtin": "4062300433939",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc14",
            "leftCorner": {
              "x": 4.963,
              "y": 6.649,
              "z": 1.189
            },
            "rightCorner": {
              "x": 4.965,
              "y": 6.683,
              "z": 1.189
            }
          },
          {
            "id": "696ebf6d43c343680a26fc15",
            "leftCorner": {
              "x": 4.965,
              "y": 6.683,
              "z": 1.189
            },
            "rightCorner": {
              "x": 4.977,
              "y": 6.853,
              "z": 1.189
            },
            "gtin": "4067796203042",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fbf0",
            "leftCorner": {
              "x": 4.977,
              "y": 6.853,
              "z": 1.189
            },
            "rightCorner": {
              "x": 4.986,
              "y": 6.981,
              "z": 1.189
            }
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738b0",
        "height": 1.4849,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fd07",
            "leftCorner": {
              "x": 4.906,
              "y": 5.829,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.915,
              "y": 5.965,
              "z": 1.485
            },
            "gtin": "4066447228151",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd08",
            "leftCorner": {
              "x": 4.915,
              "y": 5.965,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.924,
              "y": 6.093,
              "z": 1.485
            },
            "gtin": "4066447398649",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd09",
            "leftCorner": {
              "x": 4.924,
              "y": 6.093,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.934,
              "y": 6.231,
              "z": 1.485
            },
            "gtin": "4066447561081",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd0a",
            "leftCorner": {
              "x": 4.934,
              "y": 6.231,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.943,
              "y": 6.37,
              "z": 1.485
            },
            "gtin": "4066447867602",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd0b",
            "leftCorner": {
              "x": 4.943,
              "y": 6.37,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.953,
              "y": 6.507,
              "z": 1.485
            },
            "gtin": "4066447400410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd0c",
            "leftCorner": {
              "x": 4.953,
              "y": 6.507,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.962,
              "y": 6.638,
              "z": 1.485
            },
            "gtin": "4066447363418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd0d",
            "leftCorner": {
              "x": 4.962,
              "y": 6.638,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.964,
              "y": 6.668,
              "z": 1.485
            }
          },
          {
            "id": "696ebf6d43c343680a26fd0e",
            "leftCorner": {
              "x": 4.964,
              "y": 6.668,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.975,
              "y": 6.823,
              "z": 1.485
            },
            "gtin": "4066447477382",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fcea",
            "leftCorner": {
              "x": 4.975,
              "y": 6.823,
              "z": 1.485
            },
            "rightCorner": {
              "x": 4.986,
              "y": 6.981,
              "z": 1.485
            },
            "gtin": "4260618520161",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738b2",
        "height": 1.7742,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fc34",
            "leftCorner": {
              "x": 4.904,
              "y": 5.797,
              "z": 1.774
            },
            "rightCorner": {
              "x": 4.913,
              "y": 5.93,
              "z": 1.774
            },
            "gtin": "9120111882379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc35",
            "leftCorner": {
              "x": 4.913,
              "y": 5.93,
              "z": 1.774
            },
            "rightCorner": {
              "x": 4.923,
              "y": 6.074,
              "z": 1.774
            },
            "gtin": "4262367680387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc36",
            "leftCorner": {
              "x": 4.923,
              "y": 6.074,
              "z": 1.774
            },
            "rightCorner": {
              "x": 4.933,
              "y": 6.216,
              "z": 1.774
            },
            "gtin": "4262367683081",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc37",
            "leftCorner": {
              "x": 4.933,
              "y": 6.216,
              "z": 1.774
            },
            "rightCorner": {
              "x": 4.944,
              "y": 6.364,
              "z": 1.774
            },
            "gtin": "4262367680776",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc38",
            "leftCorner": {
              "x": 4.944,
              "y": 6.364,
              "z": 1.774
            },
            "rightCorner": {
              "x": 4.954,
              "y": 6.515,
              "z": 1.774
            },
            "gtin": "4260133235632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc39",
            "leftCorner": {
              "x": 4.954,
              "y": 6.515,
              "z": 1.774
            },
            "rightCorner": {
              "x": 4.966,
              "y": 6.687,
              "z": 1.774
            },
            "gtin": "4260133231184",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc3a",
            "leftCorner": {
              "x": 4.966,
              "y": 6.687,
              "z": 1.774
            },
            "rightCorner": {
              "x": 4.969,
              "y": 6.727,
              "z": 1.774
            }
          },
          {
            "id": "696ebf6d43c343680a26fc3b",
            "leftCorner": {
              "x": 4.969,
              "y": 6.727,
              "z": 1.774
            },
            "rightCorner": {
              "x": 4.984,
              "y": 6.946,
              "z": 1.774
            },
            "gtin": "4260133234727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc3c",
            "leftCorner": {
              "x": 4.984,
              "y": 6.946,
              "z": 1.774
            },
            "rightCorner": {
              "x": 4.993,
              "y": 7.069,
              "z": 1.774
            },
            "gtin": "4260133234840",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757b7b5fe7bc046959a2d",
    "name": "68e757b7b5fe7bc046959a2d",
    "x": 4.9392,
    "y": 7.0072,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68738,
      "w": 0.7263
    },
    "statistics": {
      "hasStockCount": 60,
      "noStockCount": 1,
      "unknownStockCount": 18,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "696ead8b3b88e258afd738bc",
        "height": 0.20692,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fc81",
            "leftCorner": {
              "x": 4.977,
              "y": 6.933,
              "z": 0.209
            },
            "rightCorner": {
              "x": 4.985,
              "y": 7.051,
              "z": 0.209
            },
            "gtin": "4067796171433",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc82",
            "leftCorner": {
              "x": 4.988,
              "y": 7.075,
              "z": 0.207
            },
            "rightCorner": {
              "x": 4.995,
              "y": 7.201,
              "z": 0.207
            },
            "gtin": "4067796171457",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc83",
            "leftCorner": {
              "x": 4.995,
              "y": 7.201,
              "z": 0.207
            },
            "rightCorner": {
              "x": 5.002,
              "y": 7.335,
              "z": 0.207
            },
            "gtin": "4067796170238",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc84",
            "leftCorner": {
              "x": 5.002,
              "y": 7.335,
              "z": 0.207
            },
            "rightCorner": {
              "x": 5.009,
              "y": 7.457,
              "z": 0.207
            },
            "gtin": "4067796171600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc85",
            "leftCorner": {
              "x": 5.009,
              "y": 7.457,
              "z": 0.207
            },
            "rightCorner": {
              "x": 5.016,
              "y": 7.59,
              "z": 0.207
            },
            "gtin": "4067796171525",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc86",
            "leftCorner": {
              "x": 5.016,
              "y": 7.59,
              "z": 0.207
            },
            "rightCorner": {
              "x": 5.023,
              "y": 7.71,
              "z": 0.207
            },
            "gtin": "4067796171563",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc87",
            "leftCorner": {
              "x": 5.023,
              "y": 7.71,
              "z": 0.207
            },
            "rightCorner": {
              "x": 5.03,
              "y": 7.843,
              "z": 0.207
            },
            "gtin": "4067796171549",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc88",
            "leftCorner": {
              "x": 5.03,
              "y": 7.843,
              "z": 0.207
            },
            "rightCorner": {
              "x": 5.038,
              "y": 7.978,
              "z": 0.207
            },
            "gtin": "4067796171587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc89",
            "leftCorner": {
              "x": 5.038,
              "y": 7.978,
              "z": 0.207
            },
            "rightCorner": {
              "x": 5.045,
              "y": 8.106,
              "z": 0.207
            },
            "gtin": "4067796170290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc8a",
            "leftCorner": {
              "x": 5.045,
              "y": 8.106,
              "z": 0.207
            },
            "rightCorner": {
              "x": 5.052,
              "y": 8.228,
              "z": 0.207
            },
            "gtin": "4058172623714",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738bb",
        "height": 0.46909,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fda2",
            "leftCorner": {
              "x": 4.982,
              "y": 7.005,
              "z": 0.469
            },
            "rightCorner": {
              "x": 4.989,
              "y": 7.129,
              "z": 0.469
            },
            "gtin": "4067796081381",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fda4",
            "leftCorner": {
              "x": 4.989,
              "y": 7.129,
              "z": 0.469
            },
            "rightCorner": {
              "x": 4.992,
              "y": 7.195,
              "z": 0.469
            },
            "gtin": "4058172795435",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fda5",
            "leftCorner": {
              "x": 4.992,
              "y": 7.195,
              "z": 0.469
            },
            "rightCorner": {
              "x": 4.996,
              "y": 7.26,
              "z": 0.469
            },
            "gtin": "4067796214741",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fda6",
            "leftCorner": {
              "x": 4.996,
              "y": 7.26,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.003,
              "y": 7.393,
              "z": 0.469
            },
            "gtin": "4058172438479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fda7",
            "leftCorner": {
              "x": 5.003,
              "y": 7.393,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.01,
              "y": 7.519,
              "z": 0.469
            },
            "gtin": "4018852028949",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fda8",
            "leftCorner": {
              "x": 5.01,
              "y": 7.519,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.017,
              "y": 7.645,
              "z": 0.469
            },
            "gtin": "4018852029229",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fda9",
            "leftCorner": {
              "x": 5.017,
              "y": 7.645,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.024,
              "y": 7.772,
              "z": 0.469
            },
            "gtin": "4018852033295",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdaa",
            "leftCorner": {
              "x": 5.024,
              "y": 7.772,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.032,
              "y": 7.912,
              "z": 0.469
            },
            "gtin": "4018852035671",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdab",
            "leftCorner": {
              "x": 5.032,
              "y": 7.912,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.039,
              "y": 8.047,
              "z": 0.469
            },
            "gtin": "4018852035404",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdac",
            "leftCorner": {
              "x": 5.039,
              "y": 8.047,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.046,
              "y": 8.174,
              "z": 0.469
            },
            "gtin": "4018852029984",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdad",
            "leftCorner": {
              "x": 5.046,
              "y": 8.174,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.053,
              "y": 8.303,
              "z": 0.469
            },
            "gtin": "4018852030003",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738b7",
        "height": 0.67701,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fd2c",
            "leftCorner": {
              "x": 4.982,
              "y": 7.005,
              "z": 0.677
            },
            "rightCorner": {
              "x": 4.989,
              "y": 7.127,
              "z": 0.677
            },
            "gtin": "4058172437915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd2e",
            "leftCorner": {
              "x": 4.989,
              "y": 7.127,
              "z": 0.677
            },
            "rightCorner": {
              "x": 4.997,
              "y": 7.26,
              "z": 0.677
            },
            "gtin": "4067796017090",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd2f",
            "leftCorner": {
              "x": 4.997,
              "y": 7.26,
              "z": 0.677
            },
            "rightCorner": {
              "x": 5.003,
              "y": 7.38,
              "z": 0.677
            },
            "gtin": "4067796010275",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd30",
            "leftCorner": {
              "x": 5.003,
              "y": 7.38,
              "z": 0.677
            },
            "rightCorner": {
              "x": 5.01,
              "y": 7.502,
              "z": 0.677
            },
            "gtin": "4066447208320",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd31",
            "leftCorner": {
              "x": 5.01,
              "y": 7.502,
              "z": 0.677
            },
            "rightCorner": {
              "x": 5.017,
              "y": 7.623,
              "z": 0.677
            },
            "gtin": "4066447411607",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd32",
            "leftCorner": {
              "x": 5.017,
              "y": 7.623,
              "z": 0.677
            },
            "rightCorner": {
              "x": 5.023,
              "y": 7.748,
              "z": 0.677
            },
            "gtin": "4066447093247",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd33",
            "leftCorner": {
              "x": 5.023,
              "y": 7.748,
              "z": 0.677
            },
            "rightCorner": {
              "x": 5.031,
              "y": 7.878,
              "z": 0.677
            },
            "gtin": "4066447626629",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd34",
            "leftCorner": {
              "x": 5.031,
              "y": 7.878,
              "z": 0.677
            },
            "rightCorner": {
              "x": 5.038,
              "y": 8.011,
              "z": 0.677
            },
            "gtin": "4067796011432",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd35",
            "leftCorner": {
              "x": 5.038,
              "y": 8.011,
              "z": 0.677
            },
            "rightCorner": {
              "x": 5.045,
              "y": 8.137,
              "z": 0.677
            },
            "gtin": "4067796010374",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd36",
            "leftCorner": {
              "x": 5.045,
              "y": 8.137,
              "z": 0.677
            },
            "rightCorner": {
              "x": 5.052,
              "y": 8.268,
              "z": 0.677
            }
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738ba",
        "height": 0.88671,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fd85",
            "leftCorner": {
              "x": 4.988,
              "y": 7.004,
              "z": 0.887
            },
            "rightCorner": {
              "x": 4.995,
              "y": 7.129,
              "z": 0.887
            },
            "gtin": "4058172438196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd87",
            "leftCorner": {
              "x": 4.995,
              "y": 7.129,
              "z": 0.887
            },
            "rightCorner": {
              "x": 5.002,
              "y": 7.263,
              "z": 0.887
            },
            "gtin": "4058172438110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd88",
            "leftCorner": {
              "x": 5.002,
              "y": 7.263,
              "z": 0.887
            },
            "rightCorner": {
              "x": 5.009,
              "y": 7.383,
              "z": 0.887
            },
            "gtin": "4058172438097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd89",
            "leftCorner": {
              "x": 5.009,
              "y": 7.383,
              "z": 0.887
            },
            "rightCorner": {
              "x": 5.015,
              "y": 7.506,
              "z": 0.887
            },
            "gtin": "4058172438158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd8a",
            "leftCorner": {
              "x": 5.015,
              "y": 7.506,
              "z": 0.887
            },
            "rightCorner": {
              "x": 5.022,
              "y": 7.628,
              "z": 0.887
            },
            "gtin": "4058172438134",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd8b",
            "leftCorner": {
              "x": 5.022,
              "y": 7.628,
              "z": 0.887
            },
            "rightCorner": {
              "x": 5.029,
              "y": 7.747,
              "z": 0.887
            },
            "gtin": "4058172438073",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd8c",
            "leftCorner": {
              "x": 5.029,
              "y": 7.747,
              "z": 0.887
            },
            "rightCorner": {
              "x": 5.036,
              "y": 7.876,
              "z": 0.887
            },
            "gtin": "4058172438172",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd8d",
            "leftCorner": {
              "x": 5.036,
              "y": 7.876,
              "z": 0.887
            },
            "rightCorner": {
              "x": 5.043,
              "y": 8.015,
              "z": 0.887
            },
            "gtin": "4058172438035",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd8e",
            "leftCorner": {
              "x": 5.043,
              "y": 8.015,
              "z": 0.887
            },
            "rightCorner": {
              "x": 5.05,
              "y": 8.134,
              "z": 0.887
            },
            "gtin": "4067796136432",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd8f",
            "leftCorner": {
              "x": 5.05,
              "y": 8.134,
              "z": 0.887
            },
            "rightCorner": {
              "x": 5.058,
              "y": 8.271,
              "z": 0.887
            },
            "gtin": "4067796214765",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738b9",
        "height": 1.1009,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fd67",
            "leftCorner": {
              "x": 4.984,
              "y": 7.005,
              "z": 1.101
            },
            "rightCorner": {
              "x": 4.992,
              "y": 7.145,
              "z": 1.101
            },
            "gtin": "4062300015920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd69",
            "leftCorner": {
              "x": 4.992,
              "y": 7.145,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.0,
              "y": 7.282,
              "z": 1.101
            },
            "gtin": "4062300025318",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd6a",
            "leftCorner": {
              "x": 5.0,
              "y": 7.282,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.006,
              "y": 7.402,
              "z": 1.101
            },
            "gtin": "4062300266230",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd6b",
            "leftCorner": {
              "x": 5.006,
              "y": 7.402,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.013,
              "y": 7.531,
              "z": 1.101
            },
            "gtin": "4062300261532",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd6c",
            "leftCorner": {
              "x": 5.013,
              "y": 7.531,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.02,
              "y": 7.655,
              "z": 1.101
            },
            "gtin": "4062300266247",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd6d",
            "leftCorner": {
              "x": 5.02,
              "y": 7.655,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.027,
              "y": 7.776,
              "z": 1.101
            },
            "gtin": "4058172438059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd6e",
            "leftCorner": {
              "x": 5.027,
              "y": 7.776,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.035,
              "y": 7.916,
              "z": 1.101
            },
            "gtin": "4058172438011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd6f",
            "leftCorner": {
              "x": 5.035,
              "y": 7.916,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.042,
              "y": 8.047,
              "z": 1.101
            },
            "gtin": "4062300257689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd70",
            "leftCorner": {
              "x": 5.042,
              "y": 8.047,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.049,
              "y": 8.175,
              "z": 1.101
            },
            "gtin": "4062300257689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd71",
            "leftCorner": {
              "x": 5.049,
              "y": 8.175,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.056,
              "y": 8.302,
              "z": 1.101
            },
            "gtin": "4062300463141",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738b6",
        "height": 1.3125,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fd0f",
            "leftCorner": {
              "x": 4.987,
              "y": 7.005,
              "z": 1.313
            },
            "rightCorner": {
              "x": 4.993,
              "y": 7.125,
              "z": 1.313
            },
            "gtin": "4062300021112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd11",
            "leftCorner": {
              "x": 4.993,
              "y": 7.125,
              "z": 1.313
            },
            "rightCorner": {
              "x": 5.001,
              "y": 7.27,
              "z": 1.313
            },
            "gtin": "4062300055483",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd12",
            "leftCorner": {
              "x": 5.001,
              "y": 7.27,
              "z": 1.313
            },
            "rightCorner": {
              "x": 5.008,
              "y": 7.401,
              "z": 1.313
            },
            "gtin": "4062300129443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd13",
            "leftCorner": {
              "x": 5.008,
              "y": 7.401,
              "z": 1.313
            },
            "rightCorner": {
              "x": 5.015,
              "y": 7.525,
              "z": 1.313
            },
            "gtin": "4062300350403",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd14",
            "leftCorner": {
              "x": 5.015,
              "y": 7.525,
              "z": 1.313
            },
            "rightCorner": {
              "x": 5.022,
              "y": 7.651,
              "z": 1.313
            },
            "gtin": "4062300020313",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd15",
            "leftCorner": {
              "x": 5.022,
              "y": 7.651,
              "z": 1.313
            },
            "rightCorner": {
              "x": 5.029,
              "y": 7.78,
              "z": 1.313
            },
            "gtin": "4062300379060",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd16",
            "leftCorner": {
              "x": 5.029,
              "y": 7.78,
              "z": 1.313
            },
            "rightCorner": {
              "x": 5.036,
              "y": 7.906,
              "z": 1.313
            },
            "gtin": "4062300208193",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd17",
            "leftCorner": {
              "x": 5.036,
              "y": 7.906,
              "z": 1.313
            },
            "rightCorner": {
              "x": 5.043,
              "y": 8.033,
              "z": 1.313
            },
            "gtin": "4062300266353",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd18",
            "leftCorner": {
              "x": 5.043,
              "y": 8.033,
              "z": 1.313
            },
            "rightCorner": {
              "x": 5.05,
              "y": 8.149,
              "z": 1.313
            },
            "gtin": "4062300336582",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd19",
            "leftCorner": {
              "x": 5.05,
              "y": 8.149,
              "z": 1.313
            },
            "rightCorner": {
              "x": 5.056,
              "y": 8.27,
              "z": 1.313
            },
            "gtin": "4062300266346",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738b8",
        "height": 1.524,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fd48",
            "leftCorner": {
              "x": 4.99,
              "y": 7.004,
              "z": 1.524
            },
            "rightCorner": {
              "x": 4.997,
              "y": 7.13,
              "z": 1.524
            },
            "gtin": "4062300290136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd4a",
            "leftCorner": {
              "x": 4.997,
              "y": 7.13,
              "z": 1.524
            },
            "rightCorner": {
              "x": 5.005,
              "y": 7.265,
              "z": 1.524
            },
            "gtin": "4062300297104",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd4b",
            "leftCorner": {
              "x": 5.005,
              "y": 7.265,
              "z": 1.524
            },
            "rightCorner": {
              "x": 5.012,
              "y": 7.39,
              "z": 1.524
            },
            "gtin": "4062300441484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd4c",
            "leftCorner": {
              "x": 5.012,
              "y": 7.39,
              "z": 1.524
            },
            "rightCorner": {
              "x": 5.019,
              "y": 7.517,
              "z": 1.524
            },
            "gtin": "4062300441576",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd4d",
            "leftCorner": {
              "x": 5.019,
              "y": 7.517,
              "z": 1.524
            },
            "rightCorner": {
              "x": 5.025,
              "y": 7.64,
              "z": 1.524
            },
            "gtin": "4062300455153",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd4e",
            "leftCorner": {
              "x": 5.025,
              "y": 7.64,
              "z": 1.524
            },
            "rightCorner": {
              "x": 5.032,
              "y": 7.765,
              "z": 1.524
            },
            "gtin": "4062300441170",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd4f",
            "leftCorner": {
              "x": 5.032,
              "y": 7.765,
              "z": 1.524
            },
            "rightCorner": {
              "x": 5.04,
              "y": 7.899,
              "z": 1.524
            },
            "gtin": "4062300123175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd50",
            "leftCorner": {
              "x": 5.04,
              "y": 7.899,
              "z": 1.524
            },
            "rightCorner": {
              "x": 5.048,
              "y": 8.04,
              "z": 1.524
            },
            "gtin": "4062300123205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd51",
            "leftCorner": {
              "x": 5.048,
              "y": 8.04,
              "z": 1.524
            },
            "rightCorner": {
              "x": 5.054,
              "y": 8.157,
              "z": 1.524
            },
            "gtin": "4062300381971",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd52",
            "leftCorner": {
              "x": 5.054,
              "y": 8.157,
              "z": 1.524
            },
            "rightCorner": {
              "x": 5.059,
              "y": 8.253,
              "z": 1.524
            },
            "gtin": "4062300020719",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738b5",
        "height": 1.7727,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fc3d",
            "leftCorner": {
              "x": 4.998,
              "y": 7.093,
              "z": 1.773
            },
            "rightCorner": {
              "x": 5.0,
              "y": 7.125,
              "z": 1.773
            }
          },
          {
            "id": "696ebf6d43c343680a26fc3e",
            "leftCorner": {
              "x": 5.0,
              "y": 7.125,
              "z": 1.773
            },
            "rightCorner": {
              "x": 5.006,
              "y": 7.243,
              "z": 1.773
            },
            "gtin": "4260133237346",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc3f",
            "leftCorner": {
              "x": 5.006,
              "y": 7.243,
              "z": 1.773
            },
            "rightCorner": {
              "x": 5.014,
              "y": 7.379,
              "z": 1.773
            },
            "gtin": "4062300473379",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc40",
            "leftCorner": {
              "x": 5.014,
              "y": 7.379,
              "z": 1.773
            },
            "rightCorner": {
              "x": 5.02,
              "y": 7.498,
              "z": 1.773
            },
            "gtin": "4062300473294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc41",
            "leftCorner": {
              "x": 5.02,
              "y": 7.498,
              "z": 1.773
            },
            "rightCorner": {
              "x": 5.028,
              "y": 7.633,
              "z": 1.773
            },
            "gtin": "4062300297036",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc42",
            "leftCorner": {
              "x": 5.028,
              "y": 7.633,
              "z": 1.773
            },
            "rightCorner": {
              "x": 5.034,
              "y": 7.753,
              "z": 1.773
            },
            "gtin": "4062300297043",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc43",
            "leftCorner": {
              "x": 5.034,
              "y": 7.753,
              "z": 1.773
            },
            "rightCorner": {
              "x": 5.042,
              "y": 7.889,
              "z": 1.773
            },
            "gtin": "4062300297081",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc44",
            "leftCorner": {
              "x": 5.042,
              "y": 7.889,
              "z": 1.773
            },
            "rightCorner": {
              "x": 5.05,
              "y": 8.029,
              "z": 1.773
            },
            "gtin": "4062300379381",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc45",
            "leftCorner": {
              "x": 5.05,
              "y": 8.029,
              "z": 1.773
            },
            "rightCorner": {
              "x": 5.057,
              "y": 8.156,
              "z": 1.773
            },
            "gtin": "4062300269804",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc46",
            "leftCorner": {
              "x": 5.057,
              "y": 8.156,
              "z": 1.773
            },
            "rightCorner": {
              "x": 5.064,
              "y": 8.287,
              "z": 1.773
            },
            "gtin": "4062300269835",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757b7b5fe7bc046959a2e",
    "name": "68e757b7b5fe7bc046959a2e",
    "x": 5.0134,
    "y": 8.2533,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68262,
      "w": 0.73077
    },
    "statistics": {
      "hasStockCount": 60,
      "noStockCount": 0,
      "unknownStockCount": 13,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "696ead8b3b88e258afd738bf",
        "height": 0.20644,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fc8b",
            "leftCorner": {
              "x": 5.052,
              "y": 8.228,
              "z": 0.207
            },
            "rightCorner": {
              "x": 5.059,
              "y": 8.355,
              "z": 0.207
            },
            "gtin": "4066447889772",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc8c",
            "leftCorner": {
              "x": 5.066,
              "y": 8.352,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.074,
              "y": 8.473,
              "z": 0.206
            },
            "gtin": "4066447889710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc8d",
            "leftCorner": {
              "x": 5.074,
              "y": 8.473,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.082,
              "y": 8.595,
              "z": 0.206
            },
            "gtin": "4066447889758",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc8e",
            "leftCorner": {
              "x": 5.082,
              "y": 8.595,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.092,
              "y": 8.738,
              "z": 0.206
            },
            "gtin": "4066447889734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc8f",
            "leftCorner": {
              "x": 5.092,
              "y": 8.738,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.096,
              "y": 8.798,
              "z": 0.206
            },
            "gtin": "4067796172003",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc90",
            "leftCorner": {
              "x": 5.096,
              "y": 8.798,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.104,
              "y": 8.918,
              "z": 0.206
            },
            "gtin": "4067796171969",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc91",
            "leftCorner": {
              "x": 5.104,
              "y": 8.918,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.112,
              "y": 9.029,
              "z": 0.206
            },
            "gtin": "4067796172171",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc92",
            "leftCorner": {
              "x": 5.112,
              "y": 9.029,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.114,
              "y": 9.056,
              "z": 0.206
            },
            "gtin": "4067796172171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc93",
            "leftCorner": {
              "x": 5.114,
              "y": 9.056,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.121,
              "y": 9.172,
              "z": 0.206
            },
            "gtin": "4067796171983",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc94",
            "leftCorner": {
              "x": 5.121,
              "y": 9.172,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.13,
              "y": 9.297,
              "z": 0.206
            },
            "gtin": "4067796172027",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc95",
            "leftCorner": {
              "x": 5.13,
              "y": 9.297,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.139,
              "y": 9.436,
              "z": 0.206
            },
            "gtin": "4067796171419",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738c3",
        "height": 0.46888,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fdae",
            "leftCorner": {
              "x": 5.06,
              "y": 8.3,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.068,
              "y": 8.424,
              "z": 0.469
            },
            "gtin": "4018852029083",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdaf",
            "leftCorner": {
              "x": 5.068,
              "y": 8.424,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.077,
              "y": 8.549,
              "z": 0.469
            },
            "gtin": "4018852029236",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdb0",
            "leftCorner": {
              "x": 5.077,
              "y": 8.549,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.086,
              "y": 8.68,
              "z": 0.469
            },
            "gtin": "4018852029250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdb1",
            "leftCorner": {
              "x": 5.086,
              "y": 8.68,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.095,
              "y": 8.812,
              "z": 0.469
            },
            "gtin": "4018852029243",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdb2",
            "leftCorner": {
              "x": 5.095,
              "y": 8.812,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.104,
              "y": 8.949,
              "z": 0.469
            },
            "gtin": "4018852030560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdb3",
            "leftCorner": {
              "x": 5.104,
              "y": 8.949,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.113,
              "y": 9.081,
              "z": 0.469
            },
            "gtin": "4018852029359",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdb4",
            "leftCorner": {
              "x": 5.113,
              "y": 9.081,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.121,
              "y": 9.2,
              "z": 0.469
            },
            "gtin": "4066447891423",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdb5",
            "leftCorner": {
              "x": 5.121,
              "y": 9.2,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.13,
              "y": 9.329,
              "z": 0.469
            },
            "gtin": "4018852030249",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdb6",
            "leftCorner": {
              "x": 5.13,
              "y": 9.329,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.134,
              "y": 9.391,
              "z": 0.469
            },
            "gtin": "4018852030171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdb7",
            "leftCorner": {
              "x": 5.134,
              "y": 9.391,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.141,
              "y": 9.494,
              "z": 0.469
            },
            "gtin": "4018852030171",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738c1",
        "height": 0.67573,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fd37",
            "leftCorner": {
              "x": 5.06,
              "y": 8.266,
              "z": 0.676
            },
            "rightCorner": {
              "x": 5.068,
              "y": 8.386,
              "z": 0.676
            },
            "gtin": "4067796157703",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd38",
            "leftCorner": {
              "x": 5.068,
              "y": 8.386,
              "z": 0.676
            },
            "rightCorner": {
              "x": 5.076,
              "y": 8.511,
              "z": 0.676
            },
            "gtin": "4067796157727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd39",
            "leftCorner": {
              "x": 5.076,
              "y": 8.511,
              "z": 0.676
            },
            "rightCorner": {
              "x": 5.085,
              "y": 8.633,
              "z": 0.676
            },
            "gtin": "4066447411621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd3a",
            "leftCorner": {
              "x": 5.085,
              "y": 8.633,
              "z": 0.676
            },
            "rightCorner": {
              "x": 5.095,
              "y": 8.776,
              "z": 0.676
            },
            "gtin": "4066447857092",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd3b",
            "leftCorner": {
              "x": 5.095,
              "y": 8.776,
              "z": 0.676
            },
            "rightCorner": {
              "x": 5.103,
              "y": 8.897,
              "z": 0.676
            },
            "gtin": "4251099705864",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd3c",
            "leftCorner": {
              "x": 5.103,
              "y": 8.897,
              "z": 0.676
            },
            "rightCorner": {
              "x": 5.111,
              "y": 9.018,
              "z": 0.676
            },
            "gtin": "4251099705857",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd3d",
            "leftCorner": {
              "x": 5.111,
              "y": 9.018,
              "z": 0.676
            },
            "rightCorner": {
              "x": 5.12,
              "y": 9.144,
              "z": 0.676
            },
            "gtin": "4251099705932",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd3e",
            "leftCorner": {
              "x": 5.12,
              "y": 9.144,
              "z": 0.676
            },
            "rightCorner": {
              "x": 5.128,
              "y": 9.266,
              "z": 0.676
            },
            "gtin": "4066447208344",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd3f",
            "leftCorner": {
              "x": 5.128,
              "y": 9.266,
              "z": 0.676
            },
            "rightCorner": {
              "x": 5.137,
              "y": 9.4,
              "z": 0.676
            },
            "gtin": "4058172795497",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738c0",
        "height": 0.88558,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fd90",
            "leftCorner": {
              "x": 5.062,
              "y": 8.269,
              "z": 0.886
            },
            "rightCorner": {
              "x": 5.07,
              "y": 8.386,
              "z": 0.886
            },
            "gtin": "4058172437892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd91",
            "leftCorner": {
              "x": 5.07,
              "y": 8.386,
              "z": 0.886
            },
            "rightCorner": {
              "x": 5.078,
              "y": 8.504,
              "z": 0.886
            },
            "gtin": "4058172437816",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd92",
            "leftCorner": {
              "x": 5.078,
              "y": 8.504,
              "z": 0.886
            },
            "rightCorner": {
              "x": 5.086,
              "y": 8.626,
              "z": 0.886
            },
            "gtin": "4058172437830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd93",
            "leftCorner": {
              "x": 5.086,
              "y": 8.626,
              "z": 0.886
            },
            "rightCorner": {
              "x": 5.096,
              "y": 8.767,
              "z": 0.886
            },
            "gtin": "4066447626667",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd94",
            "leftCorner": {
              "x": 5.096,
              "y": 8.767,
              "z": 0.886
            },
            "rightCorner": {
              "x": 5.104,
              "y": 8.888,
              "z": 0.886
            },
            "gtin": "4062300455887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd95",
            "leftCorner": {
              "x": 5.104,
              "y": 8.888,
              "z": 0.886
            },
            "rightCorner": {
              "x": 5.113,
              "y": 9.015,
              "z": 0.886
            },
            "gtin": "4062300260795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd96",
            "leftCorner": {
              "x": 5.113,
              "y": 9.015,
              "z": 0.886
            },
            "rightCorner": {
              "x": 5.121,
              "y": 9.132,
              "z": 0.886
            },
            "gtin": "4066447519143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd97",
            "leftCorner": {
              "x": 5.121,
              "y": 9.132,
              "z": 0.886
            },
            "rightCorner": {
              "x": 5.129,
              "y": 9.253,
              "z": 0.886
            },
            "gtin": "4058172437793",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd98",
            "leftCorner": {
              "x": 5.129,
              "y": 9.253,
              "z": 0.886
            },
            "rightCorner": {
              "x": 5.139,
              "y": 9.4,
              "z": 0.886
            },
            "gtin": "4066447888942",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738c4",
        "height": 1.0996,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fd72",
            "leftCorner": {
              "x": 5.063,
              "y": 8.299,
              "z": 1.1
            },
            "rightCorner": {
              "x": 5.072,
              "y": 8.421,
              "z": 1.1
            },
            "gtin": "4062300427372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd73",
            "leftCorner": {
              "x": 5.072,
              "y": 8.421,
              "z": 1.1
            },
            "rightCorner": {
              "x": 5.08,
              "y": 8.542,
              "z": 1.1
            },
            "gtin": "4062300261563",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd74",
            "leftCorner": {
              "x": 5.08,
              "y": 8.542,
              "z": 1.1
            },
            "rightCorner": {
              "x": 5.089,
              "y": 8.678,
              "z": 1.1
            },
            "gtin": "4062300024816",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd75",
            "leftCorner": {
              "x": 5.089,
              "y": 8.678,
              "z": 1.1
            },
            "rightCorner": {
              "x": 5.098,
              "y": 8.81,
              "z": 1.1
            },
            "gtin": "4062300463103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd76",
            "leftCorner": {
              "x": 5.098,
              "y": 8.81,
              "z": 1.1
            },
            "rightCorner": {
              "x": 5.107,
              "y": 8.94,
              "z": 1.1
            },
            "gtin": "4062300463059",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd77",
            "leftCorner": {
              "x": 5.107,
              "y": 8.94,
              "z": 1.1
            },
            "rightCorner": {
              "x": 5.115,
              "y": 9.065,
              "z": 1.1
            },
            "gtin": "4062300463646",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd78",
            "leftCorner": {
              "x": 5.115,
              "y": 9.065,
              "z": 1.1
            },
            "rightCorner": {
              "x": 5.124,
              "y": 9.186,
              "z": 1.1
            },
            "gtin": "4062300266087",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd79",
            "leftCorner": {
              "x": 5.124,
              "y": 9.186,
              "z": 1.1
            },
            "rightCorner": {
              "x": 5.132,
              "y": 9.314,
              "z": 1.1
            },
            "gtin": "4062300208254",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd7a",
            "leftCorner": {
              "x": 5.132,
              "y": 9.314,
              "z": 1.1
            },
            "rightCorner": {
              "x": 5.141,
              "y": 9.435,
              "z": 1.1
            },
            "gtin": "4062300266179",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738bd",
        "height": 1.3097,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fd1a",
            "leftCorner": {
              "x": 5.064,
              "y": 8.267,
              "z": 1.31
            },
            "rightCorner": {
              "x": 5.072,
              "y": 8.384,
              "z": 1.31
            },
            "gtin": "4062300269880",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd1b",
            "leftCorner": {
              "x": 5.072,
              "y": 8.384,
              "z": 1.31
            },
            "rightCorner": {
              "x": 5.08,
              "y": 8.509,
              "z": 1.31
            },
            "gtin": "4062300427181",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd1c",
            "leftCorner": {
              "x": 5.08,
              "y": 8.509,
              "z": 1.31
            },
            "rightCorner": {
              "x": 5.089,
              "y": 8.638,
              "z": 1.31
            },
            "gtin": "4062300406476",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd1d",
            "leftCorner": {
              "x": 5.089,
              "y": 8.638,
              "z": 1.31
            },
            "rightCorner": {
              "x": 5.098,
              "y": 8.772,
              "z": 1.31
            },
            "gtin": "4062300406483",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd1e",
            "leftCorner": {
              "x": 5.098,
              "y": 8.772,
              "z": 1.31
            },
            "rightCorner": {
              "x": 5.107,
              "y": 8.898,
              "z": 1.31
            },
            "gtin": "4062300455184",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd1f",
            "leftCorner": {
              "x": 5.107,
              "y": 8.898,
              "z": 1.31
            },
            "rightCorner": {
              "x": 5.116,
              "y": 9.028,
              "z": 1.31
            },
            "gtin": "4062300455207",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd20",
            "leftCorner": {
              "x": 5.116,
              "y": 9.028,
              "z": 1.31
            },
            "rightCorner": {
              "x": 5.124,
              "y": 9.15,
              "z": 1.31
            },
            "gtin": "4062300441453",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd21",
            "leftCorner": {
              "x": 5.124,
              "y": 9.15,
              "z": 1.31
            },
            "rightCorner": {
              "x": 5.132,
              "y": 9.272,
              "z": 1.31
            },
            "gtin": "4062300441422",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd22",
            "leftCorner": {
              "x": 5.132,
              "y": 9.272,
              "z": 1.31
            },
            "rightCorner": {
              "x": 5.142,
              "y": 9.413,
              "z": 1.31
            },
            "gtin": "4062300262683",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd23",
            "leftCorner": {
              "x": 5.142,
              "y": 9.413,
              "z": 1.31
            },
            "rightCorner": {
              "x": 5.153,
              "y": 9.575,
              "z": 1.31
            },
            "gtin": "4062300379503",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738be",
        "height": 1.5217,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fd53",
            "leftCorner": {
              "x": 5.069,
              "y": 8.25,
              "z": 1.522
            },
            "rightCorner": {
              "x": 5.07,
              "y": 8.275,
              "z": 1.522
            },
            "gtin": "4062300271241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd54",
            "leftCorner": {
              "x": 5.07,
              "y": 8.275,
              "z": 1.522
            },
            "rightCorner": {
              "x": 5.078,
              "y": 8.389,
              "z": 1.522
            },
            "gtin": "4062300271241",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd55",
            "leftCorner": {
              "x": 5.078,
              "y": 8.389,
              "z": 1.522
            },
            "rightCorner": {
              "x": 5.086,
              "y": 8.508,
              "z": 1.522
            },
            "gtin": "4062300265813",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd56",
            "leftCorner": {
              "x": 5.086,
              "y": 8.508,
              "z": 1.522
            },
            "rightCorner": {
              "x": 5.095,
              "y": 8.637,
              "z": 1.522
            },
            "gtin": "4062300321335",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd57",
            "leftCorner": {
              "x": 5.095,
              "y": 8.637,
              "z": 1.522
            },
            "rightCorner": {
              "x": 5.108,
              "y": 8.833,
              "z": 1.522
            },
            "gtin": "4062300309784",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd58",
            "leftCorner": {
              "x": 5.108,
              "y": 8.833,
              "z": 1.522
            },
            "rightCorner": {
              "x": 5.118,
              "y": 8.974,
              "z": 1.522
            },
            "gtin": "4062300441316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd59",
            "leftCorner": {
              "x": 5.118,
              "y": 8.974,
              "z": 1.522
            },
            "rightCorner": {
              "x": 5.127,
              "y": 9.111,
              "z": 1.522
            },
            "gtin": "4062300367715",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd5a",
            "leftCorner": {
              "x": 5.127,
              "y": 9.111,
              "z": 1.522
            },
            "rightCorner": {
              "x": 5.136,
              "y": 9.232,
              "z": 1.522
            },
            "gtin": "4062300406490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd5b",
            "leftCorner": {
              "x": 5.136,
              "y": 9.232,
              "z": 1.522
            },
            "rightCorner": {
              "x": 5.145,
              "y": 9.366,
              "z": 1.522
            },
            "gtin": "4062300441361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd5c",
            "leftCorner": {
              "x": 5.145,
              "y": 9.366,
              "z": 1.522
            },
            "rightCorner": {
              "x": 5.157,
              "y": 9.541,
              "z": 1.522
            },
            "gtin": "4062300321366",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738c2",
        "height": 1.768,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fc47",
            "leftCorner": {
              "x": 5.074,
              "y": 8.284,
              "z": 1.768
            },
            "rightCorner": {
              "x": 5.083,
              "y": 8.419,
              "z": 1.768
            }
          },
          {
            "id": "696ebf6d43c343680a26fc48",
            "leftCorner": {
              "x": 5.083,
              "y": 8.419,
              "z": 1.768
            },
            "rightCorner": {
              "x": 5.091,
              "y": 8.544,
              "z": 1.768
            },
            "gtin": "4062300441514",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc49",
            "leftCorner": {
              "x": 5.091,
              "y": 8.544,
              "z": 1.768
            },
            "rightCorner": {
              "x": 5.096,
              "y": 8.606,
              "z": 1.768
            }
          },
          {
            "id": "696ebf6d43c343680a26fc4a",
            "leftCorner": {
              "x": 5.096,
              "y": 8.606,
              "z": 1.768
            },
            "rightCorner": {
              "x": 5.102,
              "y": 8.699,
              "z": 1.768
            }
          },
          {
            "id": "696ebf6d43c343680a26fc4b",
            "leftCorner": {
              "x": 5.102,
              "y": 8.699,
              "z": 1.768
            },
            "rightCorner": {
              "x": 5.107,
              "y": 8.771,
              "z": 1.768
            }
          },
          {
            "id": "696ebf6d43c343680a26fc4c",
            "leftCorner": {
              "x": 5.107,
              "y": 8.771,
              "z": 1.768
            },
            "rightCorner": {
              "x": 5.112,
              "y": 8.84,
              "z": 1.768
            }
          },
          {
            "id": "696ebf6d43c343680a26fc4d",
            "leftCorner": {
              "x": 5.112,
              "y": 8.84,
              "z": 1.768
            },
            "rightCorner": {
              "x": 5.119,
              "y": 8.943,
              "z": 1.768
            }
          },
          {
            "id": "696ebf6d43c343680a26fc4e",
            "leftCorner": {
              "x": 5.119,
              "y": 8.943,
              "z": 1.768
            },
            "rightCorner": {
              "x": 5.125,
              "y": 9.031,
              "z": 1.768
            },
            "gtin": "4066447872873",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc4f",
            "leftCorner": {
              "x": 5.125,
              "y": 9.031,
              "z": 1.768
            },
            "rightCorner": {
              "x": 5.134,
              "y": 9.17,
              "z": 1.768
            },
            "gtin": "4062300375253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc50",
            "leftCorner": {
              "x": 5.134,
              "y": 9.17,
              "z": 1.768
            },
            "rightCorner": {
              "x": 5.144,
              "y": 9.31,
              "z": 1.768
            },
            "gtin": "4062300426962",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc51",
            "leftCorner": {
              "x": 5.144,
              "y": 9.31,
              "z": 1.768
            },
            "rightCorner": {
              "x": 5.148,
              "y": 9.38,
              "z": 1.768
            }
          },
          {
            "id": "696ebf6d43c343680a26fc52",
            "leftCorner": {
              "x": 5.148,
              "y": 9.38,
              "z": 1.768
            },
            "rightCorner": {
              "x": 5.155,
              "y": 9.481,
              "z": 1.768
            },
            "gtin": "4062300465329",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757b7b5fe7bc046959a2f",
    "name": "68e757b7b5fe7bc046959a2f",
    "x": 5.0996,
    "y": 9.4764,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.67783,
      "w": 0.73522
    },
    "statistics": {
      "hasStockCount": 63,
      "noStockCount": 0,
      "unknownStockCount": 15,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "696ead8b3b88e258afd738ca",
        "height": 0.2025,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fc96",
            "leftCorner": {
              "x": 5.14,
              "y": 9.436,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.15,
              "y": 9.593,
              "z": 0.206
            },
            "gtin": "4066447889871",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc97",
            "leftCorner": {
              "x": 5.153,
              "y": 9.569,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.163,
              "y": 9.696,
              "z": 0.203
            },
            "gtin": "4066447889833",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc98",
            "leftCorner": {
              "x": 5.163,
              "y": 9.696,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.173,
              "y": 9.819,
              "z": 0.203
            },
            "gtin": "4067796172232",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc99",
            "leftCorner": {
              "x": 5.173,
              "y": 9.819,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.183,
              "y": 9.944,
              "z": 0.203
            },
            "gtin": "4066447889857",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc9a",
            "leftCorner": {
              "x": 5.183,
              "y": 9.944,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.194,
              "y": 10.075,
              "z": 0.203
            },
            "gtin": "4066447889819",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc9b",
            "leftCorner": {
              "x": 5.194,
              "y": 10.075,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.204,
              "y": 10.201,
              "z": 0.203
            },
            "gtin": "4067796171204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc9c",
            "leftCorner": {
              "x": 5.204,
              "y": 10.201,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.215,
              "y": 10.341,
              "z": 0.203
            },
            "gtin": "4066447202625",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc9d",
            "leftCorner": {
              "x": 5.215,
              "y": 10.341,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.225,
              "y": 10.46,
              "z": 0.203
            },
            "gtin": "4067796171167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fc9e",
            "leftCorner": {
              "x": 5.225,
              "y": 10.46,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.235,
              "y": 10.579,
              "z": 0.203
            },
            "gtin": "4067796171181",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc5c",
            "leftCorner": {
              "x": 5.235,
              "y": 10.579,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.246,
              "y": 10.719,
              "z": 0.203
            },
            "gtin": "4067796170252",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738c7",
        "height": 0.46737,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fdb8",
            "leftCorner": {
              "x": 5.141,
              "y": 9.494,
              "z": 0.469
            },
            "rightCorner": {
              "x": 5.152,
              "y": 9.65,
              "z": 0.469
            },
            "gtin": "4018852030164",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdb9",
            "leftCorner": {
              "x": 5.154,
              "y": 9.626,
              "z": 0.467
            },
            "rightCorner": {
              "x": 5.163,
              "y": 9.747,
              "z": 0.467
            },
            "gtin": "4018852030225",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdba",
            "leftCorner": {
              "x": 5.163,
              "y": 9.747,
              "z": 0.467
            },
            "rightCorner": {
              "x": 5.173,
              "y": 9.869,
              "z": 0.467
            },
            "gtin": "4018852029519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdbb",
            "leftCorner": {
              "x": 5.173,
              "y": 9.869,
              "z": 0.467
            },
            "rightCorner": {
              "x": 5.184,
              "y": 10.0,
              "z": 0.467
            },
            "gtin": "4018852034056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdbc",
            "leftCorner": {
              "x": 5.184,
              "y": 10.0,
              "z": 0.467
            },
            "rightCorner": {
              "x": 5.196,
              "y": 10.142,
              "z": 0.467
            },
            "gtin": "4018852034117",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdbd",
            "leftCorner": {
              "x": 5.196,
              "y": 10.142,
              "z": 0.467
            },
            "rightCorner": {
              "x": 5.207,
              "y": 10.287,
              "z": 0.467
            },
            "gtin": "4018852035978",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdbe",
            "leftCorner": {
              "x": 5.207,
              "y": 10.287,
              "z": 0.467
            },
            "rightCorner": {
              "x": 5.218,
              "y": 10.419,
              "z": 0.467
            },
            "gtin": "4018852030492",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdbf",
            "leftCorner": {
              "x": 5.218,
              "y": 10.419,
              "z": 0.467
            },
            "rightCorner": {
              "x": 5.23,
              "y": 10.566,
              "z": 0.467
            },
            "gtin": "4018852030522",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fda3",
            "leftCorner": {
              "x": 5.23,
              "y": 10.566,
              "z": 0.467
            },
            "rightCorner": {
              "x": 5.243,
              "y": 10.719,
              "z": 0.467
            },
            "gtin": "4018852030485",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738c9",
        "height": 0.67595,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fd40",
            "leftCorner": {
              "x": 5.137,
              "y": 9.4,
              "z": 0.676
            },
            "rightCorner": {
              "x": 5.153,
              "y": 9.633,
              "z": 0.676
            },
            "gtin": "4058172795459",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd41",
            "leftCorner": {
              "x": 5.154,
              "y": 9.609,
              "z": 0.676
            },
            "rightCorner": {
              "x": 5.164,
              "y": 9.73,
              "z": 0.676
            },
            "gtin": "4066447411645",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd42",
            "leftCorner": {
              "x": 5.164,
              "y": 9.73,
              "z": 0.676
            },
            "rightCorner": {
              "x": 5.174,
              "y": 9.852,
              "z": 0.676
            },
            "gtin": "4066447519105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd43",
            "leftCorner": {
              "x": 5.174,
              "y": 9.852,
              "z": 0.676
            },
            "rightCorner": {
              "x": 5.184,
              "y": 9.975,
              "z": 0.676
            },
            "gtin": "4066447208368",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd44",
            "leftCorner": {
              "x": 5.184,
              "y": 9.975,
              "z": 0.676
            },
            "rightCorner": {
              "x": 5.194,
              "y": 10.1,
              "z": 0.676
            },
            "gtin": "4066447519167",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd45",
            "leftCorner": {
              "x": 5.194,
              "y": 10.1,
              "z": 0.676
            },
            "rightCorner": {
              "x": 5.207,
              "y": 10.265,
              "z": 0.676
            },
            "gtin": "4251099706120",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd46",
            "leftCorner": {
              "x": 5.207,
              "y": 10.265,
              "z": 0.676
            },
            "rightCorner": {
              "x": 5.219,
              "y": 10.405,
              "z": 0.676
            },
            "gtin": "4251099706076",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd47",
            "leftCorner": {
              "x": 5.219,
              "y": 10.405,
              "z": 0.676
            },
            "rightCorner": {
              "x": 5.231,
              "y": 10.56,
              "z": 0.676
            },
            "gtin": "4251099614197",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd2d",
            "leftCorner": {
              "x": 5.231,
              "y": 10.56,
              "z": 0.676
            },
            "rightCorner": {
              "x": 5.244,
              "y": 10.719,
              "z": 0.676
            },
            "gtin": "4251099609537",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738c8",
        "height": 0.87801,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fd99",
            "leftCorner": {
              "x": 5.139,
              "y": 9.4,
              "z": 0.886
            },
            "rightCorner": {
              "x": 5.153,
              "y": 9.595,
              "z": 0.886
            },
            "gtin": "4058172437878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd9a",
            "leftCorner": {
              "x": 5.157,
              "y": 9.57,
              "z": 0.878
            },
            "rightCorner": {
              "x": 5.168,
              "y": 9.703,
              "z": 0.878
            },
            "gtin": "4058172437854",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd9b",
            "leftCorner": {
              "x": 5.168,
              "y": 9.703,
              "z": 0.878
            },
            "rightCorner": {
              "x": 5.178,
              "y": 9.825,
              "z": 0.878
            },
            "gtin": "4058172869662",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd9c",
            "leftCorner": {
              "x": 5.178,
              "y": 9.825,
              "z": 0.878
            },
            "rightCorner": {
              "x": 5.188,
              "y": 9.952,
              "z": 0.878
            },
            "gtin": "4066447872699",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd9d",
            "leftCorner": {
              "x": 5.188,
              "y": 9.952,
              "z": 0.878
            },
            "rightCorner": {
              "x": 5.199,
              "y": 10.086,
              "z": 0.878
            },
            "gtin": "4066447600636",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd9e",
            "leftCorner": {
              "x": 5.199,
              "y": 10.086,
              "z": 0.878
            },
            "rightCorner": {
              "x": 5.209,
              "y": 10.216,
              "z": 0.878
            },
            "gtin": "4058172438318",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd9f",
            "leftCorner": {
              "x": 5.209,
              "y": 10.216,
              "z": 0.878
            },
            "rightCorner": {
              "x": 5.22,
              "y": 10.348,
              "z": 0.878
            },
            "gtin": "4066447519181",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fda0",
            "leftCorner": {
              "x": 5.22,
              "y": 10.348,
              "z": 0.878
            },
            "rightCorner": {
              "x": 5.23,
              "y": 10.466,
              "z": 0.878
            },
            "gtin": "4066447519129",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fda1",
            "leftCorner": {
              "x": 5.23,
              "y": 10.466,
              "z": 0.878
            },
            "rightCorner": {
              "x": 5.24,
              "y": 10.588,
              "z": 0.878
            },
            "gtin": "4066447208382",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd86",
            "leftCorner": {
              "x": 5.24,
              "y": 10.588,
              "z": 0.878
            },
            "rightCorner": {
              "x": 5.25,
              "y": 10.718,
              "z": 0.878
            },
            "gtin": "4062300463196",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738c6",
        "height": 1.1011,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fd7b",
            "leftCorner": {
              "x": 5.141,
              "y": 9.435,
              "z": 1.1
            },
            "rightCorner": {
              "x": 5.154,
              "y": 9.626,
              "z": 1.1
            },
            "gtin": "4062300266148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd7c",
            "leftCorner": {
              "x": 5.155,
              "y": 9.602,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.165,
              "y": 9.723,
              "z": 1.101
            },
            "gtin": "4062300259638",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd7d",
            "leftCorner": {
              "x": 5.165,
              "y": 9.723,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.175,
              "y": 9.846,
              "z": 1.101
            },
            "gtin": "4062300439481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd7e",
            "leftCorner": {
              "x": 5.175,
              "y": 9.846,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.185,
              "y": 9.975,
              "z": 1.101
            },
            "gtin": "4062300265998",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd7f",
            "leftCorner": {
              "x": 5.185,
              "y": 9.975,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.196,
              "y": 10.105,
              "z": 1.101
            },
            "gtin": "4062300266117",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd80",
            "leftCorner": {
              "x": 5.196,
              "y": 10.105,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.207,
              "y": 10.239,
              "z": 1.101
            },
            "gtin": "4062300261303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd81",
            "leftCorner": {
              "x": 5.207,
              "y": 10.239,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.217,
              "y": 10.363,
              "z": 1.101
            },
            "gtin": "4062300036710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd82",
            "leftCorner": {
              "x": 5.217,
              "y": 10.363,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.228,
              "y": 10.496,
              "z": 1.101
            },
            "gtin": "4062300462229",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd83",
            "leftCorner": {
              "x": 5.228,
              "y": 10.496,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.232,
              "y": 10.551,
              "z": 1.101
            },
            "gtin": "4062300262515",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd84",
            "leftCorner": {
              "x": 5.232,
              "y": 10.551,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.238,
              "y": 10.617,
              "z": 1.101
            },
            "gtin": "4062300463011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd68",
            "leftCorner": {
              "x": 5.238,
              "y": 10.617,
              "z": 1.101
            },
            "rightCorner": {
              "x": 5.246,
              "y": 10.719,
              "z": 1.101
            },
            "gtin": "4062300198838",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738c5",
        "height": 1.3085,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fd24",
            "leftCorner": {
              "x": 5.15,
              "y": 9.551,
              "z": 1.309
            },
            "rightCorner": {
              "x": 5.16,
              "y": 9.675,
              "z": 1.309
            },
            "gtin": "4062300379657",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd25",
            "leftCorner": {
              "x": 5.16,
              "y": 9.675,
              "z": 1.309
            },
            "rightCorner": {
              "x": 5.17,
              "y": 9.796,
              "z": 1.309
            },
            "gtin": "4062300409064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd26",
            "leftCorner": {
              "x": 5.17,
              "y": 9.796,
              "z": 1.309
            },
            "rightCorner": {
              "x": 5.18,
              "y": 9.922,
              "z": 1.309
            },
            "gtin": "4062300349445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd27",
            "leftCorner": {
              "x": 5.18,
              "y": 9.922,
              "z": 1.309
            },
            "rightCorner": {
              "x": 5.191,
              "y": 10.05,
              "z": 1.309
            },
            "gtin": "4062300262652",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd28",
            "leftCorner": {
              "x": 5.191,
              "y": 10.05,
              "z": 1.309
            },
            "rightCorner": {
              "x": 5.202,
              "y": 10.19,
              "z": 1.309
            },
            "gtin": "4062300258655",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd29",
            "leftCorner": {
              "x": 5.202,
              "y": 10.19,
              "z": 1.309
            },
            "rightCorner": {
              "x": 5.214,
              "y": 10.336,
              "z": 1.309
            },
            "gtin": "4062300348455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fd2a",
            "leftCorner": {
              "x": 5.214,
              "y": 10.336,
              "z": 1.309
            },
            "rightCorner": {
              "x": 5.225,
              "y": 10.466,
              "z": 1.309
            },
            "gtin": "4062300440425",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd2b",
            "leftCorner": {
              "x": 5.225,
              "y": 10.466,
              "z": 1.309
            },
            "rightCorner": {
              "x": 5.235,
              "y": 10.587,
              "z": 1.309
            },
            "gtin": "4062300265967",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd10",
            "leftCorner": {
              "x": 5.235,
              "y": 10.587,
              "z": 1.309
            },
            "rightCorner": {
              "x": 5.245,
              "y": 10.719,
              "z": 1.309
            },
            "gtin": "4062300253735",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738cc",
        "height": 1.5193,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fd5d",
            "leftCorner": {
              "x": 5.154,
              "y": 9.517,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.164,
              "y": 9.638,
              "z": 1.519
            },
            "gtin": "4062300265295",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd5e",
            "leftCorner": {
              "x": 5.164,
              "y": 9.638,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.173,
              "y": 9.755,
              "z": 1.519
            },
            "gtin": "4062300462892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd5f",
            "leftCorner": {
              "x": 5.173,
              "y": 9.755,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.183,
              "y": 9.878,
              "z": 1.519
            },
            "gtin": "4062300463042",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd60",
            "leftCorner": {
              "x": 5.183,
              "y": 9.878,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.188,
              "y": 9.938,
              "z": 1.519
            },
            "gtin": "4062300439665",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd61",
            "leftCorner": {
              "x": 5.188,
              "y": 9.938,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.199,
              "y": 10.068,
              "z": 1.519
            },
            "gtin": "4062300437517",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd62",
            "leftCorner": {
              "x": 5.199,
              "y": 10.068,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.21,
              "y": 10.211,
              "z": 1.519
            },
            "gtin": "4062300457683",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd63",
            "leftCorner": {
              "x": 5.21,
              "y": 10.211,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.216,
              "y": 10.283,
              "z": 1.519
            },
            "gtin": "4066447859027",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd64",
            "leftCorner": {
              "x": 5.216,
              "y": 10.283,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.226,
              "y": 10.4,
              "z": 1.519
            },
            "gtin": "4066447859027",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd65",
            "leftCorner": {
              "x": 5.226,
              "y": 10.4,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.233,
              "y": 10.494,
              "z": 1.519
            },
            "gtin": "4067796181104",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd66",
            "leftCorner": {
              "x": 5.233,
              "y": 10.494,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.24,
              "y": 10.582,
              "z": 1.519
            },
            "gtin": "4067796181128",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fd49",
            "leftCorner": {
              "x": 5.24,
              "y": 10.582,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.251,
              "y": 10.718,
              "z": 1.519
            },
            "gtin": "4260133235441",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738cb",
        "height": 1.769,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fc53",
            "leftCorner": {
              "x": 5.155,
              "y": 9.481,
              "z": 1.768
            },
            "rightCorner": {
              "x": 5.166,
              "y": 9.643,
              "z": 1.768
            },
            "gtin": "4062300375178",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc54",
            "leftCorner": {
              "x": 5.164,
              "y": 9.619,
              "z": 1.769
            },
            "rightCorner": {
              "x": 5.175,
              "y": 9.752,
              "z": 1.769
            },
            "gtin": "4062300375307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc55",
            "leftCorner": {
              "x": 5.175,
              "y": 9.752,
              "z": 1.769
            },
            "rightCorner": {
              "x": 5.187,
              "y": 9.893,
              "z": 1.769
            },
            "gtin": "4062300375260",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc56",
            "leftCorner": {
              "x": 5.187,
              "y": 9.893,
              "z": 1.769
            },
            "rightCorner": {
              "x": 5.198,
              "y": 10.036,
              "z": 1.769
            },
            "gtin": "4062300375246",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc57",
            "leftCorner": {
              "x": 5.198,
              "y": 10.036,
              "z": 1.769
            },
            "rightCorner": {
              "x": 5.21,
              "y": 10.176,
              "z": 1.769
            },
            "gtin": "4062300375215",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc58",
            "leftCorner": {
              "x": 5.21,
              "y": 10.176,
              "z": 1.769
            },
            "rightCorner": {
              "x": 5.221,
              "y": 10.317,
              "z": 1.769
            },
            "gtin": "3444570201158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc59",
            "leftCorner": {
              "x": 5.221,
              "y": 10.317,
              "z": 1.769
            },
            "rightCorner": {
              "x": 5.232,
              "y": 10.445,
              "z": 1.769
            },
            "gtin": "3444570201202",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc5a",
            "leftCorner": {
              "x": 5.232,
              "y": 10.445,
              "z": 1.769
            },
            "rightCorner": {
              "x": 5.242,
              "y": 10.569,
              "z": 1.769
            },
            "gtin": "3444570201196",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fc17",
            "leftCorner": {
              "x": 5.242,
              "y": 10.569,
              "z": 1.769
            },
            "rightCorner": {
              "x": 5.254,
              "y": 10.718,
              "z": 1.769
            },
            "gtin": "4260133230309",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757c5b5fe7bc046959a4c",
    "name": "68e757c5b5fe7bc046959a4c",
    "x": 7.4764,
    "y": 11.771,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73357,
      "w": 0.67961
    },
    "statistics": {
      "hasStockCount": 57,
      "noStockCount": 4,
      "unknownStockCount": 34
    },
    "layers": [
      {
        "id": "696ead8b3b88e258afd738d4",
        "height": 0.20614,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fe4a",
            "leftCorner": {
              "x": 7.432,
              "y": 11.775,
              "z": 0.206
            },
            "rightCorner": {
              "x": 7.425,
              "y": 11.687,
              "z": 0.206
            },
            "gtin": "4067796170993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe4b",
            "leftCorner": {
              "x": 7.425,
              "y": 11.687,
              "z": 0.206
            },
            "rightCorner": {
              "x": 7.418,
              "y": 11.6,
              "z": 0.206
            },
            "gtin": "4067796170979",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe4c",
            "leftCorner": {
              "x": 7.418,
              "y": 11.6,
              "z": 0.206
            },
            "rightCorner": {
              "x": 7.411,
              "y": 11.506,
              "z": 0.206
            },
            "gtin": "4066447523041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe4d",
            "leftCorner": {
              "x": 7.411,
              "y": 11.506,
              "z": 0.206
            },
            "rightCorner": {
              "x": 7.406,
              "y": 11.447,
              "z": 0.206
            },
            "gtin": "4066447880731",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe4e",
            "leftCorner": {
              "x": 7.406,
              "y": 11.447,
              "z": 0.206
            },
            "rightCorner": {
              "x": 7.398,
              "y": 11.33,
              "z": 0.206
            },
            "gtin": "4067796075403",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe4f",
            "leftCorner": {
              "x": 7.398,
              "y": 11.33,
              "z": 0.206
            },
            "rightCorner": {
              "x": 7.39,
              "y": 11.235,
              "z": 0.206
            }
          },
          {
            "id": "696ebf6d43c343680a26fe50",
            "leftCorner": {
              "x": 7.39,
              "y": 11.235,
              "z": 0.206
            },
            "rightCorner": {
              "x": 7.383,
              "y": 11.135,
              "z": 0.206
            },
            "gtin": "4066447880151",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe51",
            "leftCorner": {
              "x": 7.383,
              "y": 11.135,
              "z": 0.206
            },
            "rightCorner": {
              "x": 7.376,
              "y": 11.048,
              "z": 0.206
            },
            "gtin": "4066447235869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe52",
            "leftCorner": {
              "x": 7.376,
              "y": 11.048,
              "z": 0.206
            },
            "rightCorner": {
              "x": 7.368,
              "y": 10.946,
              "z": 0.206
            },
            "gtin": "4066447467673",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe53",
            "leftCorner": {
              "x": 7.368,
              "y": 10.946,
              "z": 0.206
            },
            "rightCorner": {
              "x": 7.362,
              "y": 10.867,
              "z": 0.206
            },
            "gtin": "4066447382969",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe54",
            "leftCorner": {
              "x": 7.362,
              "y": 10.867,
              "z": 0.206
            },
            "rightCorner": {
              "x": 7.356,
              "y": 10.782,
              "z": 0.206
            },
            "gtin": "4066447364125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe55",
            "leftCorner": {
              "x": 7.356,
              "y": 10.782,
              "z": 0.206
            },
            "rightCorner": {
              "x": 7.346,
              "y": 10.655,
              "z": 0.206
            },
            "gtin": "4066447880687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe56",
            "leftCorner": {
              "x": 7.346,
              "y": 10.655,
              "z": 0.206
            },
            "rightCorner": {
              "x": 7.339,
              "y": 10.56,
              "z": 0.206
            },
            "gtin": "4066447570342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe57",
            "leftCorner": {
              "x": 7.339,
              "y": 10.56,
              "z": 0.206
            },
            "rightCorner": {
              "x": 7.332,
              "y": 10.475,
              "z": 0.206
            },
            "gtin": "4067796171013",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738d0",
        "height": 0.5137,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fdfe",
            "leftCorner": {
              "x": 7.434,
              "y": 11.774,
              "z": 0.514
            },
            "rightCorner": {
              "x": 7.431,
              "y": 11.735,
              "z": 0.514
            }
          },
          {
            "id": "696ebf6d43c343680a26fe00",
            "leftCorner": {
              "x": 7.431,
              "y": 11.735,
              "z": 0.514
            },
            "rightCorner": {
              "x": 7.422,
              "y": 11.613,
              "z": 0.514
            },
            "gtin": "4030651054240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe01",
            "leftCorner": {
              "x": 7.422,
              "y": 11.613,
              "z": 0.514
            },
            "rightCorner": {
              "x": 7.415,
              "y": 11.516,
              "z": 0.514
            },
            "gtin": "4030651054295",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe02",
            "leftCorner": {
              "x": 7.415,
              "y": 11.516,
              "z": 0.514
            },
            "rightCorner": {
              "x": 7.408,
              "y": 11.435,
              "z": 0.514
            },
            "gtin": "4066447704310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe03",
            "leftCorner": {
              "x": 7.408,
              "y": 11.435,
              "z": 0.514
            },
            "rightCorner": {
              "x": 7.4,
              "y": 11.329,
              "z": 0.514
            },
            "gtin": "4066447735086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe04",
            "leftCorner": {
              "x": 7.4,
              "y": 11.329,
              "z": 0.514
            },
            "rightCorner": {
              "x": 7.391,
              "y": 11.208,
              "z": 0.514
            },
            "gtin": "4067796069891",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe05",
            "leftCorner": {
              "x": 7.391,
              "y": 11.208,
              "z": 0.514
            },
            "rightCorner": {
              "x": 7.386,
              "y": 11.147,
              "z": 0.514
            },
            "gtin": "4066447871333",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe06",
            "leftCorner": {
              "x": 7.386,
              "y": 11.147,
              "z": 0.514
            },
            "rightCorner": {
              "x": 7.381,
              "y": 11.07,
              "z": 0.514
            },
            "gtin": "4066447981308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe07",
            "leftCorner": {
              "x": 7.381,
              "y": 11.07,
              "z": 0.514
            },
            "rightCorner": {
              "x": 7.374,
              "y": 10.98,
              "z": 0.514
            },
            "gtin": "4066447883251",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe08",
            "leftCorner": {
              "x": 7.374,
              "y": 10.98,
              "z": 0.514
            },
            "rightCorner": {
              "x": 7.369,
              "y": 10.917,
              "z": 0.514
            },
            "gtin": "4066447880632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe09",
            "leftCorner": {
              "x": 7.369,
              "y": 10.917,
              "z": 0.514
            },
            "rightCorner": {
              "x": 7.363,
              "y": 10.84,
              "z": 0.514
            },
            "gtin": "4066447880632",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe0a",
            "leftCorner": {
              "x": 7.363,
              "y": 10.84,
              "z": 0.514
            },
            "rightCorner": {
              "x": 7.355,
              "y": 10.732,
              "z": 0.514
            },
            "gtin": "4262368742572",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe0b",
            "leftCorner": {
              "x": 7.355,
              "y": 10.732,
              "z": 0.514
            },
            "rightCorner": {
              "x": 7.346,
              "y": 10.622,
              "z": 0.514
            },
            "gtin": "4262368742497",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe0c",
            "leftCorner": {
              "x": 7.346,
              "y": 10.622,
              "z": 0.514
            },
            "rightCorner": {
              "x": 7.339,
              "y": 10.532,
              "z": 0.514
            },
            "gtin": "4262368742534",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738d1",
        "height": 0.72224,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fe24",
            "leftCorner": {
              "x": 7.443,
              "y": 11.774,
              "z": 0.722
            },
            "rightCorner": {
              "x": 7.435,
              "y": 11.67,
              "z": 0.722
            },
            "gtin": "4008233181882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe26",
            "leftCorner": {
              "x": 7.435,
              "y": 11.67,
              "z": 0.722
            },
            "rightCorner": {
              "x": 7.425,
              "y": 11.544,
              "z": 0.722
            },
            "gtin": "4008233174488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe27",
            "leftCorner": {
              "x": 7.425,
              "y": 11.544,
              "z": 0.722
            },
            "rightCorner": {
              "x": 7.415,
              "y": 11.414,
              "z": 0.722
            },
            "gtin": "4008233179490",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe28",
            "leftCorner": {
              "x": 7.415,
              "y": 11.414,
              "z": 0.722
            },
            "rightCorner": {
              "x": 7.408,
              "y": 11.314,
              "z": 0.722
            },
            "gtin": "4008233181776",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe29",
            "leftCorner": {
              "x": 7.408,
              "y": 11.314,
              "z": 0.722
            },
            "rightCorner": {
              "x": 7.399,
              "y": 11.208,
              "z": 0.722
            },
            "gtin": "4008233176444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe2a",
            "leftCorner": {
              "x": 7.399,
              "y": 11.208,
              "z": 0.722
            },
            "rightCorner": {
              "x": 7.392,
              "y": 11.11,
              "z": 0.722
            },
            "gtin": "4008233172347",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe2b",
            "leftCorner": {
              "x": 7.392,
              "y": 11.11,
              "z": 0.722
            },
            "rightCorner": {
              "x": 7.384,
              "y": 11.006,
              "z": 0.722
            },
            "gtin": "4008233176420",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe2c",
            "leftCorner": {
              "x": 7.384,
              "y": 11.006,
              "z": 0.722
            },
            "rightCorner": {
              "x": 7.376,
              "y": 10.904,
              "z": 0.722
            },
            "gtin": "4008233176697",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe2d",
            "leftCorner": {
              "x": 7.376,
              "y": 10.904,
              "z": 0.722
            },
            "rightCorner": {
              "x": 7.368,
              "y": 10.791,
              "z": 0.722
            },
            "gtin": "4008233174488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe2e",
            "leftCorner": {
              "x": 7.368,
              "y": 10.791,
              "z": 0.722
            },
            "rightCorner": {
              "x": 7.359,
              "y": 10.674,
              "z": 0.722
            },
            "gtin": "4008233176437",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe25",
            "leftCorner": {
              "x": 7.359,
              "y": 10.674,
              "z": 0.722
            },
            "rightCorner": {
              "x": 7.347,
              "y": 10.527,
              "z": 0.722
            }
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738d2",
        "height": 0.93517,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fe2f",
            "leftCorner": {
              "x": 7.432,
              "y": 11.775,
              "z": 0.935
            },
            "rightCorner": {
              "x": 7.428,
              "y": 11.719,
              "z": 0.935
            },
            "gtin": "4008491107792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe31",
            "leftCorner": {
              "x": 7.428,
              "y": 11.719,
              "z": 0.935
            },
            "rightCorner": {
              "x": 7.422,
              "y": 11.643,
              "z": 0.935
            },
            "gtin": "4008491107792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe32",
            "leftCorner": {
              "x": 7.422,
              "y": 11.643,
              "z": 0.935
            },
            "rightCorner": {
              "x": 7.414,
              "y": 11.537,
              "z": 0.935
            },
            "gtin": "4008491109932",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe33",
            "leftCorner": {
              "x": 7.414,
              "y": 11.537,
              "z": 0.935
            },
            "rightCorner": {
              "x": 7.406,
              "y": 11.438,
              "z": 0.935
            },
            "gtin": "4008491100229",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe34",
            "leftCorner": {
              "x": 7.406,
              "y": 11.438,
              "z": 0.935
            },
            "rightCorner": {
              "x": 7.398,
              "y": 11.337,
              "z": 0.935
            },
            "gtin": "4008491118224",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe35",
            "leftCorner": {
              "x": 7.398,
              "y": 11.337,
              "z": 0.935
            },
            "rightCorner": {
              "x": 7.391,
              "y": 11.24,
              "z": 0.935
            },
            "gtin": "4030651054226",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe36",
            "leftCorner": {
              "x": 7.391,
              "y": 11.24,
              "z": 0.935
            },
            "rightCorner": {
              "x": 7.384,
              "y": 11.145,
              "z": 0.935
            },
            "gtin": "4030651046047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe37",
            "leftCorner": {
              "x": 7.384,
              "y": 11.145,
              "z": 0.935
            },
            "rightCorner": {
              "x": 7.377,
              "y": 11.054,
              "z": 0.935
            },
            "gtin": "4059779068311",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe38",
            "leftCorner": {
              "x": 7.377,
              "y": 11.054,
              "z": 0.935
            },
            "rightCorner": {
              "x": 7.369,
              "y": 10.953,
              "z": 0.935
            },
            "gtin": "4059779069127",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe39",
            "leftCorner": {
              "x": 7.369,
              "y": 10.953,
              "z": 0.935
            },
            "rightCorner": {
              "x": 7.363,
              "y": 10.87,
              "z": 0.935
            },
            "gtin": "4059779059272",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe3a",
            "leftCorner": {
              "x": 7.363,
              "y": 10.87,
              "z": 0.935
            },
            "rightCorner": {
              "x": 7.356,
              "y": 10.788,
              "z": 0.935
            },
            "gtin": "4059779048412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe3b",
            "leftCorner": {
              "x": 7.356,
              "y": 10.788,
              "z": 0.935
            },
            "rightCorner": {
              "x": 7.35,
              "y": 10.698,
              "z": 0.935
            },
            "gtin": "4059779064290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe3c",
            "leftCorner": {
              "x": 7.35,
              "y": 10.698,
              "z": 0.935
            },
            "rightCorner": {
              "x": 7.343,
              "y": 10.612,
              "z": 0.935
            },
            "gtin": "4059779034309",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe30",
            "leftCorner": {
              "x": 7.343,
              "y": 10.612,
              "z": 0.935
            },
            "rightCorner": {
              "x": 7.337,
              "y": 10.528,
              "z": 0.935
            },
            "gtin": "4059779052327",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738d3",
        "height": 1.1893,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fe3d",
            "leftCorner": {
              "x": 7.43,
              "y": 11.775,
              "z": 1.189
            },
            "rightCorner": {
              "x": 7.422,
              "y": 11.671,
              "z": 1.189
            },
            "gtin": "4008491118316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe3f",
            "leftCorner": {
              "x": 7.422,
              "y": 11.671,
              "z": 1.189
            },
            "rightCorner": {
              "x": 7.417,
              "y": 11.599,
              "z": 1.189
            },
            "gtin": "4008491119115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe40",
            "leftCorner": {
              "x": 7.417,
              "y": 11.599,
              "z": 1.189
            },
            "rightCorner": {
              "x": 7.411,
              "y": 11.521,
              "z": 1.189
            },
            "gtin": "4008491121484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe41",
            "leftCorner": {
              "x": 7.411,
              "y": 11.521,
              "z": 1.189
            },
            "rightCorner": {
              "x": 7.402,
              "y": 11.409,
              "z": 1.189
            },
            "gtin": "4008491126878",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe42",
            "leftCorner": {
              "x": 7.402,
              "y": 11.409,
              "z": 1.189
            },
            "rightCorner": {
              "x": 7.394,
              "y": 11.305,
              "z": 1.189
            },
            "gtin": "4008491113878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe43",
            "leftCorner": {
              "x": 7.394,
              "y": 11.305,
              "z": 1.189
            },
            "rightCorner": {
              "x": 7.388,
              "y": 11.229,
              "z": 1.189
            },
            "gtin": "4008491106252",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe44",
            "leftCorner": {
              "x": 7.388,
              "y": 11.229,
              "z": 1.189
            },
            "rightCorner": {
              "x": 7.384,
              "y": 11.174,
              "z": 1.189
            },
            "gtin": "4008491101387",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe45",
            "leftCorner": {
              "x": 7.384,
              "y": 11.174,
              "z": 1.189
            },
            "rightCorner": {
              "x": 7.376,
              "y": 11.075,
              "z": 1.189
            },
            "gtin": "4008491130608",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe46",
            "leftCorner": {
              "x": 7.376,
              "y": 11.075,
              "z": 1.189
            },
            "rightCorner": {
              "x": 7.369,
              "y": 10.977,
              "z": 1.189
            },
            "gtin": "4008491109772",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe47",
            "leftCorner": {
              "x": 7.369,
              "y": 10.977,
              "z": 1.189
            },
            "rightCorner": {
              "x": 7.361,
              "y": 10.869,
              "z": 1.189
            },
            "gtin": "4008491130646",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe48",
            "leftCorner": {
              "x": 7.361,
              "y": 10.869,
              "z": 1.189
            },
            "rightCorner": {
              "x": 7.352,
              "y": 10.755,
              "z": 1.189
            },
            "gtin": "4008491100182",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe49",
            "leftCorner": {
              "x": 7.352,
              "y": 10.755,
              "z": 1.189
            },
            "rightCorner": {
              "x": 7.343,
              "y": 10.641,
              "z": 1.189
            },
            "gtin": "4065331002839",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe3e",
            "leftCorner": {
              "x": 7.343,
              "y": 10.641,
              "z": 1.189
            },
            "rightCorner": {
              "x": 7.335,
              "y": 10.528,
              "z": 1.189
            },
            "gtin": "4065331005250",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738cf",
        "height": 1.4411,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fdee",
            "leftCorner": {
              "x": 7.431,
              "y": 11.775,
              "z": 1.441
            },
            "rightCorner": {
              "x": 7.424,
              "y": 11.689,
              "z": 1.441
            },
            "gtin": "4066447858891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdf0",
            "leftCorner": {
              "x": 7.424,
              "y": 11.689,
              "z": 1.441
            },
            "rightCorner": {
              "x": 7.419,
              "y": 11.619,
              "z": 1.441
            },
            "gtin": "4066447858938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdf1",
            "leftCorner": {
              "x": 7.419,
              "y": 11.619,
              "z": 1.441
            },
            "rightCorner": {
              "x": 7.413,
              "y": 11.547,
              "z": 1.441
            },
            "gtin": "4066447858877",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdf2",
            "leftCorner": {
              "x": 7.413,
              "y": 11.547,
              "z": 1.441
            },
            "rightCorner": {
              "x": 7.407,
              "y": 11.471,
              "z": 1.441
            },
            "gtin": "4066447858952",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdf3",
            "leftCorner": {
              "x": 7.407,
              "y": 11.471,
              "z": 1.441
            },
            "rightCorner": {
              "x": 7.401,
              "y": 11.387,
              "z": 1.441
            },
            "gtin": "4066447858976",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdf4",
            "leftCorner": {
              "x": 7.401,
              "y": 11.387,
              "z": 1.441
            },
            "rightCorner": {
              "x": 7.395,
              "y": 11.307,
              "z": 1.441
            },
            "gtin": "4066447429169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdf5",
            "leftCorner": {
              "x": 7.395,
              "y": 11.307,
              "z": 1.441
            },
            "rightCorner": {
              "x": 7.39,
              "y": 11.245,
              "z": 1.441
            },
            "gtin": "4065331004314",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdf6",
            "leftCorner": {
              "x": 7.39,
              "y": 11.245,
              "z": 1.441
            },
            "rightCorner": {
              "x": 7.385,
              "y": 11.175,
              "z": 1.441
            },
            "gtin": "4065331001085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdf7",
            "leftCorner": {
              "x": 7.385,
              "y": 11.175,
              "z": 1.441
            },
            "rightCorner": {
              "x": 7.38,
              "y": 11.119,
              "z": 1.441
            },
            "gtin": "4065331001207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdf8",
            "leftCorner": {
              "x": 7.38,
              "y": 11.119,
              "z": 1.441
            },
            "rightCorner": {
              "x": 7.374,
              "y": 11.039,
              "z": 1.441
            },
            "gtin": "4065331001221",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdf9",
            "leftCorner": {
              "x": 7.374,
              "y": 11.039,
              "z": 1.441
            },
            "rightCorner": {
              "x": 7.369,
              "y": 10.969,
              "z": 1.441
            },
            "gtin": "4065331001122",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdfa",
            "leftCorner": {
              "x": 7.369,
              "y": 10.969,
              "z": 1.441
            },
            "rightCorner": {
              "x": 7.365,
              "y": 10.913,
              "z": 1.441
            },
            "gtin": "4065331001306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdfb",
            "leftCorner": {
              "x": 7.365,
              "y": 10.913,
              "z": 1.441
            },
            "rightCorner": {
              "x": 7.354,
              "y": 10.776,
              "z": 1.441
            },
            "gtin": "4065331004482",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdfc",
            "leftCorner": {
              "x": 7.354,
              "y": 10.776,
              "z": 1.441
            },
            "rightCorner": {
              "x": 7.348,
              "y": 10.689,
              "z": 1.441
            },
            "gtin": "4065331005052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdfd",
            "leftCorner": {
              "x": 7.348,
              "y": 10.689,
              "z": 1.441
            },
            "rightCorner": {
              "x": 7.342,
              "y": 10.616,
              "z": 1.441
            },
            "gtin": "4065331002792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdef",
            "leftCorner": {
              "x": 7.342,
              "y": 10.616,
              "z": 1.441
            },
            "rightCorner": {
              "x": 7.335,
              "y": 10.528,
              "z": 1.441
            },
            "gtin": "4065331002815",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738ce",
        "height": 1.6927,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fdce",
            "leftCorner": {
              "x": 7.341,
              "y": 10.641,
              "z": 1.693
            },
            "rightCorner": {
              "x": 7.336,
              "y": 10.58,
              "z": 1.693
            },
            "gtin": "4045612010951",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdc0",
            "leftCorner": {
              "x": 7.428,
              "y": 11.775,
              "z": 1.693
            },
            "rightCorner": {
              "x": 7.421,
              "y": 11.687,
              "z": 1.693
            },
            "gtin": "3574661444123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdc1",
            "leftCorner": {
              "x": 7.421,
              "y": 11.687,
              "z": 1.693
            },
            "rightCorner": {
              "x": 7.415,
              "y": 11.613,
              "z": 1.693
            },
            "gtin": "3574661444147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdc2",
            "leftCorner": {
              "x": 7.415,
              "y": 11.613,
              "z": 1.693
            },
            "rightCorner": {
              "x": 7.41,
              "y": 11.538,
              "z": 1.693
            },
            "gtin": "42420750",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdc3",
            "leftCorner": {
              "x": 7.41,
              "y": 11.538,
              "z": 1.693
            },
            "rightCorner": {
              "x": 7.4,
              "y": 11.41,
              "z": 1.693
            },
            "gtin": "4066447438642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdc4",
            "leftCorner": {
              "x": 7.4,
              "y": 11.41,
              "z": 1.693
            },
            "rightCorner": {
              "x": 7.393,
              "y": 11.327,
              "z": 1.693
            },
            "gtin": "4066447467635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdc5",
            "leftCorner": {
              "x": 7.393,
              "y": 11.327,
              "z": 1.693
            },
            "rightCorner": {
              "x": 7.39,
              "y": 11.276,
              "z": 1.693
            },
            "gtin": "4066447467659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdc6",
            "leftCorner": {
              "x": 7.39,
              "y": 11.276,
              "z": 1.693
            },
            "rightCorner": {
              "x": 7.384,
              "y": 11.205,
              "z": 1.693
            },
            "gtin": "4015100720754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdc7",
            "leftCorner": {
              "x": 7.384,
              "y": 11.205,
              "z": 1.693
            },
            "rightCorner": {
              "x": 7.378,
              "y": 11.126,
              "z": 1.693
            },
            "gtin": "4015100721843",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdc8",
            "leftCorner": {
              "x": 7.378,
              "y": 11.126,
              "z": 1.693
            },
            "rightCorner": {
              "x": 7.373,
              "y": 11.055,
              "z": 1.693
            },
            "gtin": "4005900936011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdc9",
            "leftCorner": {
              "x": 7.373,
              "y": 11.055,
              "z": 1.693
            },
            "rightCorner": {
              "x": 7.367,
              "y": 10.984,
              "z": 1.693
            },
            "gtin": "4005900936059",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdca",
            "leftCorner": {
              "x": 7.367,
              "y": 10.984,
              "z": 1.693
            },
            "rightCorner": {
              "x": 7.359,
              "y": 10.877,
              "z": 1.693
            },
            "gtin": "3600542460347",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdcb",
            "leftCorner": {
              "x": 7.359,
              "y": 10.877,
              "z": 1.693
            },
            "rightCorner": {
              "x": 7.353,
              "y": 10.792,
              "z": 1.693
            },
            "gtin": "3600542463386",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdcc",
            "leftCorner": {
              "x": 7.353,
              "y": 10.792,
              "z": 1.693
            },
            "rightCorner": {
              "x": 7.345,
              "y": 10.695,
              "z": 1.693
            },
            "gtin": "4065331001160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdcd",
            "leftCorner": {
              "x": 7.345,
              "y": 10.695,
              "z": 1.693
            },
            "rightCorner": {
              "x": 7.341,
              "y": 10.641,
              "z": 1.693
            },
            "gtin": "4045612010975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdcf",
            "leftCorner": {
              "x": 7.336,
              "y": 10.58,
              "z": 1.693
            },
            "rightCorner": {
              "x": 7.329,
              "y": 10.482,
              "z": 1.693
            },
            "gtin": "4066447782370",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757c5b5fe7bc046959a4d",
    "name": "68e757c5b5fe7bc046959a4d",
    "x": 7.378,
    "y": 10.533,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73309,
      "w": 0.68014
    },
    "statistics": {
      "hasStockCount": 41,
      "noStockCount": 0,
      "unknownStockCount": 30
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd738dc",
        "height": 0.20865,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fe58",
            "leftCorner": {
              "x": 7.329,
              "y": 10.483,
              "z": 0.209
            },
            "rightCorner": {
              "x": 7.322,
              "y": 10.386,
              "z": 0.209
            },
            "gtin": "4067796171037",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe59",
            "leftCorner": {
              "x": 7.322,
              "y": 10.386,
              "z": 0.209
            },
            "rightCorner": {
              "x": 7.313,
              "y": 10.276,
              "z": 0.209
            }
          },
          {
            "id": "696ebf6d43c343680a26fe5a",
            "leftCorner": {
              "x": 7.313,
              "y": 10.276,
              "z": 0.209
            },
            "rightCorner": {
              "x": 7.307,
              "y": 10.188,
              "z": 0.209
            },
            "gtin": "4030651053861",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe5b",
            "leftCorner": {
              "x": 7.307,
              "y": 10.188,
              "z": 0.209
            },
            "rightCorner": {
              "x": 7.3,
              "y": 10.103,
              "z": 0.209
            }
          },
          {
            "id": "696ebf6d43c343680a26fe5c",
            "leftCorner": {
              "x": 7.3,
              "y": 10.103,
              "z": 0.209
            },
            "rightCorner": {
              "x": 7.286,
              "y": 9.915,
              "z": 0.209
            },
            "gtin": "4062300445543",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe5d",
            "leftCorner": {
              "x": 7.286,
              "y": 9.915,
              "z": 0.209
            },
            "rightCorner": {
              "x": 7.282,
              "y": 9.854,
              "z": 0.209
            }
          },
          {
            "id": "696ebf6d43c343680a26fe5e",
            "leftCorner": {
              "x": 7.282,
              "y": 9.854,
              "z": 0.209
            },
            "rightCorner": {
              "x": 7.268,
              "y": 9.678,
              "z": 0.209
            }
          },
          {
            "id": "696ebf6d43c343680a26fe5f",
            "leftCorner": {
              "x": 7.268,
              "y": 9.678,
              "z": 0.209
            },
            "rightCorner": {
              "x": 7.255,
              "y": 9.492,
              "z": 0.209
            },
            "gtin": "4062300445475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe60",
            "leftCorner": {
              "x": 7.255,
              "y": 9.492,
              "z": 0.209
            },
            "rightCorner": {
              "x": 7.24,
              "y": 9.297,
              "z": 0.209
            },
            "gtin": "8001841041452",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738d5",
        "height": 0.51216,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fe0d",
            "leftCorner": {
              "x": 7.339,
              "y": 10.532,
              "z": 0.514
            },
            "rightCorner": {
              "x": 7.33,
              "y": 10.407,
              "z": 0.514
            },
            "gtin": "4008233181769",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe0e",
            "leftCorner": {
              "x": 7.324,
              "y": 10.415,
              "z": 0.512
            },
            "rightCorner": {
              "x": 7.316,
              "y": 10.308,
              "z": 0.512
            },
            "gtin": "4017512173418",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe0f",
            "leftCorner": {
              "x": 7.316,
              "y": 10.308,
              "z": 0.512
            },
            "rightCorner": {
              "x": 7.308,
              "y": 10.195,
              "z": 0.512
            },
            "gtin": "4059779068250",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe10",
            "leftCorner": {
              "x": 7.308,
              "y": 10.195,
              "z": 0.512
            },
            "rightCorner": {
              "x": 7.299,
              "y": 10.084,
              "z": 0.512
            },
            "gtin": "4030651053847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe11",
            "leftCorner": {
              "x": 7.299,
              "y": 10.084,
              "z": 0.512
            },
            "rightCorner": {
              "x": 7.295,
              "y": 10.019,
              "z": 0.512
            }
          },
          {
            "id": "696ebf6d43c343680a26fe12",
            "leftCorner": {
              "x": 7.295,
              "y": 10.019,
              "z": 0.512
            },
            "rightCorner": {
              "x": 7.285,
              "y": 9.886,
              "z": 0.512
            },
            "gtin": "4066447362817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe13",
            "leftCorner": {
              "x": 7.285,
              "y": 9.886,
              "z": 0.512
            },
            "rightCorner": {
              "x": 7.28,
              "y": 9.825,
              "z": 0.512
            }
          },
          {
            "id": "696ebf6d43c343680a26fe14",
            "leftCorner": {
              "x": 7.28,
              "y": 9.825,
              "z": 0.512
            },
            "rightCorner": {
              "x": 7.269,
              "y": 9.674,
              "z": 0.512
            },
            "gtin": "4066447518634",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe15",
            "leftCorner": {
              "x": 7.269,
              "y": 9.674,
              "z": 0.512
            },
            "rightCorner": {
              "x": 7.253,
              "y": 9.467,
              "z": 0.512
            },
            "gtin": "4058172997105",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe16",
            "leftCorner": {
              "x": 7.253,
              "y": 9.467,
              "z": 0.512
            },
            "rightCorner": {
              "x": 7.235,
              "y": 9.223,
              "z": 0.512
            },
            "gtin": "4058172996931",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738d8",
        "height": 0.80522,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fed6",
            "leftCorner": {
              "x": 7.335,
              "y": 10.536,
              "z": 0.805
            },
            "rightCorner": {
              "x": 7.328,
              "y": 10.448,
              "z": 0.805
            },
            "gtin": "4011448001104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fed8",
            "leftCorner": {
              "x": 7.328,
              "y": 10.448,
              "z": 0.805
            },
            "rightCorner": {
              "x": 7.321,
              "y": 10.351,
              "z": 0.805
            },
            "gtin": "4011448007007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fed9",
            "leftCorner": {
              "x": 7.321,
              "y": 10.351,
              "z": 0.805
            },
            "rightCorner": {
              "x": 7.313,
              "y": 10.24,
              "z": 0.805
            },
            "gtin": "4008491112192",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26feda",
            "leftCorner": {
              "x": 7.313,
              "y": 10.24,
              "z": 0.805
            },
            "rightCorner": {
              "x": 7.297,
              "y": 10.024,
              "z": 0.805
            },
            "gtin": "4008491111843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fedb",
            "leftCorner": {
              "x": 7.297,
              "y": 10.024,
              "z": 0.805
            },
            "rightCorner": {
              "x": 7.285,
              "y": 9.871,
              "z": 0.805
            },
            "gtin": "4008491112642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fedc",
            "leftCorner": {
              "x": 7.285,
              "y": 9.871,
              "z": 0.805
            },
            "rightCorner": {
              "x": 7.279,
              "y": 9.797,
              "z": 0.805
            },
            "gtin": "4260401414769",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fedd",
            "leftCorner": {
              "x": 7.279,
              "y": 9.797,
              "z": 0.805
            },
            "rightCorner": {
              "x": 7.274,
              "y": 9.725,
              "z": 0.805
            },
            "gtin": "4260401410778",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fede",
            "leftCorner": {
              "x": 7.274,
              "y": 9.725,
              "z": 0.805
            },
            "rightCorner": {
              "x": 7.269,
              "y": 9.655,
              "z": 0.805
            },
            "gtin": "4260401410808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fedf",
            "leftCorner": {
              "x": 7.269,
              "y": 9.655,
              "z": 0.805
            },
            "rightCorner": {
              "x": 7.264,
              "y": 9.596,
              "z": 0.805
            },
            "gtin": "4260401411904",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fee0",
            "leftCorner": {
              "x": 7.264,
              "y": 9.596,
              "z": 0.805
            },
            "rightCorner": {
              "x": 7.259,
              "y": 9.529,
              "z": 0.805
            },
            "gtin": "4260401410686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fee1",
            "leftCorner": {
              "x": 7.259,
              "y": 9.529,
              "z": 0.805
            },
            "rightCorner": {
              "x": 7.255,
              "y": 9.472,
              "z": 0.805
            },
            "gtin": "4260401414707",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fee2",
            "leftCorner": {
              "x": 7.255,
              "y": 9.472,
              "z": 0.805
            },
            "rightCorner": {
              "x": 7.249,
              "y": 9.386,
              "z": 0.805
            },
            "gtin": "4066447256734",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fee3",
            "leftCorner": {
              "x": 7.249,
              "y": 9.386,
              "z": 0.805
            },
            "rightCorner": {
              "x": 7.242,
              "y": 9.293,
              "z": 0.805
            },
            "gtin": "4066447888720",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738d9",
        "height": 1.0604,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fef5",
            "leftCorner": {
              "x": 7.335,
              "y": 10.536,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.326,
              "y": 10.424,
              "z": 1.06
            },
            "gtin": "4065331000682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fef6",
            "leftCorner": {
              "x": 7.326,
              "y": 10.424,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.319,
              "y": 10.328,
              "z": 1.06
            },
            "gtin": "4065331001542",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fef7",
            "leftCorner": {
              "x": 7.319,
              "y": 10.328,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.313,
              "y": 10.244,
              "z": 1.06
            },
            "gtin": "4065331000330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fef8",
            "leftCorner": {
              "x": 7.313,
              "y": 10.244,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.306,
              "y": 10.161,
              "z": 1.06
            },
            "gtin": "4065331000064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fef9",
            "leftCorner": {
              "x": 7.306,
              "y": 10.161,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.302,
              "y": 10.099,
              "z": 1.06
            },
            "gtin": "4065331000323",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fefa",
            "leftCorner": {
              "x": 7.302,
              "y": 10.099,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.297,
              "y": 10.035,
              "z": 1.06
            },
            "gtin": "4065331000781",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fefb",
            "leftCorner": {
              "x": 7.297,
              "y": 10.035,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.292,
              "y": 9.97,
              "z": 1.06
            },
            "gtin": "4065331000026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fefc",
            "leftCorner": {
              "x": 7.292,
              "y": 9.97,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.286,
              "y": 9.893,
              "z": 1.06
            },
            "gtin": "4065331000033",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fefd",
            "leftCorner": {
              "x": 7.286,
              "y": 9.893,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.28,
              "y": 9.814,
              "z": 1.06
            },
            "gtin": "4065331000040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fefe",
            "leftCorner": {
              "x": 7.28,
              "y": 9.814,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.275,
              "y": 9.742,
              "z": 1.06
            },
            "gtin": "4065331000040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26feff",
            "leftCorner": {
              "x": 7.275,
              "y": 9.742,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.27,
              "y": 9.676,
              "z": 1.06
            },
            "gtin": "4065331000019",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff00",
            "leftCorner": {
              "x": 7.27,
              "y": 9.676,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.265,
              "y": 9.61,
              "z": 1.06
            },
            "gtin": "42420743",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff01",
            "leftCorner": {
              "x": 7.265,
              "y": 9.61,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.26,
              "y": 9.548,
              "z": 1.06
            },
            "gtin": "4065331005175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff02",
            "leftCorner": {
              "x": 7.26,
              "y": 9.548,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.256,
              "y": 9.489,
              "z": 1.06
            },
            "gtin": "4065331005212",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff03",
            "leftCorner": {
              "x": 7.256,
              "y": 9.489,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.249,
              "y": 9.398,
              "z": 1.06
            },
            "gtin": "4065331005106",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff04",
            "leftCorner": {
              "x": 7.249,
              "y": 9.398,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.247,
              "y": 9.37,
              "z": 1.06
            },
            "gtin": "4065331000743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff05",
            "leftCorner": {
              "x": 7.247,
              "y": 9.37,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.24,
              "y": 9.273,
              "z": 1.06
            },
            "gtin": "4065331000767",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738d7",
        "height": 1.3567,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fe83",
            "leftCorner": {
              "x": 7.336,
              "y": 10.536,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.331,
              "y": 10.479,
              "z": 1.357
            },
            "gtin": "4001638523134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe85",
            "leftCorner": {
              "x": 7.331,
              "y": 10.479,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.327,
              "y": 10.416,
              "z": 1.357
            },
            "gtin": "4001638523134",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe86",
            "leftCorner": {
              "x": 7.327,
              "y": 10.416,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.323,
              "y": 10.361,
              "z": 1.357
            },
            "gtin": "4001638523127",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe87",
            "leftCorner": {
              "x": 7.323,
              "y": 10.361,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.317,
              "y": 10.292,
              "z": 1.357
            },
            "gtin": "4001638096560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe88",
            "leftCorner": {
              "x": 7.317,
              "y": 10.292,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.313,
              "y": 10.233,
              "z": 1.357
            },
            "gtin": "4001638590235",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe89",
            "leftCorner": {
              "x": 7.313,
              "y": 10.233,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.305,
              "y": 10.123,
              "z": 1.357
            },
            "gtin": "4001638523165",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe8a",
            "leftCorner": {
              "x": 7.305,
              "y": 10.123,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.301,
              "y": 10.074,
              "z": 1.357
            },
            "gtin": "4001638523165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe8b",
            "leftCorner": {
              "x": 7.301,
              "y": 10.074,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.289,
              "y": 9.918,
              "z": 1.357
            },
            "gtin": "4001638523189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe8c",
            "leftCorner": {
              "x": 7.289,
              "y": 9.918,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.28,
              "y": 9.799,
              "z": 1.357
            }
          },
          {
            "id": "696ebf6d43c343680a26fe8d",
            "leftCorner": {
              "x": 7.28,
              "y": 9.799,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.276,
              "y": 9.735,
              "z": 1.357
            },
            "gtin": "4001638590440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe8e",
            "leftCorner": {
              "x": 7.276,
              "y": 9.735,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.272,
              "y": 9.683,
              "z": 1.357
            },
            "gtin": "4001638590433",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe8f",
            "leftCorner": {
              "x": 7.272,
              "y": 9.683,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.268,
              "y": 9.637,
              "z": 1.357
            },
            "gtin": "4001638590679",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe90",
            "leftCorner": {
              "x": 7.268,
              "y": 9.637,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.264,
              "y": 9.586,
              "z": 1.357
            },
            "gtin": "4001638590402",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe91",
            "leftCorner": {
              "x": 7.264,
              "y": 9.586,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.257,
              "y": 9.488,
              "z": 1.357
            },
            "gtin": "3574661266787",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe92",
            "leftCorner": {
              "x": 7.257,
              "y": 9.488,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.249,
              "y": 9.377,
              "z": 1.357
            },
            "gtin": "3574661264455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe93",
            "leftCorner": {
              "x": 7.249,
              "y": 9.377,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.241,
              "y": 9.268,
              "z": 1.357
            },
            "gtin": "3574661606033",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8b3b88e258afd738d6",
        "height": 1.692,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fdd0",
            "leftCorner": {
              "x": 7.328,
              "y": 10.489,
              "z": 1.692
            },
            "rightCorner": {
              "x": 7.321,
              "y": 10.389,
              "z": 1.692
            },
            "gtin": "4066447782295",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdd1",
            "leftCorner": {
              "x": 7.321,
              "y": 10.389,
              "z": 1.692
            },
            "rightCorner": {
              "x": 7.303,
              "y": 10.157,
              "z": 1.692
            },
            "gtin": "4066447782431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdd2",
            "leftCorner": {
              "x": 7.303,
              "y": 10.157,
              "z": 1.692
            },
            "rightCorner": {
              "x": 7.283,
              "y": 9.89,
              "z": 1.692
            },
            "gtin": "4066447857955",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdd3",
            "leftCorner": {
              "x": 7.283,
              "y": 9.89,
              "z": 1.692
            },
            "rightCorner": {
              "x": 7.28,
              "y": 9.849,
              "z": 1.692
            },
            "gtin": "4066447857955",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdd4",
            "leftCorner": {
              "x": 7.28,
              "y": 9.849,
              "z": 1.692
            },
            "rightCorner": {
              "x": 7.277,
              "y": 9.808,
              "z": 1.692
            },
            "gtin": "4063528082954",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdd5",
            "leftCorner": {
              "x": 7.277,
              "y": 9.808,
              "z": 1.692
            },
            "rightCorner": {
              "x": 7.265,
              "y": 9.644,
              "z": 1.692
            },
            "gtin": "4021457660612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdd6",
            "leftCorner": {
              "x": 7.265,
              "y": 9.644,
              "z": 1.692
            },
            "rightCorner": {
              "x": 7.261,
              "y": 9.598,
              "z": 1.692
            },
            "gtin": "4021457660650",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdd7",
            "leftCorner": {
              "x": 7.261,
              "y": 9.598,
              "z": 1.692
            },
            "rightCorner": {
              "x": 7.258,
              "y": 9.547,
              "z": 1.692
            },
            "gtin": "4021457660599",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdd8",
            "leftCorner": {
              "x": 7.258,
              "y": 9.547,
              "z": 1.692
            },
            "rightCorner": {
              "x": 7.254,
              "y": 9.492,
              "z": 1.692
            },
            "gtin": "4103040898241",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdd9",
            "leftCorner": {
              "x": 7.254,
              "y": 9.492,
              "z": 1.692
            },
            "rightCorner": {
              "x": 7.247,
              "y": 9.411,
              "z": 1.692
            },
            "gtin": "4103040009234",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdda",
            "leftCorner": {
              "x": 7.247,
              "y": 9.411,
              "z": 1.692
            },
            "rightCorner": {
              "x": 7.245,
              "y": 9.375,
              "z": 1.692
            },
            "gtin": "4103040009210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fddb",
            "leftCorner": {
              "x": 7.235,
              "y": 9.378,
              "z": 1.69
            },
            "rightCorner": {
              "x": 7.231,
              "y": 9.329,
              "z": 1.69
            },
            "gtin": "4102963001509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fddc",
            "leftCorner": {
              "x": 7.231,
              "y": 9.329,
              "z": 1.69
            },
            "rightCorner": {
              "x": 7.228,
              "y": 9.286,
              "z": 1.69
            },
            "gtin": "41029671",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757c5b5fe7bc046959a4e",
    "name": "68e757c5b5fe7bc046959a4e",
    "x": 7.28,
    "y": 9.2889,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73303,
      "w": 0.68019
    },
    "statistics": {
      "hasStockCount": 44,
      "noStockCount": 2,
      "unknownStockCount": 25
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd738e2",
        "height": 0.20409,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fe61",
            "leftCorner": {
              "x": 7.24,
              "y": 9.297,
              "z": 0.209
            },
            "rightCorner": {
              "x": 7.227,
              "y": 9.128,
              "z": 0.209
            },
            "gtin": "8001841078175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe62",
            "leftCorner": {
              "x": 7.222,
              "y": 9.131,
              "z": 0.204
            },
            "rightCorner": {
              "x": 7.209,
              "y": 8.957,
              "z": 0.204
            },
            "gtin": "8006540556139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe63",
            "leftCorner": {
              "x": 7.209,
              "y": 8.957,
              "z": 0.204
            },
            "rightCorner": {
              "x": 7.197,
              "y": 8.796,
              "z": 0.204
            },
            "gtin": "4006000028415",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe64",
            "leftCorner": {
              "x": 7.197,
              "y": 8.796,
              "z": 0.204
            },
            "rightCorner": {
              "x": 7.179,
              "y": 8.553,
              "z": 0.204
            },
            "gtin": "5099514002735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe65",
            "leftCorner": {
              "x": 7.179,
              "y": 8.553,
              "z": 0.204
            },
            "rightCorner": {
              "x": 7.166,
              "y": 8.38,
              "z": 0.204
            },
            "gtin": "4066447909548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe66",
            "leftCorner": {
              "x": 7.166,
              "y": 8.38,
              "z": 0.204
            },
            "rightCorner": {
              "x": 7.144,
              "y": 8.091,
              "z": 0.204
            },
            "gtin": "4066447442045",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738e1",
        "height": 0.51767,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fe17",
            "leftCorner": {
              "x": 7.225,
              "y": 9.227,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.219,
              "y": 9.152,
              "z": 0.518
            },
            "gtin": "4066447377361",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe18",
            "leftCorner": {
              "x": 7.219,
              "y": 9.152,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.214,
              "y": 9.089,
              "z": 0.518
            },
            "gtin": "4066447355154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe19",
            "leftCorner": {
              "x": 7.214,
              "y": 9.089,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.21,
              "y": 9.024,
              "z": 0.518
            },
            "gtin": "4067796083255",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe1a",
            "leftCorner": {
              "x": 7.21,
              "y": 9.024,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.204,
              "y": 8.951,
              "z": 0.518
            },
            "gtin": "4066447354829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe1b",
            "leftCorner": {
              "x": 7.204,
              "y": 8.951,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.199,
              "y": 8.887,
              "z": 0.518
            }
          },
          {
            "id": "696ebf6d43c343680a26fe1c",
            "leftCorner": {
              "x": 7.199,
              "y": 8.887,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.192,
              "y": 8.791,
              "z": 0.518
            },
            "gtin": "4262368740356",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe1d",
            "leftCorner": {
              "x": 7.192,
              "y": 8.791,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.186,
              "y": 8.708,
              "z": 0.518
            },
            "gtin": "4262368740356",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe1e",
            "leftCorner": {
              "x": 7.186,
              "y": 8.708,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.176,
              "y": 8.571,
              "z": 0.518
            },
            "gtin": "4262368742176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe1f",
            "leftCorner": {
              "x": 7.176,
              "y": 8.571,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.168,
              "y": 8.463,
              "z": 0.518
            },
            "gtin": "4251758435439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe20",
            "leftCorner": {
              "x": 7.168,
              "y": 8.463,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.161,
              "y": 8.375,
              "z": 0.518
            },
            "gtin": "4251758434180",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe21",
            "leftCorner": {
              "x": 7.161,
              "y": 8.375,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.156,
              "y": 8.309,
              "z": 0.518
            },
            "gtin": "4251758434081",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe22",
            "leftCorner": {
              "x": 7.156,
              "y": 8.309,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.149,
              "y": 8.221,
              "z": 0.518
            },
            "gtin": "4251758434005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe23",
            "leftCorner": {
              "x": 7.149,
              "y": 8.221,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.143,
              "y": 8.135,
              "z": 0.518
            },
            "gtin": "4251758434005",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fdff",
            "leftCorner": {
              "x": 7.143,
              "y": 8.135,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.136,
              "y": 8.046,
              "z": 0.518
            },
            "gtin": "4002448134640",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738de",
        "height": 0.80566,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fee4",
            "leftCorner": {
              "x": 7.242,
              "y": 9.293,
              "z": 0.805
            },
            "rightCorner": {
              "x": 7.236,
              "y": 9.22,
              "z": 0.805
            },
            "gtin": "4066447256666",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fee5",
            "leftCorner": {
              "x": 7.228,
              "y": 9.223,
              "z": 0.806
            },
            "rightCorner": {
              "x": 7.218,
              "y": 9.095,
              "z": 0.806
            },
            "gtin": "4066447710007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fee6",
            "leftCorner": {
              "x": 7.218,
              "y": 9.095,
              "z": 0.806
            },
            "rightCorner": {
              "x": 7.206,
              "y": 8.929,
              "z": 0.806
            },
            "gtin": "4066447412536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fee7",
            "leftCorner": {
              "x": 7.206,
              "y": 8.929,
              "z": 0.806
            },
            "rightCorner": {
              "x": 7.202,
              "y": 8.877,
              "z": 0.806
            },
            "gtin": "4066447709780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fee8",
            "leftCorner": {
              "x": 7.202,
              "y": 8.877,
              "z": 0.806
            },
            "rightCorner": {
              "x": 7.198,
              "y": 8.828,
              "z": 0.806
            },
            "gtin": "4066447709780",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fee9",
            "leftCorner": {
              "x": 7.198,
              "y": 8.828,
              "z": 0.806
            },
            "rightCorner": {
              "x": 7.193,
              "y": 8.757,
              "z": 0.806
            },
            "gtin": "4066447256710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26feea",
            "leftCorner": {
              "x": 7.193,
              "y": 8.757,
              "z": 0.806
            },
            "rightCorner": {
              "x": 7.18,
              "y": 8.588,
              "z": 0.806
            },
            "gtin": "4066447394924",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26feeb",
            "leftCorner": {
              "x": 7.18,
              "y": 8.588,
              "z": 0.806
            },
            "rightCorner": {
              "x": 7.171,
              "y": 8.462,
              "z": 0.806
            },
            "gtin": "4066447876277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26feec",
            "leftCorner": {
              "x": 7.171,
              "y": 8.462,
              "z": 0.806
            },
            "rightCorner": {
              "x": 7.164,
              "y": 8.37,
              "z": 0.806
            },
            "gtin": "4066447712995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26feed",
            "leftCorner": {
              "x": 7.164,
              "y": 8.37,
              "z": 0.806
            },
            "rightCorner": {
              "x": 7.157,
              "y": 8.284,
              "z": 0.806
            },
            "gtin": "4066447671285",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26feee",
            "leftCorner": {
              "x": 7.157,
              "y": 8.284,
              "z": 0.806
            },
            "rightCorner": {
              "x": 7.141,
              "y": 8.06,
              "z": 0.806
            },
            "gtin": "4066447442021",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26feef",
            "leftCorner": {
              "x": 7.141,
              "y": 8.06,
              "z": 0.806
            },
            "rightCorner": {
              "x": 7.126,
              "y": 7.86,
              "z": 0.806
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738dd",
        "height": 1.0604,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ff06",
            "leftCorner": {
              "x": 7.238,
              "y": 9.276,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.229,
              "y": 9.153,
              "z": 1.06
            },
            "gtin": "4065331000705",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff07",
            "leftCorner": {
              "x": 7.229,
              "y": 9.153,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.223,
              "y": 9.074,
              "z": 1.06
            },
            "gtin": "3574661727073",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff08",
            "leftCorner": {
              "x": 7.223,
              "y": 9.074,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.22,
              "y": 9.028,
              "z": 1.06
            },
            "gtin": "3574661727073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff09",
            "leftCorner": {
              "x": 7.22,
              "y": 9.028,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.214,
              "y": 8.949,
              "z": 1.06
            },
            "gtin": "3574661264431",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff0a",
            "leftCorner": {
              "x": 7.214,
              "y": 8.949,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.207,
              "y": 8.863,
              "z": 1.06
            },
            "gtin": "3574661474939",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff0b",
            "leftCorner": {
              "x": 7.207,
              "y": 8.863,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.2,
              "y": 8.766,
              "z": 1.06
            },
            "gtin": "3574661474953",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff0c",
            "leftCorner": {
              "x": 7.2,
              "y": 8.766,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.192,
              "y": 8.655,
              "z": 1.06
            },
            "gtin": "3574661474915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff0d",
            "leftCorner": {
              "x": 7.192,
              "y": 8.655,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.182,
              "y": 8.527,
              "z": 1.06
            },
            "gtin": "4066447710120",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff0e",
            "leftCorner": {
              "x": 7.182,
              "y": 8.527,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.177,
              "y": 8.452,
              "z": 1.06
            },
            "gtin": "4066447710144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff0f",
            "leftCorner": {
              "x": 7.177,
              "y": 8.452,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.17,
              "y": 8.365,
              "z": 1.06
            },
            "gtin": "4066447710021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff10",
            "leftCorner": {
              "x": 7.17,
              "y": 8.365,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.164,
              "y": 8.284,
              "z": 1.06
            },
            "gtin": "4066447710021",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff11",
            "leftCorner": {
              "x": 7.164,
              "y": 8.284,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.16,
              "y": 8.229,
              "z": 1.06
            }
          },
          {
            "id": "696ebf6d43c343680a26ff12",
            "leftCorner": {
              "x": 7.16,
              "y": 8.229,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.155,
              "y": 8.163,
              "z": 1.06
            },
            "gtin": "4066447256703",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff13",
            "leftCorner": {
              "x": 7.155,
              "y": 8.163,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.149,
              "y": 8.085,
              "z": 1.06
            },
            "gtin": "4066447876253",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738e0",
        "height": 1.3599,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fe94",
            "leftCorner": {
              "x": 7.228,
              "y": 9.271,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.22,
              "y": 9.164,
              "z": 1.36
            },
            "gtin": "3574661818207",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe95",
            "leftCorner": {
              "x": 7.22,
              "y": 9.164,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.215,
              "y": 9.087,
              "z": 1.36
            },
            "gtin": "3574661817064",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe96",
            "leftCorner": {
              "x": 7.215,
              "y": 9.087,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.209,
              "y": 9.013,
              "z": 1.36
            },
            "gtin": "3574661500553",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe97",
            "leftCorner": {
              "x": 7.209,
              "y": 9.013,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.204,
              "y": 8.947,
              "z": 1.36
            },
            "gtin": "3574661816005",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe98",
            "leftCorner": {
              "x": 7.204,
              "y": 8.947,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.197,
              "y": 8.855,
              "z": 1.36
            },
            "gtin": "3574661474960",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe99",
            "leftCorner": {
              "x": 7.197,
              "y": 8.855,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.19,
              "y": 8.759,
              "z": 1.36
            },
            "gtin": "3574661264448",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe9a",
            "leftCorner": {
              "x": 7.19,
              "y": 8.759,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.182,
              "y": 8.648,
              "z": 1.36
            },
            "gtin": "3574661821344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe9b",
            "leftCorner": {
              "x": 7.182,
              "y": 8.648,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.173,
              "y": 8.537,
              "z": 1.36
            },
            "gtin": "3574661821337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe9c",
            "leftCorner": {
              "x": 7.173,
              "y": 8.537,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.167,
              "y": 8.448,
              "z": 1.36
            },
            "gtin": "42439516",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe9d",
            "leftCorner": {
              "x": 7.167,
              "y": 8.448,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.163,
              "y": 8.395,
              "z": 1.36
            },
            "gtin": "42241249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe9e",
            "leftCorner": {
              "x": 7.163,
              "y": 8.395,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.16,
              "y": 8.355,
              "z": 1.36
            },
            "gtin": "42241249",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe9f",
            "leftCorner": {
              "x": 7.16,
              "y": 8.355,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.155,
              "y": 8.298,
              "z": 1.36
            },
            "gtin": "42241225",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fea0",
            "leftCorner": {
              "x": 7.155,
              "y": 8.298,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.151,
              "y": 8.243,
              "z": 1.36
            },
            "gtin": "4260702189403",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fea1",
            "leftCorner": {
              "x": 7.151,
              "y": 8.243,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.147,
              "y": 8.181,
              "z": 1.36
            },
            "gtin": "4260474730995",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fea2",
            "leftCorner": {
              "x": 7.147,
              "y": 8.181,
              "z": 1.36
            },
            "rightCorner": {
              "x": 7.138,
              "y": 8.062,
              "z": 1.36
            },
            "gtin": "4066447107159",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fea3",
            "leftCorner": {
              "x": 7.14,
              "y": 8.062,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.133,
              "y": 7.966,
              "z": 1.357
            },
            "gtin": "4066447710243",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738df",
        "height": 1.6897,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fddd",
            "leftCorner": {
              "x": 7.226,
              "y": 9.264,
              "z": 1.69
            },
            "rightCorner": {
              "x": 7.214,
              "y": 9.1,
              "z": 1.69
            },
            "gtin": "4102963301135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdde",
            "leftCorner": {
              "x": 7.214,
              "y": 9.1,
              "z": 1.69
            },
            "rightCorner": {
              "x": 7.207,
              "y": 9.015,
              "z": 1.69
            },
            "gtin": "4062300419391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fddf",
            "leftCorner": {
              "x": 7.207,
              "y": 9.015,
              "z": 1.69
            },
            "rightCorner": {
              "x": 7.201,
              "y": 8.935,
              "z": 1.69
            },
            "gtin": "4062300419421",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fde0",
            "leftCorner": {
              "x": 7.201,
              "y": 8.935,
              "z": 1.69
            },
            "rightCorner": {
              "x": 7.196,
              "y": 8.864,
              "z": 1.69
            },
            "gtin": "42428268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fde1",
            "leftCorner": {
              "x": 7.196,
              "y": 8.864,
              "z": 1.69
            },
            "rightCorner": {
              "x": 7.189,
              "y": 8.763,
              "z": 1.69
            },
            "gtin": "42241294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fde2",
            "leftCorner": {
              "x": 7.189,
              "y": 8.763,
              "z": 1.69
            },
            "rightCorner": {
              "x": 7.178,
              "y": 8.624,
              "z": 1.69
            },
            "gtin": "42241287",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fde3",
            "leftCorner": {
              "x": 7.178,
              "y": 8.624,
              "z": 1.69
            },
            "rightCorner": {
              "x": 7.171,
              "y": 8.526,
              "z": 1.69
            },
            "gtin": "42241317",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fde4",
            "leftCorner": {
              "x": 7.171,
              "y": 8.526,
              "z": 1.69
            },
            "rightCorner": {
              "x": 7.165,
              "y": 8.455,
              "z": 1.69
            },
            "gtin": "4062300419377",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fde5",
            "leftCorner": {
              "x": 7.165,
              "y": 8.455,
              "z": 1.69
            },
            "rightCorner": {
              "x": 7.16,
              "y": 8.384,
              "z": 1.69
            },
            "gtin": "4062300419384",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fde6",
            "leftCorner": {
              "x": 7.16,
              "y": 8.384,
              "z": 1.69
            },
            "rightCorner": {
              "x": 7.155,
              "y": 8.318,
              "z": 1.69
            },
            "gtin": "4062300419445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fde7",
            "leftCorner": {
              "x": 7.155,
              "y": 8.318,
              "z": 1.69
            },
            "rightCorner": {
              "x": 7.152,
              "y": 8.275,
              "z": 1.69
            },
            "gtin": "4062300419414",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fde8",
            "leftCorner": {
              "x": 7.152,
              "y": 8.275,
              "z": 1.69
            },
            "rightCorner": {
              "x": 7.147,
              "y": 8.212,
              "z": 1.69
            },
            "gtin": "4062300419452",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757c5b5fe7bc046959a4f",
    "name": "68e757c5b5fe7bc046959a4f",
    "x": 7.1826,
    "y": 8.0583,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73635,
      "w": 0.6766
    },
    "statistics": {
      "hasStockCount": 26,
      "noStockCount": 1,
      "unknownStockCount": 8
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd738e7",
        "height": 0.20202,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fe67",
            "leftCorner": {
              "x": 7.144,
              "y": 8.091,
              "z": 0.204
            },
            "rightCorner": {
              "x": 7.128,
              "y": 7.873,
              "z": 0.204
            },
            "gtin": "4067796220506",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe68",
            "leftCorner": {
              "x": 7.123,
              "y": 7.89,
              "z": 0.202
            },
            "rightCorner": {
              "x": 7.085,
              "y": 7.444,
              "z": 0.202
            },
            "gtin": "4067796061635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe69",
            "leftCorner": {
              "x": 7.085,
              "y": 7.444,
              "z": 0.202
            },
            "rightCorner": {
              "x": 7.033,
              "y": 6.83,
              "z": 0.202
            },
            "gtin": "4066447442069",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738e4",
        "height": 0.80726,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fef0",
            "leftCorner": {
              "x": 7.127,
              "y": 7.876,
              "z": 0.807
            },
            "rightCorner": {
              "x": 7.114,
              "y": 7.723,
              "z": 0.807
            },
            "gtin": "5038278014103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fef1",
            "leftCorner": {
              "x": 7.114,
              "y": 7.723,
              "z": 0.807
            },
            "rightCorner": {
              "x": 7.094,
              "y": 7.489,
              "z": 0.807
            },
            "gtin": "4066447442007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fef2",
            "leftCorner": {
              "x": 7.094,
              "y": 7.489,
              "z": 0.807
            },
            "rightCorner": {
              "x": 7.076,
              "y": 7.27,
              "z": 0.807
            },
            "gtin": "4066447382914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fef3",
            "leftCorner": {
              "x": 7.076,
              "y": 7.27,
              "z": 0.807
            },
            "rightCorner": {
              "x": 7.058,
              "y": 7.059,
              "z": 0.807
            },
            "gtin": "4066447783384",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fed7",
            "leftCorner": {
              "x": 7.058,
              "y": 7.059,
              "z": 0.807
            },
            "rightCorner": {
              "x": 7.037,
              "y": 6.816,
              "z": 0.807
            },
            "gtin": "4066447533835",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738e3",
        "height": 1.0617,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ff14",
            "leftCorner": {
              "x": 7.149,
              "y": 8.085,
              "z": 1.06
            },
            "rightCorner": {
              "x": 7.141,
              "y": 7.978,
              "z": 1.06
            },
            "gtin": "4066447876314",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff15",
            "leftCorner": {
              "x": 7.137,
              "y": 7.994,
              "z": 1.062
            },
            "rightCorner": {
              "x": 7.129,
              "y": 7.895,
              "z": 1.062
            },
            "gtin": "4066447520125",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff16",
            "leftCorner": {
              "x": 7.129,
              "y": 7.895,
              "z": 1.062
            },
            "rightCorner": {
              "x": 7.117,
              "y": 7.756,
              "z": 1.062
            },
            "gtin": "4066447111293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff17",
            "leftCorner": {
              "x": 7.117,
              "y": 7.756,
              "z": 1.062
            },
            "rightCorner": {
              "x": 7.101,
              "y": 7.57,
              "z": 1.062
            },
            "gtin": "4058172893063",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff18",
            "leftCorner": {
              "x": 7.101,
              "y": 7.57,
              "z": 1.062
            },
            "rightCorner": {
              "x": 7.088,
              "y": 7.415,
              "z": 1.062
            },
            "gtin": "4066447382891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff19",
            "leftCorner": {
              "x": 7.088,
              "y": 7.415,
              "z": 1.062
            },
            "rightCorner": {
              "x": 7.077,
              "y": 7.288,
              "z": 1.062
            },
            "gtin": "4066447519457",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff1a",
            "leftCorner": {
              "x": 7.077,
              "y": 7.288,
              "z": 1.062
            },
            "rightCorner": {
              "x": 7.066,
              "y": 7.151,
              "z": 1.062
            },
            "gtin": "4066447858099",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff1b",
            "leftCorner": {
              "x": 7.066,
              "y": 7.151,
              "z": 1.062
            },
            "rightCorner": {
              "x": 7.046,
              "y": 6.921,
              "z": 1.062
            },
            "gtin": "4058172801440",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fef4",
            "leftCorner": {
              "x": 7.046,
              "y": 6.921,
              "z": 1.062
            },
            "rightCorner": {
              "x": 7.037,
              "y": 6.816,
              "z": 1.062
            },
            "gtin": "3600542512954",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738e5",
        "height": 1.3572,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fea4",
            "leftCorner": {
              "x": 7.132,
              "y": 7.966,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.127,
              "y": 7.907,
              "z": 1.357
            },
            "gtin": "4066447106299",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fea5",
            "leftCorner": {
              "x": 7.127,
              "y": 7.907,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.12,
              "y": 7.83,
              "z": 1.357
            },
            "gtin": "4066447786460",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fea6",
            "leftCorner": {
              "x": 7.12,
              "y": 7.83,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.114,
              "y": 7.752,
              "z": 1.357
            },
            "gtin": "4066447106428",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fea7",
            "leftCorner": {
              "x": 7.114,
              "y": 7.752,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.108,
              "y": 7.688,
              "z": 1.357
            },
            "gtin": "4066447578270",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fea8",
            "leftCorner": {
              "x": 7.108,
              "y": 7.688,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.099,
              "y": 7.576,
              "z": 1.357
            },
            "gtin": "4066447578256",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fea9",
            "leftCorner": {
              "x": 7.099,
              "y": 7.576,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.091,
              "y": 7.485,
              "z": 1.357
            },
            "gtin": "4066447578171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26feaa",
            "leftCorner": {
              "x": 7.091,
              "y": 7.485,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.086,
              "y": 7.423,
              "z": 1.357
            },
            "gtin": "4066447502763",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26feab",
            "leftCorner": {
              "x": 7.086,
              "y": 7.423,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.082,
              "y": 7.374,
              "z": 1.357
            },
            "gtin": "4066447786422",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26feac",
            "leftCorner": {
              "x": 7.082,
              "y": 7.374,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.078,
              "y": 7.329,
              "z": 1.357
            },
            "gtin": "4067796128499",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fead",
            "leftCorner": {
              "x": 7.078,
              "y": 7.329,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.073,
              "y": 7.273,
              "z": 1.357
            },
            "gtin": "4066447502725",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26feae",
            "leftCorner": {
              "x": 7.073,
              "y": 7.273,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.066,
              "y": 7.192,
              "z": 1.357
            },
            "gtin": "4066447578232",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26feaf",
            "leftCorner": {
              "x": 7.066,
              "y": 7.192,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.062,
              "y": 7.14,
              "z": 1.357
            },
            "gtin": "4067796084818",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26feb0",
            "leftCorner": {
              "x": 7.062,
              "y": 7.14,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.055,
              "y": 7.055,
              "z": 1.357
            },
            "gtin": "4006000130958",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26feb1",
            "leftCorner": {
              "x": 7.055,
              "y": 7.055,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.047,
              "y": 6.962,
              "z": 1.357
            },
            "gtin": "4005900721334",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26feb2",
            "leftCorner": {
              "x": 7.047,
              "y": 6.962,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.036,
              "y": 6.831,
              "z": 1.357
            },
            "gtin": "4005900906304",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738e6",
        "height": 1.6971,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fde9",
            "leftCorner": {
              "x": 7.147,
              "y": 8.212,
              "z": 1.69
            },
            "rightCorner": {
              "x": 7.123,
              "y": 7.887,
              "z": 1.69
            },
            "gtin": "4066447750829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdea",
            "leftCorner": {
              "x": 7.123,
              "y": 7.903,
              "z": 1.697
            },
            "rightCorner": {
              "x": 7.1,
              "y": 7.627,
              "z": 1.697
            },
            "gtin": "4067796178791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fdeb",
            "leftCorner": {
              "x": 7.1,
              "y": 7.627,
              "z": 1.697
            },
            "rightCorner": {
              "x": 7.081,
              "y": 7.406,
              "z": 1.697
            }
          },
          {
            "id": "696ebf6d43c343680a26fdec",
            "leftCorner": {
              "x": 7.081,
              "y": 7.406,
              "z": 1.697
            },
            "rightCorner": {
              "x": 7.056,
              "y": 7.106,
              "z": 1.697
            },
            "gtin": "4066447885217",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fded",
            "leftCorner": {
              "x": 7.056,
              "y": 7.106,
              "z": 1.697
            },
            "rightCorner": {
              "x": 7.033,
              "y": 6.837,
              "z": 1.697
            }
          }
        ]
      }
    ]
  },
  {
    "id": "68e757c5b5fe7bc046959a50",
    "name": "68e757c5b5fe7bc046959a50",
    "x": 7.0805,
    "y": 6.8002,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72869,
      "w": 0.68485
    },
    "statistics": {
      "hasStockCount": 65,
      "noStockCount": 3,
      "unknownStockCount": 45,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd738eb",
        "height": 0.20873,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fe6a",
            "leftCorner": {
              "x": 7.033,
              "y": 6.83,
              "z": 0.202
            },
            "rightCorner": {
              "x": 7.021,
              "y": 6.679,
              "z": 0.202
            },
            "gtin": "4066447236026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe6b",
            "leftCorner": {
              "x": 7.027,
              "y": 6.666,
              "z": 0.209
            },
            "rightCorner": {
              "x": 7.013,
              "y": 6.443,
              "z": 0.209
            },
            "gtin": "4067796103397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe6c",
            "leftCorner": {
              "x": 7.013,
              "y": 6.443,
              "z": 0.209
            },
            "rightCorner": {
              "x": 7.005,
              "y": 6.303,
              "z": 0.209
            },
            "gtin": "4067796103298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe6d",
            "leftCorner": {
              "x": 7.005,
              "y": 6.303,
              "z": 0.209
            },
            "rightCorner": {
              "x": 6.999,
              "y": 6.21,
              "z": 0.209
            },
            "gtin": "4062300472693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe6e",
            "leftCorner": {
              "x": 6.999,
              "y": 6.21,
              "z": 0.209
            },
            "rightCorner": {
              "x": 6.991,
              "y": 6.082,
              "z": 0.209
            },
            "gtin": "4062300450097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe6f",
            "leftCorner": {
              "x": 6.991,
              "y": 6.082,
              "z": 0.209
            },
            "rightCorner": {
              "x": 6.985,
              "y": 5.985,
              "z": 0.209
            },
            "gtin": "4062300432086",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe70",
            "leftCorner": {
              "x": 6.985,
              "y": 5.985,
              "z": 0.209
            },
            "rightCorner": {
              "x": 6.979,
              "y": 5.898,
              "z": 0.209
            },
            "gtin": "4062300462175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe71",
            "leftCorner": {
              "x": 6.979,
              "y": 5.898,
              "z": 0.209
            },
            "rightCorner": {
              "x": 6.972,
              "y": 5.786,
              "z": 0.209
            },
            "gtin": "4062300449503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe72",
            "leftCorner": {
              "x": 6.972,
              "y": 5.786,
              "z": 0.209
            },
            "rightCorner": {
              "x": 6.965,
              "y": 5.661,
              "z": 0.209
            },
            "gtin": "4262367681421",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe73",
            "leftCorner": {
              "x": 6.965,
              "y": 5.661,
              "z": 0.209
            },
            "rightCorner": {
              "x": 6.957,
              "y": 5.543,
              "z": 0.209
            },
            "gtin": "4262367681445",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738e8",
        "height": 0.43303,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ff1c",
            "leftCorner": {
              "x": 7.035,
              "y": 6.803,
              "z": 0.433
            },
            "rightCorner": {
              "x": 7.031,
              "y": 6.733,
              "z": 0.433
            },
            "gtin": "4018852016861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff1e",
            "leftCorner": {
              "x": 7.031,
              "y": 6.733,
              "z": 0.433
            },
            "rightCorner": {
              "x": 7.026,
              "y": 6.649,
              "z": 0.433
            },
            "gtin": "4018852034667",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff1f",
            "leftCorner": {
              "x": 7.026,
              "y": 6.649,
              "z": 0.433
            },
            "rightCorner": {
              "x": 7.02,
              "y": 6.556,
              "z": 0.433
            },
            "gtin": "4018852017332",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff20",
            "leftCorner": {
              "x": 7.02,
              "y": 6.556,
              "z": 0.433
            },
            "rightCorner": {
              "x": 7.014,
              "y": 6.464,
              "z": 0.433
            },
            "gtin": "4018852018377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff21",
            "leftCorner": {
              "x": 7.014,
              "y": 6.464,
              "z": 0.433
            },
            "rightCorner": {
              "x": 7.006,
              "y": 6.336,
              "z": 0.433
            },
            "gtin": "4018852016892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff22",
            "leftCorner": {
              "x": 7.006,
              "y": 6.336,
              "z": 0.433
            },
            "rightCorner": {
              "x": 7.001,
              "y": 6.242,
              "z": 0.433
            },
            "gtin": "4018852017240",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff23",
            "leftCorner": {
              "x": 7.001,
              "y": 6.242,
              "z": 0.433
            },
            "rightCorner": {
              "x": 6.994,
              "y": 6.131,
              "z": 0.433
            },
            "gtin": "4018852017301",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff24",
            "leftCorner": {
              "x": 6.994,
              "y": 6.131,
              "z": 0.433
            },
            "rightCorner": {
              "x": 6.987,
              "y": 6.025,
              "z": 0.433
            },
            "gtin": "4018852017271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff25",
            "leftCorner": {
              "x": 6.987,
              "y": 6.025,
              "z": 0.433
            },
            "rightCorner": {
              "x": 6.978,
              "y": 5.881,
              "z": 0.433
            },
            "gtin": "4066447373257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff26",
            "leftCorner": {
              "x": 6.978,
              "y": 5.881,
              "z": 0.433
            },
            "rightCorner": {
              "x": 6.968,
              "y": 5.72,
              "z": 0.433
            },
            "gtin": "4058172445804",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff27",
            "leftCorner": {
              "x": 6.968,
              "y": 5.72,
              "z": 0.433
            },
            "rightCorner": {
              "x": 6.959,
              "y": 5.568,
              "z": 0.433
            },
            "gtin": "4058172445804",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738ef",
        "height": 0.68562,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fff4",
            "leftCorner": {
              "x": 7.034,
              "y": 6.803,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.029,
              "y": 6.718,
              "z": 0.686
            },
            "gtin": "4067796171785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fff6",
            "leftCorner": {
              "x": 7.029,
              "y": 6.718,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.023,
              "y": 6.63,
              "z": 0.686
            },
            "gtin": "4067796171822",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fff7",
            "leftCorner": {
              "x": 7.023,
              "y": 6.63,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.018,
              "y": 6.536,
              "z": 0.686
            },
            "gtin": "4058172843303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fff8",
            "leftCorner": {
              "x": 7.018,
              "y": 6.536,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.012,
              "y": 6.444,
              "z": 0.686
            },
            "gtin": "4067796171648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fff9",
            "leftCorner": {
              "x": 7.012,
              "y": 6.444,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.007,
              "y": 6.358,
              "z": 0.686
            },
            "gtin": "4067796171648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fffa",
            "leftCorner": {
              "x": 7.007,
              "y": 6.358,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.0,
              "y": 6.254,
              "z": 0.686
            },
            "gtin": "4067796170160",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fffb",
            "leftCorner": {
              "x": 7.0,
              "y": 6.254,
              "z": 0.686
            },
            "rightCorner": {
              "x": 6.993,
              "y": 6.144,
              "z": 0.686
            }
          },
          {
            "id": "696ebf6d43c343680a26fffc",
            "leftCorner": {
              "x": 6.993,
              "y": 6.144,
              "z": 0.686
            },
            "rightCorner": {
              "x": 6.988,
              "y": 6.052,
              "z": 0.686
            },
            "gtin": "4062300475014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fffd",
            "leftCorner": {
              "x": 6.988,
              "y": 6.052,
              "z": 0.686
            },
            "rightCorner": {
              "x": 6.983,
              "y": 5.973,
              "z": 0.686
            },
            "gtin": "4062300443587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fffe",
            "leftCorner": {
              "x": 6.983,
              "y": 5.973,
              "z": 0.686
            },
            "rightCorner": {
              "x": 6.977,
              "y": 5.888,
              "z": 0.686
            },
            "gtin": "4062300325111",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffff",
            "leftCorner": {
              "x": 6.977,
              "y": 5.888,
              "z": 0.686
            },
            "rightCorner": {
              "x": 6.972,
              "y": 5.805,
              "z": 0.686
            },
            "gtin": "4062300325111",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270000",
            "leftCorner": {
              "x": 6.972,
              "y": 5.805,
              "z": 0.686
            },
            "rightCorner": {
              "x": 6.968,
              "y": 5.73,
              "z": 0.686
            },
            "gtin": "4062300278578",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270001",
            "leftCorner": {
              "x": 6.968,
              "y": 5.73,
              "z": 0.686
            },
            "rightCorner": {
              "x": 6.961,
              "y": 5.63,
              "z": 0.686
            },
            "gtin": "4062300325050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270002",
            "leftCorner": {
              "x": 6.961,
              "y": 5.63,
              "z": 0.686
            },
            "rightCorner": {
              "x": 6.957,
              "y": 5.556,
              "z": 0.686
            },
            "gtin": "4062300342811",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738ee",
        "height": 0.93621,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ffcb",
            "leftCorner": {
              "x": 7.033,
              "y": 6.803,
              "z": 0.936
            },
            "rightCorner": {
              "x": 7.029,
              "y": 6.732,
              "z": 0.936
            },
            "gtin": "4067796171709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffcd",
            "leftCorner": {
              "x": 7.029,
              "y": 6.732,
              "z": 0.936
            },
            "rightCorner": {
              "x": 7.023,
              "y": 6.644,
              "z": 0.936
            },
            "gtin": "4067796171686",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffce",
            "leftCorner": {
              "x": 7.023,
              "y": 6.644,
              "z": 0.936
            },
            "rightCorner": {
              "x": 7.017,
              "y": 6.546,
              "z": 0.936
            },
            "gtin": "4058172843204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffcf",
            "leftCorner": {
              "x": 7.017,
              "y": 6.546,
              "z": 0.936
            },
            "rightCorner": {
              "x": 7.011,
              "y": 6.44,
              "z": 0.936
            },
            "gtin": "4058172425776",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffd0",
            "leftCorner": {
              "x": 7.011,
              "y": 6.44,
              "z": 0.936
            },
            "rightCorner": {
              "x": 7.005,
              "y": 6.349,
              "z": 0.936
            },
            "gtin": "4067796171723",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffd1",
            "leftCorner": {
              "x": 7.005,
              "y": 6.349,
              "z": 0.936
            },
            "rightCorner": {
              "x": 7.0,
              "y": 6.266,
              "z": 0.936
            },
            "gtin": "4067796171624",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffd2",
            "leftCorner": {
              "x": 7.0,
              "y": 6.266,
              "z": 0.936
            },
            "rightCorner": {
              "x": 6.993,
              "y": 6.162,
              "z": 0.936
            },
            "gtin": "4066447658262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffd3",
            "leftCorner": {
              "x": 6.993,
              "y": 6.162,
              "z": 0.936
            },
            "rightCorner": {
              "x": 6.988,
              "y": 6.071,
              "z": 0.936
            },
            "gtin": "4058172843228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffd4",
            "leftCorner": {
              "x": 6.988,
              "y": 6.071,
              "z": 0.936
            },
            "rightCorner": {
              "x": 6.983,
              "y": 5.992,
              "z": 0.936
            },
            "gtin": "4062300432123",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffd5",
            "leftCorner": {
              "x": 6.983,
              "y": 5.992,
              "z": 0.936
            },
            "rightCorner": {
              "x": 6.978,
              "y": 5.909,
              "z": 0.936
            },
            "gtin": "4062300449473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffd6",
            "leftCorner": {
              "x": 6.978,
              "y": 5.909,
              "z": 0.936
            },
            "rightCorner": {
              "x": 6.973,
              "y": 5.836,
              "z": 0.936
            },
            "gtin": "4062300278530",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffd7",
            "leftCorner": {
              "x": 6.973,
              "y": 5.836,
              "z": 0.936
            },
            "rightCorner": {
              "x": 6.968,
              "y": 5.746,
              "z": 0.936
            },
            "gtin": "4062300278547",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffd8",
            "leftCorner": {
              "x": 6.968,
              "y": 5.746,
              "z": 0.936
            },
            "rightCorner": {
              "x": 6.963,
              "y": 5.678,
              "z": 0.936
            },
            "gtin": "4066447923476",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffd9",
            "leftCorner": {
              "x": 6.963,
              "y": 5.678,
              "z": 0.936
            },
            "rightCorner": {
              "x": 6.96,
              "y": 5.617,
              "z": 0.936
            },
            "gtin": "4066447971460",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffda",
            "leftCorner": {
              "x": 6.96,
              "y": 5.617,
              "z": 0.936
            },
            "rightCorner": {
              "x": 6.955,
              "y": 5.54,
              "z": 0.936
            },
            "gtin": "4066447112894",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738ed",
        "height": 1.1518,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ffad",
            "leftCorner": {
              "x": 6.958,
              "y": 5.585,
              "z": 1.152
            },
            "rightCorner": {
              "x": 6.953,
              "y": 5.512,
              "z": 1.152
            },
            "gtin": "9120111880443",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff9d",
            "leftCorner": {
              "x": 7.033,
              "y": 6.803,
              "z": 1.152
            },
            "rightCorner": {
              "x": 7.029,
              "y": 6.735,
              "z": 1.152
            },
            "gtin": "4260133231924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff9f",
            "leftCorner": {
              "x": 7.029,
              "y": 6.735,
              "z": 1.152
            },
            "rightCorner": {
              "x": 7.024,
              "y": 6.653,
              "z": 1.152
            },
            "gtin": "4260133232549",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffa0",
            "leftCorner": {
              "x": 7.024,
              "y": 6.653,
              "z": 1.152
            },
            "rightCorner": {
              "x": 7.018,
              "y": 6.562,
              "z": 1.152
            },
            "gtin": "4260133231948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffa1",
            "leftCorner": {
              "x": 7.018,
              "y": 6.562,
              "z": 1.152
            },
            "rightCorner": {
              "x": 7.013,
              "y": 6.475,
              "z": 1.152
            },
            "gtin": "4260133232648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffa2",
            "leftCorner": {
              "x": 7.013,
              "y": 6.475,
              "z": 1.152
            },
            "rightCorner": {
              "x": 7.008,
              "y": 6.395,
              "z": 1.152
            },
            "gtin": "4260133232525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffa3",
            "leftCorner": {
              "x": 7.008,
              "y": 6.395,
              "z": 1.152
            },
            "rightCorner": {
              "x": 7.001,
              "y": 6.29,
              "z": 1.152
            },
            "gtin": "4260133231870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffa4",
            "leftCorner": {
              "x": 7.001,
              "y": 6.29,
              "z": 1.152
            },
            "rightCorner": {
              "x": 6.996,
              "y": 6.202,
              "z": 1.152
            },
            "gtin": "4260133232501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffa5",
            "leftCorner": {
              "x": 6.996,
              "y": 6.202,
              "z": 1.152
            },
            "rightCorner": {
              "x": 6.991,
              "y": 6.12,
              "z": 1.152
            },
            "gtin": "4260133236288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffa6",
            "leftCorner": {
              "x": 6.991,
              "y": 6.12,
              "z": 1.152
            },
            "rightCorner": {
              "x": 6.986,
              "y": 6.041,
              "z": 1.152
            },
            "gtin": "4260133232600",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffa7",
            "leftCorner": {
              "x": 6.986,
              "y": 6.041,
              "z": 1.152
            },
            "rightCorner": {
              "x": 6.981,
              "y": 5.958,
              "z": 1.152
            },
            "gtin": "4260133234536",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffa8",
            "leftCorner": {
              "x": 6.981,
              "y": 5.958,
              "z": 1.152
            },
            "rightCorner": {
              "x": 6.976,
              "y": 5.885,
              "z": 1.152
            },
            "gtin": "9120111882782",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffa9",
            "leftCorner": {
              "x": 6.976,
              "y": 5.885,
              "z": 1.152
            },
            "rightCorner": {
              "x": 6.972,
              "y": 5.814,
              "z": 1.152
            },
            "gtin": "9120111882768",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffaa",
            "leftCorner": {
              "x": 6.972,
              "y": 5.814,
              "z": 1.152
            },
            "rightCorner": {
              "x": 6.967,
              "y": 5.731,
              "z": 1.152
            },
            "gtin": "9120111881235",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffab",
            "leftCorner": {
              "x": 6.967,
              "y": 5.731,
              "z": 1.152
            },
            "rightCorner": {
              "x": 6.961,
              "y": 5.64,
              "z": 1.152
            },
            "gtin": "9120111880443",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffac",
            "leftCorner": {
              "x": 6.961,
              "y": 5.64,
              "z": 1.152
            },
            "rightCorner": {
              "x": 6.958,
              "y": 5.585,
              "z": 1.152
            },
            "gtin": "9120111880443",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738ec",
        "height": 1.3607,
        "facings": [
          {
            "id": "696ebf6d43c343680a26feb3",
            "leftCorner": {
              "x": 7.036,
              "y": 6.831,
              "z": 1.357
            },
            "rightCorner": {
              "x": 7.031,
              "y": 6.771,
              "z": 1.357
            },
            "gtin": "4260133235205",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26feb4",
            "leftCorner": {
              "x": 7.031,
              "y": 6.757,
              "z": 1.361
            },
            "rightCorner": {
              "x": 7.026,
              "y": 6.677,
              "z": 1.361
            },
            "gtin": "4260133235175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26feb5",
            "leftCorner": {
              "x": 7.026,
              "y": 6.677,
              "z": 1.361
            },
            "rightCorner": {
              "x": 7.021,
              "y": 6.588,
              "z": 1.361
            },
            "gtin": "4260133235199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26feb6",
            "leftCorner": {
              "x": 7.021,
              "y": 6.588,
              "z": 1.361
            },
            "rightCorner": {
              "x": 7.015,
              "y": 6.499,
              "z": 1.361
            },
            "gtin": "4260133232624",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26feb7",
            "leftCorner": {
              "x": 7.015,
              "y": 6.499,
              "z": 1.361
            },
            "rightCorner": {
              "x": 7.01,
              "y": 6.411,
              "z": 1.361
            },
            "gtin": "4260133232563",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26feb8",
            "leftCorner": {
              "x": 7.01,
              "y": 6.411,
              "z": 1.361
            },
            "rightCorner": {
              "x": 7.005,
              "y": 6.331,
              "z": 1.361
            },
            "gtin": "4260133232662",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26feb9",
            "leftCorner": {
              "x": 7.005,
              "y": 6.331,
              "z": 1.361
            },
            "rightCorner": {
              "x": 6.999,
              "y": 6.243,
              "z": 1.361
            },
            "gtin": "4260133231900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26feba",
            "leftCorner": {
              "x": 6.999,
              "y": 6.243,
              "z": 1.361
            },
            "rightCorner": {
              "x": 6.994,
              "y": 6.158,
              "z": 1.361
            },
            "gtin": "4260133234482",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26febb",
            "leftCorner": {
              "x": 6.994,
              "y": 6.158,
              "z": 1.361
            },
            "rightCorner": {
              "x": 6.989,
              "y": 6.077,
              "z": 1.361
            },
            "gtin": "4260133231818",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26febc",
            "leftCorner": {
              "x": 6.989,
              "y": 6.077,
              "z": 1.361
            },
            "rightCorner": {
              "x": 6.984,
              "y": 5.997,
              "z": 1.361
            },
            "gtin": "4260133232587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26febd",
            "leftCorner": {
              "x": 6.984,
              "y": 5.997,
              "z": 1.361
            },
            "rightCorner": {
              "x": 6.979,
              "y": 5.919,
              "z": 1.361
            },
            "gtin": "4260133232464",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26febe",
            "leftCorner": {
              "x": 6.979,
              "y": 5.919,
              "z": 1.361
            },
            "rightCorner": {
              "x": 6.974,
              "y": 5.844,
              "z": 1.361
            },
            "gtin": "4260133232709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26febf",
            "leftCorner": {
              "x": 6.974,
              "y": 5.844,
              "z": 1.361
            },
            "rightCorner": {
              "x": 6.97,
              "y": 5.766,
              "z": 1.361
            },
            "gtin": "4260133236301",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fec0",
            "leftCorner": {
              "x": 6.97,
              "y": 5.766,
              "z": 1.361
            },
            "rightCorner": {
              "x": 6.965,
              "y": 5.69,
              "z": 1.361
            },
            "gtin": "4260133236301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fec1",
            "leftCorner": {
              "x": 6.965,
              "y": 5.69,
              "z": 1.361
            },
            "rightCorner": {
              "x": 6.96,
              "y": 5.615,
              "z": 1.361
            },
            "gtin": "9120111882706",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fec2",
            "leftCorner": {
              "x": 6.96,
              "y": 5.615,
              "z": 1.361
            },
            "rightCorner": {
              "x": 6.955,
              "y": 5.537,
              "z": 1.361
            },
            "gtin": "4260249142329",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738ea",
        "height": 1.613,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ff68",
            "leftCorner": {
              "x": 7.028,
              "y": 6.804,
              "z": 1.613
            },
            "rightCorner": {
              "x": 7.025,
              "y": 6.749,
              "z": 1.613
            },
            "gtin": "4262367684385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff6a",
            "leftCorner": {
              "x": 7.025,
              "y": 6.749,
              "z": 1.613
            },
            "rightCorner": {
              "x": 7.019,
              "y": 6.665,
              "z": 1.613
            },
            "gtin": "4262367684224",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff6b",
            "leftCorner": {
              "x": 7.019,
              "y": 6.665,
              "z": 1.613
            },
            "rightCorner": {
              "x": 7.015,
              "y": 6.591,
              "z": 1.613
            },
            "gtin": "4262367681605",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff6c",
            "leftCorner": {
              "x": 7.015,
              "y": 6.591,
              "z": 1.613
            },
            "rightCorner": {
              "x": 7.009,
              "y": 6.499,
              "z": 1.613
            },
            "gtin": "4262367681568",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff6d",
            "leftCorner": {
              "x": 7.009,
              "y": 6.499,
              "z": 1.613
            },
            "rightCorner": {
              "x": 7.004,
              "y": 6.411,
              "z": 1.613
            },
            "gtin": "4260249140035",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff6e",
            "leftCorner": {
              "x": 7.004,
              "y": 6.411,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.999,
              "y": 6.329,
              "z": 1.613
            },
            "gtin": "4260249143647",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff6f",
            "leftCorner": {
              "x": 6.999,
              "y": 6.329,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.994,
              "y": 6.248,
              "z": 1.613
            },
            "gtin": "4262367681384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff70",
            "leftCorner": {
              "x": 6.994,
              "y": 6.248,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.989,
              "y": 6.173,
              "z": 1.613
            },
            "gtin": "4260249147126",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff71",
            "leftCorner": {
              "x": 6.989,
              "y": 6.173,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.984,
              "y": 6.087,
              "z": 1.613
            },
            "gtin": "4260249140103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff72",
            "leftCorner": {
              "x": 6.984,
              "y": 6.087,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.979,
              "y": 6.01,
              "z": 1.613
            },
            "gtin": "4262367681582",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff73",
            "leftCorner": {
              "x": 6.979,
              "y": 6.01,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.974,
              "y": 5.934,
              "z": 1.613
            },
            "gtin": "4262367681322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff74",
            "leftCorner": {
              "x": 6.974,
              "y": 5.934,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.97,
              "y": 5.86,
              "z": 1.613
            },
            "gtin": "4260618528600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff75",
            "leftCorner": {
              "x": 6.97,
              "y": 5.86,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.965,
              "y": 5.789,
              "z": 1.613
            },
            "gtin": "4260249140028",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff76",
            "leftCorner": {
              "x": 6.965,
              "y": 5.789,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.96,
              "y": 5.713,
              "z": 1.613
            },
            "gtin": "4260249142343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff77",
            "leftCorner": {
              "x": 6.96,
              "y": 5.713,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.955,
              "y": 5.634,
              "z": 1.613
            },
            "gtin": "4262367681629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff78",
            "leftCorner": {
              "x": 6.955,
              "y": 5.634,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.951,
              "y": 5.559,
              "z": 1.613
            },
            "gtin": "4262367681759",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738e9",
        "height": 1.8221,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ff37",
            "leftCorner": {
              "x": 7.019,
              "y": 6.804,
              "z": 1.822
            },
            "rightCorner": {
              "x": 7.016,
              "y": 6.754,
              "z": 1.822
            },
            "gtin": "4066447179767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff38",
            "leftCorner": {
              "x": 7.016,
              "y": 6.754,
              "z": 1.822
            },
            "rightCorner": {
              "x": 7.011,
              "y": 6.677,
              "z": 1.822
            },
            "gtin": "4066447179736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff39",
            "leftCorner": {
              "x": 7.011,
              "y": 6.677,
              "z": 1.822
            },
            "rightCorner": {
              "x": 7.007,
              "y": 6.6,
              "z": 1.822
            },
            "gtin": "4066447423907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff3a",
            "leftCorner": {
              "x": 7.007,
              "y": 6.6,
              "z": 1.822
            },
            "rightCorner": {
              "x": 7.002,
              "y": 6.519,
              "z": 1.822
            },
            "gtin": "4066447179743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff3b",
            "leftCorner": {
              "x": 7.002,
              "y": 6.519,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.996,
              "y": 6.431,
              "z": 1.822
            },
            "gtin": "4066447179750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff3c",
            "leftCorner": {
              "x": 6.996,
              "y": 6.431,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.991,
              "y": 6.351,
              "z": 1.822
            },
            "gtin": "7640161877061",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff3d",
            "leftCorner": {
              "x": 6.991,
              "y": 6.351,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.986,
              "y": 6.263,
              "z": 1.822
            },
            "gtin": "7640161877085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff3e",
            "leftCorner": {
              "x": 6.986,
              "y": 6.263,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.981,
              "y": 6.182,
              "z": 1.822
            },
            "gtin": "7640230493819",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff3f",
            "leftCorner": {
              "x": 6.981,
              "y": 6.182,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.976,
              "y": 6.104,
              "z": 1.822
            },
            "gtin": "7640161877313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff40",
            "leftCorner": {
              "x": 6.976,
              "y": 6.104,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.972,
              "y": 6.044,
              "z": 1.822
            },
            "gtin": "7640230493833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff41",
            "leftCorner": {
              "x": 6.972,
              "y": 6.044,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.967,
              "y": 5.969,
              "z": 1.822
            },
            "gtin": "4260526594049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff42",
            "leftCorner": {
              "x": 6.967,
              "y": 5.969,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.963,
              "y": 5.894,
              "z": 1.822
            },
            "gtin": "4260526595367",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff43",
            "leftCorner": {
              "x": 6.963,
              "y": 5.894,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.958,
              "y": 5.817,
              "z": 1.822
            },
            "gtin": "4260526594100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff44",
            "leftCorner": {
              "x": 6.958,
              "y": 5.817,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.953,
              "y": 5.738,
              "z": 1.822
            },
            "gtin": "4260526594193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff45",
            "leftCorner": {
              "x": 6.953,
              "y": 5.738,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.948,
              "y": 5.65,
              "z": 1.822
            },
            "gtin": "4260526593073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff46",
            "leftCorner": {
              "x": 6.948,
              "y": 5.65,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.941,
              "y": 5.539,
              "z": 1.822
            },
            "gtin": "9120111881174",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757c5b5fe7bc046959a51",
    "name": "68e757c5b5fe7bc046959a51",
    "x": 6.9975,
    "y": 5.5492,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73475,
      "w": 0.67834
    },
    "statistics": {
      "hasStockCount": 42,
      "noStockCount": 3,
      "unknownStockCount": 38,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd738f5",
        "height": 0.20293,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fe74",
            "leftCorner": {
              "x": 6.952,
              "y": 5.541,
              "z": 0.203
            },
            "rightCorner": {
              "x": 6.942,
              "y": 5.417,
              "z": 0.203
            },
            "gtin": "4262367681407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe75",
            "leftCorner": {
              "x": 6.942,
              "y": 5.417,
              "z": 0.203
            },
            "rightCorner": {
              "x": 6.931,
              "y": 5.285,
              "z": 0.203
            },
            "gtin": "4067796001723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe76",
            "leftCorner": {
              "x": 6.931,
              "y": 5.285,
              "z": 0.203
            },
            "rightCorner": {
              "x": 6.918,
              "y": 5.119,
              "z": 0.203
            },
            "gtin": "4066447349801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe77",
            "leftCorner": {
              "x": 6.918,
              "y": 5.119,
              "z": 0.203
            },
            "rightCorner": {
              "x": 6.904,
              "y": 4.942,
              "z": 0.203
            },
            "gtin": "4066447087727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe78",
            "leftCorner": {
              "x": 6.904,
              "y": 4.942,
              "z": 0.203
            },
            "rightCorner": {
              "x": 6.891,
              "y": 4.781,
              "z": 0.203
            },
            "gtin": "4067796082272",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe79",
            "leftCorner": {
              "x": 6.891,
              "y": 4.781,
              "z": 0.203
            },
            "rightCorner": {
              "x": 6.88,
              "y": 4.641,
              "z": 0.203
            },
            "gtin": "4066447208962",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe7a",
            "leftCorner": {
              "x": 6.88,
              "y": 4.641,
              "z": 0.203
            },
            "rightCorner": {
              "x": 6.867,
              "y": 4.485,
              "z": 0.203
            },
            "gtin": "4066447208962",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe7b",
            "leftCorner": {
              "x": 6.867,
              "y": 4.485,
              "z": 0.203
            },
            "rightCorner": {
              "x": 6.855,
              "y": 4.328,
              "z": 0.203
            },
            "gtin": "4066447208962",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738f4",
        "height": 0.43146,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ff28",
            "leftCorner": {
              "x": 6.959,
              "y": 5.568,
              "z": 0.433
            },
            "rightCorner": {
              "x": 6.95,
              "y": 5.423,
              "z": 0.433
            },
            "gtin": "4067796181012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff29",
            "leftCorner": {
              "x": 6.942,
              "y": 5.421,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.929,
              "y": 5.258,
              "z": 0.431
            },
            "gtin": "4062300376199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff2a",
            "leftCorner": {
              "x": 6.929,
              "y": 5.258,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.919,
              "y": 5.131,
              "z": 0.431
            },
            "gtin": "4062300376199",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff2b",
            "leftCorner": {
              "x": 6.919,
              "y": 5.131,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.907,
              "y": 4.977,
              "z": 0.431
            },
            "gtin": "4062300463486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff2c",
            "leftCorner": {
              "x": 6.907,
              "y": 4.977,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.895,
              "y": 4.831,
              "z": 0.431
            }
          },
          {
            "id": "696ebf6d43c343680a26ff2d",
            "leftCorner": {
              "x": 6.895,
              "y": 4.831,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.883,
              "y": 4.677,
              "z": 0.431
            },
            "gtin": "4062300376182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff2e",
            "leftCorner": {
              "x": 6.883,
              "y": 4.677,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.87,
              "y": 4.515,
              "z": 0.431
            },
            "gtin": "4062300463516",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff2f",
            "leftCorner": {
              "x": 6.87,
              "y": 4.515,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.854,
              "y": 4.32,
              "z": 0.431
            },
            "gtin": "4062300429710",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738f6",
        "height": 0.68423,
        "facings": [
          {
            "id": "696ebf6d43c343680a270003",
            "leftCorner": {
              "x": 6.957,
              "y": 5.556,
              "z": 0.686
            },
            "rightCorner": {
              "x": 6.95,
              "y": 5.449,
              "z": 0.686
            },
            "gtin": "4260133235694",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270004",
            "leftCorner": {
              "x": 6.943,
              "y": 5.447,
              "z": 0.684
            },
            "rightCorner": {
              "x": 6.934,
              "y": 5.337,
              "z": 0.684
            },
            "gtin": "4260133235694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270005",
            "leftCorner": {
              "x": 6.934,
              "y": 5.337,
              "z": 0.684
            },
            "rightCorner": {
              "x": 6.922,
              "y": 5.188,
              "z": 0.684
            },
            "gtin": "4260133234550",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270006",
            "leftCorner": {
              "x": 6.922,
              "y": 5.188,
              "z": 0.684
            },
            "rightCorner": {
              "x": 6.912,
              "y": 5.064,
              "z": 0.684
            },
            "gtin": "4260133236387",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270007",
            "leftCorner": {
              "x": 6.912,
              "y": 5.064,
              "z": 0.684
            },
            "rightCorner": {
              "x": 6.899,
              "y": 4.89,
              "z": 0.684
            },
            "gtin": "4260133236325",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270008",
            "leftCorner": {
              "x": 6.899,
              "y": 4.89,
              "z": 0.684
            },
            "rightCorner": {
              "x": 6.886,
              "y": 4.731,
              "z": 0.684
            },
            "gtin": "4260133236127",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270009",
            "leftCorner": {
              "x": 6.886,
              "y": 4.731,
              "z": 0.684
            },
            "rightCorner": {
              "x": 6.872,
              "y": 4.553,
              "z": 0.684
            },
            "gtin": "4260133236400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27000a",
            "leftCorner": {
              "x": 6.872,
              "y": 4.553,
              "z": 0.684
            },
            "rightCorner": {
              "x": 6.86,
              "y": 4.414,
              "z": 0.684
            },
            "gtin": "4260133232259",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27000b",
            "leftCorner": {
              "x": 6.86,
              "y": 4.414,
              "z": 0.684
            },
            "rightCorner": {
              "x": 6.85,
              "y": 4.28,
              "z": 0.684
            },
            "gtin": "4260133236578",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738f0",
        "height": 0.93505,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ffdb",
            "leftCorner": {
              "x": 6.947,
              "y": 5.538,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.943,
              "y": 5.486,
              "z": 0.935
            },
            "gtin": "4066447114140",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffdc",
            "leftCorner": {
              "x": 6.943,
              "y": 5.486,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.94,
              "y": 5.439,
              "z": 0.935
            },
            "gtin": "4066447112931",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffdd",
            "leftCorner": {
              "x": 6.94,
              "y": 5.439,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.935,
              "y": 5.38,
              "z": 0.935
            },
            "gtin": "4260133231122",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffde",
            "leftCorner": {
              "x": 6.935,
              "y": 5.38,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.93,
              "y": 5.323,
              "z": 0.935
            },
            "gtin": "4260133234864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffdf",
            "leftCorner": {
              "x": 6.93,
              "y": 5.323,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.926,
              "y": 5.274,
              "z": 0.935
            },
            "gtin": "4260133231375",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffe0",
            "leftCorner": {
              "x": 6.926,
              "y": 5.274,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.923,
              "y": 5.227,
              "z": 0.935
            },
            "gtin": "4260133236554",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffe1",
            "leftCorner": {
              "x": 6.923,
              "y": 5.227,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.919,
              "y": 5.187,
              "z": 0.935
            },
            "gtin": "4260133233997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffe2",
            "leftCorner": {
              "x": 6.919,
              "y": 5.187,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.913,
              "y": 5.109,
              "z": 0.935
            },
            "gtin": "9120111880191",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffe3",
            "leftCorner": {
              "x": 6.913,
              "y": 5.109,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.907,
              "y": 5.028,
              "z": 0.935
            },
            "gtin": "4260133236431",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffe4",
            "leftCorner": {
              "x": 6.907,
              "y": 5.028,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.9,
              "y": 4.943,
              "z": 0.935
            },
            "gtin": "4260133231238",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffe5",
            "leftCorner": {
              "x": 6.9,
              "y": 4.943,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.893,
              "y": 4.859,
              "z": 0.935
            },
            "gtin": "4260133231252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffe6",
            "leftCorner": {
              "x": 6.893,
              "y": 4.859,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.885,
              "y": 4.751,
              "z": 0.935
            },
            "gtin": "4260133230750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffe7",
            "leftCorner": {
              "x": 6.885,
              "y": 4.751,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.876,
              "y": 4.64,
              "z": 0.935
            },
            "gtin": "4260133237322",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffe8",
            "leftCorner": {
              "x": 6.876,
              "y": 4.64,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.867,
              "y": 4.527,
              "z": 0.935
            },
            "gtin": "4062300473522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffe9",
            "leftCorner": {
              "x": 6.867,
              "y": 4.527,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.859,
              "y": 4.433,
              "z": 0.935
            },
            "gtin": "4062300444621",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffea",
            "leftCorner": {
              "x": 6.859,
              "y": 4.433,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.85,
              "y": 4.316,
              "z": 0.935
            },
            "gtin": "4260133231351",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738f3",
        "height": 1.1501,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ffae",
            "leftCorner": {
              "x": 6.944,
              "y": 5.509,
              "z": 1.15
            },
            "rightCorner": {
              "x": 6.937,
              "y": 5.423,
              "z": 1.15
            },
            "gtin": "4066447910278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffaf",
            "leftCorner": {
              "x": 6.937,
              "y": 5.423,
              "z": 1.15
            },
            "rightCorner": {
              "x": 6.929,
              "y": 5.327,
              "z": 1.15
            },
            "gtin": "4066447191363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffb0",
            "leftCorner": {
              "x": 6.929,
              "y": 5.327,
              "z": 1.15
            },
            "rightCorner": {
              "x": 6.926,
              "y": 5.284,
              "z": 1.15
            },
            "gtin": "4066447208931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffb1",
            "leftCorner": {
              "x": 6.926,
              "y": 5.284,
              "z": 1.15
            },
            "rightCorner": {
              "x": 6.923,
              "y": 5.243,
              "z": 1.15
            },
            "gtin": "4067796161885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffb2",
            "leftCorner": {
              "x": 6.923,
              "y": 5.243,
              "z": 1.15
            },
            "rightCorner": {
              "x": 6.919,
              "y": 5.199,
              "z": 1.15
            },
            "gtin": "4066447191394",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffb3",
            "leftCorner": {
              "x": 6.919,
              "y": 5.199,
              "z": 1.15
            },
            "rightCorner": {
              "x": 6.915,
              "y": 5.154,
              "z": 1.15
            },
            "gtin": "4066447257168",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffb4",
            "leftCorner": {
              "x": 6.915,
              "y": 5.154,
              "z": 1.15
            },
            "rightCorner": {
              "x": 6.912,
              "y": 5.11,
              "z": 1.15
            },
            "gtin": "4066447257151",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffb5",
            "leftCorner": {
              "x": 6.912,
              "y": 5.11,
              "z": 1.15
            },
            "rightCorner": {
              "x": 6.905,
              "y": 5.02,
              "z": 1.15
            },
            "gtin": "4062300362239",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffb6",
            "leftCorner": {
              "x": 6.905,
              "y": 5.02,
              "z": 1.15
            },
            "rightCorner": {
              "x": 6.898,
              "y": 4.932,
              "z": 1.15
            },
            "gtin": "4062300362215",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffb7",
            "leftCorner": {
              "x": 6.898,
              "y": 4.932,
              "z": 1.15
            },
            "rightCorner": {
              "x": 6.89,
              "y": 4.835,
              "z": 1.15
            },
            "gtin": "4062300446069",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffb8",
            "leftCorner": {
              "x": 6.89,
              "y": 4.835,
              "z": 1.15
            },
            "rightCorner": {
              "x": 6.882,
              "y": 4.741,
              "z": 1.15
            },
            "gtin": "4062300362277",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffb9",
            "leftCorner": {
              "x": 6.882,
              "y": 4.741,
              "z": 1.15
            },
            "rightCorner": {
              "x": 6.872,
              "y": 4.614,
              "z": 1.15
            },
            "gtin": "4018852029175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffba",
            "leftCorner": {
              "x": 6.872,
              "y": 4.614,
              "z": 1.15
            },
            "rightCorner": {
              "x": 6.864,
              "y": 4.516,
              "z": 1.15
            },
            "gtin": "4018852026969",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffbb",
            "leftCorner": {
              "x": 6.864,
              "y": 4.516,
              "z": 1.15
            },
            "rightCorner": {
              "x": 6.859,
              "y": 4.454,
              "z": 1.15
            },
            "gtin": "4251099706342",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffbc",
            "leftCorner": {
              "x": 6.859,
              "y": 4.454,
              "z": 1.15
            },
            "rightCorner": {
              "x": 6.851,
              "y": 4.351,
              "z": 1.15
            },
            "gtin": "4260311984710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffbd",
            "leftCorner": {
              "x": 6.851,
              "y": 4.351,
              "z": 1.15
            },
            "rightCorner": {
              "x": 6.845,
              "y": 4.278,
              "z": 1.15
            },
            "gtin": "4260311984734",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738f1",
        "height": 1.3598,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fec3",
            "leftCorner": {
              "x": 6.947,
              "y": 5.534,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.935,
              "y": 5.379,
              "z": 1.36
            },
            "gtin": "4066447866834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fec4",
            "leftCorner": {
              "x": 6.935,
              "y": 5.379,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.928,
              "y": 5.297,
              "z": 1.36
            },
            "gtin": "4066447184327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fec5",
            "leftCorner": {
              "x": 6.928,
              "y": 5.297,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.918,
              "y": 5.168,
              "z": 1.36
            },
            "gtin": "4067796069167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fec6",
            "leftCorner": {
              "x": 6.918,
              "y": 5.168,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.908,
              "y": 5.037,
              "z": 1.36
            },
            "gtin": "4260133230187",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fec7",
            "leftCorner": {
              "x": 6.908,
              "y": 5.037,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.896,
              "y": 4.887,
              "z": 1.36
            },
            "gtin": "4260133232037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fec8",
            "leftCorner": {
              "x": 6.896,
              "y": 4.887,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.884,
              "y": 4.736,
              "z": 1.36
            },
            "gtin": "4260133235717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fec9",
            "leftCorner": {
              "x": 6.884,
              "y": 4.736,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.872,
              "y": 4.589,
              "z": 1.36
            },
            "gtin": "4260133230736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26feca",
            "leftCorner": {
              "x": 6.872,
              "y": 4.589,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.857,
              "y": 4.406,
              "z": 1.36
            },
            "gtin": "4260133233812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fecb",
            "leftCorner": {
              "x": 6.857,
              "y": 4.406,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.85,
              "y": 4.316,
              "z": 1.36
            },
            "gtin": "4260133237384",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738f7",
        "height": 1.612,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ff79",
            "leftCorner": {
              "x": 6.951,
              "y": 5.559,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.946,
              "y": 5.479,
              "z": 1.613
            },
            "gtin": "4262367684200",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff7a",
            "leftCorner": {
              "x": 6.94,
              "y": 5.477,
              "z": 1.612
            },
            "rightCorner": {
              "x": 6.932,
              "y": 5.373,
              "z": 1.612
            },
            "gtin": "4067796002409",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff7b",
            "leftCorner": {
              "x": 6.932,
              "y": 5.373,
              "z": 1.612
            },
            "rightCorner": {
              "x": 6.923,
              "y": 5.259,
              "z": 1.612
            },
            "gtin": "4067796172942",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff7c",
            "leftCorner": {
              "x": 6.923,
              "y": 5.259,
              "z": 1.612
            },
            "rightCorner": {
              "x": 6.913,
              "y": 5.142,
              "z": 1.612
            },
            "gtin": "4260133232754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff7d",
            "leftCorner": {
              "x": 6.913,
              "y": 5.142,
              "z": 1.612
            },
            "rightCorner": {
              "x": 6.903,
              "y": 5.015,
              "z": 1.612
            },
            "gtin": "4262367680325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff7e",
            "leftCorner": {
              "x": 6.903,
              "y": 5.015,
              "z": 1.612
            },
            "rightCorner": {
              "x": 6.893,
              "y": 4.89,
              "z": 1.612
            },
            "gtin": "4260249140530",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff7f",
            "leftCorner": {
              "x": 6.893,
              "y": 4.89,
              "z": 1.612
            },
            "rightCorner": {
              "x": 6.883,
              "y": 4.76,
              "z": 1.612
            }
          },
          {
            "id": "696ebf6d43c343680a26ff80",
            "leftCorner": {
              "x": 6.883,
              "y": 4.76,
              "z": 1.612
            },
            "rightCorner": {
              "x": 6.871,
              "y": 4.618,
              "z": 1.612
            },
            "gtin": "4262367682077",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff81",
            "leftCorner": {
              "x": 6.871,
              "y": 4.618,
              "z": 1.612
            },
            "rightCorner": {
              "x": 6.862,
              "y": 4.497,
              "z": 1.612
            }
          },
          {
            "id": "696ebf6d43c343680a26ff82",
            "leftCorner": {
              "x": 6.862,
              "y": 4.497,
              "z": 1.612
            },
            "rightCorner": {
              "x": 6.853,
              "y": 4.392,
              "z": 1.612
            },
            "gtin": "4260133237261",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff83",
            "leftCorner": {
              "x": 6.853,
              "y": 4.392,
              "z": 1.612
            },
            "rightCorner": {
              "x": 6.844,
              "y": 4.28,
              "z": 1.612
            },
            "gtin": "4260133237285",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738f2",
        "height": 1.8211,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ff47",
            "leftCorner": {
              "x": 6.938,
              "y": 5.537,
              "z": 1.821
            },
            "rightCorner": {
              "x": 6.929,
              "y": 5.424,
              "z": 1.821
            },
            "gtin": "4062300467545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff48",
            "leftCorner": {
              "x": 6.929,
              "y": 5.424,
              "z": 1.821
            },
            "rightCorner": {
              "x": 6.919,
              "y": 5.296,
              "z": 1.821
            },
            "gtin": "4062300467576",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff49",
            "leftCorner": {
              "x": 6.919,
              "y": 5.296,
              "z": 1.821
            },
            "rightCorner": {
              "x": 6.898,
              "y": 5.031,
              "z": 1.821
            },
            "gtin": "4062300380745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff4a",
            "leftCorner": {
              "x": 6.898,
              "y": 5.031,
              "z": 1.821
            },
            "rightCorner": {
              "x": 6.887,
              "y": 4.896,
              "z": 1.821
            },
            "gtin": "4066447935738",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff4b",
            "leftCorner": {
              "x": 6.887,
              "y": 4.896,
              "z": 1.821
            },
            "rightCorner": {
              "x": 6.877,
              "y": 4.772,
              "z": 1.821
            },
            "gtin": "4260133239104",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff4c",
            "leftCorner": {
              "x": 6.877,
              "y": 4.772,
              "z": 1.821
            },
            "rightCorner": {
              "x": 6.867,
              "y": 4.65,
              "z": 1.821
            },
            "gtin": "4067796172362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff4d",
            "leftCorner": {
              "x": 6.867,
              "y": 4.65,
              "z": 1.821
            },
            "rightCorner": {
              "x": 6.859,
              "y": 4.542,
              "z": 1.821
            },
            "gtin": "4058172425813",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff4e",
            "leftCorner": {
              "x": 6.859,
              "y": 4.542,
              "z": 1.821
            },
            "rightCorner": {
              "x": 6.851,
              "y": 4.445,
              "z": 1.821
            },
            "gtin": "4066447711424",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff4f",
            "leftCorner": {
              "x": 6.851,
              "y": 4.445,
              "z": 1.821
            },
            "rightCorner": {
              "x": 6.838,
              "y": 4.278,
              "z": 1.821
            },
            "gtin": "4262367684149",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757c5b5fe7bc046959a52",
    "name": "68e757c5b5fe7bc046959a52",
    "x": 6.8988,
    "y": 4.3155,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73201,
      "w": 0.68129
    },
    "statistics": {
      "hasStockCount": 34,
      "noStockCount": 1,
      "unknownStockCount": 41,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd738fd",
        "height": 0.20454,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fe7c",
            "leftCorner": {
              "x": 6.855,
              "y": 4.328,
              "z": 0.203
            },
            "rightCorner": {
              "x": 6.839,
              "y": 4.134,
              "z": 0.203
            },
            "gtin": "4260208910891",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe7d",
            "leftCorner": {
              "x": 6.841,
              "y": 4.146,
              "z": 0.205
            },
            "rightCorner": {
              "x": 6.829,
              "y": 3.981,
              "z": 0.205
            },
            "gtin": "5903018640723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe7e",
            "leftCorner": {
              "x": 6.829,
              "y": 3.981,
              "z": 0.205
            },
            "rightCorner": {
              "x": 6.819,
              "y": 3.837,
              "z": 0.205
            },
            "gtin": "4260208910846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe7f",
            "leftCorner": {
              "x": 6.819,
              "y": 3.837,
              "z": 0.205
            },
            "rightCorner": {
              "x": 6.807,
              "y": 3.679,
              "z": 0.205
            },
            "gtin": "4260208910846",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fe80",
            "leftCorner": {
              "x": 6.807,
              "y": 3.679,
              "z": 0.205
            },
            "rightCorner": {
              "x": 6.792,
              "y": 3.468,
              "z": 0.205
            },
            "gtin": "4260208910815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe81",
            "leftCorner": {
              "x": 6.792,
              "y": 3.468,
              "z": 0.205
            },
            "rightCorner": {
              "x": 6.775,
              "y": 3.233,
              "z": 0.205
            },
            "gtin": "5903018640747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe82",
            "leftCorner": {
              "x": 6.775,
              "y": 3.233,
              "z": 0.205
            },
            "rightCorner": {
              "x": 6.765,
              "y": 3.092,
              "z": 0.205
            },
            "gtin": "9120111881624",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738fe",
        "height": 0.4322,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ff30",
            "leftCorner": {
              "x": 6.854,
              "y": 4.32,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.838,
              "y": 4.121,
              "z": 0.431
            },
            "gtin": "4062300463455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff31",
            "leftCorner": {
              "x": 6.84,
              "y": 4.133,
              "z": 0.432
            },
            "rightCorner": {
              "x": 6.827,
              "y": 3.95,
              "z": 0.432
            },
            "gtin": "4062300399518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff32",
            "leftCorner": {
              "x": 6.827,
              "y": 3.95,
              "z": 0.432
            },
            "rightCorner": {
              "x": 6.817,
              "y": 3.81,
              "z": 0.432
            },
            "gtin": "8588000526239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff33",
            "leftCorner": {
              "x": 6.817,
              "y": 3.81,
              "z": 0.432
            },
            "rightCorner": {
              "x": 6.808,
              "y": 3.688,
              "z": 0.432
            },
            "gtin": "8588000526222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff34",
            "leftCorner": {
              "x": 6.808,
              "y": 3.688,
              "z": 0.432
            },
            "rightCorner": {
              "x": 6.795,
              "y": 3.51,
              "z": 0.432
            },
            "gtin": "4260133237308",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff35",
            "leftCorner": {
              "x": 6.795,
              "y": 3.51,
              "z": 0.432
            },
            "rightCorner": {
              "x": 6.785,
              "y": 3.366,
              "z": 0.432
            },
            "gtin": "4260618523094",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff36",
            "leftCorner": {
              "x": 6.785,
              "y": 3.366,
              "z": 0.432
            },
            "rightCorner": {
              "x": 6.774,
              "y": 3.221,
              "z": 0.432
            },
            "gtin": "4262367682688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff1d",
            "leftCorner": {
              "x": 6.774,
              "y": 3.221,
              "z": 0.432
            },
            "rightCorner": {
              "x": 6.764,
              "y": 3.072,
              "z": 0.432
            },
            "gtin": "4262367684873",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738ff",
        "height": 0.68393,
        "facings": [
          {
            "id": "696ebf6d43c343680a27000c",
            "leftCorner": {
              "x": 6.851,
              "y": 4.292,
              "z": 0.684
            },
            "rightCorner": {
              "x": 6.834,
              "y": 4.064,
              "z": 0.684
            },
            "gtin": "4262367684019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27000d",
            "leftCorner": {
              "x": 6.834,
              "y": 4.064,
              "z": 0.684
            },
            "rightCorner": {
              "x": 6.821,
              "y": 3.881,
              "z": 0.684
            }
          },
          {
            "id": "696ebf6d43c343680a27000e",
            "leftCorner": {
              "x": 6.821,
              "y": 3.881,
              "z": 0.684
            },
            "rightCorner": {
              "x": 6.812,
              "y": 3.754,
              "z": 0.684
            },
            "gtin": "4262367683210",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27000f",
            "leftCorner": {
              "x": 6.812,
              "y": 3.754,
              "z": 0.684
            },
            "rightCorner": {
              "x": 6.802,
              "y": 3.614,
              "z": 0.684
            },
            "gtin": "4262367685177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270010",
            "leftCorner": {
              "x": 6.802,
              "y": 3.614,
              "z": 0.684
            },
            "rightCorner": {
              "x": 6.791,
              "y": 3.465,
              "z": 0.684
            },
            "gtin": "4262367680196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270011",
            "leftCorner": {
              "x": 6.791,
              "y": 3.465,
              "z": 0.684
            },
            "rightCorner": {
              "x": 6.783,
              "y": 3.357,
              "z": 0.684
            },
            "gtin": "4260350926870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270012",
            "leftCorner": {
              "x": 6.783,
              "y": 3.357,
              "z": 0.684
            },
            "rightCorner": {
              "x": 6.772,
              "y": 3.197,
              "z": 0.684
            },
            "gtin": "4260350926856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fff5",
            "leftCorner": {
              "x": 6.772,
              "y": 3.197,
              "z": 0.684
            },
            "rightCorner": {
              "x": 6.763,
              "y": 3.072,
              "z": 0.684
            },
            "gtin": "4260311984536",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738fb",
        "height": 0.93547,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ffeb",
            "leftCorner": {
              "x": 6.85,
              "y": 4.316,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.838,
              "y": 4.163,
              "z": 0.935
            },
            "gtin": "4260133237230",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffec",
            "leftCorner": {
              "x": 6.836,
              "y": 4.175,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.827,
              "y": 4.045,
              "z": 0.935
            },
            "gtin": "4260133233409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffed",
            "leftCorner": {
              "x": 6.827,
              "y": 4.045,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.817,
              "y": 3.901,
              "z": 0.935
            },
            "gtin": "4260133233416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffee",
            "leftCorner": {
              "x": 6.817,
              "y": 3.901,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.808,
              "y": 3.781,
              "z": 0.935
            },
            "gtin": "4260133230781",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffef",
            "leftCorner": {
              "x": 6.808,
              "y": 3.781,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.8,
              "y": 3.665,
              "z": 0.935
            },
            "gtin": "4260133231399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fff0",
            "leftCorner": {
              "x": 6.8,
              "y": 3.665,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.793,
              "y": 3.576,
              "z": 0.935
            },
            "gtin": "4260229232194",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fff1",
            "leftCorner": {
              "x": 6.793,
              "y": 3.576,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.786,
              "y": 3.478,
              "z": 0.935
            },
            "gtin": "4260229232224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fff2",
            "leftCorner": {
              "x": 6.786,
              "y": 3.478,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.776,
              "y": 3.339,
              "z": 0.935
            }
          },
          {
            "id": "696ebf6d43c343680a26fff3",
            "leftCorner": {
              "x": 6.776,
              "y": 3.339,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.766,
              "y": 3.197,
              "z": 0.935
            },
            "gtin": "4262367684569",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffcc",
            "leftCorner": {
              "x": 6.766,
              "y": 3.197,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.757,
              "y": 3.072,
              "z": 0.935
            },
            "gtin": "4262367683562",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738fa",
        "height": 1.1509,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ffbe",
            "leftCorner": {
              "x": 6.846,
              "y": 4.29,
              "z": 1.151
            },
            "rightCorner": {
              "x": 6.841,
              "y": 4.237,
              "z": 1.151
            },
            "gtin": "4260311985267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffbf",
            "leftCorner": {
              "x": 6.842,
              "y": 4.237,
              "z": 1.151
            },
            "rightCorner": {
              "x": 6.837,
              "y": 4.177,
              "z": 1.151
            },
            "gtin": "9120111881709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffc0",
            "leftCorner": {
              "x": 6.837,
              "y": 4.177,
              "z": 1.151
            },
            "rightCorner": {
              "x": 6.822,
              "y": 3.965,
              "z": 1.151
            },
            "gtin": "4262367685306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffc1",
            "leftCorner": {
              "x": 6.822,
              "y": 3.965,
              "z": 1.151
            },
            "rightCorner": {
              "x": 6.813,
              "y": 3.831,
              "z": 1.151
            },
            "gtin": "4262367685320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffc2",
            "leftCorner": {
              "x": 6.813,
              "y": 3.831,
              "z": 1.151
            },
            "rightCorner": {
              "x": 6.81,
              "y": 3.789,
              "z": 1.151
            },
            "gtin": "4262367685344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffc3",
            "leftCorner": {
              "x": 6.81,
              "y": 3.789,
              "z": 1.151
            },
            "rightCorner": {
              "x": 6.804,
              "y": 3.705,
              "z": 1.151
            },
            "gtin": "4260249146907",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffc4",
            "leftCorner": {
              "x": 6.804,
              "y": 3.705,
              "z": 1.151
            },
            "rightCorner": {
              "x": 6.799,
              "y": 3.646,
              "z": 1.151
            },
            "gtin": "4260311980958",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffc5",
            "leftCorner": {
              "x": 6.799,
              "y": 3.646,
              "z": 1.151
            },
            "rightCorner": {
              "x": 6.794,
              "y": 3.57,
              "z": 1.151
            }
          },
          {
            "id": "696ebf6d43c343680a26ffc6",
            "leftCorner": {
              "x": 6.794,
              "y": 3.57,
              "z": 1.151
            },
            "rightCorner": {
              "x": 6.788,
              "y": 3.491,
              "z": 1.151
            },
            "gtin": "4262367685214",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffc7",
            "leftCorner": {
              "x": 6.788,
              "y": 3.491,
              "z": 1.151
            },
            "rightCorner": {
              "x": 6.783,
              "y": 3.416,
              "z": 1.151
            },
            "gtin": "4260208911140",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffc8",
            "leftCorner": {
              "x": 6.783,
              "y": 3.416,
              "z": 1.151
            },
            "rightCorner": {
              "x": 6.777,
              "y": 3.337,
              "z": 1.151
            },
            "gtin": "4260208911126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ffc9",
            "leftCorner": {
              "x": 6.777,
              "y": 3.337,
              "z": 1.151
            },
            "rightCorner": {
              "x": 6.773,
              "y": 3.274,
              "z": 1.151
            },
            "gtin": "4260208911454",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ffca",
            "leftCorner": {
              "x": 6.773,
              "y": 3.274,
              "z": 1.151
            },
            "rightCorner": {
              "x": 6.766,
              "y": 3.186,
              "z": 1.151
            },
            "gtin": "4260208911119",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff9e",
            "leftCorner": {
              "x": 6.766,
              "y": 3.186,
              "z": 1.151
            },
            "rightCorner": {
              "x": 6.758,
              "y": 3.072,
              "z": 1.151
            },
            "gtin": "9120111883550",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738f8",
        "height": 1.3596,
        "facings": [
          {
            "id": "696ebf6d43c343680a26fecc",
            "leftCorner": {
              "x": 6.85,
              "y": 4.316,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.843,
              "y": 4.224,
              "z": 1.36
            },
            "gtin": "4260311984017",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fecd",
            "leftCorner": {
              "x": 6.844,
              "y": 4.236,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.838,
              "y": 4.147,
              "z": 1.36
            },
            "gtin": "4260311981399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fece",
            "leftCorner": {
              "x": 6.838,
              "y": 4.147,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.831,
              "y": 4.05,
              "z": 1.36
            },
            "gtin": "4260311985847",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fecf",
            "leftCorner": {
              "x": 6.831,
              "y": 4.05,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.82,
              "y": 3.902,
              "z": 1.36
            },
            "gtin": "4260311985892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fed0",
            "leftCorner": {
              "x": 6.82,
              "y": 3.902,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.81,
              "y": 3.756,
              "z": 1.36
            },
            "gtin": "4260311980262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fed1",
            "leftCorner": {
              "x": 6.81,
              "y": 3.756,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.803,
              "y": 3.67,
              "z": 1.36
            },
            "gtin": "9120111881518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fed2",
            "leftCorner": {
              "x": 6.803,
              "y": 3.67,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.796,
              "y": 3.57,
              "z": 1.36
            },
            "gtin": "4262367685498",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fed3",
            "leftCorner": {
              "x": 6.796,
              "y": 3.57,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.787,
              "y": 3.448,
              "z": 1.36
            },
            "gtin": "4262367684972",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fed4",
            "leftCorner": {
              "x": 6.787,
              "y": 3.448,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.779,
              "y": 3.334,
              "z": 1.36
            },
            "gtin": "4260249143029",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26fed5",
            "leftCorner": {
              "x": 6.779,
              "y": 3.334,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.77,
              "y": 3.205,
              "z": 1.36
            },
            "gtin": "4262367684996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26fe84",
            "leftCorner": {
              "x": 6.77,
              "y": 3.205,
              "z": 1.36
            },
            "rightCorner": {
              "x": 6.76,
              "y": 3.072,
              "z": 1.36
            },
            "gtin": "4260249145610",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738f9",
        "height": 1.6126,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ff84",
            "leftCorner": {
              "x": 6.842,
              "y": 4.292,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.835,
              "y": 4.196,
              "z": 1.613
            },
            "gtin": "4260311983973",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff85",
            "leftCorner": {
              "x": 6.835,
              "y": 4.196,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.827,
              "y": 4.084,
              "z": 1.613
            },
            "gtin": "4260311984772",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff86",
            "leftCorner": {
              "x": 6.827,
              "y": 4.084,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.82,
              "y": 3.977,
              "z": 1.613
            },
            "gtin": "4260311985311",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff87",
            "leftCorner": {
              "x": 6.82,
              "y": 3.977,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.812,
              "y": 3.869,
              "z": 1.613
            },
            "gtin": "4260311986110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff88",
            "leftCorner": {
              "x": 6.812,
              "y": 3.869,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.805,
              "y": 3.775,
              "z": 1.613
            },
            "gtin": "4260311980026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff89",
            "leftCorner": {
              "x": 6.805,
              "y": 3.775,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.798,
              "y": 3.682,
              "z": 1.613
            },
            "gtin": "4260311981412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff8a",
            "leftCorner": {
              "x": 6.798,
              "y": 3.682,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.792,
              "y": 3.593,
              "z": 1.613
            },
            "gtin": "4260311984499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff8b",
            "leftCorner": {
              "x": 6.792,
              "y": 3.593,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.784,
              "y": 3.485,
              "z": 1.613
            },
            "gtin": "4260311983423",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff8c",
            "leftCorner": {
              "x": 6.784,
              "y": 3.485,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.776,
              "y": 3.373,
              "z": 1.613
            },
            "gtin": "4260311985953",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff8d",
            "leftCorner": {
              "x": 6.776,
              "y": 3.373,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.768,
              "y": 3.253,
              "z": 1.613
            },
            "gtin": "4262367685023",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff8e",
            "leftCorner": {
              "x": 6.768,
              "y": 3.253,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.761,
              "y": 3.16,
              "z": 1.613
            },
            "gtin": "4260350926917",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff8f",
            "leftCorner": {
              "x": 6.761,
              "y": 3.16,
              "z": 1.613
            },
            "rightCorner": {
              "x": 6.753,
              "y": 3.05,
              "z": 1.613
            },
            "gtin": "4260350927037",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd738fc",
        "height": 1.8217,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ff50",
            "leftCorner": {
              "x": 6.837,
              "y": 4.29,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.826,
              "y": 4.13,
              "z": 1.822
            },
            "gtin": "4262367684163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff51",
            "leftCorner": {
              "x": 6.826,
              "y": 4.13,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.819,
              "y": 4.032,
              "z": 1.822
            },
            "gtin": "4251099707219",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff52",
            "leftCorner": {
              "x": 6.819,
              "y": 4.032,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.811,
              "y": 3.923,
              "z": 1.822
            },
            "gtin": "4251099603900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff53",
            "leftCorner": {
              "x": 6.811,
              "y": 3.923,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.803,
              "y": 3.811,
              "z": 1.822
            },
            "gtin": "4260133234918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff54",
            "leftCorner": {
              "x": 6.803,
              "y": 3.811,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.794,
              "y": 3.693,
              "z": 1.822
            },
            "gtin": "4260133233324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff55",
            "leftCorner": {
              "x": 6.794,
              "y": 3.693,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.787,
              "y": 3.587,
              "z": 1.822
            },
            "gtin": "4260133231290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff56",
            "leftCorner": {
              "x": 6.787,
              "y": 3.587,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.778,
              "y": 3.466,
              "z": 1.822
            },
            "gtin": "4260133232402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff57",
            "leftCorner": {
              "x": 6.778,
              "y": 3.466,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.769,
              "y": 3.344,
              "z": 1.822
            }
          },
          {
            "id": "696ebf6d43c343680a26ff58",
            "leftCorner": {
              "x": 6.769,
              "y": 3.344,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.762,
              "y": 3.238,
              "z": 1.822
            },
            "gtin": "4260133234789",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff59",
            "leftCorner": {
              "x": 6.762,
              "y": 3.238,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.753,
              "y": 3.124,
              "z": 1.822
            },
            "gtin": "4260133236264",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757c5b5fe7bc046959a53",
    "name": "68e757c5b5fe7bc046959a53",
    "x": 6.8143,
    "y": 3.074,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73705,
      "w": 0.67584
    },
    "statistics": {
      "hasStockCount": 39,
      "noStockCount": 0,
      "unknownStockCount": 38,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73901",
        "height": 0.50031,
        "facings": [
          {
            "id": "696ebf6d43c343680a270013",
            "leftCorner": {
              "x": 6.771,
              "y": 3.078,
              "z": 0.5
            },
            "rightCorner": {
              "x": 6.749,
              "y": 2.83,
              "z": 0.5
            },
            "gtin": "4018852032762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270015",
            "leftCorner": {
              "x": 6.749,
              "y": 2.83,
              "z": 0.5
            },
            "rightCorner": {
              "x": 6.737,
              "y": 2.685,
              "z": 0.5
            },
            "gtin": "4018852032786",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270016",
            "leftCorner": {
              "x": 6.737,
              "y": 2.685,
              "z": 0.5
            },
            "rightCorner": {
              "x": 6.725,
              "y": 2.549,
              "z": 0.5
            },
            "gtin": "4018852032779",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270017",
            "leftCorner": {
              "x": 6.725,
              "y": 2.549,
              "z": 0.5
            },
            "rightCorner": {
              "x": 6.712,
              "y": 2.399,
              "z": 0.5
            },
            "gtin": "4018852032793",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270018",
            "leftCorner": {
              "x": 6.712,
              "y": 2.399,
              "z": 0.5
            },
            "rightCorner": {
              "x": 6.705,
              "y": 2.321,
              "z": 0.5
            },
            "gtin": "4067796002560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270019",
            "leftCorner": {
              "x": 6.705,
              "y": 2.321,
              "z": 0.5
            },
            "rightCorner": {
              "x": 6.699,
              "y": 2.249,
              "z": 0.5
            },
            "gtin": "4067796002560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27001a",
            "leftCorner": {
              "x": 6.699,
              "y": 2.249,
              "z": 0.5
            },
            "rightCorner": {
              "x": 6.687,
              "y": 2.115,
              "z": 0.5
            },
            "gtin": "4066447616217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27001b",
            "leftCorner": {
              "x": 6.687,
              "y": 2.115,
              "z": 0.5
            },
            "rightCorner": {
              "x": 6.675,
              "y": 1.967,
              "z": 0.5
            },
            "gtin": "4066447709643",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270014",
            "leftCorner": {
              "x": 6.675,
              "y": 1.967,
              "z": 0.5
            },
            "rightCorner": {
              "x": 6.663,
              "y": 1.832,
              "z": 0.5
            },
            "gtin": "4066447709667",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73902",
        "height": 0.19357,
        "facings": [
          {
            "id": "696ebf6d43c343680a27001c",
            "leftCorner": {
              "x": 6.764,
              "y": 3.078,
              "z": 0.194
            },
            "rightCorner": {
              "x": 6.748,
              "y": 2.897,
              "z": 0.194
            },
            "gtin": "4058172812941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27001d",
            "leftCorner": {
              "x": 6.748,
              "y": 2.897,
              "z": 0.194
            },
            "rightCorner": {
              "x": 6.719,
              "y": 2.559,
              "z": 0.194
            },
            "gtin": "4058172812965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27001e",
            "leftCorner": {
              "x": 6.719,
              "y": 2.559,
              "z": 0.194
            },
            "rightCorner": {
              "x": 6.701,
              "y": 2.356,
              "z": 0.194
            },
            "gtin": "4062300428720",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27001f",
            "leftCorner": {
              "x": 6.701,
              "y": 2.356,
              "z": 0.194
            },
            "rightCorner": {
              "x": 6.686,
              "y": 2.18,
              "z": 0.194
            },
            "gtin": "4066447762983",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270020",
            "leftCorner": {
              "x": 6.686,
              "y": 2.18,
              "z": 0.194
            },
            "rightCorner": {
              "x": 6.669,
              "y": 1.986,
              "z": 0.194
            }
          },
          {
            "id": "696ebf6d43c343680a270021",
            "leftCorner": {
              "x": 6.669,
              "y": 1.986,
              "z": 0.194
            },
            "rightCorner": {
              "x": 6.663,
              "y": 1.917,
              "z": 0.194
            },
            "gtin": "9120111882461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270022",
            "leftCorner": {
              "x": 6.663,
              "y": 1.917,
              "z": 0.194
            },
            "rightCorner": {
              "x": 6.657,
              "y": 1.847,
              "z": 0.194
            },
            "gtin": "9120111882461",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73903",
        "height": 0.80676,
        "facings": [
          {
            "id": "696ebf6d43c343680a270023",
            "leftCorner": {
              "x": 6.772,
              "y": 3.078,
              "z": 0.807
            },
            "rightCorner": {
              "x": 6.761,
              "y": 2.949,
              "z": 0.807
            },
            "gtin": "4066447704051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270025",
            "leftCorner": {
              "x": 6.761,
              "y": 2.949,
              "z": 0.807
            },
            "rightCorner": {
              "x": 6.746,
              "y": 2.784,
              "z": 0.807
            },
            "gtin": "8720294065623",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270026",
            "leftCorner": {
              "x": 6.746,
              "y": 2.784,
              "z": 0.807
            },
            "rightCorner": {
              "x": 6.737,
              "y": 2.671,
              "z": 0.807
            },
            "gtin": "8720294053309",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270027",
            "leftCorner": {
              "x": 6.737,
              "y": 2.671,
              "z": 0.807
            },
            "rightCorner": {
              "x": 6.728,
              "y": 2.577,
              "z": 0.807
            },
            "gtin": "8720294070108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270028",
            "leftCorner": {
              "x": 6.728,
              "y": 2.577,
              "z": 0.807
            },
            "rightCorner": {
              "x": 6.721,
              "y": 2.485,
              "z": 0.807
            },
            "gtin": "8720294053286",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270029",
            "leftCorner": {
              "x": 6.721,
              "y": 2.485,
              "z": 0.807
            },
            "rightCorner": {
              "x": 6.713,
              "y": 2.398,
              "z": 0.807
            },
            "gtin": "8720294053293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27002a",
            "leftCorner": {
              "x": 6.713,
              "y": 2.398,
              "z": 0.807
            },
            "rightCorner": {
              "x": 6.701,
              "y": 2.256,
              "z": 0.807
            },
            "gtin": "4062300345287",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27002b",
            "leftCorner": {
              "x": 6.701,
              "y": 2.256,
              "z": 0.807
            },
            "rightCorner": {
              "x": 6.695,
              "y": 2.187,
              "z": 0.807
            },
            "gtin": "4066447709629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27002c",
            "leftCorner": {
              "x": 6.695,
              "y": 2.187,
              "z": 0.807
            },
            "rightCorner": {
              "x": 6.689,
              "y": 2.118,
              "z": 0.807
            },
            "gtin": "4066447709629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27002d",
            "leftCorner": {
              "x": 6.689,
              "y": 2.118,
              "z": 0.807
            },
            "rightCorner": {
              "x": 6.682,
              "y": 2.042,
              "z": 0.807
            },
            "gtin": "4066447616194",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27002e",
            "leftCorner": {
              "x": 6.682,
              "y": 2.042,
              "z": 0.807
            },
            "rightCorner": {
              "x": 6.676,
              "y": 1.974,
              "z": 0.807
            },
            "gtin": "4066447616194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270024",
            "leftCorner": {
              "x": 6.676,
              "y": 1.974,
              "z": 0.807
            },
            "rightCorner": {
              "x": 6.664,
              "y": 1.832,
              "z": 0.807
            },
            "gtin": "4018852032755",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73904",
        "height": 1.0512,
        "facings": [
          {
            "id": "696ebf6d43c343680a27002f",
            "leftCorner": {
              "x": 6.777,
              "y": 3.077,
              "z": 1.051
            },
            "rightCorner": {
              "x": 6.763,
              "y": 2.913,
              "z": 1.051
            },
            "gtin": "4018852036630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270031",
            "leftCorner": {
              "x": 6.763,
              "y": 2.913,
              "z": 1.051
            },
            "rightCorner": {
              "x": 6.755,
              "y": 2.821,
              "z": 1.051
            },
            "gtin": "4066447910292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270032",
            "leftCorner": {
              "x": 6.755,
              "y": 2.821,
              "z": 1.051
            },
            "rightCorner": {
              "x": 6.745,
              "y": 2.709,
              "z": 1.051
            },
            "gtin": "4066447877472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270033",
            "leftCorner": {
              "x": 6.745,
              "y": 2.709,
              "z": 1.051
            },
            "rightCorner": {
              "x": 6.74,
              "y": 2.644,
              "z": 1.051
            },
            "gtin": "4260347955418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270034",
            "leftCorner": {
              "x": 6.74,
              "y": 2.644,
              "z": 1.051
            },
            "rightCorner": {
              "x": 6.735,
              "y": 2.588,
              "z": 1.051
            },
            "gtin": "4260347956347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270035",
            "leftCorner": {
              "x": 6.735,
              "y": 2.588,
              "z": 1.051
            },
            "rightCorner": {
              "x": 6.729,
              "y": 2.521,
              "z": 1.051
            },
            "gtin": "4260347959362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270036",
            "leftCorner": {
              "x": 6.729,
              "y": 2.521,
              "z": 1.051
            },
            "rightCorner": {
              "x": 6.723,
              "y": 2.449,
              "z": 1.051
            },
            "gtin": "4260347956316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270037",
            "leftCorner": {
              "x": 6.723,
              "y": 2.449,
              "z": 1.051
            },
            "rightCorner": {
              "x": 6.716,
              "y": 2.376,
              "z": 1.051
            },
            "gtin": "4260347953650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270038",
            "leftCorner": {
              "x": 6.716,
              "y": 2.376,
              "z": 1.051
            },
            "rightCorner": {
              "x": 6.71,
              "y": 2.308,
              "z": 1.051
            },
            "gtin": "9120111880917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270039",
            "leftCorner": {
              "x": 6.71,
              "y": 2.308,
              "z": 1.051
            },
            "rightCorner": {
              "x": 6.704,
              "y": 2.237,
              "z": 1.051
            }
          },
          {
            "id": "696ebf6d43c343680a27003a",
            "leftCorner": {
              "x": 6.704,
              "y": 2.237,
              "z": 1.051
            },
            "rightCorner": {
              "x": 6.698,
              "y": 2.161,
              "z": 1.051
            },
            "gtin": "9120111880931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27003b",
            "leftCorner": {
              "x": 6.698,
              "y": 2.161,
              "z": 1.051
            },
            "rightCorner": {
              "x": 6.692,
              "y": 2.096,
              "z": 1.051
            },
            "gtin": "9120111880931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27003c",
            "leftCorner": {
              "x": 6.692,
              "y": 2.096,
              "z": 1.051
            },
            "rightCorner": {
              "x": 6.687,
              "y": 2.035,
              "z": 1.051
            },
            "gtin": "4062300034747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27003d",
            "leftCorner": {
              "x": 6.687,
              "y": 2.035,
              "z": 1.051
            },
            "rightCorner": {
              "x": 6.682,
              "y": 1.985,
              "z": 1.051
            },
            "gtin": "4062300034778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27003e",
            "leftCorner": {
              "x": 6.682,
              "y": 1.985,
              "z": 1.051
            },
            "rightCorner": {
              "x": 6.674,
              "y": 1.894,
              "z": 1.051
            },
            "gtin": "4062300393639",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270030",
            "leftCorner": {
              "x": 6.674,
              "y": 1.894,
              "z": 1.051
            },
            "rightCorner": {
              "x": 6.669,
              "y": 1.832,
              "z": 1.051
            },
            "gtin": "4062300392915",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73907",
        "height": 1.3035,
        "facings": [
          {
            "id": "696ebf6d43c343680a27003f",
            "leftCorner": {
              "x": 6.769,
              "y": 3.078,
              "z": 1.304
            },
            "rightCorner": {
              "x": 6.755,
              "y": 2.908,
              "z": 1.304
            },
            "gtin": "4008137030187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270041",
            "leftCorner": {
              "x": 6.755,
              "y": 2.908,
              "z": 1.304
            },
            "rightCorner": {
              "x": 6.741,
              "y": 2.755,
              "z": 1.304
            },
            "gtin": "4004191017737",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270042",
            "leftCorner": {
              "x": 6.741,
              "y": 2.755,
              "z": 1.304
            },
            "rightCorner": {
              "x": 6.726,
              "y": 2.578,
              "z": 1.304
            },
            "gtin": "4058172958632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270043",
            "leftCorner": {
              "x": 6.726,
              "y": 2.578,
              "z": 1.304
            },
            "rightCorner": {
              "x": 6.711,
              "y": 2.402,
              "z": 1.304
            },
            "gtin": "4058172958571",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270044",
            "leftCorner": {
              "x": 6.711,
              "y": 2.402,
              "z": 1.304
            },
            "rightCorner": {
              "x": 6.694,
              "y": 2.209,
              "z": 1.304
            },
            "gtin": "4058172958656",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270045",
            "leftCorner": {
              "x": 6.694,
              "y": 2.209,
              "z": 1.304
            },
            "rightCorner": {
              "x": 6.677,
              "y": 2.018,
              "z": 1.304
            },
            "gtin": "4066447413809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270040",
            "leftCorner": {
              "x": 6.677,
              "y": 2.018,
              "z": 1.304
            },
            "rightCorner": {
              "x": 6.661,
              "y": 1.832,
              "z": 1.304
            },
            "gtin": "4066447413786",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73905",
        "height": 1.6113,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ff90",
            "leftCorner": {
              "x": 6.766,
              "y": 3.056,
              "z": 1.611
            },
            "rightCorner": {
              "x": 6.753,
              "y": 2.907,
              "z": 1.611
            },
            "gtin": "4260526927113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff91",
            "leftCorner": {
              "x": 6.753,
              "y": 2.907,
              "z": 1.611
            },
            "rightCorner": {
              "x": 6.747,
              "y": 2.837,
              "z": 1.611
            },
            "gtin": "4262367684347",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff92",
            "leftCorner": {
              "x": 6.747,
              "y": 2.837,
              "z": 1.611
            },
            "rightCorner": {
              "x": 6.74,
              "y": 2.755,
              "z": 1.611
            },
            "gtin": "4260133234802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff93",
            "leftCorner": {
              "x": 6.74,
              "y": 2.755,
              "z": 1.611
            },
            "rightCorner": {
              "x": 6.728,
              "y": 2.624,
              "z": 1.611
            },
            "gtin": "4262367684958",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff94",
            "leftCorner": {
              "x": 6.728,
              "y": 2.624,
              "z": 1.611
            },
            "rightCorner": {
              "x": 6.72,
              "y": 2.521,
              "z": 1.611
            },
            "gtin": "4262367681209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff95",
            "leftCorner": {
              "x": 6.72,
              "y": 2.521,
              "z": 1.611
            },
            "rightCorner": {
              "x": 6.715,
              "y": 2.467,
              "z": 1.611
            },
            "gtin": "4062300236424",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff96",
            "leftCorner": {
              "x": 6.715,
              "y": 2.467,
              "z": 1.611
            },
            "rightCorner": {
              "x": 6.71,
              "y": 2.407,
              "z": 1.611
            },
            "gtin": "4062300236424",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff97",
            "leftCorner": {
              "x": 6.71,
              "y": 2.407,
              "z": 1.611
            },
            "rightCorner": {
              "x": 6.703,
              "y": 2.336,
              "z": 1.611
            },
            "gtin": "4058172684203",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff98",
            "leftCorner": {
              "x": 6.703,
              "y": 2.336,
              "z": 1.611
            },
            "rightCorner": {
              "x": 6.694,
              "y": 2.227,
              "z": 1.611
            },
            "gtin": "4066447348590",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff99",
            "leftCorner": {
              "x": 6.694,
              "y": 2.227,
              "z": 1.611
            },
            "rightCorner": {
              "x": 6.681,
              "y": 2.08,
              "z": 1.611
            },
            "gtin": "4067796003451",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff9a",
            "leftCorner": {
              "x": 6.681,
              "y": 2.08,
              "z": 1.611
            },
            "rightCorner": {
              "x": 6.677,
              "y": 2.028,
              "z": 1.611
            },
            "gtin": "4066447495287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff9b",
            "leftCorner": {
              "x": 6.677,
              "y": 2.028,
              "z": 1.611
            },
            "rightCorner": {
              "x": 6.672,
              "y": 1.976,
              "z": 1.611
            },
            "gtin": "4066447495287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff9c",
            "leftCorner": {
              "x": 6.672,
              "y": 1.976,
              "z": 1.611
            },
            "rightCorner": {
              "x": 6.668,
              "y": 1.923,
              "z": 1.611
            },
            "gtin": "4260618523377",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff69",
            "leftCorner": {
              "x": 6.668,
              "y": 1.923,
              "z": 1.611
            },
            "rightCorner": {
              "x": 6.66,
              "y": 1.833,
              "z": 1.611
            },
            "gtin": "7640230491716",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73900",
        "height": 1.8203,
        "facings": [
          {
            "id": "696ebf6d43c343680a26ff5a",
            "leftCorner": {
              "x": 6.753,
              "y": 3.124,
              "z": 1.822
            },
            "rightCorner": {
              "x": 6.742,
              "y": 2.967,
              "z": 1.822
            },
            "gtin": "4260133236455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff5b",
            "leftCorner": {
              "x": 6.751,
              "y": 2.973,
              "z": 1.82
            },
            "rightCorner": {
              "x": 6.743,
              "y": 2.878,
              "z": 1.82
            },
            "gtin": "4260526596715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff5c",
            "leftCorner": {
              "x": 6.743,
              "y": 2.878,
              "z": 1.82
            },
            "rightCorner": {
              "x": 6.732,
              "y": 2.757,
              "z": 1.82
            },
            "gtin": "4066447191004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff5d",
            "leftCorner": {
              "x": 6.732,
              "y": 2.757,
              "z": 1.82
            },
            "rightCorner": {
              "x": 6.722,
              "y": 2.639,
              "z": 1.82
            },
            "gtin": "4066447229677",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff5e",
            "leftCorner": {
              "x": 6.722,
              "y": 2.639,
              "z": 1.82
            },
            "rightCorner": {
              "x": 6.715,
              "y": 2.559,
              "z": 1.82
            },
            "gtin": "4066447154283",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff5f",
            "leftCorner": {
              "x": 6.715,
              "y": 2.559,
              "z": 1.82
            },
            "rightCorner": {
              "x": 6.709,
              "y": 2.484,
              "z": 1.82
            },
            "gtin": "4066447154276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a26ff60",
            "leftCorner": {
              "x": 6.709,
              "y": 2.484,
              "z": 1.82
            },
            "rightCorner": {
              "x": 6.702,
              "y": 2.405,
              "z": 1.82
            },
            "gtin": "4066447218312",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff61",
            "leftCorner": {
              "x": 6.702,
              "y": 2.405,
              "z": 1.82
            },
            "rightCorner": {
              "x": 6.695,
              "y": 2.329,
              "z": 1.82
            },
            "gtin": "4066447218299",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff62",
            "leftCorner": {
              "x": 6.695,
              "y": 2.329,
              "z": 1.82
            },
            "rightCorner": {
              "x": 6.688,
              "y": 2.241,
              "z": 1.82
            },
            "gtin": "4066447218336",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff63",
            "leftCorner": {
              "x": 6.688,
              "y": 2.241,
              "z": 1.82
            },
            "rightCorner": {
              "x": 6.68,
              "y": 2.157,
              "z": 1.82
            },
            "gtin": "4260347955517",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff64",
            "leftCorner": {
              "x": 6.68,
              "y": 2.157,
              "z": 1.82
            },
            "rightCorner": {
              "x": 6.674,
              "y": 2.08,
              "z": 1.82
            },
            "gtin": "4260347955548",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff65",
            "leftCorner": {
              "x": 6.674,
              "y": 2.08,
              "z": 1.82
            },
            "rightCorner": {
              "x": 6.666,
              "y": 1.989,
              "z": 1.82
            },
            "gtin": "4260347955548",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff66",
            "leftCorner": {
              "x": 6.666,
              "y": 1.989,
              "z": 1.82
            },
            "rightCorner": {
              "x": 6.659,
              "y": 1.908,
              "z": 1.82
            },
            "gtin": "4062300369269",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a26ff67",
            "leftCorner": {
              "x": 6.659,
              "y": 1.908,
              "z": 1.82
            },
            "rightCorner": {
              "x": 6.652,
              "y": 1.835,
              "z": 1.82
            },
            "gtin": "9120111881587",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757c5b5fe7bc046959a54",
    "name": "68e757c5b5fe7bc046959a54",
    "x": 8.2901,
    "y": 1.7041,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68202,
      "w": 0.73134
    },
    "statistics": {
      "hasStockCount": 13,
      "noStockCount": 5,
      "unknownStockCount": 25
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd7390c",
        "height": 0.20408,
        "facings": [
          {
            "id": "696ebf6d43c343680a270068",
            "leftCorner": {
              "x": 8.335,
              "y": 1.701,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.344,
              "y": 1.824,
              "z": 0.204
            },
            "gtin": "4015200035765",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270069",
            "leftCorner": {
              "x": 8.344,
              "y": 1.824,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.354,
              "y": 1.97,
              "z": 0.204
            },
            "gtin": "4002448046424",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27006a",
            "leftCorner": {
              "x": 8.354,
              "y": 1.97,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.357,
              "y": 2.014,
              "z": 0.204
            },
            "gtin": "4002448046424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27006b",
            "leftCorner": {
              "x": 8.357,
              "y": 2.014,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.368,
              "y": 2.174,
              "z": 0.204
            }
          },
          {
            "id": "696ebf6d43c343680a27006c",
            "leftCorner": {
              "x": 8.368,
              "y": 2.174,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.39,
              "y": 2.493,
              "z": 0.204
            },
            "gtin": "4010355486110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27006d",
            "leftCorner": {
              "x": 8.39,
              "y": 2.493,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.397,
              "y": 2.582,
              "z": 0.204
            },
            "gtin": "4251758419781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27006e",
            "leftCorner": {
              "x": 8.397,
              "y": 2.582,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.403,
              "y": 2.672,
              "z": 0.204
            }
          },
          {
            "id": "696ebf6d43c343680a27006f",
            "leftCorner": {
              "x": 8.403,
              "y": 2.672,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.41,
              "y": 2.778,
              "z": 0.204
            },
            "gtin": "4066447212525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270070",
            "leftCorner": {
              "x": 8.41,
              "y": 2.778,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.419,
              "y": 2.903,
              "z": 0.204
            },
            "gtin": "4015000310048",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7390f",
        "height": 0.55332,
        "facings": [
          {
            "id": "696ebf6d43c343680a27012e",
            "leftCorner": {
              "x": 8.339,
              "y": 1.701,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.348,
              "y": 1.827,
              "z": 0.553
            },
            "gtin": "4015200036328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270130",
            "leftCorner": {
              "x": 8.348,
              "y": 1.827,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.363,
              "y": 2.042,
              "z": 0.553
            },
            "gtin": "4002448083399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270131",
            "leftCorner": {
              "x": 8.363,
              "y": 2.042,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.38,
              "y": 2.282,
              "z": 0.553
            },
            "gtin": "4002448083399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270132",
            "leftCorner": {
              "x": 8.38,
              "y": 2.282,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.39,
              "y": 2.437,
              "z": 0.553
            }
          },
          {
            "id": "696ebf6d43c343680a270133",
            "leftCorner": {
              "x": 8.39,
              "y": 2.437,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.402,
              "y": 2.602,
              "z": 0.553
            },
            "gtin": "4066447413762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270134",
            "leftCorner": {
              "x": 8.402,
              "y": 2.602,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.413,
              "y": 2.757,
              "z": 0.553
            },
            "gtin": "4066447793154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270135",
            "leftCorner": {
              "x": 8.413,
              "y": 2.757,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.427,
              "y": 2.957,
              "z": 0.553
            },
            "gtin": "4066447793178",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7390b",
        "height": 0.85043,
        "facings": [
          {
            "id": "696ebf6d43c343680a270051",
            "leftCorner": {
              "x": 8.338,
              "y": 1.701,
              "z": 0.85
            },
            "rightCorner": {
              "x": 8.346,
              "y": 1.812,
              "z": 0.85
            },
            "gtin": "4001499958694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270053",
            "leftCorner": {
              "x": 8.346,
              "y": 1.812,
              "z": 0.85
            },
            "rightCorner": {
              "x": 8.357,
              "y": 1.977,
              "z": 0.85
            },
            "gtin": "4001499968556",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270054",
            "leftCorner": {
              "x": 8.357,
              "y": 1.977,
              "z": 0.85
            },
            "rightCorner": {
              "x": 8.37,
              "y": 2.166,
              "z": 0.85
            },
            "gtin": "4001499963339",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270055",
            "leftCorner": {
              "x": 8.37,
              "y": 2.166,
              "z": 0.85
            },
            "rightCorner": {
              "x": 8.384,
              "y": 2.36,
              "z": 0.85
            },
            "gtin": "9005835313364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270056",
            "leftCorner": {
              "x": 8.384,
              "y": 2.36,
              "z": 0.85
            },
            "rightCorner": {
              "x": 8.393,
              "y": 2.49,
              "z": 0.85
            },
            "gtin": "4066447793130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270057",
            "leftCorner": {
              "x": 8.393,
              "y": 2.49,
              "z": 0.85
            },
            "rightCorner": {
              "x": 8.405,
              "y": 2.658,
              "z": 0.85
            },
            "gtin": "4066447220223",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270058",
            "leftCorner": {
              "x": 8.405,
              "y": 2.658,
              "z": 0.85
            },
            "rightCorner": {
              "x": 8.416,
              "y": 2.811,
              "z": 0.85
            }
          },
          {
            "id": "696ebf6d43c343680a270059",
            "leftCorner": {
              "x": 8.416,
              "y": 2.811,
              "z": 0.85
            },
            "rightCorner": {
              "x": 8.425,
              "y": 2.948,
              "z": 0.85
            },
            "gtin": "4066447807028",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7390a",
        "height": 1.1483,
        "facings": [
          {
            "id": "696ebf6d43c343680a270046",
            "leftCorner": {
              "x": 8.337,
              "y": 1.701,
              "z": 1.148
            },
            "rightCorner": {
              "x": 8.341,
              "y": 1.769,
              "z": 1.148
            },
            "gtin": "4001499969799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270048",
            "leftCorner": {
              "x": 8.341,
              "y": 1.769,
              "z": 1.148
            },
            "rightCorner": {
              "x": 8.351,
              "y": 1.909,
              "z": 1.148
            },
            "gtin": "4015000970211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270049",
            "leftCorner": {
              "x": 8.351,
              "y": 1.909,
              "z": 1.148
            },
            "rightCorner": {
              "x": 8.359,
              "y": 2.017,
              "z": 1.148
            },
            "gtin": "4015200035772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27004a",
            "leftCorner": {
              "x": 8.359,
              "y": 2.017,
              "z": 1.148
            },
            "rightCorner": {
              "x": 8.369,
              "y": 2.169,
              "z": 1.148
            },
            "gtin": "4066447763126",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27004b",
            "leftCorner": {
              "x": 8.369,
              "y": 2.169,
              "z": 1.148
            },
            "rightCorner": {
              "x": 8.38,
              "y": 2.316,
              "z": 1.148
            },
            "gtin": "4251758400451",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27004c",
            "leftCorner": {
              "x": 8.38,
              "y": 2.316,
              "z": 1.148
            },
            "rightCorner": {
              "x": 8.386,
              "y": 2.41,
              "z": 1.148
            },
            "gtin": "4008455049113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27004d",
            "leftCorner": {
              "x": 8.386,
              "y": 2.41,
              "z": 1.148
            },
            "rightCorner": {
              "x": 8.395,
              "y": 2.539,
              "z": 1.148
            },
            "gtin": "4066447149180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27004e",
            "leftCorner": {
              "x": 8.395,
              "y": 2.539,
              "z": 1.148
            },
            "rightCorner": {
              "x": 8.4,
              "y": 2.605,
              "z": 1.148
            },
            "gtin": "4067796132946",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27004f",
            "leftCorner": {
              "x": 8.4,
              "y": 2.605,
              "z": 1.148
            },
            "rightCorner": {
              "x": 8.406,
              "y": 2.698,
              "z": 1.148
            },
            "gtin": "4015200035727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270050",
            "leftCorner": {
              "x": 8.406,
              "y": 2.698,
              "z": 1.148
            },
            "rightCorner": {
              "x": 8.414,
              "y": 2.8,
              "z": 1.148
            },
            "gtin": "4015200035727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270047",
            "leftCorner": {
              "x": 8.414,
              "y": 2.8,
              "z": 1.148
            },
            "rightCorner": {
              "x": 8.424,
              "y": 2.948,
              "z": 1.148
            },
            "gtin": "4262459711708",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7390d",
        "height": 1.4024,
        "facings": [
          {
            "id": "696ebf6d43c343680a2700bb",
            "leftCorner": {
              "x": 8.342,
              "y": 1.7,
              "z": 1.402
            },
            "rightCorner": {
              "x": 8.348,
              "y": 1.785,
              "z": 1.402
            },
            "gtin": "4015200036717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700bd",
            "leftCorner": {
              "x": 8.348,
              "y": 1.785,
              "z": 1.402
            },
            "rightCorner": {
              "x": 8.355,
              "y": 1.88,
              "z": 1.402
            },
            "gtin": "4015200036717",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700be",
            "leftCorner": {
              "x": 8.355,
              "y": 1.88,
              "z": 1.402
            },
            "rightCorner": {
              "x": 8.371,
              "y": 2.113,
              "z": 1.402
            },
            "gtin": "4015200037080",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700bf",
            "leftCorner": {
              "x": 8.371,
              "y": 2.113,
              "z": 1.402
            },
            "rightCorner": {
              "x": 8.384,
              "y": 2.304,
              "z": 1.402
            }
          },
          {
            "id": "696ebf6d43c343680a2700c0",
            "leftCorner": {
              "x": 8.384,
              "y": 2.304,
              "z": 1.402
            },
            "rightCorner": {
              "x": 8.4,
              "y": 2.533,
              "z": 1.402
            },
            "gtin": "4015200038155",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700c1",
            "leftCorner": {
              "x": 8.4,
              "y": 2.533,
              "z": 1.402
            },
            "rightCorner": {
              "x": 8.413,
              "y": 2.719,
              "z": 1.402
            },
            "gtin": "4015200036526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700c2",
            "leftCorner": {
              "x": 8.413,
              "y": 2.719,
              "z": 1.402
            },
            "rightCorner": {
              "x": 8.43,
              "y": 2.954,
              "z": 1.402
            },
            "gtin": "4015200037103",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7390e",
        "height": 1.7351,
        "facings": [
          {
            "id": "696ebf6d43c343680a2700d1",
            "leftCorner": {
              "x": 8.345,
              "y": 1.7,
              "z": 1.735
            },
            "rightCorner": {
              "x": 8.358,
              "y": 1.889,
              "z": 1.735
            },
            "gtin": "4251758418807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700d3",
            "leftCorner": {
              "x": 8.358,
              "y": 1.889,
              "z": 1.735
            },
            "rightCorner": {
              "x": 8.38,
              "y": 2.191,
              "z": 1.735
            },
            "gtin": "4251758426420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700d4",
            "leftCorner": {
              "x": 8.38,
              "y": 2.191,
              "z": 1.735
            },
            "rightCorner": {
              "x": 8.395,
              "y": 2.412,
              "z": 1.735
            },
            "gtin": "4251758427526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700d5",
            "leftCorner": {
              "x": 8.395,
              "y": 2.412,
              "z": 1.735
            },
            "rightCorner": {
              "x": 8.405,
              "y": 2.557,
              "z": 1.735
            },
            "gtin": "4251758419279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700d6",
            "leftCorner": {
              "x": 8.405,
              "y": 2.557,
              "z": 1.735
            },
            "rightCorner": {
              "x": 8.423,
              "y": 2.809,
              "z": 1.735
            },
            "gtin": "4251758437778",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700d7",
            "leftCorner": {
              "x": 8.423,
              "y": 2.809,
              "z": 1.735
            },
            "rightCorner": {
              "x": 8.434,
              "y": 2.976,
              "z": 1.735
            },
            "gtin": "4015200037110",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757c5b5fe7bc046959a55",
    "name": "68e757c5b5fe7bc046959a55",
    "x": 8.3737,
    "y": 2.9654,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.67675,
      "w": 0.73621
    },
    "statistics": {
      "hasStockCount": 34,
      "noStockCount": 1,
      "unknownStockCount": 40
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73911",
        "height": 0.20301,
        "facings": [
          {
            "id": "696ebf6d43c343680a270071",
            "leftCorner": {
              "x": 8.419,
              "y": 2.903,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.429,
              "y": 3.044,
              "z": 0.204
            },
            "gtin": "4013162034062",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270072",
            "leftCorner": {
              "x": 8.427,
              "y": 3.057,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.441,
              "y": 3.226,
              "z": 0.203
            },
            "gtin": "4013162034086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270073",
            "leftCorner": {
              "x": 8.441,
              "y": 3.226,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.449,
              "y": 3.323,
              "z": 0.203
            },
            "gtin": "4066447232011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270074",
            "leftCorner": {
              "x": 8.449,
              "y": 3.323,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.46,
              "y": 3.445,
              "z": 0.203
            },
            "gtin": "4066447232011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270075",
            "leftCorner": {
              "x": 8.46,
              "y": 3.445,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.468,
              "y": 3.546,
              "z": 0.203
            },
            "gtin": "4066447232011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270076",
            "leftCorner": {
              "x": 8.468,
              "y": 3.546,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.476,
              "y": 3.634,
              "z": 0.203
            }
          },
          {
            "id": "696ebf6d43c343680a270077",
            "leftCorner": {
              "x": 8.476,
              "y": 3.634,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.483,
              "y": 3.722,
              "z": 0.203
            },
            "gtin": "4066447892420",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270078",
            "leftCorner": {
              "x": 8.483,
              "y": 3.722,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.493,
              "y": 3.835,
              "z": 0.203
            },
            "gtin": "4066447228830",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270079",
            "leftCorner": {
              "x": 8.493,
              "y": 3.835,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.501,
              "y": 3.935,
              "z": 0.203
            },
            "gtin": "4066447228830",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27007a",
            "leftCorner": {
              "x": 8.501,
              "y": 3.935,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.508,
              "y": 4.018,
              "z": 0.203
            },
            "gtin": "4066447879674",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27007b",
            "leftCorner": {
              "x": 8.508,
              "y": 4.018,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.516,
              "y": 4.108,
              "z": 0.203
            }
          },
          {
            "id": "696ebf6d43c343680a27007c",
            "leftCorner": {
              "x": 8.516,
              "y": 4.108,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.52,
              "y": 4.158,
              "z": 0.203
            },
            "gtin": "4066447879667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27007d",
            "leftCorner": {
              "x": 8.52,
              "y": 4.158,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.524,
              "y": 4.205,
              "z": 0.203
            },
            "gtin": "4066447879667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27007e",
            "leftCorner": {
              "x": 8.524,
              "y": 4.205,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.53,
              "y": 4.281,
              "z": 0.203
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73913",
        "height": 0.55087,
        "facings": [
          {
            "id": "696ebf6d43c343680a270136",
            "leftCorner": {
              "x": 8.427,
              "y": 2.957,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.434,
              "y": 3.068,
              "z": 0.553
            },
            "gtin": "4013162033294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270137",
            "leftCorner": {
              "x": 8.432,
              "y": 3.082,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.441,
              "y": 3.192,
              "z": 0.551
            },
            "gtin": "4067796211160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270138",
            "leftCorner": {
              "x": 8.441,
              "y": 3.192,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.449,
              "y": 3.282,
              "z": 0.551
            },
            "gtin": "4067796211160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270139",
            "leftCorner": {
              "x": 8.449,
              "y": 3.282,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.459,
              "y": 3.402,
              "z": 0.551
            }
          },
          {
            "id": "696ebf6d43c343680a27013a",
            "leftCorner": {
              "x": 8.459,
              "y": 3.402,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.469,
              "y": 3.526,
              "z": 0.551
            },
            "gtin": "4066447791099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27013b",
            "leftCorner": {
              "x": 8.469,
              "y": 3.526,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.477,
              "y": 3.623,
              "z": 0.551
            },
            "gtin": "4066447054774",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27013c",
            "leftCorner": {
              "x": 8.477,
              "y": 3.623,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.484,
              "y": 3.704,
              "z": 0.551
            },
            "gtin": "4066447054774",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27013d",
            "leftCorner": {
              "x": 8.484,
              "y": 3.704,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.491,
              "y": 3.783,
              "z": 0.551
            },
            "gtin": "4067796156331",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27013e",
            "leftCorner": {
              "x": 8.491,
              "y": 3.783,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.497,
              "y": 3.852,
              "z": 0.551
            },
            "gtin": "4067796156331",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27013f",
            "leftCorner": {
              "x": 8.497,
              "y": 3.852,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.506,
              "y": 3.966,
              "z": 0.551
            },
            "gtin": "4067796156836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270140",
            "leftCorner": {
              "x": 8.506,
              "y": 3.966,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.514,
              "y": 4.06,
              "z": 0.551
            },
            "gtin": "4066447706789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270141",
            "leftCorner": {
              "x": 8.514,
              "y": 4.06,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.518,
              "y": 4.11,
              "z": 0.551
            },
            "gtin": "4262441480018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270142",
            "leftCorner": {
              "x": 8.518,
              "y": 4.11,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.523,
              "y": 4.167,
              "z": 0.551
            },
            "gtin": "4262441480018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270143",
            "leftCorner": {
              "x": 8.523,
              "y": 4.167,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.529,
              "y": 4.235,
              "z": 0.551
            },
            "gtin": "4262441480018",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73914",
        "height": 0.84591,
        "facings": [
          {
            "id": "696ebf6d43c343680a27005a",
            "leftCorner": {
              "x": 8.42,
              "y": 2.962,
              "z": 0.846
            },
            "rightCorner": {
              "x": 8.427,
              "y": 3.066,
              "z": 0.846
            },
            "gtin": "4013162023967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27005b",
            "leftCorner": {
              "x": 8.429,
              "y": 3.066,
              "z": 0.846
            },
            "rightCorner": {
              "x": 8.445,
              "y": 3.253,
              "z": 0.846
            },
            "gtin": "4013162023929",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27005c",
            "leftCorner": {
              "x": 8.445,
              "y": 3.253,
              "z": 0.846
            },
            "rightCorner": {
              "x": 8.452,
              "y": 3.335,
              "z": 0.846
            },
            "gtin": "4013162031962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27005d",
            "leftCorner": {
              "x": 8.452,
              "y": 3.335,
              "z": 0.846
            },
            "rightCorner": {
              "x": 8.459,
              "y": 3.422,
              "z": 0.846
            },
            "gtin": "4013162031962",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27005e",
            "leftCorner": {
              "x": 8.459,
              "y": 3.422,
              "z": 0.846
            },
            "rightCorner": {
              "x": 8.467,
              "y": 3.513,
              "z": 0.846
            },
            "gtin": "4262376082103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27005f",
            "leftCorner": {
              "x": 8.467,
              "y": 3.513,
              "z": 0.846
            },
            "rightCorner": {
              "x": 8.473,
              "y": 3.592,
              "z": 0.846
            },
            "gtin": "5412533417227",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270060",
            "leftCorner": {
              "x": 8.473,
              "y": 3.592,
              "z": 0.846
            },
            "rightCorner": {
              "x": 8.481,
              "y": 3.679,
              "z": 0.846
            },
            "gtin": "5412533417227",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270061",
            "leftCorner": {
              "x": 8.481,
              "y": 3.679,
              "z": 0.846
            },
            "rightCorner": {
              "x": 8.487,
              "y": 3.755,
              "z": 0.846
            },
            "gtin": "5412533416862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270062",
            "leftCorner": {
              "x": 8.487,
              "y": 3.755,
              "z": 0.846
            },
            "rightCorner": {
              "x": 8.496,
              "y": 3.863,
              "z": 0.846
            },
            "gtin": "5412533416862",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270063",
            "leftCorner": {
              "x": 8.496,
              "y": 3.863,
              "z": 0.846
            },
            "rightCorner": {
              "x": 8.502,
              "y": 3.931,
              "z": 0.846
            },
            "gtin": "4262433360502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270064",
            "leftCorner": {
              "x": 8.502,
              "y": 3.931,
              "z": 0.846
            },
            "rightCorner": {
              "x": 8.507,
              "y": 3.995,
              "z": 0.846
            },
            "gtin": "4262433360502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270065",
            "leftCorner": {
              "x": 8.507,
              "y": 3.995,
              "z": 0.846
            },
            "rightCorner": {
              "x": 8.512,
              "y": 4.056,
              "z": 0.846
            },
            "gtin": "4262459714518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270066",
            "leftCorner": {
              "x": 8.512,
              "y": 4.056,
              "z": 0.846
            },
            "rightCorner": {
              "x": 8.515,
              "y": 4.09,
              "z": 0.846
            },
            "gtin": "4262459714518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270067",
            "leftCorner": {
              "x": 8.515,
              "y": 4.09,
              "z": 0.846
            },
            "rightCorner": {
              "x": 8.519,
              "y": 4.138,
              "z": 0.846
            },
            "gtin": "4262459714792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270052",
            "leftCorner": {
              "x": 8.519,
              "y": 4.138,
              "z": 0.846
            },
            "rightCorner": {
              "x": 8.525,
              "y": 4.207,
              "z": 0.846
            },
            "gtin": "4262459714792",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73912",
        "height": 1.0997,
        "facings": [
          {
            "id": "696ebf6d43c343680a27017e",
            "leftCorner": {
              "x": 8.418,
              "y": 2.962,
              "z": 1.1
            },
            "rightCorner": {
              "x": 8.43,
              "y": 3.103,
              "z": 1.1
            },
            "gtin": "8006540422731",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270180",
            "leftCorner": {
              "x": 8.43,
              "y": 3.103,
              "z": 1.1
            },
            "rightCorner": {
              "x": 8.439,
              "y": 3.205,
              "z": 1.1
            },
            "gtin": "8700216621427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270181",
            "leftCorner": {
              "x": 8.439,
              "y": 3.205,
              "z": 1.1
            },
            "rightCorner": {
              "x": 8.445,
              "y": 3.285,
              "z": 1.1
            },
            "gtin": "8700216621427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270182",
            "leftCorner": {
              "x": 8.445,
              "y": 3.285,
              "z": 1.1
            },
            "rightCorner": {
              "x": 8.456,
              "y": 3.413,
              "z": 1.1
            },
            "gtin": "8700216621342",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270183",
            "leftCorner": {
              "x": 8.456,
              "y": 3.413,
              "z": 1.1
            },
            "rightCorner": {
              "x": 8.464,
              "y": 3.504,
              "z": 1.1
            },
            "gtin": "8700216621397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270184",
            "leftCorner": {
              "x": 8.464,
              "y": 3.504,
              "z": 1.1
            },
            "rightCorner": {
              "x": 8.473,
              "y": 3.61,
              "z": 1.1
            },
            "gtin": "8700216621397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270185",
            "leftCorner": {
              "x": 8.473,
              "y": 3.61,
              "z": 1.1
            },
            "rightCorner": {
              "x": 8.479,
              "y": 3.683,
              "z": 1.1
            },
            "gtin": "8700216621380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270186",
            "leftCorner": {
              "x": 8.479,
              "y": 3.683,
              "z": 1.1
            },
            "rightCorner": {
              "x": 8.487,
              "y": 3.781,
              "z": 1.1
            },
            "gtin": "4001499963506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270187",
            "leftCorner": {
              "x": 8.487,
              "y": 3.781,
              "z": 1.1
            },
            "rightCorner": {
              "x": 8.495,
              "y": 3.869,
              "z": 1.1
            },
            "gtin": "4001499964510",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270188",
            "leftCorner": {
              "x": 8.495,
              "y": 3.869,
              "z": 1.1
            },
            "rightCorner": {
              "x": 8.501,
              "y": 3.946,
              "z": 1.1
            },
            "gtin": "4001499964558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270189",
            "leftCorner": {
              "x": 8.501,
              "y": 3.946,
              "z": 1.1
            },
            "rightCorner": {
              "x": 8.509,
              "y": 4.04,
              "z": 1.1
            }
          },
          {
            "id": "696ebf6d43c343680a27018a",
            "leftCorner": {
              "x": 8.509,
              "y": 4.04,
              "z": 1.1
            },
            "rightCorner": {
              "x": 8.513,
              "y": 4.091,
              "z": 1.1
            },
            "gtin": "4001499938313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27017f",
            "leftCorner": {
              "x": 8.513,
              "y": 4.091,
              "z": 1.1
            },
            "rightCorner": {
              "x": 8.523,
              "y": 4.207,
              "z": 1.1
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73910",
        "height": 1.3945,
        "facings": [
          {
            "id": "696ebf6d43c343680a2700c3",
            "leftCorner": {
              "x": 8.43,
              "y": 2.954,
              "z": 1.402
            },
            "rightCorner": {
              "x": 8.436,
              "y": 3.052,
              "z": 1.402
            },
            "gtin": "8718951666436",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700c4",
            "leftCorner": {
              "x": 8.429,
              "y": 3.066,
              "z": 1.394
            },
            "rightCorner": {
              "x": 8.436,
              "y": 3.14,
              "z": 1.394
            },
            "gtin": "4015200035666",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700c5",
            "leftCorner": {
              "x": 8.436,
              "y": 3.14,
              "z": 1.394
            },
            "rightCorner": {
              "x": 8.443,
              "y": 3.231,
              "z": 1.394
            },
            "gtin": "4015200037455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700c6",
            "leftCorner": {
              "x": 8.443,
              "y": 3.231,
              "z": 1.394
            },
            "rightCorner": {
              "x": 8.453,
              "y": 3.345,
              "z": 1.394
            },
            "gtin": "4015200035628",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700c7",
            "leftCorner": {
              "x": 8.453,
              "y": 3.345,
              "z": 1.394
            },
            "rightCorner": {
              "x": 8.463,
              "y": 3.461,
              "z": 1.394
            },
            "gtin": "4015200035628",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700c8",
            "leftCorner": {
              "x": 8.463,
              "y": 3.461,
              "z": 1.394
            },
            "rightCorner": {
              "x": 8.47,
              "y": 3.547,
              "z": 1.394
            },
            "gtin": "4015200035604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700c9",
            "leftCorner": {
              "x": 8.47,
              "y": 3.547,
              "z": 1.394
            },
            "rightCorner": {
              "x": 8.478,
              "y": 3.643,
              "z": 1.394
            },
            "gtin": "4015200035642",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700ca",
            "leftCorner": {
              "x": 8.478,
              "y": 3.643,
              "z": 1.394
            },
            "rightCorner": {
              "x": 8.485,
              "y": 3.727,
              "z": 1.394
            },
            "gtin": "4015200035741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700cb",
            "leftCorner": {
              "x": 8.485,
              "y": 3.727,
              "z": 1.394
            },
            "rightCorner": {
              "x": 8.493,
              "y": 3.824,
              "z": 1.394
            },
            "gtin": "4015200035741",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700cc",
            "leftCorner": {
              "x": 8.493,
              "y": 3.824,
              "z": 1.394
            },
            "rightCorner": {
              "x": 8.502,
              "y": 3.923,
              "z": 1.394
            },
            "gtin": "4015200035611",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700cd",
            "leftCorner": {
              "x": 8.502,
              "y": 3.923,
              "z": 1.394
            },
            "rightCorner": {
              "x": 8.508,
              "y": 3.999,
              "z": 1.394
            },
            "gtin": "4015200035598",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700ce",
            "leftCorner": {
              "x": 8.508,
              "y": 3.999,
              "z": 1.394
            },
            "rightCorner": {
              "x": 8.513,
              "y": 4.059,
              "z": 1.394
            }
          },
          {
            "id": "696ebf6d43c343680a2700cf",
            "leftCorner": {
              "x": 8.513,
              "y": 4.059,
              "z": 1.394
            },
            "rightCorner": {
              "x": 8.517,
              "y": 4.101,
              "z": 1.394
            },
            "gtin": "4001499964541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700d0",
            "leftCorner": {
              "x": 8.517,
              "y": 4.101,
              "z": 1.394
            },
            "rightCorner": {
              "x": 8.521,
              "y": 4.156,
              "z": 1.394
            },
            "gtin": "4001499964541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700bc",
            "leftCorner": {
              "x": 8.521,
              "y": 4.156,
              "z": 1.394
            },
            "rightCorner": {
              "x": 8.526,
              "y": 4.207,
              "z": 1.394
            },
            "gtin": "4001499964541",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73915",
        "height": 1.7321,
        "facings": [
          {
            "id": "696ebf6d43c343680a2700d8",
            "leftCorner": {
              "x": 8.426,
              "y": 2.99,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.44,
              "y": 3.16,
              "z": 1.732
            },
            "gtin": "4003387000898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700d9",
            "leftCorner": {
              "x": 8.44,
              "y": 3.16,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.455,
              "y": 3.328,
              "z": 1.732
            },
            "gtin": "40737584",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700da",
            "leftCorner": {
              "x": 8.455,
              "y": 3.328,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.469,
              "y": 3.495,
              "z": 1.732
            },
            "gtin": "4062196082884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700db",
            "leftCorner": {
              "x": 8.469,
              "y": 3.495,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.478,
              "y": 3.609,
              "z": 1.732
            },
            "gtin": "4062196082235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700dc",
            "leftCorner": {
              "x": 8.478,
              "y": 3.609,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.486,
              "y": 3.703,
              "z": 1.732
            },
            "gtin": "4062196310529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700dd",
            "leftCorner": {
              "x": 8.486,
              "y": 3.703,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.495,
              "y": 3.804,
              "z": 1.732
            },
            "gtin": "7610243002667",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700de",
            "leftCorner": {
              "x": 8.495,
              "y": 3.804,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.501,
              "y": 3.875,
              "z": 1.732
            },
            "gtin": "4008455028712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700df",
            "leftCorner": {
              "x": 8.501,
              "y": 3.875,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.508,
              "y": 3.96,
              "z": 1.732
            },
            "gtin": "4066447790306",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700e0",
            "leftCorner": {
              "x": 8.508,
              "y": 3.96,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.519,
              "y": 4.096,
              "z": 1.732
            },
            "gtin": "4066447790313",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700e1",
            "leftCorner": {
              "x": 8.519,
              "y": 4.096,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.524,
              "y": 4.15,
              "z": 1.732
            },
            "gtin": "4066447195156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700e2",
            "leftCorner": {
              "x": 8.524,
              "y": 4.15,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.527,
              "y": 4.193,
              "z": 1.732
            },
            "gtin": "4066447195156",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757c5b5fe7bc046959a56",
    "name": "68e757c5b5fe7bc046959a56",
    "x": 8.4732,
    "y": 4.1934,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68031,
      "w": 0.73292
    },
    "statistics": {
      "hasStockCount": 19,
      "noStockCount": 2,
      "unknownStockCount": 34,
      "shelfCategory": "CLEANING"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73919",
        "height": 0.20724,
        "facings": [
          {
            "id": "696ebf6d43c343680a27007f",
            "leftCorner": {
              "x": 8.524,
              "y": 4.264,
              "z": 0.207
            },
            "rightCorner": {
              "x": 8.528,
              "y": 4.325,
              "z": 0.207
            },
            "gtin": "4015000010320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270080",
            "leftCorner": {
              "x": 8.528,
              "y": 4.325,
              "z": 0.207
            },
            "rightCorner": {
              "x": 8.533,
              "y": 4.389,
              "z": 0.207
            },
            "gtin": "4015000010320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270081",
            "leftCorner": {
              "x": 8.533,
              "y": 4.389,
              "z": 0.207
            },
            "rightCorner": {
              "x": 8.538,
              "y": 4.456,
              "z": 0.207
            },
            "gtin": "8720181239878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270082",
            "leftCorner": {
              "x": 8.538,
              "y": 4.456,
              "z": 0.207
            },
            "rightCorner": {
              "x": 8.543,
              "y": 4.527,
              "z": 0.207
            },
            "gtin": "8720181239908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270083",
            "leftCorner": {
              "x": 8.543,
              "y": 4.527,
              "z": 0.207
            },
            "rightCorner": {
              "x": 8.549,
              "y": 4.596,
              "z": 0.207
            },
            "gtin": "4001499139796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270084",
            "leftCorner": {
              "x": 8.549,
              "y": 4.596,
              "z": 0.207
            },
            "rightCorner": {
              "x": 8.555,
              "y": 4.682,
              "z": 0.207
            },
            "gtin": "4010355485953",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270085",
            "leftCorner": {
              "x": 8.555,
              "y": 4.682,
              "z": 0.207
            },
            "rightCorner": {
              "x": 8.562,
              "y": 4.776,
              "z": 0.207
            },
            "gtin": "4010355485953",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270086",
            "leftCorner": {
              "x": 8.562,
              "y": 4.776,
              "z": 0.207
            },
            "rightCorner": {
              "x": 8.573,
              "y": 4.922,
              "z": 0.207
            },
            "gtin": "4066447231427",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270087",
            "leftCorner": {
              "x": 8.573,
              "y": 4.922,
              "z": 0.207
            },
            "rightCorner": {
              "x": 8.583,
              "y": 5.063,
              "z": 0.207
            },
            "gtin": "4066447231427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270088",
            "leftCorner": {
              "x": 8.583,
              "y": 5.063,
              "z": 0.207
            },
            "rightCorner": {
              "x": 8.593,
              "y": 5.188,
              "z": 0.207
            },
            "gtin": "4066447231441",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270089",
            "leftCorner": {
              "x": 8.593,
              "y": 5.188,
              "z": 0.207
            },
            "rightCorner": {
              "x": 8.603,
              "y": 5.329,
              "z": 0.207
            },
            "gtin": "4066447790771",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27008a",
            "leftCorner": {
              "x": 8.603,
              "y": 5.329,
              "z": 0.207
            },
            "rightCorner": {
              "x": 8.614,
              "y": 5.468,
              "z": 0.207
            },
            "gtin": "4066447790771",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7391a",
        "height": 0.55267,
        "facings": [
          {
            "id": "696ebf6d43c343680a270144",
            "leftCorner": {
              "x": 8.526,
              "y": 4.217,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.53,
              "y": 4.272,
              "z": 0.553
            }
          },
          {
            "id": "696ebf6d43c343680a270145",
            "leftCorner": {
              "x": 8.53,
              "y": 4.272,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.534,
              "y": 4.329,
              "z": 0.553
            },
            "gtin": "8700216663762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270146",
            "leftCorner": {
              "x": 8.534,
              "y": 4.329,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.54,
              "y": 4.413,
              "z": 0.553
            },
            "gtin": "8700216663762",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270147",
            "leftCorner": {
              "x": 8.54,
              "y": 4.413,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.55,
              "y": 4.537,
              "z": 0.553
            },
            "gtin": "8700216624688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270148",
            "leftCorner": {
              "x": 8.55,
              "y": 4.537,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.559,
              "y": 4.666,
              "z": 0.553
            },
            "gtin": "8700216661584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270149",
            "leftCorner": {
              "x": 8.559,
              "y": 4.666,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.569,
              "y": 4.796,
              "z": 0.553
            }
          },
          {
            "id": "696ebf6d43c343680a27014a",
            "leftCorner": {
              "x": 8.569,
              "y": 4.796,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.581,
              "y": 4.953,
              "z": 0.553
            },
            "gtin": "4251758404657",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27014b",
            "leftCorner": {
              "x": 8.581,
              "y": 4.953,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.589,
              "y": 5.067,
              "z": 0.553
            },
            "gtin": "8714789952543",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27014c",
            "leftCorner": {
              "x": 8.589,
              "y": 5.067,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.596,
              "y": 5.159,
              "z": 0.553
            },
            "gtin": "8714789952543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27014d",
            "leftCorner": {
              "x": 8.596,
              "y": 5.159,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.603,
              "y": 5.255,
              "z": 0.553
            },
            "gtin": "8714789952543",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27014e",
            "leftCorner": {
              "x": 8.603,
              "y": 5.255,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.612,
              "y": 5.369,
              "z": 0.553
            },
            "gtin": "8714789952581",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73917",
        "height": 0.97866,
        "facings": [
          {
            "id": "696ebf6d43c343680a27018b",
            "leftCorner": {
              "x": 8.524,
              "y": 4.19,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.528,
              "y": 4.242,
              "z": 0.979
            }
          },
          {
            "id": "696ebf6d43c343680a27018d",
            "leftCorner": {
              "x": 8.528,
              "y": 4.242,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.534,
              "y": 4.328,
              "z": 0.979
            },
            "gtin": "4001499961526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27018e",
            "leftCorner": {
              "x": 8.534,
              "y": 4.328,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.541,
              "y": 4.425,
              "z": 0.979
            },
            "gtin": "4001499969690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27018f",
            "leftCorner": {
              "x": 8.541,
              "y": 4.425,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.548,
              "y": 4.519,
              "z": 0.979
            },
            "gtin": "4001499926143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270190",
            "leftCorner": {
              "x": 8.548,
              "y": 4.519,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.555,
              "y": 4.606,
              "z": 0.979
            },
            "gtin": "4001499961502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270191",
            "leftCorner": {
              "x": 8.555,
              "y": 4.606,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.564,
              "y": 4.727,
              "z": 0.979
            },
            "gtin": "4001499961540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270192",
            "leftCorner": {
              "x": 8.564,
              "y": 4.727,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.579,
              "y": 4.933,
              "z": 0.979
            },
            "gtin": "4001499192791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270193",
            "leftCorner": {
              "x": 8.579,
              "y": 4.933,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.587,
              "y": 5.031,
              "z": 0.979
            },
            "gtin": "4001499140648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270194",
            "leftCorner": {
              "x": 8.587,
              "y": 5.031,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.593,
              "y": 5.121,
              "z": 0.979
            },
            "gtin": "4001499140648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270195",
            "leftCorner": {
              "x": 8.593,
              "y": 5.121,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.6,
              "y": 5.211,
              "z": 0.979
            },
            "gtin": "4001499960161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270196",
            "leftCorner": {
              "x": 8.6,
              "y": 5.211,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.606,
              "y": 5.297,
              "z": 0.979
            },
            "gtin": "4001499960161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270197",
            "leftCorner": {
              "x": 8.606,
              "y": 5.297,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.624,
              "y": 5.533,
              "z": 0.979
            },
            "gtin": "4001499960178",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73918",
        "height": 1.3588,
        "facings": [
          {
            "id": "696ebf6d43c343680a2701af",
            "leftCorner": {
              "x": 8.529,
              "y": 4.189,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.532,
              "y": 4.234,
              "z": 1.359
            }
          },
          {
            "id": "696ebf6d43c343680a2701b1",
            "leftCorner": {
              "x": 8.532,
              "y": 4.234,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.539,
              "y": 4.322,
              "z": 1.359
            },
            "gtin": "4066447789911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701b2",
            "leftCorner": {
              "x": 8.539,
              "y": 4.322,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.547,
              "y": 4.434,
              "z": 1.359
            },
            "gtin": "4066447790290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701b3",
            "leftCorner": {
              "x": 8.547,
              "y": 4.434,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.554,
              "y": 4.529,
              "z": 1.359
            },
            "gtin": "4015000970921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701b4",
            "leftCorner": {
              "x": 8.554,
              "y": 4.529,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.562,
              "y": 4.627,
              "z": 1.359
            },
            "gtin": "4015000970921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701b5",
            "leftCorner": {
              "x": 8.562,
              "y": 4.627,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.57,
              "y": 4.741,
              "z": 1.359
            },
            "gtin": "8700216663854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701b6",
            "leftCorner": {
              "x": 8.57,
              "y": 4.741,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.581,
              "y": 4.882,
              "z": 1.359
            },
            "gtin": "4251758404619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701b7",
            "leftCorner": {
              "x": 8.581,
              "y": 4.882,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.588,
              "y": 4.985,
              "z": 1.359
            }
          },
          {
            "id": "696ebf6d43c343680a2701b8",
            "leftCorner": {
              "x": 8.588,
              "y": 4.985,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.595,
              "y": 5.078,
              "z": 1.359
            },
            "gtin": "4066447789966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701b9",
            "leftCorner": {
              "x": 8.595,
              "y": 5.078,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.603,
              "y": 5.178,
              "z": 1.359
            },
            "gtin": "4066447289619",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701ba",
            "leftCorner": {
              "x": 8.603,
              "y": 5.178,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.611,
              "y": 5.283,
              "z": 1.359
            },
            "gtin": "4011200560900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701bb",
            "leftCorner": {
              "x": 8.611,
              "y": 5.283,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.619,
              "y": 5.39,
              "z": 1.359
            },
            "gtin": "4011200560900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701bc",
            "leftCorner": {
              "x": 8.619,
              "y": 5.39,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.629,
              "y": 5.526,
              "z": 1.359
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73916",
        "height": 1.7355,
        "facings": [
          {
            "id": "696ebf6d43c343680a2700e3",
            "leftCorner": {
              "x": 8.527,
              "y": 4.193,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.536,
              "y": 4.29,
              "z": 1.732
            },
            "gtin": "4002448006473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700e4",
            "leftCorner": {
              "x": 8.544,
              "y": 4.272,
              "z": 1.735
            },
            "rightCorner": {
              "x": 8.553,
              "y": 4.398,
              "z": 1.735
            },
            "gtin": "4066447236101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700e5",
            "leftCorner": {
              "x": 8.553,
              "y": 4.398,
              "z": 1.735
            },
            "rightCorner": {
              "x": 8.56,
              "y": 4.491,
              "z": 1.735
            },
            "gtin": "4058172348952",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700e6",
            "leftCorner": {
              "x": 8.56,
              "y": 4.491,
              "z": 1.735
            },
            "rightCorner": {
              "x": 8.567,
              "y": 4.581,
              "z": 1.735
            },
            "gtin": "40161938",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700e7",
            "leftCorner": {
              "x": 8.567,
              "y": 4.581,
              "z": 1.735
            },
            "rightCorner": {
              "x": 8.573,
              "y": 4.67,
              "z": 1.735
            },
            "gtin": "4016471075474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700e8",
            "leftCorner": {
              "x": 8.573,
              "y": 4.67,
              "z": 1.735
            },
            "rightCorner": {
              "x": 8.579,
              "y": 4.744,
              "z": 1.735
            },
            "gtin": "4027848394562",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700e9",
            "leftCorner": {
              "x": 8.579,
              "y": 4.744,
              "z": 1.735
            },
            "rightCorner": {
              "x": 8.588,
              "y": 4.867,
              "z": 1.735
            },
            "gtin": "4008455029115",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700ea",
            "leftCorner": {
              "x": 8.588,
              "y": 4.867,
              "z": 1.735
            },
            "rightCorner": {
              "x": 8.596,
              "y": 4.972,
              "z": 1.735
            },
            "gtin": "4008455603117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700eb",
            "leftCorner": {
              "x": 8.596,
              "y": 4.972,
              "z": 1.735
            },
            "rightCorner": {
              "x": 8.604,
              "y": 5.086,
              "z": 1.735
            },
            "gtin": "4008455029719",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700ec",
            "leftCorner": {
              "x": 8.604,
              "y": 5.086,
              "z": 1.735
            },
            "rightCorner": {
              "x": 8.61,
              "y": 5.165,
              "z": 1.735
            },
            "gtin": "4066447236262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700ed",
            "leftCorner": {
              "x": 8.61,
              "y": 5.165,
              "z": 1.735
            },
            "rightCorner": {
              "x": 8.617,
              "y": 5.256,
              "z": 1.735
            },
            "gtin": "4066447236262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700ee",
            "leftCorner": {
              "x": 8.617,
              "y": 5.256,
              "z": 1.735
            },
            "rightCorner": {
              "x": 8.625,
              "y": 5.359,
              "z": 1.735
            },
            "gtin": "4008455105314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700ef",
            "leftCorner": {
              "x": 8.625,
              "y": 5.359,
              "z": 1.735
            },
            "rightCorner": {
              "x": 8.63,
              "y": 5.435,
              "z": 1.735
            },
            "gtin": "4010355139825",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757c5b5fe7bc046959a57",
    "name": "68e757c5b5fe7bc046959a57",
    "x": 8.5669,
    "y": 5.438,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68122,
      "w": 0.73208
    },
    "statistics": {
      "hasStockCount": 26,
      "noStockCount": 0,
      "unknownStockCount": 25,
      "shelfCategory": "CLEANING"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd7391e",
        "height": 0.20777,
        "facings": [
          {
            "id": "696ebf6d43c343680a27008b",
            "leftCorner": {
              "x": 8.615,
              "y": 5.467,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.622,
              "y": 5.563,
              "z": 0.208
            },
            "gtin": "4001499921629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27008c",
            "leftCorner": {
              "x": 8.622,
              "y": 5.563,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.631,
              "y": 5.692,
              "z": 0.208
            },
            "gtin": "4001499970214",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27008d",
            "leftCorner": {
              "x": 8.631,
              "y": 5.692,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.64,
              "y": 5.822,
              "z": 0.208
            },
            "gtin": "4001499970139",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27008e",
            "leftCorner": {
              "x": 8.64,
              "y": 5.822,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.649,
              "y": 5.948,
              "z": 0.208
            },
            "gtin": "4001499970160",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27008f",
            "leftCorner": {
              "x": 8.649,
              "y": 5.948,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.658,
              "y": 6.076,
              "z": 0.208
            },
            "gtin": "4001499970122",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270090",
            "leftCorner": {
              "x": 8.658,
              "y": 6.076,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.663,
              "y": 6.133,
              "z": 0.208
            },
            "gtin": "4001499970122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270091",
            "leftCorner": {
              "x": 8.663,
              "y": 6.133,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.67,
              "y": 6.23,
              "z": 0.208
            },
            "gtin": "4010355247261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270092",
            "leftCorner": {
              "x": 8.67,
              "y": 6.23,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.684,
              "y": 6.436,
              "z": 0.208
            },
            "gtin": "4066447054897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270093",
            "leftCorner": {
              "x": 8.684,
              "y": 6.436,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.693,
              "y": 6.554,
              "z": 0.208
            },
            "gtin": "4066447216219",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270094",
            "leftCorner": {
              "x": 8.693,
              "y": 6.554,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.701,
              "y": 6.666,
              "z": 0.208
            },
            "gtin": "4058172767906",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7391b",
        "height": 0.55739,
        "facings": [
          {
            "id": "696ebf6d43c343680a27014f",
            "leftCorner": {
              "x": 8.612,
              "y": 5.369,
              "z": 0.553
            },
            "rightCorner": {
              "x": 8.624,
              "y": 5.531,
              "z": 0.553
            },
            "gtin": "4015000960861",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270150",
            "leftCorner": {
              "x": 8.624,
              "y": 5.529,
              "z": 0.557
            },
            "rightCorner": {
              "x": 8.632,
              "y": 5.645,
              "z": 0.557
            },
            "gtin": "4015000960847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270151",
            "leftCorner": {
              "x": 8.632,
              "y": 5.645,
              "z": 0.557
            },
            "rightCorner": {
              "x": 8.641,
              "y": 5.769,
              "z": 0.557
            },
            "gtin": "4251758417084",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270152",
            "leftCorner": {
              "x": 8.641,
              "y": 5.769,
              "z": 0.557
            },
            "rightCorner": {
              "x": 8.651,
              "y": 5.898,
              "z": 0.557
            }
          },
          {
            "id": "696ebf6d43c343680a270153",
            "leftCorner": {
              "x": 8.651,
              "y": 5.898,
              "z": 0.557
            },
            "rightCorner": {
              "x": 8.665,
              "y": 6.104,
              "z": 0.557
            },
            "gtin": "4001499960963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270154",
            "leftCorner": {
              "x": 8.665,
              "y": 6.104,
              "z": 0.557
            },
            "rightCorner": {
              "x": 8.681,
              "y": 6.32,
              "z": 0.557
            },
            "gtin": "4001499954993",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270155",
            "leftCorner": {
              "x": 8.681,
              "y": 6.32,
              "z": 0.557
            },
            "rightCorner": {
              "x": 8.694,
              "y": 6.501,
              "z": 0.557
            },
            "gtin": "4001499185267",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270156",
            "leftCorner": {
              "x": 8.694,
              "y": 6.501,
              "z": 0.557
            },
            "rightCorner": {
              "x": 8.707,
              "y": 6.682,
              "z": 0.557
            },
            "gtin": "4001499954986",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7391d",
        "height": 0.97978,
        "facings": [
          {
            "id": "696ebf6d43c343680a270198",
            "leftCorner": {
              "x": 8.625,
              "y": 5.531,
              "z": 0.98
            },
            "rightCorner": {
              "x": 8.639,
              "y": 5.726,
              "z": 0.98
            },
            "gtin": "4001499953958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270199",
            "leftCorner": {
              "x": 8.639,
              "y": 5.726,
              "z": 0.98
            },
            "rightCorner": {
              "x": 8.646,
              "y": 5.821,
              "z": 0.98
            },
            "gtin": "4001499961465",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27019a",
            "leftCorner": {
              "x": 8.646,
              "y": 5.821,
              "z": 0.98
            },
            "rightCorner": {
              "x": 8.653,
              "y": 5.92,
              "z": 0.98
            },
            "gtin": "4001499961465",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27019b",
            "leftCorner": {
              "x": 8.653,
              "y": 5.92,
              "z": 0.98
            },
            "rightCorner": {
              "x": 8.658,
              "y": 5.993,
              "z": 0.98
            },
            "gtin": "4262376081793",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27019c",
            "leftCorner": {
              "x": 8.658,
              "y": 5.993,
              "z": 0.98
            },
            "rightCorner": {
              "x": 8.664,
              "y": 6.08,
              "z": 0.98
            },
            "gtin": "4262433361547",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27019d",
            "leftCorner": {
              "x": 8.664,
              "y": 6.08,
              "z": 0.98
            },
            "rightCorner": {
              "x": 8.671,
              "y": 6.17,
              "z": 0.98
            },
            "gtin": "4066447706741",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27019e",
            "leftCorner": {
              "x": 8.671,
              "y": 6.17,
              "z": 0.98
            },
            "rightCorner": {
              "x": 8.677,
              "y": 6.249,
              "z": 0.98
            },
            "gtin": "4066447706741",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27019f",
            "leftCorner": {
              "x": 8.677,
              "y": 6.249,
              "z": 0.98
            },
            "rightCorner": {
              "x": 8.687,
              "y": 6.394,
              "z": 0.98
            },
            "gtin": "4251758404459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701a0",
            "leftCorner": {
              "x": 8.687,
              "y": 6.394,
              "z": 0.98
            },
            "rightCorner": {
              "x": 8.691,
              "y": 6.45,
              "z": 0.98
            },
            "gtin": "4066447289596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701a1",
            "leftCorner": {
              "x": 8.691,
              "y": 6.45,
              "z": 0.98
            },
            "rightCorner": {
              "x": 8.697,
              "y": 6.53,
              "z": 0.98
            },
            "gtin": "4066447289596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701a2",
            "leftCorner": {
              "x": 8.697,
              "y": 6.53,
              "z": 0.98
            },
            "rightCorner": {
              "x": 8.705,
              "y": 6.639,
              "z": 0.98
            },
            "gtin": "4004666001766",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701a3",
            "leftCorner": {
              "x": 8.705,
              "y": 6.639,
              "z": 0.98
            },
            "rightCorner": {
              "x": 8.708,
              "y": 6.687,
              "z": 0.98
            },
            "gtin": "4004666000332",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7391f",
        "height": 1.3607,
        "facings": [
          {
            "id": "696ebf6d43c343680a2701bd",
            "leftCorner": {
              "x": 8.627,
              "y": 5.524,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.634,
              "y": 5.628,
              "z": 1.361
            },
            "gtin": "4015200035390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701be",
            "leftCorner": {
              "x": 8.634,
              "y": 5.628,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.642,
              "y": 5.728,
              "z": 1.361
            },
            "gtin": "4015200035406",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701bf",
            "leftCorner": {
              "x": 8.642,
              "y": 5.728,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.648,
              "y": 5.818,
              "z": 1.361
            },
            "gtin": "4010355489241",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701c0",
            "leftCorner": {
              "x": 8.648,
              "y": 5.818,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.655,
              "y": 5.92,
              "z": 1.361
            },
            "gtin": "4010355489241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701c1",
            "leftCorner": {
              "x": 8.655,
              "y": 5.92,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.662,
              "y": 6.007,
              "z": 1.361
            },
            "gtin": "4010355489241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701c2",
            "leftCorner": {
              "x": 8.662,
              "y": 6.007,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.665,
              "y": 6.049,
              "z": 1.361
            }
          },
          {
            "id": "696ebf6d43c343680a2701c3",
            "leftCorner": {
              "x": 8.665,
              "y": 6.049,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.668,
              "y": 6.101,
              "z": 1.361
            }
          },
          {
            "id": "696ebf6d43c343680a2701c4",
            "leftCorner": {
              "x": 8.668,
              "y": 6.101,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.673,
              "y": 6.168,
              "z": 1.361
            },
            "gtin": "4058172924583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701c5",
            "leftCorner": {
              "x": 8.673,
              "y": 6.168,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.684,
              "y": 6.316,
              "z": 1.361
            }
          },
          {
            "id": "696ebf6d43c343680a2701c6",
            "leftCorner": {
              "x": 8.684,
              "y": 6.316,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.69,
              "y": 6.399,
              "z": 1.361
            },
            "gtin": "4010355335616",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701c7",
            "leftCorner": {
              "x": 8.69,
              "y": 6.399,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.696,
              "y": 6.481,
              "z": 1.361
            },
            "gtin": "4010355335616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701c8",
            "leftCorner": {
              "x": 8.696,
              "y": 6.481,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.701,
              "y": 6.554,
              "z": 1.361
            },
            "gtin": "4004666000806",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701c9",
            "leftCorner": {
              "x": 8.701,
              "y": 6.554,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.707,
              "y": 6.63,
              "z": 1.361
            },
            "gtin": "4004666000851",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701ca",
            "leftCorner": {
              "x": 8.707,
              "y": 6.63,
              "z": 1.361
            },
            "rightCorner": {
              "x": 8.713,
              "y": 6.725,
              "z": 1.361
            },
            "gtin": "4004666000851",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7391c",
        "height": 1.7382,
        "facings": [
          {
            "id": "696ebf6d43c343680a2700f0",
            "leftCorner": {
              "x": 8.627,
              "y": 5.434,
              "z": 1.738
            },
            "rightCorner": {
              "x": 8.634,
              "y": 5.524,
              "z": 1.738
            },
            "gtin": "4053700260218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700f1",
            "leftCorner": {
              "x": 8.634,
              "y": 5.524,
              "z": 1.738
            },
            "rightCorner": {
              "x": 8.645,
              "y": 5.683,
              "z": 1.738
            },
            "gtin": "4002448047834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700f2",
            "leftCorner": {
              "x": 8.645,
              "y": 5.683,
              "z": 1.738
            },
            "rightCorner": {
              "x": 8.654,
              "y": 5.799,
              "z": 1.738
            },
            "gtin": "4002448140306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700f3",
            "leftCorner": {
              "x": 8.654,
              "y": 5.799,
              "z": 1.738
            },
            "rightCorner": {
              "x": 8.668,
              "y": 5.994,
              "z": 1.738
            },
            "gtin": "4002448079088",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700f4",
            "leftCorner": {
              "x": 8.668,
              "y": 5.994,
              "z": 1.738
            },
            "rightCorner": {
              "x": 8.68,
              "y": 6.167,
              "z": 1.738
            },
            "gtin": "4036581536535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700f5",
            "leftCorner": {
              "x": 8.68,
              "y": 6.167,
              "z": 1.738
            },
            "rightCorner": {
              "x": 8.686,
              "y": 6.255,
              "z": 1.738
            },
            "gtin": "4036581536337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700f6",
            "leftCorner": {
              "x": 8.686,
              "y": 6.255,
              "z": 1.738
            },
            "rightCorner": {
              "x": 8.69,
              "y": 6.31,
              "z": 1.738
            },
            "gtin": "4062196160971",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700f7",
            "leftCorner": {
              "x": 8.69,
              "y": 6.31,
              "z": 1.738
            },
            "rightCorner": {
              "x": 8.7,
              "y": 6.438,
              "z": 1.738
            },
            "gtin": "4058172895067",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700f8",
            "leftCorner": {
              "x": 8.7,
              "y": 6.438,
              "z": 1.738
            },
            "rightCorner": {
              "x": 8.707,
              "y": 6.54,
              "z": 1.738
            },
            "gtin": "4058172931871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700f9",
            "leftCorner": {
              "x": 8.707,
              "y": 6.54,
              "z": 1.738
            },
            "rightCorner": {
              "x": 8.711,
              "y": 6.594,
              "z": 1.738
            },
            "gtin": "4058172185786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700fa",
            "leftCorner": {
              "x": 8.711,
              "y": 6.594,
              "z": 1.738
            },
            "rightCorner": {
              "x": 8.715,
              "y": 6.657,
              "z": 1.738
            },
            "gtin": "4058172185786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700fb",
            "leftCorner": {
              "x": 8.715,
              "y": 6.657,
              "z": 1.738
            },
            "rightCorner": {
              "x": 8.722,
              "y": 6.746,
              "z": 1.738
            }
          }
        ]
      }
    ]
  },
  {
    "id": "68e757c5b5fe7bc046959a58",
    "name": "68e757c5b5fe7bc046959a58",
    "x": 8.6585,
    "y": 6.7162,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68378,
      "w": 0.72969
    },
    "statistics": {
      "hasStockCount": 20,
      "noStockCount": 1,
      "unknownStockCount": 21,
      "shelfCategory": "CLEANING"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73921",
        "height": 0.20521,
        "facings": [
          {
            "id": "696ebf6d43c343680a270095",
            "leftCorner": {
              "x": 8.701,
              "y": 6.666,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.714,
              "y": 6.845,
              "z": 0.208
            },
            "gtin": "8720182432360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270096",
            "leftCorner": {
              "x": 8.714,
              "y": 6.877,
              "z": 0.205
            },
            "rightCorner": {
              "x": 8.726,
              "y": 7.056,
              "z": 0.205
            },
            "gtin": "8720182432377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270097",
            "leftCorner": {
              "x": 8.726,
              "y": 7.056,
              "z": 0.205
            },
            "rightCorner": {
              "x": 8.729,
              "y": 7.099,
              "z": 0.205
            }
          },
          {
            "id": "696ebf6d43c343680a270098",
            "leftCorner": {
              "x": 8.729,
              "y": 7.099,
              "z": 0.205
            },
            "rightCorner": {
              "x": 8.737,
              "y": 7.223,
              "z": 0.205
            },
            "gtin": "4002448140368",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270099",
            "leftCorner": {
              "x": 8.737,
              "y": 7.223,
              "z": 0.205
            },
            "rightCorner": {
              "x": 8.744,
              "y": 7.337,
              "z": 0.205
            },
            "gtin": "8435495840855",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27009a",
            "leftCorner": {
              "x": 8.744,
              "y": 7.337,
              "z": 0.205
            },
            "rightCorner": {
              "x": 8.754,
              "y": 7.495,
              "z": 0.205
            },
            "gtin": "4251758404633",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27009b",
            "leftCorner": {
              "x": 8.754,
              "y": 7.495,
              "z": 0.205
            },
            "rightCorner": {
              "x": 8.764,
              "y": 7.645,
              "z": 0.205
            },
            "gtin": "5000204549256",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27009c",
            "leftCorner": {
              "x": 8.764,
              "y": 7.645,
              "z": 0.205
            },
            "rightCorner": {
              "x": 8.771,
              "y": 7.759,
              "z": 0.205
            }
          },
          {
            "id": "696ebf6d43c343680a27009d",
            "leftCorner": {
              "x": 8.771,
              "y": 7.759,
              "z": 0.205
            },
            "rightCorner": {
              "x": 8.779,
              "y": 7.87,
              "z": 0.205
            },
            "gtin": "4010355485397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27009e",
            "leftCorner": {
              "x": 8.779,
              "y": 7.87,
              "z": 0.205
            },
            "rightCorner": {
              "x": 8.785,
              "y": 7.963,
              "z": 0.205
            }
          },
          {
            "id": "696ebf6d43c343680a27009f",
            "leftCorner": {
              "x": 8.785,
              "y": 7.963,
              "z": 0.205
            },
            "rightCorner": {
              "x": 8.791,
              "y": 8.054,
              "z": 0.205
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73923",
        "height": 0.55392,
        "facings": [
          {
            "id": "696ebf6d43c343680a270157",
            "leftCorner": {
              "x": 8.712,
              "y": 6.713,
              "z": 0.554
            },
            "rightCorner": {
              "x": 8.726,
              "y": 6.929,
              "z": 0.554
            },
            "gtin": "4015200033129",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270158",
            "leftCorner": {
              "x": 8.726,
              "y": 6.929,
              "z": 0.554
            },
            "rightCorner": {
              "x": 8.741,
              "y": 7.158,
              "z": 0.554
            },
            "gtin": "4015000973892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270159",
            "leftCorner": {
              "x": 8.741,
              "y": 7.158,
              "z": 0.554
            },
            "rightCorner": {
              "x": 8.754,
              "y": 7.363,
              "z": 0.554
            },
            "gtin": "4015000973885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27015a",
            "leftCorner": {
              "x": 8.754,
              "y": 7.363,
              "z": 0.554
            },
            "rightCorner": {
              "x": 8.767,
              "y": 7.566,
              "z": 0.554
            },
            "gtin": "5000204096927",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27015b",
            "leftCorner": {
              "x": 8.767,
              "y": 7.566,
              "z": 0.554
            },
            "rightCorner": {
              "x": 8.781,
              "y": 7.785,
              "z": 0.554
            },
            "gtin": "5000204096675",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27015c",
            "leftCorner": {
              "x": 8.781,
              "y": 7.785,
              "z": 0.554
            },
            "rightCorner": {
              "x": 8.793,
              "y": 7.965,
              "z": 0.554
            },
            "gtin": "5000204096958",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73924",
        "height": 0.97877,
        "facings": [
          {
            "id": "696ebf6d43c343680a2701ae",
            "leftCorner": {
              "x": 8.773,
              "y": 7.8,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.779,
              "y": 7.896,
              "z": 0.979
            },
            "gtin": "4066447790757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701a4",
            "leftCorner": {
              "x": 8.702,
              "y": 6.72,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.708,
              "y": 6.811,
              "z": 0.979
            },
            "gtin": "4004666000493",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701a5",
            "leftCorner": {
              "x": 8.708,
              "y": 6.811,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.715,
              "y": 6.906,
              "z": 0.979
            },
            "gtin": "4004666000493",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701a6",
            "leftCorner": {
              "x": 8.715,
              "y": 6.906,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.724,
              "y": 7.047,
              "z": 0.979
            },
            "gtin": "4251758417299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701a7",
            "leftCorner": {
              "x": 8.724,
              "y": 7.047,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.732,
              "y": 7.178,
              "z": 0.979
            },
            "gtin": "4251758417299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701a8",
            "leftCorner": {
              "x": 8.732,
              "y": 7.178,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.739,
              "y": 7.279,
              "z": 0.979
            },
            "gtin": "4066447790009",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701a9",
            "leftCorner": {
              "x": 8.739,
              "y": 7.279,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.745,
              "y": 7.374,
              "z": 0.979
            }
          },
          {
            "id": "696ebf6d43c343680a2701aa",
            "leftCorner": {
              "x": 8.745,
              "y": 7.374,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.751,
              "y": 7.467,
              "z": 0.979
            },
            "gtin": "4066447792348",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701ab",
            "leftCorner": {
              "x": 8.751,
              "y": 7.467,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.757,
              "y": 7.556,
              "z": 0.979
            },
            "gtin": "4066447790672",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701ac",
            "leftCorner": {
              "x": 8.757,
              "y": 7.556,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.765,
              "y": 7.681,
              "z": 0.979
            }
          },
          {
            "id": "696ebf6d43c343680a2701ad",
            "leftCorner": {
              "x": 8.765,
              "y": 7.681,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.773,
              "y": 7.8,
              "z": 0.979
            },
            "gtin": "4066447790764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27018c",
            "leftCorner": {
              "x": 8.779,
              "y": 7.896,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.783,
              "y": 7.961,
              "z": 0.979
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73920",
        "height": 1.3585,
        "facings": [
          {
            "id": "696ebf6d43c343680a2701cb",
            "leftCorner": {
              "x": 8.707,
              "y": 6.757,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.714,
              "y": 6.863,
              "z": 1.359
            },
            "gtin": "4015000971157",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701cc",
            "leftCorner": {
              "x": 8.714,
              "y": 6.863,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.722,
              "y": 6.994,
              "z": 1.359
            },
            "gtin": "8700216710756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701cd",
            "leftCorner": {
              "x": 8.722,
              "y": 6.994,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.731,
              "y": 7.123,
              "z": 1.359
            },
            "gtin": "8700216710718",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701ce",
            "leftCorner": {
              "x": 8.731,
              "y": 7.123,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.738,
              "y": 7.233,
              "z": 1.359
            },
            "gtin": "8700216663816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701cf",
            "leftCorner": {
              "x": 8.738,
              "y": 7.233,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.744,
              "y": 7.333,
              "z": 1.359
            },
            "gtin": "8700216710671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701d0",
            "leftCorner": {
              "x": 8.744,
              "y": 7.333,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.752,
              "y": 7.452,
              "z": 1.359
            },
            "gtin": "8700216710671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701d1",
            "leftCorner": {
              "x": 8.752,
              "y": 7.452,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.758,
              "y": 7.547,
              "z": 1.359
            },
            "gtin": "8720182315182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701d2",
            "leftCorner": {
              "x": 8.758,
              "y": 7.547,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.766,
              "y": 7.671,
              "z": 1.359
            },
            "gtin": "8720182315182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701d3",
            "leftCorner": {
              "x": 8.766,
              "y": 7.671,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.774,
              "y": 7.788,
              "z": 1.359
            },
            "gtin": "4015000314886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701d4",
            "leftCorner": {
              "x": 8.774,
              "y": 7.788,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.78,
              "y": 7.877,
              "z": 1.359
            },
            "gtin": "4015000314886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701b0",
            "leftCorner": {
              "x": 8.78,
              "y": 7.877,
              "z": 1.359
            },
            "rightCorner": {
              "x": 8.785,
              "y": 7.961,
              "z": 1.359
            },
            "gtin": "4066447792416",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73922",
        "height": 1.7343,
        "facings": [
          {
            "id": "696ebf6d43c343680a2700fc",
            "leftCorner": {
              "x": 8.708,
              "y": 6.779,
              "z": 1.734
            },
            "rightCorner": {
              "x": 8.717,
              "y": 6.917,
              "z": 1.734
            },
            "gtin": "4058172928574",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700fd",
            "leftCorner": {
              "x": 8.717,
              "y": 6.917,
              "z": 1.734
            },
            "rightCorner": {
              "x": 8.726,
              "y": 7.06,
              "z": 1.734
            }
          },
          {
            "id": "696ebf6d43c343680a2700fe",
            "leftCorner": {
              "x": 8.726,
              "y": 7.06,
              "z": 1.734
            },
            "rightCorner": {
              "x": 8.733,
              "y": 7.167,
              "z": 1.734
            },
            "gtin": "4001499957635",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700ff",
            "leftCorner": {
              "x": 8.733,
              "y": 7.167,
              "z": 1.734
            },
            "rightCorner": {
              "x": 8.74,
              "y": 7.278,
              "z": 1.734
            },
            "gtin": "4001499961519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270100",
            "leftCorner": {
              "x": 8.74,
              "y": 7.278,
              "z": 1.734
            },
            "rightCorner": {
              "x": 8.746,
              "y": 7.37,
              "z": 1.734
            },
            "gtin": "4001499961472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270101",
            "leftCorner": {
              "x": 8.746,
              "y": 7.37,
              "z": 1.734
            },
            "rightCorner": {
              "x": 8.755,
              "y": 7.51,
              "z": 1.734
            },
            "gtin": "4001499953866",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270102",
            "leftCorner": {
              "x": 8.755,
              "y": 7.51,
              "z": 1.734
            },
            "rightCorner": {
              "x": 8.765,
              "y": 7.661,
              "z": 1.734
            },
            "gtin": "4001499953866",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270103",
            "leftCorner": {
              "x": 8.765,
              "y": 7.661,
              "z": 1.734
            },
            "rightCorner": {
              "x": 8.772,
              "y": 7.77,
              "z": 1.734
            },
            "gtin": "4262441480025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270104",
            "leftCorner": {
              "x": 8.772,
              "y": 7.77,
              "z": 1.734
            },
            "rightCorner": {
              "x": 8.778,
              "y": 7.862,
              "z": 1.734
            },
            "gtin": "4262459713016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270105",
            "leftCorner": {
              "x": 8.778,
              "y": 7.862,
              "z": 1.734
            },
            "rightCorner": {
              "x": 8.785,
              "y": 7.959,
              "z": 1.734
            },
            "gtin": "4262459713108",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757c5b5fe7bc046959a59",
    "name": "68e757c5b5fe7bc046959a59",
    "x": 8.7405,
    "y": 7.976,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.6832,
      "w": 0.73023
    },
    "statistics": {
      "hasStockCount": 25,
      "noStockCount": 0,
      "unknownStockCount": 35,
      "shelfCategory": "CLEANING"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73929",
        "height": 0.20109,
        "facings": [
          {
            "id": "696ebf6d43c343680a2700a0",
            "leftCorner": {
              "x": 8.792,
              "y": 8.066,
              "z": 0.201
            },
            "rightCorner": {
              "x": 8.798,
              "y": 8.144,
              "z": 0.201
            },
            "gtin": "4010355490773",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700a1",
            "leftCorner": {
              "x": 8.798,
              "y": 8.144,
              "z": 0.201
            },
            "rightCorner": {
              "x": 8.803,
              "y": 8.228,
              "z": 0.201
            },
            "gtin": "4262459714242",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700a2",
            "leftCorner": {
              "x": 8.803,
              "y": 8.228,
              "z": 0.201
            },
            "rightCorner": {
              "x": 8.816,
              "y": 8.418,
              "z": 0.201
            },
            "gtin": "4066447790696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700a3",
            "leftCorner": {
              "x": 8.816,
              "y": 8.418,
              "z": 0.201
            },
            "rightCorner": {
              "x": 8.819,
              "y": 8.46,
              "z": 0.201
            }
          },
          {
            "id": "696ebf6d43c343680a2700a4",
            "leftCorner": {
              "x": 8.819,
              "y": 8.46,
              "z": 0.201
            },
            "rightCorner": {
              "x": 8.831,
              "y": 8.65,
              "z": 0.201
            },
            "gtin": "4066447790689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700a5",
            "leftCorner": {
              "x": 8.831,
              "y": 8.65,
              "z": 0.201
            },
            "rightCorner": {
              "x": 8.845,
              "y": 8.858,
              "z": 0.201
            },
            "gtin": "4010355488558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700a6",
            "leftCorner": {
              "x": 8.845,
              "y": 8.858,
              "z": 0.201
            },
            "rightCorner": {
              "x": 8.849,
              "y": 8.921,
              "z": 0.201
            },
            "gtin": "4066447519808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700a7",
            "leftCorner": {
              "x": 8.849,
              "y": 8.921,
              "z": 0.201
            },
            "rightCorner": {
              "x": 8.864,
              "y": 9.139,
              "z": 0.201
            },
            "gtin": "4058172769603",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73925",
        "height": 0.55142,
        "facings": [
          {
            "id": "696ebf6d43c343680a27015d",
            "leftCorner": {
              "x": 8.791,
              "y": 7.978,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.799,
              "y": 8.1,
              "z": 0.551
            },
            "gtin": "4066447289275",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27015e",
            "leftCorner": {
              "x": 8.799,
              "y": 8.1,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.805,
              "y": 8.2,
              "z": 0.551
            },
            "gtin": "4066447289336",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27015f",
            "leftCorner": {
              "x": 8.805,
              "y": 8.2,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.814,
              "y": 8.324,
              "z": 0.551
            },
            "gtin": "4066447289312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270160",
            "leftCorner": {
              "x": 8.814,
              "y": 8.324,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.817,
              "y": 8.366,
              "z": 0.551
            }
          },
          {
            "id": "696ebf6d43c343680a270161",
            "leftCorner": {
              "x": 8.817,
              "y": 8.366,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.825,
              "y": 8.495,
              "z": 0.551
            },
            "gtin": "4066447289299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270162",
            "leftCorner": {
              "x": 8.825,
              "y": 8.495,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.833,
              "y": 8.613,
              "z": 0.551
            },
            "gtin": "4066447791617",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270163",
            "leftCorner": {
              "x": 8.833,
              "y": 8.613,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.842,
              "y": 8.746,
              "z": 0.551
            },
            "gtin": "4066447789034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270164",
            "leftCorner": {
              "x": 8.842,
              "y": 8.746,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.85,
              "y": 8.869,
              "z": 0.551
            },
            "gtin": "4066447791624",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270165",
            "leftCorner": {
              "x": 8.85,
              "y": 8.869,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.855,
              "y": 8.945,
              "z": 0.551
            },
            "gtin": "4010355198341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270166",
            "leftCorner": {
              "x": 8.855,
              "y": 8.945,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.861,
              "y": 9.028,
              "z": 0.551
            },
            "gtin": "4066447789058",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270167",
            "leftCorner": {
              "x": 8.861,
              "y": 9.028,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.866,
              "y": 9.102,
              "z": 0.551
            },
            "gtin": "4066447756333",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270168",
            "leftCorner": {
              "x": 8.866,
              "y": 9.102,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.872,
              "y": 9.195,
              "z": 0.551
            },
            "gtin": "4066447671094",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73926",
        "height": 0.88866,
        "facings": [
          {
            "id": "696ebf6d43c343680a2701d5",
            "leftCorner": {
              "x": 8.788,
              "y": 7.973,
              "z": 0.889
            },
            "rightCorner": {
              "x": 8.794,
              "y": 8.062,
              "z": 0.889
            },
            "gtin": "8719992617241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701d7",
            "leftCorner": {
              "x": 8.794,
              "y": 8.062,
              "z": 0.889
            },
            "rightCorner": {
              "x": 8.798,
              "y": 8.13,
              "z": 0.889
            },
            "gtin": "8719992617241",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701d8",
            "leftCorner": {
              "x": 8.798,
              "y": 8.13,
              "z": 0.889
            },
            "rightCorner": {
              "x": 8.802,
              "y": 8.184,
              "z": 0.889
            },
            "gtin": "8720929322190",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701d9",
            "leftCorner": {
              "x": 8.802,
              "y": 8.184,
              "z": 0.889
            },
            "rightCorner": {
              "x": 8.807,
              "y": 8.257,
              "z": 0.889
            },
            "gtin": "8720929322220",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701da",
            "leftCorner": {
              "x": 8.807,
              "y": 8.257,
              "z": 0.889
            },
            "rightCorner": {
              "x": 8.809,
              "y": 8.296,
              "z": 0.889
            },
            "gtin": "5000204331455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701db",
            "leftCorner": {
              "x": 8.809,
              "y": 8.296,
              "z": 0.889
            },
            "rightCorner": {
              "x": 8.812,
              "y": 8.341,
              "z": 0.889
            },
            "gtin": "5000204331455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701dc",
            "leftCorner": {
              "x": 8.812,
              "y": 8.341,
              "z": 0.889
            },
            "rightCorner": {
              "x": 8.815,
              "y": 8.384,
              "z": 0.889
            },
            "gtin": "5000204199550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701dd",
            "leftCorner": {
              "x": 8.815,
              "y": 8.384,
              "z": 0.889
            },
            "rightCorner": {
              "x": 8.822,
              "y": 8.485,
              "z": 0.889
            },
            "gtin": "5000204199550",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701de",
            "leftCorner": {
              "x": 8.822,
              "y": 8.485,
              "z": 0.889
            },
            "rightCorner": {
              "x": 8.828,
              "y": 8.579,
              "z": 0.889
            }
          },
          {
            "id": "696ebf6d43c343680a2701df",
            "leftCorner": {
              "x": 8.828,
              "y": 8.579,
              "z": 0.889
            },
            "rightCorner": {
              "x": 8.836,
              "y": 8.688,
              "z": 0.889
            }
          },
          {
            "id": "696ebf6d43c343680a2701e0",
            "leftCorner": {
              "x": 8.836,
              "y": 8.688,
              "z": 0.889
            },
            "rightCorner": {
              "x": 8.842,
              "y": 8.79,
              "z": 0.889
            },
            "gtin": "5000204331455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701e1",
            "leftCorner": {
              "x": 8.842,
              "y": 8.79,
              "z": 0.889
            },
            "rightCorner": {
              "x": 8.85,
              "y": 8.897,
              "z": 0.889
            },
            "gtin": "5000204668995",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701e2",
            "leftCorner": {
              "x": 8.85,
              "y": 8.897,
              "z": 0.889
            },
            "rightCorner": {
              "x": 8.858,
              "y": 9.025,
              "z": 0.889
            },
            "gtin": "4067796179514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701e3",
            "leftCorner": {
              "x": 8.858,
              "y": 9.025,
              "z": 0.889
            },
            "rightCorner": {
              "x": 8.864,
              "y": 9.116,
              "z": 0.889
            },
            "gtin": "4067796179491",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701d6",
            "leftCorner": {
              "x": 8.864,
              "y": 9.116,
              "z": 0.889
            },
            "rightCorner": {
              "x": 8.871,
              "y": 9.22,
              "z": 0.889
            },
            "gtin": "4067796093957",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73928",
        "height": 1.1451,
        "facings": [
          {
            "id": "696ebf6d43c343680a2701f0",
            "leftCorner": {
              "x": 8.783,
              "y": 7.973,
              "z": 1.145
            },
            "rightCorner": {
              "x": 8.794,
              "y": 8.128,
              "z": 1.145
            },
            "gtin": "8720182899460",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701f1",
            "leftCorner": {
              "x": 8.794,
              "y": 8.128,
              "z": 1.145
            },
            "rightCorner": {
              "x": 8.801,
              "y": 8.235,
              "z": 1.145
            },
            "gtin": "8720182894878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701f2",
            "leftCorner": {
              "x": 8.801,
              "y": 8.235,
              "z": 1.145
            },
            "rightCorner": {
              "x": 8.803,
              "y": 8.271,
              "z": 1.145
            }
          },
          {
            "id": "696ebf6d43c343680a2701f3",
            "leftCorner": {
              "x": 8.803,
              "y": 8.271,
              "z": 1.145
            },
            "rightCorner": {
              "x": 8.81,
              "y": 8.378,
              "z": 1.145
            },
            "gtin": "8720182894885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701f4",
            "leftCorner": {
              "x": 8.81,
              "y": 8.378,
              "z": 1.145
            },
            "rightCorner": {
              "x": 8.813,
              "y": 8.42,
              "z": 1.145
            }
          },
          {
            "id": "696ebf6d43c343680a2701f5",
            "leftCorner": {
              "x": 8.813,
              "y": 8.42,
              "z": 1.145
            },
            "rightCorner": {
              "x": 8.822,
              "y": 8.551,
              "z": 1.145
            },
            "gtin": "4015000969635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701f6",
            "leftCorner": {
              "x": 8.822,
              "y": 8.551,
              "z": 1.145
            },
            "rightCorner": {
              "x": 8.831,
              "y": 8.693,
              "z": 1.145
            },
            "gtin": "4015000969451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701f7",
            "leftCorner": {
              "x": 8.831,
              "y": 8.693,
              "z": 1.145
            },
            "rightCorner": {
              "x": 8.84,
              "y": 8.825,
              "z": 1.145
            },
            "gtin": "4015000969536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701f8",
            "leftCorner": {
              "x": 8.84,
              "y": 8.825,
              "z": 1.145
            },
            "rightCorner": {
              "x": 8.849,
              "y": 8.955,
              "z": 1.145
            },
            "gtin": "4015000969536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701f9",
            "leftCorner": {
              "x": 8.849,
              "y": 8.955,
              "z": 1.145
            },
            "rightCorner": {
              "x": 8.857,
              "y": 9.071,
              "z": 1.145
            },
            "gtin": "4015000969444",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701fa",
            "leftCorner": {
              "x": 8.857,
              "y": 9.071,
              "z": 1.145
            },
            "rightCorner": {
              "x": 8.866,
              "y": 9.208,
              "z": 1.145
            },
            "gtin": "4015000969512",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73927",
        "height": 1.4414,
        "facings": [
          {
            "id": "696ebf6d43c343680a2701e4",
            "leftCorner": {
              "x": 8.784,
              "y": 7.973,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.787,
              "y": 8.012,
              "z": 1.441
            }
          },
          {
            "id": "696ebf6d43c343680a2701e6",
            "leftCorner": {
              "x": 8.787,
              "y": 8.012,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.795,
              "y": 8.136,
              "z": 1.441
            },
            "gtin": "4015000969574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701e7",
            "leftCorner": {
              "x": 8.795,
              "y": 8.136,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.803,
              "y": 8.262,
              "z": 1.441
            },
            "gtin": "4015200032627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701e8",
            "leftCorner": {
              "x": 8.803,
              "y": 8.262,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.806,
              "y": 8.3,
              "z": 1.441
            }
          },
          {
            "id": "696ebf6d43c343680a2701e9",
            "leftCorner": {
              "x": 8.806,
              "y": 8.3,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.812,
              "y": 8.396,
              "z": 1.441
            },
            "gtin": "4015000973366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701ea",
            "leftCorner": {
              "x": 8.812,
              "y": 8.396,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.815,
              "y": 8.439,
              "z": 1.441
            }
          },
          {
            "id": "696ebf6d43c343680a2701eb",
            "leftCorner": {
              "x": 8.815,
              "y": 8.439,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.827,
              "y": 8.611,
              "z": 1.441
            },
            "gtin": "4015000969499",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701ec",
            "leftCorner": {
              "x": 8.827,
              "y": 8.611,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.835,
              "y": 8.739,
              "z": 1.441
            },
            "gtin": "4015000973373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701ed",
            "leftCorner": {
              "x": 8.835,
              "y": 8.739,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.844,
              "y": 8.875,
              "z": 1.441
            },
            "gtin": "4015200032573",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701ee",
            "leftCorner": {
              "x": 8.844,
              "y": 8.875,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.853,
              "y": 9.0,
              "z": 1.441
            },
            "gtin": "4015200036694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701ef",
            "leftCorner": {
              "x": 8.853,
              "y": 9.0,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.862,
              "y": 9.136,
              "z": 1.441
            },
            "gtin": "4051281960701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701e5",
            "leftCorner": {
              "x": 8.862,
              "y": 9.136,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.867,
              "y": 9.22,
              "z": 1.441
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7392a",
        "height": 1.7323,
        "facings": [
          {
            "id": "696ebf6d43c343680a270106",
            "leftCorner": {
              "x": 8.785,
              "y": 7.959,
              "z": 1.734
            },
            "rightCorner": {
              "x": 8.789,
              "y": 8.034,
              "z": 1.734
            },
            "gtin": "4262459711777",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270107",
            "leftCorner": {
              "x": 8.788,
              "y": 8.046,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.795,
              "y": 8.15,
              "z": 1.732
            },
            "gtin": "4008455105215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270108",
            "leftCorner": {
              "x": 8.795,
              "y": 8.15,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.805,
              "y": 8.3,
              "z": 1.732
            },
            "gtin": "4015000969925",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270109",
            "leftCorner": {
              "x": 8.805,
              "y": 8.3,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.808,
              "y": 8.342,
              "z": 1.732
            }
          },
          {
            "id": "696ebf6d43c343680a27010a",
            "leftCorner": {
              "x": 8.808,
              "y": 8.342,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.814,
              "y": 8.43,
              "z": 1.732
            },
            "gtin": "4015200032795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27010b",
            "leftCorner": {
              "x": 8.814,
              "y": 8.43,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.817,
              "y": 8.474,
              "z": 1.732
            },
            "gtin": "4015200032795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27010c",
            "leftCorner": {
              "x": 8.817,
              "y": 8.474,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.826,
              "y": 8.616,
              "z": 1.732
            },
            "gtin": "4015200032818",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27010d",
            "leftCorner": {
              "x": 8.826,
              "y": 8.616,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.835,
              "y": 8.753,
              "z": 1.732
            },
            "gtin": "4015000969598",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27010e",
            "leftCorner": {
              "x": 8.835,
              "y": 8.753,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.844,
              "y": 8.885,
              "z": 1.732
            },
            "gtin": "4015000969628",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27010f",
            "leftCorner": {
              "x": 8.844,
              "y": 8.885,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.853,
              "y": 9.015,
              "z": 1.732
            },
            "gtin": "4015000969468",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270110",
            "leftCorner": {
              "x": 8.853,
              "y": 9.015,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.863,
              "y": 9.165,
              "z": 1.732
            },
            "gtin": "4066447082920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270111",
            "leftCorner": {
              "x": 8.863,
              "y": 9.165,
              "z": 1.732
            },
            "rightCorner": {
              "x": 8.866,
              "y": 9.22,
              "z": 1.732
            },
            "gtin": "4001499969775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270112",
            "leftCorner": {
              "x": 8.884,
              "y": 9.198,
              "z": 1.731
            },
            "rightCorner": {
              "x": 8.889,
              "y": 9.274,
              "z": 1.731
            },
            "gtin": "4001499969775",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757c5b5fe7bc046959a5a",
    "name": "68e757c5b5fe7bc046959a5a",
    "x": 8.8327,
    "y": 9.2025,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.67888,
      "w": 0.73425
    },
    "statistics": {
      "hasStockCount": 62,
      "noStockCount": 5,
      "unknownStockCount": 30
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73931",
        "height": 0.20351,
        "facings": [
          {
            "id": "696ebf6d43c343680a2700a8",
            "leftCorner": {
              "x": 8.864,
              "y": 9.139,
              "z": 0.201
            },
            "rightCorner": {
              "x": 8.877,
              "y": 9.34,
              "z": 0.201
            },
            "gtin": "4058172769566",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700a9",
            "leftCorner": {
              "x": 8.887,
              "y": 9.318,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.897,
              "y": 9.448,
              "z": 0.204
            },
            "gtin": "4058172769542",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700aa",
            "leftCorner": {
              "x": 8.897,
              "y": 9.448,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.907,
              "y": 9.577,
              "z": 0.204
            },
            "gtin": "4058172769627",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700ab",
            "leftCorner": {
              "x": 8.907,
              "y": 9.577,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.917,
              "y": 9.701,
              "z": 0.204
            },
            "gtin": "4058172769528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700ac",
            "leftCorner": {
              "x": 8.917,
              "y": 9.701,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.928,
              "y": 9.838,
              "z": 0.204
            }
          },
          {
            "id": "696ebf6d43c343680a2700ad",
            "leftCorner": {
              "x": 8.928,
              "y": 9.838,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.94,
              "y": 9.989,
              "z": 0.204
            },
            "gtin": "4058172510618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700ae",
            "leftCorner": {
              "x": 8.94,
              "y": 9.989,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.955,
              "y": 10.178,
              "z": 0.204
            },
            "gtin": "4058172510595",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700af",
            "leftCorner": {
              "x": 8.955,
              "y": 10.178,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.965,
              "y": 10.309,
              "z": 0.204
            },
            "gtin": "4058172510557",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2700b0",
            "leftCorner": {
              "x": 8.965,
              "y": 10.309,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.984,
              "y": 10.547,
              "z": 0.204
            },
            "gtin": "4058172769481",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73930",
        "height": 0.54982,
        "facings": [
          {
            "id": "696ebf6d43c343680a270169",
            "leftCorner": {
              "x": 8.872,
              "y": 9.195,
              "z": 0.551
            },
            "rightCorner": {
              "x": 8.879,
              "y": 9.303,
              "z": 0.551
            },
            "gtin": "4066447750324",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27016a",
            "leftCorner": {
              "x": 8.889,
              "y": 9.281,
              "z": 0.55
            },
            "rightCorner": {
              "x": 8.896,
              "y": 9.375,
              "z": 0.55
            },
            "gtin": "4066447750324",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27016b",
            "leftCorner": {
              "x": 8.896,
              "y": 9.375,
              "z": 0.55
            },
            "rightCorner": {
              "x": 8.901,
              "y": 9.446,
              "z": 0.55
            },
            "gtin": "4067796065060",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27016c",
            "leftCorner": {
              "x": 8.901,
              "y": 9.446,
              "z": 0.55
            },
            "rightCorner": {
              "x": 8.909,
              "y": 9.535,
              "z": 0.55
            },
            "gtin": "4066447348408",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27016d",
            "leftCorner": {
              "x": 8.909,
              "y": 9.535,
              "z": 0.55
            },
            "rightCorner": {
              "x": 8.915,
              "y": 9.621,
              "z": 0.55
            },
            "gtin": "4066447348408",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27016e",
            "leftCorner": {
              "x": 8.915,
              "y": 9.621,
              "z": 0.55
            },
            "rightCorner": {
              "x": 8.922,
              "y": 9.71,
              "z": 0.55
            },
            "gtin": "4066447771916",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27016f",
            "leftCorner": {
              "x": 8.922,
              "y": 9.71,
              "z": 0.55
            },
            "rightCorner": {
              "x": 8.931,
              "y": 9.817,
              "z": 0.55
            },
            "gtin": "4066447771916",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270170",
            "leftCorner": {
              "x": 8.931,
              "y": 9.817,
              "z": 0.55
            },
            "rightCorner": {
              "x": 8.943,
              "y": 9.98,
              "z": 0.55
            },
            "gtin": "4067796160628",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270171",
            "leftCorner": {
              "x": 8.943,
              "y": 9.98,
              "z": 0.55
            },
            "rightCorner": {
              "x": 8.953,
              "y": 10.106,
              "z": 0.55
            },
            "gtin": "4067796062038",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270172",
            "leftCorner": {
              "x": 8.953,
              "y": 10.106,
              "z": 0.55
            },
            "rightCorner": {
              "x": 8.958,
              "y": 10.164,
              "z": 0.55
            },
            "gtin": "4066447877908",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270173",
            "leftCorner": {
              "x": 8.958,
              "y": 10.164,
              "z": 0.55
            },
            "rightCorner": {
              "x": 8.975,
              "y": 10.376,
              "z": 0.55
            }
          },
          {
            "id": "696ebf6d43c343680a270174",
            "leftCorner": {
              "x": 8.975,
              "y": 10.376,
              "z": 0.55
            },
            "rightCorner": {
              "x": 8.98,
              "y": 10.444,
              "z": 0.55
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7392c",
        "height": 0.80417,
        "facings": [
          {
            "id": "696ebf6d43c343680a270217",
            "leftCorner": {
              "x": 8.88,
              "y": 9.199,
              "z": 0.804
            },
            "rightCorner": {
              "x": 8.89,
              "y": 9.319,
              "z": 0.804
            },
            "gtin": "4251758415820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270218",
            "leftCorner": {
              "x": 8.89,
              "y": 9.319,
              "z": 0.804
            },
            "rightCorner": {
              "x": 8.895,
              "y": 9.393,
              "z": 0.804
            },
            "gtin": "4251758422842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270219",
            "leftCorner": {
              "x": 8.895,
              "y": 9.393,
              "z": 0.804
            },
            "rightCorner": {
              "x": 8.902,
              "y": 9.479,
              "z": 0.804
            },
            "gtin": "4251758432414",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27021a",
            "leftCorner": {
              "x": 8.902,
              "y": 9.479,
              "z": 0.804
            },
            "rightCorner": {
              "x": 8.908,
              "y": 9.558,
              "z": 0.804
            },
            "gtin": "4251758432278",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27021b",
            "leftCorner": {
              "x": 8.908,
              "y": 9.558,
              "z": 0.804
            },
            "rightCorner": {
              "x": 8.915,
              "y": 9.647,
              "z": 0.804
            },
            "gtin": "4251758432292",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27021c",
            "leftCorner": {
              "x": 8.915,
              "y": 9.647,
              "z": 0.804
            },
            "rightCorner": {
              "x": 8.922,
              "y": 9.737,
              "z": 0.804
            },
            "gtin": "5000204414394",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27021d",
            "leftCorner": {
              "x": 8.922,
              "y": 9.737,
              "z": 0.804
            },
            "rightCorner": {
              "x": 8.928,
              "y": 9.811,
              "z": 0.804
            },
            "gtin": "4251758423047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27021e",
            "leftCorner": {
              "x": 8.928,
              "y": 9.811,
              "z": 0.804
            },
            "rightCorner": {
              "x": 8.938,
              "y": 9.93,
              "z": 0.804
            },
            "gtin": "4002448145790",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27021f",
            "leftCorner": {
              "x": 8.938,
              "y": 9.93,
              "z": 0.804
            },
            "rightCorner": {
              "x": 8.944,
              "y": 10.011,
              "z": 0.804
            },
            "gtin": "4251758424877",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270220",
            "leftCorner": {
              "x": 8.944,
              "y": 10.011,
              "z": 0.804
            },
            "rightCorner": {
              "x": 8.95,
              "y": 10.089,
              "z": 0.804
            },
            "gtin": "4251758424891",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270221",
            "leftCorner": {
              "x": 8.95,
              "y": 10.089,
              "z": 0.804
            },
            "rightCorner": {
              "x": 8.957,
              "y": 10.175,
              "z": 0.804
            },
            "gtin": "4251758423740",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270222",
            "leftCorner": {
              "x": 8.957,
              "y": 10.175,
              "z": 0.804
            },
            "rightCorner": {
              "x": 8.962,
              "y": 10.246,
              "z": 0.804
            },
            "gtin": "4066447435108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270223",
            "leftCorner": {
              "x": 8.962,
              "y": 10.246,
              "z": 0.804
            },
            "rightCorner": {
              "x": 8.969,
              "y": 10.327,
              "z": 0.804
            },
            "gtin": "4066447435108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270224",
            "leftCorner": {
              "x": 8.969,
              "y": 10.327,
              "z": 0.804
            },
            "rightCorner": {
              "x": 8.974,
              "y": 10.388,
              "z": 0.804
            },
            "gtin": "4058172769900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270225",
            "leftCorner": {
              "x": 8.974,
              "y": 10.388,
              "z": 0.804
            },
            "rightCorner": {
              "x": 8.978,
              "y": 10.45,
              "z": 0.804
            },
            "gtin": "4058172769900",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7392b",
        "height": 1.0166,
        "facings": [
          {
            "id": "696ebf6d43c343680a2701fb",
            "leftCorner": {
              "x": 8.883,
              "y": 9.198,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.892,
              "y": 9.31,
              "z": 1.017
            },
            "gtin": "4251642611598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2701fd",
            "leftCorner": {
              "x": 8.892,
              "y": 9.31,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.899,
              "y": 9.394,
              "z": 1.017
            },
            "gtin": "4251642611604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701fe",
            "leftCorner": {
              "x": 8.899,
              "y": 9.394,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.904,
              "y": 9.463,
              "z": 1.017
            },
            "gtin": "4251642611628",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701ff",
            "leftCorner": {
              "x": 8.904,
              "y": 9.463,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.912,
              "y": 9.567,
              "z": 1.017
            },
            "gtin": "5000204355444",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270200",
            "leftCorner": {
              "x": 8.912,
              "y": 9.567,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.92,
              "y": 9.672,
              "z": 1.017
            },
            "gtin": "5000204355444",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270201",
            "leftCorner": {
              "x": 8.92,
              "y": 9.672,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.93,
              "y": 9.789,
              "z": 1.017
            },
            "gtin": "5000204415087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270202",
            "leftCorner": {
              "x": 8.93,
              "y": 9.789,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.938,
              "y": 9.89,
              "z": 1.017
            },
            "gtin": "5000204415056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270203",
            "leftCorner": {
              "x": 8.938,
              "y": 9.89,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.945,
              "y": 9.99,
              "z": 1.017
            },
            "gtin": "5000204349818",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270204",
            "leftCorner": {
              "x": 8.945,
              "y": 9.99,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.952,
              "y": 10.071,
              "z": 1.017
            },
            "gtin": "5000204357103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270205",
            "leftCorner": {
              "x": 8.952,
              "y": 10.071,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.957,
              "y": 10.143,
              "z": 1.017
            },
            "gtin": "5000204356502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270206",
            "leftCorner": {
              "x": 8.957,
              "y": 10.143,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.964,
              "y": 10.225,
              "z": 1.017
            },
            "gtin": "5000204356380",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270207",
            "leftCorner": {
              "x": 8.964,
              "y": 10.225,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.97,
              "y": 10.3,
              "z": 1.017
            },
            "gtin": "5000204356656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270208",
            "leftCorner": {
              "x": 8.97,
              "y": 10.3,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.976,
              "y": 10.38,
              "z": 1.017
            },
            "gtin": "5000204414813",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7392e",
        "height": 1.2276,
        "facings": [
          {
            "id": "696ebf6d43c343680a27022f",
            "leftCorner": {
              "x": 8.882,
              "y": 9.199,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.888,
              "y": 9.273,
              "z": 1.228
            },
            "gtin": "5000204219890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270230",
            "leftCorner": {
              "x": 8.888,
              "y": 9.273,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.89,
              "y": 9.306,
              "z": 1.228
            },
            "gtin": "5000204219890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270231",
            "leftCorner": {
              "x": 8.89,
              "y": 9.306,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.896,
              "y": 9.376,
              "z": 1.228
            },
            "gtin": "5000204219388",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270232",
            "leftCorner": {
              "x": 8.896,
              "y": 9.376,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.901,
              "y": 9.44,
              "z": 1.228
            },
            "gtin": "5000204219357",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270233",
            "leftCorner": {
              "x": 8.901,
              "y": 9.44,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.91,
              "y": 9.562,
              "z": 1.228
            },
            "gtin": "4251758433398",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270234",
            "leftCorner": {
              "x": 8.91,
              "y": 9.562,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.916,
              "y": 9.634,
              "z": 1.228
            },
            "gtin": "4251758433336",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270235",
            "leftCorner": {
              "x": 8.916,
              "y": 9.634,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.923,
              "y": 9.726,
              "z": 1.228
            },
            "gtin": "4251758433251",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270236",
            "leftCorner": {
              "x": 8.923,
              "y": 9.726,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.931,
              "y": 9.819,
              "z": 1.228
            },
            "gtin": "4251758433237",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270237",
            "leftCorner": {
              "x": 8.931,
              "y": 9.819,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.933,
              "y": 9.854,
              "z": 1.228
            },
            "gtin": "4051281984288",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270238",
            "leftCorner": {
              "x": 8.933,
              "y": 9.854,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.936,
              "y": 9.889,
              "z": 1.228
            },
            "gtin": "4051281984288",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270239",
            "leftCorner": {
              "x": 8.936,
              "y": 9.889,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.941,
              "y": 9.953,
              "z": 1.228
            },
            "gtin": "4058172822391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27023a",
            "leftCorner": {
              "x": 8.941,
              "y": 9.953,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.946,
              "y": 10.013,
              "z": 1.228
            },
            "gtin": "4058172822391",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27023b",
            "leftCorner": {
              "x": 8.946,
              "y": 10.013,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.95,
              "y": 10.071,
              "z": 1.228
            },
            "gtin": "4058172822391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27023c",
            "leftCorner": {
              "x": 8.95,
              "y": 10.071,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.955,
              "y": 10.133,
              "z": 1.228
            },
            "gtin": "4066447874822",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27023d",
            "leftCorner": {
              "x": 8.955,
              "y": 10.133,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.96,
              "y": 10.197,
              "z": 1.228
            },
            "gtin": "4058172822414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27023e",
            "leftCorner": {
              "x": 8.96,
              "y": 10.197,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.965,
              "y": 10.26,
              "z": 1.228
            },
            "gtin": "4058172822438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27023f",
            "leftCorner": {
              "x": 8.965,
              "y": 10.26,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.971,
              "y": 10.327,
              "z": 1.228
            },
            "gtin": "4058172822438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270240",
            "leftCorner": {
              "x": 8.971,
              "y": 10.327,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.975,
              "y": 10.389,
              "z": 1.228
            },
            "gtin": "4058172822438",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270241",
            "leftCorner": {
              "x": 8.975,
              "y": 10.389,
              "z": 1.228
            },
            "rightCorner": {
              "x": 8.982,
              "y": 10.476,
              "z": 1.228
            },
            "gtin": "4066447874808",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7392f",
        "height": 1.4809,
        "facings": [
          {
            "id": "696ebf6d43c343680a27025e",
            "leftCorner": {
              "x": 8.951,
              "y": 10.048,
              "z": 1.481
            },
            "rightCorner": {
              "x": 8.957,
              "y": 10.113,
              "z": 1.481
            },
            "gtin": "4066447520712",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270252",
            "leftCorner": {
              "x": 8.885,
              "y": 9.198,
              "z": 1.481
            },
            "rightCorner": {
              "x": 8.894,
              "y": 9.314,
              "z": 1.481
            },
            "gtin": "4051281960725",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270254",
            "leftCorner": {
              "x": 8.894,
              "y": 9.314,
              "z": 1.481
            },
            "rightCorner": {
              "x": 8.902,
              "y": 9.421,
              "z": 1.481
            },
            "gtin": "4051281960848",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270255",
            "leftCorner": {
              "x": 8.902,
              "y": 9.421,
              "z": 1.481
            },
            "rightCorner": {
              "x": 8.906,
              "y": 9.469,
              "z": 1.481
            },
            "gtin": "4051281960886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270256",
            "leftCorner": {
              "x": 8.906,
              "y": 9.469,
              "z": 1.481
            },
            "rightCorner": {
              "x": 8.911,
              "y": 9.534,
              "z": 1.481
            },
            "gtin": "4051281960909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270257",
            "leftCorner": {
              "x": 8.911,
              "y": 9.534,
              "z": 1.481
            },
            "rightCorner": {
              "x": 8.916,
              "y": 9.6,
              "z": 1.481
            },
            "gtin": "5000204230703",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270258",
            "leftCorner": {
              "x": 8.916,
              "y": 9.6,
              "z": 1.481
            },
            "rightCorner": {
              "x": 8.922,
              "y": 9.668,
              "z": 1.481
            },
            "gtin": "5000204227079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270259",
            "leftCorner": {
              "x": 8.922,
              "y": 9.668,
              "z": 1.481
            },
            "rightCorner": {
              "x": 8.927,
              "y": 9.74,
              "z": 1.481
            },
            "gtin": "5000204395013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27025a",
            "leftCorner": {
              "x": 8.927,
              "y": 9.74,
              "z": 1.481
            },
            "rightCorner": {
              "x": 8.933,
              "y": 9.817,
              "z": 1.481
            },
            "gtin": "5000204394955",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27025b",
            "leftCorner": {
              "x": 8.933,
              "y": 9.817,
              "z": 1.481
            },
            "rightCorner": {
              "x": 8.939,
              "y": 9.889,
              "z": 1.481
            },
            "gtin": "5000204412055",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27025c",
            "leftCorner": {
              "x": 8.939,
              "y": 9.889,
              "z": 1.481
            },
            "rightCorner": {
              "x": 8.946,
              "y": 9.979,
              "z": 1.481
            },
            "gtin": "4251758438225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27025d",
            "leftCorner": {
              "x": 8.946,
              "y": 9.979,
              "z": 1.481
            },
            "rightCorner": {
              "x": 8.951,
              "y": 10.048,
              "z": 1.481
            },
            "gtin": "4066447520729",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27025f",
            "leftCorner": {
              "x": 8.957,
              "y": 10.113,
              "z": 1.481
            },
            "rightCorner": {
              "x": 8.959,
              "y": 10.151,
              "z": 1.481
            },
            "gtin": "4066447520699",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270260",
            "leftCorner": {
              "x": 8.959,
              "y": 10.151,
              "z": 1.481
            },
            "rightCorner": {
              "x": 8.962,
              "y": 10.188,
              "z": 1.481
            },
            "gtin": "4066447520705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270261",
            "leftCorner": {
              "x": 8.962,
              "y": 10.188,
              "z": 1.481
            },
            "rightCorner": {
              "x": 8.966,
              "y": 10.228,
              "z": 1.481
            },
            "gtin": "4066447520682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270262",
            "leftCorner": {
              "x": 8.966,
              "y": 10.228,
              "z": 1.481
            },
            "rightCorner": {
              "x": 8.971,
              "y": 10.298,
              "z": 1.481
            },
            "gtin": "4058172769740",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270263",
            "leftCorner": {
              "x": 8.971,
              "y": 10.298,
              "z": 1.481
            },
            "rightCorner": {
              "x": 8.979,
              "y": 10.402,
              "z": 1.481
            },
            "gtin": "4058172769740",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270264",
            "leftCorner": {
              "x": 8.979,
              "y": 10.402,
              "z": 1.481
            },
            "rightCorner": {
              "x": 8.985,
              "y": 10.479,
              "z": 1.481
            },
            "gtin": "4066447049992",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7392d",
        "height": 1.7313,
        "facings": [
          {
            "id": "696ebf6d43c343680a270113",
            "leftCorner": {
              "x": 8.89,
              "y": 9.274,
              "z": 1.731
            },
            "rightCorner": {
              "x": 8.901,
              "y": 9.425,
              "z": 1.731
            },
            "gtin": "4001499944420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270114",
            "leftCorner": {
              "x": 8.901,
              "y": 9.425,
              "z": 1.731
            },
            "rightCorner": {
              "x": 8.909,
              "y": 9.516,
              "z": 1.731
            },
            "gtin": "4001499116896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270115",
            "leftCorner": {
              "x": 8.909,
              "y": 9.516,
              "z": 1.731
            },
            "rightCorner": {
              "x": 8.919,
              "y": 9.645,
              "z": 1.731
            }
          },
          {
            "id": "696ebf6d43c343680a270116",
            "leftCorner": {
              "x": 8.919,
              "y": 9.645,
              "z": 1.731
            },
            "rightCorner": {
              "x": 8.924,
              "y": 9.711,
              "z": 1.731
            },
            "gtin": "4066447343328",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270117",
            "leftCorner": {
              "x": 8.924,
              "y": 9.711,
              "z": 1.731
            },
            "rightCorner": {
              "x": 8.929,
              "y": 9.775,
              "z": 1.731
            },
            "gtin": "4066447343281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270118",
            "leftCorner": {
              "x": 8.929,
              "y": 9.775,
              "z": 1.731
            },
            "rightCorner": {
              "x": 8.934,
              "y": 9.846,
              "z": 1.731
            },
            "gtin": "4066447874747",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270119",
            "leftCorner": {
              "x": 8.934,
              "y": 9.846,
              "z": 1.731
            },
            "rightCorner": {
              "x": 8.94,
              "y": 9.912,
              "z": 1.731
            },
            "gtin": "4066447343229",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27011a",
            "leftCorner": {
              "x": 8.94,
              "y": 9.912,
              "z": 1.731
            },
            "rightCorner": {
              "x": 8.944,
              "y": 9.97,
              "z": 1.731
            },
            "gtin": "4066447343441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27011b",
            "leftCorner": {
              "x": 8.944,
              "y": 9.97,
              "z": 1.731
            },
            "rightCorner": {
              "x": 8.949,
              "y": 10.031,
              "z": 1.731
            },
            "gtin": "4066447874785",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27011c",
            "leftCorner": {
              "x": 8.949,
              "y": 10.031,
              "z": 1.731
            },
            "rightCorner": {
              "x": 8.954,
              "y": 10.096,
              "z": 1.731
            },
            "gtin": "4066447343205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27011d",
            "leftCorner": {
              "x": 8.954,
              "y": 10.096,
              "z": 1.731
            },
            "rightCorner": {
              "x": 8.958,
              "y": 10.151,
              "z": 1.731
            },
            "gtin": "4067796184709",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27011e",
            "leftCorner": {
              "x": 8.958,
              "y": 10.151,
              "z": 1.731
            },
            "rightCorner": {
              "x": 8.963,
              "y": 10.213,
              "z": 1.731
            }
          },
          {
            "id": "696ebf6d43c343680a27011f",
            "leftCorner": {
              "x": 8.963,
              "y": 10.213,
              "z": 1.731
            },
            "rightCorner": {
              "x": 8.968,
              "y": 10.279,
              "z": 1.731
            },
            "gtin": "4066447874747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270120",
            "leftCorner": {
              "x": 8.968,
              "y": 10.279,
              "z": 1.731
            },
            "rightCorner": {
              "x": 8.974,
              "y": 10.345,
              "z": 1.731
            },
            "gtin": "4066447874761",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270121",
            "leftCorner": {
              "x": 8.974,
              "y": 10.345,
              "z": 1.731
            },
            "rightCorner": {
              "x": 8.978,
              "y": 10.406,
              "z": 1.731
            },
            "gtin": "4066447343182",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270122",
            "leftCorner": {
              "x": 8.978,
              "y": 10.406,
              "z": 1.731
            },
            "rightCorner": {
              "x": 8.988,
              "y": 10.526,
              "z": 1.731
            },
            "gtin": "4066447343243",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757c5b5fe7bc046959a5b",
    "name": "68e757c5b5fe7bc046959a5b",
    "x": 8.9229,
    "y": 10.436,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.67225,
      "w": 0.74032
    },
    "statistics": {
      "hasStockCount": 42,
      "noStockCount": 1,
      "unknownStockCount": 37
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73936",
        "height": 0.2045,
        "facings": [
          {
            "id": "696ebf6d43c343680a2700b9",
            "leftCorner": {
              "x": 9.043,
              "y": 11.206,
              "z": 0.204
            },
            "rightCorner": {
              "x": 9.072,
              "y": 11.503,
              "z": 0.204
            },
            "gtin": "4058172769429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700ba",
            "leftCorner": {
              "x": 9.072,
              "y": 11.503,
              "z": 0.204
            },
            "rightCorner": {
              "x": 9.088,
              "y": 11.67,
              "z": 0.204
            },
            "gtin": "4058172769443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700b1",
            "leftCorner": {
              "x": 8.978,
              "y": 10.534,
              "z": 0.204
            },
            "rightCorner": {
              "x": 8.994,
              "y": 10.704,
              "z": 0.204
            },
            "gtin": "4058172769467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700b2",
            "leftCorner": {
              "x": 8.994,
              "y": 10.704,
              "z": 0.204
            },
            "rightCorner": {
              "x": 9.003,
              "y": 10.796,
              "z": 0.204
            },
            "gtin": "4058172510533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700b3",
            "leftCorner": {
              "x": 9.003,
              "y": 10.796,
              "z": 0.204
            },
            "rightCorner": {
              "x": 9.009,
              "y": 10.861,
              "z": 0.204
            },
            "gtin": "4066447892345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700b4",
            "leftCorner": {
              "x": 9.009,
              "y": 10.861,
              "z": 0.204
            },
            "rightCorner": {
              "x": 9.016,
              "y": 10.93,
              "z": 0.204
            }
          },
          {
            "id": "696ebf6d43c343680a2700b5",
            "leftCorner": {
              "x": 9.016,
              "y": 10.93,
              "z": 0.204
            },
            "rightCorner": {
              "x": 9.021,
              "y": 10.982,
              "z": 0.204
            },
            "gtin": "4058172510519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700b6",
            "leftCorner": {
              "x": 9.021,
              "y": 10.982,
              "z": 0.204
            },
            "rightCorner": {
              "x": 9.024,
              "y": 11.015,
              "z": 0.204
            },
            "gtin": "4058172510519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700b7",
            "leftCorner": {
              "x": 9.024,
              "y": 11.015,
              "z": 0.204
            },
            "rightCorner": {
              "x": 9.037,
              "y": 11.142,
              "z": 0.204
            },
            "gtin": "4024489046218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700b8",
            "leftCorner": {
              "x": 9.037,
              "y": 11.142,
              "z": 0.204
            },
            "rightCorner": {
              "x": 9.043,
              "y": 11.206,
              "z": 0.204
            },
            "gtin": "4024489046119",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73934",
        "height": 0.55511,
        "facings": [
          {
            "id": "696ebf6d43c343680a270175",
            "leftCorner": {
              "x": 8.98,
              "y": 10.444,
              "z": 0.55
            },
            "rightCorner": {
              "x": 8.986,
              "y": 10.526,
              "z": 0.55
            },
            "gtin": "4066447082906",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270176",
            "leftCorner": {
              "x": 8.98,
              "y": 10.513,
              "z": 0.555
            },
            "rightCorner": {
              "x": 8.987,
              "y": 10.586,
              "z": 0.555
            },
            "gtin": "4066447082906",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270177",
            "leftCorner": {
              "x": 8.987,
              "y": 10.586,
              "z": 0.555
            },
            "rightCorner": {
              "x": 8.998,
              "y": 10.702,
              "z": 0.555
            },
            "gtin": "4058172769887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270178",
            "leftCorner": {
              "x": 8.998,
              "y": 10.702,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.009,
              "y": 10.82,
              "z": 0.555
            },
            "gtin": "4066447771558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270179",
            "leftCorner": {
              "x": 9.009,
              "y": 10.82,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.023,
              "y": 10.958,
              "z": 0.555
            },
            "gtin": "4066447771893",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27017a",
            "leftCorner": {
              "x": 9.023,
              "y": 10.958,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.035,
              "y": 11.083,
              "z": 0.555
            },
            "gtin": "4066447877649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27017b",
            "leftCorner": {
              "x": 9.035,
              "y": 11.083,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.046,
              "y": 11.204,
              "z": 0.555
            },
            "gtin": "4066447879643",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27017c",
            "leftCorner": {
              "x": 9.046,
              "y": 11.204,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.058,
              "y": 11.327,
              "z": 0.555
            },
            "gtin": "4066447350173",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27017d",
            "leftCorner": {
              "x": 9.058,
              "y": 11.327,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.076,
              "y": 11.514,
              "z": 0.555
            },
            "gtin": "4022664018821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27012f",
            "leftCorner": {
              "x": 9.076,
              "y": 11.514,
              "z": 0.555
            },
            "rightCorner": {
              "x": 9.092,
              "y": 11.675,
              "z": 0.555
            },
            "gtin": "4066447984576",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73938",
        "height": 0.80765,
        "facings": [
          {
            "id": "696ebf6d43c343680a270226",
            "leftCorner": {
              "x": 8.978,
              "y": 10.45,
              "z": 0.804
            },
            "rightCorner": {
              "x": 8.994,
              "y": 10.649,
              "z": 0.804
            },
            "gtin": "4058172822797",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270227",
            "leftCorner": {
              "x": 8.992,
              "y": 10.635,
              "z": 0.808
            },
            "rightCorner": {
              "x": 9.008,
              "y": 10.8,
              "z": 0.808
            },
            "gtin": "4066447984491",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270228",
            "leftCorner": {
              "x": 9.008,
              "y": 10.8,
              "z": 0.808
            },
            "rightCorner": {
              "x": 9.025,
              "y": 10.971,
              "z": 0.808
            },
            "gtin": "4066447897708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270229",
            "leftCorner": {
              "x": 9.025,
              "y": 10.971,
              "z": 0.808
            },
            "rightCorner": {
              "x": 9.035,
              "y": 11.072,
              "z": 0.808
            },
            "gtin": "4066447897623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27022a",
            "leftCorner": {
              "x": 9.035,
              "y": 11.072,
              "z": 0.808
            },
            "rightCorner": {
              "x": 9.043,
              "y": 11.16,
              "z": 0.808
            },
            "gtin": "4066447984453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27022b",
            "leftCorner": {
              "x": 9.043,
              "y": 11.16,
              "z": 0.808
            },
            "rightCorner": {
              "x": 9.052,
              "y": 11.25,
              "z": 0.808
            },
            "gtin": "4066447897609",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27022c",
            "leftCorner": {
              "x": 9.052,
              "y": 11.25,
              "z": 0.808
            },
            "rightCorner": {
              "x": 9.066,
              "y": 11.395,
              "z": 0.808
            },
            "gtin": "4066447897685",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27022d",
            "leftCorner": {
              "x": 9.066,
              "y": 11.395,
              "z": 0.808
            },
            "rightCorner": {
              "x": 9.079,
              "y": 11.531,
              "z": 0.808
            },
            "gtin": "4066447897647",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27022e",
            "leftCorner": {
              "x": 9.079,
              "y": 11.531,
              "z": 0.808
            },
            "rightCorner": {
              "x": 9.092,
              "y": 11.662,
              "z": 0.808
            },
            "gtin": "4066447984439",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73935",
        "height": 1.0187,
        "facings": [
          {
            "id": "696ebf6d43c343680a270209",
            "leftCorner": {
              "x": 8.976,
              "y": 10.38,
              "z": 1.017
            },
            "rightCorner": {
              "x": 8.984,
              "y": 10.485,
              "z": 1.017
            },
            "gtin": "5000204378511",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27020a",
            "leftCorner": {
              "x": 8.975,
              "y": 10.472,
              "z": 1.019
            },
            "rightCorner": {
              "x": 8.982,
              "y": 10.545,
              "z": 1.019
            },
            "gtin": "5000204378511",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27020b",
            "leftCorner": {
              "x": 8.982,
              "y": 10.545,
              "z": 1.019
            },
            "rightCorner": {
              "x": 8.99,
              "y": 10.632,
              "z": 1.019
            },
            "gtin": "5000204414752",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27020c",
            "leftCorner": {
              "x": 8.99,
              "y": 10.632,
              "z": 1.019
            },
            "rightCorner": {
              "x": 8.998,
              "y": 10.706,
              "z": 1.019
            },
            "gtin": "5000204427837",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27020d",
            "leftCorner": {
              "x": 8.998,
              "y": 10.706,
              "z": 1.019
            },
            "rightCorner": {
              "x": 9.008,
              "y": 10.814,
              "z": 1.019
            },
            "gtin": "4008495637806",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27020e",
            "leftCorner": {
              "x": 9.008,
              "y": 10.814,
              "z": 1.019
            },
            "rightCorner": {
              "x": 9.017,
              "y": 10.904,
              "z": 1.019
            },
            "gtin": "4008495019930",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27020f",
            "leftCorner": {
              "x": 9.017,
              "y": 10.904,
              "z": 1.019
            },
            "rightCorner": {
              "x": 9.025,
              "y": 10.994,
              "z": 1.019
            },
            "gtin": "4008495015727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270210",
            "leftCorner": {
              "x": 9.025,
              "y": 10.994,
              "z": 1.019
            },
            "rightCorner": {
              "x": 9.032,
              "y": 11.067,
              "z": 1.019
            },
            "gtin": "4066447877748",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270211",
            "leftCorner": {
              "x": 9.032,
              "y": 11.067,
              "z": 1.019
            },
            "rightCorner": {
              "x": 9.04,
              "y": 11.141,
              "z": 1.019
            },
            "gtin": "4066447877861",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270212",
            "leftCorner": {
              "x": 9.04,
              "y": 11.141,
              "z": 1.019
            },
            "rightCorner": {
              "x": 9.047,
              "y": 11.216,
              "z": 1.019
            },
            "gtin": "4067796161007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270213",
            "leftCorner": {
              "x": 9.047,
              "y": 11.216,
              "z": 1.019
            },
            "rightCorner": {
              "x": 9.053,
              "y": 11.283,
              "z": 1.019
            },
            "gtin": "4067796161007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270214",
            "leftCorner": {
              "x": 9.053,
              "y": 11.283,
              "z": 1.019
            },
            "rightCorner": {
              "x": 9.065,
              "y": 11.409,
              "z": 1.019
            },
            "gtin": "4066447984415",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270215",
            "leftCorner": {
              "x": 9.065,
              "y": 11.409,
              "z": 1.019
            },
            "rightCorner": {
              "x": 9.075,
              "y": 11.508,
              "z": 1.019
            },
            "gtin": "4066447501612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270216",
            "leftCorner": {
              "x": 9.075,
              "y": 11.508,
              "z": 1.019
            },
            "rightCorner": {
              "x": 9.081,
              "y": 11.568,
              "z": 1.019
            },
            "gtin": "4066447069419",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2701fc",
            "leftCorner": {
              "x": 9.081,
              "y": 11.568,
              "z": 1.019
            },
            "rightCorner": {
              "x": 9.091,
              "y": 11.676,
              "z": 1.019
            },
            "gtin": "4066447297768",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73937",
        "height": 1.2298,
        "facings": [
          {
            "id": "696ebf6d43c343680a270242",
            "leftCorner": {
              "x": 8.978,
              "y": 10.462,
              "z": 1.23
            },
            "rightCorner": {
              "x": 8.984,
              "y": 10.521,
              "z": 1.23
            },
            "gtin": "4066447975239",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270243",
            "leftCorner": {
              "x": 8.984,
              "y": 10.521,
              "z": 1.23
            },
            "rightCorner": {
              "x": 8.992,
              "y": 10.607,
              "z": 1.23
            }
          },
          {
            "id": "696ebf6d43c343680a270244",
            "leftCorner": {
              "x": 8.992,
              "y": 10.607,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.005,
              "y": 10.74,
              "z": 1.23
            },
            "gtin": "4058172510298",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270245",
            "leftCorner": {
              "x": 9.005,
              "y": 10.74,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.012,
              "y": 10.808,
              "z": 1.23
            },
            "gtin": "4058172510274",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270246",
            "leftCorner": {
              "x": 9.012,
              "y": 10.808,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.018,
              "y": 10.876,
              "z": 1.23
            },
            "gtin": "4066447880540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270247",
            "leftCorner": {
              "x": 9.018,
              "y": 10.876,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.025,
              "y": 10.945,
              "z": 1.23
            },
            "gtin": "4066447423471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270248",
            "leftCorner": {
              "x": 9.025,
              "y": 10.945,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.033,
              "y": 11.029,
              "z": 1.23
            },
            "gtin": "4066447423464",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270249",
            "leftCorner": {
              "x": 9.033,
              "y": 11.029,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.039,
              "y": 11.096,
              "z": 1.23
            },
            "gtin": "4058172510410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27024a",
            "leftCorner": {
              "x": 9.039,
              "y": 11.096,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.046,
              "y": 11.164,
              "z": 1.23
            },
            "gtin": "4058172510410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27024b",
            "leftCorner": {
              "x": 9.046,
              "y": 11.164,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.053,
              "y": 11.238,
              "z": 1.23
            },
            "gtin": "4066447877809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27024c",
            "leftCorner": {
              "x": 9.053,
              "y": 11.238,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.06,
              "y": 11.305,
              "z": 1.23
            },
            "gtin": "4058172510656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27024d",
            "leftCorner": {
              "x": 9.06,
              "y": 11.305,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.066,
              "y": 11.372,
              "z": 1.23
            },
            "gtin": "4058172510656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27024e",
            "leftCorner": {
              "x": 9.066,
              "y": 11.372,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.074,
              "y": 11.449,
              "z": 1.23
            },
            "gtin": "4058172510656",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27024f",
            "leftCorner": {
              "x": 9.074,
              "y": 11.449,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.08,
              "y": 11.52,
              "z": 1.23
            },
            "gtin": "4058172510359",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270250",
            "leftCorner": {
              "x": 9.08,
              "y": 11.52,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.088,
              "y": 11.598,
              "z": 1.23
            },
            "gtin": "4067796065510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270251",
            "leftCorner": {
              "x": 9.088,
              "y": 11.598,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.092,
              "y": 11.643,
              "z": 1.23
            },
            "gtin": "4058172799693",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73933",
        "height": 1.4842,
        "facings": [
          {
            "id": "696ebf6d43c343680a270265",
            "leftCorner": {
              "x": 8.982,
              "y": 10.465,
              "z": 1.484
            },
            "rightCorner": {
              "x": 8.988,
              "y": 10.526,
              "z": 1.484
            },
            "gtin": "4058172769689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270266",
            "leftCorner": {
              "x": 8.988,
              "y": 10.526,
              "z": 1.484
            },
            "rightCorner": {
              "x": 8.995,
              "y": 10.598,
              "z": 1.484
            },
            "gtin": "4058172769726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270267",
            "leftCorner": {
              "x": 8.995,
              "y": 10.598,
              "z": 1.484
            },
            "rightCorner": {
              "x": 9.003,
              "y": 10.673,
              "z": 1.484
            },
            "gtin": "4058172769726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270268",
            "leftCorner": {
              "x": 9.003,
              "y": 10.673,
              "z": 1.484
            },
            "rightCorner": {
              "x": 9.01,
              "y": 10.751,
              "z": 1.484
            },
            "gtin": "4058172769702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270269",
            "leftCorner": {
              "x": 9.01,
              "y": 10.751,
              "z": 1.484
            },
            "rightCorner": {
              "x": 9.018,
              "y": 10.828,
              "z": 1.484
            },
            "gtin": "4058172769702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27026a",
            "leftCorner": {
              "x": 9.018,
              "y": 10.828,
              "z": 1.484
            },
            "rightCorner": {
              "x": 9.025,
              "y": 10.908,
              "z": 1.484
            },
            "gtin": "4058172769788",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27026b",
            "leftCorner": {
              "x": 9.025,
              "y": 10.908,
              "z": 1.484
            },
            "rightCorner": {
              "x": 9.035,
              "y": 11.004,
              "z": 1.484
            }
          },
          {
            "id": "696ebf6d43c343680a27026c",
            "leftCorner": {
              "x": 9.035,
              "y": 11.004,
              "z": 1.484
            },
            "rightCorner": {
              "x": 9.043,
              "y": 11.09,
              "z": 1.484
            }
          },
          {
            "id": "696ebf6d43c343680a27026d",
            "leftCorner": {
              "x": 9.043,
              "y": 11.09,
              "z": 1.484
            },
            "rightCorner": {
              "x": 9.05,
              "y": 11.169,
              "z": 1.484
            },
            "gtin": "4058172797811",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27026e",
            "leftCorner": {
              "x": 9.05,
              "y": 11.169,
              "z": 1.484
            },
            "rightCorner": {
              "x": 9.058,
              "y": 11.244,
              "z": 1.484
            },
            "gtin": "4066447877922",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27026f",
            "leftCorner": {
              "x": 9.058,
              "y": 11.244,
              "z": 1.484
            },
            "rightCorner": {
              "x": 9.065,
              "y": 11.315,
              "z": 1.484
            }
          },
          {
            "id": "696ebf6d43c343680a270270",
            "leftCorner": {
              "x": 9.065,
              "y": 11.315,
              "z": 1.484
            },
            "rightCorner": {
              "x": 9.07,
              "y": 11.367,
              "z": 1.484
            },
            "gtin": "4058172799716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270271",
            "leftCorner": {
              "x": 9.07,
              "y": 11.367,
              "z": 1.484
            },
            "rightCorner": {
              "x": 9.077,
              "y": 11.44,
              "z": 1.484
            }
          },
          {
            "id": "696ebf6d43c343680a270272",
            "leftCorner": {
              "x": 9.077,
              "y": 11.44,
              "z": 1.484
            },
            "rightCorner": {
              "x": 9.086,
              "y": 11.538,
              "z": 1.484
            },
            "gtin": "4058172799730",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270273",
            "leftCorner": {
              "x": 9.086,
              "y": 11.538,
              "z": 1.484
            },
            "rightCorner": {
              "x": 9.093,
              "y": 11.605,
              "z": 1.484
            }
          },
          {
            "id": "696ebf6d43c343680a270253",
            "leftCorner": {
              "x": 9.093,
              "y": 11.605,
              "z": 1.484
            },
            "rightCorner": {
              "x": 9.099,
              "y": 11.675,
              "z": 1.484
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73932",
        "height": 1.7336,
        "facings": [
          {
            "id": "696ebf6d43c343680a270123",
            "leftCorner": {
              "x": 8.984,
              "y": 10.512,
              "z": 1.734
            },
            "rightCorner": {
              "x": 8.995,
              "y": 10.63,
              "z": 1.734
            },
            "gtin": "4066447442106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270124",
            "leftCorner": {
              "x": 8.995,
              "y": 10.63,
              "z": 1.734
            },
            "rightCorner": {
              "x": 9.003,
              "y": 10.712,
              "z": 1.734
            },
            "gtin": "4066447745597",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270125",
            "leftCorner": {
              "x": 9.003,
              "y": 10.712,
              "z": 1.734
            },
            "rightCorner": {
              "x": 9.011,
              "y": 10.791,
              "z": 1.734
            },
            "gtin": "4058172780301",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270126",
            "leftCorner": {
              "x": 9.011,
              "y": 10.791,
              "z": 1.734
            },
            "rightCorner": {
              "x": 9.018,
              "y": 10.863,
              "z": 1.734
            },
            "gtin": "4066447745504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270127",
            "leftCorner": {
              "x": 9.018,
              "y": 10.863,
              "z": 1.734
            },
            "rightCorner": {
              "x": 9.029,
              "y": 10.979,
              "z": 1.734
            },
            "gtin": "4066447745535",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270128",
            "leftCorner": {
              "x": 9.029,
              "y": 10.979,
              "z": 1.734
            },
            "rightCorner": {
              "x": 9.034,
              "y": 11.028,
              "z": 1.734
            },
            "gtin": "4058172780257",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270129",
            "leftCorner": {
              "x": 9.034,
              "y": 11.028,
              "z": 1.734
            },
            "rightCorner": {
              "x": 9.041,
              "y": 11.107,
              "z": 1.734
            },
            "gtin": "4066447672008",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27012a",
            "leftCorner": {
              "x": 9.041,
              "y": 11.107,
              "z": 1.734
            },
            "rightCorner": {
              "x": 9.047,
              "y": 11.162,
              "z": 1.734
            },
            "gtin": "4066447671971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27012b",
            "leftCorner": {
              "x": 9.047,
              "y": 11.162,
              "z": 1.734
            },
            "rightCorner": {
              "x": 9.055,
              "y": 11.252,
              "z": 1.734
            },
            "gtin": "4009864067033",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27012c",
            "leftCorner": {
              "x": 9.055,
              "y": 11.252,
              "z": 1.734
            },
            "rightCorner": {
              "x": 9.072,
              "y": 11.429,
              "z": 1.734
            },
            "gtin": "4066447249934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27012d",
            "leftCorner": {
              "x": 9.072,
              "y": 11.429,
              "z": 1.734
            },
            "rightCorner": {
              "x": 9.085,
              "y": 11.563,
              "z": 1.734
            },
            "gtin": "4009864063790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2700d2",
            "leftCorner": {
              "x": 9.085,
              "y": 11.563,
              "z": 1.734
            },
            "rightCorner": {
              "x": 9.096,
              "y": 11.675,
              "z": 1.734
            },
            "gtin": "4009864063004",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757d2b5fe7bc046959a7c",
    "name": "68e757d2b5fe7bc046959a7c",
    "x": 11.205,
    "y": 11.517,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.7358,
      "w": 0.6772
    },
    "statistics": {
      "hasStockCount": 17,
      "noStockCount": 3,
      "unknownStockCount": 26,
      "shelfCategory": "CLEANING"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd7393d",
        "height": 0.2073,
        "facings": [
          {
            "id": "696ebf6d43c343680a27030c",
            "leftCorner": {
              "x": 11.16,
              "y": 11.521,
              "z": 0.207
            },
            "rightCorner": {
              "x": 11.152,
              "y": 11.425,
              "z": 0.207
            },
            "gtin": "4011200652902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27030d",
            "leftCorner": {
              "x": 11.152,
              "y": 11.425,
              "z": 0.207
            },
            "rightCorner": {
              "x": 11.142,
              "y": 11.305,
              "z": 0.207
            }
          },
          {
            "id": "696ebf6d43c343680a27030e",
            "leftCorner": {
              "x": 11.142,
              "y": 11.305,
              "z": 0.207
            },
            "rightCorner": {
              "x": 11.129,
              "y": 11.152,
              "z": 0.207
            },
            "gtin": "8710908175824",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27030f",
            "leftCorner": {
              "x": 11.129,
              "y": 11.152,
              "z": 0.207
            },
            "rightCorner": {
              "x": 11.121,
              "y": 11.049,
              "z": 0.207
            },
            "gtin": "4058172185649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270310",
            "leftCorner": {
              "x": 11.121,
              "y": 11.049,
              "z": 0.207
            },
            "rightCorner": {
              "x": 11.114,
              "y": 10.965,
              "z": 0.207
            }
          },
          {
            "id": "696ebf6d43c343680a270311",
            "leftCorner": {
              "x": 11.114,
              "y": 10.965,
              "z": 0.207
            },
            "rightCorner": {
              "x": 11.103,
              "y": 10.838,
              "z": 0.207
            },
            "gtin": "4001499969287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270312",
            "leftCorner": {
              "x": 11.103,
              "y": 10.838,
              "z": 0.207
            },
            "rightCorner": {
              "x": 11.095,
              "y": 10.735,
              "z": 0.207
            },
            "gtin": "4001499168314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270313",
            "leftCorner": {
              "x": 11.095,
              "y": 10.735,
              "z": 0.207
            },
            "rightCorner": {
              "x": 11.088,
              "y": 10.66,
              "z": 0.207
            },
            "gtin": "4001499969270",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270314",
            "leftCorner": {
              "x": 11.088,
              "y": 10.66,
              "z": 0.207
            },
            "rightCorner": {
              "x": 11.077,
              "y": 10.526,
              "z": 0.207
            },
            "gtin": "5000204150735",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270315",
            "leftCorner": {
              "x": 11.077,
              "y": 10.526,
              "z": 0.207
            },
            "rightCorner": {
              "x": 11.07,
              "y": 10.438,
              "z": 0.207
            }
          },
          {
            "id": "696ebf6d43c343680a270316",
            "leftCorner": {
              "x": 11.07,
              "y": 10.438,
              "z": 0.207
            },
            "rightCorner": {
              "x": 11.061,
              "y": 10.335,
              "z": 0.207
            },
            "gtin": "4066447233698",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7393b",
        "height": 0.5508,
        "facings": [
          {
            "id": "696ebf6d43c343680a2702cd",
            "leftCorner": {
              "x": 11.151,
              "y": 11.522,
              "z": 0.551
            },
            "rightCorner": {
              "x": 11.143,
              "y": 11.433,
              "z": 0.551
            },
            "gtin": "4002448077640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702cf",
            "leftCorner": {
              "x": 11.143,
              "y": 11.433,
              "z": 0.551
            },
            "rightCorner": {
              "x": 11.134,
              "y": 11.314,
              "z": 0.551
            },
            "gtin": "4251758407054",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702d0",
            "leftCorner": {
              "x": 11.134,
              "y": 11.314,
              "z": 0.551
            },
            "rightCorner": {
              "x": 11.123,
              "y": 11.188,
              "z": 0.551
            },
            "gtin": "4008455048413",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702d1",
            "leftCorner": {
              "x": 11.123,
              "y": 11.188,
              "z": 0.551
            },
            "rightCorner": {
              "x": 11.117,
              "y": 11.12,
              "z": 0.551
            },
            "gtin": "4058172185540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702d2",
            "leftCorner": {
              "x": 11.117,
              "y": 11.12,
              "z": 0.551
            },
            "rightCorner": {
              "x": 11.112,
              "y": 11.06,
              "z": 0.551
            },
            "gtin": "4260006920023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702d3",
            "leftCorner": {
              "x": 11.112,
              "y": 11.06,
              "z": 0.551
            },
            "rightCorner": {
              "x": 11.104,
              "y": 10.959,
              "z": 0.551
            },
            "gtin": "4260006920009",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702d4",
            "leftCorner": {
              "x": 11.104,
              "y": 10.959,
              "z": 0.551
            },
            "rightCorner": {
              "x": 11.096,
              "y": 10.864,
              "z": 0.551
            },
            "gtin": "4260006920009",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702d5",
            "leftCorner": {
              "x": 11.096,
              "y": 10.864,
              "z": 0.551
            },
            "rightCorner": {
              "x": 11.087,
              "y": 10.749,
              "z": 0.551
            },
            "gtin": "4066447920710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702d6",
            "leftCorner": {
              "x": 11.087,
              "y": 10.749,
              "z": 0.551
            },
            "rightCorner": {
              "x": 11.076,
              "y": 10.622,
              "z": 0.551
            },
            "gtin": "4058172924620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702d7",
            "leftCorner": {
              "x": 11.076,
              "y": 10.622,
              "z": 0.551
            },
            "rightCorner": {
              "x": 11.066,
              "y": 10.499,
              "z": 0.551
            },
            "gtin": "4066447091038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702d8",
            "leftCorner": {
              "x": 11.066,
              "y": 10.499,
              "z": 0.551
            },
            "rightCorner": {
              "x": 11.049,
              "y": 10.296,
              "z": 0.551
            },
            "gtin": "4058172924668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702d9",
            "leftCorner": {
              "x": 11.049,
              "y": 10.296,
              "z": 0.551
            },
            "rightCorner": {
              "x": 11.044,
              "y": 10.237,
              "z": 0.551
            },
            "gtin": "8700216834018",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7393f",
        "height": 0.88721,
        "facings": [
          {
            "id": "696ebf6e43c343680a270378",
            "leftCorner": {
              "x": 11.153,
              "y": 11.522,
              "z": 0.887
            },
            "rightCorner": {
              "x": 11.137,
              "y": 11.332,
              "z": 0.887
            },
            "gtin": "8700216656054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27037a",
            "leftCorner": {
              "x": 11.137,
              "y": 11.332,
              "z": 0.887
            },
            "rightCorner": {
              "x": 11.125,
              "y": 11.193,
              "z": 0.887
            }
          },
          {
            "id": "696ebf6e43c343680a27037b",
            "leftCorner": {
              "x": 11.125,
              "y": 11.193,
              "z": 0.887
            },
            "rightCorner": {
              "x": 11.111,
              "y": 11.02,
              "z": 0.887
            },
            "gtin": "8700216672115",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27037c",
            "leftCorner": {
              "x": 11.111,
              "y": 11.02,
              "z": 0.887
            },
            "rightCorner": {
              "x": 11.097,
              "y": 10.854,
              "z": 0.887
            },
            "gtin": "8700216672115",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27037d",
            "leftCorner": {
              "x": 11.097,
              "y": 10.854,
              "z": 0.887
            },
            "rightCorner": {
              "x": 11.071,
              "y": 10.535,
              "z": 0.887
            },
            "gtin": "8700216717779",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27037e",
            "leftCorner": {
              "x": 11.071,
              "y": 10.535,
              "z": 0.887
            },
            "rightCorner": {
              "x": 11.06,
              "y": 10.405,
              "z": 0.887
            },
            "gtin": "8700216677363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27037f",
            "leftCorner": {
              "x": 11.06,
              "y": 10.405,
              "z": 0.887
            },
            "rightCorner": {
              "x": 11.052,
              "y": 10.316,
              "z": 0.887
            },
            "gtin": "4067796149159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270379",
            "leftCorner": {
              "x": 11.052,
              "y": 10.316,
              "z": 0.887
            },
            "rightCorner": {
              "x": 11.049,
              "y": 10.276,
              "z": 0.887
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7393c",
        "height": 1.2299,
        "facings": [
          {
            "id": "696ebf6d43c343680a2702ea",
            "leftCorner": {
              "x": 11.152,
              "y": 11.522,
              "z": 1.23
            },
            "rightCorner": {
              "x": 11.138,
              "y": 11.353,
              "z": 1.23
            },
            "gtin": "4066447890679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702ec",
            "leftCorner": {
              "x": 11.138,
              "y": 11.353,
              "z": 1.23
            },
            "rightCorner": {
              "x": 11.127,
              "y": 11.215,
              "z": 1.23
            },
            "gtin": "4058172924682",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702ed",
            "leftCorner": {
              "x": 11.127,
              "y": 11.215,
              "z": 1.23
            },
            "rightCorner": {
              "x": 11.095,
              "y": 10.836,
              "z": 1.23
            }
          },
          {
            "id": "696ebf6d43c343680a2702ee",
            "leftCorner": {
              "x": 11.095,
              "y": 10.836,
              "z": 1.23
            },
            "rightCorner": {
              "x": 11.082,
              "y": 10.676,
              "z": 1.23
            }
          },
          {
            "id": "696ebf6d43c343680a2702ef",
            "leftCorner": {
              "x": 11.082,
              "y": 10.676,
              "z": 1.23
            },
            "rightCorner": {
              "x": 11.071,
              "y": 10.546,
              "z": 1.23
            },
            "gtin": "4066447016574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702f0",
            "leftCorner": {
              "x": 11.071,
              "y": 10.546,
              "z": 1.23
            },
            "rightCorner": {
              "x": 11.061,
              "y": 10.427,
              "z": 1.23
            }
          },
          {
            "id": "696ebf6d43c343680a2702f1",
            "leftCorner": {
              "x": 11.061,
              "y": 10.427,
              "z": 1.23
            },
            "rightCorner": {
              "x": 11.053,
              "y": 10.325,
              "z": 1.23
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7393e",
        "height": 1.4849,
        "facings": [
          {
            "id": "696ebf6e43c343680a27035a",
            "leftCorner": {
              "x": 11.145,
              "y": 11.522,
              "z": 1.485
            },
            "rightCorner": {
              "x": 11.131,
              "y": 11.355,
              "z": 1.485
            },
            "gtin": "4066447448382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27035c",
            "leftCorner": {
              "x": 11.131,
              "y": 11.355,
              "z": 1.485
            },
            "rightCorner": {
              "x": 11.119,
              "y": 11.21,
              "z": 1.485
            }
          },
          {
            "id": "696ebf6e43c343680a27035d",
            "leftCorner": {
              "x": 11.119,
              "y": 11.21,
              "z": 1.485
            },
            "rightCorner": {
              "x": 11.114,
              "y": 11.152,
              "z": 1.485
            }
          },
          {
            "id": "696ebf6e43c343680a27035e",
            "leftCorner": {
              "x": 11.114,
              "y": 11.152,
              "z": 1.485
            },
            "rightCorner": {
              "x": 11.105,
              "y": 11.042,
              "z": 1.485
            }
          },
          {
            "id": "696ebf6e43c343680a27035f",
            "leftCorner": {
              "x": 11.105,
              "y": 11.042,
              "z": 1.485
            },
            "rightCorner": {
              "x": 11.093,
              "y": 10.899,
              "z": 1.485
            },
            "gtin": "4066447088106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270360",
            "leftCorner": {
              "x": 11.093,
              "y": 10.899,
              "z": 1.485
            },
            "rightCorner": {
              "x": 11.081,
              "y": 10.757,
              "z": 1.485
            }
          },
          {
            "id": "696ebf6e43c343680a270361",
            "leftCorner": {
              "x": 11.081,
              "y": 10.757,
              "z": 1.485
            },
            "rightCorner": {
              "x": 11.074,
              "y": 10.671,
              "z": 1.485
            }
          },
          {
            "id": "696ebf6e43c343680a270362",
            "leftCorner": {
              "x": 11.074,
              "y": 10.671,
              "z": 1.485
            },
            "rightCorner": {
              "x": 11.062,
              "y": 10.528,
              "z": 1.485
            },
            "gtin": "4066447016611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270363",
            "leftCorner": {
              "x": 11.062,
              "y": 10.528,
              "z": 1.485
            },
            "rightCorner": {
              "x": 11.054,
              "y": 10.426,
              "z": 1.485
            },
            "gtin": "4066447016611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270364",
            "leftCorner": {
              "x": 11.054,
              "y": 10.426,
              "z": 1.485
            },
            "rightCorner": {
              "x": 11.044,
              "y": 10.306,
              "z": 1.485
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7393a",
        "height": 1.7306,
        "facings": [
          {
            "id": "696ebf6d43c343680a270274",
            "leftCorner": {
              "x": 11.146,
              "y": 11.522,
              "z": 1.731
            },
            "rightCorner": {
              "x": 11.139,
              "y": 11.441,
              "z": 1.731
            },
            "gtin": "40161853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270276",
            "leftCorner": {
              "x": 11.139,
              "y": 11.441,
              "z": 1.731
            },
            "rightCorner": {
              "x": 11.131,
              "y": 11.34,
              "z": 1.731
            },
            "gtin": "40161808",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270277",
            "leftCorner": {
              "x": 11.131,
              "y": 11.34,
              "z": 1.731
            },
            "rightCorner": {
              "x": 11.124,
              "y": 11.26,
              "z": 1.731
            },
            "gtin": "40161822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270278",
            "leftCorner": {
              "x": 11.124,
              "y": 11.26,
              "z": 1.731
            },
            "rightCorner": {
              "x": 11.116,
              "y": 11.163,
              "z": 1.731
            },
            "gtin": "4016100245001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270279",
            "leftCorner": {
              "x": 11.116,
              "y": 11.163,
              "z": 1.731
            },
            "rightCorner": {
              "x": 11.106,
              "y": 11.04,
              "z": 1.731
            },
            "gtin": "4016100240150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27027a",
            "leftCorner": {
              "x": 11.106,
              "y": 11.04,
              "z": 1.731
            },
            "rightCorner": {
              "x": 11.096,
              "y": 10.93,
              "z": 1.731
            },
            "gtin": "40161181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27027b",
            "leftCorner": {
              "x": 11.096,
              "y": 10.93,
              "z": 1.731
            },
            "rightCorner": {
              "x": 11.089,
              "y": 10.846,
              "z": 1.731
            },
            "gtin": "4016100810117",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27027c",
            "leftCorner": {
              "x": 11.089,
              "y": 10.846,
              "z": 1.731
            },
            "rightCorner": {
              "x": 11.085,
              "y": 10.79,
              "z": 1.731
            },
            "gtin": "40161310",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27027d",
            "leftCorner": {
              "x": 11.085,
              "y": 10.79,
              "z": 1.731
            },
            "rightCorner": {
              "x": 11.08,
              "y": 10.732,
              "z": 1.731
            },
            "gtin": "40161334",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27027e",
            "leftCorner": {
              "x": 11.08,
              "y": 10.732,
              "z": 1.731
            },
            "rightCorner": {
              "x": 11.07,
              "y": 10.606,
              "z": 1.731
            },
            "gtin": "40161747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27027f",
            "leftCorner": {
              "x": 11.07,
              "y": 10.606,
              "z": 1.731
            },
            "rightCorner": {
              "x": 11.063,
              "y": 10.522,
              "z": 1.731
            },
            "gtin": "40161754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270280",
            "leftCorner": {
              "x": 11.063,
              "y": 10.522,
              "z": 1.731
            },
            "rightCorner": {
              "x": 11.054,
              "y": 10.42,
              "z": 1.731
            },
            "gtin": "4002832001190",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270281",
            "leftCorner": {
              "x": 11.054,
              "y": 10.42,
              "z": 1.731
            },
            "rightCorner": {
              "x": 11.044,
              "y": 10.297,
              "z": 1.731
            },
            "gtin": "4066447673401",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757d2b5fe7bc046959a7d",
    "name": "68e757d2b5fe7bc046959a7d",
    "x": 11.106,
    "y": 10.296,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73456,
      "w": 0.67854
    },
    "statistics": {
      "hasStockCount": 48,
      "noStockCount": 0,
      "unknownStockCount": 40
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73946",
        "height": 0.2047,
        "facings": [
          {
            "id": "696ebf6d43c343680a270317",
            "leftCorner": {
              "x": 11.061,
              "y": 10.335,
              "z": 0.207
            },
            "rightCorner": {
              "x": 11.045,
              "y": 10.132,
              "z": 0.207
            },
            "gtin": "4066447080773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270318",
            "leftCorner": {
              "x": 11.05,
              "y": 10.157,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.038,
              "y": 9.999,
              "z": 0.205
            },
            "gtin": "8700216698689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270319",
            "leftCorner": {
              "x": 11.038,
              "y": 9.999,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.033,
              "y": 9.944,
              "z": 0.205
            },
            "gtin": "8700216239196",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27031a",
            "leftCorner": {
              "x": 11.033,
              "y": 9.944,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.029,
              "y": 9.893,
              "z": 0.205
            },
            "gtin": "8700216239035",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27031b",
            "leftCorner": {
              "x": 11.029,
              "y": 9.893,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.025,
              "y": 9.842,
              "z": 0.205
            },
            "gtin": "8700216239011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27031c",
            "leftCorner": {
              "x": 11.025,
              "y": 9.842,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.02,
              "y": 9.783,
              "z": 0.205
            },
            "gtin": "8700216238977",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27031d",
            "leftCorner": {
              "x": 11.02,
              "y": 9.783,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.016,
              "y": 9.727,
              "z": 0.205
            },
            "gtin": "8700216239080",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27031e",
            "leftCorner": {
              "x": 11.016,
              "y": 9.727,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.011,
              "y": 9.662,
              "z": 0.205
            },
            "gtin": "8700216287876",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27031f",
            "leftCorner": {
              "x": 11.011,
              "y": 9.662,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.005,
              "y": 9.589,
              "z": 0.205
            },
            "gtin": "4058172926563",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270320",
            "leftCorner": {
              "x": 11.005,
              "y": 9.589,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.001,
              "y": 9.534,
              "z": 0.205
            },
            "gtin": "4010355442093",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270321",
            "leftCorner": {
              "x": 11.001,
              "y": 9.534,
              "z": 0.205
            },
            "rightCorner": {
              "x": 10.996,
              "y": 9.472,
              "z": 0.205
            },
            "gtin": "4058172926471",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270322",
            "leftCorner": {
              "x": 10.996,
              "y": 9.472,
              "z": 0.205
            },
            "rightCorner": {
              "x": 10.991,
              "y": 9.407,
              "z": 0.205
            },
            "gtin": "4058172926709",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270323",
            "leftCorner": {
              "x": 10.991,
              "y": 9.407,
              "z": 0.205
            },
            "rightCorner": {
              "x": 10.986,
              "y": 9.35,
              "z": 0.205
            },
            "gtin": "4010355485779",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270324",
            "leftCorner": {
              "x": 10.986,
              "y": 9.35,
              "z": 0.205
            },
            "rightCorner": {
              "x": 10.978,
              "y": 9.254,
              "z": 0.205
            },
            "gtin": "8006540728437",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270325",
            "leftCorner": {
              "x": 10.978,
              "y": 9.254,
              "z": 0.205
            },
            "rightCorner": {
              "x": 10.972,
              "y": 9.17,
              "z": 0.205
            },
            "gtin": "8006540728468",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73942",
        "height": 0.54934,
        "facings": [
          {
            "id": "696ebf6d43c343680a2702e7",
            "leftCorner": {
              "x": 10.98,
              "y": 9.364,
              "z": 0.549
            },
            "rightCorner": {
              "x": 10.974,
              "y": 9.292,
              "z": 0.549
            },
            "gtin": "4067796170337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702da",
            "leftCorner": {
              "x": 11.051,
              "y": 10.261,
              "z": 0.549
            },
            "rightCorner": {
              "x": 11.044,
              "y": 10.182,
              "z": 0.549
            },
            "gtin": "8700216833875",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702db",
            "leftCorner": {
              "x": 11.045,
              "y": 10.182,
              "z": 0.549
            },
            "rightCorner": {
              "x": 11.039,
              "y": 10.116,
              "z": 0.549
            },
            "gtin": "8700216833974",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702dc",
            "leftCorner": {
              "x": 11.039,
              "y": 10.116,
              "z": 0.549
            },
            "rightCorner": {
              "x": 11.034,
              "y": 10.042,
              "z": 0.549
            },
            "gtin": "8700216833868",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702dd",
            "leftCorner": {
              "x": 11.034,
              "y": 10.042,
              "z": 0.549
            },
            "rightCorner": {
              "x": 11.029,
              "y": 9.989,
              "z": 0.549
            },
            "gtin": "4051281982840",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702de",
            "leftCorner": {
              "x": 11.029,
              "y": 9.989,
              "z": 0.549
            },
            "rightCorner": {
              "x": 11.024,
              "y": 9.919,
              "z": 0.549
            }
          },
          {
            "id": "696ebf6d43c343680a2702df",
            "leftCorner": {
              "x": 11.024,
              "y": 9.919,
              "z": 0.549
            },
            "rightCorner": {
              "x": 11.022,
              "y": 9.894,
              "z": 0.549
            }
          },
          {
            "id": "696ebf6d43c343680a2702e0",
            "leftCorner": {
              "x": 11.022,
              "y": 9.894,
              "z": 0.549
            },
            "rightCorner": {
              "x": 11.014,
              "y": 9.791,
              "z": 0.549
            },
            "gtin": "4051281982741",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702e1",
            "leftCorner": {
              "x": 11.014,
              "y": 9.791,
              "z": 0.549
            },
            "rightCorner": {
              "x": 11.006,
              "y": 9.691,
              "z": 0.549
            },
            "gtin": "4051281982901",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702e2",
            "leftCorner": {
              "x": 11.006,
              "y": 9.691,
              "z": 0.549
            },
            "rightCorner": {
              "x": 11.0,
              "y": 9.623,
              "z": 0.549
            },
            "gtin": "4066447791549",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702e3",
            "leftCorner": {
              "x": 11.0,
              "y": 9.623,
              "z": 0.549
            },
            "rightCorner": {
              "x": 10.995,
              "y": 9.556,
              "z": 0.549
            },
            "gtin": "4066447791532",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702e4",
            "leftCorner": {
              "x": 10.995,
              "y": 9.556,
              "z": 0.549
            },
            "rightCorner": {
              "x": 10.99,
              "y": 9.495,
              "z": 0.549
            },
            "gtin": "4066447879704",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702e5",
            "leftCorner": {
              "x": 10.99,
              "y": 9.495,
              "z": 0.549
            },
            "rightCorner": {
              "x": 10.985,
              "y": 9.43,
              "z": 0.549
            },
            "gtin": "4066447879704",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702e6",
            "leftCorner": {
              "x": 10.985,
              "y": 9.43,
              "z": 0.549
            },
            "rightCorner": {
              "x": 10.98,
              "y": 9.364,
              "z": 0.549
            },
            "gtin": "4066447791563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702e8",
            "leftCorner": {
              "x": 10.974,
              "y": 9.292,
              "z": 0.549
            },
            "rightCorner": {
              "x": 10.968,
              "y": 9.213,
              "z": 0.549
            },
            "gtin": "4066447791785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702e9",
            "leftCorner": {
              "x": 10.968,
              "y": 9.213,
              "z": 0.549
            },
            "rightCorner": {
              "x": 10.962,
              "y": 9.137,
              "z": 0.549
            }
          },
          {
            "id": "696ebf6d43c343680a2702ce",
            "leftCorner": {
              "x": 10.962,
              "y": 9.137,
              "z": 0.549
            },
            "rightCorner": {
              "x": 10.955,
              "y": 9.054,
              "z": 0.549
            },
            "gtin": "4067796170320",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73940",
        "height": 0.76112,
        "facings": [
          {
            "id": "696ebf6e43c343680a270380",
            "leftCorner": {
              "x": 11.06,
              "y": 10.3,
              "z": 0.761
            },
            "rightCorner": {
              "x": 11.052,
              "y": 10.197,
              "z": 0.761
            },
            "gtin": "8700216657143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270381",
            "leftCorner": {
              "x": 11.052,
              "y": 10.197,
              "z": 0.761
            },
            "rightCorner": {
              "x": 11.04,
              "y": 10.055,
              "z": 0.761
            },
            "gtin": "8700216657075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270382",
            "leftCorner": {
              "x": 11.04,
              "y": 10.055,
              "z": 0.761
            },
            "rightCorner": {
              "x": 11.036,
              "y": 10.002,
              "z": 0.761
            },
            "gtin": "8700216731287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270383",
            "leftCorner": {
              "x": 11.036,
              "y": 10.002,
              "z": 0.761
            },
            "rightCorner": {
              "x": 11.031,
              "y": 9.936,
              "z": 0.761
            }
          },
          {
            "id": "696ebf6e43c343680a270384",
            "leftCorner": {
              "x": 11.031,
              "y": 9.936,
              "z": 0.761
            },
            "rightCorner": {
              "x": 11.028,
              "y": 9.906,
              "z": 0.761
            },
            "gtin": "8700216657006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270385",
            "leftCorner": {
              "x": 11.028,
              "y": 9.906,
              "z": 0.761
            },
            "rightCorner": {
              "x": 11.02,
              "y": 9.801,
              "z": 0.761
            },
            "gtin": "8700216657006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270386",
            "leftCorner": {
              "x": 11.02,
              "y": 9.801,
              "z": 0.761
            },
            "rightCorner": {
              "x": 11.016,
              "y": 9.755,
              "z": 0.761
            },
            "gtin": "5000204378870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270387",
            "leftCorner": {
              "x": 11.016,
              "y": 9.755,
              "z": 0.761
            },
            "rightCorner": {
              "x": 11.01,
              "y": 9.667,
              "z": 0.761
            },
            "gtin": "5000204078251",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270388",
            "leftCorner": {
              "x": 11.01,
              "y": 9.667,
              "z": 0.761
            },
            "rightCorner": {
              "x": 11.003,
              "y": 9.584,
              "z": 0.761
            },
            "gtin": "5000204078329",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270389",
            "leftCorner": {
              "x": 11.003,
              "y": 9.584,
              "z": 0.761
            },
            "rightCorner": {
              "x": 10.996,
              "y": 9.499,
              "z": 0.761
            },
            "gtin": "5000204078565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27038a",
            "leftCorner": {
              "x": 10.996,
              "y": 9.499,
              "z": 0.761
            },
            "rightCorner": {
              "x": 10.99,
              "y": 9.419,
              "z": 0.761
            },
            "gtin": "5000204414394",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27038b",
            "leftCorner": {
              "x": 10.99,
              "y": 9.419,
              "z": 0.761
            },
            "rightCorner": {
              "x": 10.985,
              "y": 9.355,
              "z": 0.761
            },
            "gtin": "4010355490193",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27038c",
            "leftCorner": {
              "x": 10.985,
              "y": 9.355,
              "z": 0.761
            },
            "rightCorner": {
              "x": 10.98,
              "y": 9.29,
              "z": 0.761
            },
            "gtin": "4010355490179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27038d",
            "leftCorner": {
              "x": 10.98,
              "y": 9.29,
              "z": 0.761
            },
            "rightCorner": {
              "x": 10.974,
              "y": 9.221,
              "z": 0.761
            },
            "gtin": "4066447875898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27038e",
            "leftCorner": {
              "x": 10.974,
              "y": 9.221,
              "z": 0.761
            },
            "rightCorner": {
              "x": 10.969,
              "y": 9.154,
              "z": 0.761
            },
            "gtin": "4066447043754",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27038f",
            "leftCorner": {
              "x": 10.969,
              "y": 9.154,
              "z": 0.761
            },
            "rightCorner": {
              "x": 10.963,
              "y": 9.078,
              "z": 0.761
            },
            "gtin": "4066447043730",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73944",
        "height": 0.97371,
        "facings": [
          {
            "id": "696ebf6e43c343680a270390",
            "leftCorner": {
              "x": 11.059,
              "y": 10.3,
              "z": 0.974
            },
            "rightCorner": {
              "x": 11.05,
              "y": 10.183,
              "z": 0.974
            },
            "gtin": "8006530059794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270392",
            "leftCorner": {
              "x": 11.05,
              "y": 10.183,
              "z": 0.974
            },
            "rightCorner": {
              "x": 11.041,
              "y": 10.073,
              "z": 0.974
            },
            "gtin": "8001090839190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270393",
            "leftCorner": {
              "x": 11.041,
              "y": 10.073,
              "z": 0.974
            },
            "rightCorner": {
              "x": 11.037,
              "y": 10.019,
              "z": 0.974
            },
            "gtin": "8700216802291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270394",
            "leftCorner": {
              "x": 11.037,
              "y": 10.019,
              "z": 0.974
            },
            "rightCorner": {
              "x": 11.03,
              "y": 9.934,
              "z": 0.974
            }
          },
          {
            "id": "696ebf6e43c343680a270395",
            "leftCorner": {
              "x": 11.03,
              "y": 9.934,
              "z": 0.974
            },
            "rightCorner": {
              "x": 11.028,
              "y": 9.906,
              "z": 0.974
            }
          },
          {
            "id": "696ebf6e43c343680a270396",
            "leftCorner": {
              "x": 11.028,
              "y": 9.906,
              "z": 0.974
            },
            "rightCorner": {
              "x": 11.021,
              "y": 9.819,
              "z": 0.974
            },
            "gtin": "8700216497596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270397",
            "leftCorner": {
              "x": 11.021,
              "y": 9.819,
              "z": 0.974
            },
            "rightCorner": {
              "x": 11.011,
              "y": 9.693,
              "z": 0.974
            },
            "gtin": "8700216538190",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270398",
            "leftCorner": {
              "x": 11.011,
              "y": 9.693,
              "z": 0.974
            },
            "rightCorner": {
              "x": 11.002,
              "y": 9.577,
              "z": 0.974
            },
            "gtin": "8001090839251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270399",
            "leftCorner": {
              "x": 11.002,
              "y": 9.577,
              "z": 0.974
            },
            "rightCorner": {
              "x": 10.994,
              "y": 9.474,
              "z": 0.974
            },
            "gtin": "8006540232040",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27039a",
            "leftCorner": {
              "x": 10.994,
              "y": 9.474,
              "z": 0.974
            },
            "rightCorner": {
              "x": 10.982,
              "y": 9.334,
              "z": 0.974
            },
            "gtin": "8700216802291",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27039b",
            "leftCorner": {
              "x": 10.982,
              "y": 9.334,
              "z": 0.974
            },
            "rightCorner": {
              "x": 10.973,
              "y": 9.21,
              "z": 0.974
            },
            "gtin": "8001090839305",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27039c",
            "leftCorner": {
              "x": 10.973,
              "y": 9.21,
              "z": 0.974
            },
            "rightCorner": {
              "x": 10.965,
              "y": 9.119,
              "z": 0.974
            },
            "gtin": "5000204393873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27039d",
            "leftCorner": {
              "x": 10.965,
              "y": 9.119,
              "z": 0.974
            },
            "rightCorner": {
              "x": 10.961,
              "y": 9.067,
              "z": 0.974
            },
            "gtin": "4066447792102",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73941",
        "height": 1.2275,
        "facings": [
          {
            "id": "696ebf6d43c343680a2702f2",
            "leftCorner": {
              "x": 11.053,
              "y": 10.325,
              "z": 1.23
            },
            "rightCorner": {
              "x": 11.038,
              "y": 10.147,
              "z": 1.23
            },
            "gtin": "4251758433497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702f3",
            "leftCorner": {
              "x": 11.045,
              "y": 10.171,
              "z": 1.227
            },
            "rightCorner": {
              "x": 11.036,
              "y": 10.053,
              "z": 1.227
            },
            "gtin": "4251758433497",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702f4",
            "leftCorner": {
              "x": 11.036,
              "y": 10.053,
              "z": 1.227
            },
            "rightCorner": {
              "x": 11.033,
              "y": 10.014,
              "z": 1.227
            },
            "gtin": "4251758433411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702f5",
            "leftCorner": {
              "x": 11.033,
              "y": 10.014,
              "z": 1.227
            },
            "rightCorner": {
              "x": 11.029,
              "y": 9.969,
              "z": 1.227
            }
          },
          {
            "id": "696ebf6d43c343680a2702f6",
            "leftCorner": {
              "x": 11.029,
              "y": 9.969,
              "z": 1.227
            },
            "rightCorner": {
              "x": 11.022,
              "y": 9.884,
              "z": 1.227
            },
            "gtin": "4251758438041",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702f7",
            "leftCorner": {
              "x": 11.022,
              "y": 9.884,
              "z": 1.227
            },
            "rightCorner": {
              "x": 11.015,
              "y": 9.79,
              "z": 1.227
            },
            "gtin": "4251758438225",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702f8",
            "leftCorner": {
              "x": 11.015,
              "y": 9.79,
              "z": 1.227
            },
            "rightCorner": {
              "x": 11.005,
              "y": 9.668,
              "z": 1.227
            },
            "gtin": "4251758433473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702f9",
            "leftCorner": {
              "x": 11.005,
              "y": 9.668,
              "z": 1.227
            },
            "rightCorner": {
              "x": 10.995,
              "y": 9.544,
              "z": 1.227
            },
            "gtin": "4251758438003",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702fa",
            "leftCorner": {
              "x": 10.995,
              "y": 9.544,
              "z": 1.227
            },
            "rightCorner": {
              "x": 10.99,
              "y": 9.478,
              "z": 1.227
            },
            "gtin": "5000204416077",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702fb",
            "leftCorner": {
              "x": 10.99,
              "y": 9.478,
              "z": 1.227
            },
            "rightCorner": {
              "x": 10.984,
              "y": 9.405,
              "z": 1.227
            },
            "gtin": "5000204332896",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702fc",
            "leftCorner": {
              "x": 10.984,
              "y": 9.405,
              "z": 1.227
            },
            "rightCorner": {
              "x": 10.979,
              "y": 9.335,
              "z": 1.227
            },
            "gtin": "5000204333107",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702fd",
            "leftCorner": {
              "x": 10.979,
              "y": 9.335,
              "z": 1.227
            },
            "rightCorner": {
              "x": 10.973,
              "y": 9.266,
              "z": 1.227
            },
            "gtin": "5000204333015",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702fe",
            "leftCorner": {
              "x": 10.973,
              "y": 9.266,
              "z": 1.227
            },
            "rightCorner": {
              "x": 10.966,
              "y": 9.178,
              "z": 1.227
            },
            "gtin": "5000204332322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702ff",
            "leftCorner": {
              "x": 10.966,
              "y": 9.178,
              "z": 1.227
            },
            "rightCorner": {
              "x": 10.957,
              "y": 9.069,
              "z": 1.227
            },
            "gtin": "5000204402759",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73943",
        "height": 1.4831,
        "facings": [
          {
            "id": "696ebf6e43c343680a270365",
            "leftCorner": {
              "x": 11.044,
              "y": 10.306,
              "z": 1.485
            },
            "rightCorner": {
              "x": 11.031,
              "y": 10.149,
              "z": 1.485
            },
            "gtin": "4251758415455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270366",
            "leftCorner": {
              "x": 11.04,
              "y": 10.173,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.028,
              "y": 10.026,
              "z": 1.483
            },
            "gtin": "4251758415585",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270367",
            "leftCorner": {
              "x": 11.028,
              "y": 10.026,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.024,
              "y": 9.978,
              "z": 1.483
            },
            "gtin": "4251758422507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270368",
            "leftCorner": {
              "x": 11.024,
              "y": 9.978,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.014,
              "y": 9.843,
              "z": 1.483
            },
            "gtin": "4251758422507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270369",
            "leftCorner": {
              "x": 11.014,
              "y": 9.843,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.003,
              "y": 9.714,
              "z": 1.483
            },
            "gtin": "4251758415707",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27036a",
            "leftCorner": {
              "x": 11.003,
              "y": 9.714,
              "z": 1.483
            },
            "rightCorner": {
              "x": 10.982,
              "y": 9.442,
              "z": 1.483
            },
            "gtin": "4251758432551",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27036b",
            "leftCorner": {
              "x": 10.982,
              "y": 9.442,
              "z": 1.483
            },
            "rightCorner": {
              "x": 10.971,
              "y": 9.309,
              "z": 1.483
            },
            "gtin": "4251758432575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27036c",
            "leftCorner": {
              "x": 10.971,
              "y": 9.309,
              "z": 1.483
            },
            "rightCorner": {
              "x": 10.96,
              "y": 9.166,
              "z": 1.483
            },
            "gtin": "4251758432766",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27036d",
            "leftCorner": {
              "x": 10.96,
              "y": 9.166,
              "z": 1.483
            },
            "rightCorner": {
              "x": 10.957,
              "y": 9.129,
              "z": 1.483
            },
            "gtin": "4251758415325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27036e",
            "leftCorner": {
              "x": 10.957,
              "y": 9.118,
              "z": 1.484
            },
            "rightCorner": {
              "x": 10.952,
              "y": 9.054,
              "z": 1.484
            },
            "gtin": "4251758422446",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73945",
        "height": 1.7302,
        "facings": [
          {
            "id": "696ebf6d43c343680a270282",
            "leftCorner": {
              "x": 11.052,
              "y": 10.3,
              "z": 1.73
            },
            "rightCorner": {
              "x": 11.038,
              "y": 10.128,
              "z": 1.73
            },
            "gtin": "4066447016659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270283",
            "leftCorner": {
              "x": 11.038,
              "y": 10.128,
              "z": 1.73
            },
            "rightCorner": {
              "x": 11.03,
              "y": 10.023,
              "z": 1.73
            },
            "gtin": "4066447789997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270284",
            "leftCorner": {
              "x": 11.03,
              "y": 10.023,
              "z": 1.73
            },
            "rightCorner": {
              "x": 11.023,
              "y": 9.938,
              "z": 1.73
            },
            "gtin": "4251758433763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270285",
            "leftCorner": {
              "x": 11.023,
              "y": 9.938,
              "z": 1.73
            },
            "rightCorner": {
              "x": 11.021,
              "y": 9.907,
              "z": 1.73
            }
          },
          {
            "id": "696ebf6d43c343680a270286",
            "leftCorner": {
              "x": 11.021,
              "y": 9.907,
              "z": 1.73
            },
            "rightCorner": {
              "x": 11.013,
              "y": 9.807,
              "z": 1.73
            },
            "gtin": "4251758433763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270287",
            "leftCorner": {
              "x": 11.013,
              "y": 9.807,
              "z": 1.73
            },
            "rightCorner": {
              "x": 11.006,
              "y": 9.722,
              "z": 1.73
            },
            "gtin": "4251758433688",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270288",
            "leftCorner": {
              "x": 11.006,
              "y": 9.722,
              "z": 1.73
            },
            "rightCorner": {
              "x": 10.998,
              "y": 9.625,
              "z": 1.73
            },
            "gtin": "4251758433664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270289",
            "leftCorner": {
              "x": 10.998,
              "y": 9.625,
              "z": 1.73
            },
            "rightCorner": {
              "x": 10.992,
              "y": 9.542,
              "z": 1.73
            },
            "gtin": "4251758422026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27028a",
            "leftCorner": {
              "x": 10.992,
              "y": 9.542,
              "z": 1.73
            },
            "rightCorner": {
              "x": 10.977,
              "y": 9.356,
              "z": 1.73
            }
          },
          {
            "id": "696ebf6d43c343680a27028b",
            "leftCorner": {
              "x": 10.977,
              "y": 9.356,
              "z": 1.73
            },
            "rightCorner": {
              "x": 10.972,
              "y": 9.29,
              "z": 1.73
            },
            "gtin": "4058172926723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27028c",
            "leftCorner": {
              "x": 10.972,
              "y": 9.29,
              "z": 1.73
            },
            "rightCorner": {
              "x": 10.966,
              "y": 9.218,
              "z": 1.73
            },
            "gtin": "4010355483218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27028d",
            "leftCorner": {
              "x": 10.966,
              "y": 9.218,
              "z": 1.73
            },
            "rightCorner": {
              "x": 10.953,
              "y": 9.054,
              "z": 1.73
            },
            "gtin": "4010355486219",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757d2b5fe7bc046959a7e",
    "name": "68e757d2b5fe7bc046959a7e",
    "x": 11.001,
    "y": 9.0398,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73005,
      "w": 0.6834
    },
    "statistics": {
      "hasStockCount": 26,
      "noStockCount": 0,
      "unknownStockCount": 42
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd7394b",
        "height": 0.19948,
        "facings": [
          {
            "id": "696ebf6d43c343680a270326",
            "leftCorner": {
              "x": 10.972,
              "y": 9.17,
              "z": 0.205
            },
            "rightCorner": {
              "x": 10.964,
              "y": 9.076,
              "z": 0.205
            },
            "gtin": "4058172767869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270327",
            "leftCorner": {
              "x": 10.964,
              "y": 9.076,
              "z": 0.205
            },
            "rightCorner": {
              "x": 10.958,
              "y": 8.994,
              "z": 0.205
            },
            "gtin": "4058172767869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270328",
            "leftCorner": {
              "x": 10.951,
              "y": 8.983,
              "z": 0.199
            },
            "rightCorner": {
              "x": 10.945,
              "y": 8.902,
              "z": 0.199
            },
            "gtin": "4058172767869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270329",
            "leftCorner": {
              "x": 10.945,
              "y": 8.902,
              "z": 0.199
            },
            "rightCorner": {
              "x": 10.939,
              "y": 8.809,
              "z": 0.199
            },
            "gtin": "4251758404220",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27032a",
            "leftCorner": {
              "x": 10.939,
              "y": 8.809,
              "z": 0.199
            },
            "rightCorner": {
              "x": 10.931,
              "y": 8.687,
              "z": 0.199
            },
            "gtin": "4066447441963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27032b",
            "leftCorner": {
              "x": 10.931,
              "y": 8.687,
              "z": 0.199
            },
            "rightCorner": {
              "x": 10.921,
              "y": 8.532,
              "z": 0.199
            },
            "gtin": "4010355489166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27032c",
            "leftCorner": {
              "x": 10.921,
              "y": 8.532,
              "z": 0.199
            },
            "rightCorner": {
              "x": 10.887,
              "y": 8.015,
              "z": 0.199
            },
            "gtin": "4010355021540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27032d",
            "leftCorner": {
              "x": 10.887,
              "y": 8.015,
              "z": 0.199
            },
            "rightCorner": {
              "x": 10.878,
              "y": 7.88,
              "z": 0.199
            },
            "gtin": "4010355021526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27032e",
            "leftCorner": {
              "x": 10.878,
              "y": 7.88,
              "z": 0.199
            },
            "rightCorner": {
              "x": 10.873,
              "y": 7.806,
              "z": 0.199
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7394a",
        "height": 0.59428,
        "facings": [
          {
            "id": "696ebf6e43c343680a2703d8",
            "leftCorner": {
              "x": 10.953,
              "y": 9.043,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.948,
              "y": 8.967,
              "z": 0.594
            },
            "gtin": "4008455038919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703d9",
            "leftCorner": {
              "x": 10.948,
              "y": 8.967,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.941,
              "y": 8.86,
              "z": 0.594
            },
            "gtin": "4008455021515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703da",
            "leftCorner": {
              "x": 10.941,
              "y": 8.86,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.932,
              "y": 8.725,
              "z": 0.594
            },
            "gtin": "4008455086811",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703db",
            "leftCorner": {
              "x": 10.932,
              "y": 8.725,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.926,
              "y": 8.634,
              "z": 0.594
            },
            "gtin": "4008455002149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703dc",
            "leftCorner": {
              "x": 10.926,
              "y": 8.634,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.918,
              "y": 8.514,
              "z": 0.594
            },
            "gtin": "4001499961458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703dd",
            "leftCorner": {
              "x": 10.918,
              "y": 8.514,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.915,
              "y": 8.457,
              "z": 0.594
            },
            "gtin": "4058172185700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703de",
            "leftCorner": {
              "x": 10.915,
              "y": 8.457,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.911,
              "y": 8.41,
              "z": 0.594
            },
            "gtin": "4058172185700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703df",
            "leftCorner": {
              "x": 10.911,
              "y": 8.41,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.905,
              "y": 8.306,
              "z": 0.594
            },
            "gtin": "4066447969412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703e0",
            "leftCorner": {
              "x": 10.905,
              "y": 8.306,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.896,
              "y": 8.176,
              "z": 0.594
            },
            "gtin": "4251758407030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703e1",
            "leftCorner": {
              "x": 10.896,
              "y": 8.176,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.886,
              "y": 8.028,
              "z": 0.594
            },
            "gtin": "4015000971881",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703e2",
            "leftCorner": {
              "x": 10.886,
              "y": 8.028,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.878,
              "y": 7.909,
              "z": 0.594
            },
            "gtin": "4015000972062",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703e3",
            "leftCorner": {
              "x": 10.878,
              "y": 7.909,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.872,
              "y": 7.812,
              "z": 0.594
            },
            "gtin": "4008455096216",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73949",
        "height": 0.97651,
        "facings": [
          {
            "id": "696ebf6e43c343680a27039e",
            "leftCorner": {
              "x": 10.958,
              "y": 9.056,
              "z": 0.977
            },
            "rightCorner": {
              "x": 10.954,
              "y": 9.003,
              "z": 0.977
            },
            "gtin": "4008455004075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27039f",
            "leftCorner": {
              "x": 10.955,
              "y": 9.003,
              "z": 0.977
            },
            "rightCorner": {
              "x": 10.952,
              "y": 8.965,
              "z": 0.977
            },
            "gtin": "4008455004266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703a0",
            "leftCorner": {
              "x": 10.952,
              "y": 8.965,
              "z": 0.977
            },
            "rightCorner": {
              "x": 10.94,
              "y": 8.786,
              "z": 0.977
            },
            "gtin": "4008455004129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703a1",
            "leftCorner": {
              "x": 10.94,
              "y": 8.786,
              "z": 0.977
            },
            "rightCorner": {
              "x": 10.936,
              "y": 8.725,
              "z": 0.977
            },
            "gtin": "4008455004037",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703a2",
            "leftCorner": {
              "x": 10.936,
              "y": 8.725,
              "z": 0.977
            },
            "rightCorner": {
              "x": 10.932,
              "y": 8.659,
              "z": 0.977
            },
            "gtin": "4008455004013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703a3",
            "leftCorner": {
              "x": 10.932,
              "y": 8.659,
              "z": 0.977
            },
            "rightCorner": {
              "x": 10.927,
              "y": 8.591,
              "z": 0.977
            },
            "gtin": "4008455004099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703a4",
            "leftCorner": {
              "x": 10.927,
              "y": 8.591,
              "z": 0.977
            },
            "rightCorner": {
              "x": 10.923,
              "y": 8.525,
              "z": 0.977
            },
            "gtin": "4008455004082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703a5",
            "leftCorner": {
              "x": 10.923,
              "y": 8.525,
              "z": 0.977
            },
            "rightCorner": {
              "x": 10.917,
              "y": 8.437,
              "z": 0.977
            },
            "gtin": "4001499926099",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703a6",
            "leftCorner": {
              "x": 10.917,
              "y": 8.437,
              "z": 0.977
            },
            "rightCorner": {
              "x": 10.911,
              "y": 8.346,
              "z": 0.977
            },
            "gtin": "4001499923739",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703a7",
            "leftCorner": {
              "x": 10.911,
              "y": 8.346,
              "z": 0.977
            },
            "rightCorner": {
              "x": 10.9,
              "y": 8.172,
              "z": 0.977
            },
            "gtin": "4001499923746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703a8",
            "leftCorner": {
              "x": 10.9,
              "y": 8.172,
              "z": 0.977
            },
            "rightCorner": {
              "x": 10.889,
              "y": 8.015,
              "z": 0.977
            },
            "gtin": "4013162004027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703a9",
            "leftCorner": {
              "x": 10.889,
              "y": 8.015,
              "z": 0.977
            },
            "rightCorner": {
              "x": 10.879,
              "y": 7.851,
              "z": 0.977
            },
            "gtin": "4015000010511",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703aa",
            "leftCorner": {
              "x": 10.879,
              "y": 7.851,
              "z": 0.977
            },
            "rightCorner": {
              "x": 10.874,
              "y": 7.781,
              "z": 0.977
            },
            "gtin": "4058172348570",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73948",
        "height": 1.23,
        "facings": [
          {
            "id": "696ebf6d43c343680a270300",
            "leftCorner": {
              "x": 10.957,
              "y": 9.069,
              "z": 1.228
            },
            "rightCorner": {
              "x": 10.951,
              "y": 8.987,
              "z": 1.228
            },
            "gtin": "4062196082839",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270301",
            "leftCorner": {
              "x": 10.949,
              "y": 8.976,
              "z": 1.23
            },
            "rightCorner": {
              "x": 10.943,
              "y": 8.88,
              "z": 1.23
            },
            "gtin": "4062196082686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270302",
            "leftCorner": {
              "x": 10.943,
              "y": 8.88,
              "z": 1.23
            },
            "rightCorner": {
              "x": 10.934,
              "y": 8.75,
              "z": 1.23
            },
            "gtin": "4251758406835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270303",
            "leftCorner": {
              "x": 10.934,
              "y": 8.75,
              "z": 1.23
            },
            "rightCorner": {
              "x": 10.928,
              "y": 8.652,
              "z": 1.23
            },
            "gtin": "4251758428882",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270304",
            "leftCorner": {
              "x": 10.928,
              "y": 8.652,
              "z": 1.23
            },
            "rightCorner": {
              "x": 10.92,
              "y": 8.534,
              "z": 1.23
            },
            "gtin": "4251758406897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270305",
            "leftCorner": {
              "x": 10.92,
              "y": 8.534,
              "z": 1.23
            },
            "rightCorner": {
              "x": 10.914,
              "y": 8.439,
              "z": 1.23
            },
            "gtin": "4251758428905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270306",
            "leftCorner": {
              "x": 10.914,
              "y": 8.439,
              "z": 1.23
            },
            "rightCorner": {
              "x": 10.906,
              "y": 8.325,
              "z": 1.23
            },
            "gtin": "4066447294798",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270307",
            "leftCorner": {
              "x": 10.906,
              "y": 8.325,
              "z": 1.23
            },
            "rightCorner": {
              "x": 10.898,
              "y": 8.2,
              "z": 1.23
            },
            "gtin": "4066447294774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270308",
            "leftCorner": {
              "x": 10.898,
              "y": 8.2,
              "z": 1.23
            },
            "rightCorner": {
              "x": 10.894,
              "y": 8.133,
              "z": 1.23
            },
            "gtin": "4066447294774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270309",
            "leftCorner": {
              "x": 10.894,
              "y": 8.133,
              "z": 1.23
            },
            "rightCorner": {
              "x": 10.892,
              "y": 8.105,
              "z": 1.23
            }
          },
          {
            "id": "696ebf6d43c343680a27030a",
            "leftCorner": {
              "x": 10.892,
              "y": 8.105,
              "z": 1.23
            },
            "rightCorner": {
              "x": 10.884,
              "y": 7.991,
              "z": 1.23
            },
            "gtin": "4010355487162",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27030b",
            "leftCorner": {
              "x": 10.884,
              "y": 7.991,
              "z": 1.23
            },
            "rightCorner": {
              "x": 10.877,
              "y": 7.885,
              "z": 1.23
            },
            "gtin": "4052400035126",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702eb",
            "leftCorner": {
              "x": 10.877,
              "y": 7.885,
              "z": 1.23
            },
            "rightCorner": {
              "x": 10.871,
              "y": 7.796,
              "z": 1.23
            },
            "gtin": "4008455004174",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73947",
        "height": 1.4838,
        "facings": [
          {
            "id": "696ebf6e43c343680a27036f",
            "leftCorner": {
              "x": 10.953,
              "y": 9.054,
              "z": 1.484
            },
            "rightCorner": {
              "x": 10.944,
              "y": 8.947,
              "z": 1.484
            },
            "gtin": "4062196346924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270370",
            "leftCorner": {
              "x": 10.946,
              "y": 8.947,
              "z": 1.484
            },
            "rightCorner": {
              "x": 10.937,
              "y": 8.82,
              "z": 1.484
            },
            "gtin": "4008455064611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270371",
            "leftCorner": {
              "x": 10.937,
              "y": 8.82,
              "z": 1.484
            },
            "rightCorner": {
              "x": 10.928,
              "y": 8.672,
              "z": 1.484
            },
            "gtin": "4008455063614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270372",
            "leftCorner": {
              "x": 10.928,
              "y": 8.672,
              "z": 1.484
            },
            "rightCorner": {
              "x": 10.918,
              "y": 8.531,
              "z": 1.484
            },
            "gtin": "4008455061511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270373",
            "leftCorner": {
              "x": 10.918,
              "y": 8.531,
              "z": 1.484
            },
            "rightCorner": {
              "x": 10.914,
              "y": 8.464,
              "z": 1.484
            },
            "gtin": "4008455045412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270374",
            "leftCorner": {
              "x": 10.914,
              "y": 8.464,
              "z": 1.484
            },
            "rightCorner": {
              "x": 10.899,
              "y": 8.238,
              "z": 1.484
            },
            "gtin": "4010355487988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270375",
            "leftCorner": {
              "x": 10.899,
              "y": 8.238,
              "z": 1.484
            },
            "rightCorner": {
              "x": 10.891,
              "y": 8.121,
              "z": 1.484
            },
            "gtin": "4010355487964",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270376",
            "leftCorner": {
              "x": 10.891,
              "y": 8.121,
              "z": 1.484
            },
            "rightCorner": {
              "x": 10.884,
              "y": 8.009,
              "z": 1.484
            },
            "gtin": "4066447218510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270377",
            "leftCorner": {
              "x": 10.884,
              "y": 8.009,
              "z": 1.484
            },
            "rightCorner": {
              "x": 10.876,
              "y": 7.886,
              "z": 1.484
            },
            "gtin": "4058172174728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27035b",
            "leftCorner": {
              "x": 10.876,
              "y": 7.886,
              "z": 1.484
            },
            "rightCorner": {
              "x": 10.87,
              "y": 7.796,
              "z": 1.484
            },
            "gtin": "4013162014392",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7394c",
        "height": 1.732,
        "facings": [
          {
            "id": "696ebf6d43c343680a27028e",
            "leftCorner": {
              "x": 10.951,
              "y": 9.043,
              "z": 1.732
            },
            "rightCorner": {
              "x": 10.948,
              "y": 8.996,
              "z": 1.732
            },
            "gtin": "4058172926600",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27028f",
            "leftCorner": {
              "x": 10.948,
              "y": 8.996,
              "z": 1.732
            },
            "rightCorner": {
              "x": 10.938,
              "y": 8.839,
              "z": 1.732
            },
            "gtin": "4058172926600",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270290",
            "leftCorner": {
              "x": 10.938,
              "y": 8.839,
              "z": 1.732
            },
            "rightCorner": {
              "x": 10.931,
              "y": 8.744,
              "z": 1.732
            },
            "gtin": "4052400018181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270291",
            "leftCorner": {
              "x": 10.931,
              "y": 8.744,
              "z": 1.732
            },
            "rightCorner": {
              "x": 10.927,
              "y": 8.669,
              "z": 1.732
            },
            "gtin": "4052400017184",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270292",
            "leftCorner": {
              "x": 10.927,
              "y": 8.669,
              "z": 1.732
            },
            "rightCorner": {
              "x": 10.922,
              "y": 8.604,
              "z": 1.732
            },
            "gtin": "4052400017085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270293",
            "leftCorner": {
              "x": 10.922,
              "y": 8.604,
              "z": 1.732
            },
            "rightCorner": {
              "x": 10.916,
              "y": 8.517,
              "z": 1.732
            },
            "gtin": "4052400017306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270294",
            "leftCorner": {
              "x": 10.916,
              "y": 8.517,
              "z": 1.732
            },
            "rightCorner": {
              "x": 10.912,
              "y": 8.449,
              "z": 1.732
            }
          },
          {
            "id": "696ebf6d43c343680a270295",
            "leftCorner": {
              "x": 10.912,
              "y": 8.449,
              "z": 1.732
            },
            "rightCorner": {
              "x": 10.906,
              "y": 8.36,
              "z": 1.732
            },
            "gtin": "4062196361552",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270296",
            "leftCorner": {
              "x": 10.906,
              "y": 8.36,
              "z": 1.732
            },
            "rightCorner": {
              "x": 10.9,
              "y": 8.268,
              "z": 1.732
            },
            "gtin": "4002448034605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270297",
            "leftCorner": {
              "x": 10.9,
              "y": 8.268,
              "z": 1.732
            },
            "rightCorner": {
              "x": 10.894,
              "y": 8.176,
              "z": 1.732
            },
            "gtin": "4002448027102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270298",
            "leftCorner": {
              "x": 10.894,
              "y": 8.176,
              "z": 1.732
            },
            "rightCorner": {
              "x": 10.887,
              "y": 8.069,
              "z": 1.732
            },
            "gtin": "4002448034544",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270299",
            "leftCorner": {
              "x": 10.887,
              "y": 8.069,
              "z": 1.732
            },
            "rightCorner": {
              "x": 10.877,
              "y": 7.924,
              "z": 1.732
            },
            "gtin": "4002448034506",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27029a",
            "leftCorner": {
              "x": 10.877,
              "y": 7.924,
              "z": 1.732
            },
            "rightCorner": {
              "x": 10.871,
              "y": 7.828,
              "z": 1.732
            },
            "gtin": "4062196101486",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27029b",
            "leftCorner": {
              "x": 10.871,
              "y": 7.828,
              "z": 1.732
            },
            "rightCorner": {
              "x": 10.867,
              "y": 7.768,
              "z": 1.732
            },
            "gtin": "8700216633727",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757d2b5fe7bc046959a7f",
    "name": "68e757d2b5fe7bc046959a7f",
    "x": 10.908,
    "y": 7.7871,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73443,
      "w": 0.67868
    },
    "statistics": {
      "hasStockCount": 22,
      "noStockCount": 1,
      "unknownStockCount": 37
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd7394d",
        "height": 0.20287,
        "facings": [
          {
            "id": "696ebf6d43c343680a27032f",
            "leftCorner": {
              "x": 10.873,
              "y": 7.806,
              "z": 0.199
            },
            "rightCorner": {
              "x": 10.867,
              "y": 7.72,
              "z": 0.199
            },
            "gtin": "4066447580303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270330",
            "leftCorner": {
              "x": 10.858,
              "y": 7.715,
              "z": 0.203
            },
            "rightCorner": {
              "x": 10.852,
              "y": 7.644,
              "z": 0.203
            },
            "gtin": "4010355489395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270331",
            "leftCorner": {
              "x": 10.852,
              "y": 7.644,
              "z": 0.203
            },
            "rightCorner": {
              "x": 10.843,
              "y": 7.534,
              "z": 0.203
            },
            "gtin": "4100280092019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270332",
            "leftCorner": {
              "x": 10.843,
              "y": 7.534,
              "z": 0.203
            },
            "rightCorner": {
              "x": 10.837,
              "y": 7.448,
              "z": 0.203
            },
            "gtin": "8001480020726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270333",
            "leftCorner": {
              "x": 10.837,
              "y": 7.448,
              "z": 0.203
            },
            "rightCorner": {
              "x": 10.827,
              "y": 7.329,
              "z": 0.203
            },
            "gtin": "8001480020726",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270334",
            "leftCorner": {
              "x": 10.827,
              "y": 7.329,
              "z": 0.203
            },
            "rightCorner": {
              "x": 10.819,
              "y": 7.222,
              "z": 0.203
            },
            "gtin": "4058172215858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270335",
            "leftCorner": {
              "x": 10.819,
              "y": 7.222,
              "z": 0.203
            },
            "rightCorner": {
              "x": 10.813,
              "y": 7.152,
              "z": 0.203
            },
            "gtin": "4066447861297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270336",
            "leftCorner": {
              "x": 10.813,
              "y": 7.152,
              "z": 0.203
            },
            "rightCorner": {
              "x": 10.805,
              "y": 7.047,
              "z": 0.203
            }
          },
          {
            "id": "696ebf6d43c343680a270337",
            "leftCorner": {
              "x": 10.805,
              "y": 7.047,
              "z": 0.203
            },
            "rightCorner": {
              "x": 10.796,
              "y": 6.933,
              "z": 0.203
            },
            "gtin": "4066447790382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270338",
            "leftCorner": {
              "x": 10.796,
              "y": 6.933,
              "z": 0.203
            },
            "rightCorner": {
              "x": 10.785,
              "y": 6.798,
              "z": 0.203
            },
            "gtin": "4066447790382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270339",
            "leftCorner": {
              "x": 10.785,
              "y": 6.798,
              "z": 0.203
            },
            "rightCorner": {
              "x": 10.776,
              "y": 6.685,
              "z": 0.203
            }
          },
          {
            "id": "696ebf6d43c343680a27033a",
            "leftCorner": {
              "x": 10.776,
              "y": 6.685,
              "z": 0.203
            },
            "rightCorner": {
              "x": 10.766,
              "y": 6.548,
              "z": 0.203
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7394e",
        "height": 0.59427,
        "facings": [
          {
            "id": "696ebf6e43c343680a2703e4",
            "leftCorner": {
              "x": 10.872,
              "y": 7.812,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.866,
              "y": 7.718,
              "z": 0.594
            },
            "gtin": "8718951581715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703e5",
            "leftCorner": {
              "x": 10.861,
              "y": 7.713,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.85,
              "y": 7.582,
              "z": 0.594
            },
            "gtin": "8718951581715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703e6",
            "leftCorner": {
              "x": 10.85,
              "y": 7.582,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.842,
              "y": 7.481,
              "z": 0.594
            },
            "gtin": "8718951581869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703e7",
            "leftCorner": {
              "x": 10.842,
              "y": 7.481,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.834,
              "y": 7.379,
              "z": 0.594
            },
            "gtin": "8718951580329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703e8",
            "leftCorner": {
              "x": 10.834,
              "y": 7.379,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.825,
              "y": 7.259,
              "z": 0.594
            },
            "gtin": "8718951580329",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703e9",
            "leftCorner": {
              "x": 10.825,
              "y": 7.259,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.818,
              "y": 7.174,
              "z": 0.594
            },
            "gtin": "4013162035489",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703ea",
            "leftCorner": {
              "x": 10.818,
              "y": 7.174,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.811,
              "y": 7.078,
              "z": 0.594
            },
            "gtin": "4013162035489",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703eb",
            "leftCorner": {
              "x": 10.811,
              "y": 7.078,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.803,
              "y": 6.986,
              "z": 0.594
            },
            "gtin": "4013162035502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703ec",
            "leftCorner": {
              "x": 10.803,
              "y": 6.986,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.795,
              "y": 6.887,
              "z": 0.594
            },
            "gtin": "5412533420166",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703ed",
            "leftCorner": {
              "x": 10.795,
              "y": 6.887,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.788,
              "y": 6.795,
              "z": 0.594
            }
          },
          {
            "id": "696ebf6e43c343680a2703ee",
            "leftCorner": {
              "x": 10.788,
              "y": 6.795,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.777,
              "y": 6.66,
              "z": 0.594
            },
            "gtin": "4001499957536",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703ef",
            "leftCorner": {
              "x": 10.777,
              "y": 6.66,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.768,
              "y": 6.544,
              "z": 0.594
            },
            "gtin": "4001499957536",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73950",
        "height": 0.97648,
        "facings": [
          {
            "id": "696ebf6e43c343680a2703ab",
            "leftCorner": {
              "x": 10.866,
              "y": 7.776,
              "z": 0.976
            },
            "rightCorner": {
              "x": 10.859,
              "y": 7.687,
              "z": 0.976
            },
            "gtin": "4015200033525",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703ac",
            "leftCorner": {
              "x": 10.859,
              "y": 7.687,
              "z": 0.976
            },
            "rightCorner": {
              "x": 10.85,
              "y": 7.58,
              "z": 0.976
            },
            "gtin": "4015200033525",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703ad",
            "leftCorner": {
              "x": 10.85,
              "y": 7.58,
              "z": 0.976
            },
            "rightCorner": {
              "x": 10.843,
              "y": 7.482,
              "z": 0.976
            },
            "gtin": "4015200033600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703ae",
            "leftCorner": {
              "x": 10.843,
              "y": 7.482,
              "z": 0.976
            },
            "rightCorner": {
              "x": 10.835,
              "y": 7.38,
              "z": 0.976
            },
            "gtin": "4015200033600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703af",
            "leftCorner": {
              "x": 10.835,
              "y": 7.38,
              "z": 0.976
            },
            "rightCorner": {
              "x": 10.828,
              "y": 7.297,
              "z": 0.976
            },
            "gtin": "4015200033587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703b0",
            "leftCorner": {
              "x": 10.828,
              "y": 7.297,
              "z": 0.976
            },
            "rightCorner": {
              "x": 10.821,
              "y": 7.205,
              "z": 0.976
            },
            "gtin": "4015200033587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703b1",
            "leftCorner": {
              "x": 10.821,
              "y": 7.205,
              "z": 0.976
            },
            "rightCorner": {
              "x": 10.813,
              "y": 7.107,
              "z": 0.976
            },
            "gtin": "4015200033587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703b2",
            "leftCorner": {
              "x": 10.813,
              "y": 7.107,
              "z": 0.976
            },
            "rightCorner": {
              "x": 10.807,
              "y": 7.026,
              "z": 0.976
            },
            "gtin": "4015200033587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703b3",
            "leftCorner": {
              "x": 10.807,
              "y": 7.026,
              "z": 0.976
            },
            "rightCorner": {
              "x": 10.798,
              "y": 6.921,
              "z": 0.976
            },
            "gtin": "4015200033556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703b4",
            "leftCorner": {
              "x": 10.798,
              "y": 6.921,
              "z": 0.976
            },
            "rightCorner": {
              "x": 10.791,
              "y": 6.823,
              "z": 0.976
            }
          },
          {
            "id": "696ebf6e43c343680a2703b5",
            "leftCorner": {
              "x": 10.791,
              "y": 6.823,
              "z": 0.976
            },
            "rightCorner": {
              "x": 10.783,
              "y": 6.726,
              "z": 0.976
            },
            "gtin": "4015200033563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703b6",
            "leftCorner": {
              "x": 10.783,
              "y": 6.726,
              "z": 0.976
            },
            "rightCorner": {
              "x": 10.775,
              "y": 6.62,
              "z": 0.976
            },
            "gtin": "4015200033563",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703b7",
            "leftCorner": {
              "x": 10.775,
              "y": 6.62,
              "z": 0.976
            },
            "rightCorner": {
              "x": 10.771,
              "y": 6.573,
              "z": 0.976
            },
            "gtin": "4015200033570",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703b8",
            "leftCorner": {
              "x": 10.771,
              "y": 6.573,
              "z": 0.976
            },
            "rightCorner": {
              "x": 10.768,
              "y": 6.532,
              "z": 0.976
            },
            "gtin": "4015200033570",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73951",
        "height": 1.3568,
        "facings": [
          {
            "id": "696ebf6e43c343680a27040a",
            "leftCorner": {
              "x": 10.867,
              "y": 7.79,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.859,
              "y": 7.683,
              "z": 1.357
            },
            "gtin": "8700216695008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27040b",
            "leftCorner": {
              "x": 10.859,
              "y": 7.683,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.851,
              "y": 7.584,
              "z": 1.357
            },
            "gtin": "8700216695008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27040c",
            "leftCorner": {
              "x": 10.851,
              "y": 7.584,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.842,
              "y": 7.468,
              "z": 1.357
            },
            "gtin": "8700216693967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27040d",
            "leftCorner": {
              "x": 10.842,
              "y": 7.468,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.834,
              "y": 7.372,
              "z": 1.357
            },
            "gtin": "8700216693967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27040e",
            "leftCorner": {
              "x": 10.834,
              "y": 7.372,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.828,
              "y": 7.293,
              "z": 1.357
            }
          },
          {
            "id": "696ebf6e43c343680a27040f",
            "leftCorner": {
              "x": 10.828,
              "y": 7.293,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.82,
              "y": 7.19,
              "z": 1.357
            },
            "gtin": "8700216695060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270410",
            "leftCorner": {
              "x": 10.82,
              "y": 7.19,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.814,
              "y": 7.108,
              "z": 1.357
            },
            "gtin": "8700216694513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270411",
            "leftCorner": {
              "x": 10.814,
              "y": 7.108,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.806,
              "y": 7.008,
              "z": 1.357
            },
            "gtin": "8700216694513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270412",
            "leftCorner": {
              "x": 10.806,
              "y": 7.008,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.798,
              "y": 6.912,
              "z": 1.357
            },
            "gtin": "8700216693974",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270413",
            "leftCorner": {
              "x": 10.798,
              "y": 6.912,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.79,
              "y": 6.808,
              "z": 1.357
            },
            "gtin": "8700216693974",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270414",
            "leftCorner": {
              "x": 10.79,
              "y": 6.808,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.782,
              "y": 6.703,
              "z": 1.357
            },
            "gtin": "8700216694162",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270415",
            "leftCorner": {
              "x": 10.782,
              "y": 6.703,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.774,
              "y": 6.61,
              "z": 1.357
            },
            "gtin": "8700216694162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270416",
            "leftCorner": {
              "x": 10.774,
              "y": 6.61,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.767,
              "y": 6.516,
              "z": 1.357
            },
            "gtin": "8700216694230",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7394f",
        "height": 1.7334,
        "facings": [
          {
            "id": "696ebf6d43c343680a27029c",
            "leftCorner": {
              "x": 10.86,
              "y": 7.763,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.854,
              "y": 7.695,
              "z": 1.733
            },
            "gtin": "8700216633642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27029d",
            "leftCorner": {
              "x": 10.854,
              "y": 7.695,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.847,
              "y": 7.607,
              "z": 1.733
            },
            "gtin": "8700216633703",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27029e",
            "leftCorner": {
              "x": 10.847,
              "y": 7.607,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.843,
              "y": 7.553,
              "z": 1.733
            },
            "gtin": "8700216634038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27029f",
            "leftCorner": {
              "x": 10.843,
              "y": 7.553,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.836,
              "y": 7.466,
              "z": 1.733
            },
            "gtin": "8700216633574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702a0",
            "leftCorner": {
              "x": 10.836,
              "y": 7.466,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.831,
              "y": 7.398,
              "z": 1.733
            },
            "gtin": "8700216633994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702a1",
            "leftCorner": {
              "x": 10.831,
              "y": 7.398,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.826,
              "y": 7.33,
              "z": 1.733
            },
            "gtin": "8700216633802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702a2",
            "leftCorner": {
              "x": 10.826,
              "y": 7.33,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.82,
              "y": 7.26,
              "z": 1.733
            },
            "gtin": "8700216634090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702a3",
            "leftCorner": {
              "x": 10.82,
              "y": 7.26,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.814,
              "y": 7.183,
              "z": 1.733
            },
            "gtin": "8700216633581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702a4",
            "leftCorner": {
              "x": 10.814,
              "y": 7.183,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.809,
              "y": 7.122,
              "z": 1.733
            },
            "gtin": "8700216633543",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702a5",
            "leftCorner": {
              "x": 10.809,
              "y": 7.122,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.803,
              "y": 7.043,
              "z": 1.733
            },
            "gtin": "4066447887297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702a6",
            "leftCorner": {
              "x": 10.803,
              "y": 7.043,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.797,
              "y": 6.974,
              "z": 1.733
            },
            "gtin": "4066447792195",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702a7",
            "leftCorner": {
              "x": 10.797,
              "y": 6.974,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.79,
              "y": 6.875,
              "z": 1.733
            },
            "gtin": "4066447792195",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702a8",
            "leftCorner": {
              "x": 10.79,
              "y": 6.875,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.782,
              "y": 6.783,
              "z": 1.733
            },
            "gtin": "4066447862898",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702a9",
            "leftCorner": {
              "x": 10.782,
              "y": 6.783,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.774,
              "y": 6.679,
              "z": 1.733
            },
            "gtin": "4066447236187",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702aa",
            "leftCorner": {
              "x": 10.774,
              "y": 6.679,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.767,
              "y": 6.585,
              "z": 1.733
            },
            "gtin": "4066447236187",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757d2b5fe7bc046959a80",
    "name": "68e757d2b5fe7bc046959a80",
    "x": 10.808,
    "y": 6.5317,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73087,
      "w": 0.68252
    },
    "statistics": {
      "hasStockCount": 24,
      "noStockCount": 1,
      "unknownStockCount": 11
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73955",
        "height": 0.20184,
        "facings": [
          {
            "id": "696ebf6d43c343680a27033b",
            "leftCorner": {
              "x": 10.766,
              "y": 6.548,
              "z": 0.203
            },
            "rightCorner": {
              "x": 10.757,
              "y": 6.437,
              "z": 0.203
            },
            "gtin": "4066447790399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27033c",
            "leftCorner": {
              "x": 10.757,
              "y": 6.428,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.746,
              "y": 6.275,
              "z": 0.202
            }
          },
          {
            "id": "696ebf6d43c343680a27033d",
            "leftCorner": {
              "x": 10.746,
              "y": 6.275,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.735,
              "y": 6.105,
              "z": 0.202
            },
            "gtin": "4251758404503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27033e",
            "leftCorner": {
              "x": 10.735,
              "y": 6.105,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.725,
              "y": 5.961,
              "z": 0.202
            },
            "gtin": "4251758404503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27033f",
            "leftCorner": {
              "x": 10.725,
              "y": 5.961,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.71,
              "y": 5.737,
              "z": 0.202
            },
            "gtin": "4058172755385",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270340",
            "leftCorner": {
              "x": 10.71,
              "y": 5.737,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.696,
              "y": 5.541,
              "z": 0.202
            },
            "gtin": "4058172755385",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270341",
            "leftCorner": {
              "x": 10.696,
              "y": 5.541,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.684,
              "y": 5.357,
              "z": 0.202
            },
            "gtin": "4058172755408",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73956",
        "height": 0.593,
        "facings": [
          {
            "id": "696ebf6e43c343680a2703f0",
            "leftCorner": {
              "x": 10.768,
              "y": 6.544,
              "z": 0.594
            },
            "rightCorner": {
              "x": 10.76,
              "y": 6.441,
              "z": 0.594
            },
            "gtin": "4001499915215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703f1",
            "leftCorner": {
              "x": 10.758,
              "y": 6.431,
              "z": 0.593
            },
            "rightCorner": {
              "x": 10.749,
              "y": 6.298,
              "z": 0.593
            }
          },
          {
            "id": "696ebf6e43c343680a2703f2",
            "leftCorner": {
              "x": 10.749,
              "y": 6.298,
              "z": 0.593
            },
            "rightCorner": {
              "x": 10.739,
              "y": 6.158,
              "z": 0.593
            }
          },
          {
            "id": "696ebf6e43c343680a2703f3",
            "leftCorner": {
              "x": 10.739,
              "y": 6.158,
              "z": 0.593
            },
            "rightCorner": {
              "x": 10.719,
              "y": 5.862,
              "z": 0.593
            },
            "gtin": "4067796180145",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703f4",
            "leftCorner": {
              "x": 10.719,
              "y": 5.862,
              "z": 0.593
            },
            "rightCorner": {
              "x": 10.7,
              "y": 5.584,
              "z": 0.593
            },
            "gtin": "4058172180613",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703f5",
            "leftCorner": {
              "x": 10.7,
              "y": 5.584,
              "z": 0.593
            },
            "rightCorner": {
              "x": 10.687,
              "y": 5.391,
              "z": 0.593
            },
            "gtin": "4066447888355",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73952",
        "height": 0.97497,
        "facings": [
          {
            "id": "696ebf6e43c343680a2703b9",
            "leftCorner": {
              "x": 10.767,
              "y": 6.522,
              "z": 0.975
            },
            "rightCorner": {
              "x": 10.758,
              "y": 6.394,
              "z": 0.975
            }
          },
          {
            "id": "696ebf6e43c343680a2703ba",
            "leftCorner": {
              "x": 10.758,
              "y": 6.394,
              "z": 0.975
            },
            "rightCorner": {
              "x": 10.75,
              "y": 6.272,
              "z": 0.975
            },
            "gtin": "4008455100517",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703bb",
            "leftCorner": {
              "x": 10.75,
              "y": 6.272,
              "z": 0.975
            },
            "rightCorner": {
              "x": 10.733,
              "y": 6.03,
              "z": 0.975
            },
            "gtin": "4008455095615",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703bc",
            "leftCorner": {
              "x": 10.733,
              "y": 6.03,
              "z": 0.975
            },
            "rightCorner": {
              "x": 10.72,
              "y": 5.84,
              "z": 0.975
            },
            "gtin": "4008455095714",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703bd",
            "leftCorner": {
              "x": 10.72,
              "y": 5.84,
              "z": 0.975
            },
            "rightCorner": {
              "x": 10.71,
              "y": 5.695,
              "z": 0.975
            },
            "gtin": "5412533424065",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703be",
            "leftCorner": {
              "x": 10.71,
              "y": 5.695,
              "z": 0.975
            },
            "rightCorner": {
              "x": 10.701,
              "y": 5.557,
              "z": 0.975
            },
            "gtin": "4262365714091",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703bf",
            "leftCorner": {
              "x": 10.701,
              "y": 5.557,
              "z": 0.975
            },
            "rightCorner": {
              "x": 10.692,
              "y": 5.424,
              "z": 0.975
            },
            "gtin": "4262365714091",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703c0",
            "leftCorner": {
              "x": 10.692,
              "y": 5.424,
              "z": 0.975
            },
            "rightCorner": {
              "x": 10.68,
              "y": 5.25,
              "z": 0.975
            },
            "gtin": "4262365714107",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73954",
        "height": 1.3579,
        "facings": [
          {
            "id": "696ebf6e43c343680a270417",
            "leftCorner": {
              "x": 10.764,
              "y": 6.506,
              "z": 1.358
            },
            "rightCorner": {
              "x": 10.756,
              "y": 6.393,
              "z": 1.358
            },
            "gtin": "8700216694742",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270418",
            "leftCorner": {
              "x": 10.756,
              "y": 6.393,
              "z": 1.358
            },
            "rightCorner": {
              "x": 10.747,
              "y": 6.258,
              "z": 1.358
            },
            "gtin": "8700216929899",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270419",
            "leftCorner": {
              "x": 10.747,
              "y": 6.258,
              "z": 1.358
            },
            "rightCorner": {
              "x": 10.743,
              "y": 6.203,
              "z": 1.358
            },
            "gtin": "8700216929899",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27041a",
            "leftCorner": {
              "x": 10.743,
              "y": 6.203,
              "z": 1.358
            },
            "rightCorner": {
              "x": 10.736,
              "y": 6.09,
              "z": 1.358
            },
            "gtin": "8700216929868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27041b",
            "leftCorner": {
              "x": 10.736,
              "y": 6.09,
              "z": 1.358
            },
            "rightCorner": {
              "x": 10.722,
              "y": 5.897,
              "z": 1.358
            },
            "gtin": "4015200036779",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27041c",
            "leftCorner": {
              "x": 10.722,
              "y": 5.897,
              "z": 1.358
            },
            "rightCorner": {
              "x": 10.712,
              "y": 5.738,
              "z": 1.358
            },
            "gtin": "4015200036793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27041d",
            "leftCorner": {
              "x": 10.712,
              "y": 5.738,
              "z": 1.358
            },
            "rightCorner": {
              "x": 10.699,
              "y": 5.551,
              "z": 1.358
            },
            "gtin": "4015200035253",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27041e",
            "leftCorner": {
              "x": 10.699,
              "y": 5.551,
              "z": 1.358
            },
            "rightCorner": {
              "x": 10.686,
              "y": 5.372,
              "z": 1.358
            },
            "gtin": "4015200035260",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27041f",
            "leftCorner": {
              "x": 10.686,
              "y": 5.372,
              "z": 1.358
            },
            "rightCorner": {
              "x": 10.676,
              "y": 5.218,
              "z": 1.358
            },
            "gtin": "4015200035031",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73953",
        "height": 1.7344,
        "facings": [
          {
            "id": "696ebf6d43c343680a2702ab",
            "leftCorner": {
              "x": 10.767,
              "y": 6.585,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.759,
              "y": 6.486,
              "z": 1.733
            },
            "gtin": "8001090747723",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702ac",
            "leftCorner": {
              "x": 10.76,
              "y": 6.476,
              "z": 1.734
            },
            "rightCorner": {
              "x": 10.746,
              "y": 6.281,
              "z": 1.734
            },
            "gtin": "4058172348754",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702ad",
            "leftCorner": {
              "x": 10.746,
              "y": 6.281,
              "z": 1.734
            },
            "rightCorner": {
              "x": 10.736,
              "y": 6.137,
              "z": 1.734
            },
            "gtin": "4001499939891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702ae",
            "leftCorner": {
              "x": 10.736,
              "y": 6.137,
              "z": 1.734
            },
            "rightCorner": {
              "x": 10.729,
              "y": 6.033,
              "z": 1.734
            },
            "gtin": "4008455047614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702af",
            "leftCorner": {
              "x": 10.729,
              "y": 6.033,
              "z": 1.734
            },
            "rightCorner": {
              "x": 10.722,
              "y": 5.93,
              "z": 1.734
            },
            "gtin": "4008455064413",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702b0",
            "leftCorner": {
              "x": 10.722,
              "y": 5.93,
              "z": 1.734
            },
            "rightCorner": {
              "x": 10.717,
              "y": 5.853,
              "z": 1.734
            },
            "gtin": "4067796167177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702b1",
            "leftCorner": {
              "x": 10.717,
              "y": 5.853,
              "z": 1.734
            },
            "rightCorner": {
              "x": 10.702,
              "y": 5.64,
              "z": 1.734
            },
            "gtin": "4066447184280",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702b2",
            "leftCorner": {
              "x": 10.702,
              "y": 5.64,
              "z": 1.734
            },
            "rightCorner": {
              "x": 10.694,
              "y": 5.514,
              "z": 1.734
            },
            "gtin": "4066447789409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702b3",
            "leftCorner": {
              "x": 10.694,
              "y": 5.514,
              "z": 1.734
            },
            "rightCorner": {
              "x": 10.685,
              "y": 5.388,
              "z": 1.734
            },
            "gtin": "4058172185526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702b4",
            "leftCorner": {
              "x": 10.685,
              "y": 5.388,
              "z": 1.734
            },
            "rightCorner": {
              "x": 10.677,
              "y": 5.27,
              "z": 1.734
            },
            "gtin": "4251758410481",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757d2b5fe7bc046959a81",
    "name": "68e757d2b5fe7bc046959a81",
    "x": 10.732,
    "y": 5.2828,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73785,
      "w": 0.67497
    },
    "statistics": {
      "hasStockCount": 11,
      "noStockCount": 1,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73c41",
        "height": 0.20162,
        "facings": [
          {
            "id": "696ebf6d43c343680a270342",
            "leftCorner": {
              "x": 10.684,
              "y": 5.357,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.671,
              "y": 5.17,
              "z": 0.202
            },
            "gtin": "4015200035895",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270343",
            "leftCorner": {
              "x": 10.677,
              "y": 5.169,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.659,
              "y": 4.965,
              "z": 0.202
            },
            "gtin": "4015200035901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270344",
            "leftCorner": {
              "x": 10.659,
              "y": 4.965,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.645,
              "y": 4.81,
              "z": 0.202
            },
            "gtin": "4015200035864",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270345",
            "leftCorner": {
              "x": 10.645,
              "y": 4.81,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.632,
              "y": 4.665,
              "z": 0.202
            },
            "gtin": "4015200035857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270346",
            "leftCorner": {
              "x": 10.632,
              "y": 4.665,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.618,
              "y": 4.506,
              "z": 0.202
            },
            "gtin": "4015200035857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270347",
            "leftCorner": {
              "x": 10.618,
              "y": 4.506,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.605,
              "y": 4.361,
              "z": 0.202
            },
            "gtin": "4015200035871",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a270348",
            "leftCorner": {
              "x": 10.605,
              "y": 4.361,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.591,
              "y": 4.208,
              "z": 0.202
            }
          },
          {
            "id": "696ebf6d43c343680a270349",
            "leftCorner": {
              "x": 10.591,
              "y": 4.208,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.58,
              "y": 4.084,
              "z": 0.202
            },
            "gtin": "4066447791228",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c40",
        "height": 0.58844,
        "facings": [
          {
            "id": "696ebf6e43c343680a2703f6",
            "leftCorner": {
              "x": 10.687,
              "y": 5.392,
              "z": 0.593
            },
            "rightCorner": {
              "x": 10.666,
              "y": 5.094,
              "z": 0.593
            },
            "gtin": "4058172585777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703f7",
            "leftCorner": {
              "x": 10.667,
              "y": 5.094,
              "z": 0.588
            },
            "rightCorner": {
              "x": 10.645,
              "y": 4.846,
              "z": 0.588
            },
            "gtin": "4067796180169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703f8",
            "leftCorner": {
              "x": 10.645,
              "y": 4.846,
              "z": 0.588
            },
            "rightCorner": {
              "x": 10.642,
              "y": 4.821,
              "z": 0.588
            }
          },
          {
            "id": "696ebf6e43c343680a2703f9",
            "leftCorner": {
              "x": 10.642,
              "y": 4.821,
              "z": 0.588
            },
            "rightCorner": {
              "x": 10.633,
              "y": 4.72,
              "z": 0.588
            },
            "gtin": "4066447791495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703fa",
            "leftCorner": {
              "x": 10.633,
              "y": 4.72,
              "z": 0.588
            },
            "rightCorner": {
              "x": 10.619,
              "y": 4.562,
              "z": 0.588
            },
            "gtin": "4066447328820",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703fb",
            "leftCorner": {
              "x": 10.619,
              "y": 4.562,
              "z": 0.588
            },
            "rightCorner": {
              "x": 10.607,
              "y": 4.426,
              "z": 0.588
            },
            "gtin": "4066447328820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703fc",
            "leftCorner": {
              "x": 10.607,
              "y": 4.426,
              "z": 0.588
            },
            "rightCorner": {
              "x": 10.596,
              "y": 4.299,
              "z": 0.588
            }
          },
          {
            "id": "696ebf6e43c343680a2703fd",
            "leftCorner": {
              "x": 10.596,
              "y": 4.299,
              "z": 0.588
            },
            "rightCorner": {
              "x": 10.592,
              "y": 4.253,
              "z": 0.588
            },
            "gtin": "4066447791235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703fe",
            "leftCorner": {
              "x": 10.592,
              "y": 4.253,
              "z": 0.588
            },
            "rightCorner": {
              "x": 10.584,
              "y": 4.168,
              "z": 0.588
            }
          },
          {
            "id": "696ebf6e43c343680a2703ff",
            "leftCorner": {
              "x": 10.584,
              "y": 4.168,
              "z": 0.588
            },
            "rightCorner": {
              "x": 10.572,
              "y": 4.033,
              "z": 0.588
            },
            "gtin": "4058172216190",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c3f",
        "height": 0.97092,
        "facings": [
          {
            "id": "696ebf6e43c343680a2703c2",
            "leftCorner": {
              "x": 10.667,
              "y": 5.068,
              "z": 0.971
            },
            "rightCorner": {
              "x": 10.653,
              "y": 4.911,
              "z": 0.971
            },
            "gtin": "8700216707664",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703c1",
            "leftCorner": {
              "x": 10.683,
              "y": 5.249,
              "z": 0.971
            },
            "rightCorner": {
              "x": 10.667,
              "y": 5.068,
              "z": 0.971
            },
            "gtin": "8700216707664",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703c3",
            "leftCorner": {
              "x": 10.653,
              "y": 4.911,
              "z": 0.971
            },
            "rightCorner": {
              "x": 10.639,
              "y": 4.755,
              "z": 0.971
            },
            "gtin": "4001499969508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703c4",
            "leftCorner": {
              "x": 10.639,
              "y": 4.755,
              "z": 0.971
            },
            "rightCorner": {
              "x": 10.625,
              "y": 4.59,
              "z": 0.971
            },
            "gtin": "4001499969515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703c5",
            "leftCorner": {
              "x": 10.625,
              "y": 4.59,
              "z": 0.971
            },
            "rightCorner": {
              "x": 10.612,
              "y": 4.447,
              "z": 0.971
            },
            "gtin": "4001499969522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703c6",
            "leftCorner": {
              "x": 10.612,
              "y": 4.447,
              "z": 0.971
            },
            "rightCorner": {
              "x": 10.595,
              "y": 4.252,
              "z": 0.971
            },
            "gtin": "4001499969539",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703c7",
            "leftCorner": {
              "x": 10.595,
              "y": 4.252,
              "z": 0.971
            },
            "rightCorner": {
              "x": 10.591,
              "y": 4.218,
              "z": 0.971
            }
          },
          {
            "id": "696ebf6e43c343680a2703c8",
            "leftCorner": {
              "x": 10.591,
              "y": 4.218,
              "z": 0.971
            },
            "rightCorner": {
              "x": 10.575,
              "y": 4.036,
              "z": 0.971
            }
          },
          {
            "id": "696ebf6e43c343680a2703c9",
            "leftCorner": {
              "x": 10.575,
              "y": 4.036,
              "z": 0.971
            },
            "rightCorner": {
              "x": 10.557,
              "y": 3.827,
              "z": 0.971
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c43",
        "height": 1.3508,
        "facings": [
          {
            "id": "696ebf6e43c343680a270420",
            "leftCorner": {
              "x": 10.679,
              "y": 5.218,
              "z": 1.351
            },
            "rightCorner": {
              "x": 10.663,
              "y": 5.038,
              "z": 1.351
            },
            "gtin": "4015200033457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270421",
            "leftCorner": {
              "x": 10.663,
              "y": 5.038,
              "z": 1.351
            },
            "rightCorner": {
              "x": 10.651,
              "y": 4.9,
              "z": 1.351
            },
            "gtin": "4015200035185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270422",
            "leftCorner": {
              "x": 10.651,
              "y": 4.9,
              "z": 1.351
            },
            "rightCorner": {
              "x": 10.635,
              "y": 4.722,
              "z": 1.351
            },
            "gtin": "8700216702447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270423",
            "leftCorner": {
              "x": 10.635,
              "y": 4.722,
              "z": 1.351
            },
            "rightCorner": {
              "x": 10.629,
              "y": 4.659,
              "z": 1.351
            },
            "gtin": "8700216702638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270424",
            "leftCorner": {
              "x": 10.629,
              "y": 4.659,
              "z": 1.351
            },
            "rightCorner": {
              "x": 10.617,
              "y": 4.516,
              "z": 1.351
            },
            "gtin": "8700216702638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270425",
            "leftCorner": {
              "x": 10.617,
              "y": 4.516,
              "z": 1.351
            },
            "rightCorner": {
              "x": 10.602,
              "y": 4.355,
              "z": 1.351
            },
            "gtin": "8700216678384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270426",
            "leftCorner": {
              "x": 10.602,
              "y": 4.355,
              "z": 1.351
            },
            "rightCorner": {
              "x": 10.586,
              "y": 4.168,
              "z": 1.351
            },
            "gtin": "8700216650809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270427",
            "leftCorner": {
              "x": 10.586,
              "y": 4.168,
              "z": 1.351
            },
            "rightCorner": {
              "x": 10.577,
              "y": 4.065,
              "z": 1.351
            }
          },
          {
            "id": "696ebf6e43c343680a270428",
            "leftCorner": {
              "x": 10.577,
              "y": 4.065,
              "z": 1.351
            },
            "rightCorner": {
              "x": 10.572,
              "y": 4.012,
              "z": 1.351
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c42",
        "height": 1.7267,
        "facings": [
          {
            "id": "696ebf6d43c343680a2702b5",
            "leftCorner": {
              "x": 10.679,
              "y": 5.27,
              "z": 1.727
            },
            "rightCorner": {
              "x": 10.661,
              "y": 5.065,
              "z": 1.727
            },
            "gtin": "4251758410153",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702b6",
            "leftCorner": {
              "x": 10.661,
              "y": 5.065,
              "z": 1.727
            },
            "rightCorner": {
              "x": 10.645,
              "y": 4.884,
              "z": 1.727
            },
            "gtin": "4251758411068",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702b7",
            "leftCorner": {
              "x": 10.645,
              "y": 4.884,
              "z": 1.727
            },
            "rightCorner": {
              "x": 10.628,
              "y": 4.696,
              "z": 1.727
            },
            "gtin": "4251758424051",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702b8",
            "leftCorner": {
              "x": 10.628,
              "y": 4.696,
              "z": 1.727
            },
            "rightCorner": {
              "x": 10.62,
              "y": 4.613,
              "z": 1.727
            },
            "gtin": "9120001468782",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702b9",
            "leftCorner": {
              "x": 10.62,
              "y": 4.613,
              "z": 1.727
            },
            "rightCorner": {
              "x": 10.61,
              "y": 4.498,
              "z": 1.727
            },
            "gtin": "4008455105819",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702ba",
            "leftCorner": {
              "x": 10.61,
              "y": 4.498,
              "z": 1.727
            },
            "rightCorner": {
              "x": 10.593,
              "y": 4.301,
              "z": 1.727
            },
            "gtin": "4015200033631",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702bb",
            "leftCorner": {
              "x": 10.593,
              "y": 4.301,
              "z": 1.727
            },
            "rightCorner": {
              "x": 10.574,
              "y": 4.093,
              "z": 1.727
            },
            "gtin": "4015200033631",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757d2b5fe7bc046959a82",
    "name": "68e757d2b5fe7bc046959a82",
    "x": 10.628,
    "y": 4.0329,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72624,
      "w": 0.68744
    },
    "statistics": {
      "hasStockCount": 12,
      "noStockCount": 0,
      "unknownStockCount": 24
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73c45",
        "height": 0.20178,
        "facings": [
          {
            "id": "696ebf6d43c343680a27034a",
            "leftCorner": {
              "x": 10.58,
              "y": 4.084,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.567,
              "y": 3.938,
              "z": 0.202
            },
            "gtin": "4067796213034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27034b",
            "leftCorner": {
              "x": 10.577,
              "y": 3.932,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.57,
              "y": 3.805,
              "z": 0.202
            },
            "gtin": "4067796213034",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a27034c",
            "leftCorner": {
              "x": 10.57,
              "y": 3.805,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.562,
              "y": 3.663,
              "z": 0.202
            },
            "gtin": "4067796213034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a27034d",
            "leftCorner": {
              "x": 10.562,
              "y": 3.663,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.554,
              "y": 3.517,
              "z": 0.202
            },
            "gtin": "4067796213034",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27034e",
            "leftCorner": {
              "x": 10.554,
              "y": 3.517,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.547,
              "y": 3.384,
              "z": 0.202
            },
            "gtin": "4067796213034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27034f",
            "leftCorner": {
              "x": 10.547,
              "y": 3.384,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.54,
              "y": 3.254,
              "z": 0.202
            },
            "gtin": "4058172216299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270350",
            "leftCorner": {
              "x": 10.54,
              "y": 3.254,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.532,
              "y": 3.113,
              "z": 0.202
            },
            "gtin": "4058172216299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270351",
            "leftCorner": {
              "x": 10.532,
              "y": 3.113,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.523,
              "y": 2.952,
              "z": 0.202
            }
          },
          {
            "id": "696ebf6e43c343680a270352",
            "leftCorner": {
              "x": 10.523,
              "y": 2.952,
              "z": 0.202
            },
            "rightCorner": {
              "x": 10.515,
              "y": 2.796,
              "z": 0.202
            },
            "gtin": "4058172755361",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c46",
        "height": 0.5871,
        "facings": [
          {
            "id": "696ebf6e43c343680a270400",
            "leftCorner": {
              "x": 10.579,
              "y": 4.026,
              "z": 0.587
            },
            "rightCorner": {
              "x": 10.577,
              "y": 3.994,
              "z": 0.587
            }
          },
          {
            "id": "696ebf6e43c343680a270401",
            "leftCorner": {
              "x": 10.577,
              "y": 3.994,
              "z": 0.587
            },
            "rightCorner": {
              "x": 10.572,
              "y": 3.907,
              "z": 0.587
            }
          },
          {
            "id": "696ebf6e43c343680a270402",
            "leftCorner": {
              "x": 10.572,
              "y": 3.907,
              "z": 0.587
            },
            "rightCorner": {
              "x": 10.57,
              "y": 3.868,
              "z": 0.587
            }
          },
          {
            "id": "696ebf6e43c343680a270403",
            "leftCorner": {
              "x": 10.57,
              "y": 3.868,
              "z": 0.587
            },
            "rightCorner": {
              "x": 10.565,
              "y": 3.775,
              "z": 0.587
            }
          },
          {
            "id": "696ebf6e43c343680a270404",
            "leftCorner": {
              "x": 10.565,
              "y": 3.775,
              "z": 0.587
            },
            "rightCorner": {
              "x": 10.557,
              "y": 3.633,
              "z": 0.587
            },
            "gtin": "4067796176261",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270405",
            "leftCorner": {
              "x": 10.557,
              "y": 3.633,
              "z": 0.587
            },
            "rightCorner": {
              "x": 10.55,
              "y": 3.503,
              "z": 0.587
            }
          },
          {
            "id": "696ebf6e43c343680a270406",
            "leftCorner": {
              "x": 10.55,
              "y": 3.503,
              "z": 0.587
            },
            "rightCorner": {
              "x": 10.543,
              "y": 3.376,
              "z": 0.587
            },
            "gtin": "4067796176247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270407",
            "leftCorner": {
              "x": 10.543,
              "y": 3.376,
              "z": 0.587
            },
            "rightCorner": {
              "x": 10.525,
              "y": 3.045,
              "z": 0.587
            },
            "gtin": "4066447161076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270408",
            "leftCorner": {
              "x": 10.525,
              "y": 3.045,
              "z": 0.587
            },
            "rightCorner": {
              "x": 10.518,
              "y": 2.922,
              "z": 0.587
            }
          },
          {
            "id": "696ebf6e43c343680a270409",
            "leftCorner": {
              "x": 10.518,
              "y": 2.922,
              "z": 0.587
            },
            "rightCorner": {
              "x": 10.511,
              "y": 2.792,
              "z": 0.587
            }
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c48",
        "height": 0.96948,
        "facings": [
          {
            "id": "696ebf6e43c343680a2703ca",
            "leftCorner": {
              "x": 10.567,
              "y": 3.821,
              "z": 0.969
            },
            "rightCorner": {
              "x": 10.56,
              "y": 3.689,
              "z": 0.969
            },
            "gtin": "4001499969423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703cb",
            "leftCorner": {
              "x": 10.56,
              "y": 3.689,
              "z": 0.969
            },
            "rightCorner": {
              "x": 10.551,
              "y": 3.526,
              "z": 0.969
            },
            "gtin": "4001499969423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703cc",
            "leftCorner": {
              "x": 10.551,
              "y": 3.526,
              "z": 0.969
            },
            "rightCorner": {
              "x": 10.543,
              "y": 3.382,
              "z": 0.969
            },
            "gtin": "4001499969423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703cd",
            "leftCorner": {
              "x": 10.543,
              "y": 3.382,
              "z": 0.969
            },
            "rightCorner": {
              "x": 10.535,
              "y": 3.237,
              "z": 0.969
            },
            "gtin": "4001499969409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703ce",
            "leftCorner": {
              "x": 10.535,
              "y": 3.237,
              "z": 0.969
            },
            "rightCorner": {
              "x": 10.526,
              "y": 3.076,
              "z": 0.969
            },
            "gtin": "4001499969416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2703cf",
            "leftCorner": {
              "x": 10.526,
              "y": 3.076,
              "z": 0.969
            },
            "rightCorner": {
              "x": 10.517,
              "y": 2.914,
              "z": 0.969
            },
            "gtin": "4001499969416",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703d0",
            "leftCorner": {
              "x": 10.517,
              "y": 2.914,
              "z": 0.969
            },
            "rightCorner": {
              "x": 10.51,
              "y": 2.788,
              "z": 0.969
            },
            "gtin": "4001499969485",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c44",
        "height": 1.3494,
        "facings": [
          {
            "id": "696ebf6e43c343680a270429",
            "leftCorner": {
              "x": 10.58,
              "y": 4.005,
              "z": 1.349
            },
            "rightCorner": {
              "x": 10.574,
              "y": 3.901,
              "z": 1.349
            },
            "gtin": "8700216650816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27042a",
            "leftCorner": {
              "x": 10.574,
              "y": 3.901,
              "z": 1.349
            },
            "rightCorner": {
              "x": 10.568,
              "y": 3.792,
              "z": 1.349
            },
            "gtin": "8700216678445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27042b",
            "leftCorner": {
              "x": 10.568,
              "y": 3.792,
              "z": 1.349
            },
            "rightCorner": {
              "x": 10.562,
              "y": 3.683,
              "z": 1.349
            },
            "gtin": "4066447710854",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27042c",
            "leftCorner": {
              "x": 10.562,
              "y": 3.683,
              "z": 1.349
            },
            "rightCorner": {
              "x": 10.557,
              "y": 3.59,
              "z": 1.349
            },
            "gtin": "4066447710854",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27042d",
            "leftCorner": {
              "x": 10.557,
              "y": 3.59,
              "z": 1.349
            },
            "rightCorner": {
              "x": 10.549,
              "y": 3.45,
              "z": 1.349
            },
            "gtin": "4066447710878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27042e",
            "leftCorner": {
              "x": 10.549,
              "y": 3.45,
              "z": 1.349
            },
            "rightCorner": {
              "x": 10.542,
              "y": 3.322,
              "z": 1.349
            },
            "gtin": "5412533420128",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27042f",
            "leftCorner": {
              "x": 10.542,
              "y": 3.322,
              "z": 1.349
            },
            "rightCorner": {
              "x": 10.536,
              "y": 3.205,
              "z": 1.349
            },
            "gtin": "5412533424553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270430",
            "leftCorner": {
              "x": 10.536,
              "y": 3.205,
              "z": 1.349
            },
            "rightCorner": {
              "x": 10.529,
              "y": 3.08,
              "z": 1.349
            },
            "gtin": "5412533424584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270431",
            "leftCorner": {
              "x": 10.529,
              "y": 3.08,
              "z": 1.349
            },
            "rightCorner": {
              "x": 10.522,
              "y": 2.959,
              "z": 1.349
            },
            "gtin": "5412533428049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270432",
            "leftCorner": {
              "x": 10.522,
              "y": 2.959,
              "z": 1.349
            },
            "rightCorner": {
              "x": 10.519,
              "y": 2.904,
              "z": 1.349
            },
            "gtin": "4262500781490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270433",
            "leftCorner": {
              "x": 10.519,
              "y": 2.904,
              "z": 1.349
            },
            "rightCorner": {
              "x": 10.513,
              "y": 2.797,
              "z": 1.349
            },
            "gtin": "4262500781773",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c47",
        "height": 1.7266,
        "facings": [
          {
            "id": "696ebf6d43c343680a2702bc",
            "leftCorner": {
              "x": 10.574,
              "y": 4.093,
              "z": 1.727
            },
            "rightCorner": {
              "x": 10.561,
              "y": 3.947,
              "z": 1.727
            },
            "gtin": "4015200033662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702bd",
            "leftCorner": {
              "x": 10.572,
              "y": 3.94,
              "z": 1.727
            },
            "rightCorner": {
              "x": 10.566,
              "y": 3.829,
              "z": 1.727
            }
          },
          {
            "id": "696ebf6d43c343680a2702be",
            "leftCorner": {
              "x": 10.566,
              "y": 3.829,
              "z": 1.727
            },
            "rightCorner": {
              "x": 10.564,
              "y": 3.799,
              "z": 1.727
            }
          },
          {
            "id": "696ebf6d43c343680a2702bf",
            "leftCorner": {
              "x": 10.564,
              "y": 3.799,
              "z": 1.727
            },
            "rightCorner": {
              "x": 10.557,
              "y": 3.659,
              "z": 1.727
            },
            "gtin": "4015200033709",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702c0",
            "leftCorner": {
              "x": 10.557,
              "y": 3.659,
              "z": 1.727
            },
            "rightCorner": {
              "x": 10.549,
              "y": 3.515,
              "z": 1.727
            },
            "gtin": "4015200033709",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702c1",
            "leftCorner": {
              "x": 10.549,
              "y": 3.515,
              "z": 1.727
            },
            "rightCorner": {
              "x": 10.541,
              "y": 3.374,
              "z": 1.727
            },
            "gtin": "4015200033679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702c2",
            "leftCorner": {
              "x": 10.541,
              "y": 3.374,
              "z": 1.727
            },
            "rightCorner": {
              "x": 10.534,
              "y": 3.244,
              "z": 1.727
            },
            "gtin": "4015200033679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702c3",
            "leftCorner": {
              "x": 10.534,
              "y": 3.244,
              "z": 1.727
            },
            "rightCorner": {
              "x": 10.527,
              "y": 3.117,
              "z": 1.727
            },
            "gtin": "4015200033679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702c4",
            "leftCorner": {
              "x": 10.527,
              "y": 3.117,
              "z": 1.727
            },
            "rightCorner": {
              "x": 10.518,
              "y": 2.95,
              "z": 1.727
            }
          },
          {
            "id": "696ebf6d43c343680a2702c5",
            "leftCorner": {
              "x": 10.518,
              "y": 2.95,
              "z": 1.727
            },
            "rightCorner": {
              "x": 10.509,
              "y": 2.799,
              "z": 1.727
            },
            "gtin": "4015200033723",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757d2b5fe7bc046959a83",
    "name": "68e757d2b5fe7bc046959a83",
    "x": 10.54,
    "y": 2.7749,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73279,
      "w": 0.68045
    },
    "statistics": {
      "hasStockCount": 16,
      "noStockCount": 3,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd7395b",
        "height": 0.20663,
        "facings": [
          {
            "id": "696ebf6e43c343680a270353",
            "leftCorner": {
              "x": 10.496,
              "y": 2.787,
              "z": 0.207
            },
            "rightCorner": {
              "x": 10.487,
              "y": 2.668,
              "z": 0.207
            },
            "gtin": "4058172755347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270354",
            "leftCorner": {
              "x": 10.487,
              "y": 2.668,
              "z": 0.207
            },
            "rightCorner": {
              "x": 10.478,
              "y": 2.546,
              "z": 0.207
            },
            "gtin": "4058172755347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270355",
            "leftCorner": {
              "x": 10.478,
              "y": 2.546,
              "z": 0.207
            },
            "rightCorner": {
              "x": 10.457,
              "y": 2.269,
              "z": 0.207
            },
            "gtin": "4015200034904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270356",
            "leftCorner": {
              "x": 10.457,
              "y": 2.269,
              "z": 0.207
            },
            "rightCorner": {
              "x": 10.445,
              "y": 2.103,
              "z": 0.207
            },
            "gtin": "4015200035109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270357",
            "leftCorner": {
              "x": 10.445,
              "y": 2.103,
              "z": 0.207
            },
            "rightCorner": {
              "x": 10.431,
              "y": 1.917,
              "z": 0.207
            },
            "gtin": "4015200032207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270358",
            "leftCorner": {
              "x": 10.431,
              "y": 1.917,
              "z": 0.207
            },
            "rightCorner": {
              "x": 10.418,
              "y": 1.739,
              "z": 0.207
            },
            "gtin": "8700216570435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270359",
            "leftCorner": {
              "x": 10.418,
              "y": 1.739,
              "z": 0.207
            },
            "rightCorner": {
              "x": 10.405,
              "y": 1.565,
              "z": 0.207
            },
            "gtin": "8700216569873",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73957",
        "height": 0.59779,
        "facings": [
          {
            "id": "696ebf6e43c343680a27043e",
            "leftCorner": {
              "x": 10.496,
              "y": 2.778,
              "z": 0.598
            },
            "rightCorner": {
              "x": 10.487,
              "y": 2.653,
              "z": 0.598
            },
            "gtin": "4066447503371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27043f",
            "leftCorner": {
              "x": 10.487,
              "y": 2.653,
              "z": 0.598
            },
            "rightCorner": {
              "x": 10.483,
              "y": 2.597,
              "z": 0.598
            },
            "gtin": "4066447343564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270440",
            "leftCorner": {
              "x": 10.483,
              "y": 2.597,
              "z": 0.598
            },
            "rightCorner": {
              "x": 10.476,
              "y": 2.513,
              "z": 0.598
            },
            "gtin": "4001499933301",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270441",
            "leftCorner": {
              "x": 10.476,
              "y": 2.513,
              "z": 0.598
            },
            "rightCorner": {
              "x": 10.467,
              "y": 2.384,
              "z": 0.598
            },
            "gtin": "4001499959844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270442",
            "leftCorner": {
              "x": 10.467,
              "y": 2.384,
              "z": 0.598
            },
            "rightCorner": {
              "x": 10.456,
              "y": 2.235,
              "z": 0.598
            },
            "gtin": "4015200036182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270443",
            "leftCorner": {
              "x": 10.456,
              "y": 2.235,
              "z": 0.598
            },
            "rightCorner": {
              "x": 10.446,
              "y": 2.104,
              "z": 0.598
            },
            "gtin": "4015200036182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270444",
            "leftCorner": {
              "x": 10.446,
              "y": 2.104,
              "z": 0.598
            },
            "rightCorner": {
              "x": 10.436,
              "y": 1.961,
              "z": 0.598
            },
            "gtin": "4015200036090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270445",
            "leftCorner": {
              "x": 10.436,
              "y": 1.961,
              "z": 0.598
            },
            "rightCorner": {
              "x": 10.425,
              "y": 1.823,
              "z": 0.598
            },
            "gtin": "4015200035819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270446",
            "leftCorner": {
              "x": 10.425,
              "y": 1.823,
              "z": 0.598
            },
            "rightCorner": {
              "x": 10.415,
              "y": 1.678,
              "z": 0.598
            },
            "gtin": "4015200036106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270447",
            "leftCorner": {
              "x": 10.415,
              "y": 1.678,
              "z": 0.598
            },
            "rightCorner": {
              "x": 10.405,
              "y": 1.554,
              "z": 0.598
            },
            "gtin": "4015200035802",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7395a",
        "height": 0.97904,
        "facings": [
          {
            "id": "696ebf6e43c343680a2703d1",
            "leftCorner": {
              "x": 10.498,
              "y": 2.779,
              "z": 0.979
            },
            "rightCorner": {
              "x": 10.482,
              "y": 2.556,
              "z": 0.979
            },
            "gtin": "4001499969393",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703d2",
            "leftCorner": {
              "x": 10.482,
              "y": 2.556,
              "z": 0.979
            },
            "rightCorner": {
              "x": 10.47,
              "y": 2.403,
              "z": 0.979
            },
            "gtin": "4001499966651",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703d3",
            "leftCorner": {
              "x": 10.47,
              "y": 2.403,
              "z": 0.979
            },
            "rightCorner": {
              "x": 10.461,
              "y": 2.272,
              "z": 0.979
            },
            "gtin": "4001499960208",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703d4",
            "leftCorner": {
              "x": 10.461,
              "y": 2.272,
              "z": 0.979
            },
            "rightCorner": {
              "x": 10.449,
              "y": 2.121,
              "z": 0.979
            },
            "gtin": "4001499960208",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703d5",
            "leftCorner": {
              "x": 10.449,
              "y": 2.121,
              "z": 0.979
            },
            "rightCorner": {
              "x": 10.439,
              "y": 1.982,
              "z": 0.979
            },
            "gtin": "8700216665872",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703d6",
            "leftCorner": {
              "x": 10.439,
              "y": 1.982,
              "z": 0.979
            },
            "rightCorner": {
              "x": 10.428,
              "y": 1.836,
              "z": 0.979
            },
            "gtin": "8700216665520",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2703d7",
            "leftCorner": {
              "x": 10.428,
              "y": 1.836,
              "z": 0.979
            },
            "rightCorner": {
              "x": 10.417,
              "y": 1.691,
              "z": 0.979
            },
            "gtin": "8700216665520",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270391",
            "leftCorner": {
              "x": 10.417,
              "y": 1.691,
              "z": 0.979
            },
            "rightCorner": {
              "x": 10.406,
              "y": 1.531,
              "z": 0.979
            },
            "gtin": "8700216665445",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73959",
        "height": 1.3573,
        "facings": [
          {
            "id": "696ebf6e43c343680a270434",
            "leftCorner": {
              "x": 10.513,
              "y": 2.797,
              "z": 1.349
            },
            "rightCorner": {
              "x": 10.51,
              "y": 2.73,
              "z": 1.349
            },
            "gtin": "4262500780400",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270435",
            "leftCorner": {
              "x": 10.492,
              "y": 2.721,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.485,
              "y": 2.628,
              "z": 1.357
            },
            "gtin": "8720181688478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270436",
            "leftCorner": {
              "x": 10.485,
              "y": 2.628,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.477,
              "y": 2.525,
              "z": 1.357
            },
            "gtin": "8720181688454",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270437",
            "leftCorner": {
              "x": 10.477,
              "y": 2.525,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.468,
              "y": 2.409,
              "z": 1.357
            },
            "gtin": "9005835314897",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270438",
            "leftCorner": {
              "x": 10.468,
              "y": 2.409,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.46,
              "y": 2.297,
              "z": 1.357
            },
            "gtin": "9005835314910",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270439",
            "leftCorner": {
              "x": 10.46,
              "y": 2.297,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.449,
              "y": 2.146,
              "z": 1.357
            },
            "gtin": "8700216570022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27043a",
            "leftCorner": {
              "x": 10.449,
              "y": 2.146,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.438,
              "y": 1.999,
              "z": 1.357
            },
            "gtin": "8700216570251",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27043b",
            "leftCorner": {
              "x": 10.438,
              "y": 1.999,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.426,
              "y": 1.843,
              "z": 1.357
            },
            "gtin": "4015200035345",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27043c",
            "leftCorner": {
              "x": 10.426,
              "y": 1.843,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.416,
              "y": 1.696,
              "z": 1.357
            },
            "gtin": "4015200035147",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27043d",
            "leftCorner": {
              "x": 10.416,
              "y": 1.696,
              "z": 1.357
            },
            "rightCorner": {
              "x": 10.404,
              "y": 1.538,
              "z": 1.357
            },
            "gtin": "4015200035116",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73958",
        "height": 1.7335,
        "facings": [
          {
            "id": "696ebf6d43c343680a2702c6",
            "leftCorner": {
              "x": 10.509,
              "y": 2.799,
              "z": 1.727
            },
            "rightCorner": {
              "x": 10.501,
              "y": 2.645,
              "z": 1.727
            },
            "gtin": "4015200035192",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6d43c343680a2702c7",
            "leftCorner": {
              "x": 10.479,
              "y": 2.636,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.469,
              "y": 2.511,
              "z": 1.733
            },
            "gtin": "4015200035192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702c8",
            "leftCorner": {
              "x": 10.469,
              "y": 2.511,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.457,
              "y": 2.34,
              "z": 1.733
            }
          },
          {
            "id": "696ebf6d43c343680a2702c9",
            "leftCorner": {
              "x": 10.457,
              "y": 2.34,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.443,
              "y": 2.155,
              "z": 1.733
            }
          },
          {
            "id": "696ebf6d43c343680a2702ca",
            "leftCorner": {
              "x": 10.443,
              "y": 2.155,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.432,
              "y": 2.007,
              "z": 1.733
            },
            "gtin": "4015200033778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702cb",
            "leftCorner": {
              "x": 10.432,
              "y": 2.007,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.421,
              "y": 1.854,
              "z": 1.733
            },
            "gtin": "4015200033778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a2702cc",
            "leftCorner": {
              "x": 10.421,
              "y": 1.854,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.409,
              "y": 1.699,
              "z": 1.733
            },
            "gtin": "8720181327063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6d43c343680a270275",
            "leftCorner": {
              "x": 10.409,
              "y": 1.699,
              "z": 1.733
            },
            "rightCorner": {
              "x": 10.397,
              "y": 1.532,
              "z": 1.733
            },
            "gtin": "8720181327063",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757d2b5fe7bc046959a84",
    "name": "68e757d2b5fe7bc046959a84",
    "x": 12.032,
    "y": 1.3576,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.67463,
      "w": 0.73815
    },
    "statistics": {
      "hasStockCount": 57,
      "noStockCount": 0,
      "unknownStockCount": 21
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd7395f",
        "height": 0.2007,
        "facings": [
          {
            "id": "696ebf6e43c343680a2704c1",
            "leftCorner": {
              "x": 12.076,
              "y": 1.354,
              "z": 0.201
            },
            "rightCorner": {
              "x": 12.086,
              "y": 1.473,
              "z": 0.201
            },
            "gtin": "4062700439029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704c3",
            "leftCorner": {
              "x": 12.086,
              "y": 1.473,
              "z": 0.201
            },
            "rightCorner": {
              "x": 12.091,
              "y": 1.526,
              "z": 0.201
            },
            "gtin": "4062700439043",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704c4",
            "leftCorner": {
              "x": 12.091,
              "y": 1.526,
              "z": 0.201
            },
            "rightCorner": {
              "x": 12.1,
              "y": 1.623,
              "z": 0.201
            },
            "gtin": "4058172573668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704c5",
            "leftCorner": {
              "x": 12.1,
              "y": 1.623,
              "z": 0.201
            },
            "rightCorner": {
              "x": 12.116,
              "y": 1.801,
              "z": 0.201
            },
            "gtin": "4066447397987",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704c6",
            "leftCorner": {
              "x": 12.116,
              "y": 1.801,
              "z": 0.201
            },
            "rightCorner": {
              "x": 12.121,
              "y": 1.863,
              "z": 0.201
            },
            "gtin": "4051281978485",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704c7",
            "leftCorner": {
              "x": 12.121,
              "y": 1.863,
              "z": 0.201
            },
            "rightCorner": {
              "x": 12.13,
              "y": 1.962,
              "z": 0.201
            },
            "gtin": "4058172743610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704c8",
            "leftCorner": {
              "x": 12.13,
              "y": 1.962,
              "z": 0.201
            },
            "rightCorner": {
              "x": 12.14,
              "y": 2.068,
              "z": 0.201
            },
            "gtin": "4066447725513",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704c9",
            "leftCorner": {
              "x": 12.14,
              "y": 2.068,
              "z": 0.201
            },
            "rightCorner": {
              "x": 12.146,
              "y": 2.131,
              "z": 0.201
            },
            "gtin": "4067796178524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704ca",
            "leftCorner": {
              "x": 12.146,
              "y": 2.131,
              "z": 0.201
            },
            "rightCorner": {
              "x": 12.153,
              "y": 2.216,
              "z": 0.201
            },
            "gtin": "4066447668230",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704cb",
            "leftCorner": {
              "x": 12.153,
              "y": 2.216,
              "z": 0.201
            },
            "rightCorner": {
              "x": 12.161,
              "y": 2.301,
              "z": 0.201
            },
            "gtin": "4066447707182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704cc",
            "leftCorner": {
              "x": 12.161,
              "y": 2.301,
              "z": 0.201
            },
            "rightCorner": {
              "x": 12.168,
              "y": 2.384,
              "z": 0.201
            },
            "gtin": "4066447784305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704cd",
            "leftCorner": {
              "x": 12.168,
              "y": 2.384,
              "z": 0.201
            },
            "rightCorner": {
              "x": 12.177,
              "y": 2.484,
              "z": 0.201
            },
            "gtin": "4066447874204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704ce",
            "leftCorner": {
              "x": 12.177,
              "y": 2.484,
              "z": 0.201
            },
            "rightCorner": {
              "x": 12.188,
              "y": 2.599,
              "z": 0.201
            },
            "gtin": "4067796150049",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73961",
        "height": 0.51069,
        "facings": [
          {
            "id": "696ebf6e43c343680a2704fc",
            "leftCorner": {
              "x": 12.076,
              "y": 1.354,
              "z": 0.511
            },
            "rightCorner": {
              "x": 12.083,
              "y": 1.432,
              "z": 0.511
            },
            "gtin": "5000204343571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704fe",
            "leftCorner": {
              "x": 12.083,
              "y": 1.432,
              "z": 0.511
            },
            "rightCorner": {
              "x": 12.094,
              "y": 1.545,
              "z": 0.511
            },
            "gtin": "5000204343571",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704ff",
            "leftCorner": {
              "x": 12.094,
              "y": 1.545,
              "z": 0.511
            },
            "rightCorner": {
              "x": 12.101,
              "y": 1.629,
              "z": 0.511
            },
            "gtin": "4027600753408",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270500",
            "leftCorner": {
              "x": 12.101,
              "y": 1.629,
              "z": 0.511
            },
            "rightCorner": {
              "x": 12.11,
              "y": 1.73,
              "z": 0.511
            },
            "gtin": "4058172893810",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270501",
            "leftCorner": {
              "x": 12.11,
              "y": 1.73,
              "z": 0.511
            },
            "rightCorner": {
              "x": 12.118,
              "y": 1.818,
              "z": 0.511
            },
            "gtin": "4058172893797",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270502",
            "leftCorner": {
              "x": 12.118,
              "y": 1.818,
              "z": 0.511
            },
            "rightCorner": {
              "x": 12.13,
              "y": 1.951,
              "z": 0.511
            },
            "gtin": "4058172573729",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270503",
            "leftCorner": {
              "x": 12.13,
              "y": 1.951,
              "z": 0.511
            },
            "rightCorner": {
              "x": 12.139,
              "y": 2.05,
              "z": 0.511
            },
            "gtin": "4067796149890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270504",
            "leftCorner": {
              "x": 12.139,
              "y": 2.05,
              "z": 0.511
            },
            "rightCorner": {
              "x": 12.148,
              "y": 2.148,
              "z": 0.511
            },
            "gtin": "4067796149913",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270505",
            "leftCorner": {
              "x": 12.148,
              "y": 2.148,
              "z": 0.511
            },
            "rightCorner": {
              "x": 12.157,
              "y": 2.244,
              "z": 0.511
            },
            "gtin": "4062700437216",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270506",
            "leftCorner": {
              "x": 12.157,
              "y": 2.244,
              "z": 0.511
            },
            "rightCorner": {
              "x": 12.164,
              "y": 2.323,
              "z": 0.511
            },
            "gtin": "4067796084900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270507",
            "leftCorner": {
              "x": 12.164,
              "y": 2.323,
              "z": 0.511
            },
            "rightCorner": {
              "x": 12.171,
              "y": 2.405,
              "z": 0.511
            },
            "gtin": "4062700673942",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270508",
            "leftCorner": {
              "x": 12.171,
              "y": 2.405,
              "z": 0.511
            },
            "rightCorner": {
              "x": 12.18,
              "y": 2.51,
              "z": 0.511
            },
            "gtin": "4066447677188",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704fd",
            "leftCorner": {
              "x": 12.18,
              "y": 2.51,
              "z": 0.511
            },
            "rightCorner": {
              "x": 12.188,
              "y": 2.599,
              "z": 0.511
            },
            "gtin": "4066447677188",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73960",
        "height": 0.80235,
        "facings": [
          {
            "id": "696ebf6e43c343680a2704ef",
            "leftCorner": {
              "x": 12.074,
              "y": 1.354,
              "z": 0.802
            },
            "rightCorner": {
              "x": 12.079,
              "y": 1.403,
              "z": 0.802
            },
            "gtin": "5000204343540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704f1",
            "leftCorner": {
              "x": 12.079,
              "y": 1.403,
              "z": 0.802
            },
            "rightCorner": {
              "x": 12.084,
              "y": 1.461,
              "z": 0.802
            },
            "gtin": "5000204343540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704f2",
            "leftCorner": {
              "x": 12.084,
              "y": 1.461,
              "z": 0.802
            },
            "rightCorner": {
              "x": 12.089,
              "y": 1.517,
              "z": 0.802
            },
            "gtin": "5000204203158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704f3",
            "leftCorner": {
              "x": 12.089,
              "y": 1.517,
              "z": 0.802
            },
            "rightCorner": {
              "x": 12.099,
              "y": 1.624,
              "z": 0.802
            },
            "gtin": "5000204373004",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704f4",
            "leftCorner": {
              "x": 12.099,
              "y": 1.624,
              "z": 0.802
            },
            "rightCorner": {
              "x": 12.107,
              "y": 1.711,
              "z": 0.802
            },
            "gtin": "5000204331998",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704f5",
            "leftCorner": {
              "x": 12.107,
              "y": 1.711,
              "z": 0.802
            },
            "rightCorner": {
              "x": 12.117,
              "y": 1.827,
              "z": 0.802
            },
            "gtin": "5000204206210",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704f6",
            "leftCorner": {
              "x": 12.117,
              "y": 1.827,
              "z": 0.802
            },
            "rightCorner": {
              "x": 12.128,
              "y": 1.947,
              "z": 0.802
            },
            "gtin": "5000204206180",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704f7",
            "leftCorner": {
              "x": 12.128,
              "y": 1.947,
              "z": 0.802
            },
            "rightCorner": {
              "x": 12.14,
              "y": 2.087,
              "z": 0.802
            },
            "gtin": "4067796083293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704f8",
            "leftCorner": {
              "x": 12.14,
              "y": 2.087,
              "z": 0.802
            },
            "rightCorner": {
              "x": 12.149,
              "y": 2.183,
              "z": 0.802
            },
            "gtin": "4010355492524",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704f9",
            "leftCorner": {
              "x": 12.149,
              "y": 2.183,
              "z": 0.802
            },
            "rightCorner": {
              "x": 12.157,
              "y": 2.273,
              "z": 0.802
            },
            "gtin": "4058172573682",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704fa",
            "leftCorner": {
              "x": 12.157,
              "y": 2.273,
              "z": 0.802
            },
            "rightCorner": {
              "x": 12.163,
              "y": 2.338,
              "z": 0.802
            },
            "gtin": "4067796158502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704fb",
            "leftCorner": {
              "x": 12.163,
              "y": 2.338,
              "z": 0.802
            },
            "rightCorner": {
              "x": 12.176,
              "y": 2.48,
              "z": 0.802
            },
            "gtin": "4067796065909",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704f0",
            "leftCorner": {
              "x": 12.176,
              "y": 2.48,
              "z": 0.802
            },
            "rightCorner": {
              "x": 12.187,
              "y": 2.599,
              "z": 0.802
            },
            "gtin": "4067796084924",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7395e",
        "height": 1.1447,
        "facings": [
          {
            "id": "696ebf6e43c343680a2704b3",
            "leftCorner": {
              "x": 12.075,
              "y": 1.354,
              "z": 1.145
            },
            "rightCorner": {
              "x": 12.085,
              "y": 1.462,
              "z": 1.145
            },
            "gtin": "4010355870384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704b5",
            "leftCorner": {
              "x": 12.085,
              "y": 1.462,
              "z": 1.145
            },
            "rightCorner": {
              "x": 12.09,
              "y": 1.517,
              "z": 1.145
            },
            "gtin": "742042736133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704b6",
            "leftCorner": {
              "x": 12.09,
              "y": 1.517,
              "z": 1.145
            },
            "rightCorner": {
              "x": 12.095,
              "y": 1.572,
              "z": 1.145
            },
            "gtin": "742042735334",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704b7",
            "leftCorner": {
              "x": 12.095,
              "y": 1.572,
              "z": 1.145
            },
            "rightCorner": {
              "x": 12.101,
              "y": 1.647,
              "z": 1.145
            },
            "gtin": "742042735334",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704b8",
            "leftCorner": {
              "x": 12.101,
              "y": 1.647,
              "z": 1.145
            },
            "rightCorner": {
              "x": 12.108,
              "y": 1.721,
              "z": 1.145
            },
            "gtin": "4067796084887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704b9",
            "leftCorner": {
              "x": 12.108,
              "y": 1.721,
              "z": 1.145
            },
            "rightCorner": {
              "x": 12.116,
              "y": 1.805,
              "z": 1.145
            },
            "gtin": "4067796084825",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704ba",
            "leftCorner": {
              "x": 12.116,
              "y": 1.805,
              "z": 1.145
            },
            "rightCorner": {
              "x": 12.124,
              "y": 1.896,
              "z": 1.145
            },
            "gtin": "4062700835036",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704bb",
            "leftCorner": {
              "x": 12.124,
              "y": 1.896,
              "z": 1.145
            },
            "rightCorner": {
              "x": 12.131,
              "y": 1.981,
              "z": 1.145
            },
            "gtin": "4062700839300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704bc",
            "leftCorner": {
              "x": 12.131,
              "y": 1.981,
              "z": 1.145
            },
            "rightCorner": {
              "x": 12.141,
              "y": 2.083,
              "z": 1.145
            },
            "gtin": "40276908",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704bd",
            "leftCorner": {
              "x": 12.141,
              "y": 2.083,
              "z": 1.145
            },
            "rightCorner": {
              "x": 12.151,
              "y": 2.199,
              "z": 1.145
            },
            "gtin": "4027600764718",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704be",
            "leftCorner": {
              "x": 12.151,
              "y": 2.199,
              "z": 1.145
            },
            "rightCorner": {
              "x": 12.159,
              "y": 2.288,
              "z": 1.145
            },
            "gtin": "4027600224717",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704bf",
            "leftCorner": {
              "x": 12.159,
              "y": 2.288,
              "z": 1.145
            },
            "rightCorner": {
              "x": 12.17,
              "y": 2.406,
              "z": 1.145
            },
            "gtin": "4027600204719",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704c0",
            "leftCorner": {
              "x": 12.17,
              "y": 2.406,
              "z": 1.145
            },
            "rightCorner": {
              "x": 12.179,
              "y": 2.511,
              "z": 1.145
            },
            "gtin": "4066447397383",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704b4",
            "leftCorner": {
              "x": 12.179,
              "y": 2.511,
              "z": 1.145
            },
            "rightCorner": {
              "x": 12.187,
              "y": 2.599,
              "z": 1.145
            },
            "gtin": "4062700836590",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7395d",
        "height": 1.484,
        "facings": [
          {
            "id": "696ebf6e43c343680a270493",
            "leftCorner": {
              "x": 12.076,
              "y": 1.354,
              "z": 1.484
            },
            "rightCorner": {
              "x": 12.088,
              "y": 1.487,
              "z": 1.484
            }
          },
          {
            "id": "696ebf6e43c343680a270495",
            "leftCorner": {
              "x": 12.088,
              "y": 1.487,
              "z": 1.484
            },
            "rightCorner": {
              "x": 12.096,
              "y": 1.57,
              "z": 1.484
            },
            "gtin": "4062700238103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270496",
            "leftCorner": {
              "x": 12.096,
              "y": 1.57,
              "z": 1.484
            },
            "rightCorner": {
              "x": 12.104,
              "y": 1.667,
              "z": 1.484
            },
            "gtin": "4027600494516",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270497",
            "leftCorner": {
              "x": 12.104,
              "y": 1.667,
              "z": 1.484
            },
            "rightCorner": {
              "x": 12.113,
              "y": 1.766,
              "z": 1.484
            },
            "gtin": "4027600234402",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270498",
            "leftCorner": {
              "x": 12.113,
              "y": 1.766,
              "z": 1.484
            },
            "rightCorner": {
              "x": 12.122,
              "y": 1.865,
              "z": 1.484
            },
            "gtin": "4027600514511",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270499",
            "leftCorner": {
              "x": 12.122,
              "y": 1.865,
              "z": 1.484
            },
            "rightCorner": {
              "x": 12.13,
              "y": 1.951,
              "z": 1.484
            },
            "gtin": "4027600504512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27049a",
            "leftCorner": {
              "x": 12.13,
              "y": 1.951,
              "z": 1.484
            },
            "rightCorner": {
              "x": 12.136,
              "y": 2.016,
              "z": 1.484
            },
            "gtin": "4027600194416",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27049b",
            "leftCorner": {
              "x": 12.136,
              "y": 2.016,
              "z": 1.484
            },
            "rightCorner": {
              "x": 12.144,
              "y": 2.106,
              "z": 1.484
            },
            "gtin": "5000204305203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27049c",
            "leftCorner": {
              "x": 12.144,
              "y": 2.106,
              "z": 1.484
            },
            "rightCorner": {
              "x": 12.153,
              "y": 2.209,
              "z": 1.484
            },
            "gtin": "4066447373332",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27049d",
            "leftCorner": {
              "x": 12.153,
              "y": 2.209,
              "z": 1.484
            },
            "rightCorner": {
              "x": 12.161,
              "y": 2.301,
              "z": 1.484
            }
          },
          {
            "id": "696ebf6e43c343680a27049e",
            "leftCorner": {
              "x": 12.161,
              "y": 2.301,
              "z": 1.484
            },
            "rightCorner": {
              "x": 12.176,
              "y": 2.459,
              "z": 1.484
            },
            "gtin": "4058172737442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27049f",
            "leftCorner": {
              "x": 12.176,
              "y": 2.459,
              "z": 1.484
            },
            "rightCorner": {
              "x": 12.179,
              "y": 2.494,
              "z": 1.484
            },
            "gtin": "4058172573583",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704a0",
            "leftCorner": {
              "x": 12.179,
              "y": 2.494,
              "z": 1.484
            },
            "rightCorner": {
              "x": 12.182,
              "y": 2.528,
              "z": 1.484
            },
            "gtin": "4058172573583",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704a1",
            "leftCorner": {
              "x": 12.182,
              "y": 2.528,
              "z": 1.484
            },
            "rightCorner": {
              "x": 12.191,
              "y": 2.63,
              "z": 1.484
            },
            "gtin": "4066447397369",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7395c",
        "height": 1.774,
        "facings": [
          {
            "id": "696ebf6e43c343680a270448",
            "leftCorner": {
              "x": 12.075,
              "y": 1.354,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.086,
              "y": 1.479,
              "z": 1.774
            },
            "gtin": "4062700837269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27044a",
            "leftCorner": {
              "x": 12.086,
              "y": 1.479,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.093,
              "y": 1.562,
              "z": 1.774
            },
            "gtin": "4062700635049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27044b",
            "leftCorner": {
              "x": 12.093,
              "y": 1.562,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.101,
              "y": 1.65,
              "z": 1.774
            },
            "gtin": "4062700835012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27044c",
            "leftCorner": {
              "x": 12.101,
              "y": 1.65,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.112,
              "y": 1.773,
              "z": 1.774
            },
            "gtin": "4062700836118",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27044d",
            "leftCorner": {
              "x": 12.112,
              "y": 1.773,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.119,
              "y": 1.852,
              "z": 1.774
            },
            "gtin": "4062700836293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27044e",
            "leftCorner": {
              "x": 12.119,
              "y": 1.852,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.131,
              "y": 1.976,
              "z": 1.774
            },
            "gtin": "4027600454510",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27044f",
            "leftCorner": {
              "x": 12.131,
              "y": 1.976,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.14,
              "y": 2.075,
              "z": 1.774
            },
            "gtin": "4027600444405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270450",
            "leftCorner": {
              "x": 12.14,
              "y": 2.075,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.149,
              "y": 2.174,
              "z": 1.774
            },
            "gtin": "4027600447512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270451",
            "leftCorner": {
              "x": 12.149,
              "y": 2.174,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.156,
              "y": 2.254,
              "z": 1.774
            },
            "gtin": "4062700835050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270452",
            "leftCorner": {
              "x": 12.156,
              "y": 2.254,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.165,
              "y": 2.353,
              "z": 1.774
            },
            "gtin": "4067796150001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270453",
            "leftCorner": {
              "x": 12.165,
              "y": 2.353,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.174,
              "y": 2.454,
              "z": 1.774
            },
            "gtin": "4058172893674",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270454",
            "leftCorner": {
              "x": 12.174,
              "y": 2.454,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.178,
              "y": 2.499,
              "z": 1.774
            },
            "gtin": "4058172893674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270455",
            "leftCorner": {
              "x": 12.178,
              "y": 2.499,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.187,
              "y": 2.599,
              "z": 1.774
            },
            "gtin": "4067796150025",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757d2b5fe7bc046959a85",
    "name": "68e757d2b5fe7bc046959a85",
    "x": 12.142,
    "y": 2.6003,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68048,
      "w": 0.73276
    },
    "statistics": {
      "hasStockCount": 24,
      "noStockCount": 2,
      "unknownStockCount": 25,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73967",
        "height": 0.19816,
        "facings": [
          {
            "id": "696ebf6e43c343680a2704cf",
            "leftCorner": {
              "x": 12.187,
              "y": 2.597,
              "z": 0.198
            },
            "rightCorner": {
              "x": 12.206,
              "y": 2.801,
              "z": 0.198
            },
            "gtin": "4067796255058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704d0",
            "leftCorner": {
              "x": 12.202,
              "y": 2.801,
              "z": 0.198
            },
            "rightCorner": {
              "x": 12.213,
              "y": 2.941,
              "z": 0.198
            },
            "gtin": "4066447716801",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704d1",
            "leftCorner": {
              "x": 12.213,
              "y": 2.941,
              "z": 0.198
            },
            "rightCorner": {
              "x": 12.221,
              "y": 3.048,
              "z": 0.198
            },
            "gtin": "4067796132069",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704d2",
            "leftCorner": {
              "x": 12.221,
              "y": 3.048,
              "z": 0.198
            },
            "rightCorner": {
              "x": 12.233,
              "y": 3.22,
              "z": 0.198
            },
            "gtin": "4058172222399",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704d3",
            "leftCorner": {
              "x": 12.233,
              "y": 3.22,
              "z": 0.198
            },
            "rightCorner": {
              "x": 12.245,
              "y": 3.371,
              "z": 0.198
            },
            "gtin": "4058172222399",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704d4",
            "leftCorner": {
              "x": 12.245,
              "y": 3.371,
              "z": 0.198
            },
            "rightCorner": {
              "x": 12.255,
              "y": 3.505,
              "z": 0.198
            },
            "gtin": "4058172639586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704d5",
            "leftCorner": {
              "x": 12.255,
              "y": 3.505,
              "z": 0.198
            },
            "rightCorner": {
              "x": 12.265,
              "y": 3.648,
              "z": 0.198
            },
            "gtin": "4067796131932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704d6",
            "leftCorner": {
              "x": 12.265,
              "y": 3.648,
              "z": 0.198
            },
            "rightCorner": {
              "x": 12.273,
              "y": 3.761,
              "z": 0.198
            },
            "gtin": "4066447398946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704d7",
            "leftCorner": {
              "x": 12.273,
              "y": 3.761,
              "z": 0.198
            },
            "rightCorner": {
              "x": 12.28,
              "y": 3.852,
              "z": 0.198
            },
            "gtin": "4058172640391",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73966",
        "height": 0.58766,
        "facings": [
          {
            "id": "696ebf6e43c343680a270531",
            "leftCorner": {
              "x": 12.189,
              "y": 2.597,
              "z": 0.588
            },
            "rightCorner": {
              "x": 12.205,
              "y": 2.818,
              "z": 0.588
            },
            "gtin": "5900951315923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270533",
            "leftCorner": {
              "x": 12.205,
              "y": 2.818,
              "z": 0.588
            },
            "rightCorner": {
              "x": 12.22,
              "y": 3.024,
              "z": 0.588
            },
            "gtin": "4008429136177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270534",
            "leftCorner": {
              "x": 12.22,
              "y": 3.024,
              "z": 0.588
            },
            "rightCorner": {
              "x": 12.225,
              "y": 3.089,
              "z": 0.588
            },
            "gtin": "4010355500571",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270535",
            "leftCorner": {
              "x": 12.225,
              "y": 3.089,
              "z": 0.588
            },
            "rightCorner": {
              "x": 12.23,
              "y": 3.154,
              "z": 0.588
            },
            "gtin": "4066447398915",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270536",
            "leftCorner": {
              "x": 12.23,
              "y": 3.154,
              "z": 0.588
            },
            "rightCorner": {
              "x": 12.247,
              "y": 3.379,
              "z": 0.588
            },
            "gtin": "4010355222084",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270537",
            "leftCorner": {
              "x": 12.247,
              "y": 3.379,
              "z": 0.588
            },
            "rightCorner": {
              "x": 12.257,
              "y": 3.517,
              "z": 0.588
            },
            "gtin": "4066447252088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270538",
            "leftCorner": {
              "x": 12.257,
              "y": 3.517,
              "z": 0.588
            },
            "rightCorner": {
              "x": 12.267,
              "y": 3.654,
              "z": 0.588
            }
          },
          {
            "id": "696ebf6e43c343680a270539",
            "leftCorner": {
              "x": 12.267,
              "y": 3.654,
              "z": 0.588
            },
            "rightCorner": {
              "x": 12.276,
              "y": 3.775,
              "z": 0.588
            },
            "gtin": "4010355221964",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27053a",
            "leftCorner": {
              "x": 12.276,
              "y": 3.775,
              "z": 0.588
            },
            "rightCorner": {
              "x": 12.282,
              "y": 3.852,
              "z": 0.588
            },
            "gtin": "4260748890028",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73964",
        "height": 0.92971,
        "facings": [
          {
            "id": "696ebf6e43c343680a270509",
            "leftCorner": {
              "x": 12.185,
              "y": 2.597,
              "z": 0.93
            },
            "rightCorner": {
              "x": 12.197,
              "y": 2.75,
              "z": 0.93
            },
            "gtin": "4058172324017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27050a",
            "leftCorner": {
              "x": 12.197,
              "y": 2.75,
              "z": 0.93
            },
            "rightCorner": {
              "x": 12.21,
              "y": 2.935,
              "z": 0.93
            },
            "gtin": "4032254789802",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27050b",
            "leftCorner": {
              "x": 12.21,
              "y": 2.935,
              "z": 0.93
            },
            "rightCorner": {
              "x": 12.221,
              "y": 3.08,
              "z": 0.93
            },
            "gtin": "5998749105214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27050c",
            "leftCorner": {
              "x": 12.221,
              "y": 3.08,
              "z": 0.93
            },
            "rightCorner": {
              "x": 12.233,
              "y": 3.236,
              "z": 0.93
            },
            "gtin": "4066447424287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27050d",
            "leftCorner": {
              "x": 12.233,
              "y": 3.236,
              "z": 0.93
            },
            "rightCorner": {
              "x": 12.245,
              "y": 3.402,
              "z": 0.93
            },
            "gtin": "7613036526845",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27050e",
            "leftCorner": {
              "x": 12.245,
              "y": 3.402,
              "z": 0.93
            },
            "rightCorner": {
              "x": 12.255,
              "y": 3.541,
              "z": 0.93
            },
            "gtin": "8445290645647",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27050f",
            "leftCorner": {
              "x": 12.255,
              "y": 3.541,
              "z": 0.93
            },
            "rightCorner": {
              "x": 12.27,
              "y": 3.74,
              "z": 0.93
            },
            "gtin": "4058172640247",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270510",
            "leftCorner": {
              "x": 12.27,
              "y": 3.74,
              "z": 0.93
            },
            "rightCorner": {
              "x": 12.278,
              "y": 3.846,
              "z": 0.93
            },
            "gtin": "4067796261370",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73965",
        "height": 1.225,
        "facings": [
          {
            "id": "696ebf6e43c343680a27051b",
            "leftCorner": {
              "x": 12.185,
              "y": 2.597,
              "z": 1.225
            },
            "rightCorner": {
              "x": 12.201,
              "y": 2.811,
              "z": 1.225
            },
            "gtin": "7613287844446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27051d",
            "leftCorner": {
              "x": 12.201,
              "y": 2.811,
              "z": 1.225
            },
            "rightCorner": {
              "x": 12.209,
              "y": 2.917,
              "z": 1.225
            },
            "gtin": "4067796265156",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27051e",
            "leftCorner": {
              "x": 12.209,
              "y": 2.917,
              "z": 1.225
            },
            "rightCorner": {
              "x": 12.214,
              "y": 2.991,
              "z": 1.225
            },
            "gtin": "4067796266788",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27051f",
            "leftCorner": {
              "x": 12.214,
              "y": 2.991,
              "z": 1.225
            },
            "rightCorner": {
              "x": 12.22,
              "y": 3.075,
              "z": 1.225
            },
            "gtin": "4067796266887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270520",
            "leftCorner": {
              "x": 12.22,
              "y": 3.075,
              "z": 1.225
            },
            "rightCorner": {
              "x": 12.231,
              "y": 3.214,
              "z": 1.225
            },
            "gtin": "4058172319754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270521",
            "leftCorner": {
              "x": 12.231,
              "y": 3.214,
              "z": 1.225
            },
            "rightCorner": {
              "x": 12.241,
              "y": 3.349,
              "z": 1.225
            },
            "gtin": "4010355220547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270522",
            "leftCorner": {
              "x": 12.241,
              "y": 3.349,
              "z": 1.225
            },
            "rightCorner": {
              "x": 12.25,
              "y": 3.475,
              "z": 1.225
            },
            "gtin": "4010355302168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270523",
            "leftCorner": {
              "x": 12.25,
              "y": 3.475,
              "z": 1.225
            },
            "rightCorner": {
              "x": 12.258,
              "y": 3.588,
              "z": 1.225
            },
            "gtin": "4066447670646",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270524",
            "leftCorner": {
              "x": 12.258,
              "y": 3.588,
              "z": 1.225
            },
            "rightCorner": {
              "x": 12.275,
              "y": 3.807,
              "z": 1.225
            },
            "gtin": "4251276204777",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73963",
        "height": 1.4826,
        "facings": [
          {
            "id": "696ebf6e43c343680a2704a2",
            "leftCorner": {
              "x": 12.192,
              "y": 2.629,
              "z": 1.483
            },
            "rightCorner": {
              "x": 12.202,
              "y": 2.754,
              "z": 1.483
            },
            "gtin": "4066447121605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704a3",
            "leftCorner": {
              "x": 12.202,
              "y": 2.754,
              "z": 1.483
            },
            "rightCorner": {
              "x": 12.212,
              "y": 2.89,
              "z": 1.483
            },
            "gtin": "4067796170955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704a4",
            "leftCorner": {
              "x": 12.212,
              "y": 2.89,
              "z": 1.483
            },
            "rightCorner": {
              "x": 12.217,
              "y": 2.964,
              "z": 1.483
            },
            "gtin": "4058172640476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704a5",
            "leftCorner": {
              "x": 12.217,
              "y": 2.964,
              "z": 1.483
            },
            "rightCorner": {
              "x": 12.228,
              "y": 3.104,
              "z": 1.483
            },
            "gtin": "4067796160147",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704a6",
            "leftCorner": {
              "x": 12.228,
              "y": 3.104,
              "z": 1.483
            },
            "rightCorner": {
              "x": 12.237,
              "y": 3.224,
              "z": 1.483
            },
            "gtin": "4066447203332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704a7",
            "leftCorner": {
              "x": 12.237,
              "y": 3.224,
              "z": 1.483
            },
            "rightCorner": {
              "x": 12.246,
              "y": 3.352,
              "z": 1.483
            },
            "gtin": "4010355508324",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704a8",
            "leftCorner": {
              "x": 12.246,
              "y": 3.352,
              "z": 1.483
            },
            "rightCorner": {
              "x": 12.255,
              "y": 3.471,
              "z": 1.483
            },
            "gtin": "4058172640452",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704a9",
            "leftCorner": {
              "x": 12.255,
              "y": 3.471,
              "z": 1.483
            },
            "rightCorner": {
              "x": 12.264,
              "y": 3.599,
              "z": 1.483
            },
            "gtin": "4066447297850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704aa",
            "leftCorner": {
              "x": 12.264,
              "y": 3.599,
              "z": 1.483
            },
            "rightCorner": {
              "x": 12.28,
              "y": 3.816,
              "z": 1.483
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73962",
        "height": 1.7717,
        "facings": [
          {
            "id": "696ebf6e43c343680a270456",
            "leftCorner": {
              "x": 12.187,
              "y": 2.599,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.197,
              "y": 2.711,
              "z": 1.774
            },
            "gtin": "4058172639784",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270457",
            "leftCorner": {
              "x": 12.194,
              "y": 2.71,
              "z": 1.772
            },
            "rightCorner": {
              "x": 12.204,
              "y": 2.844,
              "z": 1.772
            },
            "gtin": "4048422102472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270458",
            "leftCorner": {
              "x": 12.204,
              "y": 2.844,
              "z": 1.772
            },
            "rightCorner": {
              "x": 12.213,
              "y": 2.97,
              "z": 1.772
            },
            "gtin": "5998749146255",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270459",
            "leftCorner": {
              "x": 12.213,
              "y": 2.97,
              "z": 1.772
            },
            "rightCorner": {
              "x": 12.223,
              "y": 3.099,
              "z": 1.772
            },
            "gtin": "4008239585851",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27045a",
            "leftCorner": {
              "x": 12.223,
              "y": 3.099,
              "z": 1.772
            },
            "rightCorner": {
              "x": 12.233,
              "y": 3.229,
              "z": 1.772
            },
            "gtin": "4008239579775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27045b",
            "leftCorner": {
              "x": 12.233,
              "y": 3.229,
              "z": 1.772
            },
            "rightCorner": {
              "x": 12.244,
              "y": 3.384,
              "z": 1.772
            },
            "gtin": "4048422193302",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27045c",
            "leftCorner": {
              "x": 12.244,
              "y": 3.384,
              "z": 1.772
            },
            "rightCorner": {
              "x": 12.252,
              "y": 3.497,
              "z": 1.772
            },
            "gtin": "4260748895504",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27045d",
            "leftCorner": {
              "x": 12.252,
              "y": 3.497,
              "z": 1.772
            },
            "rightCorner": {
              "x": 12.259,
              "y": 3.584,
              "z": 1.772
            },
            "gtin": "4008239155511",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27045e",
            "leftCorner": {
              "x": 12.259,
              "y": 3.584,
              "z": 1.772
            },
            "rightCorner": {
              "x": 12.265,
              "y": 3.666,
              "z": 1.772
            },
            "gtin": "4008239184382",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27045f",
            "leftCorner": {
              "x": 12.265,
              "y": 3.666,
              "z": 1.772
            },
            "rightCorner": {
              "x": 12.276,
              "y": 3.811,
              "z": 1.772
            }
          }
        ]
      }
    ]
  },
  {
    "id": "68e757d2b5fe7bc046959a86",
    "name": "68e757d2b5fe7bc046959a86",
    "x": 12.237,
    "y": 3.8509,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68013,
      "w": 0.7331
    },
    "statistics": {
      "hasStockCount": 37,
      "noStockCount": 1,
      "unknownStockCount": 21,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd7396d",
        "height": 0.19795,
        "facings": [
          {
            "id": "696ebf6e43c343680a2704d8",
            "leftCorner": {
              "x": 12.282,
              "y": 3.856,
              "z": 0.198
            },
            "rightCorner": {
              "x": 12.29,
              "y": 3.949,
              "z": 0.198
            },
            "gtin": "4067796068436",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704d9",
            "leftCorner": {
              "x": 12.29,
              "y": 3.949,
              "z": 0.198
            },
            "rightCorner": {
              "x": 12.334,
              "y": 4.542,
              "z": 0.198
            },
            "gtin": "4066447670516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704da",
            "leftCorner": {
              "x": 12.334,
              "y": 4.542,
              "z": 0.198
            },
            "rightCorner": {
              "x": 12.364,
              "y": 4.939,
              "z": 0.198
            },
            "gtin": "4058172640322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704db",
            "leftCorner": {
              "x": 12.364,
              "y": 4.939,
              "z": 0.198
            },
            "rightCorner": {
              "x": 12.39,
              "y": 5.291,
              "z": 0.198
            },
            "gtin": "4066447502367",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73968",
        "height": 0.58977,
        "facings": [
          {
            "id": "696ebf6e43c343680a27053b",
            "leftCorner": {
              "x": 12.283,
              "y": 3.856,
              "z": 0.59
            },
            "rightCorner": {
              "x": 12.289,
              "y": 3.942,
              "z": 0.59
            },
            "gtin": "4260748890066",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27053c",
            "leftCorner": {
              "x": 12.289,
              "y": 3.942,
              "z": 0.59
            },
            "rightCorner": {
              "x": 12.296,
              "y": 4.027,
              "z": 0.59
            },
            "gtin": "9120063686285",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27053d",
            "leftCorner": {
              "x": 12.296,
              "y": 4.027,
              "z": 0.59
            },
            "rightCorner": {
              "x": 12.301,
              "y": 4.096,
              "z": 0.59
            },
            "gtin": "9120063686247",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27053e",
            "leftCorner": {
              "x": 12.301,
              "y": 4.096,
              "z": 0.59
            },
            "rightCorner": {
              "x": 12.307,
              "y": 4.183,
              "z": 0.59
            },
            "gtin": "9120063686261",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27053f",
            "leftCorner": {
              "x": 12.307,
              "y": 4.183,
              "z": 0.59
            },
            "rightCorner": {
              "x": 12.313,
              "y": 4.261,
              "z": 0.59
            },
            "gtin": "9120063681518",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270540",
            "leftCorner": {
              "x": 12.313,
              "y": 4.261,
              "z": 0.59
            },
            "rightCorner": {
              "x": 12.32,
              "y": 4.344,
              "z": 0.59
            },
            "gtin": "9120063681532",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270541",
            "leftCorner": {
              "x": 12.32,
              "y": 4.344,
              "z": 0.59
            },
            "rightCorner": {
              "x": 12.326,
              "y": 4.431,
              "z": 0.59
            },
            "gtin": "9120063681525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270542",
            "leftCorner": {
              "x": 12.326,
              "y": 4.431,
              "z": 0.59
            },
            "rightCorner": {
              "x": 12.333,
              "y": 4.516,
              "z": 0.59
            },
            "gtin": "4262437747033",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270543",
            "leftCorner": {
              "x": 12.333,
              "y": 4.516,
              "z": 0.59
            },
            "rightCorner": {
              "x": 12.339,
              "y": 4.601,
              "z": 0.59
            },
            "gtin": "4262437746937",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270544",
            "leftCorner": {
              "x": 12.339,
              "y": 4.601,
              "z": 0.59
            },
            "rightCorner": {
              "x": 12.344,
              "y": 4.673,
              "z": 0.59
            },
            "gtin": "4262437746999",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270545",
            "leftCorner": {
              "x": 12.344,
              "y": 4.673,
              "z": 0.59
            },
            "rightCorner": {
              "x": 12.35,
              "y": 4.75,
              "z": 0.59
            },
            "gtin": "4251871669506",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270546",
            "leftCorner": {
              "x": 12.35,
              "y": 4.75,
              "z": 0.59
            },
            "rightCorner": {
              "x": 12.355,
              "y": 4.822,
              "z": 0.59
            },
            "gtin": "4251871669858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270547",
            "leftCorner": {
              "x": 12.355,
              "y": 4.822,
              "z": 0.59
            },
            "rightCorner": {
              "x": 12.361,
              "y": 4.895,
              "z": 0.59
            },
            "gtin": "4250231598845",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270548",
            "leftCorner": {
              "x": 12.361,
              "y": 4.895,
              "z": 0.59
            },
            "rightCorner": {
              "x": 12.366,
              "y": 4.968,
              "z": 0.59
            },
            "gtin": "4250231598876",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270549",
            "leftCorner": {
              "x": 12.366,
              "y": 4.968,
              "z": 0.59
            },
            "rightCorner": {
              "x": 12.372,
              "y": 5.049,
              "z": 0.59
            },
            "gtin": "4010355512178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270532",
            "leftCorner": {
              "x": 12.372,
              "y": 5.049,
              "z": 0.59
            },
            "rightCorner": {
              "x": 12.376,
              "y": 5.094,
              "z": 0.59
            },
            "gtin": "4010355500533",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73969",
        "height": 0.92357,
        "facings": [
          {
            "id": "696ebf6e43c343680a270511",
            "leftCorner": {
              "x": 12.283,
              "y": 3.847,
              "z": 0.924
            },
            "rightCorner": {
              "x": 12.291,
              "y": 3.951,
              "z": 0.924
            },
            "gtin": "4067796079043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270512",
            "leftCorner": {
              "x": 12.291,
              "y": 3.951,
              "z": 0.924
            },
            "rightCorner": {
              "x": 12.297,
              "y": 4.041,
              "z": 0.924
            },
            "gtin": "4010355220684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270513",
            "leftCorner": {
              "x": 12.297,
              "y": 4.041,
              "z": 0.924
            },
            "rightCorner": {
              "x": 12.303,
              "y": 4.112,
              "z": 0.924
            },
            "gtin": "4066447120516",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270514",
            "leftCorner": {
              "x": 12.303,
              "y": 4.112,
              "z": 0.924
            },
            "rightCorner": {
              "x": 12.308,
              "y": 4.184,
              "z": 0.924
            }
          },
          {
            "id": "696ebf6e43c343680a270515",
            "leftCorner": {
              "x": 12.308,
              "y": 4.184,
              "z": 0.924
            },
            "rightCorner": {
              "x": 12.316,
              "y": 4.286,
              "z": 0.924
            },
            "gtin": "4067796160185",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270516",
            "leftCorner": {
              "x": 12.316,
              "y": 4.286,
              "z": 0.924
            },
            "rightCorner": {
              "x": 12.324,
              "y": 4.397,
              "z": 0.924
            },
            "gtin": "4067796160185",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270517",
            "leftCorner": {
              "x": 12.324,
              "y": 4.397,
              "z": 0.924
            },
            "rightCorner": {
              "x": 12.338,
              "y": 4.586,
              "z": 0.924
            },
            "gtin": "4058172640285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270518",
            "leftCorner": {
              "x": 12.338,
              "y": 4.586,
              "z": 0.924
            },
            "rightCorner": {
              "x": 12.35,
              "y": 4.746,
              "z": 0.924
            },
            "gtin": "4066447242676",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270519",
            "leftCorner": {
              "x": 12.35,
              "y": 4.746,
              "z": 0.924
            },
            "rightCorner": {
              "x": 12.363,
              "y": 4.918,
              "z": 0.924
            },
            "gtin": "4066447475876",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27051a",
            "leftCorner": {
              "x": 12.363,
              "y": 4.918,
              "z": 0.924
            },
            "rightCorner": {
              "x": 12.376,
              "y": 5.09,
              "z": 0.924
            },
            "gtin": "4066447475869",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7396c",
        "height": 1.2258,
        "facings": [
          {
            "id": "696ebf6e43c343680a270525",
            "leftCorner": {
              "x": 12.275,
              "y": 3.807,
              "z": 1.225
            },
            "rightCorner": {
              "x": 12.286,
              "y": 3.966,
              "z": 1.225
            },
            "gtin": "5998749120552",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270526",
            "leftCorner": {
              "x": 12.291,
              "y": 3.969,
              "z": 1.226
            },
            "rightCorner": {
              "x": 12.296,
              "y": 4.027,
              "z": 1.226
            },
            "gtin": "4260633073185",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270527",
            "leftCorner": {
              "x": 12.296,
              "y": 4.027,
              "z": 1.226
            },
            "rightCorner": {
              "x": 12.302,
              "y": 4.109,
              "z": 1.226
            },
            "gtin": "4066447751079",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270528",
            "leftCorner": {
              "x": 12.302,
              "y": 4.109,
              "z": 1.226
            },
            "rightCorner": {
              "x": 12.309,
              "y": 4.199,
              "z": 1.226
            },
            "gtin": "4066447295139",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270529",
            "leftCorner": {
              "x": 12.309,
              "y": 4.199,
              "z": 1.226
            },
            "rightCorner": {
              "x": 12.316,
              "y": 4.296,
              "z": 1.226
            },
            "gtin": "4066447670608",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27052a",
            "leftCorner": {
              "x": 12.316,
              "y": 4.296,
              "z": 1.226
            },
            "rightCorner": {
              "x": 12.324,
              "y": 4.4,
              "z": 1.226
            },
            "gtin": "4058172099861",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27052b",
            "leftCorner": {
              "x": 12.324,
              "y": 4.4,
              "z": 1.226
            },
            "rightCorner": {
              "x": 12.331,
              "y": 4.498,
              "z": 1.226
            },
            "gtin": "4058172100024",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27052c",
            "leftCorner": {
              "x": 12.331,
              "y": 4.498,
              "z": 1.226
            },
            "rightCorner": {
              "x": 12.34,
              "y": 4.621,
              "z": 1.226
            },
            "gtin": "4058172099847",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27052d",
            "leftCorner": {
              "x": 12.34,
              "y": 4.621,
              "z": 1.226
            },
            "rightCorner": {
              "x": 12.348,
              "y": 4.725,
              "z": 1.226
            },
            "gtin": "4066447749502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27052e",
            "leftCorner": {
              "x": 12.348,
              "y": 4.725,
              "z": 1.226
            },
            "rightCorner": {
              "x": 12.355,
              "y": 4.815,
              "z": 1.226
            },
            "gtin": "4067796162837",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27052f",
            "leftCorner": {
              "x": 12.355,
              "y": 4.815,
              "z": 1.226
            },
            "rightCorner": {
              "x": 12.361,
              "y": 4.894,
              "z": 1.226
            },
            "gtin": "4010355512154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270530",
            "leftCorner": {
              "x": 12.361,
              "y": 4.894,
              "z": 1.226
            },
            "rightCorner": {
              "x": 12.366,
              "y": 4.972,
              "z": 1.226
            },
            "gtin": "4010355512154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27051c",
            "leftCorner": {
              "x": 12.366,
              "y": 4.972,
              "z": 1.226
            },
            "rightCorner": {
              "x": 12.376,
              "y": 5.094,
              "z": 1.226
            },
            "gtin": "4010355500595",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7396b",
        "height": 1.4791,
        "facings": [
          {
            "id": "696ebf6e43c343680a2704ab",
            "leftCorner": {
              "x": 12.28,
              "y": 3.816,
              "z": 1.483
            },
            "rightCorner": {
              "x": 12.289,
              "y": 3.927,
              "z": 1.483
            },
            "gtin": "4010355214027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704ac",
            "leftCorner": {
              "x": 12.289,
              "y": 3.931,
              "z": 1.479
            },
            "rightCorner": {
              "x": 12.297,
              "y": 4.031,
              "z": 1.479
            }
          },
          {
            "id": "696ebf6e43c343680a2704ad",
            "leftCorner": {
              "x": 12.297,
              "y": 4.031,
              "z": 1.479
            },
            "rightCorner": {
              "x": 12.315,
              "y": 4.28,
              "z": 1.479
            },
            "gtin": "4260446690203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704ae",
            "leftCorner": {
              "x": 12.315,
              "y": 4.28,
              "z": 1.479
            },
            "rightCorner": {
              "x": 12.324,
              "y": 4.4,
              "z": 1.479
            },
            "gtin": "4260748894446",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704af",
            "leftCorner": {
              "x": 12.324,
              "y": 4.4,
              "z": 1.479
            },
            "rightCorner": {
              "x": 12.341,
              "y": 4.622,
              "z": 1.479
            },
            "gtin": "4260748894590",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704b0",
            "leftCorner": {
              "x": 12.341,
              "y": 4.622,
              "z": 1.479
            },
            "rightCorner": {
              "x": 12.349,
              "y": 4.732,
              "z": 1.479
            },
            "gtin": "4066447747485",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704b1",
            "leftCorner": {
              "x": 12.349,
              "y": 4.732,
              "z": 1.479
            },
            "rightCorner": {
              "x": 12.358,
              "y": 4.851,
              "z": 1.479
            },
            "gtin": "4058172099908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704b2",
            "leftCorner": {
              "x": 12.358,
              "y": 4.851,
              "z": 1.479
            },
            "rightCorner": {
              "x": 12.367,
              "y": 4.973,
              "z": 1.479
            },
            "gtin": "4058172222757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270494",
            "leftCorner": {
              "x": 12.367,
              "y": 4.973,
              "z": 1.479
            },
            "rightCorner": {
              "x": 12.377,
              "y": 5.094,
              "z": 1.479
            },
            "gtin": "4058172222757",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7396a",
        "height": 1.7703,
        "facings": [
          {
            "id": "696ebf6e43c343680a270466",
            "leftCorner": {
              "x": 12.343,
              "y": 4.684,
              "z": 1.77
            },
            "rightCorner": {
              "x": 12.355,
              "y": 4.838,
              "z": 1.77
            },
            "gtin": "8410136024184",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270460",
            "leftCorner": {
              "x": 12.276,
              "y": 3.811,
              "z": 1.772
            },
            "rightCorner": {
              "x": 12.285,
              "y": 3.94,
              "z": 1.772
            },
            "gtin": "4048422192350",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270461",
            "leftCorner": {
              "x": 12.288,
              "y": 3.944,
              "z": 1.77
            },
            "rightCorner": {
              "x": 12.298,
              "y": 4.086,
              "z": 1.77
            },
            "gtin": "4048422159001",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270462",
            "leftCorner": {
              "x": 12.298,
              "y": 4.086,
              "z": 1.77
            },
            "rightCorner": {
              "x": 12.309,
              "y": 4.231,
              "z": 1.77
            },
            "gtin": "4048422177807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270463",
            "leftCorner": {
              "x": 12.309,
              "y": 4.231,
              "z": 1.77
            },
            "rightCorner": {
              "x": 12.32,
              "y": 4.375,
              "z": 1.77
            },
            "gtin": "8445290990419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270464",
            "leftCorner": {
              "x": 12.32,
              "y": 4.375,
              "z": 1.77
            },
            "rightCorner": {
              "x": 12.334,
              "y": 4.559,
              "z": 1.77
            },
            "gtin": "8445290990198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270465",
            "leftCorner": {
              "x": 12.334,
              "y": 4.559,
              "z": 1.77
            },
            "rightCorner": {
              "x": 12.343,
              "y": 4.684,
              "z": 1.77
            },
            "gtin": "3065890159815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270467",
            "leftCorner": {
              "x": 12.355,
              "y": 4.838,
              "z": 1.77
            },
            "rightCorner": {
              "x": 12.364,
              "y": 4.958,
              "z": 1.77
            },
            "gtin": "4008429085307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270468",
            "leftCorner": {
              "x": 12.364,
              "y": 4.958,
              "z": 1.77
            },
            "rightCorner": {
              "x": 12.372,
              "y": 5.06,
              "z": 1.77
            },
            "gtin": "3065890135383",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757d2b5fe7bc046959a87",
    "name": "68e757d2b5fe7bc046959a87",
    "x": 12.236,
    "y": 5.0921,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.67914,
      "w": 0.73401
    },
    "statistics": {
      "hasStockCount": 26,
      "noStockCount": 1,
      "unknownStockCount": 37,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73974",
        "height": 0.20679,
        "facings": [
          {
            "id": "696ebf6e43c343680a2704dc",
            "leftCorner": {
              "x": 12.391,
              "y": 5.278,
              "z": 0.207
            },
            "rightCorner": {
              "x": 12.436,
              "y": 5.872,
              "z": 0.207
            },
            "gtin": "4008429033377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704dd",
            "leftCorner": {
              "x": 12.438,
              "y": 5.872,
              "z": 0.207
            },
            "rightCorner": {
              "x": 12.466,
              "y": 6.247,
              "z": 0.207
            },
            "gtin": "4008429155888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704de",
            "leftCorner": {
              "x": 12.467,
              "y": 6.247,
              "z": 0.207
            },
            "rightCorner": {
              "x": 12.473,
              "y": 6.327,
              "z": 0.207
            },
            "gtin": "4008429155888",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73973",
        "height": 0.50839,
        "facings": [
          {
            "id": "696ebf6e43c343680a2705df",
            "leftCorner": {
              "x": 12.378,
              "y": 5.081,
              "z": 0.508
            },
            "rightCorner": {
              "x": 12.398,
              "y": 5.344,
              "z": 0.508
            },
            "gtin": "4067796149319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705e1",
            "leftCorner": {
              "x": 12.398,
              "y": 5.344,
              "z": 0.508
            },
            "rightCorner": {
              "x": 12.416,
              "y": 5.566,
              "z": 0.508
            },
            "gtin": "4067796163346",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705e2",
            "leftCorner": {
              "x": 12.416,
              "y": 5.566,
              "z": 0.508
            },
            "rightCorner": {
              "x": 12.433,
              "y": 5.789,
              "z": 0.508
            },
            "gtin": "4067796163346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705e3",
            "leftCorner": {
              "x": 12.433,
              "y": 5.789,
              "z": 0.508
            },
            "rightCorner": {
              "x": 12.45,
              "y": 6.005,
              "z": 0.508
            },
            "gtin": "4067796254969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705e4",
            "leftCorner": {
              "x": 12.45,
              "y": 6.005,
              "z": 0.508
            },
            "rightCorner": {
              "x": 12.475,
              "y": 6.327,
              "z": 0.508
            },
            "gtin": "4067796254983",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7396e",
        "height": 0.79957,
        "facings": [
          {
            "id": "696ebf6e43c343680a27054a",
            "leftCorner": {
              "x": 12.377,
              "y": 5.081,
              "z": 0.8
            },
            "rightCorner": {
              "x": 12.385,
              "y": 5.187,
              "z": 0.8
            },
            "gtin": "4002064417653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27054c",
            "leftCorner": {
              "x": 12.385,
              "y": 5.187,
              "z": 0.8
            },
            "rightCorner": {
              "x": 12.395,
              "y": 5.315,
              "z": 0.8
            },
            "gtin": "4002064419183",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27054d",
            "leftCorner": {
              "x": 12.395,
              "y": 5.315,
              "z": 0.8
            },
            "rightCorner": {
              "x": 12.403,
              "y": 5.411,
              "z": 0.8
            },
            "gtin": "4066447265279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27054e",
            "leftCorner": {
              "x": 12.403,
              "y": 5.411,
              "z": 0.8
            },
            "rightCorner": {
              "x": 12.414,
              "y": 5.551,
              "z": 0.8
            },
            "gtin": "4058172944604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27054f",
            "leftCorner": {
              "x": 12.414,
              "y": 5.551,
              "z": 0.8
            },
            "rightCorner": {
              "x": 12.421,
              "y": 5.652,
              "z": 0.8
            },
            "gtin": "4058172639746",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270550",
            "leftCorner": {
              "x": 12.421,
              "y": 5.652,
              "z": 0.8
            },
            "rightCorner": {
              "x": 12.43,
              "y": 5.758,
              "z": 0.8
            },
            "gtin": "4010355221032",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270551",
            "leftCorner": {
              "x": 12.43,
              "y": 5.758,
              "z": 0.8
            },
            "rightCorner": {
              "x": 12.438,
              "y": 5.86,
              "z": 0.8
            },
            "gtin": "4010355221032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270552",
            "leftCorner": {
              "x": 12.438,
              "y": 5.86,
              "z": 0.8
            },
            "rightCorner": {
              "x": 12.445,
              "y": 5.953,
              "z": 0.8
            },
            "gtin": "4066447294996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270553",
            "leftCorner": {
              "x": 12.445,
              "y": 5.953,
              "z": 0.8
            },
            "rightCorner": {
              "x": 12.453,
              "y": 6.059,
              "z": 0.8
            },
            "gtin": "4066447265293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270554",
            "leftCorner": {
              "x": 12.453,
              "y": 6.059,
              "z": 0.8
            },
            "rightCorner": {
              "x": 12.461,
              "y": 6.161,
              "z": 0.8
            },
            "gtin": "4066447265293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270555",
            "leftCorner": {
              "x": 12.461,
              "y": 6.161,
              "z": 0.8
            },
            "rightCorner": {
              "x": 12.472,
              "y": 6.302,
              "z": 0.8
            },
            "gtin": "4066447370119",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73970",
        "height": 1.0578,
        "facings": [
          {
            "id": "696ebf6e43c343680a270570",
            "leftCorner": {
              "x": 12.377,
              "y": 5.081,
              "z": 1.058
            },
            "rightCorner": {
              "x": 12.388,
              "y": 5.217,
              "z": 1.058
            },
            "gtin": "4058172640353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270572",
            "leftCorner": {
              "x": 12.388,
              "y": 5.217,
              "z": 1.058
            },
            "rightCorner": {
              "x": 12.396,
              "y": 5.32,
              "z": 1.058
            },
            "gtin": "4002064422145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270573",
            "leftCorner": {
              "x": 12.396,
              "y": 5.32,
              "z": 1.058
            },
            "rightCorner": {
              "x": 12.402,
              "y": 5.395,
              "z": 1.058
            },
            "gtin": "4002064401300",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270574",
            "leftCorner": {
              "x": 12.402,
              "y": 5.395,
              "z": 1.058
            },
            "rightCorner": {
              "x": 12.41,
              "y": 5.494,
              "z": 1.058
            },
            "gtin": "4006538019817",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270575",
            "leftCorner": {
              "x": 12.41,
              "y": 5.494,
              "z": 1.058
            },
            "rightCorner": {
              "x": 12.417,
              "y": 5.588,
              "z": 1.058
            },
            "gtin": "4006538007999",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270576",
            "leftCorner": {
              "x": 12.417,
              "y": 5.588,
              "z": 1.058
            },
            "rightCorner": {
              "x": 12.425,
              "y": 5.694,
              "z": 1.058
            },
            "gtin": "4008239288226",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270577",
            "leftCorner": {
              "x": 12.425,
              "y": 5.694,
              "z": 1.058
            },
            "rightCorner": {
              "x": 12.433,
              "y": 5.792,
              "z": 1.058
            },
            "gtin": "4067796254648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270578",
            "leftCorner": {
              "x": 12.433,
              "y": 5.792,
              "z": 1.058
            },
            "rightCorner": {
              "x": 12.44,
              "y": 5.885,
              "z": 1.058
            },
            "gtin": "4066447989298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270579",
            "leftCorner": {
              "x": 12.44,
              "y": 5.885,
              "z": 1.058
            },
            "rightCorner": {
              "x": 12.448,
              "y": 5.987,
              "z": 1.058
            },
            "gtin": "4067796139556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27057a",
            "leftCorner": {
              "x": 12.448,
              "y": 5.987,
              "z": 1.058
            },
            "rightCorner": {
              "x": 12.456,
              "y": 6.087,
              "z": 1.058
            },
            "gtin": "4010355213365",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27057b",
            "leftCorner": {
              "x": 12.456,
              "y": 6.087,
              "z": 1.058
            },
            "rightCorner": {
              "x": 12.462,
              "y": 6.174,
              "z": 1.058
            },
            "gtin": "4010355213365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27057c",
            "leftCorner": {
              "x": 12.462,
              "y": 6.174,
              "z": 1.058
            },
            "rightCorner": {
              "x": 12.472,
              "y": 6.298,
              "z": 1.058
            },
            "gtin": "4067796068399",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73971",
        "height": 1.3113,
        "facings": [
          {
            "id": "696ebf6e43c343680a270597",
            "leftCorner": {
              "x": 12.378,
              "y": 5.081,
              "z": 1.311
            },
            "rightCorner": {
              "x": 12.382,
              "y": 5.134,
              "z": 1.311
            }
          },
          {
            "id": "696ebf6e43c343680a270599",
            "leftCorner": {
              "x": 12.382,
              "y": 5.134,
              "z": 1.311
            },
            "rightCorner": {
              "x": 12.389,
              "y": 5.22,
              "z": 1.311
            },
            "gtin": "4003572773231",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27059a",
            "leftCorner": {
              "x": 12.389,
              "y": 5.22,
              "z": 1.311
            },
            "rightCorner": {
              "x": 12.396,
              "y": 5.31,
              "z": 1.311
            },
            "gtin": "4260688857020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27059b",
            "leftCorner": {
              "x": 12.396,
              "y": 5.31,
              "z": 1.311
            },
            "rightCorner": {
              "x": 12.405,
              "y": 5.43,
              "z": 1.311
            },
            "gtin": "4262437745367",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27059c",
            "leftCorner": {
              "x": 12.405,
              "y": 5.43,
              "z": 1.311
            },
            "rightCorner": {
              "x": 12.421,
              "y": 5.629,
              "z": 1.311
            },
            "gtin": "4010355557223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27059d",
            "leftCorner": {
              "x": 12.421,
              "y": 5.629,
              "z": 1.311
            },
            "rightCorner": {
              "x": 12.428,
              "y": 5.717,
              "z": 1.311
            },
            "gtin": "4058172319457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27059e",
            "leftCorner": {
              "x": 12.428,
              "y": 5.717,
              "z": 1.311
            },
            "rightCorner": {
              "x": 12.435,
              "y": 5.816,
              "z": 1.311
            },
            "gtin": "4260748894996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27059f",
            "leftCorner": {
              "x": 12.435,
              "y": 5.816,
              "z": 1.311
            },
            "rightCorner": {
              "x": 12.441,
              "y": 5.894,
              "z": 1.311
            },
            "gtin": "4260748895009",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705a0",
            "leftCorner": {
              "x": 12.441,
              "y": 5.894,
              "z": 1.311
            },
            "rightCorner": {
              "x": 12.449,
              "y": 5.986,
              "z": 1.311
            },
            "gtin": "4058172100062",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705a1",
            "leftCorner": {
              "x": 12.449,
              "y": 5.986,
              "z": 1.311
            },
            "rightCorner": {
              "x": 12.456,
              "y": 6.085,
              "z": 1.311
            },
            "gtin": "4058172100062",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705a2",
            "leftCorner": {
              "x": 12.456,
              "y": 6.085,
              "z": 1.311
            },
            "rightCorner": {
              "x": 12.464,
              "y": 6.18,
              "z": 1.311
            },
            "gtin": "4058172100086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705a3",
            "leftCorner": {
              "x": 12.464,
              "y": 6.18,
              "z": 1.311
            },
            "rightCorner": {
              "x": 12.473,
              "y": 6.299,
              "z": 1.311
            },
            "gtin": "4067796254167",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73972",
        "height": 1.5225,
        "facings": [
          {
            "id": "696ebf6e43c343680a2705bb",
            "leftCorner": {
              "x": 12.383,
              "y": 5.081,
              "z": 1.523
            },
            "rightCorner": {
              "x": 12.386,
              "y": 5.122,
              "z": 1.523
            }
          },
          {
            "id": "696ebf6e43c343680a2705bd",
            "leftCorner": {
              "x": 12.386,
              "y": 5.122,
              "z": 1.523
            },
            "rightCorner": {
              "x": 12.391,
              "y": 5.184,
              "z": 1.523
            },
            "gtin": "4045612003977",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705be",
            "leftCorner": {
              "x": 12.391,
              "y": 5.184,
              "z": 1.523
            },
            "rightCorner": {
              "x": 12.402,
              "y": 5.32,
              "z": 1.523
            },
            "gtin": "5998749142363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705bf",
            "leftCorner": {
              "x": 12.402,
              "y": 5.32,
              "z": 1.523
            },
            "rightCorner": {
              "x": 12.409,
              "y": 5.41,
              "z": 1.523
            },
            "gtin": "4008429162831",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705c0",
            "leftCorner": {
              "x": 12.409,
              "y": 5.41,
              "z": 1.523
            },
            "rightCorner": {
              "x": 12.418,
              "y": 5.523,
              "z": 1.523
            },
            "gtin": "4008429037986",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705c1",
            "leftCorner": {
              "x": 12.418,
              "y": 5.523,
              "z": 1.523
            },
            "rightCorner": {
              "x": 12.446,
              "y": 5.888,
              "z": 1.523
            },
            "gtin": "4008429081767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705c2",
            "leftCorner": {
              "x": 12.446,
              "y": 5.888,
              "z": 1.523
            },
            "rightCorner": {
              "x": 12.454,
              "y": 5.997,
              "z": 1.523
            },
            "gtin": "5998749146477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705c3",
            "leftCorner": {
              "x": 12.454,
              "y": 5.997,
              "z": 1.523
            },
            "rightCorner": {
              "x": 12.467,
              "y": 6.161,
              "z": 1.523
            },
            "gtin": "5998749139677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705c4",
            "leftCorner": {
              "x": 12.467,
              "y": 6.161,
              "z": 1.523
            },
            "rightCorner": {
              "x": 12.476,
              "y": 6.273,
              "z": 1.523
            },
            "gtin": "4002064406213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705c5",
            "leftCorner": {
              "x": 12.476,
              "y": 6.273,
              "z": 1.523
            },
            "rightCorner": {
              "x": 12.485,
              "y": 6.395,
              "z": 1.523
            },
            "gtin": "4002064406527",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7396f",
        "height": 1.7668,
        "facings": [
          {
            "id": "696ebf6e43c343680a270469",
            "leftCorner": {
              "x": 12.372,
              "y": 5.06,
              "z": 1.77
            },
            "rightCorner": {
              "x": 12.387,
              "y": 5.266,
              "z": 1.77
            },
            "gtin": "4008429114588",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27046a",
            "leftCorner": {
              "x": 12.396,
              "y": 5.252,
              "z": 1.767
            },
            "rightCorner": {
              "x": 12.402,
              "y": 5.331,
              "z": 1.767
            },
            "gtin": "4008239411396",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27046b",
            "leftCorner": {
              "x": 12.402,
              "y": 5.331,
              "z": 1.767
            },
            "rightCorner": {
              "x": 12.407,
              "y": 5.4,
              "z": 1.767
            },
            "gtin": "5400585189049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27046c",
            "leftCorner": {
              "x": 12.407,
              "y": 5.4,
              "z": 1.767
            },
            "rightCorner": {
              "x": 12.414,
              "y": 5.496,
              "z": 1.767
            },
            "gtin": "4008239396006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27046d",
            "leftCorner": {
              "x": 12.414,
              "y": 5.496,
              "z": 1.767
            },
            "rightCorner": {
              "x": 12.422,
              "y": 5.591,
              "z": 1.767
            },
            "gtin": "5400585235159",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27046e",
            "leftCorner": {
              "x": 12.422,
              "y": 5.591,
              "z": 1.767
            },
            "rightCorner": {
              "x": 12.428,
              "y": 5.668,
              "z": 1.767
            },
            "gtin": "5400585258622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27046f",
            "leftCorner": {
              "x": 12.428,
              "y": 5.668,
              "z": 1.767
            },
            "rightCorner": {
              "x": 12.436,
              "y": 5.77,
              "z": 1.767
            },
            "gtin": "4066447295054",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270470",
            "leftCorner": {
              "x": 12.436,
              "y": 5.77,
              "z": 1.767
            },
            "rightCorner": {
              "x": 12.442,
              "y": 5.849,
              "z": 1.767
            },
            "gtin": "5400585377651",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270471",
            "leftCorner": {
              "x": 12.442,
              "y": 5.849,
              "z": 1.767
            },
            "rightCorner": {
              "x": 12.448,
              "y": 5.929,
              "z": 1.767
            },
            "gtin": "4066447295078",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270472",
            "leftCorner": {
              "x": 12.448,
              "y": 5.929,
              "z": 1.767
            },
            "rightCorner": {
              "x": 12.454,
              "y": 6.009,
              "z": 1.767
            },
            "gtin": "4008239313911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270473",
            "leftCorner": {
              "x": 12.454,
              "y": 6.009,
              "z": 1.767
            },
            "rightCorner": {
              "x": 12.462,
              "y": 6.103,
              "z": 1.767
            },
            "gtin": "4008239133687",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270474",
            "leftCorner": {
              "x": 12.462,
              "y": 6.103,
              "z": 1.767
            },
            "rightCorner": {
              "x": 12.469,
              "y": 6.194,
              "z": 1.767
            },
            "gtin": "4058172319709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270475",
            "leftCorner": {
              "x": 12.469,
              "y": 6.194,
              "z": 1.767
            },
            "rightCorner": {
              "x": 12.484,
              "y": 6.392,
              "z": 1.767
            },
            "gtin": "5900951258589",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757d2b5fe7bc046959a88",
    "name": "68e757d2b5fe7bc046959a88",
    "x": 12.43,
    "y": 6.3256,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68065,
      "w": 0.73261
    },
    "statistics": {
      "hasStockCount": 16,
      "noStockCount": 0,
      "unknownStockCount": 45,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd7397b",
        "height": 0.20399,
        "facings": [
          {
            "id": "696ebf6e43c343680a2704df",
            "leftCorner": {
              "x": 12.475,
              "y": 6.322,
              "z": 0.204
            },
            "rightCorner": {
              "x": 12.501,
              "y": 6.656,
              "z": 0.204
            },
            "gtin": "3065890155947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704e0",
            "leftCorner": {
              "x": 12.5,
              "y": 6.656,
              "z": 0.204
            },
            "rightCorner": {
              "x": 12.514,
              "y": 6.852,
              "z": 0.204
            },
            "gtin": "3065890155916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704e1",
            "leftCorner": {
              "x": 12.514,
              "y": 6.852,
              "z": 0.204
            },
            "rightCorner": {
              "x": 12.537,
              "y": 7.161,
              "z": 0.204
            },
            "gtin": "4008429157196",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704e2",
            "leftCorner": {
              "x": 12.537,
              "y": 7.161,
              "z": 0.204
            },
            "rightCorner": {
              "x": 12.561,
              "y": 7.488,
              "z": 0.204
            },
            "gtin": "4067796254136",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73978",
        "height": 0.51105,
        "facings": [
          {
            "id": "696ebf6e43c343680a2705e5",
            "leftCorner": {
              "x": 12.479,
              "y": 6.322,
              "z": 0.511
            },
            "rightCorner": {
              "x": 12.515,
              "y": 6.784,
              "z": 0.511
            },
            "gtin": "4010355213501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705e6",
            "leftCorner": {
              "x": 12.513,
              "y": 6.784,
              "z": 0.511
            },
            "rightCorner": {
              "x": 12.549,
              "y": 7.281,
              "z": 0.511
            },
            "gtin": "4010355213549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705e7",
            "leftCorner": {
              "x": 12.549,
              "y": 7.281,
              "z": 0.511
            },
            "rightCorner": {
              "x": 12.571,
              "y": 7.578,
              "z": 0.511
            },
            "gtin": "4010355508423",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73979",
        "height": 0.80558,
        "facings": [
          {
            "id": "696ebf6e43c343680a270556",
            "leftCorner": {
              "x": 12.472,
              "y": 6.302,
              "z": 0.8
            },
            "rightCorner": {
              "x": 12.48,
              "y": 6.409,
              "z": 0.8
            },
            "gtin": "4066447265255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270557",
            "leftCorner": {
              "x": 12.486,
              "y": 6.404,
              "z": 0.806
            },
            "rightCorner": {
              "x": 12.489,
              "y": 6.441,
              "z": 0.806
            },
            "gtin": "4066447265255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270558",
            "leftCorner": {
              "x": 12.489,
              "y": 6.441,
              "z": 0.806
            },
            "rightCorner": {
              "x": 12.497,
              "y": 6.552,
              "z": 0.806
            }
          },
          {
            "id": "696ebf6e43c343680a270559",
            "leftCorner": {
              "x": 12.497,
              "y": 6.552,
              "z": 0.806
            },
            "rightCorner": {
              "x": 12.505,
              "y": 6.666,
              "z": 0.806
            },
            "gtin": "4067796269444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27055a",
            "leftCorner": {
              "x": 12.505,
              "y": 6.666,
              "z": 0.806
            },
            "rightCorner": {
              "x": 12.515,
              "y": 6.802,
              "z": 0.806
            },
            "gtin": "4067796261356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27055b",
            "leftCorner": {
              "x": 12.515,
              "y": 6.802,
              "z": 0.806
            },
            "rightCorner": {
              "x": 12.526,
              "y": 6.944,
              "z": 0.806
            },
            "gtin": "4067796272703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27055c",
            "leftCorner": {
              "x": 12.526,
              "y": 6.944,
              "z": 0.806
            },
            "rightCorner": {
              "x": 12.533,
              "y": 7.042,
              "z": 0.806
            },
            "gtin": "4066447476040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27055d",
            "leftCorner": {
              "x": 12.533,
              "y": 7.042,
              "z": 0.806
            },
            "rightCorner": {
              "x": 12.54,
              "y": 7.138,
              "z": 0.806
            },
            "gtin": "4066447476040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27055e",
            "leftCorner": {
              "x": 12.54,
              "y": 7.138,
              "z": 0.806
            },
            "rightCorner": {
              "x": 12.546,
              "y": 7.221,
              "z": 0.806
            },
            "gtin": "4058172100161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27055f",
            "leftCorner": {
              "x": 12.546,
              "y": 7.221,
              "z": 0.806
            },
            "rightCorner": {
              "x": 12.553,
              "y": 7.311,
              "z": 0.806
            },
            "gtin": "4058172589584",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270560",
            "leftCorner": {
              "x": 12.553,
              "y": 7.311,
              "z": 0.806
            },
            "rightCorner": {
              "x": 12.558,
              "y": 7.385,
              "z": 0.806
            },
            "gtin": "4067796160208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270561",
            "leftCorner": {
              "x": 12.558,
              "y": 7.385,
              "z": 0.806
            },
            "rightCorner": {
              "x": 12.564,
              "y": 7.462,
              "z": 0.806
            },
            "gtin": "4067796160222",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270562",
            "leftCorner": {
              "x": 12.564,
              "y": 7.462,
              "z": 0.806
            },
            "rightCorner": {
              "x": 12.571,
              "y": 7.555,
              "z": 0.806
            },
            "gtin": "4067796160222",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7397a",
        "height": 1.0587,
        "facings": [
          {
            "id": "696ebf6e43c343680a27057d",
            "leftCorner": {
              "x": 12.472,
              "y": 6.298,
              "z": 1.058
            },
            "rightCorner": {
              "x": 12.481,
              "y": 6.407,
              "z": 1.058
            },
            "gtin": "4067796274080",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27057e",
            "leftCorner": {
              "x": 12.482,
              "y": 6.402,
              "z": 1.059
            },
            "rightCorner": {
              "x": 12.485,
              "y": 6.44,
              "z": 1.059
            },
            "gtin": "4066447120479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27057f",
            "leftCorner": {
              "x": 12.485,
              "y": 6.44,
              "z": 1.059
            },
            "rightCorner": {
              "x": 12.489,
              "y": 6.497,
              "z": 1.059
            },
            "gtin": "4066447120479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270580",
            "leftCorner": {
              "x": 12.489,
              "y": 6.497,
              "z": 1.059
            },
            "rightCorner": {
              "x": 12.492,
              "y": 6.533,
              "z": 1.059
            }
          },
          {
            "id": "696ebf6e43c343680a270581",
            "leftCorner": {
              "x": 12.492,
              "y": 6.533,
              "z": 1.059
            },
            "rightCorner": {
              "x": 12.499,
              "y": 6.633,
              "z": 1.059
            },
            "gtin": "4010355375230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270582",
            "leftCorner": {
              "x": 12.499,
              "y": 6.633,
              "z": 1.059
            },
            "rightCorner": {
              "x": 12.506,
              "y": 6.725,
              "z": 1.059
            },
            "gtin": "4010355375230",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270583",
            "leftCorner": {
              "x": 12.506,
              "y": 6.725,
              "z": 1.059
            },
            "rightCorner": {
              "x": 12.514,
              "y": 6.839,
              "z": 1.059
            },
            "gtin": "4010355508300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270584",
            "leftCorner": {
              "x": 12.514,
              "y": 6.839,
              "z": 1.059
            },
            "rightCorner": {
              "x": 12.521,
              "y": 6.933,
              "z": 1.059
            },
            "gtin": "4010355375216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270585",
            "leftCorner": {
              "x": 12.521,
              "y": 6.933,
              "z": 1.059
            },
            "rightCorner": {
              "x": 12.53,
              "y": 7.051,
              "z": 1.059
            },
            "gtin": "4067796272727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270586",
            "leftCorner": {
              "x": 12.53,
              "y": 7.051,
              "z": 1.059
            },
            "rightCorner": {
              "x": 12.537,
              "y": 7.146,
              "z": 1.059
            },
            "gtin": "4066447238600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270587",
            "leftCorner": {
              "x": 12.537,
              "y": 7.146,
              "z": 1.059
            },
            "rightCorner": {
              "x": 12.544,
              "y": 7.247,
              "z": 1.059
            },
            "gtin": "4066447747409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270588",
            "leftCorner": {
              "x": 12.544,
              "y": 7.247,
              "z": 1.059
            },
            "rightCorner": {
              "x": 12.551,
              "y": 7.339,
              "z": 1.059
            },
            "gtin": "4058172640261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270589",
            "leftCorner": {
              "x": 12.551,
              "y": 7.339,
              "z": 1.059
            },
            "rightCorner": {
              "x": 12.558,
              "y": 7.432,
              "z": 1.059
            },
            "gtin": "4010355213082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27058a",
            "leftCorner": {
              "x": 12.558,
              "y": 7.432,
              "z": 1.059
            },
            "rightCorner": {
              "x": 12.564,
              "y": 7.52,
              "z": 1.059
            },
            "gtin": "4058172100505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27058b",
            "leftCorner": {
              "x": 12.564,
              "y": 7.52,
              "z": 1.059
            },
            "rightCorner": {
              "x": 12.571,
              "y": 7.606,
              "z": 1.059
            },
            "gtin": "4010355213129",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73977",
        "height": 1.3133,
        "facings": [
          {
            "id": "696ebf6e43c343680a2705a4",
            "leftCorner": {
              "x": 12.473,
              "y": 6.299,
              "z": 1.311
            },
            "rightCorner": {
              "x": 12.48,
              "y": 6.39,
              "z": 1.311
            },
            "gtin": "4067796254181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705a5",
            "leftCorner": {
              "x": 12.481,
              "y": 6.385,
              "z": 1.313
            },
            "rightCorner": {
              "x": 12.483,
              "y": 6.423,
              "z": 1.313
            },
            "gtin": "4067796254181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705a6",
            "leftCorner": {
              "x": 12.483,
              "y": 6.423,
              "z": 1.313
            },
            "rightCorner": {
              "x": 12.488,
              "y": 6.479,
              "z": 1.313
            },
            "gtin": "4058172100420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705a7",
            "leftCorner": {
              "x": 12.488,
              "y": 6.479,
              "z": 1.313
            },
            "rightCorner": {
              "x": 12.49,
              "y": 6.517,
              "z": 1.313
            }
          },
          {
            "id": "696ebf6e43c343680a2705a8",
            "leftCorner": {
              "x": 12.49,
              "y": 6.517,
              "z": 1.313
            },
            "rightCorner": {
              "x": 12.498,
              "y": 6.619,
              "z": 1.313
            },
            "gtin": "4010355214188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705a9",
            "leftCorner": {
              "x": 12.498,
              "y": 6.619,
              "z": 1.313
            },
            "rightCorner": {
              "x": 12.505,
              "y": 6.71,
              "z": 1.313
            },
            "gtin": "4066447120455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705aa",
            "leftCorner": {
              "x": 12.505,
              "y": 6.71,
              "z": 1.313
            },
            "rightCorner": {
              "x": 12.512,
              "y": 6.817,
              "z": 1.313
            }
          },
          {
            "id": "696ebf6e43c343680a2705ab",
            "leftCorner": {
              "x": 12.512,
              "y": 6.817,
              "z": 1.313
            },
            "rightCorner": {
              "x": 12.52,
              "y": 6.918,
              "z": 1.313
            },
            "gtin": "4010355213563",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705ac",
            "leftCorner": {
              "x": 12.52,
              "y": 6.918,
              "z": 1.313
            },
            "rightCorner": {
              "x": 12.534,
              "y": 7.107,
              "z": 1.313
            },
            "gtin": "4010355213600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705ad",
            "leftCorner": {
              "x": 12.534,
              "y": 7.107,
              "z": 1.313
            },
            "rightCorner": {
              "x": 12.541,
              "y": 7.207,
              "z": 1.313
            },
            "gtin": "4067796265170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705ae",
            "leftCorner": {
              "x": 12.541,
              "y": 7.207,
              "z": 1.313
            },
            "rightCorner": {
              "x": 12.548,
              "y": 7.307,
              "z": 1.313
            },
            "gtin": "4067796265194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705af",
            "leftCorner": {
              "x": 12.548,
              "y": 7.307,
              "z": 1.313
            },
            "rightCorner": {
              "x": 12.556,
              "y": 7.406,
              "z": 1.313
            },
            "gtin": "4058172100345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705b0",
            "leftCorner": {
              "x": 12.556,
              "y": 7.406,
              "z": 1.313
            },
            "rightCorner": {
              "x": 12.563,
              "y": 7.5,
              "z": 1.313
            }
          },
          {
            "id": "696ebf6e43c343680a2705b1",
            "leftCorner": {
              "x": 12.563,
              "y": 7.5,
              "z": 1.313
            },
            "rightCorner": {
              "x": 12.569,
              "y": 7.584,
              "z": 1.313
            },
            "gtin": "4058172100321",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73976",
        "height": 1.5257,
        "facings": [
          {
            "id": "696ebf6e43c343680a2705c6",
            "leftCorner": {
              "x": 12.486,
              "y": 6.39,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.488,
              "y": 6.427,
              "z": 1.526
            }
          },
          {
            "id": "696ebf6e43c343680a2705c7",
            "leftCorner": {
              "x": 12.488,
              "y": 6.427,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.493,
              "y": 6.486,
              "z": 1.526
            },
            "gtin": "4066447747362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705c8",
            "leftCorner": {
              "x": 12.493,
              "y": 6.486,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.496,
              "y": 6.523,
              "z": 1.526
            }
          },
          {
            "id": "696ebf6e43c343680a2705c9",
            "leftCorner": {
              "x": 12.496,
              "y": 6.523,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.503,
              "y": 6.621,
              "z": 1.526
            },
            "gtin": "4066447747386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705ca",
            "leftCorner": {
              "x": 12.503,
              "y": 6.621,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.511,
              "y": 6.726,
              "z": 1.526
            },
            "gtin": "4066447295092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705cb",
            "leftCorner": {
              "x": 12.511,
              "y": 6.726,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.519,
              "y": 6.836,
              "z": 1.526
            },
            "gtin": "4066447295092",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705cc",
            "leftCorner": {
              "x": 12.519,
              "y": 6.836,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.526,
              "y": 6.94,
              "z": 1.526
            },
            "gtin": "4066447295115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705cd",
            "leftCorner": {
              "x": 12.526,
              "y": 6.94,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.534,
              "y": 7.04,
              "z": 1.526
            },
            "gtin": "4066447238488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705ce",
            "leftCorner": {
              "x": 12.534,
              "y": 7.04,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.54,
              "y": 7.127,
              "z": 1.526
            }
          },
          {
            "id": "696ebf6e43c343680a2705cf",
            "leftCorner": {
              "x": 12.54,
              "y": 7.127,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.548,
              "y": 7.232,
              "z": 1.526
            },
            "gtin": "4066447238501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705d0",
            "leftCorner": {
              "x": 12.548,
              "y": 7.232,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.554,
              "y": 7.32,
              "z": 1.526
            },
            "gtin": "4010355556943",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705d1",
            "leftCorner": {
              "x": 12.554,
              "y": 7.32,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.56,
              "y": 7.403,
              "z": 1.526
            },
            "gtin": "4058172639883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705d2",
            "leftCorner": {
              "x": 12.56,
              "y": 7.403,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.567,
              "y": 7.497,
              "z": 1.526
            },
            "gtin": "4010355556929",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705d3",
            "leftCorner": {
              "x": 12.567,
              "y": 7.497,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.573,
              "y": 7.575,
              "z": 1.526
            },
            "gtin": "4010355556929",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73975",
        "height": 1.7735,
        "facings": [
          {
            "id": "696ebf6e43c343680a270476",
            "leftCorner": {
              "x": 12.487,
              "y": 6.387,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.489,
              "y": 6.425,
              "z": 1.774
            }
          },
          {
            "id": "696ebf6e43c343680a270477",
            "leftCorner": {
              "x": 12.489,
              "y": 6.425,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.5,
              "y": 6.569,
              "z": 1.774
            },
            "gtin": "4066447598056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270478",
            "leftCorner": {
              "x": 12.5,
              "y": 6.569,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.502,
              "y": 6.597,
              "z": 1.774
            }
          },
          {
            "id": "696ebf6e43c343680a270479",
            "leftCorner": {
              "x": 12.502,
              "y": 6.597,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.515,
              "y": 6.777,
              "z": 1.774
            },
            "gtin": "4066447195132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27047a",
            "leftCorner": {
              "x": 12.515,
              "y": 6.777,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.527,
              "y": 6.929,
              "z": 1.774
            },
            "gtin": "4058172639708",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27047b",
            "leftCorner": {
              "x": 12.527,
              "y": 6.929,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.537,
              "y": 7.068,
              "z": 1.774
            },
            "gtin": "4058172639708",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27047c",
            "leftCorner": {
              "x": 12.537,
              "y": 7.068,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.552,
              "y": 7.28,
              "z": 1.774
            },
            "gtin": "4058172639661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27047d",
            "leftCorner": {
              "x": 12.552,
              "y": 7.28,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.565,
              "y": 7.449,
              "z": 1.774
            },
            "gtin": "4058172639661",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27047e",
            "leftCorner": {
              "x": 12.565,
              "y": 7.449,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.574,
              "y": 7.578,
              "z": 1.774
            }
          }
        ]
      }
    ]
  },
  {
    "id": "68e757d2b5fe7bc046959a89",
    "name": "68e757d2b5fe7bc046959a89",
    "x": 12.531,
    "y": 7.58,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68268,
      "w": 0.73071
    },
    "statistics": {
      "hasStockCount": 28,
      "noStockCount": 2,
      "unknownStockCount": 34,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd7397f",
        "height": 0.20351,
        "facings": [
          {
            "id": "696ebf6e43c343680a2704e3",
            "leftCorner": {
              "x": 12.561,
              "y": 7.488,
              "z": 0.204
            },
            "rightCorner": {
              "x": 12.576,
              "y": 7.695,
              "z": 0.204
            },
            "gtin": "4067796254723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704e4",
            "leftCorner": {
              "x": 12.585,
              "y": 7.703,
              "z": 0.204
            },
            "rightCorner": {
              "x": 12.599,
              "y": 7.918,
              "z": 0.204
            },
            "gtin": "4058172100581",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704e5",
            "leftCorner": {
              "x": 12.599,
              "y": 7.918,
              "z": 0.204
            },
            "rightCorner": {
              "x": 12.609,
              "y": 8.064,
              "z": 0.204
            },
            "gtin": "8410136010422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704e6",
            "leftCorner": {
              "x": 12.609,
              "y": 8.064,
              "z": 0.204
            },
            "rightCorner": {
              "x": 12.62,
              "y": 8.219,
              "z": 0.204
            },
            "gtin": "8445290479693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704e7",
            "leftCorner": {
              "x": 12.62,
              "y": 8.219,
              "z": 0.204
            },
            "rightCorner": {
              "x": 12.631,
              "y": 8.382,
              "z": 0.204
            },
            "gtin": "8445291315167",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704e8",
            "leftCorner": {
              "x": 12.631,
              "y": 8.382,
              "z": 0.204
            },
            "rightCorner": {
              "x": 12.641,
              "y": 8.526,
              "z": 0.204
            },
            "gtin": "7613287908971",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704e9",
            "leftCorner": {
              "x": 12.641,
              "y": 8.526,
              "z": 0.204
            },
            "rightCorner": {
              "x": 12.65,
              "y": 8.663,
              "z": 0.204
            },
            "gtin": "7613287908780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704ea",
            "leftCorner": {
              "x": 12.65,
              "y": 8.663,
              "z": 0.204
            },
            "rightCorner": {
              "x": 12.66,
              "y": 8.813,
              "z": 0.204
            },
            "gtin": "7613032212728",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73981",
        "height": 0.51204,
        "facings": [
          {
            "id": "696ebf6e43c343680a2705e8",
            "leftCorner": {
              "x": 12.571,
              "y": 7.578,
              "z": 0.511
            },
            "rightCorner": {
              "x": 12.594,
              "y": 7.892,
              "z": 0.511
            },
            "gtin": "4058172100642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705e9",
            "leftCorner": {
              "x": 12.6,
              "y": 7.9,
              "z": 0.512
            },
            "rightCorner": {
              "x": 12.61,
              "y": 8.045,
              "z": 0.512
            }
          },
          {
            "id": "696ebf6e43c343680a2705ea",
            "leftCorner": {
              "x": 12.61,
              "y": 8.045,
              "z": 0.512
            },
            "rightCorner": {
              "x": 12.622,
              "y": 8.215,
              "z": 0.512
            },
            "gtin": "8445291157026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705eb",
            "leftCorner": {
              "x": 12.622,
              "y": 8.215,
              "z": 0.512
            },
            "rightCorner": {
              "x": 12.643,
              "y": 8.524,
              "z": 0.512
            },
            "gtin": "8445290494221",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705ec",
            "leftCorner": {
              "x": 12.643,
              "y": 8.524,
              "z": 0.512
            },
            "rightCorner": {
              "x": 12.652,
              "y": 8.659,
              "z": 0.512
            },
            "gtin": "8445290494245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705ed",
            "leftCorner": {
              "x": 12.652,
              "y": 8.659,
              "z": 0.512
            },
            "rightCorner": {
              "x": 12.663,
              "y": 8.817,
              "z": 0.512
            },
            "gtin": "8445290494245",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7397c",
        "height": 0.80511,
        "facings": [
          {
            "id": "696ebf6e43c343680a270563",
            "leftCorner": {
              "x": 12.571,
              "y": 7.555,
              "z": 0.806
            },
            "rightCorner": {
              "x": 12.575,
              "y": 7.62,
              "z": 0.806
            },
            "gtin": "4066447750768",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270564",
            "leftCorner": {
              "x": 12.581,
              "y": 7.628,
              "z": 0.805
            },
            "rightCorner": {
              "x": 12.587,
              "y": 7.709,
              "z": 0.805
            },
            "gtin": "4066447750768",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270565",
            "leftCorner": {
              "x": 12.587,
              "y": 7.709,
              "z": 0.805
            },
            "rightCorner": {
              "x": 12.592,
              "y": 7.786,
              "z": 0.805
            },
            "gtin": "4066447750744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270566",
            "leftCorner": {
              "x": 12.592,
              "y": 7.786,
              "z": 0.805
            },
            "rightCorner": {
              "x": 12.597,
              "y": 7.857,
              "z": 0.805
            },
            "gtin": "4058172589607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270567",
            "leftCorner": {
              "x": 12.597,
              "y": 7.857,
              "z": 0.805
            },
            "rightCorner": {
              "x": 12.602,
              "y": 7.933,
              "z": 0.805
            },
            "gtin": "4058172100284",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270568",
            "leftCorner": {
              "x": 12.602,
              "y": 7.933,
              "z": 0.805
            },
            "rightCorner": {
              "x": 12.607,
              "y": 8.008,
              "z": 0.805
            },
            "gtin": "4066447670660",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270569",
            "leftCorner": {
              "x": 12.607,
              "y": 8.008,
              "z": 0.805
            },
            "rightCorner": {
              "x": 12.614,
              "y": 8.107,
              "z": 0.805
            },
            "gtin": "4066447295016",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27056a",
            "leftCorner": {
              "x": 12.614,
              "y": 8.107,
              "z": 0.805
            },
            "rightCorner": {
              "x": 12.621,
              "y": 8.219,
              "z": 0.805
            },
            "gtin": "4058172319358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27056b",
            "leftCorner": {
              "x": 12.621,
              "y": 8.219,
              "z": 0.805
            },
            "rightCorner": {
              "x": 12.629,
              "y": 8.329,
              "z": 0.805
            },
            "gtin": "4066447494907",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27056c",
            "leftCorner": {
              "x": 12.629,
              "y": 8.329,
              "z": 0.805
            },
            "rightCorner": {
              "x": 12.635,
              "y": 8.424,
              "z": 0.805
            }
          },
          {
            "id": "696ebf6e43c343680a27056d",
            "leftCorner": {
              "x": 12.635,
              "y": 8.424,
              "z": 0.805
            },
            "rightCorner": {
              "x": 12.642,
              "y": 8.517,
              "z": 0.805
            },
            "gtin": "7613032729400",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27056e",
            "leftCorner": {
              "x": 12.642,
              "y": 8.517,
              "z": 0.805
            },
            "rightCorner": {
              "x": 12.648,
              "y": 8.615,
              "z": 0.805
            },
            "gtin": "7613032729370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27056f",
            "leftCorner": {
              "x": 12.648,
              "y": 8.615,
              "z": 0.805
            },
            "rightCorner": {
              "x": 12.656,
              "y": 8.732,
              "z": 0.805
            },
            "gtin": "7613034460981",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27054b",
            "leftCorner": {
              "x": 12.656,
              "y": 8.732,
              "z": 0.805
            },
            "rightCorner": {
              "x": 12.663,
              "y": 8.824,
              "z": 0.805
            },
            "gtin": "7613034451804",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7397e",
        "height": 1.0605,
        "facings": [
          {
            "id": "696ebf6e43c343680a27058c",
            "leftCorner": {
              "x": 12.582,
              "y": 7.614,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.588,
              "y": 7.713,
              "z": 1.06
            }
          },
          {
            "id": "696ebf6e43c343680a27058d",
            "leftCorner": {
              "x": 12.588,
              "y": 7.713,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.595,
              "y": 7.808,
              "z": 1.06
            },
            "gtin": "4058172319198",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27058e",
            "leftCorner": {
              "x": 12.595,
              "y": 7.808,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.602,
              "y": 7.907,
              "z": 1.06
            },
            "gtin": "4058172318955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27058f",
            "leftCorner": {
              "x": 12.602,
              "y": 7.907,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.608,
              "y": 8.002,
              "z": 1.06
            },
            "gtin": "4066447703580",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270590",
            "leftCorner": {
              "x": 12.608,
              "y": 8.002,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.614,
              "y": 8.095,
              "z": 1.06
            },
            "gtin": "4260748894354",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270591",
            "leftCorner": {
              "x": 12.614,
              "y": 8.095,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.622,
              "y": 8.202,
              "z": 1.06
            },
            "gtin": "4260748894293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270592",
            "leftCorner": {
              "x": 12.622,
              "y": 8.202,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.626,
              "y": 8.266,
              "z": 1.06
            },
            "gtin": "7613287070067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270593",
            "leftCorner": {
              "x": 12.626,
              "y": 8.266,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.635,
              "y": 8.394,
              "z": 1.06
            },
            "gtin": "8445291446663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270594",
            "leftCorner": {
              "x": 12.635,
              "y": 8.394,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.643,
              "y": 8.515,
              "z": 1.06
            },
            "gtin": "7613287071125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270595",
            "leftCorner": {
              "x": 12.643,
              "y": 8.515,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.65,
              "y": 8.625,
              "z": 1.06
            },
            "gtin": "4000487225947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270596",
            "leftCorner": {
              "x": 12.65,
              "y": 8.625,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.658,
              "y": 8.739,
              "z": 1.06
            },
            "gtin": "7613033058103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270571",
            "leftCorner": {
              "x": 12.658,
              "y": 8.739,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.664,
              "y": 8.824,
              "z": 1.06
            },
            "gtin": "4000487225923",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73980",
        "height": 1.3147,
        "facings": [
          {
            "id": "696ebf6e43c343680a2705b2",
            "leftCorner": {
              "x": 12.581,
              "y": 7.592,
              "z": 1.315
            },
            "rightCorner": {
              "x": 12.588,
              "y": 7.689,
              "z": 1.315
            },
            "gtin": "4058172100109",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705b3",
            "leftCorner": {
              "x": 12.588,
              "y": 7.689,
              "z": 1.315
            },
            "rightCorner": {
              "x": 12.596,
              "y": 7.811,
              "z": 1.315
            },
            "gtin": "4058172100109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705b4",
            "leftCorner": {
              "x": 12.596,
              "y": 7.811,
              "z": 1.315
            },
            "rightCorner": {
              "x": 12.603,
              "y": 7.916,
              "z": 1.315
            },
            "gtin": "4058172100123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705b5",
            "leftCorner": {
              "x": 12.603,
              "y": 7.916,
              "z": 1.315
            },
            "rightCorner": {
              "x": 12.609,
              "y": 7.999,
              "z": 1.315
            },
            "gtin": "4058172100123",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705b6",
            "leftCorner": {
              "x": 12.609,
              "y": 7.999,
              "z": 1.315
            },
            "rightCorner": {
              "x": 12.615,
              "y": 8.089,
              "z": 1.315
            },
            "gtin": "4058172100123",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705b7",
            "leftCorner": {
              "x": 12.615,
              "y": 8.089,
              "z": 1.315
            },
            "rightCorner": {
              "x": 12.622,
              "y": 8.183,
              "z": 1.315
            },
            "gtin": "8710255100098",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705b8",
            "leftCorner": {
              "x": 12.622,
              "y": 8.183,
              "z": 1.315
            },
            "rightCorner": {
              "x": 12.632,
              "y": 8.341,
              "z": 1.315
            },
            "gtin": "8710255189123",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705b9",
            "leftCorner": {
              "x": 12.632,
              "y": 8.341,
              "z": 1.315
            },
            "rightCorner": {
              "x": 12.638,
              "y": 8.431,
              "z": 1.315
            },
            "gtin": "8710255100050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705ba",
            "leftCorner": {
              "x": 12.638,
              "y": 8.431,
              "z": 1.315
            },
            "rightCorner": {
              "x": 12.651,
              "y": 8.623,
              "z": 1.315
            },
            "gtin": "7613034581266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270598",
            "leftCorner": {
              "x": 12.651,
              "y": 8.623,
              "z": 1.315
            },
            "rightCorner": {
              "x": 12.665,
              "y": 8.824,
              "z": 1.315
            },
            "gtin": "7613034580801",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7397d",
        "height": 1.5262,
        "facings": [
          {
            "id": "696ebf6e43c343680a2705d4",
            "leftCorner": {
              "x": 12.587,
              "y": 7.583,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.593,
              "y": 7.678,
              "z": 1.526
            },
            "gtin": "4260688851400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705d5",
            "leftCorner": {
              "x": 12.593,
              "y": 7.678,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.6,
              "y": 7.781,
              "z": 1.526
            },
            "gtin": "4260688851363",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705d6",
            "leftCorner": {
              "x": 12.6,
              "y": 7.781,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.606,
              "y": 7.868,
              "z": 1.526
            },
            "gtin": "4260688851387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705d7",
            "leftCorner": {
              "x": 12.606,
              "y": 7.868,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.613,
              "y": 7.968,
              "z": 1.526
            },
            "gtin": "4260688851448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705d8",
            "leftCorner": {
              "x": 12.613,
              "y": 7.968,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.619,
              "y": 8.054,
              "z": 1.526
            },
            "gtin": "7613038187587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705d9",
            "leftCorner": {
              "x": 12.619,
              "y": 8.054,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.624,
              "y": 8.123,
              "z": 1.526
            },
            "gtin": "7613038187587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705da",
            "leftCorner": {
              "x": 12.624,
              "y": 8.123,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.629,
              "y": 8.199,
              "z": 1.526
            },
            "gtin": "7613038187587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705db",
            "leftCorner": {
              "x": 12.629,
              "y": 8.199,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.634,
              "y": 8.272,
              "z": 1.526
            },
            "gtin": "7613038194899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705dc",
            "leftCorner": {
              "x": 12.634,
              "y": 8.272,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.643,
              "y": 8.411,
              "z": 1.526
            },
            "gtin": "7613035464322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705dd",
            "leftCorner": {
              "x": 12.643,
              "y": 8.411,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.653,
              "y": 8.559,
              "z": 1.526
            },
            "gtin": "8445291352100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705de",
            "leftCorner": {
              "x": 12.653,
              "y": 8.559,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.663,
              "y": 8.696,
              "z": 1.526
            },
            "gtin": "7613032286378",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705bc",
            "leftCorner": {
              "x": 12.663,
              "y": 8.696,
              "z": 1.526
            },
            "rightCorner": {
              "x": 12.671,
              "y": 8.823,
              "z": 1.526
            },
            "gtin": "7613032286378",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73982",
        "height": 1.7737,
        "facings": [
          {
            "id": "696ebf6e43c343680a27047f",
            "leftCorner": {
              "x": 12.587,
              "y": 7.586,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.597,
              "y": 7.729,
              "z": 1.774
            },
            "gtin": "4058172323973",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270480",
            "leftCorner": {
              "x": 12.597,
              "y": 7.729,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.607,
              "y": 7.88,
              "z": 1.774
            }
          },
          {
            "id": "696ebf6e43c343680a270481",
            "leftCorner": {
              "x": 12.607,
              "y": 7.88,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.616,
              "y": 8.018,
              "z": 1.774
            }
          },
          {
            "id": "696ebf6e43c343680a270482",
            "leftCorner": {
              "x": 12.616,
              "y": 8.018,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.634,
              "y": 8.278,
              "z": 1.774
            },
            "gtin": "4262437745145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270483",
            "leftCorner": {
              "x": 12.634,
              "y": 8.278,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.648,
              "y": 8.477,
              "z": 1.774
            },
            "gtin": "7613032727826",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270484",
            "leftCorner": {
              "x": 12.648,
              "y": 8.477,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.654,
              "y": 8.573,
              "z": 1.774
            }
          },
          {
            "id": "696ebf6e43c343680a270485",
            "leftCorner": {
              "x": 12.654,
              "y": 8.573,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.667,
              "y": 8.756,
              "z": 1.774
            },
            "gtin": "8710255192031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270486",
            "leftCorner": {
              "x": 12.667,
              "y": 8.756,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.679,
              "y": 8.935,
              "z": 1.774
            },
            "gtin": "8710255150529",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757d2b5fe7bc046959a8a",
    "name": "68e757d2b5fe7bc046959a8a",
    "x": 12.624,
    "y": 8.832,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68386,
      "w": 0.72961
    },
    "statistics": {
      "hasStockCount": 40,
      "noStockCount": 2,
      "unknownStockCount": 35,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73987",
        "height": 0.20516,
        "facings": [
          {
            "id": "696ebf6e43c343680a2704eb",
            "leftCorner": {
              "x": 12.66,
              "y": 8.813,
              "z": 0.204
            },
            "rightCorner": {
              "x": 12.68,
              "y": 9.11,
              "z": 0.204
            },
            "gtin": "4770608253769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704ec",
            "leftCorner": {
              "x": 12.687,
              "y": 9.115,
              "z": 0.205
            },
            "rightCorner": {
              "x": 12.707,
              "y": 9.425,
              "z": 0.205
            },
            "gtin": "4770608255626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704ed",
            "leftCorner": {
              "x": 12.707,
              "y": 9.425,
              "z": 0.205
            },
            "rightCorner": {
              "x": 12.716,
              "y": 9.563,
              "z": 0.205
            },
            "gtin": "3065890158306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2704ee",
            "leftCorner": {
              "x": 12.716,
              "y": 9.563,
              "z": 0.205
            },
            "rightCorner": {
              "x": 12.728,
              "y": 9.755,
              "z": 0.205
            },
            "gtin": "4008429168406",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2704c2",
            "leftCorner": {
              "x": 12.728,
              "y": 9.755,
              "z": 0.205
            },
            "rightCorner": {
              "x": 12.749,
              "y": 10.077,
              "z": 0.205
            },
            "gtin": "4008429168352",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73989",
        "height": 0.51412,
        "facings": [
          {
            "id": "696ebf6e43c343680a2705ee",
            "leftCorner": {
              "x": 12.663,
              "y": 8.817,
              "z": 0.512
            },
            "rightCorner": {
              "x": 12.672,
              "y": 8.95,
              "z": 0.512
            },
            "gtin": "8445290083586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705ef",
            "leftCorner": {
              "x": 12.671,
              "y": 8.955,
              "z": 0.514
            },
            "rightCorner": {
              "x": 12.681,
              "y": 9.101,
              "z": 0.514
            },
            "gtin": "8445290083548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705f0",
            "leftCorner": {
              "x": 12.681,
              "y": 9.101,
              "z": 0.514
            },
            "rightCorner": {
              "x": 12.69,
              "y": 9.245,
              "z": 0.514
            },
            "gtin": "8445290083302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705f1",
            "leftCorner": {
              "x": 12.69,
              "y": 9.245,
              "z": 0.514
            },
            "rightCorner": {
              "x": 12.699,
              "y": 9.391,
              "z": 0.514
            },
            "gtin": "8445290084750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705f2",
            "leftCorner": {
              "x": 12.699,
              "y": 9.391,
              "z": 0.514
            },
            "rightCorner": {
              "x": 12.706,
              "y": 9.49,
              "z": 0.514
            },
            "gtin": "7613036894784",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705f3",
            "leftCorner": {
              "x": 12.706,
              "y": 9.49,
              "z": 0.514
            },
            "rightCorner": {
              "x": 12.715,
              "y": 9.626,
              "z": 0.514
            },
            "gtin": "7613036894869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705f4",
            "leftCorner": {
              "x": 12.715,
              "y": 9.626,
              "z": 0.514
            },
            "rightCorner": {
              "x": 12.729,
              "y": 9.852,
              "z": 0.514
            },
            "gtin": "7613036631976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705f5",
            "leftCorner": {
              "x": 12.729,
              "y": 9.852,
              "z": 0.514
            },
            "rightCorner": {
              "x": 12.741,
              "y": 10.039,
              "z": 0.514
            },
            "gtin": "7613036631952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705e0",
            "leftCorner": {
              "x": 12.741,
              "y": 10.039,
              "z": 0.514
            },
            "rightCorner": {
              "x": 12.744,
              "y": 10.077,
              "z": 0.514
            }
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd7398a",
        "height": 0.72271,
        "facings": [
          {
            "id": "696ebf6e43c343680a270626",
            "leftCorner": {
              "x": 12.666,
              "y": 8.851,
              "z": 0.723
            },
            "rightCorner": {
              "x": 12.672,
              "y": 8.94,
              "z": 0.723
            },
            "gtin": "4770608265823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270627",
            "leftCorner": {
              "x": 12.672,
              "y": 8.94,
              "z": 0.723
            },
            "rightCorner": {
              "x": 12.677,
              "y": 9.03,
              "z": 0.723
            },
            "gtin": "4770608265823",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270628",
            "leftCorner": {
              "x": 12.677,
              "y": 9.03,
              "z": 0.723
            },
            "rightCorner": {
              "x": 12.684,
              "y": 9.137,
              "z": 0.723
            },
            "gtin": "4770608266264",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270629",
            "leftCorner": {
              "x": 12.684,
              "y": 9.137,
              "z": 0.723
            },
            "rightCorner": {
              "x": 12.69,
              "y": 9.224,
              "z": 0.723
            },
            "gtin": "4770608266097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27062a",
            "leftCorner": {
              "x": 12.69,
              "y": 9.224,
              "z": 0.723
            },
            "rightCorner": {
              "x": 12.697,
              "y": 9.326,
              "z": 0.723
            },
            "gtin": "4770608265915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27062b",
            "leftCorner": {
              "x": 12.697,
              "y": 9.326,
              "z": 0.723
            },
            "rightCorner": {
              "x": 12.702,
              "y": 9.41,
              "z": 0.723
            },
            "gtin": "4008429134715",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27062c",
            "leftCorner": {
              "x": 12.702,
              "y": 9.41,
              "z": 0.723
            },
            "rightCorner": {
              "x": 12.708,
              "y": 9.497,
              "z": 0.723
            },
            "gtin": "4008429134739",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27062d",
            "leftCorner": {
              "x": 12.708,
              "y": 9.497,
              "z": 0.723
            },
            "rightCorner": {
              "x": 12.714,
              "y": 9.593,
              "z": 0.723
            },
            "gtin": "4008429134197",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27062e",
            "leftCorner": {
              "x": 12.714,
              "y": 9.593,
              "z": 0.723
            },
            "rightCorner": {
              "x": 12.727,
              "y": 9.798,
              "z": 0.723
            },
            "gtin": "8853301003629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27062f",
            "leftCorner": {
              "x": 12.727,
              "y": 9.798,
              "z": 0.723
            },
            "rightCorner": {
              "x": 12.739,
              "y": 9.979,
              "z": 0.723
            },
            "gtin": "8853301003568",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270630",
            "leftCorner": {
              "x": 12.739,
              "y": 9.979,
              "z": 0.723
            },
            "rightCorner": {
              "x": 12.744,
              "y": 10.059,
              "z": 0.723
            },
            "gtin": "8853301003506",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73985",
        "height": 0.93468,
        "facings": [
          {
            "id": "696ebf6e43c343680a27060d",
            "leftCorner": {
              "x": 12.663,
              "y": 8.83,
              "z": 0.935
            },
            "rightCorner": {
              "x": 12.67,
              "y": 8.937,
              "z": 0.935
            },
            "gtin": "9120063681006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27060f",
            "leftCorner": {
              "x": 12.67,
              "y": 8.937,
              "z": 0.935
            },
            "rightCorner": {
              "x": 12.676,
              "y": 9.03,
              "z": 0.935
            },
            "gtin": "9120063680962",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270610",
            "leftCorner": {
              "x": 12.676,
              "y": 9.03,
              "z": 0.935
            },
            "rightCorner": {
              "x": 12.682,
              "y": 9.124,
              "z": 0.935
            },
            "gtin": "9120063680979",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270611",
            "leftCorner": {
              "x": 12.682,
              "y": 9.124,
              "z": 0.935
            },
            "rightCorner": {
              "x": 12.689,
              "y": 9.226,
              "z": 0.935
            },
            "gtin": "4260748894712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270612",
            "leftCorner": {
              "x": 12.689,
              "y": 9.226,
              "z": 0.935
            },
            "rightCorner": {
              "x": 12.696,
              "y": 9.331,
              "z": 0.935
            },
            "gtin": "4260748894651",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270613",
            "leftCorner": {
              "x": 12.696,
              "y": 9.331,
              "z": 0.935
            },
            "rightCorner": {
              "x": 12.7,
              "y": 9.405,
              "z": 0.935
            },
            "gtin": "4260748890196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270614",
            "leftCorner": {
              "x": 12.7,
              "y": 9.405,
              "z": 0.935
            },
            "rightCorner": {
              "x": 12.706,
              "y": 9.497,
              "z": 0.935
            },
            "gtin": "4260748890165",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270615",
            "leftCorner": {
              "x": 12.706,
              "y": 9.497,
              "z": 0.935
            },
            "rightCorner": {
              "x": 12.712,
              "y": 9.588,
              "z": 0.935
            },
            "gtin": "4770608259556",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270616",
            "leftCorner": {
              "x": 12.712,
              "y": 9.588,
              "z": 0.935
            },
            "rightCorner": {
              "x": 12.719,
              "y": 9.687,
              "z": 0.935
            },
            "gtin": "4770608259556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270617",
            "leftCorner": {
              "x": 12.719,
              "y": 9.687,
              "z": 0.935
            },
            "rightCorner": {
              "x": 12.726,
              "y": 9.798,
              "z": 0.935
            },
            "gtin": "4770608259549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270618",
            "leftCorner": {
              "x": 12.726,
              "y": 9.798,
              "z": 0.935
            },
            "rightCorner": {
              "x": 12.732,
              "y": 9.893,
              "z": 0.935
            },
            "gtin": "4008429131721",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270619",
            "leftCorner": {
              "x": 12.732,
              "y": 9.893,
              "z": 0.935
            },
            "rightCorner": {
              "x": 12.739,
              "y": 9.997,
              "z": 0.935
            },
            "gtin": "4008429131721",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27060e",
            "leftCorner": {
              "x": 12.739,
              "y": 9.997,
              "z": 0.935
            },
            "rightCorner": {
              "x": 12.744,
              "y": 10.077,
              "z": 0.935
            },
            "gtin": "4008429122521",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73984",
        "height": 1.1488,
        "facings": [
          {
            "id": "696ebf6e43c343680a270601",
            "leftCorner": {
              "x": 12.666,
              "y": 8.829,
              "z": 1.149
            },
            "rightCorner": {
              "x": 12.673,
              "y": 8.929,
              "z": 1.149
            },
            "gtin": "7613035754942",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270603",
            "leftCorner": {
              "x": 12.673,
              "y": 8.929,
              "z": 1.149
            },
            "rightCorner": {
              "x": 12.679,
              "y": 9.03,
              "z": 1.149
            },
            "gtin": "7613035754614",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270604",
            "leftCorner": {
              "x": 12.679,
              "y": 9.03,
              "z": 1.149
            },
            "rightCorner": {
              "x": 12.69,
              "y": 9.198,
              "z": 1.149
            },
            "gtin": "4260165197540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270605",
            "leftCorner": {
              "x": 12.69,
              "y": 9.198,
              "z": 1.149
            },
            "rightCorner": {
              "x": 12.697,
              "y": 9.303,
              "z": 1.149
            },
            "gtin": "4260165197649",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270606",
            "leftCorner": {
              "x": 12.697,
              "y": 9.303,
              "z": 1.149
            },
            "rightCorner": {
              "x": 12.703,
              "y": 9.399,
              "z": 1.149
            },
            "gtin": "9120063688395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270607",
            "leftCorner": {
              "x": 12.703,
              "y": 9.399,
              "z": 1.149
            },
            "rightCorner": {
              "x": 12.709,
              "y": 9.499,
              "z": 1.149
            },
            "gtin": "9120063688418",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270608",
            "leftCorner": {
              "x": 12.709,
              "y": 9.499,
              "z": 1.149
            },
            "rightCorner": {
              "x": 12.715,
              "y": 9.59,
              "z": 1.149
            },
            "gtin": "9120063688401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270609",
            "leftCorner": {
              "x": 12.715,
              "y": 9.59,
              "z": 1.149
            },
            "rightCorner": {
              "x": 12.722,
              "y": 9.687,
              "z": 1.149
            },
            "gtin": "4250231536472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27060a",
            "leftCorner": {
              "x": 12.722,
              "y": 9.687,
              "z": 1.149
            },
            "rightCorner": {
              "x": 12.728,
              "y": 9.792,
              "z": 1.149
            },
            "gtin": "4250231536472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27060b",
            "leftCorner": {
              "x": 12.728,
              "y": 9.792,
              "z": 1.149
            },
            "rightCorner": {
              "x": 12.735,
              "y": 9.889,
              "z": 1.149
            },
            "gtin": "4250231536410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27060c",
            "leftCorner": {
              "x": 12.735,
              "y": 9.889,
              "z": 1.149
            },
            "rightCorner": {
              "x": 12.741,
              "y": 9.983,
              "z": 1.149
            },
            "gtin": "4250231536458",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270602",
            "leftCorner": {
              "x": 12.741,
              "y": 9.983,
              "z": 1.149
            },
            "rightCorner": {
              "x": 12.747,
              "y": 10.077,
              "z": 1.149
            },
            "gtin": "4250231536373",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73986",
        "height": 1.3603,
        "facings": [
          {
            "id": "696ebf6e43c343680a27061a",
            "leftCorner": {
              "x": 12.666,
              "y": 8.829,
              "z": 1.36
            },
            "rightCorner": {
              "x": 12.674,
              "y": 8.95,
              "z": 1.36
            },
            "gtin": "8005852171139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27061c",
            "leftCorner": {
              "x": 12.674,
              "y": 8.95,
              "z": 1.36
            },
            "rightCorner": {
              "x": 12.681,
              "y": 9.049,
              "z": 1.36
            },
            "gtin": "8005852171108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27061d",
            "leftCorner": {
              "x": 12.681,
              "y": 9.049,
              "z": 1.36
            },
            "rightCorner": {
              "x": 12.687,
              "y": 9.148,
              "z": 1.36
            },
            "gtin": "8005852171054",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27061e",
            "leftCorner": {
              "x": 12.687,
              "y": 9.148,
              "z": 1.36
            },
            "rightCorner": {
              "x": 12.693,
              "y": 9.242,
              "z": 1.36
            },
            "gtin": "8005852171009",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27061f",
            "leftCorner": {
              "x": 12.693,
              "y": 9.242,
              "z": 1.36
            },
            "rightCorner": {
              "x": 12.697,
              "y": 9.306,
              "z": 1.36
            },
            "gtin": "8005852750150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270620",
            "leftCorner": {
              "x": 12.697,
              "y": 9.306,
              "z": 1.36
            },
            "rightCorner": {
              "x": 12.703,
              "y": 9.395,
              "z": 1.36
            },
            "gtin": "9120063685608",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270621",
            "leftCorner": {
              "x": 12.703,
              "y": 9.395,
              "z": 1.36
            },
            "rightCorner": {
              "x": 12.709,
              "y": 9.491,
              "z": 1.36
            },
            "gtin": "9120063685615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270622",
            "leftCorner": {
              "x": 12.709,
              "y": 9.491,
              "z": 1.36
            },
            "rightCorner": {
              "x": 12.715,
              "y": 9.578,
              "z": 1.36
            },
            "gtin": "9120063685646",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270623",
            "leftCorner": {
              "x": 12.715,
              "y": 9.578,
              "z": 1.36
            },
            "rightCorner": {
              "x": 12.722,
              "y": 9.691,
              "z": 1.36
            },
            "gtin": "4026813571502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270624",
            "leftCorner": {
              "x": 12.722,
              "y": 9.691,
              "z": 1.36
            },
            "rightCorner": {
              "x": 12.728,
              "y": 9.78,
              "z": 1.36
            },
            "gtin": "4026813571533",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270625",
            "leftCorner": {
              "x": 12.728,
              "y": 9.78,
              "z": 1.36
            },
            "rightCorner": {
              "x": 12.734,
              "y": 9.878,
              "z": 1.36
            },
            "gtin": "4026813571526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27061b",
            "leftCorner": {
              "x": 12.734,
              "y": 9.878,
              "z": 1.36
            },
            "rightCorner": {
              "x": 12.747,
              "y": 10.077,
              "z": 1.36
            },
            "gtin": "8595606406759",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73983",
        "height": 1.568,
        "facings": [
          {
            "id": "696ebf6e43c343680a2705f6",
            "leftCorner": {
              "x": 12.669,
              "y": 8.829,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.676,
              "y": 8.933,
              "z": 1.568
            },
            "gtin": "4260345753177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705f8",
            "leftCorner": {
              "x": 12.676,
              "y": 8.933,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.682,
              "y": 9.027,
              "z": 1.568
            },
            "gtin": "4260345753313",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705f9",
            "leftCorner": {
              "x": 12.682,
              "y": 9.027,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.688,
              "y": 9.119,
              "z": 1.568
            },
            "gtin": "4260345753207",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705fa",
            "leftCorner": {
              "x": 12.688,
              "y": 9.119,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.695,
              "y": 9.237,
              "z": 1.568
            },
            "gtin": "4260345755058",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705fb",
            "leftCorner": {
              "x": 12.695,
              "y": 9.237,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.703,
              "y": 9.356,
              "z": 1.568
            },
            "gtin": "4260345755058",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705fc",
            "leftCorner": {
              "x": 12.703,
              "y": 9.356,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.71,
              "y": 9.469,
              "z": 1.568
            },
            "gtin": "4260345755058",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705fd",
            "leftCorner": {
              "x": 12.71,
              "y": 9.469,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.717,
              "y": 9.566,
              "z": 1.568
            },
            "gtin": "4260688858850",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705fe",
            "leftCorner": {
              "x": 12.717,
              "y": 9.566,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.723,
              "y": 9.672,
              "z": 1.568
            },
            "gtin": "4260688858843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2705ff",
            "leftCorner": {
              "x": 12.723,
              "y": 9.672,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.731,
              "y": 9.783,
              "z": 1.568
            },
            "gtin": "4260688858829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270600",
            "leftCorner": {
              "x": 12.731,
              "y": 9.783,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.737,
              "y": 9.874,
              "z": 1.568
            },
            "gtin": "4262422871569",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2705f7",
            "leftCorner": {
              "x": 12.737,
              "y": 9.874,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.75,
              "y": 10.077,
              "z": 1.568
            },
            "gtin": "8595606406766",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73988",
        "height": 1.7743,
        "facings": [
          {
            "id": "696ebf6e43c343680a270487",
            "leftCorner": {
              "x": 12.68,
              "y": 8.94,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.693,
              "y": 9.128,
              "z": 1.774
            },
            "gtin": "4008429114649",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270488",
            "leftCorner": {
              "x": 12.693,
              "y": 9.128,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.702,
              "y": 9.27,
              "z": 1.774
            },
            "gtin": "4008429114663",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270489",
            "leftCorner": {
              "x": 12.702,
              "y": 9.27,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.723,
              "y": 9.594,
              "z": 1.774
            },
            "gtin": "4008429088711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27048a",
            "leftCorner": {
              "x": 12.723,
              "y": 9.594,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.742,
              "y": 9.882,
              "z": 1.774
            },
            "gtin": "4008429088360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27048b",
            "leftCorner": {
              "x": 12.742,
              "y": 9.882,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.754,
              "y": 10.069,
              "z": 1.774
            },
            "gtin": "5900951307775",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e757d2b5fe7bc046959a8b",
    "name": "68e757d2b5fe7bc046959a8b",
    "x": 12.601,
    "y": 10.088,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.65976,
      "w": 0.75147
    },
    "statistics": {
      "hasStockCount": 2,
      "noStockCount": 0,
      "unknownStockCount": 8,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73c4a",
        "height": 1.1892,
        "facings": [
          {
            "id": "696ebf7143c343680a2720cd",
            "leftCorner": {
              "x": 12.709,
              "y": 10.074,
              "z": 1.189
            },
            "rightCorner": {
              "x": 12.722,
              "y": 10.171,
              "z": 1.189
            },
            "gtin": "4002064605159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a2720cf",
            "leftCorner": {
              "x": 12.722,
              "y": 10.171,
              "z": 1.189
            },
            "rightCorner": {
              "x": 12.833,
              "y": 11.02,
              "z": 1.189
            },
            "gtin": "4058172319686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a2720ce",
            "leftCorner": {
              "x": 12.833,
              "y": 11.02,
              "z": 1.189
            },
            "rightCorner": {
              "x": 12.871,
              "y": 11.313,
              "z": 1.189
            },
            "gtin": "4010355298423",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c49",
        "height": 1.7759,
        "facings": [
          {
            "id": "696ebf6e43c343680a27048c",
            "leftCorner": {
              "x": 12.754,
              "y": 10.069,
              "z": 1.774
            },
            "rightCorner": {
              "x": 12.767,
              "y": 10.273,
              "z": 1.774
            },
            "gtin": "4260688859512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27048d",
            "leftCorner": {
              "x": 12.743,
              "y": 10.268,
              "z": 1.776
            },
            "rightCorner": {
              "x": 12.762,
              "y": 10.413,
              "z": 1.776
            },
            "gtin": "8595606405271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27048e",
            "leftCorner": {
              "x": 12.762,
              "y": 10.413,
              "z": 1.776
            },
            "rightCorner": {
              "x": 12.783,
              "y": 10.576,
              "z": 1.776
            },
            "gtin": "8445290312112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27048f",
            "leftCorner": {
              "x": 12.783,
              "y": 10.576,
              "z": 1.776
            },
            "rightCorner": {
              "x": 12.81,
              "y": 10.783,
              "z": 1.776
            },
            "gtin": "8445290311801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270490",
            "leftCorner": {
              "x": 12.81,
              "y": 10.783,
              "z": 1.776
            },
            "rightCorner": {
              "x": 12.837,
              "y": 10.992,
              "z": 1.776
            },
            "gtin": "8445290312167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270491",
            "leftCorner": {
              "x": 12.837,
              "y": 10.992,
              "z": 1.776
            },
            "rightCorner": {
              "x": 12.842,
              "y": 11.029,
              "z": 1.776
            }
          },
          {
            "id": "696ebf6e43c343680a270492",
            "leftCorner": {
              "x": 12.842,
              "y": 11.029,
              "z": 1.776
            },
            "rightCorner": {
              "x": 12.86,
              "y": 11.167,
              "z": 1.776
            },
            "gtin": "8445290311900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270449",
            "leftCorner": {
              "x": 12.86,
              "y": 11.167,
              "z": 1.776
            },
            "rightCorner": {
              "x": 12.879,
              "y": 11.312,
              "z": 1.776
            },
            "gtin": "8445290311900",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "68e76371b5fe7bc046959aae",
    "name": "68e76371b5fe7bc046959aae",
    "x": 0.19577,
    "y": -17.794,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69391,
      "w": 0.72007
    },
    "statistics": {
      "hasStockCount": 50,
      "noStockCount": 4,
      "unknownStockCount": 24
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73c50",
        "height": 0.17328,
        "facings": [
          {
            "id": "696ebf6f43c343680a270b7b",
            "leftCorner": {
              "x": 0.237,
              "y": -17.796,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.243,
              "y": -17.633,
              "z": 0.173
            },
            "gtin": "4015100809961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b7c",
            "leftCorner": {
              "x": 0.243,
              "y": -17.633,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.245,
              "y": -17.581,
              "z": 0.173
            }
          },
          {
            "id": "696ebf6f43c343680a270b7d",
            "leftCorner": {
              "x": 0.245,
              "y": -17.581,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.247,
              "y": -17.534,
              "z": 0.173
            },
            "gtin": "4015100810028",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b7e",
            "leftCorner": {
              "x": 0.247,
              "y": -17.534,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.25,
              "y": -17.458,
              "z": 0.173
            },
            "gtin": "4015100810080",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b7f",
            "leftCorner": {
              "x": 0.25,
              "y": -17.458,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.252,
              "y": -17.398,
              "z": 0.173
            },
            "gtin": "4005900749680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b80",
            "leftCorner": {
              "x": 0.252,
              "y": -17.398,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.254,
              "y": -17.337,
              "z": 0.173
            },
            "gtin": "4005900749727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b81",
            "leftCorner": {
              "x": 0.254,
              "y": -17.337,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.258,
              "y": -17.232,
              "z": 0.173
            },
            "gtin": "4066447376838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b82",
            "leftCorner": {
              "x": 0.258,
              "y": -17.232,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.26,
              "y": -17.176,
              "z": 0.173
            },
            "gtin": "4066447376852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b83",
            "leftCorner": {
              "x": 0.26,
              "y": -17.176,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.262,
              "y": -17.123,
              "z": 0.173
            },
            "gtin": "4066447376814",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b84",
            "leftCorner": {
              "x": 0.262,
              "y": -17.123,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.264,
              "y": -17.072,
              "z": 0.173
            },
            "gtin": "4066447376814",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b85",
            "leftCorner": {
              "x": 0.264,
              "y": -17.072,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.266,
              "y": -17.009,
              "z": 0.173
            },
            "gtin": "4067796148800",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b86",
            "leftCorner": {
              "x": 0.266,
              "y": -17.009,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.268,
              "y": -16.957,
              "z": 0.173
            },
            "gtin": "4064666847931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b87",
            "leftCorner": {
              "x": 0.268,
              "y": -16.957,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.27,
              "y": -16.904,
              "z": 0.173
            },
            "gtin": "4064666045184",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b88",
            "leftCorner": {
              "x": 0.27,
              "y": -16.904,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.272,
              "y": -16.849,
              "z": 0.173
            },
            "gtin": "4064666847863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b89",
            "leftCorner": {
              "x": 0.272,
              "y": -16.849,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.274,
              "y": -16.799,
              "z": 0.173
            },
            "gtin": "4064666847887",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c4d",
        "height": 0.4739,
        "facings": [
          {
            "id": "696ebf6f43c343680a270c26",
            "leftCorner": {
              "x": 0.231,
              "y": -17.796,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.234,
              "y": -17.699,
              "z": 0.474
            },
            "gtin": "4067796206982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c27",
            "leftCorner": {
              "x": 0.234,
              "y": -17.699,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.236,
              "y": -17.653,
              "z": 0.474
            },
            "gtin": "4066447376791",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c28",
            "leftCorner": {
              "x": 0.236,
              "y": -17.653,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.238,
              "y": -17.596,
              "z": 0.474
            },
            "gtin": "4066447376883",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c29",
            "leftCorner": {
              "x": 0.238,
              "y": -17.596,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.24,
              "y": -17.547,
              "z": 0.474
            },
            "gtin": "4066447376883",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c2a",
            "leftCorner": {
              "x": 0.24,
              "y": -17.547,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.241,
              "y": -17.507,
              "z": 0.474
            },
            "gtin": "4005900749444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c2b",
            "leftCorner": {
              "x": 0.241,
              "y": -17.507,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.245,
              "y": -17.42,
              "z": 0.474
            },
            "gtin": "4005900749604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c2c",
            "leftCorner": {
              "x": 0.245,
              "y": -17.42,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.248,
              "y": -17.343,
              "z": 0.474
            },
            "gtin": "4005900749529",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c2d",
            "leftCorner": {
              "x": 0.248,
              "y": -17.343,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.25,
              "y": -17.277,
              "z": 0.474
            },
            "gtin": "4005900749406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c2e",
            "leftCorner": {
              "x": 0.25,
              "y": -17.277,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.252,
              "y": -17.221,
              "z": 0.474
            },
            "gtin": "4005900749406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c2f",
            "leftCorner": {
              "x": 0.252,
              "y": -17.221,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.254,
              "y": -17.171,
              "z": 0.474
            },
            "gtin": "4005900749840",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c30",
            "leftCorner": {
              "x": 0.254,
              "y": -17.171,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.257,
              "y": -17.08,
              "z": 0.474
            },
            "gtin": "4897097266312",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c31",
            "leftCorner": {
              "x": 0.257,
              "y": -17.08,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.261,
              "y": -16.987,
              "z": 0.474
            },
            "gtin": "4897097266329",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c32",
            "leftCorner": {
              "x": 0.261,
              "y": -16.987,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.264,
              "y": -16.893,
              "z": 0.474
            },
            "gtin": "4897097266329",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c33",
            "leftCorner": {
              "x": 0.264,
              "y": -16.893,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.268,
              "y": -16.79,
              "z": 0.474
            },
            "gtin": "4897097266404",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c4c",
        "height": 0.76587,
        "facings": [
          {
            "id": "696ebf6e43c343680a2709fc",
            "leftCorner": {
              "x": 0.232,
              "y": -17.796,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.235,
              "y": -17.712,
              "z": 0.766
            }
          },
          {
            "id": "696ebf6e43c343680a2709fd",
            "leftCorner": {
              "x": 0.235,
              "y": -17.712,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.237,
              "y": -17.67,
              "z": 0.766
            },
            "gtin": "4068359038767",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709fe",
            "leftCorner": {
              "x": 0.237,
              "y": -17.67,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.239,
              "y": -17.621,
              "z": 0.766
            },
            "gtin": "4068359038767",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709ff",
            "leftCorner": {
              "x": 0.239,
              "y": -17.621,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.24,
              "y": -17.569,
              "z": 0.766
            },
            "gtin": "4064666847894",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a00",
            "leftCorner": {
              "x": 0.24,
              "y": -17.569,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.242,
              "y": -17.529,
              "z": 0.766
            },
            "gtin": "3614229728675",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a01",
            "leftCorner": {
              "x": 0.242,
              "y": -17.529,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.244,
              "y": -17.468,
              "z": 0.766
            },
            "gtin": "3614229728620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a02",
            "leftCorner": {
              "x": 0.244,
              "y": -17.468,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.246,
              "y": -17.413,
              "z": 0.766
            },
            "gtin": "3614229728637",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a03",
            "leftCorner": {
              "x": 0.246,
              "y": -17.413,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.249,
              "y": -17.338,
              "z": 0.766
            },
            "gtin": "3614229728637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a04",
            "leftCorner": {
              "x": 0.249,
              "y": -17.338,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.252,
              "y": -17.258,
              "z": 0.766
            },
            "gtin": "3600521575543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a05",
            "leftCorner": {
              "x": 0.252,
              "y": -17.258,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.254,
              "y": -17.197,
              "z": 0.766
            },
            "gtin": "3600521575543",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a06",
            "leftCorner": {
              "x": 0.254,
              "y": -17.197,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.256,
              "y": -17.15,
              "z": 0.766
            },
            "gtin": "7610099050423",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a07",
            "leftCorner": {
              "x": 0.256,
              "y": -17.15,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.258,
              "y": -17.098,
              "z": 0.766
            }
          },
          {
            "id": "696ebf6e43c343680a270a08",
            "leftCorner": {
              "x": 0.258,
              "y": -17.098,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.26,
              "y": -17.044,
              "z": 0.766
            },
            "gtin": "3600522910015",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a09",
            "leftCorner": {
              "x": 0.26,
              "y": -17.044,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.262,
              "y": -16.979,
              "z": 0.766
            },
            "gtin": "8006540650318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a0a",
            "leftCorner": {
              "x": 0.262,
              "y": -16.979,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.264,
              "y": -16.924,
              "z": 0.766
            },
            "gtin": "8006540650318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a0b",
            "leftCorner": {
              "x": 0.264,
              "y": -16.924,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.267,
              "y": -16.865,
              "z": 0.766
            },
            "gtin": "3600522471684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a0c",
            "leftCorner": {
              "x": 0.267,
              "y": -16.865,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.269,
              "y": -16.805,
              "z": 0.766
            },
            "gtin": "3600522471684",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c4e",
        "height": 1.0607,
        "facings": [
          {
            "id": "696ebf6e43c343680a270a7c",
            "leftCorner": {
              "x": 0.238,
              "y": -17.796,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.243,
              "y": -17.672,
              "z": 1.061
            },
            "gtin": "830372000441",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a7e",
            "leftCorner": {
              "x": 0.243,
              "y": -17.672,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.245,
              "y": -17.624,
              "z": 1.061
            },
            "gtin": "9120130824534",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a7f",
            "leftCorner": {
              "x": 0.245,
              "y": -17.624,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.252,
              "y": -17.422,
              "z": 1.061
            },
            "gtin": "4067796114409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a80",
            "leftCorner": {
              "x": 0.252,
              "y": -17.422,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.258,
              "y": -17.255,
              "z": 1.061
            },
            "gtin": "4015100438918",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a81",
            "leftCorner": {
              "x": 0.258,
              "y": -17.255,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.261,
              "y": -17.187,
              "z": 1.061
            },
            "gtin": "4015100800180",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a82",
            "leftCorner": {
              "x": 0.261,
              "y": -17.187,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.262,
              "y": -17.146,
              "z": 1.061
            },
            "gtin": "4066447866872",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a83",
            "leftCorner": {
              "x": 0.262,
              "y": -17.146,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.269,
              "y": -16.969,
              "z": 1.061
            },
            "gtin": "4063528078582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a84",
            "leftCorner": {
              "x": 0.269,
              "y": -16.969,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.271,
              "y": -16.903,
              "z": 1.061
            },
            "gtin": "4063528078674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a85",
            "leftCorner": {
              "x": 0.294,
              "y": -16.901,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.297,
              "y": -16.819,
              "z": 1.06
            },
            "gtin": "4015100800081",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c4f",
        "height": 1.356,
        "facings": [
          {
            "id": "696ebf6e43c343680a270afa",
            "leftCorner": {
              "x": 0.25,
              "y": -17.796,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.253,
              "y": -17.714,
              "z": 1.356
            },
            "gtin": "4015100438857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270afb",
            "leftCorner": {
              "x": 0.253,
              "y": -17.714,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.255,
              "y": -17.671,
              "z": 1.356
            },
            "gtin": "4015100800609",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270afc",
            "leftCorner": {
              "x": 0.255,
              "y": -17.671,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.257,
              "y": -17.622,
              "z": 1.356
            },
            "gtin": "4015100800609",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270afd",
            "leftCorner": {
              "x": 0.257,
              "y": -17.622,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.259,
              "y": -17.572,
              "z": 1.356
            }
          },
          {
            "id": "696ebf6e43c343680a270afe",
            "leftCorner": {
              "x": 0.259,
              "y": -17.572,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.262,
              "y": -17.474,
              "z": 1.356
            },
            "gtin": "4262391990001",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270aff",
            "leftCorner": {
              "x": 0.262,
              "y": -17.474,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.266,
              "y": -17.37,
              "z": 1.356
            },
            "gtin": "4262391990056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b00",
            "leftCorner": {
              "x": 0.266,
              "y": -17.37,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.268,
              "y": -17.309,
              "z": 1.356
            },
            "gtin": "4262391990049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b01",
            "leftCorner": {
              "x": 0.268,
              "y": -17.309,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.271,
              "y": -17.254,
              "z": 1.356
            },
            "gtin": "4262391990018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b02",
            "leftCorner": {
              "x": 0.271,
              "y": -17.254,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.273,
              "y": -17.199,
              "z": 1.356
            },
            "gtin": "4262391990025",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b03",
            "leftCorner": {
              "x": 0.273,
              "y": -17.199,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.274,
              "y": -17.151,
              "z": 1.356
            },
            "gtin": "4262391990506",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b04",
            "leftCorner": {
              "x": 0.274,
              "y": -17.151,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.277,
              "y": -17.074,
              "z": 1.356
            },
            "gtin": "4262391990513",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b05",
            "leftCorner": {
              "x": 0.277,
              "y": -17.074,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.279,
              "y": -17.026,
              "z": 1.356
            },
            "gtin": "4067796069679",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b06",
            "leftCorner": {
              "x": 0.279,
              "y": -17.026,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.281,
              "y": -16.975,
              "z": 1.356
            },
            "gtin": "4066447668339",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b07",
            "leftCorner": {
              "x": 0.281,
              "y": -16.975,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.285,
              "y": -16.866,
              "z": 1.356
            },
            "gtin": "8006540349120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270b08",
            "leftCorner": {
              "x": 0.285,
              "y": -16.866,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.288,
              "y": -16.783,
              "z": 1.356
            },
            "gtin": "4066447384567",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73c4b",
        "height": 1.6489,
        "facings": [
          {
            "id": "696ebf6e43c343680a27094e",
            "leftCorner": {
              "x": 0.259,
              "y": -17.797,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.263,
              "y": -17.702,
              "z": 1.649
            }
          },
          {
            "id": "696ebf6e43c343680a270950",
            "leftCorner": {
              "x": 0.263,
              "y": -17.702,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.268,
              "y": -17.563,
              "z": 1.649
            },
            "gtin": "4066447944099",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270951",
            "leftCorner": {
              "x": 0.268,
              "y": -17.563,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.277,
              "y": -17.315,
              "z": 1.649
            },
            "gtin": "3030050185867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270952",
            "leftCorner": {
              "x": 0.277,
              "y": -17.315,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.279,
              "y": -17.264,
              "z": 1.649
            },
            "gtin": "4066447238105",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270953",
            "leftCorner": {
              "x": 0.279,
              "y": -17.264,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.28,
              "y": -17.217,
              "z": 1.649
            },
            "gtin": "4015100437973",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270954",
            "leftCorner": {
              "x": 0.28,
              "y": -17.217,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.282,
              "y": -17.174,
              "z": 1.649
            },
            "gtin": "4015100747195",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270955",
            "leftCorner": {
              "x": 0.282,
              "y": -17.174,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.284,
              "y": -17.131,
              "z": 1.649
            },
            "gtin": "4015100746877",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270956",
            "leftCorner": {
              "x": 0.284,
              "y": -17.131,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.285,
              "y": -17.088,
              "z": 1.649
            },
            "gtin": "4015100800128",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270957",
            "leftCorner": {
              "x": 0.285,
              "y": -17.088,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.287,
              "y": -17.036,
              "z": 1.649
            },
            "gtin": "3600522280774",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270958",
            "leftCorner": {
              "x": 0.287,
              "y": -17.036,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.29,
              "y": -16.973,
              "z": 1.649
            },
            "gtin": "4015100860146",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270959",
            "leftCorner": {
              "x": 0.29,
              "y": -16.973,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.293,
              "y": -16.887,
              "z": 1.649
            },
            "gtin": "4066447383829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27095a",
            "leftCorner": {
              "x": 0.293,
              "y": -16.887,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.295,
              "y": -16.819,
              "z": 1.649
            },
            "gtin": "3600523966714",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27095b",
            "leftCorner": {
              "x": 0.295,
              "y": -16.819,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.297,
              "y": -16.777,
              "z": 1.649
            },
            "gtin": "4015100815788",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e76371b5fe7bc046959aaf",
    "name": "68e76371b5fe7bc046959aaf",
    "x": 0.25328,
    "y": -16.791,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.67822,
      "w": 0.73486
    },
    "statistics": {
      "hasStockCount": 80,
      "noStockCount": 2,
      "unknownStockCount": 13,
      "shelfCategory": "HAIR"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd739d2",
        "height": 0.17456,
        "facings": [
          {
            "id": "696ebf6f43c343680a270b8a",
            "leftCorner": {
              "x": 0.299,
              "y": -16.798,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.304,
              "y": -16.736,
              "z": 0.175
            },
            "gtin": "3614229728668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b8b",
            "leftCorner": {
              "x": 0.304,
              "y": -16.736,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.308,
              "y": -16.688,
              "z": 0.175
            },
            "gtin": "3614229728606",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b8c",
            "leftCorner": {
              "x": 0.308,
              "y": -16.688,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.312,
              "y": -16.633,
              "z": 0.175
            },
            "gtin": "4015100190496",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b8d",
            "leftCorner": {
              "x": 0.312,
              "y": -16.633,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.319,
              "y": -16.553,
              "z": 0.175
            },
            "gtin": "4015100860481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b8e",
            "leftCorner": {
              "x": 0.319,
              "y": -16.553,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.325,
              "y": -16.474,
              "z": 0.175
            },
            "gtin": "4015100860344",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b8f",
            "leftCorner": {
              "x": 0.325,
              "y": -16.474,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.329,
              "y": -16.424,
              "z": 0.175
            },
            "gtin": "4015100860467",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b90",
            "leftCorner": {
              "x": 0.329,
              "y": -16.424,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.338,
              "y": -16.316,
              "z": 0.175
            },
            "gtin": "4015100860863",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b91",
            "leftCorner": {
              "x": 0.338,
              "y": -16.316,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.345,
              "y": -16.229,
              "z": 0.175
            },
            "gtin": "4015100860382",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b92",
            "leftCorner": {
              "x": 0.345,
              "y": -16.229,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.351,
              "y": -16.144,
              "z": 0.175
            },
            "gtin": "4015100860986",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b93",
            "leftCorner": {
              "x": 0.351,
              "y": -16.144,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.356,
              "y": -16.092,
              "z": 0.175
            },
            "gtin": "4015100892826",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b94",
            "leftCorner": {
              "x": 0.356,
              "y": -16.092,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.363,
              "y": -15.995,
              "z": 0.175
            },
            "gtin": "4015100866100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b95",
            "leftCorner": {
              "x": 0.363,
              "y": -15.995,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.368,
              "y": -15.944,
              "z": 0.175
            },
            "gtin": "4015100860887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b96",
            "leftCorner": {
              "x": 0.368,
              "y": -15.944,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.374,
              "y": -15.861,
              "z": 0.175
            },
            "gtin": "4015100860504",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b97",
            "leftCorner": {
              "x": 0.374,
              "y": -15.861,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.38,
              "y": -15.789,
              "z": 0.175
            },
            "gtin": "4015100860443",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739d3",
        "height": 0.47371,
        "facings": [
          {
            "id": "696ebf6f43c343680a270c34",
            "leftCorner": {
              "x": 0.297,
              "y": -16.788,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.302,
              "y": -16.727,
              "z": 0.474
            },
            "gtin": "4066447068689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c35",
            "leftCorner": {
              "x": 0.302,
              "y": -16.727,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.31,
              "y": -16.634,
              "z": 0.474
            },
            "gtin": "4058172702051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c36",
            "leftCorner": {
              "x": 0.31,
              "y": -16.634,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.315,
              "y": -16.562,
              "z": 0.474
            },
            "gtin": "4066447240665",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c37",
            "leftCorner": {
              "x": 0.315,
              "y": -16.562,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.319,
              "y": -16.511,
              "z": 0.474
            },
            "gtin": "4066447234213",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c38",
            "leftCorner": {
              "x": 0.319,
              "y": -16.511,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.323,
              "y": -16.461,
              "z": 0.474
            },
            "gtin": "4058172831386",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c39",
            "leftCorner": {
              "x": 0.323,
              "y": -16.461,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.328,
              "y": -16.4,
              "z": 0.474
            },
            "gtin": "4066447238228",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c3a",
            "leftCorner": {
              "x": 0.328,
              "y": -16.4,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.333,
              "y": -16.347,
              "z": 0.474
            },
            "gtin": "4066447238242",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c3b",
            "leftCorner": {
              "x": 0.333,
              "y": -16.347,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.335,
              "y": -16.311,
              "z": 0.474
            },
            "gtin": "4058172702150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c3c",
            "leftCorner": {
              "x": 0.335,
              "y": -16.311,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.342,
              "y": -16.235,
              "z": 0.474
            },
            "gtin": "4067796002584",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c3d",
            "leftCorner": {
              "x": 0.342,
              "y": -16.235,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.347,
              "y": -16.173,
              "z": 0.474
            },
            "gtin": "4058172702112",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c3e",
            "leftCorner": {
              "x": 0.347,
              "y": -16.173,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.351,
              "y": -16.115,
              "z": 0.474
            },
            "gtin": "4058172702136",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c3f",
            "leftCorner": {
              "x": 0.351,
              "y": -16.115,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.355,
              "y": -16.064,
              "z": 0.474
            },
            "gtin": "4058172831409",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c40",
            "leftCorner": {
              "x": 0.355,
              "y": -16.064,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.36,
              "y": -16.001,
              "z": 0.474
            },
            "gtin": "4058172920684",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c41",
            "leftCorner": {
              "x": 0.36,
              "y": -16.001,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.365,
              "y": -15.944,
              "z": 0.474
            },
            "gtin": "4058172920684",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c42",
            "leftCorner": {
              "x": 0.365,
              "y": -15.944,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.369,
              "y": -15.894,
              "z": 0.474
            },
            "gtin": "4058172702075",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c43",
            "leftCorner": {
              "x": 0.369,
              "y": -15.894,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.374,
              "y": -15.831,
              "z": 0.474
            },
            "gtin": "4067796166439",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c44",
            "leftCorner": {
              "x": 0.374,
              "y": -15.831,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.378,
              "y": -15.786,
              "z": 0.474
            },
            "gtin": "4066447793529",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739cf",
        "height": 0.7656,
        "facings": [
          {
            "id": "696ebf6e43c343680a270a0d",
            "leftCorner": {
              "x": 0.269,
              "y": -16.805,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.27,
              "y": -16.759,
              "z": 0.766
            },
            "gtin": "3600522471714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a0e",
            "leftCorner": {
              "x": 0.302,
              "y": -16.757,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.306,
              "y": -16.71,
              "z": 0.766
            },
            "gtin": "3600522471714",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a0f",
            "leftCorner": {
              "x": 0.306,
              "y": -16.71,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.31,
              "y": -16.664,
              "z": 0.766
            },
            "gtin": "8001841217055",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a10",
            "leftCorner": {
              "x": 0.31,
              "y": -16.664,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.313,
              "y": -16.62,
              "z": 0.766
            },
            "gtin": "8001841217055",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a11",
            "leftCorner": {
              "x": 0.313,
              "y": -16.62,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.32,
              "y": -16.539,
              "z": 0.766
            },
            "gtin": "8001841228488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a12",
            "leftCorner": {
              "x": 0.32,
              "y": -16.539,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.326,
              "y": -16.456,
              "z": 0.766
            }
          },
          {
            "id": "696ebf6e43c343680a270a13",
            "leftCorner": {
              "x": 0.326,
              "y": -16.456,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.33,
              "y": -16.406,
              "z": 0.766
            }
          },
          {
            "id": "696ebf6e43c343680a270a14",
            "leftCorner": {
              "x": 0.33,
              "y": -16.406,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.334,
              "y": -16.359,
              "z": 0.766
            }
          },
          {
            "id": "696ebf6e43c343680a270a15",
            "leftCorner": {
              "x": 0.334,
              "y": -16.359,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.338,
              "y": -16.314,
              "z": 0.766
            }
          },
          {
            "id": "696ebf6e43c343680a270a16",
            "leftCorner": {
              "x": 0.338,
              "y": -16.314,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.344,
              "y": -16.237,
              "z": 0.766
            },
            "gtin": "810006943450",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a17",
            "leftCorner": {
              "x": 0.344,
              "y": -16.237,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.35,
              "y": -16.157,
              "z": 0.766
            },
            "gtin": "810006943467",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a18",
            "leftCorner": {
              "x": 0.35,
              "y": -16.157,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.358,
              "y": -16.061,
              "z": 0.766
            },
            "gtin": "810006943405",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a19",
            "leftCorner": {
              "x": 0.358,
              "y": -16.061,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.362,
              "y": -16.006,
              "z": 0.766
            },
            "gtin": "810006943474",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a1a",
            "leftCorner": {
              "x": 0.362,
              "y": -16.006,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.367,
              "y": -15.951,
              "z": 0.766
            },
            "gtin": "810006943412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a1b",
            "leftCorner": {
              "x": 0.367,
              "y": -15.951,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.371,
              "y": -15.893,
              "z": 0.766
            },
            "gtin": "810006943481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a1c",
            "leftCorner": {
              "x": 0.371,
              "y": -15.893,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.379,
              "y": -15.798,
              "z": 0.766
            },
            "gtin": "810006943429",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739d0",
        "height": 1.0602,
        "facings": [
          {
            "id": "696ebf6e43c343680a270a86",
            "leftCorner": {
              "x": 0.301,
              "y": -16.82,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.304,
              "y": -16.747,
              "z": 1.06
            },
            "gtin": "4015100865653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a87",
            "leftCorner": {
              "x": 0.307,
              "y": -16.747,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.311,
              "y": -16.693,
              "z": 1.06
            },
            "gtin": "4015100815627",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a88",
            "leftCorner": {
              "x": 0.311,
              "y": -16.693,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.315,
              "y": -16.644,
              "z": 1.06
            },
            "gtin": "4066447342253",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a89",
            "leftCorner": {
              "x": 0.315,
              "y": -16.644,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.319,
              "y": -16.589,
              "z": 1.06
            },
            "gtin": "4066447384642",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a8a",
            "leftCorner": {
              "x": 0.319,
              "y": -16.589,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.323,
              "y": -16.546,
              "z": 1.06
            },
            "gtin": "4066447237467",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a8b",
            "leftCorner": {
              "x": 0.323,
              "y": -16.546,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.327,
              "y": -16.497,
              "z": 1.06
            },
            "gtin": "4066447383867",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a8c",
            "leftCorner": {
              "x": 0.327,
              "y": -16.497,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.331,
              "y": -16.449,
              "z": 1.06
            },
            "gtin": "4066447384666",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a8d",
            "leftCorner": {
              "x": 0.331,
              "y": -16.449,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.335,
              "y": -16.4,
              "z": 1.06
            },
            "gtin": "4067796148855",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a8e",
            "leftCorner": {
              "x": 0.335,
              "y": -16.4,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.339,
              "y": -16.349,
              "z": 1.06
            },
            "gtin": "4066447704723",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a8f",
            "leftCorner": {
              "x": 0.339,
              "y": -16.349,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.342,
              "y": -16.31,
              "z": 1.06
            },
            "gtin": "4067796082012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a90",
            "leftCorner": {
              "x": 0.342,
              "y": -16.31,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.349,
              "y": -16.221,
              "z": 1.06
            },
            "gtin": "4066447242263",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a91",
            "leftCorner": {
              "x": 0.349,
              "y": -16.221,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.355,
              "y": -16.146,
              "z": 1.06
            },
            "gtin": "4015100810769",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a92",
            "leftCorner": {
              "x": 0.355,
              "y": -16.146,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.359,
              "y": -16.098,
              "z": 1.06
            },
            "gtin": "4015100439243",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a93",
            "leftCorner": {
              "x": 0.359,
              "y": -16.098,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.363,
              "y": -16.041,
              "z": 1.06
            },
            "gtin": "4066447342291",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a94",
            "leftCorner": {
              "x": 0.363,
              "y": -16.041,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.367,
              "y": -15.993,
              "z": 1.06
            },
            "gtin": "4066447378535",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a95",
            "leftCorner": {
              "x": 0.367,
              "y": -15.993,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.371,
              "y": -15.949,
              "z": 1.06
            },
            "gtin": "4072600282243",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a96",
            "leftCorner": {
              "x": 0.371,
              "y": -15.949,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.379,
              "y": -15.848,
              "z": 1.06
            },
            "gtin": "1230000120012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a97",
            "leftCorner": {
              "x": 0.379,
              "y": -15.848,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.382,
              "y": -15.813,
              "z": 1.06
            },
            "gtin": "4013162030934",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739d1",
        "height": 1.3565,
        "facings": [
          {
            "id": "696ebf6e43c343680a270b09",
            "leftCorner": {
              "x": 0.31,
              "y": -16.782,
              "z": 1.357
            },
            "rightCorner": {
              "x": 0.314,
              "y": -16.733,
              "z": 1.357
            },
            "gtin": "4015100860825",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b0a",
            "leftCorner": {
              "x": 0.314,
              "y": -16.733,
              "z": 1.357
            },
            "rightCorner": {
              "x": 0.318,
              "y": -16.689,
              "z": 1.357
            },
            "gtin": "4066447342277",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b0b",
            "leftCorner": {
              "x": 0.318,
              "y": -16.689,
              "z": 1.357
            },
            "rightCorner": {
              "x": 0.322,
              "y": -16.643,
              "z": 1.357
            },
            "gtin": "4066447899146",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b0c",
            "leftCorner": {
              "x": 0.322,
              "y": -16.643,
              "z": 1.357
            },
            "rightCorner": {
              "x": 0.325,
              "y": -16.602,
              "z": 1.357
            },
            "gtin": "4067796062854",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b0d",
            "leftCorner": {
              "x": 0.325,
              "y": -16.602,
              "z": 1.357
            },
            "rightCorner": {
              "x": 0.328,
              "y": -16.557,
              "z": 1.357
            },
            "gtin": "4067796062854",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b0e",
            "leftCorner": {
              "x": 0.328,
              "y": -16.557,
              "z": 1.357
            },
            "rightCorner": {
              "x": 0.332,
              "y": -16.514,
              "z": 1.357
            },
            "gtin": "4066447384154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270b0f",
            "leftCorner": {
              "x": 0.332,
              "y": -16.514,
              "z": 1.357
            },
            "rightCorner": {
              "x": 0.336,
              "y": -16.469,
              "z": 1.357
            },
            "gtin": "4066447467574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270b10",
            "leftCorner": {
              "x": 0.336,
              "y": -16.469,
              "z": 1.357
            },
            "rightCorner": {
              "x": 0.339,
              "y": -16.421,
              "z": 1.357
            },
            "gtin": "4067796069730",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b11",
            "leftCorner": {
              "x": 0.339,
              "y": -16.421,
              "z": 1.357
            },
            "rightCorner": {
              "x": 0.343,
              "y": -16.37,
              "z": 1.357
            },
            "gtin": "4104260045736",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b12",
            "leftCorner": {
              "x": 0.343,
              "y": -16.37,
              "z": 1.357
            },
            "rightCorner": {
              "x": 0.347,
              "y": -16.325,
              "z": 1.357
            },
            "gtin": "4066447376579",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b13",
            "leftCorner": {
              "x": 0.347,
              "y": -16.325,
              "z": 1.357
            },
            "rightCorner": {
              "x": 0.351,
              "y": -16.273,
              "z": 1.357
            },
            "gtin": "4066447376579",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b14",
            "leftCorner": {
              "x": 0.351,
              "y": -16.273,
              "z": 1.357
            },
            "rightCorner": {
              "x": 0.36,
              "y": -16.158,
              "z": 1.357
            },
            "gtin": "4066447376555",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b15",
            "leftCorner": {
              "x": 0.36,
              "y": -16.158,
              "z": 1.357
            },
            "rightCorner": {
              "x": 0.368,
              "y": -16.064,
              "z": 1.357
            },
            "gtin": "4066447438789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270b16",
            "leftCorner": {
              "x": 0.368,
              "y": -16.064,
              "z": 1.357
            },
            "rightCorner": {
              "x": 0.373,
              "y": -16.008,
              "z": 1.357
            },
            "gtin": "4066447439205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270b17",
            "leftCorner": {
              "x": 0.373,
              "y": -16.008,
              "z": 1.357
            },
            "rightCorner": {
              "x": 0.377,
              "y": -15.953,
              "z": 1.357
            },
            "gtin": "4066447376494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270b18",
            "leftCorner": {
              "x": 0.377,
              "y": -15.953,
              "z": 1.357
            },
            "rightCorner": {
              "x": 0.385,
              "y": -15.85,
              "z": 1.357
            },
            "gtin": "4066447376456",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739ce",
        "height": 1.6488,
        "facings": [
          {
            "id": "696ebf6e43c343680a27095c",
            "leftCorner": {
              "x": 0.315,
              "y": -16.776,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.318,
              "y": -16.73,
              "z": 1.649
            },
            "gtin": "4015100800227",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27095d",
            "leftCorner": {
              "x": 0.318,
              "y": -16.73,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.322,
              "y": -16.685,
              "z": 1.649
            },
            "gtin": "4072600721902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27095e",
            "leftCorner": {
              "x": 0.322,
              "y": -16.685,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.326,
              "y": -16.636,
              "z": 1.649
            },
            "gtin": "4072600721704",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27095f",
            "leftCorner": {
              "x": 0.326,
              "y": -16.636,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.33,
              "y": -16.589,
              "z": 1.649
            },
            "gtin": "5010724527481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270960",
            "leftCorner": {
              "x": 0.33,
              "y": -16.589,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.333,
              "y": -16.541,
              "z": 1.649
            },
            "gtin": "5010724527467",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270961",
            "leftCorner": {
              "x": 0.333,
              "y": -16.541,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.337,
              "y": -16.49,
              "z": 1.649
            },
            "gtin": "5010724527474",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270962",
            "leftCorner": {
              "x": 0.337,
              "y": -16.49,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.341,
              "y": -16.447,
              "z": 1.649
            },
            "gtin": "5010724527443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270963",
            "leftCorner": {
              "x": 0.341,
              "y": -16.447,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.345,
              "y": -16.397,
              "z": 1.649
            },
            "gtin": "5010724532966",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270964",
            "leftCorner": {
              "x": 0.345,
              "y": -16.397,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.349,
              "y": -16.351,
              "z": 1.649
            },
            "gtin": "5010724532966",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270965",
            "leftCorner": {
              "x": 0.349,
              "y": -16.351,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.353,
              "y": -16.302,
              "z": 1.649
            },
            "gtin": "5010724004777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270966",
            "leftCorner": {
              "x": 0.353,
              "y": -16.302,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.357,
              "y": -16.249,
              "z": 1.649
            },
            "gtin": "5010724003824",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270967",
            "leftCorner": {
              "x": 0.357,
              "y": -16.249,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.363,
              "y": -16.17,
              "z": 1.649
            },
            "gtin": "5010724526798",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270968",
            "leftCorner": {
              "x": 0.363,
              "y": -16.17,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.369,
              "y": -16.096,
              "z": 1.649
            },
            "gtin": "5010724527375",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270969",
            "leftCorner": {
              "x": 0.369,
              "y": -16.096,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.373,
              "y": -16.049,
              "z": 1.649
            },
            "gtin": "5010724527375",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27096a",
            "leftCorner": {
              "x": 0.373,
              "y": -16.049,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.377,
              "y": -16.003,
              "z": 1.649
            },
            "gtin": "5010724006443",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27096b",
            "leftCorner": {
              "x": 0.377,
              "y": -16.003,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.381,
              "y": -15.954,
              "z": 1.649
            },
            "gtin": "5010724006443",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27096c",
            "leftCorner": {
              "x": 0.381,
              "y": -15.954,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.384,
              "y": -15.908,
              "z": 1.649
            },
            "gtin": "5010724006467",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27096d",
            "leftCorner": {
              "x": 0.384,
              "y": -15.908,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.391,
              "y": -15.83,
              "z": 1.649
            },
            "gtin": "4262500781346",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27096e",
            "leftCorner": {
              "x": 0.391,
              "y": -15.83,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.393,
              "y": -15.799,
              "z": 1.649
            }
          }
        ]
      }
    ]
  },
  {
    "id": "68e76371b5fe7bc046959ab0",
    "name": "68e76371b5fe7bc046959ab0",
    "x": 0.33036,
    "y": -15.791,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68927,
      "w": 0.72451
    },
    "statistics": {
      "hasStockCount": 64,
      "noStockCount": 1,
      "unknownStockCount": 14,
      "shelfCategory": "HAIR"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd739d9",
        "height": 0.17475,
        "facings": [
          {
            "id": "696ebf6f43c343680a270b98",
            "leftCorner": {
              "x": 0.376,
              "y": -15.784,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.385,
              "y": -15.612,
              "z": 0.175
            },
            "gtin": "4021457634019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b99",
            "leftCorner": {
              "x": 0.385,
              "y": -15.612,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.395,
              "y": -15.408,
              "z": 0.175
            },
            "gtin": "4021457647651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b9a",
            "leftCorner": {
              "x": 0.395,
              "y": -15.408,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.398,
              "y": -15.347,
              "z": 0.175
            },
            "gtin": "4021457647606",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b9b",
            "leftCorner": {
              "x": 0.398,
              "y": -15.347,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.4,
              "y": -15.305,
              "z": 0.175
            },
            "gtin": "4025089005018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b9c",
            "leftCorner": {
              "x": 0.4,
              "y": -15.305,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.403,
              "y": -15.254,
              "z": 0.175
            },
            "gtin": "4025089005087",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b9d",
            "leftCorner": {
              "x": 0.403,
              "y": -15.254,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.405,
              "y": -15.203,
              "z": 0.175
            },
            "gtin": "4025089005087",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b9e",
            "leftCorner": {
              "x": 0.405,
              "y": -15.203,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.408,
              "y": -15.153,
              "z": 0.175
            },
            "gtin": "4025089007999",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b9f",
            "leftCorner": {
              "x": 0.408,
              "y": -15.153,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.41,
              "y": -15.113,
              "z": 0.175
            },
            "gtin": "4055297220866",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ba0",
            "leftCorner": {
              "x": 0.41,
              "y": -15.113,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.412,
              "y": -15.064,
              "z": 0.175
            },
            "gtin": "4025089007968",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ba1",
            "leftCorner": {
              "x": 0.412,
              "y": -15.064,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.415,
              "y": -15.014,
              "z": 0.175
            },
            "gtin": "4025089007968",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ba2",
            "leftCorner": {
              "x": 0.415,
              "y": -15.014,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.418,
              "y": -14.956,
              "z": 0.175
            }
          },
          {
            "id": "696ebf6f43c343680a270ba3",
            "leftCorner": {
              "x": 0.418,
              "y": -14.956,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.42,
              "y": -14.9,
              "z": 0.175
            },
            "gtin": "4001638095716",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ba4",
            "leftCorner": {
              "x": 0.42,
              "y": -14.9,
              "z": 0.175
            },
            "rightCorner": {
              "x": 0.426,
              "y": -14.797,
              "z": 0.175
            },
            "gtin": "4001638093620",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739d7",
        "height": 0.47241,
        "facings": [
          {
            "id": "696ebf6f43c343680a270c45",
            "leftCorner": {
              "x": 0.374,
              "y": -15.782,
              "z": 0.472
            },
            "rightCorner": {
              "x": 0.378,
              "y": -15.728,
              "z": 0.472
            },
            "gtin": "4066447238891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c46",
            "leftCorner": {
              "x": 0.377,
              "y": -15.727,
              "z": 0.472
            },
            "rightCorner": {
              "x": 0.384,
              "y": -15.64,
              "z": 0.472
            },
            "gtin": "4066447238952",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c47",
            "leftCorner": {
              "x": 0.381,
              "y": -15.64,
              "z": 0.472
            },
            "rightCorner": {
              "x": 0.392,
              "y": -15.41,
              "z": 0.472
            },
            "gtin": "4066447238877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c48",
            "leftCorner": {
              "x": 0.392,
              "y": -15.41,
              "z": 0.472
            },
            "rightCorner": {
              "x": 0.395,
              "y": -15.349,
              "z": 0.472
            },
            "gtin": "4066447238938",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c49",
            "leftCorner": {
              "x": 0.395,
              "y": -15.349,
              "z": 0.472
            },
            "rightCorner": {
              "x": 0.398,
              "y": -15.29,
              "z": 0.472
            },
            "gtin": "4066447238938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c4a",
            "leftCorner": {
              "x": 0.398,
              "y": -15.29,
              "z": 0.472
            },
            "rightCorner": {
              "x": 0.403,
              "y": -15.198,
              "z": 0.472
            },
            "gtin": "4066447239072",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c4b",
            "leftCorner": {
              "x": 0.403,
              "y": -15.198,
              "z": 0.472
            },
            "rightCorner": {
              "x": 0.406,
              "y": -15.139,
              "z": 0.472
            },
            "gtin": "4066447239133",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c4c",
            "leftCorner": {
              "x": 0.406,
              "y": -15.139,
              "z": 0.472
            },
            "rightCorner": {
              "x": 0.409,
              "y": -15.08,
              "z": 0.472
            },
            "gtin": "4066447239157",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c4d",
            "leftCorner": {
              "x": 0.409,
              "y": -15.08,
              "z": 0.472
            },
            "rightCorner": {
              "x": 0.411,
              "y": -15.028,
              "z": 0.472
            },
            "gtin": "4066447704709",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c4e",
            "leftCorner": {
              "x": 0.411,
              "y": -15.028,
              "z": 0.472
            },
            "rightCorner": {
              "x": 0.415,
              "y": -14.948,
              "z": 0.472
            },
            "gtin": "4066447332308",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c4f",
            "leftCorner": {
              "x": 0.415,
              "y": -14.948,
              "z": 0.472
            },
            "rightCorner": {
              "x": 0.418,
              "y": -14.899,
              "z": 0.472
            },
            "gtin": "4066447332285",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c50",
            "leftCorner": {
              "x": 0.418,
              "y": -14.899,
              "z": 0.472
            },
            "rightCorner": {
              "x": 0.421,
              "y": -14.829,
              "z": 0.472
            },
            "gtin": "4066447332322",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c51",
            "leftCorner": {
              "x": 0.421,
              "y": -14.829,
              "z": 0.472
            },
            "rightCorner": {
              "x": 0.424,
              "y": -14.779,
              "z": 0.472
            },
            "gtin": "4066447331295",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739d4",
        "height": 0.7645,
        "facings": [
          {
            "id": "696ebf6e43c343680a270a1d",
            "leftCorner": {
              "x": 0.375,
              "y": -15.794,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.385,
              "y": -15.671,
              "z": 0.765
            },
            "gtin": "071164343166",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a1e",
            "leftCorner": {
              "x": 0.381,
              "y": -15.67,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.388,
              "y": -15.524,
              "z": 0.765
            },
            "gtin": "071164302262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a1f",
            "leftCorner": {
              "x": 0.388,
              "y": -15.524,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.392,
              "y": -15.457,
              "z": 0.765
            },
            "gtin": "071164029855",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a20",
            "leftCorner": {
              "x": 0.392,
              "y": -15.457,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.395,
              "y": -15.4,
              "z": 0.765
            },
            "gtin": "071164304112",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a21",
            "leftCorner": {
              "x": 0.395,
              "y": -15.4,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.398,
              "y": -15.339,
              "z": 0.765
            },
            "gtin": "071164304112",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a22",
            "leftCorner": {
              "x": 0.398,
              "y": -15.339,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.4,
              "y": -15.281,
              "z": 0.765
            },
            "gtin": "071164304211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a23",
            "leftCorner": {
              "x": 0.4,
              "y": -15.281,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.403,
              "y": -15.231,
              "z": 0.765
            },
            "gtin": "071164363317",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a24",
            "leftCorner": {
              "x": 0.403,
              "y": -15.231,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.405,
              "y": -15.184,
              "z": 0.765
            },
            "gtin": "071164302231",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a25",
            "leftCorner": {
              "x": 0.405,
              "y": -15.184,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.408,
              "y": -15.139,
              "z": 0.765
            },
            "gtin": "071164302231",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a26",
            "leftCorner": {
              "x": 0.408,
              "y": -15.139,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.411,
              "y": -15.076,
              "z": 0.765
            },
            "gtin": "071164323410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a27",
            "leftCorner": {
              "x": 0.411,
              "y": -15.076,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.416,
              "y": -14.977,
              "z": 0.765
            },
            "gtin": "071164333211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a28",
            "leftCorner": {
              "x": 0.416,
              "y": -14.977,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.421,
              "y": -14.878,
              "z": 0.765
            },
            "gtin": "3574661818450",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a29",
            "leftCorner": {
              "x": 0.421,
              "y": -14.878,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.425,
              "y": -14.781,
              "z": 0.765
            },
            "gtin": "3574661818467",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739d5",
        "height": 1.0577,
        "facings": [
          {
            "id": "696ebf6e43c343680a270a98",
            "leftCorner": {
              "x": 0.374,
              "y": -15.808,
              "z": 1.058
            },
            "rightCorner": {
              "x": 0.379,
              "y": -15.743,
              "z": 1.058
            },
            "gtin": "4013162030965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a99",
            "leftCorner": {
              "x": 0.377,
              "y": -15.743,
              "z": 1.058
            },
            "rightCorner": {
              "x": 0.383,
              "y": -15.673,
              "z": 1.058
            },
            "gtin": "4013162033447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a9a",
            "leftCorner": {
              "x": 0.381,
              "y": -15.673,
              "z": 1.058
            },
            "rightCorner": {
              "x": 0.386,
              "y": -15.612,
              "z": 1.058
            },
            "gtin": "5037156285321",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a9b",
            "leftCorner": {
              "x": 0.384,
              "y": -15.612,
              "z": 1.058
            },
            "rightCorner": {
              "x": 0.392,
              "y": -15.447,
              "z": 1.058
            },
            "gtin": "5037156296082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a9c",
            "leftCorner": {
              "x": 0.392,
              "y": -15.447,
              "z": 1.058
            },
            "rightCorner": {
              "x": 0.396,
              "y": -15.37,
              "z": 1.058
            },
            "gtin": "50008605",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a9d",
            "leftCorner": {
              "x": 0.396,
              "y": -15.37,
              "z": 1.058
            },
            "rightCorner": {
              "x": 0.398,
              "y": -15.319,
              "z": 1.058
            },
            "gtin": "5037156271546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a9e",
            "leftCorner": {
              "x": 0.398,
              "y": -15.319,
              "z": 1.058
            },
            "rightCorner": {
              "x": 0.401,
              "y": -15.265,
              "z": 1.058
            },
            "gtin": "5037156271553",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a9f",
            "leftCorner": {
              "x": 0.401,
              "y": -15.265,
              "z": 1.058
            },
            "rightCorner": {
              "x": 0.404,
              "y": -15.213,
              "z": 1.058
            },
            "gtin": "5037156225587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270aa0",
            "leftCorner": {
              "x": 0.404,
              "y": -15.213,
              "z": 1.058
            },
            "rightCorner": {
              "x": 0.406,
              "y": -15.164,
              "z": 1.058
            },
            "gtin": "5037156263961",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270aa1",
            "leftCorner": {
              "x": 0.406,
              "y": -15.164,
              "z": 1.058
            },
            "rightCorner": {
              "x": 0.409,
              "y": -15.105,
              "z": 1.058
            },
            "gtin": "50002993",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270aa2",
            "leftCorner": {
              "x": 0.409,
              "y": -15.105,
              "z": 1.058
            },
            "rightCorner": {
              "x": 0.411,
              "y": -15.058,
              "z": 1.058
            },
            "gtin": "5037156225365",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270aa3",
            "leftCorner": {
              "x": 0.411,
              "y": -15.058,
              "z": 1.058
            },
            "rightCorner": {
              "x": 0.416,
              "y": -14.972,
              "z": 1.058
            },
            "gtin": "4066447674880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270aa4",
            "leftCorner": {
              "x": 0.416,
              "y": -14.972,
              "z": 1.058
            },
            "rightCorner": {
              "x": 0.419,
              "y": -14.896,
              "z": 1.058
            },
            "gtin": "4066447452778",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270aa5",
            "leftCorner": {
              "x": 0.419,
              "y": -14.896,
              "z": 1.058
            },
            "rightCorner": {
              "x": 0.423,
              "y": -14.818,
              "z": 1.058
            },
            "gtin": "4066447674071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270aa6",
            "leftCorner": {
              "x": 0.423,
              "y": -14.818,
              "z": 1.058
            },
            "rightCorner": {
              "x": 0.427,
              "y": -14.74,
              "z": 1.058
            },
            "gtin": "4021457655397",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739db",
        "height": 1.1903,
        "facings": []
      },
      {
        "id": "696ead8c3b88e258afd739d8",
        "height": 1.3543,
        "facings": [
          {
            "id": "696ebf6e43c343680a270b19",
            "leftCorner": {
              "x": 0.385,
              "y": -15.85,
              "z": 1.357
            },
            "rightCorner": {
              "x": 0.394,
              "y": -15.746,
              "z": 1.357
            },
            "gtin": "5037156225457",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b1a",
            "leftCorner": {
              "x": 0.383,
              "y": -15.741,
              "z": 1.354
            },
            "rightCorner": {
              "x": 0.39,
              "y": -15.59,
              "z": 1.354
            },
            "gtin": "5037156295399",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b1b",
            "leftCorner": {
              "x": 0.39,
              "y": -15.59,
              "z": 1.354
            },
            "rightCorner": {
              "x": 0.398,
              "y": -15.432,
              "z": 1.354
            },
            "gtin": "5037156225495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270b1c",
            "leftCorner": {
              "x": 0.398,
              "y": -15.432,
              "z": 1.354
            },
            "rightCorner": {
              "x": 0.401,
              "y": -15.381,
              "z": 1.354
            },
            "gtin": "5037156225488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b1d",
            "leftCorner": {
              "x": 0.401,
              "y": -15.381,
              "z": 1.354
            },
            "rightCorner": {
              "x": 0.405,
              "y": -15.297,
              "z": 1.354
            },
            "gtin": "5037156254273",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b1e",
            "leftCorner": {
              "x": 0.405,
              "y": -15.297,
              "z": 1.354
            },
            "rightCorner": {
              "x": 0.409,
              "y": -15.226,
              "z": 1.354
            },
            "gtin": "5037156225518",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b1f",
            "leftCorner": {
              "x": 0.409,
              "y": -15.226,
              "z": 1.354
            },
            "rightCorner": {
              "x": 0.411,
              "y": -15.178,
              "z": 1.354
            },
            "gtin": "5037156225525",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b20",
            "leftCorner": {
              "x": 0.411,
              "y": -15.178,
              "z": 1.354
            },
            "rightCorner": {
              "x": 0.413,
              "y": -15.129,
              "z": 1.354
            },
            "gtin": "5037156275292",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b21",
            "leftCorner": {
              "x": 0.413,
              "y": -15.129,
              "z": 1.354
            },
            "rightCorner": {
              "x": 0.418,
              "y": -15.047,
              "z": 1.354
            },
            "gtin": "5037156279450",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b22",
            "leftCorner": {
              "x": 0.418,
              "y": -15.047,
              "z": 1.354
            },
            "rightCorner": {
              "x": 0.42,
              "y": -14.993,
              "z": 1.354
            },
            "gtin": "5037156286427",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b23",
            "leftCorner": {
              "x": 0.42,
              "y": -14.993,
              "z": 1.354
            },
            "rightCorner": {
              "x": 0.423,
              "y": -14.938,
              "z": 1.354
            },
            "gtin": "5037156225044",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b24",
            "leftCorner": {
              "x": 0.423,
              "y": -14.938,
              "z": 1.354
            },
            "rightCorner": {
              "x": 0.426,
              "y": -14.884,
              "z": 1.354
            },
            "gtin": "5037156225051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270b25",
            "leftCorner": {
              "x": 0.426,
              "y": -14.884,
              "z": 1.354
            },
            "rightCorner": {
              "x": 0.431,
              "y": -14.787,
              "z": 1.354
            },
            "gtin": "3600542500333",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739d6",
        "height": 1.6485,
        "facings": [
          {
            "id": "696ebf6e43c343680a27096f",
            "leftCorner": {
              "x": 0.384,
              "y": -15.794,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.395,
              "y": -15.661,
              "z": 1.649
            },
            "gtin": "4003573025056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270970",
            "leftCorner": {
              "x": 0.391,
              "y": -15.661,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.399,
              "y": -15.501,
              "z": 1.649
            },
            "gtin": "4003573025018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270971",
            "leftCorner": {
              "x": 0.399,
              "y": -15.501,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.403,
              "y": -15.417,
              "z": 1.649
            },
            "gtin": "3600542512213",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270972",
            "leftCorner": {
              "x": 0.403,
              "y": -15.417,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.408,
              "y": -15.327,
              "z": 1.649
            },
            "gtin": "3600542461658",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270973",
            "leftCorner": {
              "x": 0.408,
              "y": -15.327,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.41,
              "y": -15.278,
              "z": 1.649
            },
            "gtin": "4260625262825",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270974",
            "leftCorner": {
              "x": 0.41,
              "y": -15.278,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.413,
              "y": -15.229,
              "z": 1.649
            },
            "gtin": "4260625262832",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270975",
            "leftCorner": {
              "x": 0.413,
              "y": -15.229,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.415,
              "y": -15.191,
              "z": 1.649
            },
            "gtin": "4260625262849",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270976",
            "leftCorner": {
              "x": 0.415,
              "y": -15.191,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.417,
              "y": -15.136,
              "z": 1.649
            },
            "gtin": "5037156267907",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270977",
            "leftCorner": {
              "x": 0.417,
              "y": -15.136,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.419,
              "y": -15.091,
              "z": 1.649
            },
            "gtin": "5037156267907",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270978",
            "leftCorner": {
              "x": 0.419,
              "y": -15.091,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.421,
              "y": -15.055,
              "z": 1.649
            },
            "gtin": "5037156278125",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270979",
            "leftCorner": {
              "x": 0.421,
              "y": -15.055,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.425,
              "y": -14.972,
              "z": 1.649
            },
            "gtin": "3600542020060",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27097a",
            "leftCorner": {
              "x": 0.425,
              "y": -14.972,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.429,
              "y": -14.902,
              "z": 1.649
            },
            "gtin": "3600541550445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27097b",
            "leftCorner": {
              "x": 0.429,
              "y": -14.902,
              "z": 1.649
            },
            "rightCorner": {
              "x": 0.433,
              "y": -14.816,
              "z": 1.649
            },
            "gtin": "3600542020053",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e76371b5fe7bc046959ab1",
    "name": "68e76371b5fe7bc046959ab1",
    "x": 0.39078,
    "y": -14.797,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68011,
      "w": 0.73311
    },
    "statistics": {
      "hasStockCount": 65,
      "noStockCount": 1,
      "unknownStockCount": 18,
      "shelfCategory": "HAIR"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd739e3",
        "height": 0.17612,
        "facings": [
          {
            "id": "696ebf6f43c343680a270ba5",
            "leftCorner": {
              "x": 0.436,
              "y": -14.8,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.441,
              "y": -14.704,
              "z": 0.176
            },
            "gtin": "4001638530378",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ba6",
            "leftCorner": {
              "x": 0.443,
              "y": -14.705,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.449,
              "y": -14.636,
              "z": 0.176
            },
            "gtin": "4001638590815",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ba7",
            "leftCorner": {
              "x": 0.449,
              "y": -14.636,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.452,
              "y": -14.593,
              "z": 0.176
            },
            "gtin": "4001638590822",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ba8",
            "leftCorner": {
              "x": 0.452,
              "y": -14.593,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.457,
              "y": -14.526,
              "z": 0.176
            },
            "gtin": "4066447331332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ba9",
            "leftCorner": {
              "x": 0.457,
              "y": -14.526,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.462,
              "y": -14.456,
              "z": 0.176
            },
            "gtin": "4066447235272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270baa",
            "leftCorner": {
              "x": 0.462,
              "y": -14.456,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.466,
              "y": -14.401,
              "z": 0.176
            },
            "gtin": "4067796081992",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bab",
            "leftCorner": {
              "x": 0.466,
              "y": -14.401,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.47,
              "y": -14.352,
              "z": 0.176
            },
            "gtin": "4066447523942",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bac",
            "leftCorner": {
              "x": 0.47,
              "y": -14.352,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.475,
              "y": -14.289,
              "z": 0.176
            },
            "gtin": "4066447331202",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bad",
            "leftCorner": {
              "x": 0.475,
              "y": -14.289,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.479,
              "y": -14.232,
              "z": 0.176
            },
            "gtin": "4066447331172",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bae",
            "leftCorner": {
              "x": 0.479,
              "y": -14.232,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.483,
              "y": -14.18,
              "z": 0.176
            },
            "gtin": "4066447378559",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270baf",
            "leftCorner": {
              "x": 0.483,
              "y": -14.18,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.487,
              "y": -14.121,
              "z": 0.176
            },
            "gtin": "4066447331226",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bb0",
            "leftCorner": {
              "x": 0.487,
              "y": -14.121,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.492,
              "y": -14.054,
              "z": 0.176
            },
            "gtin": "4066447107357",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bb1",
            "leftCorner": {
              "x": 0.492,
              "y": -14.054,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.497,
              "y": -13.99,
              "z": 0.176
            },
            "gtin": "4066447523621",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bb2",
            "leftCorner": {
              "x": 0.497,
              "y": -13.99,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.501,
              "y": -13.94,
              "z": 0.176
            },
            "gtin": "4067796070064",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bb3",
            "leftCorner": {
              "x": 0.501,
              "y": -13.94,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.506,
              "y": -13.871,
              "z": 0.176
            },
            "gtin": "4066447859638",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bb4",
            "leftCorner": {
              "x": 0.506,
              "y": -13.871,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.514,
              "y": -13.772,
              "z": 0.176
            },
            "gtin": "3600542512466",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739e0",
        "height": 0.47525,
        "facings": [
          {
            "id": "696ebf6f43c343680a270c52",
            "leftCorner": {
              "x": 0.435,
              "y": -14.784,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.439,
              "y": -14.696,
              "z": 0.475
            },
            "gtin": "4066447331240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c53",
            "leftCorner": {
              "x": 0.441,
              "y": -14.696,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.445,
              "y": -14.61,
              "z": 0.475
            },
            "gtin": "4066447592061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c54",
            "leftCorner": {
              "x": 0.448,
              "y": -14.61,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.452,
              "y": -14.55,
              "z": 0.475
            },
            "gtin": "4066447592085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c55",
            "leftCorner": {
              "x": 0.452,
              "y": -14.55,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.457,
              "y": -14.488,
              "z": 0.475
            },
            "gtin": "4066447330915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c56",
            "leftCorner": {
              "x": 0.457,
              "y": -14.488,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.461,
              "y": -14.429,
              "z": 0.475
            },
            "gtin": "4058172935961",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c57",
            "leftCorner": {
              "x": 0.461,
              "y": -14.429,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.465,
              "y": -14.38,
              "z": 0.475
            },
            "gtin": "4066447330953",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c58",
            "leftCorner": {
              "x": 0.465,
              "y": -14.38,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.47,
              "y": -14.318,
              "z": 0.475
            },
            "gtin": "4066447107371",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c59",
            "leftCorner": {
              "x": 0.47,
              "y": -14.318,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.474,
              "y": -14.257,
              "z": 0.475
            },
            "gtin": "4066447331356",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c5a",
            "leftCorner": {
              "x": 0.474,
              "y": -14.257,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.478,
              "y": -14.201,
              "z": 0.475
            },
            "gtin": "4066447331271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c5b",
            "leftCorner": {
              "x": 0.478,
              "y": -14.201,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.483,
              "y": -14.135,
              "z": 0.475
            },
            "gtin": "4067796083507",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c5c",
            "leftCorner": {
              "x": 0.483,
              "y": -14.135,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.488,
              "y": -14.076,
              "z": 0.475
            },
            "gtin": "4067796083507",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c5d",
            "leftCorner": {
              "x": 0.488,
              "y": -14.076,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.492,
              "y": -14.019,
              "z": 0.475
            },
            "gtin": "3600542657259",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c5e",
            "leftCorner": {
              "x": 0.492,
              "y": -14.019,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.496,
              "y": -13.961,
              "z": 0.475
            },
            "gtin": "3600542617710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c5f",
            "leftCorner": {
              "x": 0.496,
              "y": -13.961,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.504,
              "y": -13.865,
              "z": 0.475
            },
            "gtin": "3600542509350",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c60",
            "leftCorner": {
              "x": 0.504,
              "y": -13.865,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.51,
              "y": -13.783,
              "z": 0.475
            },
            "gtin": "3600542571586",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739dc",
        "height": 0.76606,
        "facings": [
          {
            "id": "696ebf6e43c343680a270a2a",
            "leftCorner": {
              "x": 0.435,
              "y": -14.786,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.44,
              "y": -14.725,
              "z": 0.766
            },
            "gtin": "3574661831435",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a2b",
            "leftCorner": {
              "x": 0.44,
              "y": -14.725,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.446,
              "y": -14.647,
              "z": 0.766
            },
            "gtin": "022796976710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a2c",
            "leftCorner": {
              "x": 0.446,
              "y": -14.647,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.453,
              "y": -14.555,
              "z": 0.766
            },
            "gtin": "022796976703",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a2d",
            "leftCorner": {
              "x": 0.453,
              "y": -14.555,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.459,
              "y": -14.473,
              "z": 0.766
            },
            "gtin": "022796976123",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a2e",
            "leftCorner": {
              "x": 0.459,
              "y": -14.473,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.465,
              "y": -14.386,
              "z": 0.766
            },
            "gtin": "3574661799438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a2f",
            "leftCorner": {
              "x": 0.465,
              "y": -14.386,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.47,
              "y": -14.322,
              "z": 0.766
            },
            "gtin": "3574661563312",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a30",
            "leftCorner": {
              "x": 0.47,
              "y": -14.322,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.475,
              "y": -14.261,
              "z": 0.766
            },
            "gtin": "4063528084439",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a31",
            "leftCorner": {
              "x": 0.475,
              "y": -14.261,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.48,
              "y": -14.196,
              "z": 0.766
            },
            "gtin": "4063528084408",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a32",
            "leftCorner": {
              "x": 0.48,
              "y": -14.196,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.484,
              "y": -14.138,
              "z": 0.766
            },
            "gtin": "4066447235258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a33",
            "leftCorner": {
              "x": 0.484,
              "y": -14.138,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.489,
              "y": -14.067,
              "z": 0.766
            },
            "gtin": "4066447235333",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a34",
            "leftCorner": {
              "x": 0.489,
              "y": -14.067,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.493,
              "y": -14.014,
              "z": 0.766
            },
            "gtin": "4262401738944",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a35",
            "leftCorner": {
              "x": 0.493,
              "y": -14.014,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.498,
              "y": -13.958,
              "z": 0.766
            },
            "gtin": "4262401738906",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a36",
            "leftCorner": {
              "x": 0.498,
              "y": -13.958,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.501,
              "y": -13.907,
              "z": 0.766
            },
            "gtin": "4262401738968",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a37",
            "leftCorner": {
              "x": 0.501,
              "y": -13.907,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.506,
              "y": -13.851,
              "z": 0.766
            },
            "gtin": "4262401732935",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a38",
            "leftCorner": {
              "x": 0.506,
              "y": -13.851,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.514,
              "y": -13.736,
              "z": 0.766
            },
            "gtin": "4262401732959",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739df",
        "height": 1.0603,
        "facings": [
          {
            "id": "696ebf6e43c343680a270aa7",
            "leftCorner": {
              "x": 0.439,
              "y": -14.745,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.444,
              "y": -14.678,
              "z": 1.06
            },
            "gtin": "4066447215892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270aa8",
            "leftCorner": {
              "x": 0.444,
              "y": -14.678,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.45,
              "y": -14.605,
              "z": 1.06
            },
            "gtin": "4066447215915",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270aa9",
            "leftCorner": {
              "x": 0.45,
              "y": -14.605,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.456,
              "y": -14.527,
              "z": 1.06
            },
            "gtin": "4063528071361",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270aaa",
            "leftCorner": {
              "x": 0.456,
              "y": -14.527,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.46,
              "y": -14.476,
              "z": 1.06
            },
            "gtin": "4270004570137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270aab",
            "leftCorner": {
              "x": 0.46,
              "y": -14.476,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.464,
              "y": -14.421,
              "z": 1.06
            },
            "gtin": "4270004570144",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270aac",
            "leftCorner": {
              "x": 0.464,
              "y": -14.421,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.468,
              "y": -14.363,
              "z": 1.06
            },
            "gtin": "4270004570106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270aad",
            "leftCorner": {
              "x": 0.468,
              "y": -14.363,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.473,
              "y": -14.295,
              "z": 1.06
            },
            "gtin": "4270004570113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270aae",
            "leftCorner": {
              "x": 0.473,
              "y": -14.295,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.476,
              "y": -14.259,
              "z": 1.06
            },
            "gtin": "4270004570120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270aaf",
            "leftCorner": {
              "x": 0.476,
              "y": -14.259,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.48,
              "y": -14.202,
              "z": 1.06
            },
            "gtin": "4262505740010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ab0",
            "leftCorner": {
              "x": 0.48,
              "y": -14.202,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.484,
              "y": -14.149,
              "z": 1.06
            },
            "gtin": "8700216928878",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ab1",
            "leftCorner": {
              "x": 0.484,
              "y": -14.149,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.489,
              "y": -14.079,
              "z": 1.06
            },
            "gtin": "8700216928823",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ab2",
            "leftCorner": {
              "x": 0.489,
              "y": -14.079,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.493,
              "y": -14.027,
              "z": 1.06
            },
            "gtin": "8700216210546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ab3",
            "leftCorner": {
              "x": 0.493,
              "y": -14.027,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.498,
              "y": -13.959,
              "z": 1.06
            },
            "gtin": "8700216212786",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ab4",
            "leftCorner": {
              "x": 0.498,
              "y": -13.959,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.502,
              "y": -13.91,
              "z": 1.06
            },
            "gtin": "8700216631792",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ab5",
            "leftCorner": {
              "x": 0.502,
              "y": -13.91,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.506,
              "y": -13.859,
              "z": 1.06
            },
            "gtin": "8700216631662",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ab6",
            "leftCorner": {
              "x": 0.506,
              "y": -13.859,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.51,
              "y": -13.803,
              "z": 1.06
            },
            "gtin": "8700216631730",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739e2",
        "height": 1.2279,
        "facings": []
      },
      {
        "id": "696ead8c3b88e258afd739e1",
        "height": 1.3579,
        "facings": [
          {
            "id": "696ebf6e43c343680a270b26",
            "leftCorner": {
              "x": 0.431,
              "y": -14.787,
              "z": 1.354
            },
            "rightCorner": {
              "x": 0.436,
              "y": -14.678,
              "z": 1.354
            },
            "gtin": "3600542511148",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b27",
            "leftCorner": {
              "x": 0.446,
              "y": -14.683,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.454,
              "y": -14.57,
              "z": 1.358
            },
            "gtin": "3600542511100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b28",
            "leftCorner": {
              "x": 0.454,
              "y": -14.57,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.462,
              "y": -14.468,
              "z": 1.358
            },
            "gtin": "3600542511612",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b29",
            "leftCorner": {
              "x": 0.462,
              "y": -14.468,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.469,
              "y": -14.372,
              "z": 1.358
            },
            "gtin": "3600542511070",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b2a",
            "leftCorner": {
              "x": 0.469,
              "y": -14.372,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.477,
              "y": -14.263,
              "z": 1.358
            },
            "gtin": "3600542511049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b2b",
            "leftCorner": {
              "x": 0.477,
              "y": -14.263,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.485,
              "y": -14.161,
              "z": 1.358
            }
          },
          {
            "id": "696ebf6e43c343680a270b2c",
            "leftCorner": {
              "x": 0.485,
              "y": -14.161,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.49,
              "y": -14.098,
              "z": 1.358
            },
            "gtin": "3600524137854",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b2d",
            "leftCorner": {
              "x": 0.49,
              "y": -14.098,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.498,
              "y": -13.995,
              "z": 1.358
            },
            "gtin": "3600524173098",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b2e",
            "leftCorner": {
              "x": 0.498,
              "y": -13.995,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.502,
              "y": -13.929,
              "z": 1.358
            },
            "gtin": "3600524137731",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b2f",
            "leftCorner": {
              "x": 0.502,
              "y": -13.929,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.508,
              "y": -13.861,
              "z": 1.358
            },
            "gtin": "3600524137618",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b30",
            "leftCorner": {
              "x": 0.508,
              "y": -13.861,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.512,
              "y": -13.803,
              "z": 1.358
            },
            "gtin": "3600524142124",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739dd",
        "height": 1.6506,
        "facings": [
          {
            "id": "696ebf6e43c343680a27097c",
            "leftCorner": {
              "x": 0.444,
              "y": -14.801,
              "z": 1.651
            },
            "rightCorner": {
              "x": 0.447,
              "y": -14.738,
              "z": 1.651
            },
            "gtin": "3600542656825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27097d",
            "leftCorner": {
              "x": 0.448,
              "y": -14.738,
              "z": 1.651
            },
            "rightCorner": {
              "x": 0.457,
              "y": -14.618,
              "z": 1.651
            },
            "gtin": "3600542657143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27097e",
            "leftCorner": {
              "x": 0.457,
              "y": -14.618,
              "z": 1.651
            },
            "rightCorner": {
              "x": 0.462,
              "y": -14.563,
              "z": 1.651
            }
          },
          {
            "id": "696ebf6e43c343680a27097f",
            "leftCorner": {
              "x": 0.462,
              "y": -14.563,
              "z": 1.651
            },
            "rightCorner": {
              "x": 0.469,
              "y": -14.467,
              "z": 1.651
            },
            "gtin": "3600542571739",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270980",
            "leftCorner": {
              "x": 0.469,
              "y": -14.467,
              "z": 1.651
            },
            "rightCorner": {
              "x": 0.473,
              "y": -14.413,
              "z": 1.651
            },
            "gtin": "3600542571333",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270981",
            "leftCorner": {
              "x": 0.473,
              "y": -14.413,
              "z": 1.651
            },
            "rightCorner": {
              "x": 0.48,
              "y": -14.316,
              "z": 1.651
            },
            "gtin": "3600542590631",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270982",
            "leftCorner": {
              "x": 0.48,
              "y": -14.316,
              "z": 1.651
            },
            "rightCorner": {
              "x": 0.484,
              "y": -14.27,
              "z": 1.651
            },
            "gtin": "3600542585996",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270983",
            "leftCorner": {
              "x": 0.484,
              "y": -14.27,
              "z": 1.651
            },
            "rightCorner": {
              "x": 0.489,
              "y": -14.196,
              "z": 1.651
            },
            "gtin": "3600542657044",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270984",
            "leftCorner": {
              "x": 0.489,
              "y": -14.196,
              "z": 1.651
            },
            "rightCorner": {
              "x": 0.493,
              "y": -14.139,
              "z": 1.651
            },
            "gtin": "3600542639040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270985",
            "leftCorner": {
              "x": 0.493,
              "y": -14.139,
              "z": 1.651
            },
            "rightCorner": {
              "x": 0.501,
              "y": -14.04,
              "z": 1.651
            },
            "gtin": "3600542638951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270986",
            "leftCorner": {
              "x": 0.501,
              "y": -14.04,
              "z": 1.651
            },
            "rightCorner": {
              "x": 0.505,
              "y": -13.986,
              "z": 1.651
            },
            "gtin": "3600542638777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270987",
            "leftCorner": {
              "x": 0.505,
              "y": -13.986,
              "z": 1.651
            },
            "rightCorner": {
              "x": 0.51,
              "y": -13.92,
              "z": 1.651
            },
            "gtin": "3600542117593",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270988",
            "leftCorner": {
              "x": 0.51,
              "y": -13.92,
              "z": 1.651
            },
            "rightCorner": {
              "x": 0.518,
              "y": -13.807,
              "z": 1.651
            },
            "gtin": "3600542398022",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e76371b5fe7bc046959ab2",
    "name": "68e76371b5fe7bc046959ab2",
    "x": 0.46243,
    "y": -13.794,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.67995,
      "w": 0.73325
    },
    "statistics": {
      "hasStockCount": 53,
      "noStockCount": 0,
      "unknownStockCount": 24,
      "shelfCategory": "HAIR"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd739e8",
        "height": 0.17748,
        "facings": [
          {
            "id": "696ebf6f43c343680a270bb5",
            "leftCorner": {
              "x": 0.51,
              "y": -13.766,
              "z": 0.177
            },
            "rightCorner": {
              "x": 0.517,
              "y": -13.67,
              "z": 0.177
            },
            "gtin": "3600542461450",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bb6",
            "leftCorner": {
              "x": 0.517,
              "y": -13.67,
              "z": 0.177
            },
            "rightCorner": {
              "x": 0.523,
              "y": -13.593,
              "z": 0.177
            },
            "gtin": "3600542461313",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bb7",
            "leftCorner": {
              "x": 0.523,
              "y": -13.593,
              "z": 0.177
            },
            "rightCorner": {
              "x": 0.53,
              "y": -13.498,
              "z": 0.177
            },
            "gtin": "3600542572026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bb8",
            "leftCorner": {
              "x": 0.53,
              "y": -13.498,
              "z": 0.177
            },
            "rightCorner": {
              "x": 0.535,
              "y": -13.426,
              "z": 0.177
            },
            "gtin": "3600542572156",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bb9",
            "leftCorner": {
              "x": 0.535,
              "y": -13.426,
              "z": 0.177
            },
            "rightCorner": {
              "x": 0.541,
              "y": -13.352,
              "z": 0.177
            },
            "gtin": "3600542462839",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bba",
            "leftCorner": {
              "x": 0.541,
              "y": -13.352,
              "z": 0.177
            },
            "rightCorner": {
              "x": 0.548,
              "y": -13.255,
              "z": 0.177
            },
            "gtin": "3600542462365",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bbb",
            "leftCorner": {
              "x": 0.548,
              "y": -13.255,
              "z": 0.177
            },
            "rightCorner": {
              "x": 0.552,
              "y": -13.2,
              "z": 0.177
            },
            "gtin": "3600542567329",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bbc",
            "leftCorner": {
              "x": 0.552,
              "y": -13.2,
              "z": 0.177
            },
            "rightCorner": {
              "x": 0.556,
              "y": -13.149,
              "z": 0.177
            },
            "gtin": "3600542624336",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bbd",
            "leftCorner": {
              "x": 0.556,
              "y": -13.149,
              "z": 0.177
            },
            "rightCorner": {
              "x": 0.561,
              "y": -13.087,
              "z": 0.177
            },
            "gtin": "3600542617741",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bbe",
            "leftCorner": {
              "x": 0.561,
              "y": -13.087,
              "z": 0.177
            },
            "rightCorner": {
              "x": 0.567,
              "y": -13.005,
              "z": 0.177
            },
            "gtin": "3600542461030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bbf",
            "leftCorner": {
              "x": 0.567,
              "y": -13.005,
              "z": 0.177
            },
            "rightCorner": {
              "x": 0.574,
              "y": -12.912,
              "z": 0.177
            },
            "gtin": "3600542462150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bc0",
            "leftCorner": {
              "x": 0.574,
              "y": -12.912,
              "z": 0.177
            },
            "rightCorner": {
              "x": 0.581,
              "y": -12.819,
              "z": 0.177
            },
            "gtin": "3600542461900",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739e5",
        "height": 0.4776,
        "facings": [
          {
            "id": "696ebf6f43c343680a270c61",
            "leftCorner": {
              "x": 0.508,
              "y": -13.778,
              "z": 0.478
            },
            "rightCorner": {
              "x": 0.515,
              "y": -13.68,
              "z": 0.478
            },
            "gtin": "3600542510271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c62",
            "leftCorner": {
              "x": 0.515,
              "y": -13.68,
              "z": 0.478
            },
            "rightCorner": {
              "x": 0.522,
              "y": -13.596,
              "z": 0.478
            },
            "gtin": "3600542509428",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c63",
            "leftCorner": {
              "x": 0.522,
              "y": -13.596,
              "z": 0.478
            },
            "rightCorner": {
              "x": 0.528,
              "y": -13.513,
              "z": 0.478
            },
            "gtin": "3600542510127",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c64",
            "leftCorner": {
              "x": 0.528,
              "y": -13.513,
              "z": 0.478
            },
            "rightCorner": {
              "x": 0.535,
              "y": -13.421,
              "z": 0.478
            },
            "gtin": "3600542509572",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c65",
            "leftCorner": {
              "x": 0.535,
              "y": -13.421,
              "z": 0.478
            },
            "rightCorner": {
              "x": 0.543,
              "y": -13.317,
              "z": 0.478
            },
            "gtin": "3600542656191",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c66",
            "leftCorner": {
              "x": 0.543,
              "y": -13.317,
              "z": 0.478
            },
            "rightCorner": {
              "x": 0.549,
              "y": -13.228,
              "z": 0.478
            },
            "gtin": "3600542656566",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c67",
            "leftCorner": {
              "x": 0.549,
              "y": -13.228,
              "z": 0.478
            },
            "rightCorner": {
              "x": 0.556,
              "y": -13.137,
              "z": 0.478
            },
            "gtin": "3600542656320",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c68",
            "leftCorner": {
              "x": 0.556,
              "y": -13.137,
              "z": 0.478
            },
            "rightCorner": {
              "x": 0.563,
              "y": -13.049,
              "z": 0.478
            },
            "gtin": "3600542460750",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c69",
            "leftCorner": {
              "x": 0.563,
              "y": -13.049,
              "z": 0.478
            },
            "rightCorner": {
              "x": 0.568,
              "y": -12.978,
              "z": 0.478
            },
            "gtin": "3600542639200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c6a",
            "leftCorner": {
              "x": 0.568,
              "y": -12.978,
              "z": 0.478
            },
            "rightCorner": {
              "x": 0.572,
              "y": -12.929,
              "z": 0.478
            },
            "gtin": "4015100812435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c6b",
            "leftCorner": {
              "x": 0.572,
              "y": -12.929,
              "z": 0.478
            },
            "rightCorner": {
              "x": 0.577,
              "y": -12.869,
              "z": 0.478
            },
            "gtin": "4015100812275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c6c",
            "leftCorner": {
              "x": 0.577,
              "y": -12.872,
              "z": 0.476
            },
            "rightCorner": {
              "x": 0.582,
              "y": -12.807,
              "z": 0.476
            },
            "gtin": "4015100814095",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739e4",
        "height": 0.76917,
        "facings": [
          {
            "id": "696ebf6e43c343680a270a39",
            "leftCorner": {
              "x": 0.511,
              "y": -13.731,
              "z": 0.769
            },
            "rightCorner": {
              "x": 0.514,
              "y": -13.688,
              "z": 0.769
            }
          },
          {
            "id": "696ebf6e43c343680a270a3a",
            "leftCorner": {
              "x": 0.514,
              "y": -13.688,
              "z": 0.769
            },
            "rightCorner": {
              "x": 0.521,
              "y": -13.586,
              "z": 0.769
            },
            "gtin": "4262500781100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a3b",
            "leftCorner": {
              "x": 0.521,
              "y": -13.586,
              "z": 0.769
            },
            "rightCorner": {
              "x": 0.526,
              "y": -13.528,
              "z": 0.769
            },
            "gtin": "4262500780905",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a3c",
            "leftCorner": {
              "x": 0.526,
              "y": -13.528,
              "z": 0.769
            },
            "rightCorner": {
              "x": 0.534,
              "y": -13.425,
              "z": 0.769
            },
            "gtin": "4262500780882",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a3d",
            "leftCorner": {
              "x": 0.534,
              "y": -13.425,
              "z": 0.769
            },
            "rightCorner": {
              "x": 0.539,
              "y": -13.349,
              "z": 0.769
            },
            "gtin": "4262401731686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a3e",
            "leftCorner": {
              "x": 0.539,
              "y": -13.349,
              "z": 0.769
            },
            "rightCorner": {
              "x": 0.543,
              "y": -13.295,
              "z": 0.769
            },
            "gtin": "4262500780288",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a3f",
            "leftCorner": {
              "x": 0.543,
              "y": -13.295,
              "z": 0.769
            },
            "rightCorner": {
              "x": 0.548,
              "y": -13.233,
              "z": 0.769
            },
            "gtin": "4260602121466",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a40",
            "leftCorner": {
              "x": 0.548,
              "y": -13.233,
              "z": 0.769
            },
            "rightCorner": {
              "x": 0.552,
              "y": -13.179,
              "z": 0.769
            },
            "gtin": "4260602121404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a41",
            "leftCorner": {
              "x": 0.552,
              "y": -13.179,
              "z": 0.769
            },
            "rightCorner": {
              "x": 0.556,
              "y": -13.123,
              "z": 0.769
            },
            "gtin": "4260602121510",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a42",
            "leftCorner": {
              "x": 0.556,
              "y": -13.123,
              "z": 0.769
            },
            "rightCorner": {
              "x": 0.561,
              "y": -13.066,
              "z": 0.769
            }
          },
          {
            "id": "696ebf6e43c343680a270a43",
            "leftCorner": {
              "x": 0.561,
              "y": -13.066,
              "z": 0.769
            },
            "rightCorner": {
              "x": 0.565,
              "y": -13.015,
              "z": 0.769
            },
            "gtin": "4262401738920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a44",
            "leftCorner": {
              "x": 0.565,
              "y": -13.015,
              "z": 0.769
            },
            "rightCorner": {
              "x": 0.569,
              "y": -12.963,
              "z": 0.769
            },
            "gtin": "4262401738883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a45",
            "leftCorner": {
              "x": 0.569,
              "y": -12.963,
              "z": 0.769
            },
            "rightCorner": {
              "x": 0.573,
              "y": -12.906,
              "z": 0.769
            },
            "gtin": "4063528078377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a46",
            "leftCorner": {
              "x": 0.577,
              "y": -12.909,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.582,
              "y": -12.847,
              "z": 0.768
            },
            "gtin": "4063528078407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a47",
            "leftCorner": {
              "x": 0.581,
              "y": -12.847,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.585,
              "y": -12.795,
              "z": 0.768
            },
            "gtin": "4063528078438",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739e9",
        "height": 1.0641,
        "facings": [
          {
            "id": "696ebf6e43c343680a270ab7",
            "leftCorner": {
              "x": 0.511,
              "y": -13.798,
              "z": 1.064
            },
            "rightCorner": {
              "x": 0.514,
              "y": -13.758,
              "z": 1.064
            },
            "gtin": "8700216631761",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ab8",
            "leftCorner": {
              "x": 0.514,
              "y": -13.758,
              "z": 1.064
            },
            "rightCorner": {
              "x": 0.522,
              "y": -13.65,
              "z": 1.064
            },
            "gtin": "8700216212724",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ab9",
            "leftCorner": {
              "x": 0.522,
              "y": -13.65,
              "z": 1.064
            },
            "rightCorner": {
              "x": 0.528,
              "y": -13.575,
              "z": 1.064
            },
            "gtin": "8700216212748",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270aba",
            "leftCorner": {
              "x": 0.528,
              "y": -13.575,
              "z": 1.064
            },
            "rightCorner": {
              "x": 0.531,
              "y": -13.531,
              "z": 1.064
            },
            "gtin": "8700216210508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270abb",
            "leftCorner": {
              "x": 0.531,
              "y": -13.531,
              "z": 1.064
            },
            "rightCorner": {
              "x": 0.54,
              "y": -13.415,
              "z": 1.064
            },
            "gtin": "8700216212847",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270abc",
            "leftCorner": {
              "x": 0.54,
              "y": -13.415,
              "z": 1.064
            },
            "rightCorner": {
              "x": 0.545,
              "y": -13.347,
              "z": 1.064
            },
            "gtin": "4063528086327",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270abd",
            "leftCorner": {
              "x": 0.545,
              "y": -13.347,
              "z": 1.064
            },
            "rightCorner": {
              "x": 0.55,
              "y": -13.281,
              "z": 1.064
            },
            "gtin": "4063528086334",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270abe",
            "leftCorner": {
              "x": 0.55,
              "y": -13.281,
              "z": 1.064
            },
            "rightCorner": {
              "x": 0.554,
              "y": -13.22,
              "z": 1.064
            },
            "gtin": "4063528086297",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270abf",
            "leftCorner": {
              "x": 0.554,
              "y": -13.22,
              "z": 1.064
            },
            "rightCorner": {
              "x": 0.559,
              "y": -13.16,
              "z": 1.064
            },
            "gtin": "4063528086303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ac0",
            "leftCorner": {
              "x": 0.559,
              "y": -13.16,
              "z": 1.064
            },
            "rightCorner": {
              "x": 0.562,
              "y": -13.121,
              "z": 1.064
            },
            "gtin": "4063528097651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270ac1",
            "leftCorner": {
              "x": 0.562,
              "y": -13.121,
              "z": 1.064
            },
            "rightCorner": {
              "x": 0.566,
              "y": -13.071,
              "z": 1.064
            },
            "gtin": "4063528097644",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ac2",
            "leftCorner": {
              "x": 0.566,
              "y": -13.071,
              "z": 1.064
            },
            "rightCorner": {
              "x": 0.57,
              "y": -13.017,
              "z": 1.064
            },
            "gtin": "4063528097637",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ac3",
            "leftCorner": {
              "x": 0.57,
              "y": -13.017,
              "z": 1.064
            },
            "rightCorner": {
              "x": 0.573,
              "y": -12.97,
              "z": 1.064
            },
            "gtin": "4063528097620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ac4",
            "leftCorner": {
              "x": 0.573,
              "y": -12.97,
              "z": 1.064
            },
            "rightCorner": {
              "x": 0.577,
              "y": -12.921,
              "z": 1.064
            },
            "gtin": "4063528097613",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ac5",
            "leftCorner": {
              "x": 0.577,
              "y": -12.921,
              "z": 1.064
            },
            "rightCorner": {
              "x": 0.581,
              "y": -12.866,
              "z": 1.064
            },
            "gtin": "4063528097606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270ac6",
            "leftCorner": {
              "x": 0.582,
              "y": -12.869,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.586,
              "y": -12.813,
              "z": 1.063
            },
            "gtin": "4063528078346",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739e6",
        "height": 1.3592,
        "facings": [
          {
            "id": "696ebf6e43c343680a270b31",
            "leftCorner": {
              "x": 0.511,
              "y": -13.798,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.517,
              "y": -13.724,
              "z": 1.359
            },
            "gtin": "3600524196561",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b32",
            "leftCorner": {
              "x": 0.517,
              "y": -13.724,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.529,
              "y": -13.569,
              "z": 1.359
            },
            "gtin": "3600524189921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270b33",
            "leftCorner": {
              "x": 0.529,
              "y": -13.569,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.535,
              "y": -13.484,
              "z": 1.359
            },
            "gtin": "3600524138011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b34",
            "leftCorner": {
              "x": 0.535,
              "y": -13.484,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.541,
              "y": -13.408,
              "z": 1.359
            },
            "gtin": "3600524230555",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b35",
            "leftCorner": {
              "x": 0.541,
              "y": -13.408,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.549,
              "y": -13.307,
              "z": 1.359
            },
            "gtin": "3600524230128",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b36",
            "leftCorner": {
              "x": 0.549,
              "y": -13.307,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.556,
              "y": -13.204,
              "z": 1.359
            },
            "gtin": "3600524138776",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b37",
            "leftCorner": {
              "x": 0.556,
              "y": -13.204,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.561,
              "y": -13.138,
              "z": 1.359
            },
            "gtin": "3600524138400",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b38",
            "leftCorner": {
              "x": 0.561,
              "y": -13.138,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.566,
              "y": -13.074,
              "z": 1.359
            },
            "gtin": "3600524141820",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b39",
            "leftCorner": {
              "x": 0.566,
              "y": -13.074,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.57,
              "y": -13.022,
              "z": 1.359
            },
            "gtin": "3600524160517",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b3a",
            "leftCorner": {
              "x": 0.57,
              "y": -13.022,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.575,
              "y": -12.953,
              "z": 1.359
            },
            "gtin": "3600524142735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270b3b",
            "leftCorner": {
              "x": 0.575,
              "y": -12.953,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.586,
              "y": -12.808,
              "z": 1.359
            },
            "gtin": "3600524139155",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739e7",
        "height": 1.652,
        "facings": [
          {
            "id": "696ebf6e43c343680a270989",
            "leftCorner": {
              "x": 0.518,
              "y": -13.798,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.525,
              "y": -13.708,
              "z": 1.652
            },
            "gtin": "3600542117920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27098a",
            "leftCorner": {
              "x": 0.525,
              "y": -13.708,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.53,
              "y": -13.647,
              "z": 1.652
            },
            "gtin": "3600542117944",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27098b",
            "leftCorner": {
              "x": 0.53,
              "y": -13.647,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.536,
              "y": -13.569,
              "z": 1.652
            },
            "gtin": "3600541970533",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27098c",
            "leftCorner": {
              "x": 0.536,
              "y": -13.569,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.54,
              "y": -13.509,
              "z": 1.652
            },
            "gtin": "3600542040150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27098d",
            "leftCorner": {
              "x": 0.54,
              "y": -13.509,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.545,
              "y": -13.45,
              "z": 1.652
            },
            "gtin": "3600542040013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27098e",
            "leftCorner": {
              "x": 0.545,
              "y": -13.45,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.551,
              "y": -13.368,
              "z": 1.652
            },
            "gtin": "3600542430289",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27098f",
            "leftCorner": {
              "x": 0.551,
              "y": -13.368,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.557,
              "y": -13.286,
              "z": 1.652
            },
            "gtin": "3600541979918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270990",
            "leftCorner": {
              "x": 0.557,
              "y": -13.286,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.562,
              "y": -13.213,
              "z": 1.652
            },
            "gtin": "3600542040068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270991",
            "leftCorner": {
              "x": 0.562,
              "y": -13.213,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.568,
              "y": -13.14,
              "z": 1.652
            },
            "gtin": "3600542040075",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270992",
            "leftCorner": {
              "x": 0.568,
              "y": -13.14,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.574,
              "y": -13.064,
              "z": 1.652
            },
            "gtin": "3600542040129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270993",
            "leftCorner": {
              "x": 0.574,
              "y": -13.064,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.577,
              "y": -13.014,
              "z": 1.652
            },
            "gtin": "3600542039994",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270994",
            "leftCorner": {
              "x": 0.577,
              "y": -13.014,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.583,
              "y": -12.938,
              "z": 1.652
            },
            "gtin": "3600542040037",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270995",
            "leftCorner": {
              "x": 0.583,
              "y": -12.938,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.589,
              "y": -12.858,
              "z": 1.652
            },
            "gtin": "3600542039970",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e76371b5fe7bc046959ab3",
    "name": "68e76371b5fe7bc046959ab3",
    "x": 0.53279,
    "y": -12.8,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68453,
      "w": 0.72898
    },
    "statistics": {
      "hasStockCount": 66,
      "noStockCount": 1,
      "unknownStockCount": 19,
      "shelfCategory": "HAIR"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd739ef",
        "height": 0.17284,
        "facings": [
          {
            "id": "696ebf6f43c343680a270bc1",
            "leftCorner": {
              "x": 0.581,
              "y": -12.819,
              "z": 0.177
            },
            "rightCorner": {
              "x": 0.587,
              "y": -12.737,
              "z": 0.177
            },
            "gtin": "3600542461856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bc2",
            "leftCorner": {
              "x": 0.582,
              "y": -12.74,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.587,
              "y": -12.656,
              "z": 0.173
            },
            "gtin": "4015100812251",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bc3",
            "leftCorner": {
              "x": 0.587,
              "y": -12.656,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.592,
              "y": -12.575,
              "z": 0.173
            },
            "gtin": "4015100812398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bc4",
            "leftCorner": {
              "x": 0.592,
              "y": -12.575,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.596,
              "y": -12.518,
              "z": 0.173
            },
            "gtin": "4015100813418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bc5",
            "leftCorner": {
              "x": 0.596,
              "y": -12.518,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.599,
              "y": -12.472,
              "z": 0.173
            },
            "gtin": "4015100813494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bc6",
            "leftCorner": {
              "x": 0.599,
              "y": -12.472,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.603,
              "y": -12.405,
              "z": 0.173
            },
            "gtin": "4015100812374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bc7",
            "leftCorner": {
              "x": 0.603,
              "y": -12.405,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.608,
              "y": -12.327,
              "z": 0.173
            },
            "gtin": "4015100812312",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bc8",
            "leftCorner": {
              "x": 0.608,
              "y": -12.327,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.611,
              "y": -12.271,
              "z": 0.173
            },
            "gtin": "4015100812510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bc9",
            "leftCorner": {
              "x": 0.611,
              "y": -12.271,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.615,
              "y": -12.22,
              "z": 0.173
            },
            "gtin": "4015100813456",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bca",
            "leftCorner": {
              "x": 0.615,
              "y": -12.22,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.621,
              "y": -12.121,
              "z": 0.173
            },
            "gtin": "4015100812473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bcb",
            "leftCorner": {
              "x": 0.621,
              "y": -12.121,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.625,
              "y": -12.048,
              "z": 0.173
            },
            "gtin": "4015100813432",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bcc",
            "leftCorner": {
              "x": 0.625,
              "y": -12.048,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.63,
              "y": -11.978,
              "z": 0.173
            },
            "gtin": "4015100865134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bcd",
            "leftCorner": {
              "x": 0.63,
              "y": -11.978,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.636,
              "y": -11.886,
              "z": 0.173
            },
            "gtin": "4015100862881",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bce",
            "leftCorner": {
              "x": 0.636,
              "y": -11.886,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.64,
              "y": -11.817,
              "z": 0.173
            },
            "gtin": "4015100862904",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bcf",
            "leftCorner": {
              "x": 0.64,
              "y": -11.817,
              "z": 0.173
            },
            "rightCorner": {
              "x": 0.644,
              "y": -11.748,
              "z": 0.173
            },
            "gtin": "4015100862942",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739eb",
        "height": 0.47571,
        "facings": [
          {
            "id": "696ebf6f43c343680a270c6d",
            "leftCorner": {
              "x": 0.581,
              "y": -12.807,
              "z": 0.476
            },
            "rightCorner": {
              "x": 0.587,
              "y": -12.728,
              "z": 0.476
            },
            "gtin": "4015100813470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c6e",
            "leftCorner": {
              "x": 0.586,
              "y": -12.728,
              "z": 0.476
            },
            "rightCorner": {
              "x": 0.599,
              "y": -12.529,
              "z": 0.476
            },
            "gtin": "4015100339789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c6f",
            "leftCorner": {
              "x": 0.599,
              "y": -12.529,
              "z": 0.476
            },
            "rightCorner": {
              "x": 0.605,
              "y": -12.43,
              "z": 0.476
            },
            "gtin": "4015100861822",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c70",
            "leftCorner": {
              "x": 0.605,
              "y": -12.43,
              "z": 0.476
            },
            "rightCorner": {
              "x": 0.609,
              "y": -12.36,
              "z": 0.476
            },
            "gtin": "4015100813098",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c71",
            "leftCorner": {
              "x": 0.609,
              "y": -12.36,
              "z": 0.476
            },
            "rightCorner": {
              "x": 0.614,
              "y": -12.286,
              "z": 0.476
            },
            "gtin": "4015100812336",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c72",
            "leftCorner": {
              "x": 0.614,
              "y": -12.286,
              "z": 0.476
            },
            "rightCorner": {
              "x": 0.618,
              "y": -12.231,
              "z": 0.476
            },
            "gtin": "4015100813357",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c73",
            "leftCorner": {
              "x": 0.618,
              "y": -12.231,
              "z": 0.476
            },
            "rightCorner": {
              "x": 0.62,
              "y": -12.197,
              "z": 0.476
            },
            "gtin": "4015100813838",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c74",
            "leftCorner": {
              "x": 0.62,
              "y": -12.197,
              "z": 0.476
            },
            "rightCorner": {
              "x": 0.623,
              "y": -12.139,
              "z": 0.476
            },
            "gtin": "4015100813111",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c75",
            "leftCorner": {
              "x": 0.623,
              "y": -12.139,
              "z": 0.476
            },
            "rightCorner": {
              "x": 0.628,
              "y": -12.061,
              "z": 0.476
            },
            "gtin": "4015100812350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c76",
            "leftCorner": {
              "x": 0.628,
              "y": -12.061,
              "z": 0.476
            },
            "rightCorner": {
              "x": 0.632,
              "y": -12.009,
              "z": 0.476
            },
            "gtin": "4015100813395",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c77",
            "leftCorner": {
              "x": 0.632,
              "y": -12.009,
              "z": 0.476
            },
            "rightCorner": {
              "x": 0.635,
              "y": -11.96,
              "z": 0.476
            },
            "gtin": "4015100816747",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c78",
            "leftCorner": {
              "x": 0.635,
              "y": -11.96,
              "z": 0.476
            },
            "rightCorner": {
              "x": 0.638,
              "y": -11.904,
              "z": 0.476
            },
            "gtin": "4015100813814",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c79",
            "leftCorner": {
              "x": 0.638,
              "y": -11.904,
              "z": 0.476
            },
            "rightCorner": {
              "x": 0.643,
              "y": -11.834,
              "z": 0.476
            },
            "gtin": "4072600282373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c7a",
            "leftCorner": {
              "x": 0.643,
              "y": -11.834,
              "z": 0.476
            },
            "rightCorner": {
              "x": 0.645,
              "y": -11.789,
              "z": 0.476
            },
            "gtin": "4072600282380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c7b",
            "leftCorner": {
              "x": 0.643,
              "y": -11.788,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.646,
              "y": -11.743,
              "z": 0.475
            },
            "gtin": "4072600282380",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739ec",
        "height": 0.76767,
        "facings": [
          {
            "id": "696ebf6e43c343680a270a48",
            "leftCorner": {
              "x": 0.584,
              "y": -12.795,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.587,
              "y": -12.752,
              "z": 0.768
            },
            "gtin": "4063528097668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a49",
            "leftCorner": {
              "x": 0.587,
              "y": -12.752,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.591,
              "y": -12.7,
              "z": 0.768
            },
            "gtin": "9000101279009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a4a",
            "leftCorner": {
              "x": 0.59,
              "y": -12.7,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.605,
              "y": -12.46,
              "z": 0.768
            },
            "gtin": "4015100813319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a4b",
            "leftCorner": {
              "x": 0.605,
              "y": -12.46,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.611,
              "y": -12.364,
              "z": 0.768
            },
            "gtin": "4015100813517",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a4c",
            "leftCorner": {
              "x": 0.611,
              "y": -12.364,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.617,
              "y": -12.276,
              "z": 0.768
            },
            "gtin": "4015100813913",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a4d",
            "leftCorner": {
              "x": 0.617,
              "y": -12.276,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.625,
              "y": -12.152,
              "z": 0.768
            },
            "gtin": "4015100814033",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a4e",
            "leftCorner": {
              "x": 0.625,
              "y": -12.152,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.633,
              "y": -12.023,
              "z": 0.768
            },
            "gtin": "4015100814071",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a4f",
            "leftCorner": {
              "x": 0.633,
              "y": -12.023,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.639,
              "y": -11.922,
              "z": 0.768
            },
            "gtin": "3600524021948",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a50",
            "leftCorner": {
              "x": 0.639,
              "y": -11.922,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.642,
              "y": -11.871,
              "z": 0.768
            },
            "gtin": "4072600710135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a51",
            "leftCorner": {
              "x": 0.642,
              "y": -11.871,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.644,
              "y": -11.838,
              "z": 0.768
            },
            "gtin": "4072600720097",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a52",
            "leftCorner": {
              "x": 0.644,
              "y": -11.838,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.647,
              "y": -11.801,
              "z": 0.768
            },
            "gtin": "4072600720080",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739ed",
        "height": 1.0634,
        "facings": [
          {
            "id": "696ebf6e43c343680a270ac7",
            "leftCorner": {
              "x": 0.586,
              "y": -12.813,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.59,
              "y": -12.756,
              "z": 1.063
            },
            "gtin": "4063528078315",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ac8",
            "leftCorner": {
              "x": 0.589,
              "y": -12.756,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.599,
              "y": -12.592,
              "z": 1.063
            },
            "gtin": "4063528078223",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ac9",
            "leftCorner": {
              "x": 0.599,
              "y": -12.592,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.607,
              "y": -12.477,
              "z": 1.063
            },
            "gtin": "4063528078254",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270aca",
            "leftCorner": {
              "x": 0.607,
              "y": -12.477,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.609,
              "y": -12.433,
              "z": 1.063
            },
            "gtin": "4063528078520",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270acb",
            "leftCorner": {
              "x": 0.609,
              "y": -12.433,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.612,
              "y": -12.39,
              "z": 1.063
            },
            "gtin": "4063528086280",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270acc",
            "leftCorner": {
              "x": 0.612,
              "y": -12.39,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.616,
              "y": -12.332,
              "z": 1.063
            },
            "gtin": "4063528078469",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270acd",
            "leftCorner": {
              "x": 0.616,
              "y": -12.332,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.619,
              "y": -12.279,
              "z": 1.063
            },
            "gtin": "4063528094575",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ace",
            "leftCorner": {
              "x": 0.619,
              "y": -12.279,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.622,
              "y": -12.226,
              "z": 1.063
            },
            "gtin": "3600523734955",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270acf",
            "leftCorner": {
              "x": 0.622,
              "y": -12.226,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.626,
              "y": -12.172,
              "z": 1.063
            },
            "gtin": "3600523749188",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ad0",
            "leftCorner": {
              "x": 0.626,
              "y": -12.172,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.629,
              "y": -12.117,
              "z": 1.063
            },
            "gtin": "3600524135805",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ad1",
            "leftCorner": {
              "x": 0.629,
              "y": -12.117,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.637,
              "y": -11.998,
              "z": 1.063
            },
            "gtin": "3600523965045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ad2",
            "leftCorner": {
              "x": 0.637,
              "y": -11.998,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.643,
              "y": -11.896,
              "z": 1.063
            },
            "gtin": "3600523900664",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ad3",
            "leftCorner": {
              "x": 0.643,
              "y": -11.896,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.649,
              "y": -11.8,
              "z": 1.063
            },
            "gtin": "3600524035860",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739ee",
        "height": 1.3586,
        "facings": [
          {
            "id": "696ebf6e43c343680a270b3c",
            "leftCorner": {
              "x": 0.589,
              "y": -12.804,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.597,
              "y": -12.7,
              "z": 1.359
            },
            "gtin": "3600524139698",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b3d",
            "leftCorner": {
              "x": 0.596,
              "y": -12.7,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.602,
              "y": -12.6,
              "z": 1.359
            },
            "gtin": "3600524142995",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b3e",
            "leftCorner": {
              "x": 0.602,
              "y": -12.6,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.606,
              "y": -12.54,
              "z": 1.359
            },
            "gtin": "3600524074517",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b3f",
            "leftCorner": {
              "x": 0.606,
              "y": -12.54,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.61,
              "y": -12.483,
              "z": 1.359
            },
            "gtin": "3600524074654",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b40",
            "leftCorner": {
              "x": 0.61,
              "y": -12.483,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.612,
              "y": -12.444,
              "z": 1.359
            },
            "gtin": "3600524074791",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b41",
            "leftCorner": {
              "x": 0.612,
              "y": -12.444,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.615,
              "y": -12.4,
              "z": 1.359
            },
            "gtin": "3600524075576",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b42",
            "leftCorner": {
              "x": 0.615,
              "y": -12.4,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.618,
              "y": -12.354,
              "z": 1.359
            },
            "gtin": "3600524135430",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b43",
            "leftCorner": {
              "x": 0.618,
              "y": -12.354,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.621,
              "y": -12.301,
              "z": 1.359
            },
            "gtin": "3600524128005",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b44",
            "leftCorner": {
              "x": 0.621,
              "y": -12.301,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.624,
              "y": -12.26,
              "z": 1.359
            },
            "gtin": "3600524144036",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b45",
            "leftCorner": {
              "x": 0.624,
              "y": -12.26,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.627,
              "y": -12.203,
              "z": 1.359
            },
            "gtin": "3600524128500",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b46",
            "leftCorner": {
              "x": 0.627,
              "y": -12.203,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.633,
              "y": -12.106,
              "z": 1.359
            },
            "gtin": "3600523899869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b47",
            "leftCorner": {
              "x": 0.633,
              "y": -12.106,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.639,
              "y": -12.011,
              "z": 1.359
            },
            "gtin": "8700216173476",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b48",
            "leftCorner": {
              "x": 0.639,
              "y": -12.011,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.642,
              "y": -11.965,
              "z": 1.359
            },
            "gtin": "8700216170260",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b49",
            "leftCorner": {
              "x": 0.642,
              "y": -11.965,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.646,
              "y": -11.911,
              "z": 1.359
            },
            "gtin": "8700216151535",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b4a",
            "leftCorner": {
              "x": 0.646,
              "y": -11.911,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.649,
              "y": -11.862,
              "z": 1.359
            },
            "gtin": "8700216173520",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b4b",
            "leftCorner": {
              "x": 0.649,
              "y": -11.862,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.653,
              "y": -11.797,
              "z": 1.359
            },
            "gtin": "8700216885737",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739ea",
        "height": 1.6503,
        "facings": [
          {
            "id": "696ebf6e43c343680a270996",
            "leftCorner": {
              "x": 0.589,
              "y": -12.858,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.595,
              "y": -12.787,
              "z": 1.652
            },
            "gtin": "3600524140045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270997",
            "leftCorner": {
              "x": 0.598,
              "y": -12.79,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.602,
              "y": -12.725,
              "z": 1.65
            },
            "gtin": "3600524140045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270998",
            "leftCorner": {
              "x": 0.602,
              "y": -12.725,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.609,
              "y": -12.613,
              "z": 1.65
            },
            "gtin": "3600524142261",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270999",
            "leftCorner": {
              "x": 0.609,
              "y": -12.613,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.615,
              "y": -12.53,
              "z": 1.65
            },
            "gtin": "3600524137380",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27099a",
            "leftCorner": {
              "x": 0.615,
              "y": -12.53,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.619,
              "y": -12.468,
              "z": 1.65
            },
            "gtin": "3600524144104",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27099b",
            "leftCorner": {
              "x": 0.619,
              "y": -12.468,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.624,
              "y": -12.378,
              "z": 1.65
            },
            "gtin": "3600524173579",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27099c",
            "leftCorner": {
              "x": 0.624,
              "y": -12.378,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.628,
              "y": -12.319,
              "z": 1.65
            },
            "gtin": "3600524142384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27099d",
            "leftCorner": {
              "x": 0.628,
              "y": -12.319,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.631,
              "y": -12.272,
              "z": 1.65
            },
            "gtin": "3600524105563",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27099e",
            "leftCorner": {
              "x": 0.631,
              "y": -12.272,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.634,
              "y": -12.217,
              "z": 1.65
            },
            "gtin": "3600524030865",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a27099f",
            "leftCorner": {
              "x": 0.634,
              "y": -12.217,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.638,
              "y": -12.154,
              "z": 1.65
            },
            "gtin": "3600524139704",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709a0",
            "leftCorner": {
              "x": 0.638,
              "y": -12.154,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.643,
              "y": -12.083,
              "z": 1.65
            },
            "gtin": "3600524138660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709a1",
            "leftCorner": {
              "x": 0.643,
              "y": -12.083,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.647,
              "y": -12.016,
              "z": 1.65
            },
            "gtin": "3600524173562",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709a2",
            "leftCorner": {
              "x": 0.647,
              "y": -12.016,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.65,
              "y": -11.969,
              "z": 1.65
            },
            "gtin": "3600524139032",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709a3",
            "leftCorner": {
              "x": 0.65,
              "y": -11.969,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.654,
              "y": -11.897,
              "z": 1.65
            },
            "gtin": "3600524142469",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709a4",
            "leftCorner": {
              "x": 0.654,
              "y": -11.897,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.657,
              "y": -11.849,
              "z": 1.65
            },
            "gtin": "3600523709946",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709a5",
            "leftCorner": {
              "x": 0.657,
              "y": -11.849,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.663,
              "y": -11.754,
              "z": 1.65
            },
            "gtin": "3600524078584",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e76371b5fe7bc046959ab4",
    "name": "68e76371b5fe7bc046959ab4",
    "x": 0.59588,
    "y": -11.801,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68057,
      "w": 0.73269
    },
    "statistics": {
      "hasStockCount": 63,
      "noStockCount": 0,
      "unknownStockCount": 21,
      "shelfCategory": "HAIR"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd739f5",
        "height": 0.17401,
        "facings": [
          {
            "id": "696ebf6f43c343680a270bd0",
            "leftCorner": {
              "x": 0.645,
              "y": -11.748,
              "z": 0.174
            },
            "rightCorner": {
              "x": 0.649,
              "y": -11.691,
              "z": 0.174
            },
            "gtin": "4015100862928",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bd1",
            "leftCorner": {
              "x": 0.649,
              "y": -11.691,
              "z": 0.174
            },
            "rightCorner": {
              "x": 0.656,
              "y": -11.599,
              "z": 0.174
            },
            "gtin": "4015100865097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bd2",
            "leftCorner": {
              "x": 0.656,
              "y": -11.599,
              "z": 0.174
            },
            "rightCorner": {
              "x": 0.661,
              "y": -11.527,
              "z": 0.174
            },
            "gtin": "4015100864854",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bd3",
            "leftCorner": {
              "x": 0.661,
              "y": -11.527,
              "z": 0.174
            },
            "rightCorner": {
              "x": 0.666,
              "y": -11.464,
              "z": 0.174
            },
            "gtin": "4015100747942",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bd4",
            "leftCorner": {
              "x": 0.666,
              "y": -11.464,
              "z": 0.174
            },
            "rightCorner": {
              "x": 0.672,
              "y": -11.383,
              "z": 0.174
            },
            "gtin": "4015100865035",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bd5",
            "leftCorner": {
              "x": 0.672,
              "y": -11.383,
              "z": 0.174
            },
            "rightCorner": {
              "x": 0.676,
              "y": -11.327,
              "z": 0.174
            },
            "gtin": "4015100864816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bd6",
            "leftCorner": {
              "x": 0.676,
              "y": -11.327,
              "z": 0.174
            },
            "rightCorner": {
              "x": 0.682,
              "y": -11.244,
              "z": 0.174
            },
            "gtin": "4015100864953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bd7",
            "leftCorner": {
              "x": 0.682,
              "y": -11.244,
              "z": 0.174
            },
            "rightCorner": {
              "x": 0.689,
              "y": -11.159,
              "z": 0.174
            },
            "gtin": "4015100864793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bd8",
            "leftCorner": {
              "x": 0.689,
              "y": -11.159,
              "z": 0.174
            },
            "rightCorner": {
              "x": 0.695,
              "y": -11.072,
              "z": 0.174
            },
            "gtin": "4015100805048",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bd9",
            "leftCorner": {
              "x": 0.695,
              "y": -11.072,
              "z": 0.174
            },
            "rightCorner": {
              "x": 0.703,
              "y": -10.965,
              "z": 0.174
            },
            "gtin": "4015100865011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bda",
            "leftCorner": {
              "x": 0.703,
              "y": -10.965,
              "z": 0.174
            },
            "rightCorner": {
              "x": 0.709,
              "y": -10.888,
              "z": 0.174
            },
            "gtin": "4015100865110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bdb",
            "leftCorner": {
              "x": 0.709,
              "y": -10.888,
              "z": 0.174
            },
            "rightCorner": {
              "x": 0.714,
              "y": -10.809,
              "z": 0.174
            },
            "gtin": "4015100864878",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739f0",
        "height": 0.47459,
        "facings": [
          {
            "id": "696ebf6f43c343680a270c7c",
            "leftCorner": {
              "x": 0.646,
              "y": -11.743,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.65,
              "y": -11.697,
              "z": 0.475
            },
            "gtin": "4072600704301",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c7d",
            "leftCorner": {
              "x": 0.65,
              "y": -11.697,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.653,
              "y": -11.654,
              "z": 0.475
            },
            "gtin": "4072600704103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c7e",
            "leftCorner": {
              "x": 0.653,
              "y": -11.654,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.657,
              "y": -11.606,
              "z": 0.475
            },
            "gtin": "4072600703601",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c7f",
            "leftCorner": {
              "x": 0.657,
              "y": -11.606,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.661,
              "y": -11.552,
              "z": 0.475
            },
            "gtin": "4072600710135",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c80",
            "leftCorner": {
              "x": 0.661,
              "y": -11.552,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.664,
              "y": -11.504,
              "z": 0.475
            },
            "gtin": "4072600703700",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c81",
            "leftCorner": {
              "x": 0.664,
              "y": -11.504,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.669,
              "y": -11.433,
              "z": 0.475
            },
            "gtin": "4072600703502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c82",
            "leftCorner": {
              "x": 0.669,
              "y": -11.433,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.673,
              "y": -11.383,
              "z": 0.475
            },
            "gtin": "4072600703809",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c83",
            "leftCorner": {
              "x": 0.673,
              "y": -11.383,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.679,
              "y": -11.307,
              "z": 0.475
            },
            "gtin": "4072600282281",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c84",
            "leftCorner": {
              "x": 0.679,
              "y": -11.307,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.685,
              "y": -11.221,
              "z": 0.475
            },
            "gtin": "4072600282304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c85",
            "leftCorner": {
              "x": 0.685,
              "y": -11.221,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.696,
              "y": -11.078,
              "z": 0.475
            },
            "gtin": "4072600282199",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c86",
            "leftCorner": {
              "x": 0.696,
              "y": -11.078,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.704,
              "y": -10.964,
              "z": 0.475
            },
            "gtin": "4072600282458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c87",
            "leftCorner": {
              "x": 0.704,
              "y": -10.964,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.707,
              "y": -10.922,
              "z": 0.475
            },
            "gtin": "4072600282441",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c88",
            "leftCorner": {
              "x": 0.707,
              "y": -10.922,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.713,
              "y": -10.838,
              "z": 0.475
            },
            "gtin": "4072600282427",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739f4",
        "height": 0.76536,
        "facings": [
          {
            "id": "696ebf6e43c343680a270a53",
            "leftCorner": {
              "x": 0.644,
              "y": -11.805,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.649,
              "y": -11.715,
              "z": 0.765
            },
            "gtin": "4072600720295",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a54",
            "leftCorner": {
              "x": 0.65,
              "y": -11.716,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.654,
              "y": -11.661,
              "z": 0.765
            },
            "gtin": "5037156296525",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a55",
            "leftCorner": {
              "x": 0.654,
              "y": -11.661,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.659,
              "y": -11.596,
              "z": 0.765
            },
            "gtin": "4015100814750",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a56",
            "leftCorner": {
              "x": 0.659,
              "y": -11.596,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.663,
              "y": -11.54,
              "z": 0.765
            },
            "gtin": "4104260074804",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a57",
            "leftCorner": {
              "x": 0.663,
              "y": -11.54,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.668,
              "y": -11.47,
              "z": 0.765
            },
            "gtin": "4104260074811",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a58",
            "leftCorner": {
              "x": 0.668,
              "y": -11.47,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.672,
              "y": -11.424,
              "z": 0.765
            },
            "gtin": "4104260074866",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a59",
            "leftCorner": {
              "x": 0.672,
              "y": -11.424,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.675,
              "y": -11.373,
              "z": 0.765
            },
            "gtin": "4072600282267",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a5a",
            "leftCorner": {
              "x": 0.675,
              "y": -11.373,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.681,
              "y": -11.293,
              "z": 0.765
            },
            "gtin": "4072600282250",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a5b",
            "leftCorner": {
              "x": 0.681,
              "y": -11.293,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.684,
              "y": -11.254,
              "z": 0.765
            },
            "gtin": "3600523682775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a5c",
            "leftCorner": {
              "x": 0.684,
              "y": -11.254,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.692,
              "y": -11.152,
              "z": 0.765
            },
            "gtin": "3600523682874",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a5d",
            "leftCorner": {
              "x": 0.692,
              "y": -11.152,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.7,
              "y": -11.044,
              "z": 0.765
            },
            "gtin": "4066447365542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a5e",
            "leftCorner": {
              "x": 0.7,
              "y": -11.044,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.705,
              "y": -10.968,
              "z": 0.765
            },
            "gtin": "4066447365603",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a5f",
            "leftCorner": {
              "x": 0.705,
              "y": -10.968,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.712,
              "y": -10.881,
              "z": 0.765
            },
            "gtin": "4066447591804",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a60",
            "leftCorner": {
              "x": 0.712,
              "y": -10.881,
              "z": 0.765
            },
            "rightCorner": {
              "x": 0.718,
              "y": -10.802,
              "z": 0.765
            },
            "gtin": "4066447240740",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739f3",
        "height": 1.0609,
        "facings": [
          {
            "id": "696ebf6e43c343680a270ad4",
            "leftCorner": {
              "x": 0.649,
              "y": -11.8,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.656,
              "y": -11.698,
              "z": 1.063
            },
            "gtin": "3600523965014",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ad5",
            "leftCorner": {
              "x": 0.651,
              "y": -11.698,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.657,
              "y": -11.628,
              "z": 1.061
            },
            "gtin": "8001841890012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ad6",
            "leftCorner": {
              "x": 0.657,
              "y": -11.628,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.662,
              "y": -11.554,
              "z": 1.061
            },
            "gtin": "4084500084971",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ad7",
            "leftCorner": {
              "x": 0.662,
              "y": -11.554,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.666,
              "y": -11.494,
              "z": 1.061
            },
            "gtin": "4084500085350",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ad8",
            "leftCorner": {
              "x": 0.666,
              "y": -11.494,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.671,
              "y": -11.427,
              "z": 1.061
            },
            "gtin": "8700216939768",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ad9",
            "leftCorner": {
              "x": 0.671,
              "y": -11.427,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.675,
              "y": -11.381,
              "z": 1.061
            },
            "gtin": "8700216637374",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ada",
            "leftCorner": {
              "x": 0.675,
              "y": -11.381,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.678,
              "y": -11.337,
              "z": 1.061
            },
            "gtin": "8006540497401",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270adb",
            "leftCorner": {
              "x": 0.678,
              "y": -11.337,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.684,
              "y": -11.251,
              "z": 1.061
            },
            "gtin": "8700216502672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270adc",
            "leftCorner": {
              "x": 0.684,
              "y": -11.251,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.692,
              "y": -11.147,
              "z": 1.061
            },
            "gtin": "8700216547857",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270add",
            "leftCorner": {
              "x": 0.692,
              "y": -11.147,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.699,
              "y": -11.058,
              "z": 1.061
            },
            "gtin": "8700216173315",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ade",
            "leftCorner": {
              "x": 0.699,
              "y": -11.058,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.706,
              "y": -10.96,
              "z": 1.061
            },
            "gtin": "8700216940108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270adf",
            "leftCorner": {
              "x": 0.706,
              "y": -10.96,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.712,
              "y": -10.877,
              "z": 1.061
            },
            "gtin": "8700216173261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270ae0",
            "leftCorner": {
              "x": 0.712,
              "y": -10.877,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.717,
              "y": -10.809,
              "z": 1.061
            },
            "gtin": "8006530063807",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739f1",
        "height": 1.3579,
        "facings": [
          {
            "id": "696ebf6f43c343680a270b4c",
            "leftCorner": {
              "x": 0.653,
              "y": -11.797,
              "z": 1.359
            },
            "rightCorner": {
              "x": 0.655,
              "y": -11.764,
              "z": 1.359
            },
            "gtin": "8700216821155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b4d",
            "leftCorner": {
              "x": 0.653,
              "y": -11.764,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.658,
              "y": -11.698,
              "z": 1.358
            },
            "gtin": "8700216821155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b4e",
            "leftCorner": {
              "x": 0.658,
              "y": -11.698,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.662,
              "y": -11.644,
              "z": 1.358
            },
            "gtin": "8700216821322",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b4f",
            "leftCorner": {
              "x": 0.662,
              "y": -11.644,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.666,
              "y": -11.578,
              "z": 1.358
            },
            "gtin": "8700216558082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b50",
            "leftCorner": {
              "x": 0.666,
              "y": -11.578,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.67,
              "y": -11.525,
              "z": 1.358
            },
            "gtin": "8700216557658",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b51",
            "leftCorner": {
              "x": 0.67,
              "y": -11.525,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.675,
              "y": -11.463,
              "z": 1.358
            },
            "gtin": "8700216170345",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b52",
            "leftCorner": {
              "x": 0.675,
              "y": -11.463,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.678,
              "y": -11.419,
              "z": 1.358
            },
            "gtin": "8700216151412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b53",
            "leftCorner": {
              "x": 0.678,
              "y": -11.419,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.683,
              "y": -11.359,
              "z": 1.358
            },
            "gtin": "8700216170321",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b54",
            "leftCorner": {
              "x": 0.683,
              "y": -11.359,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.686,
              "y": -11.307,
              "z": 1.358
            },
            "gtin": "8700216151443",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b55",
            "leftCorner": {
              "x": 0.686,
              "y": -11.307,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.689,
              "y": -11.269,
              "z": 1.358
            },
            "gtin": "8700216151443",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b56",
            "leftCorner": {
              "x": 0.689,
              "y": -11.269,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.694,
              "y": -11.206,
              "z": 1.358
            },
            "gtin": "8700216170239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b57",
            "leftCorner": {
              "x": 0.694,
              "y": -11.206,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.699,
              "y": -11.134,
              "z": 1.358
            },
            "gtin": "8700216170239",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b58",
            "leftCorner": {
              "x": 0.699,
              "y": -11.134,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.704,
              "y": -11.066,
              "z": 1.358
            },
            "gtin": "8700216151344",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b59",
            "leftCorner": {
              "x": 0.704,
              "y": -11.066,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.71,
              "y": -10.982,
              "z": 1.358
            },
            "gtin": "8700216151504",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b5a",
            "leftCorner": {
              "x": 0.71,
              "y": -10.982,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.715,
              "y": -10.922,
              "z": 1.358
            },
            "gtin": "8700216558037",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b5b",
            "leftCorner": {
              "x": 0.715,
              "y": -10.922,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.72,
              "y": -10.852,
              "z": 1.358
            },
            "gtin": "8700216939829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b5c",
            "leftCorner": {
              "x": 0.72,
              "y": -10.852,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.724,
              "y": -10.799,
              "z": 1.358
            },
            "gtin": "8700216939508",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739f2",
        "height": 1.6499,
        "facings": [
          {
            "id": "696ebf6e43c343680a2709a6",
            "leftCorner": {
              "x": 0.658,
              "y": -11.753,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.662,
              "y": -11.71,
              "z": 1.65
            },
            "gtin": "8006540430880",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709a7",
            "leftCorner": {
              "x": 0.662,
              "y": -11.71,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.667,
              "y": -11.636,
              "z": 1.65
            },
            "gtin": "8700216422413",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709a8",
            "leftCorner": {
              "x": 0.667,
              "y": -11.636,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.672,
              "y": -11.567,
              "z": 1.65
            },
            "gtin": "8700216422437",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709a9",
            "leftCorner": {
              "x": 0.672,
              "y": -11.567,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.677,
              "y": -11.505,
              "z": 1.65
            },
            "gtin": "8700216558136",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709aa",
            "leftCorner": {
              "x": 0.677,
              "y": -11.505,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.681,
              "y": -11.449,
              "z": 1.65
            },
            "gtin": "8700216885805",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709ab",
            "leftCorner": {
              "x": 0.681,
              "y": -11.449,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.685,
              "y": -11.389,
              "z": 1.65
            },
            "gtin": "8700216422116",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709ac",
            "leftCorner": {
              "x": 0.685,
              "y": -11.389,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.69,
              "y": -11.319,
              "z": 1.65
            },
            "gtin": "8700216821216",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709ad",
            "leftCorner": {
              "x": 0.69,
              "y": -11.319,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.695,
              "y": -11.255,
              "z": 1.65
            },
            "gtin": "8700216558259",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709ae",
            "leftCorner": {
              "x": 0.695,
              "y": -11.255,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.701,
              "y": -11.177,
              "z": 1.65
            },
            "gtin": "8700216821087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709af",
            "leftCorner": {
              "x": 0.701,
              "y": -11.177,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.706,
              "y": -11.106,
              "z": 1.65
            },
            "gtin": "8700216557689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709b0",
            "leftCorner": {
              "x": 0.706,
              "y": -11.106,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.711,
              "y": -11.042,
              "z": 1.65
            },
            "gtin": "8700216885768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709b1",
            "leftCorner": {
              "x": 0.711,
              "y": -11.042,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.717,
              "y": -10.966,
              "z": 1.65
            },
            "gtin": "8700216558761",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709b2",
            "leftCorner": {
              "x": 0.717,
              "y": -10.966,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.721,
              "y": -10.906,
              "z": 1.65
            },
            "gtin": "8700216558471",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709b3",
            "leftCorner": {
              "x": 0.721,
              "y": -10.906,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.725,
              "y": -10.852,
              "z": 1.65
            },
            "gtin": "8700216557764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709b4",
            "leftCorner": {
              "x": 0.725,
              "y": -10.852,
              "z": 1.65
            },
            "rightCorner": {
              "x": 0.729,
              "y": -10.791,
              "z": 1.65
            },
            "gtin": "4066447882872",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e76371b5fe7bc046959ab5",
    "name": "68e76371b5fe7bc046959ab5",
    "x": 0.67331,
    "y": -10.793,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68157,
      "w": 0.73176
    },
    "statistics": {
      "hasStockCount": 51,
      "noStockCount": 0,
      "unknownStockCount": 33,
      "shelfCategory": "HAIR"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd739fb",
        "height": 0.17058,
        "facings": [
          {
            "id": "696ebf6f43c343680a270bdc",
            "leftCorner": {
              "x": 0.714,
              "y": -10.809,
              "z": 0.174
            },
            "rightCorner": {
              "x": 0.721,
              "y": -10.727,
              "z": 0.174
            },
            "gtin": "4015100864991",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bdd",
            "leftCorner": {
              "x": 0.725,
              "y": -10.716,
              "z": 0.171
            },
            "rightCorner": {
              "x": 0.732,
              "y": -10.622,
              "z": 0.171
            },
            "gtin": "4015100864939",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bde",
            "leftCorner": {
              "x": 0.732,
              "y": -10.622,
              "z": 0.171
            },
            "rightCorner": {
              "x": 0.736,
              "y": -10.565,
              "z": 0.171
            },
            "gtin": "4015100816488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bdf",
            "leftCorner": {
              "x": 0.736,
              "y": -10.565,
              "z": 0.171
            },
            "rightCorner": {
              "x": 0.742,
              "y": -10.48,
              "z": 0.171
            },
            "gtin": "4015100816464",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270be0",
            "leftCorner": {
              "x": 0.742,
              "y": -10.48,
              "z": 0.171
            },
            "rightCorner": {
              "x": 0.749,
              "y": -10.376,
              "z": 0.171
            },
            "gtin": "4015100865059",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270be1",
            "leftCorner": {
              "x": 0.749,
              "y": -10.376,
              "z": 0.171
            },
            "rightCorner": {
              "x": 0.756,
              "y": -10.284,
              "z": 0.171
            },
            "gtin": "4015100816440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270be2",
            "leftCorner": {
              "x": 0.756,
              "y": -10.284,
              "z": 0.171
            },
            "rightCorner": {
              "x": 0.762,
              "y": -10.197,
              "z": 0.171
            },
            "gtin": "4015100864977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270be3",
            "leftCorner": {
              "x": 0.762,
              "y": -10.197,
              "z": 0.171
            },
            "rightCorner": {
              "x": 0.767,
              "y": -10.12,
              "z": 0.171
            },
            "gtin": "4015100864915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270be4",
            "leftCorner": {
              "x": 0.767,
              "y": -10.12,
              "z": 0.171
            },
            "rightCorner": {
              "x": 0.773,
              "y": -10.042,
              "z": 0.171
            },
            "gtin": "4005900917669",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270be5",
            "leftCorner": {
              "x": 0.773,
              "y": -10.042,
              "z": 0.171
            },
            "rightCorner": {
              "x": 0.778,
              "y": -9.968,
              "z": 0.171
            },
            "gtin": "4005900917706",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270be6",
            "leftCorner": {
              "x": 0.778,
              "y": -9.968,
              "z": 0.171
            },
            "rightCorner": {
              "x": 0.785,
              "y": -9.873,
              "z": 0.171
            },
            "gtin": "4066447237429",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270be7",
            "leftCorner": {
              "x": 0.785,
              "y": -9.873,
              "z": 0.171
            },
            "rightCorner": {
              "x": 0.791,
              "y": -9.782,
              "z": 0.171
            },
            "gtin": "4066447237443",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739f7",
        "height": 0.47355,
        "facings": [
          {
            "id": "696ebf6f43c343680a270c89",
            "leftCorner": {
              "x": 0.713,
              "y": -10.838,
              "z": 0.475
            },
            "rightCorner": {
              "x": 0.718,
              "y": -10.772,
              "z": 0.475
            },
            "gtin": "4072600282205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c8a",
            "leftCorner": {
              "x": 0.724,
              "y": -10.762,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.73,
              "y": -10.68,
              "z": 0.474
            },
            "gtin": "4072600283172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c8b",
            "leftCorner": {
              "x": 0.73,
              "y": -10.68,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.737,
              "y": -10.58,
              "z": 0.474
            },
            "gtin": "4072600282274",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c8c",
            "leftCorner": {
              "x": 0.737,
              "y": -10.58,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.74,
              "y": -10.543,
              "z": 0.474
            },
            "gtin": "4005900917744",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c8d",
            "leftCorner": {
              "x": 0.74,
              "y": -10.543,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.744,
              "y": -10.491,
              "z": 0.474
            },
            "gtin": "4005900910141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c8e",
            "leftCorner": {
              "x": 0.744,
              "y": -10.491,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.749,
              "y": -10.409,
              "z": 0.474
            },
            "gtin": "4005900917829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c8f",
            "leftCorner": {
              "x": 0.749,
              "y": -10.409,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.755,
              "y": -10.324,
              "z": 0.474
            },
            "gtin": "4005900910066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c90",
            "leftCorner": {
              "x": 0.755,
              "y": -10.324,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.759,
              "y": -10.269,
              "z": 0.474
            },
            "gtin": "4005900917959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c91",
            "leftCorner": {
              "x": 0.759,
              "y": -10.269,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.763,
              "y": -10.214,
              "z": 0.474
            },
            "gtin": "4005900910301",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c92",
            "leftCorner": {
              "x": 0.763,
              "y": -10.214,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.768,
              "y": -10.15,
              "z": 0.474
            },
            "gtin": "4006000192857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c93",
            "leftCorner": {
              "x": 0.768,
              "y": -10.15,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.772,
              "y": -10.091,
              "z": 0.474
            },
            "gtin": "4006000192918",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c94",
            "leftCorner": {
              "x": 0.772,
              "y": -10.091,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.78,
              "y": -9.976,
              "z": 0.474
            },
            "gtin": "4066447626841",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c95",
            "leftCorner": {
              "x": 0.78,
              "y": -9.976,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.788,
              "y": -9.869,
              "z": 0.474
            },
            "gtin": "4067796166415",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c96",
            "leftCorner": {
              "x": 0.788,
              "y": -9.869,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.793,
              "y": -9.794,
              "z": 0.474
            },
            "gtin": "4066447785425",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c97",
            "leftCorner": {
              "x": 0.793,
              "y": -9.794,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.798,
              "y": -9.727,
              "z": 0.474
            },
            "gtin": "4066447626803",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739f6",
        "height": 0.7643,
        "facings": [
          {
            "id": "696ebf6e43c343680a270a61",
            "leftCorner": {
              "x": 0.725,
              "y": -10.792,
              "z": 0.764
            },
            "rightCorner": {
              "x": 0.731,
              "y": -10.709,
              "z": 0.764
            },
            "gtin": "4066447237016",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a62",
            "leftCorner": {
              "x": 0.731,
              "y": -10.709,
              "z": 0.764
            },
            "rightCorner": {
              "x": 0.736,
              "y": -10.642,
              "z": 0.764
            },
            "gtin": "4066447154832",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a63",
            "leftCorner": {
              "x": 0.736,
              "y": -10.642,
              "z": 0.764
            },
            "rightCorner": {
              "x": 0.739,
              "y": -10.595,
              "z": 0.764
            },
            "gtin": "4066447237481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a64",
            "leftCorner": {
              "x": 0.739,
              "y": -10.595,
              "z": 0.764
            },
            "rightCorner": {
              "x": 0.743,
              "y": -10.545,
              "z": 0.764
            },
            "gtin": "4067796166392",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a65",
            "leftCorner": {
              "x": 0.743,
              "y": -10.545,
              "z": 0.764
            },
            "rightCorner": {
              "x": 0.746,
              "y": -10.506,
              "z": 0.764
            },
            "gtin": "4066447668315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a66",
            "leftCorner": {
              "x": 0.746,
              "y": -10.506,
              "z": 0.764
            },
            "rightCorner": {
              "x": 0.749,
              "y": -10.456,
              "z": 0.764
            },
            "gtin": "4067796166644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a67",
            "leftCorner": {
              "x": 0.749,
              "y": -10.456,
              "z": 0.764
            },
            "rightCorner": {
              "x": 0.753,
              "y": -10.398,
              "z": 0.764
            },
            "gtin": "4067796172706",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a68",
            "leftCorner": {
              "x": 0.753,
              "y": -10.398,
              "z": 0.764
            },
            "rightCorner": {
              "x": 0.758,
              "y": -10.331,
              "z": 0.764
            },
            "gtin": "4066447091762",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a69",
            "leftCorner": {
              "x": 0.758,
              "y": -10.331,
              "z": 0.764
            },
            "rightCorner": {
              "x": 0.764,
              "y": -10.253,
              "z": 0.764
            },
            "gtin": "4066447091748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a6a",
            "leftCorner": {
              "x": 0.764,
              "y": -10.253,
              "z": 0.764
            },
            "rightCorner": {
              "x": 0.768,
              "y": -10.185,
              "z": 0.764
            },
            "gtin": "4066447091748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a6b",
            "leftCorner": {
              "x": 0.768,
              "y": -10.185,
              "z": 0.764
            },
            "rightCorner": {
              "x": 0.774,
              "y": -10.108,
              "z": 0.764
            },
            "gtin": "4058172880292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a6c",
            "leftCorner": {
              "x": 0.774,
              "y": -10.108,
              "z": 0.764
            },
            "rightCorner": {
              "x": 0.781,
              "y": -10.009,
              "z": 0.764
            },
            "gtin": "4058172923838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270a6d",
            "leftCorner": {
              "x": 0.781,
              "y": -10.009,
              "z": 0.764
            },
            "rightCorner": {
              "x": 0.79,
              "y": -9.883,
              "z": 0.764
            },
            "gtin": "4066447230895",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a6e",
            "leftCorner": {
              "x": 0.79,
              "y": -9.883,
              "z": 0.764
            },
            "rightCorner": {
              "x": 0.796,
              "y": -9.799,
              "z": 0.764
            },
            "gtin": "4015000981194",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739f8",
        "height": 1.0598,
        "facings": [
          {
            "id": "696ebf6e43c343680a270ae1",
            "leftCorner": {
              "x": 0.717,
              "y": -10.809,
              "z": 1.061
            },
            "rightCorner": {
              "x": 0.725,
              "y": -10.698,
              "z": 1.061
            },
            "gtin": "8006540532867",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ae2",
            "leftCorner": {
              "x": 0.735,
              "y": -10.687,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.741,
              "y": -10.597,
              "z": 1.06
            },
            "gtin": "4066447241167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270ae3",
            "leftCorner": {
              "x": 0.741,
              "y": -10.597,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.744,
              "y": -10.559,
              "z": 1.06
            },
            "gtin": "4066447342079",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ae4",
            "leftCorner": {
              "x": 0.744,
              "y": -10.559,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.752,
              "y": -10.445,
              "z": 1.06
            },
            "gtin": "4066447668377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270ae5",
            "leftCorner": {
              "x": 0.752,
              "y": -10.445,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.76,
              "y": -10.329,
              "z": 1.06
            },
            "gtin": "4066447365887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270ae6",
            "leftCorner": {
              "x": 0.76,
              "y": -10.329,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.763,
              "y": -10.281,
              "z": 1.06
            },
            "gtin": "4066447910124",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ae7",
            "leftCorner": {
              "x": 0.763,
              "y": -10.281,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.767,
              "y": -10.232,
              "z": 1.06
            },
            "gtin": "4066447910148",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ae8",
            "leftCorner": {
              "x": 0.767,
              "y": -10.232,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.771,
              "y": -10.183,
              "z": 1.06
            },
            "gtin": "4066447880526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270ae9",
            "leftCorner": {
              "x": 0.771,
              "y": -10.183,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.778,
              "y": -10.081,
              "z": 1.06
            },
            "gtin": "4067796154122",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270aea",
            "leftCorner": {
              "x": 0.778,
              "y": -10.081,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.788,
              "y": -9.943,
              "z": 1.06
            },
            "gtin": "4067796154160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270aeb",
            "leftCorner": {
              "x": 0.788,
              "y": -9.943,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.794,
              "y": -9.85,
              "z": 1.06
            },
            "gtin": "4066447241068",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270aec",
            "leftCorner": {
              "x": 0.794,
              "y": -9.85,
              "z": 1.06
            },
            "rightCorner": {
              "x": 0.8,
              "y": -9.764,
              "z": 1.06
            },
            "gtin": "4067796183535",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739f9",
        "height": 1.3561,
        "facings": [
          {
            "id": "696ebf6f43c343680a270b5d",
            "leftCorner": {
              "x": 0.731,
              "y": -10.788,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.738,
              "y": -10.698,
              "z": 1.356
            },
            "gtin": "4067796154184",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b5e",
            "leftCorner": {
              "x": 0.738,
              "y": -10.698,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.742,
              "y": -10.641,
              "z": 1.356
            },
            "gtin": "4067796154221",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b5f",
            "leftCorner": {
              "x": 0.742,
              "y": -10.641,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.744,
              "y": -10.609,
              "z": 1.356
            },
            "gtin": "4067796183498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b60",
            "leftCorner": {
              "x": 0.744,
              "y": -10.609,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.748,
              "y": -10.556,
              "z": 1.356
            },
            "gtin": "4066447241235",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b61",
            "leftCorner": {
              "x": 0.748,
              "y": -10.556,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.751,
              "y": -10.505,
              "z": 1.356
            },
            "gtin": "4066447241082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b62",
            "leftCorner": {
              "x": 0.751,
              "y": -10.505,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.755,
              "y": -10.451,
              "z": 1.356
            },
            "gtin": "4066447240900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b63",
            "leftCorner": {
              "x": 0.755,
              "y": -10.451,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.761,
              "y": -10.373,
              "z": 1.356
            },
            "gtin": "4066447882896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b64",
            "leftCorner": {
              "x": 0.761,
              "y": -10.373,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.769,
              "y": -10.26,
              "z": 1.356
            },
            "gtin": "4067796154245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b65",
            "leftCorner": {
              "x": 0.769,
              "y": -10.26,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.772,
              "y": -10.218,
              "z": 1.356
            },
            "gtin": "4066447785470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b66",
            "leftCorner": {
              "x": 0.772,
              "y": -10.218,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.775,
              "y": -10.176,
              "z": 1.356
            },
            "gtin": "4066447365467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b67",
            "leftCorner": {
              "x": 0.775,
              "y": -10.176,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.782,
              "y": -10.07,
              "z": 1.356
            },
            "gtin": "4066447365429",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b68",
            "leftCorner": {
              "x": 0.782,
              "y": -10.07,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.792,
              "y": -9.941,
              "z": 1.356
            },
            "gtin": "4066447240849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b69",
            "leftCorner": {
              "x": 0.792,
              "y": -9.941,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.798,
              "y": -9.853,
              "z": 1.356
            },
            "gtin": "4066447785449",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b6a",
            "leftCorner": {
              "x": 0.798,
              "y": -9.853,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.801,
              "y": -9.806,
              "z": 1.356
            },
            "gtin": "4066447241105",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b6b",
            "leftCorner": {
              "x": 0.801,
              "y": -9.806,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.805,
              "y": -9.754,
              "z": 1.356
            },
            "gtin": "4066447241105",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739fa",
        "height": 1.6484,
        "facings": [
          {
            "id": "696ebf6e43c343680a2709b5",
            "leftCorner": {
              "x": 0.736,
              "y": -10.78,
              "z": 1.648
            },
            "rightCorner": {
              "x": 0.74,
              "y": -10.711,
              "z": 1.648
            },
            "gtin": "4066447240801",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709b6",
            "leftCorner": {
              "x": 0.74,
              "y": -10.711,
              "z": 1.648
            },
            "rightCorner": {
              "x": 0.744,
              "y": -10.657,
              "z": 1.648
            },
            "gtin": "4066447240801",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709b7",
            "leftCorner": {
              "x": 0.744,
              "y": -10.657,
              "z": 1.648
            },
            "rightCorner": {
              "x": 0.748,
              "y": -10.605,
              "z": 1.648
            },
            "gtin": "4066447240788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709b8",
            "leftCorner": {
              "x": 0.748,
              "y": -10.605,
              "z": 1.648
            },
            "rightCorner": {
              "x": 0.753,
              "y": -10.528,
              "z": 1.648
            },
            "gtin": "4066447342055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709b9",
            "leftCorner": {
              "x": 0.753,
              "y": -10.528,
              "z": 1.648
            },
            "rightCorner": {
              "x": 0.757,
              "y": -10.475,
              "z": 1.648
            },
            "gtin": "4066447342031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709ba",
            "leftCorner": {
              "x": 0.757,
              "y": -10.475,
              "z": 1.648
            },
            "rightCorner": {
              "x": 0.761,
              "y": -10.424,
              "z": 1.648
            },
            "gtin": "4067796166606",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709bb",
            "leftCorner": {
              "x": 0.761,
              "y": -10.424,
              "z": 1.648
            },
            "rightCorner": {
              "x": 0.765,
              "y": -10.36,
              "z": 1.648
            },
            "gtin": "4067796166477",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709bc",
            "leftCorner": {
              "x": 0.765,
              "y": -10.36,
              "z": 1.648
            },
            "rightCorner": {
              "x": 0.77,
              "y": -10.297,
              "z": 1.648
            },
            "gtin": "4067796166453",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709bd",
            "leftCorner": {
              "x": 0.77,
              "y": -10.297,
              "z": 1.648
            },
            "rightCorner": {
              "x": 0.773,
              "y": -10.249,
              "z": 1.648
            },
            "gtin": "4066447378771",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709be",
            "leftCorner": {
              "x": 0.773,
              "y": -10.249,
              "z": 1.648
            },
            "rightCorner": {
              "x": 0.777,
              "y": -10.198,
              "z": 1.648
            },
            "gtin": "4066447365849",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709bf",
            "leftCorner": {
              "x": 0.777,
              "y": -10.198,
              "z": 1.648
            },
            "rightCorner": {
              "x": 0.784,
              "y": -10.101,
              "z": 1.648
            },
            "gtin": "4066447365863",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709c0",
            "leftCorner": {
              "x": 0.784,
              "y": -10.101,
              "z": 1.648
            },
            "rightCorner": {
              "x": 0.792,
              "y": -9.983,
              "z": 1.648
            },
            "gtin": "4067796166668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709c1",
            "leftCorner": {
              "x": 0.792,
              "y": -9.983,
              "z": 1.648
            },
            "rightCorner": {
              "x": 0.797,
              "y": -9.917,
              "z": 1.648
            },
            "gtin": "4066447365801",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709c2",
            "leftCorner": {
              "x": 0.797,
              "y": -9.917,
              "z": 1.648
            },
            "rightCorner": {
              "x": 0.801,
              "y": -9.863,
              "z": 1.648
            },
            "gtin": "4066447365825",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709c3",
            "leftCorner": {
              "x": 0.801,
              "y": -9.863,
              "z": 1.648
            },
            "rightCorner": {
              "x": 0.805,
              "y": -9.81,
              "z": 1.648
            },
            "gtin": "4067796166620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709c4",
            "leftCorner": {
              "x": 0.806,
              "y": -9.793,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.811,
              "y": -9.721,
              "z": 1.652
            },
            "gtin": "4066447806687",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e76371b5fe7bc046959ab6",
    "name": "68e76371b5fe7bc046959ab6",
    "x": 0.75106,
    "y": -9.789,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68178,
      "w": 0.73156
    },
    "statistics": {
      "hasStockCount": 59,
      "noStockCount": 2,
      "unknownStockCount": 19,
      "shelfCategory": "HAIR"
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73a00",
        "height": 0.17931,
        "facings": [
          {
            "id": "696ebf6f43c343680a270be8",
            "leftCorner": {
              "x": 0.798,
              "y": -9.776,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.803,
              "y": -9.695,
              "z": 0.179
            },
            "gtin": "4066447468076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270be9",
            "leftCorner": {
              "x": 0.803,
              "y": -9.695,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.808,
              "y": -9.628,
              "z": 0.179
            },
            "gtin": "4066447468052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bea",
            "leftCorner": {
              "x": 0.808,
              "y": -9.628,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.812,
              "y": -9.565,
              "z": 0.179
            },
            "gtin": "4066447858693",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270beb",
            "leftCorner": {
              "x": 0.812,
              "y": -9.565,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.819,
              "y": -9.477,
              "z": 0.179
            },
            "gtin": "4066447745443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bec",
            "leftCorner": {
              "x": 0.819,
              "y": -9.477,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.824,
              "y": -9.4,
              "z": 0.179
            },
            "gtin": "4066447220735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bed",
            "leftCorner": {
              "x": 0.824,
              "y": -9.4,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.83,
              "y": -9.316,
              "z": 0.179
            },
            "gtin": "4066447468014",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bee",
            "leftCorner": {
              "x": 0.83,
              "y": -9.316,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.835,
              "y": -9.242,
              "z": 0.179
            },
            "gtin": "4066447467871",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bef",
            "leftCorner": {
              "x": 0.835,
              "y": -9.242,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.84,
              "y": -9.173,
              "z": 0.179
            },
            "gtin": "4066447468175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bf0",
            "leftCorner": {
              "x": 0.84,
              "y": -9.173,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.845,
              "y": -9.107,
              "z": 0.179
            },
            "gtin": "4067796182354",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bf1",
            "leftCorner": {
              "x": 0.845,
              "y": -9.107,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.85,
              "y": -9.033,
              "z": 0.179
            },
            "gtin": "4067796182330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bf2",
            "leftCorner": {
              "x": 0.85,
              "y": -9.033,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.856,
              "y": -8.944,
              "z": 0.179
            },
            "gtin": "4066447467932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bf3",
            "leftCorner": {
              "x": 0.856,
              "y": -8.944,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.862,
              "y": -8.865,
              "z": 0.179
            },
            "gtin": "4066447467956",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bf4",
            "leftCorner": {
              "x": 0.862,
              "y": -8.865,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.866,
              "y": -8.803,
              "z": 0.179
            },
            "gtin": "4066447220612",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739ff",
        "height": 0.47666,
        "facings": [
          {
            "id": "696ebf6f43c343680a270c98",
            "leftCorner": {
              "x": 0.8,
              "y": -9.721,
              "z": 0.477
            },
            "rightCorner": {
              "x": 0.805,
              "y": -9.645,
              "z": 0.477
            },
            "gtin": "4066447626827",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c99",
            "leftCorner": {
              "x": 0.805,
              "y": -9.645,
              "z": 0.477
            },
            "rightCorner": {
              "x": 0.809,
              "y": -9.58,
              "z": 0.477
            },
            "gtin": "4103040051653",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c9a",
            "leftCorner": {
              "x": 0.809,
              "y": -9.58,
              "z": 0.477
            },
            "rightCorner": {
              "x": 0.813,
              "y": -9.527,
              "z": 0.477
            },
            "gtin": "4103040051691",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c9b",
            "leftCorner": {
              "x": 0.813,
              "y": -9.527,
              "z": 0.477
            },
            "rightCorner": {
              "x": 0.82,
              "y": -9.435,
              "z": 0.477
            },
            "gtin": "4103040051714",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c9c",
            "leftCorner": {
              "x": 0.82,
              "y": -9.435,
              "z": 0.477
            },
            "rightCorner": {
              "x": 0.827,
              "y": -9.328,
              "z": 0.477
            },
            "gtin": "4103040045768",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c9d",
            "leftCorner": {
              "x": 0.827,
              "y": -9.328,
              "z": 0.477
            },
            "rightCorner": {
              "x": 0.832,
              "y": -9.262,
              "z": 0.477
            },
            "gtin": "4103040019424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c9e",
            "leftCorner": {
              "x": 0.832,
              "y": -9.262,
              "z": 0.477
            },
            "rightCorner": {
              "x": 0.836,
              "y": -9.202,
              "z": 0.477
            },
            "gtin": "4103040051677",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c9f",
            "leftCorner": {
              "x": 0.836,
              "y": -9.202,
              "z": 0.477
            },
            "rightCorner": {
              "x": 0.841,
              "y": -9.139,
              "z": 0.477
            },
            "gtin": "4103040048448",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ca0",
            "leftCorner": {
              "x": 0.841,
              "y": -9.139,
              "z": 0.477
            },
            "rightCorner": {
              "x": 0.845,
              "y": -9.071,
              "z": 0.477
            },
            "gtin": "4008890026410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ca1",
            "leftCorner": {
              "x": 0.845,
              "y": -9.071,
              "z": 0.477
            },
            "rightCorner": {
              "x": 0.85,
              "y": -8.998,
              "z": 0.477
            },
            "gtin": "4008890006429",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ca2",
            "leftCorner": {
              "x": 0.85,
              "y": -8.998,
              "z": 0.477
            },
            "rightCorner": {
              "x": 0.856,
              "y": -8.92,
              "z": 0.477
            },
            "gtin": "4008890006429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ca3",
            "leftCorner": {
              "x": 0.856,
              "y": -8.92,
              "z": 0.477
            },
            "rightCorner": {
              "x": 0.86,
              "y": -8.869,
              "z": 0.477
            }
          },
          {
            "id": "696ebf6f43c343680a270ca4",
            "leftCorner": {
              "x": 0.86,
              "y": -8.869,
              "z": 0.477
            },
            "rightCorner": {
              "x": 0.864,
              "y": -8.807,
              "z": 0.477
            },
            "gtin": "4008666204608",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a01",
        "height": 0.76782,
        "facings": [
          {
            "id": "696ebf6e43c343680a270a6f",
            "leftCorner": {
              "x": 0.797,
              "y": -9.768,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.803,
              "y": -9.681,
              "z": 0.768
            },
            "gtin": "4012800003743",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a70",
            "leftCorner": {
              "x": 0.803,
              "y": -9.681,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.809,
              "y": -9.59,
              "z": 0.768
            }
          },
          {
            "id": "696ebf6e43c343680a270a71",
            "leftCorner": {
              "x": 0.809,
              "y": -9.59,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.813,
              "y": -9.533,
              "z": 0.768
            },
            "gtin": "4008666271211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a72",
            "leftCorner": {
              "x": 0.813,
              "y": -9.533,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.82,
              "y": -9.442,
              "z": 0.768
            },
            "gtin": "4008666210517",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a73",
            "leftCorner": {
              "x": 0.82,
              "y": -9.442,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.825,
              "y": -9.37,
              "z": 0.768
            },
            "gtin": "4008666203137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a74",
            "leftCorner": {
              "x": 0.825,
              "y": -9.37,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.831,
              "y": -9.289,
              "z": 0.768
            },
            "gtin": "4008666273307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a75",
            "leftCorner": {
              "x": 0.831,
              "y": -9.289,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.834,
              "y": -9.236,
              "z": 0.768
            },
            "gtin": "4008666200174",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a76",
            "leftCorner": {
              "x": 0.834,
              "y": -9.236,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.839,
              "y": -9.165,
              "z": 0.768
            },
            "gtin": "4008666209016",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a77",
            "leftCorner": {
              "x": 0.839,
              "y": -9.165,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.844,
              "y": -9.097,
              "z": 0.768
            },
            "gtin": "4008666211217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a78",
            "leftCorner": {
              "x": 0.844,
              "y": -9.097,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.849,
              "y": -9.024,
              "z": 0.768
            },
            "gtin": "4008666203663",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a79",
            "leftCorner": {
              "x": 0.849,
              "y": -9.024,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.855,
              "y": -8.945,
              "z": 0.768
            },
            "gtin": "4008666271204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a7a",
            "leftCorner": {
              "x": 0.855,
              "y": -8.945,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.861,
              "y": -8.854,
              "z": 0.768
            },
            "gtin": "4008666223654",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a7b",
            "leftCorner": {
              "x": 0.861,
              "y": -8.854,
              "z": 0.768
            },
            "rightCorner": {
              "x": 0.866,
              "y": -8.789,
              "z": 0.768
            },
            "gtin": "4008666273802",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739fe",
        "height": 1.0628,
        "facings": [
          {
            "id": "696ebf6e43c343680a270aed",
            "leftCorner": {
              "x": 0.798,
              "y": -9.757,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.802,
              "y": -9.694,
              "z": 1.063
            },
            "gtin": "4104260073500",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270aee",
            "leftCorner": {
              "x": 0.802,
              "y": -9.694,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.807,
              "y": -9.622,
              "z": 1.063
            },
            "gtin": "4104260076501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270aef",
            "leftCorner": {
              "x": 0.807,
              "y": -9.622,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.812,
              "y": -9.552,
              "z": 1.063
            },
            "gtin": "8001090896315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270af0",
            "leftCorner": {
              "x": 0.812,
              "y": -9.552,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.817,
              "y": -9.485,
              "z": 1.063
            },
            "gtin": "8001090890054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270af1",
            "leftCorner": {
              "x": 0.817,
              "y": -9.485,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.824,
              "y": -9.392,
              "z": 1.063
            },
            "gtin": "8001090892843",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270af2",
            "leftCorner": {
              "x": 0.824,
              "y": -9.392,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.828,
              "y": -9.326,
              "z": 1.063
            },
            "gtin": "8001090894878",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270af3",
            "leftCorner": {
              "x": 0.828,
              "y": -9.326,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.833,
              "y": -9.264,
              "z": 1.063
            },
            "gtin": "8001090891334",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270af4",
            "leftCorner": {
              "x": 0.833,
              "y": -9.264,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.837,
              "y": -9.206,
              "z": 1.063
            },
            "gtin": "8001090891334",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270af5",
            "leftCorner": {
              "x": 0.837,
              "y": -9.206,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.841,
              "y": -9.141,
              "z": 1.063
            },
            "gtin": "8001090891334",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270af6",
            "leftCorner": {
              "x": 0.841,
              "y": -9.141,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.846,
              "y": -9.074,
              "z": 1.063
            },
            "gtin": "8001090896049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a270af7",
            "leftCorner": {
              "x": 0.846,
              "y": -9.074,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.851,
              "y": -9.007,
              "z": 1.063
            },
            "gtin": "8001090894991",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270af8",
            "leftCorner": {
              "x": 0.851,
              "y": -9.007,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.857,
              "y": -8.921,
              "z": 1.063
            },
            "gtin": "8001090896735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270af9",
            "leftCorner": {
              "x": 0.857,
              "y": -8.921,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.863,
              "y": -8.836,
              "z": 1.063
            },
            "gtin": "8700216517669",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a270a7d",
            "leftCorner": {
              "x": 0.863,
              "y": -8.836,
              "z": 1.063
            },
            "rightCorner": {
              "x": 0.866,
              "y": -8.795,
              "z": 1.063
            },
            "gtin": "8001090895349",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739fd",
        "height": 1.3595,
        "facings": [
          {
            "id": "696ebf6f43c343680a270b6c",
            "leftCorner": {
              "x": 0.804,
              "y": -9.747,
              "z": 1.36
            },
            "rightCorner": {
              "x": 0.809,
              "y": -9.683,
              "z": 1.36
            },
            "gtin": "4066447679007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b6d",
            "leftCorner": {
              "x": 0.809,
              "y": -9.683,
              "z": 1.36
            },
            "rightCorner": {
              "x": 0.813,
              "y": -9.615,
              "z": 1.36
            },
            "gtin": "8001090894366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b6e",
            "leftCorner": {
              "x": 0.813,
              "y": -9.615,
              "z": 1.36
            },
            "rightCorner": {
              "x": 0.817,
              "y": -9.558,
              "z": 1.36
            },
            "gtin": "8001090890528",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b6f",
            "leftCorner": {
              "x": 0.817,
              "y": -9.558,
              "z": 1.36
            },
            "rightCorner": {
              "x": 0.821,
              "y": -9.511,
              "z": 1.36
            },
            "gtin": "8001090890528",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b70",
            "leftCorner": {
              "x": 0.821,
              "y": -9.511,
              "z": 1.36
            },
            "rightCorner": {
              "x": 0.827,
              "y": -9.419,
              "z": 1.36
            }
          },
          {
            "id": "696ebf6f43c343680a270b71",
            "leftCorner": {
              "x": 0.827,
              "y": -9.419,
              "z": 1.36
            },
            "rightCorner": {
              "x": 0.834,
              "y": -9.323,
              "z": 1.36
            },
            "gtin": "8001090896216",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b72",
            "leftCorner": {
              "x": 0.834,
              "y": -9.323,
              "z": 1.36
            },
            "rightCorner": {
              "x": 0.838,
              "y": -9.266,
              "z": 1.36
            },
            "gtin": "8700216301749",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b73",
            "leftCorner": {
              "x": 0.838,
              "y": -9.266,
              "z": 1.36
            },
            "rightCorner": {
              "x": 0.842,
              "y": -9.211,
              "z": 1.36
            },
            "gtin": "8700216328623",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b74",
            "leftCorner": {
              "x": 0.842,
              "y": -9.211,
              "z": 1.36
            },
            "rightCorner": {
              "x": 0.846,
              "y": -9.147,
              "z": 1.36
            },
            "gtin": "8700216328661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b75",
            "leftCorner": {
              "x": 0.846,
              "y": -9.147,
              "z": 1.36
            },
            "rightCorner": {
              "x": 0.851,
              "y": -9.078,
              "z": 1.36
            },
            "gtin": "8700216328869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b76",
            "leftCorner": {
              "x": 0.851,
              "y": -9.078,
              "z": 1.36
            },
            "rightCorner": {
              "x": 0.855,
              "y": -9.022,
              "z": 1.36
            },
            "gtin": "8700216328760",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b77",
            "leftCorner": {
              "x": 0.855,
              "y": -9.022,
              "z": 1.36
            },
            "rightCorner": {
              "x": 0.859,
              "y": -8.968,
              "z": 1.36
            },
            "gtin": "8700216496032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b78",
            "leftCorner": {
              "x": 0.859,
              "y": -8.968,
              "z": 1.36
            },
            "rightCorner": {
              "x": 0.863,
              "y": -8.918,
              "z": 1.36
            },
            "gtin": "8006540903346",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270b79",
            "leftCorner": {
              "x": 0.863,
              "y": -8.918,
              "z": 1.36
            },
            "rightCorner": {
              "x": 0.867,
              "y": -8.858,
              "z": 1.36
            },
            "gtin": "8700216495981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270b7a",
            "leftCorner": {
              "x": 0.867,
              "y": -8.858,
              "z": 1.36
            },
            "rightCorner": {
              "x": 0.871,
              "y": -8.796,
              "z": 1.36
            },
            "gtin": "8700216328609",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd739fc",
        "height": 1.6521,
        "facings": [
          {
            "id": "696ebf6e43c343680a2709c5",
            "leftCorner": {
              "x": 0.811,
              "y": -9.721,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.815,
              "y": -9.665,
              "z": 1.652
            },
            "gtin": "4008666750396",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709c6",
            "leftCorner": {
              "x": 0.815,
              "y": -9.665,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.818,
              "y": -9.62,
              "z": 1.652
            },
            "gtin": "4008666750396",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709c7",
            "leftCorner": {
              "x": 0.818,
              "y": -9.62,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.821,
              "y": -9.571,
              "z": 1.652
            },
            "gtin": "4008666770011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709c8",
            "leftCorner": {
              "x": 0.821,
              "y": -9.571,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.825,
              "y": -9.517,
              "z": 1.652
            },
            "gtin": "4008666770004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709c9",
            "leftCorner": {
              "x": 0.825,
              "y": -9.517,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.832,
              "y": -9.424,
              "z": 1.652
            },
            "gtin": "4008666704979",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709ca",
            "leftCorner": {
              "x": 0.832,
              "y": -9.424,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.838,
              "y": -9.332,
              "z": 1.652
            },
            "gtin": "4008666709561",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709cb",
            "leftCorner": {
              "x": 0.838,
              "y": -9.332,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.842,
              "y": -9.273,
              "z": 1.652
            },
            "gtin": "4008666709547",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709cc",
            "leftCorner": {
              "x": 0.842,
              "y": -9.273,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.846,
              "y": -9.219,
              "z": 1.652
            },
            "gtin": "4008666704207",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709cd",
            "leftCorner": {
              "x": 0.846,
              "y": -9.219,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.849,
              "y": -9.175,
              "z": 1.652
            },
            "gtin": "4008666705136",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709ce",
            "leftCorner": {
              "x": 0.849,
              "y": -9.175,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.853,
              "y": -9.115,
              "z": 1.652
            },
            "gtin": "4008666700902",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709cf",
            "leftCorner": {
              "x": 0.853,
              "y": -9.115,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.857,
              "y": -9.065,
              "z": 1.652
            },
            "gtin": "4008666701602",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709d0",
            "leftCorner": {
              "x": 0.857,
              "y": -9.065,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.86,
              "y": -9.016,
              "z": 1.652
            },
            "gtin": "4008666700001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709d1",
            "leftCorner": {
              "x": 0.86,
              "y": -9.016,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.864,
              "y": -8.965,
              "z": 1.652
            },
            "gtin": "4008666700001",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709d2",
            "leftCorner": {
              "x": 0.864,
              "y": -8.965,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.868,
              "y": -8.908,
              "z": 1.652
            },
            "gtin": "4008666700209",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709d3",
            "leftCorner": {
              "x": 0.868,
              "y": -8.908,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.876,
              "y": -8.801,
              "z": 1.652
            },
            "gtin": "4008666700407",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e76371b5fe7bc046959ab7",
    "name": "68e76371b5fe7bc046959ab7",
    "x": 0.81918,
    "y": -8.7961,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69011,
      "w": 0.7237
    },
    "statistics": {
      "hasStockCount": 66,
      "noStockCount": 1,
      "unknownStockCount": 16
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73a06",
        "height": 0.17876,
        "facings": [
          {
            "id": "696ebf6f43c343680a270bf5",
            "leftCorner": {
              "x": 0.866,
              "y": -8.803,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.871,
              "y": -8.735,
              "z": 0.179
            },
            "gtin": "4015100815887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bf6",
            "leftCorner": {
              "x": 0.867,
              "y": -8.738,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.868,
              "y": -8.708,
              "z": 0.179
            },
            "gtin": "4015100815887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bf7",
            "leftCorner": {
              "x": 0.868,
              "y": -8.708,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.871,
              "y": -8.653,
              "z": 0.179
            },
            "gtin": "4015100816204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bf8",
            "leftCorner": {
              "x": 0.871,
              "y": -8.653,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.873,
              "y": -8.611,
              "z": 0.179
            },
            "gtin": "4015100816204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bf9",
            "leftCorner": {
              "x": 0.873,
              "y": -8.611,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.875,
              "y": -8.562,
              "z": 0.179
            },
            "gtin": "4015100815900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bfa",
            "leftCorner": {
              "x": 0.875,
              "y": -8.562,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.878,
              "y": -8.508,
              "z": 0.179
            },
            "gtin": "4015100815900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270bfb",
            "leftCorner": {
              "x": 0.878,
              "y": -8.508,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.882,
              "y": -8.416,
              "z": 0.179
            },
            "gtin": "4015100816167",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bfc",
            "leftCorner": {
              "x": 0.882,
              "y": -8.416,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.887,
              "y": -8.325,
              "z": 0.179
            },
            "gtin": "4015100816082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bfd",
            "leftCorner": {
              "x": 0.887,
              "y": -8.325,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.891,
              "y": -8.236,
              "z": 0.179
            },
            "gtin": "4015100816129",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bfe",
            "leftCorner": {
              "x": 0.891,
              "y": -8.236,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.895,
              "y": -8.149,
              "z": 0.179
            },
            "gtin": "4066447565164",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270bff",
            "leftCorner": {
              "x": 0.895,
              "y": -8.149,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.899,
              "y": -8.056,
              "z": 0.179
            },
            "gtin": "4066447565225",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c00",
            "leftCorner": {
              "x": 0.899,
              "y": -8.056,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.904,
              "y": -7.97,
              "z": 0.179
            },
            "gtin": "4066447902501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c01",
            "leftCorner": {
              "x": 0.904,
              "y": -7.97,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.908,
              "y": -7.884,
              "z": 0.179
            },
            "gtin": "4066447330441",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c02",
            "leftCorner": {
              "x": 0.908,
              "y": -7.884,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.912,
              "y": -7.79,
              "z": 0.179
            },
            "gtin": "4066447330502",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a02",
        "height": 0.39604,
        "facings": [
          {
            "id": "696ebf6f43c343680a270ca6",
            "leftCorner": {
              "x": 0.864,
              "y": -8.796,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.868,
              "y": -8.702,
              "z": 0.396
            },
            "gtin": "4015100816068",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ca7",
            "leftCorner": {
              "x": 0.868,
              "y": -8.702,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.871,
              "y": -8.657,
              "z": 0.396
            },
            "gtin": "4015100816006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ca8",
            "leftCorner": {
              "x": 0.871,
              "y": -8.657,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.874,
              "y": -8.584,
              "z": 0.396
            },
            "gtin": "4015100816006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ca9",
            "leftCorner": {
              "x": 0.874,
              "y": -8.584,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.878,
              "y": -8.501,
              "z": 0.396
            },
            "gtin": "4015100816181",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270caa",
            "leftCorner": {
              "x": 0.878,
              "y": -8.501,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.882,
              "y": -8.413,
              "z": 0.396
            },
            "gtin": "4015100815962",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cab",
            "leftCorner": {
              "x": 0.882,
              "y": -8.413,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.886,
              "y": -8.322,
              "z": 0.396
            },
            "gtin": "4015100816266",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cac",
            "leftCorner": {
              "x": 0.886,
              "y": -8.322,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.891,
              "y": -8.234,
              "z": 0.396
            },
            "gtin": "4015100816327",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cad",
            "leftCorner": {
              "x": 0.891,
              "y": -8.234,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.895,
              "y": -8.146,
              "z": 0.396
            },
            "gtin": "4066447330564",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cae",
            "leftCorner": {
              "x": 0.895,
              "y": -8.146,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.899,
              "y": -8.055,
              "z": 0.396
            },
            "gtin": "4067796180749",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270caf",
            "leftCorner": {
              "x": 0.899,
              "y": -8.055,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.903,
              "y": -7.97,
              "z": 0.396
            },
            "gtin": "4066447669039",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cb0",
            "leftCorner": {
              "x": 0.903,
              "y": -7.97,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.907,
              "y": -7.883,
              "z": 0.396
            },
            "gtin": "4067796214543",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cb1",
            "leftCorner": {
              "x": 0.907,
              "y": -7.883,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.912,
              "y": -7.784,
              "z": 0.396
            },
            "gtin": "4058172704710",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a04",
        "height": 0.64406,
        "facings": [
          {
            "id": "696ebf6f43c343680a270cd3",
            "leftCorner": {
              "x": 0.866,
              "y": -8.789,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.87,
              "y": -8.7,
              "z": 0.644
            },
            "gtin": "4015100816105",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cd4",
            "leftCorner": {
              "x": 0.87,
              "y": -8.7,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.873,
              "y": -8.651,
              "z": 0.644
            },
            "gtin": "4015100816525",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cd5",
            "leftCorner": {
              "x": 0.873,
              "y": -8.651,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.876,
              "y": -8.582,
              "z": 0.644
            },
            "gtin": "4015100816525",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cd6",
            "leftCorner": {
              "x": 0.876,
              "y": -8.582,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.88,
              "y": -8.492,
              "z": 0.644
            },
            "gtin": "4015100816044",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cd7",
            "leftCorner": {
              "x": 0.88,
              "y": -8.492,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.884,
              "y": -8.403,
              "z": 0.644
            },
            "gtin": "4015100816242",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cd8",
            "leftCorner": {
              "x": 0.884,
              "y": -8.403,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.889,
              "y": -8.313,
              "z": 0.644
            },
            "gtin": "4015100815825",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cd9",
            "leftCorner": {
              "x": 0.889,
              "y": -8.313,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.893,
              "y": -8.222,
              "z": 0.644
            },
            "gtin": "4015100816280",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cda",
            "leftCorner": {
              "x": 0.893,
              "y": -8.222,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.897,
              "y": -8.133,
              "z": 0.644
            },
            "gtin": "4066447616330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cdb",
            "leftCorner": {
              "x": 0.897,
              "y": -8.133,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.901,
              "y": -8.047,
              "z": 0.644
            },
            "gtin": "4066447616361",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cdc",
            "leftCorner": {
              "x": 0.901,
              "y": -8.047,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.905,
              "y": -7.963,
              "z": 0.644
            },
            "gtin": "4066447706802",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cdd",
            "leftCorner": {
              "x": 0.905,
              "y": -7.963,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.909,
              "y": -7.877,
              "z": 0.644
            },
            "gtin": "4066447330717",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cde",
            "leftCorner": {
              "x": 0.909,
              "y": -7.877,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.914,
              "y": -7.781,
              "z": 0.644
            },
            "gtin": "4066447330656",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a07",
        "height": 0.89627,
        "facings": [
          {
            "id": "696ebf6f43c343680a270d2d",
            "leftCorner": {
              "x": 0.873,
              "y": -8.794,
              "z": 0.896
            },
            "rightCorner": {
              "x": 0.875,
              "y": -8.733,
              "z": 0.896
            },
            "gtin": "3600524000080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d2e",
            "leftCorner": {
              "x": 0.875,
              "y": -8.733,
              "z": 0.896
            },
            "rightCorner": {
              "x": 0.877,
              "y": -8.69,
              "z": 0.896
            },
            "gtin": "3600524000080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d2f",
            "leftCorner": {
              "x": 0.877,
              "y": -8.69,
              "z": 0.896
            },
            "rightCorner": {
              "x": 0.88,
              "y": -8.644,
              "z": 0.896
            },
            "gtin": "3600524000073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d30",
            "leftCorner": {
              "x": 0.88,
              "y": -8.644,
              "z": 0.896
            },
            "rightCorner": {
              "x": 0.883,
              "y": -8.563,
              "z": 0.896
            },
            "gtin": "3600524000073",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d31",
            "leftCorner": {
              "x": 0.883,
              "y": -8.563,
              "z": 0.896
            },
            "rightCorner": {
              "x": 0.888,
              "y": -8.47,
              "z": 0.896
            },
            "gtin": "3600523941162",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d32",
            "leftCorner": {
              "x": 0.888,
              "y": -8.47,
              "z": 0.896
            },
            "rightCorner": {
              "x": 0.893,
              "y": -8.37,
              "z": 0.896
            },
            "gtin": "3600523941117",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d33",
            "leftCorner": {
              "x": 0.893,
              "y": -8.37,
              "z": 0.896
            },
            "rightCorner": {
              "x": 0.897,
              "y": -8.27,
              "z": 0.896
            },
            "gtin": "3600523941063",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d34",
            "leftCorner": {
              "x": 0.897,
              "y": -8.27,
              "z": 0.896
            },
            "rightCorner": {
              "x": 0.902,
              "y": -8.169,
              "z": 0.896
            },
            "gtin": "3600523941018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d35",
            "leftCorner": {
              "x": 0.902,
              "y": -8.169,
              "z": 0.896
            },
            "rightCorner": {
              "x": 0.907,
              "y": -8.067,
              "z": 0.896
            },
            "gtin": "3600523776368",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d36",
            "leftCorner": {
              "x": 0.907,
              "y": -8.067,
              "z": 0.896
            },
            "rightCorner": {
              "x": 0.911,
              "y": -7.977,
              "z": 0.896
            },
            "gtin": "3600523789832",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d37",
            "leftCorner": {
              "x": 0.911,
              "y": -7.977,
              "z": 0.896
            },
            "rightCorner": {
              "x": 0.916,
              "y": -7.886,
              "z": 0.896
            },
            "gtin": "3600523776290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d38",
            "leftCorner": {
              "x": 0.916,
              "y": -7.886,
              "z": 0.896
            },
            "rightCorner": {
              "x": 0.921,
              "y": -7.782,
              "z": 0.896
            },
            "gtin": "3600524015060",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a08",
        "height": 1.153,
        "facings": [
          {
            "id": "696ebf6f43c343680a270d59",
            "leftCorner": {
              "x": 0.874,
              "y": -8.799,
              "z": 1.153
            },
            "rightCorner": {
              "x": 0.879,
              "y": -8.695,
              "z": 1.153
            },
            "gtin": "3600523714544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d5b",
            "leftCorner": {
              "x": 0.879,
              "y": -8.695,
              "z": 1.153
            },
            "rightCorner": {
              "x": 0.881,
              "y": -8.651,
              "z": 1.153
            }
          },
          {
            "id": "696ebf6f43c343680a270d5c",
            "leftCorner": {
              "x": 0.881,
              "y": -8.651,
              "z": 1.153
            },
            "rightCorner": {
              "x": 0.885,
              "y": -8.564,
              "z": 1.153
            },
            "gtin": "3600523738137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d5d",
            "leftCorner": {
              "x": 0.885,
              "y": -8.564,
              "z": 1.153
            },
            "rightCorner": {
              "x": 0.89,
              "y": -8.472,
              "z": 1.153
            },
            "gtin": "3600524000127",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d5e",
            "leftCorner": {
              "x": 0.89,
              "y": -8.472,
              "z": 1.153
            },
            "rightCorner": {
              "x": 0.894,
              "y": -8.373,
              "z": 1.153
            },
            "gtin": "3600524000110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d5f",
            "leftCorner": {
              "x": 0.894,
              "y": -8.373,
              "z": 1.153
            },
            "rightCorner": {
              "x": 0.899,
              "y": -8.272,
              "z": 1.153
            },
            "gtin": "3600524000097",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d60",
            "leftCorner": {
              "x": 0.899,
              "y": -8.272,
              "z": 1.153
            },
            "rightCorner": {
              "x": 0.904,
              "y": -8.178,
              "z": 1.153
            },
            "gtin": "3600523946938",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d61",
            "leftCorner": {
              "x": 0.904,
              "y": -8.178,
              "z": 1.153
            },
            "rightCorner": {
              "x": 0.909,
              "y": -8.076,
              "z": 1.153
            },
            "gtin": "3600523776382",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d62",
            "leftCorner": {
              "x": 0.909,
              "y": -8.076,
              "z": 1.153
            },
            "rightCorner": {
              "x": 0.913,
              "y": -7.986,
              "z": 1.153
            },
            "gtin": "3600523789856",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d63",
            "leftCorner": {
              "x": 0.913,
              "y": -7.986,
              "z": 1.153
            },
            "rightCorner": {
              "x": 0.917,
              "y": -7.893,
              "z": 1.153
            },
            "gtin": "3600523789863",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d64",
            "leftCorner": {
              "x": 0.917,
              "y": -7.893,
              "z": 1.153
            },
            "rightCorner": {
              "x": 0.922,
              "y": -7.796,
              "z": 1.153
            },
            "gtin": "3600523789849",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a05",
        "height": 1.403,
        "facings": [
          {
            "id": "696ebf6f43c343680a270d00",
            "leftCorner": {
              "x": 0.875,
              "y": -8.799,
              "z": 1.403
            },
            "rightCorner": {
              "x": 0.879,
              "y": -8.726,
              "z": 1.403
            },
            "gtin": "3600523714537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d02",
            "leftCorner": {
              "x": 0.879,
              "y": -8.726,
              "z": 1.403
            },
            "rightCorner": {
              "x": 0.88,
              "y": -8.693,
              "z": 1.403
            }
          },
          {
            "id": "696ebf6f43c343680a270d03",
            "leftCorner": {
              "x": 0.88,
              "y": -8.693,
              "z": 1.403
            },
            "rightCorner": {
              "x": 0.883,
              "y": -8.646,
              "z": 1.403
            },
            "gtin": "3600523714407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d04",
            "leftCorner": {
              "x": 0.883,
              "y": -8.646,
              "z": 1.403
            },
            "rightCorner": {
              "x": 0.887,
              "y": -8.56,
              "z": 1.403
            },
            "gtin": "3600523714407",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d05",
            "leftCorner": {
              "x": 0.887,
              "y": -8.56,
              "z": 1.403
            },
            "rightCorner": {
              "x": 0.891,
              "y": -8.47,
              "z": 1.403
            },
            "gtin": "3600523991495",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d06",
            "leftCorner": {
              "x": 0.891,
              "y": -8.47,
              "z": 1.403
            },
            "rightCorner": {
              "x": 0.896,
              "y": -8.373,
              "z": 1.403
            },
            "gtin": "3600523714490",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d07",
            "leftCorner": {
              "x": 0.896,
              "y": -8.373,
              "z": 1.403
            },
            "rightCorner": {
              "x": 0.901,
              "y": -8.269,
              "z": 1.403
            },
            "gtin": "3600523714476",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d08",
            "leftCorner": {
              "x": 0.901,
              "y": -8.269,
              "z": 1.403
            },
            "rightCorner": {
              "x": 0.905,
              "y": -8.176,
              "z": 1.403
            },
            "gtin": "3600523947133",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d09",
            "leftCorner": {
              "x": 0.905,
              "y": -8.176,
              "z": 1.403
            },
            "rightCorner": {
              "x": 0.91,
              "y": -8.076,
              "z": 1.403
            },
            "gtin": "3600523776450",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d0a",
            "leftCorner": {
              "x": 0.91,
              "y": -8.076,
              "z": 1.403
            },
            "rightCorner": {
              "x": 0.914,
              "y": -7.981,
              "z": 1.403
            },
            "gtin": "30178120",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d0b",
            "leftCorner": {
              "x": 0.914,
              "y": -7.981,
              "z": 1.403
            },
            "rightCorner": {
              "x": 0.918,
              "y": -7.891,
              "z": 1.403
            },
            "gtin": "3600523947034",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d0c",
            "leftCorner": {
              "x": 0.918,
              "y": -7.891,
              "z": 1.403
            },
            "rightCorner": {
              "x": 0.924,
              "y": -7.783,
              "z": 1.403
            },
            "gtin": "3600523776429",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a03",
        "height": 1.6537,
        "facings": [
          {
            "id": "696ebf6e43c343680a2709d4",
            "leftCorner": {
              "x": 0.876,
              "y": -8.801,
              "z": 1.652
            },
            "rightCorner": {
              "x": 0.88,
              "y": -8.733,
              "z": 1.652
            },
            "gtin": "3600523714513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709d5",
            "leftCorner": {
              "x": 0.881,
              "y": -8.737,
              "z": 1.654
            },
            "rightCorner": {
              "x": 0.883,
              "y": -8.698,
              "z": 1.654
            },
            "gtin": "3600523714513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709d6",
            "leftCorner": {
              "x": 0.883,
              "y": -8.698,
              "z": 1.654
            },
            "rightCorner": {
              "x": 0.885,
              "y": -8.652,
              "z": 1.654
            },
            "gtin": "3600523714438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709d7",
            "leftCorner": {
              "x": 0.885,
              "y": -8.652,
              "z": 1.654
            },
            "rightCorner": {
              "x": 0.889,
              "y": -8.567,
              "z": 1.654
            },
            "gtin": "3600523714438",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709d8",
            "leftCorner": {
              "x": 0.889,
              "y": -8.567,
              "z": 1.654
            },
            "rightCorner": {
              "x": 0.894,
              "y": -8.472,
              "z": 1.654
            },
            "gtin": "3600523714506",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709d9",
            "leftCorner": {
              "x": 0.894,
              "y": -8.472,
              "z": 1.654
            },
            "rightCorner": {
              "x": 0.898,
              "y": -8.378,
              "z": 1.654
            },
            "gtin": "3600523714445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709da",
            "leftCorner": {
              "x": 0.898,
              "y": -8.378,
              "z": 1.654
            },
            "rightCorner": {
              "x": 0.903,
              "y": -8.273,
              "z": 1.654
            },
            "gtin": "3600523714414",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709db",
            "leftCorner": {
              "x": 0.903,
              "y": -8.273,
              "z": 1.654
            },
            "rightCorner": {
              "x": 0.907,
              "y": -8.187,
              "z": 1.654
            },
            "gtin": "3600524128821",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709dc",
            "leftCorner": {
              "x": 0.907,
              "y": -8.187,
              "z": 1.654
            },
            "rightCorner": {
              "x": 0.913,
              "y": -8.077,
              "z": 1.654
            },
            "gtin": "3600524128838",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709dd",
            "leftCorner": {
              "x": 0.913,
              "y": -8.077,
              "z": 1.654
            },
            "rightCorner": {
              "x": 0.917,
              "y": -7.986,
              "z": 1.654
            },
            "gtin": "3600523776320",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709de",
            "leftCorner": {
              "x": 0.917,
              "y": -7.986,
              "z": 1.654
            },
            "rightCorner": {
              "x": 0.921,
              "y": -7.894,
              "z": 1.654
            },
            "gtin": "3600523776474",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709df",
            "leftCorner": {
              "x": 0.921,
              "y": -7.894,
              "z": 1.654
            },
            "rightCorner": {
              "x": 0.926,
              "y": -7.794,
              "z": 1.654
            },
            "gtin": "3600523776306",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e76371b5fe7bc046959ab8",
    "name": "68e76371b5fe7bc046959ab8",
    "x": 0.87903,
    "y": -7.8017,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68216,
      "w": 0.73121
    },
    "statistics": {
      "hasStockCount": 69,
      "noStockCount": 0,
      "unknownStockCount": 7
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73a0e",
        "height": 0.17889,
        "facings": [
          {
            "id": "696ebf6f43c343680a270c03",
            "leftCorner": {
              "x": 0.912,
              "y": -7.79,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.917,
              "y": -7.695,
              "z": 0.179
            },
            "gtin": "4066447330410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c04",
            "leftCorner": {
              "x": 0.931,
              "y": -7.701,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.938,
              "y": -7.596,
              "z": 0.179
            },
            "gtin": "3600542574709",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c05",
            "leftCorner": {
              "x": 0.938,
              "y": -7.596,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.948,
              "y": -7.458,
              "z": 0.179
            },
            "gtin": "3600542518970",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c06",
            "leftCorner": {
              "x": 0.948,
              "y": -7.458,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.955,
              "y": -7.35,
              "z": 0.179
            },
            "gtin": "3600542574686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c07",
            "leftCorner": {
              "x": 0.955,
              "y": -7.35,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.961,
              "y": -7.269,
              "z": 0.179
            },
            "gtin": "4015100817485",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c08",
            "leftCorner": {
              "x": 0.961,
              "y": -7.269,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.967,
              "y": -7.186,
              "z": 0.179
            },
            "gtin": "4015100817683",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c09",
            "leftCorner": {
              "x": 0.967,
              "y": -7.186,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.972,
              "y": -7.113,
              "z": 0.179
            },
            "gtin": "4015100817706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c0a",
            "leftCorner": {
              "x": 0.972,
              "y": -7.113,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.977,
              "y": -7.035,
              "z": 0.179
            },
            "gtin": "4015100817805",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c0b",
            "leftCorner": {
              "x": 0.977,
              "y": -7.035,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.982,
              "y": -6.97,
              "z": 0.179
            },
            "gtin": "4015100817560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c0c",
            "leftCorner": {
              "x": 0.982,
              "y": -6.97,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.988,
              "y": -6.875,
              "z": 0.179
            },
            "gtin": "4015100817782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270c0d",
            "leftCorner": {
              "x": 0.988,
              "y": -6.875,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.993,
              "y": -6.804,
              "z": 0.179
            },
            "gtin": "4015100817508",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a09",
        "height": 0.39563,
        "facings": [
          {
            "id": "696ebf6f43c343680a270cb2",
            "leftCorner": {
              "x": 0.922,
              "y": -7.789,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.928,
              "y": -7.698,
              "z": 0.396
            },
            "gtin": "4066447330472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cb3",
            "leftCorner": {
              "x": 0.928,
              "y": -7.698,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.936,
              "y": -7.587,
              "z": 0.396
            },
            "gtin": "3600542524698",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cb4",
            "leftCorner": {
              "x": 0.936,
              "y": -7.587,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.944,
              "y": -7.465,
              "z": 0.396
            },
            "gtin": "3600542621090",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cb5",
            "leftCorner": {
              "x": 0.944,
              "y": -7.465,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.952,
              "y": -7.346,
              "z": 0.396
            },
            "gtin": "3600542519014",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cb6",
            "leftCorner": {
              "x": 0.952,
              "y": -7.346,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.958,
              "y": -7.27,
              "z": 0.396
            },
            "gtin": "4015100817461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cb7",
            "leftCorner": {
              "x": 0.958,
              "y": -7.27,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.963,
              "y": -7.191,
              "z": 0.396
            },
            "gtin": "4015100817584",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cb8",
            "leftCorner": {
              "x": 0.963,
              "y": -7.191,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.968,
              "y": -7.121,
              "z": 0.396
            },
            "gtin": "4015100817423",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cb9",
            "leftCorner": {
              "x": 0.968,
              "y": -7.121,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.973,
              "y": -7.047,
              "z": 0.396
            },
            "gtin": "4015100817720",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cba",
            "leftCorner": {
              "x": 0.973,
              "y": -7.047,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.978,
              "y": -6.979,
              "z": 0.396
            },
            "gtin": "4015100817744",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cbb",
            "leftCorner": {
              "x": 0.978,
              "y": -6.979,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.984,
              "y": -6.897,
              "z": 0.396
            },
            "gtin": "4015100861006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cbc",
            "leftCorner": {
              "x": 0.984,
              "y": -6.897,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.989,
              "y": -6.824,
              "z": 0.396
            },
            "gtin": "4015100817522",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cbd",
            "leftCorner": {
              "x": 0.989,
              "y": -6.824,
              "z": 0.396
            },
            "rightCorner": {
              "x": 0.993,
              "y": -6.768,
              "z": 0.396
            },
            "gtin": "3600524194918",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a0d",
        "height": 0.64427,
        "facings": [
          {
            "id": "696ebf6f43c343680a270cdf",
            "leftCorner": {
              "x": 0.923,
              "y": -7.786,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.929,
              "y": -7.695,
              "z": 0.644
            },
            "gtin": "4067796163032",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ce0",
            "leftCorner": {
              "x": 0.929,
              "y": -7.695,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.936,
              "y": -7.593,
              "z": 0.644
            },
            "gtin": "3600542632003",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ce1",
            "leftCorner": {
              "x": 0.936,
              "y": -7.593,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.945,
              "y": -7.467,
              "z": 0.644
            },
            "gtin": "3600542519076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ce2",
            "leftCorner": {
              "x": 0.945,
              "y": -7.467,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.955,
              "y": -7.332,
              "z": 0.644
            },
            "gtin": "3600542519052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ce3",
            "leftCorner": {
              "x": 0.955,
              "y": -7.332,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.961,
              "y": -7.239,
              "z": 0.644
            },
            "gtin": "4015100817669",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ce4",
            "leftCorner": {
              "x": 0.961,
              "y": -7.239,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.968,
              "y": -7.144,
              "z": 0.644
            },
            "gtin": "4015100817768",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ce5",
            "leftCorner": {
              "x": 0.968,
              "y": -7.144,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.973,
              "y": -7.071,
              "z": 0.644
            },
            "gtin": "4015100817447",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ce6",
            "leftCorner": {
              "x": 0.973,
              "y": -7.071,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.977,
              "y": -7.003,
              "z": 0.644
            },
            "gtin": "4015100817829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ce7",
            "leftCorner": {
              "x": 0.977,
              "y": -7.003,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.983,
              "y": -6.929,
              "z": 0.644
            },
            "gtin": "4015100817645",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ce8",
            "leftCorner": {
              "x": 0.983,
              "y": -6.929,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.988,
              "y": -6.849,
              "z": 0.644
            },
            "gtin": "4015100817324",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ce9",
            "leftCorner": {
              "x": 0.988,
              "y": -6.849,
              "z": 0.644
            },
            "rightCorner": {
              "x": 0.993,
              "y": -6.784,
              "z": 0.644
            },
            "gtin": "4015100817348",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a0c",
        "height": 0.89715,
        "facings": [
          {
            "id": "696ebf6f43c343680a270d39",
            "leftCorner": {
              "x": 0.93,
              "y": -7.788,
              "z": 0.897
            },
            "rightCorner": {
              "x": 0.936,
              "y": -7.696,
              "z": 0.897
            },
            "gtin": "4260625262689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d3a",
            "leftCorner": {
              "x": 0.936,
              "y": -7.696,
              "z": 0.897
            },
            "rightCorner": {
              "x": 0.942,
              "y": -7.608,
              "z": 0.897
            },
            "gtin": "4260625262696",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d3b",
            "leftCorner": {
              "x": 0.942,
              "y": -7.608,
              "z": 0.897
            },
            "rightCorner": {
              "x": 0.949,
              "y": -7.518,
              "z": 0.897
            },
            "gtin": "4260625265017",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d3c",
            "leftCorner": {
              "x": 0.949,
              "y": -7.518,
              "z": 0.897
            },
            "rightCorner": {
              "x": 0.956,
              "y": -7.406,
              "z": 0.897
            },
            "gtin": "4260625265017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d3d",
            "leftCorner": {
              "x": 0.956,
              "y": -7.406,
              "z": 0.897
            },
            "rightCorner": {
              "x": 0.964,
              "y": -7.302,
              "z": 0.897
            },
            "gtin": "4015100861525",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d3e",
            "leftCorner": {
              "x": 0.964,
              "y": -7.302,
              "z": 0.897
            },
            "rightCorner": {
              "x": 0.971,
              "y": -7.196,
              "z": 0.897
            },
            "gtin": "4015100861709",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d3f",
            "leftCorner": {
              "x": 0.971,
              "y": -7.196,
              "z": 0.897
            },
            "rightCorner": {
              "x": 0.978,
              "y": -7.099,
              "z": 0.897
            },
            "gtin": "4015100861686",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d40",
            "leftCorner": {
              "x": 0.978,
              "y": -7.099,
              "z": 0.897
            },
            "rightCorner": {
              "x": 0.984,
              "y": -7.006,
              "z": 0.897
            },
            "gtin": "4015100861303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d41",
            "leftCorner": {
              "x": 0.984,
              "y": -7.006,
              "z": 0.897
            },
            "rightCorner": {
              "x": 0.991,
              "y": -6.906,
              "z": 0.897
            },
            "gtin": "4015100441697",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d42",
            "leftCorner": {
              "x": 0.991,
              "y": -6.906,
              "z": 0.897
            },
            "rightCorner": {
              "x": 0.994,
              "y": -6.857,
              "z": 0.897
            },
            "gtin": "4015100441710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d43",
            "leftCorner": {
              "x": 0.994,
              "y": -6.857,
              "z": 0.897
            },
            "rightCorner": {
              "x": 0.998,
              "y": -6.814,
              "z": 0.897
            },
            "gtin": "4015100441710",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a0a",
        "height": 1.1537,
        "facings": [
          {
            "id": "696ebf6f43c343680a270d65",
            "leftCorner": {
              "x": 0.922,
              "y": -7.796,
              "z": 1.153
            },
            "rightCorner": {
              "x": 0.926,
              "y": -7.702,
              "z": 1.153
            },
            "gtin": "4260625262658",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d66",
            "leftCorner": {
              "x": 0.937,
              "y": -7.708,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.943,
              "y": -7.616,
              "z": 1.154
            },
            "gtin": "4260625262672",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d67",
            "leftCorner": {
              "x": 0.943,
              "y": -7.616,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.95,
              "y": -7.521,
              "z": 1.154
            },
            "gtin": "4260625265000",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d68",
            "leftCorner": {
              "x": 0.95,
              "y": -7.521,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.958,
              "y": -7.41,
              "z": 1.154
            },
            "gtin": "4015100861549",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d69",
            "leftCorner": {
              "x": 0.958,
              "y": -7.41,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.966,
              "y": -7.296,
              "z": 1.154
            },
            "gtin": "4015100861662",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d6a",
            "leftCorner": {
              "x": 0.966,
              "y": -7.296,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.973,
              "y": -7.194,
              "z": 1.154
            },
            "gtin": "4015100861389",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d6b",
            "leftCorner": {
              "x": 0.973,
              "y": -7.194,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.979,
              "y": -7.107,
              "z": 1.154
            },
            "gtin": "4015100441512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d6c",
            "leftCorner": {
              "x": 0.979,
              "y": -7.107,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.985,
              "y": -7.018,
              "z": 1.154
            },
            "gtin": "4015100441574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d6d",
            "leftCorner": {
              "x": 0.985,
              "y": -7.018,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.991,
              "y": -6.925,
              "z": 1.154
            },
            "gtin": "4015100441659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d6e",
            "leftCorner": {
              "x": 0.991,
              "y": -6.925,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.998,
              "y": -6.83,
              "z": 1.154
            },
            "gtin": "4015100441673",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a0f",
        "height": 1.4035,
        "facings": [
          {
            "id": "696ebf6f43c343680a270d13",
            "leftCorner": {
              "x": 0.97,
              "y": -7.245,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.974,
              "y": -7.195,
              "z": 1.404
            },
            "gtin": "4015100861402",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d0d",
            "leftCorner": {
              "x": 0.933,
              "y": -7.789,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.939,
              "y": -7.699,
              "z": 1.404
            },
            "gtin": "4260625262634",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d0e",
            "leftCorner": {
              "x": 0.939,
              "y": -7.699,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.945,
              "y": -7.606,
              "z": 1.404
            }
          },
          {
            "id": "696ebf6f43c343680a270d0f",
            "leftCorner": {
              "x": 0.945,
              "y": -7.606,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.951,
              "y": -7.517,
              "z": 1.404
            },
            "gtin": "4260625262641",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d10",
            "leftCorner": {
              "x": 0.951,
              "y": -7.517,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.959,
              "y": -7.409,
              "z": 1.404
            },
            "gtin": "4015100861563",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d11",
            "leftCorner": {
              "x": 0.959,
              "y": -7.409,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.967,
              "y": -7.297,
              "z": 1.404
            },
            "gtin": "4015100861426",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d12",
            "leftCorner": {
              "x": 0.967,
              "y": -7.297,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.97,
              "y": -7.245,
              "z": 1.404
            },
            "gtin": "4015100861402",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d14",
            "leftCorner": {
              "x": 0.974,
              "y": -7.195,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.981,
              "y": -7.098,
              "z": 1.404
            },
            "gtin": "4015100861501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d15",
            "leftCorner": {
              "x": 0.981,
              "y": -7.098,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.986,
              "y": -7.014,
              "z": 1.404
            },
            "gtin": "4015100815030",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d16",
            "leftCorner": {
              "x": 0.986,
              "y": -7.014,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.994,
              "y": -6.912,
              "z": 1.404
            },
            "gtin": "4015100441451",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d17",
            "leftCorner": {
              "x": 0.994,
              "y": -6.912,
              "z": 1.404
            },
            "rightCorner": {
              "x": 1.0,
              "y": -6.818,
              "z": 1.404
            },
            "gtin": "4015100441475",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a0b",
        "height": 1.6551,
        "facings": [
          {
            "id": "696ebf6e43c343680a2709e0",
            "leftCorner": {
              "x": 0.926,
              "y": -7.794,
              "z": 1.654
            },
            "rightCorner": {
              "x": 0.931,
              "y": -7.698,
              "z": 1.654
            },
            "gtin": "4260625262610",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709e1",
            "leftCorner": {
              "x": 0.943,
              "y": -7.704,
              "z": 1.655
            },
            "rightCorner": {
              "x": 0.949,
              "y": -7.613,
              "z": 1.655
            },
            "gtin": "4260625262627",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709e2",
            "leftCorner": {
              "x": 0.949,
              "y": -7.613,
              "z": 1.655
            },
            "rightCorner": {
              "x": 0.955,
              "y": -7.526,
              "z": 1.655
            },
            "gtin": "4260625264997",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709e3",
            "leftCorner": {
              "x": 0.955,
              "y": -7.526,
              "z": 1.655
            },
            "rightCorner": {
              "x": 0.963,
              "y": -7.417,
              "z": 1.655
            },
            "gtin": "4015100861648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709e4",
            "leftCorner": {
              "x": 0.963,
              "y": -7.417,
              "z": 1.655
            },
            "rightCorner": {
              "x": 0.971,
              "y": -7.302,
              "z": 1.655
            },
            "gtin": "4015100861365",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709e5",
            "leftCorner": {
              "x": 0.971,
              "y": -7.302,
              "z": 1.655
            },
            "rightCorner": {
              "x": 0.978,
              "y": -7.199,
              "z": 1.655
            },
            "gtin": "4015100861341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709e6",
            "leftCorner": {
              "x": 0.978,
              "y": -7.199,
              "z": 1.655
            },
            "rightCorner": {
              "x": 0.985,
              "y": -7.1,
              "z": 1.655
            },
            "gtin": "4015100861440",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709e7",
            "leftCorner": {
              "x": 0.985,
              "y": -7.1,
              "z": 1.655
            },
            "rightCorner": {
              "x": 0.99,
              "y": -7.015,
              "z": 1.655
            },
            "gtin": "4015100441321",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709e8",
            "leftCorner": {
              "x": 0.99,
              "y": -7.015,
              "z": 1.655
            },
            "rightCorner": {
              "x": 0.997,
              "y": -6.919,
              "z": 1.655
            },
            "gtin": "4015100801415",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709e9",
            "leftCorner": {
              "x": 0.997,
              "y": -6.919,
              "z": 1.655
            },
            "rightCorner": {
              "x": 1.004,
              "y": -6.823,
              "z": 1.655
            },
            "gtin": "4015100441369",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709ea",
            "leftCorner": {
              "x": 1.004,
              "y": -6.823,
              "z": 1.655
            },
            "rightCorner": {
              "x": 1.01,
              "y": -6.741,
              "z": 1.655
            },
            "gtin": "4015100443141",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e76371b5fe7bc046959ab9",
    "name": "68e76371b5fe7bc046959ab9",
    "x": 0.94054,
    "y": -6.7954,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68228,
      "w": 0.73109
    },
    "statistics": {
      "hasStockCount": 65,
      "noStockCount": 1,
      "unknownStockCount": 5
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73a14",
        "height": 0.18025,
        "facings": [
          {
            "id": "696ebf6f43c343680a270c0e",
            "leftCorner": {
              "x": 0.993,
              "y": -6.804,
              "z": 0.179
            },
            "rightCorner": {
              "x": 0.997,
              "y": -6.744,
              "z": 0.179
            },
            "gtin": "4025089000495",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c0f",
            "leftCorner": {
              "x": 0.989,
              "y": -6.735,
              "z": 0.18
            },
            "rightCorner": {
              "x": 0.994,
              "y": -6.664,
              "z": 0.18
            },
            "gtin": "4025089000501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c10",
            "leftCorner": {
              "x": 0.994,
              "y": -6.664,
              "z": 0.18
            },
            "rightCorner": {
              "x": 0.999,
              "y": -6.595,
              "z": 0.18
            },
            "gtin": "4025089000518",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c11",
            "leftCorner": {
              "x": 0.999,
              "y": -6.595,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.006,
              "y": -6.491,
              "z": 0.18
            },
            "gtin": "9002422106927",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c12",
            "leftCorner": {
              "x": 1.006,
              "y": -6.491,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.012,
              "y": -6.401,
              "z": 0.18
            },
            "gtin": "3600522822332",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c13",
            "leftCorner": {
              "x": 1.012,
              "y": -6.401,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.019,
              "y": -6.31,
              "z": 0.18
            },
            "gtin": "3600520982557",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c14",
            "leftCorner": {
              "x": 1.019,
              "y": -6.31,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.024,
              "y": -6.226,
              "z": 0.18
            },
            "gtin": "3600520982540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c15",
            "leftCorner": {
              "x": 1.024,
              "y": -6.226,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.03,
              "y": -6.142,
              "z": 0.18
            },
            "gtin": "3600520982519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c16",
            "leftCorner": {
              "x": 1.03,
              "y": -6.142,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.037,
              "y": -6.048,
              "z": 0.18
            },
            "gtin": "3600521365632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c17",
            "leftCorner": {
              "x": 1.037,
              "y": -6.048,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.043,
              "y": -5.959,
              "z": 0.18
            },
            "gtin": "3600520982502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c18",
            "leftCorner": {
              "x": 1.043,
              "y": -5.959,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.049,
              "y": -5.874,
              "z": 0.18
            },
            "gtin": "3600520982496",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c19",
            "leftCorner": {
              "x": 1.049,
              "y": -5.874,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.055,
              "y": -5.781,
              "z": 0.18
            },
            "gtin": "3600520982472",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a13",
        "height": 0.3981,
        "facings": [
          {
            "id": "696ebf6f43c343680a270cbe",
            "leftCorner": {
              "x": 0.982,
              "y": -6.759,
              "z": 0.398
            },
            "rightCorner": {
              "x": 0.986,
              "y": -6.695,
              "z": 0.398
            },
            "gtin": "3600524194925",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cbf",
            "leftCorner": {
              "x": 0.986,
              "y": -6.695,
              "z": 0.398
            },
            "rightCorner": {
              "x": 0.991,
              "y": -6.633,
              "z": 0.398
            },
            "gtin": "3600524194932",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cc0",
            "leftCorner": {
              "x": 0.991,
              "y": -6.633,
              "z": 0.398
            },
            "rightCorner": {
              "x": 0.997,
              "y": -6.543,
              "z": 0.398
            },
            "gtin": "4015100432275",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cc1",
            "leftCorner": {
              "x": 0.997,
              "y": -6.543,
              "z": 0.398
            },
            "rightCorner": {
              "x": 1.004,
              "y": -6.432,
              "z": 0.398
            },
            "gtin": "4015100802948",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cc2",
            "leftCorner": {
              "x": 1.004,
              "y": -6.432,
              "z": 0.398
            },
            "rightCorner": {
              "x": 1.009,
              "y": -6.363,
              "z": 0.398
            },
            "gtin": "4015100728880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270cc3",
            "leftCorner": {
              "x": 1.009,
              "y": -6.363,
              "z": 0.398
            },
            "rightCorner": {
              "x": 1.016,
              "y": -6.263,
              "z": 0.398
            },
            "gtin": "4015100310979",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cc4",
            "leftCorner": {
              "x": 1.016,
              "y": -6.263,
              "z": 0.398
            },
            "rightCorner": {
              "x": 1.022,
              "y": -6.172,
              "z": 0.398
            },
            "gtin": "4015100311174",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cc5",
            "leftCorner": {
              "x": 1.022,
              "y": -6.172,
              "z": 0.398
            },
            "rightCorner": {
              "x": 1.03,
              "y": -6.068,
              "z": 0.398
            },
            "gtin": "4015100311037",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cc6",
            "leftCorner": {
              "x": 1.03,
              "y": -6.068,
              "z": 0.398
            },
            "rightCorner": {
              "x": 1.036,
              "y": -5.973,
              "z": 0.398
            },
            "gtin": "4015100311150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cc7",
            "leftCorner": {
              "x": 1.036,
              "y": -5.973,
              "z": 0.398
            },
            "rightCorner": {
              "x": 1.043,
              "y": -5.879,
              "z": 0.398
            },
            "gtin": "4015100339895",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cc8",
            "leftCorner": {
              "x": 1.043,
              "y": -5.879,
              "z": 0.398
            },
            "rightCorner": {
              "x": 1.049,
              "y": -5.783,
              "z": 0.398
            },
            "gtin": "4015100311013",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a11",
        "height": 0.64657,
        "facings": [
          {
            "id": "696ebf6f43c343680a270cea",
            "leftCorner": {
              "x": 0.985,
              "y": -6.776,
              "z": 0.647
            },
            "rightCorner": {
              "x": 0.99,
              "y": -6.7,
              "z": 0.647
            },
            "gtin": "4015100817225",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ceb",
            "leftCorner": {
              "x": 0.99,
              "y": -6.7,
              "z": 0.647
            },
            "rightCorner": {
              "x": 0.997,
              "y": -6.607,
              "z": 0.647
            },
            "gtin": "3600542389877",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cec",
            "leftCorner": {
              "x": 0.997,
              "y": -6.607,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.003,
              "y": -6.515,
              "z": 0.647
            },
            "gtin": "3600541043046",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ced",
            "leftCorner": {
              "x": 1.003,
              "y": -6.515,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.006,
              "y": -6.476,
              "z": 0.647
            }
          },
          {
            "id": "696ebf6f43c343680a270cee",
            "leftCorner": {
              "x": 1.006,
              "y": -6.476,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.01,
              "y": -6.405,
              "z": 0.647
            },
            "gtin": "3600541043015",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cef",
            "leftCorner": {
              "x": 1.01,
              "y": -6.405,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.018,
              "y": -6.302,
              "z": 0.647
            },
            "gtin": "3600542389822",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cf0",
            "leftCorner": {
              "x": 1.018,
              "y": -6.302,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.024,
              "y": -6.211,
              "z": 0.647
            },
            "gtin": "4015100310931",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cf1",
            "leftCorner": {
              "x": 1.024,
              "y": -6.211,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.03,
              "y": -6.117,
              "z": 0.647
            },
            "gtin": "4015100310832",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cf2",
            "leftCorner": {
              "x": 1.03,
              "y": -6.117,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.037,
              "y": -6.015,
              "z": 0.647
            },
            "gtin": "4015100724103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cf3",
            "leftCorner": {
              "x": 1.037,
              "y": -6.015,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.044,
              "y": -5.924,
              "z": 0.647
            },
            "gtin": "4015100310917",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cf4",
            "leftCorner": {
              "x": 1.044,
              "y": -5.924,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.051,
              "y": -5.82,
              "z": 0.647
            },
            "gtin": "4015100311136",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a12",
        "height": 0.89921,
        "facings": [
          {
            "id": "696ebf6f43c343680a270d44",
            "leftCorner": {
              "x": 0.997,
              "y": -6.814,
              "z": 0.897
            },
            "rightCorner": {
              "x": 1.004,
              "y": -6.723,
              "z": 0.897
            },
            "gtin": "4015100441772",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d45",
            "leftCorner": {
              "x": 0.996,
              "y": -6.714,
              "z": 0.899
            },
            "rightCorner": {
              "x": 1.003,
              "y": -6.621,
              "z": 0.899
            },
            "gtin": "4002441020261",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d46",
            "leftCorner": {
              "x": 1.003,
              "y": -6.621,
              "z": 0.899
            },
            "rightCorner": {
              "x": 1.009,
              "y": -6.53,
              "z": 0.899
            }
          },
          {
            "id": "696ebf6f43c343680a270d47",
            "leftCorner": {
              "x": 1.009,
              "y": -6.53,
              "z": 0.899
            },
            "rightCorner": {
              "x": 1.017,
              "y": -6.416,
              "z": 0.899
            },
            "gtin": "3600540244901",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d48",
            "leftCorner": {
              "x": 1.017,
              "y": -6.416,
              "z": 0.899
            },
            "rightCorner": {
              "x": 1.024,
              "y": -6.313,
              "z": 0.899
            },
            "gtin": "4002441020056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d49",
            "leftCorner": {
              "x": 1.024,
              "y": -6.313,
              "z": 0.899
            },
            "rightCorner": {
              "x": 1.031,
              "y": -6.217,
              "z": 0.899
            }
          },
          {
            "id": "696ebf6f43c343680a270d4a",
            "leftCorner": {
              "x": 1.031,
              "y": -6.217,
              "z": 0.899
            },
            "rightCorner": {
              "x": 1.038,
              "y": -6.115,
              "z": 0.899
            },
            "gtin": "3600541250406",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d4b",
            "leftCorner": {
              "x": 1.038,
              "y": -6.115,
              "z": 0.899
            },
            "rightCorner": {
              "x": 1.045,
              "y": -6.003,
              "z": 0.899
            },
            "gtin": "3600542222693",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d4c",
            "leftCorner": {
              "x": 1.045,
              "y": -6.003,
              "z": 0.899
            },
            "rightCorner": {
              "x": 1.052,
              "y": -5.906,
              "z": 0.899
            },
            "gtin": "3600541250253",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d4d",
            "leftCorner": {
              "x": 1.052,
              "y": -5.906,
              "z": 0.899
            },
            "rightCorner": {
              "x": 1.059,
              "y": -5.804,
              "z": 0.899
            },
            "gtin": "3600541250154",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a15",
        "height": 1.1551,
        "facings": [
          {
            "id": "696ebf6f43c343680a270d6f",
            "leftCorner": {
              "x": 0.998,
              "y": -6.83,
              "z": 1.154
            },
            "rightCorner": {
              "x": 1.004,
              "y": -6.743,
              "z": 1.154
            },
            "gtin": "4002441020278",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d70",
            "leftCorner": {
              "x": 0.994,
              "y": -6.734,
              "z": 1.155
            },
            "rightCorner": {
              "x": 1.0,
              "y": -6.638,
              "z": 1.155
            },
            "gtin": "3600541375369",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d71",
            "leftCorner": {
              "x": 1.0,
              "y": -6.638,
              "z": 1.155
            },
            "rightCorner": {
              "x": 1.007,
              "y": -6.537,
              "z": 1.155
            },
            "gtin": "3600541901643",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d72",
            "leftCorner": {
              "x": 1.007,
              "y": -6.537,
              "z": 1.155
            },
            "rightCorner": {
              "x": 1.015,
              "y": -6.431,
              "z": 1.155
            },
            "gtin": "4002441020292",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d73",
            "leftCorner": {
              "x": 1.015,
              "y": -6.431,
              "z": 1.155
            },
            "rightCorner": {
              "x": 1.022,
              "y": -6.328,
              "z": 1.155
            },
            "gtin": "4002441020087",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d74",
            "leftCorner": {
              "x": 1.022,
              "y": -6.328,
              "z": 1.155
            },
            "rightCorner": {
              "x": 1.029,
              "y": -6.225,
              "z": 1.155
            },
            "gtin": "3600541524217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d75",
            "leftCorner": {
              "x": 1.029,
              "y": -6.225,
              "z": 1.155
            },
            "rightCorner": {
              "x": 1.036,
              "y": -6.119,
              "z": 1.155
            },
            "gtin": "3600541593718",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d76",
            "leftCorner": {
              "x": 1.036,
              "y": -6.119,
              "z": 1.155
            },
            "rightCorner": {
              "x": 1.043,
              "y": -6.014,
              "z": 1.155
            },
            "gtin": "3600541250604",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d77",
            "leftCorner": {
              "x": 1.043,
              "y": -6.014,
              "z": 1.155
            },
            "rightCorner": {
              "x": 1.05,
              "y": -5.912,
              "z": 1.155
            },
            "gtin": "3600541250505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d78",
            "leftCorner": {
              "x": 1.05,
              "y": -5.912,
              "z": 1.155
            },
            "rightCorner": {
              "x": 1.055,
              "y": -5.839,
              "z": 1.155
            },
            "gtin": "3600542447461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d79",
            "leftCorner": {
              "x": 1.056,
              "y": -5.838,
              "z": 1.159
            },
            "rightCorner": {
              "x": 1.06,
              "y": -5.776,
              "z": 1.159
            },
            "gtin": "42447603",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a10",
        "height": 1.4075,
        "facings": [
          {
            "id": "696ebf6f43c343680a270d18",
            "leftCorner": {
              "x": 1.0,
              "y": -6.818,
              "z": 1.403
            },
            "rightCorner": {
              "x": 1.006,
              "y": -6.735,
              "z": 1.403
            },
            "gtin": "4015100441499",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d19",
            "leftCorner": {
              "x": 0.997,
              "y": -6.726,
              "z": 1.407
            },
            "rightCorner": {
              "x": 1.003,
              "y": -6.634,
              "z": 1.407
            },
            "gtin": "4002441020209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d1a",
            "leftCorner": {
              "x": 1.003,
              "y": -6.634,
              "z": 1.407
            },
            "rightCorner": {
              "x": 1.009,
              "y": -6.54,
              "z": 1.407
            },
            "gtin": "3600541901759",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d1b",
            "leftCorner": {
              "x": 1.009,
              "y": -6.54,
              "z": 1.407
            },
            "rightCorner": {
              "x": 1.011,
              "y": -6.513,
              "z": 1.407
            }
          },
          {
            "id": "696ebf6f43c343680a270d1c",
            "leftCorner": {
              "x": 1.011,
              "y": -6.513,
              "z": 1.407
            },
            "rightCorner": {
              "x": 1.019,
              "y": -6.407,
              "z": 1.407
            },
            "gtin": "3600542169950",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d1d",
            "leftCorner": {
              "x": 1.019,
              "y": -6.407,
              "z": 1.407
            },
            "rightCorner": {
              "x": 1.026,
              "y": -6.307,
              "z": 1.407
            },
            "gtin": "4002441020193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d1e",
            "leftCorner": {
              "x": 1.026,
              "y": -6.307,
              "z": 1.407
            },
            "rightCorner": {
              "x": 1.032,
              "y": -6.214,
              "z": 1.407
            },
            "gtin": "3600541900141",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d1f",
            "leftCorner": {
              "x": 1.032,
              "y": -6.214,
              "z": 1.407
            },
            "rightCorner": {
              "x": 1.039,
              "y": -6.111,
              "z": 1.407
            },
            "gtin": "3600541250857",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d20",
            "leftCorner": {
              "x": 1.039,
              "y": -6.111,
              "z": 1.407
            },
            "rightCorner": {
              "x": 1.047,
              "y": -5.998,
              "z": 1.407
            },
            "gtin": "3600541250857",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d21",
            "leftCorner": {
              "x": 1.047,
              "y": -5.998,
              "z": 1.407
            },
            "rightCorner": {
              "x": 1.054,
              "y": -5.896,
              "z": 1.407
            },
            "gtin": "3600541250758",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d22",
            "leftCorner": {
              "x": 1.054,
              "y": -5.896,
              "z": 1.407
            },
            "rightCorner": {
              "x": 1.061,
              "y": -5.793,
              "z": 1.407
            },
            "gtin": "3600541250703",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a16",
        "height": 1.6586,
        "facings": [
          {
            "id": "696ebf6e43c343680a2709eb",
            "leftCorner": {
              "x": 0.999,
              "y": -6.732,
              "z": 1.659
            },
            "rightCorner": {
              "x": 1.005,
              "y": -6.646,
              "z": 1.659
            },
            "gtin": "3600540604415",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709ec",
            "leftCorner": {
              "x": 1.005,
              "y": -6.646,
              "z": 1.659
            },
            "rightCorner": {
              "x": 1.012,
              "y": -6.545,
              "z": 1.659
            },
            "gtin": "3600542466547",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709ed",
            "leftCorner": {
              "x": 1.012,
              "y": -6.545,
              "z": 1.659
            },
            "rightCorner": {
              "x": 1.02,
              "y": -6.438,
              "z": 1.659
            },
            "gtin": "4002441020308",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709ee",
            "leftCorner": {
              "x": 1.02,
              "y": -6.438,
              "z": 1.659
            },
            "rightCorner": {
              "x": 1.027,
              "y": -6.334,
              "z": 1.659
            },
            "gtin": "3600541043060",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709ef",
            "leftCorner": {
              "x": 1.027,
              "y": -6.334,
              "z": 1.659
            },
            "rightCorner": {
              "x": 1.033,
              "y": -6.237,
              "z": 1.659
            },
            "gtin": "3600541910812",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709f0",
            "leftCorner": {
              "x": 1.033,
              "y": -6.237,
              "z": 1.659
            },
            "rightCorner": {
              "x": 1.041,
              "y": -6.131,
              "z": 1.659
            },
            "gtin": "3600541402096",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709f1",
            "leftCorner": {
              "x": 1.041,
              "y": -6.131,
              "z": 1.659
            },
            "rightCorner": {
              "x": 1.048,
              "y": -6.025,
              "z": 1.659
            },
            "gtin": "3600542031073",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709f2",
            "leftCorner": {
              "x": 1.048,
              "y": -6.025,
              "z": 1.659
            },
            "rightCorner": {
              "x": 1.055,
              "y": -5.925,
              "z": 1.659
            },
            "gtin": "3600541251052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709f3",
            "leftCorner": {
              "x": 1.055,
              "y": -5.925,
              "z": 1.659
            },
            "rightCorner": {
              "x": 1.063,
              "y": -5.816,
              "z": 1.659
            },
            "gtin": "3600542541817",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "68e76371b5fe7bc046959aba",
    "name": "68e76371b5fe7bc046959aba",
    "x": 1.0125,
    "y": -5.7972,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.67746,
      "w": 0.73556
    },
    "statistics": {
      "hasStockCount": 44,
      "noStockCount": 2,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "696ead8c3b88e258afd73a1c",
        "height": 0.18006,
        "facings": [
          {
            "id": "696ebf6f43c343680a270c1a",
            "leftCorner": {
              "x": 1.058,
              "y": -5.78,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.063,
              "y": -5.714,
              "z": 0.18
            },
            "gtin": "4066447332186",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c1b",
            "leftCorner": {
              "x": 1.063,
              "y": -5.714,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.072,
              "y": -5.612,
              "z": 0.18
            },
            "gtin": "4066447332155",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c1c",
            "leftCorner": {
              "x": 1.072,
              "y": -5.612,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.08,
              "y": -5.51,
              "z": 0.18
            },
            "gtin": "4066447331523",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c1d",
            "leftCorner": {
              "x": 1.08,
              "y": -5.51,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.086,
              "y": -5.441,
              "z": 0.18
            },
            "gtin": "4066447331493",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c1e",
            "leftCorner": {
              "x": 1.086,
              "y": -5.441,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.092,
              "y": -5.374,
              "z": 0.18
            },
            "gtin": "4066447331554",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c1f",
            "leftCorner": {
              "x": 1.092,
              "y": -5.374,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.099,
              "y": -5.279,
              "z": 0.18
            },
            "gtin": "4015100876093",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c20",
            "leftCorner": {
              "x": 1.099,
              "y": -5.279,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.102,
              "y": -5.242,
              "z": 0.18
            }
          },
          {
            "id": "696ebf6f43c343680a270c21",
            "leftCorner": {
              "x": 1.102,
              "y": -5.242,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.109,
              "y": -5.165,
              "z": 0.18
            },
            "gtin": "4015100816921",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c22",
            "leftCorner": {
              "x": 1.109,
              "y": -5.165,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.118,
              "y": -5.052,
              "z": 0.18
            },
            "gtin": "4015100816969",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c23",
            "leftCorner": {
              "x": 1.118,
              "y": -5.052,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.127,
              "y": -4.948,
              "z": 0.18
            },
            "gtin": "4015100763744",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c24",
            "leftCorner": {
              "x": 1.127,
              "y": -4.948,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.133,
              "y": -4.876,
              "z": 0.18
            },
            "gtin": "4015100816983",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270c25",
            "leftCorner": {
              "x": 1.133,
              "y": -4.876,
              "z": 0.18
            },
            "rightCorner": {
              "x": 1.138,
              "y": -4.811,
              "z": 0.18
            },
            "gtin": "4015100863161",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a17",
        "height": 0.40059,
        "facings": [
          {
            "id": "696ebf6f43c343680a270cc9",
            "leftCorner": {
              "x": 1.053,
              "y": -5.782,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.063,
              "y": -5.658,
              "z": 0.401
            },
            "gtin": "9120064451684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270cca",
            "leftCorner": {
              "x": 1.063,
              "y": -5.658,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.077,
              "y": -5.492,
              "z": 0.401
            },
            "gtin": "9120064451660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ccb",
            "leftCorner": {
              "x": 1.077,
              "y": -5.492,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.084,
              "y": -5.4,
              "z": 0.401
            },
            "gtin": "4015000529150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ccc",
            "leftCorner": {
              "x": 1.084,
              "y": -5.4,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.092,
              "y": -5.31,
              "z": 0.401
            },
            "gtin": "4015000529174",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ccd",
            "leftCorner": {
              "x": 1.092,
              "y": -5.31,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.105,
              "y": -5.145,
              "z": 0.401
            },
            "gtin": "4015000529136",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cce",
            "leftCorner": {
              "x": 1.105,
              "y": -5.145,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.113,
              "y": -5.048,
              "z": 0.401
            },
            "gtin": "4015100192223",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270ccf",
            "leftCorner": {
              "x": 1.113,
              "y": -5.048,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.12,
              "y": -4.96,
              "z": 0.401
            },
            "gtin": "5057566628075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270cd0",
            "leftCorner": {
              "x": 1.12,
              "y": -4.96,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.127,
              "y": -4.883,
              "z": 0.401
            },
            "gtin": "4058172938344",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cd1",
            "leftCorner": {
              "x": 1.127,
              "y": -4.883,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.13,
              "y": -4.845,
              "z": 0.401
            },
            "gtin": "4059186101939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270ca5",
            "leftCorner": {
              "x": 1.13,
              "y": -4.845,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.133,
              "y": -4.804,
              "z": 0.401
            },
            "gtin": "4059186101939",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a1d",
        "height": 0.6491,
        "facings": [
          {
            "id": "696ebf6f43c343680a270cf5",
            "leftCorner": {
              "x": 1.051,
              "y": -5.82,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.057,
              "y": -5.73,
              "z": 0.647
            },
            "gtin": "4015100747829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cf6",
            "leftCorner": {
              "x": 1.058,
              "y": -5.73,
              "z": 0.649
            },
            "rightCorner": {
              "x": 1.064,
              "y": -5.654,
              "z": 0.649
            },
            "gtin": "3600524043834",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cf7",
            "leftCorner": {
              "x": 1.064,
              "y": -5.654,
              "z": 0.649
            },
            "rightCorner": {
              "x": 1.071,
              "y": -5.576,
              "z": 0.649
            },
            "gtin": "3600524043636",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cf8",
            "leftCorner": {
              "x": 1.071,
              "y": -5.576,
              "z": 0.649
            },
            "rightCorner": {
              "x": 1.074,
              "y": -5.541,
              "z": 0.649
            }
          },
          {
            "id": "696ebf6f43c343680a270cf9",
            "leftCorner": {
              "x": 1.074,
              "y": -5.541,
              "z": 0.649
            },
            "rightCorner": {
              "x": 1.077,
              "y": -5.499,
              "z": 0.649
            },
            "gtin": "3600524043537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270cfa",
            "leftCorner": {
              "x": 1.077,
              "y": -5.499,
              "z": 0.649
            },
            "rightCorner": {
              "x": 1.083,
              "y": -5.428,
              "z": 0.649
            },
            "gtin": "4015100816341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cfb",
            "leftCorner": {
              "x": 1.083,
              "y": -5.428,
              "z": 0.649
            },
            "rightCorner": {
              "x": 1.088,
              "y": -5.359,
              "z": 0.649
            },
            "gtin": "4015100816365",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cfc",
            "leftCorner": {
              "x": 1.088,
              "y": -5.359,
              "z": 0.649
            },
            "rightCorner": {
              "x": 1.095,
              "y": -5.283,
              "z": 0.649
            },
            "gtin": "4015100816402",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cfd",
            "leftCorner": {
              "x": 1.095,
              "y": -5.283,
              "z": 0.649
            },
            "rightCorner": {
              "x": 1.113,
              "y": -5.065,
              "z": 0.649
            },
            "gtin": "4260625264492",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cfe",
            "leftCorner": {
              "x": 1.113,
              "y": -5.065,
              "z": 0.649
            },
            "rightCorner": {
              "x": 1.124,
              "y": -4.929,
              "z": 0.649
            },
            "gtin": "4260625264508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270cff",
            "leftCorner": {
              "x": 1.124,
              "y": -4.929,
              "z": 0.649
            },
            "rightCorner": {
              "x": 1.129,
              "y": -4.862,
              "z": 0.649
            },
            "gtin": "4104260075603",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270cd2",
            "leftCorner": {
              "x": 1.129,
              "y": -4.862,
              "z": 0.649
            },
            "rightCorner": {
              "x": 1.134,
              "y": -4.804,
              "z": 0.649
            },
            "gtin": "4104260075610",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a1b",
        "height": 0.90098,
        "facings": [
          {
            "id": "696ebf6f43c343680a270d4e",
            "leftCorner": {
              "x": 1.059,
              "y": -5.804,
              "z": 0.899
            },
            "rightCorner": {
              "x": 1.062,
              "y": -5.763,
              "z": 0.899
            },
            "gtin": "3600523193226",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d4f",
            "leftCorner": {
              "x": 1.059,
              "y": -5.763,
              "z": 0.901
            },
            "rightCorner": {
              "x": 1.068,
              "y": -5.652,
              "z": 0.901
            },
            "gtin": "3600523193202",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d50",
            "leftCorner": {
              "x": 1.068,
              "y": -5.652,
              "z": 0.901
            },
            "rightCorner": {
              "x": 1.078,
              "y": -5.531,
              "z": 0.901
            },
            "gtin": "4015100863482",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d51",
            "leftCorner": {
              "x": 1.078,
              "y": -5.531,
              "z": 0.901
            },
            "rightCorner": {
              "x": 1.081,
              "y": -5.495,
              "z": 0.901
            }
          },
          {
            "id": "696ebf6f43c343680a270d52",
            "leftCorner": {
              "x": 1.081,
              "y": -5.495,
              "z": 0.901
            },
            "rightCorner": {
              "x": 1.085,
              "y": -5.452,
              "z": 0.901
            },
            "gtin": "4015100863499",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d53",
            "leftCorner": {
              "x": 1.085,
              "y": -5.452,
              "z": 0.901
            },
            "rightCorner": {
              "x": 1.088,
              "y": -5.408,
              "z": 0.901
            },
            "gtin": "4015100863512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d54",
            "leftCorner": {
              "x": 1.088,
              "y": -5.408,
              "z": 0.901
            },
            "rightCorner": {
              "x": 1.091,
              "y": -5.368,
              "z": 0.901
            },
            "gtin": "4058172934384",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d55",
            "leftCorner": {
              "x": 1.091,
              "y": -5.368,
              "z": 0.901
            },
            "rightCorner": {
              "x": 1.095,
              "y": -5.328,
              "z": 0.901
            },
            "gtin": "4058172934407",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d56",
            "leftCorner": {
              "x": 1.095,
              "y": -5.328,
              "z": 0.901
            },
            "rightCorner": {
              "x": 1.098,
              "y": -5.286,
              "z": 0.901
            },
            "gtin": "4058172934407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d57",
            "leftCorner": {
              "x": 1.098,
              "y": -5.286,
              "z": 0.901
            },
            "rightCorner": {
              "x": 1.117,
              "y": -5.058,
              "z": 0.901
            },
            "gtin": "4260625264454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d58",
            "leftCorner": {
              "x": 1.117,
              "y": -5.058,
              "z": 0.901
            },
            "rightCorner": {
              "x": 1.121,
              "y": -5.004,
              "z": 0.901
            },
            "gtin": "4260625264447",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d2c",
            "leftCorner": {
              "x": 1.121,
              "y": -5.004,
              "z": 0.901
            },
            "rightCorner": {
              "x": 1.138,
              "y": -4.804,
              "z": 0.901
            },
            "gtin": "4104260075412",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a19",
        "height": 1.1595,
        "facings": [
          {
            "id": "696ebf6f43c343680a270d7a",
            "leftCorner": {
              "x": 1.061,
              "y": -5.776,
              "z": 1.16
            },
            "rightCorner": {
              "x": 1.064,
              "y": -5.731,
              "z": 1.16
            },
            "gtin": "42447597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d7b",
            "leftCorner": {
              "x": 1.065,
              "y": -5.731,
              "z": 1.16
            },
            "rightCorner": {
              "x": 1.081,
              "y": -5.536,
              "z": 1.16
            },
            "gtin": "3600542563734",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d7c",
            "leftCorner": {
              "x": 1.081,
              "y": -5.536,
              "z": 1.16
            },
            "rightCorner": {
              "x": 1.09,
              "y": -5.43,
              "z": 1.16
            },
            "gtin": "3600542563727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d7d",
            "leftCorner": {
              "x": 1.09,
              "y": -5.43,
              "z": 1.16
            },
            "rightCorner": {
              "x": 1.096,
              "y": -5.357,
              "z": 1.16
            },
            "gtin": "4066447331769",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d7e",
            "leftCorner": {
              "x": 1.096,
              "y": -5.357,
              "z": 1.16
            },
            "rightCorner": {
              "x": 1.11,
              "y": -5.178,
              "z": 1.16
            },
            "gtin": "4066447331820",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d7f",
            "leftCorner": {
              "x": 1.11,
              "y": -5.178,
              "z": 1.16
            },
            "rightCorner": {
              "x": 1.117,
              "y": -5.103,
              "z": 1.16
            },
            "gtin": "4066447331912",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d5a",
            "leftCorner": {
              "x": 1.117,
              "y": -5.103,
              "z": 1.16
            },
            "rightCorner": {
              "x": 1.141,
              "y": -4.804,
              "z": 1.16
            },
            "gtin": "4015100215182",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a1a",
        "height": 1.4123,
        "facings": [
          {
            "id": "696ebf6f43c343680a270d23",
            "leftCorner": {
              "x": 1.057,
              "y": -5.801,
              "z": 1.412
            },
            "rightCorner": {
              "x": 1.066,
              "y": -5.68,
              "z": 1.412
            },
            "gtin": "5037156295900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d24",
            "leftCorner": {
              "x": 1.067,
              "y": -5.68,
              "z": 1.412
            },
            "rightCorner": {
              "x": 1.079,
              "y": -5.538,
              "z": 1.412
            },
            "gtin": "5037156295962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d25",
            "leftCorner": {
              "x": 1.079,
              "y": -5.538,
              "z": 1.412
            },
            "rightCorner": {
              "x": 1.081,
              "y": -5.51,
              "z": 1.412
            }
          },
          {
            "id": "696ebf6f43c343680a270d26",
            "leftCorner": {
              "x": 1.081,
              "y": -5.51,
              "z": 1.412
            },
            "rightCorner": {
              "x": 1.09,
              "y": -5.401,
              "z": 1.412
            },
            "gtin": "3600542563741",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d27",
            "leftCorner": {
              "x": 1.09,
              "y": -5.401,
              "z": 1.412
            },
            "rightCorner": {
              "x": 1.096,
              "y": -5.33,
              "z": 1.412
            },
            "gtin": "4066447332032",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d28",
            "leftCorner": {
              "x": 1.096,
              "y": -5.33,
              "z": 1.412
            },
            "rightCorner": {
              "x": 1.115,
              "y": -5.095,
              "z": 1.412
            },
            "gtin": "4066447332001",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d29",
            "leftCorner": {
              "x": 1.115,
              "y": -5.095,
              "z": 1.412
            },
            "rightCorner": {
              "x": 1.128,
              "y": -4.947,
              "z": 1.412
            },
            "gtin": "4066447331974",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d2a",
            "leftCorner": {
              "x": 1.128,
              "y": -4.947,
              "z": 1.412
            },
            "rightCorner": {
              "x": 1.133,
              "y": -4.877,
              "z": 1.412
            },
            "gtin": "4066447331943",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6f43c343680a270d2b",
            "leftCorner": {
              "x": 1.133,
              "y": -4.877,
              "z": 1.412
            },
            "rightCorner": {
              "x": 1.136,
              "y": -4.841,
              "z": 1.412
            },
            "gtin": "4066447331790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6f43c343680a270d01",
            "leftCorner": {
              "x": 1.136,
              "y": -4.841,
              "z": 1.412
            },
            "rightCorner": {
              "x": 1.139,
              "y": -4.804,
              "z": 1.412
            },
            "gtin": "4066447331790",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8c3b88e258afd73a18",
        "height": 1.66,
        "facings": [
          {
            "id": "696ebf6e43c343680a2709f4",
            "leftCorner": {
              "x": 1.063,
              "y": -5.816,
              "z": 1.659
            },
            "rightCorner": {
              "x": 1.067,
              "y": -5.755,
              "z": 1.659
            },
            "gtin": "4015100876758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709f5",
            "leftCorner": {
              "x": 1.065,
              "y": -5.755,
              "z": 1.66
            },
            "rightCorner": {
              "x": 1.07,
              "y": -5.689,
              "z": 1.66
            },
            "gtin": "4015100738100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709f6",
            "leftCorner": {
              "x": 1.07,
              "y": -5.689,
              "z": 1.66
            },
            "rightCorner": {
              "x": 1.075,
              "y": -5.63,
              "z": 1.66
            },
            "gtin": "4015100812091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709f7",
            "leftCorner": {
              "x": 1.075,
              "y": -5.63,
              "z": 1.66
            },
            "rightCorner": {
              "x": 1.084,
              "y": -5.498,
              "z": 1.66
            },
            "gtin": "4015100812077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709f8",
            "leftCorner": {
              "x": 1.086,
              "y": -5.498,
              "z": 1.66
            },
            "rightCorner": {
              "x": 1.091,
              "y": -5.444,
              "z": 1.66
            },
            "gtin": "4015100877076",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709f9",
            "leftCorner": {
              "x": 1.091,
              "y": -5.444,
              "z": 1.66
            },
            "rightCorner": {
              "x": 1.099,
              "y": -5.342,
              "z": 1.66
            },
            "gtin": "4015100876871",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf6e43c343680a2709fa",
            "leftCorner": {
              "x": 1.099,
              "y": -5.342,
              "z": 1.66
            },
            "rightCorner": {
              "x": 1.109,
              "y": -5.225,
              "z": 1.66
            },
            "gtin": "4015100876994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a2709fb",
            "leftCorner": {
              "x": 1.109,
              "y": -5.225,
              "z": 1.66
            },
            "rightCorner": {
              "x": 1.124,
              "y": -5.035,
              "z": 1.66
            },
            "gtin": "4066447864656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf6e43c343680a27094f",
            "leftCorner": {
              "x": 1.124,
              "y": -5.035,
              "z": 1.66
            },
            "rightCorner": {
              "x": 1.143,
              "y": -4.804,
              "z": 1.66
            },
            "gtin": "4067796163094",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "692d7f041a003a4e8dadb900",
    "name": "692d7f041a003a4e8dadb900",
    "x": 8.5192,
    "y": 0.22189,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.92004,
      "w": -0.39181
    },
    "layers": []
  },
  {
    "id": "692d7f6c1a003a4e8dadb903",
    "name": "692d7f6c1a003a4e8dadb903",
    "x": 0.80517,
    "y": 1.0337,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99932,
      "w": 0.036939
    },
    "statistics": {
      "hasStockCount": 17,
      "noStockCount": 0,
      "unknownStockCount": 20
    },
    "layers": [
      {
        "id": "696ead8e3b88e258afd73bd2",
        "height": 0.22165,
        "facings": [
          {
            "id": "696ebf7143c343680a271f59",
            "leftCorner": {
              "x": 0.817,
              "y": 1.188,
              "z": 0.222
            },
            "rightCorner": {
              "x": 0.508,
              "y": 1.211,
              "z": 0.222
            },
            "gtin": "4066447247435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f5b",
            "leftCorner": {
              "x": 0.508,
              "y": 1.211,
              "z": 0.222
            },
            "rightCorner": {
              "x": 0.26,
              "y": 1.229,
              "z": 0.222
            },
            "gtin": "4066447664072",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f5c",
            "leftCorner": {
              "x": 0.26,
              "y": 1.229,
              "z": 0.222
            },
            "rightCorner": {
              "x": 0.035,
              "y": 1.246,
              "z": 0.222
            },
            "gtin": "4066447709483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f5a",
            "leftCorner": {
              "x": 0.035,
              "y": 1.246,
              "z": 0.222
            },
            "rightCorner": {
              "x": -0.181,
              "y": 1.262,
              "z": 0.222
            },
            "gtin": "4066447709438",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bd4",
        "height": 0.56584,
        "facings": [
          {
            "id": "696ebf7143c343680a271f5f",
            "leftCorner": {
              "x": 0.816,
              "y": 1.18,
              "z": 0.566
            },
            "rightCorner": {
              "x": 0.617,
              "y": 1.195,
              "z": 0.566
            },
            "gtin": "4066447221602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f61",
            "leftCorner": {
              "x": 0.617,
              "y": 1.195,
              "z": 0.566
            },
            "rightCorner": {
              "x": 0.42,
              "y": 1.209,
              "z": 0.566
            },
            "gtin": "4066447663815",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f62",
            "leftCorner": {
              "x": 0.42,
              "y": 1.209,
              "z": 0.566
            },
            "rightCorner": {
              "x": 0.243,
              "y": 1.222,
              "z": 0.566
            },
            "gtin": "4066447562040",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f63",
            "leftCorner": {
              "x": 0.243,
              "y": 1.222,
              "z": 0.566
            },
            "rightCorner": {
              "x": 0.059,
              "y": 1.236,
              "z": 0.566
            },
            "gtin": "4066447562019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f64",
            "leftCorner": {
              "x": 0.059,
              "y": 1.236,
              "z": 0.566
            },
            "rightCorner": {
              "x": -0.063,
              "y": 1.245,
              "z": 0.566
            },
            "gtin": "4066447561920",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f60",
            "leftCorner": {
              "x": -0.063,
              "y": 1.245,
              "z": 0.566
            },
            "rightCorner": {
              "x": -0.181,
              "y": 1.254,
              "z": 0.566
            },
            "gtin": "4066447561890",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bcf",
        "height": 0.86054,
        "facings": [
          {
            "id": "696ebf7143c343680a271f4d",
            "leftCorner": {
              "x": 0.816,
              "y": 1.174,
              "z": 0.861
            },
            "rightCorner": {
              "x": 0.719,
              "y": 1.181,
              "z": 0.861
            },
            "gtin": "40267654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f4f",
            "leftCorner": {
              "x": 0.719,
              "y": 1.181,
              "z": 0.861
            },
            "rightCorner": {
              "x": 0.635,
              "y": 1.187,
              "z": 0.861
            },
            "gtin": "4063565252402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f50",
            "leftCorner": {
              "x": 0.635,
              "y": 1.187,
              "z": 0.861
            },
            "rightCorner": {
              "x": 0.547,
              "y": 1.193,
              "z": 0.861
            },
            "gtin": "4042448103932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f51",
            "leftCorner": {
              "x": 0.547,
              "y": 1.193,
              "z": 0.861
            },
            "rightCorner": {
              "x": 0.435,
              "y": 1.202,
              "z": 0.861
            },
            "gtin": "4042448164971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f52",
            "leftCorner": {
              "x": 0.435,
              "y": 1.202,
              "z": 0.861
            },
            "rightCorner": {
              "x": 0.32,
              "y": 1.21,
              "z": 0.861
            },
            "gtin": "4042448164964",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f53",
            "leftCorner": {
              "x": 0.32,
              "y": 1.21,
              "z": 0.861
            },
            "rightCorner": {
              "x": 0.248,
              "y": 1.216,
              "z": 0.861
            },
            "gtin": "4250255100185",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f54",
            "leftCorner": {
              "x": 0.248,
              "y": 1.216,
              "z": 0.861
            },
            "rightCorner": {
              "x": 0.183,
              "y": 1.22,
              "z": 0.861
            },
            "gtin": "4058172795848",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f55",
            "leftCorner": {
              "x": 0.183,
              "y": 1.22,
              "z": 0.861
            },
            "rightCorner": {
              "x": 0.052,
              "y": 1.23,
              "z": 0.861
            },
            "gtin": "4010355506313",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f56",
            "leftCorner": {
              "x": 0.052,
              "y": 1.23,
              "z": 0.861
            },
            "rightCorner": {
              "x": -0.076,
              "y": 1.24,
              "z": 0.861
            },
            "gtin": "4010355506313",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f4e",
            "leftCorner": {
              "x": -0.076,
              "y": 1.24,
              "z": 0.861
            },
            "rightCorner": {
              "x": -0.182,
              "y": 1.247,
              "z": 0.861
            },
            "gtin": "4066447381184",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bce",
        "height": 1.1166,
        "facings": [
          {
            "id": "696ebf7143c343680a271f40",
            "leftCorner": {
              "x": 0.815,
              "y": 1.17,
              "z": 1.117
            },
            "rightCorner": {
              "x": 0.771,
              "y": 1.173,
              "z": 1.117
            },
            "gtin": "4260479729703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f42",
            "leftCorner": {
              "x": 0.771,
              "y": 1.173,
              "z": 1.117
            },
            "rightCorner": {
              "x": 0.731,
              "y": 1.176,
              "z": 1.117
            },
            "gtin": "4250255104947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f43",
            "leftCorner": {
              "x": 0.731,
              "y": 1.176,
              "z": 1.117
            },
            "rightCorner": {
              "x": 0.695,
              "y": 1.179,
              "z": 1.117
            },
            "gtin": "4250255100444",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f44",
            "leftCorner": {
              "x": 0.695,
              "y": 1.179,
              "z": 1.117
            },
            "rightCorner": {
              "x": 0.631,
              "y": 1.183,
              "z": 1.117
            },
            "gtin": "086806034029",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f45",
            "leftCorner": {
              "x": 0.631,
              "y": 1.183,
              "z": 1.117
            },
            "rightCorner": {
              "x": 0.578,
              "y": 1.187,
              "z": 1.117
            },
            "gtin": "086806033992",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f46",
            "leftCorner": {
              "x": 0.578,
              "y": 1.187,
              "z": 1.117
            },
            "rightCorner": {
              "x": 0.515,
              "y": 1.192,
              "z": 1.117
            },
            "gtin": "041771880804",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f47",
            "leftCorner": {
              "x": 0.515,
              "y": 1.192,
              "z": 1.117
            },
            "rightCorner": {
              "x": 0.396,
              "y": 1.201,
              "z": 1.117
            },
            "gtin": "4066447794304",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f48",
            "leftCorner": {
              "x": 0.396,
              "y": 1.201,
              "z": 1.117
            },
            "rightCorner": {
              "x": 0.235,
              "y": 1.213,
              "z": 1.117
            },
            "gtin": "4066447676716",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f49",
            "leftCorner": {
              "x": 0.235,
              "y": 1.213,
              "z": 1.117
            },
            "rightCorner": {
              "x": 0.125,
              "y": 1.221,
              "z": 1.117
            },
            "gtin": "4066447609134",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f4a",
            "leftCorner": {
              "x": 0.125,
              "y": 1.221,
              "z": 1.117
            },
            "rightCorner": {
              "x": 0.003,
              "y": 1.23,
              "z": 1.117
            },
            "gtin": "4066447485844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f4b",
            "leftCorner": {
              "x": 0.003,
              "y": 1.23,
              "z": 1.117
            },
            "rightCorner": {
              "x": -0.06,
              "y": 1.235,
              "z": 1.117
            },
            "gtin": "4058172590702",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f4c",
            "leftCorner": {
              "x": -0.06,
              "y": 1.235,
              "z": 1.117
            },
            "rightCorner": {
              "x": -0.109,
              "y": 1.238,
              "z": 1.117
            },
            "gtin": "4058172590733",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "696ebf7143c343680a271f41",
            "leftCorner": {
              "x": -0.109,
              "y": 1.238,
              "z": 1.117
            },
            "rightCorner": {
              "x": -0.182,
              "y": 1.244,
              "z": 1.117
            },
            "gtin": "4058172095108",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bd0",
        "height": 1.5683,
        "facings": [
          {
            "id": "696ebf7143c343680a271f57",
            "leftCorner": {
              "x": 0.813,
              "y": 1.145,
              "z": 1.568
            },
            "rightCorner": {
              "x": 0.726,
              "y": 1.151,
              "z": 1.568
            },
            "gtin": "4067796155600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f58",
            "leftCorner": {
              "x": 0.726,
              "y": 1.151,
              "z": 1.568
            },
            "rightCorner": {
              "x": -0.184,
              "y": 1.219,
              "z": 1.568
            },
            "gtin": "4058172795695",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bd3",
        "height": 1.7579,
        "facings": [
          {
            "id": "696ebf7143c343680a271f5d",
            "leftCorner": {
              "x": 0.813,
              "y": 1.14,
              "z": 1.758
            },
            "rightCorner": {
              "x": -0.103,
              "y": 1.208,
              "z": 1.758
            },
            "gtin": "7638900424256",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696ebf7143c343680a271f5e",
            "leftCorner": {
              "x": -0.103,
              "y": 1.208,
              "z": 1.758
            },
            "rightCorner": {
              "x": -0.184,
              "y": 1.214,
              "z": 1.758
            },
            "gtin": "7638900026429",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "696ead8e3b88e258afd73bd1",
        "height": 1.9733,
        "facings": []
      }
    ]
  }
]